// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-family: sans-serif
}

.mackinacpro {
    font-family: P22 Mackinacpro, sans-serif;
}

body {
    margin: 0
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
    display: block
}

audio,
canvas,
progress,
video {
    vertical-align: baseline;
    display: inline-block
}

audio:not([controls]) {
    height: 0;
    display: none
}

[hidden],
template {
    display: none
}

a {
    background-color: transparent
}

a:active,
a:hover {
    outline: 0
}

abbr[title] {
    border-bottom: 1px dotted
}

b,
strong {
    font-weight: 700
}

dfn {
    font-style: italic
}

h1 {
    margin: .67em 0;
    font-size: 2em
}

mark {
    color: #000;
    background: #ff0
}

small {
    font-size: 80%
}

sub,
sup {
    vertical-align: baseline;
    font-size: 75%;
    line-height: 0;
    position: relative
}

sup {
    top: -.5em
}

sub {
    bottom: -.25em
}

img {
    border: 0
}

svg:not(:root) {
    overflow: hidden
}

hr {
    box-sizing: content-box;
    height: 0
}

pre {
    overflow: auto
}

code,
kbd,
pre,
samp {
    font-family: monospace;
    font-size: 1em
}

button,
input,
optgroup,
select,
textarea {
    color: inherit;
    font: inherit;
    margin: 0
}

button {
    overflow: visible
}

button,
select {
    text-transform: none
}

button,
html input[type=button],
input[type=reset] {
    -webkit-appearance: button;
    cursor: pointer
}

button[disabled],
html input[disabled] {
    cursor: default
}

button::-moz-focus-inner,
input::-moz-focus-inner {
    border: 0;
    padding: 0
}

input {
    line-height: normal
}

input[type=checkbox],
input[type=radio] {
    box-sizing: border-box;
    padding: 0
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    height: auto
}

input[type=search] {
    -webkit-appearance: none
}

input[type=search]::-webkit-search-cancel-button,
input[type=search]::-webkit-search-decoration {
    -webkit-appearance: none
}

legend {
    border: 0;
    padding: 0
}

textarea {
    overflow: auto
}

optgroup {
    font-weight: 700
}

table {
    border-collapse: collapse;
    border-spacing: 0
}

td,
th {
    padding: 0
}

@font-face {
    font-family: webflow-icons;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})format("truetype");
    font-weight: 400;
    font-style: normal;
}

[class^=w-icon-],
[class*=\\ w-icon-] {
    speak: none;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    font-family: webflow-icons !important
}

.w-icon-slider-right:before {
    content: "î˜€"
}

.w-icon-slider-left:before {
    content: "î˜"
}

.w-icon-nav-menu:before {
    content: "î˜‚"
}

.w-icon-arrow-down:before,
.w-icon-dropdown-toggle:before {
    content: "î˜ƒ"
}

.w-icon-file-upload-remove:before {
    content: "î¤€"
}

.w-icon-file-upload-icon:before {
    content: "î¤ƒ"
}

* {
    box-sizing: border-box
}

html {
    height: 100%
}

body {
    color: #333;
    background-color: #fff;
    min-height: 100%;
    margin: 0;
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 20px
}

img {
    vertical-align: middle;
    max-width: 100%;
    display: inline-block
}

html.w-mod-touch * {
    background-attachment: scroll !important
}

.w-block {
    display: block
}

.w-inline-block {
    max-width: 100%;
    display: inline-block
}

.w-clearfix:before,
.w-clearfix:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-clearfix:after {
    clear: both
}

.w-hidden {
    display: none
}

.w-button {
    color: #fff;
    line-height: inherit;
    cursor: pointer;
    background-color: #3898ec;
    border: 0;
    border-radius: 0;
    padding: 9px 15px;
    text-decoration: none;
    display: inline-block
}

input.w-button {
    -webkit-appearance: button
}

html[data-w-dynpage] [data-w-cloak] {
    color: transparent !important
}

.w-code-block {
    margin: unset
}

pre.w-code-block code {
    all: inherit
}

.w-webflow-badge,
.w-webflow-badge * {
    z-index: auto;
    visibility: visible;
    box-sizing: border-box;
    float: none;
    clear: none;
    box-shadow: none;
    opacity: 1;
    direction: ltr;
    font-family: inherit;
    font-weight: inherit;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    font-style: inherit;
    font-variant: inherit;
    text-align: inherit;
    letter-spacing: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
    text-indent: 0;
    text-transform: inherit;
    text-shadow: none;
    font-smoothing: auto;
    vertical-align: baseline;
    cursor: inherit;
    white-space: inherit;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    background: 0 0;
    border: 0 transparent;
    border-radius: 0;
    width: auto;
    min-width: 0;
    max-width: none;
    height: auto;
    min-height: 0;
    max-height: none;
    margin: 0;
    padding: 0;
    list-style-type: disc;
    transition: none;
    display: block;
    position: static;
    top: auto;
    bottom: auto;
    left: auto;
    right: auto;
    overflow: visible;
    transform: none
}

.w-webflow-badge {
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, .1), 0 1px 3px rgba(0, 0, 0, .1);
    visibility: visible !important;
    z-index: 2147483647 !important;
    color: #aaadb0 !important;
    opacity: 1 !important;
    background-color: #fff !important;
    border-radius: 3px !important;
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    padding: 6px !important;
    font-size: 12px !important;
    line-height: 14px !important;
    text-decoration: none !important;
    display: inline-block !important;
    position: fixed !important;
    top: auto !important;
    bottom: 12px !important;
    left: auto !important;
    right: 12px !important;
    overflow: visible !important;
    transform: none !important
}

.w-webflow-badge>img {
    visibility: visible !important;
    opacity: 1 !important;
    vertical-align: middle !important;
    display: inline-block !important
}

h1,
h2,
h3,
h4,
h5,
h6 {
    margin-bottom: 10px;
    font-weight: 700
}

h1 {
    margin-top: 20px;
    font-size: 38px;
    line-height: 44px
}

h2 {
    margin-top: 20px;
    font-size: 32px;
    line-height: 36px
}

h3 {
    margin-top: 20px;
    font-size: 24px;
    line-height: 30px
}

h4 {
    margin-top: 10px;
    font-size: 18px;
    line-height: 24px
}

h5 {
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px
}

h6 {
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px
}

p {
    margin-top: 0;
    margin-bottom: 10px
}

blockquote {
    border-left: 5px solid #e2e2e2;
    margin: 0 0 10px;
    padding: 10px 20px;
    font-size: 18px;
    line-height: 22px
}

figure {
    margin: 0 0 10px
}

ul,
ol {
    margin-top: 0;
    margin-bottom: 10px;
    padding-left: 40px
}

.w-list-unstyled {
    padding-left: 0;
    list-style: none
}

.w-embed:before,
.w-embed:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-embed:after {
    clear: both
}

.w-video {
    width: 100%;
    padding: 0;
    position: relative
}

.w-video iframe,
.w-video object,
.w-video embed {
    border: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0
}

fieldset {
    border: 0;
    margin: 0;
    padding: 0
}

button,
[type=button],
[type=reset] {
    cursor: pointer;
    -webkit-appearance: button;
    border: 0
}

.w-form {
    margin: 0 0 15px
}

.w-form-done {
    text-align: center;
    background-color: #ddd;
    padding: 20px;
    display: none
}

.w-form-fail {
    background-color: #ffdede;
    margin-top: 10px;
    padding: 10px;
    display: none
}

label {
    margin-bottom: 5px;
    font-weight: 700;
    display: block
}

.w-input,
.w-select {
    color: #333;
    vertical-align: middle;
    background-color: #fff;
    border: 1px solid #ccc;
    width: 100%;
    height: 38px;
    margin-bottom: 10px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 1.42857;
    display: block
}

.w-input:-moz-placeholder,
.w-select:-moz-placeholder {
    color: #999
}

.w-input::-moz-placeholder,
.w-select::-moz-placeholder {
    color: #999;
    opacity: 1
}

.w-input::-webkit-input-placeholder,
.w-select::-webkit-input-placeholder {
    color: #999
}

.w-input:focus,
.w-select:focus {
    border-color: #3898ec;
    outline: 0
}

.w-input[disabled],
.w-select[disabled],
.w-input[readonly],
.w-select[readonly],
fieldset[disabled] .w-input,
fieldset[disabled] .w-select {
    cursor: not-allowed
}

.w-input[disabled]:not(.w-input-disabled),
.w-select[disabled]:not(.w-input-disabled),
.w-input[readonly],
.w-select[readonly],
fieldset[disabled]:not(.w-input-disabled) .w-input,
fieldset[disabled]:not(.w-input-disabled) .w-select {
    background-color: #eee
}

textarea.w-input,
textarea.w-select {
    height: auto
}

.w-select {
    background-color: #f3f3f3
}

.w-select[multiple] {
    height: auto
}

.w-form-label {
    cursor: pointer;
    margin-bottom: 0;
    font-weight: 400;
    display: inline-block
}

.w-radio {
    margin-bottom: 5px;
    padding-left: 20px;
    display: block
}

.w-radio:before,
.w-radio:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-radio:after {
    clear: both
}

.w-radio-input {
    float: left;
    margin: 3px 0 0 -20px;
    line-height: normal
}

.w-file-upload {
    margin-bottom: 10px;
    display: block
}

.w-file-upload-input {
    opacity: 0;
    z-index: -100;
    width: .1px;
    height: .1px;
    position: absolute;
    overflow: hidden
}

.w-file-upload-default,
.w-file-upload-uploading,
.w-file-upload-success {
    color: #333;
    display: inline-block
}

.w-file-upload-error {
    margin-top: 10px;
    display: block
}

.w-file-upload-default.w-hidden,
.w-file-upload-uploading.w-hidden,
.w-file-upload-error.w-hidden,
.w-file-upload-success.w-hidden {
    display: none
}

.w-file-upload-uploading-btn {
    cursor: pointer;
    background-color: #fafafa;
    border: 1px solid #ccc;
    margin: 0;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 400;
    display: flex
}

.w-file-upload-file {
    background-color: #fafafa;
    border: 1px solid #ccc;
    flex-grow: 1;
    justify-content: space-between;
    margin: 0;
    padding: 8px 9px 8px 11px;
    display: flex
}

.w-file-upload-file-name {
    font-size: 14px;
    font-weight: 400;
    display: block
}

.w-file-remove-link {
    cursor: pointer;
    width: auto;
    height: auto;
    margin-top: 3px;
    margin-left: 10px;
    padding: 3px;
    display: block
}

.w-icon-file-upload-remove {
    margin: auto;
    font-size: 10px
}

.w-file-upload-error-msg {
    color: #ea384c;
    padding: 2px 0;
    display: inline-block
}

.w-file-upload-info {
    padding: 0 12px;
    line-height: 38px;
    display: inline-block
}

.w-file-upload-label {
    cursor: pointer;
    background-color: #fafafa;
    border: 1px solid #ccc;
    margin: 0;
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 400;
    display: inline-block
}

.w-icon-file-upload-icon,
.w-icon-file-upload-uploading {
    width: 20px;
    margin-right: 8px;
    display: inline-block
}

.w-icon-file-upload-uploading {
    height: 20px
}

.w-container {
    max-width: 940px;
    margin-left: auto;
    margin-right: auto
}

.w-container:before,
.w-container:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-container:after {
    clear: both
}

.w-container .w-row {
    margin-left: -10px;
    margin-right: -10px
}

.w-row:before,
.w-row:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-row:after {
    clear: both
}

.w-row .w-row {
    margin-left: 0;
    margin-right: 0
}

.w-col {
    float: left;
    width: 100%;
    min-height: 1px;
    padding-left: 10px;
    padding-right: 10px;
    position: relative
}

.w-col .w-col {
    padding-left: 0;
    padding-right: 0
}

.w-col-1 {
    width: 8.33333%
}

.w-col-2 {
    width: 16.6667%
}

.w-col-3 {
    width: 25%
}

.w-col-4 {
    width: 33.3333%
}

.w-col-5 {
    width: 41.6667%
}

.w-col-6 {
    width: 50%
}

.w-col-7 {
    width: 58.3333%
}

.w-col-8 {
    width: 66.6667%
}

.w-col-9 {
    width: 75%
}

.w-col-10 {
    width: 83.3333%
}

.w-col-11 {
    width: 91.6667%
}

.w-col-12 {
    width: 100%
}

.w-hidden-main {
    display: none !important
}

@media screen and (max-width:991px) {
    .w-container {
        max-width: 728px
    }

    .w-hidden-main {
        display: inherit !important
    }

    .w-hidden-medium {
        display: none !important
    }

    .w-col-medium-1 {
        width: 8.33333%
    }

    .w-col-medium-2 {
        width: 16.6667%
    }

    .w-col-medium-3 {
        width: 25%
    }

    .w-col-medium-4 {
        width: 33.3333%
    }

    .w-col-medium-5 {
        width: 41.6667%
    }

    .w-col-medium-6 {
        width: 50%
    }

    .w-col-medium-7 {
        width: 58.3333%
    }

    .w-col-medium-8 {
        width: 66.6667%
    }

    .w-col-medium-9 {
        width: 75%
    }

    .w-col-medium-10 {
        width: 83.3333%
    }

    .w-col-medium-11 {
        width: 91.6667%
    }

    .w-col-medium-12 {
        width: 100%
    }

    .w-col-stack {
        width: 100%;
        left: auto;
        right: auto
    }
}

@media screen and (max-width:767px) {

    .w-hidden-main,
    .w-hidden-medium {
        display: inherit !important
    }

    .w-hidden-small {
        display: none !important
    }

    .w-row,
    .w-container .w-row {
        margin-left: 0;
        margin-right: 0
    }

    .w-col {
        width: 100%;
        left: auto;
        right: auto
    }

    .w-col-small-1 {
        width: 8.33333%
    }

    .w-col-small-2 {
        width: 16.6667%
    }

    .w-col-small-3 {
        width: 25%
    }

    .w-col-small-4 {
        width: 33.3333%
    }

    .w-col-small-5 {
        width: 41.6667%
    }

    .w-col-small-6 {
        width: 50%
    }

    .w-col-small-7 {
        width: 58.3333%
    }

    .w-col-small-8 {
        width: 66.6667%
    }

    .w-col-small-9 {
        width: 75%
    }

    .w-col-small-10 {
        width: 83.3333%
    }

    .w-col-small-11 {
        width: 91.6667%
    }

    .w-col-small-12 {
        width: 100%
    }
}

@media screen and (max-width:479px) {
    .w-container {
        max-width: none
    }

    .w-hidden-main,
    .w-hidden-medium,
    .w-hidden-small {
        display: inherit !important
    }

    .w-hidden-tiny {
        display: none !important
    }

    .w-col {
        width: 100%
    }

    .w-col-tiny-1 {
        width: 8.33333%
    }

    .w-col-tiny-2 {
        width: 16.6667%
    }

    .w-col-tiny-3 {
        width: 25%
    }

    .w-col-tiny-4 {
        width: 33.3333%
    }

    .w-col-tiny-5 {
        width: 41.6667%
    }

    .w-col-tiny-6 {
        width: 50%
    }

    .w-col-tiny-7 {
        width: 58.3333%
    }

    .w-col-tiny-8 {
        width: 66.6667%
    }

    .w-col-tiny-9 {
        width: 75%
    }

    .w-col-tiny-10 {
        width: 83.3333%
    }

    .w-col-tiny-11 {
        width: 91.6667%
    }

    .w-col-tiny-12 {
        width: 100%
    }
}

.w-widget {
    position: relative
}

.w-widget-map {
    width: 100%;
    height: 400px
}

.w-widget-map label {
    width: auto;
    display: inline
}

.w-widget-map img {
    max-width: inherit
}

.w-widget-map .gm-style-iw {
    text-align: center
}

.w-widget-map .gm-style-iw>button {
    display: none !important
}

.w-widget-twitter {
    overflow: hidden
}

.w-widget-twitter-count-shim {
    vertical-align: top;
    text-align: center;
    background: #fff;
    border: 1px solid #758696;
    border-radius: 3px;
    width: 28px;
    height: 20px;
    display: inline-block;
    position: relative
}

.w-widget-twitter-count-shim * {
    pointer-events: none;
    -webkit-user-select: none;
    user-select: none
}

.w-widget-twitter-count-shim .w-widget-twitter-count-inner {
    text-align: center;
    color: #999;
    font-family: serif;
    font-size: 15px;
    line-height: 12px;
    position: relative
}

.w-widget-twitter-count-shim .w-widget-twitter-count-clear {
    display: block;
    position: relative
}

.w-widget-twitter-count-shim.w--large {
    width: 36px;
    height: 28px
}

.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {
    font-size: 18px;
    line-height: 18px
}

.w-widget-twitter-count-shim:not(.w--vertical) {
    margin-left: 5px;
    margin-right: 8px
}

.w-widget-twitter-count-shim:not(.w--vertical).w--large {
    margin-left: 6px
}

.w-widget-twitter-count-shim:not(.w--vertical):before,
.w-widget-twitter-count-shim:not(.w--vertical):after {
    content: " ";
    pointer-events: none;
    border: solid transparent;
    width: 0;
    height: 0;
    position: absolute;
    top: 50%;
    left: 0
}

.w-widget-twitter-count-shim:not(.w--vertical):before {
    border-width: 4px;
    border-color: rgba(117, 134, 150, 0) #5d6c7b rgba(117, 134, 150, 0) rgba(117, 134, 150, 0);
    margin-top: -4px;
    margin-left: -9px
}

.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {
    border-width: 5px;
    margin-top: -5px;
    margin-left: -10px
}

.w-widget-twitter-count-shim:not(.w--vertical):after {
    border-width: 4px;
    border-color: rgba(255, 255, 255, 0) #fff rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);
    margin-top: -4px;
    margin-left: -8px
}

.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {
    border-width: 5px;
    margin-top: -5px;
    margin-left: -9px
}

.w-widget-twitter-count-shim.w--vertical {
    width: 61px;
    height: 33px;
    margin-bottom: 8px
}

.w-widget-twitter-count-shim.w--vertical:before,
.w-widget-twitter-count-shim.w--vertical:after {
    content: " ";
    pointer-events: none;
    border: solid transparent;
    width: 0;
    height: 0;
    position: absolute;
    top: 100%;
    left: 50%
}

.w-widget-twitter-count-shim.w--vertical:before {
    border-width: 5px;
    border-color: #5d6c7b rgba(117, 134, 150, 0) rgba(117, 134, 150, 0);
    margin-left: -5px
}

.w-widget-twitter-count-shim.w--vertical:after {
    border-width: 4px;
    border-color: #fff rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);
    margin-left: -4px
}

.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {
    font-size: 18px;
    line-height: 22px
}

.w-widget-twitter-count-shim.w--vertical.w--large {
    width: 76px
}

.w-background-video {
    color: #fff;
    height: 500px;
    position: relative;
    overflow: hidden
}

.w-background-video>video {
    object-fit: cover;
    z-index: -100;
    background-position: 50%;
    background-size: cover;
    width: 100%;
    height: 100%;
    margin: auto;
    position: absolute;
    top: -100%;
    bottom: -100%;
    left: -100%;
    right: -100%
}

.w-background-video>video::-webkit-media-controls-start-playback-button {
    -webkit-appearance: none;
    display: none !important
}

.w-background-video--control {
    background-color: transparent;
    padding: 0;
    position: absolute;
    bottom: 1em;
    right: 1em
}

.w-background-video--control>[hidden] {
    display: none !important
}

.w-slider {
    text-align: center;
    clear: both;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
    background: #ddd;
    height: 300px;
    position: relative
}

.w-slider-mask {
    z-index: 1;
    white-space: nowrap;
    height: 100%;
    display: block;
    position: relative;
    left: 0;
    right: 0;
    overflow: hidden
}

.w-slide {
    vertical-align: top;
    white-space: normal;
    text-align: left;
    width: 100%;
    height: 100%;
    display: inline-block;
    position: relative
}

.w-slider-nav {
    z-index: 2;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
    height: 40px;
    margin: auto;
    padding-top: 10px;
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0
}

.w-slider-nav.w-round>div {
    border-radius: 100%
}

.w-slider-nav.w-num>div {
    font-size: inherit;
    line-height: inherit;
    width: auto;
    height: auto;
    padding: .2em .5em
}

.w-slider-nav.w-shadow>div {
    box-shadow: 0 0 3px rgba(51, 51, 51, .4)
}

.w-slider-nav-invert {
    color: #fff
}

.w-slider-nav-invert>div {
    background-color: rgba(34, 34, 34, .4)
}

.w-slider-nav-invert>div.w-active {
    background-color: #222
}

.w-slider-dot {
    cursor: pointer;
    background-color: rgba(255, 255, 255, .4);
    width: 1em;
    height: 1em;
    margin: 0 3px .5em;
    transition: background-color .1s, color .1s;
    display: inline-block;
    position: relative
}

.w-slider-dot.w-active {
    background-color: #fff
}

.w-slider-dot:focus {
    outline: none;
    box-shadow: 0 0 0 2px #fff
}

.w-slider-dot:focus.w-active {
    box-shadow: none
}

.w-slider-arrow-left,
.w-slider-arrow-right {
    cursor: pointer;
    color: #fff;
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
    -webkit-user-select: none;
    user-select: none;
    width: 80px;
    margin: auto;
    font-size: 40px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden
}

.w-slider-arrow-left [class^=w-icon-],
.w-slider-arrow-right [class^=w-icon-],
.w-slider-arrow-left [class*=\\ w-icon-],
.w-slider-arrow-right [class*=\\ w-icon-] {
    position: absolute
}

.w-slider-arrow-left:focus,
.w-slider-arrow-right:focus {
    outline: 0
}

.w-slider-arrow-left {
    z-index: 3;
    right: auto
}

.w-slider-arrow-right {
    z-index: 4;
    left: auto
}

.w-icon-slider-left,
.w-icon-slider-right {
    width: 1em;
    height: 1em;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0
}

.w-slider-aria-label {
    clip: rect(0 0 0 0);
    border: 0;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    position: absolute;
    overflow: hidden
}

.w-slider-force-show {
    display: block !important
}

.w-dropdown {
    text-align: left;
    z-index: 900;
    margin-left: auto;
    margin-right: auto;
    display: inline-block;
    position: relative
}

.w-dropdown-btn,
.w-dropdown-toggle,
.w-dropdown-link {
    vertical-align: top;
    color: #222;
    text-align: left;
    white-space: nowrap;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    text-decoration: none;
    position: relative
}

.w-dropdown-toggle {
    -webkit-user-select: none;
    user-select: none;
    cursor: pointer;
    padding-right: 40px;
    display: inline-block
}

.w-dropdown-toggle:focus {
    outline: 0
}

.w-icon-dropdown-toggle {
    width: 1em;
    height: 1em;
    margin: auto 20px auto auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0
}

.w-dropdown-list {
    background: #ddd;
    min-width: 100%;
    display: none;
    position: absolute
}

.w-dropdown-list.w--open {
    display: block
}

.w-dropdown-link {
    color: #222;
    padding: 10px 20px;
    display: block
}

.w-dropdown-link.w--current {
    color: #0082f3
}

.w-dropdown-link:focus {
    outline: 0
}

@media screen and (max-width:767px) {
    .w-nav-brand {
        padding-left: 10px
    }
}

.w-lightbox-backdrop {
    cursor: auto;
    letter-spacing: normal;
    text-indent: 0;
    text-shadow: none;
    text-transform: none;
    visibility: visible;
    white-space: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    color: #fff;
    text-align: center;
    z-index: 2000;
    opacity: 0;
    -webkit-user-select: none;
    -moz-user-select: none;
    -webkit-tap-highlight-color: transparent;
    background: rgba(0, 0, 0, .9);
    outline: 0;
    font-family: Helvetica Neue, Helvetica, Ubuntu, Segoe UI, Verdana, sans-serif;
    font-size: 17px;
    font-style: normal;
    font-weight: 300;
    line-height: 1.2;
    list-style: disc;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    -webkit-transform: translate(0)
}

.w-lightbox-backdrop,
.w-lightbox-container {
    -webkit-overflow-scrolling: touch;
    height: 100%;
    overflow: auto
}

.w-lightbox-content {
    height: 100vh;
    position: relative;
    overflow: hidden
}

.w-lightbox-view {
    opacity: 0;
    width: 100vw;
    height: 100vh;
    position: absolute
}

.w-lightbox-view:before {
    content: "";
    height: 100vh
}

.w-lightbox-group,
.w-lightbox-group .w-lightbox-view,
.w-lightbox-group .w-lightbox-view:before {
    height: 86vh
}

.w-lightbox-frame,
.w-lightbox-view:before {
    vertical-align: middle;
    display: inline-block
}

.w-lightbox-figure {
    margin: 0;
    position: relative
}

.w-lightbox-group .w-lightbox-figure {
    cursor: pointer
}

.w-lightbox-img {
    width: auto;
    max-width: none;
    height: auto
}

.w-lightbox-image {
    float: none;
    max-width: 100vw;
    max-height: 100vh;
    display: block
}

.w-lightbox-group .w-lightbox-image {
    max-height: 86vh
}

.w-lightbox-caption {
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: rgba(0, 0, 0, .4);
    padding: .5em 1em;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden
}

.w-lightbox-embed {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0
}

.w-lightbox-control {
    cursor: pointer;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 24px;
    width: 4em;
    transition: all .3s;
    position: absolute;
    top: 0
}

.w-lightbox-left {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    display: none;
    bottom: 0;
    left: 0
}

.w-lightbox-right {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    display: none;
    bottom: 0;
    right: 0
}

.w-lightbox-close {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: 18px;
    height: 2.6em;
    right: 0
}

.w-lightbox-strip {
    white-space: nowrap;
    padding: 0 1vh;
    line-height: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-x: hidden;
    overflow-y: hidden
}

.w-lightbox-item {
    box-sizing: content-box;
    cursor: pointer;
    width: 10vh;
    padding: 2vh 1vh;
    display: inline-block;
    -webkit-transform: translate(0, 0)
}

.w-lightbox-active {
    opacity: .3
}

.w-lightbox-thumbnail {
    background: #222;
    height: 10vh;
    position: relative;
    overflow: hidden
}

.w-lightbox-thumbnail-image {
    position: absolute;
    top: 0;
    left: 0
}

.w-lightbox-thumbnail .w-lightbox-tall {
    width: 100%;
    top: 50%;
    transform: translateY(-50%)
}

.w-lightbox-thumbnail .w-lightbox-wide {
    height: 100%;
    left: 50%;
    transform: translate(-50%)
}

.w-lightbox-spinner {
    box-sizing: border-box;
    border: 5px solid rgba(0, 0, 0, .4);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-top: -20px;
    margin-left: -20px;
    animation: .8s linear infinite spin;
    position: absolute;
    top: 50%;
    left: 50%
}

.w-lightbox-spinner:after {
    content: "";
    border: 3px solid transparent;
    border-bottom-color: #fff;
    border-radius: 50%;
    position: absolute;
    top: -4px;
    bottom: -4px;
    left: -4px;
    right: -4px
}

.w-lightbox-hide {
    display: none
}

.w-lightbox-noscroll {
    overflow: hidden
}

@media (min-width:768px) {
    .w-lightbox-content {
        height: 96vh;
        margin-top: 2vh
    }

    .w-lightbox-view,
    .w-lightbox-view:before {
        height: 96vh
    }

    .w-lightbox-group,
    .w-lightbox-group .w-lightbox-view,
    .w-lightbox-group .w-lightbox-view:before {
        height: 84vh
    }

    .w-lightbox-image {
        max-width: 96vw;
        max-height: 96vh
    }

    .w-lightbox-group .w-lightbox-image {
        max-width: 82.3vw;
        max-height: 84vh
    }

    .w-lightbox-left,
    .w-lightbox-right {
        opacity: .5;
        display: block
    }

    .w-lightbox-close {
        opacity: .8
    }

    .w-lightbox-control:hover {
        opacity: 1
    }
}

.w-lightbox-inactive,
.w-lightbox-inactive:hover {
    opacity: 0
}

.w-richtext:before,
.w-richtext:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-richtext:after {
    clear: both
}

.w-richtext[contenteditable=true]:before,
.w-richtext[contenteditable=true]:after {
    white-space: initial
}

.w-richtext ol,
.w-richtext ul {
    overflow: hidden
}

.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,
.w-richtext .w-richtext-figure-selected[data-rt-type=video] div:after,
.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,
.w-richtext .w-richtext-figure-selected[data-rt-type=image] div {
    outline: 2px solid #2895f7
}

.w-richtext figure.w-richtext-figure-type-video>div:after,
.w-richtext figure[data-rt-type=video]>div:after {
    content: "";
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0
}

.w-richtext figure {
    max-width: 60%;
    position: relative
}

.w-richtext figure>div:before {
    cursor: default !important
}

.w-richtext figure img {
    width: 100%
}

.w-richtext figure figcaption.w-richtext-figcaption-placeholder {
    opacity: .6
}

.w-richtext figure div {
    color: transparent;
    font-size: 0
}

.w-richtext figure.w-richtext-figure-type-image,
.w-richtext figure[data-rt-type=image] {
    display: table
}

.w-richtext figure.w-richtext-figure-type-image>div,
.w-richtext figure[data-rt-type=image]>div {
    display: inline-block
}

.w-richtext figure.w-richtext-figure-type-image>figcaption,
.w-richtext figure[data-rt-type=image]>figcaption {
    caption-side: bottom;
    display: table-caption
}

.w-richtext figure.w-richtext-figure-type-video,
.w-richtext figure[data-rt-type=video] {
    width: 60%;
    height: 0
}

.w-richtext figure.w-richtext-figure-type-video iframe,
.w-richtext figure[data-rt-type=video] iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0
}

.w-richtext figure.w-richtext-figure-type-video>div,
.w-richtext figure[data-rt-type=video]>div {
    width: 100%
}

.w-richtext figure.w-richtext-align-center {
    clear: both;
    margin-left: auto;
    margin-right: auto
}

.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image>div,
.w-richtext figure.w-richtext-align-center[data-rt-type=image]>div {
    max-width: 100%
}

.w-richtext figure.w-richtext-align-normal {
    clear: both
}

.w-richtext figure.w-richtext-align-fullwidth {
    text-align: center;
    clear: both;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: block
}

.w-richtext figure.w-richtext-align-fullwidth>div {
    padding-bottom: inherit;
    display: inline-block
}

.w-richtext figure.w-richtext-align-fullwidth>figcaption {
    display: block
}

.w-richtext figure.w-richtext-align-floatleft {
    float: left;
    clear: none;
    margin-right: 15px
}

.w-richtext figure.w-richtext-align-floatright {
    float: right;
    clear: none;
    margin-left: 15px
}

.w-nav {
    z-index: 1000;
    background: #ddd;
    position: relative
}

.w-nav:before,
.w-nav:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-nav:after {
    clear: both
}

.w-nav-brand {
    float: left;
    color: #333;
    text-decoration: none;
    position: relative
}

.w-nav-link {
    vertical-align: top;
    color: #222;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
    text-decoration: none;
    display: inline-block;
    position: relative
}

@media screen and (max-width:767px) {
    .mobile-padding {
        padding: 4px 0px 4px 0;
    }
}

.w-nav-link.w--current {
    color: #0082f3
}

.w-nav-menu {
    float: right;
    position: relative
}

[data-nav-menu-open] {
    text-align: center;
    background: #c8c8c8;
    min-width: 200px;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    overflow: visible;
    display: block !important
}

.w--nav-link-open {
    display: block;
    position: relative
}

.w-nav-overlay {
    width: 100%;
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    overflow: hidden
}

.w-nav-overlay [data-nav-menu-open] {
    top: 0
}

.w-nav[data-animation=over-left] .w-nav-overlay {
    width: auto
}

.w-nav[data-animation=over-left] .w-nav-overlay,
.w-nav[data-animation=over-left] [data-nav-menu-open] {
    z-index: 1;
    top: 0;
    right: auto
}

.w-nav[data-animation=over-right] .w-nav-overlay {
    width: auto
}

.w-nav[data-animation=over-right] .w-nav-overlay,
.w-nav[data-animation=over-right] [data-nav-menu-open] {
    z-index: 1;
    top: 0;
    left: auto
}


.w-tabs {
    position: relative
}

.w-tabs:before,
.w-tabs:after {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-tabs:after {
    clear: both
}

.w-tab-menu {
    position: relative
}

.w-tab-link {
    vertical-align: top;
    text-align: left;
    cursor: pointer;
    color: #222;
    background-color: #ddd;
    padding: 9px 30px;
    text-decoration: none;
    display: inline-block;
    position: relative
}

.w-tab-link.w--current {
    background-color: #c8c8c8
}

.w-tab-link:focus {
    outline: 0
}

.w-tab-content {
    display: block;
    position: relative;
    overflow: hidden
}

.w-tab-pane {
    display: none;
    position: relative
}

.w--tab-active {
    display: block
}

@media screen and (max-width:679px) {
    .w-tab-link {
        display: block
    }
}

.w-ix-emptyfix:after {
    content: ""
}

@keyframes spin {
    0% {
        transform: rotate(0)
    }

    to {
        transform: rotate(360deg)
    }
}

.w-dyn-empty {
    background-color: #ddd;
    padding: 10px
}

.w-dyn-hide,
.w-dyn-bind-empty,
.w-condition-invisible {
    display: none !important
}

.wf-layout-layout {
    display: grid
}

.w-code-component>* {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0
}

:root {
    --black: black;
    --white: white;
    --pabloo-green: #16A34A;
    /* Changed from #d53987 */
    --goldenrod: #ebb82f;
    --slate-blue: #5050ff;
    --black-2: #1f1f1f;
    --soft-pink: #faf2eb;
    --white-smoke: #f7f7f5;
    --light-slate-grey: #828aa5;
    --pabloo-green-2: #c73a88;
    --light-pink: #f5cde1;
    --dark-violet: #240213;
    --dark-green: #014737;
    --magenta: #5b002c;
    --darker-violet: #200010;
    --transparent: rgba(255, 255, 255, 0);
    --cream: #f7e8c7;
    --systemflow-lite--neutral--80: #636b75;
    --systemflow-lite--neutral--10: white;
    --systemflow-lite--neutral--100: #0e0f11;
    --systemflow-lite--neutral--20: #f9fafb;
    --elements-webflow-library--neutral--800: #211f54;
    --elements-webflow-library--neutral--300: #eff0f6;
    --elements-webflow-library--neutral--100: white;
    --elements-webflow-library--general--shadow-01: rgba(20, 20, 43, .06);
    --elements-webflow-library--accent--primary-1: #4a3aff;
    --elements-webflow-library--neutral--600: #6e7191;
    --systemflow-lite--primary--70: #1d39c4;
    --systemflow-lite--primary--80: #10239e;
    --systemflow-lite--primary--60: #2f54eb;
    --systemflow-lite--primary--50: #597ef7;
    --systemflow-lite--primary--10: #f2f6ff
}

.w-checkbox {
    margin-bottom: 5px;
    padding-left: 20px;
    display: block
}

.w-checkbox:before {
    content: " ";
    grid-area: 1/1/2/2;
    display: table
}

.w-checkbox:after {
    content: " ";
    clear: both;
    grid-area: 1/1/2/2;
    display: table
}

.w-checkbox-input {
    float: left;
    margin: 4px 0 0 -20px;
    line-height: normal
}

.w-checkbox-input--inputType-custom {
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 12px;
    height: 12px
}

.w-checkbox-input--inputType-custom.w--redirected-checked {
    background-color: #3898ec;
    background-image: url(https://d3e54v103j8qbb.cloudfront.net/static/custom-checkbox-checkmark.589d534424.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-color: #3898ec
}

.w-checkbox-input--inputType-custom.w--redirected-focus {
    box-shadow: 0 0 3px 1px #3898ec
}

.w-layout-grid {
    grid-row-gap: 16px;
    grid-column-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.w-layout-blockcontainer {
    max-width: 940px;
    margin-left: auto;
    margin-right: auto;
    display: block
}

.w-form-formradioinput--inputType-custom {
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 12px;
    height: 12px
}

.w-form-formradioinput--inputType-custom.w--redirected-focus {
    box-shadow: 0 0 3px 1px #3898ec
}

.w-form-formradioinput--inputType-custom.w--redirected-checked {
    border-width: 4px;
    border-color: #3898ec
}

.w-pagination-wrapper {
    flex-wrap: wrap;
    justify-content: center;
    display: flex
}

.w-pagination-previous {
    color: #333;
    background-color: #fafafa;
    border: 1px solid #ccc;
    border-radius: 2px;
    margin-left: 10px;
    margin-right: 10px;
    padding: 9px 20px;
    font-size: 14px;
    display: block
}

.w-pagination-previous-icon {
    margin-right: 4px
}

.w-pagination-next {
    color: #333;
    background-color: #fafafa;
    border: 1px solid #ccc;
    border-radius: 2px;
    margin-left: 10px;
    margin-right: 10px;
    padding: 9px 20px;
    font-size: 14px;
    display: block
}

.w-pagination-next-icon {
    margin-left: 4px
}

.w-embed-youtubevideo {
    background-image: url(https://d3e54v103j8qbb.cloudfront.net/static/youtube-placeholder.2b05e7d68d.svg);
    background-position: 50%;
    background-size: cover;
    width: 100%;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    position: relative
}

.w-embed-youtubevideo:empty {
    min-height: 75px;
    padding-bottom: 56.25%
}

@media screen and (max-width:991px) {
    .w-layout-blockcontainer {
        max-width: 728px
    }
}

@media screen and (max-width:767px) {
    .w-layout-blockcontainer {
        max-width: none
    }
}

body {
    color: var(--black);
    font-family: Satoshi, sans-serif;
    font-size: 18px;
    line-height: 28px
}

h1 {
    letter-spacing: -.5px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 64px;
    font-weight: 700;
    line-height: 64px
}

h2 {
    letter-spacing: -1px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 52px;
    font-weight: 700;
    line-height: 56px
}

h3 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px
}

h4 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px
}

h5 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px
}

h6 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 12px;
    font-weight: 700;
    line-height: 18px
}

p {
    margin-bottom: 0
}

a {
    color: var(--black);
    text-decoration: none
}

ul,
ol {
    margin-top: 0;
    margin-bottom: 10px;
    padding-left: 40px
}

img {
    max-width: 100%;
    height: auto;
    display: inline-block
}

strong {
    font-weight: 700
}

blockquote {
    border-left: 5px solid #e2e2e2;
    margin-bottom: 10px;
    padding: 10px 20px;
    font-size: 18px;
    line-height: 22px
}

figure {
    margin-bottom: 10px
}

figcaption {
    text-align: center;
    margin-top: 5px
}

.page-wrapper {
    margin-top: 0;
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    position: static
}

.page-wrapper.dark-bg {
    background-color: var(--black)
}

.main-wrapper {
    backdrop-filter: blur(20px);
    background-color: rgba(255, 255, 255, .59);
    height: 100%;
    margin-top: 0;
    position: relative
}

.main-wrapper.transparent-bg {
    background-color: transparent
}

.home-hero-section {
    margin-top: 60px;
    margin-bottom: 24px
}

.wrapper-1300px {
    z-index: 2;
    background-color: transparent;
    border-radius: 16px;
    flex-wrap: wrap;
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding: 2px 34px 40px;
    display: flex;
    position: relative
}

.wrapper-1300px.home-hero-flex {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;
    display: flex
}

.wrapper-1300px.featured-on-wrapper {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 24px
}

.wrapper-1300px.center {
    justify-content: center
}

.wrapper-1300px.mt-negative {
    margin-top: -32px
}

.wrapper-1300px.p0 {
    padding-left: 0;
    padding-right: 0
}

.wrapper-1300px.p-top-reset {
    padding-top: 0
}

.wrapper-1300px._40-0 {
    padding-bottom: 0
}

.wrapper-1300px._0-40 {
    padding-top: 0
}

.wrapper-1300px.for-about {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: .5fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    margin-left: auto;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    display: grid
}

.wrapper-1300px.for-integra {
    flex-flow: row;
    width: 100%;
    max-width: none;
    padding-left: 0;
    padding-right: 0
}

.large-link {
    color: #fff;
    white-space: nowrap;
    background-color: #000;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-left: 16px;
    padding: 22px 40px;
    text-decoration: none;
    display: flex
}

.large-link-2 {
    transform-origin: 100%;
    color: #fff;
    white-space: nowrap;
    background-color: #000;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-left: 16px;
    padding: 22px 40px;
    text-decoration: none;
    transition: background-color .34s;
    display: flex;
    overflow: hidden
}

.large-link-2:hover {
    background-color: var(--pabloo-green)
}

.large-link-2.show,
.large-link-2.show.w--current {
    border-radius: 8px;
    padding: 12px 32px
}

.nav-menu {
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    font-weight: 500;
    display: flex
}

.navigation-right {
    justify-content: flex-end;
    align-items: center;
    width: auto;
    height: 100%;
    padding-right: 0;
    display: flex
}

.navigation-right.tab-visibility {
    display: none
}

.nav-link-register {
    margin-left: 0;
    margin-right: 0;
    padding-left: 16px;
    padding-right: 16px;
    font-weight: 500;
    transition: all .4s
}

.nav-link-register:hover {
    color: var(--pabloo-green)
}

.nav-link-register.hide {
    display: block
}

.navigation-left {
    align-items: center;
    width: 25%;
    height: 100%;
    padding-left: 20px;
    padding-right: 0;
    display: flex
}

.navigation-container {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1440px;
    height: 100%;
    min-height: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.navigation-container.custo {
    padding-top: 8px;
    padding-right: 8px
}

.logo {
    width: 150px;
    height: 36px
}

.logo.competitor-landing-nav-logo {
    width: 100%
}

.nav-button-text {
    margin-right: 6px;
    font-weight: 500
}

.brand {
    padding: 12px
}

.nav-link {
    margin-left: 0;
    margin-right: 0;
    padding-left: 12px;
    padding-right: 12px;
    font-weight: 500;
    transition: all .4s;
    display: none
}

.nav-link:hover,
.nav-link.w--current {
    color: var(--pabloo-green)
}

.nav-link.show {
    display: block
}

.nav01 {
    background-color: #fff;
    align-items: center;
    height: 90px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%
}

.nav01.sticky {
    z-index: 99;
    background-color: var(--white);
    width: 100%;
    height: auto;
    min-height: 88px;
    padding: 24px 5%;
    position: sticky
}

.home-hero-content-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 56%;
    max-width: 680px;
    padding-bottom: 60px;
    display: flex
}

.home-hero-heading-wrapper {
    max-width: 680px;
    margin-bottom: 20px
}

.home-hero-heading {
    font-size: 64px;
    line-height: 1.2em
}

.home-hero-heading.smaller {
    font-size: 48px
}

.hero-special-span {
    color: var(--pabloo-green);
    letter-spacing: normal;
    font-family: "P22mackinacpro 11", sans-serif;
    font-style: italic;
    font-weight: 700
}

.hero-special-span.competitor-landing-usps-highlight-heading-span {
    color: var(--pabloo-green)
}

.home-hero-para-wrapper {
    max-width: 630px;
    margin-bottom: 36px
}

.home-hero-para {
    letter-spacing: -.2px;
    font-size: 20px;
    font-weight: 500
}

.home-hero-para.custo {
    font-size: 18px;
    font-weight: 400
}

.bold-span {
    box-shadow: inset 0 -18px 0 8px var(--goldenrod);
    font-weight: 700;
    line-height: 32px
}

.bold-span.no-bg {
    box-shadow: none
}

.button-wrapper {
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.button-wrapper.home-hero-btn-wrapper {
    grid-column-gap: 20px;
    grid-row-gap: 20px
}

.primary-button {
    border: 2px solid var(--pabloo-green);
    background-color: var(--pabloo-green);
    padding: 22px 32px;
    font-size: 20px;
    font-weight: 700;
    transition: color .36s, background-color .36s;
    display: none
}

.primary-button:hover {
    color: var(--pabloo-green);
    background-color: transparent
}

.primary-button.white-color-button {
    background-color: var(--white);
    color: var(--pabloo-green);
    border-radius: 8px;
    padding: 18px 22px;
    display: block
}

.primary-button.white-color-button:hover {
    border-color: var(--white);
    color: var(--white);
    background-color: transparent
}

.primary-button.contact-button {
    margin-top: 48px
}

.primary-button.contact-button.show {
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 18px
}

.primary-button.home {
    float: none;
    clear: none;
    border-radius: 8px;
    flex: none;
    padding: 12px 16px;
    font-size: 18px;
    display: block;
    position: static
}

.primary-button.home.pricing-cta {
    float: left
}

.primary-button.white-alter-button {
    border-color: var(--white);
    background-color: var(--pabloo-green)
}

.primary-button.white-alter-button:hover {
    background-color: var(--black);
    color: var(--white)
}

.primary-button.popup-form-button {
    margin-top: 36px
}

.primary-button.visible,
.primary-button.show {
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 18px;
    display: block
}

.primary-button.white-button.book-button {
    border-style: solid;
    border-color: var(--white);
    color: #d53987;
    text-align: center;
    border-radius: 6px;
    padding: 12px 20px;
    font-size: 16px;
    line-height: 140%;
    display: block
}

.primary-button.white-button.book-button:hover {
    border-style: solid;
    border-color: var(--white);
    background-color: var(--black);
    color: var(--white);
    transform: none
}

.primary-button.white-button.book-button.banner-cta-new {
    width: 200px
}

.primary-button.white-button.ads-button {
    color: var(--pabloo-green);
    border-radius: 6px;
    width: auto;
    max-width: none;
    padding: 12px 20px;
    font-size: 20px;
    line-height: 140%;
    display: inline-block
}

.primary-button.white-button.ads-button:hover {
    border-color: var(--white);
    color: var(--white);
    background-color: transparent
}

.hollow-button {
    color: var(--black);
    text-align: center;
    background-color: transparent;
    border: 2px solid #000;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 700;
    transition: color .36s, background-color .36s
}

.hollow-button:hover {
    background-color: var(--black);
    color: var(--white)
}

.hollow-button.white-hollow-button {
    border-color: var(--white);
    color: var(--white);
    background-color: transparent
}

.hollow-button.white-hollow-button:hover {
    border-color: var(--white);
    background-color: var(--white);
    color: var(--pabloo-green)
}

.hollow-button.white-bg-button {
    border-style: solid;
    border-color: var(--white);
    background-color: var(--white);
    padding-left: 32px;
    padding-right: 32px
}

.hollow-button.white-bg-button:hover {
    background-color: transparent;
    border-style: solid
}

.home-hero-stat-grid {
    grid-column-gap: 48px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-items: stretch;
    width: 100%;
    max-width: 800px;
    margin-top: 24px;
    margin-bottom: 40px;
    display: grid
}

.home-hero-stat-grid.pricing-stat.pricing-center {
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto
}

.home-hero-stat-grid.custo {
    grid-column-gap: 16px;
    justify-content: start;
    justify-items: start;
    margin-top: 56px;
    margin-left: auto;
    margin-right: auto
}

.home-hero-stat-item {
    text-align: center;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.hero-stat-block-square {
    border-top: 1px solid rgba(0, 0, 0, .1);
    border-left: 1px solid rgba(0, 0, 0, .1);
    width: 100%;
    height: 28px
}

.hero-stat-block-square.white-block {
    border-top-color: rgba(255, 255, 255, .1);
    border-left-color: rgba(255, 255, 255, .1)
}

.home-hero-stat-block {
    text-align: center;
    flex-direction: column;
    align-self: center;
    align-items: flex-start;
    padding-left: 20px;
    display: flex;
    position: relative
}

.home-hero-stat-number {
    color: var(--pabloo-green);
    margin-bottom: 8px;
    font-family: "P22mackinacpro 17", sans-serif;
    font-size: 56px;
    font-style: italic;
    font-weight: 700;
    line-height: 50px
}

.home-hero-stat-number.white-text,
.home-hero-stat-number.competitor-landing-usps-stat-number {
    color: var(--white)
}

.home-hero-stat-number.small {
    font-size: 52px
}

.home-hero-stat-text {
    font-size: 16px;
    font-weight: 500
}

.home-hero-stat-text.competitor-landing-hero-stat-text {
    color: var(--white)
}

.home-hero-stat-text.small {
    font-size: 18px
}

.home-hero-stat-text.pricing-text {
    color: #fff;
    font-weight: 400
}

.hero-image-wrapper {
    box-shadow: 14px 14px 0 0 var(--slate-blue);
    border-radius: 8px;
    width: 45%;
    max-width: 480px;
    margin-left: 2%
}

.home-hero-image {
    object-fit: cover;
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.cards-section {
    margin-bottom: 0;
    padding-bottom: 0;
    transition: opacity .2s
}

.cards-section.vertical-padding-large {
    text-align: center;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    margin-left: 70px;
    margin-right: 40px;
    padding-top: 19px;
    padding-bottom: 100px;
    display: flex
}

.logo-wrapper-head {
    text-align: center;
    margin-bottom: 50px
}

.logo-wrapper-head.integra._2-0 {
    width: 800px
}

.logo-wrapper-heading {
    font-size: 24px;
    font-weight: 700
}

.logo-wrapper-grid {
    flex-flow: wrap;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    width: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.logo-wrapper-grid.investors {
    grid-column-gap: 10%;
    grid-row-gap: 60px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: flex-start;
    margin-top: 8px;
    display: grid
}

.logo-wrapper-grid.logo-wrapper-grid-sm {
    flex-direction: row;
    align-content: stretch;
    align-items: stretch;
    max-width: 100%;
    display: block
}

.logo-wrapper-grid.as-featured-on-logos-wrapper-grid {
    align-items: center
}

.logo-container {
    filter: grayscale();
    width: 14%;
    height: 34px;
    margin-bottom: 32px;
    margin-left: 32px;
    margin-right: 32px
}

.logo-container.as-featured-on-logo-container {
    margin-top: 0
}

.logo-container.as-featured-on-logo-container.cnbc-logo-container {
    height: 44px
}

.company-logo {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.company-logo.accel-logo {
    height: 40px
}

.company-logo.publication-logo.forbes-logo {
    height: 80%
}

.company-logo.publication-logo.cnbc-logo,
.company-logo.publication-logo.et-logo {
    height: 100%
}

.company-logo.publication-logo.ent-logo {
    height: 80%
}

.home-value-section {
    background-color: var(--black-2);
    position: relative
}

.home-value-wrapper {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 160px;
    padding-bottom: 160px;
    display: flex
}

.home-value-content-wrapper {
    width: 53%;
    max-width: 640px
}

.home-value-heading {
    color: #fff;
    margin-bottom: 20px
}

.special-span {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif;
    font-style: italic;
    font-weight: 700
}

.home-value-para {
    color: var(--white);
    letter-spacing: .2px;
    width: 100%;
    max-width: 570px;
    font-weight: 500
}

.home-value-image-container {
    width: 45%;
    max-width: 470px;
    height: 412px;
    position: relative
}

.value-image-wrapper-1 {
    border-radius: 10px;
    max-width: 345px;
    max-height: 80px;
    position: absolute;
    top: 2%;
    bottom: auto;
    left: 0%;
    right: auto;
    transform: rotate(-4deg)
}

.home-value-image {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.value-image-wrapper-2 {
    max-width: 190px;
    max-height: 137px;
    position: absolute;
    top: 30%;
    bottom: auto;
    left: 26%;
    right: auto;
    transform: rotate(19deg)
}

.value-image-wrapper-3 {
    width: 412px;
    max-width: 412px;
    height: 112px;
    max-height: 112px;
    position: absolute;
    top: 71%;
    bottom: auto;
    left: 0%;
    right: auto;
    transform: rotate(10deg)
}

.home-split-section {
    background-color: var(--soft-pink);
    padding-top: 90px;
    padding-bottom: 29px
}

.home-split-section.light-grey-bg {
    background-color: var(--white-smoke)
}

.home-split-section.bottom-0 {
    padding-bottom: 0
}

.home-split-section._50-50 {
    padding-top: 0;
    padding-bottom: 50px
}

.split-section-wrapper {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.split-section-wrapper.wrapper-logo {
    z-index: 1;
    align-items: center;
    margin-top: 20px;
    position: relative
}

.split-section-wrapper.wrapper-logo.partners {
    align-items: flex-start
}

.split-section-wrapper.reverse {
    flex-wrap: nowrap;
    margin-top: 80px;
    position: relative
}

.split-section-content-container {
    flex-direction: column;
    flex: none;
    align-items: flex-start;
    width: 44%;
    max-width: 620px;
    display: flex
}

.split-section-content-container.split-2 {
    width: 45%
}

.split-section-content-container.max-width-520px {
    max-width: 520px
}

.split-section-heading {
    letter-spacing: -.5px;
    margin-bottom: 20px;
    font-size: 44px;
    line-height: 48px
}

.split-section-heading.max-width-560px {
    letter-spacing: -.5px;
    max-width: 560px
}

.split-section-heading.max-width-520px {
    letter-spacing: -.5px;
    max-width: 520px
}

.split-section-heading.last {
    margin-bottom: 0
}

.split-section-heading.max-width-560px {
    letter-spacing: -.5px;
    letter-spacing: -.5px;
    letter-spacing: -.5px;
    letter-spacing: -.5px;
    max-width: 560px;
    font-size: 40px
}

.blue-span {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif;
    font-style: italic;
    font-weight: 700
}

.split-pointer-container {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    display: flex
}

.split-pointer-container.support {
    max-width: 660px
}

.split-pointer-wrapper {
    align-items: flex-start;
    margin-bottom: 10px;
    display: flex
}

.split-pointer-icon-container {
    flex: none;
    width: 24px;
    height: 24px;
    margin-top: 3px;
    margin-right: 12px
}

.split-pointer-icon-container._20px {
    width: 20px;
    height: 20px;
    margin-top: 5px
}

.split-pointer-icon {
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: block
}

.split-pointer-text {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    font-weight: 500
}

.split-pointer-text.white-pointer-text {
    color: var(--white)
}

.pointer-bold-span {
    font-weight: 700
}

.split-button-wrapper {
    margin-top: 40px
}

.blue-button {
    background-color: var(--slate-blue);
    color: var(--white);
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 700;
    transition: background-color .36s
}

.blue-button:hover {
    background-color: var(--pabloo-green)
}

.split-image-wrapper {
    width: 45%;
    max-width: 560px;
    margin-top: 24px;
    position: static
}

.split-image-wrapper._50 {
    width: 50%
}

.split-image {
    box-shadow: none;
    object-fit: contain;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    margin-top: 32px;
    margin-bottom: 24px
}

.split-image.no-shadow {
    box-shadow: none;
    width: 80%
}

.split-image-2 {
    box-shadow: none;
    border-radius: 20px;
    max-width: none;
    max-height: none;
    position: absolute;
    top: auto;
    bottom: -20%;
    left: auto;
    right: 34%
}

.split-image-wrapper-2 {
    width: 50%;
    max-width: 660px;
    max-height: 528px;
    margin-right: 5%;
    position: relative
}

.split-image-wrapper-2.split-image-wrapper-3 {
    max-height: none
}

.split-top-image-container {
    border-radius: 5px;
    width: 48px;
    height: 48px;
    margin-bottom: 28px
}

.split-top-image {
    width: 100%;
    height: 100%
}

.home-work-wrapper {
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.home-work-wrapper.slack-steps-wrapper {
    flex-wrap: nowrap;
    padding: 40px 16px
}

.work-head-wrapper {
    margin-bottom: 80px
}

.work-head-wrapper.slack-steps-header-wrapper {
    width: 100%;
    margin-bottom: 32px
}

.work-head-wrapper.slack-steps-header-wrapper.m-b-0 {
    margin-bottom: 0
}

.work-span {
    font-family: "P22mackinacpro 18", sans-serif;
    font-style: italic;
    font-weight: 400
}

.work-span.color-pink {
    color: var(--pabloo-green)
}

.work-span.color-pink-11 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif;
    line-height: 90%
}

.home-work-slide-wrapper {
    width: auto
}

.home-work-slide-wrapper.slack-steps-wrapper {
    flex-wrap: nowrap;
    align-items: stretch;
    width: 100%;
    display: none
}

.home-work-slider {
    background-color: transparent;
    align-items: center
}

.slide-nave-hide {
    background-color: transparent;
    font-size: 10px;
    display: block;
    top: auto;
    bottom: -4%;
    left: 0%;
    right: 0%
}

.mask-visible {
    width: 100%;
    max-width: 440px;
    overflow: visible
}

.mask-visible._480px {
    max-width: 480px
}

.work-slide-container {
    background-color: #fff;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 40px;
    display: flex
}

.work-slide-container.slack-step-container {
    border-radius: 8px;
    flex-flow: column;
    flex: 0 1 auto;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 8px;
    margin-right: 8px;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, .1)
}

.work-slide-number-container {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61eba4f2f6ec07650a54102c_Number%20Cover.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    justify-content: center;
    align-items: center;
    width: 68px;
    height: 68px;
    margin-bottom: 28px;
    display: flex
}

.work-slide-number-container.dont-resize {
    flex: none;
    margin-bottom: 25px
}

.work-slide-number-container.slack-step-number {
    margin-bottom: 16px
}

.work-slider-text-wrapper {
    width: 100%;
    max-width: none;
    font-size: 24px;
    font-weight: 500
}

.work-slider-text-wrapper.sleck-step-text-wrapper {
    margin-bottom: 8px
}

.review-section {
    background-color: var(--white-smoke);
    padding-top: 120px;
    padding-bottom: 120px
}

.review-head-wrapper {
    text-align: center;
    max-width: 810px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto
}

.review-heading {
    color: var(--black);
    letter-spacing: -.5px;
    font-size: 44px
}

.review-span-head {
    font-family: "P22mackinacpro 15", sans-serif
}

.review-slider-wrapper {
    justify-content: center;
    align-items: center;
    width: 100%
}

.review-slider {
    background-color: transparent;
    border-radius: 10px;
    max-width: 1080px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.review-slider.india {
    display: none
}

.mask-not-visible {
    border-radius: 10px
}

.review-slide {
    background-color: transparent;
    border-radius: 0;
    padding: 40px 32px
}

.review-slider-container {
    background-color: var(--white);
    border-radius: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 16px 0 16px 40px;
    display: flex;
    position: relative;
    box-shadow: 0 0 16px rgba(0, 0, 0, .08)
}

.review-slider-container.home {
    box-shadow: none;
    background-color: transparent
}

.review-company-image-container {
    flex: none;
    height: 40px;
    margin-bottom: 32px;
    line-height: 40px
}

.review-company-image-container.airmeet-logo-wrapper {
    height: 40px
}

.review-company-image-container.synthesis-testimonial-logo {
    height: 32px
}

.review-company-image {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.review-company-image.remo-logo {
    height: 60%
}

.review-slider-content-wrapper {
    flex: none;
    align-items: center;
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 100px;
    margin-bottom: 40px;
    display: flex
}

.review-slider-text {
    color: var(--black);
    margin-left: auto;
    margin-right: auto;
    font-size: 22px;
    font-weight: 400;
    line-height: 1.3
}

.mention-span {
    color: var(--pabloo-green)
}

.review-slider-author-wrapper {
    flex: none;
    align-items: center;
    max-width: none;
    display: flex
}

.review-author-image-wrapper {
    border-radius: 100%;
    flex: none;
    width: 56px;
    height: 56px;
    margin-right: 16px;
    overflow: hidden
}

.review-author-image {
    width: 100%;
    height: 100%
}

.review-author-info-wrapper {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex-direction: column;
    grid-template-rows: auto;
    grid-template-columns: auto auto 1fr;
    grid-auto-columns: 1fr;
    align-items: flex-start;
    display: grid
}

.review-author-name {
    color: var(--black);
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5
}

.review-author-job-post {
    color: rgba(0, 0, 0, .64);
    font-size: 16px;
    font-weight: 500
}

.home-pointers-section {
    padding-top: 90px;
    padding-bottom: 90px
}

.home-pointers-split-wrapper {
    justify-content: space-around;
    align-items: center;
    display: flex
}

.home-pointers-image-wrapper {
    flex: none;
    width: 45%;
    max-width: 560px;
    margin-right: 5%
}

.home-pointer-split-image {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.home-pointer-split-content-wrapper {
    flex-direction: column;
    flex: none;
    align-items: flex-start;
    width: 45%;
    max-width: 560px;
    display: flex
}

.pitch-section {
    background-color: var(--white-smoke);
    margin-top: 31px;
    margin-bottom: 0;
    padding-top: 55px;
    padding-bottom: 83px
}

.pitch-head-wrapper {
    text-align: center;
    max-width: 840px;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto
}

.pitch-heading {
    margin-top: 19px;
    margin-bottom: 19px;
    font-size: 44px
}

.pitch-illustration-wrapper {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex
}

.pitch-illustration-head {
    border-radius: 10px;
    flex: none;
    width: 240px;
    height: 64px
}

.pitch-illustration {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.pitch-brach-wrapper {
    width: 85%
}

.pitch-brach-wrapper.persona {
    width: auto
}

.brach-image {
    width: 100%;
    height: 100%
}

.brach-image.branch-image-vertical {
    display: none
}

.branch-card-wrapper {
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    flex: none;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.branch-card-wrapper.branch-persona {
    grid-template-columns: 1fr 1fr;
    max-width: 920px
}

.branch-card-wrapper.three-columns {
    grid-template-columns: 1fr 1fr 1fr
}

.pitch-main-card {
    border: 2px solid var(--pabloo-green);
    background-color: var(--white);
    box-shadow: -7px 7px 0 0 var(--pabloo-green);
    outline-offset: 0px;
    border-radius: 10px;
    outline: 3px #000;
    padding: 28px
}

.pitch-main-card.bottom-block.mobile {
    display: none
}

.pitch-card-content-wrapper {
    flex-direction: column;
    align-items: flex-start;
    max-width: 214px;
    display: flex
}

.pitch-card-content-wrapper.persona {
    max-width: none
}

.pitch-card-icon-wrapper {
    flex: none;
    width: 48px;
    height: 48px;
    margin-bottom: 24px
}

.pitch-icon {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.pitch-card-head {
    color: var(--black-2);
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.7
}

.pitch-card-para {
    flex: none;
    font-weight: 500
}

.pitch-card-para.persona {
    color: var(--black)
}

.home-support-section {
    background-color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62e4d52ca92ff67972f30036_ezgif.com-gif-maker.webp);
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: -24px;
    padding-top: 80px;
    padding-bottom: 80px
}

.support-wrapper {
    justify-content: space-between;
    display: flex
}

.support-content-wrapper {
    flex: none;
    width: 100%;
    max-width: 730px
}

.support-heading {
    color: var(--white);
    margin-bottom: 28px
}

.support-span {
    font-family: "P22mackinacpro 15", sans-serif;
    font-style: italic
}

.support-button-wrapper {
    align-items: flex-start;
    margin-top: 40px;
    display: flex
}

.faq-section {
    padding-top: 90px;
    padding-bottom: 90px
}

.faq-head-wrapper {
    text-align: center;
    margin-bottom: 68px
}

.faq-heading {
    font-size: 32px
}

.faq-wrapper {
    grid-column-gap: 40px;
    grid-row-gap: 28px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.faq-container {
    background-color: var(--white-smoke);
    box-shadow: none;
    cursor: pointer;
    border-radius: 10px;
    max-width: 620px;
    margin-bottom: 28px;
    padding: 24px 40px;
    transition: box-shadow .36s
}

.faq-container:hover {
    box-shadow: -8px 8px 0 0 var(--slate-blue)
}

.faq-question-wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    display: flex
}

.faq-question {
    max-width: 480px;
    margin-right: 28px;
    font-size: 20px;
    font-weight: 500
}

.faq-dropdown-icon-container {
    flex: none;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    display: flex
}

.faq-dropdown-icon {
    width: 100%;
    height: 100%
}

.faq-answer-wrapper {
    width: 100%;
    max-width: 525px;
    margin-top: 14px;
    display: none;
    overflow: hidden
}

.faq-answer {
    color: rgba(0, 0, 0, .7);
    font-weight: 500;
    line-height: 1.4
}

.cta-section {
    background-color: var(--pabloo-green);
    padding-top: 0;
    padding-bottom: 0
}

.cta-split-wrapper {
    justify-content: space-between;
    align-items: stretch;
    display: flex;
    position: relative
}

.cta-split-wrapper.align-center {
    align-items: center
}

.cta-split-content-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 48%;
    max-width: 670px;
    padding-top: 130px;
    padding-bottom: 130px;
    display: flex
}

.cta-split-content-wrapper.persona {
    width: 49%;
    padding-top: 120px;
    padding-bottom: 120px
}

.cta-split-content-wrapper.width-sm {
    width: 40%
}

.cta-split-head-para {
    color: var(--black);
    letter-spacing: 0;
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 28px
}

.cta-split-head-para.pricing {
    letter-spacing: .2px;
    margin-bottom: 32px;
    font-size: 18px;
    font-weight: 400
}

.cta-split-head-para.persona {
    color: var(--white);
    margin-bottom: 40px
}

.cta-split-heading {
    color: var(--white);
    margin-bottom: 12px;
    font-size: 40px;
    line-height: 1.2em
}

.cta-split-heading.persona {
    margin-bottom: 15px
}

.cta-split-heading.heading-small {
    text-align: center;
    font-size: 32px;
    font-weight: 500
}

.white-alter-span {
    font-family: Satoshi, sans-serif;
    font-style: italic;
    font-weight: 700;
    display: inline
}

.white-alter-span.cta {
    display: inline
}

.white-alter-span.white {
    color: var(--black-2);
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 60px;
    font-style: normal;
    line-height: 1.2em
}

.cta-image-wrapper {
    width: 47%;
    max-width: 650px;
    max-height: none
}

.cta-image-wrapper.flex {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    display: flex
}

.cta-image-wrapper.flex.width-md {
    width: 50%
}

.cta-image {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.cta-image.h-auto {
    width: 80%;
    max-width: 80%;
    height: auto;
    margin-left: auto;
    margin-right: auto
}

.footer {
    background-color: var(--black);
    padding-bottom: 28px
}

.footer-content-wrapper {
    flex-direction: column;
    width: 100%;
    display: flex
}

.footer-logo-container {
    align-items: center;
    width: 141px;
    max-height: 30px;
    display: flex
}

.footer-logo-container.w--current {
    margin-right: 48px
}

.footer-logo {
    width: 100%;
    height: 100%
}

.footer-down-container {
    border-top: 1px solid rgba(255, 255, 255, .1);
    flex: none;
    justify-content: space-between;
    align-items: center;
    padding-top: 28px;
    line-height: 16px;
    display: flex
}

.footer-down-container.competitor-landing-footer-bottom-section {
    padding-bottom: 32px
}

.copyright-text {
    color: rgba(255, 255, 255, .8);
    flex: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 100%
}

.footer-down-link {
    color: rgba(255, 255, 255, .8);
    margin-left: 32px;
    margin-right: 0;
    font-size: 16px;
    text-decoration: none;
    transition: opacity .4s
}

.footer-down-link:hover {
    color: #fff
}

.pricing-hero-section {
    background-color: var(--pabloo-green);
    background-image: none;
    background-position: 0 0;
    background-size: auto;
    margin-bottom: 90px;
    padding-top: 88px;
    padding-bottom: 80px;
    position: relative
}

.pricing-hero-section.blue-bg {
    background-color: var(--slate-blue);
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto
}

.home-slider-section {
    background-color: var(--pabloo-green);
    padding-top: 80px;
    padding-bottom: 80px;
    position: relative
}

.home-slider-section.cs {
    height: 90vh;
    padding-top: 140px;
    padding-bottom: 140px
}

.home-slider-section-head {
    text-align: center;
    width: 100%;
    margin-bottom: 10px
}

.home-slider-section-heading {
    color: var(--white);
    max-width: 840px;
    margin-left: auto;
    margin-right: auto
}

.home-slider-main-wrapper {
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: flex
}

.home-slider-main-wrapper.cs {
    margin-top: 40px
}

.pricing-head-container {
    text-align: center;
    margin-bottom: 20px
}

.pricing-heading {
    color: var(--black-2);
    margin-bottom: 20px;
    font-size: 64px;
    line-height: 110%
}

.pricing-heading.white {
    color: var(--white)
}

.pricing-hero-para {
    color: var(--white);
    margin-bottom: 16px;
    font-size: 24px;
    line-height: 32px
}

.auto-slider-arrow-left {
    background-color: transparent;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    padding: 10px 5px;
    transition: background-color .3s;
    display: flex;
    position: absolute;
    top: auto;
    bottom: -20px;
    left: auto;
    right: 100px
}

.auto-slider-arrow-left:hover {
    background-color: var(--white)
}

.auto-slider-arrow-right {
    background-color: transparent;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    padding: 10px 5px;
    display: flex;
    position: absolute;
    top: auto;
    bottom: -20px;
    left: auto;
    right: 40px;
    overflow: visible
}

.auto-slider-arrow-right:hover {
    background-color: #fff
}

.auto-slider-arrow-right.home {
    display: none
}

.auto-slider-arrow-right.home.show {
    width: 64px;
    display: flex;
    bottom: -12px
}

.auto-slider-arrow-right.home.show {
    background-color: #fff;
    width: 64px;
    display: flex;
    bottom: 22px;
    right: 64px
}

.auto-slider-arrow-right.home.show:hover {
    background-color: #fff
}

.slider-icon {
    object-fit: contain;
    width: 30px;
    height: 30px;
    display: block
}

.contact-hero-section {
    margin-top: -1px;
    margin-bottom: 110px
}

.contact-hero-wrapper {
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 167px;
    display: flex
}

.contact-hero-text-wrapper {
    flex-direction: column;
    width: 55%;
    max-width: 720px;
    display: flex
}

.contact-hero-heading {
    margin-bottom: 20px
}

.contact-hero-para {
    margin-bottom: 48px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4
}

.contact-field-wrapper {
    grid-column-gap: 48px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    margin-bottom: 20px;
    display: grid
}

.contact-field-block {
    flex-direction: column;
    align-items: flex-start;
    margin-right: 10px;
    display: flex;
    position: relative
}

.contact-form-field {
    letter-spacing: .2px;
    border: 1px #000;
    border-bottom: 2px solid rgba(0, 0, 0, .1);
    height: 46px;
    margin-bottom: 0;
    padding-bottom: 16px;
    padding-left: 0;
    font-size: 20px;
    font-weight: 500
}

.contact-form-field:focus {
    border-bottom-color: rgba(213, 57, 135, .1)
}

.contact-form-field::placeholder {
    color: rgba(0, 0, 0, .6)
}

.contact-form-select {
    color: rgba(0, 0, 0, .6);
    background-color: transparent;
    border: 1px #000;
    border-bottom: 2px solid rgba(0, 0, 0, .1);
    height: 46px;
    margin-bottom: 0;
    padding-bottom: 10px;
    padding-left: 0;
    font-size: 20px;
    font-weight: 500
}

.contact-message {
    border: 1px #000;
    border-bottom: 2px solid rgba(0, 0, 0, .1);
    padding-left: 0;
    font-size: 20px;
    font-weight: 500
}

.contact-message:focus {
    border-bottom-color: rgba(213, 57, 135, .2)
}

.contact-message::placeholder {
    color: rgba(0, 0, 0, .6)
}

.email-section {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61e91732e354a8764f6fdb08_Group%2023%20\\(2\\).svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 120px;
    padding-bottom: 120px
}

.email-heading {
    color: var(--white)
}

.email-span {
    color: var(--white);
    font-family: "P22mackinacpro 15", sans-serif;
    font-style: italic;
    text-decoration: none
}

.email-link {
    border-bottom: 1px solid var(--white);
    color: var(--white);
    text-decoration: none
}

.blog-hero-section {
    background-color: var(--soft-pink);
    padding-top: 120px;
    padding-bottom: 250px;
    position: relative
}

.blog-hero-wrapper {
    text-align: center;
    flex-direction: column;
    flex: 1 1;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex
}

.blog-hero-heading {
    color: var(--white);
    letter-spacing: normal;
    max-width: 960px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto
}

.blog-hero-para {
    color: var(--white);
    max-width: 480px;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.5
}

.blog-hero-form-block {
    border-radius: 10px;
    max-width: 577px;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    display: block
}

.blog-hero-form-block.m-t-4 {
    margin-top: 8px
}

.blog-form {
    align-items: stretch;
    max-width: 577px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.blog-form-field {
    color: var(--white);
    letter-spacing: .2px;
    background-color: rgba(255, 255, 255, .07);
    border: 1px #000;
    border-radius: 8px;
    height: 64px;
    margin-bottom: 0;
    margin-right: 20px;
    padding-left: 24px;
    font-size: 20px;
    font-weight: 400
}

.blog-form-field::placeholder {
    color: #fff;
    letter-spacing: .2px;
    font-weight: 400
}

.blog-form-field.custo {
    background-color: rgba(0, 0, 0, .56)
}

.subscribe-button {
    border: 2px solid var(--white);
    background-color: var(--white);
    color: var(--pabloo-green);
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    transition: all .36s
}

.subscribe-button:hover {
    border: 2px solid var(--white);
    background-color: var(--pabloo-green);
    color: var(--white)
}

.blog-feature-section {
    position: relative;
    top: -201px
}

.blog-feature-wrapper {
    background-color: var(--white);
    border-radius: 10px;
    width: 100%;
    padding: 24px;
    box-shadow: 0 10px 100px rgba(0, 0, 0, .1)
}

.blog-feature-wrapper.custo {
    border: 8px none var(--goldenrod);
    background-color: var(--white-smoke);
    border-radius: 8px
}

.wrapper-1080px {
    width: 80%;
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto
}

.wrapper-1080px.blog-wrapper {
    width: 80%;
    max-width: 1260px;
    display: flex
}

.blog-feature-block {
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    height: auto;
    display: grid
}

.blog-feature-block.guide {
    grid-template-columns: 1fr 2fr
}

.blog-feature-image-container {
    border-radius: 10px;
    width: 100%;
    max-width: 538px;
    height: auto;
    overflow: hidden
}

.blog-feature-image {
    object-fit: contain;
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.blog-feature-info-top {
    align-items: center;
    margin-bottom: 20px;
    display: flex
}

.blog-feature-info-top.spread {
    flex: 0 1 auto;
    justify-content: space-between;
    width: 100%
}

.blog-tag-text {
    color: var(--pabloo-green);
    letter-spacing: .8px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700
}

.blog-date {
    color: rgba(0, 0, 0, .6);
    letter-spacing: .8px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700
}

.divider-circle {
    background-color: rgba(0, 0, 0, .2);
    border-radius: 100%;
    flex: none;
    width: 6px;
    height: 6px;
    margin-left: 10px;
    margin-right: 10px
}

.blog-feature-heading {
    letter-spacing: -.5px;
    margin-bottom: 12px;
    font-size: 32px;
    line-height: 36px
}

.blog-feature-para {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 17px;
    line-height: 1.5
}

.blog-feature-author-block {
    align-items: center;
    margin-top: 80px;
    display: flex
}

.blog-feature-author-block.blog-collection {
    margin-top: 0
}

.blog-feature-author-image-block {
    border-radius: 100%;
    flex: none;
    width: 48px;
    height: 48px;
    margin-right: 10px;
    overflow: hidden
}

.blog-feature-author-image {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.blog-author-info-block {
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.blog-author-name {
    margin-bottom: 0;
    font-weight: 700;
    line-height: 18px
}

.blog-author-job-title {
    color: rgba(0, 0, 0, .6);
    margin-top: 8px;
    font-weight: 500;
    line-height: 18px
}

.cms-blog-block-section {
    padding-bottom: 140px
}

.cms-blog-blocks-wrapper {
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto
}

.cms-blog-blocks-wrapper.flex {
    flex-wrap: wrap;
    display: flex
}

.cms-blog-blocks-wrapper.flex.align {
    justify-content: center;
    margin-left: auto;
    margin-right: auto
}

.blog-filter-tab-container {
    z-index: 9999999
}

.blog-filter-tab {
    justify-content: center;
    align-items: center;
    display: none
}

.blog-tab {
    background-color: transparent;
    border-bottom: 2px solid rgba(31, 31, 31, .1);
    margin-left: 28px;
    margin-right: 28px;
    font-size: 20px;
    font-weight: 700
}

.blog-tab.w--current {
    border-bottom-color: var(--pabloo-green);
    background-color: transparent
}

.blog-tab-content {
    margin-top: 0;
    overflow: visible
}

.blog-collection-list {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.blog-collection-item {
    background-color: var(--white);
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 520px;
    padding: 24px 24px 38px;
    display: flex;
    box-shadow: 0 10px 80px rgba(0, 0, 0, .05)
}

.blog-collection-item:hover {
    box-shadow: 0 10px 40px rgba(0, 0, 0, .1)
}

.blog-collection-item.margin {
    max-width: 440px;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 12px
}

.blog-collection-item.margin.custo {
    border: 10px none var(--goldenrod);
    background-color: var(--white);
    border-radius: 0;
    max-width: 540px;
    margin-bottom: 12px;
    display: none
}

.blog-collection-item.margin.custo._1 {
    margin-top: 0;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px
}

.blog-collection-item.margin.custo._2 {
    background-image: none;
    margin-left: 0;
    margin-right: 12px;
    padding-left: 24px;
    padding-right: 24px
}

.blog-collection-item.margin.mt-16 {
    border-radius: 0;
    margin-top: 0;
    display: none
}

.blog-collection-item.limit-width {
    max-width: 440px;
    margin-left: 12px
}

.blog-collection-item.limit-width.custo {
    border: 10px none var(--goldenrod);
    border-radius: 0
}

.blog-collection-item.limit-width.custo.m-t-16 {
    margin-top: 0;
    margin-left: 0;
    margin-right: 12px
}

.blog-collection-parent-item {
    z-index: 999999;
    align-items: stretch;
    display: flex
}

.blog-card-image-container {
    border-radius: 10px;
    max-width: 470px;
    height: 296px;
    max-height: 296px;
    margin-bottom: 24px;
    overflow: hidden
}

.blog-card-image-container.ebook-1 {
    background-color: transparent
}

.blog-card-image {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.blog-card-image.custo {
    object-fit: contain;
    transform-style: preserve-3d
}

.blog-card-image.custo:hover {
    object-fit: contain;
    transform: scale3d(1.1, 1.1, 1.1)
}

.blog-card-content-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: 472px;
    display: flex
}

.blog-card-heading {
    font-family: Inter, sans-serif;
    font-size: 24px;
    line-height: 1.5
}

.blog-card-para {
    color: rgba(0, 0, 0, .8)
}

.blog-card-para.custo {
    margin-top: 16px;
    font-family: Inter, sans-serif
}

.success-message {
    background-color: var(--white);
    color: var(--slate-blue);
    border-radius: 10px;
    width: 100%;
    font-size: 20px;
    font-weight: 700
}

.error-message {
    color: #d5393c;
    background-color: #f3dada;
    border-radius: 10px;
    width: 100%;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    padding: 10px 20px;
    font-size: 18px;
    font-weight: 700
}

.empty-state {
    color: var(--slate-blue);
    text-align: center;
    background-color: rgba(80, 80, 255, .05);
    border-radius: 10px;
    padding: 24px;
    font-size: 20px;
    font-weight: 700
}

.blog-collection-hero-section {
    padding-top: 40px
}

.blog-collection-head-wrapper {
    margin-left: auto;
    margin-right: auto
}

.blog-collection-heading {
    margin-bottom: 16px;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 56px;
    line-height: 64px
}

.blog-collection-para {
    color: rgba(0, 0, 0, .82);
    letter-spacing: .2px;
    font-size: 24px;
    font-weight: 400;
    line-height: 36px
}

.blog-main-image-wrapper {
    width: 100%;
    max-width: 1440px;
    height: auto;
    max-height: none;
    margin: 24px auto 80px
}

.blog-main-image {
    object-fit: cover;
    border-radius: 16px;
    width: 100%;
    height: 100%
}

.blog-rich-text-section {
    padding-bottom: 120px;
    position: relative
}

.more-blog-section {
    background-color: var(--white-smoke);
    padding-top: 120px;
    padding-bottom: 120px
}

.more-blog-head {
    text-align: center;
    margin-bottom: 80px
}

.more-blog-heading {
    font-size: 44px
}

.blog-more-container {
    flex-direction: column;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    max-width: 1080px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.more-button-wrapper {
    flex: none;
    margin-top: 70px
}

.blog-rich-text {
    width: 100%;
    font-weight: 400
}

.blog-rich-text h2 {
    margin-bottom: 16px;
    font-size: 32px;
    line-height: 1.5
}

.blog-rich-text p {
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4
}

.blog-rich-text li {
    margin-bottom: 16px;
    font-size: 20px;
    list-style-type: decimal
}

.blog-rich-text h3 {
    margin-bottom: 12px
}

.blog-rich-text blockquote {
    background-color: rgba(213, 57, 135, .2);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f130c006a25f4b76fe8f8c_Frame%20\\(2\\).svg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: auto;
    border-left-style: none;
    padding: 40px;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.4
}

.blog-rich-text img {
    margin-top: 10px
}

.blog-rich-text figcaption {
    color: rgba(0, 0, 0, .8);
    font-weight: 500;
    line-height: 1.6
}

.blog-rich-text a {
    /* color: var(--pabloo-green); */
    /* text-decoration: none */
}

.blog-rich-text h1 {
    margin-bottom: 30px
}

.blog-contact-container {
    border-top: 2px solid rgba(0, 0, 0, .1);
    justify-content: space-between;
    align-items: center;
    margin-top: 80px;
    padding-top: 48px;
    display: flex
}

.blog-designer-wrapper {
    margin-left: 48px
}

.home-value-bg-image-wrap {
    width: 70%;
    max-width: 700px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%
}

.home-value-bg-image {
    object-fit: cover;
    object-position: 0% 50%;
    width: 100%;
    height: 100%
}

.home-slider-image-1 {
    width: 30%;
    max-width: 400px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto
}

.home-slider-image-2 {
    width: 30%;
    max-width: 400px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.value-image-wrapper-4 {
    display: none
}

.pricing-hero-table {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: rgba(255, 255, 255, 0);
    border-radius: 20px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    max-width: 1048px;
    margin-top: 71px;
    margin-left: auto;
    margin-right: auto;
    display: grid;
    box-shadow: 7px 4px 24px rgba(0, 0, 0, .1)
}

.pricing-hero-table.new {
    margin-bottom: 0
}

.text-link {
    color: var(--pabloo-green);
    transition: background-color .2s
}

.text-link:hover {
    color: var(--slate-blue)
}

.pagination {
    flex-direction: row;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    margin-top: 60px;
    display: flex
}

.page-count {
    color: rgba(0, 0, 0, .6);
    width: auto;
    margin-top: 0;
    margin-right: 38px;
    font-weight: 500;
    display: flex
}

.next-button {
    border-width: 1.5px;
    border-color: var(--black);
    color: var(--black);
    cursor: pointer;
    background-color: transparent;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    transition: all .36s
}

.next-button:hover {
    border-color: var(--pabloo-green);
    background-color: var(--pabloo-green);
    color: var(--white)
}

.previous-button {
    border-width: 1.5px;
    border-color: var(--black);
    color: var(--black);
    cursor: pointer;
    background-color: transparent;
    border-radius: 8px;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    transition: all .36s
}

.previous-button:hover {
    border-color: var(--pabloo-green);
    background-color: var(--pabloo-green);
    color: var(--white)
}

.utility-page-wrap {
    justify-content: center;
    align-items: center;
    width: 100vw;
    max-width: 700px;
    height: 100vh;
    max-height: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.utility-page-wrap._404 {
    flex-direction: column;
    height: auto;
    margin-top: 200px;
    /* margin-bottom: -1vw */
}

@media screen and (max-width:767px) {
    .utility-page-wrap {
        justify-content: center;
        align-items: center;
        width: 100vw;
        max-width: 700px;
        height: 100vh;
        max-height: 100%;
        margin-left: auto;
        margin-right: auto;
        display: flex
    }

    .utility-page-wrap._404 {
        flex-direction: column;
        height: auto;
        margin-top: 30vw;
        margin-bottom: -18vw
    }
}

.utility-page-content {
    text-align: center;
    flex-direction: column;
    margin-bottom: 60px;
    display: flex
}

.utility-page-form {
    flex-direction: column;
    align-items: stretch;
    display: flex
}

.html-embed {
    width: 100%;
    margin-bottom: 50px
}

.pricing-table-left {
    background-color: #fff;
    width: 100%;
    height: 100%;
    padding: 0
}

.pricing-table-right {
    background-color: var(--white-smoke);
    flex: 0 1 auto;
    width: 100%;
    padding: 48px
}

.price-table-heading {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 700
}

.price-point-contain {
    margin-bottom: 38px
}

.price-point-wrapper {
    align-items: flex-start;
    margin-bottom: 18px;
    display: flex
}

.price-point-wrapper.price-point-seperator-wrapper {
    margin-bottom: 8px
}

.checkmark {
    margin-right: 16px
}

.price-point {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    max-width: 480px;
    margin-right: 0;
    font-size: 20px;
    font-weight: 500
}

.price-point.bold {
    color: #d53987;
    margin-right: 0;
    font-weight: 700
}

.price-point.bold.price-point-seperator {
    color: #000;
    font-size: 20px
}

.slack-span {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f43a6e8fe3d56a1da03474_image%2032.svg);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: contain;
    padding-left: 30px;
    font-weight: 700
}

.slack-span.regular {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f46550b9aea1f8ce4ee3bb_slack-new-logo%201.svg);
    background-size: auto;
    padding-left: 35px;
    font-weight: 500
}

.html-embed-2 {
    display: block
}

.black-button {
    background-color: var(--black);
    color: var(--white);
    border: 2px solid #000;
    border-radius: 8px;
    margin-left: auto;
    margin-right: auto;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 700;
    transition: color .36s, background-color .36s
}

.black-button:hover {
    background-color: var(--white);
    color: var(--black)
}

.popup {
    z-index: 2147483647;
    background-color: rgba(0, 0, 0, .85);
    justify-content: center;
    align-items: center;
    display: none;
    position: fixed;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.wrapper-1280px {
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 100px;
    display: flex;
    position: relative
}

.wrapper-1280px.popup-div {
    padding-top: 0;
    padding-bottom: 0
}

.wrapper-1280px.solution-wrapper {
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px.split-wrapper {
    flex-direction: column;
    align-items: stretch;
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px.finance-wrapper {
    flex-direction: column;
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px.together-blue-flex {
    max-width: 1200px
}

.wrapper-1280px.discover-product-hero-flex {
    flex-direction: column;
    padding-top: 88px;
    padding-bottom: 0
}

.wrapper-1280px.discover-purchase-flex {
    padding-top: 120px;
    padding-bottom: 140px
}

.wrapper-1280px.discover-tools-flex {
    max-width: 1260px;
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px.procurement-black-flex {
    flex-direction: column;
    align-items: stretch;
    padding-top: 140px;
    padding-bottom: 140px
}

.wrapper-1280px.case-study-hero-flex {
    padding-top: 64px;
    padding-bottom: 64px
}

.wrapper-1280px.case-study-flex {
    justify-content: center
}

.wrapper-1280px.track-approval-flex {
    max-width: 1260px
}

.wrapper-1280px.multi-channel-approval-flex {
    max-width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px
}

.wrapper-1280px.workflow-approval-flex {
    align-items: center;
    padding-bottom: 120px
}

.wrapper-1280px.fast-track-approval-hero-flex {
    z-index: 1;
    flex-direction: column;
    padding-top: 88px;
    padding-bottom: 0
}

.wrapper-1280px.document-one-place-flex {
    padding-top: 120px;
    padding-bottom: 140px
}

.wrapper-1280px.best-deals-flex {
    padding-top: 80px;
    padding-bottom: 80px
}

.wrapper-1280px.assisted-tools-flex {
    padding-top: 70px;
    padding-bottom: 120px
}

.wrapper-1280px.assisted-purchasing-flex {
    flex-direction: column;
    padding-top: 88px;
    padding-bottom: 0
}

.wrapper-1280px.actionable-insight-flex {
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px.contract-renewals-flex {
    max-width: 1200px;
    padding-top: 120px;
    padding-bottom: 140px
}

.wrapper-1280px.slack-steps-width-limiter {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px
}

.wrapper-1280px.custo {
    flex-wrap: wrap;
    justify-content: center
}

.wrapper-1280px.wrap {
    flex-wrap: wrap
}

.wrapper-1280px.custom {
    padding-top: 40px;
    padding-bottom: 80px
}

.wrapper-1280px.pt-xs {
    padding-top: 24px
}

.wrapper-1280px.points-container {
    z-index: 3
}

.html-embed-calendly {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto
}

.popup-close {
    border: 2px solid var(--white);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: -2%
}

.medium-span {
    font-weight: 500
}

.work-slider-number-2 {
    color: #d53987;
    font-family: "P22mackinacpro 17", sans-serif;
    font-size: 32px;
    font-weight: 700
}

.home-work-section-slider {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61e91732e354a8764f6fdb08_Group%2023%20\\(2\\).svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 80px;
    padding-bottom: 120px;
    overflow: hidden
}

.home-work-section-slider.blue-background {
    background-color: var(--slate-blue);
    background-image: none
}

.left-arrow-2 {
    background-color: rgba(255, 255, 255, .3);
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin-left: 0%;
    transition: all .3s;
    display: flex;
    top: auto;
    bottom: -20%;
    left: 0%;
    right: auto
}

.left-arrow-2:hover {
    background-color: rgba(255, 255, 255, .2);
    transform: translate(-5px)
}

.right-arrow-2 {
    background-color: rgba(255, 255, 255, .3);
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    transition: all .2s;
    display: flex;
    top: auto;
    bottom: -20%;
    left: 64px;
    right: auto
}

.right-arrow-2:hover {
    background-color: rgba(255, 255, 255, .2);
    transform: translate(5px)
}

.right-arrow-2.competitor-landing-page-how-it-works-slider {
    left: 14%
}

.home-work-heading-2 {
    color: #fff;
    line-height: 108%
}

.home-work-heading-2.slack-steps-heading {
    color: #000;
    margin-bottom: 20px
}

.work-slide-2 {
    background-color: #fff;
    border-radius: 10px;
    max-width: 440px;
    max-height: 272px;
    margin-right: 60px
}

.work-slide-2.max-width-500 {
    max-width: 500px
}

.slider-arrows {
    object-fit: contain
}

.privacy-section {
    padding-top: 100px;
    padding-bottom: 60px
}

.privacy-content-wrapper {
    flex: 1 1;
    display: flex
}

.privacy-rich-text {
    color: var(--black);
    display: block
}

.privacy-rich-text h2 {
    margin-bottom: 20px;
    font-size: 40px;
    line-height: 140%
}

.privacy-rich-text p {
    color: var(--light-slate-grey);
    margin-bottom: 14px;
    font-weight: 500
}

.privacy-rich-text h3 {
    text-align: center;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 20px;
    line-height: 120%
}

.privacy-rich-text ul {
    color: var(--light-slate-grey);
    font-weight: 500
}

.privacy-rich-text li {
    color: var(--light-slate-grey);
    margin-bottom: 10px
}

.privacy-rich-text ol {
    color: var(--light-slate-grey);
    font-weight: 500
}

.privacy-rich-text a {
    color: var(--pabloo-green-2);
    font-weight: 400
}

.privacy-rich-text a:hover {
    color: var(--black)
}

.blog-feature-block-section {
    padding-bottom: 120px;
    display: none
}

.blog-feature-item {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    background-color: var(--white);
    color: var(--black);
    border-radius: 10px;
    grid-template-rows: auto;
    grid-template-columns: 1.2fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    padding: 24px;
    display: grid;
    box-shadow: 0 10px 80px rgba(0, 0, 0, .07)
}

.blog-featured-image-container {
    border-radius: 10px;
    width: 100%;
    height: auto;
    overflow: hidden
}

.blog-featured-image {
    width: 100%
}

.blog-featured-text-container {
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.bold-head {
    text-transform: uppercase;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px
}

.blog-featured-heading {
    letter-spacing: -.5px;
    margin-bottom: 12px;
    font-size: 32px;
    line-height: 36px
}

.blog-featured-para {
    color: rgba(0, 0, 0, .7);
    letter-spacing: .2px;
    margin-bottom: 30px;
    font-size: 20px
}

.hide {
    display: none
}

.popup-container {
    background-color: var(--white);
    border-radius: 10px;
    width: 100%;
    max-width: 708px;
    margin-left: auto;
    margin-right: auto;
    padding: 50px;
    position: relative
}

.popup-heading {
    letter-spacing: -.5px;
    margin-bottom: 30px;
    font-size: 44px;
    line-height: 48px
}

.popup-cross {
    width: 52%;
    height: 52%
}

.popup-text-field {
    border: 1px #000;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
    width: 100%;
    margin-bottom: 0
}

.popup-text-field::placeholder {
    letter-spacing: .2px;
    font-size: 20px;
    font-weight: 500
}

.popup-text-field.form-right {
    width: 100%
}

.popup-split-block {
    grid-column-gap: 48px;
    grid-row-gap: 20px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    margin-bottom: 20px;
    display: grid
}

.popup-split-block.block-down {
    margin-bottom: 0
}

._16-px {
    color: #b6b6b6;
    flex-direction: row-reverse;
    flex: none;
    order: 0;
    font-size: 16px;
    line-height: 150%;
    display: flex
}

.about-head-container {
    text-align: center;
    flex: 0 1 auto;
    max-width: 1080px;
    margin: 78px auto 64px
}

.about-head-container.persona {
    max-width: 840px;
    margin-bottom: 100px
}

.about-head-container.procurement {
    flex-direction: column;
    align-items: center;
    max-width: 1060px;
    display: flex
}

.about-head-container.procurement.management-hub-hero {
    max-width: 1060px
}

.about-head-container.new {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    display: flex
}

.about-hero-text-contain {
    background-color: var(--white);
    border-radius: 10px;
    width: 100%;
    max-width: 960px;
    margin-top: -136px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 64px;
    padding-bottom: 40px;
    position: relative;
    top: 84px;
    bottom: 0%;
    left: 0%;
    right: 0%;
    box-shadow: 0 48px 120px rgba(0, 0, 0, .1)
}

.about-hero-text-wrap {
    width: 90%;
    margin-left: auto;
    margin-right: auto
}

.about-hero-paragraph {
    text-align: center;
    letter-spacing: .2px;
    width: 80%;
    margin-bottom: 24px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.2
}

.about-hero-paragraph.point {
    margin-bottom: 0
}

.about-hero-point-wrap {
    align-items: center;
    margin-bottom: 16px;
    display: flex
}

.about-point-icon {
    width: 100%;
    max-width: 40px;
    margin-right: 20px
}

.about-hero-wrapper {
    background-color: var(--slate-blue);
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    margin-bottom: 90px;
    padding-top: 120px;
    padding-bottom: 0;
    position: relative
}

.about-team-section {
    margin-top: 280px
}

.about-team-wrapper {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 70px
}

.about-team-heading {
    text-align: center;
    letter-spacing: -.5px;
    margin-bottom: 80px;
    margin-left: 0;
    margin-right: auto;
    font-size: 44px;
    line-height: 109%
}

.team-grid {
    grid-column-gap: 58px;
    grid-row-gap: 58px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    display: flex
}

.team-grid.speakers-grid-webinar {
    grid-column-gap: 16px;
    grid-row-gap: 24px;
    flex-wrap: wrap;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    margin-top: 24px;
    display: grid
}

.team-grid.speakers-grid-webinar.volopay-speakers {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    justify-content: flex-start;
    margin-top: 40px
}

.team-grid.speakers-grid-webinar.volopay-speakers.m-t-80 {
    grid-column-gap: 8px;
    margin-top: 80px
}

.team-member-wrap {
    flex: 0 1 auto
}

.team-member-wrap.m-r-32 {
    margin-right: 32px
}

.team-member-wrap.ml-16 {
    margin-left: 16px
}

.member-image-wrap {
    object-fit: contain;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    display: flex;
    position: relative
}

.member-image {
    position: static;
    top: -10px;
    right: 10px;
    box-shadow: 7px 7px #000
}

.member-image._1 {
    box-shadow: 7px 7px 0 0 var(--slate-blue);
    padding: 0 0%
}

.member-image._1.member-image-webinar {
    background-color: var(--white);
    max-width: none;
    max-height: 200px;
    line-height: 28px
}

.member-image._1.member-image-webinar.volopay-speaker-image {
    max-height: 200px
}

.member-image._1.member-image-webinar.saas-cfo-webinar {
    max-height: 240px
}

.member-image._1.member-image-webinar.saas-cfo-webinar.no-shadow {
    box-shadow: none;
    max-height: 300px
}

.member-image._1.member-image-webinar.saas-cfo-webinar.no-shadow.smaller {
    background-color: transparent;
    max-height: 240px;
    padding: 24px 0%
}

.member-image._1.member-image-webinar.no-shadow {
    box-shadow: none
}

.member-image._1.member-image-webinar.reset {
    padding: 0 0%
}

.member-image._2 {
    background-color: var(--white);
    box-shadow: 7px 7px 0 0 var(--pabloo-green);
    background-image: none;
    padding: 0 0%
}

.member-image._2.member-image-webinar {
    background-color: var(--white);
    background-image: none;
    max-width: none;
    max-height: 200px
}

.member-image._2.member-image-webinar.volopay-speaker-image {
    max-height: 200px
}

.member-image._2.member-image-webinar.volopay-speaker-image.speaker-2 {
    box-shadow: 7px 7px 0 0 var(--goldenrod)
}

.member-image._2.member-image-webinar.saas-cfo-webinar {
    max-height: 240px
}

.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow {
    box-shadow: none;
    max-height: 300px
}

.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller {
    background-color: transparent;
    background-image: none;
    max-height: 240px;
    padding-left: 0%;
    padding-right: 0%
}

.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller.pb-0 {
    object-fit: contain;
    width: 88%;
    margin-left: auto;
    margin-right: auto
}

.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.custo {
    max-height: 240px;
    padding-top: 0;
    padding-left: 0%;
    padding-right: 0%
}

.member-image._2.member-image-webinar.no-shadow {
    box-shadow: none
}

.member-image._2.member-image-webinar.reset {
    padding: 0 0%
}

.member-image._3 {
    box-shadow: 7px 7px #ebb82f
}

.member-info-contain {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-items: center;
    margin-top: 8px;
    display: grid
}

.member-name {
    letter-spacing: -.5px;
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 700;
    line-height: 133%
}

.member-name.volopay-member-name {
    text-align: center;
    margin-top: 8px;
    margin-bottom: 0;
    font-size: 20px
}

.member-company {
    color: #000;
    text-align: center;
    letter-spacing: .8px;
    text-transform: uppercase;
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 700;
    line-height: 125%
}

.member-ex-position {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    font-weight: 500;
    line-height: 133%
}

.career-section {
    background-color: var(--white-smoke)
}

.career-wrapper {
    justify-content: space-between;
    align-items: flex-start;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 120px;
    display: flex
}

.career-left-wrap {
    width: 50%;
    max-width: 600px;
    position: sticky;
    top: 120px
}

.career-right-wrap {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    width: 46%;
    max-width: 600px;
    display: grid
}

.career-block {
    background-color: var(--white);
    box-shadow: -7px 7px 0 0 var(--pabloo-green);
    border-radius: 10px;
    padding: 32px
}

.career-icon {
    width: 100%;
    max-width: 48px;
    margin-bottom: 24px
}

.career-paragraph {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    font-size: 24px;
    font-weight: 500;
    line-height: 125%
}

.career-heading {
    letter-spacing: -.5px;
    margin-bottom: 16px;
    font-size: 44px;
    line-height: 109%
}

.career-text {
    letter-spacing: .2px;
    margin-bottom: 40px;
    font-weight: 500;
    line-height: 156%
}

.about-slider-section {
    background-color: var(--black);
    display: none;
    position: relative;
    overflow: hidden
}

.about-slider-wrapper {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding: 120px 0 180px;
    position: relative
}

.about-slide {
    border-radius: 10px;
    max-width: 480px;
    margin-right: 60px
}

.about-slider-contain {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    display: flex
}

.about-slider {
    background-color: transparent;
    align-items: center;
    height: auto;
    position: relative
}

.left-arrow-about {
    background-color: rgba(255, 255, 255, .3);
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin-left: 0%;
    transition: all .3s;
    display: flex;
    top: auto;
    bottom: -40%;
    left: 0%;
    right: auto
}

.left-arrow-about:hover {
    background-color: rgba(255, 255, 255, .2);
    transform: translate(-5px)
}

.right-arrow-about {
    background-color: rgba(255, 255, 255, .3);
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    transition: all .2s;
    display: flex;
    top: auto;
    bottom: -40%;
    left: 70px;
    right: auto
}

.right-arrow-about:hover {
    background-color: rgba(255, 255, 255, .2);
    transform: translate(5px)
}

.about-span {
    text-align: left;
    font-family: "P22mackinacpro 11", sans-serif;
    font-style: italic;
    font-weight: 700
}

.number-text {
    color: var(--pabloo-green);
    margin-bottom: 24px;
    font-family: "P22mackinacpro 11", sans-serif;
    font-size: 64px;
    font-weight: 700;
    line-height: 100%
}

.about-subheading {
    color: var(--white);
    letter-spacing: -.5px;
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 700;
    line-height: 133%
}

.about-slide-text {
    color: var(--white);
    letter-spacing: .2px;
    max-width: 480px;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 133%
}

.background-image {
    height: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%
}

.about-slider-wrap {
    width: 100%;
    display: flex
}

.persona-hero-card {
    z-index: 20;
    background-color: #fff;
    border-radius: 10px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 85%;
    max-width: 1200px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    padding-top: 40px;
    padding-bottom: 40px;
    display: flex;
    position: relative;
    overflow: hidden;
    box-shadow: 0 48px 120px rgba(0, 0, 0, .04)
}

.persona-hero-card-image {
    width: 45%;
    max-width: 520px;
    height: 100%
}

.persona-hero-card-text {
    width: 48%;
    max-width: 520px;
    margin-left: 0;
    margin-right: 2%
}

.persona-card-text {
    font-size: 44px;
    line-height: 109%
}

.personal-top-tag-wrap {
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    display: flex
}

.top-tag-line {
    background-color: var(--goldenrod);
    width: 40px;
    height: 2px
}

.persona-head-para {
    color: var(--white);
    font-size: 20px;
    font-weight: 500;
    line-height: 140%
}

.persona-head-para.procurement {
    max-width: 840px
}

.persona-head-para.it {
    max-width: 920px
}

.persona-hero-button-wrap {
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    display: flex
}

.persona-hero-button-wrap.margin-top-120 {
    margin-top: 80px
}

.persona-hero-section {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642bffa1cb27627aca9c5cc7_Rectangle%201261.png);
    background-position: 0 80%;
    background-repeat: no-repeat;
    background-size: auto;
    position: relative
}

.persona-hero-section.no-bg {
    background-image: none
}

.persona-down-hero-bg {
    background-color: var(--white);
    width: 100%;
    height: 120px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.persona-solution-section {
    background-color: var(--black-2)
}

.solution-text-container {
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    max-width: 560px;
    margin-right: 3%;
    display: flex
}

.solution-heading {
    color: var(--white);
    margin-bottom: 16px;
    font-size: 32px;
    line-height: 112%
}

.persona-solution-para {
    color: var(--white);
    max-width: 465px;
    font-weight: 500;
    line-height: 156%
}

.persona-solution-pointers-wrap {
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    max-width: 520px;
    display: flex
}

.solution-pointer-head {
    color: var(--white);
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: 700;
    line-height: 133%
}

.solution-pointer-wrap {
    color: var(--white);
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 12px;
    font-weight: 500;
    line-height: 156%;
    display: flex
}

.solution-pointer-icon {
    flex: none;
    width: 24px;
    height: 24px;
    margin-top: 2px;
    margin-right: 12px
}

.persona-split-secion.split-2 {
    background-color: var(--white-smoke)
}

.persona-split-section-head {
    text-align: center;
    max-width: 840px;
    margin-bottom: 120px;
    margin-left: auto;
    margin-right: auto
}

.persona-split-section-head.procurement {
    max-width: 1140px
}

.persona-split-section-heading {
    line-height: 120%
}

.split-container {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.split-container.split-top-padding-0 {
    padding-top: 0
}

.split-container.split-inverse {
    flex-direction: row-reverse
}

.persona-split-text-container {
    flex-direction: column;
    align-items: flex-start;
    width: 46%;
    max-width: 480px;
    margin-right: 3%;
    display: flex
}

.persona-split-text-container.split-2 {
    max-width: 530px;
    margin-left: 3%;
    margin-right: 0%
}

.persona-split-text-container.split-3 {
    max-width: 560px
}

.persona-split-text-container.procurement {
    max-width: 520px
}

.persona-split-text-container.procurement-2-text {
    width: 40%;
    max-width: 540px;
    margin-left: 3%;
    margin-right: 0%
}

.persona-split-text-container.procurement-2-text._w-50 {
    width: 50%
}

.persona-split-text-container.it {
    width: 40%;
    max-width: 520px
}

.persona-split-icon-container {
    border-radius: 5px;
    flex: none;
    width: 48px;
    height: 48px;
    margin-bottom: 28px;
    overflow: hidden
}

.persona-split-icon {
    width: 100%;
    height: 100%
}

.persona-split-text {
    margin-bottom: 16px;
    font-size: 44px;
    line-height: 120%
}

.persona-split-para {
    max-width: 480px;
    font-weight: 500;
    line-height: 156%
}

.persona-split-image-container {
    box-shadow: -15px 13px 0 0 var(--slate-blue);
    border-radius: 8px;
    width: 53%;
    max-width: 600px;
    margin-right: 30px;
    position: relative
}

.persona-split-image-container.split-2 {
    box-shadow: -15px 13px 0 0 var(--pabloo-green);
    margin-right: 0
}

.persona-split-image-container.procurement-1-image {
    margin-right: 0
}

.persona-split-image-container.procurement-1-image.proc-image-alternate-landing,
.persona-split-image-container.procurement-section-3-image {
    box-shadow: none
}

.persona-split-image-container.procurement-section-3-image._w-50 {
    width: 50%
}

.persona-split-image {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-shadow: 0 10px 20px rgba(31, 31, 31, .05)
}

.persona-split-image.procurement-section-3 {
    z-index: 10;
    box-shadow: none;
    position: relative
}

.persona-split-image.procurement-section-3.solid-shadow {
    box-shadow: -11px 11px 0 0 var(--pabloo-green)
}

.persona-split-image.split-image-alternate-landing {
    box-shadow: 0 0 8px rgba(0, 0, 0, .16)
}

.persona-split-image.split-image-alternate-landing.hide-shadow {
    box-shadow: none
}

.persona-split-image.split-image-alternate-landing.hide-shadow.solid-shadow {
    box-shadow: 11px 11px 0 0 var(--slate-blue)
}

.persona-split-side-image {
    border-radius: 10px;
    width: 40%;
    position: absolute;
    top: 35%;
    bottom: auto;
    left: auto;
    right: -7%;
    overflow: hidden;
    box-shadow: -17px 17px 100px rgba(0, 0, 0, .08)
}

.persona-split-side-image.split-2 {
    width: 30%;
    top: 27%;
    right: -3%
}

.persona-split-side-image.split-3 {
    width: 60%;
    top: 18%;
    right: -7%
}

.persona-finance-section {
    background-color: var(--black);
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto
}

.finance-head-wrap {
    margin-bottom: 80px
}

.finance-head-wrap.procurement {
    max-width: 840px
}

.finance-heading {
    color: var(--black);
    text-align: center;
    line-height: 108%
}

.finance-grid {
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    align-content: center;
    align-items: start;
    display: grid
}

.finance-grid-item {
    color: var(--white);
    text-align: center;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 150%;
    display: flex
}

.finanve-item-icon-block {
    flex: none;
    width: 48px;
    height: 48px;
    margin-bottom: 24px
}

.finance-button-wrap {
    justify-content: center;
    align-items: center;
    margin-top: 80px;
    display: flex
}

.persona-text-link {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d1ffb97d792f833449_Vector%20\\(9\\).svg), url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);
    background-position: 85%, 85%;
    background-repeat: no-repeat, no-repeat;
    background-size: auto, auto;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 40px;
    font-weight: 700;
    transition: color .3s, background-position .3s
}

.persona-text-link:hover {
    color: var(--pabloo-green);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);
    background-position: 95%;
    background-repeat: no-repeat;
    background-size: auto
}

.persona-block-image {
    margin-bottom: 28px
}

.persona-hero-image {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.procurement-section-1-image._1 {
    border-radius: 10px;
    width: 13%;
    max-width: 72px;
    position: absolute;
    top: 18%;
    bottom: auto;
    left: auto;
    right: -4%;
    transform: rotate(15deg);
    box-shadow: 0 10px 60px rgba(0, 0, 0, .05)
}

.procurement-section-1-image._2 {
    background-color: var(--white);
    background-image: none;
    border-radius: 10px;
    width: 15%;
    max-width: 15%;
    margin-top: auto;
    margin-bottom: auto;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: -6%;
    right: auto;
    transform: rotate(-15deg);
    box-shadow: 0 10px 60px rgba(0, 0, 0, .1)
}

.procurement-section-1-image._2.compound {
    padding: 0 0%
}

.procurement-section-1-image._3 {
    border-radius: 10px;
    width: 15%;
    max-width: 88%;
    position: absolute;
    top: auto;
    bottom: 7%;
    left: auto;
    right: -7%;
    transform: rotate(15deg);
    box-shadow: 7px 7px 60px rgba(0, 0, 0, .1)
}

.procurement-section-2-image {
    border-radius: 12px;
    width: 60%;
    max-width: 384px;
    margin-top: 70px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: -8%;
    box-shadow: 0 20px 80px rgba(0, 0, 0, .08)
}

.shadow-div {
    background-color: var(--black);
    opacity: .04;
    filter: blur(50px);
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.dropdown-list {
    background-color: transparent
}

.dropdown-list.w--open {
    margin-top: -6px;
    padding-top: 21px;
    left: -152px
}

.dropdown-list.product {
    left: -200px
}

.dropdown-list.resources {
    left: -340px
}

.persona-dropdown-wrap {
    background-color: var(--white);
    border-radius: 10px;
    width: 400px;
    padding: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .16)
}

.persona-dropdown-wrap.product {
    width: 792px
}

.persona-dropdown-wrap.product-drop-down {
    width: 720px;
    position: static
}

.persona-dropdown-wrap.resources {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 800px;
    display: block
}

.persona-dropdown-link {
    border: 1px #000;
    border-top: 2px solid rgba(0, 0, 0, .08);
    border-bottom: 2px rgba(0, 0, 0, .08);
    border-radius: 0;
    align-items: flex-start;
    padding: 16px 10px;
    display: flex;
    position: static
}

.persona-dropdown-link:hover {
    background-color: rgba(213, 57, 135, .05)
}

.persona-dropdown-link.dropdown-link-no-border {
    border-top-style: none;
    padding-top: 20px;
    padding-bottom: 20px
}

.persona-dropdown-link.dropdown-link-no-border.discover-hero-pointer {
    align-items: center
}

.persona-dropdown-link.dropdown-link-no-border.discover-hero-pointer.custo {
    align-items: flex-start;
    margin-top: 0;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 10px
}

.persona-dropdown-link.center {
    align-items: center
}

.persona-dropdown-link.center.custo {
    align-items: flex-start;
    padding-top: 12px;
    padding-bottom: 12px
}

.persona-dropdown-link.center.custo.hide,
.persona-dropdown-link.center.custo.hide.w--current {
    display: flex
}

.persona-dropdown-icon {
    width: 32px;
    height: 32px;
    margin-right: 16px;
    display: block
}

.persona-dropdown-text-wrap {
    width: 90%
}

.persona-dropdown-title {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 700;
    line-height: 100%
}

.persona-dropdown-description {
    color: rgba(0, 0, 0, .8);
    font-size: 14px;
    line-height: 140%
}

.persona-dropdown-description.hide {
    display: block
}

.dropdown-toggle {
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
    font-family: Satoshi, sans-serif;
    font-weight: 500;
    display: flex
}

.dropdown-toggle.w--open:hover {
    color: var(--pabloo-green)
}

.dropdown-toggle.product {
    display: none;
    overflow: visible
}

.icon {
    margin-left: 8px;
    margin-right: 0;
    position: relative
}

.persona-triangle {
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    top: 7px;
    bottom: auto;
    left: 0%;
    right: 0%
}

.persona-triangle.product {
    top: 7px;
    bottom: auto;
    left: 250px;
    right: auto
}

.persona-triangle.product-dropdown-triangle {
    left: -32%
}

.dropdown {
    margin-left: 0;
    margin-right: 0;
    display: block
}

.dropdown.resources-hide {
    display: block
}

.dropdown-text {
    font-family: Satoshi, sans-serif;
    font-weight: 500
}

.together-blue-section {
    background-color: var(--slate-blue);
    color: var(--white)
}

.together-image-container {
    width: 45%;
    max-width: 520px
}

.slack-hero-image {
    width: 100%
}

.together-text-container {
    width: 45%;
    max-width: 520px
}

.together-blue-heading {
    margin-bottom: 20px
}

.together-blue-heading.custo {
    color: var(--white)
}

.together-blue-heading.working {
    max-width: 761px
}

.together-blue-paragraph-18px {
    letter-spacing: .2px;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px
}

.together-blue-paragraph-18px.custo {
    color: var(--white)
}

.discover-product-hero-section {
    padding-top: 80px;
    padding-bottom: 120px;
    position: relative
}

.discover-product-hero-bg {
    z-index: -1;
    background-color: var(--white-smoke);
    width: 100%;
    height: 100%;
    max-height: 1192px;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%
}

.discover-product-hero-bg.custo {
    background-color: var(--white)
}

.discover-product-hero-wrapper {
    text-align: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 920px;
    margin-bottom: 24px;
    display: flex
}

.discover-product-hero-heading {
    color: var(--black);
    margin-bottom: 20px;
    font-family: Satoshi, sans-serif;
    font-size: 64px;
    line-height: 72px
}

.discover-product-hero-heading.insights {
    max-width: 640px
}

.discover-product-hero-heading.track-usage {
    max-width: 711px
}

.discover-product-hero-heading.track-usage.width-lg {
    max-width: 90%;
    line-height: 78px
}

.discover-pink-span {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.discover-hero-paragraph {
    opacity: .8;
    letter-spacing: .2px;
    margin-bottom: 40px;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px
}

.discover-hero-paragraph.max-width-700px {
    max-width: 700px
}

.discover-hero-paragraph.track-usage {
    max-width: 720px
}

.discover-hero-paragraph.track-usage.width-lg {
    max-width: 80%
}

.discover-hero-pointer {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    margin-top: 24px;
    padding-left: 0;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px
}

.discover-hero-pink-line {
    background-color: var(--pabloo-green);
    width: 40px;
    height: 2px
}

.discover-hero-pink-text {
    color: var(--pabloo-green);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px
}

.discover-hero-pink-text-wrapper {
    align-items: center;
    margin-bottom: 24px;
    display: flex
}

.discover-hero-circle-image {
    width: 100%;
    max-width: 450px
}

.discover-hero-circle-image.left {
    position: absolute;
    top: auto;
    bottom: 20%;
    left: 0%;
    right: auto
}

.discover-hero-circle-image.right {
    position: absolute;
    top: auto;
    bottom: 20%;
    left: auto;
    right: 0%
}

.discover-hero-visual {
    object-fit: fill;
    width: 100%
}

.new-product-text-container {
    width: 45%;
    max-width: 500px
}

.new-product-image-container {
    width: 52%;
    max-width: 640px
}

.new-product-heading-44px {
    color: var(--pabloo-green);
    letter-spacing: -.5px;
    margin-bottom: 16px;
    font-family: Satoshi, sans-serif;
    font-size: 44px;
    line-height: 48px
}

.new-product-heading-44px.max-width-400px {
    max-width: 440px
}

.new-product-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 28px
}

.new-product-paragraph-18px {
    color: rgba(0, 0, 0, .8);
    letter-spacing: .2px;
    margin-top: 24px;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px
}

.new-product-paragraph-18px.max-width-480px {
    color: var(--black);
    max-width: 480px;
    font-size: 20px;
    font-weight: 400
}

.new-product-hero-image {
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.new-product-hero-image.custo {
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .08)
}

.new-product-hero-image.custo.no-shadow,
.new-product-hero-image.hide-shadow {
    box-shadow: none
}

.discover-purchase-section.gray-bg {
    background-color: var(--white-smoke)
}

.purchase-text-container {
    width: 45%;
    max-width: 500px
}

.purchase-image-container {
    width: 52%;
    max-width: 640px
}

.discover-tools-section {
    background-color: var(--white-smoke)
}

.discover-tools-section.white-bg {
    background-color: var(--white)
}

.tools-text-container {
    width: 45%;
    max-width: 540px
}

.tools-text-container.max-width-500px {
    width: 42%;
    max-width: 500px
}

.tools-image-container {
    width: 52%;
    max-width: 640px
}

.tools-image-container.resize-width {
    width: 56%
}

.tools-hero-image {
    box-shadow: -14px 14px 0 0 var(--pabloo-green);
    border-radius: 10px;
    width: 100%
}

.tools-hero-image.custo {
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .08)
}

.tools-hero-image.hide-shadow {
    box-shadow: none
}

.procuement-black-section {
    background-color: var(--black);
    color: var(--white)
}

.procurement-upper-container {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 80px;
    display: flex
}

.procurement-bottom-container {
    width: 100%
}

.procurement-paragraph-18px {
    letter-spacing: .2px;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px
}

.procurement-paragraph-18px.main {
    text-align: center;
    max-width: 730px
}

.procurement-heading-wrapper {
    width: 70%;
    max-width: 920px;
    margin-right: 1%
}

.procurement-grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-wrap: wrap;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: center;
    display: flex
}

.procurement-item {
    color: var(--white);
    background-color: rgba(255, 255, 255, .2);
    border-radius: 10px;
    width: 100%;
    max-width: 400px;
    padding: 32px
}

.procurement-heading-24px {
    letter-spacing: -.5px;
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px
}

.procurement-item-text-18px {
    letter-spacing: .2px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px
}

.procurement-image-container {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 24px;
    display: flex
}

.procurement-arrow-wrapper {
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    display: flex
}

.procurement-arrow-white {
    width: 24px;
    height: 24px
}

.procurement-arrow-pink {
    width: 24px;
    height: 24px;
    display: none
}

.button-container {
    justify-content: center;
    align-items: center;
    display: flex
}

.case-study-hero-scetion {
    background-color: var(--white-smoke);
    padding-top: 80px
}

.case-study-hero-text-container {
    flex-direction: column;
    align-items: flex-start;
    width: 48%;
    max-width: 540px;
    display: flex
}

.case-study-hero-image-container {
    width: 48%;
    max-width: 520px;
    position: relative
}

.case-study-hero-heading {
    font-size: 52px;
    line-height: 56px
}

.case-study-button-rapper {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 422px;
    margin-top: 20px;
    display: flex
}

.read-stories-button,
.success-story-button {
    align-items: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    display: flex
}

.arrow-bottom-icon,
.arrow-right-icon {
    width: 24px;
    height: 24px;
    margin-left: 4px
}

.case-study-hero-image {
    width: 100%;
    height: 500px;
    width: 500px;
    object-fit: cover;
    object-position: "center",
}

.case-study-span-wrapper {
    align-items: center;
    margin-bottom: 24px;
    display: flex
}

.case-study-hero-pink-line {
    background-color: var(--pabloo-green);
    width: 40px;
    height: 2px;
    margin-left: 20px
}

.case-study-hero-pink-text {
    color: var(--pabloo-green);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 700;
    line-height: 20px
}

.case-study-grid {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    height: 100%;
    display: grid
}

.case-study-container {
    width: 100%;
    max-width: 1100px
}

.case-study-item-wrapper {
    background-color: var(--white);
    border-radius: 10px;
    width: 100%;
    max-width: 520px;
    padding: 24px 24px 28px;
    transition: all .2s;
    box-shadow: 7px 7px 80px rgba(0, 0, 0, .05)
}

.case-study-item-wrapper:hover {
    transform: translateY(-5px);
    box-shadow: 7px 7px 80px rgba(0, 0, 0, .1)
}

.case-study-list-wrapper {
    width: 100%
}

.case-study-hero-item-image {
    border-radius: 10px;
    width: 100%;
    height: 100%
}

.case-study-item-text-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin-top: 24px;
    display: flex
}

.case-study-item-pink-tag {
    color: var(--pabloo-green);
    letter-spacing: .8px;
    text-transform: uppercase;
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px
}

.case-study-item-heading {
    letter-spacing: -.5px;
    margin-bottom: 8px;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px
}

.case-study-item-para-small {
    color: rgba(0, 0, 0, .6);
    letter-spacing: .2px;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px
}

.track-approval-text-container {
    width: 45%;
    max-width: 480px
}

.track-appoval-image-container {
    width: 52%;
    max-width: 640px;
    position: relative
}

.track-appoval-image-container._w-md {
    width: 40%
}

.track-approval-hero-image {
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.track-approval-item-absolute {
    border-radius: 8px;
    width: 60%;
    max-width: 330px;
    position: absolute;
    top: 100px;
    bottom: auto;
    left: auto;
    right: -10%;
    box-shadow: 14px 14px 80px rgba(0, 0, 0, .08)
}

.track-approval-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 28px
}

.multi-channel-approval-section {
    background-color: var(--white-smoke)
}

._404-heading {
    color: var(--black-2);
    margin-bottom: 20px;
    font-size: 150px;
    line-height: 90%
}

@media (max-width: 768px) {
    ._404-heading {
        color: var(--black-2);
        margin-bottom: 20px;
        font-size: 80px;
        line-height: 90%
    }

}

.multi-channel-image-container {
    width: 45%;
    max-width: 500px;
    position: relative
}

.multi-channel-text-container {
    color: var(--dark-violet);
    width: 48%;
    max-width: 540px
}

.multi-channel-item-wrapper {
    box-shadow: -11px 11px 0 0 var(--pabloo-green);
    border-radius: 8px;
    width: 90%;
    max-width: 360px;
    position: relative
}

.multi-channel-item-wrapper.middle {
    margin-top: 40px;
    margin-bottom: 40px;
    margin-left: auto
}

.multi-channel-hero-item-image {
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.multi-channel-background {
    width: 90%;
    max-width: 400px;
    height: auto
}

.multi-channel-background.top-right {
    position: absolute;
    top: -40px;
    bottom: auto;
    left: auto;
    right: -10%
}

.multi-channel-background.bottom-left {
    position: absolute;
    top: auto;
    bottom: -50px;
    left: -10%;
    right: auto
}

.workflow-approval-text-wrapper {
    width: 45%;
    max-width: 500px
}

.workflow-approval-image-wrapper {
    z-index: 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 52%;
    max-width: 680px;
    height: 100%;
    display: flex;
    position: relative;
    overflow: visible
}

.fast-track-approval-hero-section {
    background-color: var(--white-smoke);
    margin-bottom: 240px;
    position: relative
}

.fast-track-approval-h1-heading {
    margin-bottom: 20px
}

.fast-track-hero-wrapper {
    text-align: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 780px;
    margin-bottom: 80px;
    display: flex
}

.fast-track-hero-image-wrapper {
    z-index: 10;
    border-radius: 10px;
    width: 100%;
    max-width: 820px;
    margin-bottom: -110px;
    position: relative;
    box-shadow: 34px 34px 120px rgba(0, 0, 0, .04)
}

.fast-track-hero-image-wrapper.track-usage {
    z-index: 18;
    box-shadow: none;
    max-width: 100%
}

.fast-track-hero-image-wrapper.track-usage.limit-width {
    max-width: 80%
}

.fast-track-hero-image-wrapper.resize {
    box-shadow: none;
    max-width: 80%
}

.fast-track-hero-image {
    border-radius: 0;
    width: 100%;
    height: 100%
}

.fast-track-hero-image.hide--shadows {
    box-shadow: none;
    border-radius: 16px
}

.fast-track-hero-circle {
    width: 100%;
    max-width: 450px;
    height: auto
}

.fast-track-hero-circle.left {
    width: 90%;
    margin-bottom: 5%
}

.fast-track-hero-circle.right {
    width: 90%;
    margin-bottom: 5%;
    position: relative
}

.fast-track-hero-circle-wrapper {
    width: 100%;
    max-width: 450px;
    height: auto
}

.fast-track-hero-circle-wrapper.left {
    justify-content: flex-end;
    display: flex;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto
}

.fast-track-hero-circle-wrapper.right {
    justify-content: flex-start;
    display: flex;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.fast-track-hero-user-element {
    z-index: 11;
    width: 100%;
    max-width: 72px;
    height: auto;
    position: absolute
}

.fast-track-hero-user-element._1 {
    top: 15%;
    bottom: auto;
    left: 35%;
    right: auto
}

.fast-track-hero-user-element._1.no-bg {
    background-color: transparent
}

.fast-track-hero-user-element._2 {
    top: auto;
    bottom: 25%;
    left: 15%;
    right: auto
}

.fast-track-hero-user-element._2.no-bg {
    background-color: transparent;
    background-image: none
}

.fast-track-hero-user-element._3 {
    top: -15%;
    bottom: auto;
    left: auto;
    right: 15%
}

.fast-track-hero-user-element._4 {
    z-index: 1;
    top: 35%;
    bottom: auto;
    left: 45%;
    right: auto
}

.fast-track-hero-user-element._4.no-bg {
    background-color: transparent
}

.fast-track-hero-user-element._5 {
    z-index: 1;
    top: auto;
    bottom: 20%;
    left: auto;
    right: 5%
}

.fast-track-hero-user-element._5.no-bg {
    background-color: transparent
}

.fast-track-hero-user-element.track-usage-1 {
    z-index: 1;
    top: 10%;
    bottom: auto;
    left: 11%;
    right: auto
}

.fast-track-hero-user-element.track-usage-2 {
    z-index: 1;
    top: auto;
    bottom: 25%;
    left: 25%;
    right: auto
}

.track-approval-absolute-image {
    width: 100%;
    height: 100%
}

.workflow-approval-gif {
    width: 100%;
    max-width: 476px;
    height: auto
}

.case-study-hero-logo-item {
    width: 45%;
    max-width: 240px;
    height: auto
}

.case-study-hero-logo-item._1 {
    position: absolute;
    top: 10%;
    bottom: auto;
    left: -15%;
    right: auto
}

.case-study-hero-logo-item._2 {
    position: absolute;
    top: auto;
    bottom: 30%;
    left: auto;
    right: -8%
}

.case-study-hero-logo-item._3 {
    position: absolute;
    top: auto;
    bottom: 7%;
    left: -7%;
    right: auto
}

.dropdown-grid {
    grid-column-gap: 56px;
    grid-row-gap: 0px
}

.social-link {
    opacity: .8;
    width: 100%;
    max-width: 28px;
    transition: opacity .2s
}

.social-link:hover {
    opacity: 1
}

.footer-top-wrapper {
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-top: 80px;
    padding-bottom: 80px;
    display: flex
}

.footer-column {
    grid-row-gap: 16px;
    flex-direction: column;
    flex: none;
    align-items: flex-start;
    display: flex
}

.footer-grid {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex-wrap: nowrap;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: space-between;
    width: 100%;
    max-width: 500px;
    padding-top: 4px;
    display: flex
}

.contain {
    object-fit: contain
}

.contain.invert {
    filter: invert()
}

.footer-heading {
    color: #fff;
    margin-bottom: 4px;
    font-size: 20px;
    font-weight: 700;
    line-height: 150%
}

.footer-left-contain {
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    display: flex
}

.social-links-contain {
    grid-column-gap: 24px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    max-width: 100%;
    display: grid
}

.footer-links {
    color: var(--white);
    font-size: 18px;
    font-weight: 500;
    line-height: 100%;
    text-decoration: none;
    transition: color .2s;
    display: block
}

.footer-links:hover {
    color: var(--pabloo-green)
}

.footer-links.hide {
    display: none
}

.mobile-only {
    display: block
}

.split-section-form-wrapper {
    margin-top: 0;
    padding: 60px
}

.form-field-wrapper {
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    max-width: none;
    display: flex
}

.form-holder {
    border-style: solid;
    border-width: 1px 1px 1px 12px;
    border-color: #f0ebe1 #f0ebe1 #f0ebe1 var(--slate-blue);
    background-color: #fff;
    border-radius: 8px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    padding: 20px 25px;
    display: flex;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
}

.review-slide-2 {
    background-color: #fff;
    border-radius: 10px;
    padding: 40px 58px 40px 60px
}

.doc-one-place-text-container {
    width: 46%;
    max-width: 500px
}

.doc-one-place-image-container {
    width: 52%;
    max-width: 640px
}

.best-deals-section {
    background-color: var(--white-smoke)
}

.best-deals-text-container {
    width: 45%;
    max-width: 500px
}

.assisted-tools-text-container {
    width: 48%;
    max-width: 580px
}

.assisted-tools-image-container {
    width: 46%;
    max-width: 470px;
    position: relative
}

.assisted-purchasing-hero-wrapper {
    text-align: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 840px;
    margin-top: 53px;
    margin-bottom: 80px;
    display: flex
}

.assisted-purchasing-hero-wrapper.insights {
    margin-top: 107px
}

.assisted-purchasing-hero-wrapper.insights.width-lg {
    max-width: 100%
}

.assisted-hero-image-wrapper {
    border-radius: 10px;
    width: 100%;
    max-width: 100%
}

.assisted-hero-section {
    padding-bottom: 140px;
    position: relative
}

.assisted-hero-item-wrapper {
    justify-content: flex-end;
    width: 90%;
    max-width: 490px;
    display: flex;
    position: relative
}

.assisted-hero-item-wrapper.left {
    position: absolute;
    top: auto;
    bottom: 300px;
    left: 0%;
    right: auto
}

.assisted-hero-item-wrapper.right {
    justify-content: flex-start;
    position: absolute;
    top: auto;
    bottom: 300px;
    left: auto;
    right: 0%
}

.assisted-hero-item-bg {
    width: 85%;
    max-width: 450px
}

.assisted-hero-office-icon {
    z-index: 11;
    border-radius: 50%;
    width: 90%;
    max-width: 72px;
    position: absolute;
    top: -18%;
    bottom: auto;
    left: 10%;
    right: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .04)
}

.assisted-hero-bird-icon {
    z-index: 11;
    border-radius: 50%;
    width: 90%;
    max-width: 80px;
    position: absolute;
    top: auto;
    bottom: 10%;
    left: 5%;
    right: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .04)
}

.assisted-hero-p-icon {
    z-index: 11;
    width: 90%;
    max-width: 96px;
    position: absolute;
    top: 30%;
    bottom: auto;
    left: 13%;
    right: auto
}

.assisted-hero-droupbox-icon {
    z-index: 11;
    width: 90%;
    max-width: 96px;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: 10px
}

.assisted-hero-z-icon {
    z-index: 11;
    width: 90%;
    max-width: 80px;
    position: absolute;
    top: auto;
    bottom: 10%;
    left: auto;
    right: 15%
}

.assisted-hero-gmail-icon {
    z-index: 11;
    border-radius: 50%;
    width: 90%;
    max-width: 72px;
    position: absolute;
    top: 25%;
    bottom: auto;
    left: 60%;
    right: auto;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .04)
}

.actionable-insight-text-wrap {
    width: 42%;
    max-width: 480px
}

.actionable-insight-image-wrap {
    width: 53%;
    max-width: 680px
}

.actionable-insight-image-wrap.resize-width {
    width: 56%
}

.insight-hero-section {
    background-color: var(--white-smoke);
    margin-bottom: 160px;
    position: relative
}

.insight-hero-section.track-usage {
    flex-direction: column;
    align-items: center;
    margin-bottom: 240px;
    display: flex
}

.investor-logo {
    width: 15%
}

.investor-logo.investor-logo-rt-demo-custo-styles {
    justify-content: flex-start;
    align-items: center;
    width: 32%;
    display: flex
}

.investor-logo.investor-logo-rt-demo-custo-styles.rt-logo {
    width: 15%
}

.funding-section {
    padding-top: 120px;
    padding-bottom: 120px
}

.bg-pink {
    background-color: var(--pabloo-green)
}

.press-section {
    padding-top: 100px;
    padding-bottom: 100px
}

.press-card {
    background-color: var(--slate-blue);
    border-radius: 12px;
    overflow: hidden
}

.press-card-image-wrapper {
    width: auto;
    height: 400px;
    overflow: hidden
}

.press-image {
    width: 100%;
    height: auto
}

.press-content-wrapper {
    grid-row-gap: 20px;
    flex-direction: column;
    margin-top: 12px;
    padding: 20px;
    display: flex
}

.press-cta {
    /* text-decoration: none */
}

.press-logo-wrapper {
    width: 150px;
    height: auto
}

.text-color-white {
    color: var(--white);
    margin-right: 8px;
    font-size: 16px;
    font-weight: 500
}

.news-logos {
    width: 40%
}

.insights-hero-image {
    justify-content: center;
    align-items: flex-start;
    width: 85%;
    max-width: 1120px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 56px;
    display: flex;
    position: relative
}

.insights-hero-image-1 {
    border-radius: 7px;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 40px 140px rgba(0, 0, 0, .04)
}

.insights-hero-image-3 {
    width: 35%;
    max-width: 450px;
    margin-bottom: 120px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto
}

.insights-hero-image-4 {
    width: 32%;
    max-width: 450px;
    margin-bottom: 84px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.insights-visualize-image {
    box-shadow: -14px 14px 0 0 var(--pabloo-green);
    border-radius: 7px
}

.insights-visualize-image.custo,
.insights-visualize-image.hide-shadow {
    box-shadow: none
}

.hero-heading-wrapper {
    text-align: center;
    justify-content: center;
    max-width: none;
    margin-bottom: 60px;
    display: flex
}

.contract-renewal-image-wrap {
    width: 48%;
    max-width: 560px
}

.contract-document-image-wrap {
    width: 52%;
    max-width: 640px
}

.contract-hero-image-wrap {
    z-index: 24;
    width: 100%;
    max-width: 100%;
    margin-bottom: -120px;
    position: relative
}

.contract-hero-image-wrap.full-width {
    z-index: 22;
    max-width: 100%;
    position: relative
}

.contract-hero-section {
    background-color: var(--white-smoke);
    margin-bottom: 240px;
    position: relative
}

.contract-hero-item-wrap {
    width: 35%;
    max-width: 450px;
    position: relative
}

.contract-hero-item-wrap.left {
    position: absolute;
    top: auto;
    bottom: 3%;
    left: 10px;
    right: auto
}

.contract-hero-item-wrap.right {
    position: absolute;
    top: auto;
    bottom: 3%;
    left: auto;
    right: 10px
}

.contract-hero-bg-image {
    width: 100%;
    height: 100%
}

.contract-hero-logo-item {
    z-index: 11;
    position: absolute
}

.contract-hero-logo-item._3 {
    border-radius: 505px;
    width: 20%;
    max-width: 72px;
    top: auto;
    bottom: 50%;
    left: 30%;
    right: auto;
    box-shadow: 7px 7px 40px rgba(0, 0, 0, .04)
}

.contract-hero-logo-item._2 {
    background-color: var(--white-smoke);
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    border-radius: 120px;
    width: 20%;
    max-width: 80px;
    top: auto;
    bottom: 58px;
    left: 50px;
    right: auto
}

.contract-hero-logo-item._1 {
    width: 20%;
    max-width: 96px;
    top: 20px;
    bottom: auto;
    left: 0%;
    right: auto
}

.contract-hero-logo-item._4 {
    border-radius: 50%;
    width: 20%;
    max-width: 72px;
    top: -20px;
    bottom: auto;
    left: auto;
    right: 50px;
    box-shadow: 7px 7px 40px rgba(0, 0, 0, .04)
}

.contract-hero-logo-item._5 {
    background-color: var(--white-smoke);
    width: 20%;
    max-width: 80px;
    top: 30%;
    bottom: auto;
    left: auto;
    right: 110px
}

.contract-hero-logo-item._6 {
    border-radius: 50%;
    width: 20%;
    max-width: 80px;
    top: auto;
    bottom: 80px;
    left: auto;
    right: 5%;
    box-shadow: 7px 7px 40px rgba(0, 0, 0, .04)
}

.procurement-home-item-wrap {
    border-radius: 10px;
    width: 100%;
    max-width: 400px;
    position: relative
}

.thank-you-section {
    background-color: var(--white);
    align-items: center;
    height: 80vh;
    display: flex
}

.hero-subheading {
    max-width: 600px;
    margin-bottom: 20px
}

.hero-subheading.competitor-landing-usps-subheading {
    color: var(--white)
}

.hero-subheading.pargrap {
    margin-bottom: 40px
}

.hero-head-container {
    text-align: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.hero-head-container.competitor-landing-usp-highlight-section {
    background-color: var(--black)
}

.hero-heading {
    text-align: center
}

.hero-heading.competitor-landing-usp-highlight-heading {
    color: var(--white)
}

.hero-heading-wrapper {
    flex-wrap: wrap;
    max-width: 800px;
    margin-bottom: 40px
}

.hero-heading-wrapper.letar {
    margin-bottom: 20px
}

.hero-heading-wrapper.justify-left {
    justify-content: flex-start
}

.home-hero-image-wrapper {
    width: 46%;
    max-width: 480px;
    display: none
}

.home-hero-image-blue-shadow {
    box-shadow: 14px 14px 0 0 var(--slate-blue);
    object-fit: cover;
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.home-hero-text-wrapper {
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 800px;
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex
}

.hello-bar {
    grid-column-gap: 10px;
    background-color: var(--pabloo-green);
    border: 1px rgba(0, 0, 0, .15);
    justify-content: center;
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex;
    position: sticky;
    top: auto;
    bottom: auto;
    left: 0%;
    right: 0%;
    box-shadow: inset 0 1px 12px rgba(0, 0, 0, .13)
}

.hello-bar.hide {
    justify-content: center;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    position: relative
}

.column {
    flex-wrap: wrap;
    justify-content: center;
    height: auto;
    padding-left: 4%;
    padding-right: 2%;
    display: flex
}

.paragraph-2 {
    margin-top: 12px;
    margin-bottom: 24px;
    font-family: "P22mackinacpro 15", sans-serif;
    font-size: 16px;
    line-height: 24px;
    display: none
}

.div-block {
    margin-top: 4%;
    margin-bottom: 8%;
    padding-left: 0
}

.div-block.h2 {
    margin-bottom: 4%
}

.text-span {
    color: #d53987
}

.heading-2 {
    font-family: Satoshi, sans-serif;
    font-size: 36px;
    font-weight: 700;
    line-height: 42px;
    display: none
}

.heading {
    color: #000;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 56px;
    line-height: 1.2em
}

.heading.center {
    text-align: left
}

.heading.social {
    text-align: center
}

.text-span-2 {
    color: #d53987;
    font-family: "P22mackinacpro 17", sans-serif
}

.div-block-2 {
    border-style: none none none solid;
    border-width: 1px 1px 1px 12px;
    border-color: black black black var(--slate-blue);
    background-color: #fff;
    border-radius: 8px;
    width: 88%;
    max-width: 100%;
    padding: 16px 32px 40px;
    box-shadow: 1px 1px 15px rgba(0, 0, 0, .09)
}

.container-3 {
    flex-flow: column;
    justify-content: flex-end;
    align-items: center;
    max-width: 76%;
    height: 100%;
    max-height: 100%;
    margin-top: 8%;
    display: flex;
    position: static
}

.container-3.margin-top-0 {
    max-width: 80%;
    margin-top: 0%
}

.body {
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto
}

.div-block-8 {
    padding-top: 0;
    padding-bottom: 16px;
    display: none
}

.div-block-9 {
    border-style: none;
    border-width: 2px 2px 2px 12px;
    border-color: var(--pabloo-green);
    outline-offset: 0px;
    background-color: transparent;
    border-radius: 6px;
    outline: 3px #000;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: flex-start;
    margin-right: 16px;
    padding-bottom: 16px;
    padding-left: 4px;
    padding-right: 16px;
    display: block
}

.div-block-10 {
    margin-top: 4%;
    padding-top: 4px;
    padding-left: 0
}

.grid-2 {
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    align-items: center;
    justify-items: start;
    margin-top: 6px
}

.text-block-6 {
    color: #000;
    font-family: Satoshi, sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px
}

.heading-3 {
    display: none
}

.columns {
    margin-bottom: 64px
}

.text-block-7 {
    color: #fff;
    font-family: Satoshi, sans-serif;
    font-size: 14px;
    font-weight: 500
}

.div-block-11 {
    margin-top: 6px;
    font-family: "P22mackinacpro 15", sans-serif
}

.text-block-8 {
    color: var(--pabloo-green);
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px
}

.div-block-12 {
    background-color: var(--light-pink);
    border-radius: 4px;
    justify-content: center;
    width: 100%;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;
    padding: 4px 8px 8px;
    display: flex
}

.div-block-13 {
    float: left;
    clear: none;
    border: 2px none var(--pabloo-green);
    object-fit: fill;
    background-color: transparent;
    border-radius: 6px;
    margin-top: 16px;
    margin-left: 0;
    padding: 0 0 16px;
    display: block;
    position: static
}

.div-block-13.brand-bg {
    display: none
}

.heading-4 {
    color: var(--slate-blue);
    line-height: 20px
}

.heading-4.featured-on-heading {
    color: var(--pabloo-green);
    font-size: 16px;
    line-height: 24px
}

.div-block-14 {
    justify-content: flex-start;
    align-items: center;
    margin-top: 16px;
    display: flex
}

.featured-on-logo {
    margin-left: 0;
    margin-right: 32px
}

.div-block-15 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    border-top: 1px rgba(0, 0, 0, .1);
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    display: flex
}

.div-block-16 {
    align-items: flex-start;
    display: flex
}

.text-block-9 {
    color: var(--pabloo-green);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px
}

.div-block-17 {
    background-color: rgba(213, 57, 135, .22);
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    margin-top: 2px;
    margin-left: 8px;
    padding: 3px 8px;
    display: flex
}

.body-2 {
    background-color: #fff
}

.div-block-18 {
    padding-top: 16%;
    display: none
}

.heading-5 {
    color: var(--black);
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 64px;
    line-height: 72px
}

.heading-5.custo {
    font-family: Satoshi, sans-serif;
    font-size: 3rem;
    line-height: 1.2em
}

.heading-5.custo.accent {
    color: var(--pabloo-green);
    font-family: Satoshi, sans-serif
}

.div-block-19 {
    margin-top: 0
}

.div-block-20 {
    margin-top: 0%;
    padding: 16% 8px 32%;
    position: relative
}

.div-block-21 {
    background-color: #fff;
    border-radius: 8px;
    padding: 48px;
    position: static;
    box-shadow: 1px 1px 24px rgba(0, 0, 0, .1)
}

.div-block-21.registration-form-block {
    backdrop-filter: blur(8px);
    outline-offset: 0px;
    background-color: #f0f0f0;
    border: 12px solid rgba(213, 57, 135, .16);
    outline: 3px #000;
    margin-top: 30px;
    margin-bottom: 0;
    padding: 16px 20px;
    box-shadow: 3px 3px 24px rgba(0, 0, 0, .1)
}

.heading-6 {
    color: var(--black);
    text-align: center;
    margin-bottom: 24px;
    font-family: Satoshi, sans-serif;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2em
}

.container-4 {
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    max-width: 85%
}

.container-4.custo {
    max-width: 1040px
}

.div-block-22 {
    flex-wrap: wrap;
    margin-top: 24px;
    display: none
}

.div-block-23 {
    background-color: var(--pabloo-green);
    border-radius: 20px;
    padding: 8px 20px
}

.div-block-23.alt-badge {
    background-color: #fff;
    margin-left: 12px
}

.text-block-10 {
    color: var(--pabloo-green);
    font-weight: 500
}

.text-block-10.primary-badge-text {
    color: #fff
}

.text-block-11 {
    color: var(--black);
    margin-left: 4px;
    font-size: 16px;
    font-weight: 500
}

.text-block-11.roundtable-text {
    color: var(--black);
    font-size: 20px
}

.text-block-11.roundtable-text.sm {
    color: var(--pabloo-green);
    font-size: 16px;
    font-weight: 700
}

.text-block-11.roundtable-text.sm.black {
    color: var(--black)
}

.text-block-11.roundtable-text.pill-text {
    color: var(--white);
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700
}

.text-block-11.xx {
    color: var(--black);
    font-size: 16px
}

.text-block-11.secondary-time {
    text-transform: uppercase
}

.div-block-24 {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    margin-top: 22px;
    margin-right: 8px;
    padding-top: 12px;
    padding-bottom: 12px;
    display: grid
}

.div-block-24.panel-shadow {
    grid-column-gap: 0px;
    grid-row-gap: 4px;
    border: 2px none var(--light-pink);
    background-color: var(--white);
    box-shadow: none;
    border-radius: 120px;
    margin-right: 24px;
    padding: 8px 0
}

.div-block-24.panel-shadow.hide {
    display: none
}

.div-block-24.panel-shadow.xx {
    background-color: rgba(255, 255, 255, .12)
}

.div-block-24.panel-shadow.xx.events {
    border-style: none;
    border-radius: 4px;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, .1)
}

.div-block-24.panel-shadow.xx.events.pad {
    background-color: var(--white);
    margin-top: 0;
    padding-left: 12px;
    padding-right: 12px
}

.div-block-24.m-t-32 {
    margin-top: 32px
}

.div-block-25 {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    margin-top: 0;
    padding-top: 12px;
    padding-bottom: 12px;
    display: grid
}

.div-block-25.panel-shadow {
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    border-radius: 4px;
    padding-left: 12px;
    padding-right: 12px;
    box-shadow: 1px 1px 8px rgba(0, 0, 0, .1)
}

.div-block-25.panel-shadow.custo.xx {
    background-color: var(--white);
    padding: 10px
}

.div-block-25.panel-shadow.custo.xx.m-t-16 {
    margin-top: 0
}

.div-block-26 {
    margin-top: 2px;
    margin-left: 0
}

.div-block-27 {
    z-index: 0;
    display: block;
    position: absolute;
    top: auto;
    bottom: 72px;
    left: auto;
    right: 8px
}

.div-block-27.hide {
    display: none
}

.div-block-28 {
    padding: 0 51px
}

.div-block-29 {
    z-index: auto;
    background-color: var(--white);
    background-image: none;
    min-height: auto;
    padding-top: 40px;
    padding-bottom: 60px;
    position: relative;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.bestsuited-webinarblock {
    background-color: var(--slate-blue);
    min-height: auto;
    padding-top: 40px;
    padding-bottom: 40px;
    position: relative
}

.heading-7 {
    color: var(--white);
    text-align: center;
    font-family: Satoshi, sans-serif;
    font-size: 36px;
    line-height: 1.2em
}

.div-block-31 {
    justify-content: center;
    padding-top: 16px;
    display: flex
}

.div-block-31.hide {
    display: none
}

.div-block-33 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    justify-items: stretch;
    margin-top: 40px;
    margin-left: 0%;
    padding-left: 12%;
    padding-right: 12%;
    display: grid
}

.grid-3 {
    grid-column-gap: 8px;
    grid-row-gap: 16px;
    border-bottom: 4px none var(--slate-blue);
    border-left: 12px none var(--slate-blue);
    background-color: var(--black);
    border-radius: 16px;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    padding: 32px
}

.grid-3.m-l-24 {
    grid-row-gap: 16px;
    background-color: var(--black);
    border: 1px #000;
    border-radius: 20px;
    width: 100%;
    margin-left: 0
}

.text-block-14 {
    color: var(--white);
    font-size: 56px;
    font-weight: 700;
    line-height: 56px
}

.text-block-15 {
    font-size: 20px;
    line-height: 20px;
    display: block
}

.text-block-16 {
    color: var(--white);
    font-size: 24px;
    line-height: 20px
}

.div-block-34 {
    justify-content: center;
    margin-top: 40px;
    display: flex
}

.div-block-34.m-t-24 {
    margin-top: 124px
}

.button {
    background-color: var(--pabloo-green);
    border-radius: 12px;
    justify-content: center;
    align-items: center;
    width: 280px;
    height: 64px;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
}

.button.round {
    border-radius: 8px;
    width: 240px;
    height: 56px;
    padding: 12px 16px;
    font-size: 18px
}

.button.bigger {
    border-radius: 8px;
    width: auto
}

.div-block-35 {
    background-color: var(--white);
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    min-height: auto;
    margin-top: 0;
    padding-bottom: 0;
    position: relative
}

.div-block-36 {
    background-color: var(--slate-blue);
    color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62b1a53121d721625b5654cd_pattern-bg.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    padding-top: 64px;
    padding-bottom: 64px
}

.div-block-36.why-attend-block {
    background-color: var(--white);
    background-image: none;
    padding-top: 24px;
    padding-left: 0;
    display: none
}

.div-block-36.pink {
    background-color: var(--white-smoke);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62b1a53121d721625b5654cd_pattern-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    padding-top: 32px;
    padding-bottom: 32px
}

.heading-8 {
    color: var(--black);
    font-family: Satoshi, sans-serif;
    font-size: 1.8rem;
    line-height: 1.2em
}

.text-block-17 {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    display: none
}

.grid-4 {
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    margin-bottom: 24px
}

.text-block-18 {
    color: #fff;
    font-size: 25px;
    line-height: 32px
}

.text-block-18.sm {
    font-size: 24px
}

.div-block-37 {
    margin-top: 16px
}

.div-block-38 {
    border-right: 24px none var(--pabloo-green);
    background-color: transparent;
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    border-bottom-right-radius: 0;
    padding: 32px 50px
}

.cta-button-roundtable {
    background-color: var(--white);
    color: var(--slate-blue);
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    width: 280px;
    height: 64px;
    padding: 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    display: flex
}

.cta-button-roundtable.cta-button-roundtable-pink {
    background-color: var(--pabloo-green);
    color: #fff;
    border-radius: 8px
}

.cta-button-roundtable.pink {
    color: var(--pabloo-green)
}

.div-block-39 {
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 32px;
    padding-right: 0;
    display: flex
}

.div-block-39.hide {
    display: none
}

.div-block-40 {
    height: auto;
    position: relative;
    overflow: hidden
}

.container-5 {
    max-width: 85%;
    padding-top: 120px;
    padding-bottom: 160px
}

.div-block-41 {
    flex-wrap: wrap;
    align-self: center;
    align-items: center;
    height: 100%;
    margin-top: 0;
    padding-left: 0;
    display: flex
}

.div-block-42 {
    width: 100%;
    margin-top: 16px
}

.div-block-44 {
    width: 100%;
    margin-top: 8px;
    display: none
}

.div-block-45 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    width: 100%;
    margin-top: 8px;
    display: grid
}

.text-block-20 {
    font-size: 16px;
    display: none;
    overflow: visible
}

.text-block-21 {
    font-size: 18px;
    font-weight: 500
}

.image-7 {
    object-fit: contain;
    border-radius: 0;
    width: auto;
    max-width: 100%;
    max-height: none;
    display: block;
    position: static;
    top: -32px;
    bottom: auto;
    left: -64px;
    right: auto
}

.div-block-46 {
    position: static
}

.column-2 {
    align-items: center;
    display: flex
}

.text-block-22 {
    color: var(--black);
    font-size: 16px;
    font-weight: 500
}

.text-block-22.blk {
    color: var(--black)
}

.column-5 {
    z-index: 1
}

.column-6 {
    padding-top: 2%;
    padding-left: 0;
    padding-right: 0
}

.map {
    border-radius: 16px;
    display: none
}

.div-block-51 {
    align-items: center;
    padding-top: 4px;
    display: flex
}

.div-block-52 {
    position: absolute;
    top: -16%;
    bottom: auto;
    left: auto;
    right: -9%
}

.div-block-53 {
    z-index: -1;
    display: none;
    position: absolute;
    top: auto;
    bottom: 64px;
    left: -25%;
    right: -25%
}

.div-block-54 {
    align-items: center;
    display: flex
}

.image-11,
.image-12 {
    display: none
}

.div-block-57 {
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
    padding-top: 16px;
    display: block
}

.text-block-24 {
    font-weight: 400
}

.hero-points-rt {
    background-color: transparent;
    border-radius: 8px;
    margin-left: auto;
    margin-right: 8px;
    padding: 4px 20px 16px 4px
}

.rt-hero-text {
    color: var(--black);
    font-family: Satoshi, sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 32px
}

.ebook-hero-points-short {
    flex-wrap: wrap;
    align-items: stretch;
    margin-top: 0;
    display: flex
}

.ebook-hero-points-short.block {
    display: block
}

.ebook-hero-points-short.m-t-16 {
    margin-top: 16px
}

.text-span-9 {
    color: var(--pabloo-green);
    font-size: 24px;
    font-weight: 900
}

.div-block-59 {
    z-index: 0;
    background-color: var(--pabloo-green);
    color: var(--pabloo-green);
    border-radius: 100%;
    width: 240px;
    height: 240px;
    display: none;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 50%;
    right: auto
}

.columns-3 {
    z-index: 1;
    position: relative
}

.container-6 {
    max-width: 1040px
}

.div-block-60 {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    background-color: transparent;
    border-radius: 2px;
    grid-template-rows: auto auto;
    grid-template-columns: auto auto;
    grid-auto-columns: 1fr;
    align-items: stretch;
    margin-top: 8px;
    padding: 24px;
    display: none
}

.text-span-11 {
    color: var(--black);
    font-family: Satoshi, sans-serif
}

.heading-9 {
    color: var(--black);
    text-align: left;
    font-size: 24px;
    font-weight: 500;
    line-height: 28px
}

.heading-10 {
    color: var(--black);
    margin-bottom: 24px
}

.heading-10.xx {
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 22px
}

.heading-10.text-white {
    color: var(--white);
    margin-bottom: 40px;
    font-size: 32px
}

.paragraph-3 {
    color: var(--black);
    white-space: pre-line;
    margin-top: 16px;
    margin-bottom: 16px
}

.div-block-61 {
    background-color: var(--pabloo-green);
    padding-top: 80px;
    padding-bottom: 80px
}

.div-block-61.pink {
    display: none
}

.div-block-61.white {
    background-color: var(--white);
    padding-bottom: 40px
}

.div-block-61.white.m-t-40 {
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 20px
}

.div-block-61.white.p-t-40 {
    margin-bottom: 43px;
    padding-top: 40px;
    padding-left: 50px;
    padding-right: 50px
}

.div-block-61.white.p-t-40.m-b-0 {
    padding-bottom: 0
}

.columns-4 {
    align-items: stretch;
    display: flex
}

.button-2 {
    background-color: var(--pabloo-green);
    color: var(--white);
    border-radius: 2px;
    margin-left: 0;
    padding: 22px 32px;
    font-size: 20px;
    font-weight: 700
}

.button-2.rt-footer-cta {
    border-radius: 16px;
    margin-left: 32px
}

.button-2.xx {
    background-color: #05254a
}

.button-2.y {
    background-color: var(--slate-blue)
}

.heading-11 {
    color: var(--black);
    font-family: Satoshi, sans-serif;
    font-size: 1.8rem;
    line-height: 1.2em
}

.column-8 {
    justify-content: center;
    align-items: flex-start;
    display: flex
}

.column-9 {
    justify-content: center;
    align-items: center;
    display: flex
}

.div-block-62 {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.text-span-12 {
    color: var(--pabloo-green)
}

.container-7 {
    max-width: 1040px
}

.div-block-63 {
    flex-flow: wrap;
    align-items: flex-start;
    margin-top: 0;
    display: flex
}

.div-block-63.hide {
    display: none
}

.div-block-64 {
    flex-wrap: wrap;
    align-items: center;
    display: flex
}

.div-block-65 {
    width: 42%;
    padding-left: 4%;
    display: none
}

.home-hero-logos-wrap {
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 24px;
    display: flex
}

.home-hero-logos-wrap.gs {
    margin-bottom: 24px
}

.home-hero-logo-container {
    background-color: #fff;
    border-radius: 4px;
    justify-content: flex-start;
    align-items: center;
    margin-right: 24px;
    padding: 12px 16px;
    display: flex;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .09)
}

.home-hero-logo-container.darger-bg {
    background-color: var(--black-2)
}

.home-hero-logo-container.jungle-bg {
    background-color: #010171
}

.div-block-66 {
    align-items: center;
    margin-right: 24px;
    display: flex
}

.div-block-66.x-block {
    display: none
}

.div-block-67 {
    align-items: center;
    margin-right: 24px;
    display: flex
}

.text-span-13 {
    color: var(--pabloo-green)
}

.link-block {
    background-color: var(--white);
    border-radius: 4px;
    align-items: center;
    padding: 8px 16px;
    display: none
}

.text-block-26 {
    margin-left: 8px
}

.button-3 {
    background-color: var(--pabloo-green);
    border-radius: 4px;
    margin-left: 16px;
    padding: 14px 16px;
    font-weight: 500;
    display: none
}

.heading-13 {
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 48px;
    line-height: 64px
}

.container-8 {
    max-width: 85%
}

.div-block-68,
.div-block-69 {
    margin-bottom: 16px;
    display: none
}

.image-16,
.image-17 {
    height: 32px
}

.text-span-15 {
    color: var(--pabloo-green)
}

.text-span-16 {
    color: var(--slate-blue);
    font-size: 40px
}

.section {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-items: start;
    padding-left: 0;
    padding-right: 0;
    display: grid
}

.section.grid-2 {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-columns: 1fr .5fr
}

.section-2 {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-70 {
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.heading-14 {
    margin-top: 8px;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px
}

.heading-15 {
    color: rgba(0, 0, 0, .61);
    letter-spacing: normal;
    text-transform: uppercase;
    margin-bottom: 8px;
    font-family: Satoshi, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px
}

.text-span-17 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 17", sans-serif
}

.heading-16 {
    color: rgba(0, 0, 0, .61);
    text-transform: uppercase;
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px
}

.div-block-72 {
    margin-top: 24px
}

.slack-step-text {
    letter-spacing: normal;
    font-size: 20px;
    line-height: 26px
}

.text-span-18 {
    color: var(--pabloo-green)
}

.slack-step-image-container {
    margin-bottom: 16px
}

.text-span-19,
.text-span-20 {
    color: var(--pabloo-green)
}

.goldman-sachs {
    height: 48px
}

.goldman-sachs.accel {
    height: 32px
}

.paragraph-12 {
    width: 72%;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    font-weight: 500;
    line-height: 140%
}

.text-span-30 {
    color: var(--slate-blue);
    font-family: "P22mackinacpro 11", sans-serif
}

.list-5 {
    margin-top: 16px;
    padding-left: 16px
}

.text-span-31 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.list-6 {
    margin-top: 16px;
    padding-left: 16px
}

.text-span-32 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.white-text {
    color: var(--white);
    margin-right: 4px;
    font-weight: 500
}

.div-block-96 {
    flex-wrap: wrap;
    display: flex
}

.image-21 {
    max-width: none;
    height: 48px
}

.div-block-97 {
    background-color: #f9a8d4;
    border-radius: 100%;
    width: 320px;
    height: 320px;
    position: absolute;
    top: 8%;
    bottom: auto;
    left: 12%;
    right: auto
}

.div-block-97.hide {
    display: block
}

.div-block-98 {
    backdrop-filter: blur(20px)blur(20px);
    -webkit-text-fill-color: inherit;
    mix-blend-mode: normal;
    background-color: rgba(255, 255, 255, .72);
    background-clip: border-box;
    padding-top: 8%
}

.div-block-98.pb-md {
    padding-bottom: 4%
}

.div-block-98.pb-md.pt-sm {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62f295f65cac0a38a49e99e4_ezgif.com-gif-maker.webp);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: cover;
    height: 100%;
    min-height: 88vh;
    padding-top: 4%
}

.div-block-98.pb-md.pt-sm.flex {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64a7e7a6656a76b25ff7b627_62f295f65cac0a38a49e99e4_ezgif.com-gif-maker.webp.png);
    background-size: cover;
    justify-content: center;
    align-items: center;
    padding-top: 12%;
    display: flex
}

.blog-subscription-container {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 2.25fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 40px;
    padding: 24px 16px;
    display: block
}

.heading-36 {
    margin-bottom: 8px;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 48px
}

.landing-nav {
    background-color: var(--white);
    padding-top: 20px;
    padding-bottom: 20px;
    position: sticky;
    top: 0
}

.landing-nav.competitor-landing-nav {
    z-index: 10;
    padding-top: 0;
    padding-bottom: 0
}

.div-block-100 {
    background-color: var(--black)
}

.div-block-101 {
    flex-flow: wrap;
    justify-content: space-around;
    align-items: stretch;
    width: 80%;
    margin-top: 80px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    display: flex
}

.div-block-102 {
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    width: 29%;
    margin-top: 40px;
    display: grid
}

.div-block-102.child {
    margin-top: 40px;
    margin-left: 0
}

.div-block-102.child.no-left {
    margin-left: 0
}

.div-block-103 {
    justify-content: flex-start;
    align-items: stretch;
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex
}

.heading-38 {
    text-align: center;
    width: 100%;
    font-size: 48px;
    line-height: 60px
}

.heading-39 {
    color: rgba(0, 0, 0, .55);
    text-align: center;
    width: 100%;
    margin-top: 24px;
    font-size: 20px;
    font-style: normal;
    font-weight: 500
}

.text-block-37,
.text-block-38,
.text-block-39,
.text-block-40,
.text-block-42,
.text-block-43 {
    color: var(--black-2);
    text-align: left;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px
}

.section-5 {
    background-color: var(--white-smoke)
}

.text-span-40 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.div-block-104 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--white);
    border-radius: 8px;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    margin-top: 40px;
    padding: 32px;
    display: grid;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .08)
}

.div-block-105 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 48px 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.image-22 {
    width: 40px;
    height: 40px
}

.paragraph-14 {
    text-align: left
}

.heading-40 {
    text-align: left;
    margin-top: 0
}

.div-block-106 {
    width: 100%;
    margin-top: 40px
}

.paragraph-15 {
    font-family: Satoshi, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px
}

.text-span-42 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.heading-41 {
    width: 100%
}

.div-block-107 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: 24px 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    width: 100%;
    margin-top: 8px;
    display: grid
}

.div-block-107.first {
    width: 100%;
    margin-top: 24px
}

.image-23 {
    width: 24px;
    height: 24px
}

.div-block-108 {
    flex-flow: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-top: 0;
    display: flex
}

.div-block-109 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: start;
    width: 100%;
    margin-top: 40px;
    display: grid
}

.text-block-44,
.text-block-45,
.text-block-46,
.text-block-47 {
    font-size: 20px;
    font-weight: 400
}

.paragraph-16,
.paragraph-17,
.paragraph-18 {
    font-size: 16px;
    line-height: 22px
}

.heading-42 {
    width: 100%
}

.list-7 {
    margin-top: 40px;
    padding-left: 0;
    list-style-type: none
}

.list-item-9,
.list-item-10 {
    margin-bottom: 24px;
    font-size: 20px
}

.list-item-11 {
    font-size: 20px
}

.div-block-111 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.section-6 {
    background-color: var(--white-smoke)
}

.text-span-43,
.text-span-44 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.div-block-112 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--white-smoke);
    grid-template-rows: auto;
    grid-template-columns: .5fr 1fr;
    grid-auto-columns: 1fr;
    padding: 16px;
    display: grid
}

.paragraph-19 {
    margin-bottom: 8px;
    font-weight: 400
}

.div-block-113 {
    background-color: var(--white);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 8px;
    padding-right: 8px;
    display: flex
}

.text-span-45 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.competitor-landing-hero-grid {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    grid-template-rows: auto;
    grid-template-columns: 1.75fr 1fr;
    grid-auto-columns: 1fr;
    align-items: start;
    padding-top: 100px;
    padding-bottom: 100px;
    display: grid
}

.competitor-landing-hero-content {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-between;
    display: grid
}

.competitor-landing-hero-form {
    border-left: 12px none var(--slate-blue);
    background-color: var(--white);
    border-radius: 8px;
    flex-wrap: wrap;
    justify-content: center;
    padding: 24px;
    display: block;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
}

.competitor-landing-hero-form.minimal-fields {
    background-color: var(--white);
    margin-top: 0
}

.competitor-landing-hero-form.add-p-md {
    padding: 24px
}

.competitor-landing-hero-heading {
    margin-top: 32px
}

.html-embed-4 {
    margin-left: auto;
    margin-right: auto;
    display: block
}

.competitor-landing-hero-section {
    height: auto;
    padding-top: 40px;
    padding-bottom: 40px
}

.heading-44 {
    font-family: Satoshi, sans-serif;
    font-size: 64px;
    line-height: 1.2em
}

.paragraph-20 {
    text-align: left;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.4em
}

.button-6 {
    background-color: var(--pabloo-green);
    border-radius: 8px;
    padding: 12px 16px;
    font-family: Satoshi, sans-serif;
    font-weight: 500
}

.button-6.w--current {
    border-radius: 8px;
    padding-top: 12px;
    padding-bottom: 12px
}

.text-span-51 {
    color: var(--pabloo-green)
}

.div-block-115 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: var(--white);
    background-image: radial-gradient(circle farthest-corner at 100% 100%, var(--pabloo-green), var(--white)45%);
    border-radius: 24px;
    grid-template-rows: auto;
    grid-template-columns: 70% 30%;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid;
    position: relative;
    box-shadow: 0 0 16px rgba(0, 0, 0, .06)
}

.div-block-116 {
    background-color: transparent;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    flex: 0 1 auto;
    justify-content: flex-end;
    align-self: auto;
    align-items: stretch;
    width: 100%;
    height: 340px;
    max-height: 340px;
    display: flex;
    position: static;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.div-block-116.uc-image-wrapper {
    background-color: transparent;
    justify-content: center
}

.div-block-118 {
    display: none
}

.text-block-48 {
    color: var(--black);
    font-size: 16px
}

.image-27 {
    border-bottom-right-radius: 24px;
    margin-top: 28px
}

.image-27.urban-company {
    border-bottom-right-radius: 24px;
    padding-right: 0
}

.review-author-name-2 {
    color: #000;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.5
}

.auto-slider-arrow-left-2 {
    background-color: transparent;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    padding: 10px 5px;
    transition: background-color .3s;
    display: none;
    position: absolute;
    top: auto;
    bottom: -20px;
    left: auto;
    right: 100px
}

.auto-slider-arrow-left-2:hover {
    background-color: #fff
}

.mention-span-2 {
    color: #d53987
}

.review-slider-text-2 {
    color: #000;
    margin-left: auto;
    margin-right: auto;
    font-size: 22px;
    font-weight: 400;
    line-height: 1.3
}

.text-block-49 {
    color: #000;
    font-size: 16px;
    line-height: 22px
}

.div-block-119 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: #fff;
    background-image: radial-gradient(circle at 100% 100%, #d53987, #fff 45%);
    border-radius: 24px;
    grid-template-rows: auto;
    grid-template-columns: 70% 30%;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid;
    position: relative;
    box-shadow: 0 0 16px rgba(0, 0, 0, .06)
}

.div-block-120 {
    padding-bottom: 32px
}

.header-bullet-point {
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    display: flex
}

.h1-heading {
    color: var(--black);
    letter-spacing: normal;
    margin-top: 0;
    margin-bottom: 0;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 64px;
    font-weight: 600;
    line-height: 1
}

.header-grid {
    grid-column-gap: 72px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1.2fr 1fr;
    align-items: start
}

.container-regular {
    width: 100%;
    max-width: 1060px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.header-feature-block {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    color: #fff;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    display: flex
}

.header-section {
    background-color: var(--white);
    align-items: center;
    height: auto;
    min-height: 90vh;
    padding: 80px 5% 48px;
    display: flex;
    position: relative
}

.div-block-122 {
    border-left: 12px solid var(--slate-blue);
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, .12);
    border-radius: 8px;
    margin-top: 0;
    padding: 32px;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
}

.feature-section {
    padding: 80px 5% 40px
}

.h3-heading {
    color: var(--black);
    letter-spacing: -.02em;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 40px;
    font-weight: 500;
    line-height: 48px
}

.feature-detail {
    color: #333b47;
    font-weight: 500;
    line-height: 24px
}

.feature-grid-large {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr
}

.feature-grid-large._3-grid {
    grid-template-columns: 1fr 1fr 1fr
}

.feature-heading-wrapper {
    grid-column-gap: 44px;
    grid-row-gap: 24px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 64px;
    display: flex
}

.feature-heading-bold {
    color: #000;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px
}

.container-12 {
    width: 100%;
    max-width: 1060px;
    margin-left: auto;
    margin-right: auto
}

.feature-content-small {
    margin-top: 32px
}

.feature-icon {
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    display: flex
}

.feature-banner {
    color: #454f5f;
    border-top: 1px solid #dce0e5;
    margin-top: 64px;
    padding-top: 16px;
    padding-bottom: 16px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px
}

.paragraph-large {
    color: rgba(0, 0, 0, .6);
    text-align: center;
    letter-spacing: -.02em;
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 500;
    line-height: 32px
}

.paragraph-large.left {
    text-align: left
}

.container-large {
    width: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.container-large.career {
    margin-top: 64px
}

.margin-bottom-32 {
    align-items: flex-start;
    margin-bottom: 32px;
    display: flex
}

.paragraph-small {
    color: var(--black);
    letter-spacing: -.01em;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px
}

.authors-wrapper {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-wrap: wrap;
    grid-template-rows: auto;
    grid-template-columns: auto auto;
    grid-auto-columns: 1fr;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0;
    padding-left: 0;
    display: grid
}

.authors-wrapper.hide {
    display: none
}

.company-logo-2 {
    max-width: none;
    height: 32px;
    margin-left: 0;
    margin-right: 16px;
    display: block
}

.company-logo-2._1 {
    background-color: var(--white);
    height: 44px;
    margin-left: 0
}

.company-logo-2._1.nivas {
    height: 200px;
    padding: 0 0%
}

.company-logo-2.dan {
    height: 200px
}

.company-logo-2.dan.lg {
    height: 180px
}

.header-wrapper-2 {
    z-index: 2;
    background-color: var(--white);
    padding-top: 64px;
    position: relative
}

.ebook-points-heading {
    color: var(--black);
    margin-top: 16px;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px
}

.ebook-points-heading.points-heading {
    color: #000;
    font-size: 16px;
    font-weight: 500
}

.image-wrapper {
    z-index: 1;
    border-left: 12px solid var(--slate-blue);
    backdrop-filter: blur(16px);
    background-color: rgba(255, 255, 255, .24);
    border-radius: 8px;
    margin-left: 32px;
    margin-right: 32px;
    padding: 32px;
    position: relative;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .12)
}

.image-wrapper.darl-mode {
    background-color: var(--white);
    backdrop-filter: none
}

.trusted-text {
    color: rgba(0, 0, 0, .8);
    text-align: left;
    margin-top: 40px;
    margin-bottom: 24px;
    font-weight: 500
}

.hero-heading-2 {
    color: var(--black);
    letter-spacing: -.03em;
    margin-top: 0;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 53px;
    line-height: 72px
}

.hero-heading-2.color {
    color: var(--pabloo-green)
}

.header-grid-3 {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    grid-template-rows: auto;
    grid-template-columns: 1fr .75fr;
    align-items: start
}

.container-13 {
    flex: 0 1 auto;
    align-self: auto;
    width: 100%;
    max-width: 1140px;
    height: 100%;
    min-height: 80vh;
    max-height: 100%;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.container-13.remove-bg {
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto
}

.div-block-123 {
    padding-top: 4%
}

.header-section-3 {
    background-color: var(--white);
    align-items: center;
    min-height: 91vh;
    padding: 80px 3% 64px;
    display: flex;
    position: relative
}

.header-section-3.with-bg {
    background-image: url(https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: 40%;
    align-items: flex-start;
    padding-top: 24px;
    padding-bottom: 24px
}

.process-heading {
    color: #000;
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 46px;
    font-weight: 700;
    line-height: 1.3
}

.shape-wrapper {
    justify-content: center;
    align-items: center;
    margin-bottom: 4px;
    display: flex
}

.line-break {
    border: 1px dashed #d9d9d9;
    width: 100%;
    height: 2px
}

.process-title-wrap {
    text-align: center;
    max-width: 1000px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto
}

.process-block {
    text-align: center;
    border-radius: 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative
}

.process-container {
    max-width: 1260px;
    margin-left: auto;
    margin-right: auto
}

.number-large {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 80px;
    font-weight: 600;
    line-height: 80px;
    position: absolute;
    top: -24px
}

.number-large.medium {
    font-size: 24px;
    line-height: 32px;
    top: -20px
}

.process-paragraph {
    color: #999;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px
}

.process-title {
    color: #262626;
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2
}

.process-grid {
    grid-column-gap: 14px;
    grid-row-gap: 100px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .25fr 1fr;
    align-items: center
}

.title-small {
    color: #8e8e8e;
    letter-spacing: 2px;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px
}

.process-section {
    background-color: #fff;
    padding: 100px 5%
}

.feature-card {
    text-align: center;
    border: 1px solid #e5e5e5;
    border-radius: 20px;
    flex-direction: column;
    align-items: center;
    padding: 50px 24px 8px;
    display: flex
}

.features-container {
    max-width: 1440px;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 60px;
    padding-right: 60px;
    display: inline-block
}

.team-heading {
    color: #161616;
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 40px;
    font-weight: 700;
    line-height: 1.3
}

.feature-section-2 {
    color: #858585;
    background-color: #fff;
    padding: 140px 3%
}

.features-wrap {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.feature-icon-wrap {
    background-color: rgba(238, 42, 82, .05);
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 110px;
    margin-bottom: 32px;
    padding: 18px;
    display: flex
}

.features-paragraph {
    margin-bottom: 24px;
    font-size: 18px;
    line-height: 27px
}

.features-button {
    background-color: var(--pabloo-green);
    color: #fff;
    text-align: center;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    height: 60px;
    margin-top: 0;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 500;
    text-decoration: none;
    transition: background-position .3s;
    display: flex
}

.features-button:hover {
    background-position: 90%
}

.features-button.ab {
    background-color: #e65a41
}

.features-button.hide {
    display: none
}

.features-button.brand {
    background-color: var(--slate-blue);
    color: var(--white);
    padding-left: 16px;
    padding-right: 16px
}

.feature-card-name {
    color: #161616;
    margin-top: 0;
    margin-bottom: 14px;
    font-size: 18px;
    font-weight: 700;
    line-height: 27px
}

.features-grid {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-right: 60px;
    font-size: 14px;
    display: grid;
    position: relative
}

.features-heading-wrap {
    flex-direction: column;
    align-items: flex-start;
    max-width: 350px;
    display: flex
}

.form-block {
    margin-top: 32px;
    margin-bottom: 16px
}

.section-regular {
    background-color: var(--white);
    padding: 80px 5%;
    position: relative
}

.section-regular.nobg {
    background-color: var(--white)
}

.section-regular.middle-band {
    background-color: var(--pabloo-green);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/638dc96dbb6b67e15aff47f2_middleband-bg.svg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: auto
}

.section-regular.middle-band.blue {
    background-color: #011b4d
}

.section-regular.m-b-80 {
    margin-bottom: 0
}

.container-regular-2 {
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden
}

.form-wrapper-2 {
    justify-content: center;
    align-items: center;
    display: flex
}

.paragraph-regular {
    letter-spacing: -.02em;
    font-size: 16px;
    line-height: 24px
}

.integration-wrapper {
    width: 100%
}

.title-wrapper {
    position: relative
}

.integration {
    color: #02044a;
    text-align: center;
    letter-spacing: -.03em;
    background-color: #fff;
    border-radius: 20px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-width: 290px;
    height: 100%;
    min-height: 64px;
    margin-left: 15px;
    margin-right: 15px;
    padding: 8px 20px;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
    text-decoration: none;
    display: flex;
    box-shadow: 46px 46px 72px 2px rgba(43, 29, 103, .08)
}

.title {
    color: var(--pabloo-green);
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px
}

.container-14 {
    width: 100%;
    max-width: 1400px;
    margin-top: 32px;
    margin-left: auto;
    margin-right: auto
}

.integration-row {
    justify-content: center;
    align-items: stretch;
    margin-bottom: 30px;
    display: flex;
    position: static
}

.integration-logo {
    width: 88px;
    margin-bottom: 0
}

.integration-logo.accel {
    width: 72px
}

.integration-logo.sp {
    width: 140px
}

.integration-logo.together {
    width: 90px
}

.title-wrap-2 {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 650px;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.integration-row-bottom {
    justify-content: center;
    align-items: stretch;
    width: 100%;
    display: flex;
    position: static;
    left: 0
}

.cta-wrapper {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.margin-bottom-24 {
    margin-bottom: 24px
}

.cta-block {
    width: 100%
}

.text-span-57 {
    color: var(--pabloo-green)
}

.text-span-57.ab {
    color: #e65a41
}

.bloom-image-effect-2 {
    z-index: -1;
    min-width: 60%;
    max-width: 70%;
    display: none;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.text-block-55 {
    color: #000;
    font-size: 24px;
    font-weight: 500;
    display: none
}

.text-span-59 {
    color: var(--pabloo-green)
}

.heading-62 {
    text-align: left;
    margin-left: 0;
    margin-right: 0
}

.heading-62.left {
    text-align: left
}

.heading-62.left.sm {
    font-size: 36px
}

.heading-62.pink {
    color: var(--slate-blue);
    margin-left: 12px;
    margin-right: 0
}

.heading-62.center {
    text-align: center
}

.heading-62.center.scheme {
    color: var(--slate-blue)
}

.header-feature-3 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-columns: 1fr;
    margin-top: 64px;
    margin-bottom: 32px
}

.text-block-56,
.text-block-57,
.text-block-58 {
    color: var(--black);
    font-size: 20px;
    font-weight: 500
}

.text-span-60 {
    color: var(--pabloo-green)
}

.button-wrapper-3 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 32px;
    display: flex
}

.flex-wrapper-centre {
    z-index: 5;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 720px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: relative
}

.margin-bottom-12 {
    margin-bottom: 12px
}

.image-cover {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.image-cover.not-in-mobile {
    object-fit: cover;
    overflow: visible
}

.image-cover.mobile-only {
    display: none
}

.heading-detail-small {
    color: var(--pabloo-green);
    letter-spacing: .08em;
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px
}

.header-placeholder-top {
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    height: 420px;
    margin-bottom: 32px;
    display: flex;
    overflow: hidden
}

.button-neutral {
    background-color: var(--pabloo-green);
    outline-offset: 0px;
    color: #fff;
    text-align: center;
    letter-spacing: -.02em;
    border-radius: 8px;
    outline: 2px solid transparent;
    justify-content: center;
    align-items: center;
    min-width: 120px;
    min-height: 48px;
    padding: 12px 16px;
    font-size: 14px;
    text-decoration: none;
    transition: background-color .3s;
    display: flex
}

.button-neutral:hover {
    background-color: rgba(213, 57, 135, .9)
}

.section-large {
    padding: 0 5% 120px;
    position: relative
}

.text-block-59 {
    font-size: 16px;
    font-weight: 500
}

.image-30 {
    max-width: 20%;
    display: none
}

.image-cover-2 {
    object-fit: cover;
    object-position: 50% 50%;
    background-color: #f0f1f4;
    width: 100%;
    height: 100%
}

.image-cover-2.yellow {
    background-color: var(--goldenrod)
}

.image-cover-2.pink {
    background-color: var(--pabloo-green);
    background-color: #d53987
}

.div-block-125 {
    z-index: 110;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    backdrop-filter: blur(8px);
    color: var(--black);
    background-color: rgba(0, 0, 0, .75);
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    display: none;
    position: fixed;
    top: 0
}

.div-block-126 {
    background-color: var(--white);
    border-radius: 16px;
    width: 48%;
    min-height: 120px;
    margin: 4% auto auto;
    padding: 32px;
    position: relative
}

.div-block-127 {
    padding-top: 8px;
    padding-bottom: 24px;
    position: relative
}

.heading-63 {
    margin-top: 0;
    margin-bottom: 8px
}

.paragraph-33 {
    color: var(--pabloo-green)
}

.link-block-2 {
    position: absolute;
    top: 16px;
    bottom: auto;
    left: auto;
    right: 16px
}

.text-block-60 {
    color: rgba(0, 0, 0, .5);
    font-size: 14px;
    line-height: 16px
}

.paragraph-34 {
    color: rgba(0, 0, 0, .55);
    margin-top: 16px;
    font-size: 20px;
    font-weight: 500
}

.text-span-61 {
    color: var(--pabloo-green);
    font-weight: 700
}

.text-span-62,
.text-span-63 {
    color: var(--pabloo-green)
}

.white-button {
    color: #0a0a0b;
    background-color: #fff;
    padding: 22px 40px;
    font-size: 18px;
    line-height: 1em;
    transition: color .35s, transform .35s, background-color .35s
}

.white-button:hover {
    color: #fff;
    background-color: #1154ff;
    transform: translateY(-3px)
}

.section-10 {
    padding-top: 80px;
    padding-bottom: 80px
}

.section-10.p-b-0 {
    padding-top: 0;
    padding-bottom: 0
}

.saas-cfo-webinar-logo {
    height: 40px
}

.div-block-140 {
    justify-content: center;
    margin-top: 80px;
    display: flex
}

.text-span-64 {
    color: var(--pabloo-green)
}

.html-embed-7 {
    align-items: center;
    display: flex
}

.html-embed-8,
.icon-embed {
    margin-top: 4px
}

.div-block-143 {
    background-color: var(--white);
    padding-top: 40px;
    padding-bottom: 40px
}

.div-block-144 {
    padding: 4% 16%
}

.text-block-65 {
    color: rgba(255, 255, 255, .65);
    text-align: center
}

.div-block-145 {
    background-color: var(--white);
    border-radius: 8px;
    margin-top: 40px;
    padding: 24px 40px 40px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, .12)
}

.submit-button {
    background-color: var(--pabloo-green);
    opacity: .57;
    cursor: not-allowed;
    border-radius: 12px;
    width: 320px;
    margin-left: auto;
    margin-right: auto;
    padding: 16px 56px;
    font-weight: 500
}

.div-block-146 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-147 {
    width: auto
}

.div-block-148 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-149 {
    justify-content: center;
    margin-top: 24px;
    display: flex
}

.field-label-2,
.field-label-3,
.field-label-4,
.field-label-5,
.field-label-6 {
    color: rgba(0, 0, 0, .4);
    font-size: 16px
}

.heading-70 {
    text-align: center;
    margin-bottom: 40px;
    font-size: 24px
}

.text-field-2,
.text-field-3,
.text-field-4,
.text-field-5 {
    padding: 24px 16px;
    font-size: 16px;
    line-height: 32px
}

.select-field-2 {
    background-color: var(--white);
    height: 50px;
    padding-top: 4px;
    font-size: 16px
}

.html-embed-9,
.html-embed-10 {
    margin-top: 6px
}

.success-message-4 {
    background-color: rgba(25, 255, 0, .32);
    border-radius: 4px
}

.cta-image-2 {
    z-index: 0;
    object-fit: cover;
    width: 50%;
    height: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%
}

.cta-button-wrapper {
    grid-column-gap: 16px;
    align-items: center;
    margin-top: 64px;
    margin-bottom: 16px;
    display: flex
}

.cta-button-wrapper.mt-24 {
    margin-top: 24px
}

.section-cta {
    background-color: #f7f9fd;
    padding: 80px 0% 80px 5%;
    position: relative
}

.section-cta.hide {
    display: block
}

.section-cta.pr-5p {
    padding-right: 5%
}

.cta-heading-wrap {
    z-index: 1;
    max-width: 100%;
    position: relative
}

.cta-heading {
    color: var(--black);
    letter-spacing: -.04em;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 16px;
    font-size: 52px;
    line-height: 56px
}

.cta-heading.ml-0 {
    margin-left: 0
}

.heading-detail {
    color: #8e8e8e;
    letter-spacing: .02em;
    text-transform: uppercase;
    white-space: normal;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 25px
}

.button-cta-primary {
    background-color: var(--pabloo-green);
    color: #fff;
    text-align: center;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    min-height: 52px;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: none;
    display: flex
}

.button-cta-primary.vendor {
    background-color: var(--pabloo-green)
}

.button-cta-secondary {
    border: 2px solid var(--pabloo-green);
    color: #1c2122;
    text-align: center;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    min-height: 52px;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: none;
    display: flex
}

.text-span-67,
.text-block-66 {
    color: var(--pabloo-green)
}

.div-block-152 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-153 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fff;
    border-top: 2px rgba(0, 0, 0, .07);
    border-radius: 0;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 0;
    padding: 12px 8px;
    display: grid
}

.div-block-153:hover {
    background-color: rgba(213, 57, 135, .05)
}

.div-block-153.margin-top-reset {
    margin-top: 0
}

.div-block-153.margin-top-reset:hover {
    background-color: rgba(213, 57, 135, .05)
}

.div-block-153.margin-top-reset.no-border {
    border-top-style: none;
    padding-top: 12px
}

.div-block-154 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    border-right: 2px rgba(0, 0, 0, .07);
    flex-wrap: wrap;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: flex-start;
    align-items: center;
    display: grid
}

.paragraph-38 {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px
}

.div-block-156 {
    background-color: #0f1444;
    border-radius: 8px;
    align-items: center;
    display: flex
}

.div-block-156.white-bg {
    background-color: var(--goldenrod);
    background-color: #ebb82f
}

.text-block-68 {
    color: var(--pabloo-green);
    font-size: 16px;
    text-decoration: none
}

.image-33 {
    object-fit: cover;
    border-radius: 8px;
    height: 100%
}

.div-block-157 {
    justify-content: center;
    align-items: center;
    display: flex
}

.div-block-158 {
    width: 100%
}

.avatar-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    align-items: center;
    display: flex
}

.avatar-wrapper._2 {
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    background-color: transparent;
    background-image: none;
    align-items: flex-start;
    padding-left: 8px;
    padding-right: 8px
}

.avatar-regular {
    background-color: #f3f5fb;
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    display: flex;
    position: relative;
    overflow: hidden
}

.avatar-regular.small {
    width: 40px;
    height: 40px
}

.avatar-image {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.avatar-name {
    font-size: 15px;
    font-weight: 500;
    line-height: 24px
}

.avatar-name.small {
    font-size: 15px;
    line-height: 24px
}

.avatar-role {
    color: #6b7094;
    font-size: 16px
}

.avatar-role.small {
    font-size: 11px;
    line-height: 20px
}

.div-block-159 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    display: flex
}

.div-block-159.stack {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    margin-top: 16px
}

.div-block-159.stack.hide {
    display: none
}

.alert-small {
    color: #160042;
    background-color: #fff;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    max-width: 340px;
    padding: 4px 16px 4px 0;
    display: flex;
    box-shadow: 35px 35px 50px -20px rgba(57, 59, 106, .14)
}

.alert-small.hide-shadow {
    box-shadow: none;
    background-color: transparent;
    max-width: 100%
}

.alert-wrapper {
    align-self: auto;
    align-items: center;
    display: flex
}

.alert-warning {
    color: #f93;
    background-color: #fff9f0;
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 16px;
    min-width: auto;
    height: 16px;
    min-height: auto;
    margin-right: 16px;
    display: flex
}

.icon-alert {
    justify-content: center;
    align-self: auto;
    align-items: center;
    width: 24px;
    height: 24px;
    display: flex
}

.heading-71 {
    margin-bottom: 20px
}

.content-grid {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.margin-bottom-08 {
    margin-bottom: 8px
}

.margin-bottom-08.text-weight-medium {
    font-weight: 500
}

.h3-heading-2 {
    letter-spacing: -.02em;
    font-size: 48px;
    line-height: 1.2
}

.h3-heading-2.text-weight-medium {
    font-weight: 500
}

.content-icon-square {
    color: #4255bd;
    background-color: #f4f5fb;
    border: 1px solid #b3bbe5;
    border-radius: 14px;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    display: flex
}

.content-icon-red {
    background-color: #fef1f1;
    border: 1px solid #f5a3a3;
    border-radius: 14px;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    display: flex
}

.content-icon-large {
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    display: flex
}

.content-heading-wrapper {
    margin-bottom: 72px
}

.content-icon-green {
    border: 1px #b3e5c3;
    border-radius: 14px;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    display: flex
}

.content-icon-orange {
    background-color: #fff9f0;
    border: 1px solid #fcd49c;
    border-radius: 14px;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    display: flex
}

.container-15 {
    z-index: 5;
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.content-icon-gray {
    background-color: #f7f7f7;
    border: 1px solid #e6e6e6;
    border-radius: 14px;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    display: flex
}

.grid-two-column-2 {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr
}

.section-large-2 {
    background-color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6244f42f88a11de61a8be252_Group%20223.svg);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    padding: 80px 5%;
    position: relative
}

.section-large-2.nobg {
    background-color: var(--white);
    background-image: none
}

.section-large-2.blackbg {
    background-color: var(--white-smoke);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/632ae3ea4736271c5ea83563_bg-element-wire-1.svg);
    background-position: 120% 115%;
    background-repeat: no-repeat;
    background-size: 160px;
    padding-top: 160px;
    padding-bottom: 80px
}

.content-card {
    color: #1a1a1a;
    border-radius: 20px;
    flex-direction: column;
    align-items: flex-start;
    padding: 24px;
    display: flex
}

.content-card.content-green {
    background-color: #f4fbf6
}

.content-card.content-blue {
    background-color: #f4f5fb
}

.content-card.content-yellow {
    background-color: #fffcf0
}

.paragraph-small-2 {
    letter-spacing: -.01em;
    font-size: 14px;
    line-height: 24px;
    display: none
}

.sub-heading-regular {
    color: rgba(26, 26, 26, .64);
    letter-spacing: -.03em;
    margin-top: 4px;
    font-size: 18px;
    line-height: 32px
}

.content-icon-yellow {
    background-color: #fffcf0;
    border: 1px solid #fcec9c;
    border-radius: 14px;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    display: flex
}

.content-image {
    border: 1px solid #e6e6e6;
    border-radius: 20px;
    height: 100%;
    overflow: hidden
}

.paragraph-39 {
    color: rgba(0, 0, 0, .6);
    font-weight: 500;
    line-height: 32px
}

.badge-wrapper {
    justify-content: flex-start;
    margin-bottom: 8px;
    display: flex
}

.badge-standard {
    background-color: var(--pabloo-green);
    color: #fff;
    border-radius: 50px;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    font-size: 12px;
    line-height: 16px;
    display: flex
}

.text-block-69 {
    color: #fff;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500
}

.link-block-3 {
    height: 100%
}

.heading-wrapper {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 720px;
    margin: 39px auto 8px;
    display: flex
}

.grid-three-column {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr
}

.paragraph-large-2 {
    color: var(--white);
    letter-spacing: -.02em;
    font-size: 20px;
    line-height: 32px
}

.testimoial-container {
    background-color: transparent;
    flex-flow: wrap;
    flex: 0 1 auto;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    padding: 40px 0%;
    display: flex;
    position: relative;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.d-128-3d-card-wrapper {
    perspective: 1000px;
    cursor: pointer;
    width: 320px;
    height: 300px;
    margin-bottom: 32px;
    margin-left: 15px;
    margin-right: 15px;
    position: relative;
    overflow: visible;
    box-shadow: 1px 1px 12px rgba(0, 0, 0, .1)
}

.slide {
    width: 100%;
    height: 100%;
    padding-left: 300px;
    padding-right: 40px;
    position: relative
}

.ck-button-w {
    color: #fff;
    text-align: center;
    background-color: #515750;
    border-radius: 0;
    padding: .875em 1.5em 1rem;
    font-size: .9375rem;
    text-decoration: none;
    transition: color .2s cubic-bezier(.25, .46, .45, .94), background-color .2s cubic-bezier(.25, .46, .45, .94)
}

.ck-button-w:hover {
    background-color: #262926
}

.ck-button-w.is--secondary {
    color: #515750;
    background-color: transparent;
    margin-right: -1.25em;
    padding-left: 1.25em;
    padding-right: 1.25em;
    font-size: .875rem;
    font-weight: 700
}

.ck-button-w.is--secondary:hover {
    color: #262926;
    /* text-decoration: none */
}

.ck-button-w.is--secondary.is--fullwidth {
    margin-top: .75rem;
    margin-bottom: -1rem;
    margin-right: 0
}

.ck-button-w.is--fullwidth {
    flex: none;
    width: 100%
}

.ck-title {
    color: #262926;
    margin-bottom: .1875em;
    font-size: 1.25rem;
    font-weight: 700
}

.ck-title.is--small {
    font-size: 1.1875rem
}

.ck-txt-link {
    transition: color .15s cubic-bezier(.25, .46, .45, .94)
}

.ck-sr__only {
    width: 1px;
    height: 1px;
    margin: -1px;
    position: absolute;
    overflow: hidden
}

.ck-modal__content-w {
    padding: 1.75rem 2rem
}

.ck-modal__content-w.is--small {
    padding: 1.5rem
}

.ck-cookie-w {
    z-index: 9500;
    max-width: 25rem;
    position: fixed;
    top: auto;
    bottom: 1.25rem;
    left: auto;
    right: 1.25rem
}

.ck-modal__exit-btn {
    z-index: 5;
    cursor: pointer;
    background-color: #fdf5f9;
    border-radius: .25rem;
    justify-content: center;
    align-items: center;
    width: 2.5rem;
    height: 2.5rem;
    margin: 1.25rem 1.25rem -2.5rem auto;
    transition: background-color .2s cubic-bezier(.25, .46, .45, .94);
    display: flex;
    position: relative
}

.ck-modal__exit-btn.is--sticky {
    position: sticky;
    top: 1rem
}

.ck-css-styles {
    display: none
}

.ck__exitbtn__line {
    background-color: #515750;
    width: 1rem;
    height: 2px;
    position: absolute
}

.ck__exitbtn__line.is--left {
    transform: rotate(45deg)
}

.ck__exitbtn__line.is--right {
    transform: rotate(-45deg)
}

.ck-modal__btns-w {
    background-color: #f3f7f2;
    border-radius: 0 0 .25rem .25rem;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    display: flex
}

.ck-modal__btns-w.is--small {
    background-color: #fdf5f9;
    justify-content: flex-start;
    padding: 1.5rem
}

.ck-modal__btns-w.in-pref-manger {
    background-color: #fdf5f9;
    margin: 2rem -2rem -2.25rem
}

.ck-modal {
    background-color: #fff;
    border-radius: .25rem;
    flex-direction: column;
    max-width: 32rem;
    margin-left: auto;
    margin-right: auto;
    font-size: .9375rem;
    line-height: 1.4;
    display: none;
    position: relative;
    box-shadow: 0 4px 1rem rgba(38, 41, 38, .05)
}

.ck-preference-w {
    z-index: 9525;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: none;
    position: fixed;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.ck-radio-w {
    color: #999c98;
    cursor: pointer;
    margin-top: 1rem;
    margin-bottom: 0;
    padding-left: 1.75rem;
    transition: color .15s cubic-bezier(.25, .46, .45, .94)
}

.ck-radio-w.is--not-allowed {
    cursor: not-allowed
}

.text-block {
    width: 1px;
    height: 1px;
    margin: -1px;
    position: absolute;
    overflow: hidden
}

.ck-preference__scroll-w {
    width: 100%;
    max-height: 100%;
    padding-left: 2rem;
    padding-right: 2rem;
    position: relative;
    overflow: auto
}

.ck-radio__label {
    color: #262926;
    cursor: pointer;
    margin-bottom: .25rem;
    font-size: .9375rem;
    font-weight: 600
}

.ck-radio__desc {
    cursor: pointer;
    font-size: .875rem;
    font-weight: 400
}

.ck-radio__btn {
    float: left;
    border: 1.75px solid #999c98;
    border-radius: .375rem;
    width: 1.25rem;
    height: 1.25rem;
    margin-top: 0;
    margin-left: -1.75rem;
    transition: background-color .2s cubic-bezier(.25, .46, .45, .94)
}

.ck-radio__btn.w--redirected-checked {
    background-color: #515750;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/63199fbef7162204cd0d425e_radio__checkmark.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: .625rem;
    border: 1px solid #515750;
    border-radius: .375rem;
    width: 1.25rem;
    height: 1.25rem;
    margin-top: 0
}

.ck-radio__btn.w--redirected-focus {
    box-shadow: none
}

.ck-radio__btn.is--checked {
    background-color: #515750;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/63199fbef7162204cd0d425e_radio__checkmark.svg);
    background-position: 45%;
    background-repeat: no-repeat;
    background-size: .625rem;
    border-color: #515750
}

.ck-form {
    padding-top: 1.25rem;
    padding-bottom: .5rem
}

.ck-preference__bg {
    opacity: 1;
    backdrop-filter: blur(.5rem);
    cursor: pointer;
    background-color: rgba(215, 231, 213, .5);
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.ck-form-w {
    margin-bottom: 0
}

.ck-prefmanager-w {
    z-index: 9475;
    color: #262926;
    text-decoration: none;
    display: flex;
    position: fixed;
    bottom: 0;
    left: 1.25rem
}

.ck-prefmanager-w:hover {
    /* text-decoration: none */
}

.ck-preference__btn {
    color: #262926;
    background-color: #fcf5f9;
    border-radius: .5rem .5rem 0 0;
    align-items: center;
    margin-bottom: -.125rem;
    padding: .75em 1em .875em;
    font-size: .9375rem;
    font-weight: 700;
    line-height: 1;
    text-decoration: none;
    transition: margin-bottom .2s cubic-bezier(.25, .46, .45, .94);
    display: flex
}

.ck-preference__btn:hover {
    margin-bottom: 0;
    /* text-decoration: none */
}

.ck-preference__icon {
    flex: none;
    width: 1.125rem;
    height: 1.125rem;
    margin-right: .375rem
}

.modal-section {
    z-index: 12000;
    color: #9aaebc;
    background-color: rgba(0, 0, 0, .4);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 150px 3%;
    font-size: 18px;
    line-height: 27px;
    display: none;
    position: fixed;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    overflow: auto
}

.modal-link {
    color: #9aaebc;
    letter-spacing: 1px;
    margin-top: 16px;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    transition: color .3s;
    position: static;
    top: 0%;
    bottom: auto;
    left: auto;
    right: 1%
}

.modal-link:hover {
    color: var(--pabloo-green)
}

.modal-paragraph {
    color: rgba(0, 0, 0, .72);
    text-align: center;
    margin-bottom: 30px;
    font-size: 20px;
    font-weight: 500
}

.modal-container {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: #fff;
    border-radius: 0;
    flex-flow: row;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-self: center;
    align-items: center;
    justify-items: center;
    max-width: 960px;
    height: auto;
    max-height: none;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    display: flex;
    position: sticky
}

.modal-content {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 52%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
    display: flex
}

.modal-heading {
    color: var(--black);
    text-align: center;
    letter-spacing: -.02em;
    width: 100%;
    margin-top: 0;
    margin-bottom: 14px;
    font-size: 38px;
    font-weight: 700;
    line-height: 48px
}

.modal-image-large {
    background-color: var(--pabloo-green);
    object-fit: contain;
    border-radius: 0;
    margin-right: 40px
}

.modal-image-large.blue-bg {
    object-fit: cover;
    background-color: #b90062;
    width: 100%
}

.modal-buttons-wrap {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    display: flex
}

.grid-cta {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1.4fr 1fr;
    align-items: center
}

.button-neutral-2 {
    background-color: var(--slate-blue);
    outline-offset: 0px;
    color: var(--white);
    text-align: center;
    letter-spacing: -.02em;
    border-radius: 48px;
    outline: 2px solid transparent;
    justify-content: center;
    align-items: center;
    min-width: 120px;
    min-height: 48px;
    padding: 12px 32px;
    font-size: 14px;
    text-decoration: none;
    transition: background-color .3s;
    display: flex
}

.button-neutral-2:hover {
    background-color: #3838d6;
    flex-wrap: wrap
}

.button-neutral-2.pink-bg {
    background-color: var(--pabloo-green);
    border-radius: 8px;
    padding-left: 16px;
    padding-right: 16px;
    font-size: 18px
}

.cta-placeholder {
    object-fit: fill;
    width: 100%
}

.text-block-70 {
    font-size: 18px;
    font-weight: 700
}

.heading-74,
.heading-74.text-black {
    color: var(--white)
}

.bold-text-4 {
    color: var(--pabloo-green)
}

.paragraph-40 {
    color: var(--light-slate-grey)
}

.div-block-161 {
    background-color: var(--white-smoke);
    border-radius: 6px;
    padding: 8px
}

.section-11 {
    width: 100%;
    margin-bottom: 0;
    padding: 24px 0 0
}

.paragraph-large-4 {
    color: var(--black-2);
    letter-spacing: -.02em;
    font-size: 20px;
    line-height: 32px
}

.flex-wrapper-centre-2 {
    z-index: 5;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: relative
}

.heading-77 {
    color: var(--black);
    line-height: 80px
}

.text-span-73 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.testimonial-paragraph {
    color: var(--black)
}

.testimonial-title-wrapper {
    max-width: 500px;
    margin-bottom: 60px
}

.testimonial-slider {
    background-color: transparent;
    width: 100%;
    height: auto
}

.sub-heading {
    color: var(--pabloo-green);
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 24px;
    font-weight: 600
}

.testimonial-section-2 {
    padding: 80px 8%;
    position: relative
}

.testimonial-container-2 {
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto
}

.div-block-164 {
    background-color: var(--white-smoke);
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    background-attachment: scroll;
    padding-left: 8%;
    padding-right: 8%;
    position: relative
}

.div-block-165 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.social-grid {
    z-index: 2;
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--white-smoke);
    border: 2px solid #ebebeb;
    border-radius: 160px;
    grid-template-rows: auto;
    grid-template-columns: 40px 40px;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: -20px;
    padding: 8px 24px 0;
    display: flex;
    position: relative
}

.social-grid.hide {
    display: none
}

.video-3 {
    display: block
}

.section-12 {
    background-color: var(--slate-blue)
}

.section-small {
    background-color: var(--white);
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    padding: 64px 5% 24px
}

.section-small.custo {
    padding-left: 0%;
    padding-right: 0%
}

.flex-wrapper-centre-3 {
    z-index: 5;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 700px;
    margin-bottom: 48px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: relative
}

.flex-wrapper-centre-3.margin-bottom-48 {
    margin-bottom: 24px
}

.flex-wrapper-centre-3.margin-bottom-48.custo {
    align-items: flex-start;
    margin-bottom: 24px
}

.h6-heading {
    letter-spacing: -.02em;
    margin-top: 0;
    font-size: 32px;
    line-height: 1.5
}

.h6-heading.custo {
    text-align: left;
    font-size: 42px;
    line-height: 1.3
}

.grid-four-column {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-wrap: wrap;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-auto-flow: row;
    justify-content: center;
    justify-items: stretch;
    display: flex
}

.grid-four-column.custo {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    align-content: stretch;
    justify-content: flex-start;
    align-items: stretch
}

.logo-block {
    background-color: var(--white);
    box-shadow: none;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    min-height: 64px;
    padding: 4px 24px;
    display: flex
}

.logo-block.custo {
    min-height: 60px
}

.logo-block.cult {
    padding-left: 24px;
    padding-right: 24px
}

.logo-block.px-8 {
    padding-left: 12px;
    padding-right: 12px
}

.image-40 {
    filter: grayscale();
    height: 32px
}

.image-40.small {
    height: 24px
}

.image-40._4g {
    height: 40px
}

.client-logo {
    filter: grayscale();
    height: 30px
}

.client-logo.mind-tickle-logo-resize {
    height: 28px;
    line-height: 28px
}

.client-logo.mind-tickle-logo-resize.small {
    height: 16px
}

.client-logo.curefit-logo-resize {
    height: 56px
}

.client-logo.curefit-logo-resize.small.custo {
    height: 30px
}

.client-logo.curefit-logo-resize.small.custo.rapido {
    height: 34px
}

.client-logo.small {
    height: 22px
}

.client-logo.big {
    height: 80px
}

.client-logo.big.momnt {
    filter: invert()grayscale();
    height: 68px
}

.client-logo.md {
    height: 48px
}

.text-span-77 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.link-block-4 {
    display: none
}

.html-embed-12 {
    margin-top: 40px
}

.bold-text-7 {
    line-height: 72px
}

.text-span-78 {
    color: var(--pabloo-green)
}

.text-span-79 {
    color: var(--slate-blue);
    font-family: "P22mackinacpro 11", sans-serif
}

.text-span-80 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.text-span-81 {
    color: var(--slate-blue);
    font-family: "P22mackinacpro 11", sans-serif
}

.text-span-82 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.text-span-83 {
    color: var(--slate-blue);
    font-family: "P22mackinacpro 11", sans-serif
}

.div-block-167 {
    display: none;
    position: absolute;
    top: 24%;
    bottom: auto;
    left: auto;
    right: 0%
}

.image-41 {
    border-bottom-right-radius: 26px
}

.image-41.wodify {
    object-fit: cover;
    align-self: flex-end;
    height: 80%;
    margin-right: -5px
}

.image-42 {
    border-bottom-right-radius: 2px
}

.testimonial-line {
    margin-left: 11px;
    margin-right: 11px
}

.testimonial-role {
    color: #acb4c3;
    font-size: 14px;
    line-height: 24px
}

.testimonial-bottom-wrapper {
    grid-column-gap: 24px;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;
    display: flex
}

.grid-team-slider {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1.7fr
}

.quote-icon {
    z-index: -1;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: 0%
}

.social-square {
    color: #07090d;
    border: 1px solid #edeff2;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    padding: 8px;
    transition: border-color .3s;
    display: flex
}

.social-square:hover {
    border-color: #c3c9d5
}

.title-wrapper-regular {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 640px;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.title-wrapper-regular.custo {
    align-items: flex-start;
    max-width: 100%;
    margin-bottom: 32px
}

.testimonial-name {
    color: #07090d;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px
}

.back-button {
    color: #07090d;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    transition: color .2s, background-color .2s;
    display: flex;
    top: auto;
    bottom: -20%;
    left: auto;
    right: 60px
}

.back-button:hover {
    background-color: var(--pabloo-green);
    color: #fff
}

.h3-heading-3 {
    color: #07090d;
    letter-spacing: -.02em;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 44px;
    font-weight: 600;
    line-height: 60px
}

.h3-heading-3.custo {
    text-align: left;
    font-size: 42px;
    line-height: 1.3
}

.next-button-2 {
    color: #07090d;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    transition: color .2s, background-color .2s;
    display: flex;
    top: auto;
    bottom: -20%;
    left: auto;
    right: 0%
}

.next-button-2:hover {
    background-color: var(--pabloo-green);
    color: #fff
}

.slide-nav-hiddle {
    display: none
}

.section-testimonial {
    background-color: #fff;
    padding: 80px 5% 140px;
    display: block;
    position: relative;
    overflow: hidden
}

.section-testimonial.unhide {
    padding: 32px 0%;
    display: block
}

.testimonial-social-wrapper {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    align-items: center;
    display: flex
}

.margin-bottom-33 {
    margin-bottom: 16px
}

.slider-testimonial {
    background-color: transparent;
    width: 100%;
    height: 100%
}

.testimonial-name-wrapper {
    justify-content: flex-start;
    align-items: center;
    margin-top: 40px;
    display: flex
}

.container-16 {
    z-index: 5;
    width: 100%;
    max-width: 1160px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 80px;
    position: relative
}

.icon-regular-2 {
    justify-content: center;
    align-items: center;
    display: flex
}

.testimonial-content-wrapper {
    flex-direction: column;
    justify-content: center;
    padding-top: 24px;
    padding-bottom: 0;
    display: flex;
    position: relative
}

.h6-heading-2 {
    color: #07090d;
    font-size: 18px;
    line-height: 32px
}

.span-primary {
    color: #1457ff
}

.div-block-168 {
    position: relative
}

.div-block-169 {
    background-color: var(--slate-blue);
    width: 100%;
    height: 50%;
    position: absolute
}

.image-43 {
    position: relative
}

.image-44 {
    width: 100%;
    position: relative
}

.div-block-170 {
    position: relative
}

.navigation-wrapper {
    grid-column-gap: 8px;
    align-items: center;
    display: flex
}

.navigation-3 {
    background-color: #fff;
    align-items: center;
    width: 100%;
    min-height: 88px;
    padding: 24px 5%;
    display: flex
}

.navigation-avatar-wrapper {
    grid-column-gap: 16px;
    align-items: center;
    display: flex
}

.navigation-link-icon {
    grid-column-gap: 44px;
    color: #160042;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    text-decoration: none;
    transition: background-color .3s;
    display: flex
}

.navigation-link-icon:hover {
    background-color: #f7f9fd
}

.logo-link-large {
    margin-right: 24px
}

.logo-2 {
    width: 124px
}

.navigation-menu-2 {
    align-items: center;
    display: flex;
    position: static
}

.navigation-container-3 {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.navigation-icon-arrow {
    margin-right: 10px
}

.navigation-link-icon-2 {
    grid-column-gap: 44px;
    color: #000;
    border-radius: 16px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    text-decoration: none;
    transition: background-color .3s;
    display: flex
}

.navigation-link-icon-2:hover {
    background-color: #f3f4f6
}

.text-span-84 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.header-content-wrapper {
    z-index: 5;
    color: #fff;
    text-align: center;
    font-weight: 500;
    display: none;
    position: relative
}

.header-slide-image {
    z-index: 2;
    object-fit: fill;
    border-radius: 32px;
    width: 100%;
    height: auto;
    min-height: auto;
    position: relative;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.sub-heading-large {
    letter-spacing: -.02em;
    font-size: 24px;
    line-height: 1.5
}

.header-discount-wrapper {
    margin-top: 24px;
    font-weight: 500
}

.header-slider-product {
    background-color: var(--white);
    border-radius: 24px;
    min-height: 562px;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
}

.discount-badge {
    color: #fff;
    background-color: #d0011d;
    border-radius: 8px;
    margin-left: 4px;
    margin-right: 4px;
    padding: 4px 10px;
    display: inline-block
}

.header-large-white {
    color: #fff;
    letter-spacing: -.04em;
    margin-top: 0;
    font-size: 64px;
    font-weight: 500;
    line-height: 1.2
}

.header-term-detail {
    margin-top: 60px
}

.header-section-small {
    padding: 62px 5%;
    position: relative
}

.header-section-small.custo {
    padding: 0 0%
}

.header-slide-wrapper {
    background-color: var(--white);
    border-radius: 32px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0;
    display: flex
}

.feature-card-2 {
    background-color: var(--white);
    color: #f4f4f6;
    border-radius: 24px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0;
    text-decoration: none;
    display: flex;
    position: relative;
    overflow: hidden
}

.shape-2 {
    justify-content: center;
    display: flex
}

.feature-shape {
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: 0%
}

.paragraph-large-6 {
    letter-spacing: -.02em;
    font-size: 18px;
    line-height: 1.5
}

.feature-icon-svg {
    justify-content: center;
    align-items: center;
    display: flex
}

.feature-section-3 {
    background-color: transparent;
    padding: 0 0%;
    position: relative
}

.margin-bottom-34 {
    margin-bottom: 8px
}

.margin-bottom-34.text-weight-medium {
    font-weight: 500;
    display: none
}

.feature-icon-3 {
    z-index: 2;
    background-color: #22242f;
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    margin-bottom: 32px;
    display: flex;
    position: absolute;
    top: 20px;
    bottom: auto;
    left: auto;
    right: 20px
}

.feature-grid-2 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.link-block-5 {
    height: 100%;
    display: block
}

.link-block-5.header-slider-product {
    box-shadow: none;
    border-radius: 32px;
    min-height: 620px
}

.heading-79 {
    color: var(--black-2);
    text-align: center;
    font-size: 20px;
    font-style: italic;
    font-weight: 300
}

.heading-79.hide {
    display: none
}

.image-45 {
    height: 240px;
    margin-left: auto;
    margin-right: auto
}

.div-block-171 {
    justify-content: center;
    display: flex
}

.div-block-171.hide {
    display: flex
}

.process-heading-2 {
    color: #000;
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 20px;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 46px;
    font-weight: 700;
    line-height: 1.3
}

.process-heading-2.m-b-8 {
    margin-bottom: 8px;
    font-family: Satoshi, sans-serif;
    font-size: 40px
}

.process-title-wrap-2 {
    text-align: center;
    max-width: 610px;
    margin-bottom: 140px;
    margin-left: auto;
    margin-right: auto
}

.process-grid-2 {
    grid-column-gap: 14px;
    grid-row-gap: 100px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .25fr 1fr .25fr 1fr;
    align-items: center
}

.process-section-2 {
    background-color: #fff;
    padding: 80px 5%
}

.m-t-40 {
    margin-top: 40px
}

.m-t-40.p-v-40 {
    margin-top: 0;
    padding-top: 40px;
    padding-bottom: 40px
}

.m-t-40.p-v-40.bg-change {
    background-color: var(--black);
    padding-top: 24px;
    padding-bottom: 48px
}

.text-span-85 {
    color: var(--pabloo-green)
}

.sub-heading-text {
    color: #fff;
    width: 120%;
    margin-bottom: 40px;
    font-family: Open Sans, sans-serif;
    font-size: 5rem;
    font-weight: 800;
    line-height: 5rem
}

.sub-heading-text.contact {
    color: #2b2b33;
    width: 100%;
    margin-bottom: 24px;
    font-family: Satoshi, sans-serif;
    font-size: 3.4rem;
    line-height: 120%
}

.social-media-link-icon {
    opacity: .33;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f23920247b8c64_facebook-logo.png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 60%;
    width: 40px;
    height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;
    transition: opacity .2s cubic-bezier(.455, .03, .515, .955)
}

.social-media-link-icon.facebook {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f23920b47b8c60_facebook-logo%20\\(1\\).png);
    background-size: 20px;
    margin-top: 20px;
    margin-bottom: 20px
}

.social-media-link-icon.facebook:hover {
    opacity: 1
}

.social-media-link-icon.linkedin1 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f2392f727b8c62_linkedin-logo.png);
    background-size: 16px;
    margin-top: 20px;
    margin-bottom: 20px
}

.social-media-link-icon.linkedin1:hover {
    opacity: 1
}

.social-media-link-icon.instagram1 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f239e0a97b8c57_instagram-social-network-logo-of-photo-camera%20\\(1\\).png);
    background-size: 16px;
    margin-top: 20px;
    margin-bottom: 20px
}

.social-media-link-icon.instagram1:hover {
    opacity: 1
}

.sub-header-wrap {
    color: #fff;
    width: 100%;
    font-family: Open Sans, sans-serif;
    font-size: 1.2rem;
    line-height: 1.5rem
}

.header-featured-wrap {
    z-index: 4;
    flex: 0 1 auto;
    width: 50%;
    position: absolute;
    top: 200px
}

.header-featured-wrap.contact {
    width: 100%;
    padding-right: 50px;
    position: relative;
    top: 0
}

.sticky-wrapper {
    height: 392vh;
    position: relative
}

.contact-us-wrapper {
    justify-content: space-between;
    align-items: stretch;
    height: auto;
    padding-bottom: 0;
    position: relative
}

.sec-bk {
    align-items: center;
    height: auto;
    padding-top: 10vh;
    padding-bottom: 4vh;
    display: block
}

.sec-bk.p-b-32.xx {
    height: auto;
    padding-bottom: 80px
}

.social-media-icons {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50vh;
    padding: 16px 8px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0
}

.big-container {
    width: 1190px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 0
}

.sub-header-img {
    flex: none;
    width: 80%;
    height: 77vh;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: 0%
}

.sub-header-img.contact-us {
    background-color: #fff;
    border-radius: 8px;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: auto;
    padding: 24px 30px 40px;
    display: flex;
    position: sticky;
    top: 100px;
    box-shadow: -8px 3px 30px -5px rgba(128, 128, 128, .5)
}

.sub-header-img.contact-us.hide-desktop {
    display: none
}

.paragraph-42 {
    color: rgba(0, 0, 0, .71);
    margin-bottom: 40px;
    font-size: 18px;
    font-weight: 400;
    line-height: 32px
}

.process-heading-3 {
    color: #2a323c;
    text-align: left;
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 14px;
    font-size: 42px;
    line-height: 1.3
}

.process-graphic {
    max-width: 100%
}

.process-step {
    background-color: var(--light-pink);
    color: var(--pabloo-green);
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 60px;
    min-width: 60px;
    height: 60px;
    min-height: 60px;
    margin-right: 24px;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    display: flex
}

.process-content {
    max-width: 460px
}

.process-block-2 {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.process-wrapper {
    display: flex
}

.process-full-wrapper {
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    display: flex;
    position: relative
}

.line-break-2 {
    background-color: #e1e5ea;
    width: 100%;
    max-width: 88%;
    height: 2px;
    margin-top: 40px;
    margin-bottom: 40px
}

.process-title-2 {
    color: #2a323c;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 32px;
    line-height: 42px
}

.process-main-block {
    align-items: flex-start;
    display: flex
}

.process-section-3 {
    padding: 100px 0% 40px
}

.process-paragraph-2 {
    color: #546478;
    margin-bottom: 24px;
    font-size: 16px;
    line-height: 28px
}

.process-title-wrap-3 {
    text-align: center;
    max-width: 680px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto
}

.process-line {
    z-index: -1;
    background-color: #e1e5ea;
    width: 2px;
    height: 100%;
    position: absolute;
    left: 30px
}

.text-span-89 {
    color: var(--pabloo-green)
}

.paragraph-43 {
    margin-top: 20px;
    margin-bottom: 20px
}

.columns-6 {
    padding-bottom: 40px;
    display: flex
}

.column-71 {
    height: auto
}

.slide-tab-current {
    background-color: var(--white);
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 55px;
    min-width: 55px;
    height: 55px;
    min-height: 55px;
    display: flex;
    box-shadow: 3px 3px 8px rgba(95, 48, 226, .16)
}

.step-detail {
    margin-left: auto;
    margin-right: auto
}

.step-count-grace {
    color: var(--black);
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    font-weight: 500
}

.slide-detail {
    border: 1px none var(--light-pink);
    border-radius: 16px;
    justify-content: space-around;
    align-items: center;
    width: auto;
    margin-bottom: 64px;
    padding: 12px;
    display: flex
}

.form-section-2 {
    background-color: var(--white);
    align-items: flex-start;
    max-width: 100%;
    padding: 140px 3%;
    display: block
}

.active-tab {
    border-radius: 100px;
    flex-flow: column wrap;
    align-items: center;
    display: flex
}

.h3 {
    color: #fff
}

.h3.price-label {
    z-index: 30;
    clear: both;
    color: var(--black);
    text-align: center;
    justify-content: center;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0;
    display: block;
    position: relative
}

.bodytext3 {
    clear: both;
    color: var(--black);
    text-align: left;
    margin-bottom: 0;
    font-size: 1.1rem;
    line-height: 1.2rem;
    position: relative
}

.bodytext3.error {
    color: #a93334
}

.actual-radio-button {
    opacity: 1;
    margin-top: 0;
    margin-left: 0;
    display: none;
    position: absolute;
    top: 20px;
    bottom: 0;
    left: -30px
}

.form-wrapper-6 {
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    display: flex
}

.error-message-4,
.form-success {
    background-color: transparent;
    border: 1px solid #fff
}

.radio-field-parent {
    float: none;
    clear: none;
    text-align: center;
    background-color: transparent;
    border: 0 solid rgba(255, 255, 255, .1);
    border-radius: 0;
    flex-flow: wrap;
    flex: 1 1;
    align-content: center;
    align-self: stretch;
    align-items: center;
    width: auto;
    height: 72px;
    margin-right: 16px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    display: inline-block;
    position: relative
}

.radio-field-label {
    z-index: 20;
    clear: both;
    border: 1px solid var(--light-pink);
    background-color: var(--white);
    color: #fff;
    text-align: left;
    letter-spacing: 0;
    text-transform: lowercase;
    cursor: pointer;
    border-radius: 8px;
    align-self: center;
    align-items: center;
    width: 100%;
    height: 72px;
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    font-size: 14px;
    font-weight: 400;
    display: block;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.radio-field-label:hover {
    border-color: var(--pabloo-green);
    background-color: var(--light-pink)
}

.radio-field-label:focus {
    border-color: var(--pabloo-green)
}

.bl-0001-custom-radio-form {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 60px;
    display: flex;
    position: relative;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.div-block-179 {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 32px;
    display: flex
}

.div-block-180 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.heading-82 {
    text-align: center;
    width: 100%
}

.text-span-91 {
    color: var(--pabloo-green)
}

.div-block-181 {
    text-align: center;
    justify-content: center;
    width: 100%;
    margin-top: 24px;
    display: flex
}

.radio-button-field-2 {
    margin-left: 16px
}

.submit-button-2 {
    background-color: var(--pabloo-green);
    border-radius: 8px;
    padding-left: 32px;
    padding-right: 32px
}

.div-block-182 {
    justify-content: center;
    margin-top: 24px;
    display: flex
}

.link-block-8 {
    width: auto;
    height: 25px;
    margin-left: auto;
    margin-right: auto
}

.text-block-82 {
    margin-left: auto;
    margin-right: auto
}

.text-block-82:hover {
    color: var(--pabloo-green)
}

.div-block-183 {
    margin-top: 8px
}

.text-span-95 {
    color: var(--pabloo-green);
    font-family: Satoshi, sans-serif;
    font-size: 20px;
    font-weight: 500
}

.div-block-184 {
    flex-wrap: wrap;
    align-items: flex-start;
    display: block
}

.div-block-185 {
    margin-left: 16px
}

.heading-83,
.heading-84 {
    margin-bottom: 4px;
    font-size: 20px
}

.text-block-83 {
    font-size: 16px;
    font-weight: 500;
    line-height: 22px
}

.text-block-84 {
    font-size: 16px;
    line-height: 22px
}

.div-block-186 {
    flex-wrap: wrap;
    margin: 32px 32px 16px;
    display: flex
}

.div-block-186.m-l-0 {
    align-items: center;
    margin-top: 0;
    margin-bottom: 2%;
    margin-left: 0
}

.image-46 {
    height: 26px;
    margin-bottom: 0
}

.div-block-187 {
    box-shadow: none;
    border-radius: 10px;
    margin-right: 8px;
    padding: 10px 0
}

.div-block-187._1 {
    background-color: var(--white);
    box-shadow: none;
    margin-left: 16px;
    padding: 10px 0%
}

.div-block-188 {
    color: rgba(0, 0, 0, .6);
    width: 100%;
    margin-top: 16px;
    margin-bottom: 0;
    font-size: 16px;
    font-weight: 300
}

.text-block-86 {
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 32px;
    font-weight: 700
}

.heading-85 {
    text-align: center;
    margin-top: 0
}

.div-block-189 {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    display: flex
}

.div-block-190 {
    width: 100%;
    padding-left: 10%;
    padding-right: 10%
}

.text-span-96 {
    color: rgba(0, 0, 0, .6);
    font-size: 14px;
    font-weight: 400
}

.div-block-191 {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    margin-top: 24px;
    display: grid
}

.div-block-191.m-t-0 {
    margin-top: 0
}

.div-block-192 {
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.text-block-87 {
    font-weight: 500
}

.heading-86 {
    color: var(--pabloo-green);
    text-align: center;
    font-size: 32px
}

.div-block-193 {
    background-color: var(--light-pink);
    border-radius: 16px;
    padding-top: 24px;
    padding-bottom: 24px;
    display: none
}

.div-block-194 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin: 80px 3%;
    display: grid
}

.bold-text-8 {
    color: var(--white)
}

.text-span-98 {
    background-color: rgba(235, 184, 47, .52)
}

.shows-archive {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    padding-top: 30px;
    padding-bottom: 30px;
    display: grid
}

.button-11 {
    background-color: var(--pabloo-green);
    cursor: pointer;
    border-radius: 4px;
    margin-top: 9px;
    margin-bottom: 9px;
    padding: 17px 54px;
    font-size: 17px
}

.button-11:hover {
    background-color: var(--pabloo-green-2)
}

.div-block-195 {
    background-color: #fff;
    border-radius: 4px
}

.intro {
    background-color: #f5f6fa;
    border-radius: 50px;
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    padding: 213px 92px;
    overflow: hidden
}

.intro.feature-3 {
    padding-top: 95px;
    padding-bottom: 95px
}

.intro.feature-3.x {
    background-color: var(--white-smoke);
    border-radius: 0;
    max-width: 100%
}

.intro.feature-3.x.hide {
    display: none
}

.show-category {
    border: 2px solid var(--pabloo-green);
    color: var(--pabloo-green);
    text-transform: uppercase;
    background-color: #fff;
    border-radius: 50px;
    padding: 8px 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    display: inline-block
}

.heading-88 {
    color: #939bb4;
    font-size: 34px;
    font-weight: 600
}

.heading-88.mob {
    color: var(--black)
}

.show-item {
    cursor: pointer;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/634d4ab36617c8d4c5462bff_Webinar%20Dan%20Fletcher-03.png), linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5));
    background-position: 0 0, 0 0;
    background-repeat: no-repeat, repeat;
    background-size: cover, auto;
    border-radius: 4px;
    min-height: 320px;
    padding: 16px 30px 27px 16px;
    transition: all .2s ease-in-out;
    display: block
}

.show-item:hover {
    filter: grayscale()
}

.show-item._1 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6333afa89bbd2c2fc7071c31_Webinar%20crownpeak-03.png), linear-gradient(transparent, transparent);
    background-position: 0 0, 0 0;
    background-repeat: no-repeat, repeat;
    background-size: cover, auto;
    border-radius: 4px;
    min-height: 320px
}

.s20 {
    height: 20px
}

.text-span-100 {
    color: var(--pabloo-green)
}

.xx {
    font-size: 18px;
    line-height: 24px
}

.paragraph-44 {
    text-align: center
}

.align-start {
    margin-top: 16px;
    position: relative
}

.div-block-197 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto minmax(80px, 160px) auto;
    grid-auto-columns: 1fr;
    align-items: center;
    display: flex
}

.text-block-89 {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px
}

.div-block-198 {
    background-color: var(--white);
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 0 16px rgba(0, 0, 0, .12)
}

.text-span-102,
.text-span-103 {
    color: var(--pabloo-green)
}

.div-block-199 {
    margin-top: 24px;
    display: flex
}

.image-47 {
    height: 64px
}

.image-47.m-l-8 {
    filter: saturate(151%);
    width: 80px;
    height: 80px;
    margin-left: 8px
}

.image-48 {
    height: 60px;
    margin-left: 8px
}

.image-48.m-l-0 {
    border-radius: 100%;
    height: 80px;
    margin-left: 0
}

.price-tabs {
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: flex
}

.price-card {
    background-color: var(--white);
    border: 1px solid #e6e6e6;
    border-radius: 20px;
    height: 100%;
    padding: 32px;
    position: relative;
    overflow: hidden
}

.badge-primary {
    color: #1a1a1a;
    letter-spacing: .02em;
    text-transform: uppercase;
    background-color: #f7f7f7;
    border: 1px solid #e6e6e6;
    border-radius: 32px;
    margin-bottom: 54px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    display: inline-block
}

.price-card-feature {
    background-color: var(--white);
    border: 2px solid #4255bd;
    border-radius: 20px;
    padding: 32px;
    position: relative;
    overflow: hidden;
    box-shadow: 17px 17px 64px -14px rgba(77, 77, 77, .16)
}

.badge-beta {
    color: gray;
    background-color: #f7f7f7;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    margin-left: 8px;
    padding: 2px 6px;
    font-weight: 600;
    display: flex
}

.price-feature-grid {
    grid-column-gap: 14px;
    grid-row-gap: 4px;
    grid-template-columns: 1fr;
    margin-top: 14px
}

.price-feature {
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px
}

.section-regular-2 {
    padding: 0 0%;
    position: relative
}

.price-text-large {
    color: #4255bd;
    margin-bottom: 14px;
    font-size: 64px;
    font-weight: 500;
    line-height: 72px
}

.button-pricing {
    color: #f7f7f7;
    text-align: center;
    background-color: #4255bd;
    border: 1px solid #6070c8;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    min-height: 48px;
    margin-top: 24px;
    padding: 8px 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: none;
    transition: border-color .4s;
    display: flex
}

.button-pricing:hover {
    border-color: #d3d3d3
}

.price-tab-link {
    color: #1a1a1a;
    text-align: center;
    letter-spacing: -.02em;
    white-space: nowrap;
    background-color: transparent;
    border-radius: 48px;
    justify-content: center;
    align-items: center;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
    display: flex
}

.price-tab-link.w--current {
    background-color: var(--slate-blue);
    color: #f7f7f7;
    box-shadow: 1px 8px 20px rgba(141, 155, 190, .16)
}

.price-content {
    width: 100%;
    overflow: visible
}

.price-text {
    color: #1a1a1a;
    margin-top: 0;
    margin-bottom: 14px;
    font-size: 40px;
    font-weight: 500;
    line-height: 48px
}

.price-feature-line {
    border-bottom: 1.5px solid #e6e6e6;
    align-items: center;
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex
}

.price-tab-menu {
    background-color: #f7f7f7;
    border: 1px solid #e6e6e6;
    border-radius: 44px;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    padding: 8px;
    display: flex
}

.paragraph-small-4 {
    letter-spacing: -.01em;
    font-size: 14px;
    line-height: 24px
}

.paragraph-small-4.text-weight-semibold {
    font-weight: 600
}

.pricing-icon {
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    display: flex
}

.pricing-image {
    z-index: -1;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: auto;
    right: 0%
}

.badge-secondary {
    color: #4255bd;
    letter-spacing: .02em;
    text-transform: uppercase;
    background-color: #f4f5fb;
    border: 1px solid #b3bbe5;
    border-radius: 32px;
    margin-bottom: 54px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    display: inline-block
}

.heading-content-2 {
    color: #1a1a1a;
    letter-spacing: -.04em;
    margin-top: 0;
    margin-bottom: 24px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 64px;
    font-weight: 700;
    line-height: 1.2
}

.price-wrapper {
    margin-top: 14px;
    padding: 14px
}

.button-pricing-outline {
    color: #4255bd;
    text-align: center;
    background-color: transparent;
    border: 1.5px solid #6070c8;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    min-height: 48px;
    margin-top: 24px;
    padding: 8px 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-decoration: none;
    transition: border-color .4s;
    display: flex
}

.button-pricing-outline:hover {
    border-color: #d3d3d3
}

.price-detail {
    letter-spacing: -.02em;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 32px
}

.price-type-2 {
    color: gray;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px
}

.pricing-text {
    color: #aaa;
    font-size: 14px;
    line-height: 24px
}

.price-custom-icon-wrapper {
    justify-content: flex-start;
    align-items: flex-end;
    margin-bottom: 14px;
    display: flex
}

.image-49 {
    object-fit: fill
}

.collection-list-wrapper {
    position: relative
}

.slider-4 {
    background-color: var(--white);
    border-radius: 32px;
    height: 100%;
    min-height: 530px;
    box-shadow: 0 0 24px rgba(0, 0, 0, .12)
}

.slide-4 {
    border-radius: 32px;
    height: auto;
    min-height: auto
}

.image-50 {
    height: 32px;
    display: inline-block
}

.left-arrow-3 {
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    left: -48px
}

.right-arrow-3 {
    justify-content: flex-end;
    align-items: center;
    display: flex;
    right: -48px
}

.image-51 {
    height: 32px
}

.mask-3 {
    border-radius: 32px;
    max-height: 620px
}

.slide-nav-4 {
    bottom: -56px
}

.text-span-104,
.text-span-105 {
    color: var(--pabloo-green)
}

.banner-2 {
    background-color: var(--pabloo-green);
    color: #fff;
    text-align: center;
    justify-content: center;
    align-items: center;
    min-height: 56px;
    padding: 16px 5%;
    display: flex
}

.banner-2.hide {
    display: none
}

.banner-wrap {
    justify-content: center;
    align-items: center;
    display: flex
}

.link-6 {
    color: var(--white)
}

.text-span-112 {
    color: var(--pabloo-green)
}

.text-span-113,
.text-span-114 {
    color: #000
}

.div-block-204 {
    background-color: var(--white-smoke);
    border-radius: 12px;
    padding: 12px
}

.text-span-116 {
    color: #000
}

.empty-state-2 {
    background-color: var(--white-smoke);
    border-radius: 24px;
    padding-top: 24px;
    padding-bottom: 24px
}

.text-block-92 {
    text-align: center;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 500
}

.text-block-92.xx {
    color: rgba(0, 0, 0, .5);
    margin-top: 8px;
    font-size: 16px
}

.text-span-117 {
    color: var(--pabloo-green)
}

.text-span-118 {
    color: #000
}

.link-7 {
    /* text-decoration: none */
}

.link-block-9 {
    background-color: var(--pabloo-green);
    text-align: center;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex
}

.text-block-94,
.text-block-95 {
    font-size: 17px
}

.text-block-96,
.text-block-97 {
    font-size: 16px
}

.text-block-98 {
    color: var(--white)
}

.html-embed-13 {
    margin-left: 0
}

.text-block-99,
.text-block-100 {
    font-size: 15px
}

.text-block-101,
.text-block-102 {
    font-size: 14px
}

.text-block-108 {
    font-size: 15px;
    font-weight: 500
}

._2 {
    background-color: var(--white-smoke);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f130c006a25f4b76fe8f8c_Frame%20\\(2\\).svg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: 160px 160px;
    margin-top: 0;
    padding: 24px 5%
}

._1 {
    background-color: var(--white-smoke);
    padding: 48px 5%
}

.f-container-regular {
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

._4 {
    background-color: var(--white-smoke);
    margin-top: 24px;
    padding: 24px 5%
}

._5 {
    background-color: var(--white);
    margin-top: 24px;
    padding: 24px 5%
}

._6 {
    margin-top: 24px;
    padding: 24px 5%
}

.html-embed-15 {
    color: #eeb6d1;
    margin-right: 16px
}

.html-embed-16 {
    margin-right: 16px
}

.heading-95 {
    font-size: 24px;
    line-height: 30px
}

.f-paragraph-large-2 {
    letter-spacing: -.02em;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 32px
}

.text-span-128 {
    color: var(--pabloo-green)
}

.container-18 {
    width: 100%;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto
}

.side-pattern-right {
    z-index: -1;
    position: absolute;
    top: 10%;
    bottom: auto;
    left: auto;
    right: 0%
}

.side-pattern {
    z-index: -1;
    position: absolute;
    top: 5%;
    bottom: auto;
    left: -5%;
    right: auto
}

.title-paragraph {
    letter-spacing: -.03em;
    max-width: 590px;
    margin-bottom: 32px;
    font-weight: 400
}

.title-wrap-4 {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 60px;
    display: flex
}

.title-wrap-4.hide {
    display: none
}

.content-h2 {
    color: var(--black-2);
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 22px;
    font-size: 54px;
    line-height: 1.1
}

.content-section {
    padding: 24px 3% 96px;
    position: relative
}

.slide-5 {
    background-color: #fff;
    border: 1px rgba(70, 137, 215, .2);
    border-radius: 15px;
    margin-right: 50px;
    padding: 0;
    overflow: hidden
}

.faq-question-wrap {
    cursor: pointer;
    border: 1px solid rgba(159, 6, 255, .2);
    border-radius: 21px;
    margin-top: 10px;
    margin-bottom: 26px;
    padding: 28px 40px
}

.jobs-board-form {
    background-color: #fff;
    border: 1px solid #e4e6f1;
    border-radius: 50px;
    align-items: center;
    margin-top: 24px;
    padding: 4px;
    display: flex
}

.f-margin-bottom-40 {
    margin-bottom: 40px
}

.f-button-neutral {
    background-color: var(--pabloo-green);
    color: #fff;
    text-align: center;
    letter-spacing: -.02em;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    min-width: auto;
    min-height: 48px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    transition: background-color .3s;
    display: flex
}

.f-button-neutral:hover {
    background-color: var(--pabloo-green-2)
}

.f-h1-heading {
    color: #160042;
    letter-spacing: -.04em;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 64px;
    line-height: 1.2
}

.f-header-input-field {
    background-color: var(--white-smoke);
    color: #160042;
    border: 1px #000;
    min-height: 48px;
    margin-bottom: 0;
    margin-right: 16px;
    padding: 12px 16px;
    font-size: 18px
}

.f-header-input-field::placeholder {
    color: #b6b9ce
}

.f-header-input-field.border-radius-left-only {
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px
}

.f-header-input-field.border-radius-right-only {
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px
}

.f-header-form-row {
    grid-column-gap: 24px;
    grid-row-gap: 12px;
    align-items: center;
    margin-bottom: 0;
    display: flex
}

.f-header-form-row.lp {
    margin-bottom: 4px
}

.link-block-11 {
    color: var(--pabloo-green);
    margin-left: 20px;
    font-weight: 700
}

.text-block-133 {
    font-size: 16px;
    /* text-decoration: none */
}

.text-span-130 {
    color: var(--pabloo-green)
}

.f-margin-bottom-24 {
    margin-bottom: 8px
}

.f-header-title-wrapper-center {
    z-index: 5;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 650px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: relative
}

.f-section-large-3 {
    padding: 92px 5% 24px;
    position: relative
}

.feature-details {
    color: #737373;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px
}

.feature-card-04 {
    flex-direction: row;
    align-items: center;
    padding: 32px;
    display: block
}

.feature-card-5 {
    border-right: 1px dashed #e5e5e5;
    flex-direction: row;
    align-items: center;
    padding: 32px;
    display: block
}

.grid-feature-wrapper {
    grid-column-gap: 72px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 2fr;
    align-items: center
}

.feature-card-6 {
    border-bottom: 1px dashed #e5e5e5;
    flex-direction: row;
    align-items: center;
    padding: 32px;
    display: block
}

.grid-features {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr
}

.feature-card-01 {
    border-bottom: 1px dashed #e5e5e5;
    border-right: 1px dashed #e5e5e5;
    flex-direction: row;
    align-items: center;
    padding: 32px;
    display: block
}

.section-feature {
    padding: 140px 5%
}

.button-feature {
    background-color: #1a1e21;
    border-radius: 4px;
    margin-top: 32px;
    padding: 16px 32px
}

.heading-large {
    color: #262626;
    letter-spacing: -.04em;
    margin-bottom: 24px;
    font-size: 50px;
    font-weight: 600;
    line-height: 60px
}

.title-large {
    color: #8e8e8e;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-bottom: 16px;
    font-size: 16px
}

.container-features {
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto
}

.link-20 {
    color: var(--slate-blue);
    font-weight: 500
}

.color-span {
    color: var(--pabloo-green)
}

.color-span.italic {
    font-style: italic
}

.faq-paragraph-2 {
    color: var(--white-smoke);
    letter-spacing: -.01em;
    font-size: 16px;
    line-height: 32px
}

.faq-grid-3 {
    grid-column-gap: 72px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr
}

.faq-heading-3 {
    color: var(--white);
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 48px;
    line-height: 56px
}

.faq-section-3 {
    background-color: var(--slate-blue);
    padding: 80px 3%
}

.faq-container-3 {
    max-width: 1060px;
    margin-left: auto;
    margin-right: auto
}

.faq-subheading {
    color: var(--white);
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 20px;
    font-size: 12px;
    font-weight: 700;
    line-height: 32px
}

.faq-title-3 {
    color: var(--white);
    letter-spacing: -.01em;
    margin-top: 0;
    line-height: 28px
}

.grey-divider {
    background-color: #e5e7eb;
    height: 1px;
    margin-bottom: 40px
}

.faq-wrapper-4 {
    margin-bottom: 50px
}

.text-block-138 {
    margin-bottom: 24px;
    font-size: 18px
}

.content-grid-2 {
    grid-column-gap: 82px;
    grid-row-gap: 82px;
    grid-template-rows: auto;
    grid-template-columns: 1.2fr 1fr;
    align-items: center
}

.a-container-regular {
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.a-margin-bottom-08 {
    margin-bottom: 8px
}

.a-detail-small {
    letter-spacing: .08em;
    text-transform: uppercase;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.8
}

.a-detail-small.custo {
    font-size: 18px
}

.a-title-wrap-center {
    text-align: center;
    flex-direction: column;
    align-items: center;
    max-width: 510px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.slide-wrap-2 {
    align-items: center;
    width: 5000px;
    margin-left: -20px;
    margin-right: -20px;
    padding: 40px 24px;
    display: flex
}

.slide-wrap-2.logos-animation {
    display: none
}

.slide-wrap-2.logos-animation.us-logos {
    display: flex
}

.milestone-circle {
    border: 2px solid var(--pabloo-green);
    background-color: #f5f9ff;
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    padding: 4px;
    display: flex;
    position: absolute;
    top: auto;
    bottom: auto
}

.link-block-12 {
    position: absolute
}

.link-block-13,
.link-block-14 {
    object-fit: fill
}

.link-block-15 {
    object-fit: cover
}

.link-block-16,
.link-block-17 {
    object-fit: none
}

.link-block-18,
.link-block-19,
.link-block-20 {
    object-fit: fill
}

.link-block-21 {
    position: absolute
}

.link-block-22 {
    position: absolute;
    top: 16px;
    bottom: auto;
    left: auto;
    right: 16px
}

.text-block-139 {
    color: var(--pabloo-green);
    text-align: center;
    font-weight: 700
}

.text-span-131 {
    color: var(--slate-blue);
    font-family: "P22mackinacpro 11", sans-serif
}

.text-span-132 {
    color: var(--pabloo-green)
}

.image-61 {
    z-index: 10;
    position: absolute;
    top: 1%;
    bottom: auto;
    left: auto;
    right: -36%
}

.text-span-133 {
    color: var(--slate-blue);
    font-family: "P22mackinacpro 11", sans-serif
}

.text-block-140 {
    text-align: center
}

.div-block-241 {
    padding-top: 4px;
    padding-bottom: 4px
}

.feature-section-4 {
    padding: 80px 3%
}

.feature-block-3 {
    align-items: flex-start;
    display: flex
}

.feature-block-header {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    min-height: 300px;
    padding-left: 72px;
    display: flex;
    position: relative
}

.feature-wrapper {
    align-items: flex-start;
    display: flex
}

.title-wrapper-3 {
    color: #000;
    letter-spacing: 2px;
    align-items: center;
    margin-bottom: 20px;
    display: flex
}

.feature-title-content {
    width: 100%
}

.title-line {
    background-color: #000;
    width: 30px;
    height: 1px;
    margin-right: 24px
}

.feature-title-2 {
    color: #2a2a2a;
    letter-spacing: -.03em;
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 36px;
    font-weight: 600;
    line-height: 44px
}

.feature-number {
    color: #b5b5b5;
    margin-top: 6px;
    margin-right: 30px;
    font-size: 24px;
    line-height: 32px
}

.feature-header-2 {
    color: #2a2a2a;
    margin-top: 0;
    margin-bottom: 16px;
    font-size: 40px;
    line-height: 48px
}

.feature-grid-4 {
    grid-column-gap: 72px;
    grid-row-gap: 72px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-bottom: 24px;
    display: grid
}

.feature-details-2 {
    color: #2a2a2a;
    font-size: 18px;
    line-height: 32px
}

.feature-container {
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto
}

.feature-pink-block {
    z-index: -1;
    background-color: #ffdfe4;
    background-image: none;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 30px;
    width: 300px;
    height: 300px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto
}

.a-testimonial-slider-content {
    grid-row-gap: 24px;
    flex-direction: column;
    justify-content: space-between;
    display: flex;
    position: relative
}

.a-testimonial-slider-grid {
    grid-column-gap: 64px;
    grid-row-gap: 48px;
    grid-template-rows: auto;
    grid-template-columns: .25fr 1fr
}

.a-testimonial-quote {
    z-index: 10;
    color: rgba(0, 0, 0, .64);
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    position: relative
}

.a-section-regular-2 {
    padding: 92px 5%;
    position: relative
}

.a-testimonial-image {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.html-embed-18 {
    border-radius: 0;
    width: 100%
}

.link-28,
.link-29 {
    color: var(--slate-blue)
}

.collection-list-wrapper-2 {
    width: 100%
}

.collection-list-3 {
    display: flex
}

.collection-item {
    margin-left: 0;
    margin-right: 20px
}

.paragraph-50 {
    margin-bottom: 40px
}

.content-section-5 {
    background-color: var(--white);
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    padding: 80px 3%
}

.content-heading {
    z-index: 1;
    color: var(--black);
    margin-top: 0;
    margin-bottom: 30px;
    font-size: 40px;
    font-weight: 600;
    line-height: 65px;
    position: relative
}

.content-grid-3 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    grid-template-rows: auto;
    grid-template-columns: 2fr;
    align-items: center;
    justify-items: start
}

.content-wrapper {
    flex-direction: column;
    align-items: flex-start;
    max-width: 700px;
    display: flex
}

.content-container {
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto
}

.div-block-244 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    margin-bottom: 16px;
    display: grid
}

.image-62 {
    width: 32px;
    height: 32px
}

.div-block-245 {
    position: relative
}

.image-63 {
    z-index: 0;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: auto
}

.text-block-141 {
    color: var(--pabloo-green);
    margin-bottom: 8px;
    font-weight: 500
}

.section-large-3 {
    padding: 120px 5%;
    position: relative
}

.text-span-142 {
    color: var(--pabloo-green)
}

.header-grid-5 {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    background-image: none;
    background-repeat: repeat;
    background-size: auto;
    grid-template-rows: auto;
    grid-template-columns: 1fr .75fr;
    align-items: start
}

.image-wrapper-3 {
    z-index: 1;
    backdrop-filter: blur(16px);
    background-color: rgba(255, 255, 255, .24);
    border-left: 12px solid #5050ff;
    border-radius: 8px;
    margin-left: 32px;
    margin-right: 32px;
    padding: 32px;
    position: relative;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .12)
}

.image-wrapper-3.darl-mode {
    backdrop-filter: none;
    background-color: #fff
}

.image-wrapper-3.darl-mode.custo {
    margin-left: 24px;
    padding: 28px 24px 28px 28px
}

.features-button-2 {
    color: #fff;
    text-align: center;
    background-color: #d53987;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    height: 60px;
    margin-top: 0;
    padding: 16px 32px;
    font-size: 18px;
    font-weight: 500;
    text-decoration: none;
    transition: background-position .3s;
    display: flex
}

.features-button-2:hover {
    background-position: 90%
}

.ebook-points-heading-2 {
    color: #000;
    margin-top: 16px;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px
}

.ebook-points-heading-2.points-heading {
    color: #000;
    font-size: 16px;
    font-weight: 500
}

.ebook-points-heading-2.points-heading.custo {
    font-size: 18px
}

.badge-standard-2 {
    color: #fff;
    background-color: #d53987;
    border-radius: 50px;
    justify-content: space-between;
    align-items: center;
    padding: 8px 20px;
    font-size: 12px;
    line-height: 16px;
    display: flex
}

.hero-heading-4 {
    color: #000;
    letter-spacing: -.03em;
    margin-top: 0;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 58px;
    line-height: 72px
}

.title-4 {
    color: #d53987;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px
}

.text-span-143 {
    color: #d53987
}

.header-section-6 {
    background-color: #fff;
    align-items: center;
    min-height: 91vh;
    padding: 80px 3% 64px;
    display: flex;
    position: relative
}

.header-wrapper-5 {
    z-index: 2;
    background-color: #fff;
    padding-top: 120px;
    position: relative
}

.paragraph-small-5 {
    color: #000;
    letter-spacing: -.01em;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px
}

.section-large-4 {
    background-color: #000;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6244f42f88a11de61a8be252_Group%20223.svg);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    padding: 80px 5%;
    position: relative
}

.section-large-4.nobg {
    background-color: #fff;
    background-image: none
}

.section-regular-4 {
    background-color: #fff;
    padding: 80px 5%;
    position: relative
}

.section-regular-4.nobg {
    background-color: #fff
}

.main-wrapper-2 {
    backdrop-filter: blur(20px);
    background-color: rgba(255, 255, 255, .59);
    height: auto;
    margin-top: 0;
    position: relative
}

.heading-101 {
    text-align: center;
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 24px;
    font-weight: 500
}

.mt-16 {
    margin-top: 16px
}

.text-block-154 {
    color: var(--white);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px
}

.div-block-256 {
    background-color: var(--slate-blue);
    border-radius: 20px;
    margin-right: 8px;
    padding: 4px 12px
}

.paragraph-57 {
    color: var(--white);
    margin-bottom: 16px;
    font-size: 25px
}

.text-span-149,
.text-span-150 {
    color: var(--slate-blue)
}

.div-block-258 {
    background-color: var(--white-smoke);
    padding: 8px
}

.text-block-155 {
    text-align: center
}

.div-block-259 {
    background-color: var(--white-smoke);
    padding: 12px 10px
}

.member-position {
    color: rgba(0, 0, 0, .72);
    text-align: center;
    font-size: 17px;
    font-weight: 500
}

.rich-text-block-20 {
    color: var(--black);
    font-size: 20px;
    line-height: 32px
}

.div-block-260 {
    display: flex
}

.heading-104 {
    color: var(--slate-blue);
    margin-left: 8px;
    font-family: Satoshi, sans-serif;
    font-size: 1.8rem;
    line-height: 1.2em
}

.collection-list-4 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto auto 1fr;
    grid-auto-columns: 1fr;
    margin-bottom: 18px;
    display: grid
}

.image-67 {
    object-fit: contain;
    height: 48px;
    line-height: 28px
}

.div-block-261 {
    background-color: var(--white-smoke);
    padding: 4px
}

.text-block-156 {
    text-align: center
}

.div-block-263 {
    border: 2px #ccc;
    border-radius: 120px;
    flex-wrap: wrap;
    padding: 6px 0;
    display: flex
}

.text-block-158 {
    color: var(--black);
    margin-left: 4px;
    font-size: 16px;
    font-weight: 500
}

.stap-button {
    float: right;
    background-color: #f3f3f2;
    border-radius: 100px;
    margin-bottom: 30px;
    padding: 10px 30px
}

.tex {
    color: #d53987;
    letter-spacing: -.5px;
    font-family: "P22mackinacpro 18", sans-serif;
    font-size: 32px;
    font-weight: 700;
    line-height: 36px
}

.grid {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr
}

.step-grid {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    grid-template-rows: auto;
    grid-template-columns: 110px 1fr 1fr 110px;
    grid-auto-columns: 1fr;
    margin-top: 30px;
    display: grid
}

.home-section {
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 0
}

.main-heding {
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex
}

.slider-section {
    text-align: center;
    padding-top: 120px;
    padding-bottom: 40px;
    display: flex
}

.slider-title {
    margin-left: auto;
    margin-right: auto
}

.badge-wrapper-2 {
    justify-content: flex-start;
    display: flex
}

.badge-wrapper-2.ml-4 {
    margin-left: 4px
}

.badge-standard-3 {
    background-color: var(--pabloo-green);
    color: #fff;
    border-radius: 50px;
    justify-content: space-between;
    align-items: center;
    padding: 4px 12px;
    font-size: 12px;
    line-height: 16px;
    display: flex
}

.div-block-264 {
    align-items: center;
    display: flex
}

.empty-state-3 {
    background-color: var(--white);
    padding-left: 50px;
    padding-right: 50px
}

.text-block-159 {
    color: var(--black);
    margin-left: 4px;
    margin-right: 0
}

.empty-state-4,
.empty-state-5,
.empty-state-6 {
    background-color: transparent
}

.rich-text-block-22 {
    color: var(--pabloo-green);
    margin-left: -22px;
    font-size: 16px
}

.image-68 {
    object-fit: fill;
    border-radius: 8px;
    width: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    display: inline-block
}

.lp-para {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5
}

.lp-text-style {
    opacity: 1;
    letter-spacing: .2px;
    margin-bottom: 16px;
    font-weight: 500;
    line-height: 1.66667
}

.lp-logo-section {
    background-color: var(--white-smoke);
    padding-top: 120px;
    padding-bottom: 120px
}

.lp-logo-section.new {
    padding-top: 0
}

.lp-logo-section.adjust {
    padding-top: 20px
}

.lp-logo-section.adjust.pb-sm {
    padding-bottom: 40px
}

.logo-head {
    text-align: center;
    font-size: 24px;
    font-weight: 700
}

.logo-span {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 17", sans-serif
}

.logo-wrapper {
    grid-column-gap: 48px;
    grid-row-gap: 32px;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    margin-top: 48px;
    display: flex
}

.logo-item {
    filter: grayscale();
    max-height: 35px
}

.logo-video {
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 120px;
    display: grid
}

.lp-win-section {
    background-color: #000;
    padding-top: 120px;
    padding-bottom: 120px
}

.win-heading {
    color: #fff;
    text-align: center;
    letter-spacing: -.5px;
    margin-bottom: 64px
}

.win-content {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: space-between;
    align-items: center;
    justify-items: stretch;
    margin-top: 120px;
    display: flex
}

.win-item-text-wrapper {
    grid-column-gap: 16px;
    color: #fff;
    letter-spacing: .2px;
    justify-content: space-between;
    font-size: 20px;
    line-height: 1.5;
    display: flex
}

.win-item-text-wrapper.grey {
    color: #a9a7b2
}

.win-bar {
    background-color: var(--pabloo-green);
    height: 16px;
    margin-top: 12px;
    position: relative
}

.win-bar.grey {
    background-color: #aaa7b3
}

.win-bar-marker {
    background-color: #fff;
    width: 19px;
    height: 16px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%
}

.win-bar-marker._92 {
    width: 25px
}

.win-bar-marker._95 {
    width: 14.55px
}

.win-bar-marker._90 {
    width: 29px
}

.win-bar-marker._93 {
    width: 21px
}

.win-subheading {
    color: #fff;
    letter-spacing: .2px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 34px;
    line-height: 1.23529
}

.win-item-wrapper {
    grid-row-gap: 48px;
    flex-direction: column;
    flex: 1 1;
    max-width: 290px;
    display: flex
}

.lp-slider {
    background-color: rgba(221, 221, 221, 0);
    height: auto;
    margin-top: 120px
}

.lp-slider-item {
    border-radius: 10px;
    padding-bottom: 60px
}

.max-height-30px {
    max-height: 30px
}

.lp-slider-wrapper {
    grid-row-gap: 50px;
    background-color: #fff;
    border-radius: 10px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 40px;
    display: flex
}

.font-size-24px {
    font-size: 24px;
    line-height: 1.4
}

.font-size-16px {
    font-size: 16px;
    line-height: 1.5
}

.font-size-16px.font-weight-bold {
    font-weight: 700
}

.lp-slider-flex {
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.vender-alternate-head {
    grid-column-gap: 20px;
    color: var(--pabloo-green);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    justify-content: center;
    align-self: stretch;
    align-items: center;
    margin-bottom: 20px;
    font-weight: 700;
    line-height: 20px;
    display: flex
}

.lp-header-line {
    background-color: var(--pabloo-green);
    width: 40px;
    height: 2px
}

.lp-h2-wrapper {
    grid-row-gap: 20px;
    text-align: center;
    flex-direction: column;
    align-items: center;
    max-width: 1056px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.max-wdith-620px {
    max-width: 620px
}

.lp-image-wrapper {
    width: 54%
}

.lp-image-wrapper._50 {
    width: 50%
}

.lp-highlighter {
    border: 4px solid #fff;
    border-radius: 8px;
    width: 100%;
    margin-top: 40px;
    padding: 4px 4%
}

.button-17 {
    background-color: var(--pabloo-green);
    border-radius: 8px
}

.div-block-265 {
    z-index: 10;
    background-color: rgba(0, 0, 0, .77);
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: none;
    position: fixed;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: auto
}

.div-block-266 {
    background-color: var(--white);
    border-radius: 16px;
    width: 32%;
    padding: 16px 24px
}

.heading-105 {
    text-align: center
}

.heading-106 {
    color: #fff;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 14px;
    line-height: 24px;
    display: block
}

.icon-regular-4 {
    color: #d53987;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 20px;
    transition: color .2s;
    display: flex
}

.div-block-268 {
    grid-column-gap: 16px;
    grid-row-gap: 4px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.tab-button-content {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    border-bottom: 1px #ececec;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    padding: 8px 12px
}

.b-navigation-card-image {
    object-fit: contain;
    width: 100%;
    height: 100%
}

.div-block-269 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-self: center;
    align-items: center;
    display: grid
}

.sub-nav-link-text {
    font-size: 15px;
    font-weight: 700;
    line-height: 24px
}

.b-navigation-title-block {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    color: #454f5f;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    display: flex
}

.b-navigation-title-block.grid-2-cols {
    grid-column-gap: 64px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.b-navigation-link-icon {
    grid-column-gap: 44px;
    color: var(--black);
    border-radius: 16px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 16px;
    text-decoration: none;
    transition: all .3s;
    display: flex
}

.b-navigation-link-icon:hover {
    color: rgb(21 128 61);
    background-color: #f3f4f6
}

.b-navigation-link-title {
    letter-spacing: -.01em;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px
}

.navigation-dropdown {
    height: 100%;
    position: static
}

.navigation-link-block {
    padding: 0 0 8px 48px
}

.navigation-list {
    z-index: 99;
    min-width: 100%
}

.navigation-list.w--open {
    background-color: #fff;
    min-width: auto;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    top: 90px;
    bottom: auto;
    left: 0;
    right: 0
}

.image-69 {
    object-fit: cover;
    border-radius: 16px;
    width: 100%;
    height: 100%
}

.heading-108 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 24px
}

.b-navigation-large-grid {
    grid-column-gap: 44px;
    grid-template-rows: auto;
    margin-bottom: 16px
}

.tab-button {
    color: #000;
    background-color: rgba(255, 255, 255, 0);
    border: 1px solid #fff;
    border-radius: 4px;
    margin-bottom: 8px;
    padding: 0;
    transition: all .3s
}

.tab-button:hover {
    background-color: #fff
}

.tab-button.w--current {
    color: #5050ff;
    background-color: rgba(80, 80, 255, .04);
    border: 1px solid #fff;
    font-weight: 400
}

.paragraph-60 {
    color: #fff;
    font-size: 14px;
    line-height: 22px;
    display: block
}

.navigation-cta-image {
    background-color: transparent;
    border-radius: 12px;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 200px;
    display: flex
}

.navigation-link-3 {
    color: #000;
    letter-spacing: -.01em;
    white-space: nowrap;
    background-color: transparent;
    border-radius: 50px;
    padding: 12px 24px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    transition: all .35s
}

.navigation-link-3:hover {
    color: var(--pabloo-green);
    background-color: #fff
}

.navigation-link-3.w--current {
    color: var(--pabloo-green)
}

.navigation-cta {
    grid-row-gap: 16px;
    background-color: #f7f9fd;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 16px 24px;
    display: flex
}

.b-navigation-link-detail {
    color: #454f5f;
    letter-spacing: -.01em;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px
}

.navigation-arrow-link {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    color: #6b7094;
    letter-spacing: -.02em;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    display: flex
}

.navigation-arrow-link:hover {
    color: #d53987
}

.navigation-grid-2 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto;
    grid-template-columns: 2fr 1fr;
    height: 390px
}

.b-navigation-card-block {
    border-radius: 16px;
    height: 240px;
    position: relative;
    overflow: hidden
}

.div-block-274 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-items: start;
    display: grid
}

.paragraph-58 {
    color: rgba(0, 0, 0, .6);
    font-size: 14px;
    line-height: 20px
}

.navigation-dropdown-base {
    background-color: #fff;
    border: 4px solid #fff;
    border-radius: 0 0 24px 24px;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    box-shadow: 5px 48px 140px -48px rgba(57, 59, 106, .08)
}

.b-navigation-base {
    flex: 1 1;
    padding: 16px
}

.chevron {
    filter: none;
    transform: rotate(-90deg)
}

.tab-button-title {
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 28px;
    display: flex
}

.tab-button-desc {
    font-size: 14px;
    line-height: 24px;
    display: none
}

.b-navigation-column {
    grid-row-gap: 9px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.b-navigation-small-grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto
}

.tab-mobile-img {
    display: none
}

.paragraph-61 {
    margin-top: 8px;
    font-size: 16px;
    line-height: 22px
}

.footer-3 {
    background-color: #000;
    padding-bottom: 28px
}

.nav-big-link {
    color: #000;
    font-size: 16px;
    font-weight: 500
}

.tabs-menu-3 {
    flex-direction: column;
    width: 40%;
    margin-right: 4%;
    padding-top: 24px;
    display: flex
}

.text-block-162 {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px
}

.navigation-toggle-3 {
    color: #160042;
    letter-spacing: -.01em;
    border-radius: 50px 50px 24px 24px;
    align-items: center;
    height: 100%;
    padding: 12px 30px 12px 24px;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    transition: all .35s
}

.navigation-toggle-3:hover {
    background-color: #fff
}

.div-block-275 {
    background-color: #5050ff;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642ad3ae8334521c3a7e0351_Security%20Hub.svg);
    background-position: 115%;
    background-repeat: no-repeat;
    background-size: 110px;
    border-radius: 8px;
    padding: 8px 16px
}

.div-block-275.inegrations---finance-bg {
    background-color: #5050ff;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642ad3ae83345266077e0370_Integrations-Finance-2.svg);
    padding-top: 8px;
    padding-bottom: 8px
}

.div-block-275.management-hub-bg {
    background-color: #5050ff;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642ad3ae8334521a587e0352_Management%20Hub%20-%205.svg);
    padding-top: 8px;
    padding-bottom: 8px
}

.tabs-content-2 {
    background-color: #fff;
    align-self: stretch;
    width: 56%;
    padding: 16px
}

.tab-component {
    align-items: stretch;
    height: 100%;
    display: flex
}

.footer-links-2 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 100%;
    text-decoration: none;
    transition: color .2s;
    display: block
}

.footer-links-2:hover {
    color: #d53987
}

.b-navigation-icon-wrapper {
    grid-column-gap: 16px;
    align-items: center;
    display: flex
}

.navigation-heading-detail-2 {
    color: #b6b9ce;
    letter-spacing: .08em;
    text-transform: uppercase;
    margin-bottom: 8px;
    margin-left: 12px;
    font-size: 14px;
    font-weight: 700;
    line-height: 24px
}

.navigation-heading-detail-2.margin-left-0 {
    margin-bottom: 0;
    margin-left: 0
}

.text-block-160 {
    color: #d53987;
    font-size: 14px;
    line-height: 20px
}

.div-block-279 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-items: start;
    display: grid
}

.sub-nav-link {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    padding: 4px 16px
}

.sub-nav-link:hover {
    background-color: rgba(80, 80, 255, .05);
    border-radius: 8px
}

.button-20 {
    background-color: var(--black);
    border-radius: 8px;
    margin-top: 24px;
    padding: 12px 16px
}

.button-20.mt-0 {
    margin-top: 0
}

.mask-5 {
    padding-top: 0;
    padding-bottom: 0;
    overflow: hidden
}

.black {
    color: var(--black)
}

.div-block-320 {
    justify-content: flex-start;
    align-items: center;
    width: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.div-block-320.center {
    justify-content: center;
    align-items: center
}

.div-block-320.social {
    justify-content: flex-start;
    align-items: center;
    width: 80%;
    margin-left: 0;
    margin-right: 0
}

.div-block-320.new {
    margin-top: 60px
}

.image-76 {
    height: 140px
}

.image-76.resize {
    height: 123px
}

.ml-16 {
    align-items: center;
    margin-left: 16px;
    display: flex
}

.div-block-321 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr auto;
    grid-auto-columns: 1fr;
    margin-left: 2%;
    display: grid
}

.image-77 {
    height: 32px;
    font-size: 18px
}

.div-block-322 {
    align-items: center;
    display: flex
}

.image-78 {
    height: 24px
}

.div-block-323 {
    align-items: center;
    display: flex
}

.div-block-331 {
    margin-top: 16px
}

.close-wrapper {
    cursor: pointer;
    background-color: #fff;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    font-weight: 700;
    display: flex;
    position: absolute;
    top: 2rem;
    bottom: auto;
    left: auto;
    right: 2rem
}

.text-block-183 {
    text-transform: capitalize;
    cursor: pointer
}

.large-link-3 {
    transform-origin: 100%;
    color: #fff;
    white-space: nowrap;
    background-color: #000;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-left: 16px;
    padding: 22px 40px;
    text-decoration: none;
    transition: background-color .34s;
    display: flex;
    overflow: hidden
}

.large-link-3:hover {
    background-color: #d53987
}

.nav-link-register-2 {
    margin-left: 0;
    margin-right: 0;
    padding-left: 16px;
    padding-right: 16px;
    font-weight: 500;
    transition: all .4s
}

.nav-link-register-2:hover {
    color: #d53987
}

.nav-link-register-2.hide {
    display: block
}

.text-block-184 {
    color: #d53987;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px
}

.text-block-185 {
    color: #d53987;
    font-size: 16px;
    text-decoration: none
}

.persona-dropdown-wrap-2 {
    background-color: #fff;
    border-radius: 10px;
    width: 400px;
    padding: 20px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, .16)
}

.persona-dropdown-wrap-2.product-drop-down {
    width: 720px;
    position: static
}

.persona-dropdown-wrap-2.resources {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 800px;
    display: block
}

.persona-dropdown-wrap-2.product {
    width: 792px
}

.dropdown-toggle-3 {
    align-items: center;
    padding-left: 12px;
    padding-right: 12px;
    font-family: Satoshi, sans-serif;
    font-weight: 500;
    display: flex
}

.dropdown-toggle-3.w--open:hover {
    color: #d53987
}

.dropdown-toggle-3.product {
    display: none;
    overflow: visible
}

.nav-link-5 {
    margin-left: 0;
    margin-right: 0;
    padding-left: 12px;
    padding-right: 12px;
    font-weight: 500;
    transition: all .4s;
    display: none
}

.nav-link-5:hover,
.nav-link-5.w--current {
    color: #d53987
}

.nav-link-5.show {
    display: block
}

.div-block-332 {
    justify-content: center;
    width: 100%;
    display: flex
}

.heading-122 {
    text-align: center
}

.div-block-333 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    margin-top: 120px;
    margin-left: 4%;
    margin-right: 4%;
    display: grid
}

.div-block-334 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    border-top: 1px dashed rgba(213, 57, 135, .5);
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-items: center;
    padding-left: 16px;
    padding-right: 16px;
    display: grid;
    position: relative
}

.div-block-334.border-gradient {
    outline-offset: 0px;
    border-top: 1px dashed rgba(213, 57, 135, .5);
    outline: 3px #000
}

.paragraph-70 {
    text-align: center;
    font-size: 16px;
    line-height: 22px
}

.heading-123 {
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 28px
}

.image-82 {
    z-index: 1;
    height: 64px;
    margin-top: -32px;
    position: relative
}

.image-83,
.image-84 {
    height: 64px;
    margin-top: -32px
}

.image-85 {
    z-index: 1;
    height: 64px;
    margin-top: -32px;
    position: relative
}

.text-span-165 {
    color: var(--pabloo-green)
}

.div-block-335 {
    background-color: var(--white);
    width: 50%;
    height: 2px;
    position: absolute;
    top: -2px;
    bottom: auto;
    left: 0%;
    right: auto
}

.div-block-336 {
    background-color: var(--white);
    width: 50%;
    height: 2px;
    position: absolute;
    top: -2px;
    bottom: auto;
    left: auto;
    right: 0%
}

.image-86 {
    width: 80px;
    height: 80px;
    margin-left: 16px
}

.blog-book-demo-block {
    background-color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/646f3ea5eeb4ddfdaefe08cd_image%20\\(22\\).png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 10px;
    width: 100%;
    padding: 45px 35px;
    position: sticky;
    top: 120px
}

.blog-book-demo-box {
    max-width: 320px;
    display: block;
    position: relative
}

.book-cta-title {
    color: var(--white);
    margin-top: 0;
    margin-bottom: 40px;
    font-size: 34px;
    line-height: 49px
}

.wrapper-block {
    width: 100%;
    padding-right: 32px
}

.wrapper-block.blog {
    flex-direction: column;
    display: flex
}

.modal-popup {
    z-index: 999;
    background-color: rgba(0, 0, 0, .5);
    display: none;
    position: fixed;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.modal-popup-block {
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex
}

.modal-popup-content {
    background-color: #d53987;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/643abee3fbcacf3d18ccff85_ads-bg.svg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: auto;
    border-radius: 14px;
    width: 100%;
    max-width: 860px;
    height: auto;
    padding: 40px 60px;
    position: relative
}

.model-title {
    color: var(--white);
    max-width: 85%;
    margin-bottom: 20px;
    font-size: 42px;
    line-height: 130.5%
}

.modal-list {
    color: var(--white);
    max-width: 58%;
    margin-top: -7px;
    margin-bottom: 40px;
    padding-left: 20px;
    font-size: 20px;
    font-weight: 500;
    line-height: 130.5%
}

.modal-list-item {
    padding-top: 7px;
    padding-bottom: 7px
}

.ads-banner-img {
    position: absolute;
    top: auto;
    bottom: 28px;
    left: auto;
    right: 35px
}

.model-close {
    background-color: #fff;
    border-radius: 100%;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    display: flex;
    position: absolute;
    top: -9%;
    bottom: auto;
    left: auto;
    right: 0%
}

.model-close-img {
    width: 30px;
    height: 30px
}

.div-block-337 {
    border: 2px solid var(--light-pink);
    background-color: var(--pabloo-green);
    border-radius: 80px;
    padding: 0 16px
}

.ssms-button-wrapper {
    grid-column-gap: 24px;
    white-space: nowrap;
    margin-top: 40px;
    display: flex
}

.button-border {
    color: #000;
    background-color: rgba(56, 152, 236, 0);
    border: 1.5px solid #000;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    display: flex
}

.ssms-second-2 {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    display: flex
}

.image-87 {
    align-self: center;
    max-width: 800px
}

.ssms-second-content {
    grid-row-gap: 20px;
    text-align: center;
    letter-spacing: .2px;
    flex-direction: column;
    align-self: center;
    max-width: 680px;
    margin-bottom: 80px;
    font-weight: 500;
    display: flex
}

.ssms-h2 {
    text-align: center
}

.ssms-2-grid {
    grid-column-gap: 32px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.ssms-grid-item {
    letter-spacing: 0;
    max-width: 330px;
    font-size: 20px;
    line-height: 1.33333
}

.ssms-h3 {
    letter-spacing: 0;
    margin-bottom: 12px;
    font-size: 23px;
    font-weight: 700;
    line-height: 1.3
}

.ssms-sec-3-grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-wrap: wrap;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    justify-items: center;
    width: 100%;
    margin-top: 80px;
    display: none
}

.ssms-sec-3-grid-item {
    box-shadow: -6px 8px 0 0 var(--pabloo-green);
    letter-spacing: .2px;
    background-color: #fff;
    border-radius: 10px;
    padding: 35px;
    font-size: 24px;
    line-height: 1.33333
}

.ssms-step-text {
    color: var(--pabloo-green);
    letter-spacing: -.5px;
    background-color: #f3f3f2;
    border-radius: 100px;
    padding: 10px 30px;
    font-size: 32px;
    font-style: italic;
    font-weight: 700;
    line-height: 1.125;
    display: inline-block
}

.ssms-3-h3 {
    letter-spacing: .2px;
    font-size: 34px;
    line-height: 1.23529
}

.div-block-338 {
    flex-direction: column;
    align-items: center;
    display: flex;
    transform: translateY(-90px)
}

.cta-bottom-fold {
    padding-top: 40px;
    padding-bottom: 40px
}

.b-navigation-base-2 {
    border-radius: 0;
    flex: 1 1;
    padding: 8px 16px;
    box-shadow: 0 48px 140px -78px rgba(0, 0, 0, .08)
}

.grid-5 {
    display: block
}

.split-image-wrapper-3 {
    width: 48%;
    max-width: 560px;
    margin-top: 24px;
    position: static
}

.slide-11 {
    width: 20%;
    margin-right: 16px
}

.left-arrow-7 {
    z-index: 0;
    background-color: #000;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.b-navigation-large-grid-2 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 16px
}

.buying-hub---hero-image {
    width: 100%;
    max-width: none
}

.navigation-toggle-4 {
    color: #160042;
    letter-spacing: -.01em;
    border-radius: 50px 50px 24px 24px;
    align-items: center;
    height: 100%;
    padding: 12px 30px 12px 24px;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    transition: all .35s
}

.navigation-toggle-4:hover {
    background-color: #fff
}

.navigation-grid-3 {
    grid-column-gap: 32px;
    grid-row-gap: 0px;
    object-fit: fill;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    height: auto;
    padding-left: 8px;
    padding-right: 8px
}

.nav-list {
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 16px;
    font-weight: 400
}

.review-slider-author-wrapper-2 {
    flex: none;
    align-items: center;
    max-width: none;
    display: flex
}

.top-tag-text-2 {
    color: #ebb82f;
    text-transform: uppercase;
    margin-left: 20px;
    margin-right: 20px;
    font-weight: 700
}

.top-tag-text-2.black {
    color: #000
}

.auto-slider-arrow-left-3 {
    background-color: transparent;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    padding: 10px 5px;
    transition: background-color .3s;
    display: none;
    position: absolute;
    top: auto;
    bottom: -20px;
    left: auto;
    right: 100px
}

.auto-slider-arrow-left-3:hover {
    background-color: #fff
}

.auto-slider-arrow-left-3.show {
    background-color: #fff;
    width: 64px;
    padding-left: 0;
    padding-right: 0;
    display: flex;
    bottom: 22px;
    right: 120px
}

.auto-slider-arrow-left-3.show:hover {
    background-color: #fff
}

.b-navigation-link-icon-2 {
    grid-column-gap: 44px;
    grid-row-gap: 44px;
    color: #000;
    border-radius: 16px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 16px;
    text-decoration: none;
    transition: all .3s;
    display: flex
}

.b-navigation-link-icon-2:hover {
    color: #d53987;
    background-color: #f8fafc
}

.right-arrow-7 {
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.new-button {
    color: #5050ff;
    background-color: #fff;
    border: 2px solid #5050ff;
    border-radius: 8px;
    transition: background-color .2s
}

.new-button:hover {
    color: #fff;
    background-color: #5050ff
}

.new-button.pink {
    color: #d53987;
    background-color: #fff;
    border-color: #d53987
}

.new-button.pink:hover {
    color: #fff;
    background-color: #d53987
}

.testimonials-section {
    padding-top: 40px;
    padding-bottom: 40px
}

.wrapper-1300px-3 {
    z-index: 2;
    background-color: transparent;
    border-radius: 16px;
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding: 160px 80px 40px;
    position: relative
}

.wrapper-1300px-3.integrations-fold {
    background-color: #fff;
    border: 6px #c73a88;
    border-radius: 32px;
    padding-top: 8px;
    padding-bottom: 8px
}

.wrapper-1300px-3.testimonials-wrapper {
    padding-top: 8px;
    padding-bottom: 8px
}

.footer-content-wrapper-2 {
    flex-direction: column;
    display: flex
}

.hover-block__text {
    flex-wrap: wrap;
    flex: 0 1 auto;
    justify-content: center;
    align-self: center;
    align-items: center;
    width: 90%;
    max-width: 398px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: static;
    top: 50%
}

.page-subheading {
    margin-top: 8px;
    font-size: 20px;
    font-weight: 400;
    line-height: 140%
}

.review-slide-3 {
    background-color: transparent;
    border-radius: 0;
    margin-top: 0;
    padding: 24px 0 40px
}

.navigation-list-2 {
    z-index: 99;
    min-width: 100%
}

.navigation-list-2.w--open {
    background-color: #fff;
    width: 56%;
    min-width: auto;
    max-width: none;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    top: 90px;
    bottom: auto;
    left: 0%;
    right: 0
}

.navigation-list-2.product.w--open {
    width: 130%
}

.navigation-list-2.solutions {
    border-radius: 16px;
    width: 60%;
    min-width: auto;
    top: 64px;
    left: 0
}

.navigation-list-2.product {
    width: 120%;
    top: 64px;
    left: 0%
}

.navigation-list-2.resources {
    border-radius: 16px;
    width: 120%;
    padding-top: 8px;
    padding-bottom: 8px;
    top: 64px
}

.mask-not-visible-2 {
    border-radius: 10px
}

.page-heading {
    margin-bottom: 8px;
    font-size: 56px
}

.image-108 {
    margin-left: auto;
    margin-right: auto
}

.div-block-367 {
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr auto;
    grid-auto-columns: 1fr;
    align-items: center;
    width: 100%;
    margin-top: 64px;
    display: block
}

.text-block-193 {
    color: #fff;
    font-family: Satoshi, sans-serif;
    font-size: 14px;
    font-weight: 500
}

.div-block-368 {
    margin-top: 6px;
    font-family: "P22mackinacpro 15", sans-serif
}

.split-button-wrapper-3 {
    margin-top: 24px
}

.div-block-369 {
    background-color: #5050ff;
    border: 3px #000;
    border-radius: 16px;
    margin-left: 4%;
    margin-right: 4%;
    padding: 32px
}

.div-block-370 {
    border: 2px solid #000;
    border-radius: 16px;
    margin-top: 64px
}

.div-block-371 {
    margin-top: 24px;
    display: flex
}

.persona-down-hero-bg-3 {
    background-color: #fff;
    width: 100%;
    height: 120px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.div-block-372 {
    align-items: center;
    display: flex
}

.heading-141 {
    text-align: center;
    margin-bottom: 64px;
    font-size: 48px;
    font-weight: 700
}

.hollow-button-3 {
    color: #000;
    text-align: center;
    background-color: transparent;
    border: 2px solid #000;
    padding: 22px;
    font-size: 20px;
    font-weight: 700;
    transition: color .36s, background-color .36s
}

.hollow-button-3:hover {
    color: #fff;
    background-color: #000
}

.hollow-button-3.rounded {
    border-radius: 12px;
    padding: 16px 20px
}

.text-span-179 {
    color: #d53987
}

.heading-142 {
    font-size: 32px;
    line-height: 40px
}

.section-25 {
    background-color: #f7f7f5;
    padding-bottom: 40px
}

.slide-14 {
    width: 32%;
    margin-top: 16px;
    margin-bottom: 16px
}

.section-26 {
    background-color: #fff;
    background-image: linear-gradient(#fff, rgba(213, 57, 135, .16) 50%, #fff);
    margin-bottom: 0;
    padding-top: 40px;
    padding-bottom: 40px
}

.section-26.intergations-fold-section {
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    background-attachment: scroll;
    position: relative
}

.review-author-job-post-3 {
    color: rgba(0, 0, 0, .64);
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5
}

.review-slider-container-3 {
    background-color: #fff;
    border-radius: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 16px 0 16px 40px;
    display: flex;
    position: relative;
    box-shadow: 0 0 16px rgba(0, 0, 0, .08)
}

.review-slider-container-3.home {
    box-shadow: none;
    background-color: transparent;
    padding-left: 20px
}

.div-block-374 {
    justify-content: center;
    margin-top: 20px;
    display: flex
}

.review-slider-text-4 {
    color: #000;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5
}

.image-111 {
    height: 64px
}

.image-111.m-l-8 {
    filter: saturate(151%);
    width: 80px;
    height: 80px;
    margin-left: 8px
}

.div-block-376 {
    margin-top: 32px
}

.heading-145 {
    color: #fff;
    font-size: 40px
}

.b-navigation-link-icon-3 {
    grid-column-gap: 44px;
    grid-row-gap: 44px;
    color: #000;
    border-radius: 16px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 16px;
    text-decoration: none;
    transition: all .3s;
    display: flex
}

.b-navigation-link-icon-3:hover {
    color: #d53987;
    background-color: #f8fafc
}

.text-span-180 {
    color: #d53987
}

.about-hero-wrapper-3 {
    background-color: #5050ff;
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    margin-bottom: 90px;
    padding-top: 88px;
    padding-bottom: 0;
    position: relative
}

.about-hero-wrapper-3.white-bg {
    background-color: #fff
}

.about-hero-wrapper-3.white-bg.margin-top-40 {
    padding-top: 40px
}

.about-hero-wrapper-3.white-bg.margin-top-40.transparent-bg {
    background-color: transparent;
    margin-bottom: 0;
    padding-top: 0
}

.paragraph-91 {
    margin-top: 16px;
    font-weight: 500;
    line-height: 32px
}

.button-25 {
    color: #fff;
    background-color: #000;
    border-radius: 12px;
    padding: 12px 20px;
    font-weight: 500
}

.home-slider-image-4 {
    width: 30%;
    max-width: 400px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto
}

.navigation-dropdown-base-3 {
    background-color: #fff;
    border: 4px solid #fff;
    border-radius: 0 0 24px 24px;
    max-width: none;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    box-shadow: 5px 48px 140px -48px rgba(57, 59, 106, .08)
}

.div-block-381 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    border: 2px solid #000;
    border-radius: 16px;
    flex-wrap: wrap;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-between;
    align-items: flex-start;
    height: 100%;
    padding: 16px;
    display: grid
}

.div-block-381:hover {
    box-shadow: 5px 6px #000
}

.heading-148 {
    text-align: center;
    margin-bottom: 24px;
    font-size: 48px
}

.link-block-30 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.link-block-31 {
    align-items: center;
    display: flex
}

.link-block-31:hover {
    /* text-decoration: none */
}

.top-tag-line-3 {
    background-color: #ebb82f;
    width: 40px;
    height: 2px
}

.top-tag-line-3.black {
    background-color: #000
}

.div-block-382 {
    padding-top: 80px;
    padding-bottom: 80px
}

.slider-12 {
    background-color: #fff;
    border-radius: 16px;
    height: 100%;
    padding: 12px
}

.badge-standard-5 {
    color: #fff;
    background-color: #d53987;
    border-radius: 50px;
    justify-content: space-between;
    align-items: center;
    padding: 4px 12px;
    font-size: 12px;
    line-height: 16px;
    display: flex
}

.text-block-197 {
    color: #5050ff;
    font-weight: 500
}

.slide-15 {
    width: 32%;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-right: 2%
}

.image-116 {
    height: 60px;
    margin-left: 8px
}

.image-116.m-l-0 {
    height: 80px;
    margin-left: 0
}

.paragraph-93 {
    color: #fff;
    margin-top: 24px
}

.review-company-image-container-3 {
    flex: none;
    height: 28px;
    margin-bottom: 16px;
    line-height: 40px
}

.review-company-image-container-3.airmeet-logo-wrapper {
    height: 28px
}

.image-117 {
    text-align: center;
    width: 100%;
    margin-right: auto
}

.footer-links-4 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 100%;
    text-decoration: none;
    transition: color .2s;
    display: block
}

.footer-links-4:hover {
    color: #d53987
}

.footer-links-4.hide {
    display: none
}

.navigation-6 {
    background-color: #fff;
    align-items: center;
    width: 100%;
    min-height: 88px;
    padding: 24px 5%;
    display: flex
}

.heading-150 {
    text-align: center
}

.section-27 {
    background-color: #fff;
    padding-top: 80px
}

.image-118 {
    object-fit: cover;
    border-radius: 8px;
    height: 100%
}

.logo-6 {
    width: 124px
}

.image-119 {
    object-fit: cover;
    border-radius: 8px;
    height: 100%
}

.text-block-199 {
    color: #d53987;
    font-size: 16px;
    text-decoration: none
}

.image-120 {
    height: 14px;
    margin-top: 1px;
    margin-left: 8px
}

.navigation-icon-arrow-5 {
    margin-right: 10px
}

.button-26 {
    background-color: #000;
    border-radius: 8px;
    margin-top: 24px;
    padding: 12px 16px
}

.button-26.mt-0 {
    margin-top: 0;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 16px
}

.div-block-391 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: #fff;
    border-top: 2px rgba(0, 0, 0, .07);
    border-radius: 0;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 0;
    padding: 12px 8px;
    display: grid
}

.div-block-391:hover {
    background-color: rgba(213, 57, 135, .05)
}

.div-block-391.margin-top-reset {
    margin-top: 0
}

.div-block-391.margin-top-reset:hover {
    background-color: rgba(213, 57, 135, .05)
}

.div-block-391.margin-top-reset.no-border {
    border-top-style: none;
    padding-top: 12px
}

.list-14 {
    padding-left: 0
}

.paragraph-96 {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px
}

.b-navigation-link-icon-4 {
    grid-column-gap: 44px;
    grid-row-gap: 44px;
    color: #000;
    border-radius: 8px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 16px;
    text-decoration: none;
    transition: all .3s;
    display: flex
}

.b-navigation-link-icon-4:hover {
    color: #d53987;
    background-color: #f8fafc
}

.div-block-392 {
    background-color: #0f1444;
    border-radius: 8px;
    align-items: center;
    display: flex
}

.navigation-menu-6 {
    align-items: center;
    display: flex;
    position: relative
}

.text-block-200 {
    color: #d53987;
    font-size: 16px;
    text-decoration: none
}

.div-block-393 {
    background-color: #0f1444;
    border-radius: 8px;
    align-items: center;
    display: flex
}

.text-block-201 {
    font-size: 16px;
    font-weight: 700
}

.b-navigation-column-4 {
    grid-row-gap: 2px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex
}

.navigation-link-6 {
    color: #000;
    letter-spacing: -.01em;
    white-space: nowrap;
    background-color: transparent;
    border-radius: 50px;
    padding: 12px 24px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    transition: all .35s
}

.navigation-link-6:hover {
    color: #d53987;
    background-color: #fff
}

.navigation-link-6.w--current {
    color: #d53987
}

.paragraph-97 {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px
}

.div-block-394 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    padding-left: 8px;
    display: grid
}

.div-block-395 {
    align-items: center;
    display: flex
}

.text-span-181 {
    color: #5050ff
}

.review-slider-content-wrapper-4 {
    flex: none;
    align-items: flex-start;
    width: 100%;
    max-width: 100%;
    height: auto;
    min-height: 100px;
    margin-bottom: 16px;
    display: flex
}

.div-block-396 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: #fff;
    background-image: radial-gradient(circle at 100% 100%, #d53987, #fff 45%);
    border-radius: 24px;
    grid-template-rows: auto;
    grid-template-columns: 25% 75%;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid;
    position: relative;
    box-shadow: 0 0 16px rgba(0, 0, 0, .06)
}

.div-block-396.border {
    box-shadow: none;
    background-image: none;
    border: 3px solid rgba(80, 80, 255, .4);
    grid-template-columns: 30% 70%;
    padding: 16px
}

.heading-152 {
    text-align: center;
    font-size: 32px;
    line-height: 40px
}

.image-121 {
    border-radius: 60px;
    margin-top: 0
}

.image-122 {
    object-fit: contain;
    border-radius: 300px;
    width: 100%;
    height: auto
}

.div-block-397 {
    display: none
}

.div-block-398 {
    background-color: transparent;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    flex: 0 1 auto;
    justify-content: flex-end;
    align-self: auto;
    align-items: stretch;
    width: 100%;
    height: 340px;
    max-height: 340px;
    display: flex;
    position: static;
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.div-block-398.uc-image-wrapper {
    background-color: transparent;
    border-radius: 300px;
    justify-content: center;
    width: 240px;
    height: 240px;
    padding: 16px
}

.image-124 {
    border-radius: 8px;
    height: 56px;
    margin-left: auto;
    margin-right: auto
}

.image-125 {
    width: 100%
}

.link-block-32 {
    border-bottom: 1px solid #fff
}

.heading-153 {
    color: #000
}

.mask-8 {
    overflow: hidden
}

.heading-154 {
    color: #000;
    text-align: center;
    width: 100%
}

.hollow-button-4 {
    color: #000;
    text-align: center;
    background-color: transparent;
    border: 2px solid #000;
    padding: 22px;
    font-size: 20px;
    font-weight: 700;
    transition: color .36s, background-color .36s
}

.hollow-button-4:hover {
    color: #fff;
    background-color: #000
}

.hollow-button-4.rounded {
    border-radius: 12px;
    padding: 16px 20px
}

.text-block-202 {
    color: #fff
}

.heading-155 {
    color: #000;
    text-align: center;
    font-size: 48px
}

.slider-13 {
    background-color: transparent;
    display: block
}

.div-block-399 {
    margin-top: 32px;
    padding-top: 80px;
    padding-bottom: 80px
}

.div-block-399.integrations-section-container {
    padding-top: 32px;
    padding-bottom: 32px
}

.div-block-400 {
    justify-content: center;
    display: flex
}

.div-block-400.hide {
    display: none
}

.div-block-401 {
    border-top: 1px solid rgba(255, 255, 255, .6);
    margin-top: 16px;
    padding-top: 24px
}

.heading-156,
.heading-157 {
    color: #000;
    text-align: center;
    width: 100%
}

.paragraph-98 {
    color: #000;
    text-align: center;
    margin-top: 16px;
    font-weight: 400
}

.div-block-402 {
    justify-content: flex-end;
    margin-left: 6%;
    margin-right: 8%;
    display: flex
}

.div-block-403 {
    background-color: #fff;
    border-radius: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    padding: 40px 12px 20px;
    display: flex;
    position: relative
}

.image-128 {
    margin-left: auto;
    margin-right: auto
}

.div-block-404 {
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr auto;
    grid-auto-columns: 1fr;
    align-items: center;
    width: 100%;
    margin-top: 64px;
    display: block
}

.div-block-404.border {
    border: 1px none var(--light-slate-grey)
}

.div-block-407 {
    border: 2px solid #000;
    border-radius: 16px;
    margin-top: 64px
}

.image-90 {
    width: 100%
}

.image-90.hide {
    display: none
}

.div-block-409 {
    align-items: center;
    display: flex
}

.heading-160 {
    text-align: center;
    margin-bottom: 64px;
    font-size: 48px;
    font-weight: 700
}

.section-28 {
    background-color: #f7f7f5;
    padding-top: 80px;
    padding-bottom: 80px
}

.text-span-183 {
    color: #d53987
}

.heading-161 {
    font-size: 32px;
    line-height: 40px
}

.slide-16 {
    width: 32%;
    margin-top: 16px;
    margin-bottom: 16px
}

.div-block-411 {
    justify-content: center;
    margin-top: 20px;
    display: flex
}

.b-navigation-link-icon-5 {
    grid-column-gap: 44px;
    grid-row-gap: 44px;
    color: #000;
    border-radius: 16px;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 12px 16px;
    text-decoration: none;
    transition: all .3s;
    display: flex
}

.b-navigation-link-icon-5:hover {
    color: #d53987;
    background-color: #f8fafc
}

.paragraph-100 {
    margin-top: 16px;
    font-weight: 500;
    line-height: 32px
}

.home-slider-image-5 {
    width: 30%;
    max-width: 400px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto
}

.div-block-419 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    border: 2px solid #000;
    border-radius: 16px;
    flex-wrap: wrap;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-between;
    align-items: flex-start;
    height: 100%;
    padding: 16px;
    display: grid
}

.div-block-419:hover {
    box-shadow: 5px 6px #000
}

.link-block-33 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-420 {
    padding-top: 80px;
    padding-bottom: 80px
}

.persona-head-para-2 {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
    line-height: 140%
}

.persona-head-para-2.it {
    max-width: 920px
}

.persona-head-para-2.it.black {
    color: #000;
    margin-top: 24px;
    font-weight: 400;
    line-height: 140%
}

.slider-15 {
    background-color: #fff;
    border-radius: 16px;
    height: 100%;
    padding: 12px
}

.text-block-207 {
    color: #5050ff;
    font-weight: 500
}

.slide-17 {
    width: 32%;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-right: 2%
}

.image-137 {
    text-align: center;
    width: 100%;
    margin-right: auto
}

.heading-168 {
    text-align: center
}

.text-span-174 {
    color: #d53987
}

.image-140 {
    margin-left: auto;
    margin-right: auto
}

.slide-18 {
    border: 2px #000;
    border-radius: 0
}

.div-block-430 {
    justify-content: center;
    width: 100%;
    height: 100%;
    margin-top: 32px;
    display: flex
}

.div-block-432 {
    border: 2px solid #000;
    border-radius: 16px;
    margin-top: 64px
}

.slider-16 {
    background-color: #fff;
    width: 100%;
    height: 100%
}

.image-143 {
    object-fit: fill;
    border: 1px #000;
    border-radius: 0;
    width: 100%;
    max-width: 100%;
    height: auto
}

.div-block-434 {
    align-items: center;
    display: flex
}

.left-arrow-8 {
    background-color: #d53987;
    border-radius: 120px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    display: flex;
    top: auto;
    bottom: -48px;
    left: auto;
    right: 24%
}

.left-arrow-8.hide {
    display: none
}

.text-span-185 {
    color: #d53987
}

.heading-171 {
    font-size: 32px;
    line-height: 40px
}

.section-30 {
    background-color: #f7f7f5;
    padding-bottom: 40px
}

.cta---pink---rounded-2 {
    background-color: #d53987;
    border-radius: 12px;
    margin-top: 24px;
    padding: 16px;
    font-weight: 500
}

.cta---pink---rounded-2.mt-40 {
    margin-top: 80px
}

.slide-19 {
    width: 32%;
    margin-top: 16px;
    margin-bottom: 16px
}

.heading-130 {
    text-align: center;
    margin-bottom: 24px;
    font-size: 48px
}

.right-arrow-8 {
    background-color: #d53987;
    border-radius: 120px;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    display: flex;
    top: auto;
    bottom: -48px;
    left: auto;
    right: 19%
}

.right-arrow-8.hide {
    display: none
}

.div-block-436 {
    object-fit: fill;
    border: 3px #d53987;
    border-radius: 16px;
    width: 72%;
    margin-left: auto;
    margin-right: auto;
    box-shadow: 0 0 16px rgba(0, 0, 0, .11)
}

.slide-nav-6 {
    font-size: 14px;
    bottom: -32px
}

.div-block-437 {
    justify-content: center;
    margin-top: 20px;
    display: flex
}

.paragraph-105 {
    margin-top: 16px;
    font-weight: 500;
    line-height: 32px
}

.right-arrow-9 {
    top: auto;
    bottom: 0%;
    left: auto;
    right: 0%
}

.home-slider-image-6 {
    width: 30%;
    max-width: 400px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto
}

.heading-177 {
    color: #000;
    margin-top: 0;
    font-size: 24px;
    line-height: 32px
}

.div-block-444 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    border: 2px solid #000;
    border-radius: 16px;
    flex-wrap: wrap;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: space-between;
    align-items: flex-start;
    height: 100%;
    padding: 16px;
    display: grid
}

.div-block-444:hover {
    box-shadow: 5px 6px #000
}

.div-block-445 {
    border-left: 2px solid #f5cde1;
    width: 72%;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 8px
}

.text-span-186 {
    color: #d53987
}

.link-block-35 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.image-147 {
    border-radius: 0
}

.div-block-446 {
    padding-top: 80px;
    padding-bottom: 80px
}

.slider-18 {
    background-color: #fff;
    border-radius: 16px;
    height: 100%;
    padding: 12px
}

.text-block-213 {
    color: #5050ff;
    font-weight: 500
}

.slide-20 {
    width: 32%;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-right: 2%
}

.div-block-449 {
    border: 2px #000;
    border-radius: 0;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.image-151 {
    text-align: center;
    width: 100%;
    margin-right: auto
}

.heading-179 {
    text-align: center
}

.paragraph-108 {
    color: #000;
    font-size: 16px
}

.html-embed-25 {
    width: 100%
}

.new-testimonialls {
    justify-content: center;
    padding-bottom: 36px;
    display: flex
}

.section-max-sav {
    background-color: var(--pabloo-green);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/644761acced7884b76421c2f_Group%20143.png), url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/644761854084c90dc5be977b_Group%20144.png);
    background-position: 100% 100%, 0 100%;
    background-repeat: no-repeat, no-repeat;
    background-size: 30%, 30%
}

.max-save-compoennt {
    width: 100%;
    max-width: 840px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 120px
}

.max-sav-heading {
    color: #fff;
    text-align: center;
    letter-spacing: -.5px
}

.max-save-para {
    color: #fff;
    text-align: center;
    max-width: 600px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    font-weight: 500
}

.div-block-456 {
    grid-row-gap: 30px;
    flex-direction: column;
    align-items: stretch;
    margin-top: 80px;
    display: flex
}

.text-block-215 {
    color: #fff;
    background-color: rgba(255, 255, 255, .2);
    border-radius: 100px;
    padding: 12px 24px;
    font-size: 20px;
    line-height: 1;
    display: none
}

.div-block-457 {
    grid-column-gap: 60px;
    grid-row-gap: 20px;
    background-color: #fff;
    border-radius: 10px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr auto;
    grid-auto-columns: 1fr;
    align-items: center;
    justify-items: start;
    margin-top: 24px;
    margin-bottom: 80px;
    padding: 25px 32px;
    display: grid;
    box-shadow: 7px 7px rgba(255, 255, 255, .2)
}

.div-block-457.hide {
    display: none
}

.text-block-218 {
    color: rgba(0, 0, 0, .6);
    letter-spacing: .2px;
    line-height: 1
}

.text-block-219 {
    color: var(--pabloo-green);
    font-size: 44px;
    font-style: italic;
    font-weight: 700;
    line-height: 1
}

.button-31 {
    background-color: var(--white);
    color: var(--pabloo-green);
    padding: 12px 16px;
    font-size: 16px;
    font-weight: 500
}

.blog-secondary-author-wrapper {
    margin-left: 32px
}

.rich-text-block-23 {
    margin-top: 8px;
    font-size: 18px;
    line-height: 32px
}

.div-block-458 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 2fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 16px;
    padding-left: 32px;
    padding-right: 32px;
    display: block
}

.section-32 {
    margin-top: 80px;
    margin-bottom: 80px
}

.rich-text-block-24 {
    text-align: center;
    margin-top: 0;
    font-size: 18px;
    line-height: 32px
}

.heading-180 {
    text-align: center;
    margin-top: 8px;
    font-size: 48px;
    font-weight: 500;
    line-height: 1.2
}

.div-block-460 {
    background-color: var(--white);
    border-radius: 20px;
    margin-top: 0;
    padding: 24px
}

.div-block-460.ebook-how-to-section {
    background-color: var(--white);
    margin-top: 120px;
    padding-bottom: 32px
}

.div-block-461 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-items: start;
    display: grid
}

.div-block-462 {
    grid-column-gap: 8px;
    grid-row-gap: 16px;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    padding-top: 16px;
    padding-bottom: 16px;
    display: grid
}

.text-block-220 {
    text-align: center;
    margin-top: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px
}

.collection-list-wrapper-4 {
    margin-top: 16px
}

.div-block-463 {
    grid-column-gap: 8px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-items: center;
    display: grid
}

.collection-list-wrapper-5 {
    margin-top: 48px;
    padding: 12px
}

.text-block-221 {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px
}

.div-block-464 {
    padding-top: 80px;
    padding-bottom: 80px
}

.section-33 {
    padding-top: 40px;
    padding-bottom: 40px
}

.collection-list-5 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.collection-item-2 {
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 4px;
    padding: 8px
}

.div-block-465 {
    background-color: var(--pabloo-green);
    border-radius: 100%;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    display: flex
}

.text-block-222 {
    color: var(--white);
    font-weight: 500
}

.div-block-466 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--pabloo-green);
    border-radius: 12px;
    grid-template-rows: auto;
    grid-template-columns: .75fr 1fr;
    grid-auto-columns: 1fr;
    padding: 56px 40px;
    display: grid;
    box-shadow: 0 2px 16px rgba(0, 0, 0, .12)
}

.heading-182 {
    color: var(--white);
    text-align: left;
    margin-top: 0;
    font-size: 40px;
    font-weight: 500;
    line-height: 1.2
}

.rich-text-block-26 {
    color: var(--white);
    font-size: 20px;
    line-height: 1.6
}

.div-block-467 {
    margin-top: 32px
}

.div-block-468 {
    padding: 40px 3% 120px
}

.div-block-469 {
    background-color: var(--white);
    border-radius: 12px;
    width: 100%;
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    padding: 40px;
    box-shadow: 1px 1px 12px rgba(0, 0, 0, .12)
}

.div-block-470 {
    background-color: var(--slate-blue);
    border-radius: 100%;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    display: flex
}

.text-block-225 {
    color: var(--white);
    font-weight: 500
}

.collection-list-6 {
    grid-column-gap: 64px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: .8fr .8fr .8fr;
    grid-auto-columns: 1fr;
    display: grid
}

.heading-183 {
    font-size: 48px;
    font-weight: 500;
    line-height: 1.2
}

.paragraph-111 {
    margin-top: 8px;
    font-size: 20px;
    line-height: 32px
}

.div-block-471 {
    border-left: 2px solid rgba(255, 255, 255, .2);
    padding-left: 24px
}

.text-block-226 {
    font-size: 20px;
    font-weight: 700
}

.div-block-472 {
    padding-top: 80px
}

.div-block-473 {
    display: none
}

.div-block-474 {
    flex-flow: wrap;
    justify-content: center;
    align-items: center;
    display: flex
}

.div-block-475 {
    width: 50%
}

.text-span-187 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.div-block-476 {
    border-bottom: 1px solid rgba(0, 0, 0, .16);
    width: 100%;
    padding-bottom: 12px
}

.div-block-476.no-border {
    border-bottom-style: none
}

.div-block-477 {
    width: 100%;
    margin-top: 24px
}

.section-34 {
    background-color: var(--white);
    padding-left: 6%;
    padding-right: 6%
}

.image-157 {
    margin-bottom: 24px
}

.div-block-478 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 70% 30%;
    grid-auto-columns: 1fr;
    width: 100%;
    max-width: 100%;
    margin-top: 24px;
    display: grid
}

.image-158 {
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.text-span-188 {
    font-size: 32px;
    font-weight: 700
}

.text-span-189 {
    font-size: 16px;
    line-height: 28px
}

.heading-185,
.heading-186,
.heading-187 {
    font-size: 48px
}

.heading-189 {
    margin-top: 0;
    margin-left: 0;
    font-size: 32px;
    line-height: 40px
}

.div-block-479 {
    border-bottom: 1px solid rgba(0, 0, 0, .16);
    align-items: center;
    padding-bottom: 8px;
    display: flex
}

.text-block-227 {
    color: var(--white);
    font-weight: 500
}

.text-block-228 {
    color: var(--white);
    margin-left: 6px;
    font-weight: 500
}

.image-160 {
    height: 48px
}

.image-161 {
    height: 60px;
    margin-left: auto;
    margin-right: auto
}

.image-162,
.image-163,
.image-164,
.image-165,
.image-166,
.image-167,
.image-168 {
    height: 48px
}

.paragraph-112 {
    grid-column-gap: 16px;
    display: flex
}

.div-block-480 {
    grid-column-gap: 16px;
    justify-content: center;
    align-items: center;
    display: flex
}

.button-32 {
    background-color: var(--slate-blue);
    border-radius: 12px;
    padding-top: 16px;
    padding-bottom: 16px
}

.div-block-481 {
    background-color: #fff;
    border-radius: 12px;
    justify-content: center;
    padding-top: 32px;
    padding-bottom: 32px;
    display: flex
}

.div-block-482 {
    margin-bottom: 24px
}

.text-span-191 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.section-35 {
    background-color: var(--white-smoke)
}

.div-block-489 {
    width: 100%;
    padding-top: 4%;
    padding-bottom: 4%
}

.heading-191 {
    font-size: 32px;
    line-height: 1.2em
}

.text-block-229 {
    margin-top: 16px;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2em
}

.text-span-192 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.heading-193 {
    text-align: center;
    font-size: 52px;
    line-height: 1.2em
}

.div-block-491 {
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 80px;
    padding-right: 80px
}

.container-1282 {
    max-width: 1120px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 30px;
    padding-right: 30px
}

.section-title {
    text-align: center;
    max-width: 100%;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto
}

.heading-194 {
    color: var(--black);
    text-align: center;
    font-size: 56px;
    font-weight: 700;
    line-height: 1.1
}

.body-4 {
    color: var(--black);
    font-size: 18px;
    font-weight: 400;
    line-height: 1.4
}

.features-grid-3 {
    grid-column-gap: 30px;
    grid-row-gap: 60px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr
}

.feature-block-4 {
    background-color: var(--white-smoke);
    text-align: center;
    border-radius: 16px;
    padding: 30px
}

.feature-illustration {
    background-color: var(--white);
    border-radius: 12px;
    margin-bottom: 40px
}

.section-36 {
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-492 {
    flex-wrap: wrap;
    justify-content: center;
    width: 80%;
    margin-top: 24px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.div-block-494 {
    margin-left: auto;
    margin-right: auto
}

.div-block-495 {
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px
}

.div-block-496 {
    margin-top: 16px
}

.heading-197 {
    font-size: 32px;
    line-height: 1.4em
}

.div-block-497 {
    margin-bottom: 40px
}

.link-38,
.link-39,
.text-span-195 {
    color: var(--pabloo-green);
    /* text-decoration: none */
}

.div-block-498 {
    align-items: center;
    margin-top: 16px;
    display: flex
}

.image-170 {
    height: 80px;
    margin-right: 16px
}

.div-block-499 {
    margin-top: 16px
}

.image-171 {
    height: 80px
}

.image-172 {
    height: 72px
}

.container-1283 {
    max-width: 1120px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 30px;
    padding-right: 30px
}

.section-title-2 {
    text-align: center;
    max-width: 100%;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto
}

.heading-198 {
    color: #fff;
    font-size: 56px;
    font-weight: 700;
    line-height: 1.4
}

.body-5 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.4
}

.features-grid-4 {
    grid-column-gap: 30px;
    grid-row-gap: 60px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr
}

.feature-block-5 {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr
}

.feature-block-2-text-wrap {
    text-align: left
}

.columns-7 {
    width: 100%
}

.heading-200 {
    text-align: left
}

.heading-200.line-height-auto {
    line-height: 1.1em
}

.paragraph-114 {
    text-align: left
}

.column-75 {
    padding-right: 8%
}

.div-block-500 {
    margin-top: 20%
}

.collection-item-3 {
    border-right: 1px rgba(0, 0, 0, .21)
}

.button-33 {
    border-radius: 12px;
    padding: 12px 16px
}

.image-173 {
    object-fit: fill
}

.text-span-196,
.text-span-197 {
    font-size: 24px
}

.text-span-198 {
    color: var(--pabloo-green)
}

.div-block-502 {
    padding: 32px 1px
}

.div-block-503 {
    grid-column-gap: 6px;
    display: flex
}

.button-34 {
    border-radius: 12px;
    padding: 12px 16px
}

.empty-state-8 {
    background-color: var(--white)
}

.text-span-199,
.text-span-200 {
    color: var(--pabloo-green)
}

.checkbox-label-3 {
    font-size: 16px;
    line-height: 16px
}

.checkbox-2 {
    margin-top: 8px
}

.heading-201 {
    text-align: center;
    font-size: 48px;
    line-height: 1.2em
}

.text-span-201 {
    color: var(--pabloo-green)
}

.form-4 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 60% 40%;
    grid-auto-columns: 1fr;
    align-items: end;
    width: 100%;
    padding: 16px 0;
    display: grid
}

.div-block-508 {
    background-color: var(--white)
}

.submit-button-4 {
    background-color: #000;
    font-size: 16px;
    line-height: 20px
}

.text-field-8 {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 32px
}

.form-block-2 {
    width: 100%
}

.heading-203 {
    text-align: center;
    margin-top: 48px;
    margin-left: auto;
    margin-right: auto;
    line-height: 1.2em
}

.heading-204 {
    color: var(--white);
    margin-bottom: 32px;
    font-size: 40px;
    line-height: 1.2em
}

.bold-text-21,
.bold-text-22 {
    color: var(--black)
}

.link-40 {
    display: flex
}

.link-40.w--current {
    grid-column-gap: 4px;
    display: block
}

.text-span-204 {
    color: var(--pabloo-green);
    background-color: rgba(245, 205, 225, .3);
    border-radius: 12px;
    margin-left: 2px;
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px
}

.empty-state-9 {
    background-color: var(--white)
}

.div-block-511 {
    justify-content: center;
    width: 100%;
    margin-top: 32px;
    display: flex
}

.div-block-513 {
    margin-top: 24px;
    margin-bottom: 24px
}

.div-block-514 {
    width: 100%;
    max-width: 820px;
    margin-bottom: -160px
}

.section-37 {
    background-color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f1703c61110085d41bc77b_Mask%20Group.png);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: cover
}

.heading-205 {
    color: var(--white);
    width: 100%;
    font-size: 48px;
    line-height: 1.2em
}

.text-span-205 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 11", sans-serif
}

.div-block-515 {
    width: 100%
}

.div-block-516 {
    grid-column-gap: 32px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    margin-top: 32px;
    padding-top: 64px;
    padding-bottom: 64px;
    display: grid
}

.div-block-517 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--white);
    border-radius: 16px;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    padding: 20px;
    display: grid
}

.paragraph-117 {
    color: #000;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2em
}

.paragraph-117.sub {
    color: #64748b;
    font-size: 18px;
    font-weight: 500
}

.div-block-518 {
    grid-column-gap: 40px;
    grid-row-gap: 16px;
    border-radius: 8px;
    grid-template-rows: auto;
    grid-template-columns: 1.75fr .75fr;
    grid-auto-columns: 1fr;
    align-items: center;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 16px;
    display: grid
}

.div-block-519 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid
}

.text-block-231 {
    color: var(--white);
    font-size: 16px;
    line-height: 1.2em
}

.text-block-232 {
    color: var(--white);
    margin-bottom: 16px;
    font-family: P22, sans-serif;
    font-size: 48px;
    font-weight: 700;
    line-height: 1.2em
}

.text-span-206 {
    font-size: 18px;
    line-height: 18px
}

.div-block-520,
.div-block-521 {
    border-left: 1px solid rgba(255, 255, 255, .24);
    padding: 24px
}

.image-175 {
    min-width: auto;
    height: 150px
}

.image-176 {
    height: 160px
}

.div-block-522 {
    align-items: center;
    display: flex
}

.div-block-523 {
    padding: 24px
}

.div-block-524 {
    background-color: var(--pabloo-green);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f1745d5c7aaa6516e4bce8_Group%20216.png);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: contain;
    padding-top: 40px;
    padding-bottom: 40px
}

.heading-206 {
    color: var(--white)
}

.div-block-525 {
    background-color: var(--pabloo-green);
    border: 1px #000;
    border-radius: 120px;
    width: auto;
    margin-bottom: 24px;
    padding: 4px 12px
}

.text-block-233 {
    color: var(--white);
    font-size: 16px;
    font-weight: 500
}

.text-block-234 {
    color: var(--white);
    margin-top: 24px;
    font-size: 20px
}

.section-38 {
    background-color: #fff
}

.div-block-527 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    margin-top: 32px;
    display: grid
}

.div-block-528 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-235 {
    font-weight: 500
}

.div-block-529 {
    display: none
}

.list-16 {
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 8px;
    padding-left: 0;
    display: block
}

.heading-208 {
    color: var(--black);
    text-align: center;
    margin-top: 8px;
    margin-bottom: 8px
}

.paragraph-118 {
    color: var(--light-slate-grey);
    text-align: center;
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 1.1em
}

.collection-list-wrapper-6 {
    margin-top: 56px
}

.mt-md.center {
    text-align: center
}

.mt-md.center.text-sm {
    color: var(--black);
    text-align: left;
    font-size: 18px;
    line-height: 1.4em
}

.column-76 {
    padding: 4%
}

.sign-up-pointer {
    background-color: transparent;
    border: 1px #000;
    border-radius: 120px;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0;
    margin-bottom: 6px;
    margin-right: 4px;
    padding: 4px;
    display: flex
}

.sign-up-pointer.last {
    border: 1px #000;
    border-radius: 120px;
    margin-right: 0
}

.sign-up-pointer-text {
    color: var(--black-2);
    font-size: 18px;
    font-weight: 400
}

.div-block-531 {
    padding-top: 4%;
    padding-bottom: 4%
}

.div-block-531.flex {
    flex-wrap: wrap;
    justify-content: center;
    padding-left: 2.4%;
    padding-right: 2.4%;
    display: flex
}

.div-block-532 {
    z-index: 1;
    background-color: var(--white);
    border-radius: 12px;
    margin-bottom: 40px;
    padding-top: 24px;
    padding-bottom: 24px;
    position: relative;
    box-shadow: 0 2px 16px rgba(0, 0, 0, .1)
}

.div-block-533 {
    border-radius: 0;
    padding: 12px 24px
}

.image-177 {
    height: 24px;
    margin-right: 6px
}

.div-block-535 {
    display: flex
}

.div-block-536 {
    width: 50%;
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-537 {
    width: 50%;
    padding-left: 8%
}

.image-178 {
    height: 64px
}

.heading-209 {
    color: var(--white);
    font-weight: 500
}

.div-block-538 {
    padding-top: 40px;
    padding-bottom: 40px
}

.text-block-241 {
    color: #fff;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 20px;
    line-height: 1.2em
}

.button-35 {
    background-color: var(--pabloo-green);
    border-radius: 0;
    padding: 12px 32px
}

.div-block-539 {
    padding-top: 16px;
    padding-bottom: 16px
}

.paragraph-119 {
    color: var(--white);
    font-weight: 300
}

.section-39 {
    background-color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64ad366f8751c560ba096ef9_second-fold-bg.svg);
    background-position: 0 0;
    background-repeat: repeat-x;
    background-size: 75%
}

.div-block-540 {
    margin-top: 0;
    padding-top: 40px;
    padding-bottom: 120px
}

.heading-210 {
    text-align: center;
    text-transform: none;
    font-family: Satoshi, sans-serif;
    font-size: 64px;
    font-weight: 700;
    line-height: 1.2em
}

.div-block-541 {
    background-image: linear-gradient(152deg, #cd3a8f 47%, var(--slate-blue));
    -webkit-text-fill-color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
    justify-content: center;
    display: flex
}

.div-block-542 {
    margin-top: 40px
}

.paragraph-120 {
    text-align: center;
    font-size: 24px;
    line-height: 2em
}

.section-40 {
    padding-top: 120px;
    padding-bottom: 120px;
    position: relative
}

.heading-211 {
    color: #fff;
    text-align: center;
    font-size: 48px;
    font-weight: 500;
    line-height: 1.1em
}

.div-block-543 {
    grid-column-gap: 40px;
    grid-row-gap: 56px;
    flex-wrap: nowrap;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-content: space-between;
    justify-content: center;
    align-items: stretch;
    justify-items: stretch;
    margin-top: 120px;
    display: grid
}

.div-block-544 {
    background-color: var(--pabloo-green);
    padding-top: 0;
    padding-bottom: 0
}

.div-block-544.yellow {
    background-color: var(--goldenrod)
}

.div-block-544.orange {
    background-color: #ff8a50
}

.div-block-544.green {
    background-color: #1dd1a1
}

.div-block-544.gray {
    background-color: #0984e3
}

.div-block-544.red {
    background-color: #f43f5e
}

.div-block-544.amber {
    background-color: #f59e0b
}

.image-180 {
    margin-top: -56px;
    margin-bottom: -.5px
}

.div-block-545 {
    background-color: var(--white);
    padding: 16px
}

.text-block-242 {
    text-align: center;
    font-weight: 700
}

.text-block-243 {
    color: var(--pabloo-green);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2em
}

.section-41 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64ad5cb8d78f2eee58e3326e_agenda-section-bg.svg);
    background-position: 0 0;
    background-repeat: repeat-x;
    background-size: 75%;
    padding-top: 0;
    padding-bottom: 0
}

.heading-212 {
    color: #fff;
    text-align: center;
    font-size: 48px;
    font-weight: 700;
    line-height: 1.1em
}

.text-block-244 {
    color: #fff;
    text-align: center;
    margin-top: 16px;
    font-size: 20px;
    line-height: 1.2em
}

.section-42 {
    background-color: #2c2e35;
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-546 {
    display: flex
}

.div-block-547 {
    width: 50%;
    padding-top: 32px;
    padding-bottom: 32px
}

.div-block-548 {
    justify-content: center;
    align-items: center;
    width: 40%;
    padding-left: 40px;
    padding-right: 40px;
    display: flex
}

.heading-213 {
    color: #fff;
    font-weight: 700;
    line-height: 1.2em
}

.paragraph-121 {
    color: #fff
}

.div-block-549 {
    padding-top: 16px;
    padding-bottom: 16px
}

.div-block-550 {
    border-bottom: 6px solid var(--goldenrod);
    margin-bottom: 16px;
    display: inline-block
}

.div-block-551 {
    border-bottom: 6px solid var(--goldenrod);
    margin-top: 16px;
    display: inline-block
}

.text-block-245 {
    color: #fff;
    font-size: 20px;
    line-height: 1.2em
}

.div-block-552 {
    background-color: rgba(247, 247, 245, .11);
    background-image: linear-gradient(214deg, #464646, #2c2e35 59%);
    border: 2px solid #414141;
    border-radius: 16px;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex;
    box-shadow: 16px 0 24px rgba(0, 0, 0, .12)
}

.section-43 {
    background-color: var(--black-2);
    padding-top: 120px;
    padding-bottom: 120px
}

.heading-214 {
    text-align: center;
    font-size: 48px;
    font-weight: 700;
    line-height: 1.2em
}

.section-44 {
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-554 {
    padding-left: 4%;
    padding-right: 4%;
    display: flex
}

.div-block-555 {
    width: 50%
}

.div-block-556 {
    align-self: center;
    width: 50%;
    padding-left: 32px
}

.div-block-557 {
    margin-top: 16px
}

.div-block-558 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-wrap: wrap;
    align-items: center;
    display: flex
}

.text-block-248 {
    color: #fff
}

.div-block-559 {
    background-color: var(--pabloo-green);
    padding: 4px 8px
}

.section-45 {
    background-color: var(--black-2);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64ad366f8751c560ba096ef9_second-fold-bg.svg);
    background-repeat: repeat-x;
    background-size: 75%;
    padding-top: 0;
    padding-bottom: 0
}

.heading-215 {
    text-align: center;
    font-size: 48px;
    font-weight: 700;
    line-height: 1.2em
}

.paragraph-122 {
    text-align: center
}

.div-block-560 {
    margin-top: 64px
}

.text-block-249 {
    text-align: center;
    text-transform: uppercase;
    font-size: 20px;
    line-height: 1.2em
}

.div-block-561 {
    grid-column-gap: 56px;
    grid-row-gap: 32px;
    justify-content: center;
    align-items: center;
    margin-top: 16px;
    display: flex
}

.image-182 {
    height: 32px
}

.image-183 {
    height: 30px;
    margin-bottom: -9px
}

.image-184 {
    height: 42px;
    margin-bottom: -16px
}

.section-46 {
    background-color: var(--slate-blue);
    padding-top: 100px;
    padding-bottom: 100px
}

.heading-216 {
    color: var(--white);
    font-size: 52px;
    font-weight: 500;
    line-height: 1.2em
}

.button-36 {
    background-color: var(--pabloo-green);
    border-radius: 12px;
    padding: 16px 24px
}

.columns-8 {
    align-items: center;
    display: flex
}

.div-block-563 {
    margin-top: 24px
}

.div-block-564 {
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-565 {
    grid-column-gap: 32px;
    grid-row-gap: 8px;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    display: flex
}

.image-185 {
    height: 240px
}

.div-block-566 {
    margin-top: 0;
    margin-bottom: 0
}

.div-block-567 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--goldenrod);
    background-image: linear-gradient(345deg, #5a4df6 38%, var(--pabloo-green));
    border-radius: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    margin-top: 5%;
    padding: 12px;
    display: grid;
    position: relative
}

.text-block-250 {
    color: var(--white);
    margin-left: 4px;
    font-size: 20px;
    font-weight: 400
}

.button-37 {
    background-color: var(--black);
    color: var(--white);
    border-radius: 12px;
    padding: 12px 32px;
    font-weight: 500;
    transition: all .3s cubic-bezier(.42, 0, .515, 1.013)
}

.button-37:hover {
    background-color: var(--pabloo-green)
}

.optimize-hero {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62f2968d9aa17f2f1003b12c_ezgif.com-gif-maker%20\\(1\\).webp);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover
}

.text-block-251 {
    color: #fff
}

.text-block-251.text-align-center {
    text-align: left
}

.heading-218 {
    color: var(--white);
    text-align: left;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 44px;
    font-weight: 500;
    line-height: 1.2em
}

.div-block-570 {
    margin-top: 56px
}

.div-block-571 {
    grid-column-gap: 0px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: .25fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 10px;
    display: grid
}

.div-block-572 {
    background-color: var(--black);
    border-radius: 12px;
    display: flex
}

.div-block-573 {
    background-color: var(--goldenrod);
    border-radius: 100%;
    align-self: center;
    width: 16px;
    height: 16px;
    margin-left: -8px
}

.div-block-573.gray {
    background-color: var(--light-slate-grey)
}

.div-block-573.blue {
    background-color: #50b0ff
}

.div-block-574 {
    background-color: transparent;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    justify-content: center;
    align-items: center;
    padding: 24px 8px;
    display: flex
}

.div-block-575 {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
    display: flex
}

.text-block-252 {
    color: var(--white)
}

.image-186 {
    height: 50px
}

.div-block-576 {
    flex: 1 1
}

.text-block-253,
.text-block-254,
.text-block-255,
.text-block-256,
.text-block-257,
.text-block-258,
.text-block-260 {
    color: var(--white)
}

.div-block-577 {
    height: 120px
}

.div-block-578 {
    background-color: var(--white)
}

.div-block-579 {
    height: 120px
}

.div-block-580 {
    background-color: #7566ff;
    padding-top: 40px;
    padding-bottom: 120px
}

.text-block-261 {
    text-align: center;
    font-size: 24px;
    line-height: 1.6em
}

.div-block-581 {
    margin-top: 12px
}

.paragraph-124 {
    color: var(--white);
    text-align: center;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.6em
}

.bold-text-23 {
    color: var(--white)
}

.div-block-583 {
    background-color: var(--white-smoke);
    height: 64px
}

.div-block-584 {
    background-color: var(--white-smoke);
    padding-bottom: 120px
}

.div-block-585 {
    justify-content: center;
    margin-top: 32px;
    display: flex
}

.button-39 {
    background-color: var(--pabloo-green);
    border-radius: 12px;
    margin-left: auto;
    margin-right: auto;
    padding: 16px 40px;
    font-size: 20px;
    font-weight: 400
}

.text-span-209 {
    color: var(--pabloo-green)
}

.heading-219 {
    font-size: 48px;
    line-height: 1.2em
}

.div-block-586 {
    margin-bottom: 40px
}

.text-block-263 {
    margin-top: 16px;
    font-size: 18px;
    line-height: 1.4em
}

.div-block-587 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-587.hide {
    display: none
}

.text-block-264 {
    color: var(--pabloo-green);
    text-align: left;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2em
}

.section-48 {
    background-color: var(--white);
    padding-top: 100px;
    padding-bottom: 40px
}

.text-block-265 {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2em
}

.pabloo-offering-pointer {
    background-color: rgba(245, 205, 225, .28);
    border-radius: 4px;
    padding: 8px
}

.vendr-offering-pointer {
    background-color: #f3f7ff;
    border-radius: 4px;
    padding: 8px
}

.section-49 {
    background-color: var(--black);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61e91732e354a8764f6fdb08_Group%2023%20\\(2\\).svg);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: 76px;
    padding-top: 100px;
    padding-bottom: 100px
}

.heading-220 {
    color: var(--white);
    line-height: 1.2em
}

.text-block-266 {
    color: var(--white);
    margin-top: 16px
}

.div-block-589 {
    margin-bottom: 40px
}

.div-block-590 {
    grid-column-gap: 24px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-267 {
    color: #fff;
    text-transform: none;
    font-weight: 400
}

.text-block-268 {
    color: #fff;
    font-weight: 400;
    line-height: 1.2em
}

.div-block-591,
.div-block-592,
.div-block-593 {
    border-bottom: 1px solid rgba(255, 255, 255, .5);
    padding: 4px
}

.div-block-594 {
    align-items: center;
    padding: 4px;
    display: flex
}

.text-span-210 {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2em
}

.text-block-269,
.text-block-270 {
    color: var(--white);
    font-size: 32px;
    font-weight: 500;
    line-height: 1.2em
}

.heading-221 {
    margin-top: 0;
    font-size: 24px;
    font-weight: 400;
    line-height: 30px
}

.heading-222 {
    letter-spacing: -.5px;
    font-size: 3rem;
    font-weight: 700;
    line-height: 1.2em
}

.section-50 {
    background-color: var(--white);
    padding-top: 100px;
    padding-bottom: 100px
}

.div-block-595 {
    grid-column-gap: 48px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .75fr;
    grid-auto-columns: 1fr;
    align-items: start;
    display: grid
}

.section-51 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64d06f7e9279d16dce484b36_64a7e7a6656a76b25ff7b627_62f295f65cac0a38a49e99e4_ezgif.com-gif-maker.webp.png);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding-top: 48px;
    padding-bottom: 120px
}

.div-block-596 {
    padding-right: 40px
}

.heading-223 {
    text-align: center
}

.text-block-271 {
    text-align: center;
    margin-top: 16px
}

.div-block-597 {
    margin-bottom: 40px
}

.div-block-598 {
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex
}

.empty-state-10,
.empty-state-11 {
    background-color: var(--white)
}

.div-block-599,
.youtube-2 {
    margin-left: auto;
    margin-right: auto
}

.section-52 {
    background-color: var(--white);
    padding-top: 20px;
    padding-bottom: 120px
}

.div-block-600 {
    margin-top: 24px
}

.div-block-601 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 32px;
    display: grid
}

.div-block-602 {
    grid-column-gap: 0px;
    grid-row-gap: 16px;
    background-color: transparent;
    grid-template-rows: auto;
    grid-template-columns: 93% 1fr;
    grid-auto-columns: 1fr;
    margin-top: 12px;
    display: grid
}

.div-block-603 {
    background-color: var(--pabloo-green);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    height: 16px
}

.div-block-604 {
    background-color: var(--white-smoke);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    height: 16px
}

.div-block-605 {
    grid-column-gap: 0px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 87% 1fr;
    grid-auto-columns: 1fr;
    margin-top: 12px;
    display: grid
}

.div-block-605.xx {
    grid-template-columns: 83% 1fr
}

.div-block-606 {
    background-color: rgba(0, 0, 0, .24);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    height: 16px
}

.div-block-607 {
    margin-top: 24px
}

.section-53 {
    padding-top: 40px;
    padding-bottom: 40px
}

.div-block-608 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 40px;
    grid-auto-columns: 1fr;
    align-items: end;
    display: grid
}

.text-block-272 {
    font-size: 16px;
    line-height: 1em
}

.div-block-609 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 40px;
    grid-auto-columns: 1fr;
    align-items: end;
    display: grid
}

.text-block-273 {
    font-size: 16px;
    line-height: 1em
}

.div-block-610 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 40px;
    grid-auto-columns: 1fr;
    align-items: end;
    display: grid
}

.text-block-274 {
    font-size: 16px;
    line-height: 1em
}

.div-block-611 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 40px;
    grid-auto-columns: 1fr;
    align-items: end;
    display: grid
}

.text-block-275 {
    font-size: 16px;
    line-height: 1em
}

.div-block-612 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 40px;
    grid-auto-columns: 1fr;
    align-items: end;
    display: grid
}

.text-block-276 {
    font-size: 16px;
    line-height: 1em
}

.div-block-613 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 40px;
    grid-auto-columns: 1fr;
    align-items: end;
    display: grid
}

.text-block-277 {
    font-size: 16px;
    line-height: 1em
}

.section-54 {
    background-color: var(--slate-blue);
    padding-top: 100px;
    padding-bottom: 120px
}

.heading-224,
.text-block-278 {
    color: var(--white);
    text-align: center
}

.div-block-614 {
    margin-top: 24px
}

.div-block-615 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 32px;
    display: grid
}

.bold-text-24 {
    color: var(--white);
    font-size: 20px;
    line-height: 1.2em
}

.text-block-279 {
    color: var(--white);
    font-size: 14px;
    line-height: 1.4em
}

.div-block-616 {
    background-color: #6363ff;
    border-radius: 12px;
    padding: 24px 16px
}

.heading-226 {
    margin-top: 8px;
    margin-bottom: 20px
}

.text-span-213 {
    font-size: 48px
}

.text-block-280 {
    color: rgba(255, 255, 255, .74);
    font-size: 14px;
    line-height: 1.2em
}

.section-55 {
    background-color: var(--black);
    padding-top: 100px;
    padding-bottom: 100px
}

.heading-227 {
    color: var(--white);
    text-align: center;
    line-height: 1.2em
}

.text-span-214 {
    color: var(--pabloo-green)
}

.text-block-281 {
    color: var(--white);
    text-align: center;
    margin-top: 16px;
    font-size: 20px
}

.div-block-617 {
    margin-top: 32px;
    padding-top: 24px;
    padding-bottom: 24px
}

.div-block-618 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-619 {
    border: 2px none var(--light-pink);
    background-color: #1c1c1c;
    border-radius: 12px;
    padding: 20px
}

.heading-228 {
    color: var(--white);
    margin-top: 0;
    font-size: 23px;
    line-height: 1.2em
}

.paragraph-125,
.paragraph-126,
.paragraph-127 {
    color: rgba(255, 255, 255, .8);
    font-size: 18px;
    font-weight: 300;
    line-height: 1.4em
}

.paragraph-128 {
    color: var(--white);
    text-align: center;
    font-size: 24px;
    font-weight: 500
}

.div-block-620 {
    margin-top: 24px
}

.text-span-215 {
    color: var(--pabloo-green);
    font-weight: 700
}

.div-block-621 {
    background-color: var(--pabloo-green);
    border-top: 1px rgba(255, 255, 255, .4);
    border-radius: 12px;
    margin-top: 0;
    padding: 32px 24px 32px 32px
}

.heading-229 {
    color: var(--white);
    text-align: center;
    font-size: 56px;
    line-height: 1.2em
}

.div-block-622 {
    justify-content: center;
    margin-top: 40px;
    display: flex
}

.button-40 {
    background-color: var(--black);
    border-radius: 8px;
    padding: 16px 32px;
    font-size: 20px;
    font-weight: 500
}

.section-56 {
    background-color: var(--pabloo-green);
    padding-top: 40px;
    padding-bottom: 40px
}

.link-41 {
    color: var(--pabloo-green)
}

.link-42 {
    color: var(--pabloo-green);
    font-weight: 500
}

.div-block-623,
.div-block-624,
.div-block-625 {
    border-radius: 12px;
    padding: 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .1)
}

.heading-230,
.heading-231,
.heading-232 {
    color: var(--white);
    text-transform: capitalize;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 20px;
    line-height: 1.2em
}

.div-block-626 {
    background-color: var(--pabloo-green);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 16px 24px
}

.div-block-627 {
    padding: 16px 24px 24px
}

.div-block-628 {
    background-color: var(--pabloo-green);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 16px 24px
}

.div-block-629 {
    padding: 16px 24px 24px
}

.div-block-630 {
    background-color: var(--pabloo-green);
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 16px 24px
}

.div-block-631 {
    padding: 16px 24px 24px
}

.text-span-216,
.text-span-217 {
    color: var(--pabloo-green)
}

.div-block-632 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-632.hide {
    display: none
}

.div-block-633 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    margin-top: 16px;
    display: grid
}

.div-block-634,
.div-block-635 {
    border: 2px solid #000;
    border-radius: 16px;
    padding: 16px
}

.heading-233 {
    margin-top: 12px;
    margin-left: 24px
}

.heading-234 {
    color: var(--pabloo-green);
    margin-top: 12px;
    margin-left: 24px
}

.paragraph-129 {
    margin-bottom: 24px
}

.div-block-636 {
    margin-top: 16px;
    margin-bottom: 16px
}

.button-41 {
    background-color: var(--pabloo-green);
    text-align: center;
    border-radius: 8px;
    width: 100%;
    padding: 12px 16px;
    font-weight: 500
}

.button-42 {
    background-color: var(--black);
    text-align: center;
    border-radius: 8px;
    width: 100%;
    padding: 12px 16px;
    font-weight: 500
}

.div-block-637 {
    grid-column-gap: 6px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 20px 1fr;
    grid-auto-columns: 1fr;
    margin-bottom: 8px;
    display: grid
}

.text-block-282 {
    font-size: 16px;
    line-height: 1.2em
}

.image-187 {
    width: 100%;
    height: auto
}

.heading-235 {
    font-size: 36px;
    line-height: 1.2em
}

.div-block-638 {
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 32px;
    display: flex
}

.image-188 {
    height: 200px
}

.heading-236 {
    text-align: center;
    width: 100%
}

.div-block-639 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 12px;
    grid-template-rows: auto;
    grid-template-columns: 1.75fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 12px;
    display: grid
}

.div-block-639.hide {
    display: none
}

.image-189 {
    object-fit: cover;
    object-position: 50% 50%;
    border-top-right-radius: 11px;
    border-bottom-right-radius: 11px;
    height: 100%
}

.div-block-640 {
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 12px;
    display: flex
}

.div-block-641 {
    margin-top: 16px
}

.button-43 {
    background-color: var(--pabloo-green);
    border-radius: 8px;
    font-size: 16px
}

.heading-237 {
    font-size: 20px;
    line-height: 1.2em
}

.text-span-218 {
    color: var(--pabloo-green)
}

.heading-238 {
    color: #121212;
    text-align: center;
    margin-top: 0
}

.heading-238.white {
    color: var(--white)
}

.div-block-642 {
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 12px;
    margin-top: 12px;
    padding: 12px;
    display: none
}

.div-block-642.glass {
    background-color: rgba(255, 255, 255, .08);
    border-width: 1px;
    border-color: rgba(255, 255, 255, .13);
    display: none
}

.button-44 {
    background-color: var(--pabloo-green);
    text-align: center;
    border-radius: 8px;
    width: 100%
}

.div-block-643 {
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    flex-wrap: wrap;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 12px;
    margin-bottom: 12px;
    padding-left: 16px;
    padding-right: 16px;
    display: grid
}

.image-190 {
    height: 18px
}

.image-191,
.image-192,
.image-193,
.image-194 {
    height: 20px
}

.div-block-644 {
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 12px;
    margin-top: 48px;
    padding: 12px;
    position: relative
}

.div-block-645 {
    width: 25%;
    position: absolute;
    top: -32px;
    left: 37.5%
}

.image-195 {
    width: 100%;
    height: auto
}

.div-block-646 {
    margin-top: 40px;
    font-size: 18px
}

.text-block-283 {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.2em
}

.div-block-647 {
    margin-top: 16px
}

.paragraph-130 {
    color: var(--white);
    font-size: 18px;
    font-weight: 400;
    line-height: 1.4em
}

.div-block-648 {
    padding-right: 24px
}

.div-block-649 {
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    display: none
}

.lottie-animation {
    width: auto;
    height: 48px;
    margin-left: auto;
    margin-right: auto
}

.html-embed-26,
.html-embed-27 {
    opacity: .64
}

.image-196 {
    height: 48px
}

.div-block-650 {
    border: 4px solid #77f;
    border-radius: 22px;
    margin-left: 0;
    display: flex
}

.webinar-cta {
    background-color: var(--white);
    color: var(--black);
    border: 3px solid #9a9afd;
    border-radius: 12px;
    padding: 12px 24px;
    font-size: 18px;
    font-weight: 700
}

.webinar-cta.pink-border {
    border-color: #f358a5
}

.webinar-cta.pink-border.pink-text {
    color: var(--pabloo-green)
}

.div-block-651 {
    border: 4px solid #77f;
    border-radius: 22px
}

.button-45 {
    background-color: var(--pabloo-green);
    border: 3px solid #e571ab;
    border-radius: 12px;
    padding: 12px 24px;
    font-weight: 700
}

.container-1285 {
    background-color: #6060f7;
    border-radius: 20px;
    max-width: 1040px;
    padding-top: 64px;
    padding-bottom: 64px
}

.container-1286 {
    max-width: 1040px;
    padding-left: 50px;
    padding-right: 50px
}

.text-span-219 {
    color: var(--slate-blue)
}

.button-46 {
    background-color: var(--pabloo-green);
    border-radius: 12px;
    padding: 12px 32px;
    font-weight: 500
}

.div-block-652 {
    grid-column-gap: 12px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 28px 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid
}

.div-block-652.mt-sm {
    margin-top: 12px
}

.text-span-220 {
    color: var(--pabloo-green)
}

.div-block-653 {
    justify-content: flex-end;
    align-items: center;
    margin-top: 16px;
    display: flex
}

.div-block-656 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64d491cbb29dae8ffa766f7b_Background%20\\(1\\).jpg);
    background-position: 100% 100%;
    background-size: cover;
    border-radius: 10px;
    align-self: center;
    width: 600px;
    display: flex
}

.image-197 {
    padding: 20px
}

.div-block-657 {
    width: 30%
}

.div-block-658 {
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 70%;
    display: flex
}

.heading-239 {
    color: var(--white);
    font-size: 26px
}

.div-block-659 {
    position: absolute;
    top: 64px;
    right: -32px
}

.image-198 {
    height: 120px
}

.div-block-660 {
    margin-top: 32px;
    position: static;
    top: auto;
    bottom: -136px;
    left: -80px;
    right: auto
}

.image-199 {
    height: 200px
}

.div-block-661 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto auto 1fr;
    grid-auto-columns: 1fr;
    justify-items: start;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    display: grid
}

.image-200 {
    height: 24px
}

.text-block-285 {
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1em
}

.image-201 {
    height: 24px
}

.div-block-662 {
    justify-content: center;
    margin-top: 24px;
    display: flex
}

.text-span-221 {
    color: var(--pabloo-green)
}

.lottie-animation-2 {
    height: 48px;
    display: block
}

.div-block-663 {
    display: none
}

.div-block-664 {
    justify-content: center;
    margin-top: 32px;
    display: flex
}

.image-202 {
    width: auto;
    height: 200px
}

.banner-cta-blog {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64d491cbb29dae8ffa766f7b_Background%20\\(1\\).jpg);
    background-position: 50% 100%;
    background-size: 500px;
    border-radius: 10px;
    justify-content: space-between;
    align-self: center;
    width: 500px;
    padding: 20px;
    display: flex
}

.image-203 {
    width: 120px
}

.heading-240 {
    color: #fff
}

.div-block-665 {
    flex-direction: column;
    align-items: center;
    width: 70%;
    display: flex
}

.link-button-copy2 {
    background-color: var(--white);
    border: 2px #505144;
    border-radius: 10px;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 210px;
    margin: 10px 0 0;
    padding: 2px;
    display: flex;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0
}

.text-block-4 {
    justify-content: flex-start;
    align-self: center;
    align-items: center;
    margin: auto 50px auto 0;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
    text-decoration: none;
    display: flex;
    position: absolute
}

.div-block-7 {
    background-color: var(--black);
    border: 1px red;
    border-radius: 10px;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    width: 40px;
    min-width: auto;
    margin-left: 0;
    padding: 5px 10px;
    display: flex;
    position: static
}

.text-block-286 {
    color: var(--white);
    padding-right: 46px;
    font-weight: 500
}

.image-204 {
    width: 20px
}

.section-57 {
    background-color: #d53987;
    padding-top: 40px;
    padding-bottom: 40px
}

.section-58 {
    padding-top: 120px
}

.text-block-288 {
    color: #fff;
    font-weight: 500
}

.section-59 {
    padding-top: 80px;
    padding-bottom: 120px
}

.div-block-669 {
    display: flex;
    position: relative;
    overflow: visible
}

.div-block-670 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-671 {
    margin-left: 0%;
    margin-right: 0%;
    padding: 12px
}

.heading-241 {
    font-size: 3rem;
    font-weight: 500;
    line-height: 1.3em
}

.div-block-672 {
    background-color: rgba(255, 255, 255, .24);
    border: 6px solid rgba(255, 255, 255, .2);
    border-radius: 12px;
    padding: 12px
}

.div-block-673 {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .75fr;
    grid-auto-columns: 1fr;
    justify-content: flex-start;
    align-items: center;
    display: grid
}

.heading-242 {
    color: #fff;
    margin-bottom: 24px;
    font-size: 2.4rem;
    line-height: 1.2em
}

.div-block-674 {
    z-index: 2;
    width: 72%;
    position: absolute;
    top: auto;
    bottom: -20%;
    left: auto;
    right: -35%
}

.image-210 {
    filter: grayscale(29%)sepia(43%);
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, .12)
}

.case-study-hero-sub-heading {
    color: var(--black);
    font-size: 20px;
    font-weight: 400;
    line-height: 1.8em
}

.rich-text-block-28 {
    font-size: 20px;
    line-height: 1.8em
}

.div-block-677 {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex
}

.case-study-hero-heading-2 {
    font-size: 3rem;
    line-height: 1.2em
}

.div-block-679 {
    margin-top: 8px
}

.text-block-290 {
    color: #fff;
    text-transform: uppercase;
    font-size: .8rem;
    font-weight: 300;
    line-height: 1.3em
}

.section-60 {
    background-color: #000;
    padding-top: 40px;
    padding-bottom: 40px
}

.paragraph-133 {
    color: var(--black);
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4
}

.case-study-hero-heading-container {
    margin-top: 24px
}

.case-study-hero-container {
    width: 60%
}

.case-study-hero-logo {
    height: 48px
}

.div-block-681 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 60%;
    display: grid
}

.div-block-682 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: .25fr 1fr;
    grid-auto-columns: 1fr;
    margin-bottom: 40px;
    display: grid
}

.paragraph-134 {
    color: #fff;
    font-size: 20px;
    line-height: 1.8em
}

.case-study-hero-metrics-container {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: repeat(auto-fit, minmax(0, auto)) minmax(0, auto) minmax(0, auto);
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    justify-items: stretch;
    margin-top: 24px;
    display: grid
}

.text-block-293 {
    text-transform: uppercase;
    font-size: .8rem;
    line-height: 1.3em
}

.case-study-hero-section {
    background-image: linear-gradient(147deg, #fff, #fff 57%, #f5cde1);
    justify-content: flex-end;
    padding-top: 160px;
    padding-bottom: 80px;
    font-size: 18px;
    line-height: 28px;
    display: flex;
    overflow: hidden
}

.div-block-683 {
    margin-top: 24px
}

.div-block-686 {
    background-color: var(--white-smoke);
    outline-offset: 0px;
    border: 1px solid rgba(31, 31, 31, .06);
    border-radius: 8px;
    outline: 3px #000;
    margin-bottom: 48px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .12)
}

.image-212 {
    height: 42px
}

.navigation-link-10 {
    color: #000;
    letter-spacing: -.01em;
    white-space: nowrap;
    cursor: pointer;
    background-color: transparent;
    border-radius: 50px;
    padding: 12px 24px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-decoration: none;
    transition: all .35s
}

.navigation-link-10:hover {
    color: #d53987;
    background-color: #fff
}

.navigation-link-10.w--current {
    color: #d53987
}

.text-block-294 {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px
}

.text-span-222,
.text-span-224 {
    color: var(--pabloo-green)
}

.section-61 {
    background-color: var(--white-smoke);
    padding-top: 80px;
    padding-bottom: 80px
}

.div-block-687 {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto auto;
    grid-template-columns: .5fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-295 {
    margin-top: 16px
}

.image-213 {
    border: 2px solid #000;
    border-radius: 4px
}

.section-62 {
    padding-top: 80px;
    padding-bottom: 80px
}

.heading-244 {
    color: var(--pabloo-green);
    text-align: center;
    font-family: Satoshi, sans-serif;
    font-size: 40px;
    line-height: 1.4em
}

.div-block-689 {
    grid-column-gap: 40px;
    grid-row-gap: 56px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 64px;
    display: grid
}

.div-block-690 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-296 {
    text-align: center;
    font-size: 20px;
    font-weight: 700
}

.div-block-691 {
    justify-content: center;
    display: flex
}

.section-63 {
    background-color: var(--black-2);
    padding-top: 120px;
    padding-bottom: 120px
}

.heading-246 {
    color: var(--white);
    text-align: center;
    font-size: 40px;
    line-height: 1.4em
}

.div-block-692 {
    margin-top: 64px
}

.div-block-693 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    margin-bottom: 24px;
    display: grid
}

.text-block-297 {
    color: var(--white);
    font-weight: 700;
    line-height: 20px
}

.paragraph-136,
.paragraph-137,
.paragraph-138,
.paragraph-139 {
    color: var(--white)
}

.text-span-225 {
    color: var(--black)
}

.image-214 {
    height: 48px
}

.div-block-694 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: transparent;
    border-radius: 40px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-items: start;
    margin-top: 32px;
    padding: 4px 20px 4px 0;
    display: grid
}

.text-block-298 {
    color: var(--white);
    text-align: center;
    font-size: 20px;
    font-weight: 400
}

.div-block-695 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: #1f1f1f;
    border: 1px solid #2e2e2e;
    border-radius: 8px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid
}

.image-215,
.image-216 {
    height: 48px
}

.div-block-696 {
    border-left: 1px solid #2e2e2e
}

.div-block-697 {
    margin-top: 24px
}

.div-block-698 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr auto;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-700 {
    border-bottom: 1px solid #5a5a5a;
    width: 56px;
    height: 1px;
    margin-top: 4px;
    display: none
}

.div-block-701 {
    border-bottom: 1px solid rgba(255, 255, 255, .24);
    justify-content: center;
    width: 72%;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 16px;
    display: flex
}

.image-217,
.image-218 {
    height: 56px
}

.updated-page-wrapper {
    max-width: 100vw;
    color: var(--dark-violet);
    margin-top: 0;
    font-family: Inter, sans-serif;
    position: relative
}

.updated-page-wrapper.optimize {
    color: var(--white)
}

.reference-hero-section {
    background-color: var(--white-smoke);
    border-radius: 10px;
    width: 100%
}

.reference-hero-wrapper {
    text-align: center;
    flex-direction: column;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    display: flex
}

.reference-center-wrapper {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 620px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.reference-top-block {
    grid-column-gap: 16px;
    align-items: center;
    width: 100%;
    display: flex
}

.reference-block {
    grid-row-gap: 60px;
    flex-direction: column;
    width: 100%;
    display: flex
}

.colors-grid {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.reference-wrapper {
    grid-row-gap: 100px;
    flex-direction: column;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 120px;
    display: flex
}

.reference-bottom-block {
    width: 100%
}

.buttons-grid {
    grid-column-gap: 16px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    justify-items: start;
    width: 100%;
    display: grid
}

.color-box {
    background-color: #145aff;
    border-radius: 12px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    height: 150px;
    padding-bottom: 20px;
    padding-left: 20px;
    font-weight: 500;
    display: flex;
    position: relative
}

.color-box._5 {
    background-color: var(--soft-pink);
    color: #fff;
    margin-top: 0
}

.color-box._4 {
    background-color: var(--dark-violet);
    color: #031447;
    margin-top: 0
}

.color-box._1 {
    background-color: var(--pabloo-green);
    color: #fff
}

.color-box._3 {
    background-color: var(--magenta);
    color: #fff
}

.color-box._2 {
    background-color: var(--white);
    background-image: none;
    border: 1px solid rgba(0, 0, 0, .3)
}

.color-box._6 {
    background-color: var(--darker-violet);
    color: #fff;
    margin-top: 0
}

.reference-text {
    opacity: .6;
    flex: none;
    font-size: 16px
}

.sg-icon-contain {
    background-color: #dfd3ff;
    border-radius: 8px;
    flex-direction: column;
    flex: none;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 56px;
    display: flex
}

.sg-icon-contain.yellow {
    background-color: #fff964
}

.sg-icon-contain.salmon {
    background-color: #ffb199
}

.typography-item-description {
    margin-bottom: 16px
}

.reference-section {
    width: 100%
}

.typography-grid {
    grid-column-gap: 16px;
    grid-row-gap: 40px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.sg-icon {
    object-fit: contain;
    width: 32px;
    height: 32px
}

.heading-64px {
    letter-spacing: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 64px;
    font-weight: 800;
    line-height: 112.5%
}

.heading-64px.hero-home-heading {
    display: inline
}

.heading-64px.hero-home-heading.sales {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    transform: perspective(2000px)
}

.heading-64px.hero-home-heading.zapier,
.heading-64px.hero-home-heading.snow {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    position: absolute;
    transform: perspective(2000px)
}

.heading-64px.hero-home-heading.top {
    max-width: 515.278px
}

.heading-64px.hero-home-heading.bottom {
    z-index: 2;
    transition: all .2s;
    position: relative
}

.heading-64px.hero-home-heading.mail,
.heading-64px.hero-home-heading.inter,
.heading-64px.hero-home-heading.adobe,
.heading-64px.hero-home-heading.jira,
.heading-64px.hero-home-heading.hubspot,
.heading-64px.hero-home-heading.zendesk {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    position: absolute;
    transform: perspective(2000px)
}

.heading-64px.text-align-center {
    color: var(--black-2);
    text-align: center;
    margin-top: 15px;
    font-size: 52px
}

.heading-64px.text-align-center.integra {
    font-size: 46px
}

.heading-64px.text-align-center.integra.new {
    text-align: left
}

.heading-64px.blogs-hero-heading {
    text-align: center
}

.heading-64px.resource-hero-heading {
    color: var(--white);
    text-align: left
}

.heading-64px.saas-hero-heading,
.heading-64px.cloud-hero-heading {
    margin-bottom: 4px
}

.heading-64px.skewed {
    transform: rotate(-11deg)
}

.heading-64px.skewed.text-color-pink {
    color: var(--pabloo-green-2);
    margin-top: -16px;
    margin-left: 12px;
    margin-right: 12px
}

.heading-90px {
    letter-spacing: -3.6px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 90px;
    font-weight: 700;
    line-height: 124.444%
}

.heading-56px {
    letter-spacing: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 56px;
    font-weight: 800;
    line-height: 118.519%
}

.heading-56px.integrations-heading {
    margin-bottom: 16px
}

.heading-56px.integrations-heading._40px-bottom-margin {
    margin-bottom: 40px
}

.heading-56px.spend-heading {
    text-align: center;
    max-width: 800px
}

.heading-48px {
    margin-top: 0;
    margin-bottom: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 48px;
    font-weight: 800;
    line-height: 116.667%
}

.heading-48px.stack-heading {
    color: var(--white);
    text-align: center;
    max-width: 800px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto
}

.heading-48px.blogs-heading {
    text-align: center;
    max-width: 728px
}

.heading-48px.ctas-heading {
    color: var(--white);
    max-width: 580px;
    margin-bottom: 8px
}

.heading-48px.ctas-heading._16px-bottom-margin {
    margin-bottom: 16px
}

.heading-48px.blog-post-title {
    color: var(--dark-violet)
}

.heading-48px.blog-post-title.cms {
    color: #5b002c
}

.heading-48px.setup-heading {
    color: var(--white);
    text-align: center;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto
}

.heading-48px.points-heading {
    color: var(--white);
    max-width: 534px;
    margin-bottom: 24px
}

.heading-40px {
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 40px;
    font-weight: 800;
    line-height: 120%
}

.heading-40px.tribe-heading {
    max-width: 800px;
    padding-right: 0
}

.heading-40px.calculator-text-contain-heading {
    max-width: 459px;
    line-height: 110%
}

.heading-40px.spend-block-heading {
    font-family: Inter, sans-serif;
    font-weight: 600
}

.navigation-bar {
    z-index: 1000;
    background-color: var(--transparent);
    margin-top: 0;
    position: fixed;
    top: 0;
    bottom: auto;
    left: 0%;
    right: 0%
}

.navigation-bar.xt {
    display: none
}

.navbar-container {
    z-index: 2;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 16px;
    padding-bottom: 16px;
    display: flex;
    position: relative
}

.navbar-container.optimize {
    justify-content: space-between;
    align-items: center;
    padding-top: 32px;
    padding-bottom: 32px
}

.navigation-menu {
    margin-left: 20px;
    margin-right: auto;
    position: static
}

.navigation-menu.new {
    flex: 0 1 auto;
    margin-left: auto;
    margin-right: 20px
}

.navigation-menu.new.optimize {
    flex: 0 1 auto;
    order: 0;
    justify-content: flex-start;
    align-items: center;
    margin-left: 0;
    margin-right: 0;
    display: block
}

.nav-links-contain {
    grid-column-gap: 12px;
    grid-row-gap: 32px;
    align-items: center;
    display: flex
}

.nav-links-contain.new,
.nav-links-contain.new.adpage,
.nav-links-contain.new.adpage.optimize {
    justify-content: center;
    align-items: center
}

.navigation-link {
    color: var(--dark-violet);
    font-weight: 500;
    line-height: 118.75%;
    transition: color .3s ease-in-out
}

.navigation-link:hover {
    color: rgb(21 128 61)
}

.navigation-link.w--current {
    color: rgb(21 128 61)
}

.navigation-link.white {
    color: var(--white)
}

.navigation-link.white:hover {
    color: var(--light-pink)
}

.navigation-link.new {
    padding-left: 15px;
    padding-right: 15px
}

.navigation-link.new.optimize-community {
    color: var(--white)
}

.navbar-dropdown {
    background-color: rgba(255, 255, 255, 0);
    border-radius: 40px;
    font-size: 16px;
    line-height: 118.75%;
    position: static
}

.navbar-dropdown-toggle {
    grid-column-gap: 8px;
    align-items: center;
    padding: 20px 0;
    display: flex;
    position: static
}

.dropdown-lists {
    background-color: #fff
}

.dropdown-lists.w--open {
    background-color: rgba(255, 255, 255, 0);
    width: 104%;
    padding-top: 40px;
    top: 82px;
    bottom: auto;
    left: -2%;
    right: auto
}

.dropdown-lists.resources.w--open {
    left: -400px
}

.dropdown-links-contain {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)
}

.dropdown-links-contain.w--open {
    border-radius: 10px;
    box-shadow: 0 80px 100px rgba(28, 28, 31, .1)
}

.dropdown-links-contain.product {
    width: 100%;
    max-width: 1312px;
    padding: 32px;
    position: relative
}

.dropdown-links-contain.solutions {
    width: 321px;
    padding: 12px
}

.dropdown-links-contain.resources {
    width: 782px;
    padding: 12px
}

.dropdown-link {
    color: var(--dark-violet);
    transition: color .3s ease-in-out
}

.dropdown-link:hover {
    color: var(--pabloo-green)
}

.dropdown-link.w--current,
.dropdown-link.w--current:hover {
    color: #ff5757
}

.dropdown-arrow-embed {
    width: 12px;
    height: 19px
}

.dropdown-arrow-embed.mobile {
    display: none
}

.logo-contain {
    grid-column-gap: 5.95px;
    grid-row-gap: 5.95px;
    align-items: flex-end;
    height: 36px;
    display: flex
}

.logo-contain.footer-logo {
    grid-column-gap: 9px;
    grid-row-gap: 9px;
    height: 60px
}

.logo-bars-contain {
    flex: none;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: flex-end;
    height: 31.72px;
    margin-bottom: auto;
    display: flex;
    overflow: hidden
}

.logo-bars-contain.footer-bars {
    height: 55.54px
}

.logo-image {
    max-width: 125px
}

.logo-image.footer-logo {
    width: 209px;
    max-width: 209px
}

.logo-bar {
    width: 11px
}

.logo-bar.second {
    margin-left: -1px
}

.logo-bar.second.footer-bar {
    width: 19px;
    margin-left: -1.5px
}

.logo-bar.third {
    margin-left: -1px
}

.logo-bar.third.footer-bar {
    width: 19px;
    margin-left: -1.5px
}

.logo-bar.first.footer-bar {
    width: 19px
}

.navigation-button-contain {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    align-items: center;
    display: flex
}

.navigation-button-contain.out-menu {
    grid-column-gap: 20px;
    grid-row-gap: 20px
}

.navigation-button-contain.in-menu {
    display: none
}

.hero-home-section {
    background-color: var(--soft-pink);
    padding-top: 0;
    overflow: hidden;
}

@media (max-width: 768px) {
    .hero-home-section {
        background-color: var(--soft-pink);
        padding-top: 0;
        overflow: hidden;
        margin-top: -30px;
    }
}

.hero-home-section.padding-bottom-xl {
    overflow: hidden
}

.hero-home-section.padding-bottom-xl.abstract-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba19fb45f87422d52b2f2_Group%202085663950.svg);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: 100%
}

.hero-home-wrapper {
    z-index: 2;
    aspect-ratio: 16/9;
    color: var(--darker-violet);
    flex-flow: row;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    margin-top: -110px;
    margin-bottom: -140px;
    padding-top: 213px;
    padding-bottom: 118px;
    display: flex;
    position: relative
}

.hero-home-wrapper.new {
    padding-top: 220px;
    padding-bottom: 140px
}

.hero-home-wrapper.new.ads {
    padding-top: 180px
}

.transparent-arrow-button {
    color: var(--dark-violet);
    letter-spacing: -.16px;
    border: 2px solid rgba(36, 2, 19, .4);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    font-size: 18px;
    font-weight: 600;
    line-height: 122.222%;
    text-decoration: none;
    display: flex;
    position: relative;
    overflow: hidden
}

.transparent-arrow-button._16px {
    padding: 18px 24px;
    font-size: 16px;
    line-height: 118.75%
}

.transparent-arrow-button._16px.navigation {
    padding-left: 36px;
    padding-right: 36px
}

.transparent-arrow-button._16px.navigation.optimize-community {
    border-color: rgba(110, 110, 110, .5)
}

.transparent-arrow-button.integra {
    color: var(--white);
    -webkit-text-fill-color: inherit;
    background-color: transparent;
    background-clip: border-box;
    border-width: 2px;
    justify-content: center;
    align-items: center
}

.transparent-arrow-button.product {
    background-color: #fff;
    align-self: flex-start;
    padding-top: 10px;
    padding-bottom: 10px
}

.transparent-arrow-button.product:hover {
    border-color: var(--pabloo-green);
    background-color: var(--pabloo-green);
    color: var(--white)
}

.button-panel {
    background-color: rgba(36, 2, 19, .15);
    border-radius: 0;
    width: 0%
}

.button-panel.white {
    background-color: rgba(255, 255, 255, .1)
}

.button-text {
    z-index: 2;
    color: var(--white);
    -webkit-text-stroke-color: var(--dark-violet);
    font-weight: 700
}

.button-text.integra {
    color: var(--white);
    -webkit-text-stroke-color: var(--dark-violet)
}

.button-text.savings {
    color: var(--white)
}

.button-text.trans,
.button-text.nav {
    color: var(--dark-violet)
}

.button-text.nav.optimize-comm {
    color: #fff
}

.button-panels-contain {
    z-index: 1;
    color: var(--white);
    border-radius: 0;
    flex-direction: row;
    flex: 0 1 auto;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: space-around;
    width: 100%;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.button-text-wrapper {
    z-index: 2;
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    align-items: center;
    display: flex;
    position: relative
}

.button-text-wrapper.optimize-community {
    justify-content: center;
    align-items: flex-end
}

.button-arrow-embed {
    width: 6px;
    height: 19px
}

.button-arrow-embed._18px {
    color: var(--white);
    -webkit-text-stroke-color: var(--white);
    width: 10px;
    height: 19px
}

.button-arrow-embed:hover {
    color: var(--pabloo-green);
    -webkit-text-stroke-color: var(--pabloo-green);
}


.button-arrow-embed._18px.trans {
    color: var(--dark-violet)
}

.button-arrow-embed.resource {
    margin-top: 2px
}

.button-arrow-embed.downward {
    width: 18px
}

.button-arrow-embed._16px,
.button-arrow-embed._14px {
    width: 7px;
    height: 24px
}

.button-arrow-embed.trans.optimize {
    width: auto;
    height: auto
}

.hero-home-text-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    align-items: flex-start;
    width: 51%;
    max-width: 560px;
    /* padding-right: 22px; */
    display: flex
}

.hero-home-text-wrapper.new {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: none
}

.pink-heading-span {
    color: var(--pabloo-green)
}

.paragraph-18px {
    font-size: 18px;
    line-height: 156%
}

.paragraph-18px.hero-home-paragraph {
    color: var(--darker-violet);
    margin-bottom: 24px;
    padding-right: 41px
}

.paragraph-18px.hero-home-paragraph.new {
    text-align: center;
    width: 80%;
    margin-top: 25px;
    font-size: 22px
}

.paragraph-18px.hero-home-paragraph.new.x {
    font-size: 17px
}

.paragraph-18px.integrations-paragraph {
    margin-bottom: 40px
}

.paragraph-18px.stack-block-paragraph {
    color: var(--white)
}

.paragraph-18px.blog-post-summary._8px-bottom-margn {
    margin-bottom: 8px
}

.paragraph-18px.ctas-paragraph {
    color: var(--white);
    max-width: 600px;
    margin-bottom: 32px
}

.paragraph-18px.tribe-tab-paragraph {
    color: var(--dark-violet);
    font-weight: 400
}

.paragraph-18px.spend-block-paragraph {
    font-weight: 400
}

.paragraph-18px.spend-block-paragraph.new {
    font-weight: 400;
    display: block
}

.paragraph-18px.reviewer-position {
    opacity: .8;
    font-weight: 500
}

.paragraph-18px.calculator-toggle-text {
    font-weight: 700
}

.paragraph-18px.resource-post-description {
    color: #240213
}

.paragraph-18px.saas-hero-paragraph {
    max-width: 636px;
    margin-bottom: 24px
}

.paragraph-18px.cloud-hero-paragraph {
    max-width: 527px;
    margin-bottom: 24px
}

.paragraph-18px.navigation-header-link-text {
    font-family: Satoshi, sans-serif;
    font-weight: 700
}

.paragraph-18px.points-check-list-text {
    color: var(--white)
}

.pink-arrow-button {
    background-color: var(--pabloo-green);
    color: var(--white);
    letter-spacing: -.18px;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    font-weight: 600;
    line-height: 122.222%;
    text-decoration: none;
    display: flex;
    position: relative;
    overflow: hidden
}

.pink-arrow-button.ebook {
    width: 60%
}

.pink-arrow-button.ads {
    margin-top: 19px
}

.pink-arrow-button.new {
    padding-left: 88px;
    padding-right: 84px
}

.stats-section {
    width: 100%;
    margin-top: 103px;
    padding-top: 0
}

.stats-wrapper {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    padding-top: 17px;
    padding-bottom: 100px;
    display: flex
}

.stats-grid {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    width: 90%;
    max-width: 1188px;
    margin-top: 60px;
    margin-left: auto;
    margin-right: auto
}

.stats-block {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    border-radius: 16px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 28px 28px 20px;
    display: flex
}

.stats-block.first {
    background-image: linear-gradient(135deg, #fff4dc, #f0deb5);
    padding-bottom: 28px
}

.stats-block.second {
    background-image: linear-gradient(135deg, #ddfbf7, #ace7df)
}

.stats-block.third {
    background-image: linear-gradient(135deg, #fbeded, #e6c5c6)
}

.stats-bottom-block {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.heading-24px {
    font-size: 24px;
    line-height: 133.333%
}

.heading-24px.stats-text {
    margin-bottom: 4px;
    font-weight: 500
}

.heading-24px.type-card-subheading {
    font-weight: 600
}

.heading-24px.stack-block-heading {
    margin-right: auto;
    font-weight: 600
}

.heading-24px.blog-post-title {
    font-weight: 600
}

.heading-24px.blog-post-title.resource-feature {
    color: var(--white);
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 700
}

.heading-24px.footer-logo-subtext {
    font-weight: 500
}

.heading-24px.tribe-link-heading {
    color: var(--dark-violet)
}

.heading-24px.review-text {
    letter-spacing: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 800
}

.heading-24px.resource-tab-heading {
    font-weight: 600
}

.heading-24px.setup-card-text {
    max-width: 230px;
    font-size: 20px
}

.heading-24px.navigation-header-heading {
    font-family: Satoshi, sans-serif
}

.stats-icon-contain {
    background-color: rgba(36, 2, 19, .08);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 48px;
    display: flex
}

.stats-icon-embed {
    width: 24px;
    height: 24px
}

.stats-gradient-block {
    background-image: linear-gradient(135deg, rgba(6, 19, 27, .1), rgba(6, 19, 27, .04));
    border-radius: 16px;
    padding: 2px
}

.stats-gradient-block.second {
    background-color: var(--transparent);
    background-image: linear-gradient(135deg, rgba(19, 86, 101, .1), rgba(19, 86, 101, .2))
}

.stats-gradient-block.third {
    background-image: linear-gradient(135deg, rgba(72, 33, 53, .08), rgba(72, 33, 53, .16))
}

.seo-page-hero {
    background-color: #fdf2ea;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/65280657811f4e02dda60f95_Background.png);
    background-repeat: no-repeat;
    background-size: cover;
    padding: 8rem 40px 80px
}

.div-block-702 {
    padding-top: 16px;
    padding-bottom: 24px;
    display: block
}

.html-embed-28 {
    text-align: left;
    font-family: P22 Mackinacpro, sans-serif
}

.paragraph-140 {
    text-align: center;
    font-family: Satoshi, sans-serif;
    font-weight: 400
}

.div-block-703 {
    padding: 24px 10%
}

.logos-main-wrapper {
    background-color: var(--transparent);
    width: 100%;
    margin-bottom: 40px;
    position: relative
}

.splide {
    position: relative
}

.splide__track {
    display: flex;
    position: relative
}

.splide__list {
    flex: none;
    display: flex;
    position: relative
}

.logo-image-contain {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 214px;
    height: 40px;
    display: flex;
    position: relative
}

.logo-tain-image {
    z-index: 1;
    opacity: 1;
    object-fit: contain;
    flex: 0 1 auto;
    height: 100%;
    position: relative
}

.logo-tain-image.puuffco {
    opacity: .72
}

.logo-colour-overlay {
    z-index: 2;
    background-color: var(--white);
    mix-blend-mode: color;
    display: block;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.logo-colour-overlay.new {
    background-color: var(--soft-pink)
}

.type-cards-section {
    background-color: #18020d;
    width: 100%;
    overflow: hidden
}

.type-cards-wrapper {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529beaffd19962a33ef44ed_Type%20Bg.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 100px
}

.type-cards-grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto
}

.type-card-block {
    border-radius: 20px;
    width: 100%;
    padding-top: 36px;
    padding-bottom: 36px;
    overflow: hidden
}

.type-card-block.first {
    background-color: var(--transparent);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529bf430cb2a8e1a63b75a1_Type%20Card%20Bg.svg), linear-gradient(135deg, #fff4dc, #f1dfb8);
    background-position: 50% 100%, 0 0;
    background-size: cover, auto;
    padding-bottom: 45px;
    padding-left: 0;
    padding-right: 0
}

.type-card-block.second {
    background-color: var(--transparent);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529bf430cb2a8e1a63b75a1_Type%20Card%20Bg.svg), linear-gradient(135deg, #fbedee, #e7c7c8);
    background-position: 50% 100%, 0 0;
    background-size: cover, auto;
    padding-bottom: 50px;
    padding-left: 0;
    padding-right: 0
}

.type-card-top-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-left: 36px;
    padding-right: 36px;
    display: flex
}

.type-card-heading-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    align-items: center;
    margin-bottom: 16px;
    display: flex
}

.type-card-icon-contain {
    background-image: linear-gradient(135deg, #fffefc, #fffaf0);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    display: flex
}

.type-card-icon-embed {
    width: 36px;
    height: 36px
}

.heading-28px {
    font-size: 28px;
    font-weight: 800;
    line-height: 128.571%;

    font-family: P22 Mackinacpro, sans-serif;
}

.heading-28px.type-card-heading {
    max-width: 483px;
    margin-bottom: 20px
}

.heading-28px.ctas-subheading {
    color: #f7e8c7;
    margin-bottom: 20px
}

.section-64 {
    padding-top: 80px;
    padding-bottom: 80px
}

.div-block-704 {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 2.5fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-705 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.paragraph-141 {
    margin-top: 16px;
    font-family: Satoshi, sans-serif;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.6em
}

.heading-248 {
    font-family: P22 Mackinacpro, sans-serif
}

.div-block-706 {
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, .14)
}

.image-219 {
    object-fit: contain;
    border-radius: 8px;
    width: 80px;
    height: 80px
}

.div-block-707 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/652927f9e4171f39a0535818_Rectangle%2034624776.png);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: auto 100%;
    margin-top: 40px;
    padding: 48px
}

.div-block-708 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: .25fr 1fr;
    grid-auto-columns: 1fr;
    padding: 16px 32px;
    display: grid
}

.text-block-300 {
    margin-top: 8px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 56px;
    font-weight: 700;
    line-height: 56px
}

.div-block-709 {
    justify-content: center;
    align-items: center;
    padding: 32px 16px;
    display: flex
}

.heading-249 {
    margin-top: 8px;
    margin-bottom: 4px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 32px;
    line-height: 1.2em
}

.paragraph-142 {
    color: #7a8391;
    font-family: Satoshi, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.6em
}

.div-block-710 {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, .1)
}

.div-block-711 {
    border-top: 1px solid rgba(0, 0, 0, .4);
    padding: 16px 32px 32px
}

.div-block-712 {
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-712.n-1 {
    margin-top: 16px
}

.div-block-713 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 2.75fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-714 {
    background-color: #eee;
    border-radius: 8px;
    width: 100%;
    display: flex
}

.div-block-715 {
    background-color: #280015;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    width: 50%;
    height: 10px
}

.div-block-716 {
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-716.n-1 {
    margin-top: 24px
}

.text-block-301 {
    color: rgba(51, 65, 85, .65);
    text-transform: uppercase;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 600
}

.div-block-717 {
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    grid-template-rows: auto;
    grid-template-columns: auto auto;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-717.new {
    display: flex
}

.text-block-302 {
    color: var(--pabloo-green);
    flex: 0 1 auto;
    font-weight: 500
}

.div-block-718 {
    display: flex
}

.link-n-1 {
    margin-left: 8px
}

.div-block-719 {
    border-left: 1px solid #f4dfe0;
    padding-top: 32px;
    padding-left: 40px
}

.section-65 {
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-720 {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    grid-template-rows: auto;
    grid-template-columns: .75fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-721 {
    background-image: linear-gradient(#fff4dc, #f0deb5);
    border: 1px solid #fdf1d6;
    border-radius: 16px;
    padding: 40px 32px 40px 40px
}

.link-block-36 {
    align-items: center;
    margin-top: 20px;
    display: flex
}

.html-embed-29 {
    margin-left: 8px
}

.text-block-303 {
    line-height: 18px;
    /* text-decoration: none */
}

.div-block-722 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid
}

.collection-list-7 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.heading-250 {
    margin-top: 0;
    margin-bottom: 0;
    font-size: 22px
}

.div-block-724 {
    margin-top: 20px
}

.div-block-725 {
    border-radius: 10px;
    padding: 16px;
    box-shadow: 3px 0 16px rgba(0, 0, 0, .12)
}

.paragraph-143 {
    font-size: 16px;
    line-height: 23px
}

.image-220 {
    height: 36px
}

.div-block-726 {
    padding-top: 8px
}

.section-66 {
    background-color: var(--dark-violet);
    padding-top: 120px;
    padding-bottom: 120px
}

.div-block-727 {
    grid-column-gap: 56px;
    grid-row-gap: 56px;
    grid-template-rows: auto;
    grid-template-columns: 1.5fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.heading-251 {
    color: var(--white);
    font-family: P22 Mackinacpro, sans-serif
}

.paragraph-144 {
    color: var(--white);
    margin-top: 20px
}

.div-block-728 {
    background-color: #fff;
    border-radius: 10px;
    padding: 16px 20px
}

.arrow-text-link {
    grid-column-gap: 8px;
    grid-row-gap: 4px;
    color: var(--dark-violet);
    cursor: pointer;
    flex-direction: column;
    align-items: flex-end;
    font-weight: 600;
    line-height: 155.556%;
    display: flex;
    overflow: hidden
}

.arrow-text-link.white {
    color: var(--white)
}

.arrow-text-link.white.hide {
    display: none
}

.arrow-text-link.resource {
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    color: var(--pabloo-green);
    font-size: 14px
}

.arrow-text-link.pink {
    color: var(--pabloo-green)
}

.arrow-text-link._14px {
    font-size: 14px
}

.arrow-text-link.menu {
    color: var(--pabloo-green)
}

.arrow-text-link.cream {
    color: var(--cream)
}

.arrow-text-link-top-contain {
    grid-column-gap: 8px;
    align-items: center;
    display: flex
}

.arrow-wrapper {
    height: 24px;
    overflow: hidden
}

.text-link-underline {
    background-color: var(--dark-violet);
    width: 100%;
    height: 2px
}

.text-link-underline.pink {
    background-color: var(--pabloo-green)
}

.text-link-underline.white {
    background-color: var(--white)
}

.text-link-underline.cream {
    background-color: var(--cream)
}

.type-cards-train-container {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex-direction: column;
    margin-top: 28px;
    margin-bottom: 42px;
    display: flex
}

.type-cards-train-container.vertical {
    margin-bottom: 58px;
    padding-left: 34px;
    padding-right: 34px
}

.type-cards-train-wrapper {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-direction: row;
    display: flex
}

.type-cards-train-wrapper.vertical {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex-direction: column
}

.type-cards-train-card {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex: none;
    align-items: center;
    display: flex
}

.type-card-checkmark {
    color: #5e4146;
    flex: none;
    width: 20px;
    height: 20px
}

.type-card-images-grid {
    align-items: end;
    width: 90%;
    max-width: 563px;
    margin-left: auto;
    margin-right: auto
}

.type-card-grid-image {
    width: 100%
}

.type-card-grid-image.shadow {
    box-shadow: 0 9px 77px rgba(36, 2, 19, .08)
}

.type-card-image-contain {
    width: 90%;
    max-width: 520px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.integrations-section {
    width: 100%;
    overflow: hidden
}

.integrations-wrapper {
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1240px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 140px;
    padding-bottom: 120px;
    display: flex
}

.integrations-wrapper.cloud {
    padding-top: 80px;
    padding-bottom: 80px
}

.integrations-text-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 45%;
    max-width: 514px;
    display: flex
}

.integrations-image-contain {
    width: 50%;
    max-width: 613px
}

.calculator-section {
    background-color: var(--soft-pink);
    position: relative;
    overflow: hidden
}

.calculator-container {
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1240px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 40px;
    padding-bottom: 40px;
    display: flex
}

.calculator-container.confined {
    width: 94%;
    max-width: 100%
}

.calculator-left {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: column;
    align-items: flex-start;
    width: 48%;
    max-width: 651px;
    display: flex
}

.calc-arrow-image {
    flex: none;
    width: 100%;
    max-width: 306px;
    display: none;
    position: absolute;
    top: auto;
    bottom: auto;
    left: auto;
    right: -22%
}

.stack-section {
    background-color: var(--dark-violet);
    width: 100%;
    overflow: hidden
}

.stack-wrapper {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 120px
}

.stack-wrapper-contain {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529cb39722f7ce55df781c6_Stack%20Bg.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto
}

.stack-span {
    color: #f7e8c7
}

.stack-tabs-menu {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 60px;
    display: flex
}

.stack-tab-link {
    background-color: var(--transparent);
    color: #f7e8c7;
    min-width: 230px;
    padding: 0
}

.stack-tab-link.w--current {
    background-color: var(--transparent)
}

.stack-tab-link-wrapper {
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    flex-direction: column;
    width: 100%;
    display: flex
}

.stack-tab-link-header {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    display: flex
}

.stack-tab-link-header:hover {
    color: none;
}

.stack-tab-link-icon {
    width: 28px;
    height: 28px
}

.stack-tab-link-progress-bar-contain {
    background-color: rgba(246, 244, 241, .2);
    border-radius: 80px;
    width: 100%;
    height: 8px;
    position: relative
}

.paragraph-20px {
    font-size: 20px;
    line-height: 140%
}

.paragraph-20px.stack-tab-link-text {
    /* color: var(--white) */
}

.paragraph-20px.stack-tab-link-text:hover {
    color: var(--pabloo-green)
}

.paragraph-20px.footer-column-subheading {
    opacity: .5;
    letter-spacing: .4px;
    text-transform: uppercase;
    margin-bottom: 4px;
    font-weight: 600
}

.paragraph-20px.footer-link {
    font-weight: 500
}

.paragraph-20px.footer-link.dark {
    color: #ccc
}

.paragraph-20px.reviewer-name {
    font-weight: 600
}

.paragraph-20px.author-name {
    font-weight: 700
}

.paragraph-20px.author-position {
    opacity: .6;
    font-weight: 500
}

.paragraph-20px.resource-post-heading {
    color: #240213;
    letter-spacing: 0
}

.paragraph-20px.blog-tag-radio-button-label {
    text-transform: capitalize;
    margin-bottom: 10px;
    padding-left: 30px;
    padding-right: 30px;
    font-family: Satoshi, sans-serif;
    font-weight: 500
}

.paragraph-20px.navigation-block-heading {
    font-weight: 600
}

.stack-tab-info-contain {
    width: 100%
}

.stack-blocks-grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto
}

.stack-block {
    border-radius: 16px;
    width: 100%;
    padding: 32px 32px 29px
}

.stack-block.a-first {
    background-color: rgba(255, 255, 255, .2);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529d3e06af926707aa8b658_Stack%20Bg%201.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover
}

.stack-block.a-second {
    background-color: var(--pabloo-green);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529d3e06af926707aa8b658_Stack%20Bg%201.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover
}

.stack-block.d-first {
    background-color: rgba(255, 255, 255, .2);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529d3e06af926707aa8b658_Stack%20Bg%201.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    padding-left: 19px;
    padding-right: 22px
}

.stack-block-top-wrapper {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.stack-block-top-wrapper.before-d {
    padding-left: 13px;
    padding-right: 10px
}

.stack-block-header {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    color: var(--white);
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.stack-block-icon {
    width: 32px;
    height: 32px
}

.stack-block-image-contain {
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.stack-block-image-contain.a-first {
    max-width: 556px;
    margin-top: 34px;
    padding-bottom: 3px
}

.stack-block-image-contain.a-second {
    max-width: 556px;
    margin-top: 32px;
    padding-bottom: 1px
}

.stack-block-image-contain.b-first {
    max-width: 537px;
    margin-top: 109px;
    padding-bottom: 39px
}

.stack-block-image-contain.c-first {
    max-width: 530px;
    margin-top: 67px;
    padding-bottom: 13px
}

.stack-block-image-contain.c-second {
    max-width: 511px;
    margin-top: 67px;
    padding-bottom: 34px
}

.stack-block-image-contain.b-second {
    max-width: 493px;
    margin-top: 39px;
    padding-bottom: 13px
}

.stack-block-image-contain.d-second {
    max-width: 552px;
    margin-top: 74px;
    padding-bottom: 11px
}

.stack-block-image-contain.d-first {
    max-width: 579px;
    margin-top: 27px;
    padding-bottom: 37px
}

.stack-block-image {
    width: 100%
}

.stack-block-image.shadow {
    box-shadow: 0 14px 73px rgba(0, 0, 0, .05)
}

.stack-tabs {
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.stack-tab-progress-bar {
    background-color: var(--white);
    border-radius: 80px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto
}

.blogs-section {
    width: 100%;
    overflow: hidden
}

.blogs-wrapper {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    flex-direction: column;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 140px;
    display: flex
}

.blogs-container {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.blogs-container.new {
    display: block
}

.blogs-collection-list-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: block
}

.blogs-collection-list {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.blogs-collection-list.grid {
    grid-column-gap: 36px;
    grid-row-gap: 36px;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.blogs-collection-list._3-column-grid {
    grid-column-gap: 40px;
    grid-row-gap: 60px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.blogs-collection-list.blog-page {
    grid-template-columns: 1fr
}

.blogs-collection-item {
    width: 100%
}

.blog-post-wrapper {
    grid-column-gap: 28px;
    grid-row-gap: 28px;
    color: var(--dark-violet);
    flex-direction: column;
    width: 100%;
    display: flex
}

.blog-post-wrapper.featured {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    background-color: #fff;
    border-radius: 20px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-shadow: 0 20px 100px rgba(36, 2, 19, .08)
}

.blog-post-wrapper._16px-gap,
.blog-post-wrapper.resource-hero {
    grid-column-gap: 16px;
    grid-row-gap: 16px
}

.blog-post-wrapper.load-list {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    border-radius: 10px;
    transition: all .3s cubic-bezier(.445, .05, .55, .95)
}

.blog-post-wrapper.load-list:hover {
    color: #b33071;
    transform: translateY(-10px)
}

.blog-post-image-wrapper {
    border-radius: 16px;
    width: 100%;
    height: 400px;
    overflow: hidden
}

.blog-post-image-wrapper.featured {
    height: 400px;
    margin-top: 0
}

.blog-post-image-wrapper.featured.blog-page {
    width: 53%
}

.blog-post-image-wrapper.featured.cms {
    width: 45%;
    max-width: 580px;
    height: 420px
}

.blog-post-image-wrapper.featured.resources-hero {
    height: 365px
}

.blog-post-image-wrapper._300px {
    height: 300px
}

.blog-post-info-wrapper {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 41px;
    display: flex
}

.blog-post-info-wrapper.featured {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    width: 43%
}

.blog-post-info-wrapper.cms {
    width: 50%;
    max-width: 620px
}

.blog-post-info-wrapper.resource-hero {
    grid-column-gap: 24px;
    grid-row-gap: 24px
}

.paragraph-16px {
    font-size: 16px;
    line-height: 125%
}

.paragraph-16px.blog-category-text {
    color: var(--pabloo-green);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    background-color: rgba(213, 57, 135, .12);
    border-radius: 8px;
    margin-bottom: 4px;
    padding: 6px 16px;
    font-weight: 600
}

.paragraph-16px.blog-category-text.no-bottom-margin {
    margin-bottom: 0
}

.paragraph-16px.blog-category-text.only-text {
    background-color: rgba(213, 57, 135, 0);
    border-radius: 0;
    margin-bottom: 0;
    padding: 0
}

.paragraph-16px.blog-category-text.date {
    color: #5b002c;
    background-color: rgba(213, 57, 135, 0);
    border-radius: 0;
    margin-bottom: 0;
    padding: 0
}

.paragraph-16px.navigation-header-text {
    font-weight: 500
}

.paragraph-16px.dropdown-link {
    margin-left: 0;
    margin-right: 0;
    padding: 0
}

.paragraph-16px.dropdown-link.highlight {
    color: var(--pabloo-green);
    font-weight: 500
}

.paragraph-16px.dropdown-link.highlight:hover {
    color: var(--darker-violet)
}

.paragraph-16px.pink-subheading {
    color: var(--pabloo-green);
    letter-spacing: 1.2px;
    text-transform: uppercase;
    font-weight: 600
}

.paragraph-16px.copyright-paragraph {
    text-align: center
}

.paragraph-16px.privacy-link {
    color: var(--black);
    text-decoration: none
}

.paragraph-16px.privacy-link.dark {
    color: #ccc
}

.paragraph-16px.dropdown-block-link-text {
    margin-left: 0;
    margin-right: 0;
    padding: 0
}

.paragraph-16px.dropdown-block-link-text.highlight {
    color: var(--pabloo-green);
    font-weight: 500
}

.paragraph-16px.dropdown-block-link-text.highlight:hover {
    color: var(--darker-violet)
}

.paragraph-16px.navigation-subheading {
    letter-spacing: 1.2px;
    text-transform: none;
    font-weight: 600
}

.paragraph-16px.navigation-block-description {
    color: var(--dark-violet);
    margin-bottom: 12px;
    line-height: 150%
}

.paragraph-16px.dropdown-block-link-description {
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    font-family: Satoshi, sans-serif;
    font-weight: 400
}

.paragraph-16px.dropdown-block-link-description.highlight {
    color: var(--pabloo-green);
    font-weight: 500
}

.paragraph-16px.dropdown-block-link-description.highlight:hover {
    color: var(--darker-violet)
}

.paragraph-16px.dropdown-block-link-heading {
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    font-weight: 600;
    line-height: 100%
}

.paragraph-16px.dropdown-block-link-heading.highlight {
    color: var(--pabloo-green);
    font-weight: 500
}

.paragraph-16px.dropdown-block-link-heading.highlight:hover {
    color: var(--darker-violet)
}

.heading-32px {
    letter-spacing: 0;
    font-size: 32px;
    font-weight: 600;
    line-height: 118.75%
}

.heading-32px.blog-sticky-heading {
    margin-top: 24px;
    margin-bottom: 24px;
    font-weight: 700
}

.heading-32px.review-text {
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 800;
    line-height: 125%
}

.blog-post-image {
    object-fit: cover;
    width: 100%;
    height: 100%;
    display: inline-block
}

.blog-post-image.featured {
    object-position: 0% 50%
}

.empty-states {
    color: var(--pabloo-green);
    text-align: center;
    background-color: rgba(213, 57, 135, .08);
    border-radius: 8px;
    padding: 14px;
    font-weight: 500
}

.empty-states.hidden {
    display: none
}

.solutions-overview-sec {
    background-color: var(--darker-violet);
    width: 100%;
    overflow: hidden
}

.ctas-wrapper {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529ed3e13ed5242e06f6cc0_CTA%20Bg.svg);
    background-position: 0 0;
    background-size: auto;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto
}

.ctas-container {
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 84px;
    padding-bottom: 95px;
    display: flex
}

.ctas-text-wrapper {
    flex-direction: column;
    align-items: flex-start;
    width: 52%;
    max-width: 607px;
    display: flex
}

.ctas-text-wrapper._50 {
    width: 50%
}

.ctas-button-contain {
    grid-column-gap: 18px;
    grid-row-gap: 18px;
    flex-wrap: wrap;
    display: flex
}

.transparent-white-arrow-button {
    color: var(--white);
    letter-spacing: -.16px;
    border: 2px solid rgba(255, 255, 255, .32);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    font-size: 18px;
    font-weight: 600;
    line-height: 122.222%;
    text-decoration: none;
    display: flex;
    position: relative;
    overflow: hidden
}

.transparent-white-arrow-button._16px {
    padding: 22px 28px;
    font-size: 16px;
    line-height: 118.75%
}

.footer-section {
    background-color: #fff;
    width: 100%;
    overflow: hidden
}

.footer-section.new.dark {
    background-color: transparent
}

.footer-wrapper {
    grid-column-gap: 50px;
    grid-row-gap: 50px;
    flex-direction: column;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 80px;
    padding-bottom: 40px;
    display: flex
}

.footer-wrapper.new {
    padding-bottom: 40px
}

.footer-top-container {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.footer-logo-header {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.brand-logos-contain {
    background-image: linear-gradient(135deg, rgba(6, 19, 27, .05), rgba(6, 19, 27, .1));
    border-radius: 100px;
    padding: 2px
}

.brand-logos-wrapper {
    background-image: linear-gradient(135deg, #fff, #fbfbfb);
    border-radius: 100px;
    width: 100%;
    padding: 15px 16px 15px 19px
}

.brand-logo.first {
    width: 73px;
    margin-right: 14px
}

.brand-logo.second {
    width: 77px;
    margin-right: 21px
}

.brand-logo.third {
    width: 80px
}

.footer-divider {
    background-color: var(--dark-violet);
    opacity: .12;
    width: 100%;
    height: 1px;
    /* margin-bottom: 30px */
}

@media screen and (max-width:767px) {
    .footer-divider {
        background-color: var(--dark-violet);
        opacity: .12;
        width: 100%;
        height: 1px;
        margin-bottom: 30px
    }
}


.footer-divider.socials.dark {
    background-color: var(--white)
}

.footer-links-wrapper {
    grid-column-gap: 50px;
    grid-row-gap: 50px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .5fr .75fr .75fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: space-between;
    width: 100%;
    display: grid
}

.footer-links-column {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    display: flex
}

.footer-links-column.first {
    max-width: 180px
}

.footer-links-column.second {
    max-width: 106px
}

.footer-links-column.third {
    max-width: 127px
}

.footer-links-column.fourth {
    max-width: 148px
}

.footer-links-column.fifth {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-flow: column;
    flex: none;
    align-items: flex-start;
    max-width: 240px
}

.footer-links-column.fifth.new {
    flex-flow: wrap;
    justify-content: center;
    align-items: flex-start
}

.footer-link-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    color: var(--dark-violet);
    flex: 0 1 auto;
    align-items: center;
    transition: color .3s ease-in-out;
    display: flex
}

.footer-link-wrapper:hover {
    color: rgb(21 128 61)
}

.footer-link-wrapper.help {
    display: none
}

.footer-link-wrapper.dark {
    color: #ccc
}

.footer-link-icon {
    width: 24px;
    height: 24px
}

.tribe-section {
    width: 100%;
    overflow: hidden
}

.tribe-wrapper {
    flex-direction: column;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 20px;
    display: flex
}

.tribe-wrapper.about {
    padding-top: 40px;
    padding-bottom: 40px
}

.tribe-tabs {
    flex-direction: row-reverse;
    align-items: center;
    width: 100%;
    display: flex
}

.tribe-tabs-content {
    width: 50%;
    max-width: 696px;
    margin-right: auto;
    overflow: visible
}

.tribe-tabs-menu {
    flex-direction: column;
    width: 40%;
    max-width: 464px;
    display: flex
}

.tribe-tabs-menu.about {
    width: 55%;
    max-width: 564px
}

.tribe-tab-link {
    background-color: rgba(255, 255, 255, 0);
    padding: 0
}

.tribe-tab-link.w--current {
    background-color: rgba(255, 255, 255, 0)
}

.tribe-tab-link-info-wrapper {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    width: 100%;
    display: flex
}

.tribe-progress-bar-contain {
    background-color: #f4dfe0;
    border-radius: 20px;
    flex: none;
    width: 4px
}

.tribe-tab-content-wrapper {
    padding-top: 2px;
    padding-bottom: 2px
}

.tribe-tab-headings-contain {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    display: flex
}

.tribe-tab-icon-contain {
    background-image: linear-gradient(135deg, rgba(72, 33, 53, .1), rgba(72, 33, 53, .15));
    border-radius: 50%;
    width: 60px;
    height: 60px;
    padding: 1px
}

.tribe-tab-icon-wrapper {
    color: var(--dark-violet);
    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: flex
}

.tribe-tab-icon-embed {
    width: 36px;
    height: 36px
}

.tribe-tab-progress-bar {
    background-color: var(--dark-violet);
    border-radius: 20px;
    width: 100%;
    height: 0%
}

.tribe-tab-image-contain {
    width: 100%;
    padding-top: 57px;
    padding-bottom: 57px;
    display: flex;
    position: relative
}

.tribe-tab-background-gradient-contain {
    z-index: 1;
    background-image: linear-gradient(rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));
    border-radius: 16px;
    width: 60%;
    padding: 1px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto
}

.tribe-tab-background-gradient {
    /*background-image: linear-gradient(135deg, #fbeded, #FEC45B);*/
    border-radius: 16px;
    width: 100%;
    height: 100%
}

.ctas-image-wrapper {
    width: 42%;
    max-width: 440px;
    position: relative
}

.ctas-image {
    width: 100%
}

.ctas-image.first {
    z-index: 1;
    position: relative
}

.ctas-image.second {
    z-index: 2;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.ctas-image.third {
    z-index: 3;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.ctas-image.fourth {
    z-index: 4;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.spend-section {
    width: 100%
}

.spend-wrapper {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding: 140px 40px;
    display: flex
}

.calculator-right {
    width: 47%
}

.calculator-right.new {
    width: 100%
}

.calculator-wrapper {
    text-align: center;
    background-image: linear-gradient(90deg, rgba(8, 9, 10, .9), #08090a);
    border-radius: 16px;
    flex-direction: column;
    align-items: center;
    padding: 36px 20px;
    display: flex
}

.calculator-heading {
    color: var(--white);
    width: 100%;
    max-width: 459px;
    margin-bottom: 80px;
    font-size: 24px;
    font-weight: 500;
    line-height: 133.33%
}

.calculator {
    width: 100%
}

.calculator-input-wrap {
    width: 85%;
    max-width: 503px;
    margin-bottom: 60px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.calculator-input-embed {
    width: 100%
}

.calculator-selector-wrap {
    z-index: 3;
    width: 1px;
    height: 1px;
    transition: all .1s;
    position: absolute;
    top: 50%;
    left: 50%;
    right: 0%;
    transform: translateY(-50%)
}

.calculator-selector-button {
    background-color: #f7e8c7;
    border: 2px solid rgba(116, 47, 47, .2);
    border-radius: 40px;
    justify-content: space-between;
    align-items: center;
    width: 82px;
    height: 32px;
    padding: 7px;
    display: flex;
    position: absolute;
    transform: translate(-50%, -50%)
}

.calculator-selector-value-wrapper {
    color: var(--white);
    background-color: #434241;
    border-radius: 50px;
    width: 120px;
    padding: 5px 14px;
    font-weight: 600;
    line-height: 111.11%;
    /* transition: all .2s cubic-bezier(.645, .045, .355, 1); */
    /* display: block; */
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translate(-50%, -210%)
}

.calculator-track {
    z-index: 1;
    background-color: rgba(229, 224, 216, .2);
    border: 1px solid rgba(185, 180, 172, .4);
    border-radius: 60px;
    width: 100%;
    height: 12px;
    position: absolute;
    top: 50%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    transform: translateY(-50%)
}

.calculator-progress-bar {
    z-index: 2;
    background-color: #f7e8c7;
    border-radius: 16px;
    width: 50%;
    height: 12px;
    transition: all .1s;
    position: absolute;
    top: 50%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    transform: translateY(-50%)
}

.calculator-selector-icons {
    width: 16px;
    height: 16px
}

.calculator-content {
    grid-column-gap: 40px;
    grid-row-gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-end;
    display: flex
}

.calculator-content-sub-heading {
    color: var(--white);
    margin-bottom: 14px;
    font-weight: 500;
    line-height: 133.33%
}

.calculator-content-text {
    color: var(--white);
    font-size: 32px;
    font-weight: 500;
    line-height: 125%
}

.calculator-content-text-wrap {
    background-color: rgba(250, 242, 235, .16);
    border-radius: 10px;
    padding: 10px 23px
}

.spend-block-icon-embed {
    width: 28px;
    height: 28px
}

.indicator-arrow {
    opacity: .4;
    width: 16px;
    height: 24px
}

.spend-image {
    width: 100%
}

.spend-image.e {
    width: 75%;
    max-width: 507px;
    margin-left: auto;
    margin-right: auto
}

.spend-image.c {
    border-radius: 10px;
    width: 70%;
    max-width: 435px;
    margin-top: -140px;
    margin-left: auto;
    margin-right: 0;
    box-shadow: 0 -20px 80px rgba(0, 0, 0, .1)
}

.spend-image.d {
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.spend-image.b {
    margin-top: 22px
}

.spend-block-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    flex: none;
    width: 100%;
    display: flex
}

.spend-block-wrapper.c,
.spend-block-wrapper.a {
    justify-content: flex-end;
    min-height: 311px
}

.spend-block-wrapper.a.new {
    color: var(--black);
    width: 360px;
    display: flex;
    position: absolute;
    top: 150%
}

.spend-block-wrapper.a.new._1 {
    background-color: var(--transparent);
    display: flex;
    bottom: auto;
    left: auto;
    overflow: hidden;
    margin-top: -70px
}

.spend-block-wrapper.a.new._2 {
    background-color: var(--transparent);
    background-image: none;
    display: none;
    bottom: auto;
    left: auto;
    overflow: hidden;
    margin-top: -50px
}

.spend-block-wrapper.a.new._3 {
    box-sizing: border-box;
    object-fit: fill;
    flex: none;
    justify-content: center;
    align-items: flex-start;
    margin-left: 0;
    display: none;
    position: absolute;
    bottom: auto;
    left: auto;
    right: auto;
    overflow: hidden;
    margin-top: -30px
}

.spend-block-wrapper.b {
    justify-content: flex-end;
    min-height: 311px
}

.spend-sticky-wrapper {
    width: 100%;
    height: 60vh;
    position: static
}

.spend-texts-blocks-wrapper {
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
    display: flex;
    position: relative
}

.spend-text-container {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    background-image: linear-gradient(135deg, #fff4dc, #f0deb5);
    border-radius: 16px;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding: 40px;
    display: flex
}

.sticky-indicator-text-wrapper {
    grid-column-gap: 10px;
    grid-row-gap: 16px;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    display: flex
}

.spend-image-wrapper {
    width: 100%;
    position: relative
}

.spend-image-wrapper.second {
    opacity: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 0 0 16px;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.spend-image-wrapper.first {
    opacity: 1;
    flex-direction: column;
    padding: 60px 65px 60px 76px;
    display: flex
}

.spend-image-wrapper.third {
    opacity: 0;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 0 0 16px;
    display: flex;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.spend-block-icon-contain {
    background-color: rgba(36, 2, 19, .1);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    display: flex
}

.spend-text-blocks-contain {
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
    max-width: 407px;
    height: 311px;
    display: flex;
    position: relative;
    overflow: hidden
}

.spend-images-grid {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .5fr;
    width: 100%
}

.spend-images-gradient-border {
    background-image: linear-gradient(135deg, rgba(6, 19, 27, .06), rgba(6, 19, 27, .04));
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    width: 60%;
    max-width: 780px;
    padding: 2px;
    position: relative;
    left: -16px
}

.paragraph-22px {
    font-size: 22px;
    line-height: 127.273%
}

.paragraph-22px.sticky-indicator-text {
    letter-spacing: -.22px;
    font-weight: 500
}

.spend-image-container {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/654d5326762335b932e9059c_Spend%20Bkg.svg), linear-gradient(135deg, #fdf8ec, #f9f2e1);
    background-position: 50%, 0 0;
    background-repeat: no-repeat, repeat;
    background-size: cover, auto;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    display: flex;
    position: relative
}

.spend-text-gradient-border {
    z-index: 2;
    background-image: linear-gradient(rgba(6, 19, 27, .04), rgba(6, 19, 27, .1));
    border-radius: 16px;
    width: 40%;
    max-width: 500px;
    padding: 2px;
    display: flex;
    position: relative
}

.spend-sticky-block {
    justify-content: center;
    width: 100%;
    padding-left: 16px;
    display: flex;
    position: sticky;
    top: 140px
}

.heading-252 {
    color: var(--white);
    margin-bottom: 24px;
    font-size: 32px;
    font-weight: 400;
    line-height: 109%
}

.heading-252.new {
    color: var(--black-2);
    font-size: 24px;
    line-height: 1.4
}

.heading-253 {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px
}

.heading-254 {
    font-size: 24px;
    line-height: 30px
}

.heading-255 {
    color: var(--goldenrod);
    text-transform: uppercase;
    margin-left: 20px;
    margin-right: 20px;
    font-size: 18px;
    line-height: 28px
}

.heading-255.pink {
    color: var(--pabloo-green)
}

.heading-256 {
    color: var(--pabloo-green);
    font-size: 28px;
    line-height: 28px
}

.reviews-section {
    width: 100%;
    overflow: hidden
}

.reviews-main-wrapper {
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    width: 100%;
    padding-top: 60px;
    padding-bottom: 60px;
    display: flex
}

.reviews-main-wrapper.new {
    padding-top: 140px
}

.reviews-slider {
    background-color: rgba(255, 255, 255, 0);
    width: 90%;
    max-width: 1138px;
    height: auto;
    display: none;
    position: relative
}

.reviews-slider-mask {
    width: 100%;
    overflow: visible
}

.review-slide-nav {
    position: absolute;
    top: auto;
    bottom: -102px;
    left: 0%;
    right: 0%
}

.reviews-slide-wrapper {
    justify-content: space-between;
    width: 100%;
    height: 100%;
    display: flex
}

.reviews-slide-image-contain {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 35%;
    max-width: 358px;
    display: flex
}

.reviews-slide-image {
    object-fit: cover;
    object-position: 0% 50%;
    border-radius: 16px;
    width: 100%;
    height: 100%
}

.reviews-slide-text-gradient-wrapper {
    background-image: linear-gradient(135deg, rgba(6, 19, 27, .04), rgba(6, 19, 27, .08));
    border-radius: 26px;
    width: 63%;
    padding: 2px
}

.review-slide-text-wrapper {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    background-image: linear-gradient(135deg, #fff4dc, #f7e7c6);
    border-radius: 26px;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 40px 40px 22px;
    display: flex
}

.reviewer-block {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: auto;
    display: flex
}

.reviewer-info-block {
    grid-column-gap: 5px;
    grid-row-gap: 5px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.review-company-logo {
    object-fit: contain;
    width: auto;
    height: 36px
}

.review-company-logo._32px {
    height: 32px
}

.review-company-logo._29px {
    height: 29px
}

.review-company-logo._31px {
    height: 31px
}

.review-company-logo._44px {
    height: 44px
}

.slider-arrow {
    color: var(--dark-violet);
    background-color: #fff;
    border: 1px solid rgba(36, 2, 19, .15);
    border-radius: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 40px;
    transition: all .4s ease-in-out;
    display: flex
}

.slider-arrow:hover {
    background-color: var(--dark-violet);
    color: var(--white)
}

.slider-arrow.right {
    top: auto;
    bottom: -101px;
    left: auto;
    right: 30%
}

.slider-arrow.right.events {
    top: -101px;
    bottom: auto;
    right: 0
}

.slider-arrow.right.events:hover {
    background-color: var(--pabloo-green-2)
}

.slider-arrow.left {
    top: auto;
    bottom: -101px;
    left: 30%;
    right: auto
}

.slider-arrow.left.events {
    justify-content: flex-start;
    align-items: center;
    top: -101px;
    bottom: auto;
    left: auto;
    right: 80px
}

.slider-arrow.left.events:hover {
    background-color: var(--pabloo-green-2)
}

.review-slide-arrow-icon-embed {
    width: 12px;
    height: 40px;
    position: relative
}

.review-slide-arrow-icon-embed.right {
    top: 2px;
    transform: rotate(180deg)
}

.home-hero-heading-contain {
    flex-direction: column
}

.logos-white-gradient {
    z-index: 2;
    background-image: linear-gradient(90deg, #fff, rgba(255, 255, 255, 0));
    width: 200px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto
}

.logos-white-gradient.right {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff);
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%
}

.logos-white-gradient.right.new {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), var(--soft-pink))
}

.logos-white-gradient.new {
    background-image: linear-gradient(90deg, var(--soft-pink), rgba(255, 255, 255, 0))
}

.reviews-slide {
    width: 100%;
    height: 100%;
    margin-right: 60px
}

.calculator-tabs-menu {
    display: none
}

.calculator-toggle-buttons-contain {
    background-color: var(--white);
    border-radius: 10px;
    flex: none;
    padding: 6px;
    position: relative
}

.calculator-toggle-button-wrapper {
    z-index: 2;
    border-radius: 10px;
    padding: 13px 26px;
    position: relative
}

.calculator-toggle-button-wrapper.saas {
    color: var(--white)
}

.calculator-toggle-background-div {
    z-index: 1;
    background-color: var(--dark-violet);
    border-radius: 10px;
    width: 46%;
    position: absolute;
    top: 6px;
    bottom: 6px;
    left: 6px;
    right: auto
}

.calculator-left-flex-wrap {
    grid-column-gap: 70px;
    grid-row-gap: 70px;
    justify-content: space-between;
    align-items: center;
    display: flex;
    position: relative
}

.flip-heading-contain {
    z-index: 1;
    flex-direction: column;
    display: flex;
    position: relative
}

.hamburger-wrapper {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    display: flex
}

.burger-line {
    background-color: var(--dark-violet);
    border-radius: 2px;
    width: 18px;
    height: 2px;
    margin-top: 2px;
    margin-bottom: 2px
}

.stack-block-heading-contain {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    align-items: center;
    display: flex
}

.hero-bottom-heading-contain {
    display: flex
}

.hero-wrapper-contain {
    width: 100%;
    max-width: 1440px;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.hero-wrapper-contain.apps-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/657aa3e5262099fe2d4a28c8_Background.svg);
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover
}

.hero-bkg {
    z-index: 1;
    object-fit: fill;
    object-position: 50% 0%;
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    height: 85%;
    max-height: 700px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.hero-bkg.blog {
    height: 100%;
    max-height: none
}

.hero-bkg.blog-cms {
    max-height: 540px
}

.hero-bkg.hub {
    max-height: 621px
}

.hero-bkg.saas {
    max-height: 769px;
    bottom: 10%
}

.hero-bkg.cloud {
    height: 90%;
    max-height: 561px
}

.home-hero-images-container {
    width: 50%;
    max-width: 700px;
    margin-right: -10%;
    position: relative
}

.hero-workflow-image {
    width: 100%
}

.hero-before-images-contain {
    width: 48%;
    max-width: 320px;
    position: absolute;
    top: 13%;
    bottom: auto;
    left: auto;
    right: 10%
}

.before-hero-image-sales {
    width: 100%
}

.before-hero-image-zapier,
.before-hero-image-snow {
    width: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.hero-after-images-contain {
    width: 48%;
    max-width: 320px;
    position: absolute;
    top: auto;
    bottom: -3%;
    left: auto;
    right: 10%
}

.hero-person-images-contain {
    width: 38%;
    max-width: 280px;
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: auto
}

.hero-person-image-sales {
    width: 100%
}

.hero-person-image-mail,
.hero-person-image-jira {
    width: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.hero-bubbles-block-wrapper {
    width: 100%;
    max-width: 160px;
    display: flex;
    position: absolute;
    top: auto;
    bottom: 5%;
    left: 8%;
    right: auto;
    overflow: hidden
}

.hero-bubbles-block {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex: none;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.hero-bubbles-block-contain {
    flex-direction: column;
    flex: none;
    width: 960px;
    display: flex;
    overflow: hidden
}

.hero-bubble-image {
    width: 100%;
    max-width: 60px;
    height: 60px
}

.after-hero-image-sales {
    width: 100%
}

.after-hero-image-zapier,
.after-hero-image-snow {
    width: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.div-block-729 {
    margin-top: 20px
}

.text-block-304 {
    opacity: .5;
    color: var(--white-smoke);
    text-align: left;
    font-size: 14px;
    line-height: 22px
}

.calc-anchor {
    position: absolute;
    top: -91px;
    bottom: auto;
    left: 0%;
    right: auto
}

.navigation-background-div {
    z-index: 1;
    opacity: 0;
    background-color: #fff;
    border-radius: 12px;
    width: 94%;
    max-width: 1312px;
    margin: 10px auto;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)
}

.navigation-background-div.dark {
    background-color: #18020d
}

.navigation-links-grid {
    grid-column-gap: 32px;
    grid-row-gap: 0px;
    object-fit: fill;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    display: flex
}

.navigation-links-grid.solutions {
    flex-direction: column
}

.navigation-links-grid.resources {
    grid-column-gap: 12px;
    grid-row-gap: 0px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .75fr;
    grid-auto-columns: 1fr;
    display: grid
}

.navigation-links-column {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-direction: column;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-items: flex-start;
    display: flex
}

.navigation-header-link-contain {
    align-items: center;
    display: flex
}

.navigation-header-link {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    color: var(--dark-violet);
    align-items: center;
    transition: color .3s ease-in-out;
    display: flex
}

.navigation-header-link:hover {
    color: var(--pabloo-green)
}

.dropdown-link-arrow-embed {
    color: var(--pabloo-green);
    width: 16px;
    height: 16px
}

.navbar-dropdown-text {
    font-weight: 500
}

.dropdown-links-container-column {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.dropdown-links-container-column.solutions,
.dropdown-links-container-column.resources {
    grid-column-gap: 0px;
    grid-row-gap: 0px
}

.dropdown-highlight-span {
    color: var(--pabloo-green);
    background-color: rgba(245, 205, 225, .3);
    border-radius: 12px;
    margin-left: 2px;
    padding: 4px 10px;
    font-weight: 500
}

.navigation-block-link {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    color: var(--dark-violet);
    border-radius: 8px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    text-decoration: none;
    transition: all .3s;
    display: flex
}

.navigation-block-link:hover {
    color: var(--pabloo-green)
}

.paragraph-14px {
    color: var(--dark-violet);
    font-size: 14px;
    line-height: 142.857%
}

.paragraph-14px.navigation-block-link-description._4px-bottom-margin {
    margin-bottom: 4px
}

.dropdown-resources-column {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 12px;
    display: flex
}

.resource-dropdown-wrapper {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    border-radius: 10px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    transition: color .3s ease-in-out;
    display: flex
}

.resource-dropdown-wrapper:hover {
    color: var(--pabloo-green)
}

.resource-dropdown-image-contain {
    background-color: rgba(213, 57, 135, .1);
    border-radius: 10px;
    width: 100%;
    height: 227px;
    padding: 27px 37px;
    display: flex
}

.resource-dropdown-image {
    object-fit: cover;
    border-radius: 13px;
    width: 100%
}

.resource-dropdown-info-block {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    display: flex
}

.integrations-lottie {
    width: 100%
}

.integrations-lottie.integra {
    text-align: left;
    object-fit: contain;
    flex: 0 1 auto;
    width: 100%
}

.spend-anchor.first {
    position: absolute;
    top: 0%;
    bottom: auto;
    left: 0%;
    right: 0%
}

.spend-anchor.second {
    position: absolute;
    top: 40%;
    bottom: auto;
    left: 0%;
    right: 0%
}

.spend-anchor.third {
    position: absolute;
    top: 70%;
    bottom: auto;
    left: 0%;
    right: 0%
}

.linear-bkg-menu-button {
    color: #000;
    background-image: linear-gradient(rgba(121, 121, 122, .08), rgba(121, 121, 122, .2));
    border-radius: 100px;
    padding: 2px;
    font-weight: 600;
    line-height: 150%;
    text-decoration: none;
    display: none
}

.dropdown-links-divider {
    display: none
}

.navigation-inner-wrapper {
    margin-right: auto;
    position: static
}

.navigation-inner-wrapper.white.new {
    margin-right: 0
}

.tribe-image-wrapper {
    z-index: 2;
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: flex;
    position: relative;
    left: 4%
}

.tribe-tab-lottie {
    z-index: 2;
    border-radius: 12px;
    width: 100%;
    position: relative
}

.tribe-tab-lottie-shadow {
    z-index: 1;
    border-radius: 12px;
    width: 100%;
    height: 98%;
    margin: auto;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    box-shadow: 0 19px 74px rgba(0, 0, 0, .08)
}

.hero-platform-wrapper {
    z-index: 2;
    width: 90%;
    max-width: 1280px;
    min-height: 200px;
    margin-left: auto;
    margin-right: auto;
    padding: 160px 8% 42px;
    position: relative
}

.hero-platform-wrapper.padding-bottom-md {
    padding-bottom: 80px
}

.hero-platform-wrapper.integra {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-flow: row;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: flex-end;
    margin-left: auto;
    margin-right: auto;
    padding-left: 2%;
    padding-right: 2%;
    display: flex
}

.hero-platform-heading-wrapper {
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 0;
    display: block
}

.hero-platform-heading-wrapper.display-flex {
    flex-wrap: wrap;
    justify-content: center;
    display: flex
}

.hero-platform-heading-wrapper.display-flex.include-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/654b723207dd65fd8b2c88f0_Group%202087326002.svg);
    background-position: 58% 40%;
    background-repeat: no-repeat;
    background-size: auto;
    max-width: 900px;
    margin-top: 32px
}

.text-span-226 {
    color: var(--pabloo-green-2)
}

.hero-platform-subheading {
    margin-top: 48px
}

.hero-platform-subheading-text {
    text-align: center;
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;
    font-family: Satoshi, sans-serif;
    font-size: 20px;
    font-weight: 500;
    display: block
}
.hero-platform-subheading-text-case {
    flex-flow: row;
    justify-content: flex-start;
    align-items: center;
    font-family: Satoshi, sans-serif;
    font-size: 20px;
    font-weight: 500;
    display: block;
    margin-bottom: 10px;
}

.hero-platform-subheading-text.integra.new {
    text-align: left
}

.hero-platform-cta-wrapper {
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 48px;
    display: flex
}

.hero-platform-cta-wrapper.integra.new {
    justify-content: flex-start;
    align-items: center
}

.hero-button-cta {
    text-align: center;
    background-color: #c73a88;
    border-radius: 10px;
    padding: 16px 32px;
    font-family: Satoshi, sans-serif;
    font-weight: 500
}

.div-block-731 {
    text-align: left;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 16px;
    display: flex
}

.text-block-305 {
    flex: 1 1;
    justify-content: center;
    align-items: flex-start;
    font-family: Satoshi, sans-serif;
    display: flex
}

.hero-platform-image {
    object-fit: fill;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    margin-top: 40px;
    display: flex;
    position: relative
}

.hero-platform-image.integra {
    justify-content: flex-end;
    align-items: stretch;
    width: 100%;
    margin-top: 0
}

.hero-spotlight-image {
    z-index: 0;
    border-radius: 16px;
    width: 72%;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    position: static;
    box-shadow: 0 8px 40px rgba(0, 0, 0, .1)
}

.hero-spotlight-image.border-radius-reset {
    border-radius: 0 0 8px 8px
}

.hero-spotlight-image.border-radius-reset.no-shadow {
    box-shadow: none;
    width: 90%
}

.blogs-hero-wrapper {
    z-index: 2;
    color: var(--darker-violet);
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 190px;
    padding-bottom: 400px;
    display: flex;
    position: relative
}

.blogs-hero-wrapper.cms {
    flex-direction: row;
    justify-content: space-between;
    padding-top: 160px;
    padding-bottom: 80px
}

.blogs-hero-header {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 938px;
    display: flex
}

.subscription-form {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    justify-content: center;
    display: flex
}

.subscription-form-block {
    width: 100%;
    max-width: 643px;
    margin-bottom: 0
}

.form-email-text-field {
    color: var(--darker-violet);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6539910146c0d6a12aef43e7_Form%20Email.svg);
    background-position: 5%;
    background-repeat: no-repeat;
    background-size: auto;
    border: 1px #000;
    border-radius: 10px;
    width: 64.9%;
    max-width: 420px;
    height: auto;
    margin-bottom: 0;
    padding: 18px 20px 18px 60px;
    font-size: 18px;
    line-height: 156%
}

.form-email-text-field::placeholder {
    color: rgba(32, 0, 16, .5)
}

.form-email-text-field._100 {
    width: 100%
}

.form-email-text-field.resource-hero {
    width: 55.7%;
    max-width: 320px
}

.absolute-submit-button {
    z-index: 4;
    background-color: rgba(255, 255, 255, 0);
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.success-state {
    background-color: var(--white);
    color: var(--pabloo-green);
    border-radius: 4px;
    font-weight: 600
}

.error-state {
    background-color: #f3adad;
    border-radius: 4px;
    font-weight: 600
}

.featured-block-contain {
    z-index: 2;
    width: 90%;
    max-width: 1300px;
    margin-top: -320px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.featured-block-contain.resources {
    width: 45%;
    max-width: 520px;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0
}

.blogs-tabs-section {
    width: 100%
}

.blog-tabs-wrapper {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 60px;
    padding-bottom: 50px
}

.blogs-tab-link {
    color: var(--dark-violet);
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    min-width: 165px;
    max-width: 165px;
    padding: 0;
    font-size: 20px;
    font-weight: 500;
    line-height: 140%
}

.blogs-tab-link.w--current {
    background-color: rgba(255, 255, 255, 0)
}

.blog-tabs-info-wrapper {
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.ctas-form-wrapper {
    background-image: linear-gradient(135deg, #fbeded, #e5c4c5);
    border-radius: 20px;
    width: 100%;
    max-width: 560px;
    padding: 40px
}

.cta-form-block {
    flex-direction: column;
    justify-content: center;
    min-height: 518px;
    margin-bottom: 0;
    display: flex
}

.cta-form-block.hide {
    display: none
}

.form-fields-contain {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.form-field-label {
    margin-bottom: 0
}

.white-form-field {
    background-color: var(--white);
    border: 1px solid rgba(36, 2, 19, .14);
    border-radius: 10px;
    height: auto;
    margin-bottom: 0;
    padding: 12px 20px;
    font-size: 20px;
    line-height: 120%
}

.white-form-field:focus {
    border-color: rgba(36, 2, 19, .24)
}

.ctas-form {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    display: flex
}

.ctas-form._16px-gap {
    grid-column-gap: 16px;
    grid-row-gap: 16px
}

.form-fields-grid {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-rows: auto;
    width: 100%
}

.form-select-field {
    background-color: var(--white);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6539dba54436eb9715b8bff9_Select%20Field%20Arrow.svg);
    background-position: 94%;
    background-repeat: no-repeat;
    background-size: auto;
    border: 1px solid rgba(36, 2, 19, .14);
    border-radius: 10px;
    height: auto;
    margin-bottom: 0;
    padding: 12px 20px;
    font-size: 20px;
    line-height: 120%
}

.form-select-field:focus {
    border-color: rgba(36, 2, 19, .24)
}

.ctas-form-gradient-wrapper {
    background-image: linear-gradient(135deg, rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));
    border-radius: 20px;
    width: 45%;
    max-width: 560px;
    padding: 1px
}

.div-block-732 {
    background-color: #fff;
    width: 100%;
    height: 180px;
    margin-top: -227px;
    padding-top: 0
}

.features-section {
    padding-top: 56px;
    padding-bottom: 120px;
    display: flex
}

.blogs-hero-section {
    background-color: var(--soft-pink);
    overflow: hidden
}

.old-sections {
    display: none
}

.blog-category-text-contain {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    color: var(--pabloo-green);
    letter-spacing: 1.2px;
    background-color: rgba(213, 57, 135, .12);
    border-radius: 16px;
    align-items: center;
    padding: 6px 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 125%;
    display: flex
}

.blog-category-text-contain.date {
    color: #5b002c;
    background-color: rgba(213, 57, 135, 0)
}

.blog-category-icon {
    width: 20px;
    height: 21px
}

.blog-tags-contain {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    display: flex
}

.blog-info-section {
    width: 100%
}

.blog-cms-info-wrapper {
    justify-content: space-between;
    align-items: flex-start;
    width: 90%;
    max-width: 1240px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 140px;
    display: flex
}

.blog-cms-left-contain {
    width: 60%;
    max-width: 760px
}

.block-rich-text {
    width: 100%
}

.block-rich-text h1 {
    margin-bottom: 28px;
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 800;
    line-height: 112.5%
}

.block-rich-text h2 {
    margin-bottom: 28px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 56px;
    font-weight: 800;
    line-height: 118.51%
}

.block-rich-text h3 {
    margin-top: 0;
    margin-bottom: 28px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 48px;
    font-weight: 800;
    line-height: 116.66%
}

.block-rich-text h4 {
    margin-top: 0;
    margin-bottom: 20px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 40px;
    font-weight: 800;
    line-height: 120%
}

.block-rich-text h5 {
    margin-top: 0;
    margin-bottom: 20px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 32px;
    font-weight: 800;
    line-height: 118.75%
}

.block-rich-text h6 {
    margin-top: 0;
    margin-bottom: 20px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 28px;
    font-weight: 800;
    line-height: 128.57%
}

.block-rich-text p,
.block-rich-text ul,
.block-rich-text ol {
    margin-bottom: 30px;
    line-height: 156%
}

.block-rich-text li {
    margin-bottom: 8px
}

.block-rich-text blockquote {
    background-color: var(--pabloo-green);
    color: var(--white);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b0274f5f5c39f63cee643_RT%20Quote.svg);
    background-position: 40px 40px;
    background-repeat: no-repeat;
    background-size: 48px 40px;
    border-left-style: none;
    border-radius: 12px;
    margin-bottom: 30px;
    padding: 108px 40px 40px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 32px;
    font-weight: 800;
    line-height: 125%
}

.block-rich-text figure {
    margin-bottom: 28px
}

.block-rich-text figcaption {
    opacity: .8;
    margin-top: 16px;
    font-weight: 500;
    line-height: 100%
}

.block-rich-text a {
    color: var(--pabloo-green);
    /* text-decoration: none; */
    transition: color .3s ease-in-out
}

.block-rich-text a:hover {
    color: var(--dark-violet)
}

.block-rich-text strong {
    font-weight: 800
}

.features-wrapper {
    width: 90%;
    max-width: 1280px;
    margin-top: 83px;
    margin-left: auto;
    margin-right: auto
}

.feature-wrap {
    grid-column-gap: 72px;
    grid-row-gap: 72px;
    flex-wrap: wrap;
    align-content: stretch;
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.feature-image-wrapper {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 55%;
    padding-top: 40px;
    padding-left: 40px
}

.feature-image-wrapper.right {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    background-position: 100%;
    padding-top: 40px;
    padding-left: 0;
    padding-right: 40px
}

.feature-image-wrapper.right.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    justify-content: flex-end;
    padding-bottom: 40px;
    display: flex
}

.feature-image-wrapper.right.green-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);
    flex: 1 1;
    width: 50%;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper.right.green-bg.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper.right.yellow-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    padding-bottom: 1px;
    padding-right: 38px
}

.feature-image-wrapper.right.yellow-bg.padding-reset {
    padding-top: 0;
    padding-right: 0
}

.feature-image-wrapper.right.green-bg-copy {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    width: 50%;
    min-height: auto;
    padding-top: 3px;
    padding-bottom: 32px;
    padding-right: 0
}

.feature-image-wrapper.right.green-bg-copy.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper.left {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)
}

.feature-image-wrapper.left.green-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    flex-direction: column;
    flex: 1 1;
    justify-content: flex-end;
    align-items: flex-start;
    height: 500px;
    padding-top: 6px;
    padding-bottom: 40px;
    display: flex
}

.feature-image-wrapper.left.green-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper.left.yellow-bg {
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex-direction: column;
    flex: 1 1;
    justify-content: flex-start;
    align-items: center;
    height: 550px;
    padding-bottom: 32px;
    display: flex
}

.feature-image-wrapper.left.yellow-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper.left.yellow-bg.padding-left-reset {
    padding-left: 0
}

.feature-image-wrapper.left.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    flex-direction: column;
    flex: 1 1;
    justify-content: center;
    align-self: center;
    align-items: flex-start;
    height: 500px;
    padding-top: 2px;
    padding-bottom: 32px;
    display: flex
}

.feature-image-wrapper.left.pink-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-content-wrap {
    width: 36.7%
}

.feature-content-header {
    color: var(--dark-violet)
}

.feature-content-heading-wrapper {
    margin-top: 24px
}

.feature-content-heading-text {
    color: var(--black-2);
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 32px;
    line-height: 1.4em
}

.feature-content-body {
    margin-top: 36px
}

.feature-content-body-text {
    font-family: Satoshi, sans-serif;
    font-size: 20px;
    font-weight: 400;
    line-height: 1.6em
}

.verical-seperator---100 {
    height: 100px
}

.text-span-227,
.text-span-228,
.text-span-229,
.text-span-230,
.text-span-231 {
    color: var(--pabloo-green-2)
}

.hero-design-element {
    position: absolute;
    top: 68%;
    bottom: auto
}

.hero-design-element.right {
    top: 32%;
    right: 0
}

.hero-design-element.left {
    top: auto;
    bottom: 0%;
    left: 0
}

.hero-design-element.center {
    top: 2%;
    left: -10%
}

.text-span-232,
.text-span-233,
.text-span-234,
.text-span-235 {
    color: var(--pabloo-green-2)
}

.blog-cms-sticky-contain {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    width: 35%;
    max-width: 400px;
    display: flex;
    position: sticky;
    top: 120px
}

.subscribe-form-gradient-wrapper {
    background-image: linear-gradient(135deg, rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));
    border-radius: 20px;
    width: 100%;
    padding: 1px
}

.subscribe-form-main-wrapper {
    background-color: #faf2eb;
    border-radius: 20px;
    width: 100%;
    padding: 40px
}

.blog-sticky-icon-contain {
    background-image: linear-gradient(135deg, #f8e7e8, #e8cacb);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    display: flex
}

.html-embed-30 {
    width: 44px;
    height: 44px
}

.author-block {
    grid-column-gap: 60px;
    grid-row-gap: 40px;
    border-top: 1px solid rgba(18, 0, 9, .12);
    flex-wrap: wrap;
    width: 100%;
    margin-top: 20px;
    padding-top: 30px;
    display: flex
}

.author-container {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    align-items: center;
    display: flex
}

.author-headings-contain {
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    flex-direction: column;
    display: flex
}

.author-image {
    border-radius: 50%;
    width: 60px;
    height: 60px
}

.related-blogs-section {
    width: 100%
}

.related-blogs-wrapper {
    grid-column-gap: 58px;
    grid-row-gap: 58px;
    flex-direction: column;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 120px;
    display: flex
}

.related-header {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.fs-cc-prefs3_overlay {
    z-index: -1;
    background-color: rgba(0, 0, 0, .8);
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.fs-cc-prefs3_header {
    background-color: #2730d4;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 2rem;
    display: flex
}

.fs-cc-manager3_text {
    opacity: .84;
    color: var(--slate-blue);
    margin-left: .625rem;
    font-size: 16px;
    font-weight: 700;
    display: inline-block
}

.fs-cc-banner3_component {
    z-index: 998;
    background-color: #fff;
    border-radius: 1rem;
    margin: 2rem;
    padding: 1.6rem 2rem;
    display: none;
    position: fixed;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: auto;
    box-shadow: 7px 7px 12px rgba(0, 0, 0, .1)
}

.fs-cc-banner3_text {
    color: var(--pabloo-green);
    font-size: 1.2rem;
    font-weight: 400
}

.fs-cc-prefs3_button {
    color: #fff;
    text-align: center;
    background-color: #129657;
    border: 2px solid #129657;
    border-radius: 999rem;
    padding: .875rem 2rem;
    font-size: 1rem
}

.fs-cc-prefs3_button.fs-cc-button-alt {
    color: #7e7e7e;
    background-color: #fff;
    border-color: #a8a8a8;
    margin-right: .75rem
}

.fs-cc-prefs3_submit {
    color: #fff;
    text-align: center;
    background-color: #4b53eb;
    border-radius: 999rem;
    margin-left: .75rem;
    padding: .875rem 2rem;
    font-size: 1rem
}

.fs-cc-prefs3_checkbox-field {
    align-items: center;
    margin-bottom: 0;
    display: flex
}

.fs-cc-prefs3_label {
    color: #4b53eb;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.4
}

.fs-cc-banner3_paragraph {
    color: #000;
    margin-top: .75rem;
    margin-bottom: 0;
    font-size: 16px
}

.fs-cc-prefs3_checkbox {
    border-radius: 999rem;
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 0;
    margin-right: .75rem
}

.fs-cc-prefs3_checkbox.w--redirected-checked {
    background-color: #129657;
    background-size: 16px;
    border-color: #129657
}

.fs-cc-prefs3_checkbox.w--redirected-focus {
    box-shadow: 0 0 3px 1px #129657
}

.fs-cc-prefs3_content {
    padding: 2rem
}

.fs-cc-prefs3_close {
    background-color: #fff;
    border-radius: 999rem;
    padding: .75rem;
    position: absolute;
    top: 2rem;
    bottom: auto;
    left: auto;
    right: 2rem
}

.fs-cc-prefs3_checkbox-label {
    display: none
}

.set-all-components-to-display-none-and-use-this-div-to-create-a-symbol {
    display: block
}

.fs-cc-prefs3_icon {
    color: #fff;
    width: 2rem;
    height: 2rem;
    margin-right: .75rem
}

.fs-cc-prefs3_component {
    z-index: 1040;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    padding: 2rem;
    display: none;
    position: fixed
}

.fs-cc-banner3_button-icon {
    width: 1rem;
    margin-right: .625rem
}

.fs-cc-manager3_icon {
    color: #4b53eb;
    width: 1rem;
    height: 1.5rem;
    display: inline-block
}

.fs-cc-banner3_button {
    color: #fff;
    background-color: #129657;
    border-radius: 12px;
    padding: .875rem 2rem;
    font-size: 1.125rem;
    text-decoration: none
}

.fs-cc-banner3_button.fs-cc-button-alt {
    background-color: #df6966;
    border-radius: 12px;
    margin-right: .75rem
}

.fs-cc-prefs3_form {
    position: relative
}

.fs-cc-prefs3_title {
    color: #fff;
    font-size: 1.5rem;
    line-height: 1.3
}

.fs-cc-banner3_block {
    margin-right: 2rem
}

.fs-cc-prefs3_buttons-wrapper {
    background-color: #f2f3ff;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    padding: 1.5rem 2rem;
    display: flex
}

.fs-cc-prefs3_toggle-wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    display: flex
}

.fs-cc-prefs3_line {
    background-color: #e9e9e9;
    flex: 1 1;
    height: 1px;
    margin-left: 1.5rem;
    margin-right: 1.5rem
}

.fs-cc-banner3_text-link {
    color: #4b53eb;
    border-bottom: 2px solid #4b53eb;
    font-weight: 400;
    text-decoration: none
}

.fs-cc-manager3_component {
    z-index: 999;
    background-color: #fff;
    border-radius: 999rem;
    align-items: center;
    display: none;
    position: fixed;
    top: auto;
    bottom: 2rem;
    left: 2rem;
    right: auto;
    box-shadow: 7px 7px 12px rgba(0, 0, 0, .1)
}

.fs-cc-banner3_container {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.fs-cc-banner3_buttons-wrapper {
    flex: none
}

.fs-cc-preferences3_close-icon {
    color: #4b53eb;
    width: 1.5rem;
    height: 1.5rem
}

.fs-cc-prefs3_form-wrapper {
    background-color: #fff;
    border-radius: .75rem;
    max-width: 45rem;
    margin-bottom: 0;
    overflow: hidden
}

.fs-cc-manager3-link {
    justify-content: center;
    align-items: center;
    padding: .5rem 1rem;
    text-decoration: none;
    display: flex
}

.fs-cc-prefs3_option {
    padding-top: .75rem;
    padding-bottom: .75rem
}

.fs-cc-banner3_button-text {
    display: inline-block
}

.resources-hero-section {
    background-color: #18020d;
    overflow: hidden
}

.navigation-bar-dark {
    z-index: 1000;
    background-color: var(--transparent);
    position: fixed;
    top: auto;
    bottom: auto;
    left: 0%;
    right: 0%
}

.navbar-dropdown-toggle-white {
    grid-column-gap: 8px;
    color: var(--white);
    align-items: center;
    padding: 20px 0;
    display: flex;
    position: static
}

.transparent-arrow-button-white {
    color: var(--white);
    letter-spacing: -.16px;
    border: 2px solid rgba(255, 255, 255, .4);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    font-size: 18px;
    font-weight: 600;
    line-height: 122.222%;
    text-decoration: none;
    display: flex;
    position: relative;
    overflow: hidden
}

.transparent-arrow-button-white._16px {
    padding: 18px 24px;
    font-size: 16px;
    line-height: 118.75%
}

.transparent-arrow-button-white._16px.navigation {
    padding-left: 14px;
    padding-right: 14px
}

.resources-hero-wrapper {
    z-index: 2;
    color: var(--darker-violet);
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 160px;
    padding-bottom: 60px;
    display: flex;
    position: relative
}

.resource-left-header {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: column;
    align-items: center;
    width: 50%;
    max-width: 547px;
    display: flex
}

.resource-hero-span {
    color: #f7e8c7
}

.resource-tabs-section {
    width: 100%
}

.resource-tabs-wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 120px;
    padding-bottom: 120px;
    display: flex
}

.resource-tab-info-wrapper {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: column;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    width: 78.2813%;
    max-width: 1002px
}

.resource-tab-flex-wrapper {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    flex-direction: column;
    width: 100%;
    display: block
}

.resource-tab-header {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 32px;
    display: flex
}

.resource-tab-heading-contain {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    align-items: center;
    display: flex
}

.resource-tab-icon-embed {
    color: var(--pabloo-green);
    width: 36px;
    height: 36px
}

.resource-collection-contain {
    width: 100%;
    padding-bottom: 40px;
    overflow: hidden
}

.resource-collection-list-wrapper {
    width: 100%
}

.resource-collection-list {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    display: grid
}

.resource-collection-item {
    width: 100%
}

.resource-post-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    width: 100%;
    display: flex
}

.resource-post-image-wrapper {
    border: 2px solid var(--soft-pink);
    border-radius: 14px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 260px;
    display: flex;
    overflow: hidden
}

.resource-post-image {
    object-fit: cover;
    object-position: 50% 50%;
    width: 100%;
    height: 100%
}

.resource-post-image.ebook {
    object-position: 10% 50%;
    display: inline-block
}

.resource-post-image.events {
    object-position: 0% 50%
}

.resource-collection-divider {
    opacity: .25;
    background-color: #0e1328;
    width: 100%;
    height: 1px;
    margin-top: 40px
}

.text-span-236,
.text-span-237,
.text-span-238 {
    color: var(--pabloo-green-2)
}

.section-67 {
    padding-top: 100px;
    padding-bottom: 100px
}

.container {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 100px
}

.container.product {
    max-width: 940px
}

.div-block-733 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    padding-left: 4%;
    padding-right: 4%;
    display: grid
}

.div-block-734 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-306 {
    font-size: 40px;
    font-weight: 600;
    line-height: 1.2em
}

.paragraph-145 {
    margin-top: 16px;
    font-family: Satoshi, sans-serif;
    font-size: 20px;
    font-weight: 400
}

.text-span-239,
.text-span-240,
.text-span-241,
.text-span-242,
.text-span-243,
.text-span-244,
.text-span-245 {
    color: var(--pabloo-green-2)
}

.image-221 {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    box-shadow: -4px 2px 24px rgba(0, 0, 0, .12)
}

.text-span-246 {
    color: var(--pabloo-green-2)
}

.div-block-735 {
    width: 60%
}

.div-block-736 {
    justify-content: center;
    width: 57%;
    display: flex
}

.text-span-247 {
    color: var(--pabloo-green-2)
}

.div-block-737 {
    background-color: #faf2eb;
    height: 100%;
    min-height: 100%;
    padding-top: 180px;
    padding-bottom: 100px;
    /* margin-bottom: 200px */
}

.div-block-738 {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto
}

.demo-sub-heading {
    width: 90%;
    margin-top: 32px;
}

@media (max-width: 768px) {
    .demo-sub-heading {
        width: 100%;
        margin-top: 32px;
    }
}

.div-block-740 {
    margin-top: 35px;
    display: flex

}

.demo-pointer-icon {
    width: 32px;
    height: 32px
}

.demo-pointer-wrapper {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    align-items: center
}

.div-block-741 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-741.social {
    grid-template-columns: 1fr
}

.div-block-742 {
    z-index: 1;
    background-color: #fff;
    border-radius: 4px;
    padding: 24px;
    position: relative;
    box-shadow: -3px 3px 8px rgba(0, 0, 0, .12)
}

.demo-g2-badges-holder {
    margin-top: 32px
}

.column-79 {
    padding-left: 0%;
    padding-right: 6%
}

.demo-form-wrapper {
    margin-top: 0;
    padding-left: 6%;
    padding-right: 10%;
    position: relative
}

.demo-form-wrapper.social {
    flex: 1 1;
    padding-left: 0%
}

.book-demo-form-graphic-1 {
    z-index: 0;
    aspect-ratio: auto;
    max-width: none;
    height: 640px;
    min-height: auto;
    position: absolute;
    top: -68px;
    bottom: auto;
    left: -40%;
    right: auto
}

.book-demo-form-graphic-1.social {
    left: 0%
}

.image-222 {
    height: 480px;
    position: absolute;
    top: auto;
    bottom: -88px;
    left: auto;
    right: -10%
}

.image-222.social {
    right: 0%
}

.html-embed-31 {
    width: 100%
}

.text-span-248,
.text-span-249,
.text-span-250,
.text-span-251 {
    color: var(--pabloo-green-2)
}

.navbar-dropdown-white {
    background-color: rgba(255, 255, 255, 0);
    border-radius: 40px;
    font-size: 16px;
    line-height: 118.75%;
    position: static
}

.container-fluid {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto
}

.flex-split {
    padding-top: 160px;
    padding-bottom: 120px;
    display: flex
}

.optimize-hero-content-container {
    width: 60%;
    padding-left: 24px;
    padding-right: 64px
}

.optimize-hero-logo {
    height: 120px
}

.div-block-743 {
    margin-top: 16px
}

.div-block-744 {
    justify-content: flex-start;
    display: flex
}

.div-block-745 {
    justify-content: center;
    align-items: center;
    width: 50%;
    padding-left: 40px;
    padding-right: 40px;
    display: flex
}

.div-block-746 {
    margin-top: 24px
}

.div-block-747 {
    border-bottom: 1px solid #5a5a5a;
    width: 56px;
    height: 1px;
    margin-top: 4px
}

.blog-tabs-header {
    margin-bottom: 40px
}

.blogs-tabs-form {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.blog-tag-radio-button-wrap {
    text-align: center;
    flex-direction: column-reverse;
    align-items: center;
    margin-bottom: 0;
    padding-left: 0;
    display: flex
}

.blog-tag-radio-button {
    border-width: 2.5px;
    border-color: rgba(36, 2, 19, .2);
    border-radius: 4px;
    width: 100%;
    height: 0;
    margin-top: 0;
    margin-left: 0
}

.blog-tag-radio-button.w--redirected-checked {
    border-width: 2.5px;
    border-color: #240213;
    width: 100%;
    height: 0
}

.blog-tag-radio-button.w--redirected-focus {
    box-shadow: none;
    flex: 0 1 auto;
    width: 100%;
    height: 4px
}

.blog-tabs-seach-input {
    border: 1px #000;
    height: auto;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 155.56%
}

.blog-tabs-seach-input:focus {
    border-style: none
}

.blog-tabs-search-wrapper {
    border: 1px solid rgba(36, 2, 19, .1);
    border-radius: 10px;
    width: 100%;
    max-width: 333px;
    padding: 10px 20px 10px 48px;
    display: flex;
    position: relative
}

.blog-search-icon {
    opacity: .5;
    width: 28px;
    height: 28px;
    position: absolute;
    top: 50%;
    bottom: 0%;
    left: 20px;
    right: auto;
    transform: translateY(-50%)
}

.blog-tag-radio-buttons-contain {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    display: flex
}

.blog-tabs-pagination {
    margin-top: 80px
}

.load-more-button {
    background-color: var(--transparent);
    border-style: none;
    justify-content: center;
    align-items: center;
    padding: 0;
    font-size: 18px;
    line-height: 156%;
    display: flex
}

.resource-tabs-filters {
    width: 19%;
    max-width: 238px;
    padding-top: 10px;
    position: sticky;
    top: 120px
}

.resources-search-wrapper {
    display: flex;
    position: relative
}

.resources-search-icon {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    bottom: 0%;
    left: auto;
    right: 12px;
    transform: translateY(-50%)
}

.resources-search-input {
    background-color: rgba(14, 19, 40, .04);
    border: 1px #000;
    border-radius: 4px;
    height: auto;
    margin-bottom: 0;
    padding: 10px 12px;
    font-size: 16px;
    font-weight: 500;
    line-height: 150%
}

.resources-radio-button-wrap {
    border-radius: 4px;
    margin-bottom: 0;
    padding: 0;
    line-height: 156%;
    overflow: hidden
}

.resources-radio-button {
    margin-left: 0;
    display: none
}

.radio-button-label {
    width: 100%;
    margin-bottom: 0;
    padding: 8px 16px;
    font-weight: 500
}

.resource-tab-form-separator {
    background-color: rgba(14, 19, 40, .25);
    width: 100%;
    height: 2px;
    margin-top: 16px;
    margin-bottom: 16px
}

.resource-name {
    display: none
}

.resources-tab-flex-contain {
    transition: all .6s cubic-bezier(.645, .045, .355, 1);
    overflow: hidden
}

.text-span-252,
.text-span-253,
.text-span-254 {
    color: var(--pabloo-green-2)
}

.procurement-team-section {
    padding-top: 85px;
    padding-bottom: 120px
}

.procurement-team-container {
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto
}

.procurement-team-wrapper {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto
}

.procurement-team-header {
    justify-content: center;
    align-items: center;
    display: flex
}

.section-heading {
    text-align: left;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 40px;
    line-height: 1.2em
}

.section-heading.text-center {
    text-align: center
}

.text-span-255 {
    color: var(--pabloo-green-2)
}

.procurement-team-cards-grid {
    grid-column-gap: 64px;
    grid-row-gap: 64px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 100px;
    display: grid
}

.procurement-team-member-image-wrapper {
    display: flex
}

.procurement-team-member-image-wrapper.new {
    justify-content: center;
    align-items: center
}

.procurement-team-member-image {
    height: auto
}

.procurement-team-member-credentials-wrapper {
    margin-top: 24px
}

.procurement-team-member-credentials-wrapper.new {
    width: 100%
}

.procurement-team-member-name {
    text-align: center;
    font-size: 20px;
    font-weight: 600
}

.procurement-team-member-designation {
    text-align: center;
    font-weight: 400
}

.procurement-team-member-description {
    margin-top: 24px
}

.paragraph-146 {
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.6em
}

.text-span-256,
.text-span-257,
.text-span-258,
.text-span-259,
.text-span-260,
.text-span-261,
.text-span-262,
.text-span-263,
.text-span-264 {
    color: var(--pabloo-green-2)
}

.div-block-749 {
    width: 50%;
    max-width: 700px
}

.intgrations-tabs-section {
    padding-top: 100px;
    padding-bottom: 100px
}

.integrations-container {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto
}

.integrations-tabs-wrap {
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    display: block
}

.text-span-265 {
    color: var(--pabloo-green-2)
}

.integrations-tabs-body {
    width: 100%;
    display: flex
}

.tab-link-tab-1 {
    background-color: #fff;
    width: 100%
}

.tab-link-tab-1.w--current {
    color: var(--white);
    background-color: #d53987;
    border-radius: 6px
}

.tab-link-tab-2 {
    background-color: #fdfdfd;
    width: 100%;
    margin-top: 8px
}

.tab-link-tab-2.w--current {
    color: var(--white);
    background-color: #d53987;
    border-radius: 6px
}

.tab-link-tab-3 {
    background-color: #fff;
    border-radius: 6px;
    width: 100%;
    margin-top: 8px
}

.tab-link-tab-3.w--current {
    color: var(--white);
    background-color: #c73b88
}

.integrations-tabs-menu {
    width: 30%;
    margin-top: 32px
}

.tab-pane-tab-1,
.tab-pane-tab-2,
.tab-pane-tab-3 {
    width: 100%
}

.tabs-content-3 {
    -webkit-text-fill-color: inherit;
    background-clip: border-box;
    width: 64%;
    margin-top: -90px;
    margin-left: 0%;
    padding: 2% 2% 4% 4%
}

.div-block-750 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-751 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    border: 1.5px solid #cbd5e1;
    border-radius: 12px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    padding: 20px 20px 20px 16px;
    transition: all .2s;
    display: grid;
    box-shadow: 0 2px 12px rgba(0, 0, 0, .08)
}

.div-block-751:hover {
    box-shadow: 2px 8px 20px rgba(0, 0, 0, .24)
}

.div-block-752 {
    padding: 10px
}

.image-223 {
    border-radius: 10px;
    height: 100px
}

.paragraph-147 {
    font-size: 14px;
    line-height: 1.6em
}

.text-block-307 {
    margin-bottom: 16px;
    line-height: 1.2em
}

.tab-link-tab-4 {
    background-color: var(--white);
    width: 100%;
    margin-top: 8px
}

.tab-link-tab-4.w--current {
    background-color: var(--pabloo-green);
    color: var(--white);
    border-radius: 6px
}

.text-span-266 {
    color: var(--pabloo-green-2)
}

.saas-hero-container {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: relative
}

.saas-hero-section {
    background-color: var(--soft-pink);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 90%, #fff 90%, #fff)
}

.saas-hero-text-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    text-align: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 794px;
    margin-top: 54px;
    display: flex
}

.saas-hero-wrapper {
    z-index: 2;
    color: var(--darker-violet);
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 140px;
    display: flex;
    position: relative
}

.saas-hero-image-wrapper {
    z-index: 2;
    width: 90%;
    max-width: 1076px;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: 20px;
    position: relative
}

.saas-hero-main-image {
    border-radius: 10px;
    width: 100%;
    box-shadow: 0 36px 178px rgba(36, 2, 19, .08)
}

.saas-hero-absolute-image {
    border-radius: 9px;
    width: 100%;
    max-width: 240px;
    position: absolute;
    top: auto;
    bottom: -5%;
    left: -5%;
    right: auto;
    box-shadow: 0 20px 100px rgba(36, 2, 19, .1)
}

.saas-hero-absolute-image.second {
    max-width: 300px;
    top: 28%;
    bottom: auto;
    left: auto;
    right: -4%
}

.stats-section-contain {
    padding-top: 45px;
    padding-bottom: 40px
}

.stats-section-contain.cloud {
    padding-top: 19px
}

.flex-section {
    width: 100%
}

.flex-container {
    grid-column-gap: 140px;
    grid-row-gap: 140px;
    flex-direction: column;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 140px;
    padding-bottom: 140px;
    display: flex
}

.flex-container._140px-bottom-margin {
    padding-top: 0;
    padding-bottom: 140px
}

.flex-container._115px-bottom-margin {
    padding-bottom: 115px
}

.flex-block-wrapper {
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.flex-block-wrapper.vertical {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    flex-direction: column;
    padding-top: 80px
}

.flex-text-block {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-direction: column;
    align-items: flex-start;
    width: 40%;
    max-width: 473px;
    display: flex
}

.flex-text-block._524px {
    max-width: 524px
}

.flex-text-block._580px {
    width: 50%;
    max-width: 580px
}

.flex-text-block._580px.new {
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 600px;
    margin-bottom: 45px
}

.flex-text-block._550px {
    width: 45%;
    max-width: 550px
}

.flex-text-block._440px {
    max-width: 440px
}

.flex-text-block.vertical-cloud {
    text-align: center;
    align-items: center;
    width: 100%;
    max-width: 600px
}

.flex-image-block {
    width: 50%;
    max-width: 676px;
    padding-top: 57px;
    padding-bottom: 57px;
    display: flex;
    position: relative
}

.flex-image-block.lottie {
    width: 55%;
    left: 5%
}

.flex-image-block.cloud-1 {
    max-width: 660px;
    padding-top: 52px;
    padding-bottom: 37px
}

.flex-image-block.vertical-cloud {
    width: 100%;
    max-width: 1080px;
    padding-top: 0;
    padding-bottom: 0
}

.flex-block-icon-embed {
    width: 28px;
    height: 28px
}

.flex-block-icon-contain {
    background-image: linear-gradient(135deg, rgba(72, 33, 53, .1), rgba(72, 33, 53, .15));
    border-radius: 50%;
    width: 50px;
    height: 50px;
    padding: 1px
}

.flex-block-icon-contain._4px-bottom-margin {
    margin-bottom: 4px
}

.flex-block-icon-contain.blue {
    background-image: linear-gradient(135deg, rgba(19, 86, 101, .12), rgba(19, 86, 101, .19))
}

.flex-block-icon-wrapper {
    color: var(--dark-violet);
    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: flex
}

.flex-block-icon-wrapper.blue {
    background-image: linear-gradient(135deg, #d6f8f3, #b3eae2)
}

.flex-block-points-contain {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    display: flex
}

.flex-block-points-contain._495px {
    max-width: 495px
}

.flex-block-point-wrapper {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    display: flex
}

.flex-block-point-icon-embed {
    flex: none;
    width: 20px;
    height: 20px;
    margin-top: 4px
}

.flex-block-point-icon-embed.pink {
    color: var(--pabloo-green)
}

.bold-text-span {
    font-weight: 700
}

.flex-block-background-gradient-contain {
    z-index: 1;
    background-image: linear-gradient(rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));
    border-radius: 16px;
    width: 60%;
    padding: 1px;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: auto
}

.flex-block-background-gradient-contain.blue {
    background-image: linear-gradient(rgba(19, 86, 101, .1), rgba(19, 86, 101, .2))
}

.flex-block-background-gradient-contain.blue.right {
    top: 0%;
    bottom: 0%;
    left: auto;
    right: 0%
}

.flex-block-background-gradient {
    background-image: linear-gradient(135deg, #fbeded, #e5c4c5);
    border-radius: 16px;
    width: 100%;
    height: 100%
}

.flex-block-background-gradient.blue {
    background-image: linear-gradient(135deg, #ddfbf7, #ace6de)
}

.flex-block-image-wrapper {
    z-index: 2;
    flex-direction: column;
    align-items: center;
    width: 100%;
    display: flex;
    position: relative;
    left: 4%
}

.flex-block-image-wrapper.right {
    text-align: left;
    left: auto;
    right: 4%
}

.flex-block-image {
    border-radius: 12px 12px 0 0;
    width: 100%;
    box-shadow: 0 19px 74px rgba(0, 0, 0, .08)
}

.flex-block-image.cloud-1 {
    border-radius: 14px;
    width: 75%;
    max-width: 500px;
    margin-left: -10%;
    box-shadow: 0 20px 100px rgba(36, 2, 19, .1)
}

.flex-block-image.cloud-2 {
    border-radius: 14px;
    width: 75%;
    max-width: 500px;
    margin-top: -40px;
    margin-left: auto;
    box-shadow: 0 -16px 100px rgba(36, 2, 19, .08), 0 20px 110px rgba(0, 0, 0, .05)
}

.flex-block-image.vertical-cloud {
    box-shadow: 0 1px 195px rgba(36, 2, 19, .08)
}

.flex-block-image.cloud-3 {
    box-shadow: 0 19px 93px rgba(36, 2, 19, .05)
}

.flex-pink-section {
    background-color: var(--soft-pink);
    width: 100%
}

.flex-block-abs-image {
    border-radius: 13px;
    width: 100%;
    max-width: 240px;
    position: absolute;
    top: auto;
    bottom: -8%;
    left: auto;
    right: 8%;
    box-shadow: 0 -16px 100px rgba(0, 0, 0, .05), 0 9px 68px rgba(36, 2, 19, .08)
}

.flex-block-abs-image.fourth {
    max-width: 301px;
    top: auto;
    bottom: -12%;
    left: 12%;
    right: auto;
    box-shadow: 0 9px 68px rgba(36, 2, 19, .08)
}

.solution-callout-section {
    background-color: var(--soft-pink);
    width: 100%;
    overflow: hidden
}

.solution-callout-wrapper {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 85%;
    max-width: 1160px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    position: relative
}

.solution-callout-text-wrapper {
    grid-column-gap: 32px;
    grid-row-gap: 32px;
    flex-direction: column;
    align-items: flex-start;
    width: 45%;
    max-width: 501px;
    padding-top: 60px;
    padding-bottom: 60px;
    display: flex
}

.solution-callout-text-wrapper.cloud {
    width: 46%;
    max-width: 490px
}

.solution-callout-images-contain {
    z-index: 1;
    grid-column-gap: 21px;
    grid-row-gap: 21px;
    flex-direction: column;
    width: 50%;
    max-width: 608px;
    display: flex;
    position: absolute;
    top: -10%;
    bottom: auto;
    left: auto;
    right: -5%;
    transform: rotate(-20deg)
}

.solution-callout-images-contain.cloud {
    max-width: 700px
}

.solution-callout-image-row {
    grid-column-gap: 22px;
    grid-row-gap: 22px;
    align-items: center;
    width: 100%;
    display: flex
}

.solution-callout-image-row.cloud-second {
    grid-column-gap: 27px;
    grid-row-gap: 27px;
    margin-left: 15%
}

.solution-callout-image {
    border-radius: 10px;
    width: 100%;
    box-shadow: 0 15px 80px rgba(0, 0, 0, .05)
}

.solution-callout-image.first {
    width: 58%;
    max-width: 361px
}

.solution-callout-image.second {
    width: 40%;
    max-width: 227px
}

.solution-callout-image.third {
    max-width: 395px;
    margin-left: auto;
    margin-right: auto
}

.solution-callout-image.cloud-first {
    box-shadow: none;
    width: 46%;
    max-width: 292px
}

.solution-callout-image.cloud-second {
    width: 55%;
    max-width: 332px;
    box-shadow: 0 -22px 138px rgba(0, 0, 0, .05), 0 12px 94px rgba(36, 2, 19, .08)
}

.solution-callout-image.cloud-third {
    width: 55%;
    max-width: 303px;
    box-shadow: 0 -20px 108px rgba(0, 0, 0, .05)
}

.solution-callout-image.cloud-fourth {
    width: 50%;
    max-width: 280px;
    margin-bottom: auto;
    box-shadow: 0 -20px 108px rgba(0, 0, 0, .05)
}

.setup-section {
    background-color: var(--dark-violet);
    width: 100%
}

.setup-wrapper {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    flex-direction: column;
    align-items: center;
    width: 90%;
    max-width: 1203px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 100px;
    display: flex
}

.setup-span {
    color: #f7e8c7
}

.setup-cards-grid {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    max-width: 1203px;
    display: flex
}

.setup-card-wrapper {
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    width: 100%;
    display: flex
}

.setup-card-number-contain {
    grid-column-gap: 2px;
    grid-row-gap: 2px;
    flex-direction: column;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    width: 90px;
    display: flex
}

.setup-card-number-image {
    object-fit: cover;
    border-radius: 12px;
    width: 100%;
    height: 100%
}

.setup-card-text-contain {
    background-color: var(--soft-pink);
    border-radius: 12px;
    align-items: center;
    width: 100%;
    padding: 28px 20px;
    display: flex
}

.cta-cream-span {
    color: var(--cream)
}

.flex-lottie {
    width: 100%
}

.cloud-hero-container {
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.cloud-hero-section {
    background-color: var(--soft-pink);
    overflow: hidden
}

.cloud-hero-wrapper {
    z-index: 2;
    color: var(--darker-violet);
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 154px;
    padding-bottom: 134px;
    display: flex;
    position: relative
}

.cloud-hero-text-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex-direction: column;
    align-items: flex-start;
    width: 53%;
    max-width: 624px;
    display: flex
}

.cloud-hero-span {
    color: var(--pabloo-green)
}

.cloud-hero-image-wrapper {
    width: 45%;
    max-width: 600px;
    display: flex;
    position: relative
}

.cloud-hero-image {
    width: 100%;
    max-width: 490px;
    margin-left: auto;
    margin-right: auto
}

.cloud-hero-absolute-image {
    border-radius: 8px;
    width: 100%;
    max-width: 180px;
    position: absolute;
    top: 30%;
    bottom: auto;
    left: -10%;
    right: auto;
    box-shadow: 0 12px 60px rgba(0, 0, 0, .05)
}

.cloud-hero-absolute-image.second {
    max-width: 300px;
    top: auto;
    bottom: -10%;
    left: -7%;
    right: auto;
    box-shadow: 0 13px 66px rgba(0, 0, 0, .05)
}

.cloud-hero-absolute-image.third {
    max-width: 197px;
    top: 30%;
    bottom: auto;
    left: auto;
    right: -10%;
    box-shadow: 0 13px 66px rgba(0, 0, 0, .05)
}

.cloud-hero-absolute-image.fourth {
    border-radius: 20px;
    max-width: 180px;
    top: auto;
    bottom: -22%;
    left: auto;
    right: -6%;
    box-shadow: 0 13px 66px rgba(0, 0, 0, .05)
}

.flex-text-header {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    align-items: center;
    display: flex
}

.cloud-absolute-image {
    border-radius: 8px;
    width: 100%;
    max-width: 252px;
    position: absolute;
    top: 38%;
    bottom: auto;
    left: -5%;
    right: auto;
    box-shadow: 0 13px 70px rgba(0, 0, 0, .05)
}

.cloud-absolute-image.second {
    max-width: 210px;
    top: auto;
    bottom: 20%;
    left: auto;
    right: -5%
}

.text-span-269 {
    color: #dfd5d1
}

.sub-heading-title {
    color: var(--dark-violet);
    text-align: center;
    margin-top: 0
}

.subheading-title-wrap {
    justify-content: center;
    display: flex
}

.html-embed-32 {
    margin-top: 2px;
    margin-left: 6px
}

.div-block-753 {
    justify-content: center;
    align-items: center;
    margin-bottom: 100px;
    display: flex
}

.heading-257 {
    text-align: center;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 32px
}

.text-span-270,
.text-span-271,
.text-span-272,
.text-span-273 {
    color: var(--pabloo-green-2)
}

.div-block-754 {
    transition: opacity .2s
}

.spend-absolute-image {
    border-radius: 8px;
    width: 100%;
    max-width: 250px;
    position: absolute;
    top: 29%;
    bottom: auto;
    left: 5%;
    right: auto;
    box-shadow: 0 32px 133px rgba(36, 2, 19, .1)
}

.spend-absolute-image.a {
    width: 40%;
    left: 8%
}

.spend-absolute-image.b {
    width: 40%;
    max-width: 266px;
    top: auto;
    bottom: 20%;
    left: auto;
    right: 5%
}

.heading-258 {
    text-align: center;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 56px
}

.paragraph-148 {
    font-size: 14px;
    line-height: 20px
}

.text-block-308 {
    color: #fff;
    font-size: 16px;
    line-height: 18px
}

.pricing-table-column-category-header {
    background-color: #fcf6e8;
    justify-content: center;
    padding-top: 8px;
    padding-bottom: 8px;
    display: flex
}

.pricing-plan-card {
    background-image: linear-gradient(#fff4dc, #f0deb5 62%);
    border: 1px solid #d7d5d2;
    border-radius: 8px;
    padding: 32px
}

.pricing-plan-card.saas-growth {
    background-image: linear-gradient(#fef2f2, #f5cde1 62%);
    margin-left: 12px
}

.pricing-plan-card.saas-pro {
    margin-left: 0;
    margin-right: 12px
}

.toggle-dot {
    background-color: #fff;
    border-radius: 50%;
    width: 24px;
    height: 24px
}

.text-block-211 {
    font-size: 14px;
    font-weight: 700
}

.pricing-menu-tabs {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    max-width: 100%;
    margin-left: 100px;
    margin-right: 100px;
    display: grid
}

.text-block-309 {
    text-align: center;
    align-self: center;
    padding-top: 0;
    padding-bottom: 0;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px
}

.text-block-209 {
    color: #828aa5;
    font-size: 14px;
    line-height: 1em
}

.div-block-755 {
    margin-top: 24px
}

.pricing-duration-toggle {
    justify-content: flex-end;
    align-items: center;
    max-width: 100%;
    margin-bottom: 48px;
    margin-left: 100px;
    margin-right: 100px;
    display: none
}

.div-block-756 {
    align-items: flex-end;
    margin-top: 24px;
    margin-bottom: 10px;
    display: flex
}

.div-block-440 {
    padding-top: 8px;
    padding-bottom: 8px
}

.div-block-427 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto auto 1fr;
    grid-auto-columns: 1fr;
    align-self: auto;
    align-items: center;
    display: grid
}

.heading-259 {
    font-size: 24px
}

.div-block-424 {
    max-width: 100%;
    margin-left: 100px;
    margin-right: 100px;
    padding-left: 100px;
    padding-right: 100px
}

.section-68 {
    background-color: #faf2eb;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6597aa2642f1fe5180df02ff_Frame%202087326089.svg);
    background-position: 0 0;
    background-size: cover;
    padding-top: 200px
}

.section-68.new {
    padding-top: 140px;
    padding-bottom: 100px
}

.pricing-table-column-status {
    justify-content: center;
    align-items: center;
    display: flex
}

.pricing-table-column-status.gray-bg {
    background-color: #f7f7f5
}

.button-27 {
    text-align: center;
    background-color: #d53987;
    border-radius: 8px;
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    font-size: 16px
}

.tab-link-pabloo-for-cloud {
    color: #828aa5;
    background-color: #fff;
    border-bottom: 2px solid #9ca3af
}

.tab-link-pabloo-for-cloud.w--current {
    color: #d53987;
    background-color: #fff;
    border-bottom: 2px solid #d53987
}

.text-block-310 {
    font-weight: 700
}

.text-block-210 {
    text-transform: none;
    margin-left: 8px;
    font-family: "P22mackinacpro 26", sans-serif;
    line-height: 18px
}

.heading-158 {
    margin-bottom: -8px;
    margin-left: 4px;
    font-family: "P22mackinacpro 16", sans-serif;
    line-height: 52px
}

.div-block-425 {
    max-width: 100%;
    margin-top: 100px;
    margin-left: 0;
    margin-right: 0
}

.toggle-contain {
    background-color: #ea9cc3;
    border-radius: 50px;
    width: 70px;
    height: 34px;
    padding-top: 5px;
    padding-left: 5px;
    padding-right: 5px;
    position: relative
}

.div-block-757 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-205 {
    text-align: center;
    font-size: 20px;
    font-weight: 500
}

.div-block-426 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template: "." "." /1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    max-width: 100%;
    margin-left: 100px;
    margin-right: 100px;
    display: grid
}

.text-block-212 {
    font-weight: 700
}

.pricing-table-row-section-header {
    background-color: #faf2eb;
    width: 100%;
    margin-top: 80px;
    padding: 24px 20px
}

.paragraph-149 {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px
}

.text-block-206 {
    text-align: center;
    font-size: 20px;
    font-weight: 500
}

.pricing-table-column-text {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    display: flex
}

.pricing-table-column-text.gray-bg {
    background-color: #f7f7f5
}

.div-block-429 {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.tab-pane-pabloo-for-saas {
    padding-top: 60px;
    padding-bottom: 0
}

.div-block-431 {
    margin-top: 24px
}

.text-span-274 {
    color: #d53987;
    font-family: "P22mackinacpro 12", sans-serif
}

.div-block-433 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    margin-top: 16px;
    display: grid
}

.tab-link-pabloo-for-saas {
    color: #828aa5;
    background-color: #fff;
    border-bottom: 2px solid #9ca3af
}

.tab-link-pabloo-for-saas.w--current {
    color: #d53987;
    background-color: #fff;
    border-bottom: 2px solid #d53887
}

.text-block-214 {
    color: #514f6d;
    font-size: 16px;
    line-height: 24px
}

.text-block-208 {
    color: #666;
    font-weight: 700
}

.pricing-tier-metric-wrap {
    margin-top: 24px;
    margin-bottom: 0
}

.text-block-312 {
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2em
}

.div-block-758 {
    background-color: #fff;
    border: 1px solid #d7d5d2;
    border-radius: 8px;
    margin-top: 8px;
    padding: 12px 16px
}

.text-block-313 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2em
}

.flex-block-lottie {
    border-radius: 12px 12px 0 0;
    width: 100%;
    box-shadow: 0 19px 74px rgba(0, 0, 0, .08)
}

.flex-block-lottie.animate-from-right {
    z-index: 2;
    box-shadow: none;
    position: relative
}

.type-card-lottie {
    z-index: 2;
    width: 100%;
    position: relative
}

.subscribe-block {
    width: 100%
}

.before-hero-image-mail,
.after-hero-image-mail,
.before-hero-image-inter,
.after-hero-image-inter,
.before-hero-image-adobe,
.after-hero-image-adobe,
.before-hero-image-jira,
.after-hero-image-jira,
.before-hero-image-hubspot,
.after-hero-image-hubspot,
.before-hero-image-zendesk,
.after-hero-image-zendesk {
    width: 100%;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.div-block-759 {
    background-color: #08090a;
    max-width: 100%;
    margin-top: 64px;
    margin-left: 0;
    margin-right: 0;
    padding: 100px
}

.heading-260 {
    color: #f7e8c7;
    text-align: center;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 48px;
    line-height: 56px
}

.heading-261 {
    color: var(--white);
    text-align: center;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 48px;
    line-height: 56px
}

.div-block-760 {
    margin-bottom: 64px
}

.tabs {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: space-between;
    align-items: start;
    justify-items: stretch;
    width: 100%;
    display: grid
}

.tabs-menu-4 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    justify-items: start;
    width: 100%;
    display: grid
}

.tabs-content-4 {
    background-color: #faf2eb;
    background-image: linear-gradient(127deg, #fff4dc, #f0deb5);
    border: 1.5px solid #f7f1d0;
    border-radius: 16px;
    flex: 0 1 auto;
    width: 100%;
    padding: 40px 32px
}

.tab-link-tab-1-2 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    color: var(--white);
    background-color: #282d32;
    border-radius: 20px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    padding: 20px 32px;
    display: grid
}

.tab-link-tab-1-2.w--current {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    background-color: var(--pabloo-green);
    color: var(--white);
    border-radius: 20px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    padding: 20px 32px;
    display: flex
}

.text-block-314 {
    margin-left: 0;
    font-size: 18px;
    line-height: 1em
}

.html-embed-33 {
    margin-bottom: -6px
}

.div-block-761 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-762 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-315 {
    font-family: Inter, sans-serif;
    font-size: 24px;
    font-weight: 500;
    line-height: 36px
}

.div-block-763 {
    display: flex
}

.text-block-316 {
    font-family: "P22mackinacpro 26", sans-serif;
    font-size: 14px
}

.text-block-317 {
    margin-left: 2px;
    margin-right: 2px;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 48px;
    line-height: 40px
}

.div-block-764 {
    margin-top: 24px
}

.text-block-318 {
    font-size: 14px;
    line-height: 20px
}

.div-block-765 {
    margin-top: 16px;
    font-size: 16px;
    line-height: 20px
}

.div-block-766 {
    margin-top: 24px
}

.button-47 {
    background-color: var(--pabloo-green);
    text-align: center;
    border-radius: 10px;
    width: 100%
}

.tab-link-tab-2-2 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    color: var(--white);
    background-color: #282d32;
    border-radius: 20px;
    align-items: center;
    padding: 20px 32px;
    display: flex
}

.tab-link-tab-2-2.w--current {
    background-color: #df4391
}

.text-block-319 {
    line-height: 1em
}

.div-block-767 {
    background-color: #faf2eb;
    border-radius: 20px;
    margin-top: 0;
    margin-bottom: 0%
}

.div-block-767.set {
    margin-bottom: 0%
}

.tab-pane-pabloo-for-cloud {
    padding-top: 60px;
    padding-bottom: 80px
}

.div-block-769 {
    max-width: 100%;
    margin-left: 100px;
    margin-right: 100px;
    padding-left: 24%;
    padding-right: 24%
}

.div-block-770 {
    margin-top: 20px
}

.div-block-771 {
    max-width: 100%;
    padding: 80px 100px
}

.select-field-3 {
    background-color: var(--white);
    color: var(--black);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin-top: 8px;
    font-family: Inter, sans-serif;
    font-weight: 500
}

.subscription-form-embed {
    width: 100%;
    margin-bottom: 0
}

.subscription-form-embed.resource {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto
}

.sticky-progress-bar-contain {
    background-color: rgba(36, 2, 19, .2);
    border-radius: 8px;
    width: 100%;
    height: 4px;
    position: absolute;
    top: auto;
    bottom: -20px;
    left: 0%;
    right: 0%
}

.sticky-blocks-progress-wrapper {
    width: 100%;
    max-width: 407px;
    position: relative
}

.sticky-progress-bar {
    background-color: #240213;
    border-radius: 8px;
    width: 100%;
    height: 100%
}

.share-links-contain {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    justify-content: center;
    width: 100%;
    display: flex
}

.share-link-icon-contain {
    background-image: linear-gradient(135deg, rgba(72, 33, 53, .1), rgba(72, 33, 53, .15));
    border-radius: 12px;
    width: 48px;
    height: 48px;
    padding: 1px
}

.share-link-icon-wrapper {
    color: var(--dark-violet);
    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);
    border-radius: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: flex
}

.share-link-icon-embed {
    width: 28px;
    height: 28px
}

.share-link-icon-embed.check {
    position: absolute;
    top: auto;
    bottom: -100%;
    left: 0%;
    right: 0%
}

.share-embed-contain {
    position: relative;
    overflow: hidden
}

.section-69 {
    background-color: #08090a;
    padding: 120px 100px
}

.text-span-275 {
    color: var(--pabloo-green-2)
}

.html-embed-34 {
    margin-left: 4px
}

.div-block-774 {
    padding-top: 100px
}

.div-block-775 {
    display: flex
}

.badge-image {
    width: 45%;
    max-width: 104px
}

.badge-image.new {
    margin-left: 0;
    margin-right: auto
}

.footer-bottom-wrapper {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: column;
    width: 100%;
    display: flex
}

.footer-socials-contain {
    grid-column-gap: 28px;
    grid-row-gap: 28px;
    align-items: center;
    display: flex
}

.footer-socials-wrapper {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    align-items: center;
    display: flex
}

.social-link-wrapper {
    color: var(--darker-violet);
    border: 1px solid #bdbdbd;
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 56px;
    height: 56px;
    transition: all .3s ease-in-out;
    display: flex
}

.social-link-wrapper:hover {
    background-color: var(--soft-pink);
    color: var(--pabloo-green-2)
}

.footer-end-wrapper {
    justify-content: space-between;
    align-items: center;
    display: flex
}

.privacy-links-contain {
    grid-column-gap: 36px;
    grid-row-gap: 36px;
    align-items: center;
    display: flex
}

.navigation-flex-wrapper {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    justify-content: space-between;
    width: 100%;
    display: flex
}

.navigation-left-flex-wrapper {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    width: 67%;
    max-width: 752px;
    display: flex
}

.navigation-left-flex-wrapper.product {
    width: 75%;
    max-width: 842px
}

.navigation-header {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-right: 24px;
    display: flex
}

.navigation-header.no-padding {
    padding-right: 0
}

.navigation-divider {
    background-color: var(--pabloo-green);
    opacity: .2;
    width: 100%;
    height: 1px
}

.navigation-block-wrapper {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    display: flex
}

.navigation-block-container {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    width: 100%;
    display: flex
}

.navigation-block-container._50 {
    width: 50%
}

.navigation-block-container._40 {
    width: 40%
}

.navigation-block-container._60 {
    width: 75%
}

.navigation-block-links-grid {
    grid-column-gap: 40px;
    grid-row-gap: 24px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%
}

.navigation-block-links-grid._2-column,
.navigation-block-links-grid.resources {
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr
}

.navigation-block-links-grid._1-column {
    grid-template-columns: 1fr
}

.navigation-block-link-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    color: var(--dark-violet);
    align-items: center;
    font-weight: 500;
    transition: color .3s ease-in-out;
    display: flex
}

.navigation-block-link-wrapper:hover {
    color: var(--pabloo-green)
}

.navigation-block-link-wrapper.resource {
    align-items: flex-start
}

.navigation-icon-contain {
    background-image: none;
    border-radius: 50%;
    flex: none;
    width: 40px;
    height: 40px;
    padding: 1px
}

.navigation-icon-contain.new {
    background-image: none
}

.navigation-icon-wrapper {
    color: var(--dark-violet);
    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);
    border-radius: 50%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: flex
}

.navigation-icon-wrapper.new {
    background-image: none
}

.navigation-icon-embed {
    width: 24px;
    height: 24px
}

.navigation-vertical-divider {
    background-color: var(--pabloo-green);
    opacity: .2;
    width: 1px
}

.navigation-right-flex-wrapper {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    flex-direction: column;
    width: 30%;
    display: flex
}

.navigation-right-flex-wrapper.product {
    width: 25%;
    max-width: 348px
}

.dropdown-image-contain {
    background-color: rgba(250, 242, 235, .6);
    border-radius: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: flex
}

.dropdown-image {
    width: 90%;
    max-width: 287px
}

.dropdown-chevron {
    width: 100%;
    max-width: 20px;
    position: absolute;
    top: -12px;
    bottom: auto;
    left: 21%;
    right: auto
}

.dropdown-chevron.solution {
    left: 30%
}

.dropdown-chevron.resources {
    left: 45%
}

.navigation-flex-grid {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    width: 100%;
    display: flex
}

.dropdown-block-image {
    width: 100%;
    margin-bottom: 12px
}

.dropdown-link-headings-contain {
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    flex-direction: column;
    align-items: flex-start;
    display: flex
}

.nav-mobile-contain {
    grid-column-gap: 12px;
    grid-row-gap: 32px;
    align-items: center;
    display: none
}

.product-dropdown-wrapper {
    display: none
}

.navigation-flex-block {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    width: 100%;
    display: flex
}

.dropdown-links-wrapper {
    width: 100%
}

.mobile-links-divider,
.solutions-dropdown-wrapper,
.resources-dropdown-wrapper {
    display: none
}

.ncf-filter-item-container {
    grid-column-gap: 32px;
    grid-row-gap: 48px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.ncf-filter-content-item {
    border-radius: 10px;
    padding: 32px;
    box-shadow: 0 20px 100px rgba(40, 0, 18, .08)
}

.page-indicator-wrapper {
    justify-content: center;
    align-items: center;
    display: flex
}

.page-indicator-wrapper.ncf-filter-page-indicator {
    margin-top: 10px
}

._24px-icon {
    flex: none;
    width: 24px;
    height: 24px;
    margin-top: 0;
    display: inline-block
}

.indicator {
    margin-top: auto;
    margin-bottom: auto;
    display: inline
}

.ncf-filter-control-search {
    outline-offset: 0px;
    border: 1px #000;
    border-radius: 8px;
    outline: 3px #d9d9d9;
    width: 100%;
    height: 56px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 7%;
    font-size: 16px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, .05)
}

.description-container-ncf {
    background-color: #f2ff8d;
    margin-top: 40px;
    margin-bottom: 8px
}

.ncf-filter-reset.ncf-filter-target.ncf-filter-no {
    opacity: 0
}

.ncf-filter-categorie-chip {
    border: 1px solid rgba(40, 0, 21, .1);
    border-radius: 120px;
    padding: 8px 12px;
    font-size: 16px;
    line-height: 24px
}

.ncf-filter-categorie-chip.ncf-selected {
    color: var(--white);
    background-color: #000;
    border-color: rgba(0, 0, 0, .1)
}

.description-header {
    font-family: Inconsolata, monospace
}

.div-block-776 {
    margin-left: auto;
    margin-right: auto;
    padding-top: 2rem;
    padding-bottom: 2rem
}

.heading-262 {
    text-align: center;
    font-family: "P22mackinacpro 12", sans-serif;
    line-height: 4.8rem
}

.text-span-276 {
    color: var(--pabloo-green-2)
}

.integrations-search-field-wrapper {
    width: 56%;
    margin-top: -126px;
    margin-left: auto;
    margin-right: auto;
    position: relative
}

.html-embed-35 {
    position: absolute;
    top: 28%;
    bottom: auto;
    left: 2%;
    right: auto
}

.apps-filter-tags-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    display: flex
}

.apps-filters-wrapper {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 100%;
    grid-auto-columns: 1fr;
    align-items: center;
    margin-top: 40px;
    display: grid
}

.slide-nav-7 {
    display: none
}

.slider-19 {
    background-color: rgba(255, 255, 255, 0);
    align-items: center;
    width: auto;
    height: auto;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    padding-left: 50px;
    padding-right: 50px;
    display: block
}

.slide-21 {
    width: auto;
    height: auto;
    margin-right: 8px;
    padding-bottom: 0;
    padding-right: 0
}

.slide-22 {
    width: auto;
    height: auto;
    margin-left: 8px;
    padding-bottom: 0;
    padding-right: 0
}

.left-arrow-9 {
    background-color: #eee;
    border-radius: 100%;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    display: block
}

.right-arrow-10 {
    background-color: #eee;
    border-radius: 100%;
    width: 40px;
    height: 40px
}

.html-embed-36 {
    align-self: center;
    margin-top: -1px
}

.app-listing-card {
    position: relative
}

.app-listing-flo-score {
    position: absolute;
    top: -38px;
    right: -12px
}

.div-block-777 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    font-family: "P22mackinacpro 26", sans-serif;
    font-size: 28px;
    line-height: 32px;
    display: grid
}

.image-225 {
    width: auto;
    height: 48px
}

.paragraph-150 {
    font-size: 16px;
    line-height: 24px
}

.div-block-778 {
    margin-top: 20px
}

.div-block-779 {
    border-top: 1px solid rgba(222, 222, 222, .3);
    margin-top: 40px;
    padding-top: 80px
}

.link-block-37 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    border: 1px solid #280015;
    border-radius: 8px;
    justify-content: flex-end;
    align-items: center;
    width: auto;
    padding: 8px 40px;
    display: flex
}

.html-embed-37 {
    margin-bottom: -6px
}

.div-block-780 {
    margin-left: 48px;
    display: none
}

.points-section {
    background-color: #014737;
    position: relative;
    overflow: hidden
}

.points-text-contain {
    flex-direction: column;
    align-items: flex-start;
    width: 51%;
    max-width: 630px;
    display: flex
}

.points-image-contain {
    grid-column-gap: 14px;
    grid-row-gap: 14px;
    flex-direction: column;
    width: 46%;
    max-width: 602px;
    display: flex
}

.points-bg-contain {
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.points-bg-image {
    width: 126%;
    max-width: 126%;
    height: 115%;
    position: absolute;
    top: -7.5%;
    bottom: 0%;
    left: -5%;
    right: 0%
}

.points-heading-span {
    color: var(--cream)
}

.points-checklist-grid {
    grid-column-gap: 24px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-bottom: 40px;
    display: grid
}

.points-checklist-row {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: flex-start;
    display: flex
}

.html-embed-38 {
    flex: none;
    width: 20px;
    height: 20px;
    margin-top: 4px
}

.points-images-top-flex {
    justify-content: space-between;
    display: flex
}

.points-image {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.points-image-wrapper {
    border-radius: 10.64px;
    overflow: hidden;
    box-shadow: 11px -11px 97px rgba(36, 2, 19, .12)
}

.points-image-wrapper.a {
    width: 54.9834%;
    max-width: 331px
}

.points-image-wrapper.b {
    width: 42.3588%;
    max-width: 255px
}

.points-image-wrapper.c {
    width: 100%;
    max-width: 602px
}

.text-span-277 {
    color: var(--pabloo-green-2)
}

.empty-state-12 {
    background-color: #fff
}

.image-226 {
    height: 140px
}

.section-70 {
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    padding-top: 24px;
    padding-bottom: 120px
}

.image-227 {
    height: 24px
}

.heading-263 {
    margin-top: 0;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px
}

.features-wrapper-2 {
    border: 1px solid #e4e4e4;
    border-radius: 8px;
    justify-content: space-around;
    align-items: center;
    margin-top: 24px;
    padding-top: 0;
    padding-bottom: 0;
    display: flex
}

.competitor-landing-hero-form-2 {
    background-color: #fff;
    border-left: 12px #5050ff;
    border-radius: 8px;
    flex-wrap: wrap;
    justify-content: center;
    padding: 24px;
    font-family: Inter, sans-serif;
    display: block;
    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
}

.html-embed-39 {
    margin-left: auto;
    margin-right: auto;
    display: block
}

.div-block-781 {
    grid-column-gap: 48px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .7fr;
    grid-auto-columns: 1fr;
    align-items: start;
    display: grid
}

.text-block-320 {
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 1em
}

.div-block-782 {
    justify-content: flex-start;
    align-items: center;
    width: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.text-block-321 {
    color: #d53987;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px
}

.div-block-783 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: auto auto 1fr;
    grid-auto-columns: 1fr;
    justify-items: start;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    display: grid
}

.features-title {
    margin-bottom: 8px;
    font-size: 40px;
    font-weight: 600;
    line-height: 48px
}

.div-block-784 {
    background-color: #f5cde1;
    border-radius: 4px;
    justify-content: center;
    width: 100%;
    margin-top: 16px;
    margin-left: auto;
    margin-right: auto;
    padding: 4px 8px 8px;
    display: flex
}

.features-block {
    text-align: center;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.div-block-785 {
    padding-right: 40px
}

.div-block-786 {
    grid-column-gap: 12px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 28px 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid
}

.div-block-786.mt-sm {
    margin-top: 12px
}

.heading-264 {
    letter-spacing: -.5px;
    margin-top: 24px;
    font-size: 2.3rem;
    font-weight: 700;
    line-height: 1.2em
}

.text-span-278 {
    color: #d53987
}

.image-228 {
    height: 24px
}

.div-block-787 {
    justify-content: center;
    margin-top: 24px;
    display: flex
}

.features-title-small {
    font-size: 24px;
    line-height: 32px
}

.div-block-788 {
    font-family: Inter, sans-serif
}

.sysf-collapse-text {
    opacity: 0;
    color: var(--systemflow-lite--neutral--80);
    padding-top: 0;
    padding-bottom: 12px;
    padding-left: 32px;
    display: none
}

.sysf-collapse-text.sysf-borderless {
    padding-left: 12px
}

.material-icons.sysf-icon-left {
    margin-top: 2px;
    margin-right: 4px
}

.material-icons.sysf-icon-left.sysf-icon-collapse {
    color: var(--systemflow-lite--neutral--80);
    margin-top: 0;
    margin-right: 0
}

.sysf-collapse-title {
    flex: 1 1;
    margin-left: 12px;
    font-weight: 500;
    display: inline-block
}

.sysf-collapse-trigger {
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    display: flex
}

.sysf-collapse-item-2 {
    cursor: pointer;
    padding-left: 16px;
    padding-right: 16px
}

.sysf-collapse {
    border-radius: 6px;
    overflow: hidden
}

.sysf-collapse.sysf-borderless {
    background-color: var(--systemflow-lite--neutral--10);
    border-style: none;
    padding: 24px
}

.sysf-collapse-wrapper {
    max-width: 640px;
    margin-left: auto;
    margin-right: auto
}

.sysf-heading {
    color: var(--systemflow-lite--neutral--100)
}

.sysf-heading.sysf-l {
    letter-spacing: -.021em;
    margin-top: 0;
    margin-bottom: 1.25rem;
    font-size: 2.25rem;
    font-weight: 600;
    line-height: 1.25
}

.sysf-tagline {
    background-color: var(--white-smoke);
    color: var(--pabloo-green);
    letter-spacing: -.006em;
    text-transform: uppercase;
    border-radius: 6px;
    margin-bottom: 3.05rem;
    padding: 8px 67px;
    font-size: 16px;
    font-weight: 800;
    line-height: 28px;
    display: inline-block;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .2)
}

.sysf-section-title {
    width: 50%;
    margin-bottom: 48px
}

.sysf-section-title.sysf-centered {
    text-align: center;
    text-align: center;
    width: 90%;
    margin-left: auto;
    margin-right: auto
}

.sysf-wrapper-m {
    padding-top: 64px;
    padding-bottom: 64px
}

.sysf-container {
    max-width: 1248px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 24px;
    padding-right: 24px
}

.sysf-c-b-neutral-20 {
    background-color: var(--systemflow-lite--neutral--20)
}

.sysf-body-text {
    color: var(--systemflow-lite--neutral--80);
    margin-top: 0
}

.sysf-body-text.sysf-m {
    letter-spacing: -.011em
}

.sysf-s-m-b-0 {
    margin-bottom: 0
}

.sysf-faq-question {
    margin-bottom: 8px;
    font-weight: 600
}

.sysf-faq-item-wrapper {
    margin-bottom: 24px
}

.sysf-faq-item-wrapper.sysf-box {
    background-color: var(--systemflow-lite--neutral--20);
    border-radius: 6px;
    height: 100%;
    margin-bottom: 24px;
    padding: 24px
}

.sysf-faq-item-wrapper.sysf-box.sysf-last {
    margin-bottom: 0
}

.sysf-column {
    width: 50%;
    padding-left: 12px;
    padding-right: 12px
}

.sysf-row {
    flex-direction: row;
    align-items: stretch;
    margin-left: -12px;
    margin-right: -12px;
    display: flex
}

.brix---heading-h3-size {
    margin-top: 0;
    margin-bottom: 2px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.2em
}

.brix---color-neutral-800 {
    color: var(--elements-webflow-library--neutral--800)
}

.brix---color-accent-1 {
    color: var(--pabloo-green)
}

.brix---display-2 {
    font-size: 40px;
    font-weight: 700;
    line-height: 1.2em
}

.brix---mg-bottom-12px {
    margin-bottom: 4px
}

.brix---text-center {
    text-align: center
}

.brix---stat-card-4-cols---04 {
    border-style: solid;
    border-width: 1px 0 0 1px;
    border-color: var(--elements-webflow-library--neutral--300);
    border-bottom-right-radius: 24px;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-left: -1px;
    padding: 44px 20px;
    display: flex
}

.brix---stat-card-4-cols---03 {
    border-style: solid;
    border-width: 1px 1px 0 0;
    border-color: var(--elements-webflow-library--neutral--300);
    border-bottom-left-radius: 24px;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 44px 20px;
    display: flex
}

.brix---stat-card-4-cols---02 {
    border: 1px solid var(--elements-webflow-library--neutral--300);
    border-top-right-radius: 24px;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-bottom: -1px;
    margin-left: -1px;
    padding: 12px;
    display: flex
}

.brix---stat-card-4-cols---01 {
    border: 1px solid var(--elements-webflow-library--neutral--300);
    border-top-left-radius: 24px;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-bottom: -1px;
    margin-right: -1px;
    padding: 12px;
    display: flex
}

.brix---grid-2-stats-v4 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    margin-top: 24px;
    display: grid
}

.brix---card {
    border: 1px solid var(--elements-webflow-library--neutral--300);
    background-color: var(--elements-webflow-library--neutral--100);
    box-shadow: 0 2px 7px 0 var(--elements-webflow-library--general--shadow-01);
    border-radius: 24px
}

.brix---heading-h2-size {
    margin-top: 0;
    margin-bottom: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;
    font-size: 38px;
    font-weight: 700;
    line-height: 50px
}

.brix---text-center-tablet {
    text-align: left
}

.brix---grid-stats-v4 {
    grid-column-gap: 70px;
    grid-row-gap: 28px;
    grid-template-rows: auto;
    grid-template-columns: .4fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    display: grid
}

.brix---container-default {
    max-width: 1218px;
    padding-left: 24px;
    padding-right: 24px
}

.brix---section {
    color: var(--elements-webflow-library--neutral--100);
    padding-top: 80px;
    padding-bottom: 80px
}

.brix---image-width-100 {
    width: 100%
}

.brix---border-radius-24px {
    z-index: -1;
    border-radius: 24px;
    overflow: hidden;
    transform: translate(0)
}

.brix---link-icon-right {
    margin-left: 6px
}

.brix---text-200-bold {
    color: var(--pabloo-green);
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 20px
}

.brix---color-accent-2 {
    color: var(--elements-webflow-library--accent--primary-1)
}

.brix---link-wrapper {
    color: var(--systemflow-lite--neutral--80);
    align-items: center;
    font-size: 18px;
    line-height: 20px;
    text-decoration: none;
    transition: color .3s;
    display: flex
}

.brix---link-wrapper:hover {
    color: var(--elements-webflow-library--accent--primary-1)
}

.brix---color-neutral-600 {
    color: var(--elements-webflow-library--neutral--600)
}

.brix---paragraph-default {
    margin-bottom: 0;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;
    font-size: 18px;
    line-height: 30px
}

.brix---mg-bottom-24px {
    margin-bottom: 24px
}

.brix---heading-h3-size-2 {
    margin-top: 0;
    margin-bottom: 12px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 34px
}

.brix---color-neutral-801 {
    color: var(--elements-webflow-library--neutral--800)
}

.brix---mg-bottom-8px {
    margin-bottom: 8px
}

.brix---mg-bottom-48px {
    color: var(--black);
    margin-bottom: 0
}

.brix---card-link-content-left-fw {
    border: 1px solid var(--elements-webflow-library--neutral--300);
    background-color: var(--elements-webflow-library--neutral--100);
    box-shadow: 0 2px 7px 0 var(--elements-webflow-library--general--shadow-01);
    transform-style: preserve-3d;
    border-radius: 24px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 48px 32px 32px;
    text-decoration: none;
    transition: transform .3s, color .3s;
    display: flex
}

.brix---card-link-content-left-fw:hover {
    transform: scale3d(.94, .94, 1.01)
}

.brix---grid-3-columns---1-col-mb {
    grid-column-gap: 28px;
    grid-row-gap: 28px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 40px;
    display: grid
}

.brix---inner-container-600px---center {
    max-width: 80%;
    margin-left: auto;
    margin-right: auto
}

.bold-text-26 {
    font-size: 34px;
    line-height: 1.3em
}

.div-block-789 {
    margin-top: 0
}

.div-block-790 {
    width: 100%
}

.text-block-322 {
    text-transform: capitalize;
    margin-top: 10px;
    font-size: 21px;
    font-weight: 900
}

.text-block-323 {
    font-size: 16px;
    line-height: 1.2
}

.button-new {
    background-color: var(--pabloo-green);
    border-radius: 9px;
    margin-left: 0;
    margin-right: auto;
    padding: 16px 40px;
    font-size: 20px;
    font-weight: 600
}

.button-48 {
    background-color: var(--pabloo-green);
    border-radius: 8px;
    padding: 3px 30px;
    font-weight: 600
}

.youtube-3 {
    margin-top: 34px
}

.image-229 {
    z-index: 2;
    position: static
}

.image-230 {
    text-align: left;
    height: 400px
}

.new-product-heading-4 {
    color: var(--pabloo-green-2);
    letter-spacing: -.5px;
    margin-bottom: 16px;
    font-family: Satoshi, sans-serif;
    font-size: 44px;
    line-height: 48px
}

.new-product-heading-4.max-width-400px {
    max-width: 440px
}

.div-block-791 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    justify-content: flex-start;
    display: flex
}

.image-231 {
    height: 400px
}

.image-232 {
    height: 500px
}

.image-233 {
    text-align: right;
    height: 400px
}

.image-234 {
    height: 500px
}

.image-235 {
    height: 400px
}

.image-236 {
    height: 500px
}

.text-block-324 {
    color: var(--pabloo-green-2);
    text-align: center;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600
}

.hero-platform-wrapper-solutions {
    z-index: 2;
    width: 90%;
    max-width: 1280px;
    min-height: 200px;
    margin-left: auto;
    margin-right: auto;
    padding: 120px 8% 0;
    position: relative
}

.hero-platform-wrapper-solutions.padding-bottom-md {
    padding-bottom: 80px
}

.image-237 {
    object-fit: contain;
    height: 100%
}

.heading-64px-copy {
    letter-spacing: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 64px;
    font-weight: 800;
    line-height: 112.5%
}

.heading-64px-copy.hero-home-heading {
    display: inline
}

.heading-64px-copy.hero-home-heading.sales {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    transform: perspective(2000px)
}

.heading-64px-copy.hero-home-heading.zapier,
.heading-64px-copy.hero-home-heading.snow {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    position: absolute;
    transform: perspective(2000px)
}

.heading-64px-copy.hero-home-heading.top {
    max-width: 515.278px
}

.heading-64px-copy.hero-home-heading.bottom {
    z-index: 2;
    transition: all .2s;
    position: relative
}

.heading-64px-copy.hero-home-heading.mail,
.heading-64px-copy.hero-home-heading.inter,
.heading-64px-copy.hero-home-heading.adobe,
.heading-64px-copy.hero-home-heading.jira,
.heading-64px-copy.hero-home-heading.hubspot,
.heading-64px-copy.hero-home-heading.zendesk {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    position: absolute;
    transform: perspective(2000px)
}

.heading-64px-copy.text-align-center {
    text-align: center;
    margin-top: 15px;
    padding-left: 69px;
    padding-right: 69px;
    font-size: 32px
}

.heading-64px-copy.text-align-center.ebook {
    color: #7e7d7d;
    font-family: Satoshi, sans-serif;
    font-size: 20px
}

.heading-64px-copy.text-align-center.events {
    text-transform: uppercase;
    font-family: Satoshi, sans-serif;
    font-size: 20px
}

.heading-64px-copy.blogs-hero-heading {
    text-align: center
}

.heading-64px-copy.resource-hero-heading {
    color: var(--white);
    text-align: left
}

.heading-64px-copy.saas-hero-heading,
.heading-64px-copy.cloud-hero-heading {
    margin-bottom: 4px
}

.heading-64px-copy.skewed {
    transform: rotate(-11deg)
}

.heading-64px-copy.skewed.text-color-pink {
    color: var(--pabloo-green-2);
    margin-top: -16px;
    margin-left: 12px;
    margin-right: 12px
}

.heading-64px-new {
    letter-spacing: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 64px;
    font-weight: 800;
    line-height: 112.5%
}

.heading-64px-new.hero-home-heading {
    display: inline
}

.heading-64px-new.hero-home-heading.sales {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    transform: perspective(2000px)
}

.heading-64px-new.hero-home-heading.zapier,
.heading-64px-new.hero-home-heading.snow {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    position: absolute;
    transform: perspective(2000px)
}

.heading-64px-new.hero-home-heading.top {
    max-width: 515.278px
}

.heading-64px-new.hero-home-heading.bottom {
    z-index: 2;
    transition: all .2s;
    position: relative
}

.heading-64px-new.hero-home-heading.mail,
.heading-64px-new.hero-home-heading.inter,
.heading-64px-new.hero-home-heading.adobe,
.heading-64px-new.hero-home-heading.jira,
.heading-64px-new.hero-home-heading.hubspot,
.heading-64px-new.hero-home-heading.zendesk {
    background-color: var(--soft-pink);
    backface-visibility: hidden;
    perspective: 2000px;
    position: absolute;
    transform: perspective(2000px)
}

.heading-64px-new.text-align-center {
    text-align: center;
    flex-direction: column;
    margin-top: 15px;
    padding-left: 69px;
    padding-right: 69px;
    font-size: 32px;
    line-height: 1.4;
    display: flex
}

.heading-64px-new.blogs-hero-heading {
    text-align: center
}

.heading-64px-new.resource-hero-heading {
    color: var(--white);
    text-align: left
}

.heading-64px-new.saas-hero-heading,
.heading-64px-new.cloud-hero-heading {
    margin-bottom: 4px
}

.heading-64px-new.skewed {
    transform: rotate(-11deg)
}

.heading-64px-new.skewed.text-color-pink {
    color: var(--pabloo-green-2);
    margin-top: -16px;
    margin-left: 12px;
    margin-right: 12px
}

.image-238 {
    object-fit: fill;
    height: auto;
    position: relative
}

.feature-image-wrapper-copy.right.green-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);
    flex: 1 1;
    width: 50%;
    height: 550px;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy.left.yellow-bg {
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    height: 500px;
    padding-bottom: 32px
}

.feature-image-wrapper-copy.left.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    height: 500px;
    padding-bottom: 32px
}

.feature-content-heading-text-copy {
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 28px;
    line-height: 1.4em
}

.image-240 {
    max-width: 90%;
    height: auto
}

.ctas-container-copy {
    grid-column-gap: 40px;
    grid-row-gap: 40px;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 84px;
    padding-bottom: 95px;
    display: flex
}

.ctas-text-wrapper-copy {
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    max-width: 607px;
    display: flex
}

.ctas-text-wrapper-copy._50 {
    width: 50%
}

.heading-48px-copy.ctas-heading {
    color: var(--white);
    letter-spacing: 0;
    max-width: 580px;
    margin-bottom: 8px;
    padding-bottom: 11px;
    font-size: 28px;
    line-height: 1.4
}

.paragraph-18px-copy.ctas-paragraph {
    color: var(--white);
    max-width: 600px;
    margin-top: 12px;
    margin-bottom: 32px;
    line-height: 1.2;
}

.paragraph-18px-copy.ctas-paragraph.center-this {
    color: var(--white);
    max-width: 600px;
    margin-top: 12px;
    margin-bottom: 32px;
    line-height: 1.2;
    /* text-align: center; */
}

.ctas-button-contain-copy {
    grid-column-gap: 18px;
    grid-row-gap: 18px;
    flex-wrap: wrap;
    display: flex
}

.heading-48px-copy {
    margin-top: 0;
    margin-bottom: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 48px;
    font-weight: 800;
    line-height: 116.667%
}

.heading-48px-copy.stack-heading {
    color: var(--white);
    text-align: center;
    max-width: 800px;
    margin-bottom: 40px;
    margin-left: auto;
    margin-right: auto
}

.heading-48px-copy.blogs-heading {
    text-align: center;
    max-width: 728px
}

.heading-48px-copy.ctas-heading {
    color: var(--white);
    max-width: 580px;
    margin-bottom: 8px
}

.heading-48px-copy.ctas-heading._16px-bottom-margin {
    margin-bottom: 16px
}

.heading-48px-copy.blog-post-title {
    color: var(--dark-violet)
}

.heading-48px-copy.blog-post-title.cms {
    color: #5b002c
}

.heading-48px-copy.setup-heading {
    color: var(--white);
    text-align: center;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto
}

.heading-48px-copy.points-heading {
    color: var(--white);
    max-width: 534px;
    margin-bottom: 24px
}

.heading-28px-copy.ctas-subheading {
    color: #f7e8c7;
    margin-bottom: 20px
}

.paragraph-18px-copy {
    font-size: 18px;
    line-height: 156%
}

.paragraph-18px-copy.hero-home-paragraph {
    color: var(--darker-violet);
    margin-bottom: 24px
}

.paragraph-18px-copy.integrations-paragraph {
    margin-bottom: 40px
}

.paragraph-18px-copy.stack-block-paragraph {
    color: var(--white)
}

.paragraph-18px-copy.blog-post-summary._8px-bottom-margn {
    margin-bottom: 8px
}

.paragraph-18px-copy.ctas-paragraph {
    color: var(--white);
    align-self: center;
    max-width: 600px;
    margin-top: 0;
    margin-bottom: 0;
    padding-left: 0;
    font-size: 16px
}

.paragraph-18px-copy.tribe-tab-paragraph {
    color: var(--dark-violet)
}

.paragraph-18px-copy.reviewer-position {
    opacity: .8;
    font-weight: 500
}

.paragraph-18px-copy.calculator-toggle-text {
    font-weight: 700
}

.paragraph-18px-copy.resource-post-description {
    color: #240213
}

.paragraph-18px-copy.saas-hero-paragraph {
    max-width: 636px;
    margin-bottom: 24px
}

.paragraph-18px-copy.cloud-hero-paragraph {
    max-width: 527px;
    margin-bottom: 24px
}

.paragraph-18px-copy.navigation-header-link-text {
    font-family: Satoshi, sans-serif;
    font-weight: 700
}

.paragraph-18px-copy.points-check-list-text {
    color: var(--white)
}

.div-block-792 {
    display: flex
}

.text-span-279 {
    color: #a9e5dd
}

.heading-28px-copy {
    font-size: 28px;
    font-weight: 600;
    line-height: 128.571%
}

.heading-28px-copy.type-card-heading {
    max-width: 483px;
    margin-bottom: 20px
}

.heading-28px-copy.ctas-subheading {
    color: #f7e8c7;
    margin-bottom: 11px;
    font-size: 25px
}

.div-block-793 {
    flex-direction: row;
    flex: 0 1 auto;
    order: 0;
    justify-content: flex-start;
    align-self: flex-start;
    align-items: stretch;
    display: flex
}

.image-242 {
    margin-right: 4px
}

.heading-28px-copy-copy {
    font-size: 28px;
    font-weight: 600;
    line-height: 128.571%
}

.heading-28px-copy-copy.type-card-heading {
    max-width: 483px;
    margin-bottom: 20px
}

.heading-28px-copy-copy.ctas-subheading {
    color: #f7e8c7;
    margin-top: 15px;
    margin-bottom: 3px;
    font-size: 18px;
    font-weight: 400
}

.spend-analyse-footer {
    padding: 56px
}

.image-243 {
    margin-top: 7px
}

.ctas-text-wrapper-copy-copy {
    flex-direction: column;
    align-items: flex-start;
    width: 40%;
    max-width: 607px;
    display: flex
}

.ctas-text-wrapper-copy-copy._50 {
    width: 50%
}

.ctas-text-wrapper-copy-copy-copy {
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    max-width: 607px;
    display: flex
}

.ctas-text-wrapper-copy-copy-copy._50 {
    width: 50%
}

.feature-image-wrapper-copy-copy {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 55%;
    padding-top: 40px;
    padding-left: 40px
}

.feature-image-wrapper-copy-copy.right {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    background-position: 100%;
    padding-top: 40px;
    padding-left: 0;
    padding-right: 40px
}

.feature-image-wrapper-copy-copy.right.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    justify-content: flex-end;
    padding-bottom: 40px;
    display: flex
}

.feature-image-wrapper-copy-copy.right.green-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);
    flex: 1 1;
    width: 50%;
    height: 550px;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy-copy.right.green-bg.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper-copy-copy.right.yellow-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    padding-bottom: 1px;
    padding-right: 38px
}

.feature-image-wrapper-copy-copy.right.yellow-bg.padding-reset {
    padding-top: 0;
    padding-right: 0
}

.feature-image-wrapper-copy-copy.right.green-bg-copy {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    width: 50%;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy-copy.right.green-bg-copy.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper-copy-copy.left {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)
}

.feature-image-wrapper-copy-copy.left.green-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    padding-bottom: 40px
}

.feature-image-wrapper-copy-copy.left.green-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper-copy-copy.left.yellow-bg {
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    height: 500px;
    padding-bottom: 32px
}

.feature-image-wrapper-copy-copy.left.yellow-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper-copy-copy.left.yellow-bg.padding-left-reset {
    padding-left: 0
}

.feature-image-wrapper-copy-copy.left.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    height: 500px;
    padding-bottom: 32px
}

.feature-image-wrapper-copy-copy.left.pink-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-content-wrap-copy {
    width: 40%
}

.feature-image-wrapper-copy.left.yellow-bg {
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    height: auto;
    padding-bottom: 32px
}

.image-245 {
    max-width: 90%
}

.text-block-325 {
    text-align: center;
    flex: 0 1 auto;
    margin-top: 11px;
    font-size: 16px
}

.div-block-794 {
    flex-direction: column;
    flex: 0 1 auto;
    justify-content: flex-start;
    display: flex
}

.stats-wrapper-copy {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 100px;
    display: flex
}

.stats-section-copy {
    width: 100%;
    margin-top: 102px
}

.stats-wrapper-new {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 100px;
    display: flex
}

.stats-wrapper-new.ebook {
    margin-top: 25px
}

.stats-wrapper-new.x {
    padding-bottom: 40px
}

.stats-section-copy {
    width: 100%;
    display: block;
    overflow: hidden
}

.stats-wrapper-copy {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    padding-top: 0;
    padding-bottom: 100px;
    display: flex
}

.stats-section-copy {
    width: 100%;
    margin-top: 26px;
    overflow: hidden
}

.hero-platform-cta-wrapper-copy {
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 48px;
    display: flex
}

.feature-image-wrapper-copy {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 55%;
    padding-top: 40px;
    padding-left: 40px
}

.feature-image-wrapper-copy.right {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    background-position: 100%;
    padding-top: 40px;
    padding-left: 0;
    padding-right: 40px
}

.feature-image-wrapper-copy.right.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    justify-content: flex-end;
    padding-bottom: 40px;
    display: flex
}

.feature-image-wrapper-copy.right.green-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);
    flex: 1 1;
    width: 50%;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy.right.green-bg.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper-copy.right.yellow-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    padding-bottom: 1px;
    padding-right: 38px
}

.feature-image-wrapper-copy.right.yellow-bg.padding-reset {
    padding-top: 0;
    padding-right: 0
}

.feature-image-wrapper-copy.right.green-bg-copy {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    width: 50%;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy.right.green-bg-copy.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper-copy.left {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)
}

.feature-image-wrapper-copy.left.green-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    padding-bottom: 40px
}

.feature-image-wrapper-copy.left.green-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper-copy.left.yellow-bg {
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex-direction: column;
    flex: 1 1;
    justify-content: flex-start;
    align-items: center;
    height: 550px;
    padding-bottom: 32px;
    display: flex
}

.feature-image-wrapper-copy.left.yellow-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper-copy.left.yellow-bg.padding-left-reset {
    padding-left: 0
}

.feature-image-wrapper-copy.left.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    flex: 1 1;
    height: 500px;
    padding-bottom: 32px
}

.feature-image-wrapper-copy.left.pink-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.div-block-732-copy {
    background-color: #fff;
    width: 100%;
    height: 180px;
    margin-top: -227px;
    padding-top: 0
}

.div-block-795 {
    flex: 0 1 auto
}

.text-block-326 {
    text-align: center;
    margin-top: 20px
}

.hero-button-cta-copy {
    text-align: center;
    text-align: center;
    background-color: #c73a88;
    border-radius: 10px;
    padding: 16px 50px;
    font-family: Satoshi, sans-serif;
    font-weight: 500
}

.div-block-796 {
    flex-direction: column;
    display: flex
}

.text-block-327 {
    text-align: center;
    margin-top: 20px;
    font-size: 16px
}

.text-span-280,
.text-span-281,
.text-span-282 {
    color: var(--pabloo-green-2)
}

.feature-image-wrapper-copy-copy-copy {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: contain;
    width: 55%;
    padding-top: 40px;
    padding-left: 40px
}

.feature-image-wrapper-copy-copy-copy.right {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    background-position: 100%;
    padding-top: 40px;
    padding-left: 0;
    padding-right: 40px
}

.feature-image-wrapper-copy-copy-copy.right.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    justify-content: flex-end;
    padding-bottom: 40px;
    display: flex
}

.feature-image-wrapper-copy-copy-copy.right.green-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);
    flex: 1 1;
    width: 50%;
    height: 500px;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy-copy-copy.right.green-bg.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper-copy-copy-copy.right.yellow-bg {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    padding-bottom: 1px;
    padding-right: 38px
}

.feature-image-wrapper-copy-copy-copy.right.yellow-bg.padding-reset {
    padding-top: 0;
    padding-right: 0
}

.feature-image-wrapper-copy-copy-copy.right.green-bg-copy {
    text-align: right;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    flex: 1 1;
    width: 50%;
    min-height: auto;
    padding-bottom: 40px
}

.feature-image-wrapper-copy-copy-copy.right.green-bg-copy.padding-right-reset {
    padding-right: 0
}

.feature-image-wrapper-copy-copy-copy.left {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)
}

.feature-image-wrapper-copy-copy-copy.left.green-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);
    padding-bottom: 40px
}

.feature-image-wrapper-copy-copy-copy.left.green-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper-copy-copy-copy.left.yellow-bg {
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
    height: 500px;
    padding-bottom: 32px
}

.feature-image-wrapper-copy-copy-copy.left.yellow-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.feature-image-wrapper-copy-copy-copy.left.yellow-bg.padding-left-reset {
    padding-left: 0
}

.feature-image-wrapper-copy-copy-copy.left.pink-bg {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);
    height: 500px;
    padding-bottom: 32px
}

.feature-image-wrapper-copy-copy-copy.left.pink-bg.padding-reset {
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 0
}

.text-span-283,
.text-span-284 {
    color: var(--pabloo-green-2)
}

.logos-main-wrapper-copy {
    width: 100%;
    position: relative
}

.splide-copy {
    position: relative
}

.splide__track-copy {
    display: flex;
    position: relative
}

.logo-colour-overlay-copy {
    z-index: 2;
    background-color: var(--dark-violet);
    mix-blend-mode: color;
    display: block;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.splide__list-copy {
    flex: none;
    display: flex;
    position: relative
}

.image-212-copy {
    height: 42px
}

.image-212-copy-copy {
    object-fit: contain;
    height: 36px
}

.hero-heading-copy {
    text-align: center
}

.hero-heading-copy.competitor-landing-usp-highlight-heading {
    color: var(--white)
}

.home-value-heading-copy {
    color: #fff;
    margin-bottom: 20px
}

.new-navigation-background-div {
    z-index: 1;
    opacity: 0;
    background-color: #fff;
    width: 100%;
    max-width: 100%;
    margin: 0;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)
}

.new-navigation-background-div.dark {
    background-color: var(--black-2)
}

.div-block-20-copy {
    margin-top: 0%;
    padding: 0% 8px 32%;
    position: relative
}

.div-block-21-copy {
    background-color: #fff;
    border-radius: 8px;
    padding: 48px;
    position: static;
    box-shadow: 1px 1px 24px rgba(0, 0, 0, .1)
}

.div-block-21-copy.registration-form-block {
    backdrop-filter: blur(8px);
    outline-offset: 0px;
    background-color: #f0f0f0;
    border: 12px solid rgba(213, 57, 135, .16);
    outline: 3px #000;
    margin-top: 30px;
    margin-bottom: 0;
    padding: 11px 20px 16px;
    box-shadow: 3px 3px 24px rgba(0, 0, 0, .1)
}

.navigation-background-div-black {
    z-index: 1;
    opacity: 0;
    background-color: #fff;
    border-radius: 12px;
    width: 94%;
    max-width: 1312px;
    margin: 10px auto;
    position: absolute;
    top: 0%;
    bottom: 0%;
    left: 0%;
    right: 0%;
    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)
}

.navigation-background-div-black.dark {
    background-color: #18020d;
    border-radius: 0;
    width: 100%;
    max-width: 100%;
    margin-top: 0;
    margin-bottom: 0
}

.html-embed-40 {
    color: var(--pabloo-green-2);
    font-weight: 600
}

.text-span-285 {
    color: var(--pabloo-green-2)
}

.text-span-286,
.text-span-287,
.text-span-288,
.text-span-289 {
    color: var(--black)
}

.text-span-290 {
    color: var(--pabloo-green)
}

.hero-button-cta-slack {
    text-align: center;
    background-color: #c73a88;
    border-radius: 10px;
    padding: 16px 32px;
    font-family: Satoshi, sans-serif;
    font-weight: 500
}

.text-block-328 {
    color: var(--pabloo-green-2);
    text-align: center;
    font-weight: 600
}

.features-section-copy {
    padding-top: 0;
    padding-bottom: 120px;
    display: flex
}

.features-wrapper-copy {
    width: 90%;
    max-width: 1280px;
    margin-top: 83px;
    margin-left: auto;
    margin-right: auto
}

.image-231-copy {
    height: 500px
}

.fast-track-approval-hero-section-copy {
    background-color: var(--white-smoke);
    margin-bottom: 240px;
    position: relative
}

.wrapper-1280px-copy {
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-bottom: 100px;
    display: flex;
    position: relative
}

.wrapper-1280px-copy.popup-div {
    padding-top: 0;
    padding-bottom: 0
}

.wrapper-1280px-copy.solution-wrapper {
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px-copy.split-wrapper {
    flex-direction: column;
    align-items: stretch;
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px-copy.finance-wrapper {
    flex-direction: column;
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px-copy.together-blue-flex {
    max-width: 1200px
}

.wrapper-1280px-copy.discover-product-hero-flex {
    flex-direction: column;
    padding-top: 88px;
    padding-bottom: 0
}

.wrapper-1280px-copy.discover-purchase-flex {
    padding-top: 120px;
    padding-bottom: 140px
}

.wrapper-1280px-copy.discover-tools-flex {
    max-width: 1260px;
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px-copy.procurement-black-flex {
    flex-direction: column;
    align-items: stretch;
    padding-top: 140px;
    padding-bottom: 140px
}

.wrapper-1280px-copy.case-study-hero-flex {
    padding-top: 64px;
    padding-bottom: 64px
}

.wrapper-1280px-copy.case-study-flex {
    justify-content: center
}

.wrapper-1280px-copy.track-approval-flex {
    max-width: 1260px
}

.wrapper-1280px-copy.multi-channel-approval-flex {
    max-width: 1200px;
    padding-top: 80px;
    padding-bottom: 80px
}

.wrapper-1280px-copy.workflow-approval-flex {
    align-items: center;
    padding-bottom: 120px
}

.wrapper-1280px-copy.fast-track-approval-hero-flex {
    z-index: 1;
    flex-direction: column;
    padding-top: 88px;
    padding-bottom: 0
}

.wrapper-1280px-copy.document-one-place-flex {
    padding-top: 120px;
    padding-bottom: 140px
}

.wrapper-1280px-copy.best-deals-flex {
    padding-top: 80px;
    padding-bottom: 80px
}

.wrapper-1280px-copy.assisted-tools-flex {
    padding-top: 70px;
    padding-bottom: 120px
}

.wrapper-1280px-copy.assisted-purchasing-flex {
    flex-direction: column;
    padding-top: 88px;
    padding-bottom: 0
}

.wrapper-1280px-copy.actionable-insight-flex {
    padding-top: 120px;
    padding-bottom: 120px
}

.wrapper-1280px-copy.contract-renewals-flex {
    max-width: 1200px;
    padding-top: 120px;
    padding-bottom: 140px
}

.wrapper-1280px-copy.slack-steps-width-limiter {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px
}

.wrapper-1280px-copy.custo {
    flex-wrap: wrap;
    justify-content: center
}

.wrapper-1280px-copy.wrap {
    flex-wrap: wrap
}

.wrapper-1280px-copy.custom {
    padding-top: 40px;
    padding-bottom: 80px
}

.wrapper-1280px-copy.pt-xs {
    padding-top: 24px
}

.wrapper-1280px-copy.points-container {
    z-index: 3
}

.fast-track-hero-wrapper-copy {
    text-align: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 780px;
    margin-top: 119px;
    margin-bottom: 80px;
    display: flex
}

.div-block-797 {
    display: block;
    position: relative
}

.navbar-logo-center-container {
    z-index: 5;
    background-color: transparent;
    width: 1030px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 20px
}

.navbar-logo-center-container.shadow-three {
    width: 100%;
    max-width: 1140px
}

.container-1290 {
    width: 100%;
    max-width: 940px;
    margin-left: auto;
    margin-right: auto
}

.navbar-wrapper-three {
    justify-content: center;
    align-items: center;
    display: flex;
    position: relative
}

.navbar-brand-three {
    z-index: 5;
    position: absolute
}

.nav-menu-wrapper-three {
    width: 100%
}

.nav-menu-three {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    display: flex
}

.nav-menu-block {
    justify-content: center;
    align-items: center;
    margin-bottom: 0;
    display: flex
}

.nav-link-6 {
    color: #1a1b1f;
    letter-spacing: .25px;
    margin-left: 5px;
    margin-right: 5px;
    padding: 5px 10px;
    font-size: 14px;
    line-height: 20px;
    text-decoration: none
}

.nav-link-6:hover {
    color: rgba(26, 27, 31, .75)
}

.nav-link-6:focus-visible {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 4px;
    outline: 2px solid #0050bd
}

.nav-link-6[data-wf-focus-visible] {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 4px;
    outline: 2px solid #0050bd
}

.nav-dropdown {
    margin-left: 5px;
    margin-right: 5px
}

.nav-dropdown-toggle {
    letter-spacing: .25px;
    padding: 5px 30px 5px 10px;
    font-size: 14px;
    line-height: 20px
}

.nav-dropdown-toggle:hover {
    color: rgba(26, 27, 31, .75)
}

.nav-dropdown-toggle:focus-visible {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-dropdown-toggle[data-wf-focus-visible] {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-dropdown-icon {
    margin-right: 10px
}

.nav-dropdown-list {
    background-color: #fff;
    border-radius: 12px
}

.nav-dropdown-list.w--open {
    padding-top: 10px;
    padding-bottom: 10px
}

.nav-dropdown-link {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 14px
}

.nav-dropdown-link:focus-visible {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-dropdown-link[data-wf-focus-visible] {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-link-accent {
    color: #1a1b1f;
    letter-spacing: .25px;
    margin-left: 5px;
    margin-right: 20px;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-decoration: none
}

.nav-link-accent:hover {
    color: rgba(26, 27, 31, .75)
}

.button-primary {
    color: #fff;
    letter-spacing: 2px;
    text-transform: uppercase;
    background-color: #1a1b1f;
    padding: 12px 25px;
    font-size: 12px;
    line-height: 20px;
    transition: all .2s
}

.button-primary:hover {
    color: #fff;
    background-color: #32343a
}

.button-primary:active {
    background-color: #43464d
}

.hello-bar-link {
    color: var(--white);
    font-size: 16px;
    font-weight: 700
}

.new-hello-bar {
    z-index: 7;
    background-color: var(--pabloo-green);
    text-align: center;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    position: fixed
}

.text-span-291 {
    font-weight: 900
}

.hello-navigation-bar {
    z-index: 20;
    background-color: var(--transparent);
    /* margin-top: 48px; */
    position: fixed;
    top: 0;
    bottom: auto;
    left: 0%;
    right: 0%
}

.hello-navbar-container {
    z-index: 2;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 100vw;
    margin-left: auto;
    margin-right: auto;
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    position: relative
}

.stats-section-copy-copy {
    width: 100%;
    margin-top: 0
}

.stats-wrapper-copy-copy {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    padding-top: 0;
    padding-bottom: 100px;
    display: flex
}

.heading-90px-copy {
    letter-spacing: -3.6px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 90px;
    font-weight: 700;
    line-height: 124.444%
}

.heading-24px-copy {
    font-size: 24px;
    line-height: 133.333%
}

.heading-24px-copy.stats-text {
    margin-bottom: 4px;
    font-weight: 500
}

.heading-24px-copy.type-card-subheading {
    font-weight: 600
}

.heading-24px-copy.stack-block-heading {
    margin-right: auto;
    font-weight: 600
}

.heading-24px-copy.blog-post-title {
    font-weight: 600
}

.heading-24px-copy.blog-post-title.resource-feature {
    color: var(--white);
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 700
}

.heading-24px-copy.footer-logo-subtext {
    font-weight: 500
}

.heading-24px-copy.tribe-link-heading {
    color: var(--dark-violet)
}

.heading-24px-copy.review-text {
    letter-spacing: 0;
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 800
}

.heading-24px-copy.resource-tab-heading {
    font-weight: 600
}

.heading-24px-copy.setup-card-text {
    max-width: 230px;
    font-size: 20px
}

.heading-24px-copy.navigation-header-heading {
    font-family: Satoshi, sans-serif
}

.heading-24px-copy.stats-text-copy {
    margin-bottom: 4px;
    font-weight: 500;
    line-height: 100%
}

.pitch-section-copy {
    background-color: var(--white);
    margin-top: 4px;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    display: block;
    overflow: visible
}

.bold-text-30-copy {
    letter-spacing: 0;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 30px;
    line-height: 100%;
    display: block
}

.bold-text-31 {
    white-space: normal;
    font-size: 18px
}

.bold-text-31-copy {
    white-space: normal;
    font-size: 18px;
    font-weight: 500
}

.stats-section-copy-copy {
    width: 100%;
    margin-top: 79px;
    overflow: hidden
}

.wrapper-1300px-copy {
    z-index: 2;
    background-color: transparent;
    border-radius: 16px;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding: 40px 34px;
    display: flex;
    position: relative
}

.home-hero-heading-copy {
    font-size: 46px;
    line-height: 1.2em
}

.home-hero-heading-copy.smaller {
    font-size: 48px
}

.image-246 {
    height: 32px
}

.cta-section-copy {
    background-color: var(--pabloo-green);
    padding-top: 0;
    padding-bottom: 0
}

.div-block-798 {
    height: 100px
}

.stats-grid-copy {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    width: 90%;
    max-width: 1188px;
    margin-top: 0;
    margin-left: auto;
    margin-right: auto
}

.solutions-overview-sec-copy {
    background-color: var(--darker-violet);
    width: 100%;
    display: none;
    overflow: hidden
}

.hero-bkg-copy {
    z-index: 0;
    object-fit: fill;
    object-position: 50% 0%;
    background-color: rgba(255, 255, 255, 0);
    flex: 1 1;
    width: 100%;
    height: 85%;
    max-height: 900px;
    display: block;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.home-split-section-copy {
    background-color: var(--soft-pink);
    padding-top: 90px;
    padding-bottom: 0
}

.home-split-section-copy.light-grey-bg {
    background-color: var(--white-smoke)
}

.home-split-section-copy.bottom-0 {
    padding-bottom: 0
}

.home-split-section-copy._50-50 {
    padding-top: 0;
    padding-bottom: 50px
}

.wrapper-1300px-copy-copy {
    z-index: 2;
    background-color: transparent;
    border-radius: 16px;
    flex-wrap: wrap;
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding: 71px 34px 40px;
    display: flex;
    position: relative
}

.wrapper-1300px-copy-copy.home-hero-flex {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;
    display: flex
}

.wrapper-1300px-copy-copy.featured-on-wrapper {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 24px
}

.wrapper-1300px-copy-copy.center {
    justify-content: center
}

.wrapper-1300px-copy-copy.mt-negative {
    margin-top: -32px
}

.wrapper-1300px-copy-copy.p0 {
    padding-left: 0;
    padding-right: 0
}

.wrapper-1300px-copy-copy.p-top-reset {
    padding-top: 0
}

.wrapper-1300px-copy-copy._40-0 {
    padding-bottom: 0
}

.wrapper-1300px-copy-copy._0-40 {
    padding-top: 0
}

.image-247 {
    text-align: left;
    object-fit: contain;
    height: 100%;
    display: block
}

.hero-platform-image-slack {
    text-align: left;
    width: 100%;
    height: 100%;
    margin-top: 48px;
    display: flex
}

.div-block-799 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 45px;
    display: grid
}

.hero-button-cta-slack-copy {
    text-align: center;
    background-color: #c73a88;
    border-radius: 10px;
    padding: 16px 90px;
    font-family: Inter, sans-serif;
    font-weight: 600
}

.paragraph-152 {
    text-align: left;
    /* padding-right: 82px */
}

.paragraph-152.social {
    text-align: left;
    width: 100%
}

.blog-collection-item-copy.margin.custo {
    border: 10px none var(--goldenrod);
    background-color: var(--white);
    border-radius: 0;
    margin-bottom: 12px
}

.collection-list-8 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    flex: 0 1 auto;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: stretch;
    padding-left: 24px;
    padding-right: 24px;
    display: grid
}

.collection-list-wrapper-7 {
    flex-direction: column;
    flex: 1 1;
    order: 0;
    justify-content: flex-start;
    align-self: auto;
    align-items: flex-start;
    max-width: 1080px;
    display: flex
}

.blog-hero-heading-copy {
    color: var(--black);
    letter-spacing: normal;
    align-self: center;
    max-width: 800px;
    margin: 15px auto 20px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 52px
}

.text-span-292 {
    color: var(--pabloo-green)
}

.hero-bkg-copy {
    z-index: 1;
    object-fit: fill;
    object-position: 50% 0%;
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    height: 85%;
    max-height: 700px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.hero-bkg-copy.blog {
    height: 100%;
    max-height: none
}

.hero-bkg-copy.blog-cms {
    max-height: 540px
}

.hero-bkg-copy.hub {
    max-height: 621px
}

.hero-bkg-copy.saas {
    max-height: 769px;
    bottom: 10%
}

.hero-bkg-copy.cloud {
    height: 90%;
    max-height: 561px
}

.hero-bkg-copy-copy {
    z-index: 0;
    opacity: .41;
    object-fit: fill;
    object-position: 50% 0%;
    background-color: rgba(255, 255, 255, 0);
    width: 100%;
    height: 85%;
    max-height: 700px;
    position: absolute;
    top: auto;
    bottom: 0%;
    left: 0%;
    right: 0%
}

.hero-bkg-copy-copy.blog {
    height: 100%;
    max-height: none
}

.hero-bkg-copy-copy.blog-cms {
    max-height: 540px
}

.hero-bkg-copy-copy.hub {
    max-height: 621px
}

.hero-bkg-copy-copy.saas {
    max-height: 769px;
    bottom: 10%
}

.hero-bkg-copy-copy.cloud {
    height: 90%;
    max-height: 561px
}

.blog-collection-item-copy {
    background-color: var(--white);
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 520px;
    padding: 24px 24px 38px;
    display: flex;
    box-shadow: 0 10px 80px rgba(0, 0, 0, .05)
}

.blog-collection-item-copy:hover {
    box-shadow: 0 10px 40px rgba(0, 0, 0, .1)
}

.blog-collection-item-copy.margin {
    max-width: 440px;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 12px
}

.blog-collection-item-copy.margin.custo {
    border: 10px none var(--goldenrod);
    background-color: var(--white);
    border-radius: 0;
    max-width: 540px;
    margin-bottom: 12px
}

.blog-collection-item-copy.margin.custo._1 {
    margin-top: 0;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px
}

.blog-collection-item-copy.margin.custo._2 {
    background-image: none;
    margin-left: 0;
    margin-right: 12px;
    padding-left: 24px;
    padding-right: 24px
}

.blog-collection-item-copy.margin.mt-16 {
    border-radius: 0;
    margin-top: 0
}

.blog-collection-item-copy.limit-width {
    max-width: 440px;
    margin-left: 12px
}

.blog-collection-item-copy.limit-width.custo {
    border: 10px none var(--goldenrod);
    border-radius: 0
}

.blog-collection-item-copy.limit-width.custo.m-t-16 {
    margin-top: 0;
    margin-left: 0;
    margin-right: 12px
}

.blog-collection-item-copy-copy.margin.custo {
    border: 10px none var(--goldenrod);
    background-color: var(--white);
    border-radius: 0;
    max-width: 540px;
    margin-bottom: 12px
}

.blog-collection-item-copy-copy {
    background-color: var(--white);
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 520px;
    padding: 24px 24px 38px;
    display: flex;
    box-shadow: 0 10px 80px rgba(0, 0, 0, .05)
}

.blog-collection-item-copy-copy:hover {
    box-shadow: 0 10px 40px rgba(0, 0, 0, .1)
}

.blog-collection-item-copy-copy.margin {
    max-width: 440px;
    margin-top: 0;
    margin-bottom: 0;
    margin-right: 12px
}

.blog-collection-item-copy-copy.margin.custo {
    border: 10px none var(--goldenrod);
    background-color: var(--white);
    border-radius: 0;
    margin-bottom: 12px
}

.blog-collection-item-copy-copy.margin.custo._1 {
    margin-top: 0;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px
}

.blog-collection-item-copy-copy.margin.custo._2 {
    background-image: none;
    margin-left: 0;
    margin-right: 12px;
    padding-left: 24px;
    padding-right: 24px
}

.blog-collection-item-copy-copy.margin.mt-16 {
    border-radius: 0;
    margin-top: 0
}

.blog-collection-item-copy-copy.limit-width {
    max-width: 440px;
    margin-left: 12px
}

.blog-collection-item-copy-copy.limit-width.custo {
    border: 10px none var(--goldenrod);
    border-radius: 0
}

.blog-collection-item-copy-copy.limit-width.custo.m-t-16 {
    margin-top: 0;
    margin-left: 0;
    margin-right: 12px
}

.div-block-800 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-329 {
    font-size: 32px
}

.text-block-330 {
    text-align: center;
    flex: 1 1;
    margin-top: 69px;
    margin-bottom: 46px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 36px;
    font-weight: 700
}

.text-span-293 {
    color: var(--pabloo-green-2)
}

.cms-blog-block-section-copy {
    padding-bottom: 140px
}

.cms-blog-block-section-copy.templates-block {
    margin-top: -176px
}

.bold-text-32 {
    font-family: "P22mackinacpro 12", sans-serif
}

.blog-card-image-copy {
    object-fit: cover;
    width: 100%;
    height: 100%
}

.blog-card-image-copy.custo {
    object-fit: contain;
    transform-style: preserve-3d
}

.blog-card-image-copy.custo:hover {
    object-fit: contain;
    transform: scale3d(1.1, 1.1, 1.1)
}

.about-hero-wrapper-copy {
    background-color: var(--slate-blue);
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    margin-bottom: 90px;
    padding-top: 120px;
    padding-bottom: 0;
    position: relative
}

.wrapper-1300px-copy {
    z-index: 2;
    background-color: transparent;
    border-radius: 16px;
    flex-wrap: wrap;
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding: 2px 34px 40px;
    display: flex;
    position: relative
}

.wrapper-1300px-copy.home-hero-flex {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;
    display: flex
}

.wrapper-1300px-copy.featured-on-wrapper {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 24px
}

.wrapper-1300px-copy.center {
    justify-content: center
}

.wrapper-1300px-copy.mt-negative {
    margin-top: -32px
}

.wrapper-1300px-copy.p0 {
    padding-left: 0;
    padding-right: 0
}

.wrapper-1300px-copy.p-top-reset {
    padding-top: 0
}

.wrapper-1300px-copy._40-0 {
    padding-bottom: 0
}

.wrapper-1300px-copy._0-40 {
    padding-top: 0
}

.new-about-1300px-header {
    z-index: 2;
    background-color: transparent;
    border-radius: 16px;
    flex-wrap: wrap;
    width: 90%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding: 2px 34px 40px;
    display: flex;
    position: relative
}

.new-about-1300px-header.home-hero-flex {
    flex-wrap: wrap;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 0;
    display: flex
}

.new-about-1300px-header.featured-on-wrapper {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 24px
}

.new-about-1300px-header.center {
    justify-content: center
}

.new-about-1300px-header.mt-negative {
    margin-top: -32px
}

.new-about-1300px-header.p0 {
    padding-left: 0;
    padding-right: 0
}

.new-about-1300px-header.p-top-reset {
    padding-top: 0
}

.new-about-1300px-header._40-0 {
    padding-bottom: 0
}

.new-about-1300px-header._0-40 {
    padding-top: 0
}

.new-about-hero-wrapper {
    background-color: var(--soft-pink);
    background-image: none;
    background-position: 0 0;
    background-repeat: repeat;
    background-size: auto;
    background-attachment: scroll;
    margin-bottom: 90px;
    padding-top: 176px;
    padding-bottom: 79px;
    position: relative
}

.text-span-294 {
    color: var(--black);
    font-size: 28px;
    font-weight: 600
}

.xs-text {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 56px;
    font-weight: 800
}

.about-heading-x {
    color: var(--black-2);
    margin-bottom: 20px;
    font-size: 65px;
    line-height: 110%
}

.about-heading-x.white {
    color: var(--white)
}

.about-hero-text-wrap-copy {
    width: 90%;
    margin-left: auto;
    margin-right: auto
}

.stats-section-copy-copy,
.stats-about {
    width: 100%;
    overflow: hidden
}

.stats-wrapper-copy-copy,
.stats-xx {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-direction: column;
    width: 100%;
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 100px;
    display: flex
}

.text-block-331 {
    color: var(--pabloo-green-2);
    text-align: left;
    align-self: flex-start;
    margin-left: 0;
    font-size: 28px;
    font-weight: 700;
    display: none
}

.text-block-332 {
    text-align: left;
    padding-top: 35px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 46px;
    line-height: 1.2
}

.text-block-332.intra {
    text-align: center;
    margin-bottom: 32px;
    padding-right: 34px;
    font-size: 46px
}

.text-span-295 {
    color: var(--pabloo-green)
}

.div-block-801 {
    border: 2px solid #cbd5e1;
    border-radius: 10px;
    width: 100%;
    padding: 24px;
    display: flex;
    box-shadow: 0 0 2px rgba(0, 0, 0, .2)
}

.div-block-801:hover {
    box-shadow: 0 8px 15px -7px rgba(0, 0, 0, .2)
}

.div-block-801.integra {
    border-color: #d3d3d3
}

.div-block-802 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.image-248 {
    border: 2px solid #cbd5e1;
    border-radius: 10px;
    height: 80px;
    margin-right: 23px
}

.image-248._2-0 {
    box-shadow: none;
    border-width: 0
}

.div-block-803 {
    line-height: 1.1
}

.text-block-333 {
    text-align: left;
    font-weight: 700
}

.div-block-804 {
    flex-flow: column;
    flex: 0 1 auto;
    align-self: center;
    display: flex
}

.div-block-805 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    padding-top: 0;
    padding-bottom: 28px;
    display: grid
}

.div-block-805.integra {
    grid-template-columns: 1fr 1fr;
    margin-top: 39px
}

.text-block-334,
.text-block-335,
.text-block-336 {
    text-align: left
}

.tribe-section---about {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
    overflow: hidden
}

.tribe-tab-image-contain-copy {
    width: 100%;
    padding-top: 57px;
    padding-bottom: 57px;
    display: none;
    position: relative
}

.text-span-296 {
    color: var(--pabloo-green-2)
}

.text-block-337 {
    margin-top: 26px;
    font-size: 16px
}

.div-block-806 {
    height: 100px
}

.solutions-overview-sec-copy,
.about-x-platform {
    background-color: var(--darker-violet);
    width: 100%;
    overflow: hidden
}

.ctas-wrapper-copy {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529ed3e13ed5242e06f6cc0_CTA%20Bg.svg);
    background-position: 0 0;
    background-size: auto;
    width: 100%;
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto
}

.about-x-platform-wrapper {
    background-color: var(--dark-violet);
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529ed3e13ed5242e06f6cc0_CTA%20Bg.svg);
    background-position: 0 0;
    background-size: auto;
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.about-x-platform-wrapper.new {
    margin-bottom: 73px
}

.ctas-container-copy {
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 84px;
    padding-bottom: 95px;
    display: flex
}

.about-x-platform-container {
    flex-flow: column;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    max-width: 1280px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 180px;
    padding-bottom: 160px;
    display: flex
}

.text-block-338 {
    color: var(--white);
    text-align: center;
    flex: 1 1;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 46px;
    font-weight: 500;
    line-height: 1.3
}

.text-span-297 {
    color: var(--white)
}

.about-x-cards {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    margin-top: 66px;
    display: grid
}

.about-x-cards.new {
    flex-flow: wrap;
    justify-content: center;
    align-items: center;
    justify-items: center;
    display: flex
}

.about-x-card {
    background-image: linear-gradient(150deg, #fdf0f1, #e3c0c1 77%);
    border-radius: 15px;
    margin-top: 0;
    padding: 40px 29px
}

.about-x-card._1 {
    background-image: linear-gradient(150deg, #d3fbf6, #a9e5dd 77%)
}

.about-x-card._3 {
    background-image: linear-gradient(150deg, #fff4dc, #f0deb5 77%)
}

.about-x-card.new {
    flex-flow: column;
    flex: 0 1 auto;
    justify-content: flex-start;
    align-items: flex-start;
    width: 30%;
    height: 250px;
    display: flex
}

.text-block-339 {
    text-transform: uppercase;
    padding-bottom: 20px;
    font-family: Satoshi, sans-serif;
    font-size: 50px;
    font-weight: 900;
    line-height: 1.1
}

.text-block-339.new {
    padding-bottom: 0;
    font-size: 25px
}

.text-block-340 {
    margin-top: 28px;
    font-family: Satoshi, sans-serif;
    font-size: 18px;
    font-weight: 900;
    line-height: 1.2
}

.text-block-340.new {
    font-size: 22px
}

.text-block-341 {
    text-align: left;
    margin-top: 17px;
    font-family: Satoshi, sans-serif;
    font-size: 15px;
    line-height: 1.3
}

.text-block-341.new {
    font-weight: 500
}

.text-span-298,
.text-span-299 {
    color: var(--pabloo-green)
}

.div-block-807 {
    flex-flow: column;
    display: flex
}

.integra.x {
    padding-top: 44px
}

.text-block-342 {
    text-align: left
}

.text-block-342.intra {
    margin-top: 10px;
    font-size: 16px;
    line-height: 1.2
}

.text-block-343 {
    border: 2px solid var(--light-slate-grey);
    text-align: left;
    border-radius: 3px;
    width: 90%;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 11px 21px;
    font-weight: 900
}

.text-block-343:hover {
    border-width: 2px;
    border-color: var(--white-smoke);
    background-color: var(--pabloo-green);
    color: var(--white)
}

.text-block-343:active {
    color: var(--dark-violet);
    border-width: 2px
}

.div-block-808 {
    flex-flow: column;
    margin-top: 44px;
    display: flex
}

.div-block-809 {
    display: flex
}

.integra-btn {
    margin-bottom: 13px
}

.tabs-menu-5 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    flex-flow: column;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    width: 90%;
    margin: 34px 0 34px 5px;
    display: grid
}

.tab-link-all,
.tab-link-finance,
.tab-link-sso,
.tab-link-hrms {
    margin-right: 21px
}

.integra-tab {
    background-color: #fff;
    border: 2px solid #d3d3d3;
    border-radius: 10px;
    width: 90%;
    margin-top: 4px;
    margin-bottom: 4px;
    padding-top: 13px;
    padding-bottom: 13px;
    font-weight: 700
}

.integra-tab.w--current {
    border-color: var(--pabloo-green);
    background-color: var(--pabloo-green);
    color: var(--white);
    width: 90%;
    padding-top: 13px;
    padding-bottom: 13px;
    font-weight: 700
}

.integra-text {
    font-weight: 700
}

.tabs-2 {
    max-width: 1300px;
    display: flex
}

.div-block-810 {
    margin-top: 81px;
    display: flex
}

.div-block-811 {
    flex: 1 1
}

.div-block-812 {
    width: 100%
}

.text-block-344 {
    text-align: center;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    width: 80%;
    margin-bottom: 50px;
    margin-left: auto;
    margin-right: auto;
    font-family: Inter, sans-serif;
    display: flex
}

.pricing-block {
    background-image: linear-gradient(283deg, rgba(77, 184, 129, .32), #f4fbf9);
    border-radius: 13px;
    padding: 27px 46px 46px;
    display: block
}

.div-block-814 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    display: flex
}

.text-block-345 {
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 30px;
    font-weight: 700;
    line-height: 64px
}

.text-block-346 {
    padding-right: 7px;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 30px;
    font-weight: 500;
    line-height: 64px
}

.text-block-347 {
    margin-bottom: 21px;
    font-size: 14px;
    line-height: 1.3
}

.pricing-cards {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 40px;
    display: grid
}

.pricing-card {
    background-color: var(--white);
    border-radius: 10px;
    flex-flow: column;
    height: 170px;
    padding: 22px;
    display: flex;
    box-shadow: 0 2px 20px -8px rgba(0, 0, 0, .2)
}

.text-block-348 {
    clear: none;
    background-color: #0cc531;
    border-radius: 6px;
    flex-flow: row;
    flex: 0 1 auto;
    justify-content: flex-start;
    align-self: flex-start;
    align-items: stretch;
    padding-left: 16px;
    padding-right: 16px;
    font-family: Satoshi, sans-serif;
    font-size: 16px;
    font-weight: 700;
    display: flex;
    position: static
}

.text-block-349 {
    margin-top: 10px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-weight: 700
}

.text-block-350 {
    font-size: 14px
}

.text-block-351 {
    text-transform: uppercase;
    font-weight: 700
}

.text-block-352 {
    margin-top: 30px;
    margin-bottom: 12px;
    font-weight: 600
}

.container-offerings {
    flex-flow: wrap;
    display: flex
}

.div-block-816 {
    background-color: var(--white);
    border-radius: 4px;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    margin-right: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 18px;
    display: flex;
    box-shadow: 0 1px 11px -5px rgba(0, 0, 0, .2)
}

.text-block-353 {
    color: var(--light-slate-grey);
    flex: 1 1;
    padding-left: 14px;
    font-size: 13px;
    font-weight: 500
}

.html-embed-41 {
    padding-left: 10px
}

.html-embed-42 {
    flex: 0 1 auto
}

.faq-section-x {
    background-color: var(--dark-violet);
    padding-top: 100px;
    padding-bottom: 100px;
    display: block
}

.faq-section-x.demo {
    background-color: var(--white)
}

.faq-item-x {
    background-color: var(--white);
    border-radius: 20px;
    margin-bottom: 20px;
    padding: 24px 30px
}

.faq-item-x.demo {
    background-color: var(--white-smoke);
    box-shadow: 0 2px 3px rgba(0, 0, 0, .2)
}

.faq-question-trigger {
    text-align: center;
    cursor: pointer;
    flex-flow: row;
    align-content: center;
    align-items: center;
    margin-bottom: 9px;
    padding-top: 0;
    padding-bottom: 0;
    display: flex
}

.sysf-custom-code-embeds {
    display: none
}

.faq-drop-icon {
    order: 0;
    align-self: auto;
    max-width: none;
    height: 10px;
    margin-right: 0;
    padding-right: 0
}

.heading-265 {
    text-align: left;
    flex: 1 1;
    margin-top: 0;
    margin-bottom: 0;
    padding-right: 15px;
    font-size: 22px;
    line-height: 1.2
}

.faq-answer {
    overflow: hidden
}

.paragraph-153 {
    text-align: left;
    margin-bottom: 15px;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-right: 12px;
    font-size: 16px
}

.div-block-817 {
    flex: 0 1 auto;
    align-self: center;
    padding: 6px;
    font-size: 22px;
    line-height: 1.2
}

.text-block-354 {
    color: var(--white);
    text-align: center;
    margin-bottom: 60px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 42px;
    line-height: 64px
}

.text-block-354.new {
    color: var(--black-2)
}

.text-span-300 {
    color: var(--pabloo-green-2)
}

.div-block-818 {
    flex-flow: row;
    display: flex
}

.text-block-355 {
    color: var(--black-2);
    flex: 1 1;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 42px;
    line-height: 1.3
}

.button-49 {
    align-self: center;
    padding-left: 91px;
    padding-right: 91px
}

.text-span-301 {
    color: var(--pabloo-green-2)
}

.div-block-819 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 50px;
    display: grid
}

.div-block-820 {
    border-radius: 14px;
    padding: 28px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, .2)
}

.heading-266 {
    font-family: P22 Mackinacpro, sans-serif
}

.paragraph-154 {
    margin-top: 0;
    padding-top: 8px;
    font-size: 16px;
    line-height: 1.3
}

.section-71 {
    display: block
}

.div-block-821 {
    margin-bottom: 0
}

.section-72 {
    float: none;
    clear: both;
    text-align: left;
    width: 100%;
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 100px;
    padding-left: 44px;
    padding-right: 44px
}

.section-72.what-is-in {
    padding-top: 45px;
    padding-left: 44px;
    padding-right: 44px
}

.section-72.why-read {
    grid-column-gap: 22px;
    grid-row-gap: 22px;
    flex-flow: column;
    padding-top: 0;
    padding-bottom: 100px;
    display: flex
}

.section-72.events {
    padding-top: 100px
}

.section-72.testimonial {
    padding-top: 100px;
    padding-bottom: 100px
}

.section-72.expectation {
    padding-top: 60px;
    padding-bottom: 100px
}

.section-72.location {
    padding: 0
}

.section-72.about-eve {
    padding-top: 250px
}

.section-72.webinar {
    padding-top: 44px;
    padding-bottom: 44px
}

.section-72.webinar-about {
    padding-top: 60px;
    padding-bottom: 60px
}

.section-72.about-partners {
    padding-top: 10px;
    padding-bottom: 40px
}

.section-72.optimize {
    height: 100%;
    padding-top: 128px;
    padding-bottom: 200px;
    font-size: 16px;
    font-weight: 400
}

.section-72.optimizef2 {
    padding-top: 0;
    padding-left: 0
}

.section-72.about {
    padding-top: 0
}

.section-72.ads {
    padding-top: 90px;
    padding-bottom: 100px
}

.div-block-822 {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    flex-flow: row;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    display: grid
}

.div-block-822.ebook {
    background-color: var(--white);
    display: flex
}

.div-block-823 {
    background-color: var(--white);
    object-fit: cover;
    border-radius: 0;
    flex-flow: column;
    display: flex
}

.image-249 {
    object-fit: cover;
    background-color: #fff;
    border-radius: 0 35px 35px 0;
    flex: 0 1 auto;
    align-self: auto;
    height: 100%;
    max-height: 100%;
    display: block
}

.div-block-824 {
    background-color: var(--soft-pink);
    color: var(--black-2);
    border-top-left-radius: 35px;
    border-bottom-left-radius: 35px;
    flex-flow: column;
    justify-content: center;
    align-items: flex-start;
    height: 100%;
    padding: 60px 41px 49px 81px;
    display: flex
}

.div-block-824.ebook {
    display: flex
}

.div-block-824.what {
    background-color: var(--white)
}

.text-block-356 {
    font-family: P22 Mackinacpro, sans-serif;
    font-weight: 500
}

.text-block-357 {
    margin-top: 0;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 50px;
    font-weight: 700;
    line-height: 1
}

.text-block-357.events {
    font-size: 42px
}

.text-span-302 {
    color: var(--pabloo-green)
}

.div-block-825 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 20px;
    display: grid
}

.div-block-826 {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex
}

.image-250 {
    width: 40px;
    padding-right: 11px
}

.text-block-358 {
    text-align: left;
    margin-top: 33px;
    margin-bottom: 81px;
    line-height: 1.5
}

.div-block-827 {
    z-index: 2;
    background-color: var(--transparent);
    justify-content: center;
    align-items: center;
    margin-top: -82px;
    padding: 0 44px 44px;
    display: flex;
    position: static
}

.div-block-827.webniars {
    margin-top: -170px
}

.div-block-828 {
    background-color: var(--white);
    border-radius: 14px;
    flex: 0 1 auto;
    align-self: auto;
    width: 80%;
    padding: 44px;
    box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .2)
}

.text-block-359 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 52px;
    font-weight: 700;
    line-height: 1
}

.text-block-359.events {
    font-size: 42px
}

.div-block-829 {
    grid-column-gap: 19px;
    grid-row-gap: 19px;
    background-color: #f8f8f8;
    border-radius: 20px;
    width: 100%;
    padding: 50px;
    display: flex
}

.div-block-829.why {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/660fa460db21ea9df7c42d15_Group%202085664163.svg);
    background-position: 0 0;
    background-repeat: repeat;
    background-size: cover;
    background-attachment: scroll;
    margin-top: 88px
}

.div-block-830 {
    width: 40%
}

.div-block-830.why {
    align-self: flex-start
}

.text-block-360 {
    font-family: Inter, sans-serif;
    font-size: 38px;
    font-weight: 700;
    line-height: 1.2
}

.text-block-360.why {
    color: var(--black-2);
    width: 90%
}

.text-span-303 {
    color: var(--pabloo-green-2)
}

.image-251 {
    align-self: flex-start;
    width: 40px;
    height: 40px
}

.div-block-831 {
    grid-column-gap: 17px;
    grid-row-gap: 17px;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 11px;
    display: flex
}

.div-block-832 {
    flex: 1 1
}

.section-73 {
    max-width: 1300px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 44px;
    padding-right: 44px
}

.text-block-361 {
    text-align: center;
    font-family: Inter, sans-serif;
    font-size: 38px;
    font-weight: 700;
    line-height: 1.2
}

.div-block-833 {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 0;
    display: flex
}

.div-block-834 {
    background-color: #fef0f6;
    border-radius: 25px;
    padding: 22px 27px
}

.div-block-834._1 {
    align-self: stretch
}

.div-block-834._2 {
    background-color: #fff4d4;
    background-image: none;
    align-self: stretch
}

.div-block-834._3 {
    background-color: #f0fef6;
    flex: 0 1 auto;
    align-self: stretch;
    margin-top: 0
}

.text-block-362 {
    text-align: center
}

.text-span-304 {
    color: var(--pabloo-green-2)
}

.text-span-305 {
    color: var(--pabloo-green)
}

.div-block-835 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/660fabd5aed4381a048727b1_Group%202085664155.svg);
    background-position: 0 0;
    background-size: cover;
    border-radius: 20px;
    padding: 70px;
    display: flex
}

.text-block-363 {
    color: var(--black-2);
    font-size: 42px;
    font-weight: 700
}

.div-block-836 {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    flex-flow: column;
    width: 65%;
    display: flex
}

.text-block-364 {
    border-left: 4px solid var(--pabloo-green);
    padding-left: 15px;
    font-weight: 700
}

.text-block-365 {
    width: 90%;
    line-height: 1.5
}

.div-block-837 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 27px;
    display: grid
}

.text-span-307 {
    color: var(--pabloo-green)
}

.text-block-366 {
    align-self: center
}

.div-block-840 {
    flex-flow: row;
    flex: 0 1 auto;
    justify-content: flex-start;
    align-self: auto;
    align-items: flex-start;
    display: block
}

.div-block-840.events {
    padding-top: 12px;
    padding-bottom: 12px
}

.text-block-370 {
    font-family: "P22mackinacpro 16", sans-serif
}

.text-block-371 {
    padding-top: 7px
}

.div-block-841 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    flex-flow: column;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    padding-top: 30px;
    padding-bottom: 30px;
    display: flex
}

.div-block-842 {
    display: flex
}

.text-block-372 {
    align-self: center;
    padding-left: 10px
}

.div-block-843 {
    margin-top: 0;
    margin-bottom: 82px
}

.partners {
    border-right: 0px solid var(--light-slate-grey);
    padding-left: 9px;
    padding-right: 9px
}

.partners.partner-logos {
    object-fit: fill;
    border: 0 solid #000;
    margin-bottom: 3px;
    margin-left: 0;
    margin-right: 0;
    padding-left: 6px;
    padding-right: 6px
}

.partners.partner-logos.pabloo {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    border-left-width: 0;
    flex-flow: row;
    flex: 1 1;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 10px;
    margin-left: 0;
    display: grid
}

.partners._3 {
    border-right-style: none;
    border-right-width: 0
}

.div-block-845 {
    grid-column-gap: 9px;
    grid-row-gap: 9px;
    flex-flow: wrap;
    flex: 1 1;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 5px;
    display: flex
}

.image-253 {
    object-fit: contain;
    align-self: center;
    height: 25px
}

.image-253.pabloo {
    object-fit: fill;
    position: absolute;
    left: 10%
}

.image-254,
.image-255 {
    object-fit: contain;
    height: 25px
}

.image-256,
.image-257 {
    height: 25px
}

.image-258 {
    height: auto
}

.slick-slider {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    flex-flow: row;
    justify-content: space-around;
    align-items: stretch;
    display: flex
}

.slick-slider.cms-slider {
    margin-top: 46px;
    display: none
}

.testimonialx {
    object-fit: fill;
    background-color: #f0f0f0;
    border-radius: 14px;
    flex: none;
    align-self: auto;
    width: 49%;
    margin-right: 20px;
    padding: 40px 30px 40px 50px;
    position: static
}

.text-block-374 {
    margin-top: 20px;
    margin-bottom: 20px
}

.testimonial-new-logo {
    object-fit: fill;
    height: 50px
}

.div-block-848 {
    object-fit: none;
    height: 50px
}

.text-block-375 {
    color: var(--pabloo-green-2);
    flex: 0 1 auto;
    order: 0;
    justify-content: center;
    align-self: stretch;
    align-items: flex-end;
    margin-bottom: 0;
    font-weight: 700;
    display: block;
    position: static
}

.div-block-849 {
    grid-column-gap: 13px;
    grid-row-gap: 13px;
    justify-content: flex-end;
    margin-bottom: 15px;
    display: none
}

.testimonial-left-slider {
    display: inline-block
}

.slide-nav-8 {
    display: none
}

.slider-20 {
    background-color: var(--white);
    display: block
}

.mask-9 {
    padding-left: 3px;
    padding-right: 3px;
    overflow: hidden
}

.text-block-376 {
    margin-bottom: 65px;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 36px
}

.text-block-377 {
    color: var(--black);
    text-align: center;
    margin-bottom: 0;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 42px
}

.text-block-377.new {
    color: var(--white);
    font-size: 42px
}

.text-block-377.pink {
    color: var(--pabloo-green)
}

.text-span-308 {
    color: var(--pabloo-green-2)
}

.text-block-378 {
    text-align: center;
    align-self: center;
    width: 70%;
    font-size: 16px
}

.div-block-850 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    background-color: #f7e0cb;
    border-radius: 30px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 98px;
    padding: 0;
    display: flex
}

.div-block-850.partner {
    grid-column-gap: 31px;
    grid-row-gap: 31px;
    justify-content: flex-start;
    align-items: center;
    margin-top: 68px;
    padding: 68px
}

.events-expectations-section {
    background-image: radial-gradient(circle at 100% 100%, #e3c0c1, #fdf0f1);
    border-radius: 20px;
    flex-flow: row;
    width: 100%;
    padding: 3px;
    display: flex
}

.event-exectations-tab {
    flex-flow: column;
    align-self: center;
    width: 50%;
    margin-top: 71px;
    padding: 32px 28px 32px 40px;
    display: flex
}

.event-expectation {
    object-fit: cover;
    border-radius: 20px;
    width: 100%;
    height: auto
}

.event-expectations-content {
    flex: 1 1;
    order: 0;
    justify-content: flex-end;
    align-self: auto;
    align-items: center;
    padding: 28px;
    display: flex
}

.agenda-tab {
    background-color: var(--transparent);
    margin-top: 10px;
    margin-bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    display: flex
}

.agenda-tab.w--current {
    background-color: #eed6d6;
    background-image: linear-gradient(154deg, #e3c0c1, #fdf0f1);
    border-radius: 12px;
    flex: 0 1 auto;
    margin-bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    display: flex
}

.agenda-header {
    align-self: center;
    font-weight: 700
}

.image-259 {
    object-fit: contain;
    align-self: flex-start;
    width: 50px;
    margin-right: 20px
}

.tab-pane-tab-1-2 {
    flex: 1 1
}

.agenda-description {
    width: 70%;
    margin-top: 5px;
    font-size: 14px;
    line-height: 1.4;
    display: none
}

.agenda {
    align-self: center
}

.text-block-379 {
    z-index: 1;
    align-self: flex-start;
    margin-top: 58px;
    margin-bottom: 0;
    padding-left: 51px;
    font-size: 26px;
    font-weight: 700;
    line-height: 1.2;
    display: flex;
    position: absolute;
    left: auto
}

.tab-pane-tab-2-2,
.tab-pane-tab-3-2 {
    flex: 1 1
}

.text-block-380 {
    color: var(--white);
    text-align: center;
    font-size: 40px;
    font-weight: 700
}

.div-block-851 {
    background-color: var(--dark-violet);
    flex: 1 1;
    padding-top: 105px;
    padding-bottom: 105px
}

.paragraph-155 {
    color: var(--pabloo-green-2);
    text-align: center;
    font-weight: 700
}

.definitions {
    color: var(--pabloo-green-2);
    text-align: center
}

.paragraph-156,
.paragraph-157 {
    color: var(--pabloo-green);
    text-align: center
}

.paragraph-158,
.paragraph-159,
.paragraph-160,
.paragraph-161,
.paragraph-162,
.paragraph-163 {
    color: var(--pabloo-green);
    text-align: center;
    font-weight: 700
}

.paragraph-164 {
    color: var(--pabloo-green);
    text-align: center
}

.paragraph-165,
.paragraph-166,
.paragraph-167,
.paragraph-168 {
    color: var(--pabloo-green);
    text-align: center;
    font-weight: 700
}

.rich-text-block-30 {
    text-align: justify;
    flex: 0 1 auto;
    margin-top: 44px
}

.image-260 {
    flex: 1 1
}

.div-put {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    display: flex
}

.inner-testimonial {
    object-fit: cover;
    flex-flow: column;
    flex: 1 1;
    justify-content: flex-start;
    align-self: stretch;
    align-items: flex-start;
    width: 100%;
    max-width: 100%;
    height: 100%;
    display: flex
}

.slider-container {
    margin-top: 43px;
    overflow: visible
}

.slider-track {
    display: flex
}

.sysf-button-text {
    font-weight: 500;
    display: inline-block
}

.material-icons-2.sysf-icon-left {
    margin-top: 2px;
    margin-right: 4px
}

.sysf-text-icon-wrapper {
    align-items: center;
    display: flex
}

.sysf-link-with-icon {
    text-decoration: none;
    display: inline-block
}

.sysf-link-with-icon:hover {
    color: var(--systemflow-lite--primary--70)
}

.sysf-link-with-icon:active {
    color: var(--systemflow-lite--primary--80)
}

.sysf-link-with-icon:focus {
    box-shadow: 0 0 0 2px var(--systemflow-lite--neutral--10), 0 0 0 5px var(--systemflow-lite--primary--60);
    color: var(--systemflow-lite--primary--70)
}

.slider-button-right {
    margin-left: 18px
}

.div-block-852 {
    object-fit: cover;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6620cd07ce745a152a79ecad_Group%202085664001.png);
    background-position: 0 0;
    background-size: auto;
    flex-flow: column;
    display: block
}

.div-block-853 {
    grid-column-gap: 26px;
    grid-row-gap: 26px;
    object-fit: fill;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6620edcbff94c4d9a8cb405b_Group%202085664001.png);
    background-position: 0 0;
    background-size: auto;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    height: 600px;
    padding: 82px;
    display: flex
}

.text-block-381 {
    border: 2px solid var(--pabloo-green);
    color: var(--white);
    text-align: center;
    border-radius: 20px;
    justify-content: center;
    align-items: center;
    width: 150px;
    padding: 6px 30px;
    line-height: 1.2;
    display: flex
}

.div-block-854 {
    grid-column-gap: 14px;
    grid-row-gap: 14px;
    flex: 0 1 auto;
    justify-content: flex-start;
    align-self: center;
    align-items: flex-start;
    line-height: 1;
    display: flex
}

.text-span-309 {
    color: var(--pabloo-green)
}

.button-50 {
    background-color: var(--white);
    color: var(--black);
    border-radius: 9px;
    align-self: center;
    padding: 15px 53px;
    font-weight: 600;
    line-height: 1.2
}

.button-50.pink {
    background-color: var(--pabloo-green);
    color: var(--white);
    align-self: center;
    padding-top: 15px;
    padding-bottom: 15px
}

.button-50.partner {
    color: var(--white);
    background-color: #f45900
}

.div-block-855 {
    grid-column-gap: 25px;
    grid-row-gap: 25px;
    margin-top: 15px;
    display: flex
}

.privacy-link {
    color: var(--pabloo-green);
    text-decoration: none
}

.div-block-856 {
    grid-column-gap: 25px;
    grid-row-gap: 25px;
    flex-flow: column;
    display: flex
}

.div-block-857 {
    background-color: var(--white);
    border-radius: 40px;
    width: 80%;
    height: 600px;
    margin-top: 40px;
    margin-bottom: -230px
}

.html-embed-43 {
    border-radius: 40px;
    display: block
}

.sysf-button-text-2 {
    font-weight: 500;
    display: inline-block
}

.sysf-button {
    background-color: var(--systemflow-lite--primary--60);
    color: var(--systemflow-lite--neutral--10);
    text-align: center;
    align-items: center;
    text-decoration: none;
    transition: background-color .25s;
    position: relative
}

.sysf-button:hover {
    background-color: var(--systemflow-lite--primary--50)
}

.sysf-button:active {
    background-color: var(--systemflow-lite--primary--70)
}

.sysf-button:focus {
    box-shadow: 0 0 0 2px var(--systemflow-lite--neutral--10), 0 0 0 5px var(--systemflow-lite--primary--60)
}

.sysf-button.sysf-medium {
    border-radius: 6px;
    padding: 8px 12px
}

.sysf-button.sysf-medium:hover {
    background-color: var(--systemflow-lite--primary--70)
}

.sysf-button.sysf-medium:active {
    background-color: var(--systemflow-lite--primary--80)
}

.sysf-button.sysf-medium:focus {
    background-color: var(--systemflow-lite--primary--70)
}

.about-pabloo-events {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    margin-top: 92px;
    display: flex
}

.about-pabloo-events.webinar {
    grid-column-gap: 33px;
    grid-row-gap: 33px;
    margin-top: 60px
}

.text-block-382 {
    color: var(--pabloo-green);
    font-weight: 700
}

.div-block-858 {
    grid-column-gap: 10px;
    grid-row-gap: 10px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: flex-start;
    display: grid
}

.logx-spend {
    height: 50px
}

.div-block-859 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    background-color: rgba(247, 224, 203, 0);
    border: 1px solid rgba(247, 170, 46, 0);
    border-radius: 20px;
    justify-content: center;
    align-items: flex-start;
    padding: 0;
    display: flex
}

.text-block-383 {
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 30px;
    font-weight: 700
}

.text-block-384 {
    color: #f45900;
    font-family: P22 Mackinacpro, sans-serif;
    font-size: 30px;
    font-weight: 700
}

.text-block-385 {
    text-align: center;
    flex-flow: row;
    width: 80%;
    display: block
}

.collection-list-wrapper-8 {
    flex-flow: wrap;
    flex: 1 1;
    margin-top: 10px;
    display: flex
}

.div-block-860 {
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 10px;
    display: flex
}

.your-grid-container {
    clear: none;
    grid-column-gap: 4px;
    grid-row-gap: 4px;
    border-right: 0 solid #000;
    border-radius: 0;
    flex-flow: row;
    flex: 1 1;
    order: 0;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    align-items: center;
    justify-items: start;
    display: flex;
    position: relative
}

.bold-text-33 {
    color: var(--pabloo-green-2)
}

.features-wrapper-new {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    display: grid
}

.features-wrapper-new.yellow {
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    margin-top: 75px;
    padding-left: 0
}

.feature-block-item {
    display: block
}

.feature-block-item.yellow1 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628ac5bc34fcf44ab7feff5_yellow-bg.svg);
    background-position: 0%;
    background-repeat: repeat-y;
    background-size: contain;
    background-attachment: scroll;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    padding: 10%;
    display: flex
}

.feature-block-item.yellow1.green1 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628cde57b512b59aa792c52_green-bg.svg);
    background-position: 100%
}

.feature-block-item.yellow1.green1.yellow-right {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628ac5bc34fcf44ab7feff5_yellow-bg.svg)
}

.feature-block-item.yellow1.pink1 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628d4132a2e79bd87db2a0f_Rectangle%2034624776.svg)
}

.feature-block-item.yellow1.pink1.greenleft {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628cde57b512b59aa792c52_green-bg.svg)
}

.feature-block-item.yellow2 {
    grid-column-gap: 25px;
    grid-row-gap: 25px;
    flex-flow: column;
    justify-content: center;
    align-items: flex-start;
    padding: 10% 10% 10% 5%;
    display: flex
}

.feature-block-image {
    object-fit: fill;
    display: inline-block
}

.feature-block-image._2-0 {
    box-shadow: none
}

.feature-block-content-logo {
    height: 60px
}

.feature-text-header {
    text-align: left;
    align-self: stretch;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.3
}

.text-span-310 {
    color: var(--pabloo-green)
}

.text-block-386 {
    line-height: 1.4
}

.text-span-311,
.text-span-312,
.text-span-313,
.text-span-314,
.text-span-315,
.text-span-316,
.text-span-317 {
    color: var(--pabloo-green)
}

.image-261 {
    height: 150px;
    position: absolute;
    top: 2894.8px;
    left: auto;
    right: 29%;
    box-shadow: 0 0 20px -9px rgba(0, 0, 0, .2)
}

.text-span-318,
.text-span-319,
.text-span-320,
.text-span-321,
.text-span-322,
.text-span-323,
.text-span-324,
.text-span-325,
.text-span-326,
.text-span-327,
.text-span-328,
.text-span-329,
.text-span-330,
.text-span-331,
.text-span-332,
.text-span-333 {
    color: var(--pabloo-green)
}

.link-43 {
    color: var(--pabloo-green);
    text-decoration: none
}

.paragraph-169 {
    color: var(--pabloo-green);
    text-align: center;
    font-weight: 700
}

.text-span-334,
.text-span-335 {
    color: var(--pabloo-green)
}

.text-span-336 {
    color: var(--pabloo-green-2)
}

.text-span-337 {
    color: var(--pabloo-green)
}

.text-span-338 {
    color: var(--pabloo-green-2)
}

.text-span-345,
.text-span-346 {
    color: var(--pabloo-green)
}

.text-span-347 {
    color: var(--pabloo-green-2)
}

.text-span-348,
.text-span-349,
.text-span-350,
.text-span-351,
.text-span-352,
.text-span-353,
.text-span-354,
.text-span-355 {
    color: var(--pabloo-green)
}

.html-embed-44 {
    display: block
}

.div-block-861 {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
    height: 100%;
    display: flex
}

.div-block-862 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    text-align: left;
    object-fit: cover;
    background-image: linear-gradient(135deg, #fbeded, #FEC45B);
    border-radius: 20px;
    flex-flow: row;
    flex: 0 1 auto;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-self: stretch;
    align-items: center;
    width: 30%;
    max-height: 500px;
    margin-bottom: 0;
    padding-top: 2%;
    padding-left: 0;
    padding-right: 0;
    display: flex;
    overflow: visible
}

.div-block-863 {
    grid-column-gap: 31px;
    grid-row-gap: 31px;
    background-image: linear-gradient(#f7e7c6, #fff4dc);
    border-radius: 20px;
    flex-flow: column;
    width: 70%;
    padding: 48px;
    display: flex
}

.tabs-3 {
    width: 90%;
    max-width: 1300px;
    display: block
}

.tabs-menu-6 {
    grid-column-gap: 11px;
    grid-row-gap: 11px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: stretch;
    margin-top: 50px;
    display: grid
}

.text-block-387 {
    font-size: 25px;
    font-weight: 400
}

.text-span-356 {
    font-weight: 700
}

.text-span-357 {
    color: var(--pabloo-green);
    font-weight: 700
}

.image-262 {
    object-fit: fill;
    flex: 0 1 auto;
    align-self: flex-end;
    width: 260px;
    margin-bottom: 0;
    display: block
}

.image-262._2-0 {
    align-self: center
}

.testimonial_tab_1 {
    border-bottom: 5px solid var(--white-smoke);
    background-color: #fff
}

.testimonial_tab_1.w--current {
    border-bottom: 5px solid var(--pabloo-green);
    background-color: rgba(200, 200, 200, 0)
}

.div-block-864 {
    justify-content: center;
    align-items: flex-start;
    height: 40px;
    display: flex
}

.text-block-388 {
    text-align: justify;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4
}

.text-span-358,
.text-span-359 {
    color: var(--pabloo-green);
    font-weight: 800
}

.dropdown-2 {
    width: 100%
}

.logos-quote-block {
    border-bottom: 1px solid #e4ebf3;
    padding: 60px 30px;
    position: relative
}

.container-1292 {
    width: 100%;
    max-width: 940px;
    margin-left: auto;
    margin-right: auto
}

.clients-wrapper-two {
    justify-content: space-between;
    align-items: center;
    max-width: 820px;
    margin-left: auto;
    margin-right: auto;
    display: flex
}

.clients-card {
    background-color: #f5f7fa;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;
    padding: 24px;
    display: flex
}

.clients-quote {
    margin-bottom: 24px;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px
}

.clients-info {
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    display: flex
}

.clients-info-image {
    object-fit: cover;
    width: 50px;
    height: 50px;
    margin-right: 24px
}

.clients-grid {
    grid-column-gap: 50px;
    grid-row-gap: 50px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    justify-items: center;
    display: grid
}

.image-263 {
    object-fit: contain;
    height: 50px
}

.text-span-360,
.text-span-361,
.text-span-362,
.text-span-363,
.text-span-364 {
    color: var(--pabloo-green);
    font-weight: 800
}

.slider-21,
.slider-22 {
    display: none
}

.text-span-365 {
    font-weight: 800
}

.bold-text-34 {
    font-weight: 500
}

.bold-text-35 {
    font-weight: 900
}

.text-span-366,
.text-span-367,
.text-span-368,
.text-span-369 {
    color: var(--pabloo-green)
}

.div-block-865 {
    display: flex
}

.tabs-4 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4f2ab2fe33ac69859f70_Group%202087326245news.png);
    background-position: 0 0;
    background-size: 100% 580px;
    width: 100%;
    height: 580px;
    display: flex
}

.tabs-menu-7 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4bbc17ed885772b7ec8f_Bgx.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 20px;
    flex: 0 1 auto;
    width: 40%;
    padding: 13px;
    display: flex
}

.tabs-content-5 {
    width: 60%
}

.tab-link-tab-1-3 {
    background-color: var(--transparent);
    height: 100px;
    padding-right: 10px;
    display: flex
}

.tab-link-tab-1-3.w--current {
    background-color: var(--transparent);
    color: var(--black);
    flex: 0 1 auto;
    height: 100px;
    padding-right: 10px;
    font-weight: 700;
    display: flex
}

.tab-link-tab-2-3 {
    background-color: var(--transparent);
    color: var(--light-slate-grey);
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding-left: 10px;
    padding-right: 10px;
    display: flex
}

.tab-link-tab-2-3.w--current {
    background-color: var(--transparent);
    font-weight: 700
}

.tab-link-tab-3-2 {
    background-color: var(--transparent);
    color: var(--black);
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: 100px;
    padding-left: 10px;
    display: flex
}

.tab-link-tab-3-2.w--current {
    background-color: var(--transparent);
    justify-content: center;
    align-items: flex-end;
    font-weight: 700
}

.div-block-867 {
    color: var(--black);
    flex: 0 1 auto;
    justify-content: center;
    align-items: center;
    width: 100%;
    display: flex
}

.text-block-389 {
    color: var(--black);
    padding-right: 10px;
    font-size: 22px
}

.div-block-868 {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    height: 580px;
    padding: 44px;
    display: flex
}

.image-264 {
    display: inline-block
}

.div-block-869 {
    height: 100px
}

.div-block-869.new {
    height: 50px
}

.body-6 {
    font-family: P22, sans-serif
}

.collection-list-wrapper-9 {
    margin-bottom: 30px
}

.text-block-390 {
    font-size: 30px
}

.text-block-391 {
    text-align: center;
    margin-top: 30px;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 90px;
    line-height: 1
}

.text-span-370 {
    color: var(--pabloo-green)
}

.image-265,
.image-266 {
    height: 32px
}

.popup-modal-new {
    z-index: 29;
    background-color: rgba(0, 0, 0, .33);
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    display: none;
    position: fixed;
    top: 0;
    overflow: hidden;
    transform: translate(0)
}

.code-embed {
    margin-top: 21px
}

.div-block-870 {
    object-fit: contain;
    width: 45%
}

.text-block-392 {
    text-align: center
}

.bold-text-36 {
    white-space: normal;
    font-size: 30px;
    line-height: 1
}

.div-block-871 {
    background-color: #fdeddf;
    background-image: linear-gradient(100deg, #fdeddf, #e8c5a7);
    border-radius: 28px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 97px;
    padding: 50px 30px 39px;
    display: flex
}

.text-block-393 {
    text-align: center;
    text-transform: uppercase;
    font-weight: 700
}

.text-span-371 {
    color: var(--pabloo-green)
}

.div-block-872 {
    grid-column-gap: 6px;
    grid-row-gap: 6px;
    border: 2px solid #ffacd6;
    border-radius: 20px;
    justify-content: center;
    align-items: flex-start;
    width: 35%;
    padding: 4px;
    display: flex
}

.div-block-872.new {
    width: 60%
}

.div-block-873 {
    height: 100%;
    display: flex
}

.div-block-874 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    justify-content: center;
    align-items: flex-start;
    margin-top: 30px;
    display: flex
}

.text-block-394 {
    color: var(--pabloo-green-2);
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 40px;
    font-weight: 500;
    line-height: 1.2
}

.text-block-395 {
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 40px
}

.div-block-875 {
    justify-content: center;
    align-items: flex-start;
    font-family: Satoshi, sans-serif;
    font-size: 22px;
    font-weight: 500;
    display: flex
}

.div-block-876 {
    margin-top: 30px
}

.text-block-396 {
    padding-right: 10px;
    font-weight: 700
}

.div-block-877 {
    grid-column-gap: 8px;
    grid-row-gap: 8px;
    flex: 0 1 auto;
    display: flex
}

.div-block-878 {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    justify-content: center;
    align-items: center;
    margin-top: 0;
    display: flex
}

.image-267 {
    flex: 0 1 auto;
    align-self: flex-start
}

.text-block-397 {
    align-self: flex-start;
    font-weight: 500
}

.div-block-879 {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    flex-flow: column;
    display: flex
}

.div-block-880 {
    grid-column-gap: 15px;
    grid-row-gap: 15px;
    flex-flow: wrap;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: flex-start;
    margin-top: 30px;
    margin-bottom: 110px;
    display: flex
}

.div-block-881 {
    justify-content: center;
    align-items: flex-start;
    display: flex
}

.div-block-881.new {
    width: 60%
}

.text-span-372 {
    color: var(--pabloo-green)
}

.text-block-398 {
    text-align: center;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    margin-top: 0;
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 38px;
    font-weight: 700;
    line-height: 1.2;
    display: block
}

.text-block-398.pink {
    color: var(--pabloo-green)
}

.div-block-882 {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    display: flex
}

.text-span-373 {
    color: var(--pabloo-green-2)
}

.div-block-883 {
    grid-column-gap: 26px;
    grid-row-gap: 26px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    height: auto;
    margin-top: 20px;
    display: grid
}

.text-block-399 {
    flex: 0 1 auto;
    font-size: 24px;
    font-weight: 700;
    line-height: 1.2
}

.div-block-884 {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    border: 3px solid #e9e7e7;
    border-radius: 20px;
    flex-flow: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 39px;
    display: flex
}

.div-block-884:hover {
    border-width: 0;
    box-shadow: 1px 4px 9px rgba(0, 0, 0, .2)
}

.div-block-885 {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex
}

.text-block-400 {
    text-align: left;
    flex: 1 1
}

.text-block-401,
.text-block-402 {
    flex: 1 1
}

.button-51 {
    padding-left: 60px
}

.button-52 {
    background-color: var(--pabloo-green);
    border-radius: 10px;
    padding-left: 60px;
    padding-right: 60px;
    font-weight: 600
}

.text-span-374 {
    color: var(--black)
}

.text-block-403 {
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 40px;
    line-height: 1.2
}

.image-268 {
    vertical-align: baseline;
    height: 25px
}

.optimize-body {
    -webkit-text-stroke-color: var(--white);
    background-color: #0f1010
}

.div-block-887 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    margin-top: 69px;
    padding-top: 2px;
    display: grid
}

.image-269 {
    height: 30px
}

.text-block-404,
.text-block-405 {
    font-size: 60px;
    line-height: 1.2
}

.text-block-406 {
    color: var(--white);
    font-size: 60px;
    line-height: 1.2
}

.text-block-407 {
    color: var(--white);
    font-family: Poppins, sans-serif;
    font-size: 60px;
    font-weight: 400;
    line-height: 1.2
}

.div-block-888 {
    width: 90%
}

.div-block-888.fold-2 {
    padding-left: 47px
}

.text-span-375 {
    color: #fff
}

.div-block-889 {
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    flex-flow: column;
    justify-content: center;
    align-items: flex-start;
    padding-left: 72px;
    display: flex
}

.text-block-408 {
    color: #ccc;
    text-transform: uppercase;
    font-size: 18px
}

.div-block-890 {
    background-color: rgba(47, 46, 46, .46);
    border: 1px solid rgba(204, 204, 204, .2);
    border-radius: 40px;
    padding: 14px 30px
}

.image-270 {
    height: 70px
}

.image-270.fold-2 {
    height: 60px
}

.div-block-891 {
    background-color: rgba(255, 255, 255, .04);
    border: 2px solid rgba(86, 86, 86, .34);
    border-radius: 20px;
    justify-content: center;
    align-items: flex-start;
    width: 80%;
    padding: 55px;
    font-weight: 400;
    line-height: 1.2;
    display: block
}

.div-block-892 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664c80bcba5c5a09b4793611_Group%2024%20c.svg);
    background-position: 50%;
    background-repeat: repeat;
    background-size: cover;
    background-attachment: scroll
}

.div-block-892.fold-2 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664b1bf1d46e76a7588efa35_Shotfinal2.svg);
    margin-left: auto;
    margin-right: auto
}

.div-block-892.fold3 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664c331fcce04b8fbf79e758_Frame%2049fold3.svg);
    background-position: 100% 100%;
    background-repeat: no-repeat;
    background-size: auto;
    padding-bottom: 110px
}

.div-block-892.fold3.fold4 {
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664c26a5770e98317577f1a1_Shotfold3.svg);
    background-size: cover;
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px
}

.code-embed-2 {
    color: rgba(255, 255, 255, .8);
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400
}

.div-block-893 {
    justify-content: flex-start;
    align-items: flex-start;
    display: flex
}

.link-block-38 {
    border: 2px solid rgba(99, 99, 99, .59);
    border-radius: 8px;
    padding: 9px 24px
}

.div-block-894 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: .75fr 1fr;
    grid-auto-columns: 1fr;
    justify-content: flex-start;
    align-items: flex-start;
    display: grid
}

.div-block-895 {
    background-color: transparent;
    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664a357bf8ff2dd87fcae846_Group%2011.svg);
    background-position: 0 0;
    background-size: cover;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    padding-top: 40px;
    padding-bottom: 40px;
    padding-right: 40px;
    display: flex
}

.image-271 {
    width: 80%;
    margin-bottom: 0
}

.text-block-410 {
    color: #ccc;
    margin-top: 40px;
    margin-bottom: 40px
}

.button-53 {
    background-color: var(--pabloo-green);
    border-radius: 11px;
    padding-left: 49px;
    padding-right: 49px;
    font-size: 16px
}

.div-block-896 {
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    display: flex
}

.text-block-411 {
    font-family: Poppins, sans-serif;
    font-size: 60px
}

.text-block-412 {
    flex: 1 1;
    width: 50%;
    padding-left: 24px;
    font-family: Poppins, sans-serif;
    font-size: 60px;
    line-height: 1.2
}

.div-block-897 {
    margin-top: -202px;
    display: flex
}

.image-272 {
    z-index: 1;
    box-sizing: border-box;
    flex: 0 1 auto;
    order: 0;
    width: 200px;
    position: sticky;
    top: 220px;
    overflow: visible
}

.div-block-898 {
    grid-column-gap: 73px;
    grid-row-gap: 73px;
    flex-flow: column;
    grid-template-rows: auto;
    grid-template-columns: minmax(200px, .25fr) 1fr;
    grid-auto-columns: 1fr;
    justify-content: center;
    align-items: flex-start;
    display: flex
}

.text-block-413 {
    font-size: 22px;
    font-weight: 700
}

.text-block-414 {
    box-sizing: content-box;
    color: #ccc
}

.div-block-899 {
    grid-column-gap: 19px;
    grid-row-gap: 19px;
    flex-flow: column;
    flex: 0 1 auto;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 10px;
    margin-bottom: 0;
    padding-bottom: 34px;
    display: flex
}

.div-block-899.onex {
    grid-column-gap: 13px;
    grid-row-gap: 13px
}

.div-block-899.two {
    margin-top: 21px;
    padding-top: 0
}

.div-block-899.three {
    margin-top: 24px
}

.div-block-899.four {
    margin-top: 10px
}

.div-block-900 {
    grid-column-gap: 37px;
    grid-row-gap: 37px;
    margin-top: 86px;
    display: flex
}

.image-273 {
    width: 60px
}

.image-274 {
    align-self: flex-start
}

.div-block-901 {
    justify-content: flex-end;
    align-items: flex-start;
    display: flex;
    position: sticky;
    top: 160px;
    overflow: visible
}

.div-block-902 {
    grid-column-gap: 60px;
    grid-row-gap: 60px;
    flex-flow: column;
    width: 65%;
    margin-top: 65px;
    padding-left: 0;
    padding-right: 37px;
    display: flex
}

.text-block-415 {
    font-family: Poppins, sans-serif;
    font-size: 60px
}

.text-block-416 {
    width: 60%
}

.div-block-903 {
    grid-column-gap: 61px;
    grid-row-gap: 61px;
    flex-flow: column;
    padding-left: 52px;
    padding-right: 52px;
    display: flex
}

.text-block-417 {
    color: #ccc;
    text-align: justify
}

.text-block-418 {
    font-size: 22px
}

.div-block-904 {
    background-color: rgba(255, 255, 255, .49);
    width: 100%;
    height: 1px;
    margin-bottom: 20px
}

.div-block-905 {
    grid-column-gap: 29px;
    grid-row-gap: 29px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    display: flex
}

.navbar-logo-left.optimize {
    z-index: 10;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    display: flex;
    position: fixed
}

.navbar-logo-left-container {
    z-index: 5;
    background-color: transparent;
    width: 1030px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    padding: 15px 20px
}

.navbar-logo-left-container.shadow-three {
    width: 100%;
    max-width: 1140px;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding-top: 20px;
    padding-bottom: 20px
}

.container-1293 {
    width: 100%;
    margin-left: auto;
    margin-right: auto
}

.navbar-wrapper {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    display: flex
}

.navbar-brand {
    flex: 0 1 auto
}

.nav-menu-wrapper {
    flex: 1 1;
    padding-left: 153px
}

.nav-menu-two {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
    margin-left: 0;
    display: flex
}

.nav-link-7 {
    color: #ccc;
    letter-spacing: .25px;
    margin-left: 5px;
    margin-right: 5px;
    padding: 5px 10px;
    font-size: 14px;
    line-height: 20px;
    text-decoration: none
}

.nav-link-7:hover {
    color: var(--white);
    font-weight: 400
}

.nav-link-7:focus-visible {
    outline-offset: 0px;
    color: var(--white);
    border-radius: 4px;
    outline: 2px solid #0050bd
}

.nav-link-7[data-wf-focus-visible] {
    outline-offset: 0px;
    color: var(--white);
    border-radius: 4px;
    outline: 2px solid #0050bd
}

.nav-dropdown-2 {
    margin-left: 5px;
    margin-right: 5px
}

.nav-dropdown-toggle-2 {
    letter-spacing: .25px;
    padding: 5px 30px 5px 10px;
    font-size: 14px;
    line-height: 20px
}

.nav-dropdown-toggle-2:hover {
    color: rgba(26, 27, 31, .75)
}

.nav-dropdown-toggle-2:focus-visible {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-dropdown-toggle-2[data-wf-focus-visible] {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-dropdown-icon-2 {
    margin-right: 10px
}

.nav-dropdown-list-2 {
    background-color: #fff;
    border-radius: 12px
}

.nav-dropdown-list-2.w--open {
    padding-top: 10px;
    padding-bottom: 10px
}

.nav-dropdown-link-2 {
    padding-top: 5px;
    padding-bottom: 5px;
    font-size: 14px
}

.nav-dropdown-link-2:focus-visible {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-dropdown-link-2[data-wf-focus-visible] {
    outline-offset: 0px;
    color: #0050bd;
    border-radius: 5px;
    outline: 2px solid #0050bd
}

.nav-divider {
    background-color: #e4ebf3;
    width: 1px;
    height: 22px;
    margin-left: 15px;
    margin-right: 15px
}

.nav-link-accent-2 {
    color: #1a1b1f;
    letter-spacing: .25px;
    margin-left: 5px;
    margin-right: 20px;
    padding: 5px 10px;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-decoration: none
}

.nav-link-accent-2:hover {
    color: rgba(26, 27, 31, .75)
}

.mobile-margin-top-11 {
    padding-left: 0
}

.button-primary-2 {
    color: #fff;
    letter-spacing: 2px;
    text-transform: uppercase;
    background-color: #1a1b1f;
    border: 1px solid #ccc;
    border-radius: 12px;
    padding: 12px 61px;
    font-size: 12px;
    line-height: 20px;
    transition: all .2s
}

.button-primary-2:hover {
    color: #fff;
    background-color: #32343a
}

.button-primary-2:active {
    background-color: #43464d
}

.button-primary-2.w--current {
    border-color: rgba(204, 204, 204, .37)
}

.list-item-12 {
    flex: 0 1 auto;
    list-style-type: none
}

.div-block-906 {
    display: none
}

.text-span-376 {
    color: var(--pabloo-green);
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 56px;
    font-style: normal
}

.div-block-907 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto auto;
    grid-template-columns: 1fr 1fr;
    grid-auto-columns: 1fr;
    align-content: start;
    justify-content: start;
    align-items: center;
    display: grid
}

.text-block-419 {
    margin-top: 0;
    font-size: 24px;
    line-height: 1.7
}

.text-block-420 {
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 50px;
    display: none
}

.text-span-377 {
    color: var(--pabloo-green-2)
}

.text-block-421 {
    color: var(--white)
}

.text-block-422 {
    color: var(--white);
    text-align: center;
    width: 75%;
    font-weight: 400
}

.text-span-378 {
    color: var(--pabloo-green);
    font-weight: 700
}

.text-span-379 {
    font-weight: 700
}

.div-block-908 {
    grid-column-gap: 52px;
    grid-row-gap: 52px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    align-items: center;
    justify-items: center;
    padding-left: 0;
    padding-right: 0;
    display: grid
}

.div-block-909 {
    object-fit: contain;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    width: 70%;
    height: 50px;
    display: flex
}

.text-block-423 {
    text-align: center;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 34px
}

.div-block-910 {
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    flex-flow: column;
    max-width: 1300px;
    margin-bottom: 56px;
    margin-left: auto;
    margin-right: auto;
    padding-top: 33px;
    padding-left: 100px;
    padding-right: 100px;
    display: flex
}

.text-span-380 {
    color: var(--pabloo-green-2)
}

.image-278 {
    object-fit: contain;
    flex: 0 1 auto;
    width: 100%;
    height: auto;
    display: block
}

.text-span-381 {
    color: var(--pabloo-green-2)
}

.text-span-382 {
    color: var(--pabloo-green)
}

.text-block-424 {
    color: var(--white);
    text-align: center;
    width: 85%;
    margin-top: 40px
}

.div-block-911 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    display: grid
}

.text-block-425 {
    font-family: "P22mackinacpro 16", sans-serif;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.5
}

.div-block-912 {
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;
    display: flex
}

.text-block-426 {
    color: var(--elements-webflow-library--neutral--600);
    margin-top: 10px;
    margin-bottom: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-weight: 600;
    line-height: 1.2
}

.div-block-913 {
    flex-flow: column;
    padding-top: 0;
    padding-bottom: 13px;
    display: flex
}

.image-279 {
    height: 50px;
    margin-top: auto;
    margin-bottom: auto;
    padding-top: 10px;
    padding-bottom: 10px
}

.div-block-914 {
    grid-column-gap: 16px;
    grid-row-gap: 16px;
    grid-template-rows: auto;
    grid-template-columns: 1fr .5fr .5fr;
    grid-auto-columns: 1fr;
    display: grid
}

.div-block-914.x1 {
    background-color: var(--white-smoke);
    border-radius: 10px
}

.div-block-914.main {
    padding-top: 35px;
    padding-bottom: 35px
}

.div-block-915 {
    border: 3px solid var(--pabloo-green);
    border-radius: 20px;
    width: 350px;
    height: 730px;
    margin-top: -705px;
    margin-left: 45%;
    position: absolute
}

.div-block-916 {
    max-width: 1300px
}

.text-block-427 {
    text-align: center;
    margin-bottom: 0;
    font-family: "P22mackinacpro 12", sans-serif;
    font-size: 38px;
    font-weight: 700;
    line-height: 1.2
}

.text-span-383 {
    color: var(--pabloo-green-2)
}

.text-span-384 {
    border-left: 0 solid #5a5a5a;
    padding-left: 0
}

@media screen and (min-width:1280px) {
    .home-hero-section {
        margin-top: 0
    }

    .wrapper-1300px {
        justify-content: flex-start
    }

    .wrapper-1300px.center-align {
        justify-content: center
    }

    .wrapper-1300px.for-about {
        margin-right: 0
    }

    .logo-container.as-featured-on-logo-container {
        align-items: center;
        display: flex
    }

    .logo-container.as-featured-on-logo-container.et-container {
        align-items: center;
        width: 17%;
        display: flex
    }

    .logo-container.as-featured-on-logo-container.cnbc-logo-container {
        width: 8%
    }

    .home-pointer-split-content-wrapper {
        width: 50%
    }

    .pricing-head-container {
        margin-bottom: 24px
    }

    .pricing-hero-table {
        background-color: #fff;
        border-radius: 20px;
        margin-top: 80px;
        box-shadow: 7px 4px 24px rgba(0, 0, 0, .11)
    }

    .pricing-table-left {
        border-radius: 20px
    }

    .pricing-table-right {
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px
    }

    .wrapper-1280px.split-wrapper.split-3 {
        padding-bottom: 140px
    }

    .wrapper-1280px.finance-wrapper {
        flex-direction: column;
        align-items: stretch;
        padding-top: 120px;
        padding-bottom: 120px
    }

    .wrapper-1280px.pt-sm {
        padding-top: 40px
    }

    .about-hero-text-contain {
        max-width: 1000px
    }

    .persona-split-text-container.split-3 {
        max-width: 560px
    }

    .persona-split-side-image.split-2 {
        top: 31%;
        right: -7%
    }

    .persona-finance-section {
        background-color: var(--black)
    }

    .finance-head-wrap {
        text-align: center;
        max-width: 720px;
        margin-bottom: 80px;
        margin-left: auto;
        margin-right: auto
    }

    .finance-heading {
        color: var(--white);
        line-height: 108%
    }

    .finance-grid {
        grid-column-gap: 40px;
        grid-row-gap: 16px;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-columns: 1fr;
        display: grid
    }

    .finance-grid-item {
        color: var(--white);
        text-align: center;
        flex-direction: column;
        align-items: center;
        font-size: 20px;
        font-weight: 500;
        line-height: 140%;
        display: flex
    }

    .finanve-item-icon-block {
        flex: none;
        width: 48px;
        height: 48px;
        margin-bottom: 24px
    }

    .finance-icon {
        width: 100%;
        height: 100%
    }

    .multi-channel-background.top-right {
        right: -15%
    }

    .case-study-hero-logo-item._2.no-bg {
        background-color: transparent;
        background-image: none
    }

    .assisted-hero-p-icon {
        left: 15%
    }

    .assisted-hero-gmail-icon {
        left: 50%
    }

    .hero-head-container {
        margin-top: 50px
    }

    .div-block-2 {
        width: 100%
    }

    .text-block-11.roundtable-text.pill-text {
        font-weight: 700
    }

    .div-block-27 {
        top: auto;
        right: -20px
    }

    .div-block-39 {
        margin-top: 0;
        padding-right: 0
    }

    .div-block-53 {
        top: auto;
        bottom: 64px
    }

    .text-span-11,
    .heading-9 {
        color: var(--black)
    }

    .heading-10 {
        color: var(--pabloo-green)
    }

    .paragraph-3 {
        color: var(--black)
    }

    .div-block-61.pink {
        display: none
    }

    .div-block-61.white {
        background-color: var(--white)
    }

    .button-2 {
        background-color: var(--pabloo-green);
        color: var(--white)
    }

    .heading-11 {
        color: var(--black)
    }

    .text-span-12 {
        color: var(--pabloo-green)
    }

    .html-embed-4 {
        margin-bottom: 0
    }

    .authors-wrapper {
        margin-top: 0
    }

    .company-logo-2.dan.lg {
        height: 160px
    }

    .container-13 {
        background-position: 100% 100%;
        background-size: 50%
    }

    .header-section-3 {
        padding-top: 120px
    }

    .header-section-3.with-bg {
        background-color: var(--white)
    }

    .image-cover.not-in-mobile {
        object-fit: cover
    }

    .modal-section {
        display: none
    }

    .modal-content {
        padding-top: 24px;
        padding-bottom: 24px
    }

    .modal-image-large {
        height: 100%
    }

    .div-block-169 {
        display: block
    }

    .header-slider-product {
        min-height: 590px
    }

    .header-featured-wrap.contact {
        position: relative
    }

    .sticky-wrapper {
        height: 100%;
        padding-bottom: 40px
    }

    .sec-bk {
        padding-bottom: 0
    }

    .sec-bk.p-b-32 {
        padding-bottom: 32vh
    }

    .sec-bk.p-b-32.xx {
        height: auto;
        padding-bottom: 0
    }

    .sub-header-img.contact-us {
        border-radius: 8px;
        padding-bottom: 24px;
        top: 16%
    }

    .columns-6 {
        padding-bottom: 80px;
        display: flex
    }

    .column-71 {
        height: auto
    }

    .f-paragraph-large-2 {
        margin-top: 24px
    }

    .jobs-board-form {
        margin-top: 16px
    }

    .faq-paragraph-2 {
        color: var(--white-smoke)
    }

    .image-57,
    .image-58,
    .image-59 {
        border-radius: 8px
    }

    .faq-heading-3 {
        color: var(--white)
    }

    .faq-section-3 {
        background-color: var(--slate-blue)
    }

    .faq-subheading,
    .faq-title-3,
    .bold-text-15 {
        color: var(--white)
    }

    .success-message-5 {
        background-color: var(--pabloo-green);
        border-radius: 8px
    }

    .text-block-137 {
        color: var(--white);
        font-weight: 500
    }

    .text-block-138 {
        text-align: center;
        margin-bottom: 8px;
        font-size: 14px
    }

    .link-24 {
        color: var(--pabloo-green)
    }

    .header-section-6 {
        padding-top: 120px
    }

    .b-navigation-base-2 {
        padding-left: 0;
        padding-right: 0
    }

    .navigation-grid-3 {
        grid-column-gap: 24px
    }

    .nav-list {
        font-size: 15px
    }

    .b-navigation-link-icon-2:hover {
        color: #d53987
    }

    .navigation-list-2.w--open {
        width: 60%;
        padding-left: 8px;
        padding-right: 8px
    }

    .navigation-list-2.product.w--open,
    .navigation-list-2.resources.w--open {
        width: 120%
    }

    .navigation-list-2.product.w--open {
        width: 110%
    }

    .b-navigation-link-icon-3:hover {
        color: #d53987
    }

    .navigation-dropdown-base-3 {
        box-shadow: 2px 24px 140px -48px rgba(57, 59, 106, .16)
    }

    .b-navigation-link-icon-4:hover {
        color: #d53987
    }

    .text-block-201 {
        font-size: 15px
    }

    .b-navigation-link-icon-5:hover {
        color: #d53987
    }

    .image-158 {
        width: 100%
    }

    .div-block-671 {
        margin-left: 0%;
        margin-right: 0%
    }

    .navigation-bar {
        top: 0
    }

    .navigation-menu {
        margin-left: 40px
    }

    .nav-links-contain {
        grid-column-gap: 20px
    }

    .dropdown-lists.w--open {
        top: 72px
    }

    .navigation-button-contain.out-menu {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .hero-home-wrapper.new {
        padding-top: 220px
    }

    .transparent-arrow-button._16px.navigation {
        padding-left: 24px;
        padding-right: 24px
    }

    .paragraph-18px.hero-home-paragraph.new {
        width: 80%
    }

    .stats-wrapper {
        padding-top: 0
    }

    .heading-24px.setup-card-text {
        font-size: 22px
    }

    .collection-list-7 {
        grid-template-columns: 1fr 1fr
    }

    .footer-links-wrapper {
        grid-template-columns: .75fr .5fr .75fr .75fr 1fr
    }

    .indicator-arrow {
        margin-right: 0
    }

    .spend-block-wrapper.a.new {
        object-fit: contain;
        width: 360px;
        margin-top: 40px;
        display: flex;
        position: absolute;
        top: 150%;
        bottom: auto;
        left: 40px;
        right: 40px
    }

    .spend-block-wrapper.a.new._1 {
        display: none;
        left: 40px
    }

    .spend-block-wrapper.a.new._2 {
        object-fit: fill;
        flex-flow: column;
        flex: none;
        justify-content: center;
        align-items: flex-start;
        margin-left: 0;
        padding-left: 0%;
        display: none;
        left: -70%;
        right: auto
    }

    .spend-block-wrapper.a.new._3 {
        flex-flow: column;
        flex: none;
        justify-content: center;
        align-items: flex-start;
        margin-left: 0;
        display: none;
        /* left: auto */
    }

    .spend-text-container {
        padding-bottom: 60px
    }

    .reviews-slide-text-gradient-wrapper {
        width: 67%
    }

    .hero-bkg {
        height: 85%
    }

    .home-hero-images-container {
        width: 55%;
        margin-right: -9%
    }

    .hero-bubbles-block-wrapper {
        bottom: 6%;
        left: 10.5%
    }

    .navigation-links-grid {
        grid-column-gap: 24px
    }

    .navigation-block-link:hover {
        color: #d53987
    }

    .hero-platform-heading-wrapper.display-flex.include-bg {
        max-width: 900px;
        padding-left: 53px
    }

    .hero-platform-image.integra {
        object-fit: contain
    }

    .hero-spotlight-image {
        width: 80%
    }

    .form-email-text-field.resource-hero {
        width: 67%
    }

    .div-block-732 {
        margin-top: -240px
    }

    .features-section {
        display: flex
    }

    .features-wrapper {
        margin-top: 67px
    }

    .feature-image-wrapper.left.green-bg {
        flex-direction: column;
        flex: 1 1;
        justify-content: flex-end;
        align-items: flex-start
    }

    .feature-image-wrapper.left.pink-bg {
        height: 550px
    }

    .hero-design-element {
        top: 64%
    }

    .hero-design-element.right {
        top: 25%
    }

    .hero-design-element.left {
        top: auto;
        bottom: 24%
    }

    .hero-design-element.center {
        left: -12%
    }

    .blog-cms-sticky-contain {
        top: 140px
    }

    .transparent-arrow-button-white._16px.navigation {
        padding-left: 24px;
        padding-right: 24px
    }

    .div-block-737 {
        padding-bottom: 38px
    }

    .flex-image-block.lottie {
        padding-top: 20px;
        padding-bottom: 20px
    }

    .flex-block-abs-image.fourth {
        bottom: -10%
    }

    .cloud-hero-absolute-image {
        top: 38%
    }

    .cloud-hero-absolute-image.third {
        top: 34%
    }

    .cloud-hero-absolute-image.fourth {
        right: -5%
    }

    .cloud-absolute-image {
        top: 38%
    }

    .cloud-absolute-image.second {
        right: -7%
    }

    .div-block-424 {
        max-width: 100%;
        margin-left: 100px;
        margin-right: 100px
    }

    .section-68 {
        background-color: #faf2eb;
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6597aa2642f1fe5180df02ff_Frame%202087326089.svg);
        background-position: 0%;
        background-repeat: no-repeat;
        background-size: auto
    }

    .div-block-425 {
        max-width: 100%;
        margin-left: 0;
        margin-right: 0
    }

    .html-embed-33 {
        margin-bottom: -6px
    }

    .tab-pane-pabloo-for-cloud {
        padding-bottom: 80px
    }

    .navigation-block-links-grid.resources {
        grid-column-gap: 60px
    }

    .nav-mobile-contain {
        grid-column-gap: 20px
    }

    .features-wrapper-2 {
        justify-content: space-around
    }

    .html-embed-39 {
        margin-bottom: 0
    }

    .heading-264 {
        font-size: 2.3rem
    }

    .sysf-tagline {
        padding-top: 12px;
        font-size: 17px;
        font-weight: 800
    }

    .brix---heading-h3-size {
        font-size: 14px;
        font-weight: 500
    }

    .brix---color-accent-1 {
        color: var(--pabloo-green)
    }

    .brix---display-2 {
        color: var(--black-2);
        font-size: 40px
    }

    .brix---stat-card-4-cols---01 {
        color: var(--black)
    }

    .feature-image-wrapper-copy.left.yellow-bg,
    .feature-image-wrapper-copy.left.pink-bg,
    .feature-image-wrapper-copy.left.pink-bg {
        height: 550px
    }

    .stats-wrapper-copy,
    .stats-wrapper-new,
    .stats-wrapper-copy {
        padding-top: 0
    }

    .feature-image-wrapper-copy.left.pink-bg {
        height: 550px
    }

    .div-block-732-copy {
        margin-top: -240px
    }

    .new-navigation-background-div {
        max-width: 100%
    }

    .html-embed-40 {
        color: var(--pabloo-green-2);
        font-weight: 600
    }

    .features-section-copy {
        display: flex
    }

    .features-wrapper-copy {
        margin-top: 67px
    }

    .wrapper-1280px-copy.split-wrapper.split-3 {
        padding-bottom: 140px
    }

    .wrapper-1280px-copy.finance-wrapper {
        flex-direction: column;
        align-items: stretch;
        padding-top: 120px;
        padding-bottom: 120px
    }

    .wrapper-1280px-copy.pt-sm {
        padding-top: 40px
    }

    .hello-navigation-bar {
        top: 0
    }

    .heading-24px-copy.setup-card-text {
        font-size: 22px
    }

    .wrapper-1300px-copy-copy {
        justify-content: flex-start
    }

    .wrapper-1300px-copy-copy.center-align {
        justify-content: center
    }

    .hero-bkg-copy,
    .hero-bkg-copy-copy {
        height: 85%
    }

    .cms-blog-block-section-copy.templates-block {
        margin-top: -180px
    }

    .wrapper-1300px-copy {
        justify-content: flex-start
    }

    .wrapper-1300px-copy.center-align {
        justify-content: center
    }

    .new-about-1300px-header {
        justify-content: flex-start
    }

    .new-about-1300px-header.center-align {
        justify-content: center
    }

    .new-about-hero-wrapper {
        background-image: none;
        background-position: 0 0;
        background-repeat: repeat;
        background-size: auto;
        background-attachment: scroll
    }

    .stats-wrapper-copy-copy,
    .stats-xx {
        padding-top: 0
    }

    .text-block-332 {
        padding-right: 23px
    }

    .section-72,
    .section-72.what-is-in {
        padding-left: 20px;
        padding-right: 20px
    }

    .section-72.events,
    .section-72.testimonial {
        padding-left: 40px;
        padding-right: 40px
    }

    .section-72.location {
        max-width: none;
        margin-left: 0;
        margin-right: 0
    }

    .section-72.optimize {
        background-size: auto
    }

    .section-72.ads {
        padding-left: 40px;
        padding-right: 40px
    }

    .div-block-822 {
        padding-left: 0;
        padding-right: 0
    }

    .text-block-357.events {
        font-size: 52px
    }

    .text-block-358 {
        margin-bottom: 103px
    }

    .div-block-827 {
        margin-top: -101px
    }

    .text-block-359.events {
        font-size: 52px
    }

    .div-block-841 {
        flex-flow: column
    }

    .partners.partner-logos {
        height: 25px;
        margin-bottom: 10px;
        display: flex
    }

    .div-block-845 {
        grid-column-gap: 0px;
        grid-row-gap: 0px
    }

    .image-260 {
        flex: 0 1 auto;
        align-self: center;
        margin-top: 0;
        padding-top: 10px
    }

    .div-block-853 {
        background-size: cover
    }

    .div-block-860 {
        margin-top: 10px
    }

    .feature-text-header {
        align-self: stretch
    }

    .text-span-339,
    .text-span-340,
    .text-span-341,
    .text-span-342,
    .text-span-343,
    .text-span-344 {
        color: var(--pabloo-green-2)
    }

    .div-block-865 {
        display: block
    }

    .div-block-866 {
        width: 30px
    }

    .tabs-4 {
        background-color: var(--soft-pink);
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4f2ab2fe33ac69859f70_Group%202087326245news.png);
        background-position: 0 0;
        background-repeat: repeat-x;
        background-size: 100% 580px;
        border-radius: 20px;
        flex-flow: row;
        flex: 0 1 auto;
        width: 100%;
        display: flex
    }

    .tabs-menu-7 {
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4bbc17ed885772b7ec8f_Bgx.png);
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-attachment: scroll;
        border-radius: 20px;
        width: 40%;
        height: 580px;
        padding: 13px;
        display: flex
    }

    .tabs-content-5 {
        width: 60%
    }

    .tab-link-tab-1-3 {
        flex: 1 1
    }

    .tab-link-tab-1-3.w--current {
        background-color: var(--transparent);
        flex-flow: column;
        flex: 0 1 auto;
        justify-content: center;
        align-items: center;
        height: 100px;
        padding-right: 10px;
        display: flex
    }

    .tab-link-tab-2-3 {
        background-color: var(--transparent);
        flex: 0 1 auto;
        justify-content: center;
        align-items: flex-end;
        height: 100px;
        padding-left: 10px;
        padding-right: 10px;
        display: flex
    }

    .tab-link-tab-2-3.w--current {
        justify-content: center;
        align-items: flex-end;
        margin-left: auto
    }

    .tab-link-tab-3-2 {
        background-color: var(--transparent);
        flex: 0 1 auto;
        justify-content: center;
        align-items: center;
        height: 100px;
        padding-left: 10px;
        display: flex
    }

    .div-block-867 {
        justify-content: center;
        align-items: center;
        display: flex
    }

    .text-block-389 {
        padding-right: 10px;
        font-size: 22px
    }

    .div-block-868 {
        box-sizing: border-box;
        object-fit: cover;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        height: 580px;
        padding: 34px;
        display: flex
    }

    .image-264 {
        flex: 0 1 auto;
        display: block;
        overflow: visible
    }

    .text-block-391 {
        font-size: 90px
    }

    .div-block-892 {
        background-position: 50%
    }

    .image-271 {
        width: 70%
    }
}

@media screen and (min-width:1440px) {
    .wrapper-1300px {
        left: auto
    }

    .wrapper-1300px.featured-on-wrapper {
        max-width: 100%
    }

    .wrapper-1300px.for-about {
        margin-right: 0
    }

    .wrapper-1300px.for-integra {
        max-width: 1300px
    }

    .navigation-left {
        width: 22%
    }

    .navigation-container {
        max-width: 100%
    }

    .nav-link {
        padding-left: 16px;
        padding-right: 16px
    }

    .nav01.sticky {
        z-index: 99
    }

    .home-hero-content-wrapper {
        width: 60%;
        max-width: 63%
    }

    .home-hero-heading-wrapper,
    .home-hero-para-wrapper {
        max-width: 88%
    }

    .primary-button.white-button.book-button {
        font-size: 16px
    }

    .cards-section.vertical-padding-large {
        margin-left: auto;
        margin-right: auto
    }

    .cards-section.vertical-padding-large.integra {
        padding-left: 70px;
        padding-right: 42px
    }

    .logo-wrapper-grid.as-featured-on-logos-wrapper-grid {
        max-width: 90%
    }

    .logo-container.as-featured-on-logo-container {
        align-items: center;
        width: 15%;
        height: 48px;
        display: flex
    }

    .logo-container.as-featured-on-logo-container.et-container {
        width: 18%;
        height: 60px
    }

    .logo-container.as-featured-on-logo-container.cnbc-logo-container {
        width: 8%;
        height: 48px
    }

    .logo-container.as-featured-on-logo-container.forbes-logo-container {
        height: 42px
    }

    .company-logo.publication-logo.forbes-logo {
        height: 64%
    }

    .company-logo.publication-logo.ent-logo {
        height: 72%
    }

    .split-section-content-container {
        width: 40%
    }

    .split-image-2 {
        right: 33%
    }

    .pitch-section {
        padding-top: 89px;
        padding-bottom: 89px
    }

    .pitch-head-wrapper {
        margin-bottom: -1px
    }

    .pitch-heading {
        margin-top: 43px;
        margin-bottom: 43px;
        font-size: 38px
    }

    .pitch-card-content-wrapper.persona {
        max-width: 350px
    }

    .pitch-card-para.persona {
        margin-bottom: 20px
    }

    .white-alter-span.white {
        font-size: 64px
    }

    .pricing-hero-section {
        background-position: 50% 0;
        background-size: cover
    }

    .blog-main-image-wrapper {
        max-width: none
    }

    .home-value-bg-image-wrap {
        max-width: 790px
    }

    .about-hero-text-contain {
        max-width: 1000px
    }

    .member-image._1.member-image-webinar,
    .member-image._2.member-image-webinar {
        max-height: 240px
    }

    .member-name.volopay-member-name {
        margin-bottom: 10px
    }

    .persona-split-text-container.split-3 {
        width: 43%
    }

    .persona-split-text-container.procurement-2-text {
        width: 42%
    }

    .persona-split-side-image {
        right: -9%
    }

    .persona-split-side-image.split-2 {
        top: 31%;
        right: -11%
    }

    .persona-split-side-image.split-3 {
        right: -6%
    }

    .persona-text-link {
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d1ffb97d792f833449_Vector%20\\(9\\).svg), url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);
        background-position: 85%, 85%;
        background-repeat: no-repeat, no-repeat;
        background-size: auto, auto;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 40px;
        font-weight: 700;
        line-height: 156%;
        transition: color .3s, background-position .34s
    }

    .persona-text-link:hover {
        color: var(--pabloo-green);
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);
        background-position: 95%;
        background-repeat: no-repeat;
        background-size: auto
    }

    .procurement-section-1-image {
        position: absolute
    }

    .procurement-section-1-image._1 {
        border-radius: 10px
    }

    .procurement-section-1-image._2 {
        border-radius: 10px;
        margin-top: auto;
        margin-bottom: auto;
        top: 0%;
        bottom: 0%;
        right: auto
    }

    .procurement-section-1-image._3 {
        border-radius: 10px;
        top: auto;
        left: auto
    }

    .procurement-section-2-image {
        right: -10%
    }

    .dropdown-toggle {
        padding-left: 16px;
        padding-right: 16px
    }

    .discover-product-hero-heading {
        line-height: 72px
    }

    .new-product-hero-image {
        box-shadow: -14px 14px 0 0 var(--slate-blue)
    }

    .tools-hero-image {
        box-shadow: -14px 14px 0 0 var(--pabloo-green)
    }

    .track-approval-hero-image {
        box-shadow: none
    }

    .multi-channel-background.bottom-left {
        left: -15%
    }

    .fast-track-hero-circle-wrapper.left {
        left: 5%
    }

    .fast-track-hero-circle-wrapper.right {
        right: 5%
    }

    .fast-track-hero-user-element._1,
    .fast-track-hero-user-element._4 {
        left: 40%
    }

    .footer-top-wrapper {
        padding-top: 32px;
        padding-bottom: 20px
    }

    .split-section-form-wrapper {
        padding-left: 32px;
        padding-right: 32px
    }

    .form-field-wrapper {
        flex-wrap: wrap
    }

    .assisted-tools-image-container {
        width: 48%;
        max-width: none
    }

    .assisted-hero-image-wrapper {
        box-shadow: none;
        max-width: 95%
    }

    .assisted-hero-office-icon {
        left: 20%
    }

    .assisted-hero-p-icon {
        left: 30%
    }

    .assisted-hero-droupbox-icon {
        right: 30px
    }

    .assisted-hero-z-icon {
        right: 25%
    }

    .assisted-hero-gmail-icon {
        left: 40%
    }

    .investor-logo.investor-logo-rt-demo-custo-styles {
        width: 33%
    }

    .insights-hero-image-4 {
        width: 30%
    }

    .contract-hero-item-wrap.left {
        left: 40px
    }

    .contract-hero-item-wrap.right {
        right: 40px
    }

    .thank-you-section {
        align-items: center;
        height: 64vh
    }

    .home-hero-text-wrapper {
        margin-top: 96px
    }

    .hello-bar {
        padding-top: 10px;
        padding-bottom: 10px;
        position: sticky
    }

    .div-block-2 {
        width: 80%
    }

    .text-block-8 {
        text-align: center
    }

    .div-block-12 {
        display: block
    }

    .body-2 {
        background-color: #fff;
        transition: all .4s
    }

    .div-block-19 {
        margin-top: 0
    }

    .div-block-19.p-r-40 {
        padding-right: 40px
    }

    .div-block-20 {
        padding: 16% 8px 20%
    }

    .container-4 {
        background-size: 40%
    }

    .container-4.custo {
        max-width: 1040px
    }

    .div-block-23 {
        align-items: center;
        padding: 16px 24px;
        display: flex
    }

    .div-block-23.alt-badge {
        border-radius: 120px
    }

    .text-block-10,
    .text-block-10.primary-badge-text {
        line-height: 18px
    }

    .text-block-11 {
        color: var(--black)
    }

    .text-block-11.roundtable-text.pill-text {
        font-weight: 700
    }

    .div-block-24 {
        margin-top: 16px
    }

    .div-block-24.panel-shadow {
        margin-top: 0
    }

    .div-block-27 {
        z-index: -1;
        top: auto;
        bottom: 16px
    }

    .div-block-28 {
        min-height: auto
    }

    .div-block-29 {
        background-color: var(--white);
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        padding-bottom: 80px
    }

    .bestsuited-webinarblock {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .button {
        transition: background-color .275s ease-in-out
    }

    .button:hover {
        background-color: var(--black)
    }

    .button.round:hover {
        background-color: var(--pabloo-green)
    }

    .div-block-35 {
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62adcf5682ada2a467982e5d_topics-bg.svg)
    }

    .div-block-38 {
        background-color: transparent;
        background-image: none;
        border-bottom-right-radius: 0;
        padding-top: 80px;
        padding-bottom: 80px;
        padding-left: 0%
    }

    .cta-button-roundtable {
        transition: background-color .275s ease-in-out
    }

    .cta-button-roundtable:hover {
        background-color: var(--black-2);
        color: var(--white)
    }

    .cta-button-roundtable.cta-button-roundtable-pink {
        background-color: var(--pabloo-green);
        color: var(--white);
        border-radius: 12px;
        box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)
    }

    .cta-button-roundtable.cta-button-roundtable-pink:hover {
        background-color: var(--black-2)
    }

    .div-block-39 {
        justify-content: flex-start;
        margin-top: 48px;
        padding-right: 0
    }

    .div-block-40 {
        background-color: var(--white)
    }

    .container-5 {
        padding-bottom: 80px;
        padding-left: 0;
        line-height: 25px
    }

    .div-block-41 {
        margin-top: 0;
        padding-left: 8%
    }

    .div-block-42 {
        margin-top: 24px
    }

    .div-block-45 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto;
        grid-template-columns: auto 1fr;
        grid-auto-columns: 1fr;
        align-items: center;
        display: grid
    }

    .text-block-20 {
        color: #fff
    }

    .text-block-21 {
        color: var(--black-2)
    }

    .image-7 {
        width: 100%;
        max-width: none;
        height: auto;
        position: static
    }

    .column-2 {
        padding-top: 56px
    }

    .text-block-22 {
        color: var(--black)
    }

    .column-5 {
        background-position: 50% 12%
    }

    .div-block-50 {
        border-radius: 120px
    }

    .column-6 {
        padding-top: 4%
    }

    .div-block-53 {
        display: none
    }

    .container-6 {
        max-width: 1040px;
        padding-left: 0;
        padding-right: 0
    }

    .container-6.m-w-72 {
        max-width: 80%
    }

    .div-block-60 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        padding-left: 24px;
        display: none
    }

    .text-span-11 {
        font-family: Satoshi, sans-serif;
        font-style: normal;
        font-weight: 700
    }

    .heading-9 {
        margin-bottom: 16px;
        font-size: 28px;
        font-weight: 500
    }

    .heading-10 {
        color: var(--black);
        font-size: 32px;
        line-height: 40px
    }

    .paragraph-3 {
        margin-top: 20px;
        font-size: 19px
    }

    .div-block-61 {
        padding-top: 120px;
        padding-bottom: 120px
    }

    .div-block-61.pink {
        display: none
    }

    .div-block-61.white {
        padding-top: 80px;
        display: block
    }

    .columns-4 {
        padding-top: 16px;
        padding-bottom: 40px
    }

    .button-2 {
        background-color: var(--pabloo-green);
        color: var(--white);
        border-radius: 2px;
        margin-top: 24px;
        margin-left: 0;
        padding: 22px 32px;
        font-size: 20px;
        font-weight: 700
    }

    .image-14 {
        line-height: 28px
    }

    .heading-11 {
        font-family: Satoshi, sans-serif
    }

    .column-8 {
        justify-content: center
    }

    .div-block-62 {
        padding-left: 0
    }

    .container-7 {
        max-width: 1040px
    }

    .div-block-63 {
        padding-right: 4%
    }

    .container-9 {
        max-width: 85%
    }

    .div-block-98.pb-md.pt-sm.flex {
        background-size: cover
    }

    .div-block-100 {
        background-color: var(--black)
    }

    .div-block-101 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-auto-columns: 1fr;
        display: flex
    }

    .div-block-102 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr;
        grid-auto-columns: 1fr;
        display: grid
    }

    .div-block-103 {
        display: flex
    }

    .container-13 {
        background-position: 100% 100%;
        background-size: 50%
    }

    .container-13.remove-bg {
        min-height: auto
    }

    .features-container {
        margin-top: 42px;
        margin-left: auto;
        padding-left: 60px
    }

    .image-cover.not-in-mobile {
        object-fit: cover
    }

    .div-block-144 {
        padding-left: 24%;
        padding-right: 24%
    }

    .section-large-2.blackbg {
        background-position: 112% 115%, 0 0
    }

    .modal-section {
        display: none
    }

    .grid-four-column {
        grid-template-columns: 1fr 1fr 1fr 1fr
    }

    .image-40,
    .client-logo {
        filter: grayscale()
    }

    .client-logo.mind-tickle-logo-resize {
        height: 28px
    }

    .header-slider-product {
        min-height: 600px
    }

    .sticky-wrapper {
        height: 100%
    }

    .sec-bk {
        padding-bottom: 14vh
    }

    .sec-bk.p-b-32.xx {
        height: auto;
        padding-bottom: 0
    }

    .div-block-194 {
        width: 100%;
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto;
        padding-left: 0%;
        padding-right: 0%
    }

    .div-block-199 {
        align-items: center
    }

    .image-47.m-l-8 {
        width: auto;
        height: 80px
    }

    .div-block-200 {
        padding-left: 5%;
        padding-right: 5%
    }

    .image-60 {
        border-radius: 8px
    }

    .header-section-6 {
        min-height: 72vh;
        padding-top: 40px
    }

    .member-position {
        line-height: 1.1
    }

    .tab-button-content {
        border-bottom-style: none;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .tab-button.w--current {
        background-color: rgba(80, 80, 255, .06)
    }

    .dropdown-toggle-3,
    .nav-link-5 {
        padding-left: 16px;
        padding-right: 16px
    }

    .blog-book-demo-box {
        max-width: 290px
    }

    .b-navigation-base-2 {
        padding-left: 0;
        padding-right: 0
    }

    .navigation-grid-3 {
        height: auto;
        padding-left: 0;
        padding-right: 0
    }

    .wrapper-1300px-3 {
        left: auto
    }

    .navigation-list-2.w--open {
        width: 56%;
        left: 0%
    }

    .navigation-list-2.solutions {
        width: 60%;
        min-width: auto;
        left: 0%
    }

    .navigation-list-2.product {
        width: 120%;
        left: auto
    }

    .navigation-list-2.resources {
        width: 120%;
        min-width: auto
    }

    .div-block-371 {
        align-items: center
    }

    .image-111.m-l-8 {
        width: auto;
        height: 80px
    }

    .navigation-menu-6 {
        position: relative
    }

    .div-block-430 {
        min-height: 320px
    }

    .html-embed-25 {
        width: 100%;
        height: 100%
    }

    .image-155,
    .image-156 {
        width: 100%
    }

    .div-block-475 {
        width: 52%
    }

    .image-158 {
        width: 80%
    }

    .text-span-204 {
        margin-left: 2px
    }

    .column-76 {
        padding-bottom: 0%;
        padding-left: 8%;
        padding-right: 8%
    }

    .div-block-671 {
        margin-left: 0%;
        margin-right: 0%
    }

    .navigation-bar {
        top: 0
    }

    .nav-links-contain {
        grid-column-gap: 32px
    }

    .dropdown-lists.w--open {
        left: -1.5%
    }

    .paragraph-18px.hero-home-paragraph.new {
        width: 80%
    }

    .pink-arrow-button.ebook {
        width: 60%
    }

    .stats-wrapper {
        padding-top: 0
    }

    .heading-24px.setup-card-text {
        font-size: 24px
    }

    .footer-links-wrapper {
        grid-column-gap: 80px;
        grid-row-gap: 80px
    }

    .calculator-content {
        grid-column-gap: 24px
    }

    .spend-image.c {
        box-shadow: 0 -20px 80px rgba(0, 0, 0, .1)
    }

    .spend-image.b {
        position: relative
    }

    .sticky-indicator-text-wrapper {
        grid-column-gap: 16px
    }

    .home-hero-images-container {
        width: 55%;
        margin-right: -7%
    }

    .hero-bubbles-block-wrapper {
        left: 16%
    }

    .navigation-links-grid {
        height: auto;
        padding-left: 0;
        padding-right: 0
    }

    .dropdown-highlight-span {
        margin-left: 2px
    }

    .tribe-image-wrapper {
        left: 8%
    }

    .hero-platform-wrapper.integra {
        padding-left: 8%;
        padding-right: 8%
    }

    .hero-platform-heading-wrapper.display-flex.include-bg {
        justify-content: center;
        align-items: flex-end;
        max-width: 900px;
        padding-left: 155px
    }

    .div-block-732 {
        margin-top: -259px
    }

    .features-section {
        display: flex
    }

    .old-sections {
        display: block
    }

    .features-wrapper {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 87px;
        display: flex
    }

    .feature-image-wrapper.left.pink-bg {
        height: 550px
    }

    .hero-design-element {
        top: 52%
    }

    .hero-design-element.right {
        top: 24%
    }

    .hero-design-element.left {
        bottom: 16%
    }

    .div-block-737 {
        align-items: center;
        min-height: auto;
        padding-bottom: 60px;
        display: flex
    }

    .div-block-737.new {
        min-height: auto;
        padding-bottom: 7%
    }

    .flex-block-image-wrapper {
        left: 6%
    }

    .flex-block-image-wrapper.right {
        right: 6%
    }

    .flex-block-image.cloud-1,
    .flex-block-image.cloud-2 {
        width: 70%
    }

    .cloud-hero-image-wrapper {
        width: 45%
    }

    .cloud-hero-absolute-image {
        top: 40%
    }

    .cloud-hero-absolute-image.fourth {
        right: -4%
    }

    .cloud-absolute-image {
        top: 40%
    }

    .cloud-absolute-image.second {
        right: -12%
    }

    .spend-absolute-image.a {
        left: 6%
    }

    .section-68,
    .tab-pane-pabloo-for-saas {
        padding-bottom: 0
    }

    .div-block-769 {
        max-width: 1280%;
        padding-left: 24%;
        padding-right: 24%
    }

    .navigation-block-links-grid.resources {
        grid-column-gap: 80px
    }

    .nav-mobile-contain {
        grid-column-gap: 32px
    }

    .points-checklist-grid {
        grid-template-columns: .9fr 1fr
    }

    .text-block-321 {
        text-align: center
    }

    .div-block-784 {
        display: block
    }

    .sysf-tagline {
        font-size: 18px;
        font-weight: 800
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        height: 550px;
        padding-left: 3px
    }

    .stats-wrapper-new {
        margin-top: 0;
        padding-top: 0
    }

    .stats-wrapper-copy {
        padding-top: 0
    }

    .feature-image-wrapper-copy.left.pink-bg {
        height: 550px
    }

    .div-block-732-copy {
        margin-top: -259px
    }

    .new-navigation-background-div {
        max-width: 100%
    }

    .div-block-20-copy {
        padding: 16% 8px 20%
    }

    .features-section-copy {
        display: flex
    }

    .features-wrapper-copy {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 87px;
        display: flex
    }

    .hello-navigation-bar {
        top: 0
    }

    .wrapper-1300px-copy {
        padding-top: 0;
        padding-bottom: 0;
        left: auto
    }

    .stats-wrapper-copy-copy {
        padding-top: 0
    }

    .heading-90px-copy.stats-block-heading-copy {
        letter-spacing: 0;
        font-size: 24px
    }

    .bold-text-30 {
        font-size: 30px
    }

    .heading-24px-copy.setup-card-text,
    .heading-24px-copy.stats-text-copy {
        font-size: 24px
    }

    .pitch-section-copy {
        padding-top: 0;
        padding-bottom: 0;
        display: block
    }

    .bold-text-30-copy {
        font-size: 30px
    }

    .wrapper-1300px-copy {
        justify-content: center;
        align-items: center;
        left: auto
    }

    .wrapper-1300px-copy-copy {
        left: auto
    }

    .wrapper-1300px-copy-copy.featured-on-wrapper {
        max-width: 100%
    }

    .paragraph-152 {
        /* padding-right: 79px */
    }

    .blog-hero-heading-copy {
        margin-top: 42px
    }

    .text-block-330 {
        flex: 1 1;
        justify-content: center;
        align-self: auto;
        align-items: flex-start;
        display: flex
    }

    .blog-card-image-copy.custo:hover {
        transform: none
    }

    .wrapper-1300px-copy {
        left: auto
    }

    .wrapper-1300px-copy.featured-on-wrapper {
        max-width: 100%
    }

    .new-about-1300px-header {
        left: auto
    }

    .new-about-1300px-header.featured-on-wrapper {
        max-width: 100%
    }

    .new-about-hero-wrapper {
        background-image: none
    }

    .xs-text,
    .about-heading-x {
        font-size: 64px
    }

    .stats-about {
        margin-top: 220px
    }

    .stats-wrapper-copy-copy,
    .stats-xx {
        margin-top: 0;
        padding-top: 0
    }

    .text-block-331 {
        align-self: flex-start
    }

    .text-block-332 {
        padding-bottom: 0;
        padding-right: 24px
    }

    .tabs-menu-5 {
        align-items: center;
        justify-items: start
    }

    .heading-265 {
        font-size: 22px
    }

    .section-72,
    .section-72.what-is-in {
        padding-left: 0;
        padding-right: 0
    }

    .section-72.about-eve {
        padding-top: 290px
    }

    .section-72.optimize {
        background-size: cover
    }

    .div-block-822 {
        padding-left: 0;
        padding-right: 0
    }

    .image-249 {
        object-fit: cover;
        display: inline-block
    }

    .div-block-827 {
        margin-top: -119px
    }

    .div-block-829.why {
        background-position: 0 100%;
        background-repeat: repeat;
        background-attachment: scroll;
        margin-top: 100px
    }

    .div-block-832.why {
        margin-top: 6px
    }

    .div-block-833 {
        justify-content: center;
        align-items: center;
        display: flex
    }

    .div-block-835 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/660fabd5aed4381a048727b1_Group%202085664155.svg);
        background-position: 0 0;
        background-size: cover;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        padding: 104px;
        display: flex
    }

    .text-block-363 {
        font-size: 42px;
        font-weight: 700
    }

    .text-span-306 {
        color: var(--pabloo-green-2)
    }

    .div-block-836 {
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        flex-flow: column;
        width: 60%;
        display: flex
    }

    .text-block-364 {
        border-left: 4px solid var(--pabloo-green);
        padding-left: 15px
    }

    .text-block-365 {
        width: 90%
    }

    .div-block-837 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        margin-top: 26px;
        display: grid
    }

    .image-252 {
        object-fit: fill
    }

    .div-block-838 {
        align-self: flex-start
    }

    .div-block-842 {
        padding-right: 12px
    }

    .div-block-857 {
        width: 70%
    }

    .collection-list-wrapper-8 {
        margin-top: 10px
    }

    .feature-text-header {
        align-self: stretch
    }

    .div-block-862 {
        padding-top: 2%
    }

    .text-block-391 {
        font-size: 90px
    }

    .div-block-888.fold-2 {
        width: 75%
    }

    .div-block-892 {
        background-position: 50%;
        background-size: cover
    }

    .image-271 {
        width: 70%
    }
}

@media screen and (min-width:1920px) {
    .wrapper-1300px.for-about {
        margin-right: 0
    }

    .wrapper-1300px.for-integra {
        max-width: 1300px
    }

    .navigation-container {
        max-width: 100%
    }

    .nav01 {
        max-width: none
    }

    .primary-button.white-button.book-button {
        font-size: 20px
    }

    .cards-section.vertical-padding-large {
        justify-content: center;
        align-items: center;
        margin-left: auto;
        margin-right: auto
    }

    .company-logo {
        height: 100%
    }

    .company-logo.uc-logo {
        height: 120%
    }

    .home-slider-section.cs {
        height: 100vh
    }

    .blog-main-image-wrapper {
        max-width: 1600px
    }

    .home-value-bg-image-wrap {
        width: 90%;
        max-width: 920px
    }

    .career-section {
        display: none
    }

    .fast-track-hero-circle-wrapper.left {
        left: 15%
    }

    .fast-track-hero-circle-wrapper.right {
        right: 15%
    }

    .contract-hero-item-wrap.left {
        left: 220px
    }

    .contract-hero-item-wrap.right {
        right: 220px
    }

    .container-4.custo {
        padding-left: 0;
        padding-right: 0
    }

    .text-block-11.roundtable-text.pill-text {
        font-weight: 700
    }

    .div-block-27 {
        top: 154px;
        right: -61px
    }

    .div-block-29 {
        background-position: 0 0;
        background-size: auto 45%;
        padding-left: 50px;
        padding-right: 50px
    }

    .div-block-36 {
        margin-top: 0
    }

    .div-block-38 {
        background-image: none;
        padding-left: 50px;
        padding-right: 50px
    }

    .div-block-39 {
        justify-content: flex-start;
        margin-top: 0;
        padding-right: 0
    }

    .container-6 {
        padding-left: 0;
        padding-right: 0
    }

    .container-7 {
        max-width: 1040px
    }

    .div-block-64 {
        justify-content: flex-start
    }

    .header-grid-3 {
        align-items: center
    }

    .container-13 {
        align-self: center;
        min-height: 50vh;
        position: relative
    }

    .container-13.remove-bg {
        min-height: auto
    }

    .header-section-3.with-bg {
        min-height: 70vh
    }

    .features-container {
        direction: rtl;
        text-align: left;
        object-fit: fill;
        margin-left: auto;
        display: inline-block
    }

    .team-heading {
        direction: ltr;
        letter-spacing: 0;
        object-fit: contain;
        order: 0;
        align-self: flex-start
    }

    .feature-section-2.new {
        display: flex
    }

    .features-heading-wrap {
        flex-flow: row;
        order: -1
    }

    .features-heading-wrap._2-0 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: flex-start
    }

    .div-block-144 {
        padding-left: 32%;
        padding-right: 32%
    }

    .section-large-2.blackbg {
        background-position: 108% 115%, 0 0
    }

    .modal-section {
        display: flex
    }

    .sticky-wrapper {
        height: 100%
    }

    .header-section-6 {
        min-height: auto
    }

    .image-67 {
        height: 42px
    }

    .empty-state-3 {
        padding-left: 50px;
        padding-right: 50px
    }

    .blog-book-demo-box {
        max-width: 320px
    }

    .section-26 {
        background-size: cover
    }

    .div-block-502 {
        padding-left: 50px;
        padding-right: 50px
    }

    .div-block-674 {
        width: 100%;
        top: 20%;
        right: -64%
    }

    .case-study-hero-sub-heading {
        font-size: 18px
    }

    .rich-text-block-28 {
        font-size: 20px
    }

    .heading-64px.text-align-center {
        font-size: 52px
    }

    .navigation-bar {
        top: 0
    }

    .hero-home-wrapper {
        padding-top: 185px
    }

    .hero-home-wrapper.new.ads {
        padding-top: 220px;
        padding-bottom: 180px
    }

    .paragraph-18px.hero-home-paragraph.new {
        width: 85%
    }

    .stats-wrapper {
        padding-top: 0
    }

    .paragraph-16px.navigation-subheading {
        text-transform: none
    }

    .spend-section.new,
    .spend-wrapper {
        margin-left: auto;
        margin-right: auto
    }

    .hero-platform-heading-wrapper.display-flex.include-bg {
        max-width: 950px;
        padding-left: 81px
    }

    .div-block-732 {
        margin-top: -260px
    }

    .features-section {
        display: flex
    }

    .old-sections {
        display: block
    }

    .features-wrapper {
        flex-flow: column;
        align-content: flex-start;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .feature-wrap {
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 50px;
        display: flex;
        position: static
    }

    .feature-image-wrapper.right.pink-bg,
    .feature-image-wrapper.right.green-bg,
    .feature-image-wrapper.right.green-bg-copy {
        order: -1
    }

    .feature-image-wrapper.left.green-bg {
        flex-direction: column;
        flex: 1 1;
        order: 1;
        justify-content: flex-start;
        align-items: center
    }

    .feature-image-wrapper.left.green-bg.padding-reset {
        order: 1
    }

    .feature-image-wrapper.left.yellow-bg {
        object-fit: fill;
        flex-direction: column;
        flex: 1 1;
        order: 1;
        align-self: center;
        align-items: center;
        height: 550px;
        display: block
    }

    .feature-image-wrapper.left.pink-bg {
        flex: 1 1;
        order: 1
    }

    .hero-design-element {
        top: 40%
    }

    .hero-design-element.right {
        top: 16%
    }

    .hero-design-element.left {
        bottom: 50%
    }

    .div-block-737 {
        align-items: center;
        min-height: auto;
        display: flex
    }

    .div-block-737.new {
        padding-bottom: 4%
    }

    .pricing-menu-tabs,
    .pricing-duration-toggle,
    .div-block-424 {
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto
    }

    .section-68 {
        padding-bottom: 0
    }

    .div-block-426 {
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto
    }

    .tab-pane-pabloo-for-saas {
        padding-bottom: 0
    }

    .div-block-760,
    .div-block-767,
    .div-block-768 {
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto
    }

    .tab-pane-pabloo-for-cloud {
        padding-bottom: 80px
    }

    .div-block-769 {
        max-width: 1280px;
        margin-left: auto;
        margin-right: auto;
        padding-left: 22%;
        padding-right: 22%
    }

    .section-69 {
        background-color: #08090a
    }

    .sysf-tagline {
        font-size: 18px
    }

    .heading-64px-copy.text-align-center,
    .heading-64px-new.text-align-center {
        font-size: 32px
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        object-fit: fill;
        flex: 1 1;
        order: 1;
        width: 50%;
        height: 550px;
        display: block
    }

    .image-244 {
        overflow-wrap: normal
    }

    .feature-image-wrapper-copy-copy.right.green-bg {
        order: -1
    }

    .feature-image-wrapper-copy.left.pink-bg {
        order: 1
    }

    .stats-wrapper-copy,
    .stats-wrapper-new,
    .stats-wrapper-copy {
        padding-top: 0
    }

    .feature-image-wrapper-copy.right.green-bg {
        order: -1
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        object-fit: fill;
        flex-direction: column;
        flex: 1 1;
        order: 1;
        align-self: center;
        align-items: center;
        height: 550px;
        display: block
    }

    .feature-image-wrapper-copy.left.pink-bg {
        flex: 1 1;
        order: 1
    }

    .div-block-732-copy {
        margin-top: -260px
    }

    .div-block-795 {
        flex-direction: column;
        display: flex
    }

    .text-block-326 {
        text-align: center;
        margin-top: 19px;
        font-size: 18px
    }

    .hero-button-cta-copy {
        padding-left: 50px;
        padding-right: 50px
    }

    .feature-image-wrapper-copy-copy-copy.right.green-bg {
        order: -1
    }

    .new-navigation-background-div {
        max-width: 100%
    }

    .features-section-copy {
        display: flex
    }

    .features-wrapper-copy {
        flex-flow: column;
        align-content: flex-start;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .hello-navigation-bar {
        top: 0
    }

    .new-about-hero-wrapper {
        background-image: none;
        background-attachment: scroll
    }

    .stats-wrapper-copy-copy,
    .stats-xx {
        padding-top: 0
    }

    .text-block-331 {
        text-align: left;
        margin-left: 0;
        text-decoration: none
    }

    .about-x-platform-wrapper.new {
        background-image: none
    }

    .faq-item-x.demo {
        padding: 38px
    }

    .section-72 {
        margin-left: auto;
        margin-right: auto
    }

    .section-72.about-eve {
        padding-top: 335px
    }

    .section-72.optimize {
        background-size: auto
    }

    .div-block-829 {
        background-color: #f8f8f8;
        border-radius: 20px;
        padding-left: 60px
    }

    .div-block-829.why {
        background-position: 0 100%;
        background-attachment: scroll
    }

    .section-73 {
        max-width: 1300px
    }

    .div-block-835 {
        margin-bottom: 47px
    }

    .div-block-841 {
        grid-column-gap: 10px;
        grid-row-gap: 10px
    }

    .testimonialx {
        width: 49%
    }

    .text-block-377,
    .text-block-377.new {
        font-size: 52px
    }

    .tab-pane-tab-2-2,
    .tab-pane-tab-3-2 {
        flex: 1 1
    }

    .image-260 {
        flex: 0 1 auto;
        align-self: auto
    }

    .div-block-857 {
        width: 50%
    }

    .feature-block-item.yellow2,
    .feature-block-item.yellow2.green2 {
        justify-content: center;
        align-items: flex-start
    }

    .feature-block-content-logo {
        flex: 0 1 auto;
        order: 0;
        align-self: flex-end
    }

    .feature-text-header {
        text-align: left;
        flex-flow: column;
        flex: 0 1 auto;
        order: 0;
        align-self: stretch;
        margin-left: 0;
        padding-left: 0;
        display: block;
        position: static
    }

    .div-block-862 {
        width: 25%;
        padding-top: 2%
    }

    .div-block-863 {
        width: 75%
    }

    .tabs-menu-6 {
        width: 100%
    }

    .text-block-391 {
        font-size: 90px
    }

    .text-block-407 {
        font-size: 70px
    }

    .div-block-888.fold-2 {
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        flex-flow: column;
        justify-content: center;
        align-items: flex-start;
        width: 80%;
        display: flex
    }

    .image-270.fold-2 {
        height: 70px
    }

    .div-block-892 {
        background-position: 50%;
        background-size: cover
    }

    .div-block-892.fold-2 {
        margin-left: 0;
        margin-right: 0
    }

    .div-block-892.fold3 {
        background-position: 100% 100%;
        background-repeat: no-repeat;
        background-size: auto;
        margin-bottom: 0;
        padding-bottom: 148px
    }

    .div-block-892.fold3.fold4 {
        background-position: 50%;
        background-size: cover
    }

    .div-block-894 {
        justify-content: flex-start;
        align-items: flex-start
    }

    .div-block-895 {
        justify-content: flex-end;
        align-items: flex-start;
        display: flex
    }

    .image-271 {
        vertical-align: baseline;
        width: 55%;
        margin-top: 30px;
        margin-right: 30px
    }

    .text-block-409 {
        width: 60%;
        font-size: 24px
    }

    .text-block-410 {
        color: #ccc;
        margin-top: 60px;
        margin-bottom: 60px;
        font-size: 26px;
        font-weight: 400;
        line-height: 1.2
    }

    .button-53 {
        border-radius: 12px;
        padding-left: 50px;
        padding-right: 50px
    }

    .div-block-896 {
        justify-content: flex-start;
        align-items: center;
        height: 100%;
        padding-left: 53px;
        padding-right: 58px;
        display: flex
    }

    .text-block-413 {
        padding-left: 8px
    }

    .text-block-414 {
        padding-left: 9px
    }

    .div-block-901 {
        overflow: hidden
    }

    .div-block-904 {
        background-color: rgba(255, 255, 255, .38);
        height: 1px
    }
}

@media screen and (max-width:991px) {
    h1 {
        font-size: 60px
    }

    .wrapper-1300px {
        padding-left: 0;
        padding-right: 0
    }

    .wrapper-1300px.home-hero-flex {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column;
        align-items: center
    }

    .wrapper-1300px.for-about {
        grid-template-columns: 1fr
    }

    .nav-menu {
        background-color: #fff;
        height: auto;
        padding-bottom: 20px;
        padding-left: 4px;
        box-shadow: 0 100px 100px rgba(0, 0, 0, .1)
    }

    .navigation-right {
        flex: 0 1 auto;
        order: 0;
        display: block;
        position: absolute;
        top: 0%;
        bottom: auto;
        left: auto;
        right: 0%
    }

    .navigation-right.tab-visibility {
        flex-direction: column;
        align-items: flex-start;
        display: flex
    }

    .nav-link-register.hide {
        display: none
    }

    .navigation-left {
        padding-left: 20px;
        padding-right: 20px
    }

    .navigation-container {
        justify-content: flex-start;
        min-height: auto;
        padding-left: 20px;
        padding-right: 20px;
        position: relative
    }

    .brand {
        margin-right: 10px;
        padding: 0
    }

    .nav-link {
        color: var(--black)
    }

    .menu-button {
        color: #3f0a3d;
        border: 1px solid rgba(0, 0, 0, .1);
        border-radius: 100%
    }

    .menu-button.w--open {
        border-color: var(--pabloo-green);
        background-color: var(--pabloo-green)
    }

    .home-hero-content-wrapper {
        width: 100%
    }

    .home-hero-heading {
        font-size: 44px;
        line-height: 48px
    }

    .primary-button {
        padding: 20px
    }

    .primary-button.popup-form-button {
        padding-top: 16px;
        padding-bottom: 16px
    }

    .hollow-button {
        padding: 20px
    }

    .hollow-button.white-hollow-button:hover {
        color: var(--pabloo-green)
    }

    .hero-image-wrapper {
        width: 80%;
        max-width: none;
        margin-top: 5%;
        margin-left: 0;
        margin-right: auto
    }

    .cards-section.vertical-padding-large {
        flex-flow: column;
        margin-left: 37px;
        margin-right: 37px
    }

    .logo-wrapper-grid {
        flex-wrap: wrap;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        justify-content: center;
        display: flex
    }

    .logo-container {
        width: 17%;
        margin-bottom: 30px;
        margin-left: 20px;
        margin-right: 20px
    }

    .home-value-wrapper {
        flex-direction: column-reverse;
        padding-top: 100px;
        padding-bottom: 100px
    }

    .home-value-content-wrapper {
        width: 100%;
        margin-top: 20px
    }

    .home-value-image-container {
        width: 100%;
        max-width: 560px;
        height: auto;
        margin-top: 0
    }

    .value-image-wrapper-1,
    .value-image-wrapper-2,
    .value-image-wrapper-3 {
        display: none
    }

    .split-section-wrapper {
        flex-direction: column;
        align-items: center
    }

    .split-section-wrapper.reverse {
        flex-direction: column-reverse;
        align-items: center
    }

    .split-section-content-container {
        width: 100%;
        margin-top: 40px;
        margin-bottom: 10px
    }

    .split-section-content-container.split-2 {
        width: 100%;
        max-width: 520px
    }

    .split-section-content-container.max-width-520px {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto
    }

    .split-section-heading.max-width-520px {
        max-width: none
    }

    .split-pointer-text {
        max-width: 540px
    }

    .blue-button {
        padding: 20px
    }

    .split-image-wrapper {
        width: 100%;
        max-width: 620px;
        margin-top: 40px
    }

    .split-image-wrapper-2 {
        width: 100%;
        height: 450px;
        margin-bottom: 5%;
        margin-right: 0%
    }

    .split-image-wrapper-2.split-image-wrapper-3 {
        height: 500px
    }

    .work-head-wrapper.slack-steps-header-wrapper {
        margin-bottom: 32px
    }

    .home-work-slide-wrapper.slack-steps-wrapper {
        flex-wrap: wrap
    }

    .work-slide-container.slack-step-container {
        margin-top: 8px;
        margin-bottom: 8px
    }

    .review-slide {
        padding-bottom: 103px
    }

    .review-slider-text {
        font-size: 20px
    }

    .home-pointers-split-wrapper {
        flex-direction: column;
        align-items: center
    }

    .home-pointers-image-wrapper {
        width: 80%;
        margin-bottom: 5%;
        margin-right: 0%
    }

    .home-pointer-split-content-wrapper {
        width: 100%
    }

    .pitch-heading {
        margin-bottom: 56px
    }

    .pitch-illustration-wrapper {
        flex-direction: row;
        justify-content: center
    }

    .pitch-brach-wrapper {
        width: 8%;
        margin-right: 20px;
        transform: rotate(0)
    }

    .pitch-brach-wrapper.persona {
        width: 8%;
        max-width: 60.0469px;
        margin-right: 0
    }

    .brach-image {
        display: none
    }

    .brach-image.branch-image-vertical {
        object-fit: contain;
        width: 100%;
        display: inline-block
    }

    .branch-card-wrapper {
        flex-flow: column wrap;
        grid-template-rows: auto auto auto auto;
        grid-template-columns: 1fr;
        width: auto
    }

    .branch-card-wrapper.branch-persona {
        z-index: 10;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr;
        position: relative
    }

    .branch-card-wrapper.three-columns {
        grid-template-columns: 1fr
    }

    .pitch-main-card.bottom-block.mobile {
        display: block
    }

    .pitch-main-card.bottom-block.bottom {
        display: none
    }

    .pitch-card-content-wrapper.persona {
        max-width: 300px
    }

    .pitch-card-content-wrapper.persona.full {
        max-width: 100%
    }

    .home-support-section {
        background-position: 70%
    }

    .cta-section {
        background-position: 50% 0
    }

    .cta-split-wrapper {
        flex-direction: column-reverse;
        align-items: center;
        padding-top: 100px;
        padding-bottom: 100px
    }

    .cta-split-content-wrapper {
        width: 100%;
        margin-top: 6%;
        padding-top: 0;
        padding-bottom: 0
    }

    .cta-split-content-wrapper.persona {
        width: 100%;
        padding-top: 0
    }

    .white-alter-span.white {
        font-size: 52px
    }

    .cta-image-wrapper {
        width: 100%
    }

    .copyright-text,
    .footer-down-link {
        font-size: 16px
    }

    .pricing-heading {
        font-size: 44px
    }

    .auto-slider-arrow-left {
        bottom: 10%;
        right: 20%
    }

    .auto-slider-arrow-right {
        bottom: 10%
    }

    .contact-hero-wrapper {
        flex-direction: column;
        margin-top: 138px
    }

    .contact-hero-text-wrapper {
        width: 100%
    }

    .blog-hero-heading {
        font-size: 55px;
        line-height: 54px
    }

    .wrapper-1080px {
        width: 75%
    }

    .blog-feature-block {
        grid-column-gap: 20px
    }

    .blog-feature-block.guide {
        grid-template-columns: 1fr
    }

    .blog-feature-image-container {
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .blog-feature-image {
        text-align: center;
        object-fit: contain;
        width: 50%
    }

    .blog-feature-heading {
        font-size: 25px
    }

    .blog-feature-para {
        font-size: 18px
    }

    .blog-collection-list {
        grid-column-gap: 20px
    }

    .home-value-bg-image-wrap {
        width: 100%;
        max-width: none;
        height: 530px;
        display: none;
        top: auto;
        bottom: 0%;
        left: 0%;
        right: 0%
    }

    .home-value-bg-image {
        object-fit: contain
    }

    .home-slider-image-1,
    .home-slider-image-2 {
        width: 40%
    }

    .value-image-wrapper-4 {
        display: block
    }

    .pricing-hero-table {
        flex-direction: column
    }

    .pricing-table-left,
    .pricing-table-right {
        width: 100%
    }

    .black-button {
        padding: 20px
    }

    .wrapper-1280px {
        flex-direction: column;
        max-width: 600px
    }

    .wrapper-1280px.popup-div {
        max-width: 1000px;
        padding-top: 100px
    }

    .wrapper-1280px.discover-new-product-flex {
        flex-direction: column-reverse;
        padding-top: 50px
    }

    .wrapper-1280px.discover-purchase-flex {
        flex-direction: column-reverse
    }

    .wrapper-1280px.case-study-hero-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px.track-approval-flex {
        flex-direction: column-reverse
    }

    .wrapper-1280px.workflow-approval-flex {
        flex-direction: column;
        padding-top: 30px
    }

    .wrapper-1280px.document-one-place-flex {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column-reverse
    }

    .wrapper-1280px.assisted-tools-flex,
    .wrapper-1280px.actionable-insight-flex,
    .wrapper-1280px.contract-renewals-flex {
        flex-direction: column-reverse
    }

    .wrapper-1280px.points-container {
        max-width: 660px
    }

    .html-embed-calendly {
        width: 100%
    }

    .popup-close {
        margin-right: 0;
        top: 40px;
        right: 0%
    }

    .home-work-heading-2.slack-steps-heading {
        color: var(--black)
    }

    .blog-feature-item {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        grid-template-columns: 1fr;
        align-items: stretch
    }

    .popup-container {
        width: 80%
    }

    .popup-heading {
        font-size: 40px
    }

    .popup-split-block.block-down {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .about-head-container {
        margin-top: 62px
    }

    .about-hero-text-contain {
        width: 90%
    }

    .team-grid {
        grid-column-gap: 58px;
        grid-row-gap: 58px;
        flex-wrap: wrap;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        justify-content: center;
        display: grid
    }

    .team-grid.speakers-grid-webinar {
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr
    }

    .team-member-wrap {
        flex: 33% 1
    }

    .member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller.pb-0 {
        max-width: 200px;
        max-height: 200px
    }

    .career-wrapper {
        flex-direction: column
    }

    .career-left-wrap {
        width: 100%;
        margin-bottom: 60px;
        position: static
    }

    .career-right-wrap {
        width: 100%;
        margin-left: auto;
        margin-right: auto
    }

    .about-slide {
        margin-right: 40px
    }

    .background-image {
        opacity: .6;
        max-width: none
    }

    .persona-hero-card {
        flex-direction: column;
        height: auto;
        padding: 60px 50px
    }

    .persona-hero-card-image {
        border-radius: 8px;
        flex: none;
        width: 100%;
        height: auto;
        overflow: hidden
    }

    .persona-hero-card-text {
        width: 100%;
        margin-bottom: 40px;
        margin-left: 0;
        margin-right: 0%
    }

    .persona-card-text {
        margin-top: 10px
    }

    .solution-text-container {
        width: 100%;
        margin-bottom: 40px;
        margin-right: 0%
    }

    .persona-solution-pointers-wrap {
        width: 100%;
        max-width: 560px
    }

    .persona-split-section-heading {
        font-size: 40px
    }

    .split-container.split-top-padding-0,
    .split-container.split-inverse {
        flex-direction: column-reverse
    }

    .persona-split-text-container {
        width: 100%;
        max-width: none;
        margin-top: 60px;
        margin-right: 0%
    }

    .persona-split-text-container.procurement-2-text {
        width: 100%;
        margin-left: 0%
    }

    .persona-split-text-container.it {
        width: 100%
    }

    .persona-split-text {
        font-size: 42px
    }

    .persona-split-para {
        max-width: none
    }

    .persona-split-image-container {
        width: 90%;
        margin-right: 0
    }

    .finance-heading {
        font-size: 44px
    }

    .finance-grid {
        grid-template-columns: 1fr
    }

    .finance-grid-item {
        max-width: 340px;
        font-size: 18px
    }

    .dropdown-list.w--open {
        margin-top: 0;
        padding-top: 0;
        position: relative;
        left: 0
    }

    .persona-dropdown-wrap {
        box-shadow: none;
        width: auto;
        padding-top: 0;
        padding-bottom: 0
    }

    .persona-dropdown-wrap.product {
        width: auto
    }

    .persona-dropdown-link {
        max-width: 350px
    }

    .persona-triangle {
        display: none
    }

    .dropdown {
        width: 100%;
        margin-left: auto;
        margin-right: auto
    }

    .together-image-container {
        width: 100%;
        margin-bottom: 60px
    }

    .together-text-container {
        width: 100%
    }

    .together-blue-heading {
        font-size: 50px;
        line-height: 100%
    }

    .together-blue-paragraph-18px {
        line-height: 150%
    }

    .discover-product-hero-bg {
        height: 85%
    }

    .discover-product-hero-heading {
        line-height: 100%
    }

    .discover-hero-paragraph {
        line-height: 150%
    }

    .discover-hero-pointer {
        line-height: 160%
    }

    .discover-hero-pink-text {
        line-height: 150%
    }

    .discover-hero-circle-image {
        width: 40%
    }

    .discover-hero-circle-image.left,
    .discover-hero-circle-image.right {
        bottom: 15%
    }

    .new-product-text-container {
        width: 100%
    }

    .new-product-image-container {
        width: 100%;
        margin-bottom: 80px
    }

    .new-product-heading-44px {
        line-height: 100%
    }

    .new-product-paragraph-18px {
        line-height: 150%
    }

    .purchase-text-container {
        width: 100%
    }

    .purchase-image-container {
        width: 100%;
        margin-bottom: 80px
    }

    .tools-text-container,
    .tools-text-container.max-width-500px {
        width: 100%
    }

    .tools-image-container {
        width: 100%;
        max-width: 550px;
        margin-bottom: 80px
    }

    .procurement-upper-container {
        flex-direction: column;
        align-items: center
    }

    .procurement-paragraph-18px {
        line-height: 150%
    }

    .procurement-heading-wrapper {
        width: 100%;
        margin-bottom: 60px;
        margin-right: 0%
    }

    .procurement-grid {
        grid-column-gap: 30px;
        grid-row-gap: 40px;
        grid-template-columns: 1fr 1fr
    }

    .procurement-item {
        padding-left: 20px;
        padding-right: 20px
    }

    .procurement-heading-24px {
        margin-bottom: 4px;
        line-height: 150%
    }

    .procurement-item-text-18px {
        line-height: 150%
    }

    .case-study-hero-text-container {
        width: 100%
    }

    .case-study-hero-image-container {
        width: 90vw;
        margin-top: 60px
    }
    .case-study-hero-image {
        width: 90vw;
        height: 90vw;
        width: 500px;
        object-fit: cover;
        object-position: "center",

    }

    .case-study-hero-heading {
        font-size: 50px;
        line-height: 100%
    }

    .case-study-hero-pink-text {
        line-height: 140%
    }

    .case-study-grid {
        grid-template-columns: 1fr;
        justify-items: center
    }

    .case-study-item-wrapper {
        padding: 20px 20px 24px
    }

    .case-study-item-pink-tag {
        line-height: 140%
    }

    .case-study-item-heading {
        line-height: 120%
    }

    .case-study-item-para-small {
        line-height: 140%
    }

    .track-approval-text-container {
        width: 100%;
        margin-top: 60px
    }

    .track-appoval-image-container {
        width: 100%
    }

    .track-approval-item-absolute {
        right: -5%
    }

    .multi-channel-image-container {
        width: 100%
    }

    .multi-channel-text-container {
        width: 100%;
        margin-top: 100px
    }

    .workflow-approval-text-wrapper {
        width: 100%;
        margin-bottom: 60px;
        position: relative;
        top: 0
    }

    .workflow-approval-image-wrapper {
        width: 100%
    }

    .fast-track-approval-h1-heading {
        line-height: 100%
    }

    .fast-track-hero-image-wrapper.track-usage {
        width: 70%;
        margin-bottom: -60px
    }

    .fast-track-hero-circle-wrapper.left,
    .fast-track-hero-circle-wrapper.right {
        width: 40%
    }

    .fast-track-hero-user-element {
        width: 18%
    }

    .fast-track-hero-user-element._1 {
        left: 20%
    }

    .fast-track-hero-user-element._2 {
        bottom: 15%;
        left: 5%
    }

    .fast-track-hero-user-element._3 {
        top: 0%;
        right: 10%
    }

    .fast-track-hero-user-element._5 {
        bottom: 5%
    }

    .dropdown-grid {
        grid-column-gap: 40px
    }

    .footer-top-wrapper {
        flex-direction: column;
        align-items: flex-start
    }

    .footer-grid {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        width: 100%;
        max-width: none;
        padding-top: 0
    }

    .footer-left-contain {
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 60px
    }

    .split-section-form-wrapper {
        padding: 10px
    }

    .review-slide-2 {
        padding-bottom: 103px
    }

    .doc-one-place-text-container,
    .doc-one-place-image-container {
        width: 100%
    }

    .best-deals-text-container {
        width: 100%;
        margin-top: 80px
    }

    .assisted-tools-text-container {
        width: 100%;
        margin-top: 60px
    }

    .assisted-tools-image-container {
        width: 100%
    }

    .assisted-purchasing-hero-wrapper {
        margin-top: 41px
    }

    .assisted-purchasing-hero-wrapper.insights {
        margin-top: 84px;
        margin-bottom: 60px
    }

    .assisted-hero-item-wrapper.left {
        justify-content: flex-start;
        width: 380px;
        bottom: 220px
    }

    .assisted-hero-item-wrapper.right {
        justify-content: flex-end;
        width: 380px;
        bottom: 220px
    }

    .assisted-hero-office-icon {
        width: 15%;
        top: 0%;
        left: 5%
    }

    .assisted-hero-bird-icon {
        width: 15%;
        left: 3%
    }

    .assisted-hero-p-icon {
        width: 15%;
        left: 10%
    }

    .assisted-hero-droupbox-icon {
        width: 18%
    }

    .assisted-hero-z-icon {
        width: 15%;
        right: 5%
    }

    .assisted-hero-gmail-icon {
        width: 15%;
        top: 35%;
        left: 70%
    }

    .actionable-insight-text-wrap {
        width: 100%;
        margin-top: 80px
    }

    .actionable-insight-image-wrap {
        width: 100%;
        max-width: 550px
    }

    .insight-hero-section.track-usage {
        margin-bottom: 180px
    }

    .investor-logo.investor-logo-rt-demo-custo-styles {
        width: 24%
    }

    .press-card-image-wrapper {
        height: 400px
    }

    .insights-hero-image-3 {
        width: 30%
    }

    .contract-renewal-image-wrap,
    .contract-document-image-wrap {
        width: 100%
    }

    .contract-hero-item-wrap.left {
        bottom: 2%;
        left: 0
    }

    .contract-hero-item-wrap.right {
        bottom: 2%;
        right: 0
    }

    .contract-hero-logo-item._2 {
        bottom: 15%;
        left: 10%
    }

    .contract-hero-logo-item._1 {
        top: -20px;
        left: 10px
    }

    .contract-hero-logo-item._4 {
        right: 10%
    }

    .contract-hero-logo-item._5 {
        right: 80px
    }

    .contract-hero-logo-item._6 {
        bottom: 15%
    }

    .hero-subheading {
        line-height: 150%
    }

    .hero-head-container {
        width: 100%
    }

    .hero-heading {
        line-height: 100%
    }

    .home-hero-image-wrapper {
        width: 100%
    }

    .usp-icon {
        width: 24px
    }

    .column {
        margin-top: 4%
    }

    .paragraph-2 {
        font-size: 14px;
        line-height: 20px
    }

    .div-block {
        margin-top: 0%
    }

    .heading-2 {
        font-size: 32px;
        line-height: 40px
    }

    .heading {
        font-size: 40px
    }

    .div-block-2 {
        max-width: 520px;
        padding-bottom: 24px
    }

    .container-3 {
        max-width: 80%;
        margin-top: 0%
    }

    .div-block-10 {
        margin-top: 0%
    }

    .grid-2 {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .text-block-6 {
        font-size: 20px;
        line-height: 36px
    }

    .text-block-6.social {
        width: 100%
    }

    .div-block-18 {
        padding-top: 0%
    }

    .heading-5 {
        font-size: 48px;
        line-height: 56px
    }

    .div-block-19 {
        font-size: 18px
    }

    .div-block-20 {
        margin-top: 40px;
        padding-top: 0%;
        padding-bottom: 4%
    }

    .container-4 {
        max-width: 100%
    }

    .div-block-23.alt-badge {
        align-items: center;
        margin-left: 8px;
        padding: 0 16px;
        display: flex
    }

    .text-block-10 {
        font-size: 16px;
        line-height: 16px
    }

    .text-block-11 {
        color: var(--black)
    }

    .div-block-24 {
        margin-top: 32px
    }

    .div-block-25 {
        margin-top: 8px
    }

    .div-block-27 {
        top: -64px;
        right: 0
    }

    .div-block-28 {
        padding-left: 24px;
        padding-right: 24px
    }

    .div-block-29 {
        background-color: var(--white);
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        min-height: auto;
        padding-top: 0;
        padding-bottom: 56px
    }

    .bestsuited-webinarblock {
        min-height: auto;
        padding-top: 56px;
        padding-bottom: 56px
    }

    .div-block-33 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        justify-content: space-around;
        display: grid
    }

    .grid-3.m-l-24 {
        width: 100%;
        margin-left: 0
    }

    .div-block-35 {
        min-height: auto;
        margin-top: 0;
        padding-top: 0;
        padding-bottom: 56px
    }

    .div-block-36 {
        background-size: cover;
        padding-top: 0;
        padding-bottom: 0
    }

    .div-block-36.pink {
        padding-top: 0;
        padding-bottom: 0
    }

    .div-block-38 {
        background-color: transparent;
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        border-bottom-right-radius: 64px;
        padding: 50px
    }

    .div-block-39 {
        justify-content: flex-start;
        margin-top: 0;
        padding-right: 0
    }

    .div-block-40 {
        height: auto;
        margin-top: 0;
        padding-top: 56px;
        padding-bottom: 56px
    }

    .container-5 {
        padding-top: 0;
        padding-bottom: 0
    }

    .div-block-41 {
        margin-top: 24px
    }

    .image-7 {
        position: static
    }

    .text-block-22 {
        color: var(--black)
    }

    .columns-2 {
        flex-direction: column-reverse;
        justify-content: flex-start;
        align-items: stretch;
        display: flex
    }

    .column-6 {
        padding-top: 0%;
        padding-left: 20px;
        padding-right: 20px
    }

    .div-block-52 {
        top: -12%
    }

    .image-11,
    .image-12 {
        display: none
    }

    .ebook-hero-points-short {
        align-items: flex-end
    }

    .div-block-61.white.p-t-40 {
        padding-top: 20px
    }

    .columns-4 {
        display: block
    }

    .div-block-65 {
        display: none
    }

    .button-6 {
        display: inline-block
    }

    .auto-slider-arrow-left-2 {
        bottom: 10%;
        right: 20%
    }

    .review-slider-text-2 {
        font-size: 20px
    }

    .header-grid {
        grid-template-columns: 1fr
    }

    .header-content {
        flex-direction: column;
        display: flex
    }

    .feature-grid-large {
        grid-template-columns: 1fr 1fr
    }

    .authors-wrapper {
        flex-wrap: wrap;
        width: 100%
    }

    .company-logo-2 {
        margin: 15px
    }

    .header-grid-3 {
        grid-template-columns: 1fr
    }

    .header-section-3 {
        padding-top: 60px
    }

    .line-break {
        display: none
    }

    .process-title-wrap {
        max-width: 600px;
        margin-bottom: 100px
    }

    .process-grid {
        grid-column-gap: 32px;
        grid-row-gap: 60px;
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        grid-template-columns: 1fr;
        max-width: 450px;
        margin-left: auto;
        margin-right: auto
    }

    .features-wrap {
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: stretch
    }

    .features-grid {
        grid-column-gap: 24px;
        max-width: 100%;
        margin-right: 0
    }

    .features-heading-wrap {
        max-width: 600px;
        margin-bottom: 60px
    }

    .integration {
        min-width: 210px
    }

    .bloom-image-effect-2 {
        min-width: 100%
    }

    .image-cover.not-in-mobile {
        object-fit: contain
    }

    .div-block-126 {
        width: 88%
    }

    .cta-image-2 {
        opacity: .5
    }

    .grid-two-column-2 {
        grid-template-columns: 1fr
    }

    .heading-wrapper {
        margin-top: 36px
    }

    .grid-three-column {
        grid-template-columns: 1fr 1fr
    }

    .testimoial-container {
        flex-direction: column-reverse;
        flex: 0 1 auto;
        align-items: center;
        margin-top: 100px;
        margin-bottom: 140px;
        margin-right: 0%
    }

    .d-128-3d-card-wrapper {
        margin-bottom: 60px
    }

    .grid-cta {
        grid-template-columns: 1fr
    }

    .testimonial-section-2 {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .flex-wrapper-centre-3.margin-bottom-48.custo {
        max-width: 100%
    }

    .grid-four-column {
        grid-template-columns: 1fr 1fr
    }

    .grid-team-slider {
        grid-template-columns: 1fr
    }

    .title-wrapper-regular.custo {
        margin-left: 0
    }

    .testimonial-content-wrapper {
        min-height: 340px;
        padding-top: 0
    }

    .div-block-169 {
        width: 30%
    }

    .image-43,
    .image-44 {
        max-width: 30%
    }

    .navigation-wrapper {
        align-items: center;
        width: auto;
        display: flex
    }

    .navigation-3 {
        position: relative
    }

    .navigation-avatar-wrapper {
        margin-right: 14px
    }

    .logo-link-large {
        margin-right: 0
    }

    .menu-button-5 {
        color: #393b6a;
        border: 1px solid #f3f5fb;
        border-radius: 8px;
        padding: 12px
    }

    .menu-button-5.w--open {
        background-color: #160042;
        border-color: #fff
    }

    .navigation-menu-2 {
        color: #393b6a;
        background-color: #fff;
        border-radius: 8px;
        padding: 12px;
        position: absolute
    }

    .navigation-menu-2.w--open {
        background-color: #282556;
        border-color: #fff
    }

    .feature-grid-2 {
        grid-template-columns: 1fr 1fr
    }

    .process-title-wrap-2 {
        max-width: 600px;
        margin-bottom: 100px
    }

    .process-grid-2 {
        grid-column-gap: 32px;
        grid-row-gap: 60px;
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        grid-template-columns: 1fr;
        max-width: 450px;
        margin-left: auto;
        margin-right: auto
    }

    .process-section-2 {
        padding-top: 37px;
        padding-bottom: 37px
    }

    .header-featured-wrap.contact {
        width: 100%;
        padding-right: 0;
        position: static;
        top: auto
    }

    .sticky-wrapper {
        height: auto
    }

    .contact-us-wrapper {
        flex-direction: column;
        height: auto
    }

    .sec-bk {
        padding-bottom: 16vh
    }

    .sec-bk.p-b-32.xx {
        height: auto;
        padding-bottom: 10vh
    }

    .social-media-icons {
        display: none
    }

    .big-container {
        width: auto;
        padding-left: 0
    }

    .sub-header-img.contact-us {
        width: 100%;
        height: auto;
        position: relative;
        top: 0
    }

    .sub-header-img.contact-us.hide-desktop {
        display: block
    }

    .process-graphic {
        margin-left: auto;
        margin-right: auto
    }

    .process-block-2 {
        flex-direction: column;
        align-items: flex-start
    }

    .column-72 {
        display: none
    }

    .shows-archive {
        grid-column-gap: 40px;
        grid-row-gap: 16px;
        grid-template-rows: auto;
        grid-template-columns: 1fr;
        grid-auto-columns: 1fr;
        justify-content: space-between;
        align-items: stretch;
        display: grid
    }

    .intro {
        padding-top: 113px;
        padding-bottom: 113px
    }

    .side-pattern {
        left: -20%
    }

    .grid-feature-wrapper {
        grid-template-columns: 1fr
    }

    .grid-features {
        grid-template-columns: 1fr 1fr
    }

    .faq-grid-3 {
        grid-column-gap: 60px
    }

    .content-grid-2 {
        grid-column-gap: 62px;
        grid-row-gap: 62px
    }

    .feature-grid-4,
    .a-testimonial-slider-grid {
        grid-template-columns: 1fr
    }

    .content-grid-3 {
        grid-template-columns: 1fr;
        justify-items: center
    }

    .header-grid-5 {
        grid-template-columns: 1fr
    }

    .header-section-6 {
        padding-top: 60px
    }

    .image-67 {
        height: 42px
    }

    .grid,
    .step-grid {
        grid-template-columns: 1fr 1fr
    }

    .home-section,
    .slider-section {
        padding-top: 90px
    }

    .slider-title {
        width: 90%;
        max-width: 1300px
    }

    .tab-button-desc-wrapper {
        overflow: hidden
    }

    .b-navigation-title-block {
        display: none
    }

    .navigation-dropdown {
        width: 100%
    }

    .navigation-link-block {
        padding: 24px
    }

    .navigation-list.w--open {
        border-bottom: 4px solid #1a1a1a;
        height: 420px;
        position: static;
        overflow: visible
    }

    .navigation-link-3 {
        width: 100%
    }

    .navigation-grid-2 {
        grid-template-columns: 1fr
    }

    .navigation-dropdown-base {
        box-shadow: none
    }

    .b-navigation-base {
        padding: 0
    }

    .tab-mobile-img {
        margin-top: 16px;
        display: block
    }

    .tabs-menu-3 {
        width: 100%;
        margin-bottom: 48px;
        margin-right: 0%
    }

    .navigation-toggle-3 {
        justify-content: flex-start;
        width: 100%
    }

    .navigation-toggle-3.w--open {
        color: #160042;
        background-color: #f7f9fd;
        width: 100%
    }

    .tabs-content-2 {
        width: 100%;
        display: none
    }

    .tab-component {
        flex-direction: column
    }

    .div-block-320 {
        justify-content: flex-start;
        align-items: center;
        margin-left: 0
    }

    .div-block-320.new {
        justify-content: center;
        align-items: center;
        margin-left: auto
    }

    .nav-link-register-2.hide {
        display: none
    }

    .persona-dropdown-wrap-2 {
        box-shadow: none;
        width: auto;
        padding-top: 0;
        padding-bottom: 0
    }

    .persona-dropdown-wrap-2.product {
        width: auto
    }

    .menu-button-7 {
        color: #3f0a3d;
        border: 1px solid rgba(0, 0, 0, .1);
        border-radius: 100%
    }

    .menu-button-7.w--open {
        background-color: #d53987;
        border-color: #d53987
    }

    .nav-link-5 {
        color: #000
    }

    .div-block-333 {
        margin-left: 0%;
        margin-right: 0%
    }

    .b-navigation-base-2 {
        padding: 0
    }

    .split-image-wrapper-3 {
        width: 100%;
        max-width: 620px;
        margin-top: 40px
    }

    .navigation-toggle-4 {
        justify-content: flex-start;
        width: 100%
    }

    .navigation-toggle-4.w--open {
        color: #160042;
        background-color: #f7f9fd;
        width: 100%
    }

    .navigation-grid-3 {
        grid-template-columns: 1fr
    }

    .auto-slider-arrow-left-3 {
        bottom: 10%;
        right: 20%
    }

    .wrapper-1300px-3 {
        padding-left: 0;
        padding-right: 0
    }

    .hover-block__text {
        width: 80%
    }

    .review-slide-3 {
        padding-bottom: 103px
    }

    .navigation-list-2.w--open {
        border-bottom: 4px solid #1a1a1a;
        height: 420px;
        position: static;
        overflow: visible
    }

    .hollow-button-3 {
        padding: 20px
    }

    .review-slider-text-4 {
        font-size: 20px
    }

    .home-slider-image-4 {
        width: 40%
    }

    .navigation-dropdown-base-3 {
        box-shadow: none
    }

    .navigation-6 {
        position: relative
    }

    .menu-button-10 {
        color: #393b6a;
        border: 1px solid #f3f5fb;
        border-radius: 8px;
        padding: 12px
    }

    .menu-button-10.w--open {
        background-color: #160042;
        border-color: #fff
    }

    .navigation-menu-6 {
        color: #393b6a;
        background-color: #fff;
        border-radius: 8px;
        padding: 12px;
        position: absolute
    }

    .navigation-menu-6.w--open {
        background-color: #282556;
        border-color: #fff
    }

    .navigation-link-6 {
        width: 100%
    }

    .hollow-button-4 {
        padding: 20px
    }

    .home-slider-image-5,
    .home-slider-image-6 {
        width: 40%
    }

    .div-block-478 {
        grid-template-columns: 1fr
    }

    .image-158 {
        width: 64%;
        margin-left: auto;
        margin-right: auto
    }

    .features-grid-3 {
        grid-row-gap: 30px;
        grid-template-columns: 1fr
    }

    .features-grid-4 {
        grid-row-gap: 30px;
        grid-template-columns: 1fr 1fr
    }

    .div-block-501 {
        justify-content: center;
        display: flex
    }

    .div-block-502 {
        padding-left: 0;
        padding-right: 0
    }

    .paragraph-117.sub {
        font-size: 14px
    }

    .div-block-598 {
        justify-content: space-between
    }

    .webinar-cta.pink-border.pink-text {
        margin-top: 22px
    }

    .container-1285 {
        padding-left: 31px;
        padding-right: 31px
    }

    .banner-cta-blog {
        width: 400px
    }

    .image-203 {
        width: 100px
    }

    .div-block-665 {
        flex-direction: column
    }

    .link-button-copy2 {
        border-style: none;
        align-self: center;
        width: 210px;
        margin-bottom: 40px;
        margin-left: 0;
        margin-right: 0;
        padding-left: 2px;
        left: 0
    }

    .div-block-666 {
        align-self: center
    }

    .case-study-hero-heading-2 {
        font-size: 50px;
        line-height: 100%
    }

    .navigation-link-10 {
        width: 100%
    }


    .colors-grid {
        grid-template-columns: 1fr 1fr 1fr 1fr
    }

    .heading-64px {
        font-size: 56px
    }

    .heading-64px.hero-home-heading {
        font-size: 64px
    }

    .heading-64px.hero-home-heading.top {
        display: block
    }

    .heading-64px.text-align-center.integra {
        font-size: 28px
    }

    .heading-90px {
        font-size: 72px
    }

    .heading-56px {
        font-size: 46px
    }

    .heading-48px {
        font-size: 42px
    }

    .heading-40px {
        font-size: 36px
    }

    .navigation-bar {
        top: 0
    }

    .navbar-container {
        position: static
    }

    .navigation-menu {
        background-color: var(--transparent);
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        position: absolute;
        overflow: visible
    }

    .navigation-menu.new {
        margin-right: auto
    }

    .navigation-menu.new.optimize {
        background-color: rgba(255, 255, 255, 0)
    }

    .nav-links-contain {
        grid-row-gap: 0px;
        background-color: var(--soft-pink);
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
        flex-direction: column;
        align-items: flex-start;
        width: 90%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
        padding: 0px 16px 24px;
        position: relative;
        overflow: visible;
        box-shadow: 0px 46px 29px 25px rgba(8, 9, 10, .1),0px 100px 27px -3px rgba(8, 9, 10, .1);
    }

    .nav-links-contain.new.adpage {
        background-color: var(--soft-pink);
        width: 100%;
        height: auto;
        margin-right: 0;
        box-shadow: 0 12px 20px -8px rgba(0, 0, 0, .2)
    }

    .navigation-link {
        margin-left: 0;
        font-family: Satoshi, sans-serif;
        /*font-size: 18px*/
    }

    .navigation-link.login {
        display: none
    }

    .navigation-link.white {
        color: var(--black)
    }

    .navbar-dropdown {
        width: 100%;
        margin-left: 0
    }

    .navbar-dropdown-toggle {
        justify-content: space-between;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .dropdown-lists {
        display: none
    }

    .dropdown-lists.w--open {
        box-shadow: none;
        border-radius: 0;
        padding-top: 0;
        display: none;
        position: static;
        left: 0
    }

    .dropdown-links-contain {
        box-shadow: none;
        border-radius: 0
    }

    .dropdown-links-contain.w--open {
        box-shadow: none;
        border-left: 1px solid rgba(28, 28, 31, .1);
        border-radius: 0
    }

    .dropdown-links-contain.product {
        background-color: rgba(255, 255, 255, 0);
        width: auto;
        padding-top: 0;
        padding-left: 0;
        padding-right: 0;
        display: flex
    }

    .dropdown-links-contain.solutions {
        background-color: rgba(255, 255, 255, 0);
        width: auto;
        padding: 0 0 24px
    }

    .dropdown-links-contain.resources {
        background-color: var(--transparent);
        width: auto;
        padding: 0
    }

    .dropdown-arrow-embed {
        width: 16px;
        height: 16px
    }

    .dropdown-arrow-embed.mobile {
        width: 14px;
        height: 24px;
        display: block
    }

    .dropdown-arrow-embed.desktop {
        display: none
    }

    .navigation-button-contain {
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        margin-left: auto;
        margin-right: 16px
    }

    .navigation-button-contain.in-menu {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        flex-direction: column;
        width: 100%;
        margin-top: 0px;
        margin-left: 0;
        margin-right: 0;
        display: flex
    }

    .navigation-button-contain.in-menu.bottom {
        margin-top: auto;
        padding-top: 24px
    }

    .navigation-button-contain.in-menu.bottom.new {
        padding-top: 10px
    }

    .hero-home-wrapper {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column;
        align-items: center;
        display: flex
    }

    .hero-home-wrapper.new {
        padding-top: 180px
    }

    .transparent-arrow-button._16px.navigation {
        padding-top: 16px;
        padding-bottom: 16px
    }

    .transparent-arrow-button._16px.navigation.login {
        width: 100%
    }

    .button-arrow-embed.menu {
        width: 14px;
        height: 16px
    }

    .hero-home-text-wrapper {
        width: 100%;
        margin-top: 44px;
        padding-right: 0
    }

    .hero-home-text-wrapper.new {
        justify-content: space-between;
        align-items: center
    }

    .paragraph-18px.hero-home-paragraph {
        padding-right: 0
    }

    .paragraph-18px.hero-home-paragraph.new {
        width: 90%
    }

    .paragraph-18px.navbar-dropdown-text {
        font-family: Satoshi, sans-serif
    }

    .paragraph-18px.callout-link-heading {
        color: var(--dark-violet);
        font-family: Satoshi, sans-serif;
        font-weight: 700
    }

    .pink-arrow-button._16px {
        font-size: 16px
    }

    .pink-arrow-button._16px.navigation,
    .pink-arrow-button.ebook {
        width: 100%
    }

    .stats-section {
        padding-top: 44px
    }

    .stats-wrapper {
        margin-top: 24px;
        padding-top: 25px
    }

    .stats-grid {
        grid-template-columns: 1fr 1fr;
        margin-top: 35px
    }

    .heading-24px {
        font-size: 22px
    }

    .logo-tain-image {
        box-sizing: border-box
    }

    .type-cards-grid {
        grid-template-columns: 1fr;
        max-width: 640px
    }

    .heading-28px {
        font-size: 24px
    }

    .collection-list-7 {
        grid-template-columns: 1fr
    }

    .arrow-text-link.menu {
        font-family: Satoshi, sans-serif;
        font-weight: 700
    }

    .integrations-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column-reverse;
        padding-top: 120px
    }

    .integrations-wrapper.saas {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        flex-direction: column
    }

    .integrations-wrapper.cloud {
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        flex-direction: column
    }

    .integrations-text-wrapper,
    .integrations-image-contain {
        width: 100%
    }

    .calculator-container {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column;
        align-items: center;
        padding-top: 80px;
        padding-bottom: 80px
    }

    .calculator-left {
        text-align: center;
        align-items: center;
        width: 100%
    }

    .calc-arrow-image {
        display: none
    }

    .stack-tab-link {
        min-width: 180px
    }

    .stack-tab-link-header {
        padding-left: 12px;
        padding-right: 12px
    }

    .paragraph-20px.stack-tab-link-text {
        font-size: 18px
    }

    .stack-blocks-grid {
        grid-template-columns: 1fr
    }

    .stack-block-image-contain.a-first {
        max-width: 600px
    }

    .blogs-wrapper {
        padding-bottom: 120px
    }

    .blogs-collection-list {
        grid-template-columns: 1fr
    }

    .blogs-collection-list._3-column-grid {
        grid-row-gap: 40px;
        grid-template-columns: 1fr 1fr
    }

    .blog-post-wrapper.featured {
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        flex-direction: column-reverse
    }

    .blog-post-wrapper.load-list:hover {
        padding: 0
    }

    .blog-post-image-wrapper.featured.blog-page,
    .blog-post-image-wrapper.featured.cms {
        width: 100%;
        height: 360px
    }

    .blog-post-image-wrapper.featured.resources-hero {
        height: 300px
    }

    .blog-post-info-wrapper.featured,
    .blog-post-info-wrapper.cms {
        width: 100%
    }

    .paragraph-16px.dropdown-block-link-text {
        text-align: left
    }

    .paragraph-16px.dropdown-block-link-text.auto {
        margin-left: auto
    }

    .paragraph-16px.navigation-subheading.mobile {
        text-align: left;
        letter-spacing: normal;
        text-transform: none;
        padding-top: 18px;
        padding-bottom: 18px;
        font-size: 18px;
        font-weight: 500
    }

    .paragraph-16px.dropdown-block-link-description {
        text-align: left;
        font-family: Inter, sans-serif;
        font-size: 14px
    }

    .paragraph-16px.dropdown-block-link-heading {
        font-weight: 500
    }

    .heading-32px {
        font-size: 28px
    }

    .ctas-container {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column
    }

    .ctas-text-wrapper,
    .ctas-text-wrapper._50 {
        width: 100%
    }

    .brand-logo.first {
        width: 60px;
        margin-right: 10px
    }

    .brand-logo.second {
        width: 64px;
        margin-right: 10px
    }

    .brand-logo.third {
        width: 70px
    }

    .footer-divider.socials {
        display: none
    }

    .footer-links-wrapper {
        grid-template-columns: 1fr 1fr 1fr
    }

    .footer-links-column.fifth.new {
        flex-flow: wrap;
        justify-content: center;
        align-items: flex-start
    }

    .tribe-tabs {
        flex-direction: column-reverse
    }

    .tribe-tabs-content {
        width: 100%;
        max-width: 600px;
        margin-bottom: 60px;
        margin-left: auto;
        margin-right: auto
    }

    .tribe-tabs-menu,
    .tribe-tabs-menu.about {
        width: 100%
    }

    .ctas-image-wrapper {
        width: 100%;
        max-width: 320px
    }

    .spend-wrapper {
        padding-top: 120px;
        padding-bottom: 120px
    }

    .calculator-right {
        width: 100%;
        max-width: 640px
    }

    .spend-block-wrapper {
        grid-column-gap: 12px;
        grid-row-gap: 12px
    }

    .spend-block-wrapper.c,
    .spend-block-wrapper.a {
        min-height: 260px
    }

    .spend-block-wrapper.a.new._1 {
        flex: none;
        justify-content: flex-start;
        align-items: flex-start;
        width: 550px;
        min-height: auto;
        padding-left: 0%;
        display: none;
        top: 180%
    }

    .spend-block-wrapper.a.new._2 {
        width: 550px;
        min-height: auto;
        display: none;
        top: 200%;
        left: -90%
    }

    .spend-block-wrapper.a.new._3 {
        width: 550px;
        min-height: auto;
        display: none;
        top: 100%;
        left: -125%
    }

    .spend-block-wrapper.b {
        min-height: 260px
    }

    .spend-text-container {
        padding: 30px 30px 40px
    }

    .spend-image-wrapper.second {
        border-radius: 16px;
        padding-left: 0
    }

    .spend-image-wrapper.first {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        padding-top: 40px;
        padding-bottom: 40px;
        padding-left: 40px
    }

    .spend-image-wrapper.third {
        border-radius: 16px;
        padding-left: 0
    }

    .spend-text-blocks-contain {
        height: 260px
    }

    .spend-images-gradient-border {
        border-radius: 0 0 16px 16px;
        width: 100%;
        margin-top: -16px;
        left: 0;
        overflow: hidden
    }

    .paragraph-22px {
        font-size: 20px
    }

    .spend-image-container {
        border-radius: 16px;
        padding-top: 16px
    }

    .spend-text-gradient-border {
        width: 100%;
        max-width: none;
        top: 0
    }

    .spend-sticky-block {
        flex-direction: column;
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
        padding-left: 0;
        top: 100px
    }

    .heading-252.new {
        font-size: 20px
    }

    .reviews-slide-wrapper {
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: center;
        max-width: 500px;
        margin-left: auto;
        margin-right: auto
    }

    .reviews-slide-image-contain {
        width: 100%;
        max-width: none
    }

    .reviews-slide-text-gradient-wrapper {
        width: 100%
    }

    .review-slide-text-wrapper {
        padding-top: 34px;
        padding-left: 34px;
        padding-right: 34px
    }

    .slider-arrow.right {
        right: 16%
    }

    .slider-arrow.left {
        left: 16%
    }

    .slider-arrow.left.events {
        left: auto
    }

    .logos-white-gradient {
        width: 140px
    }

    .navigation-menu-button {
        border: 2px solid rgba(22 163 74);
        border-radius: 10px;
        flex-direction: column;
        justify-content: space-between;
        padding: 16px;
        display: flex
    }

    .navigation-menu-button.w--open {
        background-color: rgba(36, 2, 19, .1)
    }

    .navigation-menu-button.white {
        border-color: rgba(255, 255, 255, .4)
    }

    .navigation-menu-button.white.w--open {
        background-color: rgba(255, 255, 255, .1)
    }

    .burger-line.a.white,
    .burger-line.b.white,
    .burger-line.c.white {
        background-color: var(--white)
    }

    .hero-bkg {
        height: 60%;
        max-height: none
    }

    .hero-bkg.blog-cms,
    .hero-bkg.hub {
        max-height: none
    }

    .home-hero-images-container {
        width: 100%
    }

    .hero-bubbles-block-wrapper {
        bottom: 6%;
        left: 15%
    }

    .calc-anchor {
        top: -87px
    }

    .navigation-background-div {
        display: none
    }

    .navigation-links-grid {
        grid-column-gap: 32px;
        grid-row-gap: 24px;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        display: grid
    }

    .navigation-links-grid.resources {
        flex-direction: column-reverse;
        grid-template-columns: 1fr;
        display: flex
    }

    .dropdown-link-arrow-embed.mobile {
        height: 24px
    }

    .navbar-dropdown-text {
        font-family: Satoshi, sans-serif;
        font-size: 18px
    }

    .dropdown-highlight-span {
        background-color: rgba(213, 57, 135, .1)
    }

    .navigation-block-link {
        padding-left: 0
    }

    .dropdown-resources-column {
        flex-direction: row;
        padding-top: 24px;
        padding-bottom: 24px;
        padding-left: 0
    }

    .resource-dropdown-image-contain {
        height: auto;
        padding: 16px
    }

    .integrations-lottie.integra {
        width: 100%
    }

    .spend-anchor.third {
        top: 60%
    }

    .linear-bkg-menu-button {
        z-index: 3;
        display: block;
        position: relative
    }

    .dropdown-links-divider {
        background-color: rgba(213, 57, 135, .1);
        width: 100%;
        height: 1px;
        padding-bottom: 0;
        padding-right: 0;
        display: block
    }

    .navigation-inner-wrapper {
        background-color: none;
        width: 100%;
        height: 76vh;
        margin-left: 0;
        margin-right: 0;
        padding-top: 0px;
        /* padding-bottom: 10px; */
        position: static;
        overflow: visible;
    }

    .navigation-inner-wrapper.white {
        background-color: none
    }

    .navigation-inner-wrapper.white.new {
        background-color: rgba(133, 131, 130, .68);
        height: 100vh;
        margin-left: 0;
        margin-right: 0;
        padding: 0 17px 40px
    }

    .navigation-inner-wrapper.white.new.optimize {
        display: block;
        overflow: visible
    }

    .hero-platform-heading-wrapper {
        margin-top: 0
    }

    .hero-platform-subheading.integra {
        margin-top: 21px
    }

    .hero-platform-subheading-text.integra {
        font-size: 16px
    }

    .hero-platform-cta-wrapper.integra {
        margin-top: 19px
    }

    .blogs-hero-wrapper {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column;
        align-items: center;
        padding-top: 160px;
        display: flex
    }

    .blogs-hero-wrapper.cms {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column
    }

    .featured-block-contain {
        max-width: 700px
    }

    .featured-block-contain.resources {
        width: 100%
    }

    .blog-tabs-wrapper {
        padding-top: 120px
    }

    .blogs-tab-link {
        width: auto;
        min-width: 100px;
        max-width: 150px;
        font-size: 18px
    }

    .blog-tabs-info-wrapper {
        max-width: 800px
    }

    .ctas-form-gradient-wrapper {
        width: 100%
    }

    .blog-cms-info-wrapper {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column;
        align-items: center;
        padding-bottom: 120px
    }

    .blog-cms-left-contain {
        width: 100%
    }

    .block-rich-text h1 {
        font-size: 56px
    }

    .block-rich-text h2 {
        font-size: 46px
    }

    .block-rich-text h3 {
        font-size: 42px
    }

    .block-rich-text h4 {
        font-size: 36px
    }

    .block-rich-text h5 {
        font-size: 28px
    }

    .block-rich-text h6 {
        font-size: 24px
    }

    .block-rich-text blockquote {
        background-size: 40px;
        padding-top: 100px;
        font-size: 28px
    }

    .feature-wrap {
        grid-column-gap: 10px;
        grid-row-gap: 10px
    }

    .feature-image-wrapper.right.pink-bg {
        flex: 1 1
    }

    .feature-image-wrapper.right.green-bg,
    .feature-image-wrapper.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper.left.green-bg {
        flex: 1 1;
        height: 350px
    }

    .feature-image-wrapper.left.yellow-bg {
        flex-direction: column;
        flex: 1 1;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 300px;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0
    }

    .feature-image-wrapper.left.pink-bg {
        flex: 1 1;
        height: 300px
    }

    .feature-content-wrap {
        width: 50%
    }

    .feature-content-header {
        padding-left: 10px
    }

    .feature-content-heading-text {
        font-size: 25px
    }

    .feature-content-body-text {
        font-size: 16px;
        line-height: 1.2
    }

    .blog-cms-sticky-contain,
    .subscribe-form-gradient-wrapper {
        width: 100%
    }

    .related-blogs-wrapper {
        max-width: 800px
    }

    .navigation-bar-dark {
        top: 0
    }

    .navbar-dropdown-toggle-white {
        color: var(--black);
        justify-content: space-between;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .transparent-arrow-button-white._16px.navigation {
        padding-top: 16px;
        padding-bottom: 16px
    }

    .resources-hero-wrapper {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column;
        align-items: center;
        padding-top: 160px;
        display: flex
    }

    .resource-left-header {
        width: 100%
    }

    .resource-tabs-wrapper {
        grid-column-gap: 50px;
        grid-row-gap: 50px;
        flex-direction: column;
        align-items: center;
        max-width: 800px;
        padding-top: 120px
    }

    .resource-tab-info-wrapper {
        width: 100%
    }

    .resource-tab-icon-embed {
        width: 32px;
        height: 32px
    }

    .resource-collection-list {
        grid-template-columns: 1fr 1fr
    }

    .resource-post-image-wrapper {
        height: 280px
    }

    .div-block-737 {
        padding-top: 140px
    }

    .div-block-740.social {
        justify-content: center;
        align-items: flex-start
    }

    .book-demo-form-graphic-1.social,
    .image-222.social {
        display: none
    }

    .text-span-251 {
        text-align: left
    }

    .navbar-dropdown-white {
        width: 100%;
        margin-left: 0
    }

    .blogs-tabs-form {
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        flex-direction: column-reverse;
        align-items: center
    }

    .blog-tag-radio-buttons-contain {
        flex-wrap: wrap
    }

    .resource-tabs-filters {
        width: 100%;
        max-width: none;
        position: static
    }

    .resource-tab-form {
        flex-direction: column;
        align-items: center;
        display: flex
    }

    .resources-radio-button-contain {
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        display: flex
    }

    .resource-tab-form-separator {
        max-width: 400px
    }

    .procurement-team-cards-grid {
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        grid-template-columns: 1fr 1fr
    }

    .procurement-team-member-card {
        margin-bottom: 40px
    }

    .paragraph-146 {
        font-size: 16px
    }

    .saas-hero-text-wrapper {
        max-width: 600px
    }

    .saas-hero-wrapper {
        flex-direction: column;
        align-items: center;
        display: flex
    }

    .saas-hero-absolute-image {
        width: 40%
    }

    .stats-section-contain {
        padding-top: 40px
    }

    .flex-container._140px-bottom-margin {
        grid-column-gap: 120px;
        grid-row-gap: 120px;
        padding-bottom: 120px
    }

    .flex-container._115px-bottom-margin {
        grid-column-gap: 120px;
        grid-row-gap: 120px;
        padding-top: 120px
    }

    .flex-block-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column
    }

    .flex-block-wrapper.reverse {
        flex-direction: column-reverse
    }

    .flex-block-wrapper.lottie {
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        padding-top: 100px
    }

    .flex-text-block,
    .flex-text-block._580px,
    .flex-text-block._550px,
    .flex-text-block.vertical-cloud,
    .flex-image-block {
        width: 100%
    }

    .flex-image-block.lottie {
        width: 100%;
        padding-top: 0;
        padding-bottom: 0;
        left: 0%
    }

    .flex-block-abs-image {
        width: 40%
    }

    .solution-callout-wrapper {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        flex-direction: column;
        max-width: 600px
    }

    .solution-callout-text-wrapper,
    .solution-callout-text-wrapper.cloud {
        width: 100%
    }

    .solution-callout-images-contain {
        width: 100%;
        max-width: 500px;
        margin-left: -10%;
        position: static;
        top: auto;
        bottom: -6%;
        left: auto;
        right: auto
    }

    .solution-callout-images-contain.cloud {
        width: 100%;
        max-width: 500px;
        margin-bottom: -20%;
        margin-left: -10%;
        position: static
    }

    .solution-callout-images-contain.saas {
        margin-bottom: -20%;
        margin-left: 0%
    }

    .setup-cards-grid {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        flex-direction: column;
        max-width: 340px
    }

    .cloud-hero-wrapper {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column;
        align-items: center;
        display: flex
    }

    .cloud-hero-text-wrapper {
        width: 100%;
        max-width: 540px
    }

    .cloud-hero-image-wrapper {
        width: 100%
    }

    .cloud-hero-absolute-image {
        width: 40%
    }

    .cloud-hero-absolute-image.second {
        width: 45%
    }

    .cloud-absolute-image {
        width: 30%
    }

    .cloud-absolute-image.second {
        width: 26%
    }

    .tabs {
        grid-template-columns: 1fr
    }

    .footer-socials-contain {
        justify-content: center
    }

    .footer-end-wrapper {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        flex-direction: column
    }

    .navigation-block-link-wrapper {
        grid-column-gap: 14px;
        grid-row-gap: 14px;
        padding-top: 18px;
        padding-bottom: 18px
    }

    .navigation-icon-embed {
        flex: none
    }

    .navigation-icon-embed._32px {
        width: 32px;
        height: 32px
    }

    .nav-mobile-contain {
        grid-row-gap: 0px;
        background-color: var(--soft-pink);
        border-radius: 10px;
        flex-direction: column;
        align-items: flex-start;
        width: 90%;
        margin-left: auto;
        margin-right: auto;
        padding: 4px 16px 24px;
        display: flex;
        position: relative
    }

    .product-dropdown-wrapper {
        z-index: 1300;
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        background-color: #faf2eb;
        flex-direction: column;
        width: 100%;
        margin-left: 100%;
        padding-top: 24px;
        display: flex;
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0%;
        right: 0%;
        overflow: auto
    }

    .dropdown-mobile-link-contain {
        grid-column-gap: 18px;
        grid-row-gap: 18px;
        flex-direction: column;
        align-items: flex-start;
        padding-left: 16px;
        padding-right: 16px;
        display: flex
    }

    .dropdown-mobile-link-contain.bottom {
        margin-top: auto;
        padding-bottom: 16px
    }

    .dropdown-mobile-link-contain.solutions {
        grid-column-gap: 0px;
        grid-row-gap: 0px
    }

    .dropdown-mobile-link-contain.resources {
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        margin-top: -18px
    }

    .dropdown-callout-link-wrapper {
        background-color: rgba(213, 57, 135, .1);
        border-radius: 12px;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
        display: flex
    }

    .callout-header {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        align-items: center;
        display: flex
    }

    .mobile-dropdown {
        width: 100%
    }

    .mobile-dropdown-toggle {
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0;
        display: flex
    }

    .mobile-dropdown-list {
        position: static;
        overflow: hidden
    }

    .mobile-dropdown-list.w--open {
        background-color: rgba(255, 255, 255, 0);
        position: static
    }

    .mobile-dropdown-links-contain {
        flex-direction: column;
        padding-top: 18px;
        display: flex
    }

    .mobile-links-divider {
        background-color: var(--pabloo-green);
        opacity: .1;
        width: 100%;
        height: 1px;
        padding-bottom: 0;
        padding-right: 0;
        display: block
    }

    .solutions-dropdown-wrapper,
    .resources-dropdown-wrapper {
        z-index: 1300;
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        background-color: #faf2eb;
        flex-direction: column;
        width: 100%;
        margin-left: 100%;
        padding-top: 24px;
        display: flex;
        position: absolute;
        top: 0%;
        bottom: 0%;
        left: 0%;
        right: 0%;
        overflow: auto
    }

    .ncf-filter-item-container {
        grid-template-columns: 1fr 1fr
    }

    ._24px-icon {
        flex: none
    }

    .points-text-contain {
        width: 50%;
        max-width: 660px;
        margin-bottom: 50px
    }

    .points-image-contain {
        width: 100%
    }

    .points-bg-contain {
        top: 0%
    }

    .points-bg-image {
        height: 100%
    }

    .section-70 {
        padding-bottom: 38px;
        padding-left: 25px;
        padding-right: 25px
    }

    .features-wrapper-2 {
        justify-content: space-between
    }

    .sysf-collapse-text {
        display: none
    }

    .material-icons.sysf-icon-left.sysf-icon-collapse {
        margin-top: 1px
    }

    .sysf-section-title {
        width: 100%;
        margin-bottom: 32px
    }

    .sysf-section-title.sysf-centered {
        width: 75%
    }

    .sysf-container {
        padding-left: 24px;
        padding-right: 24px
    }

    .sysf-faq-question {
        line-height: 1.5
    }

    .sysf-faq-item-wrapper.sysf-box,
    .sysf-faq-item-wrapper.sysf-box.sysf-last {
        margin-bottom: 16px
    }

    .sysf-column {
        width: 100%
    }

    .sysf-row {
        flex-direction: column
    }

    .brix---heading-h3-size {
        font-size: 22px;
        line-height: 32px
    }

    .brix---display-2 {
        font-size: 58px;
        line-height: 70px
    }

    .brix---heading-h2-size {
        font-size: 30px;
        line-height: 46px
    }

    .brix---text-center-tablet {
        text-align: center
    }

    .brix---grid-stats-v4 {
        grid-template-columns: 1fr
    }

    .brix---section {
        padding-top: 33px;
        padding-bottom: 118px
    }

    .brix---heading-h3-size-2 {
        font-size: 22px;
        line-height: 32px
    }

    .brix---mg-bottom-48px {
        margin-bottom: 0
    }

    .brix---grid-3-columns---1-col-mb {
        grid-template-columns: 1fr
    }

    .bold-text-26 {
        font-size: 27px
    }

    .button-48 {
        text-align: center;
        padding-left: 13px;
        padding-right: 13px
    }

    .image-230 {
        height: 250px
    }

    .new-product-heading-4 {
        line-height: 100%
    }

    .image-231 {
        height: 350px
    }

    .image-232,
    .image-233,
    .image-234 {
        height: 340px
    }

    .image-236 {
        height: 300px
    }

    .hero-platform-wrapper-solutions {
        padding-top: 125px
    }

    .heading-64px-copy {
        font-size: 56px
    }

    .heading-64px-copy.hero-home-heading {
        font-size: 64px
    }

    .heading-64px-copy.hero-home-heading.top {
        display: block
    }

    .heading-64px-new {
        font-size: 56px
    }

    .heading-64px-new.hero-home-heading {
        font-size: 64px
    }

    .heading-64px-new.hero-home-heading.top {
        display: block
    }

    .image-238 {
        flex: 0 1 auto;
        order: 0;
        align-self: auto;
        padding-top: 42px
    }

    .feature-image-wrapper-copy.right.green-bg {
        flex: 1 1;
        width: 50%;
        height: 350px
    }

    .feature-image-wrapper-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        flex-direction: column;
        flex: 1 1;
        justify-content: flex-end;
        align-items: center;
        width: 50%;
        height: 350px;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0;
        display: flex
    }

    .feature-image-wrapper-copy.left.pink-bg {
        flex: 1 1
    }

    .feature-content-heading-text-copy {
        font-size: 22px
    }

    .image-239 {
        object-fit: fill
    }

    .image-240 {
        max-width: 100%
    }

    .image-241 {
        height: 50px
    }

    .ctas-text-wrapper-copy,
    .ctas-text-wrapper-copy._50,
    .ctas-text-wrapper-copy,
    .ctas-text-wrapper-copy._50 {
        width: 100%
    }

    .heading-48px-copy {
        font-size: 42px
    }

    .paragraph-18px-copy.navbar-dropdown-text {
        font-family: Satoshi, sans-serif
    }

    .paragraph-18px-copy.callout-link-heading {
        color: var(--dark-violet);
        font-family: Satoshi, sans-serif;
        font-weight: 700
    }

    .heading-28px-copy,
    .heading-28px-copy-copy {
        font-size: 24px
    }

    .ctas-text-wrapper-copy-copy,
    .ctas-text-wrapper-copy-copy._50,
    .ctas-text-wrapper-copy-copy-copy,
    .ctas-text-wrapper-copy-copy-copy._50 {
        width: 100%
    }

    .feature-image-wrapper-copy-copy.right.green-bg {
        flex: 1 1;
        width: 50%;
        height: 350px
    }

    .feature-image-wrapper-copy-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper-copy-copy.left.green-bg {
        flex: 1 1
    }

    .feature-image-wrapper-copy-copy.left.yellow-bg {
        flex-direction: column;
        flex: 1 1;
        justify-content: flex-end;
        align-items: center;
        width: 50%;
        height: 350px;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0;
        display: flex
    }

    .feature-image-wrapper-copy-copy.left.pink-bg {
        flex: 1 1
    }

    .feature-content-wrap-copy {
        width: 50%
    }

    .feature-image-wrapper-copy.right.green-bg,
    .feature-image-wrapper-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        flex: 1 1;
        width: 50%;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0
    }

    .feature-image-wrapper-copy.left.pink-bg {
        flex: 1 1;
        height: 350px;
        padding-left: 12px
    }

    .image-245 {
        max-width: 100%
    }

    .feature-image-wrapper-copy.right.green-bg,
    .feature-image-wrapper-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper-copy.right.green-bg,
    .feature-image-wrapper-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .stats-wrapper-copy,
    .stats-wrapper-new,
    .stats-wrapper-copy {
        margin-top: 24px;
        padding-top: 25px
    }

    .stats-section-copy {
        margin-top: 19px
    }

    .feature-image-wrapper-copy.right.green-bg,
    .feature-image-wrapper-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper-copy.left.green-bg {
        flex: 1 1
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        flex-direction: column;
        flex: 1 1;
        justify-content: center;
        align-items: center;
        width: 50%;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0
    }

    .feature-image-wrapper-copy.left.pink-bg {
        flex: 1 1;
        height: 350px
    }

    .feature-image-wrapper-copy-copy-copy.right.green-bg {
        flex: 1 1;
        width: 50%;
        height: 350px;
        padding-right: 0
    }

    .feature-image-wrapper-copy-copy-copy.right.green-bg-copy {
        flex: 1 1;
        width: 50%
    }

    .feature-image-wrapper-copy-copy-copy.left.green-bg {
        flex: 1 1
    }

    .feature-image-wrapper-copy-copy-copy.left.yellow-bg {
        flex-direction: column;
        flex: 1 1;
        justify-content: flex-end;
        align-items: center;
        width: 50%;
        height: 350px;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 0;
        display: flex
    }

    .feature-image-wrapper-copy-copy-copy.left.pink-bg {
        flex: 1 1
    }

    .hero-heading-copy {
        line-height: 100%
    }

    .new-navigation-background-div {
        display: none;
        overflow: visible
    }

    .container-1289 {
        max-width: 100%;
        padding-left: 40px;
        padding-right: 40px
    }

    .div-block-20-copy {
        margin-top: 40px;
        padding-top: 0%;
        padding-bottom: 4%
    }

    .navigation-background-div-black {
        display: none
    }

    .features-wrapper-copy {
        margin-top: 6px
    }

    .image-231-copy {
        height: 350px
    }

    .wrapper-1280px-copy {
        flex-direction: column;
        max-width: 600px
    }

    .wrapper-1280px-copy.popup-div {
        max-width: 1000px;
        padding-top: 100px
    }

    .wrapper-1280px-copy.discover-new-product-flex {
        flex-direction: column-reverse;
        padding-top: 50px
    }

    .wrapper-1280px-copy.discover-purchase-flex {
        flex-direction: column-reverse
    }

    .wrapper-1280px-copy.case-study-hero-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px-copy.track-approval-flex {
        flex-direction: column-reverse
    }

    .wrapper-1280px-copy.workflow-approval-flex {
        flex-direction: column;
        padding-top: 30px
    }

    .wrapper-1280px-copy.document-one-place-flex {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column-reverse
    }

    .wrapper-1280px-copy.assisted-tools-flex,
    .wrapper-1280px-copy.actionable-insight-flex,
    .wrapper-1280px-copy.contract-renewals-flex {
        flex-direction: column-reverse
    }

    .wrapper-1280px-copy.points-container {
        max-width: 660px
    }

    .container-1290 {
        max-width: 728px
    }

    .navbar-wrapper-three {
        justify-content: space-between
    }

    .navbar-brand-three {
        position: relative
    }

    .nav-menu-wrapper-three {
        background-color: transparent;
        top: 70px
    }

    .nav-menu-three {
        background-color: #fff;
        border-radius: 50px;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        padding: 20px;
        display: flex;
        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)
    }

    .nav-link-6 {
        padding-left: 5px;
        padding-right: 5px
    }

    .nav-dropdown-list.shadow-three.w--open {
        position: absolute
    }

    .menu-button-11 {
        padding: 12px
    }

    .menu-button-11.w--open {
        color: #fff;
        background-color: #a6b1bf
    }

    .hello-bar-link {
        color: var(--white);
        text-align: center;
        font-weight: 500
    }

    .new-hello-bar {
        background-color: var(--pabloo-green);
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
        display: block
    }

    .hello-navbar-container {
        position: static
    }

    .heading-90px-copy {
        font-size: 72px
    }

    .heading-24px-copy {
        font-size: 22px
    }

    .home-hero-heading-copy {
        font-size: 40px;
        line-height: 48px
    }

    .cta-section-copy {
        background-position: 50% 0
    }

    .stats-grid-copy {
        grid-template-columns: 1fr 1fr;
        margin-top: 35px
    }

    .hero-bkg-copy.blog-cms,
    .hero-bkg-copy.hub {
        max-height: none
    }

    .wrapper-1300px-copy-copy {
        padding-left: 0;
        padding-right: 0
    }

    .wrapper-1300px-copy-copy.home-hero-flex {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column;
        align-items: center
    }

    .image-247 {
        height: 90%
    }

    .div-block-799 {
        grid-template-columns: 1fr
    }

    .blog-hero-heading-copy {
        font-size: 55px;
        line-height: 54px
    }

    .hero-bkg-copy {
        height: 60%;
        max-height: none
    }

    .hero-bkg-copy.blog-cms,
    .hero-bkg-copy.hub {
        max-height: none
    }

    .hero-bkg-copy-copy {
        height: 60%;
        max-height: none
    }

    .hero-bkg-copy-copy.blog-cms,
    .hero-bkg-copy-copy.hub {
        max-height: none
    }

    .text-block-330 {
        margin-top: 39px
    }

    .cms-blog-block-section-copy.templates-block {
        padding-bottom: 139px
    }

    .wrapper-1300px-copy {
        padding-left: 0;
        padding-right: 0
    }

    .wrapper-1300px-copy.home-hero-flex {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column;
        align-items: center
    }

    .new-about-1300px-header {
        margin-top: 27px;
        padding-left: 0;
        padding-right: 0
    }

    .new-about-1300px-header.home-hero-flex {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        flex-direction: column;
        align-items: center
    }

    .new-about-hero-wrapper {
        background-image: none;
        background-position: 0 0;
        background-repeat: repeat;
        background-size: auto;
        background-attachment: scroll;
        padding-bottom: 20px
    }

    .text-span-294 {
        font-size: 25px
    }

    .xs-text {
        font-size: 52px
    }

    .about-heading-x {
        font-size: 44px
    }

    .stats-wrapper-copy-copy,
    .stats-xx {
        margin-top: 24px;
        padding-top: 25px
    }

    .text-block-332,
    .text-block-332.intra {
        font-size: 38px
    }

    .div-block-801.integra {
        padding: 19px
    }

    .text-block-333 {
        flex: 0 1 auto;
        order: 0;
        font-size: 16px
    }

    .tribe-section---about {
        padding-top: 60px
    }

    .ctas-container-copy,
    .about-x-platform-container {
        grid-column-gap: 80px;
        grid-row-gap: 80px;
        flex-direction: column
    }

    .text-block-338 {
        font-size: 38px
    }

    .about-x-cards {
        margin-top: 3px
    }

    .about-x-card.new {
        width: 100%
    }

    .text-block-342.intra {
        font-size: 14px
    }

    .tabs-menu-5 {
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        flex-flow: row;
        flex: 0 1 auto;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        width: 100%;
        margin-left: 0
    }

    .integra-tab {
        width: 100%
    }

    .integra-tab.w--current {
        border-color: var(--pabloo-green);
        width: 100%
    }

    .integra-text,
    .integra-text-block {
        text-align: center
    }

    .tabs-2,
    .div-block-810 {
        flex-flow: column
    }

    .div-block-811 {
        margin-top: 44px
    }

    .heading-265 {
        font-size: 18px
    }

    .text-block-355 {
        font-size: 32px
    }

    .div-block-819 {
        grid-template-columns: 1fr 1fr 1fr
    }

    .paragraph-154 {
        display: block
    }

    .section-72.ebooks,
    .section-72.events {
        background-color: var(--soft-pink)
    }

    .section-72.testimonial {
        padding-top: 86px
    }

    .section-72.block3 {
        padding-top: 91px
    }

    .div-block-822 {
        grid-template-columns: 1fr
    }

    .div-block-823 {
        display: flex
    }

    .image-249 {
        object-fit: cover;
        border-top-right-radius: 0;
        border-bottom-left-radius: 35px;
        align-self: center;
        width: 100%;
        height: 400px;
        display: none
    }

    .div-block-824 {
        border-top-right-radius: 35px;
        border-bottom-right-radius: 35px;
        border-bottom-left-radius: 35px;
        padding-left: 70px
    }

    .text-block-357 {
        text-align: center
    }

    .text-block-358 {
        text-align: justify;
        margin-bottom: 99px
    }

    .div-block-828 {
        width: 100%
    }

    .text-block-359.events {
        text-align: center
    }

    .div-block-830.why {
        width: 35%
    }

    .text-block-363 {
        line-height: 1
    }

    .text-block-365 {
        font-size: 16px;
        line-height: 1.3
    }

    .div-block-840 {
        align-self: center
    }

    .text-block-370,
    .text-block-371 {
        text-align: center
    }

    .div-block-842 {
        text-align: center;
        align-self: center
    }

    .div-block-843 {
        margin-bottom: 84px
    }

    .div-block-845 {
        justify-content: center;
        align-items: flex-start
    }

    .text-block-373 {
        text-align: center
    }

    .testimonialx {
        width: 100%
    }

    .div-block-850.partner {
        margin-bottom: 66px
    }

    .events-expectations-section {
        flex-flow: column
    }

    .event-exectations-tab {
        width: 100%
    }

    .rich-text-block-30 {
        text-align: justify;
        margin-top: 9px
    }

    .div-block-857 {
        width: 100%
    }

    .sysf-button.sysf-medium {
        font-size: 16px
    }

    .about-pabloo-events {
        margin-top: 41px;
        margin-bottom: 28px
    }

    .div-block-860 {
        justify-content: flex-start;
        align-items: flex-start
    }

    .your-grid-container {
        justify-content: center;
        align-items: flex-start;
        display: flex
    }

    .features-wrapper-new.yellow {
        grid-template-columns: 1fr
    }

    .feature-block-item.yellow2 {
        padding-left: 0%;
        padding-right: 0%
    }

    .div-block-861 {
        flex-flow: column
    }

    .div-block-862 {
        align-self: center;
        width: 40%;
        padding-top: 30px;
        padding-left: 30px;
        padding-right: 30px
    }

    .div-block-863 {
        width: 100%;
        padding: 60px
    }

    .text-block-387 {
        text-align: center;
        font-size: 25px
    }

    .image-262 {
        width: 300px
    }

    .text-block-388 {
        text-align: justify;
        font-size: 18px
    }

    .container-1292 {
        max-width: 728px
    }

    .tabs-4 {
        background-size: cover;
        flex-flow: column;
        height: auto
    }

    .tabs-menu-7 {
        width: 100%;
        height: 360px
    }

    .tabs-content-5 {
        width: 100%
    }

    .div-block-868 {
        height: 580px
    }

    .text-block-391 {
        text-align: center;
        font-size: 64px
    }

    .div-block-872 {
        width: 60%
    }

    .div-block-880 {
        flex-flow: row
    }

    .div-block-881.new {
        width: 80%
    }

    .div-block-883 {
        grid-template-columns: 1fr
    }

    .div-block-887 {
        grid-column-gap: 68px;
        grid-row-gap: 68px;
        flex-flow: column;
        grid-template-columns: 1fr;
        justify-content: center;
        align-items: flex-start;
        display: flex
    }

    .text-block-407,
    .div-block-888 {
        width: 100%
    }

    .div-block-888.fold-2 {
        margin-bottom: 50px;
        padding-left: 0
    }

    .div-block-889 {
        width: 100%
    }

    .div-block-892.fold-2 {
        margin-bottom: 0
    }

    .div-block-893 {
        justify-content: center;
        align-items: flex-start;
        width: 100%
    }

    .div-block-894 {
        flex-flow: column;
        grid-template-columns: .75fr;
        align-content: stretch;
        justify-content: start;
        align-items: start;
        justify-items: center;
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        display: flex
    }

    .div-block-895 {
        display: none
    }

    .button-53 {
        padding: 12px 71px;
        font-size: 20px
    }

    .div-block-896 {
        width: 100%;
        padding: 99px 72px 67px
    }

    .div-block-897 {
        margin-top: 9px
    }

    .div-block-901 {
        display: none
    }

    .div-block-902 {
        grid-column-gap: 19px;
        grid-row-gap: 19px;
        width: 100%;
        padding-right: 0
    }

    .text-block-415 {
        text-align: center;
        line-height: 1.4
    }

    .text-block-417 {
        text-align: center
    }

    .div-block-905 {
        justify-content: flex-start;
        align-items: flex-start
    }

    .container-1293 {
        max-width: 728px
    }

    .nav-menu-wrapper {
        background-color: transparent;
        padding-left: 10px;
        padding-right: 10px
    }

    .nav-menu-two {
        background-color: var(--black-2);
        border: 1px solid rgba(204, 204, 204, .13);
        border-radius: 19px;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        margin-top: 24px;
        padding: 20px;
        display: flex;
        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)
    }

    .nav-link-7 {
        padding-left: 5px;
        padding-right: 5px
    }

    .nav-dropdown-list-2.shadow-three.w--open {
        position: absolute
    }

    .menu-button-12 {
        flex: 0 1 auto;
        padding: 0
    }

    .menu-button-12:active {
        padding: 0
    }

    .menu-button-12.w--open {
        color: #fff;
        background-color: rgba(166, 177, 191, 0);
        padding: 0
    }

    .image-275 {
        width: 35px;
        margin-right: 20px
    }

    .image-276 {
        width: 100%;
        margin-bottom: 0;
        padding-bottom: 0
    }

    .div-block-906 {
        flex-flow: row;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        display: none
    }

    .image-277 {
        padding-left: 20px
    }

    .text-span-376 {
        font-size: 52px
    }

    .div-block-907 {
        grid-template-columns: 1fr;
        grid-auto-flow: column
    }

    .text-block-419 {
        margin-top: 35px;
        margin-bottom: 67px
    }

    .div-block-908 {
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-items: center;
        margin-left: 0;
        padding-left: 0;
        padding-right: 0
    }

    .div-block-909 {
        justify-content: center;
        align-items: center
    }

    .text-block-423 {
        line-height: 1.3
    }

    .text-block-424 {
        margin-top: 1px
    }

    .text-block-425 {
        font-size: 25px
    }

    .text-block-426 {
        font-size: 16px
    }

    .text-block-427 {
        font-size: 25px
    }

    .text-block-428,
    .text-block-429,
    .text-block-430 {
        font-size: 14px;
        line-height: 1.2
    }
}

@media screen and (max-width:767px) {
    h1 {
        font-size: 50px
    }

    h2 {
        font-size: 40px;
        line-height: 50px
    }

    .home-hero-section {
        margin-top: 60px
    }

    .wrapper-1300px {
        padding-top: 8px
    }

    .wrapper-1300px.for-integra {
        margin-left: 0;
        margin-right: 0
    }

    .navigation-right {
        display: none
    }

    .navigation-right.show {
        display: block
    }

    .navigation-left {
        justify-content: space-between;
        width: 100%
    }

    .home-hero-heading {
        font-size: 40px;
        line-height: 42px
    }

    .button-wrapper.home-hero-btn-wrapper {
        justify-content: center;
        width: 100%
    }

    .primary-button {
        font-size: 16px
    }

    .primary-button.white-alter-button {
        text-align: center;
        width: 100%
    }

    .primary-button.popup-form-button {
        width: 100%
    }

    .hollow-button {
        font-size: 16px
    }

    .home-hero-stat-grid {
        flex-wrap: wrap;
        display: flex
    }

    .home-hero-stat-block {
        padding-left: 10px
    }

    .home-hero-stat-number {
        font-size: 38px
    }

    .hero-image-wrapper {
        width: 90%;
        margin-top: 10%
    }

    .cards-section.vertical-padding-large {
        margin-left: 31px;
        margin-right: 31px
    }

    .logo-container {
        width: 20%;
        margin-bottom: 40px;
        margin-left: 20px;
        margin-right: 20px
    }

    .home-value-content-wrapper {
        margin-top: 0
    }

    .home-value-heading {
        margin-bottom: 25px
    }

    .split-section-content-container.first {
        margin-top: 80px
    }

    .split-image-wrapper._50 {
        width: 100%
    }

    .split-image-2 {
        max-width: 300px;
        max-height: 160px;
        top: 70%;
        right: 2%
    }

    .work-slide-container {
        padding: 20px
    }

    .work-slide-number-container {
        width: 50px;
        height: 50px
    }

    .work-slider-text-wrapper {
        font-size: 22px
    }

    .review-heading {
        font-size: 40px
    }

    .review-slider {
        height: auto;
        display: flex
    }

    .review-slider.width-100 {
        width: 100%
    }

    .mask-not-visible {
        height: auto
    }

    .review-slide {
        height: 100%;
        padding-top: 60px;
        padding-left: 20px;
        padding-right: 20px
    }

    .review-slider-text {
        font-size: 18px
    }

    .pitch-heading {
        margin-bottom: 60px;
        font-size: 36px;
        line-height: 109%
    }

    .pitch-illustration-head {
        width: 100px
    }

    .pitch-brach-wrapper {
        width: 15%
    }

    .pitch-brach-wrapper.persona {
        width: 15%;
        max-width: 63.0938px
    }

    .branch-card-wrapper {
        flex: 0 1 auto
    }

    .branch-card-wrapper.three-columns {
        grid-template-columns: 1fr
    }

    .pitch-main-card.bottom-block.mobile {
        display: none
    }

    .pitch-main-card.bottom-block.bottom {
        display: block
    }

    .home-support-section {
        background-position: 75%
    }

    .support-content-wrapper {
        width: 90%
    }

    .faq-wrapper {
        grid-template-columns: 1fr
    }

    .white-alter-span.white {
        font-size: 45px
    }

    .footer-logo-container {
        margin-right: 0
    }

    .footer-logo-container.w--current {
        flex: none;
        margin-right: 0
    }

    .footer-down-container {
        flex-flow: column-reverse wrap;
        justify-content: center;
        max-width: 480px;
        margin-left: auto;
        margin-right: auto
    }

    .copyright-text {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 0
    }

    .footer-down-link.first {
        margin-left: 0
    }

    .pricing-heading {
        letter-spacing: 0
    }

    .auto-slider-arrow-left {
        bottom: 6%;
        right: 25%
    }

    .auto-slider-arrow-right {
        bottom: 6%
    }

    .contact-hero-wrapper {
        margin-top: 160px
    }

    .blog-hero-section {
        padding-bottom: 280px
    }

    .blog-hero-heading {
        font-size: 40px;
        line-height: 40px
    }

    .blog-hero-para {
        font-size: 18px
    }

    .blog-form {
        flex-direction: column
    }

    .blog-form-field {
        text-align: center;
        height: 60px;
        margin-bottom: 20px;
        margin-right: 0
    }

    .blog-form-field::placeholder {
        font-size: 18px
    }

    .subscribe-button {
        height: 60px;
        font-size: 18px
    }

    .wrapper-1080px.blog-wrapper {
        flex-direction: column
    }

    .blog-feature-block {
        grid-template-rows: auto auto;
        grid-template-columns: 1fr
    }

    .blog-filter-tab {
        align-items: flex-end
    }

    .blog-tab {
        margin-right: 0
    }

    .blog-tab.w--current {
        font-size: 18px
    }

    .blog-collection-list {
        grid-template-columns: 1fr
    }

    .blog-main-image-wrapper {
        height: auto
    }

    .blog-rich-text a {
        transition: color .2s
    }

    .blog-rich-text a:hover {
        color: var(--slate-blue)
    }

    .pricing-hero-table.new {
        grid-template-columns: 1fr
    }

    .black-button {
        font-size: 16px
    }

    .wrapper-1280px.discover-new-product-flex {
        padding-top: 0
    }

    .wrapper-1280px.discover-purchase-flex,
    .wrapper-1280px.discover-tools-flex,
    .wrapper-1280px.procurement-black-flex,
    .wrapper-1280px.contract-renewals-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .popup-close {
        right: 0%
    }

    .work-slide-2 {
        max-width: none;
        max-height: 250px;
        margin-right: 40px
    }

    .bold-head {
        margin-bottom: 10px
    }

    .blog-featured-heading {
        font-size: 26px
    }

    .blog-featured-para {
        font-size: 18px
    }

    .popup-container {
        width: 90%;
        padding: 30px
    }

    .popup-heading {
        font-size: 32px;
        line-height: 38px
    }

    .popup-text-field::placeholder {
        font-size: 18px
    }

    .popup-split-block {
        grid-template-rows: auto auto;
        grid-template-columns: 1fr;
        margin-bottom: 20px
    }

    .about-hero-paragraph {
        font-size: 15px
    }

    .team-grid {
        grid-template-columns: 1fr;
        max-width: 388px;
        margin-left: auto;
        margin-right: auto
    }

    .career-paragraph {
        font-size: 22px
    }

    .about-slide {
        max-width: none;
        max-height: none;
        margin-right: 40px
    }

    .background-image {
        opacity: .4
    }

    .persona-hero-card {
        padding: 30px
    }

    .paragraph-18px-copy.ctas-paragraph.center-this {
        color: var(--white);
        max-width: 600px;
        margin-top: 12px;
        margin-bottom: 32px;
        line-height: 1.2;
        text-align: center;
    }

    .persona-card-text {
        margin-top: 0;
        font-size: 40px
    }

    .persona-head-para {
        font-size: 18px
    }

    .persona-split-text {
        font-size: 40px
    }

    .persona-split-image-container.procurement-section-3-image {
        width: 100%
    }

    .finance-heading {
        font-size: 40px
    }

    .persona-block-image {
        margin-bottom: 20px
    }

    .together-blue-heading {
        font-size: 40px
    }

    .together-blue-paragraph-18px {
        font-size: 16px
    }

    .discover-product-hero-section {
        padding-bottom: 100px
    }

    .discover-product-hero-heading {
        margin-bottom: 16px
    }

    .discover-hero-paragraph {
        margin-bottom: 30px;
        font-size: 18px
    }

    .discover-hero-pointer,
    .discover-hero-pink-text {
        font-size: 16px
    }

    .discover-hero-pink-text-wrapper {
        margin-bottom: 18px
    }

    .new-product-heading-44px {
        font-size: 40px
    }

    .new-product-paragraph-18px,
    .procurement-paragraph-18px {
        font-size: 16px
    }

    .procurement-grid {
        grid-template-columns: 1fr;
        justify-items: center
    }

    .procurement-heading-24px {
        font-size: 22px
    }

    .procurement-item-text-18px {
        font-size: 16px
    }

    .case-study-hero-heading {
        font-size: 45px
    }

    .track-appoval-image-container,
    .multi-channel-image-container {
        width: 90%
    }

    .fast-track-approval-h1-heading {
        margin-bottom: 15px;
        font-size: 45px
    }

    .dropdown-grid {
        grid-template-columns: 1fr
    }

    .footer-grid {
        grid-row-gap: 60px;
        flex-direction: column;
        display: flex
    }

    .split-section-form-wrapper {
        padding: 30px
    }

    .review-slide-2 {
        height: 100%;
        padding-top: 60px;
        padding-left: 20px;
        padding-right: 20px
    }

    .assisted-purchasing-hero-wrapper.insights {
        margin-top: 47px
    }

    .assisted-hero-item-wrapper.left,
    .assisted-hero-item-wrapper.right {
        width: 300px
    }

    .actionable-insight-text-wrap {
        max-width: 500px
    }

    .investor-logo.investor-logo-rt-demo-custo-styles {
        width: 26%
    }

    .insights-hero-image-3 {
        margin-bottom: 90px
    }

    .insights-hero-image-4 {
        margin-bottom: 70px
    }

    .contract-hero-item-wrap.left,
    .contract-hero-item-wrap.right {
        bottom: 1%
    }

    .contract-hero-logo-item._1 {
        top: 0
    }

    .contract-hero-logo-item._5 {
        right: 30%
    }

    .hello-bar {
        flex-direction: column;
        align-items: center
    }

    .div-block-18 {
        padding-top: 0%
    }

    .div-block-20 {
        margin-top: 24px;
        padding-top: 10%;
        padding-left: 24px;
        padding-right: 24px
    }

    .div-block-21.registration-form-block {
        padding-left: 16px;
        padding-right: 15px
    }

    .container-4 {
        max-width: 100%
    }

    .div-block-23.alt-badge {
        margin-top: 0;
        margin-left: 16px
    }

    .text-block-11 {
        color: var(--black)
    }

    .div-block-24,
    .div-block-25 {
        margin-top: 16px
    }

    .div-block-27 {
        top: 0;
        right: 0
    }

    .div-block-28 {
        padding-top: 0;
        padding-bottom: 0
    }

    .div-block-29 {
        background-color: var(--white);
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        min-height: auto
    }

    .bestsuited-webinarblock {
        min-height: auto;
        padding-top: 56px;
        padding-bottom: 56px
    }

    .div-block-33 {
        grid-column-gap: 8px;
        grid-row-gap: 8px;
        flex-wrap: wrap;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        grid-auto-flow: row;
        display: grid
    }

    .grid-3 {
        padding-bottom: 16px;
        padding-left: 16px
    }

    .grid-3.m-l-24 {
        width: 100%;
        margin-left: 0
    }

    .button.bigger {
        height: 54px
    }

    .div-block-35 {
        min-height: auto;
        padding-top: 1px;
        padding-bottom: 4px
    }

    .div-block-36 {
        padding-top: 56px;
        padding-bottom: 56px
    }

    .text-block-18 {
        font-size: 24px;
        line-height: 28px
    }

    .div-block-38 {
        background-color: transparent;
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        padding: 24px 30px
    }

    .div-block-39 {
        justify-content: center;
        margin-top: 0;
        padding-left: 16px;
        padding-right: 16px
    }

    .div-block-40 {
        height: auto
    }

    .container-5 {
        max-width: 90%;
        padding-top: 56px;
        padding-bottom: 56px
    }

    .div-block-41 {
        justify-content: flex-start;
        margin-top: 24px
    }

    .div-block-42 {
        justify-content: center;
        display: flex
    }

    .image-7 {
        position: static
    }

    .text-block-22 {
        color: var(--black)
    }

    .columns-2 {
        flex-direction: column-reverse;
        display: flex
    }

    .div-block-49 {
        display: flex
    }

    .column-6 {
        padding-top: 0%
    }

    .image-11,
    .image-12 {
        display: none
    }

    .div-block-61.white.p-t-40 {
        padding-left: 30px;
        padding-right: 30px
    }

    .columns-4 {
        display: block
    }

    .column-8 {
        justify-content: flex-start;
        padding-left: 0
    }

    .div-block-63 {
        width: 100%;
        padding-top: 24px
    }

    .div-block-65 {
        display: none
    }

    .section {
        padding-left: 30px;
        padding-right: 30px
    }

    .auto-slider-arrow-left-2 {
        bottom: 6%;
        right: 25%
    }

    .review-slider-text-2 {
        font-size: 18px
    }

    .h1-heading {
        font-size: 72px
    }

    .header-grid {
        grid-template-columns: 1fr
    }

    .company-logo-2 {
        margin-left: 15px;
        margin-right: 15px
    }

    .header-section-3 {
        padding-bottom: 100px
    }

    .process-heading {
        font-size: 50px
    }

    .process-grid {
        grid-template-columns: 1fr
    }

    .features-container {
        padding-left: 40px;
        padding-right: 40px
    }

    .feature-section-2 {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .features-grid {
        grid-row-gap: 24px;
        grid-template-columns: 1fr
    }

    .features-heading-wrap {
        margin-bottom: 60px
    }

    .section-regular {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .cta-block {
        padding-left: 24px;
        padding-right: 24px
    }

    .header-feature-3 {
        margin-top: 32px
    }

    .image-cover.not-in-mobile {
        display: none
    }

    .image-cover.mobile-only {
        object-fit: contain;
        display: block
    }

    .header-placeholder-top {
        height: 490px
    }

    .section-large {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .cta-image-2 {
        display: none
    }

    .section-cta {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .cta-heading {
        font-size: 50px;
        line-height: 60px
    }

    .button-cta-primary {
        width: 100%
    }

    .content-grid {
        grid-column-gap: 24px;
        grid-row-gap: 24px
    }

    .h3-heading-2 {
        font-size: 40px
    }

    .grid-two-column-2 {
        grid-template-columns: 1fr
    }

    .section-large-2 {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .grid-three-column {
        grid-template-columns: 1fr
    }

    .testimoial-container {
        margin-top: 100px;
        padding-bottom: 100px;
        padding-left: 0;
        padding-right: 0
    }

    .ck-modal__content-w {
        padding-bottom: 1.5rem;
        padding-left: 1.5rem;
        padding-right: 1.5rem
    }

    .ck-modal__exit-btn {
        margin-right: 1.25rem
    }

    .ck-modal__exit-btn.is--sticky {
        top: -1rem
    }

    .ck-modal__btns-w {
        padding: 1.5rem
    }

    .ck-modal__btns-w.in-pref-manger {
        margin: 1.5rem -1.5rem -2rem;
        padding-top: 1.25rem;
        position: sticky;
        bottom: 0
    }

    .ck-preference__scroll-w {
        padding-top: 2rem
    }

    .ck-form {
        padding-top: .75rem
    }

    .ck-preference__icon {
        margin-right: 0
    }

    .ck-preference-txt {
        display: none
    }

    .modal-section {
        justify-content: flex-start;
        padding-top: 100px;
        padding-bottom: 100px
    }

    .modal-container {
        flex-direction: column;
        align-items: flex-start;
        padding: 40px 20px
    }

    .modal-content {
        width: 100%;
        margin-bottom: 45px
    }

    .modal-image-large {
        margin-bottom: 20px;
        margin-right: 0
    }

    .modal-image-large.blue-bg {
        object-fit: cover;
        height: 300px
    }

    .section-small {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .grid-team-slider {
        grid-template-columns: 1fr
    }

    .h3-heading-3 {
        font-size: 36px;
        line-height: 52px
    }

    .header-large-white {
        font-size: 48px
    }

    .header-section-small {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .process-heading-2 {
        font-size: 50px
    }

    .process-grid-2 {
        grid-template-columns: 1fr
    }

    .m-t-40.p-v-40.bg-change {
        padding-top: 26px
    }

    .header-featured-wrap {
        width: 70%;
        top: 100px
    }

    .process-step {
        margin-right: 20px
    }

    .process-title-wrap-3 {
        margin-bottom: 60px
    }

    .intro {
        padding-left: 55px;
        padding-right: 55px
    }

    .section-regular-2 {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .pricing-icon {
        color: #1a1a1a
    }

    .heading-content-2 {
        font-size: 48px
    }

    .price-custom-icon {
        color: #1a1a1a
    }

    .banner-2 {
        background-image: none;
        background-position: 0 0;
        background-repeat: repeat;
        background-size: auto
    }

    .banner-wrap {
        flex-direction: column;
        align-items: flex-start;
        width: 100%
    }

    .link-block-9 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        flex-wrap: nowrap;
        grid-template-rows: auto;
        grid-template-columns: 1fr auto;
        grid-auto-columns: 1fr;
        justify-items: stretch;
        padding-left: 12px;
        padding-right: 12px;
        display: grid
    }

    .side-pattern {
        left: -35%
    }

    .faq-question-wrap {
        padding-left: 32px;
        padding-right: 32px
    }

    .f-h1-heading {
        margin-top: 0;
        font-size: 48px
    }

    .f-section-large-3 {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .feature-card-04 {
        border-bottom: 1px dashed #e5e5e5
    }

    .feature-card-5 {
        border-bottom: 1px dashed #e5e5e5;
        border-right-style: none
    }

    .grid-features {
        grid-template-columns: 1fr
    }

    .feature-card-01 {
        border-right-style: none
    }

    .section-feature {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .faq-grid-3 {
        grid-row-gap: 40px;
        grid-template-columns: 1fr
    }

    .content-grid-2 {
        grid-template-columns: 1fr
    }

    .feature-block-header {
        padding-left: 40px
    }

    .a-testimonial-slider-grid {
        grid-template-columns: 1fr
    }

    .a-section-regular-2 {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .content-section-5 {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .content-heading {
        font-size: 40px;
        line-height: 50px
    }

    .content-grid-3 {
        grid-row-gap: 60px
    }

    .section-large-3 {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .header-section-6 {
        padding-bottom: 100px
    }

    .section-large-4,
    .section-regular-4 {
        padding-top: 72px;
        padding-bottom: 72px
    }

    .image-67 {
        height: 37px
    }

    .grid {
        grid-template-columns: 1fr
    }

    .step-grid {
        grid-template-rows: auto;
        grid-template-columns: 1fr
    }

    .slider-section {
        padding-top: 100px
    }

    .lp-para {
        font-size: 18px
    }

    .lp-logo-section {
        padding-top: 60px;
        padding-bottom: 60px
    }

    .logo-video {
        grid-row-gap: 32px;
        flex-direction: column;
        margin-top: 60px;
        display: flex
    }

    .lp-win-section {
        padding-top: 60px;
        padding-bottom: 60px
    }

    .win-content {
        grid-row-gap: 32px;
        flex-direction: column;
        margin-top: 60px
    }

    .win-item-wrapper {
        grid-row-gap: 24px
    }

    .lp-slider-flex {
        grid-row-gap: 24px;
        flex-direction: column;
        display: flex
    }

    .vender-alternate-head {
        grid-column-gap: 12px;
        margin-bottom: 12px
    }

    .lp-image-wrapper,
    .lp-image-wrapper._50 {
        width: 100%
    }

    .lp-highlighter {
        border-width: 2px;
        margin-top: 20px
    }

    .b-navigation-large-grid,
    .navigation-grid-2,
    .b-navigation-small-grid {
        grid-template-columns: 1fr
    }

    .div-block-320 {
        justify-content: center;
        align-items: center
    }

    .image-76 {
        flex: 0 1 auto;
        height: 100px
    }

    .close-wrapper {
        width: 24px;
        height: 24px;
        top: 1rem;
        right: 1rem
    }

    .blog-book-demo-box {
        align-self: center
    }

    .ssms-button-wrapper {
        grid-row-gap: 24px;
        flex-direction: column
    }

    .image-87 {
        width: 100%
    }

    .ssms-2-grid {
        grid-template-columns: 1fr
    }

    .ssms-grid-item {
        max-width: 100%;
        font-size: 18px
    }

    .ssms-h3 {
        font-size: 26px
    }

    .ssms-sec-3-grid {
        grid-template-columns: 1fr 1fr
    }

    .ssms-sec-3-grid-item {
        padding: 20px;
        font-size: 18px
    }

    .ssms-step-text {
        padding: 8px 20px;
        font-size: 26px
    }

    .ssms-3-h3 {
        font-size: 26px
    }

    .b-navigation-large-grid-2,
    .navigation-grid-3 {
        grid-template-columns: 1fr
    }

    .auto-slider-arrow-left-3 {
        bottom: 6%;
        right: 25%
    }

    .hover-block__text {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: none;
        min-height: 44%;
        padding: 20px;
        display: flex;
        position: absolute;
        top: auto;
        bottom: 0%;
        left: 0;
        right: 0;
        transform: none
    }

    .review-slide-3 {
        height: 100%;
        padding-top: 60px;
        padding-left: 20px;
        padding-right: 20px
    }

    .mask-not-visible-2 {
        height: auto
    }

    .hollow-button-3 {
        font-size: 16px
    }

    .review-slider-text-4 {
        font-size: 18px
    }

    .hollow-button-4 {
        font-size: 16px
    }

    .persona-head-para-2 {
        font-size: 18px
    }

    .max-save-compoennt {
        padding-top: 64px;
        padding-bottom: 64px
    }

    .max-sav-heading {
        font-size: 32px;
        line-height: 44px
    }

    .max-save-para {
        font-size: 16px;
        line-height: 24px
    }

    .div-block-456 {
        grid-row-gap: 16px;
        margin-top: 48px
    }

    .text-block-215 {
        font-size: 17px
    }

    .div-block-457 {
        grid-column-gap: 30px;
        grid-row-gap: 18px;
        margin-top: 16px;
        margin-bottom: 40px;
        padding-left: 24px;
        padding-right: 24px
    }

    .text-block-218 {
        font-size: 16px
    }

    .text-block-219 {
        font-size: 36px
    }

    .hide-in-mobile {
        display: none
    }

    .div-block-502 {
        padding-left: 30px;
        padding-right: 30px
    }

    .section-48 {
        padding-top: 67px;
        padding-left: 17px;
        padding-right: 17px
    }

    .div-block-590 {
        grid-column-gap: 6px
    }

    .div-block-598 {
        padding-left: 21px;
        padding-right: 21px
    }

    .section-52 {
        padding-left: 16px;
        padding-right: 16px
    }

    .section-55 {
        padding-bottom: 72px
    }

    .div-block-618 {
        grid-template-columns: 1fr;
        padding-left: 18px;
        padding-right: 18px
    }

    .heading-229 {
        font-size: 32px
    }

    .container-1286 {
        padding-left: 30px;
        padding-right: 30px
    }

    .banner-cta-blog {
        align-self: center
    }

    .link-button-copy2 {
        left: 8px
    }

    .case-study-hero-heading-2 {
        font-size: 45px
    }

    .reference-hero-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .reference-center-wrapper {
        width: 90%
    }

    .colors-grid {
        grid-template-columns: 1fr 1fr 1fr
    }

    .reference-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .buttons-grid {
        grid-template-columns: 1fr 1fr
    }

    .heading-64px {
        font-size: 48px
    }

    .heading-64px.hero-home-heading {
        font-size: 46px
    }

    .heading-64px.text-align-center {
        font-size: 45px
    }

    .heading-90px {
        font-size: 60px;
        line-height: 120%
    }

    .heading-56px {
        font-size: 42px
    }

    .heading-56px.integrations-heading._40px-bottom-margin {
        margin-bottom: 30px
    }

    .heading-48px {
        font-size: 38px
    }

    .heading-40px {
        font-size: 32px
    }

    .navigation-bar {
        top: 0
    }

    .navbar-container {
        padding-top: 12px;
        padding-bottom: 12px
    }

    .navigation-link {
        /*font-size: 16px*/
    }

    .navbar-logo {
        padding-left: 0
    }

    .logo-image.footer-logo {
        width: 160px
    }

    .logo-bar.second.footer-bar,
    .logo-bar.third.footer-bar,
    .logo-bar.first.footer-bar {
        width: 14px
    }

    .navigation-button-contain.out-menu {
        margin-right: 12px;
        display: none
    }

    .hero-home-wrapper {
        padding-top: 120px;
        padding-bottom: 100px;
        margin-top: -120px;
        margin-bottom: -140px;
    }

    .hero-home-wrapper.new {
        padding-top: 140px
    }

    .transparent-arrow-button {
        padding-left: 24px;
        padding-right: 24px;
    }

    .hero-home-text-wrapper {
        max-width: 460px
    }

    .hero-home-text-wrapper.new {
        width: 100%
    }

    .paragraph-18px {
        font-size: 16px
    }

    .paragraph-18px.hero-home-paragraph.new {
        font-size: 22px
    }

    .paragraph-18px.integrations-paragraph {
        margin-bottom: 30px;
        text-align: center;

    }

    .paragraph-18px.saas-hero-paragraph,
    .paragraph-18px.cloud-hero-paragraph {
        margin-bottom: 16px
    }

    .pink-arrow-button {
        padding-left: 24px;
        padding-right: 24px
    }

    .stats-section {
        margin-top: 0
    }

    .stats-wrapper {
        margin-top: 11px
    }

    .stats-grid {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        grid-template-columns: 1fr;
        max-width: 360px
    }

    .heading-24px {
        font-size: 20px
    }

    .heading-24px.review-text {
        font-size: 18px
    }

    .logo-image-contain {
        height: 30px
    }

    .type-cards-grid {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .type-card-block.first,
    .type-card-block.second {
        padding-top: 30px;
        padding-bottom: 30px
    }

    .type-card-top-wrapper {
        padding-left: 30px;
        padding-right: 30px
    }

    .type-card-icon-contain {
        width: 50px;
        height: 50px
    }

    .heading-28px {
        font-size: 22px
    }

    .div-block-704 {
        grid-template-columns: 2.5fr
    }

    .div-block-720 {
        grid-template-columns: 1fr;
        padding-left: 11px;
        padding-right: 11px
    }

    .collection-list-7 {
        grid-template-columns: 1fr
    }

    .type-cards-train-container.vertical {
        margin-top: 20px;
        margin-bottom: 40px;
        padding-left: 30px;
        padding-right: 30px
    }

    .integrations-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .integrations-wrapper.saas {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        padding-bottom: 80px
    }

    .calculator-container {
        grid-column-gap: 40px;
        grid-row-gap: 40px
    }

    .stack-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .stack-tabs-menu {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .stack-tab-link {
        text-align: center;
        min-width: 100px;
        display: flex
    }

    .stack-tab-link-wrapper {
        margin-top: auto
    }

    .stack-tab-link-header {
        padding-top: 6px;
        padding-bottom: 6px
    }

    .stack-tab-link-icon {
        display: none
    }

    .stack-tab-link-progress-bar-contain {
        height: 6px
    }

    .paragraph-20px {
        font-size: 18px
    }

    .paragraph-20px.stack-tab-link-text {
        font-size: 16px
    }

    .paragraph-20px.blog-tag-radio-button-label {
        padding-left: 20px;
        padding-right: 20px
    }

    .stack-blocks-grid {
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        grid-template-columns: 1fr
    }

    .stack-block.a-first,
    .stack-block.a-second,
    .stack-block.d-first {
        padding: 28px
    }

    .stack-block-image-contain.a-first {
        margin-top: 40px
    }

    .stack-block-image-contain.b-first,
    .stack-block-image-contain.c-first,
    .stack-block-image-contain.c-second,
    .stack-block-image-contain.b-second,
    .stack-block-image-contain.d-second,
    .stack-block-image-contain.d-first {
        margin-top: 40px;
        padding-bottom: 0
    }

    .blogs-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .blogs-container {
        grid-template-columns: 1fr;
        max-width: 500px
    }

    .blogs-collection-list._3-column-grid {
        grid-template-columns: 1fr
    }

    .blog-post-image-wrapper.featured,
    .blog-post-image-wrapper.featured.blog-page,
    .blog-post-image-wrapper.featured.cms {
        height: 300px
    }

    .blog-post-image-wrapper.featured.resources-hero {
        height: 260px
    }

    .blog-post-image-wrapper._300px {
        height: 240px
    }

    .paragraph-16px.blog-category-text {
        margin-bottom: 0;
        padding-left: 12px;
        padding-right: 12px;
        font-size: 14px
    }

    .paragraph-16px.copyright-paragraph {
        font-size: 14px
    }

    .heading-32px {
        font-size: 26px
    }

    .ctas-container {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        padding-top: 80px
    }

    .transparent-white-arrow-button {
        padding-left: 24px;
        padding-right: 24px
    }

    .footer-wrapper {
        padding-top: 60px
    }

    .footer-top-container {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        flex-direction: column;
        align-items: flex-start
    }

    .brand-logos-wrapper {
        padding: 12px 14px
    }

    .brand-logo.third {
        width: 67px
    }

    .footer-links-column.fifth.new {
        justify-content: center;
        align-items: center
    }

    .footer-link-icon {
        width: 20px;
        height: 20px
    }

    .tribe-tab-link-info-wrapper {
        grid-column-gap: 24px;
        grid-row-gap: 24px
    }

    .tribe-tab-image-contain {
        padding-top: 40px;
        padding-bottom: 40px
    }

    .spend-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .spend-image.c {
        margin-top: -80px
    }

    .spend-block-wrapper {
        grid-column-gap: 10px;
        grid-row-gap: 10px
    }

    .spend-block-wrapper.c,
    .spend-block-wrapper.a {
        min-height: 220px
    }

    .spend-block-wrapper.a.new._1,
    .spend-block-wrapper.a.new._2,
    .spend-block-wrapper.a.new._3 {
        width: 360px;
        display: none
    }

    .spend-block-wrapper.b {
        min-height: 220px
    }

    .spend-sticky-wrapper {
        height: 60vh
    }

    .spend-text-container {
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px
    }

    .sticky-indicator-text-wrapper {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .spend-image-wrapper.first {
        padding: 30px 20px
    }

    .spend-image-wrapper.third {
        padding-left: 0
    }

    .spend-block-icon-contain {
        width: 40px;
        height: 40px
    }

    .spend-text-blocks-contain {
        height: 220px
    }

    .spend-images-grid {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .paragraph-22px {
        font-size: 18px
    }

    .paragraph-22px.sticky-indicator-text {
        font-size: 16px
    }

    .spend-sticky-block {
        top: 80px
    }

    .heading-252.new {
        font-size: 19px
    }

    .reviews-main-wrapper {
        padding-top: 100px
    }

    .reviews-slider {
        max-width: 358px
    }

    .reviews-slide-wrapper {
        flex-direction: column-reverse
    }

    .reviews-slide-image-contain,
    .reviews-slide-text-gradient-wrapper {
        width: 100%
    }

    .review-slide-text-wrapper {
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        padding: 20px 40px 20px 20px
    }

    .reviewer-block {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        flex-direction: column;
        align-items: flex-start
    }

    .reviewer-info-block {
        grid-column-gap: 3px;
        grid-row-gap: 3px
    }

    .review-company-logo {
        height: 30px
    }

    .review-company-logo._32px {
        height: 28px
    }

    .review-company-logo._29px {
        height: 24px
    }

    .review-company-logo._44px {
        height: 36px
    }

    .slider-arrow {
        border-width: 3px;
        flex-flow: row;
        justify-content: flex-start;
        align-items: center;
        margin-top: 100px;
        margin-left: 20px;
        margin-right: 20px;
        display: flex
    }

    .slider-arrow.right {
        right: -10%
    }

    .slider-arrow.right.events {
        top: -160px;
        right: 30%
    }

    .slider-arrow.left {
        left: -10%
    }

    .slider-arrow.left.events {
        justify-content: center;
        align-items: flex-start;
        top: -160px;
        left: 30%
    }

    .slider-arrow.testimonials {
        border-width: 0;
        border-color: var(--light-pink);
        -webkit-text-stroke-color: var(--pabloo-green);
        margin-left: auto;
        margin-right: auto;
        box-shadow: 0 2px 20px -1px rgba(0, 0, 0, .2), 0 2px 5px rgba(0, 0, 0, .2)
    }

    .slider-arrow.testimonials:hover {
        background-color: var(--pabloo-green)
    }

    .slider-arrow.testimonials.left {
        margin: 21px 0 0;
        padding-top: 0;
        top: auto;
        bottom: 0;
        left: 35%;
        overflow: visible
    }

    .slider-arrow.testimonials.right {
        margin: 20px 0 0;
        top: auto;
        bottom: 0;
        left: auto;
        right: 35%
    }

    .review-slide-arrow-icon-embed {
        flex: 1 1;
    }

    .review-slide-arrow-icon-embed.right {
        justify-content: center;
        align-self: center;
        align-items: center;
        display: flex;
        margin-right: -3px;
        margin-bottom: 5px;
    }

    .review-slide-arrow-icon-embed.left {
        justify-content: center;
        align-self: center;
        align-items: center;
        display: flex;
        margin-left: -3px;
    }

    .logos-white-gradient {
        width: 40px
    }

    .reviews-slide {
        object-fit: fill;
        margin-right: 40px
    }

    .home-hero-images-container {
        max-width: 580px;
        margin-right: -5%
    }

    .hero-bubbles-block-wrapper {
        width: 100%;
        max-width: 150px;
        bottom: 6%;
        left: 14%
    }

    .hero-bubbles-block-contain {
        width: auto
    }

    .hero-bubble-image {
        width: 100px;
        max-width: 50px;
        height: 50px
    }

    .calc-anchor {
        top: -70px
    }

    .navigation-links-grid {
        grid-template-columns: 1fr
    }

    .navbar-dropdown-text {
        font-size: 16px
    }

    .dropdown-resources-column {
        flex-direction: column
    }

    .resource-dropdown-image-contain {
        width: 30%;
        height: 140px
    }

    .resource-dropdown-info-block {
        width: 70%
    }

    .spend-anchor.second {
        top: 35%
    }

    .spend-anchor.third {
        top: 55%
    }

    .footer-logo-link {
        padding-left: 0
    }

    .hero-platform-wrapper.integra {
        flex-flow: wrap
    }

    .hero-platform-heading-wrapper.display-flex.include-bg {
        margin-top: 10px
    }

    .hero-platform-cta-wrapper.integra {
        justify-content: center;
        align-items: flex-start
    }

    .blogs-hero-wrapper {
        padding-top: 120px
    }

    .blogs-hero-wrapper.cms {
        padding-top: 140px
    }

    .subscription-form {
        flex-direction: column
    }

    .form-email-text-field,
    .form-email-text-field.resource-hero {
        width: 100%;
        max-width: none
    }

    .blogs-tab-link {
        min-width: 80px;
        font-size: 16px
    }

    .blog-tabs-info-wrapper {
        max-width: 500px
    }

    .ctas-form-wrapper {
        padding: 30px 24px
    }

    .form-fields-contain._4px-margin {
        margin-bottom: 4px
    }

    .white-form-field {
        padding-left: 16px;
        padding-right: 16px;
        font-size: 18px
    }

    .ctas-form {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .form-select-field {
        background-position: 95%;
        padding-left: 16px;
        font-size: 18px
    }

    .div-block-732 {
        height: 100px;
        margin-top: -142px
    }

    .blog-cms-info-wrapper {
        padding-bottom: 100px
    }

    .block-rich-text h1 {
        font-size: 48px
    }

    .block-rich-text h2 {
        font-size: 42px
    }

    .block-rich-text h3 {
        font-size: 38px
    }

    .block-rich-text h4 {
        font-size: 32px
    }

    .block-rich-text h5 {
        font-size: 26px
    }

    .block-rich-text h6 {
        font-size: 22px
    }

    .block-rich-text p {
        margin-bottom: 24px;
        font-size: 16px
    }

    .block-rich-text ul,
    .block-rich-text ol {
        margin-bottom: 28px
    }

    .block-rich-text li {
        margin-bottom: 4px;
        font-size: 16px
    }

    .block-rich-text blockquote {
        background-position: 30px 30px;
        background-size: 34px;
        padding: 80px 30px 30px;
        font-size: 24px
    }

    .feature-wrap {
        flex-direction: row;
        justify-content: center;
        align-items: center
    }

    .feature-image-wrapper.right.green-bg {
        padding-right: 2px
    }

    .feature-image-wrapper.left.pink-bg {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 0;
        padding-left: 0;
        display: flex
    }

    .feature-content-heading-text {
        font-size: 22px
    }

    .feature-content-body-text {
        font-size: 14px
    }

    .subscribe-form-main-wrapper {
        padding: 30px 24px
    }

    .author-block {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .author-container {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .related-blogs-wrapper {
        max-width: 500px;
        padding-bottom: 100px
    }

    .related-header {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        flex-wrap: wrap
    }

    .fs-cc-prefs3_submit {
        margin-left: 0
    }

    .fs-cc-prefs3_buttons-wrapper {
        flex-direction: column
    }

    .fs-cc-banner3_container {
        flex-direction: column;
        align-items: flex-start
    }

    .fs-cc-banner3_buttons-wrapper {
        margin-top: 1rem
    }

    .fs-cc-prefs3_buttons-block {
        margin-bottom: 1rem
    }

    .transparent-arrow-button-white {
        padding-left: 24px;
        padding-right: 24px
    }

    .resources-hero-wrapper {
        padding-top: 120px
    }

    .resource-tabs-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .resource-tab-heading-contain {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .resource-tab-icon-embed {
        width: 28px;
        height: 28px
    }

    .resource-collection-list {
        grid-column-gap: 20px;
        grid-row-gap: 40px
    }

    .resource-post-image-wrapper {
        height: 240px
    }

    .div-block-733 {
        grid-template-columns: 1fr 1fr
    }

    .book-demo-form-graphic-1,
    .image-222 {
        display: none
    }

    .blog-tabs-seach-input {
        padding-left: 6px;
        font-size: 16px
    }

    .blog-tabs-search-wrapper {
        padding-top: 6px;
        padding-bottom: 6px;
        padding-left: 40px
    }

    .blog-search-icon {
        width: 24px;
        height: 24px;
        left: 12px
    }

    .blog-tag-radio-buttons-contain {
        justify-content: center;
        align-items: center
    }

    .load-more-button,
    .resources-radio-button-wrap {
        font-size: 16px
    }

    .resource-tab-form-separator {
        max-width: 300px
    }

    .procurement-team-cards-grid {
        grid-template-columns: 1fr 1fr
    }

    .procurement-team-member-card {
        margin: 8px
    }

    .paragraph-146 {
        font-size: 16px
    }

    .saas-hero-container {
        grid-column-gap: 60px;
        grid-row-gap: 60px
    }

    .saas-hero-text-wrapper {
        margin-top: 70px
    }

    .saas-hero-wrapper {
        padding-top: 120px
    }

    .saas-hero-absolute-image.second {
        border-radius: 4px;
        width: 45%
    }

    .stats-section-contain {
        padding-top: 20px;
        padding-bottom: 20px
    }

    .flex-image-block {
        padding-top: 40px;
        padding-bottom: 40px
    }

    .flex-image-block.cloud-1 {
        padding-top: 40px
    }

    .flex-block-abs-image.fourth {
        border-radius: 8px
    }

    .solution-callout-wrapper {
        flex-direction: column
    }

    .solution-callout-text-wrapper.cloud {
        grid-column-gap: 26px;
        grid-row-gap: 26px
    }

    .solution-callout-text-wrapper.saas {
        grid-column-gap: 26px;
        grid-row-gap: 26px;
        padding-bottom: 40px
    }

    .solution-callout-images-contain {
        width: 100%;
        max-width: 500px
    }

    .solution-callout-images-contain.saas {
        margin-left: 10%;
        position: static
    }

    .setup-cards-grid {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .cloud-hero-wrapper {
        padding-top: 120px
    }

    .cloud-hero-absolute-image {
        width: 30%;
        left: -2%
    }

    .cloud-hero-absolute-image.second {
        left: -4%
    }

    .cloud-hero-absolute-image.third {
        right: -4%
    }

    .cloud-hero-absolute-image.fourth {
        border-radius: 12px;
        right: -4%
    }

    .heading-258 {
        display: block
    }

    .div-block-424 {
        padding-left: 1px;
        padding-right: 1px
    }

    .sticky-progress-bar-contain {
        height: 3px
    }

    .badge-image {
        max-width: 90px
    }

    .badge-image.new {
        margin-right: auto
    }

    .footer-socials-wrapper {
        flex-wrap: wrap;
        justify-content: center
    }

    .social-link-wrapper {
        width: 48px;
        height: 48px
    }

    .privacy-links-contain {
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        flex-wrap: wrap;
        justify-content: center
    }

    .navigation-icon-embed._32px {
        width: 24px;
        height: 24px
    }

    .ncf-filter-item-container {
        grid-template-columns: 1fr
    }

    .points-checklist-grid {
        grid-column-gap: 10px;
        grid-row-gap: 12px
    }

    .features-wrapper-2 {
        flex-wrap: wrap;
        margin-bottom: -40px
    }

    .competitor-landing-hero-form-2 {
        margin-top: 50px
    }

    .div-block-781 {
        grid-template-columns: 1fr
    }

    .features-block {
        width: 50%;
        margin-bottom: 40px
    }

    .sysf-heading.sysf-l {
        font-size: 1.7rem
    }

    .sysf-section-title,
    .sysf-section-title.sysf-centered,
    .sysf-section-title.sysf-centered {
        width: 100%
    }

    .sysf-container {
        padding-left: 16px;
        padding-right: 16px
    }

    .sysf-faq-item-wrapper,
    .sysf-faq-item-wrapper.sysf-box {
        margin-bottom: 16px
    }

    .brix---display-2 {
        font-size: 48px;
        line-height: 56px
    }

    .brix---stat-card-4-cols---04 {
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0
    }

    .brix---stat-card-4-cols---03 {
        border-width: 0 0 1px;
        border-bottom-left-radius: 0
    }

    .brix---stat-card-4-cols---02 {
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0
    }

    .brix---stat-card-4-cols---01 {
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        border-radius: 0
    }

    .brix---grid-2-stats-v4 {
        grid-template-columns: 1fr 1fr
    }

    .brix---heading-h2-size {
        font-size: 28px;
        line-height: 40px
    }

    .brix---grid-stats-v4 {
        grid-template-columns: 1fr
    }

    .brix---section {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .brix---link-icon-right {
        width: 20px;
        margin-left: 8px
    }

    .brix---text-200-bold {
        font-size: 16px;
        line-height: 18px
    }

    .brix---mg-bottom-48px {
        margin-bottom: 0
    }

    .brix---card-link-content-left-fw {
        align-items: stretch
    }

    .brix---grid-3-columns---1-col-mb {
        grid-template-columns: 1fr
    }

    .bold-text-26 {
        font-size: 32px
    }

    .button-new {
        text-align: center;
        width: 100%
    }

    .button-48 {
        text-align: center;
        padding-top: 13px;
        padding-bottom: 13px;
        font-size: 13px;
        line-height: 1.1
    }

    .container-1287 {
        padding-left: 31px;
        padding-right: 31px
    }

    .image-230 {
        height: 220px
    }

    .new-product-heading-4 {
        font-size: 40px
    }

    .image-231,
    .image-232 {
        height: 270px
    }

    .hero-platform-wrapper-solutions {
        padding-top: 120px
    }

    .heading-64px-copy {
        font-size: 48px
    }

    .heading-64px-copy.hero-home-heading {
        font-size: 46px
    }

    .heading-64px-copy.text-align-center {
        padding-left: 33px;
        padding-right: 33px;
        font-size: 27px
    }

    .heading-64px-new {
        font-size: 48px
    }

    .heading-64px-new.hero-home-heading {
        font-size: 46px
    }

    .heading-64px-new.text-align-center {
        padding-left: 26px;
        padding-right: 26px;
        font-size: 27px
    }

    .image-238 {
        flex: 1 1;
        align-self: center
    }

    .feature-image-wrapper-copy.right.green-bg {
        object-fit: fill;
        flex-direction: row;
        flex: 1 1;
        justify-content: center;
        align-self: auto;
        align-items: center;
        padding-bottom: 0;
        padding-right: 0;
        display: flex
    }

    .image-239 {
        object-fit: contain
    }

    .paragraph-18px-copy.saas-hero-paragraph,
    .paragraph-18px-copy.cloud-hero-paragraph {
        margin-bottom: 16px
    }

    .heading-48px-copy {
        font-size: 38px
    }

    .paragraph-18px-copy {
        font-size: 16px
    }

    .paragraph-18px-copy.integrations-paragraph {
        margin-bottom: 30px
    }

    .paragraph-18px-copy.saas-hero-paragraph,
    .paragraph-18px-copy.cloud-hero-paragraph {
        margin-bottom: 16px
    }

    .heading-28px-copy {
        font-size: 22px
    }

    .div-block-793 {
        margin-bottom: 5px
    }

    .heading-28px-copy-copy {
        font-size: 22px
    }

    .feature-image-wrapper-copy-copy.right.green-bg {
        object-fit: fill;
        flex-direction: row;
        flex: 1 1;
        justify-content: center;
        align-self: auto;
        align-items: center;
        padding-bottom: 0;
        padding-right: 0;
        display: flex
    }

    .stats-wrapper-new {
        margin-top: 11px
    }

    .stats-wrapper-copy {
        margin-top: 11px
    }

    .stats-section-copy {
        margin-top: 0
    }

    .feature-image-wrapper-copy.left.pink-bg {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 0;
        padding-left: 0;
        display: flex
    }

    .div-block-732-copy {
        height: 100px;
        margin-top: -142px
    }

    .feature-image-wrapper-copy-copy-copy.right.green-bg {
        object-fit: fill;
        flex-direction: row;
        flex: 1 1;
        justify-content: center;
        align-self: auto;
        align-items: center;
        padding-bottom: 0;
        padding-right: 0;
        display: flex
    }

    .home-value-heading-copy {
        margin-bottom: 25px
    }

    .container-1289 {
        padding-left: 4px;
        padding-right: 4px
    }

    .div-block-20-copy {
        margin-top: 24px;
        padding-top: 10%;
        padding-left: 24px;
        padding-right: 24px
    }

    .div-block-21-copy.registration-form-block {
        padding-left: 16px;
        padding-right: 15px
    }

    .image-231-copy {
        height: 270px
    }

    .wrapper-1280px-copy.discover-new-product-flex {
        padding-top: 0
    }

    .wrapper-1280px-copy.discover-purchase-flex,
    .wrapper-1280px-copy.discover-tools-flex,
    .wrapper-1280px-copy.procurement-black-flex,
    .wrapper-1280px-copy.contract-renewals-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .navbar-brand-three {
        padding-left: 0
    }

    .nav-menu-three {
        border-radius: 20px;
        flex-direction: column;
        padding-bottom: 30px
    }

    .nav-menu-block {
        flex-direction: column
    }

    .nav-link-6 {
        padding-top: 10px;
        padding-bottom: 10px;
        display: inline-block
    }

    .nav-dropdown {
        flex-direction: column;
        align-items: center;
        display: flex
    }

    .nav-dropdown-toggle {
        padding-top: 10px;
        padding-bottom: 10px
    }

    .nav-dropdown-list.shadow-three {
        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)
    }

    .nav-dropdown-list.shadow-three.w--open {
        position: relative
    }

    .nav-dropdown-list.shadow-three.mobile-shadow-hide {
        box-shadow: none
    }

    .nav-link-accent {
        margin-right: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: inline-block
    }

    .mobile-margin-top-10 {
        margin-top: 10px
    }

    .hello-bar-link {
        font-size: 12px
    }

    .new-hello-bar {
        padding-left: 26px;
        padding-right: 26px
    }

    .hello-navigation-bar {
        margin-top: -5px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .hello-navbar-container {
        padding-top: 10px;
        padding-bottom: 5px
    }

    .heading-90px-copy {
        font-size: 60px;
        line-height: 120%
    }

    .heading-24px-copy {
        font-size: 20px
    }

    .heading-24px-copy.review-text {
        font-size: 18px
    }

    .home-hero-heading-copy {
        font-size: 36px;
        line-height: 42px
    }

    .wrapper-1300px-copy,
    .wrapper-1300px-copy-copy {
        padding-top: 8px
    }

    .stats-grid-copy {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        grid-template-columns: 1fr;
        max-width: 360px
    }

    .wrapper-1300px-copy,
    .wrapper-1300px-copy-copy {
        padding-top: 8px
    }

    .paragraph-152 {
        text-align: center;
        /* margin-left: 10px */
    }

    .collection-list-8 {
        grid-template-columns: 1fr
    }

    .blog-hero-heading-copy {
        font-size: 40px;
        line-height: 40px
    }

    .text-block-330 {
        margin-bottom: 29px
    }

    .cms-blog-block-section-copy.templates-block {
        margin-top: -176px
    }

    .wrapper-1300px-copy {
        padding-top: 8px
    }

    .new-about-1300px-header {
        margin-top: 0;
        padding-top: 0
    }

    .new-about-hero-wrapper {
        padding-bottom: 10px
    }

    .xs-text {
        font-size: 45px
    }

    .about-heading-x {
        letter-spacing: 0;
        width: 100%;
        padding-left: 62px;
        padding-right: 62px;
        font-size: 40px
    }

    .about-hero-text-wrap-copy {
        font-size: 16px
    }

    .stats-section-copy-copy,
    .stats-about {
        margin-top: 0
    }

    .stats-wrapper-copy-copy,
    .stats-xx {
        margin-top: 11px
    }

    .div-block-801.integra {
        width: 90%
    }

    .div-block-805,
    .div-block-805.integra {
        grid-template-columns: 1fr
    }

    .tribe-tab-image-contain-copy {
        padding-top: 40px;
        padding-bottom: 40px
    }

    .ctas-container-copy,
    .about-x-platform-container {
        grid-column-gap: 60px;
        grid-row-gap: 25px;
        padding-top: 80px
    }

    .about-x-cards {
        grid-template-columns: 1fr;
        width: 70%
    }

    .about-x-cards.new {
        width: 90%
    }

    .tabs-menu-5 {
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        object-fit: fill;
        grid-template-columns: 1fr
    }

    .integra-tab,
    .integra-tab.w--current {
        width: 90%
    }

    .pricing-block {
        margin-right: 20px
    }

    .text-block-345,
    .text-block-346 {
        font-size: 22px
    }

    .pricing-cards {
        grid-template-columns: 1fr
    }

    .div-block-815 {
        width: 100%;
        padding: 12px 25px
    }

    .container-1291 {
        margin-left: 15px;
        margin-right: 15px
    }

    .faq-wrapper-x {
        padding-left: 10px;
        padding-right: 10px
    }

    .paragraph-153 {
        padding-top: 11px
    }

    .div-block-818 {
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        flex-flow: column
    }

    .div-block-819 {
        grid-template-columns: 1fr
    }

    .section-72 {
        padding-left: 28px;
        padding-right: 28px
    }

    .section-72.what-is-in {
        padding-left: 29px;
        padding-right: 29px
    }

    .section-72.events {
        background-color: var(--soft-pink);
        padding-left: 20px;
        padding-right: 20px
    }

    .section-72.testimonial {
        padding-top: 62px;
        padding-left: 20px;
        padding-right: 20px
    }

    .section-72.expectation {
        padding-left: 20px;
        padding-right: 20px
    }

    .section-72.webx {
        background-color: var(--soft-pink)
    }

    .section-72.optimize {
        padding-bottom: 136px
    }

    .section-72.block3 {
        margin-top: 0;
        padding-top: 73px
    }

    .div-block-824 {
        padding-left: 49px
    }

    .text-block-357 {
        font-size: 38px;
        line-height: 1.1
    }

    .text-block-358 {
        text-align: justify
    }

    .div-block-827 {
        padding-left: 0;
        padding-right: 0
    }

    .div-block-828 {
        width: 100%;
        padding: 25px
    }

    .text-block-359 {
        text-align: center;
        font-size: 38px;
        line-height: 1.1
    }

    .div-block-829 {
        flex-flow: column;
        padding-left: 28px;
        padding-right: 28px
    }

    .div-block-829.why {
        padding-top: 62px;
        padding-left: 28px;
        padding-right: 28px
    }

    .div-block-830 {
        width: 100%
    }

    .div-block-830.why {
        width: 70%;
        padding-left: 31px
    }

    .text-block-360 {
        font-size: 32px
    }

    .div-block-832.why {
        margin-top: 17px
    }

    .text-block-361 {
        font-size: 32px
    }

    .div-block-833 {
        flex-flow: column
    }

    .div-block-835 {
        border-top-left-radius: 10px;
        border-top-right-radius: 30px;
        flex-flow: column;
        padding: 55px 45px
    }

    .div-block-836 {
        width: 100%
    }

    .div-block-838 {
        margin-top: 43px
    }

    .text-block-366,
    .text-block-367,
    .text-block-368,
    .text-block-369 {
        font-size: 16px
    }

    .div-block-841 {
        flex-flow: column;
        justify-content: center;
        align-items: flex-start
    }

    .text-block-372 {
        flex: 0 1 auto;
        font-size: 16px
    }

    .div-block-843 {
        margin-bottom: 86px
    }

    .partners.partner-logos {
        border-left-width: 0
    }

    .div-block-845 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center
    }

    .testimonialx {
        padding-left: 40px
    }

    .slider-20 {
        margin-top: 1px
    }

    .text-block-376 {
        text-align: center;
        margin-bottom: 89px
    }

    .text-block-377 {
        line-height: 1
    }

    .text-block-378 {
        width: 90%
    }

    .event-expectation {
        height: 300px
    }

    .text-block-380 {
        font-size: 34px
    }

    .div-block-851 {
        padding-top: 69px;
        padding-bottom: 69px
    }

    .rich-text-block-30 {
        margin-top: 0
    }

    .div-block-853 {
        padding-left: 20px;
        padding-right: 20px
    }

    .div-block-854 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        line-height: .5
    }

    .text-span-309 {
        line-height: 0
    }

    .div-block-855 {
        flex-flow: column
    }

    .div-block-857 {
        flex: 0 1 auto;
        margin-left: 0
    }

    .about-pabloo-events {
        margin-top: 183px
    }

    .div-block-858 {
        grid-template-columns: 1fr 1fr
    }

    .text-block-385 {
        width: 100%
    }

    .feature-block-item.yellow1 {
        padding-right: 5%
    }

    .feature-block-content-logo {
        align-self: auto;
        height: 60px
    }

    .feature-text-header {
        font-size: 26px
    }

    .text-block-386 {
        font-size: 16px
    }

    .div-block-861 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .div-block-861.slider {
        padding-left: 10px;
        padding-right: 10px;
        display: flex
    }

    .div-block-862 {
        width: 300px;
        height: 300px;
        /*padding-top: 20px*/
    }

    .div-block-863 {
        flex: 0 1 auto;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px
    }

    .tabs-3 {
        display: none
    }

    .tabs-menu-6 {
        grid-template-columns: 1fr 1fr
    }

    .text-block-387 {
        font-size: 22px
    }

    .image-262 {
        object-fit: fill
    }

    .text-block-388 {
        text-align: center;
        font-size: 16px
    }

    .logos-quote-block {
        padding: 60px 15px
    }

    .clients-wrapper-two {
        flex-direction: column
    }

    .clients-card {
        width: 100%;
        margin-bottom: 30px
    }

    .clients-grid {
        grid-column-gap: 40px;
        grid-template-columns: 1fr 1fr 1fr;
        margin-top: 15px
    }

    .slider-21 {
        flex-flow: column;
        display: block
    }

    .slide-23 {
        background-color: var(--white);
        object-fit: fill;
        height: 100%;
        margin-bottom: -3px;
        padding-bottom: 0;
        position: static
    }

    .mask-10 {
        height: auto;
        margin-left: 10px;
        margin-right: 10px;
        padding-left: 0;
        padding-right: 0
    }

    .slider-22 {
        background-color: var(--white);
        flex-flow: column;
        flex: 0 1 auto;
        order: 0;
        justify-content: center;
        align-self: auto;
        align-items: flex-start;
        width: 100%;
        height: auto;
        padding-left: 40px;
        padding-right: 40px;
        display: block;
        position: relative
    }

    .icon-2,
    .icon-3 {
        margin-top: 100px
    }

    .slide-nav-9 {
        display: none
    }

    .tabs-menu-7,
    .tabs-content-5 {
        height: 400px
    }

    .text-block-389 {
        font-size: 16px
    }

    .div-block-868 {
        height: 400px;
        padding-left: 20px;
        padding-right: 20px
    }

    .text-block-391 {
        font-size: 60px
    }

    .div-block-870 {
        object-fit: none;
        width: 100%;
        height: 300px;
        margin-top: 60px;
        margin-bottom: 25px;
        display: none
    }

    .div-block-871 {
        background-color: var(--soft-pink);
        background-image: none
    }

    .div-block-872 {
        width: 80%
    }

    .div-block-874 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .text-block-394 {
        text-align: center;
        flex: 0 1 auto
    }

    .div-block-880 {
        flex-flow: wrap
    }

    .div-block-881.new {
        width: 100%
    }

    .text-block-398 {
        width: 80%
    }

    .div-block-886 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .text-block-407 {
        text-align: center;
        margin-bottom: 15px
    }

    .div-block-888 {
        flex-flow: column;
        justify-content: center;
        align-items: center;
        display: flex
    }

    .div-block-889 {
        justify-content: center;
        align-items: center;
        padding-left: 0
    }

    .image-270 {
        text-align: center
    }

    .div-block-891 {
        width: 90%
    }

    .div-block-892.fold3 {
        padding-bottom: 50px
    }

    .div-block-892.fold3.fold4 {
        border-bottom-right-radius: 30px;
        border-bottom-left-radius: 30px;
        margin-bottom: 15px;
        padding-bottom: 82px
    }

    .text-block-410 {
        text-align: center
    }

    .button-53 {
        text-align: left;
        justify-content: flex-start;
        align-self: center;
        align-items: flex-start;
        display: block
    }

    .text-block-412 {
        text-align: center;
        font-size: 50px
    }

    .div-block-898 {
        grid-column-gap: 36px;
        grid-row-gap: 36px;
        justify-content: center;
        align-items: center
    }

    .text-block-414 {
        text-align: center
    }

    .div-block-899,
    .div-block-899.two,
    .div-block-899.three {
        justify-content: flex-start;
        align-items: center
    }

    .image-274 {
        display: none
    }

    .div-block-902 {
        grid-column-gap: 27px;
        grid-row-gap: 27px;
        padding-right: 0
    }

    .text-block-415 {
        text-align: center;
        font-size: 50px
    }

    .div-block-903 {
        padding-left: 10px;
        padding-right: 10px
    }

    .text-block-417 {
        text-align: center
    }

    .text-block-418 {
        line-height: 1.4
    }

    .navbar-logo-left-container {
        max-width: 100%
    }

    .navbar-brand {
        padding-left: 0
    }

    .nav-menu-two {
        border-radius: 20px;
        flex-direction: column;
        padding-bottom: 30px
    }

    .nav-link-7 {
        padding-top: 10px;
        padding-bottom: 10px;
        display: inline-block
    }

    .nav-dropdown-2 {
        flex-direction: column;
        align-items: center;
        display: flex
    }

    .nav-dropdown-toggle-2 {
        padding-top: 10px;
        padding-bottom: 10px
    }

    .nav-dropdown-list-2.shadow-three {
        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)
    }

    .nav-dropdown-list-2.shadow-three.w--open {
        position: relative
    }

    .nav-dropdown-list-2.shadow-three.mobile-shadow-hide {
        box-shadow: none
    }

    .nav-divider {
        width: 200px;
        max-width: 100%;
        height: 1px;
        margin-top: 10px;
        margin-bottom: 10px
    }

    .nav-link-accent-2 {
        margin-right: 5px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: inline-block
    }

    .mobile-margin-top-11 {
        margin-top: 10px
    }

    .text-span-376 {
        font-size: 45px
    }

    .div-block-908 {
        align-items: center;
        justify-items: start
    }

    .div-block-909 {
        width: 100%
    }

    .div-block-910 {
        padding-left: 60px;
        padding-right: 60px
    }

    .text-block-425 {
        font-size: 22px
    }

    .text-block-426 {
        font-size: 14px
    }

    .text-block-427 {
        text-align: left
    }
}

@media screen and (max-width:479px) {
    h2 {
        line-height: 42px
    }

    .page-wrapper {
        aspect-ratio: auto;
        padding-left: 0;
        padding-right: 0;
        overflow: scroll
    }

    .page-wrapper.fix-overflow {
        overflow: visible
    }

    .main-wrapper {
        background-color: var(--white);
        backdrop-filter: none;
        margin-top: 0
    }

    .home-hero-section {
        margin-top: 0;
        margin-bottom: 0
    }

    .wrapper-1300px {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .wrapper-1300px.adjust-padding {
        padding-top: 16px
    }

    .wrapper-1300px.privacy {
        margin-left: 0;
        margin-right: 0
    }

    .large-link-2 {
        justify-content: flex-end;
        margin-left: 8px;
        padding: 16px 6px;
        font-size: 14px;
        display: none
    }

    .large-link-2.show {
        justify-content: center;
        margin-left: 0;
        padding-left: 8px;
        padding-right: 8px;
        display: flex
    }

    .nav-menu {
        height: auto;
        padding-bottom: 0;
        padding-left: 0;
        overflow: visible
    }

    .navigation-right {
        justify-content: space-between;
        margin-right: 8px;
        padding-right: 0;
        display: flex
    }

    .navigation-right.tab-visibility {
        flex-direction: column;
        display: none
    }

    .nav-link-register.hide {
        display: block
    }

    .navigation-left {
        justify-content: flex-start;
        height: auto;
        margin-left: 8px;
        padding-left: 0;
        padding-right: 0;
        display: flex
    }

    .navigation-left.custo {
        width: auto;
        padding-left: 8px;
        padding-right: 8px;
        display: block
    }

    .navigation-container {
        flex-direction: row;
        align-items: center;
        height: auto;
        min-height: auto;
        padding-left: 0;
        padding-right: 0
    }

    .navigation-container.custo {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 0
    }

    .logo {
        width: auto;
        height: 24px;
        max-height: 24px
    }

    .logo.competitor-landing-nav-logo {
        width: auto;
        height: 20px
    }

    .nav-button-text {
        margin-right: 0;
        font-size: 16px
    }

    .brand.w--current {
        margin-right: 0
    }

    .nav-link {
        display: block
    }

    .nav-link.sp {
        background-color: var(--pabloo-green);
        color: var(--white)
    }

    .nav01 {
        height: 70px
    }

    .nav01.sticky {
        padding-top: 16px;
        padding-bottom: 16px
    }

    .menu-button {
        background-color: var(--white);
        border-style: none;
        border-radius: 0% 6px 6px 0%;
        padding: 8px 6px;
        box-shadow: 0 0 8px rgba(0, 0, 0, .1)
    }

    .home-hero-heading {
        line-height: 1.4em
    }

    .home-hero-para {
        line-height: 1.6em
    }

    .button-wrapper.home-hero-btn-wrapper {
        flex-flow: column wrap;
        align-items: stretch;
        width: 100%
    }

    .primary-button {
        text-align: center
    }

    .home-hero-stat-grid {
        flex-wrap: wrap;
        grid-template-columns: 1fr 1fr;
        justify-content: flex-start;
        align-items: flex-start;
        display: flex
    }

    .home-hero-stat-grid.pricing-stat {
        flex-flow: wrap;
        justify-content: flex-start;
        align-items: flex-start
    }

    .home-hero-stat-grid.pricing-stat.pricing-center {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-columns: 1fr;
        margin-top: 32px;
        padding-left: 0;
        padding-right: 8px;
        display: grid
    }

    .home-hero-stat-grid.demo-stat-grid {
        align-items: flex-start;
        display: none
    }

    .home-hero-stat-grid.competitor-landing-page-hero-stat-grid {
        justify-content: flex-start
    }

    .home-hero-stat-item {
        align-items: flex-start;
        width: 100%;
        margin-bottom: 10px
    }

    .home-hero-stat-item.competitor-landing-page-hero-stat-item {
        width: 100%
    }

    .hero-stat-block-square {
        line-height: 20px
    }

    .hero-stat-block-square.demo-stat-block-square {
        height: 12px
    }

    .home-hero-stat-block {
        grid-column-gap: 20px;
        flex-flow: wrap;
        justify-content: center;
        align-self: center;
        align-items: center;
        width: 100%
    }

    .home-hero-stat-number {
        text-align: center;
        width: 100%;
        line-height: 48px
    }

    .home-hero-stat-number.white-text {
        margin-bottom: 0;
        margin-right: 10px;
        line-height: 45px
    }

    .home-hero-stat-number.demo-stat-number {
        margin-bottom: 2px;
        font-size: 28px;
        line-height: 28px
    }

    .home-hero-stat-number.competitor-landing-usps-stat-number {
        text-align: center
    }

    .home-hero-stat-text {
        text-align: left;
        order: 0;
        line-height: 20px
    }

    .home-hero-stat-text.demo-hero-stat-text {
        text-align: left;
        font-size: 12px;
        line-height: 16px
    }

    .hero-image-wrapper {
        width: 90%
    }

    .cards-section {
        margin-bottom: 0;
        padding-left: 0;
        padding-right: 0
    }

    .cards-section.vertical-padding-large {
        margin-left: 21px;
        margin-right: 21px;
        padding-bottom: 64px
    }

    .logo-wrapper-grid {
        grid-column-gap: 30px;
        grid-row-gap: 30px;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-columns: 1fr;
        justify-content: center;
        display: grid
    }

    .logo-wrapper-grid.investors {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-columns: 1fr 1fr;
        grid-auto-flow: row;
        justify-items: stretch;
        margin-bottom: 60px
    }

    .logo-container {
        width: auto;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 0
    }

    .company-logo {
        height: 100%
    }

    .company-logo.accel-logo.fix {
        height: 40px
    }

    .home-value-wrapper {
        padding: 100px 8px
    }

    .home-value-content-wrapper {
        margin-top: 0
    }

    .home-value-heading {
        font-size: 32px;
        line-height: 38px
    }

    .value-image-wrapper-3 {
        width: 250px
    }

    .home-split-section {
        padding-top: 0;
        padding-bottom: 60px
    }

    .home-split-section.light-grey-bg {
        padding: 60px 8px
    }

    .split-section-wrapper.wrapper-logo {
        margin-top: 187px
    }

    .split-section-wrapper.reverse {
        padding-left: 8px;
        padding-right: 8px
    }

    .split-section-content-container,
    .split-section-content-container.first {
        margin-top: 0
    }

    .split-section-content-container.first.spaced-top {
        margin-top: 48px
    }

    .split-section-heading {
        letter-spacing: 0;
        font-size: 32px;
        line-height: 38px
    }

    .split-section-heading.max-width-560px,
    .split-section-heading.max-width-520px {
        line-height: 38px
    }

    .split-section-heading.max-width-560px {
        font-size: 28px;
        line-height: 150%
    }

    .blue-button {
        font-size: 16px
    }

    .split-image-wrapper {
        margin-top: 16px;
        margin-bottom: 24px
    }

    .split-image-2 {
        max-width: 200px
    }

    .split-image-wrapper-2.split-image-wrapper-3,
    .split-image-wrapper-2.h-auto {
        height: auto
    }

    .home-work-wrapper.slack-steps-wrapper {
        padding-left: 0;
        padding-right: 0
    }

    .slide-nave-hide {
        position: static;
        top: auto;
        bottom: -8%;
        left: 0%;
        right: 0%
    }

    .mask-visible {
        width: 90%
    }

    .mask-visible._480px {
        width: 95%;
        max-width: none
    }

    .review-section {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .review-head-wrapper {
        margin-bottom: 40px
    }

    .review-heading {
        letter-spacing: 0;
        font-size: 24px;
        line-height: 32px
    }

    .review-slider-wrapper {
        width: 100%
    }

    .review-slider {
        flex-wrap: wrap;
        width: 100%;
        max-width: 100%;
        height: auto
    }

    .review-slide {
        width: 100%;
        height: auto;
        padding: 32px 0 0
    }

    .review-slider-container {
        padding-bottom: 0;
        padding-left: 24px
    }

    .review-slider-container.home {
        padding-left: 16px;
        padding-right: 16px
    }

    .review-company-image-container {
        height: 24px;
        display: block
    }

    .review-company-image-container.airmeet-logo-wrapper {
        height: 24px
    }

    .review-slider-content-wrapper {
        min-height: auto;
        margin-bottom: 32px
    }

    .review-slider-text {
        font-weight: 400
    }

    .review-slider-author-wrapper {
        flex-direction: row;
        align-items: flex-start
    }

    .review-author-info-wrapper {
        grid-column-gap: 4px;
        grid-row-gap: 4px;
        grid-template-columns: auto;
        align-items: start;
        margin-top: 0;
        margin-bottom: 16px;
        margin-left: 8px
    }

    .review-author-job-post {
        font-size: 12px;
        line-height: 16px
    }

    .home-pointers-section {
        padding-left: 8px;
        padding-right: 8px
    }

    .home-pointers-image-wrapper {
        width: 100%
    }

    .home-pointer-split-content-wrapper {
        margin-top: 40px
    }

    .pitch-section {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .pitch-heading {
        letter-spacing: 0;
        padding-left: 18px;
        padding-right: 18px;
        font-size: 26px;
        line-height: 109%
    }

    .pitch-illustration-wrapper {
        flex-direction: column;
        align-items: center;
        width: 100%
    }

    .pitch-illustration-head {
        width: 160px;
        margin-bottom: 40px
    }

    .pitch-brach-wrapper {
        display: none
    }

    .branch-card-wrapper {
        align-self: auto;
        width: 100%
    }

    .branch-card-wrapper.three-columns {
        grid-template-columns: 1fr
    }

    .pitch-card-head {
        font-size: 20px
    }

    .pitch-card-para.persona {
        font-size: 16px
    }

    .home-support-section {
        padding-left: 8px;
        padding-right: 8px
    }

    .support-content-wrapper {
        width: 100%
    }

    .faq-container {
        padding-left: 20px;
        padding-right: 20px
    }

    .faq-question {
        font-size: 18px
    }

    .faq-answer {
        font-size: 17px
    }

    .cta-split-wrapper {
        padding-left: 8px;
        padding-right: 8px
    }

    .cta-split-wrapper.competitor-cta-section {
        padding: 40px 16px
    }

    .cta-split-wrapper.align-center {
        padding-top: 40px;
        padding-bottom: 40px
    }

    .cta-split-content-wrapper.width-sm {
        width: 100%
    }

    .cta-split-heading {
        line-height: 38px
    }

    .white-alter-span {
        display: inline
    }

    .white-alter-span.white {
        font-size: 32px
    }

    .cta-image-wrapper,
    .cta-image-wrapper.flex.width-md {
        width: 100%
    }

    .footer {
        padding-bottom: 40px;
        padding-left: 8px;
        padding-right: 8px
    }

    .copyright-text {
        flex: 0 1 auto
    }

    .copyright-text.competitor-landing {
        font-size: 14px
    }

    .footer-down-link {
        margin-left: 10px;
        margin-right: 10px
    }

    .footer-down-link.first.competitor-landing {
        font-size: 14px
    }

    .footer-down-link.last {
        margin-right: 0
    }

    .footer-down-link.last.competitor-landing {
        margin-left: 0;
        font-size: 14px
    }

    .footer-down-link-wrapper.competitor-landing-footer-down-link-wrapper {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto auto;
        grid-template-columns: 1fr 1fr;
        grid-auto-columns: 1fr;
        display: grid
    }

    .home-slider-section-heading {
        letter-spacing: 0;
        font-size: 32px;
        line-height: 38px
    }

    .pricing-heading {
        font-size: 37px;
        line-height: 150%
    }

    .auto-slider-arrow-left {
        display: none;
        bottom: 10%;
        left: auto;
        right: 80px
    }

    .auto-slider-arrow-right {
        display: none;
        bottom: 10%;
        left: auto;
        right: 32px
    }

    .auto-slider-arrow-right.home.show {
        position: static;
        bottom: 0;
        right: 0
    }

    .contact-hero-section {
        margin-top: 0
    }

    .contact-hero-wrapper {
        margin-top: 175px
    }

    .contact-hero-heading {
        font-size: 40px;
        line-height: 48px
    }

    .contact-field-wrapper {
        grid-row-gap: 20px;
        grid-template-columns: 1fr
    }

    .contact-field-block {
        margin-right: 0
    }

    .contact-form-select {
        margin-left: -4px;
        padding-left: 0;
        display: flex
    }

    .contact-message {
        margin-bottom: 0
    }

    .email-span {
        font-size: 25px;
        display: block
    }

    .blog-hero-heading {
        max-width: none;
        font-size: 36px;
        line-height: 38px
    }

    .blog-feature-section {
        top: -289px
    }

    .blog-feature-wrapper {
        padding: 16px
    }

    .blog-feature-wrapper.custo {
        border-width: 6px;
        padding: 8px
    }

    .wrapper-1080px,
    .wrapper-1080px.blog-wrapper {
        width: 90%
    }

    .blog-feature-block {
        grid-row-gap: 23px;
        grid-template-rows: auto auto
    }

    .blog-feature-block.guide {
        grid-template-columns: 1fr
    }

    .blog-feature-image-container {
        height: 180px
    }

    .blog-feature-image {
        height: 100%
    }

    .blog-feature-content-wrapper {
        padding-left: 11px;
        padding-right: 11px
    }

    .blog-feature-info-top {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 12px
    }

    .blog-feature-info-top.spread,
    .blog-tag-text {
        font-size: 13px
    }

    .blog-date {
        font-size: 13px;
        line-height: 22px
    }

    .divider-circle {
        display: none
    }

    .blog-feature-heading {
        font-size: 18px;
        line-height: 1.3
    }

    .blog-feature-para {
        margin-top: 16px;
        margin-bottom: 18px;
        font-size: 12px;
        line-height: 1.5
    }

    .blog-feature-author-block {
        margin-top: 30px
    }

    .blog-feature-author-block.blog-collection {
        margin-bottom: 40px
    }

    .cms-blog-block-section {
        padding-bottom: 140px
    }

    .blog-filter-tab {
        flex-flow: column wrap;
        align-items: center
    }

    .blog-tab {
        justify-content: center;
        width: 100%;
        margin-left: 0;
        display: flex
    }

    .blog-collection-item {
        padding-left: 8px;
        padding-right: 8px
    }

    .blog-collection-item.margin.custo {
        border-width: 6px;
        margin-right: 0;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .blog-collection-item.limit-width.custo {
        border-width: 6px;
        margin-top: 16px;
        margin-left: 0;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .blog-card-image-container {
        height: 180px
    }

    .blog-card-heading {
        margin-bottom: 8px;
        font-size: 20px;
        line-height: 1.2
    }

    .blog-card-para {
        font-size: 16px;
        line-height: 22px
    }

    .blog-card-para.custo {
        margin-top: 10px;
        font-size: 14px
    }

    .blog-collection-hero-section {
        padding-top: 48px
    }

    .blog-collection-heading {
        font-size: 48px
    }

    .blog-collection-para {
        font-size: 18px
    }

    .blog-main-image-wrapper {
        margin-bottom: 24px
    }

    .blog-rich-text-section {
        flex-wrap: wrap;
        height: 100%;
        padding-bottom: 0;
        display: flex;
        position: relative;
        overflow: visible
    }

    .more-blog-section {
        padding-top: 8px;
        padding-bottom: 8px
    }

    .more-blog-head {
        margin-bottom: 24px
    }

    .blog-contact-container {
        flex-direction: column;
        align-items: flex-start
    }

    .blog-designer-wrapper {
        width: 100%;
        margin-left: 0
    }

    .home-slider-image-1,
    .home-slider-image-2 {
        width: 50%
    }

    .pricing-hero-table {
        grid-template-columns: 1fr
    }

    .pricing-table-left,
    .pricing-table-right {
        padding-left: 20px;
        padding-right: 20px
    }

    .price-point {
        font-size: 18px;
        line-height: 25px
    }

    .html-embed-2 {
        margin-top: 28px;
        margin-bottom: 21px
    }

    .wrapper-1280px {
        flex-direction: column;
        justify-content: space-between;
        width: 90%
    }

    .wrapper-1280px.solution-wrapper,
    .wrapper-1280px.split-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px.finance-wrapper {
        padding-top: 80px
    }

    .wrapper-1280px.case-study-hero-flex {
        padding-top: 60px;
        padding-bottom: 50px
    }

    .wrapper-1280px.case-study-flex {
        padding-top: 50px;
        padding-bottom: 50px
    }

    .wrapper-1280px.fast-track-approval-hero-flex {
        padding-top: 60px
    }

    .wrapper-1280px.document-one-place-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px.assisted-tools-flex {
        padding-bottom: 100px
    }

    .wrapper-1280px.assisted-purchasing-flex {
        margin-top: 0;
        padding-top: 60px
    }

    .wrapper-1280px.actionable-insight-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px.custo {
        padding-top: 40px;
        padding-bottom: 40px
    }

    .wrapper-1280px.points-container {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .popup-close {
        width: 40px;
        height: 40px;
        top: 50px;
        right: 0%
    }

    .home-work-section-slider,
    .home-work-section-slider.competitor-landing-page-how-it-works-slider {
        padding-left: 8px;
        padding-right: 8px
    }

    .privacy-content-wrapper {
        flex-direction: row;
        flex: 0 1 auto;
        justify-content: flex-start;
        align-items: center;
        width: 100%
    }

    .privacy-rich-text h2 {
        font-size: 36px
    }

    .privacy-rich-text p {
        font-size: 16px;
        line-height: 150%
    }

    .privacy-rich-text h4 {
        font-size: 17px
    }

    .blog-featured-heading {
        font-size: 24px
    }

    .blog-featured-para {
        font-size: 16px;
        line-height: 24px
    }

    .popup-container {
        width: 100%;
        padding: 22px
    }

    .popup-heading {
        font-size: 24px;
        line-height: 26px
    }

    .popup-text-field::placeholder {
        font-size: 16px
    }

    ._16-px {
        flex-wrap: wrap-reverse;
        display: flex
    }

    .about-hero-paragraph {
        font-size: 13px
    }

    .about-hero-point-wrap {
        flex-direction: column;
        align-items: flex-start
    }

    .about-point-icon {
        margin-bottom: 10px;
        margin-right: 0
    }

    .about-hero-wrapper {
        background-position: 0%, 100%
    }

    .about-team-heading {
        letter-spacing: 0;
        font-size: 32px
    }

    .team-grid.speakers-grid-webinar {
        grid-template-columns: 1fr;
        justify-content: flex-start;
        max-width: 100%;
        display: flex
    }

    .team-grid.speakers-grid-webinar.volopay-speakers {
        grid-template-columns: 1fr 1fr
    }

    .member-image._1.member-image-webinar.volopay-speaker-image,
    .member-image._2.member-image-webinar.volopay-speaker-image {
        max-height: 120px
    }

    .member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller.pb-0 {
        object-fit: contain
    }

    .member-name.volopay-member-name {
        font-size: 16px
    }

    .member-company {
        font-size: 12px
    }

    .career-wrapper {
        padding-top: 100px
    }

    .career-block {
        padding-left: 24px;
        padding-right: 24px
    }

    .career-paragraph {
        font-size: 20px
    }

    .career-heading {
        letter-spacing: 0;
        font-size: 32px
    }

    .about-slide {
        max-height: none;
        margin-right: 20px
    }

    .about-slider-contain {
        padding: 0
    }

    .about-slider {
        width: 100%
    }

    .left-arrow-about,
    .right-arrow-about {
        bottom: -26%
    }

    .about-subheading {
        font-size: 22px;
        line-height: 120%
    }

    .about-slide-text {
        font-size: 16px
    }

    .persona-hero-card {
        width: 90%;
        padding: 20px
    }

    .persona-card-text {
        margin-top: 0;
        font-size: 28px
    }

    .persona-head-para {
        font-size: 16px
    }

    .persona-head-para.it {
        font-size: 18px;
        line-height: 150%
    }

    .persona-hero-button-wrap.margin-top-120 {
        margin-top: 64px
    }

    .persona-solution-para,
    .solution-pointer-wrap {
        font-size: 16px
    }

    .persona-split-section-head {
        margin-bottom: 60px
    }

    .persona-split-section-heading {
        font-size: 32px
    }

    .persona-split-text-container {
        margin-top: 60px
    }

    .persona-split-text {
        font-size: 32px
    }

    .persona-split-para {
        font-size: 16px
    }

    .persona-split-image-container.procurement-section-3-image {
        width: 100%
    }

    .finance-head-wrap {
        margin-bottom: 40px
    }

    .finance-heading {
        font-size: 32px
    }

    .finance-grid-item {
        font-size: 16px
    }

    .persona-block-image {
        margin-bottom: 10px
    }

    .dropdown-list.w--open {
        object-fit: fill;
        overflow: visible
    }

    .persona-dropdown-wrap {
        padding-left: 16px;
        padding-right: 16px
    }

    .persona-dropdown-wrap.product-drop-down {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        overflow: visible
    }

    .persona-dropdown-wrap.resources {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .persona-dropdown-link,
    .persona-dropdown-link.dropdown-link-no-border {
        padding-top: 12px;
        padding-bottom: 12px
    }

    .persona-dropdown-icon {
        width: 32px;
        height: 32px
    }

    .persona-dropdown-title {
        margin-bottom: 4px;
        font-size: 16px
    }

    .persona-dropdown-description {
        font-size: 12px
    }

    .dropdown-toggle.w--open {
        background-color: var(--light-pink)
    }

    .together-blue-heading {
        font-size: 35px
    }

    .discover-product-hero-section {
        padding-bottom: 80px
    }

    .discover-product-hero-section.custo {
        padding-bottom: 40px
    }

    .discover-product-hero-heading {
        font-size: 40px
    }

    .discover-hero-paragraph {
        font-size: 16px
    }

    .discover-hero-pink-line {
        width: 30px
    }

    .discover-hero-pink-text {
        margin-left: 10px;
        margin-right: 10px;
        font-size: 14px
    }

    .discover-new-product-section.discover-new-product-slack {
        margin-top: 32px
    }

    .new-product-heading-44px {
        font-size: 32px
    }

    .new-product-paragraph-18px {
        line-height: 160%
    }

    .new-product-hero-image {
        box-shadow: -8px 8px 0 0 var(--slate-blue);
        border-radius: 4px
    }

    .tools-image-container {
        margin-bottom: 60px
    }

    .tools-image-container.resize-width {
        width: 100%
    }

    .tools-hero-image {
        box-shadow: -8px 8px 0 0 var(--pabloo-green);
        border-radius: 4px
    }

    .procurement-item {
        padding: 30px 15px
    }

    .button-container {
        flex-wrap: wrap;
        justify-content: center
    }

    .case-study-hero-heading {
        font-size: 35px
    }

    .case-study-button-rapper {
        flex-direction: column;
        align-items: flex-start;
        margin-top: 30px;
    }

    .read-stories-button {
        margin-bottom: 10px
    }

    .case-study-hero-pink-text {
        font-size: 16px
    }

    .case-study-item-wrapper {
        padding: 12px 12px 16px
    }

    .case-study-item-text-wrapper {
        margin-top: 16px
    }

    .case-study-item-pink-tag {
        margin-bottom: 8px;
        font-size: 14px
    }

    .case-study-item-heading {
        font-size: 22px
    }

    .case-study-item-para-small {
        font-size: 16px
    }

    .track-appoval-image-container,
    .track-appoval-image-container._w-md {
        width: 100%
    }

    .track-approval-hero-image {
        box-shadow: -7px 7px 0 0 var(--slate-blue)
    }

    .track-approval-hero-image.hide-shadow {
        box-shadow: none
    }

    .track-approval-item-absolute {
        width: 70%;
        right: -2%
    }

    .multi-channel-image-container {
        width: 95%
    }

    .multi-channel-item-wrapper {
        box-shadow: -7px 7px 0 0 var(--pabloo-green)
    }

    .multi-channel-item-wrapper.middle {
        margin-top: 30px;
        margin-bottom: 30px
    }

    .workflow-approval-text-wrapper {
        margin-top: 50px
    }

    .fast-track-approval-hero-section {
        margin-bottom: 140px
    }

    .fast-track-approval-h1-heading {
        margin-bottom: 10px;
        font-size: 35px
    }

    .fast-track-hero-image-wrapper {
        margin-bottom: -50px
    }

    .fast-track-hero-image-wrapper.track-usage {
        width: 90%
    }

    .fast-track-hero-image-wrapper.resize {
        max-width: 96%
    }

    .fast-track-hero-circle.left,
    .fast-track-hero-circle.right {
        width: 100%
    }

    .fast-track-hero-user-element {
        width: 30%
    }

    .fast-track-hero-user-element._4 {
        top: 25%
    }

    .fast-track-hero-user-element.track-usage-2 {
        bottom: 5%;
        left: 20%
    }

    .case-study-hero-logo-item._2 {
        right: -5%
    }

    .footer-top-wrapper {
        padding-top: 16px;
        padding-bottom: 16px
    }

    .footer-top-wrapper.competitor-footer {
        padding-left: 16px;
        padding-right: 16px
    }

    .footer-grid {
        flex-flow: wrap
    }

    .footer-left-contain {
        grid-row-gap: 50px;
        flex-direction: column
    }

    .footer-links {
        font-size: 16px
    }

    .mobile-only {
        display: block
    }

    .split-section-form-wrapper {
        padding: 0
    }

    .form-holder {
        padding: 10px
    }

    .assisted-purchasing-hero-wrapper {
        margin-bottom: 60px
    }

    .assisted-purchasing-hero-wrapper.insights {
        margin-top: 19px
    }

    .assisted-hero-section {
        padding-bottom: 100px
    }

    .assisted-hero-item-wrapper.left,
    .assisted-hero-item-wrapper.right {
        width: 200px;
        bottom: 150px
    }

    .actionable-insight-text-wrap {
        margin-top: 60px
    }

    .actionable-insight-image-wrap.resize-width {
        width: 100%
    }

    .insight-hero-section {
        margin-bottom: 120px
    }

    .insight-hero-section.track-usage {
        margin-bottom: 160px
    }

    .investor-logo,
    .investor-logo.investor-logo-rt-demo-custo-styles,
    .investor-logo.investor-logo-rt-demo-custo-styles.rt-logo.fix {
        width: 100%
    }

    .press-card-image-wrapper {
        box-shadow: none;
        height: auto
    }

    .text-color-white {
        text-align: center;
        font-size: 12px;
        line-height: 24px
    }

    .news-logos {
        width: 100%
    }

    .insights-hero-image {
        width: 90%;
        padding-bottom: 70px
    }

    .insights-hero-image-1 {
        width: 70%
    }

    .insights-hero-image-4 {
        margin-bottom: 140px
    }

    .insights-visualize-image {
        box-shadow: -8px 8px 0 0 var(--pabloo-green)
    }

    .contract-hero-image-wrap {
        margin-bottom: -60px
    }

    .contract-hero-section {
        margin-bottom: 140px
    }

    .hero-subheading {
        font-size: 16px
    }

    .hero-head-container.competitor-landing-usp-highlight-section {
        padding-left: 8px;
        padding-right: 8px
    }

    .hero-heading {
        font-size: 36px
    }

    .hero-heading-wrapper {
        margin-bottom: 20px
    }

    .home-hero-image-blue-shadow {
        box-shadow: 7px 7px 0 0 var(--slate-blue);
        border-radius: 6px
    }

    .home-hero-text-wrapper {
        margin-top: 40px
    }

    .hello-bar {
        flex-flow: wrap;
        padding-left: 8px;
        padding-right: 8px;
        position: sticky;
        top: auto
    }

    .column {
        flex-wrap: wrap
    }

    .div-block {
        margin-top: 4%;
        padding-left: 0
    }

    .heading {
        margin-bottom: 8px;
        font-size: 28px;
        line-height: 1.2
    }

    .heading.center {
        text-align: center;
        /* margin-left: 5px */
    }

    .div-block-2 {
        width: 100%;
        padding-bottom: 12px;
        padding-left: 16px;
        padding-right: 16px
    }

    .container-3 {
        max-width: 100%
    }

    .container-3.margin-top-0 {
        max-width: 96%
    }

    .div-block-9 {
        padding-bottom: 0
    }

    .div-block-10 {
        padding-left: 4px
    }

    .grid-2 {
        align-items: center;
        margin-top: 4px
    }

    .text-block-6 {
        font-size: 18px;
        line-height: 28px
    }

    .div-block-13 {
        margin-top: 8px;
        margin-bottom: 16px
    }

    .div-block-14 {
        margin-top: 8px
    }

    .div-block-15 {
        flex-wrap: wrap
    }

    .div-block-15.m-t-20 {
        margin-top: 20px
    }

    .div-block-15.m-t-20.m-b-40 {
        margin-bottom: 40px
    }

    .text-block-9 {
        font-size: 12px
    }

    .div-block-17 {
        margin-top: 0;
        padding: 2px 6px
    }

    .body-2 {
        object-fit: fill;
        overflow: visible
    }

    .heading-5 {
        font-size: 48px;
        line-height: 56px
    }

    .heading-5.custo {
        font-size: 37px;
        line-height: 1.2em
    }

    .div-block-19 {
        margin-top: 16px
    }

    .div-block-20 {
        width: 100%;
        padding: 32px 8px
    }

    .div-block-21 {
        padding: 24px 16px
    }

    .div-block-21.registration-form-block {
        padding-left: 8px;
        padding-right: 8px
    }

    .container-4 {
        background-color: var(--white);
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        max-width: 100%
    }

    .container-4.custo {
        max-width: 90%
    }

    .div-block-22 {
        flex-flow: column wrap;
        align-items: flex-start
    }

    .div-block-23.alt-badge {
        margin-top: 16px;
        margin-left: 0;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .text-block-11 {
        color: var(--white);
        font-size: 16px
    }

    .text-block-11.roundtable-text {
        font-size: 16px
    }

    .div-block-24 {
        color: #fff;
        margin-top: 16px;
        padding-top: 2px;
        padding-bottom: 2px
    }

    .div-block-24.panel-shadow {
        margin-right: 0;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .div-block-25.panel-shadow {
        grid-column-gap: 4px;
        grid-row-gap: 4px;
        align-items: center;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .div-block-25.panel-shadow.custo {
        padding-top: 2px;
        padding-bottom: 2px
    }

    .div-block-27 {
        top: -24px;
        bottom: auto;
        right: 0
    }

    .div-block-28 {
        padding: 0
    }

    .div-block-29 {
        background-color: var(--white);
        border: 4px red;
        min-height: auto;
        padding-top: 24px;
        padding-bottom: 24px
    }

    .bestsuited-webinarblock {
        min-height: auto;
        padding: 40px 8px;
        display: block
    }

    .bestsuited-webinarblock.hide {
        display: none
    }

    .heading-7 {
        font-size: 28px;
        line-height: 1.2em
    }

    .div-block-33 {
        grid-row-gap: 24px;
        flex-wrap: wrap;
        grid-template-columns: 1fr;
        align-content: stretch;
        justify-content: flex-start;
        align-items: flex-start;
        padding-left: 16px;
        padding-right: 16px
    }

    .grid-3 {
        padding-top: 16px
    }

    .grid-3.m-l-24 {
        width: 100%;
        margin-top: 0;
        margin-left: 0;
        padding-top: 16px
    }

    .text-block-14 {
        font-size: 38px
    }

    .div-block-34 {
        margin-top: 56px;
        padding-left: 12px;
        padding-right: 12px
    }

    .button {
        border-radius: 8px;
        width: 100%;
        height: 56px;
        font-size: 16px
    }

    .div-block-35 {
        background-color: var(--white);
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62b1a53121d721625b5654cd_pattern-bg.png);
        background-repeat: no-repeat;
        background-size: cover;
        min-height: auto;
        margin-top: 40px;
        padding: 24px 0;
        display: block
    }

    .div-block-36 {
        background-color: transparent;
        background-image: none;
        padding-top: 8px;
        padding-bottom: 32px
    }

    .div-block-36.why-attend-block {
        display: none
    }

    .heading-8 {
        text-align: center;
        margin-bottom: 21px;
        font-size: 24px;
        line-height: 30px
    }

    .grid-4 {
        grid-column-gap: 8px;
        grid-row-gap: 8px;
        margin-bottom: 16px
    }

    .text-block-18 {
        font-size: 16px;
        line-height: 20px
    }

    .div-block-37 {
        font-size: 18px
    }

    .div-block-38 {
        background-color: transparent;
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        border-bottom-right-radius: 32px;
        padding: 24px 16px
    }

    .cta-button-roundtable {
        border-radius: 8px;
        width: 100%;
        height: 56px;
        font-size: 16px
    }

    .cta-button-roundtable.cta-button-roundtable-pink {
        border-radius: 8px
    }

    .div-block-39 {
        margin-top: 0;
        padding-left: 0;
        padding-right: 0
    }

    .div-block-40 {
        height: auto;
        padding-top: 16px;
        padding-bottom: 16px;
        display: block
    }

    .container-5 {
        max-width: 100%;
        padding-top: 40px;
        padding-bottom: 40px
    }

    .div-block-41 {
        margin-top: 24px
    }

    .div-block-42 {
        justify-content: center;
        display: flex
    }

    .div-block-45 {
        grid-column-gap: 8px;
        grid-row-gap: 8px;
        margin-bottom: 16px
    }

    .text-block-21 {
        font-size: 18px
    }

    .image-7 {
        width: 100%;
        position: static
    }

    .text-block-22 {
        color: var(--black);
        font-size: 15px
    }

    .columns-2 {
        flex-direction: column-reverse;
        display: flex
    }

    .column-5 {
        background-image: none;
        padding-left: 0;
        padding-right: 0;
        display: block
    }

    .column-6 {
        padding-top: 0%;
        padding-left: 8px;
        padding-right: 8px
    }

    .text-span-7 {
        color: var(--white);
        -webkit-text-stroke-color: var(--white)
    }

    .div-block-52 {
        display: none;
        top: -28%;
        right: auto
    }

    .image-9 {
        display: block
    }

    .image-9.hide {
        display: none
    }

    .image-10 {
        display: block
    }

    .div-block-57 {
        flex-wrap: wrap
    }

    .hero-points-rt {
        background-color: rgba(255, 255, 255, .19);
        margin-top: 8px
    }

    .rt-hero-text {
        color: var(--black);
        font-size: 18px;
        line-height: 30px
    }

    .ebook-hero-points-short {
        justify-content: flex-start
    }

    .container-6 {
        max-width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .div-block-60 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        padding-left: 8px;
        padding-right: 8px
    }

    .heading-9 {
        font-size: 20px
    }

    .heading-10,
    .heading-10.text-white {
        font-size: 24px
    }

    .paragraph-3 {
        font-size: 18px;
        font-weight: 400;
        line-height: 1.4em
    }

    .div-block-61.white {
        padding-top: 48px;
        padding-bottom: 48px;
        display: block
    }

    .div-block-61.white.m-t-40 {
        margin-top: 0;
        padding-top: 0
    }

    .div-block-61.white.p-t-40 {
        padding-left: 15px;
        padding-right: 15px
    }

    .columns-4 {
        display: block
    }

    .button-2 {
        margin-left: 0;
        padding-left: 28px;
        padding-right: 28px
    }

    .button-2.rt-footer-cta {
        border-radius: 8px;
        margin-left: 0
    }

    .heading-11 {
        font-size: 24px;
        line-height: 1.2em
    }

    .column-8 {
        flex-wrap: nowrap;
        flex: 0 1 auto;
        display: block
    }

    .column-9 {
        flex-wrap: wrap;
        flex: 0 1 auto;
        padding-left: 0;
        padding-right: 0;
        display: block
    }

    .container-7 {
        max-width: 100%
    }

    .div-block-63 {
        padding-top: 8px
    }

    .div-block-65 {
        display: none
    }

    .body-3 {
        overflow: visible
    }

    .home-hero-logos-wrap {
        flex-wrap: wrap;
        align-items: center;
        padding-left: 0;
        padding-right: 0
    }

    .home-hero-logo-container {
        margin-top: 0;
        margin-right: 8px;
        padding-top: 4px;
        padding-bottom: 4px;
        padding-left: 10px
    }

    .home-hero-logo-container.gs {
        margin-top: 0
    }

    .div-block-66.margin-reset {
        margin-right: 0
    }

    .div-block-67 {
        width: 20px;
        height: 20px;
        margin-right: 8px
    }

    .div-block-67.gs {
        width: 16px;
        height: 16px
    }

    .image-15 {
        max-width: 100%
    }

    .link-block {
        width: 100%
    }

    .button-3 {
        width: 100%;
        margin-top: 24px;
        margin-left: 0
    }

    .section {
        grid-template-columns: 1fr;
        padding-left: 5px;
        padding-right: 5px
    }

    .section-2 {
        grid-template-columns: 1fr
    }

    .div-block-70 {
        justify-content: flex-start
    }

    .goldman-sachs {
        height: 32px
    }

    .goldman-sachs.accel {
        height: 20px
    }

    .paragraph-12 {
        color: rgba(0, 0, 0, .68);
        width: 100%;
        font-size: 16px
    }

    .div-block-97 {
        position: fixed;
        left: 0%
    }

    .div-block-97.hide {
        display: none
    }

    .div-block-98.pb-md {
        backdrop-filter: none
    }

    .div-block-98.pb-md.pt-sm.flex {
        background-image: none;
        background-position: 0 0;
        background-repeat: repeat;
        background-size: auto
    }

    .blog-subscription-container {
        padding-left: 0;
        padding-right: 0
    }

    .heading-36 {
        font-size: 36px
    }

    .landing-nav.competitor-landing-nav {
        padding-bottom: 0
    }

    .div-block-102 {
        justify-items: center;
        width: 100%
    }

    .div-block-102.child {
        margin-left: 0
    }

    .div-block-104 {
        grid-column-gap: 32px;
        grid-row-gap: 32px;
        padding: 12px 8px
    }

    .div-block-105 {
        grid-template-columns: 1fr
    }

    .paragraph-14,
    .heading-40 {
        text-align: center
    }

    .div-block-109 {
        grid-template-columns: 1fr
    }

    .image-24 {
        margin-top: 32px
    }

    .list-item-9 {
        margin-top: 24px;
        margin-bottom: 48px;
        font-size: 18px
    }

    .list-item-10 {
        margin-bottom: 48px;
        font-size: 18px
    }

    .list-item-11 {
        font-size: 18px
    }

    .div-block-111 {
        grid-template-columns: 1fr
    }

    .section-6 {
        background-color: var(--white-smoke)
    }

    .div-block-112 {
        grid-template-columns: 1fr
    }

    .competitor-landing-hero-grid {
        grid-column-gap: 32px;
        grid-row-gap: 32px;
        grid-template-columns: 1fr;
        padding: 8px 8px 40px
    }

    .competitor-landing-hero-content {
        grid-column-gap: 12px;
        grid-row-gap: 12px
    }

    .competitor-landing-hero-form.minimal-fields {
        background-color: var(--pabloo-green)
    }

    .competitor-landing-hero-section {
        padding-top: 0
    }

    .heading-44 {
        font-size: 40px;
        line-height: 56px
    }

    .paragraph-20 {
        font-size: 18px;
        line-height: 1.4em
    }

    .button-6 {
        padding: 8px;
        font-family: Satoshi, sans-serif;
        font-size: 12px;
        font-weight: 500
    }

    .button-6.w--current {
        padding: 8px 12px;
        font-size: 14px
    }

    .button-6.competitor-ladning-nav-cta,
    .button-6.competitor-ladning-nav-cta.w--current {
        padding-left: 16px;
        padding-right: 16px;
        font-size: 16px
    }

    .div-block-115 {
        background-image: radial-gradient(circle farthest-corner at 50% 100%, var(--pabloo-green), var(--black)53%);
        grid-template-columns: auto
    }

    .div-block-116 {
        display: none
    }

    .div-block-118 {
        width: 80px;
        display: block
    }

    .image-26 {
        border-radius: 0% 0% 0% 8px
    }

    .text-block-48 {
        display: none
    }

    .auto-slider-arrow-left-2 {
        display: none;
        bottom: 10%;
        left: auto;
        right: 80px
    }

    .review-slider-text-2 {
        font-weight: 400
    }

    .text-block-49 {
        display: none
    }

    .div-block-119 {
        background-image: radial-gradient(circle farthest-corner at 0% 100%, #d53987, var(--white)32%);
        grid-template-columns: auto
    }

    .div-block-120 {
        padding-bottom: 40px
    }

    .html-embed-5 {
        margin-bottom: 0
    }

    .image-28 {
        height: 28px
    }

    .h1-heading {
        font-size: 64px
    }

    .header-section {
        height: auto;
        padding-bottom: 60px
    }

    .h3-heading {
        font-size: 36px;
        line-height: 44px
    }

    .feature-grid-large {
        grid-template-columns: 1fr
    }

    .authors-wrapper {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-rows: auto;
        grid-template-columns: 1fr;
        grid-auto-columns: 1fr;
        justify-content: flex-start;
        margin-top: 0;
        display: grid
    }

    .company-logo-2 {
        margin-top: 8px;
        margin-bottom: 8px
    }

    .company-logo-2._1.nivas {
        height: 140px
    }

    .company-logo-2.dan {
        height: 140px;
        margin-left: 0
    }

    .company-logo-2.dan.lg {
        height: 200px
    }

    .ebook-points-heading {
        text-align: left;
        font-size: 16px;
        line-height: 26px
    }

    .ebook-points-heading.custo {
        text-align: left;
        font-size: 18px
    }

    .image-wrapper.darl-mode {
        margin-left: 0;
        margin-right: 0
    }

    .image-wrapper.darl-mode.custo {
        margin-left: 0
    }

    .trusted-text {
        text-align: center
    }

    .hero-heading-2 {
        text-align: left;
        letter-spacing: 0;
        text-transform: capitalize;
        font-size: 2em;
        line-height: 1.2em
    }

    .hero-heading-2.custo {
        text-align: left;
        font-size: 34px
    }

    .header-grid-3 {
        grid-column-gap: 40px;
        grid-row-gap: 40px
    }

    .div-block-123 {
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        display: flex
    }

    .header-section-3 {
        margin-top: 0;
        padding-top: 23px;
        padding-bottom: 60px
    }

    .header-section-3.with-bg {
        background-image: url(https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg);
        background-repeat: no-repeat;
        background-size: 0%
    }

    .process-heading {
        font-size: 32px
    }

    .shape.hide {
        max-width: 50%;
        display: block
    }

    .number-large.medium {
        position: absolute;
        top: -8px
    }

    .process-grid {
        grid-template-columns: 1fr
    }

    .process-section {
        padding-bottom: 40px
    }

    .feature-card {
        padding-top: 40px
    }

    .features-container {
        padding-left: 20px;
        padding-right: 20px
    }

    .team-heading {
        font-size: 32px
    }

    .features-paragraph {
        font-size: 16px;
        font-weight: 300
    }

    .features-button {
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        font-size: 15px;
        font-weight: 500
    }

    .features-button.ab {
        justify-content: flex-start
    }

    .section-regular.middle-band {
        background-position: 50% 100%;
        background-size: contain;
        background-attachment: scroll
    }

    .section-regular.partner-section {
        padding-left: 4px;
        padding-right: 4px
    }

    .form-wrapper-2 {
        flex-direction: column
    }

    .integration {
        min-width: 130px;
        min-height: 120px;
        padding: 16px
    }

    .integration-logo {
        width: 70px
    }

    .cta-block {
        padding: 32px 16px
    }

    .bloom-image-effect-2 {
        display: none
    }

    .bold-text,
    .bold-text-2 {
        font-size: 60px
    }

    .heading-62 {
        font-size: 32px
    }

    .image-cover {
        object-fit: cover;
        object-position: 50% 50%
    }

    .image-cover.not-in-mobile {
        display: none
    }

    .image-cover.mobile-only {
        object-fit: contain;
        display: block
    }

    .header-placeholder-top {
        height: 390px
    }

    .div-block-126 {
        width: 98%;
        margin-top: 50%;
        padding-left: 16px;
        padding-right: 16px
    }

    .heading-63 {
        font-size: 20px;
        line-height: 26px
    }

    .paragraph-33 {
        font-size: 14px;
        line-height: 18px
    }

    .text-block-60 {
        font-size: 12px
    }

    .white-button {
        text-align: center;
        width: 100%
    }

    .div-block-144 {
        padding-left: 8px;
        padding-right: 8px
    }

    .text-block-65 {
        font-size: 14px
    }

    .div-block-145 {
        border-radius: 0;
        padding-left: 8px;
        padding-right: 8px
    }

    .submit-button {
        width: 100%
    }

    .div-block-146,
    .div-block-148 {
        grid-template-columns: 1fr
    }

    .cta-image-2 {
        opacity: .16;
        width: 100%;
        display: block
    }

    .cta-button-wrapper {
        grid-row-gap: 14px;
        flex-direction: column;
        align-items: stretch
    }

    .section-cta.hide {
        padding-left: 2%;
        padding-right: 2%
    }

    .cta-heading {
        font-size: 32px;
        line-height: 42px
    }

    .button-cta-secondary {
        border-color: var(--white);
        background-color: var(--white)
    }

    .div-block-152 {
        grid-template-columns: 1fr
    }

    .div-block-153.margin-top-reset.no-border {
        grid-template-columns: .5fr 1fr;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .avatar-name {
        text-align: left
    }

    .div-block-159 {
        flex-wrap: wrap
    }

    .heading-71 {
        text-align: left
    }

    .content-grid {
        grid-template-columns: 1fr
    }

    .section-large-2.blackbg {
        background-image: none;
        background-position: 0 0;
        background-repeat: repeat;
        background-size: auto
    }

    .testimoial-container {
        flex-direction: column;
        align-items: center;
        margin-top: 100px;
        margin-right: 0;
        padding-bottom: 100px;
        padding-left: 0;
        padding-right: 0
    }

    .d-128-3d-card-wrapper {
        width: 300px;
        margin-left: 0;
        margin-right: 0
    }

    .ck-button-w {
        padding-left: 1.25em;
        padding-right: 1.25em
    }

    .ck-modal__content-w.is--small {
        padding-bottom: 1.25rem;
        padding-left: 1.25rem;
        padding-right: 1.25rem
    }

    .ck-cookie-w {
        max-width: 100%;
        top: auto;
        bottom: 0%;
        left: 0%;
        right: 0%
    }

    .ck-modal__exit-btn {
        margin-top: 1rem;
        margin-right: 1rem
    }

    .ck-modal__btns-w.is--small {
        padding: 1.25rem
    }

    .ck-modal {
        max-width: 100%;
        display: none
    }

    .ck-preference-w {
        align-items: flex-end
    }

    .ck-preference__scroll-w {
        max-width: 100%;
        padding-left: 0;
        padding-right: 0
    }

    .ck-prefmanager-w {
        left: 1rem
    }

    .modal-section {
        z-index: 9;
        display: none
    }

    .modal-paragraph {
        margin-bottom: 24px;
        font-size: 16px;
        line-height: 24px
    }

    .modal-container {
        border-radius: 0;
        grid-template-columns: 1fr;
        padding: 48px 12px 12px
    }

    .modal-content {
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
        padding-right: 0;
        display: flex
    }

    .modal-content.hide {
        display: none
    }

    .modal-heading {
        font-size: 24px;
        line-height: 32px
    }

    .modal-image-large {
        object-fit: contain;
        border-radius: 0;
        width: 100%;
        max-height: 200px;
        margin-bottom: 0
    }

    .modal-image-large.blue-bg {
        width: 100%
    }

    .modal-buttons-wrap {
        text-align: center;
        flex-direction: column;
        align-items: stretch
    }

    .section-11 {
        padding-left: 0%;
        padding-right: 0%
    }

    .heading-77 {
        font-size: 40px;
        line-height: 52px
    }

    .testimonial-title-wrapper {
        padding-left: 4%;
        padding-right: 5%
    }

    .testimonial-section-2 {
        padding: 80px 0% 0
    }

    .div-block-164 {
        padding-left: 1%;
        padding-right: 1%
    }

    .section-small {
        padding-left: 2%;
        padding-right: 2%
    }

    .h6-heading {
        font-size: 30px;
        line-height: 1.3
    }

    .grid-four-column {
        grid-template-columns: 1fr
    }

    .logo-block {
        min-height: 60px;
        padding-left: 8px;
        padding-right: 8px
    }

    .client-logo {
        height: 26px
    }

    .client-logo.mind-tickle-logo-resize {
        height: 20px
    }

    .client-logo.curefit-logo-resize {
        height: 40px
    }

    .client-logo.m-t-8 {
        height: 24px
    }

    .title-wrapper-regular {
        text-align: center
    }

    .back-button,
    .next-button-2 {
        display: none
    }

    .section-testimonial {
        overflow: hidden
    }

    .container-16 {
        max-width: 100%
    }

    .h6-heading-2 {
        font-size: 22px;
        line-height: 32px
    }

    .span-primary {
        color: var(--pabloo-green)
    }

    .div-block-168 {
        position: relative
    }

    .div-block-169 {
        background-color: var(--light-pink);
        width: 100%;
        height: 84%;
        position: absolute;
        bottom: 0
    }

    .image-43,
    .image-44,
    .div-block-170 {
        position: relative
    }

    .navigation-avatar-wrapper {
        display: none
    }

    .header-slide-image {
        object-fit: cover;
        border-radius: 16px;
        min-height: auto
    }

    .header-slider-product {
        border-radius: 0;
        height: 210px;
        min-height: 180px
    }

    .header-slide-wrapper {
        height: 100%;
        padding-top: 0;
        padding-bottom: 0
    }

    .feature-section-3 {
        padding-bottom: 60px
    }

    .feature-grid-2 {
        grid-template-columns: 1fr
    }

    .link-block-5 {
        height: 100%
    }

    .link-block-5.header-slider-product {
        min-height: auto
    }

    .div-block-171.hide {
        display: none
    }

    .process-heading-2 {
        font-size: 44px
    }

    .process-heading-2.m-b-8 {
        font-size: 1.8em
    }

    .process-grid-2 {
        grid-column-gap: 64px;
        grid-row-gap: 64px;
        grid-template-columns: 1fr
    }

    .sub-heading-text {
        width: auto;
        font-size: 3rem;
        line-height: 3rem
    }

    .header-featured-wrap {
        width: 100%;
        top: 50%;
        transform: translateY(-50%)
    }

    .header-featured-wrap.contact {
        padding-right: 0;
        display: block
    }

    .sticky-wrapper {
        height: auto;
        position: relative
    }

    .contact-us-wrapper {
        position: static
    }

    .big-container {
        padding-left: 0;
        padding-right: 0
    }

    .sub-header-img.contact-us {
        padding-left: 10px;
        padding-right: 10px;
        position: static
    }

    .process-graphic {
        max-width: 100%
    }

    .process-step {
        margin-bottom: 20px;
        margin-right: 0
    }

    .line-break-2 {
        max-width: 100%
    }

    .process-main-block {
        flex-direction: column
    }

    .process-section-3 {
        overflow: visible
    }

    .process-line {
        display: none
    }

    .columns-6 {
        display: block
    }

    .column-71 {
        object-fit: fill;
        position: static
    }

    .column-72 {
        position: static
    }

    .slide-detail {
        flex-direction: column;
        align-items: flex-start
    }

    .text-span-95 {
        font-size: 16px;
        line-height: 26px
    }

    .heading-83,
    .heading-84 {
        text-align: left;
        font-size: 16px
    }

    .text-block-83,
    .text-block-84 {
        text-align: left;
        font-size: 14px
    }

    .div-block-186 {
        margin-left: 0
    }

    .div-block-186.m-l-0 {
        margin-right: 0
    }

    .image-46 {
        height: 24px
    }

    .div-block-187 {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-right: 0
    }

    .text-block-86 {
        text-align: left;
        font-size: 24px;
        font-style: normal
    }

    .div-block-191 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        flex-wrap: wrap;
        grid-template-rows: auto;
        grid-template-columns: 1fr;
        grid-auto-columns: 1fr;
        justify-content: flex-end;
        justify-items: start;
        display: flex
    }

    .div-block-192 {
        justify-content: flex-start;
        margin-top: 16px
    }

    .div-block-194 {
        grid-template-columns: 1fr
    }

    .intro {
        max-width: 90%;
        padding-bottom: 54px;
        padding-left: 35px;
        padding-right: 37px
    }

    .intro.feature-3 {
        padding-top: 56px;
        padding-left: 21px;
        padding-right: 21px
    }

    .heading-88 {
        margin-top: 15px;
        padding-right: 26px
    }

    .heading-88.mob {
        padding-right: 106px
    }

    .column-73,
    .column-74 {
        padding-left: 0;
        padding-right: 0
    }

    .heading-89 {
        font-size: 16px
    }

    .section-regular-2 {
        padding-top: 48px
    }

    .pricing-image {
        max-width: 40%
    }

    .heading-content-2 {
        font-size: 38px
    }

    .slider-4 {
        min-height: auto
    }

    .left-arrow-3,
    .right-arrow-3 {
        display: none
    }

    .banner-wrap {
        text-align: left
    }

    .text-block-103,
    .text-block-104 {
        font-size: 13px
    }

    .text-block-105,
    .text-block-106 {
        font-size: 12px
    }

    .text-block-107,
    .text-block-108 {
        font-size: 13px
    }

    .heading-95 {
        font-size: 22px
    }

    .text-span-127 {
        color: var(--pabloo-green)
    }

    .f-header-form-row {
        flex-direction: column;
        align-items: flex-start
    }

    .feature-card-04,
    .feature-card-5,
    .feature-card-6,
    .feature-card-01 {
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        display: flex
    }

    .heading-large {
        font-size: 48px
    }

    .feature-block-header {
        padding-left: 20px
    }

    .feature-title-2 {
        font-size: 1.4em;
        line-height: 1.2em
    }

    .feature-number {
        margin-right: 20px;
        font-size: 1.2em;
        line-height: 1em
    }

    .feature-header-2 {
        font-size: 34px;
        line-height: 44px
    }

    .feature-pink-block {
        width: 100%
    }

    .collection-list-3 {
        grid-column-gap: 4px;
        grid-row-gap: 4px;
        flex-wrap: nowrap;
        grid-template-rows: auto;
        grid-template-columns: 1fr 1fr 1fr;
        grid-auto-columns: 1fr;
        align-items: center;
        width: 100%;
        display: flex
    }

    .paragraph-50 {
        text-align: left;
        margin-bottom: 24px;
        font-size: 16px;
        font-weight: 300;
        line-height: 1.4em
    }

    .header-grid-5 {
        grid-column-gap: 40px;
        grid-row-gap: 40px
    }

    .image-wrapper-3.darl-mode {
        margin-left: 0;
        margin-right: 0
    }

    .image-wrapper-3.darl-mode.custo {
        margin-left: 0
    }

    .features-button-2 {
        justify-content: center;
        align-self: center;
        margin-left: auto;
        margin-right: auto;
        font-size: 15px;
        font-weight: 500
    }

    .ebook-points-heading-2 {
        text-align: left;
        font-size: 16px;
        line-height: 26px
    }

    .ebook-points-heading-2.custo {
        text-align: left;
        font-size: 18px
    }

    .hero-heading-4 {
        text-align: left;
        font-size: 40px;
        line-height: 50px
    }

    .hero-heading-4.custo {
        text-align: left;
        font-size: 44px
    }

    .header-section-6 {
        padding-bottom: 60px
    }

    .main-wrapper-2 {
        backdrop-filter: blur(5px)blur(120px);
        background-color: #fff
    }

    .rich-text-block-20 {
        font-size: 18px;
        line-height: 1.6em
    }

    .heading-104 {
        font-size: 32px;
        line-height: 1.2em
    }

    .collection-list-4 {
        grid-template-columns: auto auto
    }

    .image-67 {
        height: 32px
    }

    .div-block-263 {
        font-size: 16px
    }

    .text-block-158 {
        color: var(--white)
    }

    .text-block-159 {
        color: var(--black)
    }

    .rich-text-block-22 {
        text-align: left
    }

    .lp-text-style {
        font-size: 16px
    }

    .logo-item {
        max-width: 120px
    }

    .win-item-wrapper {
        align-self: stretch;
        max-width: 100%
    }

    .lp-image-wrapper {
        align-self: stretch
    }

    .navigation-link-block {
        padding-left: 14px;
        padding-right: 14px
    }

    .navigation-cta {
        padding: 24px
    }

    .footer-3 {
        padding-bottom: 40px;
        padding-left: 8px;
        padding-right: 8px
    }

    .footer-links-2 {
        font-size: 16px
    }

    .div-block-320 {
        flex-wrap: wrap;
        justify-content: center
    }

    .image-76 {
        height: 70px
    }

    .div-block-321 {
        width: 100%;
        margin-top: 24px
    }

    .large-link-3 {
        justify-content: flex-end;
        margin-left: 8px;
        padding: 16px 6px;
        font-size: 14px;
        display: none
    }

    .nav-link-register-2.hide {
        display: block
    }

    .text-block-184 {
        font-size: 12px
    }

    .persona-dropdown-wrap-2 {
        padding-left: 16px;
        padding-right: 16px
    }

    .persona-dropdown-wrap-2.product-drop-down {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
        overflow: visible
    }

    .persona-dropdown-wrap-2.resources {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .menu-button-7 {
        background-color: #fff;
        border-style: none;
        border-radius: 0% 6px 6px 0%;
        padding: 8px 6px;
        box-shadow: 0 0 8px rgba(0, 0, 0, .1)
    }

    .dropdown-toggle-3.w--open {
        background-color: #f5cde1
    }

    .nav-link-5 {
        display: block
    }

    .nav-link-5.sp {
        color: #fff;
        background-color: #d53987
    }

    .div-block-332 {
        justify-content: center;
        align-self: center;
        width: auto
    }

    .heading-122 {
        font-size: 32px;
        line-height: 36px
    }

    .div-block-333 {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-columns: 1fr;
        margin-top: 40px;
        margin-left: 0%;
        margin-right: 0%
    }

    .div-block-334,
    .div-block-334.border-gradient {
        border-top-style: none
    }

    .image-82,
    .image-83,
    .image-84,
    .image-85 {
        margin-top: 0
    }

    .blog-book-demo-block {
        display: none
    }

    .wrapper-block {
        padding-right: 0
    }

    .split-image-wrapper-3 {
        margin-top: 16px;
        margin-bottom: 0
    }

    .review-slider-author-wrapper-2 {
        flex-direction: row;
        align-items: center;
        width: 100%
    }

    .top-tag-text-2 {
        margin-left: 10px;
        margin-right: 10px;
        font-size: 16px
    }

    .auto-slider-arrow-left-3 {
        display: none;
        bottom: 10%;
        left: auto;
        right: 80px
    }

    .auto-slider-arrow-left-3.show {
        flex: 0 1 auto;
        order: 0;
        position: static;
        bottom: 0;
        right: 64px
    }

    .wrapper-1300px-3 {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .hover-block__text {
        background-color: #fff;
        margin-top: 55%;
        padding-top: 35px;
        padding-bottom: 35px;
        position: relative;
        top: 0%;
        bottom: auto;
        left: 0;
        right: 0;
        transform: none
    }

    .page-subheading {
        font-size: 18px
    }

    .review-slide-3 {
        height: auto;
        max-height: none;
        padding: 0
    }

    .navigation-list-2.solutions.w--open,
    .navigation-list-2.resources.w--open {
        width: 100%
    }

    .mask-not-visible-2 {
        height: 100%
    }

    .page-heading {
        font-size: 40px;
        line-height: 48px
    }

    .div-block-367 {
        grid-template-columns: auto;
        margin-top: 24px
    }

    .div-block-369 {
        margin-left: 4px;
        margin-right: 4px;
        padding: 12px
    }

    .heading-141 {
        font-size: 32px;
        line-height: 150%
    }

    .review-author-job-post-3 {
        font-size: 12px;
        line-height: 16px
    }

    .review-slider-container-3 {
        padding-bottom: 0;
        padding-left: 24px
    }

    .review-slider-container-3.home {
        padding-top: 0;
        padding-left: 8px;
        padding-right: 8px
    }

    .review-slider-text-4 {
        font-size: 14px;
        font-weight: 400
    }

    .heading-145 {
        font-size: 32px
    }

    .about-hero-wrapper-3 {
        background-position: 0%, 100%
    }

    .about-hero-wrapper-3.white-bg.margin-top-40.transparent-bg {
        margin-bottom: 24px
    }

    .home-slider-image-4 {
        width: 50%
    }

    .heading-148 {
        font-size: 32px;
        line-height: 150%
    }

    .paragraph-93 {
        font-size: 16px;
        line-height: 24px
    }

    .review-company-image-container-3 {
        height: 24px;
        display: block
    }

    .review-company-image-container-3.airmeet-logo-wrapper {
        height: 24px
    }

    .footer-links-4 {
        font-size: 16px
    }

    .div-block-391.margin-top-reset.no-border {
        grid-column-gap: 4px;
        grid-template-columns: auto;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .heading-151 {
        font-size: 16px
    }

    .menu-button-10.w--open {
        background-color: var(--pabloo-green)
    }

    .review-slider-content-wrapper-4 {
        min-height: auto;
        margin-top: 8px;
        margin-bottom: 16px
    }

    .div-block-396 {
        background-image: radial-gradient(circle at 0 100%, #d53987, #fff 32%);
        grid-template-columns: auto
    }

    .div-block-396.border {
        grid-template-columns: 1fr;
        padding-top: 0;
        padding-left: 8px;
        padding-right: 8px
    }

    .heading-152 {
        font-size: 28px
    }

    .div-block-397 {
        width: 72px;
        display: block
    }

    .image-123 {
        border-radius: 0% 0% 0% 8px
    }

    .div-block-398 {
        display: none
    }

    .heading-155 {
        font-size: 32px
    }

    .div-block-399 {
        padding-top: 24px
    }

    .div-block-399.integrations-section-container {
        margin-top: 0
    }

    .div-block-404 {
        grid-template-columns: auto;
        margin-top: 24px
    }

    .heading-160 {
        font-size: 32px;
        line-height: 150%
    }

    .home-slider-image-5 {
        width: 50%
    }

    .persona-head-para-2 {
        font-size: 16px
    }

    .persona-head-para-2.it {
        font-size: 18px;
        line-height: 150%
    }

    .persona-head-para-2.it.black {
        font-size: 18px;
        font-weight: 400
    }

    .heading-130 {
        margin-bottom: 0;
        font-size: 32px;
        line-height: 150%
    }

    .div-block-436 {
        width: 100%
    }

    .home-slider-image-6 {
        width: 50%
    }

    .heading-177 {
        font-size: 18px
    }

    .div-block-445 {
        border-left-style: none;
        width: 100%
    }

    .paragraph-108 {
        font-size: 14px
    }

    .rich-text-block-23 {
        text-align: left;
        font-size: 16px;
        line-height: 1.6
    }

    .heading-180 {
        font-size: 40px
    }

    .collection-list-wrapper-5 {
        padding-left: 0;
        padding-right: 0
    }

    .collection-list-5 {
        grid-template-columns: 1fr
    }

    .div-block-466 {
        border-radius: 0;
        grid-template-columns: 1fr
    }

    .div-block-469 {
        padding: 16px
    }

    .collection-list-6 {
        grid-template-columns: 1fr
    }

    .paragraph-111 {
        font-size: 18px;
        line-height: 1.6
    }

    .div-block-471 {
        border-left-style: none;
        padding-left: 0
    }

    .div-block-473 {
        width: 120px;
        display: block
    }

    .section-34 {
        padding-left: 2%;
        padding-right: 2%
    }

    .div-block-478 {
        grid-template-columns: 1fr
    }

    .text-span-188 {
        font-size: 24px
    }

    .heading-185,
    .heading-186,
    .heading-187 {
        font-size: 34px
    }

    .heading-189 {
        font-size: 24px;
        line-height: 1.2em
    }

    .text-block-228 {
        margin-left: 6px
    }

    .heading-191,
    .text-block-229 {
        line-height: 1.6em
    }

    .heading-193 {
        font-size: 36px;
        line-height: 1.6em
    }

    .div-block-491 {
        width: 100%;
        max-width: none;
        padding-left: 8px;
        padding-right: 8px
    }

    .container-1282 {
        padding-left: 8px;
        padding-right: 8px
    }

    .heading-194 {
        font-size: 36px;
        line-height: 1.6
    }

    .section-36 {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .container-1283 {
        padding-left: 0;
        padding-right: 0
    }

    .heading-198 {
        font-size: 40px
    }

    .features-grid-4 {
        grid-template-columns: 1fr
    }

    .div-block-502 {
        padding-left: 9px;
        padding-right: 9px
    }

    .form-4 {
        grid-template-columns: 1fr
    }

    .section-37 {
        background-size: cover
    }

    .div-block-516 {
        grid-template-columns: 1fr
    }

    .div-block-518 {
        grid-template-columns: auto
    }

    .div-block-519 {
        grid-template-columns: 1fr
    }

    .div-block-529 {
        background-color: var(--black);
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/643657e7caba8c4227a33de6_ads-banner.svg);
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: cover;
        align-self: flex-end;
        width: 100%;
        height: auto;
        padding-bottom: 12px;
        padding-left: 12px;
        padding-right: 12px;
        display: flex;
        position: sticky;
        bottom: 0
    }

    .heading-207 {
        color: var(--white);
        text-align: center;
        font-size: 20px
    }

    .list-16 {
        justify-content: flex-start
    }

    .collection-list-wrapper-6,
    .collection-item-4 {
        width: 100%
    }

    .mt-md.center.text-sm {
        font-size: 16px
    }

    .column-76 {
        padding-left: 0%;
        padding-right: 0%
    }

    .column-77 {
        padding-left: 0;
        padding-right: 0
    }

    .div-block-535 {
        flex-wrap: wrap
    }

    .div-block-536 {
        width: 100%;
        padding: 40px 16px 64px
    }

    .div-block-537 {
        display: none
    }

    .image-178 {
        height: 48px
    }

    .div-block-540 {
        padding-left: 16px;
        padding-right: 16px
    }

    .heading-210 {
        font-size: 38px;
        line-height: 1.1em
    }

    .paragraph-120 {
        font-size: 18px
    }

    .section-40 {
        padding: 80px 16px
    }

    .div-block-543 {
        grid-row-gap: 80px;
        grid-template-columns: 1fr
    }

    .section-41 {
        padding-left: 0;
        padding-right: 0
    }

    .section-42 {
        padding: 64px 8px
    }

    .div-block-546 {
        flex-wrap: wrap
    }

    .div-block-547 {
        width: 100%
    }

    .div-block-548 {
        width: 100%;
        margin-top: 32px;
        padding-left: 0;
        padding-right: 0
    }

    .div-block-552 {
        height: 100%;
        padding: 20px 12px
    }

    .section-43 {
        padding: 56px 8px
    }

    .section-44 {
        padding: 80px 16px
    }

    .div-block-554 {
        flex-wrap: wrap
    }

    .div-block-555 {
        width: 100%
    }

    .div-block-556 {
        width: 100%;
        margin-top: 32px;
        padding-left: 0
    }

    .section-45 {
        padding: 0
    }

    .div-block-561 {
        flex-wrap: wrap
    }

    .section-46 {
        padding: 64px 16px
    }

    .heading-216 {
        font-size: 40px
    }

    .columns-8 {
        display: block
    }

    .div-block-562 {
        margin-top: 32px
    }

    .div-block-564 {
        padding-left: 16px;
        padding-right: 16px
    }

    .image-185 {
        width: 100%;
        height: auto
    }

    .div-block-567 {
        grid-column-gap: 4px;
        padding-left: 8px;
        padding-right: 8px
    }

    .text-block-250 {
        font-size: 16px
    }

    .button-37 {
        padding-left: 16px;
        padding-right: 16px;
        font-size: 14px
    }

    .text-block-251 {
        text-align: center;
        font-size: 16px
    }

    .text-block-251.text-align-center {
        text-align: center
    }

    .heading-218 {
        text-align: center;
        font-size: 40px
    }

    .div-block-571 {
        grid-template-columns: .5fr 1fr
    }

    .div-block-574 {
        padding: 8px 0
    }

    .div-block-575 {
        grid-column-gap: 2px;
        grid-row-gap: 12px;
        grid-template-rows: auto;
        grid-template-columns: 1fr auto auto;
        grid-auto-columns: 1fr;
        padding: 8px 4px 8px 8px;
        display: grid
    }

    .text-block-252 {
        font-size: 16px;
        line-height: 1.6em
    }

    .image-186 {
        height: 40px;
        font-size: 18px
    }

    .text-block-253,
    .text-block-254,
    .text-block-255,
    .text-block-256,
    .text-block-257,
    .text-block-258,
    .text-block-260 {
        font-size: 16px
    }

    .div-block-577 {
        height: 40px
    }

    .div-block-579 {
        height: 30px
    }

    .div-block-580 {
        padding-left: 8px;
        padding-right: 8px
    }

    .text-block-261 {
        font-size: 20px
    }

    .div-block-581 {
        margin-top: 24px
    }

    .div-block-583 {
        height: 20px
    }

    .div-block-584 {
        padding-left: 8px;
        padding-right: 8px
    }

    .heading-219 {
        font-size: 32px
    }

    .section-48 {
        padding-top: 12%;
        padding-left: 8px;
        padding-right: 8px
    }

    .section-49 {
        padding: 24% 8px 10%
    }

    .heading-220 {
        font-size: 32px
    }

    .div-block-590 {
        grid-column-gap: 8px
    }

    .text-block-268,
    .text-span-210,
    .text-block-269,
    .text-block-270 {
        font-size: 16px
    }

    .heading-221 {
        font-size: 20px
    }

    .heading-222 {
        font-size: 40px
    }

    .section-50 {
        padding: 8% 8px
    }

    .div-block-595 {
        grid-template-columns: 1fr
    }

    .section-51 {
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        padding: 4% 8px 8%
    }

    .div-block-596 {
        padding-right: 0
    }

    .heading-223 {
        font-size: 32px;
        line-height: 1.2em
    }

    .div-block-598 {
        padding-left: 8px;
        padding-right: 8px;
        position: relative
    }

    .section-52 {
        padding: 8% 8px 40px
    }

    .div-block-601 {
        grid-template-columns: 1fr
    }

    .section-54 {
        padding: 32px 8px
    }

    .heading-224 {
        font-size: 32px;
        line-height: 1.2em
    }

    .div-block-615 {
        grid-template-columns: 1fr
    }

    .section-55 {
        padding: 48px 8px 32px
    }

    .heading-227 {
        font-size: 32px
    }

    .text-block-281 {
        color: var(--white)
    }

    .div-block-618 {
        grid-template-columns: 1fr
    }

    .div-block-621 {
        padding-left: 8px;
        padding-right: 8px
    }

    .heading-229 {
        font-size: 32px
    }

    .link-41 {
        color: var(--pabloo-green)
    }

    .div-block-632 {
        grid-template-columns: 1fr
    }

    .heading-235 {
        font-size: 32px
    }

    .image-188 {
        width: 100%;
        height: auto
    }

    .container-1286 {
        padding-left: 22px;
        padding-right: 22px
    }

    .image-202 {
        height: auto
    }

    .banner-cta-blog {
        width: 300px
    }

    .heading-240 {
        text-align: center;
        margin-top: 0;
        font-size: 20px
    }

    .div-block-665 {
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;
        margin-left: 8px
    }

    .link-button-copy2 {
        width: 180px;
        margin-bottom: 0
    }

    .text-block-4 {
        font-size: 16px;
        line-height: 100%
    }

    .text-block-286 {
        font-size: 16px
    }

    .section-59 {
        padding-left: 16px;
        padding-right: 16px
    }

    .div-block-669 {
        flex-wrap: wrap
    }

    .image-207 {
        object-fit: cover;
        height: 120px
    }

    .heading-241 {
        font-size: 2.25rem
    }

    .div-block-673 {
        grid-template-columns: 1fr
    }

    .div-block-674 {
        width: 100%;
        margin-top: 24px;
        margin-bottom: 0;
        display: block;
        position: relative;
        top: auto;
        bottom: -80px;
        right: auto
    }

    .div-block-675 {
        padding-left: 12px;
        padding-right: 12px
    }

    .case-study-hero-sub-heading {
        margin-top: 20px;
        font-size: 14px
    }

    .rich-text-block-28 {
        font-size: 1rem;
        line-height: 1.75em
    }

    .case-study-hero-heading-2 {
        font-size: 2.5rem;
        line-height: 1.1em
    }

    .section-60 {
        padding-top: 120px;
        padding-left: 16px;
        padding-right: 16px
    }

    .paragraph-133 {
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.4em
    }

    .case-study-hero-container {
        width: 100%
    }

    .div-block-681 {
        grid-template-columns: 1fr 1fr;
        width: 100%
    }

    .div-block-682 {
        grid-template-columns: 1fr
    }

    .case-study-hero-metrics-container {
        grid-template-columns: auto
    }

    .case-study-hero-section {
        padding: 80px 16px 32px;
        overflow: visible
    }

    .image-212 {
        width: auto;
        height: auto;
        min-height: auto;
        max-height: 36px
    }

    .bold-text-25 {
        font-size: .9em;
        line-height: 1.2em
    }

    .rich-text-block-29 {
        font-size: 16px;
        font-weight: 300;
        line-height: 1.8em
    }

    .section-61 {
        padding-left: 16px;
        padding-right: 16px
    }

    .div-block-687 {
        grid-template-columns: 1fr
    }

    .section-62 {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .div-block-689 {
        grid-template-columns: 1fr
    }

    .section-63 {
        padding-left: 16px;
        padding-right: 16px
    }

    .div-block-694 {
        justify-items: center;
        padding-right: 0
    }

    .text-block-298 {
        font-size: 14px;
        line-height: 1.2em
    }

    .div-block-698 {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .div-block-700 {
        width: 56px;
        display: block
    }

    .div-block-701 {
        width: 100%
    }

    .image-217,
    .image-218 {
        height: 40px
    }


    .reference-hero-wrapper {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .colors-grid {
        grid-template-columns: 1fr 1fr
    }

    .buttons-grid {
        grid-template-columns: 1fr
    }

    .heading-64px {
        font-size: 42px
    }

    .heading-64px.hero-home-heading {
        font-size: 36px
    }

    .heading-64px.hero-home-heading.top {
        max-width: 400px
    }

    .heading-64px.hero-home-heading.bottom {
        flex: 0 1 auto
    }

    .heading-64px.hero-home-heading.zendesk {
        width: 152.828px
    }

    .heading-64px.text-align-center {
        margin-bottom: 16px;
        font-size: 26px
    }

    .heading-64px.text-align-center.include-bg-element {
        margin-top: 0
    }

    .heading-64px.blogs-hero-heading,
    .heading-64px.resource-hero-heading {
        font-size: 38px
    }

    .heading-90px {
        font-size: 48px
    }

    .heading-56px {
        font-size: 36px
    }

    .heading-56px.integrations-heading._40px-bottom-margin {
        margin-bottom: 24px
    }

    .heading-48px {
        font-size: 32px
    }

    .heading-48px.stack-heading {
        margin-bottom: 30px
    }

    .heading-40px {
        font-size: 28px
    }

    .heading-40px.spend-block-heading {
        font-size: 24px
    }

    .navigation-bar {
        margin-top: 0;
        top: 0
    }

    .navigation-link {
        width: 100%;
        margin-right: auto
    }

    .logo-contain {
        grid-column-gap: 4px;
        grid-row-gap: 4px
    }

    .logo-image {
        max-width: 130px;
    }

    .logo-bar.second,
    .logo-bar.third,
    .logo-bar.first {
        width: 10px
    }

    .navigation-button-contain.out-menu {
        margin-right: 6px
    }

    .navigation-button-contain.in-menu {
        grid-column-gap: 10px;
        grid-row-gap: 10px
    }

    .hero-home-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px
    }

    .hero-home-wrapper.new,
    .hero-home-wrapper.new.ads {
        padding-top: 100px
    }

    .transparent-arrow-button {
        padding: 18px 20px;
        font-size: 17px
    }

    .hero-home-text-wrapper {
        max-width: 383px;
        padding-top: 0
    }

    .hero-home-text-wrapper.new {
        margin-top: 94px
    }

    .paragraph-18px.hero-home-paragraph {
        margin-bottom: 10px
    }

    .paragraph-18px.hero-home-paragraph.new {
        font-size: 18px
    }

    .paragraph-18px.integrations-paragraph {
        margin-bottom: 30px
    }

    .paragraph-18px.spend-block-paragraph,
    .paragraph-18px.reviewer-position {
        font-size: 14px
    }

    .paragraph-18px.saas-hero-paragraph,
    .paragraph-18px.cloud-hero-paragraph {
        margin-bottom: 10px
    }

    .pink-arrow-button {
        padding: 18px 20px;
        font-size: 17px
    }

    .pink-arrow-button.new {
        padding-left: 40px;
        padding-right: 40px
    }

    .stats-section {
        padding-top: 2px
    }

    .stats-wrapper {
        margin-top: 15px;
        padding-top: 39px;
        padding-bottom: 80px
    }

    .stats-grid {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .stats-block {
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px
    }

    .heading-24px.stats-text {
        margin-bottom: 0
    }

    .heading-24px.review-text {
        font-size: 17px
    }

    .heading-24px.setup-card-text {
        font-size: 18px
    }

    .seo-page-hero {
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        padding: 32px 16px 40px
    }

    .seo-page-hero.new {
        padding-top: 151px
    }

    .html-embed-28 {
        font-size: 18px
    }

    .paragraph-140 {
        font-size: 16px
    }

    .div-block-703 {
        padding-left: 0%;
        padding-right: 0%
    }

    .type-cards-grid {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .type-card-block.first,
    .type-card-block.second {
        padding-top: 24px
    }

    .type-card-top-wrapper {
        padding-left: 16px;
        padding-right: 16px
    }

    .type-card-heading-wrapper {
        grid-column-gap: 12px;
        grid-row-gap: 12px
    }

    .type-card-icon-contain {
        width: 46px;
        height: 46px
    }

    .type-card-icon-embed {
        width: 30px;
        height: 30px
    }

    .heading-28px {
        font-size: 20px
    }

    .div-block-704 {
        grid-template-columns: 1fr;
        padding-left: 10px;
        padding-right: 10px
    }

    .div-block-705 {
        grid-template-columns: 1fr
    }

    .heading-248 {
        text-align: left
    }

    .div-block-707 {
        padding-left: 16px;
        padding-right: 16px
    }

    .div-block-708 {
        grid-template-columns: 1fr;
        align-items: center;
        justify-items: center
    }

    .heading-249,
    .paragraph-142 {
        text-align: center
    }

    .section-65 {
        padding: 40px 16px
    }

    .div-block-720 {
        grid-template-columns: 1fr;
        padding-left: 0;
        padding-right: 0
    }

    .div-block-721 {
        padding-bottom: 40px
    }

    .collection-list-7 {
        grid-template-columns: 1fr
    }

    .section-66 {
        padding: 80px 16px
    }

    .div-block-727 {
        grid-template-columns: 1fr
    }

    .arrow-text-link {
        font-size: 17px
    }

    .arrow-text-link-top-contain {
        align-items: flex-end
    }

    .text-link-underline.hide-on-portrait {
        display: none
    }

    .type-cards-train-container.vertical {
        padding-left: 16px;
        padding-right: 16px
    }

    .type-cards-train-card {
        align-items: flex-start
    }

    .type-card-checkmark {
        margin-top: 3px
    }

    .integrations-wrapper {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        padding-top: 80px;
        padding-bottom: 60px
    }

    .integrations-wrapper.saas,
    .integrations-wrapper.cloud {
        padding-bottom: 60px
    }

    .calculator-left {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .stack-wrapper {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .stack-tabs-menu {
        grid-column-gap: 4px;
        grid-row-gap: 4px;
        margin-bottom: 40px
    }

    .stack-tab-link {
        min-width: 70px
    }

    .stack-tab-link-progress-bar-contain {
        height: 4px
    }

    .paragraph-20px.stack-tab-link-text {
        font-size: 14px
    }

    .paragraph-20px.footer-column-subheading,
    .paragraph-20px.footer-link,
    .paragraph-20px.reviewer-name,
    .paragraph-20px.form-field-label {
        font-size: 16px
    }

    .paragraph-20px.blog-tag-radio-button-label {
        padding-left: 16px;
        padding-right: 16px
    }

    .stack-blocks-grid {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .stack-block.a-first,
    .stack-block.a-second,
    .stack-block.d-first {
        padding: 20px
    }

    .stack-block-header {
        grid-column-gap: 10px;
        grid-row-gap: 10px;
        flex-direction: column;
        align-items: flex-start
    }

    .stack-block-image-contain.a-first,
    .stack-block-image-contain.a-second,
    .stack-block-image-contain.b-first,
    .stack-block-image-contain.c-first,
    .stack-block-image-contain.c-second,
    .stack-block-image-contain.b-second,
    .stack-block-image-contain.d-second,
    .stack-block-image-contain.d-first {
        margin-top: 30px
    }

    .blogs-wrapper {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .blog-post-wrapper._16px-gap,
    .blog-post-wrapper.load-list {
        grid-column-gap: 12px;
        grid-row-gap: 12px
    }

    .blog-post-image-wrapper.featured {
        height: 225px
    }

    .blog-post-image-wrapper.featured.blog-page {
        height: 260px
    }

    .blog-post-image-wrapper.featured.cms,
    .blog-post-image-wrapper.featured.resources-hero {
        height: 240px
    }

    .blog-post-image-wrapper._300px {
        height: 225px
    }

    .blog-post-info-wrapper {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .heading-32px {
        font-size: 24px
    }

    .blog-post-image.featured {
        object-fit: cover;
        height: 80%
    }

    .transparent-white-arrow-button {
        padding: 18px 20px;
        font-size: 17px
    }

    .footer-wrapper {
        grid-column-gap: 40px;
        grid-row-gap: 10px;
        padding-top: 40px
    }

    .footer-top-container {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .brand-logos-contain.new {
        align-self: center;
        width: 100%
    }

    .brand-logos-wrapper {
        padding: 10px
    }

    .brand-logos-wrapper.new {
        justify-content: center;
        align-items: center;
        display: flex
    }

    .brand-logo.first {
        width: 54px;
        margin-right: 2px
    }

    .brand-logo.second {
        width: 54px;
        margin-right: 6px
    }

    .brand-logo.third {
        width: 58px
    }

    .footer-links-wrapper {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        grid-template-columns: 1fr 1fr
    }

    .footer-links-wrapper.new {
        grid-template-columns: 1fr 1fr
    }

    .footer-links-column.fifth {
        max-width: none;
        padding-top: 20px
    }

    .footer-links-column.fifth.new {
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        flex-flow: wrap;
        align-content: stretch;
        justify-content: center;
        align-items: center;
        padding-top: 39px;
        display: flex
    }

    .tribe-wrapper {
        margin-top: -20px
    }

    .tribe-tab-link-info-wrapper {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .tribe-tab-image-contain {
        padding-top: 30px;
        padding-bottom: 30px
    }

    .spend-wrapper {
        padding: 80px 10px
    }

    .calculator-wrapper {
        padding: 30px 16px
    }

    .spend-block-icon-embed {
        width: 24px;
        height: 24px
    }

    .spend-image.c {
        margin-top: -40px
    }

    .spend-block-wrapper {
        grid-column-gap: 10px;
        grid-row-gap: 10px
    }

    .spend-block-wrapper.a.new._1 {
        width: 240px;
        display: none
    }

    .spend-block-wrapper.a.new._2 {
        width: 260px;
        display: none;
        left: -110%
    }

    .spend-block-wrapper.a.new._3 {
        width: 260px;
        margin-top: 20px;
        display: none;
        /* left: -150% */
    }

    .spend-block-wrapper.b {
        min-height: 190px
    }

    .spend-sticky-wrapper {
        height: 50vh
    }

    .spend-text-container {
        padding-top: 14px;
        padding-left: 14px;
        padding-right: 14px
    }

    .sticky-indicator-text-wrapper {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .spend-image-wrapper.first {
        padding: 20px 16px
    }

    .spend-images-grid {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .heading-252 {
        padding-left: 11px;
        padding-right: 11px;
        line-height: 1.1
    }

    .heading-252.new {
        text-align: center;
        font-size: 19px
    }

    .reviews-main-wrapper {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .review-slide-nav {
        display: none
    }

    .review-slide-text-wrapper {
        grid-column-gap: 24px;
        grid-row-gap: 24px;
        padding: 16px
    }

    .reviewer-block {
        grid-column-gap: 12px;
        grid-row-gap: 12px;
        flex-direction: column;
        align-items: flex-start
    }

    .reviewer-info-block {
        grid-column-gap: 2px;
        grid-row-gap: 2px
    }

    .review-company-logo {
        height: 30px
    }

    .review-company-logo._32px {
        height: 24px
    }

    .review-company-logo._29px {
        height: 20px
    }

    .review-company-logo._31px {
        height: 26px
    }

    .review-company-logo._44px {
        height: 28px
    }

    .slider-arrow.right {
        bottom: -60px;
        right: 0%
    }

    .slider-arrow.right.events {
        left: auto;
        right: 20px
    }

    .slider-arrow.left {
        bottom: -60px;
        left: 0%
    }

    .slider-arrow.left.events {
        left: 20px;
        right: auto
    }

    .slider-arrow.testimonials.left {
        clear: none;
        object-fit: fill;
        justify-content: flex-start;
        align-items: center;
        margin-top: 20px;
        margin-left: 0;
        margin-right: 0;
        display: flex;
        position: absolute;
        top: auto;
        bottom: auto;
        left: 25%;
        right: 0%;
        overflow: visible
    }

    .slider-arrow.testimonials.right {
        margin-top: 20px;
        position: absolute;
        top: auto;
        bottom: auto;
        right: 25%
    }

    .review-slide-arrow-icon-embed {
        flex: 1 1;
        display: block;
        position: relative
    }

    .home-hero-heading-contain {
        flex: 0 1 auto;
        order: -1;
        padding-right: 0
    }

    .logos-white-gradient {
        width: 20px
    }

    .navigation-menu-button {
        padding: 14px
    }

    .hero-wrapper-contain {
        margin-top: 50px;
        /* padding-top: 37px */
    }

    .home-hero-images-container {
        max-width: 400px
    }

    .hero-bubbles-block-wrapper {
        max-width: 120px;
        left: 12%
    }

    .hero-bubbles-block {
        grid-column-gap: 20px;
        grid-row-gap: 20px
    }

    .hero-bubble-image {
        width: 100%;
        max-width: 40px;
        height: auto
    }

    .dropdown-resources-column {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        padding-top: 10px
    }

    .resource-dropdown-wrapper {
        flex-direction: column;
        align-items: flex-start
    }

    .resource-dropdown-image-contain,
    .resource-dropdown-info-block {
        width: 100%
    }

    .integrations-lottie {
        min-width: 100%
    }

    .navigation-inner-wrapper.white.new {
        padding-left: 0;
        padding-right: 0
    }

    .tribe-tab-lottie-shadow {
        height: 96%
    }

    .hero-platform-wrapper {
        width: 100%;
        padding-left: 12px;
        padding-right: 12px
    }

    .hero-platform-heading-wrapper.display-flex.include-bg {
        background-image: none;
        background-position: 0 0;
        background-repeat: repeat;
        background-size: auto
    }

    .hero-platform-heading-wrapper.integra {
        padding-left: 33px;
        padding-right: 33px
    }

    .hero-platform-subheading-text {
        padding: 16px 30px;
        font-size: 19px;
        margin-top: -25px;
        margin-bottom: 10px
    }

    .hero-platform-subheading-text-case {
        flex-flow: row;
        justify-content: flex-start;
        align-items: center;
        font-family: Satoshi, sans-serif;
        font-size: 20px;
        font-weight: 500;
        display: block;
        padding: 16px 30px;
        margin-top: 15px;
        margin-bottom: 10px
    }

    .hero-platform-cta-wrapper.integra {
        justify-content: center;
        align-items: flex-start
    }

    .hero-platform-image {
        margin-top: 24px
    }

    .hero-spotlight-image {
        width: 100%
    }

    .blogs-hero-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px
    }

    .blogs-hero-wrapper.cms {
        padding-top: 120px
    }

    .form-email-text-field {
        background-size: 24px;
        padding-left: 46px;
        font-size: 16px
    }

    .blog-tabs-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .ctas-form-wrapper {
        padding: 24px 16px
    }

    .form-fields-contain {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .white-form-field {
        font-size: 16px
    }

    .ctas-form {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .form-fields-grid {
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-columns: 1fr
    }

    .form-select-field {
        font-size: 16px
    }

    .features-section {
        padding-bottom: 80px
    }

    .blog-category-text-contain {
        grid-column-gap: 8px;
        grid-row-gap: 8px
    }

    .blog-cms-info-wrapper {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .block-rich-text h1 {
        font-size: 42px
    }

    .block-rich-text h2 {
        font-size: 36px
    }

    .block-rich-text h3 {
        font-size: 32px
    }

    .block-rich-text h4 {
        font-size: 28px
    }

    .block-rich-text h5 {
        font-size: 24px
    }

    .block-rich-text h6 {
        font-size: 20px
    }

    .block-rich-text ul,
    .block-rich-text ol {
        margin-bottom: 24px
    }

    .block-rich-text li {
        margin-bottom: 2px
    }

    .block-rich-text blockquote {
        background-position: 20px 20px;
        background-size: 30px;
        padding: 68px 20px 20px;
        font-size: 20px
    }

    .feature-wrap {
        flex-direction: row;
        justify-content: center;
        align-items: center
    }

    .feature-image-wrapper.right.pink-bg {
        order: -1;
        width: 100%;
        padding-right: 16px
    }

    .feature-image-wrapper.right.green-bg {
        text-align: center;
        order: -1;
        width: 100%
    }

    .feature-image-wrapper.right.yellow-bg {
        text-align: center;
        flex: 1 1
    }

    .feature-image-wrapper.right.green-bg-copy {
        text-align: center;
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
        order: -1;
        width: 100%
    }

    .feature-image-wrapper.left.green-bg {
        text-align: center;
        width: 100%;
        padding-left: 16px
    }

    .feature-image-wrapper.left.yellow-bg {
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 16px;
        padding-left: 16px
    }

    .feature-image-wrapper.left.pink-bg {
        text-align: center;
        width: 100%
    }

    .feature-content-wrap {
        width: 100%
    }

    .feature-content-header {
        text-align: left
    }

    .feature-content-icon-wrapper {
        text-align: left;
        align-items: center;
        display: block
    }

    .hero-design-element.right,
    .hero-design-element.left {
        display: none
    }

    .subscribe-form-main-wrapper {
        padding: 24px 16px
    }

    .fs-cc-prefs3_button.fs-cc-button-alt {
        margin-bottom: .25rem;
        margin-right: 0
    }

    .fs-cc-prefs3_label {
        font-size: .75rem
    }

    .fs-cc-prefs3_icon {
        width: 1.5rem;
        height: 1.5rem
    }

    .fs-cc-banner3_button {
        text-align: center
    }

    .fs-cc-banner3_button.fs-cc-button-alt {
        margin-bottom: .5rem;
        margin-right: 0
    }

    .fs-cc-prefs3_title {
        font-size: 1.125rem
    }

    .fs-cc-banner3_block {
        text-align: center;
        margin-right: 0
    }

    .fs-cc-prefs3_line {
        min-width: .75rem;
        margin-left: .75rem;
        margin-right: .75rem;
        display: none
    }

    .fs-cc-banner3_buttons-wrapper {
        flex-direction: column;
        width: 100%;
        display: flex
    }

    .fs-cc-prefs3_form-wrapper {
        width: 100%
    }

    .fs-cc-prefs3_buttons-block {
        flex-direction: column;
        display: flex
    }

    .fs-cc-prefs3_option {
        padding-top: .5rem;
        padding-bottom: .5rem
    }

    .transparent-arrow-button-white {
        padding: 18px 20px;
        font-size: 17px
    }

    .resources-hero-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px
    }

    .resource-tabs-wrapper {
        max-width: 420px;
        padding-top: 80px;
        padding-bottom: 80px
    }

    .resource-tab-header {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        flex-flow: wrap;
        align-items: center
    }

    .resource-collection-list {
        grid-template-columns: 1fr
    }

    .resource-post-image-wrapper {
        height: 200px
    }

    .div-block-733 {
        grid-template-columns: 1fr
    }

    .div-block-735,
    .div-block-736 {
        width: 100%
    }

    .div-block-737 {
        padding-top: 120px
    }

    .div-block-741 {
        grid-template-columns: 1fr
    }

    .demo-form-wrapper {
        margin-top: 24px;
        padding-left: 0%;
        padding-right: 0%
    }

    .book-demo-form-graphic-1,
    .image-222 {
        display: none
    }

    .flex-split {
        flex-wrap: wrap;
        justify-content: center;
        padding-top: 64px;
        padding-bottom: 64px
    }

    .optimize-hero-content-container {
        width: 100%;
        padding-left: 0;
        padding-right: 0
    }

    .optimize-hero-logo {
        height: 80px
    }

    .div-block-744 {
        justify-content: center
    }

    .blog-tag-radio-buttons-contain {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .resource-tab-form-separator {
        max-width: 250px
    }

    .section-heading.text-center {
        font-size: 32px
    }

    .procurement-team-cards-grid {
        grid-template-columns: 1fr;
        margin-top: 80px
    }

    .procurement-team-member-card {
        margin-top: 21px
    }

    .procurement-team-member-image {
        height: 300px
    }

    .div-block-749 {
        width: 100%
    }

    .integrations-tabs-wrap {
        width: 100%;
        padding-left: 12px;
        padding-right: 12px
    }

    .integrations-tabs-body {
        flex-wrap: wrap
    }

    .integrations-tabs-menu {
        width: 100%
    }

    .tabs-content-3 {
        width: 100%;
        margin-top: 24px;
        padding-left: 0;
        padding-right: 0
    }

    .div-block-750 {
        padding-left: 0;
        padding-right: 0;
        display: block
    }

    .div-block-751 {
        grid-template-columns: auto;
        margin-bottom: 32px
    }

    .saas-hero-text-wrapper {
        margin-top: 65px
    }

    .saas-hero-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px
    }

    .flex-container._140px-bottom-margin {
        grid-column-gap: 100px;
        grid-row-gap: 100px;
        padding-bottom: 100px
    }

    .flex-container._115px-bottom-margin {
        grid-column-gap: 100px;
        grid-row-gap: 100px;
        padding-top: 100px;
        padding-bottom: 100px
    }

    .flex-block-wrapper {
        grid-column-gap: 40px;
        grid-row-gap: 40px
    }

    .flex-block-wrapper.lottie {
        padding-top: 80px
    }

    .flex-block-wrapper.vertical {
        grid-column-gap: 40px;
        grid-row-gap: 40px;
        padding-top: 60px
    }

    .flex-text-block {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .flex-image-block,
    .flex-image-block.cloud-1 {
        padding-top: 30px;
        padding-bottom: 30px
    }

    .solution-callout-text-wrapper.cloud,
    .solution-callout-text-wrapper.saas {
        grid-column-gap: 20px;
        grid-row-gap: 20px;
        padding-bottom: 30px
    }

    .solution-callout-images-contain.cloud,
    .solution-callout-images-contain.saas,
    .solution-callout-image-row {
        grid-column-gap: 12px;
        grid-row-gap: 12px
    }

    .solution-callout-image-row.cloud-second {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .setup-card-text-contain {
        padding: 20px 16px
    }

    .cloud-hero-wrapper {
        grid-column-gap: 60px;
        grid-row-gap: 60px;
        padding-bottom: 120px
    }

    .heading-258 {
        font-size: 32px;
        line-height: 1.2em
    }

    .pricing-table-column-category-header {
        width: 32%;
        margin-left: 0
    }

    .pricing-plan-card.saas-growth {
        margin-left: 0
    }

    .pricing-plan-card.saas-pro {
        width: 100%;
        margin-bottom: 24px;
        margin-right: 0
    }

    .pricing-menu-tabs,
    .pricing-duration-toggle {
        margin-left: 0;
        margin-right: 0
    }

    .div-block-440 {
        display: none
    }

    .div-block-424 {
        margin-top: 82px;
        margin-left: 0;
        margin-right: 0;
        padding-left: 29px;
        padding-right: 29px
    }

    .section-68 {
        padding-top: 99px
    }

    .toggle-contain {
        margin-left: 15px;
        margin-right: 15px
    }

    .div-block-426 {
        flex-wrap: wrap;
        grid-template-columns: auto 1fr 1fr;
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        display: flex
    }

    .div-block-759 {
        padding: 31px 15px
    }

    .heading-260,
    .heading-261 {
        font-size: 24px;
        line-height: 1.2
    }

    .div-block-761 {
        grid-template-columns: 1fr
    }

    .div-block-769 {
        margin-left: 0;
        margin-right: 0;
        padding-left: 0%;
        padding-right: 0%
    }

    .image-224,
    .div-block-773 {
        display: none
    }

    .badge-image.new {
        flex: 0 1 auto;
        max-width: 90px;
        margin-right: 0
    }

    .points-checklist-grid {
        grid-template-columns: 1fr;
        margin-bottom: 30px
    }

    .points-image-wrapper {
        border-radius: 6px
    }

    .image-226 {
        height: 100px
    }

    .section-70 {
        background-image: none;
        background-repeat: repeat;
        background-size: auto;
        padding: 4% 8px 8%
    }

    .heading-263 {
        font-size: 14px
    }

    .div-block-781 {
        grid-template-columns: 1fr
    }

    .div-block-782 {
        flex-wrap: wrap;
        justify-content: center
    }

    .div-block-785 {
        padding-right: 0
    }

    .heading-264 {
        margin-top: 5px;
        font-size: 40px;
        line-height: .7
    }

    .material-icons.sysf-icon-left.sysf-icon-collapse {
        margin-top: 4px
    }

    .sysf-collapse-title {
        line-height: 1.5
    }

    .sysf-collapse-trigger {
        align-items: flex-start
    }

    .sysf-collapse.sysf-borderless {
        padding: 16px
    }

    .sysf-heading.sysf-l {
        font-size: 16px;
        font-weight: 700
    }

    .sysf-tagline {
        padding-left: 28px;
        padding-right: 28px;
        font-size: 14px
    }

    .sysf-body-text.sysf-m.sysf-s-m-b-0 {
        font-size: 14px
    }

    .brix---heading-h3-size {
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 30px
    }

    .brix---display-2 {
        font-size: 38px;
        line-height: 48px
    }

    .brix---heading-h2-size {
        font-size: 24px;
        line-height: 34px
    }

    .brix---container-default {
        padding-left: 20px;
        padding-right: 20px
    }

    .brix---section {
        padding-top: 49px
    }

    .brix---link-icon-right {
        width: 18px
    }

    .brix---text-200-bold {
        font-size: 15px;
        line-height: 16px
    }

    .brix---paragraph-default {
        margin-top: 28px;
        font-size: 17px;
        line-height: 28px
    }

    .brix---mg-bottom-24px {
        margin-bottom: 16px
    }

    .brix---heading-h3-size-2 {
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 30px
    }

    .brix---mg-bottom-8px {
        margin-bottom: 6px
    }

    .brix---mg-bottom-48px {
        margin-bottom: 32px
    }

    .brix---card-link-content-left-fw {
        padding: 24px
    }

    .brix---grid-3-columns---1-col-mb {
        grid-template-columns: 1fr
    }

    .bold-text-26 {
        font-size: 19px;
        line-height: .3
    }

    .column-80 {
        padding-left: 0;
        padding-right: 0
    }

    .button-new {
        margin-top: 13px;
        padding-top: 7px;
        padding-bottom: 7px;
        font-size: 14px
    }

    .button-48 {
        padding-left: 12px;
        padding-right: 12px;
        font-size: 10px
    }

    .paragraph-151 {
        margin-top: 15px;
        font-size: 12px;
        line-height: 1
    }

    .container-1288 {
        padding-left: 5px;
        padding-right: 5px
    }

    .bold-text-27,
    .bold-text-28,
    .bold-text-29 {
        font-size: 16px
    }

    .image-230 {
        text-align: center;
        height: 240px
    }

    .new-product-heading-4 {
        font-size: 32px
    }

    .image-231 {
        text-align: center;
        height: 320px
    }

    .image-232 {
        height: 300px
    }

    .image-233 {
        text-align: center
    }

    .hero-platform-wrapper-solutions {
        width: 100%;
        padding-top: 121px;
        padding-left: 12px;
        padding-right: 12px
    }

    .heading-64px-copy {
        font-size: 42px
    }

    .heading-64px-copy.hero-home-heading {
        font-size: 36px
    }

    .heading-64px-copy.hero-home-heading.top {
        max-width: 400px
    }

    .heading-64px-copy.hero-home-heading.zendesk {
        width: 152.828px
    }

    .heading-64px-copy.text-align-center {
        margin-bottom: 16px;
        font-size: 24px
    }

    .heading-64px-copy.text-align-center.include-bg-element {
        margin-top: 0
    }

    .heading-64px-copy.blogs-hero-heading,
    .heading-64px-copy.resource-hero-heading {
        font-size: 38px
    }

    .heading-64px-new {
        font-size: 42px
    }

    .heading-64px-new.hero-home-heading {
        font-size: 36px
    }

    .heading-64px-new.hero-home-heading.top {
        max-width: 400px
    }

    .heading-64px-new.hero-home-heading.zendesk {
        width: 152.828px
    }

    .heading-64px-new.text-align-center {
        margin-bottom: 16px;
        padding-left: 13px;
        padding-right: 13px;
        font-size: 25px
    }

    .heading-64px-new.text-align-center.include-bg-element {
        margin-top: 0
    }

    .heading-64px-new.blogs-hero-heading,
    .heading-64px-new.resource-hero-heading {
        font-size: 38px
    }

    .image-238 {
        object-fit: contain;
        flex: 1 1;
        align-self: center
    }

    .feature-image-wrapper-copy.right.green-bg {
        text-align: center;
        flex-flow: column;
        flex: 1 1;
        order: -1;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 0
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        text-align: center;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        height: 350px;
        padding-bottom: 0;
        padding-left: 0
    }

    .image-240 {
        align-self: center
    }

    .paragraph-18px-copy.spend-block-paragraph,
    .paragraph-18px-copy.reviewer-position {
        font-size: 14px
    }

    .paragraph-18px-copy.saas-hero-paragraph,
    .paragraph-18px-copy.cloud-hero-paragraph {
        margin-bottom: 10px
    }

    .heading-48px-copy {
        font-size: 32px
    }

    .heading-48px-copy.stack-heading {
        margin-bottom: 30px
    }

    .paragraph-18px-copy.hero-home-paragraph {
        margin-bottom: 10px
    }

    .paragraph-18px-copy.integrations-paragraph {
        margin-bottom: 30px
    }

    .paragraph-18px-copy.spend-block-paragraph,
    .paragraph-18px-copy.reviewer-position {
        font-size: 14px
    }

    .paragraph-18px-copy.saas-hero-paragraph,
    .paragraph-18px-copy.cloud-hero-paragraph {
        margin-bottom: 10px
    }

    .heading-28px-copy {
        font-size: 20px
    }

    .div-block-793 {
        margin-bottom: 11px
    }

    .heading-28px-copy-copy {
        font-size: 20px
    }

    .spend-analyse-footer {
        padding-bottom: 80px
    }

    .feature-image-wrapper-copy-copy.right.pink-bg {
        order: -1;
        width: 100%;
        padding-right: 16px
    }

    .feature-image-wrapper-copy-copy.right.green-bg {
        text-align: center;
        flex-flow: column;
        flex: 1 1;
        order: -1;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 0
    }

    .feature-image-wrapper-copy-copy.right.yellow-bg {
        text-align: center;
        flex: 1 1
    }

    .feature-image-wrapper-copy-copy.right.green-bg-copy {
        text-align: center;
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
        order: -1;
        width: 100%
    }

    .feature-image-wrapper-copy-copy.left.green-bg {
        text-align: center;
        width: 100%;
        padding-left: 16px
    }

    .feature-image-wrapper-copy-copy.left.yellow-bg {
        text-align: center;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        height: 350px;
        padding-bottom: 0;
        padding-left: 0
    }

    .feature-image-wrapper-copy-copy.left.pink-bg {
        text-align: center;
        width: 100%
    }

    .feature-content-wrap-copy {
        width: 100%
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        text-align: center;
        width: 100%;
        padding-bottom: 16px;
        padding-left: 16px
    }

    .stats-wrapper-copy,
    .stats-wrapper-new,
    .stats-wrapper-copy {
        margin-top: -5px;
        padding-top: 39px;
        padding-bottom: 50px
    }

    .feature-image-wrapper-copy.right.pink-bg {
        order: -1;
        width: 100%;
        padding-right: 16px
    }

    .feature-image-wrapper-copy.right.green-bg {
        text-align: center;
        order: -1;
        width: 100%
    }

    .feature-image-wrapper-copy.right.yellow-bg {
        text-align: center;
        flex: 1 1
    }

    .feature-image-wrapper-copy.right.green-bg-copy {
        text-align: center;
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
        order: -1;
        width: 100%
    }

    .feature-image-wrapper-copy.left.green-bg {
        text-align: center;
        width: 100%;
        padding-left: 16px
    }

    .feature-image-wrapper-copy.left.yellow-bg {
        text-align: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 16px;
        padding-left: 16px
    }

    .feature-image-wrapper-copy.left.pink-bg {
        text-align: center;
        width: 100%
    }

    .hero-button-cta-copy {
        padding-left: 18px;
        padding-right: 18px
    }

    .feature-image-wrapper-copy-copy-copy.right.pink-bg {
        order: -1;
        width: 100%;
        padding-right: 16px
    }

    .feature-image-wrapper-copy-copy-copy.right.green-bg {
        text-align: center;
        flex-flow: column;
        flex: 1 1;
        order: -1;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 0
    }

    .feature-image-wrapper-copy-copy-copy.right.yellow-bg {
        text-align: center;
        flex: 1 1
    }

    .feature-image-wrapper-copy-copy-copy.right.green-bg-copy {
        text-align: center;
        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);
        order: -1;
        width: 100%
    }

    .feature-image-wrapper-copy-copy-copy.left.green-bg {
        text-align: center;
        width: 100%;
        padding-left: 16px
    }

    .feature-image-wrapper-copy-copy-copy.left.yellow-bg {
        text-align: center;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        height: 350px;
        padding-bottom: 0;
        padding-left: 0
    }

    .feature-image-wrapper-copy-copy-copy.left.pink-bg {
        text-align: center;
        width: 100%
    }

    .image-212-copy,
    .image-212-copy-copy {
        width: auto;
        height: auto;
        min-height: auto;
        max-height: 36px
    }

    .hero-heading-copy {
        margin-top: 47px;
        font-size: 36px
    }

    .home-value-heading-copy {
        margin-top: 35px;
        font-size: 32px;
        line-height: 38px
    }

    .div-block-20-copy {
        width: 100%;
        padding: 32px 8px
    }

    .div-block-21-copy {
        padding: 24px 16px
    }

    .div-block-21-copy.registration-form-block {
        padding-left: 8px;
        padding-right: 8px
    }

    .features-section-copy {
        padding-bottom: 80px
    }

    .image-231-copy {
        text-align: center;
        height: 320px
    }

    .fast-track-approval-hero-section-copy {
        margin-bottom: 140px
    }

    .wrapper-1280px-copy {
        flex-direction: column;
        justify-content: space-between;
        width: 90%
    }

    .wrapper-1280px-copy.solution-wrapper,
    .wrapper-1280px-copy.split-wrapper {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px-copy.finance-wrapper {
        padding-top: 80px
    }

    .wrapper-1280px-copy.case-study-hero-flex {
        padding-top: 60px;
        padding-bottom: 50px
    }

    .wrapper-1280px-copy.case-study-flex {
        padding-top: 50px;
        padding-bottom: 50px
    }

    .wrapper-1280px-copy.fast-track-approval-hero-flex {
        padding-top: 60px
    }

    .wrapper-1280px-copy.document-one-place-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px-copy.assisted-tools-flex {
        padding-bottom: 100px
    }

    .wrapper-1280px-copy.assisted-purchasing-flex {
        margin-top: 0;
        padding-top: 60px
    }

    .wrapper-1280px-copy.actionable-insight-flex {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .wrapper-1280px-copy.custo {
        padding-top: 40px;
        padding-bottom: 40px
    }

    .wrapper-1280px-copy.points-container {
        padding-top: 80px;
        padding-bottom: 80px
    }

    .container-1290 {
        max-width: none
    }

    .nav-menu-three {
        flex-direction: column
    }

    .hello-bar-link {
        font-size: 12px
    }

    .new-hello-bar {
        padding-left: 38px;
        padding-right: 38px;
        overflow: visible
    }

    .heading-90px-copy {
        font-size: 48px
    }

    .heading-24px-copy.stats-text {
        margin-bottom: 0
    }

    .heading-24px-copy.review-text {
        font-size: 17px
    }

    .heading-24px-copy.setup-card-text {
        font-size: 18px
    }

    .heading-24px-copy.stats-text-copy {
        margin-bottom: 0
    }

    .pitch-section-copy {
        padding-top: 100px;
        padding-bottom: 100px
    }

    .home-hero-heading-copy {
        font-size: 32px;
        line-height: 1.4em
    }

    .image-246 {
        height: 20px
    }

    .stats-grid-copy {
        grid-column-gap: 16px;
        grid-row-gap: 16px
    }

    .home-split-section-copy {
        padding-top: 0;
        padding-bottom: 60px
    }

    .home-split-section-copy.light-grey-bg {
        padding: 60px 8px
    }

    .wrapper-1300px-copy-copy {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .wrapper-1300px-copy-copy.adjust-padding {
        padding-top: 16px
    }

    .image-247 {
        height: 100%
    }

    .collection-list-8 {
        padding-left: 9px;
        padding-right: 9px
    }

    .blog-hero-heading-copy {
        max-width: none;
        padding-left: 14px;
        padding-right: 14px;
        font-size: 26px;
        line-height: 38px
    }

    .blog-collection-item-copy {
        padding-left: 8px;
        padding-right: 8px
    }

    .blog-collection-item-copy.margin.custo {
        border-width: 6px;
        margin-right: 0;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .blog-collection-item-copy.limit-width.custo {
        border-width: 6px;
        margin-top: 16px;
        margin-left: 0;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .blog-collection-item-copy-copy.margin.custo {
        border-width: 6px;
        margin-right: 0;
        padding: 20px
    }

    .blog-collection-item-copy-copy {
        padding-left: 8px;
        padding-right: 8px
    }

    .blog-collection-item-copy-copy.margin.custo {
        border-width: 6px;
        margin-right: 0;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .blog-collection-item-copy-copy.limit-width.custo {
        border-width: 6px;
        margin-top: 16px;
        margin-left: 0;
        padding-top: 20px;
        padding-bottom: 20px
    }

    .text-block-330 {
        margin-top: 46px;
        margin-bottom: 35px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 24px;
        line-height: 1.3
    }

    .cms-blog-block-section-copy {
        padding-bottom: 140px
    }

    .cms-blog-block-section-copy.templates-block {
        margin-top: -301px
    }

    .about-hero-wrapper-copy {
        background-position: 0%, 100%
    }

    .wrapper-1300px-copy {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .wrapper-1300px-copy.adjust-padding {
        padding-top: 16px
    }

    .new-about-1300px-header {
        width: 100%;
        padding-left: 8px;
        padding-right: 8px
    }

    .new-about-1300px-header.adjust-padding {
        padding-top: 16px
    }

    .new-about-hero-wrapper {
        background-position: 0%, 100%
    }

    .text-span-294 {
        padding-left: 9px;
        padding-right: 9px;
        font-size: 18px;
        line-height: 1.1
    }

    .xs-text {
        font-size: 32px
    }

    .about-heading-x {
        padding-left: 10px;
        padding-right: 10px;
        font-size: 32px;
        line-height: 1.2
    }

    .stats-wrapper-copy-copy,
    .stats-xx {
        margin-top: 15px;
        padding-top: 39px;
        padding-bottom: 80px
    }

    .text-block-332 {
        font-size: 32px
    }

    .text-block-332.intra,
    .text-span-295 {
        text-align: center
    }

    .tribe-tab-image-contain-copy {
        padding-top: 30px;
        padding-bottom: 30px
    }

    .about-x-cards,
    .about-x-cards.new {
        width: 95%
    }

    .text-block-344 {
        font-size: 16px;
        line-height: 1.2
    }

    .pricing-block {
        width: 100%;
        margin-right: 0;
        padding-left: 20px;
        padding-right: 20px
    }

    .div-block-814 {
        margin-bottom: 20px
    }

    .text-block-345,
    .text-block-346 {
        font-size: 19px;
        line-height: 1.2
    }

    .pricing-cards {
        margin-right: 0
    }

    .pricing-card {
        width: 100%
    }

    .container-1291 {
        margin-left: 5px;
        margin-right: 5px
    }

    .faq-item-x.demo {
        padding-top: 44px;
        padding-bottom: 44px
    }

    .heading-265 {
        font-size: 16px;
        line-height: 1.3
    }

    .faq-answer {
        padding-top: 2px
    }

    .paragraph-153 {
        text-align: left;
        font-size: 14px
    }

    .section-72 {
        background-color: rgba(250, 242, 235, 0);
        padding-left: 10px;
        padding-right: 10px
    }

    .section-72.what-is-in {
        padding-left: 10px;
        padding-right: 10px
    }

    .section-72.ebooks,
    .section-72.events {
        background-color: var(--soft-pink)
    }

    .section-72.testimonial {
        padding-top: 70px;
        padding-left: 20px;
        padding-right: 20px
    }

    .section-72.expectation {
        padding-left: 10px;
        padding-right: 10px
    }

    .section-72.optimize {
        padding-top: 93px
    }

    .section-72.block3 {
        padding-top: 0
    }

    .div-block-823 {
        display: none
    }

    .image-249 {
        height: 300px
    }

    .div-block-824 {
        border-bottom-right-radius: 35px;
        border-bottom-left-radius: 35px;
        justify-content: center;
        align-items: center;
        padding-bottom: 100px;
        padding-left: 35px;
        padding-right: 35px
    }

    .text-block-357,
    .text-block-357.events {
        text-align: center;
        font-size: 32px
    }

    .text-block-358 {
        text-align: justify;
        margin-bottom: 23px;
        font-size: 14px
    }

    .div-block-827 {
        padding-left: 10px;
        padding-right: 10px
    }

    .text-block-359,
    .text-block-359.events {
        text-align: center;
        font-size: 32px
    }

    .div-block-829.why {
        padding-left: 14px;
        padding-right: 14px
    }

    .div-block-830.why {
        width: 100%
    }

    .text-block-360 {
        font-size: 28px
    }

    .text-block-360.why {
        padding-left: 11px;
        padding-right: 11px
    }

    .text-block-361,
    .text-block-363 {
        font-size: 28px
    }

    .div-block-838 {
        align-self: center
    }

    .div-block-839 {
        padding-left: 13px;
        padding-right: 13px
    }

    .text-block-370,
    .text-block-371 {
        text-align: center;
        font-size: 16px
    }

    .div-block-841 {
        justify-content: center;
        align-items: center
    }

    .div-block-843 {
        margin-bottom: 65px
    }

    .partners {
        border-right-width: 0;
        align-self: center;
        padding-left: 0
    }

    .partners.partner-logos {
        border-left: 0px solid var(--light-slate-grey);
        border-right-width: 0;
        align-self: center
    }

    .div-block-845 {
        grid-column-gap: 9px;
        grid-row-gap: 9px;
        flex-flow: column;
        justify-content: flex-start;
        align-items: center
    }

    .image-253 {
        height: 20px
    }

    .text-block-373 {
        text-align: center;
        font-size: 16px
    }

    .image-256 {
        line-height: 1.2
    }

    .testimonialx {
        padding-top: 30px;
        padding-left: 30px
    }

    .testimonial-new-logo {
        height: 40px
    }

    .text-block-375 {
        margin-bottom: 0
    }

    .text-block-376 {
        text-align: center;
        margin-bottom: 98px;
        line-height: 1.2
    }

    .text-block-377 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center;
        display: flex
    }

    .div-block-850.partner {
        margin-top: 47px;
        padding-left: 20px;
        padding-right: 20px
    }

    .event-exectations-tab {
        padding-left: 10px;
        padding-right: 10px
    }

    .text-block-379 {
        justify-content: center;
        align-items: flex-start;
        padding-left: 40%
    }

    .text-block-380 {
        padding-left: 30px;
        padding-right: 30px;
        font-size: 32px;
        line-height: 1.2
    }

    .rich-text-block-30 {
        text-align: left;
        flex: 0 1 auto;
        order: 0;
        align-self: auto;
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        padding-left: 21px;
        padding-right: 21px
    }

    .div-block-853 {
        padding-left: 10px;
        padding-right: 10px
    }

    .div-block-857 {
        height: 400px
    }

    .sysf-button.sysf-medium {
        align-self: stretch
    }

    .text-block-382 {
        font-size: 14px
    }

    .div-block-858 {
        grid-template-columns: 1fr 1fr
    }

    .div-block-859 {
        flex-flow: column;
        justify-content: flex-start;
        align-items: center
    }

    .text-block-385 {
        text-align: center
    }

    .your-grid-container {
        flex-flow: column;
        grid-template-columns: 1fr;
        align-items: center;
        justify-items: center
    }

    .feature-block-item.yellow1 {
        background-repeat: repeat-y;
        padding: 10% 5%
    }

    .feature-block-item.yellow2 {
        grid-column-gap: 25px;
        grid-row-gap: 25px
    }

    .feature-block-content-logo {
        height: 60px
    }

    .feature-text-header {
        font-size: 22px
    }

    .text-block-386 {
        font-size: 14px
    }

    .div-block-861.slider {
        margin-bottom: 0;
        overflow: hidden
    }

    .div-block-862 {
        width: auto;
        max-width: none;
        height: auto;
        /*height: 300px;*/
        /*padding-top: 20px*/
    }

    .div-block-863 {
        width: 100%;
        margin-bottom: 20px;
        padding: 40px 30px;
        overflow: hidden
    }

    .tabs-menu-6 {
        flex-flow: column;
        grid-template-columns: 1fr;
        justify-content: space-between;
        align-items: center
    }

    .image-262 {
        object-fit: fill;
        width: 260px;
        overflow: visible
    }

    .text-block-388 {
        text-align: center
    }

    .container-1292 {
        max-width: none
    }

    .clients-quote {
        font-size: 20px;
        line-height: 28px
    }

    .clients-info-image {
        margin-right: 16px
    }

    .clients-grid {
        grid-column-gap: 20px;
        grid-row-gap: 40px;
        grid-template-columns: 1fr 1fr
    }

    .slide-23 {
        object-fit: contain;
        margin-right: 5px
    }

    .slider-22 {
        padding-left: 10px;
        padding-right: 10px;
        position: relative
    }

    .tabs-menu-7 {
        flex-flow: row;
        justify-content: flex-start;
        align-items: flex-start;
        height: 380px
    }

    .tabs-content-5 {
        height: 300px
    }

    .tab-link-tab-1-3 {
        height: auto;
        padding-left: 10px
    }

    .tab-link-tab-1-3.w--current {
        justify-content: flex-start;
        align-items: center;
        height: auto;
        padding-left: 10px
    }

    .tab-link-tab-2-3 {
        height: auto;
        padding-left: 0;
        padding-right: 0
    }

    .tab-link-tab-3-2 {
        height: auto
    }

    .text-block-389 {
        font-size: 14px
    }

    .div-block-868 {
        height: 300px
    }

    .text-block-391 {
        text-align: center;
        font-size: 40px
    }

    .div-block-870 {
        height: 200px;
        margin-top: 20px;
        margin-bottom: 20px
    }

    .div-block-872 {
        width: 100%
    }

    .div-block-872.new {
        width: 90%;
        padding-top: 8px;
        padding-bottom: 8px
    }

    .div-block-875 {
        grid-column-gap: 9px;
        grid-row-gap: 9px;
        flex-flow: column
    }

    .div-block-878 {
        margin-top: 25px;
        margin-bottom: 18px
    }

    .text-block-397 {
        font-size: 16px
    }

    .text-block-398 {
        width: 90%;
        font-size: 24px
    }

    .div-block-884 {
        padding-left: 35px;
        padding-right: 35px
    }

    .text-block-407 {
        margin-bottom: 5px;
        font-size: 40px
    }

    .text-block-408 {
        font-size: 16px
    }

    .image-270 {
        height: 45px
    }

    .image-270.fold-2 {
        height: 40px
    }

    .div-block-891 {
        padding-left: 11px;
        padding-right: 11px
    }

    .div-block-892.fold3.fold4 {
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px
    }

    .button-53 {
        text-align: center;
        padding-left: 30px;
        padding-right: 34px;
        font-size: 16px
    }

    .div-block-896 {
        padding-left: 40px;
        padding-right: 40px
    }

    .text-block-412 {
        padding-left: 0;
        font-size: 30px
    }

    .div-block-897 {
        width: 100%;
        margin-top: 0;
        padding-top: 54px
    }

    .div-block-902 {
        grid-column-gap: 29px;
        grid-row-gap: 29px;
        padding-right: 0
    }

    .text-block-415 {
        font-size: 32px;
        line-height: 1.2
    }

    .text-block-417 {
        text-align: center;
        font-size: 16px
    }

    .text-block-418 {
        font-size: 16px
    }

    .div-block-905 {
        justify-content: flex-start;
        align-items: flex-start
    }

    .container-1293 {
        max-width: none
    }

    .nav-menu-two {
        flex-direction: column
    }

    .menu-button-12,
    .menu-button-12:active {
        padding-right: 0
    }

    .image-277 {
        padding-left: 0
    }

    .text-span-376 {
        font-size: 32px
    }

    .text-block-419 {
        text-align: justify;
        font-size: 18px
    }

    .text-block-422 {
        width: 90%
    }

    .div-block-908 {
        grid-column-gap: 30px;
        grid-row-gap: 30px
    }

    .div-block-910 {
        padding-left: 40px;
        padding-right: 40px
    }

    .text-block-425 {
        font-size: 16px
    }

    .text-block-426 {
        font-size: 12px
    }

    .text-block-427 {
        font-size: 16px
    }

    .text-block-430 {
        font-size: 10px
    }
}

#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc747-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc790-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc791-93cb7710 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc792-93cb7710 {
    grid-area: span 1/span 2/span 1/span 2
}

#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc793-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc84d-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc858-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc86c-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc877-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc88b-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc896-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc8aa-93cb7710,
#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc8b5-93cb7710,
#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9cc97-cee9cc82,
#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9cc9d-cee9cc82,
#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccac-cee9cc82,
#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccbb-cee9cc82 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: auto
}

#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b54-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b58-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b5c-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b60-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b64-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b68-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b6c-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b70-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b74-e3ba9b4c,
#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b78-e3ba9b4c,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c0f-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c15-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c1b-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c21-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c27-ebcc7be3,
#w-node-bb90c496-c575-1494-3005-6bcdf8e82a17-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c32-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c3a-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c4b-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cb2-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cbb-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cc4-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7ccd-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cd6-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cdf-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7ceb-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cec-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cee-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d2b-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d35-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d3a-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d43-ebcc7be3,
#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d4e-ebcc7be3,
#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f009-3251eff9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f010-3251eff9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f011-3251eff9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f012-3251eff9,
#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f013-3251eff9,
#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f014-3251eff9,
#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f015-3251eff9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f016-3251eff9,
#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f017-3251eff9,
#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a9296e-f64fae89,
#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a92977-f64fae89,
#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a92986-f64fae89,
#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a92995-f64fae89,
#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a929ac-f64fae89,
#w-node-_623e8343-de28-bcf3-6173-0032134eba50-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba56-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba5c-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba62-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba68-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba73-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba7b-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134eba8c-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebaf3-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebafc-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb05-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb0e-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb17-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb23-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb24-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb26-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb63-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb6d-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb72-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb7b-074bcbbe,
#w-node-_623e8343-de28-bcf3-6173-0032134ebb86-074bcbbe,
#w-node-_4d46cc23-8ec1-3981-be6a-a103125fbe80-93cb7738,
#w-node-_89cd2751-9b34-2040-9f21-4a7cc8f42a90-93cb7738,
#w-node-b6ea5126-82cc-9c4c-845a-b3ac63d6f8c8-93cb7738,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80ce-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80d4-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80da-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80e0-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80e6-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80f1-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80f9-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d810a-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8173-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d817c-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8185-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d818e-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8197-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81a3-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81a4-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81a6-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81e3-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81ed-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81f2-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81fb-eb80e708,
#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8206-eb80e708,
#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7739,
#w-node-ad2baa79-e05c-3254-6679-d28f7b6620b6-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ad2baa79-e05c-3254-6679-d28f7b6620bc-50e938d3 {
    justify-self: auto
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e938e4-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e938ea-50e938d3 {
    justify-self: auto
}

#w-node-_807a9b0f-1427-d35d-746f-e6219c1b7a1e-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_807a9b0f-1427-d35d-746f-e6219c1b7a24-50e938d3 {
    justify-self: auto
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e938f8-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93900-50e938d3 {
    justify-self: auto
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93911-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93917-50e938d3 {
    justify-self: auto
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93925-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e9392b-50e938d3 {
    justify-self: auto
}

#w-node-_7a0adbe3-9234-ae81-b72f-8b8f1baf7065-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7a0adbe3-9234-ae81-b72f-8b8f1baf706b-50e938d3 {
    justify-self: auto
}

#w-node-ba8fc776-c335-adf3-3775-c9e333014c4f-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ba8fc776-c335-adf3-3775-c9e333014c55-50e938d3 {
    justify-self: auto
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb53890ed-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb53890f3-50e938d3 {
    justify-self: auto
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389107-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb538910d-50e938d3 {
    justify-self: auto
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb538911e-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389124-50e938d3 {
    justify-self: auto
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389138-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389140-50e938d3 {
    justify-self: auto
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb538914e-50e938d3 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389154-50e938d3 {
    justify-self: auto
}

#w-node-d862036f-348e-95b1-d411-9d2c13184902-93cb773c,
#w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c409-93cb773c,
#w-node-_01b5676c-0c15-b261-4ad0-393603f95b9d-93cb773c {
    align-self: auto;
    justify-self: auto
}

#w-node-_89e33cb6-1014-442c-9dc8-61847d5443c4-7d5443b9,
#w-node-_89e33cb6-1014-442c-9dc8-61847d5443cf-7d5443b9,
#w-node-_89e33cb6-1014-442c-9dc8-61847d5443da-7d5443b9,
#w-node-_89e33cb6-1014-442c-9dc8-61847d5443e5-7d5443b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_715b4270-6d1c-2ced-4a71-388d64049471-93cb773e,
#w-node-_3eb03c01-305f-629a-cfc8-eab54b8bd47b-93cb773e {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_2caa981a-1245-8dde-0467-aa5c2e271ab6-93cb773e,
#w-node-_87009e58-eb0d-089a-8953-434470df64e4-93cb773e,
#w-node-_2f307556-891f-bdaf-0872-21266377a3f2-93cb773e,
#w-node-_4c92dfac-3403-9d50-d207-d6bc2b20a7b4-93cb773e,
#w-node-_4c92dfac-3403-9d50-d207-d6bc2b20a7b5-93cb773e,
#w-node-_4c92dfac-3403-9d50-d207-d6bc2b20a7b7-93cb773e,
#w-node-b32ab332-5753-8f6b-532d-f38d1558a8ce-93cb773e,
#w-node-b32ab332-5753-8f6b-532d-f38d1558a8cf-93cb773e,
#w-node-b32ab332-5753-8f6b-532d-f38d1558a8d1-93cb773e,
#w-node-d25799f6-7178-8313-ed07-6b3027a55c07-93cb773e,
#w-node-d25799f6-7178-8313-ed07-6b3027a55c08-93cb773e,
#w-node-d25799f6-7178-8313-ed07-6b3027a55c0a-93cb773e,
#w-node-cc09c278-2d84-4b68-e023-f85d3deb23df-93cb773e,
#w-node-cc09c278-2d84-4b68-e023-f85d3deb23e0-93cb773e,
#w-node-cc09c278-2d84-4b68-e023-f85d3deb23e2-93cb773e,
#w-node-a77735db-1cfb-6d8d-bb24-f08f06dab9f9-93cb773e,
#w-node-a77735db-1cfb-6d8d-bb24-f08f06dab9fa-93cb773e,
#w-node-a77735db-1cfb-6d8d-bb24-f08f06dab9fc-93cb773e,
#w-node-_7011b672-cb26-acc2-a652-4e8490d3b62e-93cb773e,
#w-node-_1d5d3793-a225-fd5d-bfdd-8c37bd765b9b-93cb773e,
#w-node-_056e026c-8303-e237-7c96-bf7aaad99942-93cb773e,
#w-node-_9c2831d2-277b-57c9-aab2-99f6da57f9d6-93cb773e,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7742,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7742,
#w-node-_4741a5ad-ecb8-45fd-b97a-63442878d5a8-93cb7742,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7742,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7742,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7742,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7742,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7742,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7742,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7742,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7742,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7742,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7742,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7742,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7742,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7742,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7742,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7742,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7742,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7742,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7742 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7742 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7742 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7742 {
    align-self: auto
}

#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ee1-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ee7-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668eed-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ef3-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ef9-2b668eb5,
#w-node-_6fef27fb-c1a3-2d06-748d-88a0eb1b42fd-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f04-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f0c-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f1d-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f84-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f8d-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f96-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f9f-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fa8-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fb1-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fbd-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fbe-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fc0-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ffd-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b669007-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b66900c-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b669015-2b668eb5,
#w-node-b5b5c87e-96d1-ed72-0d99-0c032b669020-2b668eb5,
#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7767,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74754d-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74754f-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747553-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747555-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74755b-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74755d-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747561-93cb7768,
#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747563-93cb7768 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d1a-93cb777d,
#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d21-93cb777d,
#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d28-93cb777d {
    justify-self: start
}

#w-node-_6485294b-ab01-ed67-2584-5f9d485441c7-93cb777d,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441c9-93cb777d,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441cd-93cb777d,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441cf-93cb777d,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027c-93cb777d,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027e-93cb777d,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0276-93cb777d,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0278-93cb777d {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d1a-93cb777e,
#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d21-93cb777e,
#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d28-93cb777e {
    justify-self: start
}

#w-node-_6485294b-ab01-ed67-2584-5f9d485441c7-93cb777e,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441c9-93cb777e,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441cd-93cb777e,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441cf-93cb777e,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027c-93cb777e,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027e-93cb777e,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0276-93cb777e,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0278-93cb777e {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb507-93cb777e {
    grid-area: 2/3/3/4
}

#w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb509-93cb777e {
    grid-area: 1/6/2/7
}

#w-node-_004f5ffd-4e87-3312-5474-6201acf36f5d-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f64-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f6b-93cb7781 {
    justify-self: start
}

#w-node-_004f5ffd-4e87-3312-5474-6201acf36f83-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f85-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f89-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f8b-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f91-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f93-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f97-93cb7781,
#w-node-_004f5ffd-4e87-3312-5474-6201acf36f99-93cb7781,
#w-node-ef91da35-ecaa-722e-9ce4-bb73d611f68c-93cb7783,
#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4ad-93cb7785 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4ae-93cb7785 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4b8-93cb7785 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4b9-93cb7785 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6a78-c7ab6a6d {
    justify-self: auto
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6a8a-c7ab6a6d {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6a93-c7ab6a6d {
    justify-self: auto
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6aa2-c7ab6a6d {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6aaa-c7ab6a6d {
    justify-self: auto
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6abc-c7ab6a6d {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6ac5-c7ab6a6d {
    justify-self: auto
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6ad4-c7ab6a6d {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6adc-c7ab6a6d {
    justify-self: auto
}

#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6aee-c7ab6a6d,
#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d093-93cb77b5,
#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d094-93cb77b5,
#w-node-_173a66da-ce82-391d-b1bb-616b52906002-93cb77b5,
#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d095-93cb77b5,
#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d098-93cb77b5,
#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1162-93cb77b5,
#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1163-93cb77b5,
#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1164-93cb77b5,
#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1167-93cb77b5,
#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85bc-93cb77b5,
#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85bd-93cb77b5,
#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85be-93cb77b5,
#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85c1-93cb77b5,
#w-node-_656a7e81-99fa-7551-bcf3-1ce7d65152b0-93cb77b5,
#w-node-_9faa675f-6c11-6b9d-f734-a4dce26246df-93cb77b5,
#w-node-bb9b15ad-1503-97f7-7b5e-d4b02332802a-93cb77b5,
#w-node-e587e106-802b-2556-d74a-ec206db554a5-93cb77b5,
#w-node-fb07354c-3001-0cd3-a6ed-12c47c3602d5-93cb77b5,
#w-node-e36009ac-1019-2bb2-f4ac-30d9ec069657-7ffd0210,
#w-node-_1dadb9fe-2716-4601-cb13-bcc5abe02a2e-7ffd0210,
#w-node-_72100bcb-af0e-6fec-fb8a-026a9d9ff525-7ffd0210,
#w-node-_7c4ceb90-8b97-9a97-62c3-1e1fd8d08f8f-7ffd0210,
#w-node-bdaea790-1339-2737-6da2-26c4d7d5caa0-7ffd0210,
#w-node-_41358288-42c7-6637-1f48-e5c10aee1e1d-7ffd0210,
#w-node-_41358288-42c7-6637-1f48-e5c10aee1e23-7ffd0210,
#w-node-fd8ae82b-b2bd-d5db-b405-7aa3cf5388b6-7ffd0210,
#w-node-_8010d6a4-3129-3481-4ecd-e9b1998d3760-7ffd0210,
#w-node-b05c4180-8284-4d67-95be-60429ebd1be0-7ffd0210,
#w-node-_8a4f3811-4024-3314-89f5-0df7d8b16f41-7ffd0210,
#w-node-_2c6ff113-7933-5b7d-da7f-ef94e9273b20-7ffd0210,
#w-node-_11a4e2eb-60d9-1575-e3cf-df436cce5ade-7ffd0210,
#w-node-c8d24d95-0015-7003-5821-cf099944a0e3-7ffd0210,
#w-node-_40c3cd2e-5e65-ca1a-f414-fa6673b7c52f-7ffd0210,
#w-node-_40c3cd2e-5e65-ca1a-f414-fa6673b7c530-7ffd0210,
#w-node-_40c3cd2e-5e65-ca1a-f414-fa6673b7c532-7ffd0210,
#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab40-7ffd0210,
#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab52-7ffd0210,
#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab4c-7ffd0210,
#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab5d-7ffd0210,
#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab65-7ffd0210,
#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb77b6,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb77b6,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb77b6,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb77b6,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb77b6,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb77b6,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb77b6,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb77b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb77b6 {
    align-self: auto
}

#w-node-_05fbec55-15d5-bc10-882a-1b7b0e76a32e-93cb77b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb77b7 {
    align-self: center;
    justify-self: center
}

#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb77b7,
#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb77b7,
#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb77b7,
#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb77b7,
#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb77b7,
#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb77b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb77ba {
    align-self: center;
    justify-self: center
}

#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb77ba,
#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb77ba,
#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb77ba,
#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb77ba,
#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb77ba,
#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb77ba,
#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a05-3d1729f0,
#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a0e-3d1729f0,
#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a1d-3d1729f0,
#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a2c-3d1729f0,
#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a43-3d1729f0,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade208-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade20d-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade212-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade217-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade21c-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade223-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade22a-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade234-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade236-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade238-93cb77c1,
#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade2ad-93cb77c1 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-bc52e2fc-ca3c-6bdb-456b-b0ea36b12fcd-93cb77c5 {
    align-self: center;
    justify-self: center
}

#w-node-_77e61512-b93e-4a57-37ef-af13341d0e17-93cb77c5 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-bc52e2fc-ca3c-6bdb-456b-b0ea36b12fdb-93cb77c5 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-bc52e2fc-ca3c-6bdb-456b-b0ea36b12fde-93cb77c5 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286a-93cb77c5 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto
}

#w-node-ffd203e1-5d43-182d-4ab2-9c0c6e5340c8-93cb77c5 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286b-93cb77c5,
#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286d-93cb77c5 {
    align-self: center
}

#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286e-93cb77c5,
#w-node-_32e39d14-5354-1527-7a58-f64d595cf77b-93cb77c5 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_9286401d-042d-36a3-288e-3545ffeb5510-93cb77c5 {
    justify-self: center
}

#w-node-_3a15f428-faa7-1bad-165a-b317a22f014e-93cb77dd {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd77f5-93cb77dd {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start;
    justify-self: center
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd77f6-93cb77dd {
    align-self: center;
    justify-self: center
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd77fe-93cb77dd {
    grid-area: span 1/span 2/span 1/span 2
}

#w-node-aa0513c7-4063-1380-347c-1a244a4c3ce2-93cb77dd,
#w-node-ff5cfcca-aec9-fdce-4621-e1ab4ae15728-93cb77dd,
#w-node-_5e6bb53a-fe25-f8a7-5b59-e9739f100201-93cb77dd {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7832-93cb77dd {
    align-self: center
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7838-93cb77dd {
    align-self: center;
    justify-self: center
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd784b-93cb77dd {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd785f-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7861-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7865-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7867-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd786b-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd786d-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7871-93cb77dd,
#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7873-93cb77dd {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd788f-93cb77dd {
    align-self: center
}

#w-node-c3872391-191b-f9ec-8d33-d740c07e2c73-93cb77fc,
#w-node-c4c37850-5df6-a06e-9a39-f93f6d779d0f-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-d26efc9b-757f-6b02-d6d9-6ed47e6eb92b-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-_32738114-c87c-8350-29fe-5f8a97eca111-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_802fb8c7-6066-06bc-5774-9463292fba4a-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-b094e1d1-5991-5a05-e7ca-30e4a066e338-93cb77fc {
    grid-area: span 1/span 2/span 1/span 2
}

#w-node-fa50ae89-2e56-e30c-dfea-4fa302f9ba75-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-eb3769ea-b13f-fff9-bfef-b81b424a2795-93cb77fc,
#w-node-_22aa8215-645d-8e69-b038-a4001bbae991-93cb77fc,
#w-node-_75aac411-2920-ccf7-0d44-6e114ccdee16-93cb77fc,
#w-node-ed6cc8ce-5095-b7b4-f967-da593ca5b131-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-d8c8aed4-c702-a892-5ef5-a80782608868-93cb77fc,
#w-node-e1a04ad3-df9a-0616-2538-a136fe9fc409-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-dda2d83a-0a05-41b8-3fe9-c8496f1287e2-93cb77fc,
#w-node-_0cd7d884-fd59-fcaa-4999-0c8a95dc5202-93cb77fc,
#w-node-_0cd7d884-fd59-fcaa-4999-0c8a95dc5203-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_5e650026-33a0-c81b-3ad8-f16c1968ad7f-93cb77fc,
#w-node-_5e650026-33a0-c81b-3ad8-f16c1968ad80-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-_928d7c5e-645b-dd23-d5ca-8f6ad755bb68-93cb77fc,
#w-node-_8cb573d7-b398-db84-6bda-6126252523c2-93cb77fc,
#w-node-_8cb573d7-b398-db84-6bda-6126252523c3-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_8cb573d7-b398-db84-6bda-6126252523c5-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-d712d870-48f3-cf51-9dda-cd4a91a33de0-93cb77fc,
#w-node-d712d870-48f3-cf51-9dda-cd4a91a33de1-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-d712d870-48f3-cf51-9dda-cd4a91a33de3-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-_601fefd5-b92c-3718-9bb5-c58bd3011545-93cb77fc,
#w-node-e900174c-7926-d1e0-4b07-c216f0467bb0-93cb77fc,
#w-node-b4463ed5-d4f4-9309-dc25-74a1819c06c4-93cb77fc,
#w-node-_84832811-aea4-468c-0a31-c1ffb33de1a1-93cb77fc,
#w-node-_84832811-aea4-468c-0a31-c1ffb33de1a3-93cb77fc,
#w-node-cfd18d1a-ff7c-aa6e-6f8f-ec1f8bf0bab8-93cb77fc,
#w-node-cfd18d1a-ff7c-aa6e-6f8f-ec1f8bf0baba-93cb77fc,
#w-node-_6007e4c0-0719-3424-4a87-6e7270f91bb8-93cb77fc,
#w-node-_6007e4c0-0719-3424-4a87-6e7270f91bba-93cb77fc,
#w-node-_9c5784aa-2414-9b3c-9e1a-b96118fd83be-93cb77fc,
#w-node-_65ea0360-0527-323d-7d00-34dc27af33f4-93cb77fc,
#w-node-_4aebaf31-8d59-123d-3bec-67879ca0b5d8-93cb77fc,
#w-node-_9c5784aa-2414-9b3c-9e1a-b96118fd83c0-93cb77fc,
#w-node-_1a33091b-740e-95ec-8fdd-2343ead28a91-93cb77fc,
#w-node-c081d2ef-0598-03f1-0b18-0f2273e4ea25-93cb77fc,
#w-node-_37768e56-2de7-90c4-a7d8-01b14a6d4129-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_60a26e9f-da0c-3420-ba3a-a8fd1e4e9c5a-93cb77fc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: stretch
}

#w-node-_0e139a5f-0e3f-c435-536e-9a1f6c4c1873-93cb77fc,
#w-node-_8995b6d8-e3d1-221d-a1da-3af1e0cc9d9d-93cb77fc,
#w-node-_8995b6d8-e3d1-221d-a1da-3af1e0cc9d9e-93cb77fc,
#w-node-b2c11cd4-ceff-cf45-531d-32078b44c444-93cb77fc,
#w-node-_2c829d5d-b45f-a93d-4fa8-ca36db8e84a5-93cb77fc,
#w-node-befe73de-ec83-6b07-0c6d-dc06b93d865f-93cb77fc,
#w-node-befe73de-ec83-6b07-0c6d-dc06b93d8665-93cb77fc,
#w-node-befe73de-ec83-6b07-0c6d-dc06b93d8674-93cb77fc,
#w-node-befe73de-ec83-6b07-0c6d-dc06b93d8683-93cb77fc,
#w-node-befe73de-ec83-6b07-0c6d-dc06b93d869a-93cb77fc,
#w-node-d6b9c541-8c70-bfd3-ecae-1f0c4152ec4d-93cb77fe,
#w-node-_477dd745-7085-6a73-b282-eb4d23ba5f38-93cb77fe,
#w-node-c27ba869-f8a9-52c2-1578-2be42dbcb792-93cb77fe,
#w-node-e1237b2f-43e4-2e61-e1fe-51a5ba19bcca-93cb77fe,
#w-node-_56c6e15a-b17a-82b7-43fd-ea46b34e063b-93cb77fe {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_40c40156-7608-9b9b-a686-c13f62607cd4-93cb77fe {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_8531ac38-9b0a-fe14-d3d1-a4b75553ece6-93cb77fe {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7912e588-f92f-47e0-eaaa-0df83b37e29c-93cb77fe,
#w-node-f71a274f-2bdb-72c1-39db-ceecb8ee3062-93cb77fe,
#w-node-_973acb1a-eb73-a8bd-583e-0ced71960216-93cb77fe,
#w-node-c6e89ad7-21ad-9f36-089c-f222892b9c70-93cb77fe {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_8890d250-4bd7-2564-bc1c-b3a4c136114a-93cb77fe,
#w-node-_57a1245e-9c7f-7935-1108-3cd27ec15b56-93cb77fe,
#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fa5-93cb77fe,
#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fa8-93cb77fe,
#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fab-93cb77fe,
#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fb0-93cb77fe,
#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fb3-93cb77fe,
#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fb6-93cb77fe {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fee-93cb77fe {
    align-self: center
}

#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3ff4-93cb77fe {
    align-self: center;
    justify-self: center
}

#w-node-_73eff977-97ce-45b5-d9a8-e77525bf4041-93cb77fe {
    align-self: auto
}

#w-node-_922125af-6840-213d-87af-bf463177b709-3177b6fb,
#w-node-_922125af-6840-213d-87af-bf463177b70b-3177b6fb,
#w-node-_922125af-6840-213d-87af-bf463177b70e-3177b6fb,
#w-node-_922125af-6840-213d-87af-bf463177b713-3177b6fb,
#w-node-_922125af-6840-213d-87af-bf463177b715-3177b6fb,
#w-node-_922125af-6840-213d-87af-bf463177b718-3177b6fb,
#w-node-_63daa8ea-c7b7-bc64-b503-1ec9ab8e0aaf-93cb7800,
#w-node-_91b11cf7-0722-728d-d871-db0dd442e6af-93cb7800,
#w-node-f28035e4-e0d5-157f-379e-3a1f22d0c8f9-93cb7800,
#w-node-cb5c13a8-46f5-b5f3-3589-55bbb31c0563-93cb7800,
#w-node-cb5c13a8-46f5-b5f3-3589-55bbb31c0564-93cb7800,
#w-node-cb5c13a8-46f5-b5f3-3589-55bbb31c0566-93cb7800,
#w-node-e5325195-7bdc-aa2f-2af4-51298d208f32-93cb7800,
#w-node-e5325195-7bdc-aa2f-2af4-51298d208f33-93cb7800,
#w-node-e5325195-7bdc-aa2f-2af4-51298d208f35-93cb7800 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b0c1b0f7-ed8e-ea97-04b6-e67ede012b0c-93cb7800,
#w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabff-93cb7800,
#w-node-bad18347-b3e3-3b17-d808-7320f8eab480-93cb7800,
#w-node-_7128d008-abfe-92cd-ad02-a2227f76f343-93cb7800,
#w-node-_8ea22c76-2344-1281-9838-1dc5c6e1102e-93cb7800 {
    align-self: auto;
    justify-self: auto
}

#w-node-_57564854-16dd-e5fb-f917-45da6f9ecb75-93cb7803,
#w-node-_09a77a8f-79e2-ac4e-7b09-293ee6307ff1-93cb7806,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7806,
#w-node-_67576e80-e279-2a6c-ca5f-1f0789972fdb-93cb7806,
#w-node-_67576e80-e279-2a6c-ca5f-1f0789972fdc-93cb7806,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7806,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7806,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7806,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7806,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7806,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7806,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7806,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7806,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7806,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7806,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7806,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7806,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7806,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7806,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7806,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7806 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7806 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7806 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7806 {
    align-self: auto
}

#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb7808,
#w-node-f1973054-052b-d1ae-a328-bda759153908-93cb7808,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7808,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7808,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7808,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7808,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7808,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb7808,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb7808 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7808 {
    align-self: auto
}

#w-node-_05fbec55-15d5-bc10-882a-1b7b0e76a32e-93cb7808,
#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b64-93cb780a,
#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2cff-93cb780a,
#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d03-93cb780a,
#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d07-93cb780a {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb780a {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-a839737e-82a4-2aa4-6b9e-4100f463cb59-93cb780a,
#w-node-_7126b630-96ac-1ddc-5357-1ec527c56260-93cb780a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8c9d-93cb780a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8ca4-93cb780a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cab-93cb780a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cb2-93cb780a,
#w-node-_41c593f6-40ad-beb2-1029-27d05d7c755b-93cb780c {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_36d2a246-cb39-7c89-6d4f-0332607907af-93cb780d,
#w-node-_77bb34f1-1340-c927-6fb8-6482a7f19145-93cb780d,
#w-node-_90f6eeec-2560-e528-eaba-6048ad0318ec-93cb780d {
    align-self: auto;
    justify-self: auto
}

#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff62-2349ff59,
#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff63-2349ff59,
#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff69-2349ff59,
#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff6a-2349ff59,
#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff70-2349ff59,
#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff71-2349ff59,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b37b-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b37c-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b37d-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b381-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b383-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b384-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b388-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b38a-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b38b-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b38f-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b391-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b392-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b393-93cb7816,
#w-node-f53807d9-5415-d802-8ee3-3f0f9268b397-93cb7816,
#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792c9-93cb7817 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792cf-93cb7817 {
    justify-self: auto
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792dd-93cb7817 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792e5-93cb7817 {
    justify-self: auto
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792f6-93cb7817 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792fc-93cb7817 {
    justify-self: auto
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd40977930a-93cb7817 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7ed293b0-81eb-4e7c-5192-2dd409779310-93cb7817 {
    justify-self: auto
}

#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7817,
#w-node-_996af45e-970d-59a6-a44f-82f0a0ac2cc9-93cb7818,
#w-node-_996af45e-970d-59a6-a44f-82f0a0ac2cca-93cb7818,
#w-node-_996af45e-970d-59a6-a44f-82f0a0ac2ccc-93cb7818,
#w-node-_7e16f63c-5ed2-4d9d-25ac-c90fddd9146c-93cb7818,
#w-node-_7e16f63c-5ed2-4d9d-25ac-c90fddd9146d-93cb7818,
#w-node-_7e16f63c-5ed2-4d9d-25ac-c90fddd9146f-93cb7818,
#w-node-_86d587e6-c4c8-d18b-09c1-7be813a8e852-93cb7818,
#w-node-_03f14b75-481d-2c4e-648b-cf0a96446e44-93cb7818,
#w-node-db34f1c3-fba8-f364-baa4-9e75089133c8-93cb7818,
#w-node-_143d5d15-62e0-62e8-a75f-32a51bcb9aaf-93cb7818,
#w-node-_9d3812e0-761c-6f06-88cf-216937bcf774-93cb7818,
#w-node-bfdc67dd-5a87-1afd-2d4e-684dfa5402a6-93cb7818,
#w-node-c6887bc3-10da-efab-2a13-109e28c49635-93cb7818,
#w-node-_33b6bea5-b01c-aa70-7b04-af4cdea6743b-93cb7818 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b2f1b523-1902-9c9c-593d-7a6b76f6921a-93cb7818 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_005b9bb7-84bb-7440-fb4f-4cb02969d2cb-93cb7818 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_4ba668e6-ca36-cc5b-7bf7-f42be58e064b-93cb7819,
#w-node-_5d57aa1a-c76b-efa2-b432-d6a8ca24d810-93cb7819 {
    align-self: center
}

#w-node-_44e7aad6-436d-7ea4-4dbf-ff175da8cde7-93cb7819 {
    justify-self: auto
}

#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc90-93cb781a,
#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc97-93cb781a,
#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc9e-93cb781a {
    justify-self: start
}

#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ed7-f5a10ed1,
#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ed9-f5a10ed1 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ee0-f5a10ed1,
#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ee9-f5a10ed1 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ef0-f5a10ed1 {
    align-self: center
}

#w-node-_1a9ad16a-cf91-4631-ccd5-84cc1676b57c-93cb781e,
#w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb74-93cb781e,
#w-node-f7bf232d-31e6-0823-e8a7-3e7f893b7fd1-93cb781e {
    align-self: auto;
    justify-self: auto
}

#w-node-_161cdf43-05f8-fdf0-849c-063676e55aa9-93cb7820 {
    align-self: center
}

#w-node-_2ac091be-85d0-7c06-96a1-31598ef01eb4-93cb7820 {
    align-self: center;
    justify-self: end
}

#w-node-_2499bd8b-1252-89c3-cd1f-f4fb98e84b54-93cb7822,
#w-node-_5796f4fb-1441-34a4-b19e-1c6039930f40-93cb7822,
#w-node-b3c0d1f4-3808-4fd1-907f-71852c76a8bc-93cb7822 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_4b928710-15ce-ac8e-c296-40b33744a978-93cb7822 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_9ee16af2-0bb9-b76f-8c7e-f558b9ed0a1a-93cb7822 {
    align-self: center;
    justify-self: center
}

#w-node-_0575697a-9b75-fad4-6c53-c532393abfa4-93cb7822 {
    align-self: center
}

#w-node-_0575697a-9b75-fad4-6c53-c532393abfaa-93cb7822 {
    align-self: center;
    justify-self: center
}

#w-node-_78883919-c1ff-44cf-3589-2a7f6bdb8902-93cb7822,
#w-node-_78883919-c1ff-44cf-3589-2a7f6bdb8905-93cb7822,
#w-node-_73653ffa-6a3b-4891-1245-d9f50281db6c-93cb7822,
#w-node-_507e9163-ce1c-6370-08ce-bd76d88aae4b-93cb7822,
#w-node-ef91da35-ecaa-722e-9ce4-bb73d611f68c-93cb7823 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eac3-93cb7829 {
    justify-self: auto
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3ead5-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eade-93cb7829 {
    justify-self: auto
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eaed-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eaf5-93cb7829 {
    justify-self: auto
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb07-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb10-93cb7829 {
    justify-self: auto
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb1f-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb27-93cb7829 {
    justify-self: auto
}

#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb39-93cb7829,
#w-node-e52efb07-d0cb-5618-f327-8e3339121aef-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e52efb07-d0cb-5618-f327-8e3339121af0-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-e52efb07-d0cb-5618-f327-8e3339121afa-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e52efb07-d0cb-5618-f327-8e3339121afb-93cb7829 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_41c593f6-40ad-beb2-1029-27d05d7c755b-93cb782a,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb782d,
#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd7-93cb782d,
#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd8-93cb782d,
#w-node-_557e393f-9a6f-aaaa-4071-60d5a79e36e0-93cb782d,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb782d,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb782d,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb782d,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb782d,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb782d,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb782d,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb782d,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb782d,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb782d,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb782d,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb782d,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb782d,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb782d,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb782d {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb782d {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb782d {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb782d {
    align-self: auto
}

#w-node-_462e1e2a-849d-3f32-13ee-d12453635faa-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_3200fcf8-0ac5-5498-78b8-a688afd4f1a4-93cb782f,
#w-node-_5552f219-48f8-213a-66df-3993c0984fac-93cb782f,
#w-node-_86f7ec23-2bc7-2459-0b38-4c7befc0e7f4-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dd1cced9-d551-0916-d0f4-dd81de3f56f9-93cb782f,
#w-node-_4a30385e-8417-5a46-85dd-b1b82088b09a-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-de1d40b8-fc4c-bb1a-d594-c0c63d8693a9-93cb782f {
    align-self: center
}

#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa1-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_9ee9eced-632f-a0e3-dd17-b47293f1c82a-93cb782f,
#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa5-93cb782f,
#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa6-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa7-93cb782f,
#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa9-93cb782f,
#w-node-_54466388-3219-79f5-198b-6bc377bb0b1f-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_54466388-3219-79f5-198b-6bc377bb0b26-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_54466388-3219-79f5-198b-6bc377bb0b27-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_54466388-3219-79f5-198b-6bc377bb0b28-93cb782f,
#w-node-_54466388-3219-79f5-198b-6bc377bb0b29-93cb782f,
#w-node-_54466388-3219-79f5-198b-6bc377bb0b2a-93cb782f,
#w-node-_54466388-3219-79f5-198b-6bc377bb0b2b-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_54466388-3219-79f5-198b-6bc377bb0b2c-93cb782f,
#w-node-_54466388-3219-79f5-198b-6bc377bb0b2d-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_62873f6e-3cca-a01b-a37f-551094e3f5ae-93cb782f,
#w-node-_394d02d1-0b95-78da-1e6e-2a245dadd403-93cb782f,
#w-node-_9bdd82a4-cb00-5ee5-13f5-6e1934c3dfcf-93cb782f,
#w-node-_2d4b391e-3c79-a86b-8abb-ccd89266c9cb-93cb782f,
#w-node-_3d5707c5-22d9-ee3b-f35b-b9cc144ffdc7-93cb782f,
#w-node-daf2dd60-1227-818d-9c5b-cc776f5e1577-93cb782f,
#w-node-_0696de55-24d9-390c-f2f5-7d9afbf5ae13-93cb782f,
#w-node-_4da5e53b-2fa8-513b-122b-7f28b22a5b79-93cb782f,
#w-node-_5bff9624-f73d-9a3b-6d33-a10cce5d076c-93cb782f,
#w-node-_464f8b3b-eab6-3b79-066f-da768c2dfec1-93cb782f,
#w-node-_36ef1cad-f49c-6f20-45e7-ed0358555a5c-93cb782f,
#w-node-_32d97587-1883-9700-2b7c-5073aa0995f9-93cb782f,
#w-node-bf8805d9-3766-00a8-dee9-75b794d57a85-93cb782f {
    order: 0;
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: auto
}

#w-node-afe74a8d-ff0f-a571-e6ac-946ecf487b86-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_0e89972e-fe99-2763-f487-af7a9b2fd0a1-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_2b53cf1e-d42d-782c-bcc7-2b15b4900f72-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_3470d107-f7bc-af98-2932-25ecdc7e4829-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_3470d107-f7bc-af98-2932-25ecdc7e482c-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_6c9cd9c6-54db-5a3c-8577-81a6c1100999-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_6c9cd9c6-54db-5a3c-8577-81a6c110099c-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_3d3769d0-21b7-a05a-9d83-9cdf4fa900fd-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_3d3769d0-21b7-a05a-9d83-9cdf4fa90100-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_2824f613-def0-706b-0c8e-9b1873735f34-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_2824f613-def0-706b-0c8e-9b1873735f37-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_5442f912-9b20-315f-39b5-62abe2c08797-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_5442f912-9b20-315f-39b5-62abe2c0879a-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_5e84255a-ecbc-6211-cf65-298c524d8b1e-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_5e84255a-ecbc-6211-cf65-298c524d8b21-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-fd97b084-77f1-2dc5-79bc-fb7d5e917a47-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-fd97b084-77f1-2dc5-79bc-fb7d5e917a4a-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_04dd575b-ab05-2294-a4d2-e6bba348df96-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_04dd575b-ab05-2294-a4d2-e6bba348df99-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_01166d48-6c36-3bce-e709-d5fed40c1b27-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_01166d48-6c36-3bce-e709-d5fed40c1b2a-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_1fc5f98d-b4ac-e466-f22a-680e25bfee18-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-_1fc5f98d-b4ac-e466-f22a-680e25bfee1b-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-a9c9e552-f957-bef9-a63a-d2492ba65273-93cb782f {
    align-self: auto;
    justify-self: auto
}

#w-node-a9c9e552-f957-bef9-a63a-d2492ba65276-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: auto;
    justify-self: auto
}

#w-node-_66862598-b3c9-84e3-cf9e-81100b7123b7-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_66862598-b3c9-84e3-cf9e-81100b7123be-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_66862598-b3c9-84e3-cf9e-81100b7123bf-93cb782f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c0-93cb782f,
#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c1-93cb782f,
#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c2-93cb782f,
#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c3-93cb782f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c4-93cb782f,
#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c5-93cb782f,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7831,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7831,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7831,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7831,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7831,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7831,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7831,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7831,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7831,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7831,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7831,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7831,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7831,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7831,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7831,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7831,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7831,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7831,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7831,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7831 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7831 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7831 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7831 {
    align-self: auto
}

#w-node-fd1a957a-533a-8824-006b-7313a5dccedb-93cb7832,
#w-node-b431b86b-f2f0-708d-f867-ce24ea365c7d-93cb7832,
#w-node-_0fab30e8-69c7-8a91-ac45-f4adb0d1bb7a-93cb7832 {
    align-self: auto;
    justify-self: auto
}

#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63281-93cb7834 {
    grid-area: 1/1/2/2;
    align-self: start;
    justify-self: auto
}

#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63282-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63286-93cb7834 {
    align-self: center;
    justify-self: stretch
}

#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328a-93cb7834 {
    grid-area: 1/2/3/3;
    justify-self: auto
}

#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328d-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328e-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328f-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63291-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63293-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632a6-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632a7-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632a8-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632aa-93cb7834,
#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632ac-93cb7834,
#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b40b-93cb7835,
#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b42e-93cb7835,
#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b44f-93cb7835,
#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b471-93cb7835,
#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b494-93cb7835,
#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b4b5-93cb7835,
#w-node-_96d1a9e5-f77d-e9a8-35ac-758eca638e96-93cb7837,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb783f,
#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd7-93cb783f,
#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd8-93cb783f,
#w-node-_557e393f-9a6f-aaaa-4071-60d5a79e36e0-93cb783f,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb783f,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb783f,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb783f,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb783f,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb783f,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb783f,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb783f,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb783f,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb783f,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb783f,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb783f,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb783f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb783f {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb783f {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb783f {
    align-self: auto
}

#w-node-_8f080c5f-5d43-e1fe-8f50-fbd438ba3900-93cb7840,
#w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61b8-93cb7840,
#w-node-_76f22f68-56ac-162e-498a-f1ddff7de17d-93cb7840,
#w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662ff-93cb7840 {
    align-self: auto;
    justify-self: auto
}

#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7842,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7842,
#w-node-_4741a5ad-ecb8-45fd-b97a-63442878d5a8-93cb7842,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7842,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7842,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7842,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7842,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7842,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7842,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7842,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7842,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7842,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7842,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7842,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7842,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7842,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7842,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7842,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7842,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7842,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7842 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7842 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7842 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7842 {
    align-self: auto
}

#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb7843 {
    align-self: center;
    justify-self: center
}

#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626bc6-93cb7843,
#w-node-c9d841c6-b7de-201c-736b-087712626bcf-93cb7843,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7844,
#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd7-93cb7844,
#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd8-93cb7844,
#w-node-_557e393f-9a6f-aaaa-4071-60d5a79e36e0-93cb7844,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7844,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7844,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7844,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7844,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7844,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7844,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7844,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7844,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7844,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7844,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7844,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7844 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7844 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7844 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7844 {
    align-self: auto
}

#w-node-_9ee16af2-0bb9-b76f-8c7e-f558b9ed0a1a-93cb7846 {
    align-self: center;
    justify-self: center
}

#w-node-_83436a2a-6983-27b5-d6cf-44eadd3347ab-93cb7846 {
    align-self: center
}

#w-node-_481a6ed2-1fcc-7792-07b9-f00d54825df1-93cb7847,
#w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b42-93cb7847,
#w-node-e03e9185-11ce-791a-e264-dee25008c53a-93cb7847 {
    align-self: auto;
    justify-self: auto
}

#w-node-c98c598c-9f00-d846-20b8-d56cae0b9346-93cb7848,
#w-node-c98c598c-9f00-d846-20b8-d56cae0b934d-93cb7848,
#w-node-c98c598c-9f00-d846-20b8-d56cae0b9354-93cb7848 {
    justify-self: start
}

#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5f4-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5f7-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5f9-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5fb-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5fd-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5ff-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef601-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef603-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef605-93cb7848,
#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef607-93cb7848 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e16d4a35-bc24-7b09-aaa3-513b15e74c78-93cb7848 {
    align-self: center
}

#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa84e-cd55d8f4 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa855-cd55d8f4 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa856-cd55d8f4 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa857-cd55d8f4,
#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa858-cd55d8f4,
#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa859-cd55d8f4,
#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa85a-cd55d8f4 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa85b-cd55d8f4,
#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa85c-cd55d8f4 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_15fdf71c-7871-73bb-c76a-9ea042992150-93cb784b {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9aae-93cb784b,
#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9ab5-93cb784b,
#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9abc-93cb784b {
    justify-self: center
}

#w-node-_1dc8c3fe-dd74-ce3e-e0f4-63fafd190397-93cb784d {
    grid-area: 1/1/2/1
}

#w-node-_1075d511-de9d-eb09-87fa-3cb611b3370e-93cb784d {
    grid-area: span 1/span 3/span 1/span 3
}

#w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d {
    grid-area: 1/2/2/2
}

#w-node-_78dbd686-4557-31f7-c2e8-0ddfac9f126c-93cb784d {
    grid-area: 1/3/2/3
}

#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf5e-93cb7871 {
    grid-area: 1/1/2/1
}

#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf67-93cb7871 {
    grid-area: span 1/span 3/span 1/span 3
}

#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {
    grid-area: 1/2/2/2
}

#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf71-93cb7871 {
    grid-area: 1/3/2/3
}

#w-node-bed9c8b8-f8d4-ab01-02e4-f685ec0a4b49-93cb7871,
#w-node-d9fcb6be-7c6f-bc6e-54d7-10c5b59ba63f-93cb7871,
#w-node-_773ed52a-f3d2-9fd1-9a87-6ae5ff8daf39-93cb7871 {
    grid-area: span 1/span 2/span 1/span 2
}

#w-node-_37c07466-bdad-ed4c-9614-29f684d1b263-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_4e888680-b006-3265-a75e-b37fbfd004cf-93cb7871,
#w-node-_0ce76b96-a607-9f7f-c880-2d30c33ee79f-93cb7871 {
    grid-area: span 1/span 2/span 1/span 2
}

#w-node-f3dce5f1-8822-db7d-fbe3-36f747433a68-93cb7871,
#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4da-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4e0-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4f4-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4fa-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b50b-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b511-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b525-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b52d-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b53b-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b541-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b555-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b55b-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b572-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b578-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b58c-93cb7871 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b592-93cb7871 {
    justify-self: auto
}

#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b5aa-93cb7871 {
    align-self: center
}

#w-node-_81d4c42b-0c38-e283-5db6-e4245108afb9-93cb7871 {
    grid-area: span 2/span 1/span 2/span 1
}

#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb7872,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7872,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7872,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7872,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7872,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7872,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7872,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7872,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7872,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7872,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7872,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7872,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7872,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7872,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7872 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7872 {
    align-self: auto
}

#w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7872 {
    grid-area: 2/3/3/4
}

#w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7872 {
    grid-area: 1/6/2/7
}

#w-node-_15fdf71c-7871-73bb-c76a-9ea042992150-93cb7874 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: center
}

#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9aae-93cb7874,
#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9ab5-93cb7874,
#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9abc-93cb7874 {
    justify-self: center
}

#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7875,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7875,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7875,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7875,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7875,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7875,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7875,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7875,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7875,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7875,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7875,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7875,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7875,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7875,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7875,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7875,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7875,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7875,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7875,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7875 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7875 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7875 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7875 {
    align-self: auto
}

#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb7877 {
    align-self: center;
    justify-self: center
}

#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb7877,
#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb7877,
#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb7877,
#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb7877,
#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb7877,
#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb7877,
#w-node-_09a77a8f-79e2-ac4e-7b09-293ee6307ff1-93cb7878,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7878,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7878,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7878,
#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7878,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7878,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7878,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7878,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7878,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7878,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7878,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7878,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7878,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7878,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7878,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7878,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7878,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7878,
#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7878 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7878 {
    align-self: center
}

#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7878 {
    align-self: center;
    justify-self: center
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7878 {
    align-self: auto
}

#w-node-c95191df-6078-39a7-ee16-e4adc7852441-93cb7879,
#w-node-_95091db4-c91c-2e2a-527d-4a498db5df0a-93cb7879,
#w-node-c95191df-6078-39a7-ee16-e4adc785244b-93cb7879,
#w-node-_3daa264e-af02-c78c-6ebb-274206f68d37-93cb7879,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7879,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7879,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7879,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7879,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7879,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7879,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7879,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7879,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7879,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7879,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7879,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7879,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7879,
#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7879 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7879 {
    align-self: auto
}

#w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7879 {
    grid-area: 2/3/3/4
}

#w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7879 {
    grid-area: 1/6/2/7
}

#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b64-93cb787a,
#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2cff-93cb787a,
#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d03-93cb787a,
#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d07-93cb787a {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb787a {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: end
}

#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8c9d-93cb787a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8ca4-93cb787a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cab-93cb787a,
#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cb2-93cb787a,
#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb787d,
#w-node-fdf54a5d-6dc2-b882-f2be-fafdce531879-93cb787f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-fdf54a5d-6dc2-b882-f2be-fafdce53187a-93cb787f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-fdf54a5d-6dc2-b882-f2be-fafdce531884-93cb787f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-fdf54a5d-6dc2-b882-f2be-fafdce531885-93cb787f {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7883,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441c7-93cb7887,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441c9-93cb7887,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027c-93cb7887,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027e-93cb7887,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0276-93cb7887,
#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0278-93cb7887,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441cd-93cb7887,
#w-node-_6485294b-ab01-ed67-2584-5f9d485441cf-93cb7887,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4b-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4c-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4d-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4f-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df50-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df51-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df53-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df54-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df55-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df57-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df58-1379df41,
#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df59-1379df41,
#w-node-_45cb4c88-9168-9674-7648-d21565364a80-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a82-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a85-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a89-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a8b-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a8e-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a92-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a94-65364a74,
#w-node-_45cb4c88-9168-9674-7648-d21565364a97-65364a74,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086bb-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086c1-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086c7-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086cd-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086d3-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086de-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086e6-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086f7-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee70875e-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708767-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708770-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708779-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708782-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee70878b-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708797-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708798-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee70879a-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087d7-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087e1-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087e6-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087ef-ee70868e,
#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087fa-ee70868e,
#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb78b5,
#w-node-f1973054-052b-d1ae-a328-bda759153908-93cb78b5,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb78b5,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb78b5,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb78b5,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb78b5,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb78b5,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb78b5,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb78b5 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb78b5 {
    align-self: auto
}

#w-node-_05fbec55-15d5-bc10-882a-1b7b0e76a32e-93cb78b5,
#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d4a-93cb78b6,
#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d4c-93cb78b6,
#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d50-93cb78b6,
#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d52-93cb78b6,
#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d56-93cb78b6,
#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d58-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d5c-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: start
}

#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d5e-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d284-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d286-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d297-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d29a-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d29d-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2a0-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2a3-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2a8-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ac-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2b0-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2b5-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2b9-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2bd-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2c2-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2c6-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ca-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2cf-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2dc-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e2-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e3-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e4-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e6-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e7-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e8-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ea-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2eb-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ec-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ee-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ef-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f0-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f2-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f3-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f4-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f6-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f7-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f8-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fa-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fb-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fc-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fe-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ff-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d300-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d302-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d303-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d304-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d306-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d307-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d308-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_9c788f07-d9fc-c3fb-0337-cb0c284f6041-93cb78b6,
#w-node-_9c788f07-d9fc-c3fb-0337-cb0c284f6042-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_9c788f07-d9fc-c3fb-0337-cb0c284f6043-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d30d-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d313-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d314-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d315-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d317-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d318-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d319-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31b-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31c-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31d-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31f-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d320-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d321-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d323-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d324-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d325-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d327-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d328-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d329-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32b-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32c-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32d-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32f-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d330-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d331-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d333-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d334-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d335-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ab8c2b69-154a-9e08-cad7-e1ad71f71beb-93cb78b6,
#w-node-ab8c2b69-154a-9e08-cad7-e1ad71f71bec-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-ab8c2b69-154a-9e08-cad7-e1ad71f71bed-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_30a30e84-4eab-213e-9723-71471c610305-93cb78b6,
#w-node-_30a30e84-4eab-213e-9723-71471c610306-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_30a30e84-4eab-213e-9723-71471c610307-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d33c-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d33f-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d342-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d345-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d348-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d34b-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d34e-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d351-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d354-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d357-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d35a-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d35d-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d360-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d363-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d366-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d369-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d36c-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d36f-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d37c-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d382-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d386-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d387-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d388-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d38b-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d38f-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d390-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d391-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d393-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d399-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d39d-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d39e-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d39f-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a2-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a6-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a7-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a8-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3aa-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b0-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b4-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b5-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b6-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b9-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3bb-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3bd-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3be-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3bf-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3df-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3eb-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3f7-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d40e-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d413-93cb78b6,
#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d418-93cb78b6 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_8475e6c8-39db-3a19-c868-b0f5e971523a-e9715238,
#w-node-_8475e6c8-39db-3a19-c868-b0f5e971523b-e9715238 {
    align-self: center
}

#w-node-_8475e6c8-39db-3a19-c868-b0f5e971523c-e9715238 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb325-93cb78b7,
#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb327-93cb78b7,
#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb32b-93cb78b7,
#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb32d-93cb78b7,
#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb331-93cb78b7,
#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb333-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb337-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: start
}

#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb339-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-aa00aef3-a684-e63a-c715-f34ea3657a64-93cb78b7,
#w-node-aa00aef3-a684-e63a-c715-f34ea3657a65-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-aa00aef3-a684-e63a-c715-f34ea3657a66-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad1-93cb78b7,
#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad2-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad3-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b6-93cb78b7,
#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b7-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b8-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f7-93cb78b7,
#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f8-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f9-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce0-93cb78b7,
#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce1-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce2-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8191-93cb78b7,
#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8192-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8193-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73955-93cb78b7,
#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73956-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73957-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_12aca550-6cf7-7049-82bf-0e8acd3f0ad9-93cb78b7,
#w-node-_12aca550-6cf7-7049-82bf-0e8acd3f0ada-93cb78b7 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_12aca550-6cf7-7049-82bf-0e8acd3f0adb-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78b7,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78b7,
#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a594-93cb78b8,
#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a596-93cb78b8,
#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a59a-93cb78b8,
#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a59c-93cb78b8,
#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a0-93cb78b8,
#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a2-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a6-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: start
}

#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a8-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65883f-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658841-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658863-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658866-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658869-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65886c-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65886f-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658874-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658878-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65887c-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658881-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658885-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658889-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65888e-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658892-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658896-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65889b-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588a8-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ae-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588af-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b0-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b6-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b7-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b8-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ba-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588bb-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588bc-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ce-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588cf-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d0-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d2-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d3-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d4-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_2f7ea246-e8c2-43a7-18c5-1f5254695811-93cb78b8,
#w-node-_2f7ea246-e8c2-43a7-18c5-1f5254695812-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_2f7ea246-e8c2-43a7-18c5-1f5254695813-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588dd-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588e3-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588e4-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588e5-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588eb-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ec-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ed-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ef-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588f0-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588f1-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ff-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658900-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658901-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658903-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658904-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658905-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_962a133b-0258-976a-44b9-2ceae20dfa66-93cb78b8,
#w-node-_962a133b-0258-976a-44b9-2ceae20dfa67-93cb78b8 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_962a133b-0258-976a-44b9-2ceae20dfa68-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658914-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658917-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65891a-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65891d-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658920-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658923-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658926-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658929-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65892c-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65892f-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658932-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658935-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658938-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65893b-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65893e-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658941-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658944-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658947-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658954-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65895a-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65895e-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65895f-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658960-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658963-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658967-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658968-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658969-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65896b-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658971-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658975-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658976-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658977-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65897a-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65897e-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65897f-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658980-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658982-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658988-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65898c-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65898d-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65898e-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658991-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658993-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658995-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658996-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658997-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589a6-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589b2-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589be-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589d5-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589da-93cb78b8,
#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589df-93cb78b8,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-aa00aef3-a684-e63a-c715-f34ea3657a64-93cb78b9,
#w-node-aa00aef3-a684-e63a-c715-f34ea3657a65-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-aa00aef3-a684-e63a-c715-f34ea3657a66-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad1-93cb78b9,
#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad2-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad3-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b6-93cb78b9,
#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b7-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b8-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f7-93cb78b9,
#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f8-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f9-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce0-93cb78b9,
#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce1-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce2-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8191-93cb78b9,
#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8192-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8193-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73955-93cb78b9,
#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73956-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73957-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-f139e468-f3cc-b550-c8a9-1de40b14318d-93cb78b9,
#w-node-f139e468-f3cc-b550-c8a9-1de40b14318e-93cb78b9 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-f139e468-f3cc-b550-c8a9-1de40b14318f-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78b9,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78b9,
#w-node-b385e230-e21c-0748-6ce3-931872347272-93cb78ba,
#w-node-b385e230-e21c-0748-6ce3-931872347274-93cb78ba,
#w-node-b385e230-e21c-0748-6ce3-931872347278-93cb78ba,
#w-node-b385e230-e21c-0748-6ce3-93187234727a-93cb78ba,
#w-node-b385e230-e21c-0748-6ce3-93187234727e-93cb78ba,
#w-node-b385e230-e21c-0748-6ce3-931872347280-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b385e230-e21c-0748-6ce3-931872347284-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: start
}

#w-node-b385e230-e21c-0748-6ce3-931872347286-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdae4-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdae6-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdaf6-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdaf9-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdafc-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdaff-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb02-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb07-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb0b-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb0f-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb14-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb18-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb1c-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb21-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb25-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb29-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb2e-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb3a-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb40-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb41-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb42-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb44-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb45-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb46-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb48-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb49-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4a-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4c-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4d-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4e-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb50-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb51-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb52-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb54-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb55-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb56-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb58-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb59-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5a-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_370dedee-316c-4be9-49c2-89861a32b8b0-93cb78ba,
#w-node-_370dedee-316c-4be9-49c2-89861a32b8b1-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_370dedee-316c-4be9-49c2-89861a32b8b2-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5c-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5d-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5e-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ee4d4f42-97e9-7e3a-eab0-1c117325c278-93cb78ba,
#w-node-ee4d4f42-97e9-7e3a-eab0-1c117325c279-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-ee4d4f42-97e9-7e3a-eab0-1c117325c27a-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb63-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb69-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6a-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6b-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6d-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6e-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6f-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb71-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb72-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb73-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb75-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb76-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb77-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb7d-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb7e-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb7f-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb81-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb82-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb83-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb85-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb86-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb87-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-db001b84-f4b1-ad0c-99c6-e8cb56067042-93cb78ba,
#w-node-db001b84-f4b1-ad0c-99c6-e8cb56067043-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-db001b84-f4b1-ad0c-99c6-e8cb56067044-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-df7e24ca-197c-5c1d-7d23-7b10530caa28-93cb78ba,
#w-node-df7e24ca-197c-5c1d-7d23-7b10530caa29-93cb78ba {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-df7e24ca-197c-5c1d-7d23-7b10530caa2a-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb8e-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb91-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb94-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb97-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb9a-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb9d-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba0-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba3-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba6-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba9-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbac-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbaf-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbb2-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbb5-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbb8-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbbb-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbbe-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbc1-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbce-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbd4-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbd8-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbd9-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbda-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbdd-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe1-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe2-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe3-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe5-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbeb-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbef-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf0-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf1-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf4-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf8-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf9-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbfa-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbfc-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc02-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc06-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc07-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc08-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc0b-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc0d-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc0f-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc10-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc11-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc2d-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc39-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc45-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc5c-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc61-93cb78ba,
#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc66-93cb78ba,
#w-node-b7843a38-8800-5dce-e230-aa37d1f45b58-93cb78bc,
#w-node-_4ae47232-fe84-b81d-ec86-6ef0a9a05741-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-b7843a38-8800-5dce-e230-aa37d1f45b60-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-_247107bd-ea7e-f150-8aab-5e83264224c2-93cb78bc,
#w-node-_0710f280-2de1-6112-1c8a-3a8c42df3dd5-93cb78bc,
#w-node-f3ed03bf-0076-a5b2-c842-4244e1bc4f0b-93cb78bc,
#w-node-_8870acee-c89d-ea76-5824-db449952b297-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_5d8806f5-21bf-378f-bf6f-05c90c6677a9-93cb78bc,
#w-node-ff86c5c4-dd1d-0d60-826d-fedd7202a63d-93cb78bc,
#w-node-_80858616-7b6b-599c-e202-a7b601bfce51-93cb78bc,
#w-node-c70fbda4-b5d3-b387-a67b-777788e6d745-93cb78bc,
#w-node-c557f283-e16e-25d8-3b90-2de4ff048945-93cb78bc,
#w-node-_9938b4e5-31d2-1c93-138d-bae4bc269111-93cb78bc,
#w-node-_29c117df-af6c-3305-f610-d2c036ddb7c4-93cb78bc,
#w-node-_95160acb-683b-9387-1985-2cd71e40aeb5-93cb78bc,
#w-node-bd2c90a3-3449-cd68-9ce5-a364ea69e078-93cb78bc,
#w-node-_4fcb369a-6251-e873-6667-b7606c289ad8-93cb78bc,
#w-node-_277c8042-d460-4cfa-a115-ba668ba2a14a-93cb78bc,
#w-node-_76746d7c-2b97-095c-54e0-bbf14503bbdd-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_5070e47b-833d-0883-324a-f424cecfb905-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-fbc1a123-a2b3-ebc6-adcd-6b93255a19b6-93cb78bc,
#w-node-_8ddce519-2261-9d1e-3eec-a671cf28b9bf-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-f4c80b7f-9c49-67e7-34af-c9f2b362ef29-93cb78bc,
#w-node-efc1cc14-56a8-05d8-f6a1-bf99658d6d05-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-efc1cc14-56a8-05d8-f6a1-bf99658d6d06-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-efc1cc14-56a8-05d8-f6a1-bf99658d6d07-93cb78bc,
#w-node-_422fb230-2d36-045c-b853-0f8089d82e62-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_422fb230-2d36-045c-b853-0f8089d82e63-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_422fb230-2d36-045c-b853-0f8089d82e64-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_22d8bcb9-b51f-eaf0-a315-9656f3a41d4a-93cb78bc,
#w-node-_22d8bcb9-b51f-eaf0-a315-9656f3a41d4b-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_22d8bcb9-b51f-eaf0-a315-9656f3a41d4c-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-bada1742-743b-7fff-4387-a5508857c704-93cb78bc,
#w-node-bada1742-743b-7fff-4387-a5508857c705-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-bada1742-743b-7fff-4387-a5508857c706-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-ed787b6d-1248-22d0-9ad4-06210883ecb9-93cb78bc,
#w-node-ed787b6d-1248-22d0-9ad4-06210883ecba-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-ed787b6d-1248-22d0-9ad4-06210883ecbb-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-d0bb2a30-4ba7-6a21-54b9-d9c8c842599f-93cb78bc,
#w-node-d0bb2a30-4ba7-6a21-54b9-d9c8c84259a0-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-d0bb2a30-4ba7-6a21-54b9-d9c8c84259a1-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_1190ae00-6e66-4235-8e95-18807d06cde2-93cb78bc,
#w-node-_1190ae00-6e66-4235-8e95-18807d06cde3-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_1190ae00-6e66-4235-8e95-18807d06cde4-93cb78bc,
#w-node-beb30fc9-0059-c6b1-8ec9-b3284a75f41d-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d3-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d4-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d5-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d7-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d8-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d9-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38db-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38dc-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38dd-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38df-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e0-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e1-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e3-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e4-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e5-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e7-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e8-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e9-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38eb-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38ec-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38ed-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38ef-93cb78bc,
#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38f0-93cb78bc {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38f1-93cb78bc,
#w-node-_9b94c343-de9a-9f9f-6748-38765931e14c-93cb78bc,
#w-node-_34db14ca-c4bc-39b2-8564-17e325a376a7-93cb78bc,
#w-node-_5bf3ab00-42aa-b93c-08a1-a1fbb4fcc9a2-93cb78bc,
#w-node-e88aaeb4-76ef-92dc-136a-9c75180c1026-93cb78bc,
#w-node-_6f631e88-9f85-5145-e1e6-48c0215e450b-93cb78bc,
#w-node-bcc2b0c3-a89e-7b50-6a2e-d1eac0ddcd37-93cb78bc,
#w-node-_56469230-0be4-65e8-dade-8eb2e4d19f96-93cb78bc,
#w-node-ee8e0457-bdd1-61c6-2506-90e91ce6c0d9-93cb78bc,
#w-node-_1dc87aa8-dc11-693b-a78d-8cf287d3d098-93cb78bc,
#w-node-_001b5ef1-6555-efb9-a5b1-2ef6292c022b-93cb78bc,
#w-node-_80741575-7979-8032-b539-3c65c770d3fe-93cb78bc,
#w-node-a4cbe887-b45f-57ca-9427-33d9ee636751-93cb78bc,
#w-node-_753d7c15-e45b-0263-7c4e-c9bdc827e246-93cb78bc,
#w-node-_48c2a45d-8050-4c9a-9e5e-b7b30c1b96b7-93cb78bc,
#w-node-_88318a72-bb06-1bed-13c7-a358263bd9fc-93cb78bc,
#w-node-_8a37ae3f-78be-543c-f8f8-7732a0d67e14-93cb78bc,
#w-node-_68709c64-fc28-3f96-d6f6-300f310b66a3-93cb78bc,
#w-node-a32f74f7-cbac-2fdc-750a-2ad4049532bc-93cb78bc,
#w-node-ca5e02d1-c2a4-1e74-9e4a-7e1536660834-93cb78bc,
#w-node-e60dd6c9-6c87-5cb7-0032-909bdd5b5548-93cb78bc,
#w-node-_3bc4b485-30b3-9c77-9dd4-daff85074425-93cb78bc,
#w-node-_7172ba28-4768-784c-4e73-269c4a4258e9-93cb78bc,
#w-node-a954e68b-9ec7-bd59-76be-bdc986833218-93cb78bc,
#w-node-_06ad1068-ce3c-99c6-a065-ac3be19415b0-93cb78bc,
#w-node-_8fb350b8-2f59-46fe-6880-a4cd7cdb52f5-93cb78bc,
#w-node-_8fb350b8-2f59-46fe-6880-a4cd7cdb52f6-93cb78bc,
#w-node-c732a22a-a7f5-84fe-9d9e-4cf56d7f911c-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062ccd-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062cd3-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062cd6-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062cd7-93cb78bc,
#w-node-_49fe0344-c4d1-3650-0707-45c05c88cdf5-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062cd9-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062cdc-93cb78bc,
#w-node-bbed632f-2fe9-adb2-739f-822d14062cdd-93cb78bc,
#w-node-e99fe387-b8d6-56b3-e2a4-44af11da6bba-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddaf5-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddafb-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddafe-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddaff-93cb78bc,
#w-node-_0e3191a1-a370-2bce-26a4-004ee9fcb811-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddb01-93cb78bc,
#w-node-_86986f42-4836-4c9e-8d95-af16c8fe7858-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddb04-93cb78bc,
#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddb05-93cb78bc,
#w-node-f19d1ce7-44bc-a6e3-f9ba-671da4eec333-93cb78bc,
#w-node-_2ba78627-dd6b-248c-9b00-4caa17872f8c-93cb78bc,
#w-node-_5f584a56-6eb9-2bdd-a3e0-350274e5f538-93cb78bc,
#w-node-_086669d1-492a-ef77-a73a-b56985608bbf-93cb78bc,
#w-node-_40eb5e87-5586-0a6f-3570-323485032148-93cb78bc,
#w-node-_50dd7425-4bfd-f928-f542-058d4cc341f8-93cb78bc,
#w-node-_7a8efeeb-f54d-d2cf-1ec7-cad5cc661932-93cb78bc,
#w-node-d5e35d94-8eba-106a-d387-d721f782b1cd-93cb78bf,
#w-node-d5e35d94-8eba-106a-d387-d721f782b1cf-93cb78bf,
#w-node-d5e35d94-8eba-106a-d387-d721f782b1d3-93cb78bf,
#w-node-d5e35d94-8eba-106a-d387-d721f782b1d5-93cb78bf,
#w-node-d5e35d94-8eba-106a-d387-d721f782b1d9-93cb78bf,
#w-node-d5e35d94-8eba-106a-d387-d721f782b1db-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-d5e35d94-8eba-106a-d387-d721f782b1df-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: start
}

#w-node-d5e35d94-8eba-106a-d387-d721f782b1e1-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274608-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274609-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460a-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460d-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460e-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78bf {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78bf,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78bf,
#w-node-d90ca9c5-4154-0bea-5a45-16baab7d645a-93cb78c0,
#w-node-d90ca9c5-4154-0bea-5a45-16baab7d645c-93cb78c0,
#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6460-93cb78c0,
#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6462-93cb78c0,
#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6466-93cb78c0,
#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6468-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-d90ca9c5-4154-0bea-5a45-16baab7d646c-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center;
    justify-self: start
}

#w-node-d90ca9c5-4154-0bea-5a45-16baab7d646e-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: start
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-aa00aef3-a684-e63a-c715-f34ea3657a64-93cb78c0,
#w-node-aa00aef3-a684-e63a-c715-f34ea3657a65-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-aa00aef3-a684-e63a-c715-f34ea3657a66-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad1-93cb78c0,
#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad2-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad3-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b6-93cb78c0,
#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b7-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b8-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f7-93cb78c0,
#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f8-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f9-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce0-93cb78c0,
#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce1-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce2-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8191-93cb78c0,
#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8192-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8193-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73955-93cb78c0,
#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73956-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73957-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-f139e468-f3cc-b550-c8a9-1de40b14318d-93cb78c0,
#w-node-f139e468-f3cc-b550-c8a9-1de40b14318e-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-f139e468-f3cc-b550-c8a9-1de40b14318f-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78c0,
#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78c0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3e6-93cb78e9 {
    align-self: center;
    justify-self: center
}

#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3f2-93cb78e9,
#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3f5-93cb78e9,
#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3f7-93cb78e9,
#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e403-93cb78e9,
#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e40f-93cb78e9,
#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e41c-93cb78e9,
#w-node-_3deb8624-686e-65dd-c431-d20a4a0d702b-93cb78ec,
#w-node-e8413fa3-2c14-0318-3f47-800a00971205-93cb78ec {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c20425a6-2326-4d4c-8b3b-f0cbe553034b-93cb7909,
#w-node-_23766549-02ab-9520-0510-6850153dfa6b-93cb7909,
#w-node-_94c7a407-ac95-9054-83ec-f8485a2bb894-93cb7909,
#w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793c7-93cb7909,
#w-node-_283026b3-5294-dee5-3d5a-4352e93cc0d3-93cb7909 {
    align-self: auto;
    justify-self: auto
}

#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb790a,
#w-node-_61e41015-1507-d45c-6189-48f5370afa39-93cb790a,
#w-node-eda86f13-9e2e-5cb1-0955-adbe8cda26b4-93cb790a,
#w-node-c578f11d-da2e-6ac7-8e4f-b8a9acb657c0-93cb790a,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb790a,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb790a,
#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb790a,
#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb790a,
#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb790a,
#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb790a,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb790a,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb790a {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb790a {
    grid-area: span 1/span 1/span 1/span 1;
    align-self: center
}

#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb790a,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb790a,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb790a,
#w-node-_15b99ec8-0277-810a-61ae-d60174f26cf5-93cb790a,
#w-node-_15b99ec8-0277-810a-61ae-d60174f26cf7-93cb790a,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb790a,
#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb790a {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb790a {
    align-self: auto
}

#w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb790a {
    grid-area: 2/3/3/4
}

#w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb790a {
    grid-area: 1/6/2/7
}

#w-node-c8a0ed9a-079c-e85c-e684-42e4dfe5e13c-93cb790f,
#w-node-c8a0ed9a-079c-e85c-e684-42e4dfe5e140-93cb790f {
    align-self: auto
}

#w-node-_058047f0-d9c2-4ec8-f4b3-063d874f13e7-93cb7923,
#w-node-_9118a212-9442-628d-ac5e-6da2ee54cda9-93cb7923,
#w-node-_06d05749-8911-70e8-b36d-954d89430ab7-93cb7923,
#w-node-_6e693b13-83bc-712c-839a-f2e50d8a4afc-93cb7924,
#w-node-_98297c28-e473-00ed-b583-8c52be085aad-93cb7924,
#w-node-d1833798-6b2f-fa9b-2099-c04947765649-93cb7924 {
    align-self: auto;
    justify-self: auto
}

#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc90-93cb7926,
#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc97-93cb7926,
#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc9e-93cb7926 {
    justify-self: center
}

#w-node-dc76907a-f8e2-c218-e3c1-24a1cf800667-93cb7926,
#w-node-dc76907a-f8e2-c218-e3c1-24a1cf800669-93cb7926,
#w-node-dc76907a-f8e2-c218-e3c1-24a1cf80066f-93cb7926,
#w-node-_32082f67-c36e-9e61-9cc0-0c92ae54d935-93cb7926,
#w-node-_960c03db-0819-8e0d-88ea-bab860117e0d-93cb7926,
#w-node-_8901cafc-90ec-6686-6166-2f9c3cd72f67-93cb7926,
#w-node-_8901cafc-90ec-6686-6166-2f9c3cd72f68-93cb7926,
#w-node-f8c96113-f23f-2c06-265d-cc7a6f1315ce-93cb7926,
#w-node-f8c96113-f23f-2c06-265d-cc7a6f1315cf-93cb7926 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6f3189e8-a31e-17ec-e872-f40da31437cb-8676de95 {
    align-self: center;
    justify-self: start
}

#w-node-_339c5877-5ff7-32e3-7e05-334be1c8c17e-8676de95 {
    align-self: center
}

#w-node-b9e4e460-f87c-7e25-eb78-1c9629344a2c-8676de95,
#w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb744e-8676de95,
#w-node-_824071e6-0194-461f-12d0-08eb4cf1c6c4-8676de95,
#w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d124-8676de95,
#w-node-_59911d5d-48ab-6fca-f96d-fd4652474e12-8676de95,
#w-node-a3b4ce1c-50b1-5fa5-1462-df981ec6e574-1adf4b3b,
#w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d4b-1adf4b3b,
#w-node-bb0cd039-e522-80e3-0a35-b1a518695189-1adf4b3b,
#w-node-eff55037-24c4-870b-155a-a9728acbb7e3-ac2ff666,
#w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f039f-ac2ff666,
#w-node-e47ab1f6-152e-159a-b9a6-e38ea9b45f92-ac2ff666,
#w-node-e9401e50-06e1-0862-cc4e-029899dc72cc-c64f9a6b,
#w-node-_09ac2a08-b917-4337-bd8f-050cee23acf2-c64f9a6b,
#w-node-_162aae03-c586-ae88-6ad4-531388f54214-c64f9a6b {
    align-self: auto;
    justify-self: auto
}

#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-952caff1,
#w-node-c1ddc278-5523-7778-97d0-329436819f82-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f83-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f84-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f85-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f86-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f87-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f88-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f89-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f8a-27d2a40c,
#w-node-c1ddc278-5523-7778-97d0-329436819f8b-27d2a40c {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-c64d297c-7f60-b05a-22aa-1b0a3ac39485-3ac3946f {
    grid-area: 1/1/2/2
}

#w-node-_798f30d4-70ab-03fa-cdde-6710fcae902b-fcae901f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-f9661c9f-41e0-1500-2752-16794f57f181-077d536b {
    align-self: center;
    justify-self: auto
}

#w-node-ff29dc34-7dc7-788a-0eee-79a242f86988-077d536b {
    justify-self: auto
}

#w-node-_65b26a55-76d8-c122-4a51-7ba062cf4d2a-077d536b {
    justify-self: end
}

#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5df6-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5df8-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5dfc-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5dfe-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e02-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e04-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e08-e1586dd0,
#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e0a-e1586dd0 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_4e9fc0c4-34d6-0e39-fb29-e29d5a662dc3-2d3663e1 {
    align-self: stretch;
    justify-self: auto
}

#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62ce2-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62ce4-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62ce8-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cea-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf0-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf2-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf6-41739e32,
#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf8-41739e32,
#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f6e-38aa0f2b,
#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f78-38aa0f2b,
#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f7d-38aa0f2b,
#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f8b-38aa0f2b,
#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f96-38aa0f2b,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a33-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a35-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a39-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a3b-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a3f-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a41-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a45-fe2f2a10,
#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a47-fe2f2a10 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_6c5b7f4c-42b3-6447-10f0-26cb1463137a-1db4e30c {
    align-self: stretch;
    justify-self: auto
}

#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a08-f31fda6f,
#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a0e-f31fda6f,
#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a1d-f31fda6f,
#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a2c-f31fda6f {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a43-f31fda6f {
    grid-area: span 1/span 1/span 1/span 1;
    justify-self: auto
}

#w-node-_7585a360-7847-67ba-0978-b8320fb22440-e9d43c82,
#w-node-_2aaf64a3-1135-b40a-19f6-8221da49343d-e9d43c82 {
    grid-area: 1/1/2/2
}

#w-node-_8cce25ef-775e-6687-e6f6-59689e610d26-6fe592a5,
#w-node-e2c822fa-b8d5-5acc-f476-11980cbc88c6-6fe592a5 {
    grid-area: span 1/span 1/span 1/span 1
}

#w-node-_7771d834-f93a-d303-7b97-685f736546a7-6fe592a5 {
    align-self: center;
    justify-self: start
}

#w-node-f5fef4f6-53bb-e3dc-28ab-68424dab6395-6fe592a5,
#w-node-_1d09d740-c52f-5379-5c77-c9d314ebadbd-6fe592a5,
#w-node-_5841ebaa-c8ab-1bd5-74ae-64556d84782f-6fe592a5,
#w-node-ce2c2b4b-69cc-5d72-1832-78c732b3bc79-6fe592a5,
#w-node-fb905444-be2f-bac8-b7a6-80cd86ea722f-6fe592a5,
#w-node-fb905444-be2f-bac8-b7a6-80cd86ea7230-6fe592a5,
#w-node-f6604f73-3c58-e8fe-ca82-892f82db4030-6fe592a5,
#w-node-f6604f73-3c58-e8fe-ca82-892f82db4031-6fe592a5,
#w-node-_61975f25-6d86-9949-f10c-b21da6ee5588-6fe592a5,
#w-node-_61975f25-6d86-9949-f10c-b21da6ee5589-6fe592a5,
#w-node-cd0d853b-2f0b-18dd-b0d3-bedefb1f7c95-6fe592a5,
#w-node-cd0d853b-2f0b-18dd-b0d3-bedefb1f7c94-6fe592a5,
#w-node-e3416bc3-31eb-c64a-8da7-8fe8ff61e686-6fe592a5,
#w-node-e3416bc3-31eb-c64a-8da7-8fe8ff61e687-6fe592a5,
#w-node-ea8ae60d-decd-9c1f-1eea-f7d0dcec360b-6fe592a5,
#w-node-ea8ae60d-decd-9c1f-1eea-f7d0dcec360a-6fe592a5,
#w-node-_0b3e8a7e-6358-5c0d-34b5-81c3bcaccdd1-6fe592a5,
#w-node-_0b3e8a7e-6358-5c0d-34b5-81c3bcaccdd2-6fe592a5 {
    align-self: center;
    justify-self: center
}

@media screen and (min-width:1920px) {
    #w-node-d862036f-348e-95b1-d411-9d2c13184902-93cb773c {
        order: 9999
    }

    #w-node-d862036f-348e-95b1-d411-9d2c13184904-93cb773c,
    #w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c400-93cb773c {
        justify-self: start
    }

    #w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c409-93cb773c {
        order: -9999
    }

    #w-node-_01b5676c-0c15-b261-4ad0-393603f95b9d-93cb773c {
        order: 9999
    }

    #w-node-_01b5676c-0c15-b261-4ad0-393603f95b9f-93cb773c {
        justify-self: start
    }

    #w-node-_477dd745-7085-6a73-b282-eb4d23ba5f2f-93cb77fe {
        grid-area: span 1/span 1/span 1/span 1
    }

    #w-node-b0c1b0f7-ed8e-ea97-04b6-e67ede012b0c-93cb7800 {
        order: 9999
    }

    #w-node-b0c1b0f7-ed8e-ea97-04b6-e67ede012b0e-93cb7800,
    #w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabf6-93cb7800 {
        justify-self: start
    }

    #w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabff-93cb7800 {
        order: -9999
    }

    #w-node-bad18347-b3e3-3b17-d808-7320f8eab480-93cb7800 {
        order: 9999
    }

    #w-node-bad18347-b3e3-3b17-d808-7320f8eab482-93cb7800,
    #w-node-_7128d008-abfe-92cd-ad02-a2227f76f33a-93cb7800 {
        justify-self: start
    }

    #w-node-_7128d008-abfe-92cd-ad02-a2227f76f343-93cb7800 {
        order: -9999
    }

    #w-node-_8ea22c76-2344-1281-9838-1dc5c6e1102e-93cb7800 {
        order: 9999
    }

    #w-node-_8ea22c76-2344-1281-9838-1dc5c6e11030-93cb7800 {
        justify-self: start
    }

    #w-node-_36d2a246-cb39-7c89-6d4f-0332607907af-93cb780d {
        order: 9999
    }

    #w-node-_36d2a246-cb39-7c89-6d4f-0332607907b1-93cb780d,
    #w-node-_77bb34f1-1340-c927-6fb8-6482a7f1913c-93cb780d {
        justify-self: start
    }

    #w-node-_77bb34f1-1340-c927-6fb8-6482a7f19145-93cb780d {
        order: -9999
    }

    #w-node-_90f6eeec-2560-e528-eaba-6048ad0318ec-93cb780d {
        order: 9999
    }

    #w-node-_90f6eeec-2560-e528-eaba-6048ad0318ee-93cb780d {
        justify-self: start
    }

    #w-node-_4ba668e6-ca36-cc5b-7bf7-f42be58e064b-93cb7819,
    #w-node-_5d57aa1a-c76b-efa2-b432-d6a8ca24d810-93cb7819 {
        align-self: center
    }

    #w-node-_1a9ad16a-cf91-4631-ccd5-84cc1676b57c-93cb781e {
        order: 9999
    }

    #w-node-_1a9ad16a-cf91-4631-ccd5-84cc1676b57e-93cb781e,
    #w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb6b-93cb781e {
        justify-self: start
    }

    #w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb74-93cb781e {
        order: -9999
    }

    #w-node-f7bf232d-31e6-0823-e8a7-3e7f893b7fd1-93cb781e {
        order: 9999
    }

    #w-node-f7bf232d-31e6-0823-e8a7-3e7f893b7fd3-93cb781e {
        justify-self: start
    }

    #w-node-fd1a957a-533a-8824-006b-7313a5dccedb-93cb7832 {
        order: 9999
    }

    #w-node-fd1a957a-533a-8824-006b-7313a5dccedd-93cb7832,
    #w-node-b431b86b-f2f0-708d-f867-ce24ea365c74-93cb7832 {
        justify-self: start
    }

    #w-node-b431b86b-f2f0-708d-f867-ce24ea365c7d-93cb7832 {
        order: -9999
    }

    #w-node-_0fab30e8-69c7-8a91-ac45-f4adb0d1bb7a-93cb7832 {
        order: 9999
    }

    #w-node-_0fab30e8-69c7-8a91-ac45-f4adb0d1bb7c-93cb7832 {
        justify-self: start
    }

    #w-node-_8f080c5f-5d43-e1fe-8f50-fbd438ba3900-93cb7840 {
        order: 9999
    }

    #w-node-_8f080c5f-5d43-e1fe-8f50-fbd438ba3902-93cb7840,
    #w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61af-93cb7840 {
        justify-self: start
    }

    #w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61b8-93cb7840 {
        order: -9999
    }

    #w-node-_76f22f68-56ac-162e-498a-f1ddff7de17d-93cb7840 {
        order: 9999
    }

    #w-node-_76f22f68-56ac-162e-498a-f1ddff7de17f-93cb7840,
    #w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662f6-93cb7840 {
        justify-self: start
    }

    #w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662ff-93cb7840 {
        order: -9999
    }

    #w-node-_481a6ed2-1fcc-7792-07b9-f00d54825df1-93cb7847 {
        order: 9999
    }

    #w-node-_481a6ed2-1fcc-7792-07b9-f00d54825df3-93cb7847,
    #w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b39-93cb7847 {
        justify-self: start
    }

    #w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b42-93cb7847 {
        order: -9999
    }

    #w-node-e03e9185-11ce-791a-e264-dee25008c53a-93cb7847 {
        order: 9999
    }

    #w-node-e03e9185-11ce-791a-e264-dee25008c53c-93cb7847 {
        justify-self: start
    }

    #w-node-c20425a6-2326-4d4c-8b3b-f0cbe553034b-93cb7909 {
        order: 9999
    }

    #w-node-c20425a6-2326-4d4c-8b3b-f0cbe553034d-93cb7909,
    #w-node-_23766549-02ab-9520-0510-6850153dfa62-93cb7909 {
        justify-self: start
    }

    #w-node-_23766549-02ab-9520-0510-6850153dfa6b-93cb7909 {
        order: -9999
    }

    #w-node-_94c7a407-ac95-9054-83ec-f8485a2bb894-93cb7909 {
        order: 9999
    }

    #w-node-_94c7a407-ac95-9054-83ec-f8485a2bb896-93cb7909,
    #w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793be-93cb7909 {
        justify-self: start
    }

    #w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793c7-93cb7909 {
        order: -9999
    }

    #w-node-_283026b3-5294-dee5-3d5a-4352e93cc0d3-93cb7909 {
        order: 9999
    }

    #w-node-_283026b3-5294-dee5-3d5a-4352e93cc0d5-93cb7909 {
        justify-self: start
    }

    #w-node-_058047f0-d9c2-4ec8-f4b3-063d874f13e7-93cb7923 {
        order: 9999
    }

    #w-node-_058047f0-d9c2-4ec8-f4b3-063d874f13e9-93cb7923,
    #w-node-_9118a212-9442-628d-ac5e-6da2ee54cda0-93cb7923 {
        justify-self: start
    }

    #w-node-_9118a212-9442-628d-ac5e-6da2ee54cda9-93cb7923 {
        order: -9999
    }

    #w-node-_06d05749-8911-70e8-b36d-954d89430ab7-93cb7923 {
        order: 9999
    }

    #w-node-_06d05749-8911-70e8-b36d-954d89430ab9-93cb7923 {
        justify-self: start
    }

    #w-node-_6e693b13-83bc-712c-839a-f2e50d8a4afc-93cb7924 {
        order: 9999
    }

    #w-node-_6e693b13-83bc-712c-839a-f2e50d8a4afe-93cb7924,
    #w-node-_98297c28-e473-00ed-b583-8c52be085aa4-93cb7924 {
        justify-self: start
    }

    #w-node-_98297c28-e473-00ed-b583-8c52be085aad-93cb7924 {
        order: -9999
    }

    #w-node-d1833798-6b2f-fa9b-2099-c04947765649-93cb7924 {
        order: 9999
    }

    #w-node-d1833798-6b2f-fa9b-2099-c0494776564b-93cb7924 {
        justify-self: start
    }

    #w-node-b9e4e460-f87c-7e25-eb78-1c9629344a2c-8676de95 {
        order: 9999
    }

    #w-node-b9e4e460-f87c-7e25-eb78-1c9629344a2e-8676de95,
    #w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb7445-8676de95 {
        justify-self: start
    }

    #w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb744e-8676de95 {
        order: -9999
    }

    #w-node-_824071e6-0194-461f-12d0-08eb4cf1c6c4-8676de95 {
        order: 9999
    }

    #w-node-_824071e6-0194-461f-12d0-08eb4cf1c6c6-8676de95,
    #w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d11b-8676de95 {
        justify-self: start
    }

    #w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d124-8676de95 {
        order: -9999
    }

    #w-node-_59911d5d-48ab-6fca-f96d-fd4652474e12-8676de95 {
        order: 9999
    }

    #w-node-_59911d5d-48ab-6fca-f96d-fd4652474e14-8676de95 {
        justify-self: start
    }

    #w-node-a3b4ce1c-50b1-5fa5-1462-df981ec6e574-1adf4b3b {
        order: 9999
    }

    #w-node-a3b4ce1c-50b1-5fa5-1462-df981ec6e576-1adf4b3b,
    #w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d42-1adf4b3b {
        justify-self: start
    }

    #w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d4b-1adf4b3b {
        order: -9999
    }

    #w-node-bb0cd039-e522-80e3-0a35-b1a518695189-1adf4b3b {
        order: 9999
    }

    #w-node-bb0cd039-e522-80e3-0a35-b1a51869518b-1adf4b3b {
        justify-self: start
    }

    #w-node-eff55037-24c4-870b-155a-a9728acbb7e3-ac2ff666 {
        order: 9999
    }

    #w-node-eff55037-24c4-870b-155a-a9728acbb7e5-ac2ff666,
    #w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f0396-ac2ff666 {
        justify-self: start
    }

    #w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f039f-ac2ff666 {
        order: -9999
    }

    #w-node-e47ab1f6-152e-159a-b9a6-e38ea9b45f92-ac2ff666 {
        order: 9999
    }

    #w-node-e47ab1f6-152e-159a-b9a6-e38ea9b45f94-ac2ff666 {
        justify-self: start
    }

    #w-node-e9401e50-06e1-0862-cc4e-029899dc72cc-c64f9a6b {
        order: 9999
    }

    #w-node-e9401e50-06e1-0862-cc4e-029899dc72ce-c64f9a6b,
    #w-node-_09ac2a08-b917-4337-bd8f-050cee23ace9-c64f9a6b {
        justify-self: start
    }

    #w-node-_09ac2a08-b917-4337-bd8f-050cee23acf2-c64f9a6b {
        order: -9999
    }

    #w-node-_162aae03-c586-ae88-6ad4-531388f54214-c64f9a6b {
        order: 9999
    }

    #w-node-_162aae03-c586-ae88-6ad4-531388f54216-c64f9a6b {
        justify-self: start
    }

    #w-node-_55933a29-ee0c-5f05-a0c1-f345d2370167-f31fda6f {
        justify-self: auto
    }
}

@media screen and (min-width:1440px) {

    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7742,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7742,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7742,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7742,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7742,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7742,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7742,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7742,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb77b6,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb77b6,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb77b6,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb77b6,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb77b6,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb77b6,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb77b6,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb77b6,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401a-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401b-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401c-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401d-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf4047-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf4048-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf4049-93cb77fe,
    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf404a-93cb77fe,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7806,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7806,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7806,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7806,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7806,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7806,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7806,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7806,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7808,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7808,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7808,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7808,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7808,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7808,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7808,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7808,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb782d,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb782d,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb782d,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb782d,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb782d,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb782d,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb782d,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb782d,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7831,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7831,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7831,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7831,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7831,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7831,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7831,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7831,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb783f,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb783f,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb783f,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb783f,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb783f,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb783f,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb783f,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb783f,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7842,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7842,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7842,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7842,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7842,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7842,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7842,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7842,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7844,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7844,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7844,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7844,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7844,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7844,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7844,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7844,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7872,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7872,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7872,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7872,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7872,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7872,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7872,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7872,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7875,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7875,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7875,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7875,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7875,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7875,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7875,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7875,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7878,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7878,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7878,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7878,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7878,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7878,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7878,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7878,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7879,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7879,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7879,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7879,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7879,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7879,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7879,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7879,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb78b5,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb78b5,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb78b5,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb78b5,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb78b5,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb78b5,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb78b5,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb78b5,
    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb790a,
    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb790a,
    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb790a,
    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb790a,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb790a,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb790a,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb790a,
    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb790a {
        grid-area: span 1/span 1/span 1/span 1
    }

    #w-node-_4de89373-2018-f68d-53f7-7019f91df458-2d3663e1 {
        justify-self: auto
    }
}

@media screen and (min-width:1280px) {

    #w-node-_3d3434d1-a202-57b4-e574-4c533e78a595-93cb7812,
    #w-node-_1fbe0be4-1ea3-4a63-4199-fb712b11a9b0-93cb7812,
    #w-node-a6d88170-cf40-dcec-fad2-5a893540766d-93cb7812,
    #w-node-_3d3434d1-a202-57b4-e574-4c533e78a595-93cb7813,
    #w-node-_1fbe0be4-1ea3-4a63-4199-fb712b11a9b0-93cb7813,
    #w-node-a6d88170-cf40-dcec-fad2-5a893540766d-93cb7813,
    #w-node-_3d3434d1-a202-57b4-e574-4c533e78a595-93cb7814,
    #w-node-_1fbe0be4-1ea3-4a63-4199-fb712b11a9b0-93cb7814,
    #w-node-a6d88170-cf40-dcec-fad2-5a893540766d-93cb7814 {
        grid-area: span 1/span 1/span 1/span 1
    }

    #w-node-b7843a38-8800-5dce-e230-aa37d1f45b60-93cb78bc {
        justify-self: center
    }

    #w-node-_247107bd-ea7e-f150-8aab-5e83264224b7-93cb78bc {
        justify-self: auto
    }
}

@media screen and (max-width:991px) {
    #w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82 {
        grid-area: span 1/span 2/span 1/span 2
    }

    #w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c400-93cb773c {
        order: 9999
    }

    #w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb507-93cb777e,
    #w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb509-93cb777e {
        grid-area: span 1/span 1/span 1/span 1
    }

    #w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a43-3d1729f0,
    #w-node-befe73de-ec83-6b07-0c6d-dc06b93d869a-93cb77fc {
        grid-area: span 1/span 2/span 1/span 2
    }

    #w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabf6-93cb7800,
    #w-node-_7128d008-abfe-92cd-ad02-a2227f76f33a-93cb7800 {
        order: 9999
    }

    #w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb780a {
        justify-self: center
    }

    #w-node-_77bb34f1-1340-c927-6fb8-6482a7f1913c-93cb780d {
        order: 9999
    }

    #w-node-_4ba668e6-ca36-cc5b-7bf7-f42be58e0649-93cb7819,
    #w-node-e4be6bd5-d7bc-15af-5134-0ec3fbe1d4e0-93cb7819 {
        justify-self: center
    }

    #w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb6b-93cb781e,
    #w-node-b431b86b-f2f0-708d-f867-ce24ea365c74-93cb7832 {
        order: 9999
    }

    #w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328a-93cb7834 {
        grid-area: 2/1/4/2
    }

    #w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61af-93cb7840,
    #w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662f6-93cb7840,
    #w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b39-93cb7847 {
        order: 9999
    }

    #w-node-_1dc8c3fe-dd74-ce3e-e0f4-63fafd190397-93cb784d {
        grid-area: 2/3/2/2
    }

    #w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d {
        grid-column-start: 1
    }

    #w-node-_78dbd686-4557-31f7-c2e8-0ddfac9f126c-93cb784d {
        grid-area: 1/1/2/3
    }

    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf5e-93cb7871 {
        grid-area: 2/3/2/2
    }

    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {
        grid-column-start: 1
    }

    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf71-93cb7871 {
        grid-area: 1/1/2/3
    }

    #w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7872,
    #w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7872,
    #w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7879,
    #w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7879 {
        grid-area: span 1/span 1/span 1/span 1
    }

    #w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb787a,
    #w-node-e8413fa3-2c14-0318-3f47-800a00971205-93cb78ec {
        justify-self: center
    }

    #w-node-_23766549-02ab-9520-0510-6850153dfa62-93cb7909,
    #w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793be-93cb7909 {
        order: 9999
    }

    #w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb790a,
    #w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb790a {
        grid-area: span 1/span 1/span 1/span 1
    }

    #w-node-_9118a212-9442-628d-ac5e-6da2ee54cda0-93cb7923,
    #w-node-_98297c28-e473-00ed-b583-8c52be085aa4-93cb7924 {
        order: 9999
    }

    #w-node-_339c5877-5ff7-32e3-7e05-334be1c8c17e-8676de95 {
        justify-self: center
    }

    #w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb7445-8676de95,
    #w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d11b-8676de95,
    #w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d42-1adf4b3b,
    #w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f0396-ac2ff666,
    #w-node-_09ac2a08-b917-4337-bd8f-050cee23ace9-c64f9a6b {
        order: 9999
    }

    #w-node-f9661c9f-41e0-1500-2752-16794f57f181-077d536b {
        align-self: center;
        justify-self: auto
    }

    #w-node-_4de89373-2018-f68d-53f7-7019f91df458-2d3663e1 {
        align-self: auto;
        justify-self: auto
    }

    #w-node-_55933a29-ee0c-5f05-a0c1-f345d2370167-f31fda6f {
        order: -9999
    }

    #w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a43-f31fda6f {
        grid-area: span 1/span 2/span 1/span 2
    }
}

@media screen and (max-width:767px) {
    #w-node-b094e1d1-5991-5a05-e7ca-30e4a066e338-93cb77fc {
        grid-column: span 1/span 1
    }

    #w-node-_1dc8c3fe-dd74-ce3e-e0f4-63fafd190397-93cb784d,
    #w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d {
        grid-row-start: 1;
        grid-column-end: 3
    }

    #w-node-_78dbd686-4557-31f7-c2e8-0ddfac9f126c-93cb784d {
        grid-area: 2/1/3/3
    }

    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf5e-93cb7871,
    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {
        grid-row-start: 1;
        grid-column-end: 3
    }

    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf71-93cb7871 {
        grid-area: 2/1/3/3
    }

    #w-node-_7f17079a-8881-0259-1eb8-c98eba1bae74-077d536b,
    #w-node-_7f17079a-8881-0259-1eb8-c98eba1bae77-077d536b,
    #w-node-_7f17079a-8881-0259-1eb8-c98eba1bae7a-077d536b,
    #w-node-_2fa56ef2-738d-6ffc-950c-ebc00e1113f4-077d536b,
    #w-node-_7cac7751-8645-8ec9-1db8-59c30615d0e7-077d536b,
    #w-node-ffeb09cf-7ce9-9d9a-2bf8-f1c820068890-077d536b,
    #w-node-_2ebbf7b3-e23c-2cba-d121-8b963a7c0f54-077d536b,
    #w-node-df5960e5-9864-5112-4eeb-e6e31e4b7329-077d536b,
    #w-node-_49d8deef-379f-633a-53a2-6063464b03d4-077d536b,
    #w-node-_37a86e95-42f8-fa49-4c8d-e97556a84cf8-077d536b {
        justify-self: center
    }
}

@media screen and (max-width:479px) {
    #w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82 {
        align-self: auto;
        justify-self: center
    }

    #w-node-d26efc9b-757f-6b02-d6d9-6ed47e6eb92b-93cb77fc,
    #w-node-_802fb8c7-6066-06bc-5774-9463292fba4a-93cb77fc {
        justify-self: start
    }

    #w-node-befe73de-ec83-6b07-0c6d-dc06b93d869a-93cb77fc {
        justify-self: auto
    }

    #w-node-_507e9163-ce1c-6370-08ce-bd76d88aae4b-93cb7822 {
        justify-self: start
    }

    #w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa1-93cb782f,
    #w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa6-93cb782f {
        justify-self: center
    }

    #w-node-c9d841c6-b7de-201c-736b-087712626bc6-93cb7843 {
        order: 9999
    }

    #w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d,
    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {
        grid-area: 1/1/2/3
    }

    #w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a43-f31fda6f {
        align-self: auto;
        justify-self: center
    }
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c995ca5562a0a11b7_Satoshi-Black.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907b88df927eb6f0c609_Satoshi-Black.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a1ac7fc52b1f10764_Satoshi-Black.otf') format('opentype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907cf0a732e6f6dd7265_Satoshi-Italic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907e5f5fbe0c50b486cc_Satoshi-VariableItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c49ffdcdf9e844e52_Satoshi-Italic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907efddb2a5b0b0255b5_Satoshi-VariableItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22ae354a81e1a6e8ecc_Satoshi-Italic.otf') format('opentype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907cfa78fa2fb5884cf6_Satoshi-Light.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d2e5dae3050d6a4ae_Satoshi-Light.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22ac9ea3efa94b78d44_Satoshi-Light.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c5f5fbe79fdb486ca_Satoshi-BlackItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c79ce670bb3daca1f_Satoshi-BlackItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a2d0e9cb218d07d89_Satoshi-BlackItalic.otf') format('opentype');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c8b23630aa8712f5d_Satoshi-LightItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c8b236328bf712f5c_Satoshi-LightItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a3876e63fcbfb937f_Satoshi-LightItalic.otf') format('opentype');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c79ce674833daca20_Satoshi-BoldItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c71fd1d0dee132f10_Satoshi-BoldItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22bf0a95ae6eff15b5b_Satoshi-BoldItalic.otf') format('opentype');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d878edabc5d3c7838_Satoshi-MediumItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907dfa78fa96ec884cf9_Satoshi-MediumItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22aba66e21bdb211459_Satoshi-MediumItalic.otf') format('opentype');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d75cb9f97e8db6959_Satoshi-Medium.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d32fac368c3c13cf8_Satoshi-Medium.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a85a3b14f4b2f3611_Satoshi-Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907efd39a16665eda62e_Satoshi-Regular.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d58147e595393cf46_Satoshi-Regular.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22abaa2d4db334fee73_Satoshi-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi variable';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907e5f5fbe3310b486cb_Satoshi-Variable.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907e58147eedff93cf47_Satoshi-Variable.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f291ee6c79af50128e0553_P22MackinacProExtraBold-Italic-webfont.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f291ee484223715c7c50ec_P22MackinacProExtraBold-Italic-webfont.woff') format('woff');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'P22';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2927d8a120352353fc784_P22MackinacProBold-Italic-webfont.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2927d82066d2c47850b77_P22MackinacProBold-Italic-webfont.woff') format('woff');
    font-weight: 800;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Satoshi';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c995ca5f15f0a11b8_Satoshi-Bold.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a6f5b56f080b08210_Satoshi-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e972f7c60601a5bab5d_Inter-Bold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e977e8a69256e1d62ae_Inter-ExtraBold.ttf') format('truetype');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e97950eb103499beb6f_Inter-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e9863de511c95f1bbc2_Inter-Regular.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e97ad2d5a4b94a6fcfa_Inter-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Inter';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e97ca731b7fff17b0d9_Inter-SemiBold.ttf') format('truetype');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 17';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24de8be94a6ac5b3f24_P22MackinacPro-ExBoldItalic_17.otf') format('opentype');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro book 25';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24d43ba4a85944175b6_P22MackinacPro-Book_25.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 11';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24d6f5b56ba58b08224_P22MackinacPro-BoldItalic_11.otf') format('opentype');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 16';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24dd07b6d1b36f34fe4_P22MackinacPro-Bold_16.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 15';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24dbaa2d491134fef5c_P22MackinacPro-BookItalic_15.otf') format('opentype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 12';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24d54165576d732ed25_P22MackinacPro-ExtraBold_12.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 26';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24db36f02da2a37019a_P22MackinacPro-Medium_26.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22mackinacpro 18';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24e4fad261e4d6fc10e_P22MackinacPro-MedItalic_18.otf') format('opentype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'P22 Mackinacpro';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e81643fb931e8e5f21_P22MackinacPro-Book_25.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22 Mackinacpro';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e804aea9dd57ef7dbd_P22MackinacPro-Medium_26.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22 Mackinacpro';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e82f7c60601a502a93_P22MackinacPro-Bold_16.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'P22 Mackinacpro';
    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e722c77e92a41be9e6_P22MackinacPro-ExtraBold_12.otf') format('opentype');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}`, "",{"version":3,"sources":["webpack://./src/styles/Pablooflow.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B;AACJ;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;IAaI;AACJ;;AAEA;;;;IAII,wBAAwB;IACxB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sBAAsB;IACtB;AACJ;;AAEA;;;;;IAKI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,8DAAqhF;IACrhF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,oBAAoB;IACpB,oBAAoB;IACpB,mCAAmC;IACnC,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,wBAAwB;IACxB,cAAc;IACd,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,wBAAwB;IACxB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,oEAAoE;IACpE,8BAA8B;IAC9B,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;IAC1B,4BAA4B;IAC5B,gCAAgC;IAChC,gCAAgC;IAChC,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,iCAAiC;IACjC;AACJ;;AAEA;;;;;;IAMI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;;;IAGI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI,SAAS;IACT,SAAS;IACT;AACJ;;AAEA;;;IAGI,eAAe;IACf,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,SAAS;IACT,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,UAAU;QACV;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,cAAc;QACd;IACJ;;IAEA;QACI,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB;AACJ;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IAEzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI,iBAAiB;IACjB,0FAA0F;IAC1F,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,uFAAuF;IACvF,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;;IAEI,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,iBAAiB;IACjB,mEAAmE;IACnE;AACJ;;AAEA;IACI,iBAAiB;IACjB,gEAAgE;IAChE;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,wBAAwB;IACxB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,yCAAyC;IACzC,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,2CAA2C;IAC3C,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,gCAAgC;IAChC,yBAAyB;IAEzB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,MAAM;IACN,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IAEzB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,sBAAsB;IACtB,wCAAwC;IACxC,6BAA6B;IAC7B,UAAU;IACV,6EAA6E;IAC7E,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;;IAEI,iCAAiC;IACjC,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI,sBAAsB;IACtB;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,4BAA4B;IAC5B,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yDAAyU;IACzU,aAAa;IACb,SAAS;IACT;AACJ;;AAEA;IACI,yDAA6U;IAC7U,aAAa;IACb,SAAS;IACT;AACJ;;AAEA;IACI,yDAAyW;IACzW,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI,WAAW;IACX,QAAQ;IACR;AACJ;;AAEA;IACI,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,sBAAsB;IACtB,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,UAAU;IACV,MAAM;IACN;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,UAAU;IACV,MAAM;IACN;AACJ;;;AAGA;IACI;AACJ;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;IACvB,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,qCAAqC;IACrC,gBAAgB;IAChB,uCAAuC;IACvC,qCAAqC;IACrC,wCAAwC;IACxC,uCAAuC;IACvC,iDAAiD;IACjD,iDAAiD;IACjD,+CAA+C;IAC/C,qEAAqE;IACrE,sDAAsD;IACtD,iDAAiD;IACjD,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC,uCAAuC;IACvC;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,4GAA4G;IAC5G,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sGAAsG;IACtG,wBAAwB;IACxB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,2BAA2B;IAC3B,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iCAAiC;IACjC,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAEhB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,4CAA4C;IAC5C,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qCAAqC;IACrC,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;IACxC,WAAW;IACX;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,8CAA8C;IAC9C,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,6BAA6B;IAC7B,8CAA8C;IAC9C,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;IAC5C,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;IAC5C,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;IAC5C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,SAAS;IACT,WAAW;IACX,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mIAAmI;IACnI,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,4CAA4C;IAC5C,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,yIAAyI;IACzI,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,6CAA6C;IAC7C,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB;AACJ;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,gBAAgB;IAChB,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uIAAuI;IACvI,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,kBAAkB;IAClB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB;AACJ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAO;IACP,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAY;IACZ,8BAA8B;IAC9B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,wCAAwC;IACxC,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,6CAA6C;IAC7C,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,kIAAkI;IAClI,8BAA8B;IAC9B,4BAA4B;IAC5B,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wCAAwC;IACxC,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC;AACJ;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI;QACI,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,oCAAoC;IACpC,cAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,+HAA+H;IAC/H,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uIAAuI;IACvI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,uIAAuI;IACvI,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAO;IACP;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;IAC1C,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,UAAU;IACV,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,2CAA2C;IAC3C,sBAAsB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAEhB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,4CAA4C;IAC5C,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,yCAAyC;IACzC;AACJ;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qIAAqI;IACrI,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,8CAA8C;IAC9C;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uPAAuP;IACvP,6BAA6B;IAC7B,uCAAuC;IACvC,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,oIAAoI;IACpI,wBAAwB;IACxB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,UAAU;IACV,wBAAwB;IACxB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,UAAU;IACV,wBAAwB;IACxB;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,wCAAwC;IACxC,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,yCAAyC;IACzC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI,qBAAqB;QACrB,mBAAmB;QACnB,eAAe;QACf;IACJ;;AAEJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV;AACJ;;AAEA;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,QAAQ;IACR,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,SAAS;IACT,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0CAA0C;IAC1C,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,uDAAuD;IACvD,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,QAAQ;IACR;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,8CAA8C;IAC9C;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,eAAe;IACf,SAAS;IACT,WAAW;IACX,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,UAAU;IACV,eAAe;IACf,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf,SAAS;IACT,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,UAAU;IACV,YAAY;IACZ,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,YAAY;IACZ,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,8BAA8B;IAC9B,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IAEb,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,iDAAiD;IACjD,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,iCAAiC;IACjC,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;IAC3B,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iCAAiC;IACjC,mBAAmB;IACnB,2BAA2B;IAC3B,oBAAoB;IACpB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IAEI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,yCAAyC;IACzC,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;IAClC,0BAA0B;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,+HAA+H;IAC/H,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,+HAA+H;IAC/H,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;IAC5B,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2CAA2C;IAC3C,6BAA6B;IAC7B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;IAChC,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,qCAAqC;IACrC,gCAAgC;IAChC,sBAAsB;IACtB,0CAA0C;IAC1C,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,sKAAsK;IACtK,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;IAEpB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;IACpB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;;;;;;IAMI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII,eAAe;IACf;AACJ;;AAEA;;;IAGI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,8BAA8B;IAC9B,4GAA4G;IAC5G,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,gCAAgC;IAChC,cAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,yEAAyE;IACzE,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,yCAAyC;IAEzC,2BAA2B;IAC3B,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,yCAAyC;IAEzC,2BAA2B;IAC3B,0CAA0C;IAC1C,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAE9B;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;IAChC;AACJ;;AAEA;IACI,cAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,qFAAqF;IACrF,8BAA8B;IAC9B,4BAA4B;IAC5B,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,oCAAoC;IACpC;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mCAAmC;IACnC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,kIAAkI;IAClI,8BAA8B;IAC9B,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAElB,0BAA0B;IAC1B,mBAAmB;IACnB,oCAAoC;IACpC,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;;;;;IAKI,wBAAwB;IACxB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;;;;IAII,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;IAChB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,oCAAoC;IACpC,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gIAAgI;IAChI,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,oCAAoC;IACpC,sIAAsI;IACtI,8BAA8B;IAC9B,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,cAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,eAAe;IACf,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,iEAAiE;IACjE,aAAa;IACb;AACJ;;AAEA;IAEI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,aAAa;IACb,qBAAqB;IACrB;AACJ;;AAEA;IACI,yBAAyB;IACzB,qIAAqI;IACrI,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,qIAAqI;IACrI,wBAAwB;IACxB,4BAA4B;IAC5B,wBAAwB;IACxB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IAEV,4BAA4B;IAC5B,eAAe;IACf,yCAAyC;IACzC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,SAAS;IACT;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,8DAA8D;IAC9D;AACJ;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,cAAc;IACd,mCAAmC;IACnC,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;IAChB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,aAAa;IAEb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;IACzB,oBAAoB;IACpB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,0CAA0C;IAC1C,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,aAAa;IACb,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,aAAa;IACb,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,wBAAwB;IACxB,8CAA8C;IAC9C;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,kIAAkI;IAClI,wBAAwB;IACxB,4BAA4B;IAC5B,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,0IAA0I;IAC1I,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kIAAkI;IAClI,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0KAA0K;IAC1K,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,cAAY;IACZ,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IAEb,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;IAC1B,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;;IAEI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,uCAAuC;IACvC,gBAAgB;IAChB,eAAe;IACf,SAAO;IACP,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,mCAAmC;IACnC,8BAA8B;IAC9B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8DAA8D;IAC9D,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,uMAAuM;IACvM,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,4BAA4B;IAC5B,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sLAAsL;IACtL,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oDAAoD;IACpD,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,kIAAkI;IAClI,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,aAAa;IACb;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB;AACJ;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mCAAmC;IACnC;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;IAChC;AACJ;;AAEA;IACI,UAAU;IAEV,2BAA2B;IAC3B,0CAA0C;IAC1C,+BAA+B;IAC/B,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mCAAmC;IACnC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,gIAAgI;IAChI,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;IACxB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI,2BAA2B;IAC3B,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;IAChC,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0CAA0C;IAC1C,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,oBAAoB;IACpB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAO;IACP,gBAAgB;IAChB;AACJ;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,OAAO;IACP,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,OAAO;IACP;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;IACxB;AACJ;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAO;IACP;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mIAAmI;IACnI,yBAAyB;IACzB,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,2IAA2I;IAC3I,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,6IAA6I;IAC7I,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iCAAiC;IACjC,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6CAA6C;IAC7C,kCAAkC;IAClC,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mIAAmI;IACnI,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAElB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,eAAe;IACf,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,2HAA2H;IAC3H,8BAA8B;IAC9B,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,8CAA8C;IAC9C,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;IAChC,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,cAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,0EAA0E;IAC1E,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;IAChB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,yEAAyE;IACzE,mBAAmB;IACnB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,uCAAuC;IACvC,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,gCAAgC;IAChC,cAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,sBAAsB;IACtB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB;AACJ;;AAEA;IACI,qCAAqC;IACrC,gPAAgP;IAChP,sCAAsC;IACtC,uCAAuC;IACvC;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,yCAAyC;IACzC,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB;AACJ;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,qCAAqC;IACrC,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,8CAA8C;IAC9C;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,2CAA2C;IAC3C,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,2CAA2C;IAC3C,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iIAAiI;IACjI,yBAAyB;IACzB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,kCAAkC;IAClC,0BAA0B;IAC1B,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,mCAAmC;IACnC,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;;IAEI,+CAA+C;IAC/C;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,gIAAgI;IAChI,8BAA8B;IAC9B,4BAA4B;IAC5B,wBAAwB;IACxB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,oBAAoB;IACpB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mIAAmI;IACnI,wBAAwB;IACxB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yEAAyE;IACzE,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;IACrB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,4BAA4B;IAC5B,uBAAuB;IACvB,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sIAAsI;IACtI,wBAAwB;IACxB,2BAA2B;IAC3B,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB;AACJ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,0CAA0C;IAC1C,+DAA+D;IAC/D,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,gCAAgC;IAChC,mIAAmI;IACnI,2BAA2B;IAC3B,oBAAoB;IACpB,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kCAAkC;IAClC,2EAA2E;IAC3E,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iJAAiJ;IACjJ,wBAAwB;IACxB,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uIAAuI;IACvI,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,gDAAgD;IAChD;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,+LAA+L;IAC/L,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,8BAA8B;IAC9B;AACJ;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,+BAA+B;IAC/B;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;;;IAGI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uCAAuC;IACvC,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,mCAAmC;IACnC,mBAAmB;IACnB,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;IAChC;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,sCAAsC;IACtC;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,sDAAsD;IACtD,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uIAAuI;IACvI,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,uIAAuI;IACvI,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,yCAAyC;IACzC,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,wFAAwF;IACxF,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kEAAkE;IAClE,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB;AACJ;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,iDAAiD;IACjD,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0CAA0C;IAC1C,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX;AACJ;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd;AACJ;;AAEA;IACI,qCAAqC;IACrC;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;;;;;;IAMI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,eAAe;IACf,MAAM;IACN,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;;;IAGI,uBAAuB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,YAAY;IACZ;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,kCAAkC;QAClC,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uIAAuI;IACvI,uBAAuB;IACvB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,qCAAqC;IACrC,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,6BAA6B;IAC7B,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;IACvB;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,6CAA6C;IAC7C;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,cAAY;IACZ,wBAAwB;IACxB,0CAA0C;IAC1C,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,WAAW;IACX;AACJ;;AAEA;IACI,0BAA0B;IAC1B,8CAA8C;AAClD;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB;AACJ;;AAEA;IACI,2DAA2D;IAC3D;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oFAAoF;IACpF,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,+HAA+H;IAC/H,4BAA4B;IAC5B,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,cAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,8HAA8H;IAC9H,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,oCAAoC;IACpC,gLAAgL;IAChL,kCAAkC;IAClC,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,gLAAgL;IAChL,kCAAkC;IAClC,4BAA4B;IAC5B,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,2DAA2D;IAC3D,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;;IAErB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,yIAAyI;IACzI,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,iCAAiC;IACjC,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;IACV;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,cAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB;AACJ;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,+HAA+H;IAC/H,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,yCAAyC;IACzC,mIAAmI;IACnI,wBAAwB;IACxB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,qCAAqC;IACrC,mIAAmI;IACnI,wBAAwB;IACxB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,yCAAyC;IACzC,mIAAmI;IACnI,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;;IAEI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;IACV,gCAAgC;IAChC;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX;AACJ;;AAEA;IACI,6HAA6H;IAC7H,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,0CAA0C;IAC1C,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,oFAAoF;IACpF,oBAAoB;IACpB;AACJ;;AAEA;IACI,wDAAwD;IACxD,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI;QACI,oCAAoC;QACpC,YAAY;QACZ,WAAW;QACX,WAAW;QACX;IACJ;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+CAA+C;IAC/C,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,cAAY;IACZ,mBAAmB;IACnB,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI,sFAAsF;IACtF,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,+EAA+E;IAC/E,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,+DAA+D;IAC/D,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qEAAqE;IACrE,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,SAAS;IACT;AACJ;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,oBAAoB;IACpB,2DAA2D;IAC3D,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,yCAAyC;IACzC,yCAAyC;IACzC,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,uBAAuB;IACvB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2DAA2D;IAC3D,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,gCAAgC;IAChC,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,qFAAqF;IACrF,6BAA6B;IAC7B,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,2KAA2K;IAC3K,6BAA6B;IAC7B,oCAAoC;IACpC,4BAA4B;IAC5B,6BAA6B;IAC7B,gCAAgC;IAChC,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,4EAA4E;IAC5E,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,aAAa;IAEb,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,QAAQ;IACR;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,qFAAqF;IACrF,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2DAA2D;IAC3D,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,cAAc;IACd,SAAS;IACT;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,sEAAsE;IACtE,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,sEAAsE;IACtE,OAAO;IACP,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;IACT;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,+HAA+H;IAC/H,wBAAwB;IACxB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,8DAA8D;IAC9D,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;;IAEI,oBAAoB;IACpB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,yCAAyC;IACzC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,oFAAoF;IACpF,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB;AACJ;;AAEA;IACI,uIAAuI;IACvI,4BAA4B;IAC5B,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;AACA;IACI,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAO;IACP,uBAAuB;IACvB,uBAAuB;IACvB,gCAAgC;IAChC;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,iIAAiI;IACjI,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV,wCAAwC;IACxC,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;IACxC,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,2DAA2D;IAC3D,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,2IAA2I;IAC3I,wBAAwB;IACxB,4BAA4B;IAC5B,qBAAqB;IACrB,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uFAAuF;IACvF,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;IACrB,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,+HAA+H;IAC/H,8BAA8B;IAC9B,4BAA4B;IAC5B,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI,yIAAyI;IACzI,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,sBAAsB;IACtB,SAAO;IACP,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iJAAiJ;IACjJ,sBAAsB;IACtB,SAAO;IACP,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,sBAAsB;IACtB,SAAO;IACP,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV;AACJ;;AAEA;IACI,OAAO;IACP;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,aAAa;IAEb,gBAAgB;IAChB;AACJ;;AAEA;IACI,uFAAuF;IACvF,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,2DAA2D;IAC3D,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,eAAe;IACf,SAAS;IACT,UAAU;IACV,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAO;IACP,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,YAAY;IACZ,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,SAAS;IACT,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,yCAAyC;IACzC,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,WAAW;IACX;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kCAAkC;IAClC,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB;;AAEJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,SAAO;IACP;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IAEjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,uCAAuC;IACvC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uCAAuC;IACvC,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qDAAqD;IACrD;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;IASI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,sFAAsF;IACtF,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,+EAA+E;IAC/E,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,OAAO;IACP,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,2DAA2D;IAC3D,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,uDAAuD;IACvD,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,uDAAuD;IACvD;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,uIAAuI;IACvI,wBAAwB;IACxB,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,mCAAmC;IACnC,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;IAYI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,oBAAoB;IACpB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,2BAA2B;IAC3B,mBAAmB;IACnB,cAAY;IACZ,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,mBAAmB;IACnB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,kCAAkC;IAClC,0BAA0B;IAC1B,sBAAsB;IACtB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,8BAA8B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI,sFAAsF;IACtF,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,QAAQ;IACR;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC;AACJ;;AAEA;;IAEI,wBAAwB;IACxB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,yCAAyC;IACzC,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,0CAA0C;IAC1C,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,0CAA0C;IAC1C,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb;AACJ;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,qDAAqD;IACrD,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qDAAqD;IACrD,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oKAAoK;IACpK,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,2DAA2D;IAC3D,gCAAgC;IAChC,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,2DAA2D;IAC3D,+BAA+B;IAC/B,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,+DAA+D;IAC/D,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb;AACJ;;AAEA;IACI,+DAA+D;IAC/D,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,+DAA+D;IAC/D,+DAA+D;IAC/D,2EAA2E;IAC3E;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,oKAAoK;IACpK,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,oDAAoD;IACpD,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,oKAAoK;IACpK,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,oKAAoK;IACpK,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oKAAoK;IACpK,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,+DAA+D;IAC/D,+DAA+D;IAC/D,2EAA2E;IAC3E,4BAA4B;IAC5B,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,oCAAoC;IACpC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,qBAAqB;IACrB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;;;;;;IAMI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC;AACJ;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB;AACJ;;AAEA;;;;;;IAMI,kCAAkC;IAElC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iJAAiJ;IACjJ,SAAO;IACP,aAAa;IACb;AACJ;;AAEA;IACI,yIAAyI;IACzI,aAAa;IACb;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iJAAiJ;IACjJ,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,iJAAiJ;IACjJ,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAY;IACZ,2BAA2B;IAC3B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yIAAyI;IACzI,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iJAAiJ;IACjJ,sBAAsB;IACtB,SAAO;IACP,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,SAAO;IACP,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,yIAAyI;IACzI,uBAAuB;IACvB,4BAA4B;IAC5B,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,yIAAyI;IACzI,yBAAyB;IACzB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,iJAAiJ;IACjJ,SAAO;IACP,UAAU;IACV,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iJAAiJ;IACjJ,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yIAAyI;IACzI,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IAEI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,UAAU;IACV,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB;AACJ;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,sBAAsB;IACtB,eAAe;IACf,MAAM;IACN,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,wCAAwC;IACxC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB;AACJ;;AAEA;IACI,sCAAsC;IACtC,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,SAAO;IACP,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,kCAAkC;IAClC,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAY;IACZ,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,sBAAsB;IACtB,SAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,4CAA4C;IAC5C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,wCAAwC;IACxC,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,QAAQ;IACR;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAY;IACZ,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC,WAAW;IACX;AACJ;;AAEA;IACI,6HAA6H;IAC7H,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;AAEA;IACI,oCAAoC;IACpC,6HAA6H;IAC7H,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAO;IACP,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,+DAA+D;IAC/D,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,qCAAqC;IACrC;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;IACV,uBAAuB;IACvB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,iCAAiC;IACjC,qCAAqC;IACrC,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,2EAA2E;IAC3E,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB;AACJ;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,cAAY;IACZ,2BAA2B;IAC3B,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,gBAAgB;IAChB,4CAA4C;IAC5C;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,8BAA8B;IAC9B,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI,cAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,SAAO;IACP,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;IAC5B,cAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC;AACJ;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,cAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,uIAAuI;IACvI,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,6BAA6B;IAC7B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAY;IACZ,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uIAAuI;IACvI,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV;AACJ;;AAEA;IACI,0CAA0C;IAC1C,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,cAAY;IACZ,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,+CAA+C;IAC/C,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,SAAO;IACP,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,SAAO;IACP,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,oBAAoB;IACpB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,cAAY;IACZ,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,wEAAwE;IACxE,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,4BAA4B;IAC5B;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,SAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,mBAAmB;IACnB,cAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,oCAAoC;IACpC,SAAO;IACP,kBAAkB;IAClB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;;;;;;IAMI,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;;;;IAII,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,SAAO;IACP,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,YAAY;IACZ;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wGAAwG;IACxG;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,uIAAuI;IACvI,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,uIAAuI;IACvI,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qDAAqD;IACrD,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,iCAAiC;IACjC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,wCAAwC;IACxC,uCAAuC;IACvC,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV;AACJ;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,wCAAwC;IACxC,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV;AACJ;;AAEA;IACI,eAAe;IACf,SAAO;IACP,gBAAgB;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,SAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8HAA8H;IAC9H,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ;AACJ;;AAEA;IACI,6HAA6H;IAC7H;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,UAAU;IACV;AACJ;;AAEA;;;;;;;;;;;;;;;;IAgBI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,2DAA2D;IAC3D,mBAAmB;IACnB,cAAc;IACd,cAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mDAAmD;IACnD,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,gBAAgB;IAChB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2CAA2C;IAC3C;AACJ;;AAEA;IACI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;;IAKI,0BAA0B;IAC1B;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,2IAA2I;IAC3I,wBAAwB;IACxB,2BAA2B;IAC3B,WAAW;IACX,aAAa;IACb;AACJ;;AAEA;IACI,wHAAwH;IACxH,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,cAAY;IACZ,UAAU;IACV,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,cAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB;AACJ;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,qBAAqB;IACrB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,MAAM;IACN,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,2DAA2D;IAC3D,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,4CAA4C;IAC5C;AACJ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,cAAY;IACZ;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI,cAAY;IACZ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB;AACJ;;AAEA;IACI,cAAY;IACZ,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,wBAAwB;IACxB;AACJ;;AAEA;IACI,uCAAuC;IACvC;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,uCAAuC;IACvC,yCAAyC;IACzC,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C,uCAAuC;IACvC,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB;AACJ;;AAEA;IACI,mIAAmI;IACnI,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB;AACJ;;AAEA;IACI,+HAA+H;IAC/H,iBAAiB;IACjB;AACJ;;AAEA;IACI,oIAAoI;IACpI,8BAA8B;IAC9B,4BAA4B;IAC5B,qBAAqB;IACrB;AACJ;;AAEA;IACI,8HAA8H;IAC9H,sBAAsB;IACtB,gCAAgC;IAChC;AACJ;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,+HAA+H;IAC/H,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;IACZ;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI,SAAO;IACP,UAAU;IACV,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,cAAY;IACZ,QAAQ;IACR,YAAY;IAEZ,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,+CAA+C;IAC/C,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,uBAAuB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,cAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IAEb,gBAAgB;IAChB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB;AACJ;;AAEA;IACI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C,WAAW;IACX,WAAW;IACX;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,aAAa;IACb;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAO;IACP;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB;AACJ;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;IAC1B,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,sCAAsC;IACtC,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,4CAA4C;IAC5C;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAY;IACZ,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,kCAAkC;IAClC,sBAAsB;IACtB;AACJ;;AAEA;IACI,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB;AACJ;;AAEA;IACI,oDAAoD;IACpD,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,wBAAwB;IACxB,oCAAoC;IACpC,sBAAsB;IACtB;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,qCAAqC;IACrC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,kCAAkC;QAClC,sBAAsB;QACtB;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qCAAqC;QACrC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,qCAAqC;QACrC;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,UAAU;QACV;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,UAAU;QACV,uBAAuB;QACvB,uBAAuB;QACvB,cAAc;QACd,gBAAgB;QAChB,aAAa;QACb,UAAU;QACV;IACJ;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,uBAAuB;QACvB,uBAAuB;QACvB,cAAc;QACd,aAAa;QACb,eAAe;IACnB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI,yBAAyB;QACzB,uIAAuI;QACvI,uBAAuB;QACvB,4BAA4B;QAC5B;IACJ;;IAEA;QACI,eAAe;QACf,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,cAAY;QACZ,kBAAkB;QAClB,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kCAAkC;QAClC,2IAA2I;QAC3I,wBAAwB;QACxB,2BAA2B;QAC3B,2BAA2B;QAC3B,mBAAmB;QACnB,cAAc;QACd,cAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,wHAAwH;QACxH,wBAAwB;QACxB,4BAA4B;QAC5B,sBAAsB;QACtB,6BAA6B;QAC7B,mBAAmB;QACnB,UAAU;QACV,aAAa;QACb,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oCAAoC;QACpC,iBAAiB;QACjB,cAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB;IACJ;;IAEA;QACI,oCAAoC;QACpC,cAAY;QACZ,uBAAuB;QACvB,qBAAqB;QACrB,aAAa;QACb,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;QACrB;IACJ;;IAEA;QACI,oCAAoC;QACpC,cAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,kBAAkB;QAClB;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;QACb,aAAa;QACb;IACJ;;IAEA;QACI,cAAY;QACZ,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,UAAU;QACV,YAAY;QACZ;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uPAAuP;QACvP,6BAA6B;QAC7B,uCAAuC;QACvC,2BAA2B;QAC3B,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,0BAA0B;QAC1B,oIAAoI;QACpI,wBAAwB;QACxB,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;QACnB,OAAO;QACP,UAAU;QACV;IACJ;;IAEA;QACI,mBAAmB;QACnB,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QAEpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,6BAA6B;QAC7B,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,qCAAqC;QACrC,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,eAAe;QACf;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,+BAA+B;QAC/B,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,6BAA6B;QAC7B,8BAA8B;QAC9B,sBAAsB;QACtB,kBAAkB;QAClB;IACJ;;IAEA;QACI,gCAAgC;QAChC,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,qCAAqC;QACrC,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,6BAA6B;QAC7B,sCAAsC;QACtC,sBAAsB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,6BAA6B;QAC7B,0BAA0B;QAC1B,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;QACrB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,oBAAoB;QACpB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI;IACJ;;IAEA;QACI,SAAO;QACP,uBAAuB;QACvB,gBAAgB;QAChB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,yBAAyB;QACzB,6BAA6B;QAC7B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,uIAAuI;QACvI,wBAAwB;QACxB,sBAAsB;QACtB,wBAAwB;QACxB,8BAA8B;QAC9B,sBAAsB;QACtB,cAAc;QACd;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB,UAAU;QACV;IACJ;;IAEA;QACI,0CAA0C;QAC1C;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,6BAA6B;QAC7B,8BAA8B;QAC9B,sBAAsB;QACtB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,wBAAwB;QACxB,yBAAyB;QACzB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,aAAa;QACb;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB,mBAAmB;QACnB,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,yBAAyB;QACzB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,QAAQ;QACR,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,SAAO;QACP,QAAQ;QACR,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAO;QACP,QAAQ;QACR,UAAU;QACV,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,SAAO;QACP,QAAQ;QACR,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,yBAAyB;QACzB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;QACnB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,cAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,uBAAuB;QACvB;IACJ;;IAEA;QACI,cAAY;QACZ,QAAQ;QACR;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,cAAY;QACZ,QAAQ;QACR,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,cAAc;QACd;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;QACjB,uBAAuB;QACvB,uBAAuB;QACvB,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,8BAA8B;QAC9B,4BAA4B;QAC5B,qBAAqB;QACrB,gBAAgB;QAChB;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,yBAAyB;QACzB,uBAAuB;QACvB;IACJ;;IAEA;QACI,wBAAwB;QACxB,UAAU;QACV,gBAAgB;QAChB;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,mBAAmB;QACnB,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0CAA0C;QAC1C;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI,cAAY;QACZ,QAAQ;QACR,cAAc;QACd,kBAAkB;QAClB,OAAO;QACP,YAAY;QACZ,UAAU;QACV;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,mCAAmC;QACnC;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,eAAe;QACf,cAAc;QACd,cAAc;QACd;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf,0CAA0C;QAC1C,uBAAuB;QACvB;IACJ;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,SAAS;QACT,kBAAkB;QAClB;IACJ;;IAEA;QACI,SAAS;QACT,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI,sBAAsB;QACtB,uCAAuC;QACvC,0BAA0B;QAC1B;IACJ;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX,cAAc;QACd,cAAc;QACd;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,aAAa;QACb,aAAa;QACb,SAAS;QACT,UAAU;QACV,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf,wBAAwB;QACxB,8BAA8B;QAC9B,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,aAAa;QACb,cAAc;QACd,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;IACA;QACI,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB;;IAEJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,OAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,YAAY;QACZ;IACJ;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ;IACJ;;IAEA;QACI,UAAU;QACV,OAAO;QACP;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV,QAAQ;QACR;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,gBAAgB;QAChB,cAAc;QACd;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,8BAA8B;QAC9B,sBAAsB;QACtB,6BAA6B;QAC7B;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd;IACJ;;IAEA;QACI,sBAAsB;QACtB,cAAc;QACd;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,gCAAgC;QAChC;IACJ;;IAEA;QACI,2BAA2B;QAC3B,aAAa;QACb;IACJ;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;QAC3B,oBAAoB;QACpB;IACJ;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;QACzB;IACJ;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,cAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,cAAc;QACd,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;QACb;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,0BAA0B;QAC1B,sBAAsB;QACtB,8BAA8B;QAC9B,oBAAoB;QACpB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,mCAAmC;QACnC;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,kBAAkB;QAClB;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI,cAAc;QACd,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;QACb;IACJ;;IAEA;QACI,yBAAyB;QACzB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;;IAGA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oCAAoC;QACpC,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kCAAkC;QAClC,gCAAgC;QAChC,+BAA+B;QAC/B,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,kBAAkB;QAClB,iBAAiB;QACjB,wFAAwF;IAC5F;;IAEA;QACI,kCAAkC;QAClC,WAAW;QACX,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI,cAAc;QACd,gCAAgC;QAChC,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,8BAA8B;QAC9B,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB,2CAA2C;QAC3C;IACJ;;IAEA;QACI,wCAAwC;QACxC,WAAW;QACX,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,wCAAwC;QACxC,WAAW;QACX;IACJ;;IAEA;QACI,oCAAoC;QACpC,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,WAAW;QACX,eAAe;QACf,cAAc;QACd,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,gCAAgC;QAChC;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,8BAA8B;QAC9B;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,oBAAoB;QACpB,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,UAAU;QACV,2BAA2B;QAC3B,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;QAChB,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,SAAS;QACT;IACJ;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;QAC7B,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;QAC5B,WAAW;QACX,iBAAiB;QACjB,OAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC,mBAAmB;QACnB,sBAAsB;QACtB,8BAA8B;QAC9B,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,8BAA8B;QAC9B,sBAAsB;QACtB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,cAAc;QACd;IACJ;;IAEA;QACI,wCAAwC;QACxC,WAAW;QACX,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;IAEA;QACI,0CAA0C;QAC1C,aAAa;QACb,cAAc;QACd,eAAe;QACf;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,SAAO;QACP;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;;;;;QAKI;IACJ;;IAEA;QACI,WAAW;QACX,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;QACjB,kCAAkC;QAClC,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;QACvB,UAAU;QACV,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;QACtB,aAAa;QACb;IACJ;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB,kBAAkB;QAClB,yBAAyB;QACzB,sBAAsB;QACtB,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,aAAa;QACb,kBAAkB;QAClB,OAAO;QACP,UAAU;QACV,QAAQ;QACR,SAAS;QACT;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI,wCAAwC;QACxC,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,aAAa;QACb;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,wCAAwC;QACxC;IACJ;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB;IACJ;;IAEA;QACI,qCAAqC;QACrC,WAAW;QACX,WAAW;QACX,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;;QAEI,aAAa;QACb,qBAAqB;QACrB,kBAAkB;QAClB,yBAAyB;QACzB,sBAAsB;QACtB,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,aAAa;QACb,kBAAkB;QAClB,OAAO;QACP,UAAU;QACV,QAAQ;QACR,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAY;QACZ,QAAQ;QACR,gBAAgB;QAChB;IACJ;;IAEA;QACI,SAAO;QACP,UAAU;QACV;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,yBAAyB;QACzB,mBAAmB;QACnB,UAAU;QACV,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,gCAAgC;QAChC;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,SAAO;QACP,UAAU;QACV;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,yBAAyB;QACzB,mBAAmB;QACnB,UAAU;QACV,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,SAAO;QACP;IACJ;;IAEA;QACI,SAAO;QACP,UAAU;QACV,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,SAAO;QACP,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,SAAO;QACP;IACJ;;IAEA;;QAEI,SAAO;QACP;IACJ;;IAEA;;;QAGI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI,SAAO;QACP,UAAU;QACV,aAAa;QACb;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,SAAO;QACP,yBAAyB;QACzB,mBAAmB;QACnB,UAAU;QACV,aAAa;QACb,cAAc;QACd,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,eAAe;QACf,8BAA8B;QAC9B,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;QACb,aAAa;QACb;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qCAAqC;QACrC,kBAAkB;QAClB,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB,qBAAqB;QACrB,6BAA6B;QAC7B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,gBAAgB;QAChB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAY;QACZ,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,cAAc;QACd,cAAY;QACZ,0CAA0C;QAC1C,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,0BAA0B;QAC1B,+BAA+B;QAC/B,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb;IACJ;;IAEA;QACI,6BAA6B;QAC7B,gCAAgC;QAChC,+BAA+B;QAC/B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB,0BAA0B;QAC1B,uBAAuB;QACvB,uBAAuB;QACvB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB;IACJ;;IAEA;QACI,iBAAiB;QACjB,4BAA4B;QAC5B,sBAAsB;QACtB,sBAAsB;QACtB,kBAAkB;QAClB,qBAAqB;QACrB,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,kBAAkB;QAClB;IACJ;;IAEA;QACI,gCAAgC;QAChC,0CAA0C;QAC1C,mBAAmB;QACnB,eAAe;QACf,6BAA6B;QAC7B,mBAAmB;QACnB,gBAAgB;QAChB,aAAa;QACb,aAAa;QACb;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,wCAAwC;QACxC;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,cAAc;QACd,yBAAyB;QACzB,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;QAC9B,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;QACd,eAAe;QACf;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,8BAA8B;QAC9B,uBAAuB;QACvB,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,YAAY;QACZ,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,MAAM;QACN;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,eAAe;QACf,wBAAwB;QACxB,8BAA8B;QAC9B,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI,uBAAuB;QACvB,aAAa;QACb,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf;IACJ;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;QAC5B,oBAAoB;QAEpB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,kBAAkB;QAClB;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB,wBAAwB;QACxB,+BAA+B;QAC/B,sBAAsB;QACtB,sBAAsB;QACtB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,wBAAwB;QACxB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,cAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,eAAe;QACf,eAAe;QACf,aAAa;QACb,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,UAAU;QACV,OAAO;QACP,QAAQ;QACR;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;;IAEtB;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;;;QAMI,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;QAGI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,cAAc;QACd,2BAA2B;QAC3B,mBAAmB;QACnB,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf,+BAA+B;QAC/B,8CAA8C;QAC9C,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,SAAS;QACT,SAAS;QACT,SAAS;QACT;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,SAAS;QACT,UAAU;QACV;IACJ;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;QAClB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,qBAAqB;QACrB,uBAAuB;QACvB;IACJ;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB;IACJ;;IAEA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,oBAAoB;QACpB,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,SAAO;QACP;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,SAAO;QACP,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,SAAO;QACP,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,SAAO;QACP,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kCAAkC;QAClC,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4BAA4B;QAC5B,6BAA6B;QAC7B,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;QACvB;IACJ;;IAEA;QACI,cAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,oBAAoB;IACxB;;IAEA;QACI,cAAY;QACZ,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,qBAAqB;QACrB,kCAAkC;QAClC;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,gBAAgB;QAChB,YAAY;QACZ,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,8BAA8B;QAC9B,iBAAiB;QACjB,cAAY;QACZ,QAAQ;QACR,uBAAuB;QACvB,gBAAgB;QAChB,uBAAuB;QACvB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kCAAkC;QAClC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;QAC/B,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,2BAA2B;QAC3B,kBAAkB;QAClB,uBAAuB;QACvB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,sBAAsB;QACtB;IACJ;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAE9B,qBAAqB;QACrB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,8BAA8B;QAC9B,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qCAAqC;QACrC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;QAClB,4BAA4B;QAC5B,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,8BAA8B;QAC9B,2BAA2B;QAC3B,uBAAuB;QACvB;IACJ;;IAEA;QACI,eAAe;QACf,2BAA2B;QAC3B;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,kCAAkC;QAClC,sBAAsB;QACtB,gBAAgB;QAChB,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,eAAe;QACf,uBAAuB;QACvB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,QAAQ;QACR;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,kCAAkC;QAClC,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,8BAA8B;QAC9B,mBAAmB;QACnB,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,WAAW;QACX,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,2BAA2B;QAC3B,kBAAkB;QAClB,aAAa;QACb,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,6BAA6B;QAC7B,8BAA8B;QAC9B,sBAAsB;QACtB;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,aAAa;QACb,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI,aAAa;QACb,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,uBAAuB;QACvB,WAAW;QACX,cAAc;QACd;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,sBAAsB;QACtB,8BAA8B;QAC9B;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI,mBAAmB;QACnB,cAAY;QACZ,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;QAC3B,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0CAA0C;QAC1C;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,4CAA4C;QAC5C;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yCAAyC;QACzC;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAElB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,oBAAoB;QACpB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,8BAA8B;QAC9B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,UAAU;QACV,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,0BAA0B;QAC1B,sBAAsB;QACtB,2BAA2B;QAC3B,uBAAuB;QACvB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,aAAa;QACb,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,8BAA8B;QAC9B,+HAA+H;QAC/H,4BAA4B;QAC5B,sBAAsB;QACtB,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB,gCAAgC;QAChC;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,aAAa;QACb,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0CAA0C;QAC1C;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;QACpB;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,cAAY;QACZ;IACJ;;IAEA;QACI,eAAe;QACf,cAAY;QACZ,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QAEI;IACJ;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,0BAA0B;QAC1B;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ,gCAAgC;QAChC,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,2GAA2G;QAC3G;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8FAA8F;QAC9F;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,wBAAwB;QACxB,0BAA0B;QAC1B,sBAAsB;QACtB,2BAA2B;QAC3B,aAAa;QACb;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,0BAA0B;QAC1B,cAAc;QACd;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,uBAAuB;QACvB;IACJ;;IAEA;QACI,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI,qFAAqF;QACrF,4BAA4B;QAC5B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,uBAAuB;QACvB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,6BAA6B;QAC7B,wBAAwB;QACxB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,YAAY;QACZ,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,+BAA+B;QAC/B,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB,eAAe;QACf,qBAAqB;QACrB,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ,cAAc;QACd;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;QACrB;IACJ;;IAEA;QACI,eAAe;QACf,SAAS;QACT,UAAU;QACV,QAAQ;QACR;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;QAC1B;IACJ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mCAAmC;QACnC,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;QACI,YAAY;QACZ,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,QAAQ;QACR;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;;QAEI,gBAAgB;QAChB;IACJ;;IAEA;;QAEI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf,wBAAwB;QACxB,0BAA0B;QAC1B,sBAAsB;QACtB,yBAAyB;QACzB,oBAAoB;QACpB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,oBAAoB;QACpB,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;;;;QAII,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;QACjB,wBAAwB;QACxB,kCAAkC;QAClC,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QAEI,qCAAqC;QACrC;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,yBAAyB;QACzB,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,4BAA4B;QAC5B,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,0BAA0B;QAC1B,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,aAAa;QACb,WAAW;QACX,UAAU;QACV;IACJ;;IAEA;QACI,cAAY;QACZ,QAAQ;QACR,gBAAgB;QAChB,SAAS;QACT;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;QAClB,OAAO;QACP,YAAY;QACZ,OAAO;QACP,QAAQ;QACR;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,2BAA2B;QAC3B,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,sEAAsE;QACtE;IACJ;;IAEA;QACI,0BAA0B;QAC1B,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,+HAA+H;QAC/H,wBAAwB;QACxB,4BAA4B;QAC5B,sBAAsB;QACtB,oBAAoB;QACpB,WAAW;QACX,YAAY;QACZ,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QAEb,gBAAgB;QAChB;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,kBAAkB;QAClB,wBAAwB;QACxB,oCAAoC;QACpC,sBAAsB;QACtB,wBAAwB;QACxB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;;;;;;;QAOI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb;IACJ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,oBAAoB;QACpB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,SAAS;QACT,aAAa;QACb;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;;IAGA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;QACnB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;;;;;;;;QAQI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,eAAe;QACf,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,aAAa;QACb;IACJ;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ,SAAS;QACT,SAAS;QACT;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,SAAS;QACT,YAAY;QACZ;IACJ;;IAEA;QACI,SAAO;QACP,cAAc;QACd;IACJ;;IAEA;QACI,cAAY;QACZ,SAAS;QACT;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB;IACJ;;IAEA;QACI,sBAAsB;QACtB,wBAAwB;QACxB,yBAAyB;QACzB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,cAAc;QACd,2BAA2B;QAC3B,mBAAmB;QACnB,gCAAgC;QAChC,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,gBAAgB;QAChB;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,qBAAqB;QACrB,uBAAuB;QACvB;IACJ;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB;IACJ;;IAEA;QACI,SAAS;QACT,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,iJAAiJ;QACjJ,SAAS;QACT;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,oBAAoB;QACpB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,oBAAoB;QACpB;IACJ;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,iBAAiB;QACjB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB;IACJ;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;;QAGI,qBAAqB;QACrB;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB;IACJ;;IAEA;;QAEI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf,mCAAmC;QACnC,WAAW;QACX,cAAc;QACd,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,cAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,yBAAyB;QACzB,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,mBAAmB;QACnB,SAAO;QACP;IACJ;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,SAAO;QACP,SAAS;QACT,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,SAAS;QACT,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,SAAO;QACP,SAAS;QACT,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,iJAAiJ;QACjJ,SAAS;QACT;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,oBAAoB;QACpB;IACJ;;IAEA;;;QAGI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI,SAAS;QACT,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,iJAAiJ;QACjJ,SAAS;QACT;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX,oBAAoB;QACpB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,SAAS;QACT,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,SAAO;QACP,SAAS;QACT,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB,iJAAiJ;QACjJ,SAAS;QACT;IACJ;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,uBAAuB;QACvB,qBAAqB;QACrB,WAAW;QACX,aAAa;QACb,iBAAiB;QACjB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,8BAA8B;QAC9B;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,cAAc;QACd;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB;IACJ;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;;QAEI,gBAAgB;QAChB,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,wCAAwC;QACxC,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gCAAgC;QAChC,+BAA+B;QAC/B,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;;QAEI,kBAAkB;QAClB;IACJ;;IAEA;QACI,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,8CAA8C;QAC9C,qBAAqB;QACrB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB,iBAAiB;QACjB,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B,mBAAmB;QACnB;IACJ;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;QACf;IACJ;;IAEA;QACI,gBAAgB;QAChB,cAAY;QACZ,QAAQ;QACR,gBAAgB;QAChB,WAAW;QACX,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,0BAA0B;QAC1B,mBAAmB;QACnB;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI,iBAAiB;QACjB,0BAA0B;QAC1B,8BAA8B;QAC9B;IACJ;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,cAAc;QACd,2BAA2B;QAC3B,uBAAuB;QACvB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,2BAA2B;QAC3B,mBAAmB;QACnB,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB;IACJ;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;QACjB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,gCAAgC;QAChC;IACJ;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,WAAW;QACX,aAAa;QACb;IACJ;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;IAaI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAkCI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAsDI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2CI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAgCI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAwDI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;IAsBI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;IAgBI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;IAeI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;IAeI;AACJ;;AAEA;;;;;IAKI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;IAqBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;;IAgBI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;IAqBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;IAeI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;IAmBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;;;;;;;;IAaI,QAAQ;IACR,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,sCAAsC;IACtC,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;IAsBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB;AACJ;;AAEA;;IAEI,kBAAkB;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAiCI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;IAqBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;IAwBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;IAUI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;IAeI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;IAoBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;IAyBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;;;;;IAkBI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAoEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAqDI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;IAMI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2DI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAsDI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2DI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAuDI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2DI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA2DI;AACJ;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;IAClB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;;;;IAYI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAqDI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;;;;;IAKI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;;;;;;IAOI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;;;;;IAMI,gBAAgB;IAChB;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;;;;;;;;IASI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;;;;;;;IAcI,gBAAgB;IAChB;AACJ;;AAEA;;;;;;;;;;;IAWI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;;;IAQI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;;;;IAqBI;AACJ;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;;;IAII;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,kBAAkB;IAClB;AACJ;;AAEA;;;;;;;;;;;;;;;;;;IAkBI,kBAAkB;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;QAgII;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;;;;;;;;QASI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;QAII;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;;QAKI;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,iBAAiB;QACjB;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;;;;;;;QAUI;IACJ;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB,4XAA4X;IAC5X,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,2oBAA2oB;IAC3oB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,4XAA4X;IAC5X,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,8YAA8Y;IAC9Y,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,8YAA8Y;IAC9Y,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,2YAA2Y;IAC3Y,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iZAAiZ;IACjZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,+XAA+X;IAC/X,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,kYAAkY;IAClY,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,mQAAmQ;IACnQ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,+SAA+S;IAC/S,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,qSAAqS;IACrS,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,4PAA4P;IAC5P,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,+HAA+H;IAC/H,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,oIAAoI;IACpI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,iIAAiI;IACjI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kIAAkI;IAClI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,gIAAgI;IAChI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mIAAmI;IACnI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,mJAAmJ;IACnJ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,2IAA2I;IAC3I,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iJAAiJ;IACjJ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,2IAA2I;IAC3I,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iJAAiJ;IACjJ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gJAAgJ;IAChJ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,6IAA6I;IAC7I,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gJAAgJ;IAChJ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,2IAA2I;IAC3I,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,6IAA6I;IAC7I,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,2IAA2I;IAC3I,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gJAAgJ;IAChJ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":["html {\n    -webkit-text-size-adjust: 100%;\n    -ms-text-size-adjust: 100%;\n    font-family: sans-serif\n}\n\n.mackinacpro {\n    font-family: P22 Mackinacpro, sans-serif;\n}\n\nbody {\n    margin: 0\n}\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n    display: block\n}\n\naudio,\ncanvas,\nprogress,\nvideo {\n    vertical-align: baseline;\n    display: inline-block\n}\n\naudio:not([controls]) {\n    height: 0;\n    display: none\n}\n\n[hidden],\ntemplate {\n    display: none\n}\n\na {\n    background-color: transparent\n}\n\na:active,\na:hover {\n    outline: 0\n}\n\nabbr[title] {\n    border-bottom: 1px dotted\n}\n\nb,\nstrong {\n    font-weight: 700\n}\n\ndfn {\n    font-style: italic\n}\n\nh1 {\n    margin: .67em 0;\n    font-size: 2em\n}\n\nmark {\n    color: #000;\n    background: #ff0\n}\n\nsmall {\n    font-size: 80%\n}\n\nsub,\nsup {\n    vertical-align: baseline;\n    font-size: 75%;\n    line-height: 0;\n    position: relative\n}\n\nsup {\n    top: -.5em\n}\n\nsub {\n    bottom: -.25em\n}\n\nimg {\n    border: 0\n}\n\nsvg:not(:root) {\n    overflow: hidden\n}\n\nhr {\n    box-sizing: content-box;\n    height: 0\n}\n\npre {\n    overflow: auto\n}\n\ncode,\nkbd,\npre,\nsamp {\n    font-family: monospace;\n    font-size: 1em\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n    color: inherit;\n    font: inherit;\n    margin: 0\n}\n\nbutton {\n    overflow: visible\n}\n\nbutton,\nselect {\n    text-transform: none\n}\n\nbutton,\nhtml input[type=button],\ninput[type=reset] {\n    -webkit-appearance: button;\n    cursor: pointer\n}\n\nbutton[disabled],\nhtml input[disabled] {\n    cursor: default\n}\n\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n    border: 0;\n    padding: 0\n}\n\ninput {\n    line-height: normal\n}\n\ninput[type=checkbox],\ninput[type=radio] {\n    box-sizing: border-box;\n    padding: 0\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n    height: auto\n}\n\ninput[type=search] {\n    -webkit-appearance: none\n}\n\ninput[type=search]::-webkit-search-cancel-button,\ninput[type=search]::-webkit-search-decoration {\n    -webkit-appearance: none\n}\n\nlegend {\n    border: 0;\n    padding: 0\n}\n\ntextarea {\n    overflow: auto\n}\n\noptgroup {\n    font-weight: 700\n}\n\ntable {\n    border-collapse: collapse;\n    border-spacing: 0\n}\n\ntd,\nth {\n    padding: 0\n}\n\n@font-face {\n    font-family: webflow-icons;\n    src: url(data:application/x-font-ttf;charset=utf-8;base64,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)format(\"truetype\");\n    font-weight: 400;\n    font-style: normal;\n}\n\n[class^=w-icon-],\n[class*=\\ w-icon-] {\n    speak: none;\n    font-variant: normal;\n    text-transform: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1;\n    font-family: webflow-icons !important\n}\n\n.w-icon-slider-right:before {\n    content: \"î˜€\"\n}\n\n.w-icon-slider-left:before {\n    content: \"î˜\"\n}\n\n.w-icon-nav-menu:before {\n    content: \"î˜‚\"\n}\n\n.w-icon-arrow-down:before,\n.w-icon-dropdown-toggle:before {\n    content: \"î˜ƒ\"\n}\n\n.w-icon-file-upload-remove:before {\n    content: \"î¤€\"\n}\n\n.w-icon-file-upload-icon:before {\n    content: \"î¤ƒ\"\n}\n\n* {\n    box-sizing: border-box\n}\n\nhtml {\n    height: 100%\n}\n\nbody {\n    color: #333;\n    background-color: #fff;\n    min-height: 100%;\n    margin: 0;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    line-height: 20px\n}\n\nimg {\n    vertical-align: middle;\n    max-width: 100%;\n    display: inline-block\n}\n\nhtml.w-mod-touch * {\n    background-attachment: scroll !important\n}\n\n.w-block {\n    display: block\n}\n\n.w-inline-block {\n    max-width: 100%;\n    display: inline-block\n}\n\n.w-clearfix:before,\n.w-clearfix:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-clearfix:after {\n    clear: both\n}\n\n.w-hidden {\n    display: none\n}\n\n.w-button {\n    color: #fff;\n    line-height: inherit;\n    cursor: pointer;\n    background-color: #3898ec;\n    border: 0;\n    border-radius: 0;\n    padding: 9px 15px;\n    text-decoration: none;\n    display: inline-block\n}\n\ninput.w-button {\n    -webkit-appearance: button\n}\n\nhtml[data-w-dynpage] [data-w-cloak] {\n    color: transparent !important\n}\n\n.w-code-block {\n    margin: unset\n}\n\npre.w-code-block code {\n    all: inherit\n}\n\n.w-webflow-badge,\n.w-webflow-badge * {\n    z-index: auto;\n    visibility: visible;\n    box-sizing: border-box;\n    float: none;\n    clear: none;\n    box-shadow: none;\n    opacity: 1;\n    direction: ltr;\n    font-family: inherit;\n    font-weight: inherit;\n    color: inherit;\n    font-size: inherit;\n    line-height: inherit;\n    font-style: inherit;\n    font-variant: inherit;\n    text-align: inherit;\n    letter-spacing: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n    text-indent: 0;\n    text-transform: inherit;\n    text-shadow: none;\n    font-smoothing: auto;\n    vertical-align: baseline;\n    cursor: inherit;\n    white-space: inherit;\n    word-break: normal;\n    word-spacing: normal;\n    word-wrap: normal;\n    background: 0 0;\n    border: 0 transparent;\n    border-radius: 0;\n    width: auto;\n    min-width: 0;\n    max-width: none;\n    height: auto;\n    min-height: 0;\n    max-height: none;\n    margin: 0;\n    padding: 0;\n    list-style-type: disc;\n    transition: none;\n    display: block;\n    position: static;\n    top: auto;\n    bottom: auto;\n    left: auto;\n    right: auto;\n    overflow: visible;\n    transform: none\n}\n\n.w-webflow-badge {\n    white-space: nowrap;\n    cursor: pointer;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, .1), 0 1px 3px rgba(0, 0, 0, .1);\n    visibility: visible !important;\n    z-index: 2147483647 !important;\n    color: #aaadb0 !important;\n    opacity: 1 !important;\n    background-color: #fff !important;\n    border-radius: 3px !important;\n    width: auto !important;\n    height: auto !important;\n    margin: 0 !important;\n    padding: 6px !important;\n    font-size: 12px !important;\n    line-height: 14px !important;\n    text-decoration: none !important;\n    display: inline-block !important;\n    position: fixed !important;\n    top: auto !important;\n    bottom: 12px !important;\n    left: auto !important;\n    right: 12px !important;\n    overflow: visible !important;\n    transform: none !important\n}\n\n.w-webflow-badge>img {\n    visibility: visible !important;\n    opacity: 1 !important;\n    vertical-align: middle !important;\n    display: inline-block !important\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin-bottom: 10px;\n    font-weight: 700\n}\n\nh1 {\n    margin-top: 20px;\n    font-size: 38px;\n    line-height: 44px\n}\n\nh2 {\n    margin-top: 20px;\n    font-size: 32px;\n    line-height: 36px\n}\n\nh3 {\n    margin-top: 20px;\n    font-size: 24px;\n    line-height: 30px\n}\n\nh4 {\n    margin-top: 10px;\n    font-size: 18px;\n    line-height: 24px\n}\n\nh5 {\n    margin-top: 10px;\n    font-size: 14px;\n    line-height: 20px\n}\n\nh6 {\n    margin-top: 10px;\n    font-size: 12px;\n    line-height: 18px\n}\n\np {\n    margin-top: 0;\n    margin-bottom: 10px\n}\n\nblockquote {\n    border-left: 5px solid #e2e2e2;\n    margin: 0 0 10px;\n    padding: 10px 20px;\n    font-size: 18px;\n    line-height: 22px\n}\n\nfigure {\n    margin: 0 0 10px\n}\n\nul,\nol {\n    margin-top: 0;\n    margin-bottom: 10px;\n    padding-left: 40px\n}\n\n.w-list-unstyled {\n    padding-left: 0;\n    list-style: none\n}\n\n.w-embed:before,\n.w-embed:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-embed:after {\n    clear: both\n}\n\n.w-video {\n    width: 100%;\n    padding: 0;\n    position: relative\n}\n\n.w-video iframe,\n.w-video object,\n.w-video embed {\n    border: none;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0\n}\n\nfieldset {\n    border: 0;\n    margin: 0;\n    padding: 0\n}\n\nbutton,\n[type=button],\n[type=reset] {\n    cursor: pointer;\n    -webkit-appearance: button;\n    border: 0\n}\n\n.w-form {\n    margin: 0 0 15px\n}\n\n.w-form-done {\n    text-align: center;\n    background-color: #ddd;\n    padding: 20px;\n    display: none\n}\n\n.w-form-fail {\n    background-color: #ffdede;\n    margin-top: 10px;\n    padding: 10px;\n    display: none\n}\n\nlabel {\n    margin-bottom: 5px;\n    font-weight: 700;\n    display: block\n}\n\n.w-input,\n.w-select {\n    color: #333;\n    vertical-align: middle;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    width: 100%;\n    height: 38px;\n    margin-bottom: 10px;\n    padding: 8px 12px;\n    font-size: 14px;\n    line-height: 1.42857;\n    display: block\n}\n\n.w-input:-moz-placeholder,\n.w-select:-moz-placeholder {\n    color: #999\n}\n\n.w-input::-moz-placeholder,\n.w-select::-moz-placeholder {\n    color: #999;\n    opacity: 1\n}\n\n.w-input::-webkit-input-placeholder,\n.w-select::-webkit-input-placeholder {\n    color: #999\n}\n\n.w-input:focus,\n.w-select:focus {\n    border-color: #3898ec;\n    outline: 0\n}\n\n.w-input[disabled],\n.w-select[disabled],\n.w-input[readonly],\n.w-select[readonly],\nfieldset[disabled] .w-input,\nfieldset[disabled] .w-select {\n    cursor: not-allowed\n}\n\n.w-input[disabled]:not(.w-input-disabled),\n.w-select[disabled]:not(.w-input-disabled),\n.w-input[readonly],\n.w-select[readonly],\nfieldset[disabled]:not(.w-input-disabled) .w-input,\nfieldset[disabled]:not(.w-input-disabled) .w-select {\n    background-color: #eee\n}\n\ntextarea.w-input,\ntextarea.w-select {\n    height: auto\n}\n\n.w-select {\n    background-color: #f3f3f3\n}\n\n.w-select[multiple] {\n    height: auto\n}\n\n.w-form-label {\n    cursor: pointer;\n    margin-bottom: 0;\n    font-weight: 400;\n    display: inline-block\n}\n\n.w-radio {\n    margin-bottom: 5px;\n    padding-left: 20px;\n    display: block\n}\n\n.w-radio:before,\n.w-radio:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-radio:after {\n    clear: both\n}\n\n.w-radio-input {\n    float: left;\n    margin: 3px 0 0 -20px;\n    line-height: normal\n}\n\n.w-file-upload {\n    margin-bottom: 10px;\n    display: block\n}\n\n.w-file-upload-input {\n    opacity: 0;\n    z-index: -100;\n    width: .1px;\n    height: .1px;\n    position: absolute;\n    overflow: hidden\n}\n\n.w-file-upload-default,\n.w-file-upload-uploading,\n.w-file-upload-success {\n    color: #333;\n    display: inline-block\n}\n\n.w-file-upload-error {\n    margin-top: 10px;\n    display: block\n}\n\n.w-file-upload-default.w-hidden,\n.w-file-upload-uploading.w-hidden,\n.w-file-upload-error.w-hidden,\n.w-file-upload-success.w-hidden {\n    display: none\n}\n\n.w-file-upload-uploading-btn {\n    cursor: pointer;\n    background-color: #fafafa;\n    border: 1px solid #ccc;\n    margin: 0;\n    padding: 8px 12px;\n    font-size: 14px;\n    font-weight: 400;\n    display: flex\n}\n\n.w-file-upload-file {\n    background-color: #fafafa;\n    border: 1px solid #ccc;\n    flex-grow: 1;\n    justify-content: space-between;\n    margin: 0;\n    padding: 8px 9px 8px 11px;\n    display: flex\n}\n\n.w-file-upload-file-name {\n    font-size: 14px;\n    font-weight: 400;\n    display: block\n}\n\n.w-file-remove-link {\n    cursor: pointer;\n    width: auto;\n    height: auto;\n    margin-top: 3px;\n    margin-left: 10px;\n    padding: 3px;\n    display: block\n}\n\n.w-icon-file-upload-remove {\n    margin: auto;\n    font-size: 10px\n}\n\n.w-file-upload-error-msg {\n    color: #ea384c;\n    padding: 2px 0;\n    display: inline-block\n}\n\n.w-file-upload-info {\n    padding: 0 12px;\n    line-height: 38px;\n    display: inline-block\n}\n\n.w-file-upload-label {\n    cursor: pointer;\n    background-color: #fafafa;\n    border: 1px solid #ccc;\n    margin: 0;\n    padding: 8px 12px;\n    font-size: 14px;\n    font-weight: 400;\n    display: inline-block\n}\n\n.w-icon-file-upload-icon,\n.w-icon-file-upload-uploading {\n    width: 20px;\n    margin-right: 8px;\n    display: inline-block\n}\n\n.w-icon-file-upload-uploading {\n    height: 20px\n}\n\n.w-container {\n    max-width: 940px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.w-container:before,\n.w-container:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-container:after {\n    clear: both\n}\n\n.w-container .w-row {\n    margin-left: -10px;\n    margin-right: -10px\n}\n\n.w-row:before,\n.w-row:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-row:after {\n    clear: both\n}\n\n.w-row .w-row {\n    margin-left: 0;\n    margin-right: 0\n}\n\n.w-col {\n    float: left;\n    width: 100%;\n    min-height: 1px;\n    padding-left: 10px;\n    padding-right: 10px;\n    position: relative\n}\n\n.w-col .w-col {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.w-col-1 {\n    width: 8.33333%\n}\n\n.w-col-2 {\n    width: 16.6667%\n}\n\n.w-col-3 {\n    width: 25%\n}\n\n.w-col-4 {\n    width: 33.3333%\n}\n\n.w-col-5 {\n    width: 41.6667%\n}\n\n.w-col-6 {\n    width: 50%\n}\n\n.w-col-7 {\n    width: 58.3333%\n}\n\n.w-col-8 {\n    width: 66.6667%\n}\n\n.w-col-9 {\n    width: 75%\n}\n\n.w-col-10 {\n    width: 83.3333%\n}\n\n.w-col-11 {\n    width: 91.6667%\n}\n\n.w-col-12 {\n    width: 100%\n}\n\n.w-hidden-main {\n    display: none !important\n}\n\n@media screen and (max-width:991px) {\n    .w-container {\n        max-width: 728px\n    }\n\n    .w-hidden-main {\n        display: inherit !important\n    }\n\n    .w-hidden-medium {\n        display: none !important\n    }\n\n    .w-col-medium-1 {\n        width: 8.33333%\n    }\n\n    .w-col-medium-2 {\n        width: 16.6667%\n    }\n\n    .w-col-medium-3 {\n        width: 25%\n    }\n\n    .w-col-medium-4 {\n        width: 33.3333%\n    }\n\n    .w-col-medium-5 {\n        width: 41.6667%\n    }\n\n    .w-col-medium-6 {\n        width: 50%\n    }\n\n    .w-col-medium-7 {\n        width: 58.3333%\n    }\n\n    .w-col-medium-8 {\n        width: 66.6667%\n    }\n\n    .w-col-medium-9 {\n        width: 75%\n    }\n\n    .w-col-medium-10 {\n        width: 83.3333%\n    }\n\n    .w-col-medium-11 {\n        width: 91.6667%\n    }\n\n    .w-col-medium-12 {\n        width: 100%\n    }\n\n    .w-col-stack {\n        width: 100%;\n        left: auto;\n        right: auto\n    }\n}\n\n@media screen and (max-width:767px) {\n\n    .w-hidden-main,\n    .w-hidden-medium {\n        display: inherit !important\n    }\n\n    .w-hidden-small {\n        display: none !important\n    }\n\n    .w-row,\n    .w-container .w-row {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .w-col {\n        width: 100%;\n        left: auto;\n        right: auto\n    }\n\n    .w-col-small-1 {\n        width: 8.33333%\n    }\n\n    .w-col-small-2 {\n        width: 16.6667%\n    }\n\n    .w-col-small-3 {\n        width: 25%\n    }\n\n    .w-col-small-4 {\n        width: 33.3333%\n    }\n\n    .w-col-small-5 {\n        width: 41.6667%\n    }\n\n    .w-col-small-6 {\n        width: 50%\n    }\n\n    .w-col-small-7 {\n        width: 58.3333%\n    }\n\n    .w-col-small-8 {\n        width: 66.6667%\n    }\n\n    .w-col-small-9 {\n        width: 75%\n    }\n\n    .w-col-small-10 {\n        width: 83.3333%\n    }\n\n    .w-col-small-11 {\n        width: 91.6667%\n    }\n\n    .w-col-small-12 {\n        width: 100%\n    }\n}\n\n@media screen and (max-width:479px) {\n    .w-container {\n        max-width: none\n    }\n\n    .w-hidden-main,\n    .w-hidden-medium,\n    .w-hidden-small {\n        display: inherit !important\n    }\n\n    .w-hidden-tiny {\n        display: none !important\n    }\n\n    .w-col {\n        width: 100%\n    }\n\n    .w-col-tiny-1 {\n        width: 8.33333%\n    }\n\n    .w-col-tiny-2 {\n        width: 16.6667%\n    }\n\n    .w-col-tiny-3 {\n        width: 25%\n    }\n\n    .w-col-tiny-4 {\n        width: 33.3333%\n    }\n\n    .w-col-tiny-5 {\n        width: 41.6667%\n    }\n\n    .w-col-tiny-6 {\n        width: 50%\n    }\n\n    .w-col-tiny-7 {\n        width: 58.3333%\n    }\n\n    .w-col-tiny-8 {\n        width: 66.6667%\n    }\n\n    .w-col-tiny-9 {\n        width: 75%\n    }\n\n    .w-col-tiny-10 {\n        width: 83.3333%\n    }\n\n    .w-col-tiny-11 {\n        width: 91.6667%\n    }\n\n    .w-col-tiny-12 {\n        width: 100%\n    }\n}\n\n.w-widget {\n    position: relative\n}\n\n.w-widget-map {\n    width: 100%;\n    height: 400px\n}\n\n.w-widget-map label {\n    width: auto;\n    display: inline\n}\n\n.w-widget-map img {\n    max-width: inherit\n}\n\n.w-widget-map .gm-style-iw {\n    text-align: center\n}\n\n.w-widget-map .gm-style-iw>button {\n    display: none !important\n}\n\n.w-widget-twitter {\n    overflow: hidden\n}\n\n.w-widget-twitter-count-shim {\n    vertical-align: top;\n    text-align: center;\n    background: #fff;\n    border: 1px solid #758696;\n    border-radius: 3px;\n    width: 28px;\n    height: 20px;\n    display: inline-block;\n    position: relative\n}\n\n.w-widget-twitter-count-shim * {\n    pointer-events: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\n.w-widget-twitter-count-shim .w-widget-twitter-count-inner {\n    text-align: center;\n    color: #999;\n    font-family: serif;\n    font-size: 15px;\n    line-height: 12px;\n    position: relative\n}\n\n.w-widget-twitter-count-shim .w-widget-twitter-count-clear {\n    display: block;\n    position: relative\n}\n\n.w-widget-twitter-count-shim.w--large {\n    width: 36px;\n    height: 28px\n}\n\n.w-widget-twitter-count-shim.w--large .w-widget-twitter-count-inner {\n    font-size: 18px;\n    line-height: 18px\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical) {\n    margin-left: 5px;\n    margin-right: 8px\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical).w--large {\n    margin-left: 6px\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical):before,\n.w-widget-twitter-count-shim:not(.w--vertical):after {\n    content: \" \";\n    pointer-events: none;\n    border: solid transparent;\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 50%;\n    left: 0\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical):before {\n    border-width: 4px;\n    border-color: rgba(117, 134, 150, 0) #5d6c7b rgba(117, 134, 150, 0) rgba(117, 134, 150, 0);\n    margin-top: -4px;\n    margin-left: -9px\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical).w--large:before {\n    border-width: 5px;\n    margin-top: -5px;\n    margin-left: -10px\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical):after {\n    border-width: 4px;\n    border-color: rgba(255, 255, 255, 0) #fff rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);\n    margin-top: -4px;\n    margin-left: -8px\n}\n\n.w-widget-twitter-count-shim:not(.w--vertical).w--large:after {\n    border-width: 5px;\n    margin-top: -5px;\n    margin-left: -9px\n}\n\n.w-widget-twitter-count-shim.w--vertical {\n    width: 61px;\n    height: 33px;\n    margin-bottom: 8px\n}\n\n.w-widget-twitter-count-shim.w--vertical:before,\n.w-widget-twitter-count-shim.w--vertical:after {\n    content: \" \";\n    pointer-events: none;\n    border: solid transparent;\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 100%;\n    left: 50%\n}\n\n.w-widget-twitter-count-shim.w--vertical:before {\n    border-width: 5px;\n    border-color: #5d6c7b rgba(117, 134, 150, 0) rgba(117, 134, 150, 0);\n    margin-left: -5px\n}\n\n.w-widget-twitter-count-shim.w--vertical:after {\n    border-width: 4px;\n    border-color: #fff rgba(255, 255, 255, 0) rgba(255, 255, 255, 0);\n    margin-left: -4px\n}\n\n.w-widget-twitter-count-shim.w--vertical .w-widget-twitter-count-inner {\n    font-size: 18px;\n    line-height: 22px\n}\n\n.w-widget-twitter-count-shim.w--vertical.w--large {\n    width: 76px\n}\n\n.w-background-video {\n    color: #fff;\n    height: 500px;\n    position: relative;\n    overflow: hidden\n}\n\n.w-background-video>video {\n    object-fit: cover;\n    z-index: -100;\n    background-position: 50%;\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    position: absolute;\n    top: -100%;\n    bottom: -100%;\n    left: -100%;\n    right: -100%\n}\n\n.w-background-video>video::-webkit-media-controls-start-playback-button {\n    -webkit-appearance: none;\n    display: none !important\n}\n\n.w-background-video--control {\n    background-color: transparent;\n    padding: 0;\n    position: absolute;\n    bottom: 1em;\n    right: 1em\n}\n\n.w-background-video--control>[hidden] {\n    display: none !important\n}\n\n.w-slider {\n    text-align: center;\n    clear: both;\n    -webkit-tap-highlight-color: transparent;\n    tap-highlight-color: transparent;\n    background: #ddd;\n    height: 300px;\n    position: relative\n}\n\n.w-slider-mask {\n    z-index: 1;\n    white-space: nowrap;\n    height: 100%;\n    display: block;\n    position: relative;\n    left: 0;\n    right: 0;\n    overflow: hidden\n}\n\n.w-slide {\n    vertical-align: top;\n    white-space: normal;\n    text-align: left;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n    position: relative\n}\n\n.w-slider-nav {\n    z-index: 2;\n    text-align: center;\n    -webkit-tap-highlight-color: transparent;\n    tap-highlight-color: transparent;\n    height: 40px;\n    margin: auto;\n    padding-top: 10px;\n    position: absolute;\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0\n}\n\n.w-slider-nav.w-round>div {\n    border-radius: 100%\n}\n\n.w-slider-nav.w-num>div {\n    font-size: inherit;\n    line-height: inherit;\n    width: auto;\n    height: auto;\n    padding: .2em .5em\n}\n\n.w-slider-nav.w-shadow>div {\n    box-shadow: 0 0 3px rgba(51, 51, 51, .4)\n}\n\n.w-slider-nav-invert {\n    color: #fff\n}\n\n.w-slider-nav-invert>div {\n    background-color: rgba(34, 34, 34, .4)\n}\n\n.w-slider-nav-invert>div.w-active {\n    background-color: #222\n}\n\n.w-slider-dot {\n    cursor: pointer;\n    background-color: rgba(255, 255, 255, .4);\n    width: 1em;\n    height: 1em;\n    margin: 0 3px .5em;\n    transition: background-color .1s, color .1s;\n    display: inline-block;\n    position: relative\n}\n\n.w-slider-dot.w-active {\n    background-color: #fff\n}\n\n.w-slider-dot:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px #fff\n}\n\n.w-slider-dot:focus.w-active {\n    box-shadow: none\n}\n\n.w-slider-arrow-left,\n.w-slider-arrow-right {\n    cursor: pointer;\n    color: #fff;\n    -webkit-tap-highlight-color: transparent;\n    tap-highlight-color: transparent;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    width: 80px;\n    margin: auto;\n    font-size: 40px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: hidden\n}\n\n.w-slider-arrow-left [class^=w-icon-],\n.w-slider-arrow-right [class^=w-icon-],\n.w-slider-arrow-left [class*=\\ w-icon-],\n.w-slider-arrow-right [class*=\\ w-icon-] {\n    position: absolute\n}\n\n.w-slider-arrow-left:focus,\n.w-slider-arrow-right:focus {\n    outline: 0\n}\n\n.w-slider-arrow-left {\n    z-index: 3;\n    right: auto\n}\n\n.w-slider-arrow-right {\n    z-index: 4;\n    left: auto\n}\n\n.w-icon-slider-left,\n.w-icon-slider-right {\n    width: 1em;\n    height: 1em;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0\n}\n\n.w-slider-aria-label {\n    clip: rect(0 0 0 0);\n    border: 0;\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    padding: 0;\n    position: absolute;\n    overflow: hidden\n}\n\n.w-slider-force-show {\n    display: block !important\n}\n\n.w-dropdown {\n    text-align: left;\n    z-index: 900;\n    margin-left: auto;\n    margin-right: auto;\n    display: inline-block;\n    position: relative\n}\n\n.w-dropdown-btn,\n.w-dropdown-toggle,\n.w-dropdown-link {\n    vertical-align: top;\n    color: #222;\n    text-align: left;\n    white-space: nowrap;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 20px;\n    text-decoration: none;\n    position: relative\n}\n\n.w-dropdown-toggle {\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    cursor: pointer;\n    padding-right: 40px;\n    display: inline-block\n}\n\n.w-dropdown-toggle:focus {\n    outline: 0\n}\n\n.w-icon-dropdown-toggle {\n    width: 1em;\n    height: 1em;\n    margin: auto 20px auto auto;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0\n}\n\n.w-dropdown-list {\n    background: #ddd;\n    min-width: 100%;\n    display: none;\n    position: absolute\n}\n\n.w-dropdown-list.w--open {\n    display: block\n}\n\n.w-dropdown-link {\n    color: #222;\n    padding: 10px 20px;\n    display: block\n}\n\n.w-dropdown-link.w--current {\n    color: #0082f3\n}\n\n.w-dropdown-link:focus {\n    outline: 0\n}\n\n@media screen and (max-width:767px) {\n    .w-nav-brand {\n        padding-left: 10px\n    }\n}\n\n.w-lightbox-backdrop {\n    cursor: auto;\n    letter-spacing: normal;\n    text-indent: 0;\n    text-shadow: none;\n    text-transform: none;\n    visibility: visible;\n    white-space: normal;\n    word-break: normal;\n    word-spacing: normal;\n    word-wrap: normal;\n    color: #fff;\n    text-align: center;\n    z-index: 2000;\n    opacity: 0;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -webkit-tap-highlight-color: transparent;\n    background: rgba(0, 0, 0, .9);\n    outline: 0;\n    font-family: Helvetica Neue, Helvetica, Ubuntu, Segoe UI, Verdana, sans-serif;\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 1.2;\n    list-style: disc;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    -webkit-transform: translate(0)\n}\n\n.w-lightbox-backdrop,\n.w-lightbox-container {\n    -webkit-overflow-scrolling: touch;\n    height: 100%;\n    overflow: auto\n}\n\n.w-lightbox-content {\n    height: 100vh;\n    position: relative;\n    overflow: hidden\n}\n\n.w-lightbox-view {\n    opacity: 0;\n    width: 100vw;\n    height: 100vh;\n    position: absolute\n}\n\n.w-lightbox-view:before {\n    content: \"\";\n    height: 100vh\n}\n\n.w-lightbox-group,\n.w-lightbox-group .w-lightbox-view,\n.w-lightbox-group .w-lightbox-view:before {\n    height: 86vh\n}\n\n.w-lightbox-frame,\n.w-lightbox-view:before {\n    vertical-align: middle;\n    display: inline-block\n}\n\n.w-lightbox-figure {\n    margin: 0;\n    position: relative\n}\n\n.w-lightbox-group .w-lightbox-figure {\n    cursor: pointer\n}\n\n.w-lightbox-img {\n    width: auto;\n    max-width: none;\n    height: auto\n}\n\n.w-lightbox-image {\n    float: none;\n    max-width: 100vw;\n    max-height: 100vh;\n    display: block\n}\n\n.w-lightbox-group .w-lightbox-image {\n    max-height: 86vh\n}\n\n.w-lightbox-caption {\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    background: rgba(0, 0, 0, .4);\n    padding: .5em 1em;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow: hidden\n}\n\n.w-lightbox-embed {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0\n}\n\n.w-lightbox-control {\n    cursor: pointer;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 24px;\n    width: 4em;\n    transition: all .3s;\n    position: absolute;\n    top: 0\n}\n\n.w-lightbox-left {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0yMCAwIDI0IDQwIiB3aWR0aD0iMjQiIGhlaWdodD0iNDAiPjxnIHRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHBhdGggZD0ibTAgMGg1djIzaDIzdjVoLTI4eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDN2MjNoMjN2M2gtMjZ6IiBmaWxsPSIjZmZmIi8+PC9nPjwvc3ZnPg==);\n    display: none;\n    bottom: 0;\n    left: 0\n}\n\n.w-lightbox-right {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMjQgNDAiIHdpZHRoPSIyNCIgaGVpZ2h0PSI0MCI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMC0waDI4djI4aC01di0yM2gtMjN6IiBvcGFjaXR5PSIuNCIvPjxwYXRoIGQ9Im0xIDFoMjZ2MjZoLTN2LTIzaC0yM3oiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+);\n    display: none;\n    bottom: 0;\n    right: 0\n}\n\n.w-lightbox-close {\n    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IDAgMTggMTciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNyI+PGcgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIj48cGF0aCBkPSJtMCAwaDd2LTdoNXY3aDd2NWgtN3Y3aC01di03aC03eiIgb3BhY2l0eT0iLjQiLz48cGF0aCBkPSJtMSAxaDd2LTdoM3Y3aDd2M2gtN3Y3aC0zdi03aC03eiIgZmlsbD0iI2ZmZiIvPjwvZz48L3N2Zz4=);\n    background-size: 18px;\n    height: 2.6em;\n    right: 0\n}\n\n.w-lightbox-strip {\n    white-space: nowrap;\n    padding: 0 1vh;\n    line-height: 0;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    overflow-x: hidden;\n    overflow-y: hidden\n}\n\n.w-lightbox-item {\n    box-sizing: content-box;\n    cursor: pointer;\n    width: 10vh;\n    padding: 2vh 1vh;\n    display: inline-block;\n    -webkit-transform: translate(0, 0)\n}\n\n.w-lightbox-active {\n    opacity: .3\n}\n\n.w-lightbox-thumbnail {\n    background: #222;\n    height: 10vh;\n    position: relative;\n    overflow: hidden\n}\n\n.w-lightbox-thumbnail-image {\n    position: absolute;\n    top: 0;\n    left: 0\n}\n\n.w-lightbox-thumbnail .w-lightbox-tall {\n    width: 100%;\n    top: 50%;\n    transform: translateY(-50%)\n}\n\n.w-lightbox-thumbnail .w-lightbox-wide {\n    height: 100%;\n    left: 50%;\n    transform: translate(-50%)\n}\n\n.w-lightbox-spinner {\n    box-sizing: border-box;\n    border: 5px solid rgba(0, 0, 0, .4);\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    margin-top: -20px;\n    margin-left: -20px;\n    animation: .8s linear infinite spin;\n    position: absolute;\n    top: 50%;\n    left: 50%\n}\n\n.w-lightbox-spinner:after {\n    content: \"\";\n    border: 3px solid transparent;\n    border-bottom-color: #fff;\n    border-radius: 50%;\n    position: absolute;\n    top: -4px;\n    bottom: -4px;\n    left: -4px;\n    right: -4px\n}\n\n.w-lightbox-hide {\n    display: none\n}\n\n.w-lightbox-noscroll {\n    overflow: hidden\n}\n\n@media (min-width:768px) {\n    .w-lightbox-content {\n        height: 96vh;\n        margin-top: 2vh\n    }\n\n    .w-lightbox-view,\n    .w-lightbox-view:before {\n        height: 96vh\n    }\n\n    .w-lightbox-group,\n    .w-lightbox-group .w-lightbox-view,\n    .w-lightbox-group .w-lightbox-view:before {\n        height: 84vh\n    }\n\n    .w-lightbox-image {\n        max-width: 96vw;\n        max-height: 96vh\n    }\n\n    .w-lightbox-group .w-lightbox-image {\n        max-width: 82.3vw;\n        max-height: 84vh\n    }\n\n    .w-lightbox-left,\n    .w-lightbox-right {\n        opacity: .5;\n        display: block\n    }\n\n    .w-lightbox-close {\n        opacity: .8\n    }\n\n    .w-lightbox-control:hover {\n        opacity: 1\n    }\n}\n\n.w-lightbox-inactive,\n.w-lightbox-inactive:hover {\n    opacity: 0\n}\n\n.w-richtext:before,\n.w-richtext:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-richtext:after {\n    clear: both\n}\n\n.w-richtext[contenteditable=true]:before,\n.w-richtext[contenteditable=true]:after {\n    white-space: initial\n}\n\n.w-richtext ol,\n.w-richtext ul {\n    overflow: hidden\n}\n\n.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-video div:after,\n.w-richtext .w-richtext-figure-selected[data-rt-type=video] div:after,\n.w-richtext .w-richtext-figure-selected.w-richtext-figure-type-image div,\n.w-richtext .w-richtext-figure-selected[data-rt-type=image] div {\n    outline: 2px solid #2895f7\n}\n\n.w-richtext figure.w-richtext-figure-type-video>div:after,\n.w-richtext figure[data-rt-type=video]>div:after {\n    content: \"\";\n    display: none;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0\n}\n\n.w-richtext figure {\n    max-width: 60%;\n    position: relative\n}\n\n.w-richtext figure>div:before {\n    cursor: default !important\n}\n\n.w-richtext figure img {\n    width: 100%\n}\n\n.w-richtext figure figcaption.w-richtext-figcaption-placeholder {\n    opacity: .6\n}\n\n.w-richtext figure div {\n    color: transparent;\n    font-size: 0\n}\n\n.w-richtext figure.w-richtext-figure-type-image,\n.w-richtext figure[data-rt-type=image] {\n    display: table\n}\n\n.w-richtext figure.w-richtext-figure-type-image>div,\n.w-richtext figure[data-rt-type=image]>div {\n    display: inline-block\n}\n\n.w-richtext figure.w-richtext-figure-type-image>figcaption,\n.w-richtext figure[data-rt-type=image]>figcaption {\n    caption-side: bottom;\n    display: table-caption\n}\n\n.w-richtext figure.w-richtext-figure-type-video,\n.w-richtext figure[data-rt-type=video] {\n    width: 60%;\n    height: 0\n}\n\n.w-richtext figure.w-richtext-figure-type-video iframe,\n.w-richtext figure[data-rt-type=video] iframe {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0\n}\n\n.w-richtext figure.w-richtext-figure-type-video>div,\n.w-richtext figure[data-rt-type=video]>div {\n    width: 100%\n}\n\n.w-richtext figure.w-richtext-align-center {\n    clear: both;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.w-richtext figure.w-richtext-align-center.w-richtext-figure-type-image>div,\n.w-richtext figure.w-richtext-align-center[data-rt-type=image]>div {\n    max-width: 100%\n}\n\n.w-richtext figure.w-richtext-align-normal {\n    clear: both\n}\n\n.w-richtext figure.w-richtext-align-fullwidth {\n    text-align: center;\n    clear: both;\n    width: 100%;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    display: block\n}\n\n.w-richtext figure.w-richtext-align-fullwidth>div {\n    padding-bottom: inherit;\n    display: inline-block\n}\n\n.w-richtext figure.w-richtext-align-fullwidth>figcaption {\n    display: block\n}\n\n.w-richtext figure.w-richtext-align-floatleft {\n    float: left;\n    clear: none;\n    margin-right: 15px\n}\n\n.w-richtext figure.w-richtext-align-floatright {\n    float: right;\n    clear: none;\n    margin-left: 15px\n}\n\n.w-nav {\n    z-index: 1000;\n    background: #ddd;\n    position: relative\n}\n\n.w-nav:before,\n.w-nav:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-nav:after {\n    clear: both\n}\n\n.w-nav-brand {\n    float: left;\n    color: #333;\n    text-decoration: none;\n    position: relative\n}\n\n.w-nav-link {\n    vertical-align: top;\n    color: #222;\n    text-align: left;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 20px;\n    text-decoration: none;\n    display: inline-block;\n    position: relative\n}\n\n@media screen and (max-width:767px) {\n    .mobile-padding {\n        padding: 4px 0px 4px 0;\n    }\n}\n\n.w-nav-link.w--current {\n    color: #0082f3\n}\n\n.w-nav-menu {\n    float: right;\n    position: relative\n}\n\n[data-nav-menu-open] {\n    text-align: center;\n    background: #c8c8c8;\n    min-width: 200px;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    overflow: visible;\n    display: block !important\n}\n\n.w--nav-link-open {\n    display: block;\n    position: relative\n}\n\n.w-nav-overlay {\n    width: 100%;\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    overflow: hidden\n}\n\n.w-nav-overlay [data-nav-menu-open] {\n    top: 0\n}\n\n.w-nav[data-animation=over-left] .w-nav-overlay {\n    width: auto\n}\n\n.w-nav[data-animation=over-left] .w-nav-overlay,\n.w-nav[data-animation=over-left] [data-nav-menu-open] {\n    z-index: 1;\n    top: 0;\n    right: auto\n}\n\n.w-nav[data-animation=over-right] .w-nav-overlay {\n    width: auto\n}\n\n.w-nav[data-animation=over-right] .w-nav-overlay,\n.w-nav[data-animation=over-right] [data-nav-menu-open] {\n    z-index: 1;\n    top: 0;\n    left: auto\n}\n\n\n.w-tabs {\n    position: relative\n}\n\n.w-tabs:before,\n.w-tabs:after {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-tabs:after {\n    clear: both\n}\n\n.w-tab-menu {\n    position: relative\n}\n\n.w-tab-link {\n    vertical-align: top;\n    text-align: left;\n    cursor: pointer;\n    color: #222;\n    background-color: #ddd;\n    padding: 9px 30px;\n    text-decoration: none;\n    display: inline-block;\n    position: relative\n}\n\n.w-tab-link.w--current {\n    background-color: #c8c8c8\n}\n\n.w-tab-link:focus {\n    outline: 0\n}\n\n.w-tab-content {\n    display: block;\n    position: relative;\n    overflow: hidden\n}\n\n.w-tab-pane {\n    display: none;\n    position: relative\n}\n\n.w--tab-active {\n    display: block\n}\n\n@media screen and (max-width:679px) {\n    .w-tab-link {\n        display: block\n    }\n}\n\n.w-ix-emptyfix:after {\n    content: \"\"\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0)\n    }\n\n    to {\n        transform: rotate(360deg)\n    }\n}\n\n.w-dyn-empty {\n    background-color: #ddd;\n    padding: 10px\n}\n\n.w-dyn-hide,\n.w-dyn-bind-empty,\n.w-condition-invisible {\n    display: none !important\n}\n\n.wf-layout-layout {\n    display: grid\n}\n\n.w-code-component>* {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0\n}\n\n:root {\n    --black: black;\n    --white: white;\n    --pabloo-green: #16A34A;\n    /* Changed from #d53987 */\n    --goldenrod: #ebb82f;\n    --slate-blue: #5050ff;\n    --black-2: #1f1f1f;\n    --soft-pink: #faf2eb;\n    --white-smoke: #f7f7f5;\n    --light-slate-grey: #828aa5;\n    --pabloo-green-2: #c73a88;\n    --light-pink: #f5cde1;\n    --dark-violet: #240213;\n    --dark-green: #014737;\n    --magenta: #5b002c;\n    --darker-violet: #200010;\n    --transparent: rgba(255, 255, 255, 0);\n    --cream: #f7e8c7;\n    --systemflow-lite--neutral--80: #636b75;\n    --systemflow-lite--neutral--10: white;\n    --systemflow-lite--neutral--100: #0e0f11;\n    --systemflow-lite--neutral--20: #f9fafb;\n    --elements-webflow-library--neutral--800: #211f54;\n    --elements-webflow-library--neutral--300: #eff0f6;\n    --elements-webflow-library--neutral--100: white;\n    --elements-webflow-library--general--shadow-01: rgba(20, 20, 43, .06);\n    --elements-webflow-library--accent--primary-1: #4a3aff;\n    --elements-webflow-library--neutral--600: #6e7191;\n    --systemflow-lite--primary--70: #1d39c4;\n    --systemflow-lite--primary--80: #10239e;\n    --systemflow-lite--primary--60: #2f54eb;\n    --systemflow-lite--primary--50: #597ef7;\n    --systemflow-lite--primary--10: #f2f6ff\n}\n\n.w-checkbox {\n    margin-bottom: 5px;\n    padding-left: 20px;\n    display: block\n}\n\n.w-checkbox:before {\n    content: \" \";\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-checkbox:after {\n    content: \" \";\n    clear: both;\n    grid-area: 1/1/2/2;\n    display: table\n}\n\n.w-checkbox-input {\n    float: left;\n    margin: 4px 0 0 -20px;\n    line-height: normal\n}\n\n.w-checkbox-input--inputType-custom {\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    width: 12px;\n    height: 12px\n}\n\n.w-checkbox-input--inputType-custom.w--redirected-checked {\n    background-color: #3898ec;\n    background-image: url(https://d3e54v103j8qbb.cloudfront.net/static/custom-checkbox-checkmark.589d534424.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-color: #3898ec\n}\n\n.w-checkbox-input--inputType-custom.w--redirected-focus {\n    box-shadow: 0 0 3px 1px #3898ec\n}\n\n.w-layout-grid {\n    grid-row-gap: 16px;\n    grid-column-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.w-layout-blockcontainer {\n    max-width: 940px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block\n}\n\n.w-form-formradioinput--inputType-custom {\n    border: 1px solid #ccc;\n    border-radius: 50%;\n    width: 12px;\n    height: 12px\n}\n\n.w-form-formradioinput--inputType-custom.w--redirected-focus {\n    box-shadow: 0 0 3px 1px #3898ec\n}\n\n.w-form-formradioinput--inputType-custom.w--redirected-checked {\n    border-width: 4px;\n    border-color: #3898ec\n}\n\n.w-pagination-wrapper {\n    flex-wrap: wrap;\n    justify-content: center;\n    display: flex\n}\n\n.w-pagination-previous {\n    color: #333;\n    background-color: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 9px 20px;\n    font-size: 14px;\n    display: block\n}\n\n.w-pagination-previous-icon {\n    margin-right: 4px\n}\n\n.w-pagination-next {\n    color: #333;\n    background-color: #fafafa;\n    border: 1px solid #ccc;\n    border-radius: 2px;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 9px 20px;\n    font-size: 14px;\n    display: block\n}\n\n.w-pagination-next-icon {\n    margin-left: 4px\n}\n\n.w-embed-youtubevideo {\n    background-image: url(https://d3e54v103j8qbb.cloudfront.net/static/youtube-placeholder.2b05e7d68d.svg);\n    background-position: 50%;\n    background-size: cover;\n    width: 100%;\n    padding-bottom: 0;\n    padding-left: 0;\n    padding-right: 0;\n    position: relative\n}\n\n.w-embed-youtubevideo:empty {\n    min-height: 75px;\n    padding-bottom: 56.25%\n}\n\n@media screen and (max-width:991px) {\n    .w-layout-blockcontainer {\n        max-width: 728px\n    }\n}\n\n@media screen and (max-width:767px) {\n    .w-layout-blockcontainer {\n        max-width: none\n    }\n}\n\nbody {\n    color: var(--black);\n    font-family: Satoshi, sans-serif;\n    font-size: 18px;\n    line-height: 28px\n}\n\nh1 {\n    letter-spacing: -.5px;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 64px;\n    font-weight: 700;\n    line-height: 64px\n}\n\nh2 {\n    letter-spacing: -1px;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 52px;\n    font-weight: 700;\n    line-height: 56px\n}\n\nh3 {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 30px\n}\n\nh4 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24px\n}\n\nh5 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px\n}\n\nh6 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 18px\n}\n\np {\n    margin-bottom: 0\n}\n\na {\n    color: var(--black);\n    text-decoration: none\n}\n\nul,\nol {\n    margin-top: 0;\n    margin-bottom: 10px;\n    padding-left: 40px\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n    display: inline-block\n}\n\nstrong {\n    font-weight: 700\n}\n\nblockquote {\n    border-left: 5px solid #e2e2e2;\n    margin-bottom: 10px;\n    padding: 10px 20px;\n    font-size: 18px;\n    line-height: 22px\n}\n\nfigure {\n    margin-bottom: 10px\n}\n\nfigcaption {\n    text-align: center;\n    margin-top: 5px\n}\n\n.page-wrapper {\n    margin-top: 0;\n    padding-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n    position: static\n}\n\n.page-wrapper.dark-bg {\n    background-color: var(--black)\n}\n\n.main-wrapper {\n    -webkit-backdrop-filter: blur(20px);\n    backdrop-filter: blur(20px);\n    background-color: rgba(255, 255, 255, .59);\n    height: 100%;\n    margin-top: 0;\n    position: relative\n}\n\n.main-wrapper.transparent-bg {\n    background-color: transparent\n}\n\n.home-hero-section {\n    margin-top: 60px;\n    margin-bottom: 24px\n}\n\n.wrapper-1300px {\n    z-index: 2;\n    background-color: transparent;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 2px 34px 40px;\n    display: flex;\n    position: relative\n}\n\n.wrapper-1300px.home-hero-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex\n}\n\n.wrapper-1300px.featured-on-wrapper {\n    width: 100%;\n    padding-top: 40px;\n    padding-bottom: 24px\n}\n\n.wrapper-1300px.center {\n    justify-content: center\n}\n\n.wrapper-1300px.mt-negative {\n    margin-top: -32px\n}\n\n.wrapper-1300px.p0 {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.wrapper-1300px.p-top-reset {\n    padding-top: 0\n}\n\n.wrapper-1300px._40-0 {\n    padding-bottom: 0\n}\n\n.wrapper-1300px._0-40 {\n    padding-top: 0\n}\n\n.wrapper-1300px.for-about {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: .5fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    margin-left: auto;\n    padding-bottom: 0;\n    padding-left: 0;\n    padding-right: 0;\n    display: grid\n}\n\n.wrapper-1300px.for-integra {\n    flex-flow: row;\n    width: 100%;\n    max-width: none;\n    padding-left: 0;\n    padding-right: 0\n}\n\n.large-link {\n    color: #fff;\n    white-space: nowrap;\n    background-color: #000;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    margin-left: 16px;\n    padding: 22px 40px;\n    text-decoration: none;\n    display: flex\n}\n\n.large-link-2 {\n    transform-origin: 100%;\n    color: #fff;\n    white-space: nowrap;\n    background-color: #000;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    margin-left: 16px;\n    padding: 22px 40px;\n    text-decoration: none;\n    transition: background-color .34s;\n    display: flex;\n    overflow: hidden\n}\n\n.large-link-2:hover {\n    background-color: var(--pabloo-green)\n}\n\n.large-link-2.show,\n.large-link-2.show.w--current {\n    border-radius: 8px;\n    padding: 12px 32px\n}\n\n.nav-menu {\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    font-weight: 500;\n    display: flex\n}\n\n.navigation-right {\n    justify-content: flex-end;\n    align-items: center;\n    width: auto;\n    height: 100%;\n    padding-right: 0;\n    display: flex\n}\n\n.navigation-right.tab-visibility {\n    display: none\n}\n\n.nav-link-register {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 16px;\n    padding-right: 16px;\n    font-weight: 500;\n    transition: all .4s\n}\n\n.nav-link-register:hover {\n    color: var(--pabloo-green)\n}\n\n.nav-link-register.hide {\n    display: block\n}\n\n.navigation-left {\n    align-items: center;\n    width: 25%;\n    height: 100%;\n    padding-left: 20px;\n    padding-right: 0;\n    display: flex\n}\n\n.navigation-container {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    max-width: 1440px;\n    height: 100%;\n    min-height: auto;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.navigation-container.custo {\n    padding-top: 8px;\n    padding-right: 8px\n}\n\n.logo {\n    width: 150px;\n    height: 36px\n}\n\n.logo.competitor-landing-nav-logo {\n    width: 100%\n}\n\n.nav-button-text {\n    margin-right: 6px;\n    font-weight: 500\n}\n\n.brand {\n    padding: 12px\n}\n\n.nav-link {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 12px;\n    padding-right: 12px;\n    font-weight: 500;\n    transition: all .4s;\n    display: none\n}\n\n.nav-link:hover,\n.nav-link.w--current {\n    color: var(--pabloo-green)\n}\n\n.nav-link.show {\n    display: block\n}\n\n.nav01 {\n    background-color: #fff;\n    align-items: center;\n    height: 90px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.nav01.sticky {\n    z-index: 99;\n    background-color: var(--white);\n    width: 100%;\n    height: auto;\n    min-height: 88px;\n    padding: 24px 5%;\n    position: -webkit-sticky;\n    position: sticky\n}\n\n.home-hero-content-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 56%;\n    max-width: 680px;\n    padding-bottom: 60px;\n    display: flex\n}\n\n.home-hero-heading-wrapper {\n    max-width: 680px;\n    margin-bottom: 20px\n}\n\n.home-hero-heading {\n    font-size: 64px;\n    line-height: 1.2em\n}\n\n.home-hero-heading.smaller {\n    font-size: 48px\n}\n\n.hero-special-span {\n    color: var(--pabloo-green);\n    letter-spacing: normal;\n    font-family: \"P22mackinacpro 11\", sans-serif;\n    font-style: italic;\n    font-weight: 700\n}\n\n.hero-special-span.competitor-landing-usps-highlight-heading-span {\n    color: var(--pabloo-green)\n}\n\n.home-hero-para-wrapper {\n    max-width: 630px;\n    margin-bottom: 36px\n}\n\n.home-hero-para {\n    letter-spacing: -.2px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.home-hero-para.custo {\n    font-size: 18px;\n    font-weight: 400\n}\n\n.bold-span {\n    box-shadow: inset 0 -18px 0 8px var(--goldenrod);\n    font-weight: 700;\n    line-height: 32px\n}\n\n.bold-span.no-bg {\n    box-shadow: none\n}\n\n.button-wrapper {\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.button-wrapper.home-hero-btn-wrapper {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px\n}\n\n.primary-button {\n    border: 2px solid var(--pabloo-green);\n    background-color: var(--pabloo-green);\n    padding: 22px 32px;\n    font-size: 20px;\n    font-weight: 700;\n    transition: color .36s, background-color .36s;\n    display: none\n}\n\n.primary-button:hover {\n    color: var(--pabloo-green);\n    background-color: transparent\n}\n\n.primary-button.white-color-button {\n    background-color: var(--white);\n    color: var(--pabloo-green);\n    border-radius: 8px;\n    padding: 18px 22px;\n    display: block\n}\n\n.primary-button.white-color-button:hover {\n    border-color: var(--white);\n    color: var(--white);\n    background-color: transparent\n}\n\n.primary-button.contact-button {\n    margin-top: 48px\n}\n\n.primary-button.contact-button.show {\n    border-radius: 8px;\n    padding: 12px 24px;\n    font-size: 18px\n}\n\n.primary-button.home {\n    float: none;\n    clear: none;\n    border-radius: 8px;\n    flex: none;\n    padding: 12px 16px;\n    font-size: 18px;\n    display: block;\n    position: static\n}\n\n.primary-button.home.pricing-cta {\n    float: left\n}\n\n.primary-button.white-alter-button {\n    border-color: var(--white);\n    background-color: var(--pabloo-green)\n}\n\n.primary-button.white-alter-button:hover {\n    background-color: var(--black);\n    color: var(--white)\n}\n\n.primary-button.popup-form-button {\n    margin-top: 36px\n}\n\n.primary-button.visible,\n.primary-button.show {\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 18px;\n    display: block\n}\n\n.primary-button.white-button.book-button {\n    border-style: solid;\n    border-color: var(--white);\n    color: #d53987;\n    text-align: center;\n    border-radius: 6px;\n    padding: 12px 20px;\n    font-size: 16px;\n    line-height: 140%;\n    display: block\n}\n\n.primary-button.white-button.book-button:hover {\n    border-style: solid;\n    border-color: var(--white);\n    background-color: var(--black);\n    color: var(--white);\n    transform: none\n}\n\n.primary-button.white-button.book-button.banner-cta-new {\n    width: 200px\n}\n\n.primary-button.white-button.ads-button {\n    color: var(--pabloo-green);\n    border-radius: 6px;\n    width: auto;\n    max-width: none;\n    padding: 12px 20px;\n    font-size: 20px;\n    line-height: 140%;\n    display: inline-block\n}\n\n.primary-button.white-button.ads-button:hover {\n    border-color: var(--white);\n    color: var(--white);\n    background-color: transparent\n}\n\n.hollow-button {\n    color: var(--black);\n    text-align: center;\n    background-color: transparent;\n    border: 2px solid #000;\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 700;\n    transition: color .36s, background-color .36s\n}\n\n.hollow-button:hover {\n    background-color: var(--black);\n    color: var(--white)\n}\n\n.hollow-button.white-hollow-button {\n    border-color: var(--white);\n    color: var(--white);\n    background-color: transparent\n}\n\n.hollow-button.white-hollow-button:hover {\n    border-color: var(--white);\n    background-color: var(--white);\n    color: var(--pabloo-green)\n}\n\n.hollow-button.white-bg-button {\n    border-style: solid;\n    border-color: var(--white);\n    background-color: var(--white);\n    padding-left: 32px;\n    padding-right: 32px\n}\n\n.hollow-button.white-bg-button:hover {\n    background-color: transparent;\n    border-style: solid\n}\n\n.home-hero-stat-grid {\n    grid-column-gap: 48px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: stretch;\n    width: 100%;\n    max-width: 800px;\n    margin-top: 24px;\n    margin-bottom: 40px;\n    display: grid\n}\n\n.home-hero-stat-grid.pricing-stat.pricing-center {\n    margin-top: 8px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.home-hero-stat-grid.custo {\n    grid-column-gap: 16px;\n    justify-content: start;\n    justify-items: start;\n    margin-top: 56px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.home-hero-stat-item {\n    text-align: center;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.hero-stat-block-square {\n    border-top: 1px solid rgba(0, 0, 0, .1);\n    border-left: 1px solid rgba(0, 0, 0, .1);\n    width: 100%;\n    height: 28px\n}\n\n.hero-stat-block-square.white-block {\n    border-top-color: rgba(255, 255, 255, .1);\n    border-left-color: rgba(255, 255, 255, .1)\n}\n\n.home-hero-stat-block {\n    text-align: center;\n    flex-direction: column;\n    align-self: center;\n    align-items: flex-start;\n    padding-left: 20px;\n    display: flex;\n    position: relative\n}\n\n.home-hero-stat-number {\n    color: var(--pabloo-green);\n    margin-bottom: 8px;\n    font-family: \"P22mackinacpro 17\", sans-serif;\n    font-size: 56px;\n    font-style: italic;\n    font-weight: 700;\n    line-height: 50px\n}\n\n.home-hero-stat-number.white-text,\n.home-hero-stat-number.competitor-landing-usps-stat-number {\n    color: var(--white)\n}\n\n.home-hero-stat-number.small {\n    font-size: 52px\n}\n\n.home-hero-stat-text {\n    font-size: 16px;\n    font-weight: 500\n}\n\n.home-hero-stat-text.competitor-landing-hero-stat-text {\n    color: var(--white)\n}\n\n.home-hero-stat-text.small {\n    font-size: 18px\n}\n\n.home-hero-stat-text.pricing-text {\n    color: #fff;\n    font-weight: 400\n}\n\n.hero-image-wrapper {\n    box-shadow: 14px 14px 0 0 var(--slate-blue);\n    border-radius: 8px;\n    width: 45%;\n    max-width: 480px;\n    margin-left: 2%\n}\n\n.home-hero-image {\n    object-fit: cover;\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.cards-section {\n    margin-bottom: 0;\n    padding-bottom: 0;\n    transition: opacity .2s\n}\n\n.cards-section.vertical-padding-large {\n    text-align: center;\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 0;\n    margin-left: 70px;\n    margin-right: 40px;\n    padding-top: 19px;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.logo-wrapper-head {\n    text-align: center;\n    margin-bottom: 50px\n}\n\n.logo-wrapper-head.integra._2-0 {\n    width: 800px\n}\n\n.logo-wrapper-heading {\n    font-size: 24px;\n    font-weight: 700\n}\n\n.logo-wrapper-grid {\n    flex-flow: wrap;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    width: 100%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.logo-wrapper-grid.investors {\n    grid-column-gap: 10%;\n    grid-row-gap: 60px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: flex-start;\n    margin-top: 8px;\n    display: grid\n}\n\n.logo-wrapper-grid.logo-wrapper-grid-sm {\n    flex-direction: row;\n    align-content: stretch;\n    align-items: stretch;\n    max-width: 100%;\n    display: block\n}\n\n.logo-wrapper-grid.as-featured-on-logos-wrapper-grid {\n    align-items: center\n}\n\n.logo-container {\n    filter: grayscale();\n    width: 14%;\n    height: 34px;\n    margin-bottom: 32px;\n    margin-left: 32px;\n    margin-right: 32px\n}\n\n.logo-container.as-featured-on-logo-container {\n    margin-top: 0\n}\n\n.logo-container.as-featured-on-logo-container.cnbc-logo-container {\n    height: 44px\n}\n\n.company-logo {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.company-logo.accel-logo {\n    height: 40px\n}\n\n.company-logo.publication-logo.forbes-logo {\n    height: 80%\n}\n\n.company-logo.publication-logo.cnbc-logo,\n.company-logo.publication-logo.et-logo {\n    height: 100%\n}\n\n.company-logo.publication-logo.ent-logo {\n    height: 80%\n}\n\n.home-value-section {\n    background-color: var(--black-2);\n    position: relative\n}\n\n.home-value-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-top: 160px;\n    padding-bottom: 160px;\n    display: flex\n}\n\n.home-value-content-wrapper {\n    width: 53%;\n    max-width: 640px\n}\n\n.home-value-heading {\n    color: #fff;\n    margin-bottom: 20px\n}\n\n.special-span {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif;\n    font-style: italic;\n    font-weight: 700\n}\n\n.home-value-para {\n    color: var(--white);\n    letter-spacing: .2px;\n    width: 100%;\n    max-width: 570px;\n    font-weight: 500\n}\n\n.home-value-image-container {\n    width: 45%;\n    max-width: 470px;\n    height: 412px;\n    position: relative\n}\n\n.value-image-wrapper-1 {\n    border-radius: 10px;\n    max-width: 345px;\n    max-height: 80px;\n    position: absolute;\n    top: 2%;\n    bottom: auto;\n    left: 0%;\n    right: auto;\n    transform: rotate(-4deg)\n}\n\n.home-value-image {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.value-image-wrapper-2 {\n    max-width: 190px;\n    max-height: 137px;\n    position: absolute;\n    top: 30%;\n    bottom: auto;\n    left: 26%;\n    right: auto;\n    transform: rotate(19deg)\n}\n\n.value-image-wrapper-3 {\n    width: 412px;\n    max-width: 412px;\n    height: 112px;\n    max-height: 112px;\n    position: absolute;\n    top: 71%;\n    bottom: auto;\n    left: 0%;\n    right: auto;\n    transform: rotate(10deg)\n}\n\n.home-split-section {\n    background-color: var(--soft-pink);\n    padding-top: 90px;\n    padding-bottom: 29px\n}\n\n.home-split-section.light-grey-bg {\n    background-color: var(--white-smoke)\n}\n\n.home-split-section.bottom-0 {\n    padding-bottom: 0\n}\n\n.home-split-section._50-50 {\n    padding-top: 0;\n    padding-bottom: 50px\n}\n\n.split-section-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.split-section-wrapper.wrapper-logo {\n    z-index: 1;\n    align-items: center;\n    margin-top: 20px;\n    position: relative\n}\n\n.split-section-wrapper.wrapper-logo.partners {\n    align-items: flex-start\n}\n\n.split-section-wrapper.reverse {\n    flex-wrap: nowrap;\n    margin-top: 80px;\n    position: relative\n}\n\n.split-section-content-container {\n    flex-direction: column;\n    flex: none;\n    align-items: flex-start;\n    width: 44%;\n    max-width: 620px;\n    display: flex\n}\n\n.split-section-content-container.split-2 {\n    width: 45%\n}\n\n.split-section-content-container.max-width-520px {\n    max-width: 520px\n}\n\n.split-section-heading {\n    letter-spacing: -.5px;\n    margin-bottom: 20px;\n    font-size: 44px;\n    line-height: 48px\n}\n\n.split-section-heading.max-width-560px {\n    letter-spacing: -.5px;\n    max-width: 560px\n}\n\n.split-section-heading.max-width-520px {\n    letter-spacing: -.5px;\n    max-width: 520px\n}\n\n.split-section-heading.last {\n    margin-bottom: 0\n}\n\n.split-section-heading.max-width-560px {\n    letter-spacing: -.5px;\n    letter-spacing: -.5px;\n    letter-spacing: -.5px;\n    letter-spacing: -.5px;\n    max-width: 560px;\n    font-size: 40px\n}\n\n.blue-span {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif;\n    font-style: italic;\n    font-weight: 700\n}\n\n.split-pointer-container {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    display: flex\n}\n\n.split-pointer-container.support {\n    max-width: 660px\n}\n\n.split-pointer-wrapper {\n    align-items: flex-start;\n    margin-bottom: 10px;\n    display: flex\n}\n\n.split-pointer-icon-container {\n    flex: none;\n    width: 24px;\n    height: 24px;\n    margin-top: 3px;\n    margin-right: 12px\n}\n\n.split-pointer-icon-container._20px {\n    width: 20px;\n    height: 20px;\n    margin-top: 5px\n}\n\n.split-pointer-icon {\n    object-fit: contain;\n    width: 100%;\n    height: 100%;\n    display: block\n}\n\n.split-pointer-text {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    font-weight: 500\n}\n\n.split-pointer-text.white-pointer-text {\n    color: var(--white)\n}\n\n.pointer-bold-span {\n    font-weight: 700\n}\n\n.split-button-wrapper {\n    margin-top: 40px\n}\n\n.blue-button {\n    background-color: var(--slate-blue);\n    color: var(--white);\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 700;\n    transition: background-color .36s\n}\n\n.blue-button:hover {\n    background-color: var(--pabloo-green)\n}\n\n.split-image-wrapper {\n    width: 45%;\n    max-width: 560px;\n    margin-top: 24px;\n    position: static\n}\n\n.split-image-wrapper._50 {\n    width: 50%\n}\n\n.split-image {\n    box-shadow: none;\n    object-fit: contain;\n    border-radius: 8px;\n    width: 100%;\n    height: 100%;\n    margin-top: 32px;\n    margin-bottom: 24px\n}\n\n.split-image.no-shadow {\n    box-shadow: none;\n    width: 80%\n}\n\n.split-image-2 {\n    box-shadow: none;\n    border-radius: 20px;\n    max-width: none;\n    max-height: none;\n    position: absolute;\n    top: auto;\n    bottom: -20%;\n    left: auto;\n    right: 34%\n}\n\n.split-image-wrapper-2 {\n    width: 50%;\n    max-width: 660px;\n    max-height: 528px;\n    margin-right: 5%;\n    position: relative\n}\n\n.split-image-wrapper-2.split-image-wrapper-3 {\n    max-height: none\n}\n\n.split-top-image-container {\n    border-radius: 5px;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 28px\n}\n\n.split-top-image {\n    width: 100%;\n    height: 100%\n}\n\n.home-work-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.home-work-wrapper.slack-steps-wrapper {\n    flex-wrap: nowrap;\n    padding: 40px 16px\n}\n\n.work-head-wrapper {\n    margin-bottom: 80px\n}\n\n.work-head-wrapper.slack-steps-header-wrapper {\n    width: 100%;\n    margin-bottom: 32px\n}\n\n.work-head-wrapper.slack-steps-header-wrapper.m-b-0 {\n    margin-bottom: 0\n}\n\n.work-span {\n    font-family: \"P22mackinacpro 18\", sans-serif;\n    font-style: italic;\n    font-weight: 400\n}\n\n.work-span.color-pink {\n    color: var(--pabloo-green)\n}\n\n.work-span.color-pink-11 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif;\n    line-height: 90%\n}\n\n.home-work-slide-wrapper {\n    width: auto\n}\n\n.home-work-slide-wrapper.slack-steps-wrapper {\n    flex-wrap: nowrap;\n    align-items: stretch;\n    width: 100%;\n    display: none\n}\n\n.home-work-slider {\n    background-color: transparent;\n    align-items: center\n}\n\n.slide-nave-hide {\n    background-color: transparent;\n    font-size: 10px;\n    display: block;\n    top: auto;\n    bottom: -4%;\n    left: 0%;\n    right: 0%\n}\n\n.mask-visible {\n    width: 100%;\n    max-width: 440px;\n    overflow: visible\n}\n\n.mask-visible._480px {\n    max-width: 480px\n}\n\n.work-slide-container {\n    background-color: #fff;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    padding: 40px;\n    display: flex\n}\n\n.work-slide-container.slack-step-container {\n    border-radius: 8px;\n    flex-flow: column;\n    flex: 0 auto;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-left: 8px;\n    margin-right: 8px;\n    box-shadow: 1px 1px 8px rgba(0, 0, 0, .1)\n}\n\n.work-slide-number-container {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61eba4f2f6ec07650a54102c_Number%20Cover.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    justify-content: center;\n    align-items: center;\n    width: 68px;\n    height: 68px;\n    margin-bottom: 28px;\n    display: flex\n}\n\n.work-slide-number-container.dont-resize {\n    flex: none;\n    margin-bottom: 25px\n}\n\n.work-slide-number-container.slack-step-number {\n    margin-bottom: 16px\n}\n\n.work-slider-text-wrapper {\n    width: 100%;\n    max-width: none;\n    font-size: 24px;\n    font-weight: 500\n}\n\n.work-slider-text-wrapper.sleck-step-text-wrapper {\n    margin-bottom: 8px\n}\n\n.review-section {\n    background-color: var(--white-smoke);\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.review-head-wrapper {\n    text-align: center;\n    max-width: 810px;\n    margin-bottom: 40px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.review-heading {\n    color: var(--black);\n    letter-spacing: -.5px;\n    font-size: 44px\n}\n\n.review-span-head {\n    font-family: \"P22mackinacpro 15\", sans-serif\n}\n\n.review-slider-wrapper {\n    justify-content: center;\n    align-items: center;\n    width: 100%\n}\n\n.review-slider {\n    background-color: transparent;\n    border-radius: 10px;\n    max-width: 1080px;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.review-slider.india {\n    display: none\n}\n\n.mask-not-visible {\n    border-radius: 10px\n}\n\n.review-slide {\n    background-color: transparent;\n    border-radius: 0;\n    padding: 40px 32px\n}\n\n.review-slider-container {\n    background-color: var(--white);\n    border-radius: 16px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    padding: 16px 0 16px 40px;\n    display: flex;\n    position: relative;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .08)\n}\n\n.review-slider-container.home {\n    box-shadow: none;\n    background-color: transparent\n}\n\n.review-company-image-container {\n    flex: none;\n    height: 40px;\n    margin-bottom: 32px;\n    line-height: 40px\n}\n\n.review-company-image-container.airmeet-logo-wrapper {\n    height: 40px\n}\n\n.review-company-image-container.synthesis-testimonial-logo {\n    height: 32px\n}\n\n.review-company-image {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.review-company-image.remo-logo {\n    height: 60%\n}\n\n.review-slider-content-wrapper {\n    flex: none;\n    align-items: center;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    min-height: 100px;\n    margin-bottom: 40px;\n    display: flex\n}\n\n.review-slider-text {\n    color: var(--black);\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 22px;\n    font-weight: 400;\n    line-height: 1.3\n}\n\n.mention-span {\n    color: var(--pabloo-green)\n}\n\n.review-slider-author-wrapper {\n    flex: none;\n    align-items: center;\n    max-width: none;\n    display: flex\n}\n\n.review-author-image-wrapper {\n    border-radius: 100%;\n    flex: none;\n    width: 56px;\n    height: 56px;\n    margin-right: 16px;\n    overflow: hidden\n}\n\n.review-author-image {\n    width: 100%;\n    height: 100%\n}\n\n.review-author-info-wrapper {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex-direction: column;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: flex-start;\n    display: grid\n}\n\n.review-author-name {\n    color: var(--black);\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.5\n}\n\n.review-author-job-post {\n    color: rgba(0, 0, 0, .64);\n    font-size: 16px;\n    font-weight: 500\n}\n\n.home-pointers-section {\n    padding-top: 90px;\n    padding-bottom: 90px\n}\n\n.home-pointers-split-wrapper {\n    justify-content: space-around;\n    align-items: center;\n    display: flex\n}\n\n.home-pointers-image-wrapper {\n    flex: none;\n    width: 45%;\n    max-width: 560px;\n    margin-right: 5%\n}\n\n.home-pointer-split-image {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.home-pointer-split-content-wrapper {\n    flex-direction: column;\n    flex: none;\n    align-items: flex-start;\n    width: 45%;\n    max-width: 560px;\n    display: flex\n}\n\n.pitch-section {\n    background-color: var(--white-smoke);\n    margin-top: 31px;\n    margin-bottom: 0;\n    padding-top: 55px;\n    padding-bottom: 83px\n}\n\n.pitch-head-wrapper {\n    text-align: center;\n    max-width: 840px;\n    margin-bottom: 0;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.pitch-heading {\n    margin-top: 19px;\n    margin-bottom: 19px;\n    font-size: 44px\n}\n\n.pitch-illustration-wrapper {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.pitch-illustration-head {\n    border-radius: 10px;\n    flex: none;\n    width: 240px;\n    height: 64px\n}\n\n.pitch-illustration {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.pitch-brach-wrapper {\n    width: 85%\n}\n\n.pitch-brach-wrapper.persona {\n    width: auto\n}\n\n.brach-image {\n    width: 100%;\n    height: 100%\n}\n\n.brach-image.branch-image-vertical {\n    display: none\n}\n\n.branch-card-wrapper {\n    grid-column-gap: 40px;\n    grid-row-gap: 16px;\n    flex: none;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.branch-card-wrapper.branch-persona {\n    grid-template-columns: 1fr 1fr;\n    max-width: 920px\n}\n\n.branch-card-wrapper.three-columns {\n    grid-template-columns: 1fr 1fr 1fr\n}\n\n.pitch-main-card {\n    border: 2px solid var(--pabloo-green);\n    background-color: var(--white);\n    box-shadow: -7px 7px 0 0 var(--pabloo-green);\n    outline-offset: 0px;\n    border-radius: 10px;\n    outline: 3px #000;\n    padding: 28px\n}\n\n.pitch-main-card.bottom-block.mobile {\n    display: none\n}\n\n.pitch-card-content-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 214px;\n    display: flex\n}\n\n.pitch-card-content-wrapper.persona {\n    max-width: none\n}\n\n.pitch-card-icon-wrapper {\n    flex: none;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 24px\n}\n\n.pitch-icon {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.pitch-card-head {\n    color: var(--black-2);\n    margin-bottom: 10px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.7\n}\n\n.pitch-card-para {\n    flex: none;\n    font-weight: 500\n}\n\n.pitch-card-para.persona {\n    color: var(--black)\n}\n\n.home-support-section {\n    background-color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62e4d52ca92ff67972f30036_ezgif.com-gif-maker.webp);\n    background-repeat: no-repeat;\n    background-size: cover;\n    margin-top: -24px;\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.support-wrapper {\n    justify-content: space-between;\n    display: flex\n}\n\n.support-content-wrapper {\n    flex: none;\n    width: 100%;\n    max-width: 730px\n}\n\n.support-heading {\n    color: var(--white);\n    margin-bottom: 28px\n}\n\n.support-span {\n    font-family: \"P22mackinacpro 15\", sans-serif;\n    font-style: italic\n}\n\n.support-button-wrapper {\n    align-items: flex-start;\n    margin-top: 40px;\n    display: flex\n}\n\n.faq-section {\n    padding-top: 90px;\n    padding-bottom: 90px\n}\n\n.faq-head-wrapper {\n    text-align: center;\n    margin-bottom: 68px\n}\n\n.faq-heading {\n    font-size: 32px\n}\n\n.faq-wrapper {\n    grid-column-gap: 40px;\n    grid-row-gap: 28px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.faq-container {\n    background-color: var(--white-smoke);\n    box-shadow: none;\n    cursor: pointer;\n    border-radius: 10px;\n    max-width: 620px;\n    margin-bottom: 28px;\n    padding: 24px 40px;\n    transition: box-shadow .36s\n}\n\n.faq-container:hover {\n    box-shadow: -8px 8px 0 0 var(--slate-blue)\n}\n\n.faq-question-wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0;\n    display: flex\n}\n\n.faq-question {\n    max-width: 480px;\n    margin-right: 28px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.faq-dropdown-icon-container {\n    flex: none;\n    justify-content: center;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    display: flex\n}\n\n.faq-dropdown-icon {\n    width: 100%;\n    height: 100%\n}\n\n.faq-answer-wrapper {\n    width: 100%;\n    max-width: 525px;\n    margin-top: 14px;\n    display: none;\n    overflow: hidden\n}\n\n.faq-answer {\n    color: rgba(0, 0, 0, .7);\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.cta-section {\n    background-color: var(--pabloo-green);\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.cta-split-wrapper {\n    justify-content: space-between;\n    align-items: stretch;\n    display: flex;\n    position: relative\n}\n\n.cta-split-wrapper.align-center {\n    align-items: center\n}\n\n.cta-split-content-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 48%;\n    max-width: 670px;\n    padding-top: 130px;\n    padding-bottom: 130px;\n    display: flex\n}\n\n.cta-split-content-wrapper.persona {\n    width: 49%;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.cta-split-content-wrapper.width-sm {\n    width: 40%\n}\n\n.cta-split-head-para {\n    color: var(--black);\n    letter-spacing: 0;\n    margin-bottom: 20px;\n    font-size: 20px;\n    line-height: 28px\n}\n\n.cta-split-head-para.pricing {\n    letter-spacing: .2px;\n    margin-bottom: 32px;\n    font-size: 18px;\n    font-weight: 400\n}\n\n.cta-split-head-para.persona {\n    color: var(--white);\n    margin-bottom: 40px\n}\n\n.cta-split-heading {\n    color: var(--white);\n    margin-bottom: 12px;\n    font-size: 40px;\n    line-height: 1.2em\n}\n\n.cta-split-heading.persona {\n    margin-bottom: 15px\n}\n\n.cta-split-heading.heading-small {\n    text-align: center;\n    font-size: 32px;\n    font-weight: 500\n}\n\n.white-alter-span {\n    font-family: Satoshi, sans-serif;\n    font-style: italic;\n    font-weight: 700;\n    display: inline\n}\n\n.white-alter-span.cta {\n    display: inline\n}\n\n.white-alter-span.white {\n    color: var(--black-2);\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 60px;\n    font-style: normal;\n    line-height: 1.2em\n}\n\n.cta-image-wrapper {\n    width: 47%;\n    max-width: 650px;\n    max-height: none\n}\n\n.cta-image-wrapper.flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.cta-image-wrapper.flex.width-md {\n    width: 50%\n}\n\n.cta-image {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.cta-image.h-auto {\n    width: 80%;\n    max-width: 80%;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.footer {\n    background-color: var(--black);\n    padding-bottom: 28px\n}\n\n.footer-content-wrapper {\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.footer-logo-container {\n    align-items: center;\n    width: 141px;\n    max-height: 30px;\n    display: flex\n}\n\n.footer-logo-container.w--current {\n    margin-right: 48px\n}\n\n.footer-logo {\n    width: 100%;\n    height: 100%\n}\n\n.footer-down-container {\n    border-top: 1px solid rgba(255, 255, 255, .1);\n    flex: none;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 28px;\n    line-height: 16px;\n    display: flex\n}\n\n.footer-down-container.competitor-landing-footer-bottom-section {\n    padding-bottom: 32px\n}\n\n.copyright-text {\n    color: rgba(255, 255, 255, .8);\n    flex: none;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 100%\n}\n\n.footer-down-link {\n    color: rgba(255, 255, 255, .8);\n    margin-left: 32px;\n    margin-right: 0;\n    font-size: 16px;\n    text-decoration: none;\n    transition: opacity .4s\n}\n\n.footer-down-link:hover {\n    color: #fff\n}\n\n.pricing-hero-section {\n    background-color: var(--pabloo-green);\n    background-image: none;\n    background-position: 0 0;\n    background-size: auto;\n    margin-bottom: 90px;\n    padding-top: 88px;\n    padding-bottom: 80px;\n    position: relative\n}\n\n.pricing-hero-section.blue-bg {\n    background-color: var(--slate-blue);\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto\n}\n\n.home-slider-section {\n    background-color: var(--pabloo-green);\n    padding-top: 80px;\n    padding-bottom: 80px;\n    position: relative\n}\n\n.home-slider-section.cs {\n    height: 90vh;\n    padding-top: 140px;\n    padding-bottom: 140px\n}\n\n.home-slider-section-head {\n    text-align: center;\n    width: 100%;\n    margin-bottom: 10px\n}\n\n.home-slider-section-heading {\n    color: var(--white);\n    max-width: 840px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.home-slider-main-wrapper {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.home-slider-main-wrapper.cs {\n    margin-top: 40px\n}\n\n.pricing-head-container {\n    text-align: center;\n    margin-bottom: 20px\n}\n\n.pricing-heading {\n    color: var(--black-2);\n    margin-bottom: 20px;\n    font-size: 64px;\n    line-height: 110%\n}\n\n.pricing-heading.white {\n    color: var(--white)\n}\n\n.pricing-hero-para {\n    color: var(--white);\n    margin-bottom: 16px;\n    font-size: 24px;\n    line-height: 32px\n}\n\n.auto-slider-arrow-left {\n    background-color: transparent;\n    border-radius: 50px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    padding: 10px 5px;\n    transition: background-color .3s;\n    display: flex;\n    position: absolute;\n    top: auto;\n    bottom: -20px;\n    left: auto;\n    right: 100px\n}\n\n.auto-slider-arrow-left:hover {\n    background-color: var(--white)\n}\n\n.auto-slider-arrow-right {\n    background-color: transparent;\n    border-radius: 50px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    padding: 10px 5px;\n    display: flex;\n    position: absolute;\n    top: auto;\n    bottom: -20px;\n    left: auto;\n    right: 40px;\n    overflow: visible\n}\n\n.auto-slider-arrow-right:hover {\n    background-color: #fff\n}\n\n.auto-slider-arrow-right.home {\n    display: none\n}\n\n.auto-slider-arrow-right.home.show {\n    width: 64px;\n    display: flex;\n    bottom: -12px\n}\n\n.auto-slider-arrow-right.home.show {\n    background-color: #fff;\n    width: 64px;\n    display: flex;\n    bottom: 22px;\n    right: 64px\n}\n\n.auto-slider-arrow-right.home.show:hover {\n    background-color: #fff\n}\n\n.slider-icon {\n    object-fit: contain;\n    width: 30px;\n    height: 30px;\n    display: block\n}\n\n.contact-hero-section {\n    margin-top: -1px;\n    margin-bottom: 110px\n}\n\n.contact-hero-wrapper {\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-top: 167px;\n    display: flex\n}\n\n.contact-hero-text-wrapper {\n    flex-direction: column;\n    width: 55%;\n    max-width: 720px;\n    display: flex\n}\n\n.contact-hero-heading {\n    margin-bottom: 20px\n}\n\n.contact-hero-para {\n    margin-bottom: 48px;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.contact-field-wrapper {\n    grid-column-gap: 48px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    margin-bottom: 20px;\n    display: grid\n}\n\n.contact-field-block {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-right: 10px;\n    display: flex;\n    position: relative\n}\n\n.contact-form-field {\n    letter-spacing: .2px;\n    border: 1px #000;\n    border-bottom: 2px solid rgba(0, 0, 0, .1);\n    height: 46px;\n    margin-bottom: 0;\n    padding-bottom: 16px;\n    padding-left: 0;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.contact-form-field:focus {\n    border-bottom-color: rgba(213, 57, 135, .1)\n}\n\n.contact-form-field::placeholder {\n    color: rgba(0, 0, 0, .6)\n}\n\n.contact-form-select {\n    color: rgba(0, 0, 0, .6);\n    background-color: transparent;\n    border: 1px #000;\n    border-bottom: 2px solid rgba(0, 0, 0, .1);\n    height: 46px;\n    margin-bottom: 0;\n    padding-bottom: 10px;\n    padding-left: 0;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.contact-message {\n    border: 1px #000;\n    border-bottom: 2px solid rgba(0, 0, 0, .1);\n    padding-left: 0;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.contact-message:focus {\n    border-bottom-color: rgba(213, 57, 135, .2)\n}\n\n.contact-message::placeholder {\n    color: rgba(0, 0, 0, .6)\n}\n\n.email-section {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61e91732e354a8764f6fdb08_Group%2023%20\\(2\\).svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.email-heading {\n    color: var(--white)\n}\n\n.email-span {\n    color: var(--white);\n    font-family: \"P22mackinacpro 15\", sans-serif;\n    font-style: italic;\n    text-decoration: none\n}\n\n.email-link {\n    border-bottom: 1px solid var(--white);\n    color: var(--white);\n    text-decoration: none\n}\n\n.blog-hero-section {\n    background-color: var(--soft-pink);\n    padding-top: 120px;\n    padding-bottom: 250px;\n    position: relative\n}\n\n.blog-hero-wrapper {\n    text-align: center;\n    flex-direction: column;\n    flex: 1;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex\n}\n\n.blog-hero-heading {\n    color: var(--white);\n    letter-spacing: normal;\n    max-width: 960px;\n    margin-bottom: 20px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.blog-hero-para {\n    color: var(--white);\n    max-width: 480px;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.5\n}\n\n.blog-hero-form-block {\n    border-radius: 10px;\n    max-width: 577px;\n    margin-top: 40px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block\n}\n\n.blog-hero-form-block.m-t-4 {\n    margin-top: 8px\n}\n\n.blog-form {\n    align-items: stretch;\n    max-width: 577px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.blog-form-field {\n    color: var(--white);\n    letter-spacing: .2px;\n    background-color: rgba(255, 255, 255, .07);\n    border: 1px #000;\n    border-radius: 8px;\n    height: 64px;\n    margin-bottom: 0;\n    margin-right: 20px;\n    padding-left: 24px;\n    font-size: 20px;\n    font-weight: 400\n}\n\n.blog-form-field::placeholder {\n    color: #fff;\n    letter-spacing: .2px;\n    font-weight: 400\n}\n\n.blog-form-field.custo {\n    background-color: rgba(0, 0, 0, .56)\n}\n\n.subscribe-button {\n    border: 2px solid var(--white);\n    background-color: var(--white);\n    color: var(--pabloo-green);\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 1.5;\n    transition: all .36s\n}\n\n.subscribe-button:hover {\n    border: 2px solid var(--white);\n    background-color: var(--pabloo-green);\n    color: var(--white)\n}\n\n.blog-feature-section {\n    position: relative;\n    top: -201px\n}\n\n.blog-feature-wrapper {\n    background-color: var(--white);\n    border-radius: 10px;\n    width: 100%;\n    padding: 24px;\n    box-shadow: 0 10px 100px rgba(0, 0, 0, .1)\n}\n\n.blog-feature-wrapper.custo {\n    border: 8px none var(--goldenrod);\n    background-color: var(--white-smoke);\n    border-radius: 8px\n}\n\n.wrapper-1080px {\n    width: 80%;\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.wrapper-1080px.blog-wrapper {\n    width: 80%;\n    max-width: 1260px;\n    display: flex\n}\n\n.blog-feature-block {\n    grid-column-gap: 40px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    height: auto;\n    display: grid\n}\n\n.blog-feature-block.guide {\n    grid-template-columns: 1fr 2fr\n}\n\n.blog-feature-image-container {\n    border-radius: 10px;\n    width: 100%;\n    max-width: 538px;\n    height: auto;\n    overflow: hidden\n}\n\n.blog-feature-image {\n    object-fit: contain;\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.blog-feature-info-top {\n    align-items: center;\n    margin-bottom: 20px;\n    display: flex\n}\n\n.blog-feature-info-top.spread {\n    flex: 0 auto;\n    justify-content: space-between;\n    width: 100%\n}\n\n.blog-tag-text {\n    color: var(--pabloo-green);\n    letter-spacing: .8px;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 700\n}\n\n.blog-date {\n    color: rgba(0, 0, 0, .6);\n    letter-spacing: .8px;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 700\n}\n\n.divider-circle {\n    background-color: rgba(0, 0, 0, .2);\n    border-radius: 100%;\n    flex: none;\n    width: 6px;\n    height: 6px;\n    margin-left: 10px;\n    margin-right: 10px\n}\n\n.blog-feature-heading {\n    letter-spacing: -.5px;\n    margin-bottom: 12px;\n    font-size: 32px;\n    line-height: 36px\n}\n\n.blog-feature-para {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 17px;\n    line-height: 1.5\n}\n\n.blog-feature-author-block {\n    align-items: center;\n    margin-top: 80px;\n    display: flex\n}\n\n.blog-feature-author-block.blog-collection {\n    margin-top: 0\n}\n\n.blog-feature-author-image-block {\n    border-radius: 100%;\n    flex: none;\n    width: 48px;\n    height: 48px;\n    margin-right: 10px;\n    overflow: hidden\n}\n\n.blog-feature-author-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.blog-author-info-block {\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.blog-author-name {\n    margin-bottom: 0;\n    font-weight: 700;\n    line-height: 18px\n}\n\n.blog-author-job-title {\n    color: rgba(0, 0, 0, .6);\n    margin-top: 8px;\n    font-weight: 500;\n    line-height: 18px\n}\n\n.cms-blog-block-section {\n    padding-bottom: 140px\n}\n\n.cms-blog-blocks-wrapper {\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.cms-blog-blocks-wrapper.flex {\n    flex-wrap: wrap;\n    display: flex\n}\n\n.cms-blog-blocks-wrapper.flex.align {\n    justify-content: center;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.blog-filter-tab-container {\n    z-index: 9999999\n}\n\n.blog-filter-tab {\n    justify-content: center;\n    align-items: center;\n    display: none\n}\n\n.blog-tab {\n    background-color: transparent;\n    border-bottom: 2px solid rgba(31, 31, 31, .1);\n    margin-left: 28px;\n    margin-right: 28px;\n    font-size: 20px;\n    font-weight: 700\n}\n\n.blog-tab.w--current {\n    border-bottom-color: var(--pabloo-green);\n    background-color: transparent\n}\n\n.blog-tab-content {\n    margin-top: 0;\n    overflow: visible\n}\n\n.blog-collection-list {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.blog-collection-item {\n    background-color: var(--white);\n    border-radius: 10px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 520px;\n    padding: 24px 24px 38px;\n    display: flex;\n    box-shadow: 0 10px 80px rgba(0, 0, 0, .05)\n}\n\n.blog-collection-item:hover {\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .1)\n}\n\n.blog-collection-item.margin {\n    max-width: 440px;\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-right: 12px\n}\n\n.blog-collection-item.margin.custo {\n    border: 10px none var(--goldenrod);\n    background-color: var(--white);\n    border-radius: 0;\n    max-width: 540px;\n    margin-bottom: 12px;\n    display: none\n}\n\n.blog-collection-item.margin.custo._1 {\n    margin-top: 0;\n    padding-top: 24px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.blog-collection-item.margin.custo._2 {\n    background-image: none;\n    margin-left: 0;\n    margin-right: 12px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.blog-collection-item.margin.mt-16 {\n    border-radius: 0;\n    margin-top: 0;\n    display: none\n}\n\n.blog-collection-item.limit-width {\n    max-width: 440px;\n    margin-left: 12px\n}\n\n.blog-collection-item.limit-width.custo {\n    border: 10px none var(--goldenrod);\n    border-radius: 0\n}\n\n.blog-collection-item.limit-width.custo.m-t-16 {\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 12px\n}\n\n.blog-collection-parent-item {\n    z-index: 999999;\n    align-items: stretch;\n    display: flex\n}\n\n.blog-card-image-container {\n    border-radius: 10px;\n    max-width: 470px;\n    height: 296px;\n    max-height: 296px;\n    margin-bottom: 24px;\n    overflow: hidden\n}\n\n.blog-card-image-container.ebook-1 {\n    background-color: transparent\n}\n\n.blog-card-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.blog-card-image.custo {\n    object-fit: contain;\n    transform-style: preserve-3d\n}\n\n.blog-card-image.custo:hover {\n    object-fit: contain;\n    transform: scale3d(1.1, 1.1, 1.1)\n}\n\n.blog-card-content-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 472px;\n    display: flex\n}\n\n.blog-card-heading {\n    font-family: Inter, sans-serif;\n    font-size: 24px;\n    line-height: 1.5\n}\n\n.blog-card-para {\n    color: rgba(0, 0, 0, .8)\n}\n\n.blog-card-para.custo {\n    margin-top: 16px;\n    font-family: Inter, sans-serif\n}\n\n.success-message {\n    background-color: var(--white);\n    color: var(--slate-blue);\n    border-radius: 10px;\n    width: 100%;\n    font-size: 20px;\n    font-weight: 700\n}\n\n.error-message {\n    color: #d5393c;\n    background-color: #f3dada;\n    border-radius: 10px;\n    width: 100%;\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 10px 20px;\n    font-size: 18px;\n    font-weight: 700\n}\n\n.empty-state {\n    color: var(--slate-blue);\n    text-align: center;\n    background-color: rgba(80, 80, 255, .05);\n    border-radius: 10px;\n    padding: 24px;\n    font-size: 20px;\n    font-weight: 700\n}\n\n.blog-collection-hero-section {\n    padding-top: 40px\n}\n\n.blog-collection-head-wrapper {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.blog-collection-heading {\n    margin-bottom: 16px;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 56px;\n    line-height: 64px\n}\n\n.blog-collection-para {\n    color: rgba(0, 0, 0, .82);\n    letter-spacing: .2px;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 36px\n}\n\n.blog-main-image-wrapper {\n    width: 100%;\n    max-width: 1440px;\n    height: auto;\n    max-height: none;\n    margin: 24px auto 80px\n}\n\n.blog-main-image {\n    object-fit: cover;\n    border-radius: 16px;\n    width: 100%;\n    height: 100%\n}\n\n.blog-rich-text-section {\n    padding-bottom: 120px;\n    position: relative\n}\n\n.more-blog-section {\n    background-color: var(--white-smoke);\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.more-blog-head {\n    text-align: center;\n    margin-bottom: 80px\n}\n\n.more-blog-heading {\n    font-size: 44px\n}\n\n.blog-more-container {\n    flex-direction: column;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.more-button-wrapper {\n    flex: none;\n    margin-top: 70px\n}\n\n.blog-rich-text {\n    width: 100%;\n    font-weight: 400\n}\n\n.blog-rich-text h2 {\n    margin-bottom: 16px;\n    font-size: 32px;\n    line-height: 1.5\n}\n\n.blog-rich-text p {\n    margin-bottom: 16px;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.blog-rich-text li {\n    margin-bottom: 16px;\n    font-size: 20px;\n    list-style-type: decimal\n}\n\n.blog-rich-text h3 {\n    margin-bottom: 12px\n}\n\n.blog-rich-text blockquote {\n    background-color: rgba(213, 57, 135, .2);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f130c006a25f4b76fe8f8c_Frame%20\\(2\\).svg);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    border-left-style: none;\n    padding: 40px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.blog-rich-text img {\n    margin-top: 10px\n}\n\n.blog-rich-text figcaption {\n    color: rgba(0, 0, 0, .8);\n    font-weight: 500;\n    line-height: 1.6\n}\n\n.blog-rich-text a {\n    /* color: var(--pabloo-green); */\n    /* text-decoration: none */\n}\n\n.blog-rich-text h1 {\n    margin-bottom: 30px\n}\n\n.blog-contact-container {\n    border-top: 2px solid rgba(0, 0, 0, .1);\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 80px;\n    padding-top: 48px;\n    display: flex\n}\n\n.blog-designer-wrapper {\n    margin-left: 48px\n}\n\n.home-value-bg-image-wrap {\n    width: 70%;\n    max-width: 700px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.home-value-bg-image {\n    object-fit: cover;\n    object-position: 0% 50%;\n    width: 100%;\n    height: 100%\n}\n\n.home-slider-image-1 {\n    width: 30%;\n    max-width: 400px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.home-slider-image-2 {\n    width: 30%;\n    max-width: 400px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.value-image-wrapper-4 {\n    display: none\n}\n\n.pricing-hero-table {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: rgba(255, 255, 255, 0);\n    border-radius: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    max-width: 1048px;\n    margin-top: 71px;\n    margin-left: auto;\n    margin-right: auto;\n    display: grid;\n    box-shadow: 7px 4px 24px rgba(0, 0, 0, .1)\n}\n\n.pricing-hero-table.new {\n    margin-bottom: 0\n}\n\n.text-link {\n    color: var(--pabloo-green);\n    transition: background-color .2s\n}\n\n.text-link:hover {\n    color: var(--slate-blue)\n}\n\n.pagination {\n    flex-direction: row;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    margin-top: 60px;\n    display: flex\n}\n\n.page-count {\n    color: rgba(0, 0, 0, .6);\n    width: auto;\n    margin-top: 0;\n    margin-right: 38px;\n    font-weight: 500;\n    display: flex\n}\n\n.next-button {\n    border-width: 1.5px;\n    border-color: var(--black);\n    color: var(--black);\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px;\n    transition: all .36s\n}\n\n.next-button:hover {\n    border-color: var(--pabloo-green);\n    background-color: var(--pabloo-green);\n    color: var(--white)\n}\n\n.previous-button {\n    border-width: 1.5px;\n    border-color: var(--black);\n    color: var(--black);\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px;\n    transition: all .36s\n}\n\n.previous-button:hover {\n    border-color: var(--pabloo-green);\n    background-color: var(--pabloo-green);\n    color: var(--white)\n}\n\n.utility-page-wrap {\n    justify-content: center;\n    align-items: center;\n    width: 100vw;\n    max-width: 700px;\n    height: 100vh;\n    max-height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.utility-page-wrap._404 {\n    flex-direction: column;\n    height: auto;\n    margin-top: 200px;\n    /* margin-bottom: -1vw */\n}\n\n@media screen and (max-width:767px) {\n    .utility-page-wrap {\n        justify-content: center;\n        align-items: center;\n        width: 100vw;\n        max-width: 700px;\n        height: 100vh;\n        max-height: 100%;\n        margin-left: auto;\n        margin-right: auto;\n        display: flex\n    }\n\n    .utility-page-wrap._404 {\n        flex-direction: column;\n        height: auto;\n        margin-top: 30vw;\n        margin-bottom: -18vw\n    }\n}\n\n.utility-page-content {\n    text-align: center;\n    flex-direction: column;\n    margin-bottom: 60px;\n    display: flex\n}\n\n.utility-page-form {\n    flex-direction: column;\n    align-items: stretch;\n    display: flex\n}\n\n.html-embed {\n    width: 100%;\n    margin-bottom: 50px\n}\n\n.pricing-table-left {\n    background-color: #fff;\n    width: 100%;\n    height: 100%;\n    padding: 0\n}\n\n.pricing-table-right {\n    background-color: var(--white-smoke);\n    flex: 0 auto;\n    width: 100%;\n    padding: 48px\n}\n\n.price-table-heading {\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: 700\n}\n\n.price-point-contain {\n    margin-bottom: 38px\n}\n\n.price-point-wrapper {\n    align-items: flex-start;\n    margin-bottom: 18px;\n    display: flex\n}\n\n.price-point-wrapper.price-point-seperator-wrapper {\n    margin-bottom: 8px\n}\n\n.checkmark {\n    margin-right: 16px\n}\n\n.price-point {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    max-width: 480px;\n    margin-right: 0;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.price-point.bold {\n    color: #d53987;\n    margin-right: 0;\n    font-weight: 700\n}\n\n.price-point.bold.price-point-seperator {\n    color: #000;\n    font-size: 20px\n}\n\n.slack-span {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f43a6e8fe3d56a1da03474_image%2032.svg);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding-left: 30px;\n    font-weight: 700\n}\n\n.slack-span.regular {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f46550b9aea1f8ce4ee3bb_slack-new-logo%201.svg);\n    background-size: auto;\n    padding-left: 35px;\n    font-weight: 500\n}\n\n.html-embed-2 {\n    display: block\n}\n\n.black-button {\n    background-color: var(--black);\n    color: var(--white);\n    border: 2px solid #000;\n    border-radius: 8px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 700;\n    transition: color .36s, background-color .36s\n}\n\n.black-button:hover {\n    background-color: var(--white);\n    color: var(--black)\n}\n\n.popup {\n    z-index: 2147483647;\n    background-color: rgba(0, 0, 0, .85);\n    justify-content: center;\n    align-items: center;\n    display: none;\n    position: fixed;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.wrapper-1280px {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-bottom: 100px;\n    display: flex;\n    position: relative\n}\n\n.wrapper-1280px.popup-div {\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.wrapper-1280px.solution-wrapper {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.split-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.finance-wrapper {\n    flex-direction: column;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.together-blue-flex {\n    max-width: 1200px\n}\n\n.wrapper-1280px.discover-product-hero-flex {\n    flex-direction: column;\n    padding-top: 88px;\n    padding-bottom: 0\n}\n\n.wrapper-1280px.discover-purchase-flex {\n    padding-top: 120px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px.discover-tools-flex {\n    max-width: 1260px;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.procurement-black-flex {\n    flex-direction: column;\n    align-items: stretch;\n    padding-top: 140px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px.case-study-hero-flex {\n    padding-top: 64px;\n    padding-bottom: 64px\n}\n\n.wrapper-1280px.case-study-flex {\n    justify-content: center\n}\n\n.wrapper-1280px.track-approval-flex {\n    max-width: 1260px\n}\n\n.wrapper-1280px.multi-channel-approval-flex {\n    max-width: 1200px;\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.wrapper-1280px.workflow-approval-flex {\n    align-items: center;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.fast-track-approval-hero-flex {\n    z-index: 1;\n    flex-direction: column;\n    padding-top: 88px;\n    padding-bottom: 0\n}\n\n.wrapper-1280px.document-one-place-flex {\n    padding-top: 120px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px.best-deals-flex {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.wrapper-1280px.assisted-tools-flex {\n    padding-top: 70px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.assisted-purchasing-flex {\n    flex-direction: column;\n    padding-top: 88px;\n    padding-bottom: 0\n}\n\n.wrapper-1280px.actionable-insight-flex {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px.contract-renewals-flex {\n    max-width: 1200px;\n    padding-top: 120px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px.slack-steps-width-limiter {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.wrapper-1280px.custo {\n    flex-wrap: wrap;\n    justify-content: center\n}\n\n.wrapper-1280px.wrap {\n    flex-wrap: wrap\n}\n\n.wrapper-1280px.custom {\n    padding-top: 40px;\n    padding-bottom: 80px\n}\n\n.wrapper-1280px.pt-xs {\n    padding-top: 24px\n}\n\n.wrapper-1280px.points-container {\n    z-index: 3\n}\n\n.html-embed-calendly {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.popup-close {\n    border: 2px solid var(--white);\n    border-radius: 10px;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: -2%\n}\n\n.medium-span {\n    font-weight: 500\n}\n\n.work-slider-number-2 {\n    color: #d53987;\n    font-family: \"P22mackinacpro 17\", sans-serif;\n    font-size: 32px;\n    font-weight: 700\n}\n\n.home-work-section-slider {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61e91732e354a8764f6fdb08_Group%2023%20\\(2\\).svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-top: 80px;\n    padding-bottom: 120px;\n    overflow: hidden\n}\n\n.home-work-section-slider.blue-background {\n    background-color: var(--slate-blue);\n    background-image: none\n}\n\n.left-arrow-2 {\n    background-color: rgba(255, 255, 255, .3);\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    margin-left: 0%;\n    transition: all .3s;\n    display: flex;\n    top: auto;\n    bottom: -20%;\n    left: 0%;\n    right: auto\n}\n\n.left-arrow-2:hover {\n    background-color: rgba(255, 255, 255, .2);\n    transform: translate(-5px)\n}\n\n.right-arrow-2 {\n    background-color: rgba(255, 255, 255, .3);\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    transition: all .2s;\n    display: flex;\n    top: auto;\n    bottom: -20%;\n    left: 64px;\n    right: auto\n}\n\n.right-arrow-2:hover {\n    background-color: rgba(255, 255, 255, .2);\n    transform: translate(5px)\n}\n\n.right-arrow-2.competitor-landing-page-how-it-works-slider {\n    left: 14%\n}\n\n.home-work-heading-2 {\n    color: #fff;\n    line-height: 108%\n}\n\n.home-work-heading-2.slack-steps-heading {\n    color: #000;\n    margin-bottom: 20px\n}\n\n.work-slide-2 {\n    background-color: #fff;\n    border-radius: 10px;\n    max-width: 440px;\n    max-height: 272px;\n    margin-right: 60px\n}\n\n.work-slide-2.max-width-500 {\n    max-width: 500px\n}\n\n.slider-arrows {\n    object-fit: contain\n}\n\n.privacy-section {\n    padding-top: 100px;\n    padding-bottom: 60px\n}\n\n.privacy-content-wrapper {\n    flex: 1;\n    display: flex\n}\n\n.privacy-rich-text {\n    color: var(--black);\n    display: block\n}\n\n.privacy-rich-text h2 {\n    margin-bottom: 20px;\n    font-size: 40px;\n    line-height: 140%\n}\n\n.privacy-rich-text p {\n    color: var(--light-slate-grey);\n    margin-bottom: 14px;\n    font-weight: 500\n}\n\n.privacy-rich-text h3 {\n    text-align: center;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 20px;\n    line-height: 120%\n}\n\n.privacy-rich-text ul {\n    color: var(--light-slate-grey);\n    font-weight: 500\n}\n\n.privacy-rich-text li {\n    color: var(--light-slate-grey);\n    margin-bottom: 10px\n}\n\n.privacy-rich-text ol {\n    color: var(--light-slate-grey);\n    font-weight: 500\n}\n\n.privacy-rich-text a {\n    color: var(--pabloo-green-2);\n    font-weight: 400\n}\n\n.privacy-rich-text a:hover {\n    color: var(--black)\n}\n\n.blog-feature-block-section {\n    padding-bottom: 120px;\n    display: none\n}\n\n.blog-feature-item {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    background-color: var(--white);\n    color: var(--black);\n    border-radius: 10px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.2fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    padding: 24px;\n    display: grid;\n    box-shadow: 0 10px 80px rgba(0, 0, 0, .07)\n}\n\n.blog-featured-image-container {\n    border-radius: 10px;\n    width: 100%;\n    height: auto;\n    overflow: hidden\n}\n\n.blog-featured-image {\n    width: 100%\n}\n\n.blog-featured-text-container {\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.bold-head {\n    text-transform: uppercase;\n    margin-bottom: 16px;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 20px\n}\n\n.blog-featured-heading {\n    letter-spacing: -.5px;\n    margin-bottom: 12px;\n    font-size: 32px;\n    line-height: 36px\n}\n\n.blog-featured-para {\n    color: rgba(0, 0, 0, .7);\n    letter-spacing: .2px;\n    margin-bottom: 30px;\n    font-size: 20px\n}\n\n.hide {\n    display: none\n}\n\n.popup-container {\n    background-color: var(--white);\n    border-radius: 10px;\n    width: 100%;\n    max-width: 708px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 50px;\n    position: relative\n}\n\n.popup-heading {\n    letter-spacing: -.5px;\n    margin-bottom: 30px;\n    font-size: 44px;\n    line-height: 48px\n}\n\n.popup-cross {\n    width: 52%;\n    height: 52%\n}\n\n.popup-text-field {\n    border: 1px #000;\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n    width: 100%;\n    margin-bottom: 0\n}\n\n.popup-text-field::placeholder {\n    letter-spacing: .2px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.popup-text-field.form-right {\n    width: 100%\n}\n\n.popup-split-block {\n    grid-column-gap: 48px;\n    grid-row-gap: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    margin-bottom: 20px;\n    display: grid\n}\n\n.popup-split-block.block-down {\n    margin-bottom: 0\n}\n\n._16-px {\n    color: #b6b6b6;\n    flex-direction: row-reverse;\n    flex: none;\n    order: 0;\n    font-size: 16px;\n    line-height: 150%;\n    display: flex\n}\n\n.about-head-container {\n    text-align: center;\n    flex: 0 auto;\n    max-width: 1080px;\n    margin: 78px auto 64px\n}\n\n.about-head-container.persona {\n    max-width: 840px;\n    margin-bottom: 100px\n}\n\n.about-head-container.procurement {\n    flex-direction: column;\n    align-items: center;\n    max-width: 1060px;\n    display: flex\n}\n\n.about-head-container.procurement.management-hub-hero {\n    max-width: 1060px\n}\n\n.about-head-container.new {\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.about-hero-text-contain {\n    background-color: var(--white);\n    border-radius: 10px;\n    width: 100%;\n    max-width: 960px;\n    margin-top: -136px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 64px;\n    padding-bottom: 40px;\n    position: relative;\n    top: 84px;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    box-shadow: 0 48px 120px rgba(0, 0, 0, .1)\n}\n\n.about-hero-text-wrap {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.about-hero-paragraph {\n    text-align: center;\n    letter-spacing: .2px;\n    width: 80%;\n    margin-bottom: 24px;\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 1.2\n}\n\n.about-hero-paragraph.point {\n    margin-bottom: 0\n}\n\n.about-hero-point-wrap {\n    align-items: center;\n    margin-bottom: 16px;\n    display: flex\n}\n\n.about-point-icon {\n    width: 100%;\n    max-width: 40px;\n    margin-right: 20px\n}\n\n.about-hero-wrapper {\n    background-color: var(--slate-blue);\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    margin-bottom: 90px;\n    padding-top: 120px;\n    padding-bottom: 0;\n    position: relative\n}\n\n.about-team-section {\n    margin-top: 280px\n}\n\n.about-team-wrapper {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 70px\n}\n\n.about-team-heading {\n    text-align: center;\n    letter-spacing: -.5px;\n    margin-bottom: 80px;\n    margin-left: 0;\n    margin-right: auto;\n    font-size: 44px;\n    line-height: 109%\n}\n\n.team-grid {\n    grid-column-gap: 58px;\n    grid-row-gap: 58px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%;\n    display: flex\n}\n\n.team-grid.speakers-grid-webinar {\n    grid-column-gap: 16px;\n    grid-row-gap: 24px;\n    flex-wrap: wrap;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    grid-auto-flow: row;\n    margin-top: 24px;\n    display: grid\n}\n\n.team-grid.speakers-grid-webinar.volopay-speakers {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    justify-content: flex-start;\n    margin-top: 40px\n}\n\n.team-grid.speakers-grid-webinar.volopay-speakers.m-t-80 {\n    grid-column-gap: 8px;\n    margin-top: 80px\n}\n\n.team-member-wrap {\n    flex: 0 auto\n}\n\n.team-member-wrap.m-r-32 {\n    margin-right: 32px\n}\n\n.team-member-wrap.ml-16 {\n    margin-left: 16px\n}\n\n.member-image-wrap {\n    object-fit: contain;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-start;\n    display: flex;\n    position: relative\n}\n\n.member-image {\n    position: static;\n    top: -10px;\n    right: 10px;\n    box-shadow: 7px 7px #000\n}\n\n.member-image._1 {\n    box-shadow: 7px 7px 0 0 var(--slate-blue);\n    padding: 0 0%\n}\n\n.member-image._1.member-image-webinar {\n    background-color: var(--white);\n    max-width: none;\n    max-height: 200px;\n    line-height: 28px\n}\n\n.member-image._1.member-image-webinar.volopay-speaker-image {\n    max-height: 200px\n}\n\n.member-image._1.member-image-webinar.saas-cfo-webinar {\n    max-height: 240px\n}\n\n.member-image._1.member-image-webinar.saas-cfo-webinar.no-shadow {\n    box-shadow: none;\n    max-height: 300px\n}\n\n.member-image._1.member-image-webinar.saas-cfo-webinar.no-shadow.smaller {\n    background-color: transparent;\n    max-height: 240px;\n    padding: 24px 0%\n}\n\n.member-image._1.member-image-webinar.no-shadow {\n    box-shadow: none\n}\n\n.member-image._1.member-image-webinar.reset {\n    padding: 0 0%\n}\n\n.member-image._2 {\n    background-color: var(--white);\n    box-shadow: 7px 7px 0 0 var(--pabloo-green);\n    background-image: none;\n    padding: 0 0%\n}\n\n.member-image._2.member-image-webinar {\n    background-color: var(--white);\n    background-image: none;\n    max-width: none;\n    max-height: 200px\n}\n\n.member-image._2.member-image-webinar.volopay-speaker-image {\n    max-height: 200px\n}\n\n.member-image._2.member-image-webinar.volopay-speaker-image.speaker-2 {\n    box-shadow: 7px 7px 0 0 var(--goldenrod)\n}\n\n.member-image._2.member-image-webinar.saas-cfo-webinar {\n    max-height: 240px\n}\n\n.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow {\n    box-shadow: none;\n    max-height: 300px\n}\n\n.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller {\n    background-color: transparent;\n    background-image: none;\n    max-height: 240px;\n    padding-left: 0%;\n    padding-right: 0%\n}\n\n.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller.pb-0 {\n    object-fit: contain;\n    width: 88%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.custo {\n    max-height: 240px;\n    padding-top: 0;\n    padding-left: 0%;\n    padding-right: 0%\n}\n\n.member-image._2.member-image-webinar.no-shadow {\n    box-shadow: none\n}\n\n.member-image._2.member-image-webinar.reset {\n    padding: 0 0%\n}\n\n.member-image._3 {\n    box-shadow: 7px 7px #ebb82f\n}\n\n.member-info-contain {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: center;\n    margin-top: 8px;\n    display: grid\n}\n\n.member-name {\n    letter-spacing: -.5px;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 133%\n}\n\n.member-name.volopay-member-name {\n    text-align: center;\n    margin-top: 8px;\n    margin-bottom: 0;\n    font-size: 20px\n}\n\n.member-company {\n    color: #000;\n    text-align: center;\n    letter-spacing: .8px;\n    text-transform: uppercase;\n    margin-bottom: 12px;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 125%\n}\n\n.member-ex-position {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    font-weight: 500;\n    line-height: 133%\n}\n\n.career-section {\n    background-color: var(--white-smoke)\n}\n\n.career-wrapper {\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.career-left-wrap {\n    width: 50%;\n    max-width: 600px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 120px\n}\n\n.career-right-wrap {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    width: 46%;\n    max-width: 600px;\n    display: grid\n}\n\n.career-block {\n    background-color: var(--white);\n    box-shadow: -7px 7px 0 0 var(--pabloo-green);\n    border-radius: 10px;\n    padding: 32px\n}\n\n.career-icon {\n    width: 100%;\n    max-width: 48px;\n    margin-bottom: 24px\n}\n\n.career-paragraph {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 125%\n}\n\n.career-heading {\n    letter-spacing: -.5px;\n    margin-bottom: 16px;\n    font-size: 44px;\n    line-height: 109%\n}\n\n.career-text {\n    letter-spacing: .2px;\n    margin-bottom: 40px;\n    font-weight: 500;\n    line-height: 156%\n}\n\n.about-slider-section {\n    background-color: var(--black);\n    display: none;\n    position: relative;\n    overflow: hidden\n}\n\n.about-slider-wrapper {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 120px 0 180px;\n    position: relative\n}\n\n.about-slide {\n    border-radius: 10px;\n    max-width: 480px;\n    margin-right: 60px\n}\n\n.about-slider-contain {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.about-slider {\n    background-color: transparent;\n    align-items: center;\n    height: auto;\n    position: relative\n}\n\n.left-arrow-about {\n    background-color: rgba(255, 255, 255, .3);\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    margin-left: 0%;\n    transition: all .3s;\n    display: flex;\n    top: auto;\n    bottom: -40%;\n    left: 0%;\n    right: auto\n}\n\n.left-arrow-about:hover {\n    background-color: rgba(255, 255, 255, .2);\n    transform: translate(-5px)\n}\n\n.right-arrow-about {\n    background-color: rgba(255, 255, 255, .3);\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    transition: all .2s;\n    display: flex;\n    top: auto;\n    bottom: -40%;\n    left: 70px;\n    right: auto\n}\n\n.right-arrow-about:hover {\n    background-color: rgba(255, 255, 255, .2);\n    transform: translate(5px)\n}\n\n.about-span {\n    text-align: left;\n    font-family: \"P22mackinacpro 11\", sans-serif;\n    font-style: italic;\n    font-weight: 700\n}\n\n.number-text {\n    color: var(--pabloo-green);\n    margin-bottom: 24px;\n    font-family: \"P22mackinacpro 11\", sans-serif;\n    font-size: 64px;\n    font-weight: 700;\n    line-height: 100%\n}\n\n.about-subheading {\n    color: var(--white);\n    letter-spacing: -.5px;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 133%\n}\n\n.about-slide-text {\n    color: var(--white);\n    letter-spacing: .2px;\n    max-width: 480px;\n    margin-bottom: 0;\n    font-size: 18px;\n    line-height: 133%\n}\n\n.background-image {\n    height: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.about-slider-wrap {\n    width: 100%;\n    display: flex\n}\n\n.persona-hero-card {\n    z-index: 20;\n    background-color: #fff;\n    border-radius: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 85%;\n    max-width: 1200px;\n    height: auto;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    display: flex;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 48px 120px rgba(0, 0, 0, .04)\n}\n\n.persona-hero-card-image {\n    width: 45%;\n    max-width: 520px;\n    height: 100%\n}\n\n.persona-hero-card-text {\n    width: 48%;\n    max-width: 520px;\n    margin-left: 0;\n    margin-right: 2%\n}\n\n.persona-card-text {\n    font-size: 44px;\n    line-height: 109%\n}\n\n.personal-top-tag-wrap {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 24px;\n    display: flex\n}\n\n.top-tag-line {\n    background-color: var(--goldenrod);\n    width: 40px;\n    height: 2px\n}\n\n.persona-head-para {\n    color: var(--white);\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 140%\n}\n\n.persona-head-para.procurement {\n    max-width: 840px\n}\n\n.persona-head-para.it {\n    max-width: 920px\n}\n\n.persona-hero-button-wrap {\n    justify-content: center;\n    align-items: center;\n    margin-top: 40px;\n    display: flex\n}\n\n.persona-hero-button-wrap.margin-top-120 {\n    margin-top: 80px\n}\n\n.persona-hero-section {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642bffa1cb27627aca9c5cc7_Rectangle%201261.png);\n    background-position: 0 80%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    position: relative\n}\n\n.persona-hero-section.no-bg {\n    background-image: none\n}\n\n.persona-down-hero-bg {\n    background-color: var(--white);\n    width: 100%;\n    height: 120px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.persona-solution-section {\n    background-color: var(--black-2)\n}\n\n.solution-text-container {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 50%;\n    max-width: 560px;\n    margin-right: 3%;\n    display: flex\n}\n\n.solution-heading {\n    color: var(--white);\n    margin-bottom: 16px;\n    font-size: 32px;\n    line-height: 112%\n}\n\n.persona-solution-para {\n    color: var(--white);\n    max-width: 465px;\n    font-weight: 500;\n    line-height: 156%\n}\n\n.persona-solution-pointers-wrap {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 50%;\n    max-width: 520px;\n    display: flex\n}\n\n.solution-pointer-head {\n    color: var(--white);\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 133%\n}\n\n.solution-pointer-wrap {\n    color: var(--white);\n    flex-direction: row;\n    justify-content: center;\n    align-items: flex-start;\n    margin-bottom: 12px;\n    font-weight: 500;\n    line-height: 156%;\n    display: flex\n}\n\n.solution-pointer-icon {\n    flex: none;\n    width: 24px;\n    height: 24px;\n    margin-top: 2px;\n    margin-right: 12px\n}\n\n.persona-split-secion.split-2 {\n    background-color: var(--white-smoke)\n}\n\n.persona-split-section-head {\n    text-align: center;\n    max-width: 840px;\n    margin-bottom: 120px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.persona-split-section-head.procurement {\n    max-width: 1140px\n}\n\n.persona-split-section-heading {\n    line-height: 120%\n}\n\n.split-container {\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.split-container.split-top-padding-0 {\n    padding-top: 0\n}\n\n.split-container.split-inverse {\n    flex-direction: row-reverse\n}\n\n.persona-split-text-container {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 46%;\n    max-width: 480px;\n    margin-right: 3%;\n    display: flex\n}\n\n.persona-split-text-container.split-2 {\n    max-width: 530px;\n    margin-left: 3%;\n    margin-right: 0%\n}\n\n.persona-split-text-container.split-3 {\n    max-width: 560px\n}\n\n.persona-split-text-container.procurement {\n    max-width: 520px\n}\n\n.persona-split-text-container.procurement-2-text {\n    width: 40%;\n    max-width: 540px;\n    margin-left: 3%;\n    margin-right: 0%\n}\n\n.persona-split-text-container.procurement-2-text._w-50 {\n    width: 50%\n}\n\n.persona-split-text-container.it {\n    width: 40%;\n    max-width: 520px\n}\n\n.persona-split-icon-container {\n    border-radius: 5px;\n    flex: none;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 28px;\n    overflow: hidden\n}\n\n.persona-split-icon {\n    width: 100%;\n    height: 100%\n}\n\n.persona-split-text {\n    margin-bottom: 16px;\n    font-size: 44px;\n    line-height: 120%\n}\n\n.persona-split-para {\n    max-width: 480px;\n    font-weight: 500;\n    line-height: 156%\n}\n\n.persona-split-image-container {\n    box-shadow: -15px 13px 0 0 var(--slate-blue);\n    border-radius: 8px;\n    width: 53%;\n    max-width: 600px;\n    margin-right: 30px;\n    position: relative\n}\n\n.persona-split-image-container.split-2 {\n    box-shadow: -15px 13px 0 0 var(--pabloo-green);\n    margin-right: 0\n}\n\n.persona-split-image-container.procurement-1-image {\n    margin-right: 0\n}\n\n.persona-split-image-container.procurement-1-image.proc-image-alternate-landing,\n.persona-split-image-container.procurement-section-3-image {\n    box-shadow: none\n}\n\n.persona-split-image-container.procurement-section-3-image._w-50 {\n    width: 50%\n}\n\n.persona-split-image {\n    border-radius: 8px;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    box-shadow: 0 10px 20px rgba(31, 31, 31, .05)\n}\n\n.persona-split-image.procurement-section-3 {\n    z-index: 10;\n    box-shadow: none;\n    position: relative\n}\n\n.persona-split-image.procurement-section-3.solid-shadow {\n    box-shadow: -11px 11px 0 0 var(--pabloo-green)\n}\n\n.persona-split-image.split-image-alternate-landing {\n    box-shadow: 0 0 8px rgba(0, 0, 0, .16)\n}\n\n.persona-split-image.split-image-alternate-landing.hide-shadow {\n    box-shadow: none\n}\n\n.persona-split-image.split-image-alternate-landing.hide-shadow.solid-shadow {\n    box-shadow: 11px 11px 0 0 var(--slate-blue)\n}\n\n.persona-split-side-image {\n    border-radius: 10px;\n    width: 40%;\n    position: absolute;\n    top: 35%;\n    bottom: auto;\n    left: auto;\n    right: -7%;\n    overflow: hidden;\n    box-shadow: -17px 17px 100px rgba(0, 0, 0, .08)\n}\n\n.persona-split-side-image.split-2 {\n    width: 30%;\n    top: 27%;\n    right: -3%\n}\n\n.persona-split-side-image.split-3 {\n    width: 60%;\n    top: 18%;\n    right: -7%\n}\n\n.persona-finance-section {\n    background-color: var(--black);\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto\n}\n\n.finance-head-wrap {\n    margin-bottom: 80px\n}\n\n.finance-head-wrap.procurement {\n    max-width: 840px\n}\n\n.finance-heading {\n    color: var(--black);\n    text-align: center;\n    line-height: 108%\n}\n\n.finance-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-content: center;\n    align-items: start;\n    display: grid\n}\n\n.finance-grid-item {\n    color: var(--white);\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 150%;\n    display: flex\n}\n\n.finanve-item-icon-block {\n    flex: none;\n    width: 48px;\n    height: 48px;\n    margin-bottom: 24px\n}\n\n.finance-button-wrap {\n    justify-content: center;\n    align-items: center;\n    margin-top: 80px;\n    display: flex\n}\n\n.persona-text-link {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d1ffb97d792f833449_Vector%20\\(9\\).svg), url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);\n    background-position: 85%, 85%;\n    background-repeat: no-repeat, no-repeat;\n    background-size: auto, auto;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-right: 40px;\n    font-weight: 700;\n    transition: color .3s, background-position .3s\n}\n\n.persona-text-link:hover {\n    color: var(--pabloo-green);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);\n    background-position: 95%;\n    background-repeat: no-repeat;\n    background-size: auto\n}\n\n.persona-block-image {\n    margin-bottom: 28px\n}\n\n.persona-hero-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.procurement-section-1-image._1 {\n    border-radius: 10px;\n    width: 13%;\n    max-width: 72px;\n    position: absolute;\n    top: 18%;\n    bottom: auto;\n    left: auto;\n    right: -4%;\n    transform: rotate(15deg);\n    box-shadow: 0 10px 60px rgba(0, 0, 0, .05)\n}\n\n.procurement-section-1-image._2 {\n    background-color: var(--white);\n    background-image: none;\n    border-radius: 10px;\n    width: 15%;\n    max-width: 15%;\n    margin-top: auto;\n    margin-bottom: auto;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: -6%;\n    right: auto;\n    transform: rotate(-15deg);\n    box-shadow: 0 10px 60px rgba(0, 0, 0, .1)\n}\n\n.procurement-section-1-image._2.compound {\n    padding: 0 0%\n}\n\n.procurement-section-1-image._3 {\n    border-radius: 10px;\n    width: 15%;\n    max-width: 88%;\n    position: absolute;\n    top: auto;\n    bottom: 7%;\n    left: auto;\n    right: -7%;\n    transform: rotate(15deg);\n    box-shadow: 7px 7px 60px rgba(0, 0, 0, .1)\n}\n\n.procurement-section-2-image {\n    border-radius: 12px;\n    width: 60%;\n    max-width: 384px;\n    margin-top: 70px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: -8%;\n    box-shadow: 0 20px 80px rgba(0, 0, 0, .08)\n}\n\n.shadow-div {\n    background-color: var(--black);\n    opacity: .04;\n    filter: blur(50px);\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.dropdown-list {\n    background-color: transparent\n}\n\n.dropdown-list.w--open {\n    margin-top: -6px;\n    padding-top: 21px;\n    left: -152px\n}\n\n.dropdown-list.product {\n    left: -200px\n}\n\n.dropdown-list.resources {\n    left: -340px\n}\n\n.persona-dropdown-wrap {\n    background-color: var(--white);\n    border-radius: 10px;\n    width: 400px;\n    padding: 20px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .16)\n}\n\n.persona-dropdown-wrap.product {\n    width: 792px\n}\n\n.persona-dropdown-wrap.product-drop-down {\n    width: 720px;\n    position: static\n}\n\n.persona-dropdown-wrap.resources {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 800px;\n    display: block\n}\n\n.persona-dropdown-link {\n    border: 1px #000;\n    border-top: 2px solid rgba(0, 0, 0, .08);\n    border-bottom: 2px rgba(0, 0, 0, .08);\n    border-radius: 0;\n    align-items: flex-start;\n    padding: 16px 10px;\n    display: flex;\n    position: static\n}\n\n.persona-dropdown-link:hover {\n    background-color: rgba(213, 57, 135, .05)\n}\n\n.persona-dropdown-link.dropdown-link-no-border {\n    border-top-style: none;\n    padding-top: 20px;\n    padding-bottom: 20px\n}\n\n.persona-dropdown-link.dropdown-link-no-border.discover-hero-pointer {\n    align-items: center\n}\n\n.persona-dropdown-link.dropdown-link-no-border.discover-hero-pointer.custo {\n    align-items: flex-start;\n    margin-top: 0;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    padding-left: 10px\n}\n\n.persona-dropdown-link.center {\n    align-items: center\n}\n\n.persona-dropdown-link.center.custo {\n    align-items: flex-start;\n    padding-top: 12px;\n    padding-bottom: 12px\n}\n\n.persona-dropdown-link.center.custo.hide,\n.persona-dropdown-link.center.custo.hide.w--current {\n    display: flex\n}\n\n.persona-dropdown-icon {\n    width: 32px;\n    height: 32px;\n    margin-right: 16px;\n    display: block\n}\n\n.persona-dropdown-text-wrap {\n    width: 90%\n}\n\n.persona-dropdown-title {\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 100%\n}\n\n.persona-dropdown-description {\n    color: rgba(0, 0, 0, .8);\n    font-size: 14px;\n    line-height: 140%\n}\n\n.persona-dropdown-description.hide {\n    display: block\n}\n\n.dropdown-toggle {\n    align-items: center;\n    padding-left: 12px;\n    padding-right: 12px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500;\n    display: flex\n}\n\n.dropdown-toggle.w--open:hover {\n    color: var(--pabloo-green)\n}\n\n.dropdown-toggle.product {\n    display: none;\n    overflow: visible\n}\n\n.icon {\n    margin-left: 8px;\n    margin-right: 0;\n    position: relative\n}\n\n.persona-triangle {\n    margin-bottom: 0;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    top: 7px;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.persona-triangle.product {\n    top: 7px;\n    bottom: auto;\n    left: 250px;\n    right: auto\n}\n\n.persona-triangle.product-dropdown-triangle {\n    left: -32%\n}\n\n.dropdown {\n    margin-left: 0;\n    margin-right: 0;\n    display: block\n}\n\n.dropdown.resources-hide {\n    display: block\n}\n\n.dropdown-text {\n    font-family: Satoshi, sans-serif;\n    font-weight: 500\n}\n\n.together-blue-section {\n    background-color: var(--slate-blue);\n    color: var(--white)\n}\n\n.together-image-container {\n    width: 45%;\n    max-width: 520px\n}\n\n.slack-hero-image {\n    width: 100%\n}\n\n.together-text-container {\n    width: 45%;\n    max-width: 520px\n}\n\n.together-blue-heading {\n    margin-bottom: 20px\n}\n\n.together-blue-heading.custo {\n    color: var(--white)\n}\n\n.together-blue-heading.working {\n    max-width: 761px\n}\n\n.together-blue-paragraph-18px {\n    letter-spacing: .2px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 28px\n}\n\n.together-blue-paragraph-18px.custo {\n    color: var(--white)\n}\n\n.discover-product-hero-section {\n    padding-top: 80px;\n    padding-bottom: 120px;\n    position: relative\n}\n\n.discover-product-hero-bg {\n    z-index: -1;\n    background-color: var(--white-smoke);\n    width: 100%;\n    height: 100%;\n    max-height: 1192px;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.discover-product-hero-bg.custo {\n    background-color: var(--white)\n}\n\n.discover-product-hero-wrapper {\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 920px;\n    margin-bottom: 24px;\n    display: flex\n}\n\n.discover-product-hero-heading {\n    color: var(--black);\n    margin-bottom: 20px;\n    font-family: Satoshi, sans-serif;\n    font-size: 64px;\n    line-height: 72px\n}\n\n.discover-product-hero-heading.insights {\n    max-width: 640px\n}\n\n.discover-product-hero-heading.track-usage {\n    max-width: 711px\n}\n\n.discover-product-hero-heading.track-usage.width-lg {\n    max-width: 90%;\n    line-height: 78px\n}\n\n.discover-pink-span {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.discover-hero-paragraph {\n    opacity: .8;\n    letter-spacing: .2px;\n    margin-bottom: 40px;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 28px\n}\n\n.discover-hero-paragraph.max-width-700px {\n    max-width: 700px\n}\n\n.discover-hero-paragraph.track-usage {\n    max-width: 720px\n}\n\n.discover-hero-paragraph.track-usage.width-lg {\n    max-width: 80%\n}\n\n.discover-hero-pointer {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    margin-top: 24px;\n    padding-left: 0;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 28px\n}\n\n.discover-hero-pink-line {\n    background-color: var(--pabloo-green);\n    width: 40px;\n    height: 2px\n}\n\n.discover-hero-pink-text {\n    color: var(--pabloo-green);\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    margin-left: 20px;\n    margin-right: 20px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px\n}\n\n.discover-hero-pink-text-wrapper {\n    align-items: center;\n    margin-bottom: 24px;\n    display: flex\n}\n\n.discover-hero-circle-image {\n    width: 100%;\n    max-width: 450px\n}\n\n.discover-hero-circle-image.left {\n    position: absolute;\n    top: auto;\n    bottom: 20%;\n    left: 0%;\n    right: auto\n}\n\n.discover-hero-circle-image.right {\n    position: absolute;\n    top: auto;\n    bottom: 20%;\n    left: auto;\n    right: 0%\n}\n\n.discover-hero-visual {\n    object-fit: fill;\n    width: 100%\n}\n\n.new-product-text-container {\n    width: 45%;\n    max-width: 500px\n}\n\n.new-product-image-container {\n    width: 52%;\n    max-width: 640px\n}\n\n.new-product-heading-44px {\n    color: var(--pabloo-green);\n    letter-spacing: -.5px;\n    margin-bottom: 16px;\n    font-family: Satoshi, sans-serif;\n    font-size: 44px;\n    line-height: 48px\n}\n\n.new-product-heading-44px.max-width-400px {\n    max-width: 440px\n}\n\n.new-product-icon {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 28px\n}\n\n.new-product-paragraph-18px {\n    color: rgba(0, 0, 0, .8);\n    letter-spacing: .2px;\n    margin-top: 24px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 30px\n}\n\n.new-product-paragraph-18px.max-width-480px {\n    color: var(--black);\n    max-width: 480px;\n    font-size: 20px;\n    font-weight: 400\n}\n\n.new-product-hero-image {\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.new-product-hero-image.custo {\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .08)\n}\n\n.new-product-hero-image.custo.no-shadow,\n.new-product-hero-image.hide-shadow {\n    box-shadow: none\n}\n\n.discover-purchase-section.gray-bg {\n    background-color: var(--white-smoke)\n}\n\n.purchase-text-container {\n    width: 45%;\n    max-width: 500px\n}\n\n.purchase-image-container {\n    width: 52%;\n    max-width: 640px\n}\n\n.discover-tools-section {\n    background-color: var(--white-smoke)\n}\n\n.discover-tools-section.white-bg {\n    background-color: var(--white)\n}\n\n.tools-text-container {\n    width: 45%;\n    max-width: 540px\n}\n\n.tools-text-container.max-width-500px {\n    width: 42%;\n    max-width: 500px\n}\n\n.tools-image-container {\n    width: 52%;\n    max-width: 640px\n}\n\n.tools-image-container.resize-width {\n    width: 56%\n}\n\n.tools-hero-image {\n    box-shadow: -14px 14px 0 0 var(--pabloo-green);\n    border-radius: 10px;\n    width: 100%\n}\n\n.tools-hero-image.custo {\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .08)\n}\n\n.tools-hero-image.hide-shadow {\n    box-shadow: none\n}\n\n.procuement-black-section {\n    background-color: var(--black);\n    color: var(--white)\n}\n\n.procurement-upper-container {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 80px;\n    display: flex\n}\n\n.procurement-bottom-container {\n    width: 100%\n}\n\n.procurement-paragraph-18px {\n    letter-spacing: .2px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 28px\n}\n\n.procurement-paragraph-18px.main {\n    text-align: center;\n    max-width: 730px\n}\n\n.procurement-heading-wrapper {\n    width: 70%;\n    max-width: 920px;\n    margin-right: 1%\n}\n\n.procurement-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-wrap: wrap;\n    grid-template-columns: 1fr 1fr 1fr;\n    justify-content: center;\n    display: flex\n}\n\n.procurement-item {\n    color: var(--white);\n    background-color: rgba(255, 255, 255, .2);\n    border-radius: 10px;\n    width: 100%;\n    max-width: 400px;\n    padding: 32px\n}\n\n.procurement-heading-24px {\n    letter-spacing: -.5px;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32px\n}\n\n.procurement-item-text-18px {\n    letter-spacing: .2px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.procurement-image-container {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 24px;\n    display: flex\n}\n\n.procurement-arrow-wrapper {\n    justify-content: center;\n    align-items: center;\n    width: 30px;\n    height: 30px;\n    display: flex\n}\n\n.procurement-arrow-white {\n    width: 24px;\n    height: 24px\n}\n\n.procurement-arrow-pink {\n    width: 24px;\n    height: 24px;\n    display: none\n}\n\n.button-container {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.case-study-hero-scetion {\n    background-color: var(--white-smoke);\n    padding-top: 80px\n}\n\n.case-study-hero-text-container {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 48%;\n    max-width: 540px;\n    display: flex\n}\n\n.case-study-hero-image-container {\n    width: 48%;\n    max-width: 520px;\n    position: relative\n}\n\n.case-study-hero-heading {\n    font-size: 52px;\n    line-height: 56px\n}\n\n.case-study-button-rapper {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    max-width: 422px;\n    margin-top: 20px;\n    display: flex\n}\n\n.read-stories-button,\n.success-story-button {\n    align-items: center;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px;\n    display: flex\n}\n\n.arrow-bottom-icon,\n.arrow-right-icon {\n    width: 24px;\n    height: 24px;\n    margin-left: 4px\n}\n\n.case-study-hero-image {\n    width: 100%;\n    height: 500px;\n    width: 500px;\n    object-fit: cover;\n    object-position: \"center\",\n}\n\n.case-study-span-wrapper {\n    align-items: center;\n    margin-bottom: 24px;\n    display: flex\n}\n\n.case-study-hero-pink-line {\n    background-color: var(--pabloo-green);\n    width: 40px;\n    height: 2px;\n    margin-left: 20px\n}\n\n.case-study-hero-pink-text {\n    color: var(--pabloo-green);\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 20px\n}\n\n.case-study-grid {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    height: 100%;\n    display: grid\n}\n\n.case-study-container {\n    width: 100%;\n    max-width: 1100px\n}\n\n.case-study-item-wrapper {\n    background-color: var(--white);\n    border-radius: 10px;\n    width: 100%;\n    max-width: 520px;\n    padding: 24px 24px 28px;\n    transition: all .2s;\n    box-shadow: 7px 7px 80px rgba(0, 0, 0, .05)\n}\n\n.case-study-item-wrapper:hover {\n    transform: translateY(-5px);\n    box-shadow: 7px 7px 80px rgba(0, 0, 0, .1)\n}\n\n.case-study-list-wrapper {\n    width: 100%\n}\n\n.case-study-hero-item-image {\n    border-radius: 10px;\n    width: 100%;\n    height: 100%\n}\n\n.case-study-item-text-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    margin-top: 24px;\n    display: flex\n}\n\n.case-study-item-pink-tag {\n    color: var(--pabloo-green);\n    letter-spacing: .8px;\n    text-transform: uppercase;\n    margin-bottom: 12px;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 20px\n}\n\n.case-study-item-heading {\n    letter-spacing: -.5px;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32px\n}\n\n.case-study-item-para-small {\n    color: rgba(0, 0, 0, .6);\n    letter-spacing: .2px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.track-approval-text-container {\n    width: 45%;\n    max-width: 480px\n}\n\n.track-appoval-image-container {\n    width: 52%;\n    max-width: 640px;\n    position: relative\n}\n\n.track-appoval-image-container._w-md {\n    width: 40%\n}\n\n.track-approval-hero-image {\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.track-approval-item-absolute {\n    border-radius: 8px;\n    width: 60%;\n    max-width: 330px;\n    position: absolute;\n    top: 100px;\n    bottom: auto;\n    left: auto;\n    right: -10%;\n    box-shadow: 14px 14px 80px rgba(0, 0, 0, .08)\n}\n\n.track-approval-icon {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 28px\n}\n\n.multi-channel-approval-section {\n    background-color: var(--white-smoke)\n}\n\n._404-heading {\n    color: var(--black-2);\n    margin-bottom: 20px;\n    font-size: 150px;\n    line-height: 90%\n}\n\n@media (max-width: 768px) {\n    ._404-heading {\n        color: var(--black-2);\n        margin-bottom: 20px;\n        font-size: 80px;\n        line-height: 90%\n    }\n\n}\n\n.multi-channel-image-container {\n    width: 45%;\n    max-width: 500px;\n    position: relative\n}\n\n.multi-channel-text-container {\n    color: var(--dark-violet);\n    width: 48%;\n    max-width: 540px\n}\n\n.multi-channel-item-wrapper {\n    box-shadow: -11px 11px 0 0 var(--pabloo-green);\n    border-radius: 8px;\n    width: 90%;\n    max-width: 360px;\n    position: relative\n}\n\n.multi-channel-item-wrapper.middle {\n    margin-top: 40px;\n    margin-bottom: 40px;\n    margin-left: auto\n}\n\n.multi-channel-hero-item-image {\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.multi-channel-background {\n    width: 90%;\n    max-width: 400px;\n    height: auto\n}\n\n.multi-channel-background.top-right {\n    position: absolute;\n    top: -40px;\n    bottom: auto;\n    left: auto;\n    right: -10%\n}\n\n.multi-channel-background.bottom-left {\n    position: absolute;\n    top: auto;\n    bottom: -50px;\n    left: -10%;\n    right: auto\n}\n\n.workflow-approval-text-wrapper {\n    width: 45%;\n    max-width: 500px\n}\n\n.workflow-approval-image-wrapper {\n    z-index: 0;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    width: 52%;\n    max-width: 680px;\n    height: 100%;\n    display: flex;\n    position: relative;\n    overflow: visible\n}\n\n.fast-track-approval-hero-section {\n    background-color: var(--white-smoke);\n    margin-bottom: 240px;\n    position: relative\n}\n\n.fast-track-approval-h1-heading {\n    margin-bottom: 20px\n}\n\n.fast-track-hero-wrapper {\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 780px;\n    margin-bottom: 80px;\n    display: flex\n}\n\n.fast-track-hero-image-wrapper {\n    z-index: 10;\n    border-radius: 10px;\n    width: 100%;\n    max-width: 820px;\n    margin-bottom: -110px;\n    position: relative;\n    box-shadow: 34px 34px 120px rgba(0, 0, 0, .04)\n}\n\n.fast-track-hero-image-wrapper.track-usage {\n    z-index: 18;\n    box-shadow: none;\n    max-width: 100%\n}\n\n.fast-track-hero-image-wrapper.track-usage.limit-width {\n    max-width: 80%\n}\n\n.fast-track-hero-image-wrapper.resize {\n    box-shadow: none;\n    max-width: 80%\n}\n\n.fast-track-hero-image {\n    border-radius: 0;\n    width: 100%;\n    height: 100%\n}\n\n.fast-track-hero-image.hide--shadows {\n    box-shadow: none;\n    border-radius: 16px\n}\n\n.fast-track-hero-circle {\n    width: 100%;\n    max-width: 450px;\n    height: auto\n}\n\n.fast-track-hero-circle.left {\n    width: 90%;\n    margin-bottom: 5%\n}\n\n.fast-track-hero-circle.right {\n    width: 90%;\n    margin-bottom: 5%;\n    position: relative\n}\n\n.fast-track-hero-circle-wrapper {\n    width: 100%;\n    max-width: 450px;\n    height: auto\n}\n\n.fast-track-hero-circle-wrapper.left {\n    justify-content: flex-end;\n    display: flex;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.fast-track-hero-circle-wrapper.right {\n    justify-content: flex-start;\n    display: flex;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.fast-track-hero-user-element {\n    z-index: 11;\n    width: 100%;\n    max-width: 72px;\n    height: auto;\n    position: absolute\n}\n\n.fast-track-hero-user-element._1 {\n    top: 15%;\n    bottom: auto;\n    left: 35%;\n    right: auto\n}\n\n.fast-track-hero-user-element._1.no-bg {\n    background-color: transparent\n}\n\n.fast-track-hero-user-element._2 {\n    top: auto;\n    bottom: 25%;\n    left: 15%;\n    right: auto\n}\n\n.fast-track-hero-user-element._2.no-bg {\n    background-color: transparent;\n    background-image: none\n}\n\n.fast-track-hero-user-element._3 {\n    top: -15%;\n    bottom: auto;\n    left: auto;\n    right: 15%\n}\n\n.fast-track-hero-user-element._4 {\n    z-index: 1;\n    top: 35%;\n    bottom: auto;\n    left: 45%;\n    right: auto\n}\n\n.fast-track-hero-user-element._4.no-bg {\n    background-color: transparent\n}\n\n.fast-track-hero-user-element._5 {\n    z-index: 1;\n    top: auto;\n    bottom: 20%;\n    left: auto;\n    right: 5%\n}\n\n.fast-track-hero-user-element._5.no-bg {\n    background-color: transparent\n}\n\n.fast-track-hero-user-element.track-usage-1 {\n    z-index: 1;\n    top: 10%;\n    bottom: auto;\n    left: 11%;\n    right: auto\n}\n\n.fast-track-hero-user-element.track-usage-2 {\n    z-index: 1;\n    top: auto;\n    bottom: 25%;\n    left: 25%;\n    right: auto\n}\n\n.track-approval-absolute-image {\n    width: 100%;\n    height: 100%\n}\n\n.workflow-approval-gif {\n    width: 100%;\n    max-width: 476px;\n    height: auto\n}\n\n.case-study-hero-logo-item {\n    width: 45%;\n    max-width: 240px;\n    height: auto\n}\n\n.case-study-hero-logo-item._1 {\n    position: absolute;\n    top: 10%;\n    bottom: auto;\n    left: -15%;\n    right: auto\n}\n\n.case-study-hero-logo-item._2 {\n    position: absolute;\n    top: auto;\n    bottom: 30%;\n    left: auto;\n    right: -8%\n}\n\n.case-study-hero-logo-item._3 {\n    position: absolute;\n    top: auto;\n    bottom: 7%;\n    left: -7%;\n    right: auto\n}\n\n.dropdown-grid {\n    grid-column-gap: 56px;\n    grid-row-gap: 0px\n}\n\n.social-link {\n    opacity: .8;\n    width: 100%;\n    max-width: 28px;\n    transition: opacity .2s\n}\n\n.social-link:hover {\n    opacity: 1\n}\n\n.footer-top-wrapper {\n    justify-content: space-between;\n    align-items: stretch;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 80px;\n    padding-bottom: 80px;\n    display: flex\n}\n\n.footer-column {\n    grid-row-gap: 16px;\n    flex-direction: column;\n    flex: none;\n    align-items: flex-start;\n    display: flex\n}\n\n.footer-grid {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex-wrap: nowrap;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 500px;\n    padding-top: 4px;\n    display: flex\n}\n\n.contain {\n    object-fit: contain\n}\n\n.contain.invert {\n    filter: invert()\n}\n\n.footer-heading {\n    color: #fff;\n    margin-bottom: 4px;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 150%\n}\n\n.footer-left-contain {\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    display: flex\n}\n\n.social-links-contain {\n    grid-column-gap: 24px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    max-width: 100%;\n    display: grid\n}\n\n.footer-links {\n    color: var(--white);\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 100%;\n    text-decoration: none;\n    transition: color .2s;\n    display: block\n}\n\n.footer-links:hover {\n    color: var(--pabloo-green)\n}\n\n.footer-links.hide {\n    display: none\n}\n\n.mobile-only {\n    display: block\n}\n\n.split-section-form-wrapper {\n    margin-top: 0;\n    padding: 60px\n}\n\n.form-field-wrapper {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-start;\n    max-width: none;\n    display: flex\n}\n\n.form-holder {\n    border-style: solid;\n    border-width: 1px 1px 1px 12px;\n    border-color: #f0ebe1 #f0ebe1 #f0ebe1 var(--slate-blue);\n    background-color: #fff;\n    border-radius: 8px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 20px 25px;\n    display: flex;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n}\n\n.review-slide-2 {\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 40px 58px 40px 60px\n}\n\n.doc-one-place-text-container {\n    width: 46%;\n    max-width: 500px\n}\n\n.doc-one-place-image-container {\n    width: 52%;\n    max-width: 640px\n}\n\n.best-deals-section {\n    background-color: var(--white-smoke)\n}\n\n.best-deals-text-container {\n    width: 45%;\n    max-width: 500px\n}\n\n.assisted-tools-text-container {\n    width: 48%;\n    max-width: 580px\n}\n\n.assisted-tools-image-container {\n    width: 46%;\n    max-width: 470px;\n    position: relative\n}\n\n.assisted-purchasing-hero-wrapper {\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 840px;\n    margin-top: 53px;\n    margin-bottom: 80px;\n    display: flex\n}\n\n.assisted-purchasing-hero-wrapper.insights {\n    margin-top: 107px\n}\n\n.assisted-purchasing-hero-wrapper.insights.width-lg {\n    max-width: 100%\n}\n\n.assisted-hero-image-wrapper {\n    border-radius: 10px;\n    width: 100%;\n    max-width: 100%\n}\n\n.assisted-hero-section {\n    padding-bottom: 140px;\n    position: relative\n}\n\n.assisted-hero-item-wrapper {\n    justify-content: flex-end;\n    width: 90%;\n    max-width: 490px;\n    display: flex;\n    position: relative\n}\n\n.assisted-hero-item-wrapper.left {\n    position: absolute;\n    top: auto;\n    bottom: 300px;\n    left: 0%;\n    right: auto\n}\n\n.assisted-hero-item-wrapper.right {\n    justify-content: flex-start;\n    position: absolute;\n    top: auto;\n    bottom: 300px;\n    left: auto;\n    right: 0%\n}\n\n.assisted-hero-item-bg {\n    width: 85%;\n    max-width: 450px\n}\n\n.assisted-hero-office-icon {\n    z-index: 11;\n    border-radius: 50%;\n    width: 90%;\n    max-width: 72px;\n    position: absolute;\n    top: -18%;\n    bottom: auto;\n    left: 10%;\n    right: auto;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .04)\n}\n\n.assisted-hero-bird-icon {\n    z-index: 11;\n    border-radius: 50%;\n    width: 90%;\n    max-width: 80px;\n    position: absolute;\n    top: auto;\n    bottom: 10%;\n    left: 5%;\n    right: auto;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .04)\n}\n\n.assisted-hero-p-icon {\n    z-index: 11;\n    width: 90%;\n    max-width: 96px;\n    position: absolute;\n    top: 30%;\n    bottom: auto;\n    left: 13%;\n    right: auto\n}\n\n.assisted-hero-droupbox-icon {\n    z-index: 11;\n    width: 90%;\n    max-width: 96px;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: 10px\n}\n\n.assisted-hero-z-icon {\n    z-index: 11;\n    width: 90%;\n    max-width: 80px;\n    position: absolute;\n    top: auto;\n    bottom: 10%;\n    left: auto;\n    right: 15%\n}\n\n.assisted-hero-gmail-icon {\n    z-index: 11;\n    border-radius: 50%;\n    width: 90%;\n    max-width: 72px;\n    position: absolute;\n    top: 25%;\n    bottom: auto;\n    left: 60%;\n    right: auto;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .04)\n}\n\n.actionable-insight-text-wrap {\n    width: 42%;\n    max-width: 480px\n}\n\n.actionable-insight-image-wrap {\n    width: 53%;\n    max-width: 680px\n}\n\n.actionable-insight-image-wrap.resize-width {\n    width: 56%\n}\n\n.insight-hero-section {\n    background-color: var(--white-smoke);\n    margin-bottom: 160px;\n    position: relative\n}\n\n.insight-hero-section.track-usage {\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 240px;\n    display: flex\n}\n\n.investor-logo {\n    width: 15%\n}\n\n.investor-logo.investor-logo-rt-demo-custo-styles {\n    justify-content: flex-start;\n    align-items: center;\n    width: 32%;\n    display: flex\n}\n\n.investor-logo.investor-logo-rt-demo-custo-styles.rt-logo {\n    width: 15%\n}\n\n.funding-section {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.bg-pink {\n    background-color: var(--pabloo-green)\n}\n\n.press-section {\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.press-card {\n    background-color: var(--slate-blue);\n    border-radius: 12px;\n    overflow: hidden\n}\n\n.press-card-image-wrapper {\n    width: auto;\n    height: 400px;\n    overflow: hidden\n}\n\n.press-image {\n    width: 100%;\n    height: auto\n}\n\n.press-content-wrapper {\n    grid-row-gap: 20px;\n    flex-direction: column;\n    margin-top: 12px;\n    padding: 20px;\n    display: flex\n}\n\n.press-cta {\n    /* text-decoration: none */\n}\n\n.press-logo-wrapper {\n    width: 150px;\n    height: auto\n}\n\n.text-color-white {\n    color: var(--white);\n    margin-right: 8px;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.news-logos {\n    width: 40%\n}\n\n.insights-hero-image {\n    justify-content: center;\n    align-items: flex-start;\n    width: 85%;\n    max-width: 1120px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 56px;\n    display: flex;\n    position: relative\n}\n\n.insights-hero-image-1 {\n    border-radius: 7px;\n    width: 100%;\n    max-width: 100%;\n    box-shadow: 0 40px 140px rgba(0, 0, 0, .04)\n}\n\n.insights-hero-image-3 {\n    width: 35%;\n    max-width: 450px;\n    margin-bottom: 120px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.insights-hero-image-4 {\n    width: 32%;\n    max-width: 450px;\n    margin-bottom: 84px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.insights-visualize-image {\n    box-shadow: -14px 14px 0 0 var(--pabloo-green);\n    border-radius: 7px\n}\n\n.insights-visualize-image.custo,\n.insights-visualize-image.hide-shadow {\n    box-shadow: none\n}\n\n.hero-heading-wrapper {\n    text-align: center;\n    justify-content: center;\n    max-width: none;\n    margin-bottom: 60px;\n    display: flex\n}\n\n.contract-renewal-image-wrap {\n    width: 48%;\n    max-width: 560px\n}\n\n.contract-document-image-wrap {\n    width: 52%;\n    max-width: 640px\n}\n\n.contract-hero-image-wrap {\n    z-index: 24;\n    width: 100%;\n    max-width: 100%;\n    margin-bottom: -120px;\n    position: relative\n}\n\n.contract-hero-image-wrap.full-width {\n    z-index: 22;\n    max-width: 100%;\n    position: relative\n}\n\n.contract-hero-section {\n    background-color: var(--white-smoke);\n    margin-bottom: 240px;\n    position: relative\n}\n\n.contract-hero-item-wrap {\n    width: 35%;\n    max-width: 450px;\n    position: relative\n}\n\n.contract-hero-item-wrap.left {\n    position: absolute;\n    top: auto;\n    bottom: 3%;\n    left: 10px;\n    right: auto\n}\n\n.contract-hero-item-wrap.right {\n    position: absolute;\n    top: auto;\n    bottom: 3%;\n    left: auto;\n    right: 10px\n}\n\n.contract-hero-bg-image {\n    width: 100%;\n    height: 100%\n}\n\n.contract-hero-logo-item {\n    z-index: 11;\n    position: absolute\n}\n\n.contract-hero-logo-item._3 {\n    border-radius: 505px;\n    width: 20%;\n    max-width: 72px;\n    top: auto;\n    bottom: 50%;\n    left: 30%;\n    right: auto;\n    box-shadow: 7px 7px 40px rgba(0, 0, 0, .04)\n}\n\n.contract-hero-logo-item._2 {\n    background-color: var(--white-smoke);\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    border-radius: 120px;\n    width: 20%;\n    max-width: 80px;\n    top: auto;\n    bottom: 58px;\n    left: 50px;\n    right: auto\n}\n\n.contract-hero-logo-item._1 {\n    width: 20%;\n    max-width: 96px;\n    top: 20px;\n    bottom: auto;\n    left: 0%;\n    right: auto\n}\n\n.contract-hero-logo-item._4 {\n    border-radius: 50%;\n    width: 20%;\n    max-width: 72px;\n    top: -20px;\n    bottom: auto;\n    left: auto;\n    right: 50px;\n    box-shadow: 7px 7px 40px rgba(0, 0, 0, .04)\n}\n\n.contract-hero-logo-item._5 {\n    background-color: var(--white-smoke);\n    width: 20%;\n    max-width: 80px;\n    top: 30%;\n    bottom: auto;\n    left: auto;\n    right: 110px\n}\n\n.contract-hero-logo-item._6 {\n    border-radius: 50%;\n    width: 20%;\n    max-width: 80px;\n    top: auto;\n    bottom: 80px;\n    left: auto;\n    right: 5%;\n    box-shadow: 7px 7px 40px rgba(0, 0, 0, .04)\n}\n\n.procurement-home-item-wrap {\n    border-radius: 10px;\n    width: 100%;\n    max-width: 400px;\n    position: relative\n}\n\n.thank-you-section {\n    background-color: var(--white);\n    align-items: center;\n    height: 80vh;\n    display: flex\n}\n\n.hero-subheading {\n    max-width: 600px;\n    margin-bottom: 20px\n}\n\n.hero-subheading.competitor-landing-usps-subheading {\n    color: var(--white)\n}\n\n.hero-subheading.pargrap {\n    margin-bottom: 40px\n}\n\n.hero-head-container {\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    margin-top: 30px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.hero-head-container.competitor-landing-usp-highlight-section {\n    background-color: var(--black)\n}\n\n.hero-heading {\n    text-align: center\n}\n\n.hero-heading.competitor-landing-usp-highlight-heading {\n    color: var(--white)\n}\n\n.hero-heading-wrapper {\n    flex-wrap: wrap;\n    max-width: 800px;\n    margin-bottom: 40px\n}\n\n.hero-heading-wrapper.letar {\n    margin-bottom: 20px\n}\n\n.hero-heading-wrapper.justify-left {\n    justify-content: flex-start\n}\n\n.home-hero-image-wrapper {\n    width: 46%;\n    max-width: 480px;\n    display: none\n}\n\n.home-hero-image-blue-shadow {\n    box-shadow: 14px 14px 0 0 var(--slate-blue);\n    object-fit: cover;\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.home-hero-text-wrapper {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 800px;\n    margin-top: 40px;\n    margin-bottom: 40px;\n    display: flex\n}\n\n.hello-bar {\n    grid-column-gap: 10px;\n    background-color: var(--pabloo-green);\n    border: 1px rgba(0, 0, 0, .15);\n    justify-content: center;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    display: flex;\n    position: -webkit-sticky;\n    position: sticky;\n    top: auto;\n    bottom: auto;\n    left: 0%;\n    right: 0%;\n    box-shadow: inset 0 1px 12px rgba(0, 0, 0, .13)\n}\n\n.hello-bar.hide {\n    justify-content: center;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    position: relative\n}\n\n.column {\n    flex-wrap: wrap;\n    justify-content: center;\n    height: auto;\n    padding-left: 4%;\n    padding-right: 2%;\n    display: flex\n}\n\n.paragraph-2 {\n    margin-top: 12px;\n    margin-bottom: 24px;\n    font-family: \"P22mackinacpro 15\", sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n    display: none\n}\n\n.div-block {\n    margin-top: 4%;\n    margin-bottom: 8%;\n    padding-left: 0\n}\n\n.div-block.h2 {\n    margin-bottom: 4%\n}\n\n.text-span {\n    color: #d53987\n}\n\n.heading-2 {\n    font-family: Satoshi, sans-serif;\n    font-size: 36px;\n    font-weight: 700;\n    line-height: 42px;\n    display: none\n}\n\n.heading {\n    color: #000;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 56px;\n    line-height: 1.2em\n}\n\n.heading.center {\n    text-align: left\n}\n\n.heading.social {\n    text-align: center\n}\n\n.text-span-2 {\n    color: #d53987;\n    font-family: \"P22mackinacpro 17\", sans-serif\n}\n\n.div-block-2 {\n    border-style: none none none solid;\n    border-width: 1px 1px 1px 12px;\n    border-color: black black black var(--slate-blue);\n    background-color: #fff;\n    border-radius: 8px;\n    width: 88%;\n    max-width: 100%;\n    padding: 16px 32px 40px;\n    box-shadow: 1px 1px 15px rgba(0, 0, 0, .09)\n}\n\n.container-3 {\n    flex-flow: column;\n    justify-content: flex-end;\n    align-items: center;\n    max-width: 76%;\n    height: 100%;\n    max-height: 100%;\n    margin-top: 8%;\n    display: flex;\n    position: static\n}\n\n.container-3.margin-top-0 {\n    max-width: 80%;\n    margin-top: 0%\n}\n\n.body {\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto\n}\n\n.div-block-8 {\n    padding-top: 0;\n    padding-bottom: 16px;\n    display: none\n}\n\n.div-block-9 {\n    border-style: none;\n    border-width: 2px 2px 2px 12px;\n    border-color: var(--pabloo-green);\n    outline-offset: 0px;\n    background-color: transparent;\n    border-radius: 6px;\n    outline: 3px #000;\n    flex-wrap: wrap;\n    align-content: space-around;\n    justify-content: flex-start;\n    margin-right: 16px;\n    padding-bottom: 16px;\n    padding-left: 4px;\n    padding-right: 16px;\n    display: block\n}\n\n.div-block-10 {\n    margin-top: 4%;\n    padding-top: 4px;\n    padding-left: 0\n}\n\n.grid-2 {\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    align-items: center;\n    justify-items: start;\n    margin-top: 6px\n}\n\n.text-block-6 {\n    color: #000;\n    font-family: Satoshi, sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 20px\n}\n\n.heading-3 {\n    display: none\n}\n\n.columns {\n    margin-bottom: 64px\n}\n\n.text-block-7 {\n    color: #fff;\n    font-family: Satoshi, sans-serif;\n    font-size: 14px;\n    font-weight: 500\n}\n\n.div-block-11 {\n    margin-top: 6px;\n    font-family: \"P22mackinacpro 15\", sans-serif\n}\n\n.text-block-8 {\n    color: var(--pabloo-green);\n    text-align: left;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px\n}\n\n.div-block-12 {\n    background-color: var(--light-pink);\n    border-radius: 4px;\n    justify-content: center;\n    width: 100%;\n    margin-top: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 4px 8px 8px;\n    display: flex\n}\n\n.div-block-13 {\n    float: left;\n    clear: none;\n    border: 2px none var(--pabloo-green);\n    object-fit: fill;\n    background-color: transparent;\n    border-radius: 6px;\n    margin-top: 16px;\n    margin-left: 0;\n    padding: 0 0 16px;\n    display: block;\n    position: static\n}\n\n.div-block-13.brand-bg {\n    display: none\n}\n\n.heading-4 {\n    color: var(--slate-blue);\n    line-height: 20px\n}\n\n.heading-4.featured-on-heading {\n    color: var(--pabloo-green);\n    font-size: 16px;\n    line-height: 24px\n}\n\n.div-block-14 {\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 16px;\n    display: flex\n}\n\n.featured-on-logo {\n    margin-left: 0;\n    margin-right: 32px\n}\n\n.div-block-15 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    border-top: 1px rgba(0, 0, 0, .1);\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: stretch;\n    display: flex\n}\n\n.div-block-16 {\n    align-items: flex-start;\n    display: flex\n}\n\n.text-block-9 {\n    color: var(--pabloo-green);\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 16px\n}\n\n.div-block-17 {\n    background-color: rgba(213, 57, 135, .22);\n    border-radius: 4px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2px;\n    margin-left: 8px;\n    padding: 3px 8px;\n    display: flex\n}\n\n.body-2 {\n    background-color: #fff\n}\n\n.div-block-18 {\n    padding-top: 16%;\n    display: none\n}\n\n.heading-5 {\n    color: var(--black);\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 64px;\n    line-height: 72px\n}\n\n.heading-5.custo {\n    font-family: Satoshi, sans-serif;\n    font-size: 3rem;\n    line-height: 1.2em\n}\n\n.heading-5.custo.accent {\n    color: var(--pabloo-green);\n    font-family: Satoshi, sans-serif\n}\n\n.div-block-19 {\n    margin-top: 0\n}\n\n.div-block-20 {\n    margin-top: 0%;\n    padding: 16% 8px 32%;\n    position: relative\n}\n\n.div-block-21 {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 48px;\n    position: static;\n    box-shadow: 1px 1px 24px rgba(0, 0, 0, .1)\n}\n\n.div-block-21.registration-form-block {\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    outline-offset: 0px;\n    background-color: #f0f0f0;\n    border: 12px solid rgba(213, 57, 135, .16);\n    outline: 3px #000;\n    margin-top: 30px;\n    margin-bottom: 0;\n    padding: 16px 20px;\n    box-shadow: 3px 3px 24px rgba(0, 0, 0, .1)\n}\n\n.heading-6 {\n    color: var(--black);\n    text-align: center;\n    margin-bottom: 24px;\n    font-family: Satoshi, sans-serif;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.container-4 {\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    max-width: 85%\n}\n\n.container-4.custo {\n    max-width: 1040px\n}\n\n.div-block-22 {\n    flex-wrap: wrap;\n    margin-top: 24px;\n    display: none\n}\n\n.div-block-23 {\n    background-color: var(--pabloo-green);\n    border-radius: 20px;\n    padding: 8px 20px\n}\n\n.div-block-23.alt-badge {\n    background-color: #fff;\n    margin-left: 12px\n}\n\n.text-block-10 {\n    color: var(--pabloo-green);\n    font-weight: 500\n}\n\n.text-block-10.primary-badge-text {\n    color: #fff\n}\n\n.text-block-11 {\n    color: var(--black);\n    margin-left: 4px;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.text-block-11.roundtable-text {\n    color: var(--black);\n    font-size: 20px\n}\n\n.text-block-11.roundtable-text.sm {\n    color: var(--pabloo-green);\n    font-size: 16px;\n    font-weight: 700\n}\n\n.text-block-11.roundtable-text.sm.black {\n    color: var(--black)\n}\n\n.text-block-11.roundtable-text.pill-text {\n    color: var(--white);\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 700\n}\n\n.text-block-11.xx {\n    color: var(--black);\n    font-size: 16px\n}\n\n.text-block-11.secondary-time {\n    text-transform: uppercase\n}\n\n.div-block-24 {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    margin-top: 22px;\n    margin-right: 8px;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    display: grid\n}\n\n.div-block-24.panel-shadow {\n    grid-column-gap: 0px;\n    grid-row-gap: 4px;\n    border: 2px none var(--light-pink);\n    background-color: var(--white);\n    box-shadow: none;\n    border-radius: 120px;\n    margin-right: 24px;\n    padding: 8px 0\n}\n\n.div-block-24.panel-shadow.hide {\n    display: none\n}\n\n.div-block-24.panel-shadow.xx {\n    background-color: rgba(255, 255, 255, .12)\n}\n\n.div-block-24.panel-shadow.xx.events {\n    border-style: none;\n    border-radius: 4px;\n    box-shadow: 1px 1px 8px rgba(0, 0, 0, .1)\n}\n\n.div-block-24.panel-shadow.xx.events.pad {\n    background-color: var(--white);\n    margin-top: 0;\n    padding-left: 12px;\n    padding-right: 12px\n}\n\n.div-block-24.m-t-32 {\n    margin-top: 32px\n}\n\n.div-block-25 {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 0;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    display: grid\n}\n\n.div-block-25.panel-shadow {\n    grid-column-gap: 4px;\n    grid-row-gap: 4px;\n    border-radius: 4px;\n    padding-left: 12px;\n    padding-right: 12px;\n    box-shadow: 1px 1px 8px rgba(0, 0, 0, .1)\n}\n\n.div-block-25.panel-shadow.custo.xx {\n    background-color: var(--white);\n    padding: 10px\n}\n\n.div-block-25.panel-shadow.custo.xx.m-t-16 {\n    margin-top: 0\n}\n\n.div-block-26 {\n    margin-top: 2px;\n    margin-left: 0\n}\n\n.div-block-27 {\n    z-index: 0;\n    display: block;\n    position: absolute;\n    top: auto;\n    bottom: 72px;\n    left: auto;\n    right: 8px\n}\n\n.div-block-27.hide {\n    display: none\n}\n\n.div-block-28 {\n    padding: 0 51px\n}\n\n.div-block-29 {\n    z-index: auto;\n    background-color: var(--white);\n    background-image: none;\n    min-height: auto;\n    padding-top: 40px;\n    padding-bottom: 60px;\n    position: relative;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.bestsuited-webinarblock {\n    background-color: var(--slate-blue);\n    min-height: auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    position: relative\n}\n\n.heading-7 {\n    color: var(--white);\n    text-align: center;\n    font-family: Satoshi, sans-serif;\n    font-size: 36px;\n    line-height: 1.2em\n}\n\n.div-block-31 {\n    justify-content: center;\n    padding-top: 16px;\n    display: flex\n}\n\n.div-block-31.hide {\n    display: none\n}\n\n.div-block-33 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    justify-items: stretch;\n    margin-top: 40px;\n    margin-left: 0%;\n    padding-left: 12%;\n    padding-right: 12%;\n    display: grid\n}\n\n.grid-3 {\n    grid-column-gap: 8px;\n    grid-row-gap: 16px;\n    border-bottom: 4px none var(--slate-blue);\n    border-left: 12px none var(--slate-blue);\n    background-color: var(--black);\n    border-radius: 16px;\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    padding: 32px\n}\n\n.grid-3.m-l-24 {\n    grid-row-gap: 16px;\n    background-color: var(--black);\n    border: 1px #000;\n    border-radius: 20px;\n    width: 100%;\n    margin-left: 0\n}\n\n.text-block-14 {\n    color: var(--white);\n    font-size: 56px;\n    font-weight: 700;\n    line-height: 56px\n}\n\n.text-block-15 {\n    font-size: 20px;\n    line-height: 20px;\n    display: block\n}\n\n.text-block-16 {\n    color: var(--white);\n    font-size: 24px;\n    line-height: 20px\n}\n\n.div-block-34 {\n    justify-content: center;\n    margin-top: 40px;\n    display: flex\n}\n\n.div-block-34.m-t-24 {\n    margin-top: 124px\n}\n\n.button {\n    background-color: var(--pabloo-green);\n    border-radius: 12px;\n    justify-content: center;\n    align-items: center;\n    width: 280px;\n    height: 64px;\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: 20px;\n    font-weight: 500;\n    display: flex;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n}\n\n.button.round {\n    border-radius: 8px;\n    width: 240px;\n    height: 56px;\n    padding: 12px 16px;\n    font-size: 18px\n}\n\n.button.bigger {\n    border-radius: 8px;\n    width: auto\n}\n\n.div-block-35 {\n    background-color: var(--white);\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    min-height: auto;\n    margin-top: 0;\n    padding-bottom: 0;\n    position: relative\n}\n\n.div-block-36 {\n    background-color: var(--slate-blue);\n    color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62b1a53121d721625b5654cd_pattern-bg.png);\n    background-position: 0 0;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n    padding-top: 64px;\n    padding-bottom: 64px\n}\n\n.div-block-36.why-attend-block {\n    background-color: var(--white);\n    background-image: none;\n    padding-top: 24px;\n    padding-left: 0;\n    display: none\n}\n\n.div-block-36.pink {\n    background-color: var(--white-smoke);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62b1a53121d721625b5654cd_pattern-bg.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-attachment: fixed;\n    padding-top: 32px;\n    padding-bottom: 32px\n}\n\n.heading-8 {\n    color: var(--black);\n    font-family: Satoshi, sans-serif;\n    font-size: 1.8rem;\n    line-height: 1.2em\n}\n\n.text-block-17 {\n    color: #fff;\n    font-size: 20px;\n    font-weight: 500;\n    display: none\n}\n\n.grid-4 {\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    margin-bottom: 24px\n}\n\n.text-block-18 {\n    color: #fff;\n    font-size: 25px;\n    line-height: 32px\n}\n\n.text-block-18.sm {\n    font-size: 24px\n}\n\n.div-block-37 {\n    margin-top: 16px\n}\n\n.div-block-38 {\n    border-right: 24px none var(--pabloo-green);\n    background-color: transparent;\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    border-bottom-right-radius: 0;\n    padding: 32px 50px\n}\n\n.cta-button-roundtable {\n    background-color: var(--white);\n    color: var(--slate-blue);\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    width: 280px;\n    height: 64px;\n    padding: 0;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n    display: flex\n}\n\n.cta-button-roundtable.cta-button-roundtable-pink {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    border-radius: 8px\n}\n\n.cta-button-roundtable.pink {\n    color: var(--pabloo-green)\n}\n\n.div-block-39 {\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-top: 32px;\n    padding-right: 0;\n    display: flex\n}\n\n.div-block-39.hide {\n    display: none\n}\n\n.div-block-40 {\n    height: auto;\n    position: relative;\n    overflow: hidden\n}\n\n.container-5 {\n    max-width: 85%;\n    padding-top: 120px;\n    padding-bottom: 160px\n}\n\n.div-block-41 {\n    flex-wrap: wrap;\n    align-self: center;\n    align-items: center;\n    height: 100%;\n    margin-top: 0;\n    padding-left: 0;\n    display: flex\n}\n\n.div-block-42 {\n    width: 100%;\n    margin-top: 16px\n}\n\n.div-block-44 {\n    width: 100%;\n    margin-top: 8px;\n    display: none\n}\n\n.div-block-45 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    width: 100%;\n    margin-top: 8px;\n    display: grid\n}\n\n.text-block-20 {\n    font-size: 16px;\n    display: none;\n    overflow: visible\n}\n\n.text-block-21 {\n    font-size: 18px;\n    font-weight: 500\n}\n\n.image-7 {\n    object-fit: contain;\n    border-radius: 0;\n    width: auto;\n    max-width: 100%;\n    max-height: none;\n    display: block;\n    position: static;\n    top: -32px;\n    bottom: auto;\n    left: -64px;\n    right: auto\n}\n\n.div-block-46 {\n    position: static\n}\n\n.column-2 {\n    align-items: center;\n    display: flex\n}\n\n.text-block-22 {\n    color: var(--black);\n    font-size: 16px;\n    font-weight: 500\n}\n\n.text-block-22.blk {\n    color: var(--black)\n}\n\n.column-5 {\n    z-index: 1\n}\n\n.column-6 {\n    padding-top: 2%;\n    padding-left: 0;\n    padding-right: 0\n}\n\n.map {\n    border-radius: 16px;\n    display: none\n}\n\n.div-block-51 {\n    align-items: center;\n    padding-top: 4px;\n    display: flex\n}\n\n.div-block-52 {\n    position: absolute;\n    top: -16%;\n    bottom: auto;\n    left: auto;\n    right: -9%\n}\n\n.div-block-53 {\n    z-index: -1;\n    display: none;\n    position: absolute;\n    top: auto;\n    bottom: 64px;\n    left: -25%;\n    right: -25%\n}\n\n.div-block-54 {\n    align-items: center;\n    display: flex\n}\n\n.image-11,\n.image-12 {\n    display: none\n}\n\n.div-block-57 {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-items: stretch;\n    padding-top: 16px;\n    display: block\n}\n\n.text-block-24 {\n    font-weight: 400\n}\n\n.hero-points-rt {\n    background-color: transparent;\n    border-radius: 8px;\n    margin-left: auto;\n    margin-right: 8px;\n    padding: 4px 20px 16px 4px\n}\n\n.rt-hero-text {\n    color: var(--black);\n    font-family: Satoshi, sans-serif;\n    font-size: 22px;\n    font-weight: 500;\n    line-height: 32px\n}\n\n.ebook-hero-points-short {\n    flex-wrap: wrap;\n    align-items: stretch;\n    margin-top: 0;\n    display: flex\n}\n\n.ebook-hero-points-short.block {\n    display: block\n}\n\n.ebook-hero-points-short.m-t-16 {\n    margin-top: 16px\n}\n\n.text-span-9 {\n    color: var(--pabloo-green);\n    font-size: 24px;\n    font-weight: 900\n}\n\n.div-block-59 {\n    z-index: 0;\n    background-color: var(--pabloo-green);\n    color: var(--pabloo-green);\n    border-radius: 100%;\n    width: 240px;\n    height: 240px;\n    display: none;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 50%;\n    right: auto\n}\n\n.columns-3 {\n    z-index: 1;\n    position: relative\n}\n\n.container-6 {\n    max-width: 1040px\n}\n\n.div-block-60 {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    background-color: transparent;\n    border-radius: 2px;\n    grid-template-rows: auto auto;\n    grid-template-columns: auto auto;\n    grid-auto-columns: 1fr;\n    align-items: stretch;\n    margin-top: 8px;\n    padding: 24px;\n    display: none\n}\n\n.text-span-11 {\n    color: var(--black);\n    font-family: Satoshi, sans-serif\n}\n\n.heading-9 {\n    color: var(--black);\n    text-align: left;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 28px\n}\n\n.heading-10 {\n    color: var(--black);\n    margin-bottom: 24px\n}\n\n.heading-10.xx {\n    margin-top: 0;\n    margin-bottom: 16px;\n    font-size: 22px\n}\n\n.heading-10.text-white {\n    color: var(--white);\n    margin-bottom: 40px;\n    font-size: 32px\n}\n\n.paragraph-3 {\n    color: var(--black);\n    white-space: pre-line;\n    margin-top: 16px;\n    margin-bottom: 16px\n}\n\n.div-block-61 {\n    background-color: var(--pabloo-green);\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.div-block-61.pink {\n    display: none\n}\n\n.div-block-61.white {\n    background-color: var(--white);\n    padding-bottom: 40px\n}\n\n.div-block-61.white.m-t-40 {\n    margin-top: 0;\n    padding-top: 0;\n    padding-bottom: 20px\n}\n\n.div-block-61.white.p-t-40 {\n    margin-bottom: 43px;\n    padding-top: 40px;\n    padding-left: 50px;\n    padding-right: 50px\n}\n\n.div-block-61.white.p-t-40.m-b-0 {\n    padding-bottom: 0\n}\n\n.columns-4 {\n    align-items: stretch;\n    display: flex\n}\n\n.button-2 {\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    border-radius: 2px;\n    margin-left: 0;\n    padding: 22px 32px;\n    font-size: 20px;\n    font-weight: 700\n}\n\n.button-2.rt-footer-cta {\n    border-radius: 16px;\n    margin-left: 32px\n}\n\n.button-2.xx {\n    background-color: #05254a\n}\n\n.button-2.y {\n    background-color: var(--slate-blue)\n}\n\n.heading-11 {\n    color: var(--black);\n    font-family: Satoshi, sans-serif;\n    font-size: 1.8rem;\n    line-height: 1.2em\n}\n\n.column-8 {\n    justify-content: center;\n    align-items: flex-start;\n    display: flex\n}\n\n.column-9 {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.div-block-62 {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.text-span-12 {\n    color: var(--pabloo-green)\n}\n\n.container-7 {\n    max-width: 1040px\n}\n\n.div-block-63 {\n    flex-flow: wrap;\n    align-items: flex-start;\n    margin-top: 0;\n    display: flex\n}\n\n.div-block-63.hide {\n    display: none\n}\n\n.div-block-64 {\n    flex-wrap: wrap;\n    align-items: center;\n    display: flex\n}\n\n.div-block-65 {\n    width: 42%;\n    padding-left: 4%;\n    display: none\n}\n\n.home-hero-logos-wrap {\n    justify-content: flex-start;\n    width: 100%;\n    margin-bottom: 24px;\n    display: flex\n}\n\n.home-hero-logos-wrap.gs {\n    margin-bottom: 24px\n}\n\n.home-hero-logo-container {\n    background-color: #fff;\n    border-radius: 4px;\n    justify-content: flex-start;\n    align-items: center;\n    margin-right: 24px;\n    padding: 12px 16px;\n    display: flex;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .09)\n}\n\n.home-hero-logo-container.darger-bg {\n    background-color: var(--black-2)\n}\n\n.home-hero-logo-container.jungle-bg {\n    background-color: #010171\n}\n\n.div-block-66 {\n    align-items: center;\n    margin-right: 24px;\n    display: flex\n}\n\n.div-block-66.x-block {\n    display: none\n}\n\n.div-block-67 {\n    align-items: center;\n    margin-right: 24px;\n    display: flex\n}\n\n.text-span-13 {\n    color: var(--pabloo-green)\n}\n\n.link-block {\n    background-color: var(--white);\n    border-radius: 4px;\n    align-items: center;\n    padding: 8px 16px;\n    display: none\n}\n\n.text-block-26 {\n    margin-left: 8px\n}\n\n.button-3 {\n    background-color: var(--pabloo-green);\n    border-radius: 4px;\n    margin-left: 16px;\n    padding: 14px 16px;\n    font-weight: 500;\n    display: none\n}\n\n.heading-13 {\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 48px;\n    line-height: 64px\n}\n\n.container-8 {\n    max-width: 85%\n}\n\n.div-block-68,\n.div-block-69 {\n    margin-bottom: 16px;\n    display: none\n}\n\n.image-16,\n.image-17 {\n    height: 32px\n}\n\n.text-span-15 {\n    color: var(--pabloo-green)\n}\n\n.text-span-16 {\n    color: var(--slate-blue);\n    font-size: 40px\n}\n\n.section {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    padding-left: 0;\n    padding-right: 0;\n    display: grid\n}\n\n.section.grid-2 {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-columns: 1fr .5fr\n}\n\n.section-2 {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-70 {\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.heading-14 {\n    margin-top: 8px;\n    margin-bottom: 0;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 20px\n}\n\n.heading-15 {\n    color: rgba(0, 0, 0, .61);\n    letter-spacing: normal;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n    font-family: Satoshi, sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px\n}\n\n.text-span-17 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 17\", sans-serif\n}\n\n.heading-16 {\n    color: rgba(0, 0, 0, .61);\n    text-transform: uppercase;\n    margin-bottom: 4px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px\n}\n\n.div-block-72 {\n    margin-top: 24px\n}\n\n.slack-step-text {\n    letter-spacing: normal;\n    font-size: 20px;\n    line-height: 26px\n}\n\n.text-span-18 {\n    color: var(--pabloo-green)\n}\n\n.slack-step-image-container {\n    margin-bottom: 16px\n}\n\n.text-span-19,\n.text-span-20 {\n    color: var(--pabloo-green)\n}\n\n.goldman-sachs {\n    height: 48px\n}\n\n.goldman-sachs.accel {\n    height: 32px\n}\n\n.paragraph-12 {\n    width: 72%;\n    margin-top: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 140%\n}\n\n.text-span-30 {\n    color: var(--slate-blue);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.list-5 {\n    margin-top: 16px;\n    padding-left: 16px\n}\n\n.text-span-31 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.list-6 {\n    margin-top: 16px;\n    padding-left: 16px\n}\n\n.text-span-32 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.white-text {\n    color: var(--white);\n    margin-right: 4px;\n    font-weight: 500\n}\n\n.div-block-96 {\n    flex-wrap: wrap;\n    display: flex\n}\n\n.image-21 {\n    max-width: none;\n    height: 48px\n}\n\n.div-block-97 {\n    background-color: #f9a8d4;\n    border-radius: 100%;\n    width: 320px;\n    height: 320px;\n    position: absolute;\n    top: 8%;\n    bottom: auto;\n    left: 12%;\n    right: auto\n}\n\n.div-block-97.hide {\n    display: block\n}\n\n.div-block-98 {\n    -webkit-backdrop-filter: blur(20px)blur(20px);\n    backdrop-filter: blur(20px)blur(20px);\n    -webkit-text-fill-color: inherit;\n    mix-blend-mode: normal;\n    background-color: rgba(255, 255, 255, .72);\n    background-clip: border-box;\n    padding-top: 8%\n}\n\n.div-block-98.pb-md {\n    padding-bottom: 4%\n}\n\n.div-block-98.pb-md.pt-sm {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62f295f65cac0a38a49e99e4_ezgif.com-gif-maker.webp);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 100%;\n    min-height: 88vh;\n    padding-top: 4%\n}\n\n.div-block-98.pb-md.pt-sm.flex {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64a7e7a6656a76b25ff7b627_62f295f65cac0a38a49e99e4_ezgif.com-gif-maker.webp.png);\n    background-size: cover;\n    justify-content: center;\n    align-items: center;\n    padding-top: 12%;\n    display: flex\n}\n\n.blog-subscription-container {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 2.25fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 40px;\n    padding: 24px 16px;\n    display: block\n}\n\n.heading-36 {\n    margin-bottom: 8px;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 48px\n}\n\n.landing-nav {\n    background-color: var(--white);\n    padding-top: 20px;\n    padding-bottom: 20px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0\n}\n\n.landing-nav.competitor-landing-nav {\n    z-index: 10;\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.div-block-100 {\n    background-color: var(--black)\n}\n\n.div-block-101 {\n    flex-flow: wrap;\n    justify-content: space-around;\n    align-items: stretch;\n    width: 80%;\n    margin-top: 80px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 20px;\n    display: flex\n}\n\n.div-block-102 {\n    grid-column-gap: 4px;\n    grid-row-gap: 4px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    width: 29%;\n    margin-top: 40px;\n    display: grid\n}\n\n.div-block-102.child {\n    margin-top: 40px;\n    margin-left: 0\n}\n\n.div-block-102.child.no-left {\n    margin-left: 0\n}\n\n.div-block-103 {\n    justify-content: flex-start;\n    align-items: stretch;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    display: flex\n}\n\n.heading-38 {\n    text-align: center;\n    width: 100%;\n    font-size: 48px;\n    line-height: 60px\n}\n\n.heading-39 {\n    color: rgba(0, 0, 0, .55);\n    text-align: center;\n    width: 100%;\n    margin-top: 24px;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500\n}\n\n.text-block-37,\n.text-block-38,\n.text-block-39,\n.text-block-40,\n.text-block-42,\n.text-block-43 {\n    color: var(--black-2);\n    text-align: left;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.section-5 {\n    background-color: var(--white-smoke)\n}\n\n.text-span-40 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.div-block-104 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--white);\n    border-radius: 8px;\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 40px;\n    padding: 32px;\n    display: grid;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .08)\n}\n\n.div-block-105 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 48px 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.image-22 {\n    width: 40px;\n    height: 40px\n}\n\n.paragraph-14 {\n    text-align: left\n}\n\n.heading-40 {\n    text-align: left;\n    margin-top: 0\n}\n\n.div-block-106 {\n    width: 100%;\n    margin-top: 40px\n}\n\n.paragraph-15 {\n    font-family: Satoshi, sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 36px\n}\n\n.text-span-42 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.heading-41 {\n    width: 100%\n}\n\n.div-block-107 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: 24px 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    width: 100%;\n    margin-top: 8px;\n    display: grid\n}\n\n.div-block-107.first {\n    width: 100%;\n    margin-top: 24px\n}\n\n.image-23 {\n    width: 24px;\n    height: 24px\n}\n\n.div-block-108 {\n    flex-flow: wrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    margin-top: 0;\n    display: flex\n}\n\n.div-block-109 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    width: 100%;\n    margin-top: 40px;\n    display: grid\n}\n\n.text-block-44,\n.text-block-45,\n.text-block-46,\n.text-block-47 {\n    font-size: 20px;\n    font-weight: 400\n}\n\n.paragraph-16,\n.paragraph-17,\n.paragraph-18 {\n    font-size: 16px;\n    line-height: 22px\n}\n\n.heading-42 {\n    width: 100%\n}\n\n.list-7 {\n    margin-top: 40px;\n    padding-left: 0;\n    list-style-type: none\n}\n\n.list-item-9,\n.list-item-10 {\n    margin-bottom: 24px;\n    font-size: 20px\n}\n\n.list-item-11 {\n    font-size: 20px\n}\n\n.div-block-111 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.section-6 {\n    background-color: var(--white-smoke)\n}\n\n.text-span-43,\n.text-span-44 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.div-block-112 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--white-smoke);\n    grid-template-rows: auto;\n    grid-template-columns: .5fr 1fr;\n    grid-auto-columns: 1fr;\n    padding: 16px;\n    display: grid\n}\n\n.paragraph-19 {\n    margin-bottom: 8px;\n    font-weight: 400\n}\n\n.div-block-113 {\n    background-color: var(--white);\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-left: 8px;\n    padding-right: 8px;\n    display: flex\n}\n\n.text-span-45 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.competitor-landing-hero-grid {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.75fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    padding-top: 100px;\n    padding-bottom: 100px;\n    display: grid\n}\n\n.competitor-landing-hero-content {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-content: space-between;\n    display: grid\n}\n\n.competitor-landing-hero-form {\n    border-left: 12px none var(--slate-blue);\n    background-color: var(--white);\n    border-radius: 8px;\n    flex-wrap: wrap;\n    justify-content: center;\n    padding: 24px;\n    display: block;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n}\n\n.competitor-landing-hero-form.minimal-fields {\n    background-color: var(--white);\n    margin-top: 0\n}\n\n.competitor-landing-hero-form.add-p-md {\n    padding: 24px\n}\n\n.competitor-landing-hero-heading {\n    margin-top: 32px\n}\n\n.html-embed-4 {\n    margin-left: auto;\n    margin-right: auto;\n    display: block\n}\n\n.competitor-landing-hero-section {\n    height: auto;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.heading-44 {\n    font-family: Satoshi, sans-serif;\n    font-size: 64px;\n    line-height: 1.2em\n}\n\n.paragraph-20 {\n    text-align: left;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.4em\n}\n\n.button-6 {\n    background-color: var(--pabloo-green);\n    border-radius: 8px;\n    padding: 12px 16px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500\n}\n\n.button-6.w--current {\n    border-radius: 8px;\n    padding-top: 12px;\n    padding-bottom: 12px\n}\n\n.text-span-51 {\n    color: var(--pabloo-green)\n}\n\n.div-block-115 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: var(--white);\n    background-image: radial-gradient(circle farthest-corner at 100% 100%, var(--pabloo-green), var(--white)45%);\n    border-radius: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 70% 30%;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid;\n    position: relative;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .06)\n}\n\n.div-block-116 {\n    background-color: transparent;\n    border-top-right-radius: 24px;\n    border-bottom-right-radius: 24px;\n    flex: 0 auto;\n    justify-content: flex-end;\n    align-self: auto;\n    align-items: stretch;\n    width: 100%;\n    height: 340px;\n    max-height: 340px;\n    display: flex;\n    position: static;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.div-block-116.uc-image-wrapper {\n    background-color: transparent;\n    justify-content: center\n}\n\n.div-block-118 {\n    display: none\n}\n\n.text-block-48 {\n    color: var(--black);\n    font-size: 16px\n}\n\n.image-27 {\n    border-bottom-right-radius: 24px;\n    margin-top: 28px\n}\n\n.image-27.urban-company {\n    border-bottom-right-radius: 24px;\n    padding-right: 0\n}\n\n.review-author-name-2 {\n    color: #000;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.5\n}\n\n.auto-slider-arrow-left-2 {\n    background-color: transparent;\n    border-radius: 50px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    padding: 10px 5px;\n    transition: background-color .3s;\n    display: none;\n    position: absolute;\n    top: auto;\n    bottom: -20px;\n    left: auto;\n    right: 100px\n}\n\n.auto-slider-arrow-left-2:hover {\n    background-color: #fff\n}\n\n.mention-span-2 {\n    color: #d53987\n}\n\n.review-slider-text-2 {\n    color: #000;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 22px;\n    font-weight: 400;\n    line-height: 1.3\n}\n\n.text-block-49 {\n    color: #000;\n    font-size: 16px;\n    line-height: 22px\n}\n\n.div-block-119 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: #fff;\n    background-image: radial-gradient(circle at 100% 100%, #d53987, #fff 45%);\n    border-radius: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 70% 30%;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid;\n    position: relative;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .06)\n}\n\n.div-block-120 {\n    padding-bottom: 32px\n}\n\n.header-bullet-point {\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    display: flex\n}\n\n.h1-heading {\n    color: var(--black);\n    letter-spacing: normal;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 64px;\n    font-weight: 600;\n    line-height: 1\n}\n\n.header-grid {\n    grid-column-gap: 72px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.2fr 1fr;\n    align-items: start\n}\n\n.container-regular {\n    width: 100%;\n    max-width: 1060px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.header-feature-block {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    color: #fff;\n    align-items: center;\n    font-size: 16px;\n    line-height: 24px;\n    display: flex\n}\n\n.header-section {\n    background-color: var(--white);\n    align-items: center;\n    height: auto;\n    min-height: 90vh;\n    padding: 80px 5% 48px;\n    display: flex;\n    position: relative\n}\n\n.div-block-122 {\n    border-left: 12px solid var(--slate-blue);\n    -webkit-backdrop-filter: blur(15px);\n    backdrop-filter: blur(15px);\n    background-color: rgba(255, 255, 255, .12);\n    border-radius: 8px;\n    margin-top: 0;\n    padding: 32px;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n}\n\n.feature-section {\n    padding: 80px 5% 40px\n}\n\n.h3-heading {\n    color: var(--black);\n    letter-spacing: -.02em;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 40px;\n    font-weight: 500;\n    line-height: 48px\n}\n\n.feature-detail {\n    color: #333b47;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.feature-grid-large {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr\n}\n\n.feature-grid-large._3-grid {\n    grid-template-columns: 1fr 1fr 1fr\n}\n\n.feature-heading-wrapper {\n    grid-column-gap: 44px;\n    grid-row-gap: 24px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: flex-end;\n    margin-bottom: 64px;\n    display: flex\n}\n\n.feature-heading-bold {\n    color: #000;\n    margin-bottom: 8px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px\n}\n\n.container-12 {\n    width: 100%;\n    max-width: 1060px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.feature-content-small {\n    margin-top: 32px\n}\n\n.feature-icon {\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    display: flex\n}\n\n.feature-banner {\n    color: #454f5f;\n    border-top: 1px solid #dce0e5;\n    margin-top: 64px;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px\n}\n\n.paragraph-large {\n    color: rgba(0, 0, 0, .6);\n    text-align: center;\n    letter-spacing: -.02em;\n    margin-top: 8px;\n    margin-bottom: 16px;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 32px\n}\n\n.paragraph-large.left {\n    text-align: left\n}\n\n.container-large {\n    width: 100%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.container-large.career {\n    margin-top: 64px\n}\n\n.margin-bottom-32 {\n    align-items: flex-start;\n    margin-bottom: 32px;\n    display: flex\n}\n\n.paragraph-small {\n    color: var(--black);\n    letter-spacing: -.01em;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px\n}\n\n.authors-wrapper {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-wrap: wrap;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto;\n    grid-auto-columns: 1fr;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 0;\n    padding-left: 0;\n    display: grid\n}\n\n.authors-wrapper.hide {\n    display: none\n}\n\n.company-logo-2 {\n    max-width: none;\n    height: 32px;\n    margin-left: 0;\n    margin-right: 16px;\n    display: block\n}\n\n.company-logo-2._1 {\n    background-color: var(--white);\n    height: 44px;\n    margin-left: 0\n}\n\n.company-logo-2._1.nivas {\n    height: 200px;\n    padding: 0 0%\n}\n\n.company-logo-2.dan {\n    height: 200px\n}\n\n.company-logo-2.dan.lg {\n    height: 180px\n}\n\n.header-wrapper-2 {\n    z-index: 2;\n    background-color: var(--white);\n    padding-top: 64px;\n    position: relative\n}\n\n.ebook-points-heading {\n    color: var(--black);\n    margin-top: 16px;\n    margin-bottom: 24px;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px\n}\n\n.ebook-points-heading.points-heading {\n    color: #000;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.image-wrapper {\n    z-index: 1;\n    border-left: 12px solid var(--slate-blue);\n    -webkit-backdrop-filter: blur(16px);\n    backdrop-filter: blur(16px);\n    background-color: rgba(255, 255, 255, .24);\n    border-radius: 8px;\n    margin-left: 32px;\n    margin-right: 32px;\n    padding: 32px;\n    position: relative;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .12)\n}\n\n.image-wrapper.darl-mode {\n    background-color: var(--white);\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none\n}\n\n.trusted-text {\n    color: rgba(0, 0, 0, .8);\n    text-align: left;\n    margin-top: 40px;\n    margin-bottom: 24px;\n    font-weight: 500\n}\n\n.hero-heading-2 {\n    color: var(--black);\n    letter-spacing: -.03em;\n    margin-top: 0;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 53px;\n    line-height: 72px\n}\n\n.hero-heading-2.color {\n    color: var(--pabloo-green)\n}\n\n.header-grid-3 {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .75fr;\n    align-items: start\n}\n\n.container-13 {\n    flex: 0 auto;\n    align-self: auto;\n    width: 100%;\n    max-width: 1140px;\n    height: 100%;\n    min-height: 80vh;\n    max-height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.container-13.remove-bg {\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto\n}\n\n.div-block-123 {\n    padding-top: 4%\n}\n\n.header-section-3 {\n    background-color: var(--white);\n    align-items: center;\n    min-height: 91vh;\n    padding: 80px 3% 64px;\n    display: flex;\n    position: relative\n}\n\n.header-section-3.with-bg {\n    background-image: url(https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: 40%;\n    align-items: flex-start;\n    padding-top: 24px;\n    padding-bottom: 24px\n}\n\n.process-heading {\n    color: #000;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 46px;\n    font-weight: 700;\n    line-height: 1.3\n}\n\n.shape-wrapper {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 4px;\n    display: flex\n}\n\n.line-break {\n    border: 1px dashed #d9d9d9;\n    width: 100%;\n    height: 2px\n}\n\n.process-title-wrap {\n    text-align: center;\n    max-width: 1000px;\n    margin-bottom: 40px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.process-block {\n    text-align: center;\n    border-radius: 30px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    position: relative\n}\n\n.process-container {\n    max-width: 1260px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.number-large {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 80px;\n    font-weight: 600;\n    line-height: 80px;\n    position: absolute;\n    top: -24px\n}\n\n.number-large.medium {\n    font-size: 24px;\n    line-height: 32px;\n    top: -20px\n}\n\n.process-paragraph {\n    color: #999;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.process-title {\n    color: #262626;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 1.2\n}\n\n.process-grid {\n    grid-column-gap: 14px;\n    grid-row-gap: 100px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .25fr 1fr;\n    align-items: center\n}\n\n.title-small {\n    color: #8e8e8e;\n    letter-spacing: 2px;\n    margin-bottom: 16px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 28px\n}\n\n.process-section {\n    background-color: #fff;\n    padding: 100px 5%\n}\n\n.feature-card {\n    text-align: center;\n    border: 1px solid #e5e5e5;\n    border-radius: 20px;\n    flex-direction: column;\n    align-items: center;\n    padding: 50px 24px 8px;\n    display: flex\n}\n\n.features-container {\n    max-width: 1440px;\n    margin-top: 25px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 60px;\n    padding-right: 60px;\n    display: inline-block\n}\n\n.team-heading {\n    color: #161616;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 24px;\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 1.3\n}\n\n.feature-section-2 {\n    color: #858585;\n    background-color: #fff;\n    padding: 140px 3%\n}\n\n.features-wrap {\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.feature-icon-wrap {\n    background-color: rgba(238, 42, 82, .05);\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n    width: 110px;\n    height: 110px;\n    margin-bottom: 32px;\n    padding: 18px;\n    display: flex\n}\n\n.features-paragraph {\n    margin-bottom: 24px;\n    font-size: 18px;\n    line-height: 27px\n}\n\n.features-button {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    text-align: center;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    margin-top: 0;\n    padding: 12px 16px;\n    font-size: 18px;\n    font-weight: 500;\n    text-decoration: none;\n    transition: background-position .3s;\n    display: flex\n}\n\n.features-button:hover {\n    background-position: 90%\n}\n\n.features-button.ab {\n    background-color: #e65a41\n}\n\n.features-button.hide {\n    display: none\n}\n\n.features-button.brand {\n    background-color: var(--slate-blue);\n    color: var(--white);\n    padding-left: 16px;\n    padding-right: 16px\n}\n\n.feature-card-name {\n    color: #161616;\n    margin-top: 0;\n    margin-bottom: 14px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 27px\n}\n\n.features-grid {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-right: 60px;\n    font-size: 14px;\n    display: grid;\n    position: relative\n}\n\n.features-heading-wrap {\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 350px;\n    display: flex\n}\n\n.form-block {\n    margin-top: 32px;\n    margin-bottom: 16px\n}\n\n.section-regular {\n    background-color: var(--white);\n    padding: 80px 5%;\n    position: relative\n}\n\n.section-regular.nobg {\n    background-color: var(--white)\n}\n\n.section-regular.middle-band {\n    background-color: var(--pabloo-green);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/638dc96dbb6b67e15aff47f2_middleband-bg.svg);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: auto\n}\n\n.section-regular.middle-band.blue {\n    background-color: #011b4d\n}\n\n.section-regular.m-b-80 {\n    margin-bottom: 0\n}\n\n.container-regular-2 {\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: hidden\n}\n\n.form-wrapper-2 {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.paragraph-regular {\n    letter-spacing: -.02em;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.integration-wrapper {\n    width: 100%\n}\n\n.title-wrapper {\n    position: relative\n}\n\n.integration {\n    color: #02044a;\n    text-align: center;\n    letter-spacing: -.03em;\n    background-color: #fff;\n    border-radius: 20px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-width: 290px;\n    height: 100%;\n    min-height: 64px;\n    margin-left: 15px;\n    margin-right: 15px;\n    padding: 8px 20px;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 28px;\n    text-decoration: none;\n    display: flex;\n    box-shadow: 46px 46px 72px 2px rgba(43, 29, 103, .08)\n}\n\n.title {\n    color: var(--pabloo-green);\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 28px\n}\n\n.container-14 {\n    width: 100%;\n    max-width: 1400px;\n    margin-top: 32px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.integration-row {\n    justify-content: center;\n    align-items: stretch;\n    margin-bottom: 30px;\n    display: flex;\n    position: static\n}\n\n.integration-logo {\n    width: 88px;\n    margin-bottom: 0\n}\n\n.integration-logo.accel {\n    width: 72px\n}\n\n.integration-logo.sp {\n    width: 140px\n}\n\n.integration-logo.together {\n    width: 90px\n}\n\n.title-wrap-2 {\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 650px;\n    margin-bottom: 0;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.integration-row-bottom {\n    justify-content: center;\n    align-items: stretch;\n    width: 100%;\n    display: flex;\n    position: static;\n    left: 0\n}\n\n.cta-wrapper {\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 720px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.margin-bottom-24 {\n    margin-bottom: 24px\n}\n\n.cta-block {\n    width: 100%\n}\n\n.text-span-57 {\n    color: var(--pabloo-green)\n}\n\n.text-span-57.ab {\n    color: #e65a41\n}\n\n.bloom-image-effect-2 {\n    z-index: -1;\n    min-width: 60%;\n    max-width: 70%;\n    display: none;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.text-block-55 {\n    color: #000;\n    font-size: 24px;\n    font-weight: 500;\n    display: none\n}\n\n.text-span-59 {\n    color: var(--pabloo-green)\n}\n\n.heading-62 {\n    text-align: left;\n    margin-left: 0;\n    margin-right: 0\n}\n\n.heading-62.left {\n    text-align: left\n}\n\n.heading-62.left.sm {\n    font-size: 36px\n}\n\n.heading-62.pink {\n    color: var(--slate-blue);\n    margin-left: 12px;\n    margin-right: 0\n}\n\n.heading-62.center {\n    text-align: center\n}\n\n.heading-62.center.scheme {\n    color: var(--slate-blue)\n}\n\n.header-feature-3 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-columns: 1fr;\n    margin-top: 64px;\n    margin-bottom: 32px\n}\n\n.text-block-56,\n.text-block-57,\n.text-block-58 {\n    color: var(--black);\n    font-size: 20px;\n    font-weight: 500\n}\n\n.text-span-60 {\n    color: var(--pabloo-green)\n}\n\n.button-wrapper-3 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-top: 32px;\n    display: flex\n}\n\n.flex-wrapper-centre {\n    z-index: 5;\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 720px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: relative\n}\n\n.margin-bottom-12 {\n    margin-bottom: 12px\n}\n\n.image-cover {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.image-cover.not-in-mobile {\n    object-fit: cover;\n    overflow: visible\n}\n\n.image-cover.mobile-only {\n    display: none\n}\n\n.heading-detail-small {\n    color: var(--pabloo-green);\n    letter-spacing: .08em;\n    text-transform: uppercase;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.header-placeholder-top {\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    height: 420px;\n    margin-bottom: 32px;\n    display: flex;\n    overflow: hidden\n}\n\n.button-neutral {\n    background-color: var(--pabloo-green);\n    outline-offset: 0px;\n    color: #fff;\n    text-align: center;\n    letter-spacing: -.02em;\n    border-radius: 8px;\n    outline: 2px solid transparent;\n    justify-content: center;\n    align-items: center;\n    min-width: 120px;\n    min-height: 48px;\n    padding: 12px 16px;\n    font-size: 14px;\n    text-decoration: none;\n    transition: background-color .3s;\n    display: flex\n}\n\n.button-neutral:hover {\n    background-color: rgba(213, 57, 135, .9)\n}\n\n.section-large {\n    padding: 0 5% 120px;\n    position: relative\n}\n\n.text-block-59 {\n    font-size: 16px;\n    font-weight: 500\n}\n\n.image-30 {\n    max-width: 20%;\n    display: none\n}\n\n.image-cover-2 {\n    object-fit: cover;\n    object-position: 50% 50%;\n    background-color: #f0f1f4;\n    width: 100%;\n    height: 100%\n}\n\n.image-cover-2.yellow {\n    background-color: var(--goldenrod)\n}\n\n.image-cover-2.pink {\n    background-color: var(--pabloo-green);\n    background-color: #d53987\n}\n\n.div-block-125 {\n    z-index: 110;\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    color: var(--black);\n    background-color: rgba(0, 0, 0, .75);\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: center;\n    width: 100vw;\n    height: 100vh;\n    display: none;\n    position: fixed;\n    top: 0\n}\n\n.div-block-126 {\n    background-color: var(--white);\n    border-radius: 16px;\n    width: 48%;\n    min-height: 120px;\n    margin: 4% auto auto;\n    padding: 32px;\n    position: relative\n}\n\n.div-block-127 {\n    padding-top: 8px;\n    padding-bottom: 24px;\n    position: relative\n}\n\n.heading-63 {\n    margin-top: 0;\n    margin-bottom: 8px\n}\n\n.paragraph-33 {\n    color: var(--pabloo-green)\n}\n\n.link-block-2 {\n    position: absolute;\n    top: 16px;\n    bottom: auto;\n    left: auto;\n    right: 16px\n}\n\n.text-block-60 {\n    color: rgba(0, 0, 0, .5);\n    font-size: 14px;\n    line-height: 16px\n}\n\n.paragraph-34 {\n    color: rgba(0, 0, 0, .55);\n    margin-top: 16px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.text-span-61 {\n    color: var(--pabloo-green);\n    font-weight: 700\n}\n\n.text-span-62,\n.text-span-63 {\n    color: var(--pabloo-green)\n}\n\n.white-button {\n    color: #0a0a0b;\n    background-color: #fff;\n    padding: 22px 40px;\n    font-size: 18px;\n    line-height: 1em;\n    transition: color .35s, transform .35s, background-color .35s\n}\n\n.white-button:hover {\n    color: #fff;\n    background-color: #1154ff;\n    transform: translateY(-3px)\n}\n\n.section-10 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.section-10.p-b-0 {\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.saas-cfo-webinar-logo {\n    height: 40px\n}\n\n.div-block-140 {\n    justify-content: center;\n    margin-top: 80px;\n    display: flex\n}\n\n.text-span-64 {\n    color: var(--pabloo-green)\n}\n\n.html-embed-7 {\n    align-items: center;\n    display: flex\n}\n\n.html-embed-8,\n.icon-embed {\n    margin-top: 4px\n}\n\n.div-block-143 {\n    background-color: var(--white);\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.div-block-144 {\n    padding: 4% 16%\n}\n\n.text-block-65 {\n    color: rgba(255, 255, 255, .65);\n    text-align: center\n}\n\n.div-block-145 {\n    background-color: var(--white);\n    border-radius: 8px;\n    margin-top: 40px;\n    padding: 24px 40px 40px;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, .12)\n}\n\n.submit-button {\n    background-color: var(--pabloo-green);\n    opacity: .57;\n    cursor: not-allowed;\n    border-radius: 12px;\n    width: 320px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 16px 56px;\n    font-weight: 500\n}\n\n.div-block-146 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-147 {\n    width: auto\n}\n\n.div-block-148 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-149 {\n    justify-content: center;\n    margin-top: 24px;\n    display: flex\n}\n\n.field-label-2,\n.field-label-3,\n.field-label-4,\n.field-label-5,\n.field-label-6 {\n    color: rgba(0, 0, 0, .4);\n    font-size: 16px\n}\n\n.heading-70 {\n    text-align: center;\n    margin-bottom: 40px;\n    font-size: 24px\n}\n\n.text-field-2,\n.text-field-3,\n.text-field-4,\n.text-field-5 {\n    padding: 24px 16px;\n    font-size: 16px;\n    line-height: 32px\n}\n\n.select-field-2 {\n    background-color: var(--white);\n    height: 50px;\n    padding-top: 4px;\n    font-size: 16px\n}\n\n.html-embed-9,\n.html-embed-10 {\n    margin-top: 6px\n}\n\n.success-message-4 {\n    background-color: rgba(25, 255, 0, .32);\n    border-radius: 4px\n}\n\n.cta-image-2 {\n    z-index: 0;\n    object-fit: cover;\n    width: 50%;\n    height: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.cta-button-wrapper {\n    grid-column-gap: 16px;\n    align-items: center;\n    margin-top: 64px;\n    margin-bottom: 16px;\n    display: flex\n}\n\n.cta-button-wrapper.mt-24 {\n    margin-top: 24px\n}\n\n.section-cta {\n    background-color: #f7f9fd;\n    padding: 80px 0% 80px 5%;\n    position: relative\n}\n\n.section-cta.hide {\n    display: block\n}\n\n.section-cta.pr-5p {\n    padding-right: 5%\n}\n\n.cta-heading-wrap {\n    z-index: 1;\n    max-width: 100%;\n    position: relative\n}\n\n.cta-heading {\n    color: var(--black);\n    letter-spacing: -.04em;\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-left: 16px;\n    font-size: 52px;\n    line-height: 56px\n}\n\n.cta-heading.ml-0 {\n    margin-left: 0\n}\n\n.heading-detail {\n    color: #8e8e8e;\n    letter-spacing: .02em;\n    text-transform: uppercase;\n    white-space: normal;\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 25px\n}\n\n.button-cta-primary {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    text-align: center;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    min-height: 52px;\n    padding: 14px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-decoration: none;\n    display: flex\n}\n\n.button-cta-primary.vendor {\n    background-color: var(--pabloo-green)\n}\n\n.button-cta-secondary {\n    border: 2px solid var(--pabloo-green);\n    color: #1c2122;\n    text-align: center;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    min-height: 52px;\n    padding: 14px 24px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-decoration: none;\n    display: flex\n}\n\n.text-span-67,\n.text-block-66 {\n    color: var(--pabloo-green)\n}\n\n.div-block-152 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-153 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: #fff;\n    border-top: 2px rgba(0, 0, 0, .07);\n    border-radius: 0;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 0;\n    padding: 12px 8px;\n    display: grid\n}\n\n.div-block-153:hover {\n    background-color: rgba(213, 57, 135, .05)\n}\n\n.div-block-153.margin-top-reset {\n    margin-top: 0\n}\n\n.div-block-153.margin-top-reset:hover {\n    background-color: rgba(213, 57, 135, .05)\n}\n\n.div-block-153.margin-top-reset.no-border {\n    border-top-style: none;\n    padding-top: 12px\n}\n\n.div-block-154 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    border-right: 2px rgba(0, 0, 0, .07);\n    flex-wrap: wrap;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-content: flex-start;\n    align-items: center;\n    display: grid\n}\n\n.paragraph-38 {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px\n}\n\n.div-block-156 {\n    background-color: #0f1444;\n    border-radius: 8px;\n    align-items: center;\n    display: flex\n}\n\n.div-block-156.white-bg {\n    background-color: var(--goldenrod);\n    background-color: #ebb82f\n}\n\n.text-block-68 {\n    color: var(--pabloo-green);\n    font-size: 16px;\n    text-decoration: none\n}\n\n.image-33 {\n    object-fit: cover;\n    border-radius: 8px;\n    height: 100%\n}\n\n.div-block-157 {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.div-block-158 {\n    width: 100%\n}\n\n.avatar-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    align-items: center;\n    display: flex\n}\n\n.avatar-wrapper._2 {\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    background-color: transparent;\n    background-image: none;\n    align-items: flex-start;\n    padding-left: 8px;\n    padding-right: 8px\n}\n\n.avatar-regular {\n    background-color: #f3f5fb;\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.avatar-regular.small {\n    width: 40px;\n    height: 40px\n}\n\n.avatar-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.avatar-name {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.avatar-name.small {\n    font-size: 15px;\n    line-height: 24px\n}\n\n.avatar-role {\n    color: #6b7094;\n    font-size: 16px\n}\n\n.avatar-role.small {\n    font-size: 11px;\n    line-height: 20px\n}\n\n.div-block-159 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    display: flex\n}\n\n.div-block-159.stack {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    margin-top: 16px\n}\n\n.div-block-159.stack.hide {\n    display: none\n}\n\n.alert-small {\n    color: #160042;\n    background-color: #fff;\n    border-radius: 8px;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 340px;\n    padding: 4px 16px 4px 0;\n    display: flex;\n    box-shadow: 35px 35px 50px -20px rgba(57, 59, 106, .14)\n}\n\n.alert-small.hide-shadow {\n    box-shadow: none;\n    background-color: transparent;\n    max-width: 100%\n}\n\n.alert-wrapper {\n    align-self: auto;\n    align-items: center;\n    display: flex\n}\n\n.alert-warning {\n    color: #f93;\n    background-color: #fff9f0;\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 16px;\n    min-width: auto;\n    height: 16px;\n    min-height: auto;\n    margin-right: 16px;\n    display: flex\n}\n\n.icon-alert {\n    justify-content: center;\n    align-self: auto;\n    align-items: center;\n    width: 24px;\n    height: 24px;\n    display: flex\n}\n\n.heading-71 {\n    margin-bottom: 20px\n}\n\n.content-grid {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.margin-bottom-08 {\n    margin-bottom: 8px\n}\n\n.margin-bottom-08.text-weight-medium {\n    font-weight: 500\n}\n\n.h3-heading-2 {\n    letter-spacing: -.02em;\n    font-size: 48px;\n    line-height: 1.2\n}\n\n.h3-heading-2.text-weight-medium {\n    font-weight: 500\n}\n\n.content-icon-square {\n    color: #4255bd;\n    background-color: #f4f5fb;\n    border: 1px solid #b3bbe5;\n    border-radius: 14px;\n    justify-content: center;\n    align-items: center;\n    width: 52px;\n    height: 52px;\n    display: flex\n}\n\n.content-icon-red {\n    background-color: #fef1f1;\n    border: 1px solid #f5a3a3;\n    border-radius: 14px;\n    justify-content: center;\n    align-items: center;\n    width: 52px;\n    height: 52px;\n    display: flex\n}\n\n.content-icon-large {\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    display: flex\n}\n\n.content-heading-wrapper {\n    margin-bottom: 72px\n}\n\n.content-icon-green {\n    border: 1px #b3e5c3;\n    border-radius: 14px;\n    justify-content: center;\n    align-items: center;\n    width: 52px;\n    height: 52px;\n    display: flex\n}\n\n.content-icon-orange {\n    background-color: #fff9f0;\n    border: 1px solid #fcd49c;\n    border-radius: 14px;\n    justify-content: center;\n    align-items: center;\n    width: 52px;\n    height: 52px;\n    display: flex\n}\n\n.container-15 {\n    z-index: 5;\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.content-icon-gray {\n    background-color: #f7f7f7;\n    border: 1px solid #e6e6e6;\n    border-radius: 14px;\n    justify-content: center;\n    align-items: center;\n    width: 52px;\n    height: 52px;\n    display: flex\n}\n\n.grid-two-column-2 {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr\n}\n\n.section-large-2 {\n    background-color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6244f42f88a11de61a8be252_Group%20223.svg);\n    background-position: 100%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding: 80px 5%;\n    position: relative\n}\n\n.section-large-2.nobg {\n    background-color: var(--white);\n    background-image: none\n}\n\n.section-large-2.blackbg {\n    background-color: var(--white-smoke);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/632ae3ea4736271c5ea83563_bg-element-wire-1.svg);\n    background-position: 120% 115%;\n    background-repeat: no-repeat;\n    background-size: 160px;\n    padding-top: 160px;\n    padding-bottom: 80px\n}\n\n.content-card {\n    color: #1a1a1a;\n    border-radius: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 24px;\n    display: flex\n}\n\n.content-card.content-green {\n    background-color: #f4fbf6\n}\n\n.content-card.content-blue {\n    background-color: #f4f5fb\n}\n\n.content-card.content-yellow {\n    background-color: #fffcf0\n}\n\n.paragraph-small-2 {\n    letter-spacing: -.01em;\n    font-size: 14px;\n    line-height: 24px;\n    display: none\n}\n\n.sub-heading-regular {\n    color: rgba(26, 26, 26, .64);\n    letter-spacing: -.03em;\n    margin-top: 4px;\n    font-size: 18px;\n    line-height: 32px\n}\n\n.content-icon-yellow {\n    background-color: #fffcf0;\n    border: 1px solid #fcec9c;\n    border-radius: 14px;\n    justify-content: center;\n    align-items: center;\n    width: 52px;\n    height: 52px;\n    display: flex\n}\n\n.content-image {\n    border: 1px solid #e6e6e6;\n    border-radius: 20px;\n    height: 100%;\n    overflow: hidden\n}\n\n.paragraph-39 {\n    color: rgba(0, 0, 0, .6);\n    font-weight: 500;\n    line-height: 32px\n}\n\n.badge-wrapper {\n    justify-content: flex-start;\n    margin-bottom: 8px;\n    display: flex\n}\n\n.badge-standard {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    border-radius: 50px;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 20px;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex\n}\n\n.text-block-69 {\n    color: #fff;\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 500\n}\n\n.link-block-3 {\n    height: 100%\n}\n\n.heading-wrapper {\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 720px;\n    margin: 39px auto 8px;\n    display: flex\n}\n\n.grid-three-column {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr\n}\n\n.paragraph-large-2 {\n    color: var(--white);\n    letter-spacing: -.02em;\n    font-size: 20px;\n    line-height: 32px\n}\n\n.testimoial-container {\n    background-color: transparent;\n    flex-flow: wrap;\n    flex: 0 auto;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 40px 0%;\n    display: flex;\n    position: relative;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.d-128-3d-card-wrapper {\n    perspective: 1000px;\n    cursor: pointer;\n    width: 320px;\n    height: 300px;\n    margin-bottom: 32px;\n    margin-left: 15px;\n    margin-right: 15px;\n    position: relative;\n    overflow: visible;\n    box-shadow: 1px 1px 12px rgba(0, 0, 0, .1)\n}\n\n.slide {\n    width: 100%;\n    height: 100%;\n    padding-left: 300px;\n    padding-right: 40px;\n    position: relative\n}\n\n.ck-button-w {\n    color: #fff;\n    text-align: center;\n    background-color: #515750;\n    border-radius: 0;\n    padding: .875em 1.5em 1rem;\n    font-size: .9375rem;\n    text-decoration: none;\n    transition: color .2s cubic-bezier(.25, .46, .45, .94), background-color .2s cubic-bezier(.25, .46, .45, .94)\n}\n\n.ck-button-w:hover {\n    background-color: #262926\n}\n\n.ck-button-w.is--secondary {\n    color: #515750;\n    background-color: transparent;\n    margin-right: -1.25em;\n    padding-left: 1.25em;\n    padding-right: 1.25em;\n    font-size: .875rem;\n    font-weight: 700\n}\n\n.ck-button-w.is--secondary:hover {\n    color: #262926;\n    /* text-decoration: none */\n}\n\n.ck-button-w.is--secondary.is--fullwidth {\n    margin-top: .75rem;\n    margin-bottom: -1rem;\n    margin-right: 0\n}\n\n.ck-button-w.is--fullwidth {\n    flex: none;\n    width: 100%\n}\n\n.ck-title {\n    color: #262926;\n    margin-bottom: .1875em;\n    font-size: 1.25rem;\n    font-weight: 700\n}\n\n.ck-title.is--small {\n    font-size: 1.1875rem\n}\n\n.ck-txt-link {\n    transition: color .15s cubic-bezier(.25, .46, .45, .94)\n}\n\n.ck-sr__only {\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    position: absolute;\n    overflow: hidden\n}\n\n.ck-modal__content-w {\n    padding: 1.75rem 2rem\n}\n\n.ck-modal__content-w.is--small {\n    padding: 1.5rem\n}\n\n.ck-cookie-w {\n    z-index: 9500;\n    max-width: 25rem;\n    position: fixed;\n    top: auto;\n    bottom: 1.25rem;\n    left: auto;\n    right: 1.25rem\n}\n\n.ck-modal__exit-btn {\n    z-index: 5;\n    cursor: pointer;\n    background-color: #fdf5f9;\n    border-radius: .25rem;\n    justify-content: center;\n    align-items: center;\n    width: 2.5rem;\n    height: 2.5rem;\n    margin: 1.25rem 1.25rem -2.5rem auto;\n    transition: background-color .2s cubic-bezier(.25, .46, .45, .94);\n    display: flex;\n    position: relative\n}\n\n.ck-modal__exit-btn.is--sticky {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 1rem\n}\n\n.ck-css-styles {\n    display: none\n}\n\n.ck__exitbtn__line {\n    background-color: #515750;\n    width: 1rem;\n    height: 2px;\n    position: absolute\n}\n\n.ck__exitbtn__line.is--left {\n    transform: rotate(45deg)\n}\n\n.ck__exitbtn__line.is--right {\n    transform: rotate(-45deg)\n}\n\n.ck-modal__btns-w {\n    background-color: #f3f7f2;\n    border-radius: 0 0 .25rem .25rem;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 2rem;\n    display: flex\n}\n\n.ck-modal__btns-w.is--small {\n    background-color: #fdf5f9;\n    justify-content: flex-start;\n    padding: 1.5rem\n}\n\n.ck-modal__btns-w.in-pref-manger {\n    background-color: #fdf5f9;\n    margin: 2rem -2rem -2.25rem\n}\n\n.ck-modal {\n    background-color: #fff;\n    border-radius: .25rem;\n    flex-direction: column;\n    max-width: 32rem;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: .9375rem;\n    line-height: 1.4;\n    display: none;\n    position: relative;\n    box-shadow: 0 4px 1rem rgba(38, 41, 38, .05)\n}\n\n.ck-preference-w {\n    z-index: 9525;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: none;\n    position: fixed;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.ck-radio-w {\n    color: #999c98;\n    cursor: pointer;\n    margin-top: 1rem;\n    margin-bottom: 0;\n    padding-left: 1.75rem;\n    transition: color .15s cubic-bezier(.25, .46, .45, .94)\n}\n\n.ck-radio-w.is--not-allowed {\n    cursor: not-allowed\n}\n\n.text-block {\n    width: 1px;\n    height: 1px;\n    margin: -1px;\n    position: absolute;\n    overflow: hidden\n}\n\n.ck-preference__scroll-w {\n    width: 100%;\n    max-height: 100%;\n    padding-left: 2rem;\n    padding-right: 2rem;\n    position: relative;\n    overflow: auto\n}\n\n.ck-radio__label {\n    color: #262926;\n    cursor: pointer;\n    margin-bottom: .25rem;\n    font-size: .9375rem;\n    font-weight: 600\n}\n\n.ck-radio__desc {\n    cursor: pointer;\n    font-size: .875rem;\n    font-weight: 400\n}\n\n.ck-radio__btn {\n    float: left;\n    border: 1.75px solid #999c98;\n    border-radius: .375rem;\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-top: 0;\n    margin-left: -1.75rem;\n    transition: background-color .2s cubic-bezier(.25, .46, .45, .94)\n}\n\n.ck-radio__btn.w--redirected-checked {\n    background-color: #515750;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/63199fbef7162204cd0d425e_radio__checkmark.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: .625rem;\n    border: 1px solid #515750;\n    border-radius: .375rem;\n    width: 1.25rem;\n    height: 1.25rem;\n    margin-top: 0\n}\n\n.ck-radio__btn.w--redirected-focus {\n    box-shadow: none\n}\n\n.ck-radio__btn.is--checked {\n    background-color: #515750;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/63199fbef7162204cd0d425e_radio__checkmark.svg);\n    background-position: 45%;\n    background-repeat: no-repeat;\n    background-size: .625rem;\n    border-color: #515750\n}\n\n.ck-form {\n    padding-top: 1.25rem;\n    padding-bottom: .5rem\n}\n\n.ck-preference__bg {\n    opacity: 1;\n    -webkit-backdrop-filter: blur(.5rem);\n    backdrop-filter: blur(.5rem);\n    cursor: pointer;\n    background-color: rgba(215, 231, 213, .5);\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.ck-form-w {\n    margin-bottom: 0\n}\n\n.ck-prefmanager-w {\n    z-index: 9475;\n    color: #262926;\n    text-decoration: none;\n    display: flex;\n    position: fixed;\n    bottom: 0;\n    left: 1.25rem\n}\n\n.ck-prefmanager-w:hover {\n    /* text-decoration: none */\n}\n\n.ck-preference__btn {\n    color: #262926;\n    background-color: #fcf5f9;\n    border-radius: .5rem .5rem 0 0;\n    align-items: center;\n    margin-bottom: -.125rem;\n    padding: .75em 1em .875em;\n    font-size: .9375rem;\n    font-weight: 700;\n    line-height: 1;\n    text-decoration: none;\n    transition: margin-bottom .2s cubic-bezier(.25, .46, .45, .94);\n    display: flex\n}\n\n.ck-preference__btn:hover {\n    margin-bottom: 0;\n    /* text-decoration: none */\n}\n\n.ck-preference__icon {\n    flex: none;\n    width: 1.125rem;\n    height: 1.125rem;\n    margin-right: .375rem\n}\n\n.modal-section {\n    z-index: 12000;\n    color: #9aaebc;\n    background-color: rgba(0, 0, 0, .4);\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 150px 3%;\n    font-size: 18px;\n    line-height: 27px;\n    display: none;\n    position: fixed;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    overflow: auto\n}\n\n.modal-link {\n    color: #9aaebc;\n    letter-spacing: 1px;\n    margin-top: 16px;\n    font-size: 16px;\n    font-weight: 600;\n    text-decoration: none;\n    transition: color .3s;\n    position: static;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: 1%\n}\n\n.modal-link:hover {\n    color: var(--pabloo-green)\n}\n\n.modal-paragraph {\n    color: rgba(0, 0, 0, .72);\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.modal-container {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: #fff;\n    border-radius: 0;\n    flex-flow: row;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-self: center;\n    align-items: center;\n    justify-items: center;\n    max-width: 960px;\n    height: auto;\n    max-height: none;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0;\n    display: flex;\n    position: -webkit-sticky;\n    position: sticky\n}\n\n.modal-content {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 52%;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 20px;\n    padding-right: 20px;\n    display: flex\n}\n\n.modal-heading {\n    color: var(--black);\n    text-align: center;\n    letter-spacing: -.02em;\n    width: 100%;\n    margin-top: 0;\n    margin-bottom: 14px;\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 48px\n}\n\n.modal-image-large {\n    background-color: var(--pabloo-green);\n    object-fit: contain;\n    border-radius: 0;\n    margin-right: 40px\n}\n\n.modal-image-large.blue-bg {\n    object-fit: cover;\n    background-color: #b90062;\n    width: 100%\n}\n\n.modal-buttons-wrap {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.grid-cta {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.4fr 1fr;\n    align-items: center\n}\n\n.button-neutral-2 {\n    background-color: var(--slate-blue);\n    outline-offset: 0px;\n    color: var(--white);\n    text-align: center;\n    letter-spacing: -.02em;\n    border-radius: 48px;\n    outline: 2px solid transparent;\n    justify-content: center;\n    align-items: center;\n    min-width: 120px;\n    min-height: 48px;\n    padding: 12px 32px;\n    font-size: 14px;\n    text-decoration: none;\n    transition: background-color .3s;\n    display: flex\n}\n\n.button-neutral-2:hover {\n    background-color: #3838d6;\n    flex-wrap: wrap\n}\n\n.button-neutral-2.pink-bg {\n    background-color: var(--pabloo-green);\n    border-radius: 8px;\n    padding-left: 16px;\n    padding-right: 16px;\n    font-size: 18px\n}\n\n.cta-placeholder {\n    object-fit: fill;\n    width: 100%\n}\n\n.text-block-70 {\n    font-size: 18px;\n    font-weight: 700\n}\n\n.heading-74,\n.heading-74.text-black {\n    color: var(--white)\n}\n\n.bold-text-4 {\n    color: var(--pabloo-green)\n}\n\n.paragraph-40 {\n    color: var(--light-slate-grey)\n}\n\n.div-block-161 {\n    background-color: var(--white-smoke);\n    border-radius: 6px;\n    padding: 8px\n}\n\n.section-11 {\n    width: 100%;\n    margin-bottom: 0;\n    padding: 24px 0 0\n}\n\n.paragraph-large-4 {\n    color: var(--black-2);\n    letter-spacing: -.02em;\n    font-size: 20px;\n    line-height: 32px\n}\n\n.flex-wrapper-centre-2 {\n    z-index: 5;\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: relative\n}\n\n.heading-77 {\n    color: var(--black);\n    line-height: 80px\n}\n\n.text-span-73 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.testimonial-paragraph {\n    color: var(--black)\n}\n\n.testimonial-title-wrapper {\n    max-width: 500px;\n    margin-bottom: 60px\n}\n\n.testimonial-slider {\n    background-color: transparent;\n    width: 100%;\n    height: auto\n}\n\n.sub-heading {\n    color: var(--pabloo-green);\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    margin-bottom: 24px;\n    font-weight: 600\n}\n\n.testimonial-section-2 {\n    padding: 80px 8%;\n    position: relative\n}\n\n.testimonial-container-2 {\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-164 {\n    background-color: var(--white-smoke);\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    background-attachment: scroll;\n    padding-left: 8%;\n    padding-right: 8%;\n    position: relative\n}\n\n.div-block-165 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.social-grid {\n    z-index: 2;\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--white-smoke);\n    border: 2px solid #ebebeb;\n    border-radius: 160px;\n    grid-template-rows: auto;\n    grid-template-columns: 40px 40px;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n    margin-top: -20px;\n    padding: 8px 24px 0;\n    display: flex;\n    position: relative\n}\n\n.social-grid.hide {\n    display: none\n}\n\n.video-3 {\n    display: block\n}\n\n.section-12 {\n    background-color: var(--slate-blue)\n}\n\n.section-small {\n    background-color: var(--white);\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    padding: 64px 5% 24px\n}\n\n.section-small.custo {\n    padding-left: 0%;\n    padding-right: 0%\n}\n\n.flex-wrapper-centre-3 {\n    z-index: 5;\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 700px;\n    margin-bottom: 48px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: relative\n}\n\n.flex-wrapper-centre-3.margin-bottom-48 {\n    margin-bottom: 24px\n}\n\n.flex-wrapper-centre-3.margin-bottom-48.custo {\n    align-items: flex-start;\n    margin-bottom: 24px\n}\n\n.h6-heading {\n    letter-spacing: -.02em;\n    margin-top: 0;\n    font-size: 32px;\n    line-height: 1.5\n}\n\n.h6-heading.custo {\n    text-align: left;\n    font-size: 42px;\n    line-height: 1.3\n}\n\n.grid-four-column {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-wrap: wrap;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-flow: row;\n    justify-content: center;\n    justify-items: stretch;\n    display: flex\n}\n\n.grid-four-column.custo {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    align-content: stretch;\n    justify-content: flex-start;\n    align-items: stretch\n}\n\n.logo-block {\n    background-color: var(--white);\n    box-shadow: none;\n    border-radius: 6px;\n    justify-content: center;\n    align-items: center;\n    min-height: 64px;\n    padding: 4px 24px;\n    display: flex\n}\n\n.logo-block.custo {\n    min-height: 60px\n}\n\n.logo-block.cult {\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.logo-block.px-8 {\n    padding-left: 12px;\n    padding-right: 12px\n}\n\n.image-40 {\n    filter: grayscale();\n    height: 32px\n}\n\n.image-40.small {\n    height: 24px\n}\n\n.image-40._4g {\n    height: 40px\n}\n\n.client-logo {\n    filter: grayscale();\n    height: 30px\n}\n\n.client-logo.mind-tickle-logo-resize {\n    height: 28px;\n    line-height: 28px\n}\n\n.client-logo.mind-tickle-logo-resize.small {\n    height: 16px\n}\n\n.client-logo.curefit-logo-resize {\n    height: 56px\n}\n\n.client-logo.curefit-logo-resize.small.custo {\n    height: 30px\n}\n\n.client-logo.curefit-logo-resize.small.custo.rapido {\n    height: 34px\n}\n\n.client-logo.small {\n    height: 22px\n}\n\n.client-logo.big {\n    height: 80px\n}\n\n.client-logo.big.momnt {\n    filter: invert()grayscale();\n    height: 68px\n}\n\n.client-logo.md {\n    height: 48px\n}\n\n.text-span-77 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.link-block-4 {\n    display: none\n}\n\n.html-embed-12 {\n    margin-top: 40px\n}\n\n.bold-text-7 {\n    line-height: 72px\n}\n\n.text-span-78 {\n    color: var(--pabloo-green)\n}\n\n.text-span-79 {\n    color: var(--slate-blue);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.text-span-80 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.text-span-81 {\n    color: var(--slate-blue);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.text-span-82 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.text-span-83 {\n    color: var(--slate-blue);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.div-block-167 {\n    display: none;\n    position: absolute;\n    top: 24%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.image-41 {\n    border-bottom-right-radius: 26px\n}\n\n.image-41.wodify {\n    object-fit: cover;\n    align-self: flex-end;\n    height: 80%;\n    margin-right: -5px\n}\n\n.image-42 {\n    border-bottom-right-radius: 2px\n}\n\n.testimonial-line {\n    margin-left: 11px;\n    margin-right: 11px\n}\n\n.testimonial-role {\n    color: #acb4c3;\n    font-size: 14px;\n    line-height: 24px\n}\n\n.testimonial-bottom-wrapper {\n    grid-column-gap: 24px;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 8px;\n    display: flex\n}\n\n.grid-team-slider {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1.7fr\n}\n\n.quote-icon {\n    z-index: -1;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.social-square {\n    color: #07090d;\n    border: 1px solid #edeff2;\n    border-radius: 4px;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n    transition: border-color .3s;\n    display: flex\n}\n\n.social-square:hover {\n    border-color: #c3c9d5\n}\n\n.title-wrapper-regular {\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 640px;\n    margin-bottom: 60px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.title-wrapper-regular.custo {\n    align-items: flex-start;\n    max-width: 100%;\n    margin-bottom: 32px\n}\n\n.testimonial-name {\n    color: #07090d;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 24px\n}\n\n.back-button {\n    color: #07090d;\n    border-radius: 6px;\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    transition: color .2s, background-color .2s;\n    display: flex;\n    top: auto;\n    bottom: -20%;\n    left: auto;\n    right: 60px\n}\n\n.back-button:hover {\n    background-color: var(--pabloo-green);\n    color: #fff\n}\n\n.h3-heading-3 {\n    color: #07090d;\n    letter-spacing: -.02em;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 44px;\n    font-weight: 600;\n    line-height: 60px\n}\n\n.h3-heading-3.custo {\n    text-align: left;\n    font-size: 42px;\n    line-height: 1.3\n}\n\n.next-button-2 {\n    color: #07090d;\n    border-radius: 6px;\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    transition: color .2s, background-color .2s;\n    display: flex;\n    top: auto;\n    bottom: -20%;\n    left: auto;\n    right: 0%\n}\n\n.next-button-2:hover {\n    background-color: var(--pabloo-green);\n    color: #fff\n}\n\n.slide-nav-hiddle {\n    display: none\n}\n\n.section-testimonial {\n    background-color: #fff;\n    padding: 80px 5% 140px;\n    display: block;\n    position: relative;\n    overflow: hidden\n}\n\n.section-testimonial.unhide {\n    padding: 32px 0%;\n    display: block\n}\n\n.testimonial-social-wrapper {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    align-items: center;\n    display: flex\n}\n\n.margin-bottom-33 {\n    margin-bottom: 16px\n}\n\n.slider-testimonial {\n    background-color: transparent;\n    width: 100%;\n    height: 100%\n}\n\n.testimonial-name-wrapper {\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 40px;\n    display: flex\n}\n\n.container-16 {\n    z-index: 5;\n    width: 100%;\n    max-width: 1160px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 80px;\n    position: relative\n}\n\n.icon-regular-2 {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.testimonial-content-wrapper {\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 24px;\n    padding-bottom: 0;\n    display: flex;\n    position: relative\n}\n\n.h6-heading-2 {\n    color: #07090d;\n    font-size: 18px;\n    line-height: 32px\n}\n\n.span-primary {\n    color: #1457ff\n}\n\n.div-block-168 {\n    position: relative\n}\n\n.div-block-169 {\n    background-color: var(--slate-blue);\n    width: 100%;\n    height: 50%;\n    position: absolute\n}\n\n.image-43 {\n    position: relative\n}\n\n.image-44 {\n    width: 100%;\n    position: relative\n}\n\n.div-block-170 {\n    position: relative\n}\n\n.navigation-wrapper {\n    grid-column-gap: 8px;\n    align-items: center;\n    display: flex\n}\n\n.navigation-3 {\n    background-color: #fff;\n    align-items: center;\n    width: 100%;\n    min-height: 88px;\n    padding: 24px 5%;\n    display: flex\n}\n\n.navigation-avatar-wrapper {\n    grid-column-gap: 16px;\n    align-items: center;\n    display: flex\n}\n\n.navigation-link-icon {\n    grid-column-gap: 44px;\n    color: #160042;\n    border-radius: 8px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 16px;\n    text-decoration: none;\n    transition: background-color .3s;\n    display: flex\n}\n\n.navigation-link-icon:hover {\n    background-color: #f7f9fd\n}\n\n.logo-link-large {\n    margin-right: 24px\n}\n\n.logo-2 {\n    width: 124px\n}\n\n.navigation-menu-2 {\n    align-items: center;\n    display: flex;\n    position: static\n}\n\n.navigation-container-3 {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.navigation-icon-arrow {\n    margin-right: 10px\n}\n\n.navigation-link-icon-2 {\n    grid-column-gap: 44px;\n    color: #000;\n    border-radius: 16px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 16px;\n    text-decoration: none;\n    transition: background-color .3s;\n    display: flex\n}\n\n.navigation-link-icon-2:hover {\n    background-color: #f3f4f6\n}\n\n.text-span-84 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.header-content-wrapper {\n    z-index: 5;\n    color: #fff;\n    text-align: center;\n    font-weight: 500;\n    display: none;\n    position: relative\n}\n\n.header-slide-image {\n    z-index: 2;\n    object-fit: fill;\n    border-radius: 32px;\n    width: 100%;\n    height: auto;\n    min-height: auto;\n    position: relative;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.sub-heading-large {\n    letter-spacing: -.02em;\n    font-size: 24px;\n    line-height: 1.5\n}\n\n.header-discount-wrapper {\n    margin-top: 24px;\n    font-weight: 500\n}\n\n.header-slider-product {\n    background-color: var(--white);\n    border-radius: 24px;\n    min-height: 562px;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n}\n\n.discount-badge {\n    color: #fff;\n    background-color: #d0011d;\n    border-radius: 8px;\n    margin-left: 4px;\n    margin-right: 4px;\n    padding: 4px 10px;\n    display: inline-block\n}\n\n.header-large-white {\n    color: #fff;\n    letter-spacing: -.04em;\n    margin-top: 0;\n    font-size: 64px;\n    font-weight: 500;\n    line-height: 1.2\n}\n\n.header-term-detail {\n    margin-top: 60px\n}\n\n.header-section-small {\n    padding: 62px 5%;\n    position: relative\n}\n\n.header-section-small.custo {\n    padding: 0 0%\n}\n\n.header-slide-wrapper {\n    background-color: var(--white);\n    border-radius: 32px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 0;\n    display: flex\n}\n\n.feature-card-2 {\n    background-color: var(--white);\n    color: #f4f4f6;\n    border-radius: 24px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    padding: 0;\n    text-decoration: none;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.shape-2 {\n    justify-content: center;\n    display: flex\n}\n\n.feature-shape {\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.paragraph-large-6 {\n    letter-spacing: -.02em;\n    font-size: 18px;\n    line-height: 1.5\n}\n\n.feature-icon-svg {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.feature-section-3 {\n    background-color: transparent;\n    padding: 0 0%;\n    position: relative\n}\n\n.margin-bottom-34 {\n    margin-bottom: 8px\n}\n\n.margin-bottom-34.text-weight-medium {\n    font-weight: 500;\n    display: none\n}\n\n.feature-icon-3 {\n    z-index: 2;\n    background-color: #22242f;\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    margin-bottom: 32px;\n    display: flex;\n    position: absolute;\n    top: 20px;\n    bottom: auto;\n    left: auto;\n    right: 20px\n}\n\n.feature-grid-2 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.link-block-5 {\n    height: 100%;\n    display: block\n}\n\n.link-block-5.header-slider-product {\n    box-shadow: none;\n    border-radius: 32px;\n    min-height: 620px\n}\n\n.heading-79 {\n    color: var(--black-2);\n    text-align: center;\n    font-size: 20px;\n    font-style: italic;\n    font-weight: 300\n}\n\n.heading-79.hide {\n    display: none\n}\n\n.image-45 {\n    height: 240px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-171 {\n    justify-content: center;\n    display: flex\n}\n\n.div-block-171.hide {\n    display: flex\n}\n\n.process-heading-2 {\n    color: #000;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 46px;\n    font-weight: 700;\n    line-height: 1.3\n}\n\n.process-heading-2.m-b-8 {\n    margin-bottom: 8px;\n    font-family: Satoshi, sans-serif;\n    font-size: 40px\n}\n\n.process-title-wrap-2 {\n    text-align: center;\n    max-width: 610px;\n    margin-bottom: 140px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.process-grid-2 {\n    grid-column-gap: 14px;\n    grid-row-gap: 100px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .25fr 1fr .25fr 1fr;\n    align-items: center\n}\n\n.process-section-2 {\n    background-color: #fff;\n    padding: 80px 5%\n}\n\n.m-t-40 {\n    margin-top: 40px\n}\n\n.m-t-40.p-v-40 {\n    margin-top: 0;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.m-t-40.p-v-40.bg-change {\n    background-color: var(--black);\n    padding-top: 24px;\n    padding-bottom: 48px\n}\n\n.text-span-85 {\n    color: var(--pabloo-green)\n}\n\n.sub-heading-text {\n    color: #fff;\n    width: 120%;\n    margin-bottom: 40px;\n    font-family: Open Sans, sans-serif;\n    font-size: 5rem;\n    font-weight: 800;\n    line-height: 5rem\n}\n\n.sub-heading-text.contact {\n    color: #2b2b33;\n    width: 100%;\n    margin-bottom: 24px;\n    font-family: Satoshi, sans-serif;\n    font-size: 3.4rem;\n    line-height: 120%\n}\n\n.social-media-link-icon {\n    opacity: .33;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f23920247b8c64_facebook-logo.png);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: 60%;\n    width: 40px;\n    height: 40px;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    transition: opacity .2s cubic-bezier(.455, .03, .515, .955)\n}\n\n.social-media-link-icon.facebook {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f23920b47b8c60_facebook-logo%20\\(1\\).png);\n    background-size: 20px;\n    margin-top: 20px;\n    margin-bottom: 20px\n}\n\n.social-media-link-icon.facebook:hover {\n    opacity: 1\n}\n\n.social-media-link-icon.linkedin1 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f2392f727b8c62_linkedin-logo.png);\n    background-size: 16px;\n    margin-top: 20px;\n    margin-bottom: 20px\n}\n\n.social-media-link-icon.linkedin1:hover {\n    opacity: 1\n}\n\n.social-media-link-icon.instagram1 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/633bfe0779f239e0a97b8c57_instagram-social-network-logo-of-photo-camera%20\\(1\\).png);\n    background-size: 16px;\n    margin-top: 20px;\n    margin-bottom: 20px\n}\n\n.social-media-link-icon.instagram1:hover {\n    opacity: 1\n}\n\n.sub-header-wrap {\n    color: #fff;\n    width: 100%;\n    font-family: Open Sans, sans-serif;\n    font-size: 1.2rem;\n    line-height: 1.5rem\n}\n\n.header-featured-wrap {\n    z-index: 4;\n    flex: 0 auto;\n    width: 50%;\n    position: absolute;\n    top: 200px\n}\n\n.header-featured-wrap.contact {\n    width: 100%;\n    padding-right: 50px;\n    position: relative;\n    top: 0\n}\n\n.sticky-wrapper {\n    height: 392vh;\n    position: relative\n}\n\n.contact-us-wrapper {\n    justify-content: space-between;\n    align-items: stretch;\n    height: auto;\n    padding-bottom: 0;\n    position: relative\n}\n\n.sec-bk {\n    align-items: center;\n    height: auto;\n    padding-top: 10vh;\n    padding-bottom: 4vh;\n    display: block\n}\n\n.sec-bk.p-b-32.xx {\n    height: auto;\n    padding-bottom: 80px\n}\n\n.social-media-icons {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 50vh;\n    padding: 16px 8px;\n    display: flex;\n    position: absolute;\n    bottom: 0;\n    left: 0\n}\n\n.big-container {\n    width: 1190px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 0\n}\n\n.sub-header-img {\n    flex: none;\n    width: 80%;\n    height: 77vh;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.sub-header-img.contact-us {\n    background-color: #fff;\n    border-radius: 8px;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: auto;\n    padding: 24px 30px 40px;\n    display: flex;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 100px;\n    box-shadow: -8px 3px 30px -5px rgba(128, 128, 128, .5)\n}\n\n.sub-header-img.contact-us.hide-desktop {\n    display: none\n}\n\n.paragraph-42 {\n    color: rgba(0, 0, 0, .71);\n    margin-bottom: 40px;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 32px\n}\n\n.process-heading-3 {\n    color: #2a323c;\n    text-align: left;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 14px;\n    font-size: 42px;\n    line-height: 1.3\n}\n\n.process-graphic {\n    max-width: 100%\n}\n\n.process-step {\n    background-color: var(--light-pink);\n    color: var(--pabloo-green);\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    min-width: 60px;\n    height: 60px;\n    min-height: 60px;\n    margin-right: 24px;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32px;\n    display: flex\n}\n\n.process-content {\n    max-width: 460px\n}\n\n.process-block-2 {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.process-wrapper {\n    display: flex\n}\n\n.process-full-wrapper {\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    display: flex;\n    position: relative\n}\n\n.line-break-2 {\n    background-color: #e1e5ea;\n    width: 100%;\n    max-width: 88%;\n    height: 2px;\n    margin-top: 40px;\n    margin-bottom: 40px\n}\n\n.process-title-2 {\n    color: #2a323c;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 32px;\n    line-height: 42px\n}\n\n.process-main-block {\n    align-items: flex-start;\n    display: flex\n}\n\n.process-section-3 {\n    padding: 100px 0% 40px\n}\n\n.process-paragraph-2 {\n    color: #546478;\n    margin-bottom: 24px;\n    font-size: 16px;\n    line-height: 28px\n}\n\n.process-title-wrap-3 {\n    text-align: center;\n    max-width: 680px;\n    margin-bottom: 40px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.process-line {\n    z-index: -1;\n    background-color: #e1e5ea;\n    width: 2px;\n    height: 100%;\n    position: absolute;\n    left: 30px\n}\n\n.text-span-89 {\n    color: var(--pabloo-green)\n}\n\n.paragraph-43 {\n    margin-top: 20px;\n    margin-bottom: 20px\n}\n\n.columns-6 {\n    padding-bottom: 40px;\n    display: flex\n}\n\n.column-71 {\n    height: auto\n}\n\n.slide-tab-current {\n    background-color: var(--white);\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 55px;\n    min-width: 55px;\n    height: 55px;\n    min-height: 55px;\n    display: flex;\n    box-shadow: 3px 3px 8px rgba(95, 48, 226, .16)\n}\n\n.step-detail {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.step-count-grace {\n    color: var(--black);\n    text-align: center;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.slide-detail {\n    border: 1px none var(--light-pink);\n    border-radius: 16px;\n    justify-content: space-around;\n    align-items: center;\n    width: auto;\n    margin-bottom: 64px;\n    padding: 12px;\n    display: flex\n}\n\n.form-section-2 {\n    background-color: var(--white);\n    align-items: flex-start;\n    max-width: 100%;\n    padding: 140px 3%;\n    display: block\n}\n\n.active-tab {\n    border-radius: 100px;\n    flex-flow: column wrap;\n    align-items: center;\n    display: flex\n}\n\n.h3 {\n    color: #fff\n}\n\n.h3.price-label {\n    z-index: 30;\n    clear: both;\n    color: var(--black);\n    text-align: center;\n    justify-content: center;\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-left: 0;\n    display: block;\n    position: relative\n}\n\n.bodytext3 {\n    clear: both;\n    color: var(--black);\n    text-align: left;\n    margin-bottom: 0;\n    font-size: 1.1rem;\n    line-height: 1.2rem;\n    position: relative\n}\n\n.bodytext3.error {\n    color: #a93334\n}\n\n.actual-radio-button {\n    opacity: 1;\n    margin-top: 0;\n    margin-left: 0;\n    display: none;\n    position: absolute;\n    top: 20px;\n    bottom: 0;\n    left: -30px\n}\n\n.form-wrapper-6 {\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    display: flex\n}\n\n.error-message-4,\n.form-success {\n    background-color: transparent;\n    border: 1px solid #fff\n}\n\n.radio-field-parent {\n    float: none;\n    clear: none;\n    text-align: center;\n    background-color: transparent;\n    border: 0 solid rgba(255, 255, 255, .1);\n    border-radius: 0;\n    flex-flow: wrap;\n    flex: 1;\n    align-content: center;\n    align-self: stretch;\n    align-items: center;\n    width: auto;\n    height: 72px;\n    margin-right: 16px;\n    padding-top: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n    display: inline-block;\n    position: relative\n}\n\n.radio-field-label {\n    z-index: 20;\n    clear: both;\n    border: 1px solid var(--light-pink);\n    background-color: var(--white);\n    color: #fff;\n    text-align: left;\n    letter-spacing: 0;\n    text-transform: lowercase;\n    cursor: pointer;\n    border-radius: 8px;\n    align-self: center;\n    align-items: center;\n    width: 100%;\n    height: 72px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0;\n    font-size: 14px;\n    font-weight: 400;\n    display: block;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.radio-field-label:hover {\n    border-color: var(--pabloo-green);\n    background-color: var(--light-pink)\n}\n\n.radio-field-label:focus {\n    border-color: var(--pabloo-green)\n}\n\n.bl-0001-custom-radio-form {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin-top: 40px;\n    margin-bottom: 60px;\n    display: flex;\n    position: relative;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.div-block-179 {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-top: 32px;\n    display: flex\n}\n\n.div-block-180 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.heading-82 {\n    text-align: center;\n    width: 100%\n}\n\n.text-span-91 {\n    color: var(--pabloo-green)\n}\n\n.div-block-181 {\n    text-align: center;\n    justify-content: center;\n    width: 100%;\n    margin-top: 24px;\n    display: flex\n}\n\n.radio-button-field-2 {\n    margin-left: 16px\n}\n\n.submit-button-2 {\n    background-color: var(--pabloo-green);\n    border-radius: 8px;\n    padding-left: 32px;\n    padding-right: 32px\n}\n\n.div-block-182 {\n    justify-content: center;\n    margin-top: 24px;\n    display: flex\n}\n\n.link-block-8 {\n    width: auto;\n    height: 25px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.text-block-82 {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.text-block-82:hover {\n    color: var(--pabloo-green)\n}\n\n.div-block-183 {\n    margin-top: 8px\n}\n\n.text-span-95 {\n    color: var(--pabloo-green);\n    font-family: Satoshi, sans-serif;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.div-block-184 {\n    flex-wrap: wrap;\n    align-items: flex-start;\n    display: block\n}\n\n.div-block-185 {\n    margin-left: 16px\n}\n\n.heading-83,\n.heading-84 {\n    margin-bottom: 4px;\n    font-size: 20px\n}\n\n.text-block-83 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 22px\n}\n\n.text-block-84 {\n    font-size: 16px;\n    line-height: 22px\n}\n\n.div-block-186 {\n    flex-wrap: wrap;\n    margin: 32px 32px 16px;\n    display: flex\n}\n\n.div-block-186.m-l-0 {\n    align-items: center;\n    margin-top: 0;\n    margin-bottom: 2%;\n    margin-left: 0\n}\n\n.image-46 {\n    height: 26px;\n    margin-bottom: 0\n}\n\n.div-block-187 {\n    box-shadow: none;\n    border-radius: 10px;\n    margin-right: 8px;\n    padding: 10px 0\n}\n\n.div-block-187._1 {\n    background-color: var(--white);\n    box-shadow: none;\n    margin-left: 16px;\n    padding: 10px 0%\n}\n\n.div-block-188 {\n    color: rgba(0, 0, 0, .6);\n    width: 100%;\n    margin-top: 16px;\n    margin-bottom: 0;\n    font-size: 16px;\n    font-weight: 300\n}\n\n.text-block-86 {\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 32px;\n    font-weight: 700\n}\n\n.heading-85 {\n    text-align: center;\n    margin-top: 0\n}\n\n.div-block-189 {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.div-block-190 {\n    width: 100%;\n    padding-left: 10%;\n    padding-right: 10%\n}\n\n.text-span-96 {\n    color: rgba(0, 0, 0, .6);\n    font-size: 14px;\n    font-weight: 400\n}\n\n.div-block-191 {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 24px;\n    display: grid\n}\n\n.div-block-191.m-t-0 {\n    margin-top: 0\n}\n\n.div-block-192 {\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.text-block-87 {\n    font-weight: 500\n}\n\n.heading-86 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-size: 32px\n}\n\n.div-block-193 {\n    background-color: var(--light-pink);\n    border-radius: 16px;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    display: none\n}\n\n.div-block-194 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin: 80px 3%;\n    display: grid\n}\n\n.bold-text-8 {\n    color: var(--white)\n}\n\n.text-span-98 {\n    background-color: rgba(235, 184, 47, .52)\n}\n\n.shows-archive {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    display: grid\n}\n\n.button-11 {\n    background-color: var(--pabloo-green);\n    cursor: pointer;\n    border-radius: 4px;\n    margin-top: 9px;\n    margin-bottom: 9px;\n    padding: 17px 54px;\n    font-size: 17px\n}\n\n.button-11:hover {\n    background-color: var(--pabloo-green-2)\n}\n\n.div-block-195 {\n    background-color: #fff;\n    border-radius: 4px\n}\n\n.intro {\n    background-color: #f5f6fa;\n    border-radius: 50px;\n    max-width: 80%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 213px 92px;\n    overflow: hidden\n}\n\n.intro.feature-3 {\n    padding-top: 95px;\n    padding-bottom: 95px\n}\n\n.intro.feature-3.x {\n    background-color: var(--white-smoke);\n    border-radius: 0;\n    max-width: 100%\n}\n\n.intro.feature-3.x.hide {\n    display: none\n}\n\n.show-category {\n    border: 2px solid var(--pabloo-green);\n    color: var(--pabloo-green);\n    text-transform: uppercase;\n    background-color: #fff;\n    border-radius: 50px;\n    padding: 8px 20px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 22px;\n    display: inline-block\n}\n\n.heading-88 {\n    color: #939bb4;\n    font-size: 34px;\n    font-weight: 600\n}\n\n.heading-88.mob {\n    color: var(--black)\n}\n\n.show-item {\n    cursor: pointer;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/634d4ab36617c8d4c5462bff_Webinar%20Dan%20Fletcher-03.png), linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5));\n    background-position: 0 0, 0 0;\n    background-repeat: no-repeat, repeat;\n    background-size: cover, auto;\n    border-radius: 4px;\n    min-height: 320px;\n    padding: 16px 30px 27px 16px;\n    transition: all .2s ease-in-out;\n    display: block\n}\n\n.show-item:hover {\n    filter: grayscale()\n}\n\n.show-item._1 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6333afa89bbd2c2fc7071c31_Webinar%20crownpeak-03.png), linear-gradient(transparent, transparent);\n    background-position: 0 0, 0 0;\n    background-repeat: no-repeat, repeat;\n    background-size: cover, auto;\n    border-radius: 4px;\n    min-height: 320px\n}\n\n.s20 {\n    height: 20px\n}\n\n.text-span-100 {\n    color: var(--pabloo-green)\n}\n\n.xx {\n    font-size: 18px;\n    line-height: 24px\n}\n\n.paragraph-44 {\n    text-align: center\n}\n\n.align-start {\n    margin-top: 16px;\n    position: relative\n}\n\n.div-block-197 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto minmax(80px, 160px) auto;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: flex\n}\n\n.text-block-89 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.div-block-198 {\n    background-color: var(--white);\n    border-radius: 8px;\n    padding: 8px;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .12)\n}\n\n.text-span-102,\n.text-span-103 {\n    color: var(--pabloo-green)\n}\n\n.div-block-199 {\n    margin-top: 24px;\n    display: flex\n}\n\n.image-47 {\n    height: 64px\n}\n\n.image-47.m-l-8 {\n    filter: saturate(151%);\n    width: 80px;\n    height: 80px;\n    margin-left: 8px\n}\n\n.image-48 {\n    height: 60px;\n    margin-left: 8px\n}\n\n.image-48.m-l-0 {\n    border-radius: 100%;\n    height: 80px;\n    margin-left: 0\n}\n\n.price-tabs {\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.price-card {\n    background-color: var(--white);\n    border: 1px solid #e6e6e6;\n    border-radius: 20px;\n    height: 100%;\n    padding: 32px;\n    position: relative;\n    overflow: hidden\n}\n\n.badge-primary {\n    color: #1a1a1a;\n    letter-spacing: .02em;\n    text-transform: uppercase;\n    background-color: #f7f7f7;\n    border: 1px solid #e6e6e6;\n    border-radius: 32px;\n    margin-bottom: 54px;\n    padding: 8px 14px;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    display: inline-block\n}\n\n.price-card-feature {\n    background-color: var(--white);\n    border: 2px solid #4255bd;\n    border-radius: 20px;\n    padding: 32px;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 17px 17px 64px -14px rgba(77, 77, 77, .16)\n}\n\n.badge-beta {\n    color: gray;\n    background-color: #f7f7f7;\n    border: 1px solid #e6e6e6;\n    border-radius: 4px;\n    justify-content: center;\n    align-items: center;\n    margin-left: 8px;\n    padding: 2px 6px;\n    font-weight: 600;\n    display: flex\n}\n\n.price-feature-grid {\n    grid-column-gap: 14px;\n    grid-row-gap: 4px;\n    grid-template-columns: 1fr;\n    margin-top: 14px\n}\n\n.price-feature {\n    color: #1a1a1a;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.section-regular-2 {\n    padding: 0 0%;\n    position: relative\n}\n\n.price-text-large {\n    color: #4255bd;\n    margin-bottom: 14px;\n    font-size: 64px;\n    font-weight: 500;\n    line-height: 72px\n}\n\n.button-pricing {\n    color: #f7f7f7;\n    text-align: center;\n    background-color: #4255bd;\n    border: 1px solid #6070c8;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    min-height: 48px;\n    margin-top: 24px;\n    padding: 8px 16px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-decoration: none;\n    transition: border-color .4s;\n    display: flex\n}\n\n.button-pricing:hover {\n    border-color: #d3d3d3\n}\n\n.price-tab-link {\n    color: #1a1a1a;\n    text-align: center;\n    letter-spacing: -.02em;\n    white-space: nowrap;\n    background-color: transparent;\n    border-radius: 48px;\n    justify-content: center;\n    align-items: center;\n    padding: 12px 32px;\n    font-size: 16px;\n    font-weight: 500;\n    display: flex\n}\n\n.price-tab-link.w--current {\n    background-color: var(--slate-blue);\n    color: #f7f7f7;\n    box-shadow: 1px 8px 20px rgba(141, 155, 190, .16)\n}\n\n.price-content {\n    width: 100%;\n    overflow: visible\n}\n\n.price-text {\n    color: #1a1a1a;\n    margin-top: 0;\n    margin-bottom: 14px;\n    font-size: 40px;\n    font-weight: 500;\n    line-height: 48px\n}\n\n.price-feature-line {\n    border-bottom: 1.5px solid #e6e6e6;\n    align-items: center;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    display: flex\n}\n\n.price-tab-menu {\n    background-color: #f7f7f7;\n    border: 1px solid #e6e6e6;\n    border-radius: 44px;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 40px;\n    padding: 8px;\n    display: flex\n}\n\n.paragraph-small-4 {\n    letter-spacing: -.01em;\n    font-size: 14px;\n    line-height: 24px\n}\n\n.paragraph-small-4.text-weight-semibold {\n    font-weight: 600\n}\n\n.pricing-icon {\n    justify-content: center;\n    align-items: center;\n    margin-right: 8px;\n    display: flex\n}\n\n.pricing-image {\n    z-index: -1;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.badge-secondary {\n    color: #4255bd;\n    letter-spacing: .02em;\n    text-transform: uppercase;\n    background-color: #f4f5fb;\n    border: 1px solid #b3bbe5;\n    border-radius: 32px;\n    margin-bottom: 54px;\n    padding: 8px 14px;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 16px;\n    display: inline-block\n}\n\n.heading-content-2 {\n    color: #1a1a1a;\n    letter-spacing: -.04em;\n    margin-top: 0;\n    margin-bottom: 24px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 64px;\n    font-weight: 700;\n    line-height: 1.2\n}\n\n.price-wrapper {\n    margin-top: 14px;\n    padding: 14px\n}\n\n.button-pricing-outline {\n    color: #4255bd;\n    text-align: center;\n    background-color: transparent;\n    border: 1.5px solid #6070c8;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    min-height: 48px;\n    margin-top: 24px;\n    padding: 8px 16px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-decoration: none;\n    transition: border-color .4s;\n    display: flex\n}\n\n.button-pricing-outline:hover {\n    border-color: #d3d3d3\n}\n\n.price-detail {\n    letter-spacing: -.02em;\n    margin-bottom: 0;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 32px\n}\n\n.price-type-2 {\n    color: gray;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px\n}\n\n.pricing-text {\n    color: #aaa;\n    font-size: 14px;\n    line-height: 24px\n}\n\n.price-custom-icon-wrapper {\n    justify-content: flex-start;\n    align-items: flex-end;\n    margin-bottom: 14px;\n    display: flex\n}\n\n.image-49 {\n    object-fit: fill\n}\n\n.collection-list-wrapper {\n    position: relative\n}\n\n.slider-4 {\n    background-color: var(--white);\n    border-radius: 32px;\n    height: 100%;\n    min-height: 530px;\n    box-shadow: 0 0 24px rgba(0, 0, 0, .12)\n}\n\n.slide-4 {\n    border-radius: 32px;\n    height: auto;\n    min-height: auto\n}\n\n.image-50 {\n    height: 32px;\n    display: inline-block\n}\n\n.left-arrow-3 {\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    left: -48px\n}\n\n.right-arrow-3 {\n    justify-content: flex-end;\n    align-items: center;\n    display: flex;\n    right: -48px\n}\n\n.image-51 {\n    height: 32px\n}\n\n.mask-3 {\n    border-radius: 32px;\n    max-height: 620px\n}\n\n.slide-nav-4 {\n    bottom: -56px\n}\n\n.text-span-104,\n.text-span-105 {\n    color: var(--pabloo-green)\n}\n\n.banner-2 {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    min-height: 56px;\n    padding: 16px 5%;\n    display: flex\n}\n\n.banner-2.hide {\n    display: none\n}\n\n.banner-wrap {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.link-6 {\n    color: var(--white)\n}\n\n.text-span-112 {\n    color: var(--pabloo-green)\n}\n\n.text-span-113,\n.text-span-114 {\n    color: #000\n}\n\n.div-block-204 {\n    background-color: var(--white-smoke);\n    border-radius: 12px;\n    padding: 12px\n}\n\n.text-span-116 {\n    color: #000\n}\n\n.empty-state-2 {\n    background-color: var(--white-smoke);\n    border-radius: 24px;\n    padding-top: 24px;\n    padding-bottom: 24px\n}\n\n.text-block-92 {\n    text-align: center;\n    margin-top: 16px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.text-block-92.xx {\n    color: rgba(0, 0, 0, .5);\n    margin-top: 8px;\n    font-size: 16px\n}\n\n.text-span-117 {\n    color: var(--pabloo-green)\n}\n\n.text-span-118 {\n    color: #000\n}\n\n.link-7 {\n    /* text-decoration: none */\n}\n\n.link-block-9 {\n    background-color: var(--pabloo-green);\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    margin-top: 0;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    display: flex\n}\n\n.text-block-94,\n.text-block-95 {\n    font-size: 17px\n}\n\n.text-block-96,\n.text-block-97 {\n    font-size: 16px\n}\n\n.text-block-98 {\n    color: var(--white)\n}\n\n.html-embed-13 {\n    margin-left: 0\n}\n\n.text-block-99,\n.text-block-100 {\n    font-size: 15px\n}\n\n.text-block-101,\n.text-block-102 {\n    font-size: 14px\n}\n\n.text-block-108 {\n    font-size: 15px;\n    font-weight: 500\n}\n\n._2 {\n    background-color: var(--white-smoke);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f130c006a25f4b76fe8f8c_Frame%20\\(2\\).svg);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: 160px 160px;\n    margin-top: 0;\n    padding: 24px 5%\n}\n\n._1 {\n    background-color: var(--white-smoke);\n    padding: 48px 5%\n}\n\n.f-container-regular {\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n._4 {\n    background-color: var(--white-smoke);\n    margin-top: 24px;\n    padding: 24px 5%\n}\n\n._5 {\n    background-color: var(--white);\n    margin-top: 24px;\n    padding: 24px 5%\n}\n\n._6 {\n    margin-top: 24px;\n    padding: 24px 5%\n}\n\n.html-embed-15 {\n    color: #eeb6d1;\n    margin-right: 16px\n}\n\n.html-embed-16 {\n    margin-right: 16px\n}\n\n.heading-95 {\n    font-size: 24px;\n    line-height: 30px\n}\n\n.f-paragraph-large-2 {\n    letter-spacing: -.02em;\n    margin-bottom: 0;\n    font-size: 18px;\n    line-height: 32px\n}\n\n.text-span-128 {\n    color: var(--pabloo-green)\n}\n\n.container-18 {\n    width: 100%;\n    max-width: 1200px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.side-pattern-right {\n    z-index: -1;\n    position: absolute;\n    top: 10%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.side-pattern {\n    z-index: -1;\n    position: absolute;\n    top: 5%;\n    bottom: auto;\n    left: -5%;\n    right: auto\n}\n\n.title-paragraph {\n    letter-spacing: -.03em;\n    max-width: 590px;\n    margin-bottom: 32px;\n    font-weight: 400\n}\n\n.title-wrap-4 {\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 60px;\n    display: flex\n}\n\n.title-wrap-4.hide {\n    display: none\n}\n\n.content-h2 {\n    color: var(--black-2);\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 22px;\n    font-size: 54px;\n    line-height: 1.1\n}\n\n.content-section {\n    padding: 24px 3% 96px;\n    position: relative\n}\n\n.slide-5 {\n    background-color: #fff;\n    border: 1px rgba(70, 137, 215, .2);\n    border-radius: 15px;\n    margin-right: 50px;\n    padding: 0;\n    overflow: hidden\n}\n\n.faq-question-wrap {\n    cursor: pointer;\n    border: 1px solid rgba(159, 6, 255, .2);\n    border-radius: 21px;\n    margin-top: 10px;\n    margin-bottom: 26px;\n    padding: 28px 40px\n}\n\n.jobs-board-form {\n    background-color: #fff;\n    border: 1px solid #e4e6f1;\n    border-radius: 50px;\n    align-items: center;\n    margin-top: 24px;\n    padding: 4px;\n    display: flex\n}\n\n.f-margin-bottom-40 {\n    margin-bottom: 40px\n}\n\n.f-button-neutral {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    text-align: center;\n    letter-spacing: -.02em;\n    border-radius: 50px;\n    justify-content: center;\n    align-items: center;\n    min-width: auto;\n    min-height: 48px;\n    padding: 12px 32px;\n    font-size: 16px;\n    font-weight: 500;\n    text-decoration: none;\n    transition: background-color .3s;\n    display: flex\n}\n\n.f-button-neutral:hover {\n    background-color: var(--pabloo-green-2)\n}\n\n.f-h1-heading {\n    color: #160042;\n    letter-spacing: -.04em;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 64px;\n    line-height: 1.2\n}\n\n.f-header-input-field {\n    background-color: var(--white-smoke);\n    color: #160042;\n    border: 1px #000;\n    min-height: 48px;\n    margin-bottom: 0;\n    margin-right: 16px;\n    padding: 12px 16px;\n    font-size: 18px\n}\n\n.f-header-input-field::placeholder {\n    color: #b6b9ce\n}\n\n.f-header-input-field.border-radius-left-only {\n    border-top-left-radius: 50px;\n    border-bottom-left-radius: 50px\n}\n\n.f-header-input-field.border-radius-right-only {\n    border-top-right-radius: 50px;\n    border-bottom-right-radius: 50px\n}\n\n.f-header-form-row {\n    grid-column-gap: 24px;\n    grid-row-gap: 12px;\n    align-items: center;\n    margin-bottom: 0;\n    display: flex\n}\n\n.f-header-form-row.lp {\n    margin-bottom: 4px\n}\n\n.link-block-11 {\n    color: var(--pabloo-green);\n    margin-left: 20px;\n    font-weight: 700\n}\n\n.text-block-133 {\n    font-size: 16px;\n    /* text-decoration: none */\n}\n\n.text-span-130 {\n    color: var(--pabloo-green)\n}\n\n.f-margin-bottom-24 {\n    margin-bottom: 8px\n}\n\n.f-header-title-wrapper-center {\n    z-index: 5;\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    max-width: 650px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: relative\n}\n\n.f-section-large-3 {\n    padding: 92px 5% 24px;\n    position: relative\n}\n\n.feature-details {\n    color: #737373;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 32px\n}\n\n.feature-card-04 {\n    flex-direction: row;\n    align-items: center;\n    padding: 32px;\n    display: block\n}\n\n.feature-card-5 {\n    border-right: 1px dashed #e5e5e5;\n    flex-direction: row;\n    align-items: center;\n    padding: 32px;\n    display: block\n}\n\n.grid-feature-wrapper {\n    grid-column-gap: 72px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 2fr;\n    align-items: center\n}\n\n.feature-card-6 {\n    border-bottom: 1px dashed #e5e5e5;\n    flex-direction: row;\n    align-items: center;\n    padding: 32px;\n    display: block\n}\n\n.grid-features {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr\n}\n\n.feature-card-01 {\n    border-bottom: 1px dashed #e5e5e5;\n    border-right: 1px dashed #e5e5e5;\n    flex-direction: row;\n    align-items: center;\n    padding: 32px;\n    display: block\n}\n\n.section-feature {\n    padding: 140px 5%\n}\n\n.button-feature {\n    background-color: #1a1e21;\n    border-radius: 4px;\n    margin-top: 32px;\n    padding: 16px 32px\n}\n\n.heading-large {\n    color: #262626;\n    letter-spacing: -.04em;\n    margin-bottom: 24px;\n    font-size: 50px;\n    font-weight: 600;\n    line-height: 60px\n}\n\n.title-large {\n    color: #8e8e8e;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n    font-size: 16px\n}\n\n.container-features {\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.link-20 {\n    color: var(--slate-blue);\n    font-weight: 500\n}\n\n.color-span {\n    color: var(--pabloo-green)\n}\n\n.color-span.italic {\n    font-style: italic\n}\n\n.faq-paragraph-2 {\n    color: var(--white-smoke);\n    letter-spacing: -.01em;\n    font-size: 16px;\n    line-height: 32px\n}\n\n.faq-grid-3 {\n    grid-column-gap: 72px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr\n}\n\n.faq-heading-3 {\n    color: var(--white);\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 48px;\n    line-height: 56px\n}\n\n.faq-section-3 {\n    background-color: var(--slate-blue);\n    padding: 80px 3%\n}\n\n.faq-container-3 {\n    max-width: 1060px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.faq-subheading {\n    color: var(--white);\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    margin-bottom: 20px;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 32px\n}\n\n.faq-title-3 {\n    color: var(--white);\n    letter-spacing: -.01em;\n    margin-top: 0;\n    line-height: 28px\n}\n\n.grey-divider {\n    background-color: #e5e7eb;\n    height: 1px;\n    margin-bottom: 40px\n}\n\n.faq-wrapper-4 {\n    margin-bottom: 50px\n}\n\n.text-block-138 {\n    margin-bottom: 24px;\n    font-size: 18px\n}\n\n.content-grid-2 {\n    grid-column-gap: 82px;\n    grid-row-gap: 82px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.2fr 1fr;\n    align-items: center\n}\n\n.a-container-regular {\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.a-margin-bottom-08 {\n    margin-bottom: 8px\n}\n\n.a-detail-small {\n    letter-spacing: .08em;\n    text-transform: uppercase;\n    margin-bottom: 0;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.8\n}\n\n.a-detail-small.custo {\n    font-size: 18px\n}\n\n.a-title-wrap-center {\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    max-width: 510px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.slide-wrap-2 {\n    align-items: center;\n    width: 5000px;\n    margin-left: -20px;\n    margin-right: -20px;\n    padding: 40px 24px;\n    display: flex\n}\n\n.slide-wrap-2.logos-animation {\n    display: none\n}\n\n.slide-wrap-2.logos-animation.us-logos {\n    display: flex\n}\n\n.milestone-circle {\n    border: 2px solid var(--pabloo-green);\n    background-color: #f5f9ff;\n    border-radius: 100px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    padding: 4px;\n    display: flex;\n    position: absolute;\n    top: auto;\n    bottom: auto\n}\n\n.link-block-12 {\n    position: absolute\n}\n\n.link-block-13,\n.link-block-14 {\n    object-fit: fill\n}\n\n.link-block-15 {\n    object-fit: cover\n}\n\n.link-block-16,\n.link-block-17 {\n    object-fit: none\n}\n\n.link-block-18,\n.link-block-19,\n.link-block-20 {\n    object-fit: fill\n}\n\n.link-block-21 {\n    position: absolute\n}\n\n.link-block-22 {\n    position: absolute;\n    top: 16px;\n    bottom: auto;\n    left: auto;\n    right: 16px\n}\n\n.text-block-139 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-weight: 700\n}\n\n.text-span-131 {\n    color: var(--slate-blue);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.text-span-132 {\n    color: var(--pabloo-green)\n}\n\n.image-61 {\n    z-index: 10;\n    position: absolute;\n    top: 1%;\n    bottom: auto;\n    left: auto;\n    right: -36%\n}\n\n.text-span-133 {\n    color: var(--slate-blue);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.text-block-140 {\n    text-align: center\n}\n\n.div-block-241 {\n    padding-top: 4px;\n    padding-bottom: 4px\n}\n\n.feature-section-4 {\n    padding: 80px 3%\n}\n\n.feature-block-3 {\n    align-items: flex-start;\n    display: flex\n}\n\n.feature-block-header {\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    min-height: 300px;\n    padding-left: 72px;\n    display: flex;\n    position: relative\n}\n\n.feature-wrapper {\n    align-items: flex-start;\n    display: flex\n}\n\n.title-wrapper-3 {\n    color: #000;\n    letter-spacing: 2px;\n    align-items: center;\n    margin-bottom: 20px;\n    display: flex\n}\n\n.feature-title-content {\n    width: 100%\n}\n\n.title-line {\n    background-color: #000;\n    width: 30px;\n    height: 1px;\n    margin-right: 24px\n}\n\n.feature-title-2 {\n    color: #2a2a2a;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    margin-bottom: 16px;\n    font-size: 36px;\n    font-weight: 600;\n    line-height: 44px\n}\n\n.feature-number {\n    color: #b5b5b5;\n    margin-top: 6px;\n    margin-right: 30px;\n    font-size: 24px;\n    line-height: 32px\n}\n\n.feature-header-2 {\n    color: #2a2a2a;\n    margin-top: 0;\n    margin-bottom: 16px;\n    font-size: 40px;\n    line-height: 48px\n}\n\n.feature-grid-4 {\n    grid-column-gap: 72px;\n    grid-row-gap: 72px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-bottom: 24px;\n    display: grid\n}\n\n.feature-details-2 {\n    color: #2a2a2a;\n    font-size: 18px;\n    line-height: 32px\n}\n\n.feature-container {\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.feature-pink-block {\n    z-index: -1;\n    background-color: #ffdfe4;\n    background-image: none;\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 30px;\n    width: 300px;\n    height: 300px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.a-testimonial-slider-content {\n    grid-row-gap: 24px;\n    flex-direction: column;\n    justify-content: space-between;\n    display: flex;\n    position: relative\n}\n\n.a-testimonial-slider-grid {\n    grid-column-gap: 64px;\n    grid-row-gap: 48px;\n    grid-template-rows: auto;\n    grid-template-columns: .25fr 1fr\n}\n\n.a-testimonial-quote {\n    z-index: 10;\n    color: rgba(0, 0, 0, .64);\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 30px;\n    position: relative\n}\n\n.a-section-regular-2 {\n    padding: 92px 5%;\n    position: relative\n}\n\n.a-testimonial-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.html-embed-18 {\n    border-radius: 0;\n    width: 100%\n}\n\n.link-28,\n.link-29 {\n    color: var(--slate-blue)\n}\n\n.collection-list-wrapper-2 {\n    width: 100%\n}\n\n.collection-list-3 {\n    display: flex\n}\n\n.collection-item {\n    margin-left: 0;\n    margin-right: 20px\n}\n\n.paragraph-50 {\n    margin-bottom: 40px\n}\n\n.content-section-5 {\n    background-color: var(--white);\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    padding: 80px 3%\n}\n\n.content-heading {\n    z-index: 1;\n    color: var(--black);\n    margin-top: 0;\n    margin-bottom: 30px;\n    font-size: 40px;\n    font-weight: 600;\n    line-height: 65px;\n    position: relative\n}\n\n.content-grid-3 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 2fr;\n    align-items: center;\n    justify-items: start\n}\n\n.content-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    max-width: 700px;\n    display: flex\n}\n\n.content-container {\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-244 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    grid-auto-flow: row;\n    margin-bottom: 16px;\n    display: grid\n}\n\n.image-62 {\n    width: 32px;\n    height: 32px\n}\n\n.div-block-245 {\n    position: relative\n}\n\n.image-63 {\n    z-index: 0;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: 0%;\n    right: auto\n}\n\n.text-block-141 {\n    color: var(--pabloo-green);\n    margin-bottom: 8px;\n    font-weight: 500\n}\n\n.section-large-3 {\n    padding: 120px 5%;\n    position: relative\n}\n\n.text-span-142 {\n    color: var(--pabloo-green)\n}\n\n.header-grid-5 {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    background-image: none;\n    background-repeat: repeat;\n    background-size: auto;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .75fr;\n    align-items: start\n}\n\n.image-wrapper-3 {\n    z-index: 1;\n    -webkit-backdrop-filter: blur(16px);\n    backdrop-filter: blur(16px);\n    background-color: rgba(255, 255, 255, .24);\n    border-left: 12px solid #5050ff;\n    border-radius: 8px;\n    margin-left: 32px;\n    margin-right: 32px;\n    padding: 32px;\n    position: relative;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .12)\n}\n\n.image-wrapper-3.darl-mode {\n    -webkit-backdrop-filter: none;\n    backdrop-filter: none;\n    background-color: #fff\n}\n\n.image-wrapper-3.darl-mode.custo {\n    margin-left: 24px;\n    padding: 28px 24px 28px 28px\n}\n\n.features-button-2 {\n    color: #fff;\n    text-align: center;\n    background-color: #d53987;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    margin-top: 0;\n    padding: 16px 32px;\n    font-size: 18px;\n    font-weight: 500;\n    text-decoration: none;\n    transition: background-position .3s;\n    display: flex\n}\n\n.features-button-2:hover {\n    background-position: 90%\n}\n\n.ebook-points-heading-2 {\n    color: #000;\n    margin-top: 16px;\n    margin-bottom: 24px;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 28px\n}\n\n.ebook-points-heading-2.points-heading {\n    color: #000;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.ebook-points-heading-2.points-heading.custo {\n    font-size: 18px\n}\n\n.badge-standard-2 {\n    color: #fff;\n    background-color: #d53987;\n    border-radius: 50px;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 20px;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex\n}\n\n.hero-heading-4 {\n    color: #000;\n    letter-spacing: -.03em;\n    margin-top: 0;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 58px;\n    line-height: 72px\n}\n\n.title-4 {\n    color: #d53987;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 28px\n}\n\n.text-span-143 {\n    color: #d53987\n}\n\n.header-section-6 {\n    background-color: #fff;\n    align-items: center;\n    min-height: 91vh;\n    padding: 80px 3% 64px;\n    display: flex;\n    position: relative\n}\n\n.header-wrapper-5 {\n    z-index: 2;\n    background-color: #fff;\n    padding-top: 120px;\n    position: relative\n}\n\n.paragraph-small-5 {\n    color: #000;\n    letter-spacing: -.01em;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px\n}\n\n.section-large-4 {\n    background-color: #000;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6244f42f88a11de61a8be252_Group%20223.svg);\n    background-position: 100%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding: 80px 5%;\n    position: relative\n}\n\n.section-large-4.nobg {\n    background-color: #fff;\n    background-image: none\n}\n\n.section-regular-4 {\n    background-color: #fff;\n    padding: 80px 5%;\n    position: relative\n}\n\n.section-regular-4.nobg {\n    background-color: #fff\n}\n\n.main-wrapper-2 {\n    -webkit-backdrop-filter: blur(20px);\n    backdrop-filter: blur(20px);\n    background-color: rgba(255, 255, 255, .59);\n    height: auto;\n    margin-top: 0;\n    position: relative\n}\n\n.heading-101 {\n    text-align: center;\n    margin-top: 0;\n    margin-bottom: 24px;\n    font-size: 24px;\n    font-weight: 500\n}\n\n.mt-16 {\n    margin-top: 16px\n}\n\n.text-block-154 {\n    color: var(--white);\n    text-transform: uppercase;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 20px\n}\n\n.div-block-256 {\n    background-color: var(--slate-blue);\n    border-radius: 20px;\n    margin-right: 8px;\n    padding: 4px 12px\n}\n\n.paragraph-57 {\n    color: var(--white);\n    margin-bottom: 16px;\n    font-size: 25px\n}\n\n.text-span-149,\n.text-span-150 {\n    color: var(--slate-blue)\n}\n\n.div-block-258 {\n    background-color: var(--white-smoke);\n    padding: 8px\n}\n\n.text-block-155 {\n    text-align: center\n}\n\n.div-block-259 {\n    background-color: var(--white-smoke);\n    padding: 12px 10px\n}\n\n.member-position {\n    color: rgba(0, 0, 0, .72);\n    text-align: center;\n    font-size: 17px;\n    font-weight: 500\n}\n\n.rich-text-block-20 {\n    color: var(--black);\n    font-size: 20px;\n    line-height: 32px\n}\n\n.div-block-260 {\n    display: flex\n}\n\n.heading-104 {\n    color: var(--slate-blue);\n    margin-left: 8px;\n    font-family: Satoshi, sans-serif;\n    font-size: 1.8rem;\n    line-height: 1.2em\n}\n\n.collection-list-4 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto 1fr;\n    grid-auto-columns: 1fr;\n    margin-bottom: 18px;\n    display: grid\n}\n\n.image-67 {\n    object-fit: contain;\n    height: 48px;\n    line-height: 28px\n}\n\n.div-block-261 {\n    background-color: var(--white-smoke);\n    padding: 4px\n}\n\n.text-block-156 {\n    text-align: center\n}\n\n.div-block-263 {\n    border: 2px #ccc;\n    border-radius: 120px;\n    flex-wrap: wrap;\n    padding: 6px 0;\n    display: flex\n}\n\n.text-block-158 {\n    color: var(--black);\n    margin-left: 4px;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.stap-button {\n    float: right;\n    background-color: #f3f3f2;\n    border-radius: 100px;\n    margin-bottom: 30px;\n    padding: 10px 30px\n}\n\n.tex {\n    color: #d53987;\n    letter-spacing: -.5px;\n    font-family: \"P22mackinacpro 18\", sans-serif;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 36px\n}\n\n.grid {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr\n}\n\n.step-grid {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    grid-template-rows: auto;\n    grid-template-columns: 110px 1fr 1fr 110px;\n    grid-auto-columns: 1fr;\n    margin-top: 30px;\n    display: grid\n}\n\n.home-section {\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 0\n}\n\n.main-heding {\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.slider-section {\n    text-align: center;\n    padding-top: 120px;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.slider-title {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.badge-wrapper-2 {\n    justify-content: flex-start;\n    display: flex\n}\n\n.badge-wrapper-2.ml-4 {\n    margin-left: 4px\n}\n\n.badge-standard-3 {\n    background-color: var(--pabloo-green);\n    color: #fff;\n    border-radius: 50px;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 12px;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex\n}\n\n.div-block-264 {\n    align-items: center;\n    display: flex\n}\n\n.empty-state-3 {\n    background-color: var(--white);\n    padding-left: 50px;\n    padding-right: 50px\n}\n\n.text-block-159 {\n    color: var(--black);\n    margin-left: 4px;\n    margin-right: 0\n}\n\n.empty-state-4,\n.empty-state-5,\n.empty-state-6 {\n    background-color: transparent\n}\n\n.rich-text-block-22 {\n    color: var(--pabloo-green);\n    margin-left: -22px;\n    font-size: 16px\n}\n\n.image-68 {\n    object-fit: fill;\n    border-radius: 8px;\n    width: 100%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    display: inline-block\n}\n\n.lp-para {\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 1.5\n}\n\n.lp-text-style {\n    opacity: 1;\n    letter-spacing: .2px;\n    margin-bottom: 16px;\n    font-weight: 500;\n    line-height: 1.66667\n}\n\n.lp-logo-section {\n    background-color: var(--white-smoke);\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.lp-logo-section.new {\n    padding-top: 0\n}\n\n.lp-logo-section.adjust {\n    padding-top: 20px\n}\n\n.lp-logo-section.adjust.pb-sm {\n    padding-bottom: 40px\n}\n\n.logo-head {\n    text-align: center;\n    font-size: 24px;\n    font-weight: 700\n}\n\n.logo-span {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 17\", sans-serif\n}\n\n.logo-wrapper {\n    grid-column-gap: 48px;\n    grid-row-gap: 32px;\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 100%;\n    margin-top: 48px;\n    display: flex\n}\n\n.logo-item {\n    filter: grayscale();\n    max-height: 35px\n}\n\n.logo-video {\n    grid-column-gap: 40px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 120px;\n    display: grid\n}\n\n.lp-win-section {\n    background-color: #000;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.win-heading {\n    color: #fff;\n    text-align: center;\n    letter-spacing: -.5px;\n    margin-bottom: 64px\n}\n\n.win-content {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: space-between;\n    align-items: center;\n    justify-items: stretch;\n    margin-top: 120px;\n    display: flex\n}\n\n.win-item-text-wrapper {\n    grid-column-gap: 16px;\n    color: #fff;\n    letter-spacing: .2px;\n    justify-content: space-between;\n    font-size: 20px;\n    line-height: 1.5;\n    display: flex\n}\n\n.win-item-text-wrapper.grey {\n    color: #a9a7b2\n}\n\n.win-bar {\n    background-color: var(--pabloo-green);\n    height: 16px;\n    margin-top: 12px;\n    position: relative\n}\n\n.win-bar.grey {\n    background-color: #aaa7b3\n}\n\n.win-bar-marker {\n    background-color: #fff;\n    width: 19px;\n    height: 16px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.win-bar-marker._92 {\n    width: 25px\n}\n\n.win-bar-marker._95 {\n    width: 14.55px\n}\n\n.win-bar-marker._90 {\n    width: 29px\n}\n\n.win-bar-marker._93 {\n    width: 21px\n}\n\n.win-subheading {\n    color: #fff;\n    letter-spacing: .2px;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 34px;\n    line-height: 1.23529\n}\n\n.win-item-wrapper {\n    grid-row-gap: 48px;\n    flex-direction: column;\n    flex: 1;\n    max-width: 290px;\n    display: flex\n}\n\n.lp-slider {\n    background-color: rgba(221, 221, 221, 0);\n    height: auto;\n    margin-top: 120px\n}\n\n.lp-slider-item {\n    border-radius: 10px;\n    padding-bottom: 60px\n}\n\n.max-height-30px {\n    max-height: 30px\n}\n\n.lp-slider-wrapper {\n    grid-row-gap: 50px;\n    background-color: #fff;\n    border-radius: 10px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 40px;\n    display: flex\n}\n\n.font-size-24px {\n    font-size: 24px;\n    line-height: 1.4\n}\n\n.font-size-16px {\n    font-size: 16px;\n    line-height: 1.5\n}\n\n.font-size-16px.font-weight-bold {\n    font-weight: 700\n}\n\n.lp-slider-flex {\n    grid-column-gap: 40px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.vender-alternate-head {\n    grid-column-gap: 20px;\n    color: var(--pabloo-green);\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    justify-content: center;\n    align-self: stretch;\n    align-items: center;\n    margin-bottom: 20px;\n    font-weight: 700;\n    line-height: 20px;\n    display: flex\n}\n\n.lp-header-line {\n    background-color: var(--pabloo-green);\n    width: 40px;\n    height: 2px\n}\n\n.lp-h2-wrapper {\n    grid-row-gap: 20px;\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    max-width: 1056px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.max-wdith-620px {\n    max-width: 620px\n}\n\n.lp-image-wrapper {\n    width: 54%\n}\n\n.lp-image-wrapper._50 {\n    width: 50%\n}\n\n.lp-highlighter {\n    border: 4px solid #fff;\n    border-radius: 8px;\n    width: 100%;\n    margin-top: 40px;\n    padding: 4px 4%\n}\n\n.button-17 {\n    background-color: var(--pabloo-green);\n    border-radius: 8px\n}\n\n.div-block-265 {\n    z-index: 10;\n    background-color: rgba(0, 0, 0, .77);\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: none;\n    position: fixed;\n    top: 0%;\n    bottom: auto;\n    left: 0%;\n    right: auto\n}\n\n.div-block-266 {\n    background-color: var(--white);\n    border-radius: 16px;\n    width: 32%;\n    padding: 16px 24px\n}\n\n.heading-105 {\n    text-align: center\n}\n\n.heading-106 {\n    color: #fff;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 14px;\n    line-height: 24px;\n    display: block\n}\n\n.icon-regular-4 {\n    color: #d53987;\n    justify-content: center;\n    align-items: center;\n    width: 18px;\n    height: 20px;\n    transition: color .2s;\n    display: flex\n}\n\n.div-block-268 {\n    grid-column-gap: 16px;\n    grid-row-gap: 4px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.tab-button-content {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    border-bottom: 1px #ececec;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    padding: 8px 12px\n}\n\n.b-navigation-card-image {\n    object-fit: contain;\n    width: 100%;\n    height: 100%\n}\n\n.div-block-269 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-self: center;\n    align-items: center;\n    display: grid\n}\n\n.sub-nav-link-text {\n    font-size: 15px;\n    font-weight: 700;\n    line-height: 24px\n}\n\n.b-navigation-title-block {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    color: #454f5f;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 16px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    display: flex\n}\n\n.b-navigation-title-block.grid-2-cols {\n    grid-column-gap: 64px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.b-navigation-link-icon {\n    grid-column-gap: 44px;\n    color: var(--black);\n    border-radius: 16px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 16px;\n    text-decoration: none;\n    transition: all .3s;\n    display: flex\n}\n\n.b-navigation-link-icon:hover {\n    color: rgb(21 128 61);\n    background-color: #f3f4f6\n}\n\n.b-navigation-link-title {\n    letter-spacing: -.01em;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px\n}\n\n.navigation-dropdown {\n    height: 100%;\n    position: static\n}\n\n.navigation-link-block {\n    padding: 0 0 8px 48px\n}\n\n.navigation-list {\n    z-index: 99;\n    min-width: 100%\n}\n\n.navigation-list.w--open {\n    background-color: #fff;\n    min-width: auto;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    top: 90px;\n    bottom: auto;\n    left: 0;\n    right: 0\n}\n\n.image-69 {\n    object-fit: cover;\n    border-radius: 16px;\n    width: 100%;\n    height: 100%\n}\n\n.heading-108 {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 18px;\n    line-height: 24px\n}\n\n.b-navigation-large-grid {\n    grid-column-gap: 44px;\n    grid-template-rows: auto;\n    margin-bottom: 16px\n}\n\n.tab-button {\n    color: #000;\n    background-color: rgba(255, 255, 255, 0);\n    border: 1px solid #fff;\n    border-radius: 4px;\n    margin-bottom: 8px;\n    padding: 0;\n    transition: all .3s\n}\n\n.tab-button:hover {\n    background-color: #fff\n}\n\n.tab-button.w--current {\n    color: #5050ff;\n    background-color: rgba(80, 80, 255, .04);\n    border: 1px solid #fff;\n    font-weight: 400\n}\n\n.paragraph-60 {\n    color: #fff;\n    font-size: 14px;\n    line-height: 22px;\n    display: block\n}\n\n.navigation-cta-image {\n    background-color: transparent;\n    border-radius: 12px;\n    justify-content: center;\n    align-items: flex-start;\n    width: 100%;\n    height: 200px;\n    display: flex\n}\n\n.navigation-link-3 {\n    color: #000;\n    letter-spacing: -.01em;\n    white-space: nowrap;\n    background-color: transparent;\n    border-radius: 50px;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    text-decoration: none;\n    transition: all .35s\n}\n\n.navigation-link-3:hover {\n    color: var(--pabloo-green);\n    background-color: #fff\n}\n\n.navigation-link-3.w--current {\n    color: var(--pabloo-green)\n}\n\n.navigation-cta {\n    grid-row-gap: 16px;\n    background-color: #f7f9fd;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    padding: 16px 24px;\n    display: flex\n}\n\n.b-navigation-link-detail {\n    color: #454f5f;\n    letter-spacing: -.01em;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.navigation-arrow-link {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    color: #6b7094;\n    letter-spacing: -.02em;\n    align-items: center;\n    font-size: 14px;\n    font-weight: 500;\n    text-decoration: none;\n    display: flex\n}\n\n.navigation-arrow-link:hover {\n    color: #d53987\n}\n\n.navigation-grid-2 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto;\n    grid-template-columns: 2fr 1fr;\n    height: 390px\n}\n\n.b-navigation-card-block {\n    border-radius: 16px;\n    height: 240px;\n    position: relative;\n    overflow: hidden\n}\n\n.div-block-274 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    display: grid\n}\n\n.paragraph-58 {\n    color: rgba(0, 0, 0, .6);\n    font-size: 14px;\n    line-height: 20px\n}\n\n.navigation-dropdown-base {\n    background-color: #fff;\n    border: 4px solid #fff;\n    border-radius: 0 0 24px 24px;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n    box-shadow: 5px 48px 140px -48px rgba(57, 59, 106, .08)\n}\n\n.b-navigation-base {\n    flex: 1;\n    padding: 16px\n}\n\n.chevron {\n    filter: none;\n    transform: rotate(-90deg)\n}\n\n.tab-button-title {\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 28px;\n    display: flex\n}\n\n.tab-button-desc {\n    font-size: 14px;\n    line-height: 24px;\n    display: none\n}\n\n.b-navigation-column {\n    grid-row-gap: 9px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.b-navigation-small-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto\n}\n\n.tab-mobile-img {\n    display: none\n}\n\n.paragraph-61 {\n    margin-top: 8px;\n    font-size: 16px;\n    line-height: 22px\n}\n\n.footer-3 {\n    background-color: #000;\n    padding-bottom: 28px\n}\n\n.nav-big-link {\n    color: #000;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.tabs-menu-3 {\n    flex-direction: column;\n    width: 40%;\n    margin-right: 4%;\n    padding-top: 24px;\n    display: flex\n}\n\n.text-block-162 {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.navigation-toggle-3 {\n    color: #160042;\n    letter-spacing: -.01em;\n    border-radius: 50px 50px 24px 24px;\n    align-items: center;\n    height: 100%;\n    padding: 12px 30px 12px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-decoration: none;\n    transition: all .35s\n}\n\n.navigation-toggle-3:hover {\n    background-color: #fff\n}\n\n.div-block-275 {\n    background-color: #5050ff;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642ad3ae8334521c3a7e0351_Security%20Hub.svg);\n    background-position: 115%;\n    background-repeat: no-repeat;\n    background-size: 110px;\n    border-radius: 8px;\n    padding: 8px 16px\n}\n\n.div-block-275.inegrations---finance-bg {\n    background-color: #5050ff;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642ad3ae83345266077e0370_Integrations-Finance-2.svg);\n    padding-top: 8px;\n    padding-bottom: 8px\n}\n\n.div-block-275.management-hub-bg {\n    background-color: #5050ff;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/642ad3ae8334521a587e0352_Management%20Hub%20-%205.svg);\n    padding-top: 8px;\n    padding-bottom: 8px\n}\n\n.tabs-content-2 {\n    background-color: #fff;\n    align-self: stretch;\n    width: 56%;\n    padding: 16px\n}\n\n.tab-component {\n    align-items: stretch;\n    height: 100%;\n    display: flex\n}\n\n.footer-links-2 {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 100%;\n    text-decoration: none;\n    transition: color .2s;\n    display: block\n}\n\n.footer-links-2:hover {\n    color: #d53987\n}\n\n.b-navigation-icon-wrapper {\n    grid-column-gap: 16px;\n    align-items: center;\n    display: flex\n}\n\n.navigation-heading-detail-2 {\n    color: #b6b9ce;\n    letter-spacing: .08em;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n    margin-left: 12px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 24px\n}\n\n.navigation-heading-detail-2.margin-left-0 {\n    margin-bottom: 0;\n    margin-left: 0\n}\n\n.text-block-160 {\n    color: #d53987;\n    font-size: 14px;\n    line-height: 20px\n}\n\n.div-block-279 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    display: grid\n}\n\n.sub-nav-link {\n    background-color: #fff;\n    border-radius: 8px;\n    width: 100%;\n    padding: 4px 16px\n}\n\n.sub-nav-link:hover {\n    background-color: rgba(80, 80, 255, .05);\n    border-radius: 8px\n}\n\n.button-20 {\n    background-color: var(--black);\n    border-radius: 8px;\n    margin-top: 24px;\n    padding: 12px 16px\n}\n\n.button-20.mt-0 {\n    margin-top: 0\n}\n\n.mask-5 {\n    padding-top: 0;\n    padding-bottom: 0;\n    overflow: hidden\n}\n\n.black {\n    color: var(--black)\n}\n\n.div-block-320 {\n    justify-content: flex-start;\n    align-items: center;\n    width: auto;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.div-block-320.center {\n    justify-content: center;\n    align-items: center\n}\n\n.div-block-320.social {\n    justify-content: flex-start;\n    align-items: center;\n    width: 80%;\n    margin-left: 0;\n    margin-right: 0\n}\n\n.div-block-320.new {\n    margin-top: 60px\n}\n\n.image-76 {\n    height: 140px\n}\n\n.image-76.resize {\n    height: 123px\n}\n\n.ml-16 {\n    align-items: center;\n    margin-left: 16px;\n    display: flex\n}\n\n.div-block-321 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr auto;\n    grid-auto-columns: 1fr;\n    margin-left: 2%;\n    display: grid\n}\n\n.image-77 {\n    height: 32px;\n    font-size: 18px\n}\n\n.div-block-322 {\n    align-items: center;\n    display: flex\n}\n\n.image-78 {\n    height: 24px\n}\n\n.div-block-323 {\n    align-items: center;\n    display: flex\n}\n\n.div-block-331 {\n    margin-top: 16px\n}\n\n.close-wrapper {\n    cursor: pointer;\n    background-color: #fff;\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    font-weight: 700;\n    display: flex;\n    position: absolute;\n    top: 2rem;\n    bottom: auto;\n    left: auto;\n    right: 2rem\n}\n\n.text-block-183 {\n    text-transform: capitalize;\n    cursor: pointer\n}\n\n.large-link-3 {\n    transform-origin: 100%;\n    color: #fff;\n    white-space: nowrap;\n    background-color: #000;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    margin-left: 16px;\n    padding: 22px 40px;\n    text-decoration: none;\n    transition: background-color .34s;\n    display: flex;\n    overflow: hidden\n}\n\n.large-link-3:hover {\n    background-color: #d53987\n}\n\n.nav-link-register-2 {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 16px;\n    padding-right: 16px;\n    font-weight: 500;\n    transition: all .4s\n}\n\n.nav-link-register-2:hover {\n    color: #d53987\n}\n\n.nav-link-register-2.hide {\n    display: block\n}\n\n.text-block-184 {\n    color: #d53987;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 16px\n}\n\n.text-block-185 {\n    color: #d53987;\n    font-size: 16px;\n    text-decoration: none\n}\n\n.persona-dropdown-wrap-2 {\n    background-color: #fff;\n    border-radius: 10px;\n    width: 400px;\n    padding: 20px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .16)\n}\n\n.persona-dropdown-wrap-2.product-drop-down {\n    width: 720px;\n    position: static\n}\n\n.persona-dropdown-wrap-2.resources {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 800px;\n    display: block\n}\n\n.persona-dropdown-wrap-2.product {\n    width: 792px\n}\n\n.dropdown-toggle-3 {\n    align-items: center;\n    padding-left: 12px;\n    padding-right: 12px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500;\n    display: flex\n}\n\n.dropdown-toggle-3.w--open:hover {\n    color: #d53987\n}\n\n.dropdown-toggle-3.product {\n    display: none;\n    overflow: visible\n}\n\n.nav-link-5 {\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 12px;\n    padding-right: 12px;\n    font-weight: 500;\n    transition: all .4s;\n    display: none\n}\n\n.nav-link-5:hover,\n.nav-link-5.w--current {\n    color: #d53987\n}\n\n.nav-link-5.show {\n    display: block\n}\n\n.div-block-332 {\n    justify-content: center;\n    width: 100%;\n    display: flex\n}\n\n.heading-122 {\n    text-align: center\n}\n\n.div-block-333 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    margin-top: 120px;\n    margin-left: 4%;\n    margin-right: 4%;\n    display: grid\n}\n\n.div-block-334 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    border-top: 1px dashed rgba(213, 57, 135, .5);\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: center;\n    padding-left: 16px;\n    padding-right: 16px;\n    display: grid;\n    position: relative\n}\n\n.div-block-334.border-gradient {\n    outline-offset: 0px;\n    border-top: 1px dashed rgba(213, 57, 135, .5);\n    outline: 3px #000\n}\n\n.paragraph-70 {\n    text-align: center;\n    font-size: 16px;\n    line-height: 22px\n}\n\n.heading-123 {\n    margin-top: 10px;\n    margin-bottom: 0;\n    line-height: 28px\n}\n\n.image-82 {\n    z-index: 1;\n    height: 64px;\n    margin-top: -32px;\n    position: relative\n}\n\n.image-83,\n.image-84 {\n    height: 64px;\n    margin-top: -32px\n}\n\n.image-85 {\n    z-index: 1;\n    height: 64px;\n    margin-top: -32px;\n    position: relative\n}\n\n.text-span-165 {\n    color: var(--pabloo-green)\n}\n\n.div-block-335 {\n    background-color: var(--white);\n    width: 50%;\n    height: 2px;\n    position: absolute;\n    top: -2px;\n    bottom: auto;\n    left: 0%;\n    right: auto\n}\n\n.div-block-336 {\n    background-color: var(--white);\n    width: 50%;\n    height: 2px;\n    position: absolute;\n    top: -2px;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.image-86 {\n    width: 80px;\n    height: 80px;\n    margin-left: 16px\n}\n\n.blog-book-demo-block {\n    background-color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/646f3ea5eeb4ddfdaefe08cd_image%20\\(22\\).png);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 10px;\n    width: 100%;\n    padding: 45px 35px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 120px\n}\n\n.blog-book-demo-box {\n    max-width: 320px;\n    display: block;\n    position: relative\n}\n\n.book-cta-title {\n    color: var(--white);\n    margin-top: 0;\n    margin-bottom: 40px;\n    font-size: 34px;\n    line-height: 49px\n}\n\n.wrapper-block {\n    width: 100%;\n    padding-right: 32px\n}\n\n.wrapper-block.blog {\n    flex-direction: column;\n    display: flex\n}\n\n.modal-popup {\n    z-index: 999;\n    background-color: rgba(0, 0, 0, .5);\n    display: none;\n    position: fixed;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.modal-popup-block {\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    display: flex\n}\n\n.modal-popup-content {\n    background-color: #d53987;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/643abee3fbcacf3d18ccff85_ads-bg.svg);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    border-radius: 14px;\n    width: 100%;\n    max-width: 860px;\n    height: auto;\n    padding: 40px 60px;\n    position: relative\n}\n\n.model-title {\n    color: var(--white);\n    max-width: 85%;\n    margin-bottom: 20px;\n    font-size: 42px;\n    line-height: 130.5%\n}\n\n.modal-list {\n    color: var(--white);\n    max-width: 58%;\n    margin-top: -7px;\n    margin-bottom: 40px;\n    padding-left: 20px;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 130.5%\n}\n\n.modal-list-item {\n    padding-top: 7px;\n    padding-bottom: 7px\n}\n\n.ads-banner-img {\n    position: absolute;\n    top: auto;\n    bottom: 28px;\n    left: auto;\n    right: 35px\n}\n\n.model-close {\n    background-color: #fff;\n    border-radius: 100%;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    position: absolute;\n    top: -9%;\n    bottom: auto;\n    left: auto;\n    right: 0%\n}\n\n.model-close-img {\n    width: 30px;\n    height: 30px\n}\n\n.div-block-337 {\n    border: 2px solid var(--light-pink);\n    background-color: var(--pabloo-green);\n    border-radius: 80px;\n    padding: 0 16px\n}\n\n.ssms-button-wrapper {\n    grid-column-gap: 24px;\n    white-space: nowrap;\n    margin-top: 40px;\n    display: flex\n}\n\n.button-border {\n    color: #000;\n    background-color: rgba(56, 152, 236, 0);\n    border: 1.5px solid #000;\n    border-radius: 8px;\n    justify-content: center;\n    align-items: center;\n    font-size: 20px;\n    font-weight: 700;\n    display: flex\n}\n\n.ssms-second-2 {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    display: flex\n}\n\n.image-87 {\n    align-self: center;\n    max-width: 800px\n}\n\n.ssms-second-content {\n    grid-row-gap: 20px;\n    text-align: center;\n    letter-spacing: .2px;\n    flex-direction: column;\n    align-self: center;\n    max-width: 680px;\n    margin-bottom: 80px;\n    font-weight: 500;\n    display: flex\n}\n\n.ssms-h2 {\n    text-align: center\n}\n\n.ssms-2-grid {\n    grid-column-gap: 32px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.ssms-grid-item {\n    letter-spacing: 0;\n    max-width: 330px;\n    font-size: 20px;\n    line-height: 1.33333\n}\n\n.ssms-h3 {\n    letter-spacing: 0;\n    margin-bottom: 12px;\n    font-size: 23px;\n    font-weight: 700;\n    line-height: 1.3\n}\n\n.ssms-sec-3-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-wrap: wrap;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    justify-items: center;\n    width: 100%;\n    margin-top: 80px;\n    display: none\n}\n\n.ssms-sec-3-grid-item {\n    box-shadow: -6px 8px 0 0 var(--pabloo-green);\n    letter-spacing: .2px;\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 35px;\n    font-size: 24px;\n    line-height: 1.33333\n}\n\n.ssms-step-text {\n    color: var(--pabloo-green);\n    letter-spacing: -.5px;\n    background-color: #f3f3f2;\n    border-radius: 100px;\n    padding: 10px 30px;\n    font-size: 32px;\n    font-style: italic;\n    font-weight: 700;\n    line-height: 1.125;\n    display: inline-block\n}\n\n.ssms-3-h3 {\n    letter-spacing: .2px;\n    font-size: 34px;\n    line-height: 1.23529\n}\n\n.div-block-338 {\n    flex-direction: column;\n    align-items: center;\n    display: flex;\n    transform: translateY(-90px)\n}\n\n.cta-bottom-fold {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.b-navigation-base-2 {\n    border-radius: 0;\n    flex: 1;\n    padding: 8px 16px;\n    box-shadow: 0 48px 140px -78px rgba(0, 0, 0, .08)\n}\n\n.grid-5 {\n    display: block\n}\n\n.split-image-wrapper-3 {\n    width: 48%;\n    max-width: 560px;\n    margin-top: 24px;\n    position: static\n}\n\n.slide-11 {\n    width: 20%;\n    margin-right: 16px\n}\n\n.left-arrow-7 {\n    z-index: 0;\n    background-color: #000;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.b-navigation-large-grid-2 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    margin-bottom: 16px\n}\n\n.buying-hub---hero-image {\n    width: 100%;\n    max-width: none\n}\n\n.navigation-toggle-4 {\n    color: #160042;\n    letter-spacing: -.01em;\n    border-radius: 50px 50px 24px 24px;\n    align-items: center;\n    height: 100%;\n    padding: 12px 30px 12px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-decoration: none;\n    transition: all .35s\n}\n\n.navigation-toggle-4:hover {\n    background-color: #fff\n}\n\n.navigation-grid-3 {\n    grid-column-gap: 32px;\n    grid-row-gap: 0px;\n    object-fit: fill;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    height: auto;\n    padding-left: 8px;\n    padding-right: 8px\n}\n\n.nav-list {\n    padding-top: 6px;\n    padding-bottom: 6px;\n    font-size: 16px;\n    font-weight: 400\n}\n\n.review-slider-author-wrapper-2 {\n    flex: none;\n    align-items: center;\n    max-width: none;\n    display: flex\n}\n\n.top-tag-text-2 {\n    color: #ebb82f;\n    text-transform: uppercase;\n    margin-left: 20px;\n    margin-right: 20px;\n    font-weight: 700\n}\n\n.top-tag-text-2.black {\n    color: #000\n}\n\n.auto-slider-arrow-left-3 {\n    background-color: transparent;\n    border-radius: 50px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    padding: 10px 5px;\n    transition: background-color .3s;\n    display: none;\n    position: absolute;\n    top: auto;\n    bottom: -20px;\n    left: auto;\n    right: 100px\n}\n\n.auto-slider-arrow-left-3:hover {\n    background-color: #fff\n}\n\n.auto-slider-arrow-left-3.show {\n    background-color: #fff;\n    width: 64px;\n    padding-left: 0;\n    padding-right: 0;\n    display: flex;\n    bottom: 22px;\n    right: 120px\n}\n\n.auto-slider-arrow-left-3.show:hover {\n    background-color: #fff\n}\n\n.b-navigation-link-icon-2 {\n    grid-column-gap: 44px;\n    grid-row-gap: 44px;\n    color: #000;\n    border-radius: 16px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 12px 16px;\n    text-decoration: none;\n    transition: all .3s;\n    display: flex\n}\n\n.b-navigation-link-icon-2:hover {\n    color: #d53987;\n    background-color: #f8fafc\n}\n\n.right-arrow-7 {\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.new-button {\n    color: #5050ff;\n    background-color: #fff;\n    border: 2px solid #5050ff;\n    border-radius: 8px;\n    transition: background-color .2s\n}\n\n.new-button:hover {\n    color: #fff;\n    background-color: #5050ff\n}\n\n.new-button.pink {\n    color: #d53987;\n    background-color: #fff;\n    border-color: #d53987\n}\n\n.new-button.pink:hover {\n    color: #fff;\n    background-color: #d53987\n}\n\n.testimonials-section {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.wrapper-1300px-3 {\n    z-index: 2;\n    background-color: transparent;\n    border-radius: 16px;\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 160px 80px 40px;\n    position: relative\n}\n\n.wrapper-1300px-3.integrations-fold {\n    background-color: #fff;\n    border: 6px #c73a88;\n    border-radius: 32px;\n    padding-top: 8px;\n    padding-bottom: 8px\n}\n\n.wrapper-1300px-3.testimonials-wrapper {\n    padding-top: 8px;\n    padding-bottom: 8px\n}\n\n.footer-content-wrapper-2 {\n    flex-direction: column;\n    display: flex\n}\n\n.hover-block__text {\n    flex-wrap: wrap;\n    flex: 0 auto;\n    justify-content: center;\n    align-self: center;\n    align-items: center;\n    width: 90%;\n    max-width: 398px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: static;\n    top: 50%\n}\n\n.page-subheading {\n    margin-top: 8px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 140%\n}\n\n.review-slide-3 {\n    background-color: transparent;\n    border-radius: 0;\n    margin-top: 0;\n    padding: 24px 0 40px\n}\n\n.navigation-list-2 {\n    z-index: 99;\n    min-width: 100%\n}\n\n.navigation-list-2.w--open {\n    background-color: #fff;\n    width: 56%;\n    min-width: auto;\n    max-width: none;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    top: 90px;\n    bottom: auto;\n    left: 0%;\n    right: 0\n}\n\n.navigation-list-2.product.w--open {\n    width: 130%\n}\n\n.navigation-list-2.solutions {\n    border-radius: 16px;\n    width: 60%;\n    min-width: auto;\n    top: 64px;\n    left: 0\n}\n\n.navigation-list-2.product {\n    width: 120%;\n    top: 64px;\n    left: 0%\n}\n\n.navigation-list-2.resources {\n    border-radius: 16px;\n    width: 120%;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    top: 64px\n}\n\n.mask-not-visible-2 {\n    border-radius: 10px\n}\n\n.page-heading {\n    margin-bottom: 8px;\n    font-size: 56px\n}\n\n.image-108 {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-367 {\n    grid-column-gap: 2px;\n    grid-row-gap: 2px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr auto;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    width: 100%;\n    margin-top: 64px;\n    display: block\n}\n\n.text-block-193 {\n    color: #fff;\n    font-family: Satoshi, sans-serif;\n    font-size: 14px;\n    font-weight: 500\n}\n\n.div-block-368 {\n    margin-top: 6px;\n    font-family: \"P22mackinacpro 15\", sans-serif\n}\n\n.split-button-wrapper-3 {\n    margin-top: 24px\n}\n\n.div-block-369 {\n    background-color: #5050ff;\n    border: 3px #000;\n    border-radius: 16px;\n    margin-left: 4%;\n    margin-right: 4%;\n    padding: 32px\n}\n\n.div-block-370 {\n    border: 2px solid #000;\n    border-radius: 16px;\n    margin-top: 64px\n}\n\n.div-block-371 {\n    margin-top: 24px;\n    display: flex\n}\n\n.persona-down-hero-bg-3 {\n    background-color: #fff;\n    width: 100%;\n    height: 120px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.div-block-372 {\n    align-items: center;\n    display: flex\n}\n\n.heading-141 {\n    text-align: center;\n    margin-bottom: 64px;\n    font-size: 48px;\n    font-weight: 700\n}\n\n.hollow-button-3 {\n    color: #000;\n    text-align: center;\n    background-color: transparent;\n    border: 2px solid #000;\n    padding: 22px;\n    font-size: 20px;\n    font-weight: 700;\n    transition: color .36s, background-color .36s\n}\n\n.hollow-button-3:hover {\n    color: #fff;\n    background-color: #000\n}\n\n.hollow-button-3.rounded {\n    border-radius: 12px;\n    padding: 16px 20px\n}\n\n.text-span-179 {\n    color: #d53987\n}\n\n.heading-142 {\n    font-size: 32px;\n    line-height: 40px\n}\n\n.section-25 {\n    background-color: #f7f7f5;\n    padding-bottom: 40px\n}\n\n.slide-14 {\n    width: 32%;\n    margin-top: 16px;\n    margin-bottom: 16px\n}\n\n.section-26 {\n    background-color: #fff;\n    background-image: linear-gradient(#fff, rgba(213, 57, 135, .16) 50%, #fff);\n    margin-bottom: 0;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.section-26.intergations-fold-section {\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    background-attachment: scroll;\n    position: relative\n}\n\n.review-author-job-post-3 {\n    color: rgba(0, 0, 0, .64);\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.5\n}\n\n.review-slider-container-3 {\n    background-color: #fff;\n    border-radius: 16px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    padding: 16px 0 16px 40px;\n    display: flex;\n    position: relative;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .08)\n}\n\n.review-slider-container-3.home {\n    box-shadow: none;\n    background-color: transparent;\n    padding-left: 20px\n}\n\n.div-block-374 {\n    justify-content: center;\n    margin-top: 20px;\n    display: flex\n}\n\n.review-slider-text-4 {\n    color: #000;\n    margin-left: auto;\n    margin-right: auto;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.5\n}\n\n.image-111 {\n    height: 64px\n}\n\n.image-111.m-l-8 {\n    filter: saturate(151%);\n    width: 80px;\n    height: 80px;\n    margin-left: 8px\n}\n\n.div-block-376 {\n    margin-top: 32px\n}\n\n.heading-145 {\n    color: #fff;\n    font-size: 40px\n}\n\n.b-navigation-link-icon-3 {\n    grid-column-gap: 44px;\n    grid-row-gap: 44px;\n    color: #000;\n    border-radius: 16px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 12px 16px;\n    text-decoration: none;\n    transition: all .3s;\n    display: flex\n}\n\n.b-navigation-link-icon-3:hover {\n    color: #d53987;\n    background-color: #f8fafc\n}\n\n.text-span-180 {\n    color: #d53987\n}\n\n.about-hero-wrapper-3 {\n    background-color: #5050ff;\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    margin-bottom: 90px;\n    padding-top: 88px;\n    padding-bottom: 0;\n    position: relative\n}\n\n.about-hero-wrapper-3.white-bg {\n    background-color: #fff\n}\n\n.about-hero-wrapper-3.white-bg.margin-top-40 {\n    padding-top: 40px\n}\n\n.about-hero-wrapper-3.white-bg.margin-top-40.transparent-bg {\n    background-color: transparent;\n    margin-bottom: 0;\n    padding-top: 0\n}\n\n.paragraph-91 {\n    margin-top: 16px;\n    font-weight: 500;\n    line-height: 32px\n}\n\n.button-25 {\n    color: #fff;\n    background-color: #000;\n    border-radius: 12px;\n    padding: 12px 20px;\n    font-weight: 500\n}\n\n.home-slider-image-4 {\n    width: 30%;\n    max-width: 400px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.navigation-dropdown-base-3 {\n    background-color: #fff;\n    border: 4px solid #fff;\n    border-radius: 0 0 24px 24px;\n    max-width: none;\n    margin-left: auto;\n    margin-right: auto;\n    overflow: hidden;\n    box-shadow: 5px 48px 140px -48px rgba(57, 59, 106, .08)\n}\n\n.div-block-381 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    border: 2px solid #000;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-content: space-between;\n    align-items: flex-start;\n    height: 100%;\n    padding: 16px;\n    display: grid\n}\n\n.div-block-381:hover {\n    box-shadow: 5px 6px #000\n}\n\n.heading-148 {\n    text-align: center;\n    margin-bottom: 24px;\n    font-size: 48px\n}\n\n.link-block-30 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.link-block-31 {\n    align-items: center;\n    display: flex\n}\n\n.link-block-31:hover {\n    /* text-decoration: none */\n}\n\n.top-tag-line-3 {\n    background-color: #ebb82f;\n    width: 40px;\n    height: 2px\n}\n\n.top-tag-line-3.black {\n    background-color: #000\n}\n\n.div-block-382 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.slider-12 {\n    background-color: #fff;\n    border-radius: 16px;\n    height: 100%;\n    padding: 12px\n}\n\n.badge-standard-5 {\n    color: #fff;\n    background-color: #d53987;\n    border-radius: 50px;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 12px;\n    font-size: 12px;\n    line-height: 16px;\n    display: flex\n}\n\n.text-block-197 {\n    color: #5050ff;\n    font-weight: 500\n}\n\n.slide-15 {\n    width: 32%;\n    margin-top: 16px;\n    margin-bottom: 16px;\n    margin-right: 2%\n}\n\n.image-116 {\n    height: 60px;\n    margin-left: 8px\n}\n\n.image-116.m-l-0 {\n    height: 80px;\n    margin-left: 0\n}\n\n.paragraph-93 {\n    color: #fff;\n    margin-top: 24px\n}\n\n.review-company-image-container-3 {\n    flex: none;\n    height: 28px;\n    margin-bottom: 16px;\n    line-height: 40px\n}\n\n.review-company-image-container-3.airmeet-logo-wrapper {\n    height: 28px\n}\n\n.image-117 {\n    text-align: center;\n    width: 100%;\n    margin-right: auto\n}\n\n.footer-links-4 {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 100%;\n    text-decoration: none;\n    transition: color .2s;\n    display: block\n}\n\n.footer-links-4:hover {\n    color: #d53987\n}\n\n.footer-links-4.hide {\n    display: none\n}\n\n.navigation-6 {\n    background-color: #fff;\n    align-items: center;\n    width: 100%;\n    min-height: 88px;\n    padding: 24px 5%;\n    display: flex\n}\n\n.heading-150 {\n    text-align: center\n}\n\n.section-27 {\n    background-color: #fff;\n    padding-top: 80px\n}\n\n.image-118 {\n    object-fit: cover;\n    border-radius: 8px;\n    height: 100%\n}\n\n.logo-6 {\n    width: 124px\n}\n\n.image-119 {\n    object-fit: cover;\n    border-radius: 8px;\n    height: 100%\n}\n\n.text-block-199 {\n    color: #d53987;\n    font-size: 16px;\n    text-decoration: none\n}\n\n.image-120 {\n    height: 14px;\n    margin-top: 1px;\n    margin-left: 8px\n}\n\n.navigation-icon-arrow-5 {\n    margin-right: 10px\n}\n\n.button-26 {\n    background-color: #000;\n    border-radius: 8px;\n    margin-top: 24px;\n    padding: 12px 16px\n}\n\n.button-26.mt-0 {\n    margin-top: 0;\n    padding-left: 12px;\n    padding-right: 12px;\n    font-size: 16px\n}\n\n.div-block-391 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: #fff;\n    border-top: 2px rgba(0, 0, 0, .07);\n    border-radius: 0;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 0;\n    padding: 12px 8px;\n    display: grid\n}\n\n.div-block-391:hover {\n    background-color: rgba(213, 57, 135, .05)\n}\n\n.div-block-391.margin-top-reset {\n    margin-top: 0\n}\n\n.div-block-391.margin-top-reset:hover {\n    background-color: rgba(213, 57, 135, .05)\n}\n\n.div-block-391.margin-top-reset.no-border {\n    border-top-style: none;\n    padding-top: 12px\n}\n\n.list-14 {\n    padding-left: 0\n}\n\n.paragraph-96 {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px\n}\n\n.b-navigation-link-icon-4 {\n    grid-column-gap: 44px;\n    grid-row-gap: 44px;\n    color: #000;\n    border-radius: 8px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 8px 16px;\n    text-decoration: none;\n    transition: all .3s;\n    display: flex\n}\n\n.b-navigation-link-icon-4:hover {\n    color: #d53987;\n    background-color: #f8fafc\n}\n\n.div-block-392 {\n    background-color: #0f1444;\n    border-radius: 8px;\n    align-items: center;\n    display: flex\n}\n\n.navigation-menu-6 {\n    align-items: center;\n    display: flex;\n    position: relative\n}\n\n.text-block-200 {\n    color: #d53987;\n    font-size: 16px;\n    text-decoration: none\n}\n\n.div-block-393 {\n    background-color: #0f1444;\n    border-radius: 8px;\n    align-items: center;\n    display: flex\n}\n\n.text-block-201 {\n    font-size: 16px;\n    font-weight: 700\n}\n\n.b-navigation-column-4 {\n    grid-row-gap: 2px;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex\n}\n\n.navigation-link-6 {\n    color: #000;\n    letter-spacing: -.01em;\n    white-space: nowrap;\n    background-color: transparent;\n    border-radius: 50px;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    text-decoration: none;\n    transition: all .35s\n}\n\n.navigation-link-6:hover {\n    color: #d53987;\n    background-color: #fff\n}\n\n.navigation-link-6.w--current {\n    color: #d53987\n}\n\n.paragraph-97 {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px\n}\n\n.div-block-394 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto 1fr;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    padding-left: 8px;\n    display: grid\n}\n\n.div-block-395 {\n    align-items: center;\n    display: flex\n}\n\n.text-span-181 {\n    color: #5050ff\n}\n\n.review-slider-content-wrapper-4 {\n    flex: none;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    min-height: 100px;\n    margin-bottom: 16px;\n    display: flex\n}\n\n.div-block-396 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: #fff;\n    background-image: radial-gradient(circle at 100% 100%, #d53987, #fff 45%);\n    border-radius: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 25% 75%;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid;\n    position: relative;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .06)\n}\n\n.div-block-396.border {\n    box-shadow: none;\n    background-image: none;\n    border: 3px solid rgba(80, 80, 255, .4);\n    grid-template-columns: 30% 70%;\n    padding: 16px\n}\n\n.heading-152 {\n    text-align: center;\n    font-size: 32px;\n    line-height: 40px\n}\n\n.image-121 {\n    border-radius: 60px;\n    margin-top: 0\n}\n\n.image-122 {\n    object-fit: contain;\n    border-radius: 300px;\n    width: 100%;\n    height: auto\n}\n\n.div-block-397 {\n    display: none\n}\n\n.div-block-398 {\n    background-color: transparent;\n    border-top-right-radius: 24px;\n    border-bottom-right-radius: 24px;\n    flex: 0 auto;\n    justify-content: flex-end;\n    align-self: auto;\n    align-items: stretch;\n    width: 100%;\n    height: 340px;\n    max-height: 340px;\n    display: flex;\n    position: static;\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.div-block-398.uc-image-wrapper {\n    background-color: transparent;\n    border-radius: 300px;\n    justify-content: center;\n    width: 240px;\n    height: 240px;\n    padding: 16px\n}\n\n.image-124 {\n    border-radius: 8px;\n    height: 56px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.image-125 {\n    width: 100%\n}\n\n.link-block-32 {\n    border-bottom: 1px solid #fff\n}\n\n.heading-153 {\n    color: #000\n}\n\n.mask-8 {\n    overflow: hidden\n}\n\n.heading-154 {\n    color: #000;\n    text-align: center;\n    width: 100%\n}\n\n.hollow-button-4 {\n    color: #000;\n    text-align: center;\n    background-color: transparent;\n    border: 2px solid #000;\n    padding: 22px;\n    font-size: 20px;\n    font-weight: 700;\n    transition: color .36s, background-color .36s\n}\n\n.hollow-button-4:hover {\n    color: #fff;\n    background-color: #000\n}\n\n.hollow-button-4.rounded {\n    border-radius: 12px;\n    padding: 16px 20px\n}\n\n.text-block-202 {\n    color: #fff\n}\n\n.heading-155 {\n    color: #000;\n    text-align: center;\n    font-size: 48px\n}\n\n.slider-13 {\n    background-color: transparent;\n    display: block\n}\n\n.div-block-399 {\n    margin-top: 32px;\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.div-block-399.integrations-section-container {\n    padding-top: 32px;\n    padding-bottom: 32px\n}\n\n.div-block-400 {\n    justify-content: center;\n    display: flex\n}\n\n.div-block-400.hide {\n    display: none\n}\n\n.div-block-401 {\n    border-top: 1px solid rgba(255, 255, 255, .6);\n    margin-top: 16px;\n    padding-top: 24px\n}\n\n.heading-156,\n.heading-157 {\n    color: #000;\n    text-align: center;\n    width: 100%\n}\n\n.paragraph-98 {\n    color: #000;\n    text-align: center;\n    margin-top: 16px;\n    font-weight: 400\n}\n\n.div-block-402 {\n    justify-content: flex-end;\n    margin-left: 6%;\n    margin-right: 8%;\n    display: flex\n}\n\n.div-block-403 {\n    background-color: #fff;\n    border-radius: 20px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 40px 12px 20px;\n    display: flex;\n    position: relative\n}\n\n.image-128 {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-404 {\n    grid-column-gap: 2px;\n    grid-row-gap: 2px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr auto;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    width: 100%;\n    margin-top: 64px;\n    display: block\n}\n\n.div-block-404.border {\n    border: 1px none var(--light-slate-grey)\n}\n\n.div-block-407 {\n    border: 2px solid #000;\n    border-radius: 16px;\n    margin-top: 64px\n}\n\n.image-90 {\n    width: 100%\n}\n\n.image-90.hide {\n    display: none\n}\n\n.div-block-409 {\n    align-items: center;\n    display: flex\n}\n\n.heading-160 {\n    text-align: center;\n    margin-bottom: 64px;\n    font-size: 48px;\n    font-weight: 700\n}\n\n.section-28 {\n    background-color: #f7f7f5;\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.text-span-183 {\n    color: #d53987\n}\n\n.heading-161 {\n    font-size: 32px;\n    line-height: 40px\n}\n\n.slide-16 {\n    width: 32%;\n    margin-top: 16px;\n    margin-bottom: 16px\n}\n\n.div-block-411 {\n    justify-content: center;\n    margin-top: 20px;\n    display: flex\n}\n\n.b-navigation-link-icon-5 {\n    grid-column-gap: 44px;\n    grid-row-gap: 44px;\n    color: #000;\n    border-radius: 16px;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: 12px 16px;\n    text-decoration: none;\n    transition: all .3s;\n    display: flex\n}\n\n.b-navigation-link-icon-5:hover {\n    color: #d53987;\n    background-color: #f8fafc\n}\n\n.paragraph-100 {\n    margin-top: 16px;\n    font-weight: 500;\n    line-height: 32px\n}\n\n.home-slider-image-5 {\n    width: 30%;\n    max-width: 400px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.div-block-419 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    border: 2px solid #000;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-content: space-between;\n    align-items: flex-start;\n    height: 100%;\n    padding: 16px;\n    display: grid\n}\n\n.div-block-419:hover {\n    box-shadow: 5px 6px #000\n}\n\n.link-block-33 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-420 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.persona-head-para-2 {\n    color: #fff;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 140%\n}\n\n.persona-head-para-2.it {\n    max-width: 920px\n}\n\n.persona-head-para-2.it.black {\n    color: #000;\n    margin-top: 24px;\n    font-weight: 400;\n    line-height: 140%\n}\n\n.slider-15 {\n    background-color: #fff;\n    border-radius: 16px;\n    height: 100%;\n    padding: 12px\n}\n\n.text-block-207 {\n    color: #5050ff;\n    font-weight: 500\n}\n\n.slide-17 {\n    width: 32%;\n    margin-top: 16px;\n    margin-bottom: 16px;\n    margin-right: 2%\n}\n\n.image-137 {\n    text-align: center;\n    width: 100%;\n    margin-right: auto\n}\n\n.heading-168 {\n    text-align: center\n}\n\n.text-span-174 {\n    color: #d53987\n}\n\n.image-140 {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.slide-18 {\n    border: 2px #000;\n    border-radius: 0\n}\n\n.div-block-430 {\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    margin-top: 32px;\n    display: flex\n}\n\n.div-block-432 {\n    border: 2px solid #000;\n    border-radius: 16px;\n    margin-top: 64px\n}\n\n.slider-16 {\n    background-color: #fff;\n    width: 100%;\n    height: 100%\n}\n\n.image-143 {\n    object-fit: fill;\n    border: 1px #000;\n    border-radius: 0;\n    width: 100%;\n    max-width: 100%;\n    height: auto\n}\n\n.div-block-434 {\n    align-items: center;\n    display: flex\n}\n\n.left-arrow-8 {\n    background-color: #d53987;\n    border-radius: 120px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    top: auto;\n    bottom: -48px;\n    left: auto;\n    right: 24%\n}\n\n.left-arrow-8.hide {\n    display: none\n}\n\n.text-span-185 {\n    color: #d53987\n}\n\n.heading-171 {\n    font-size: 32px;\n    line-height: 40px\n}\n\n.section-30 {\n    background-color: #f7f7f5;\n    padding-bottom: 40px\n}\n\n.cta---pink---rounded-2 {\n    background-color: #d53987;\n    border-radius: 12px;\n    margin-top: 24px;\n    padding: 16px;\n    font-weight: 500\n}\n\n.cta---pink---rounded-2.mt-40 {\n    margin-top: 80px\n}\n\n.slide-19 {\n    width: 32%;\n    margin-top: 16px;\n    margin-bottom: 16px\n}\n\n.heading-130 {\n    text-align: center;\n    margin-bottom: 24px;\n    font-size: 48px\n}\n\n.right-arrow-8 {\n    background-color: #d53987;\n    border-radius: 120px;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    top: auto;\n    bottom: -48px;\n    left: auto;\n    right: 19%\n}\n\n.right-arrow-8.hide {\n    display: none\n}\n\n.div-block-436 {\n    object-fit: fill;\n    border: 3px #d53987;\n    border-radius: 16px;\n    width: 72%;\n    margin-left: auto;\n    margin-right: auto;\n    box-shadow: 0 0 16px rgba(0, 0, 0, .11)\n}\n\n.slide-nav-6 {\n    font-size: 14px;\n    bottom: -32px\n}\n\n.div-block-437 {\n    justify-content: center;\n    margin-top: 20px;\n    display: flex\n}\n\n.paragraph-105 {\n    margin-top: 16px;\n    font-weight: 500;\n    line-height: 32px\n}\n\n.right-arrow-9 {\n    top: auto;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.home-slider-image-6 {\n    width: 30%;\n    max-width: 400px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.heading-177 {\n    color: #000;\n    margin-top: 0;\n    font-size: 24px;\n    line-height: 32px\n}\n\n.div-block-444 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    border: 2px solid #000;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-content: space-between;\n    align-items: flex-start;\n    height: 100%;\n    padding: 16px;\n    display: grid\n}\n\n.div-block-444:hover {\n    box-shadow: 5px 6px #000\n}\n\n.div-block-445 {\n    border-left: 2px solid #f5cde1;\n    width: 72%;\n    margin-top: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    padding-left: 8px\n}\n\n.text-span-186 {\n    color: #d53987\n}\n\n.link-block-35 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.image-147 {\n    border-radius: 0\n}\n\n.div-block-446 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.slider-18 {\n    background-color: #fff;\n    border-radius: 16px;\n    height: 100%;\n    padding: 12px\n}\n\n.text-block-213 {\n    color: #5050ff;\n    font-weight: 500\n}\n\n.slide-20 {\n    width: 32%;\n    margin-top: 16px;\n    margin-bottom: 16px;\n    margin-right: 2%\n}\n\n.div-block-449 {\n    border: 2px #000;\n    border-radius: 0;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.image-151 {\n    text-align: center;\n    width: 100%;\n    margin-right: auto\n}\n\n.heading-179 {\n    text-align: center\n}\n\n.paragraph-108 {\n    color: #000;\n    font-size: 16px\n}\n\n.html-embed-25 {\n    width: 100%\n}\n\n.new-testimonialls {\n    justify-content: center;\n    padding-bottom: 36px;\n    display: flex\n}\n\n.section-max-sav {\n    background-color: var(--pabloo-green);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/644761acced7884b76421c2f_Group%20143.png), url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/644761854084c90dc5be977b_Group%20144.png);\n    background-position: 100% 100%, 0 100%;\n    background-repeat: no-repeat, no-repeat;\n    background-size: 30%, 30%\n}\n\n.max-save-compoennt {\n    width: 100%;\n    max-width: 840px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.max-sav-heading {\n    color: #fff;\n    text-align: center;\n    letter-spacing: -.5px\n}\n\n.max-save-para {\n    color: #fff;\n    text-align: center;\n    max-width: 600px;\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    font-weight: 500\n}\n\n.div-block-456 {\n    grid-row-gap: 30px;\n    flex-direction: column;\n    align-items: stretch;\n    margin-top: 80px;\n    display: flex\n}\n\n.text-block-215 {\n    color: #fff;\n    background-color: rgba(255, 255, 255, .2);\n    border-radius: 100px;\n    padding: 12px 24px;\n    font-size: 20px;\n    line-height: 1;\n    display: none\n}\n\n.div-block-457 {\n    grid-column-gap: 60px;\n    grid-row-gap: 20px;\n    background-color: #fff;\n    border-radius: 10px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr auto;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    justify-items: start;\n    margin-top: 24px;\n    margin-bottom: 80px;\n    padding: 25px 32px;\n    display: grid;\n    box-shadow: 7px 7px rgba(255, 255, 255, .2)\n}\n\n.div-block-457.hide {\n    display: none\n}\n\n.text-block-218 {\n    color: rgba(0, 0, 0, .6);\n    letter-spacing: .2px;\n    line-height: 1\n}\n\n.text-block-219 {\n    color: var(--pabloo-green);\n    font-size: 44px;\n    font-style: italic;\n    font-weight: 700;\n    line-height: 1\n}\n\n.button-31 {\n    background-color: var(--white);\n    color: var(--pabloo-green);\n    padding: 12px 16px;\n    font-size: 16px;\n    font-weight: 500\n}\n\n.blog-secondary-author-wrapper {\n    margin-left: 32px\n}\n\n.rich-text-block-23 {\n    margin-top: 8px;\n    font-size: 18px;\n    line-height: 32px\n}\n\n.div-block-458 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 2fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 16px;\n    padding-left: 32px;\n    padding-right: 32px;\n    display: block\n}\n\n.section-32 {\n    margin-top: 80px;\n    margin-bottom: 80px\n}\n\n.rich-text-block-24 {\n    text-align: center;\n    margin-top: 0;\n    font-size: 18px;\n    line-height: 32px\n}\n\n.heading-180 {\n    text-align: center;\n    margin-top: 8px;\n    font-size: 48px;\n    font-weight: 500;\n    line-height: 1.2\n}\n\n.div-block-460 {\n    background-color: var(--white);\n    border-radius: 20px;\n    margin-top: 0;\n    padding: 24px\n}\n\n.div-block-460.ebook-how-to-section {\n    background-color: var(--white);\n    margin-top: 120px;\n    padding-bottom: 32px\n}\n\n.div-block-461 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    display: grid\n}\n\n.div-block-462 {\n    grid-column-gap: 8px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto 1fr;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 0;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    display: grid\n}\n\n.text-block-220 {\n    text-align: center;\n    margin-top: 0;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.collection-list-wrapper-4 {\n    margin-top: 16px\n}\n\n.div-block-463 {\n    grid-column-gap: 8px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: center;\n    display: grid\n}\n\n.collection-list-wrapper-5 {\n    margin-top: 48px;\n    padding: 12px\n}\n\n.text-block-221 {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 32px\n}\n\n.div-block-464 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.section-33 {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.collection-list-5 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.collection-item-2 {\n    border: 1px solid rgba(0, 0, 0, .1);\n    border-radius: 4px;\n    padding: 8px\n}\n\n.div-block-465 {\n    background-color: var(--pabloo-green);\n    border-radius: 100%;\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    display: flex\n}\n\n.text-block-222 {\n    color: var(--white);\n    font-weight: 500\n}\n\n.div-block-466 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--pabloo-green);\n    border-radius: 12px;\n    grid-template-rows: auto;\n    grid-template-columns: .75fr 1fr;\n    grid-auto-columns: 1fr;\n    padding: 56px 40px;\n    display: grid;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, .12)\n}\n\n.heading-182 {\n    color: var(--white);\n    text-align: left;\n    margin-top: 0;\n    font-size: 40px;\n    font-weight: 500;\n    line-height: 1.2\n}\n\n.rich-text-block-26 {\n    color: var(--white);\n    font-size: 20px;\n    line-height: 1.6\n}\n\n.div-block-467 {\n    margin-top: 32px\n}\n\n.div-block-468 {\n    padding: 40px 3% 120px\n}\n\n.div-block-469 {\n    background-color: var(--white);\n    border-radius: 12px;\n    width: 100%;\n    max-width: 1140px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 40px;\n    box-shadow: 1px 1px 12px rgba(0, 0, 0, .12)\n}\n\n.div-block-470 {\n    background-color: var(--slate-blue);\n    border-radius: 100%;\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    display: flex\n}\n\n.text-block-225 {\n    color: var(--white);\n    font-weight: 500\n}\n\n.collection-list-6 {\n    grid-column-gap: 64px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: .8fr .8fr .8fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.heading-183 {\n    font-size: 48px;\n    font-weight: 500;\n    line-height: 1.2\n}\n\n.paragraph-111 {\n    margin-top: 8px;\n    font-size: 20px;\n    line-height: 32px\n}\n\n.div-block-471 {\n    border-left: 2px solid rgba(255, 255, 255, .2);\n    padding-left: 24px\n}\n\n.text-block-226 {\n    font-size: 20px;\n    font-weight: 700\n}\n\n.div-block-472 {\n    padding-top: 80px\n}\n\n.div-block-473 {\n    display: none\n}\n\n.div-block-474 {\n    flex-flow: wrap;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.div-block-475 {\n    width: 50%\n}\n\n.text-span-187 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.div-block-476 {\n    border-bottom: 1px solid rgba(0, 0, 0, .16);\n    width: 100%;\n    padding-bottom: 12px\n}\n\n.div-block-476.no-border {\n    border-bottom-style: none\n}\n\n.div-block-477 {\n    width: 100%;\n    margin-top: 24px\n}\n\n.section-34 {\n    background-color: var(--white);\n    padding-left: 6%;\n    padding-right: 6%\n}\n\n.image-157 {\n    margin-bottom: 24px\n}\n\n.div-block-478 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 70% 30%;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    max-width: 100%;\n    margin-top: 24px;\n    display: grid\n}\n\n.image-158 {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.text-span-188 {\n    font-size: 32px;\n    font-weight: 700\n}\n\n.text-span-189 {\n    font-size: 16px;\n    line-height: 28px\n}\n\n.heading-185,\n.heading-186,\n.heading-187 {\n    font-size: 48px\n}\n\n.heading-189 {\n    margin-top: 0;\n    margin-left: 0;\n    font-size: 32px;\n    line-height: 40px\n}\n\n.div-block-479 {\n    border-bottom: 1px solid rgba(0, 0, 0, .16);\n    align-items: center;\n    padding-bottom: 8px;\n    display: flex\n}\n\n.text-block-227 {\n    color: var(--white);\n    font-weight: 500\n}\n\n.text-block-228 {\n    color: var(--white);\n    margin-left: 6px;\n    font-weight: 500\n}\n\n.image-160 {\n    height: 48px\n}\n\n.image-161 {\n    height: 60px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.image-162,\n.image-163,\n.image-164,\n.image-165,\n.image-166,\n.image-167,\n.image-168 {\n    height: 48px\n}\n\n.paragraph-112 {\n    grid-column-gap: 16px;\n    display: flex\n}\n\n.div-block-480 {\n    grid-column-gap: 16px;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.button-32 {\n    background-color: var(--slate-blue);\n    border-radius: 12px;\n    padding-top: 16px;\n    padding-bottom: 16px\n}\n\n.div-block-481 {\n    background-color: #fff;\n    border-radius: 12px;\n    justify-content: center;\n    padding-top: 32px;\n    padding-bottom: 32px;\n    display: flex\n}\n\n.div-block-482 {\n    margin-bottom: 24px\n}\n\n.text-span-191 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.section-35 {\n    background-color: var(--white-smoke)\n}\n\n.div-block-489 {\n    width: 100%;\n    padding-top: 4%;\n    padding-bottom: 4%\n}\n\n.heading-191 {\n    font-size: 32px;\n    line-height: 1.2em\n}\n\n.text-block-229 {\n    margin-top: 16px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.text-span-192 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.heading-193 {\n    text-align: center;\n    font-size: 52px;\n    line-height: 1.2em\n}\n\n.div-block-491 {\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 80px;\n    padding-right: 80px\n}\n\n.container-1282 {\n    max-width: 1120px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 30px;\n    padding-right: 30px\n}\n\n.section-title {\n    text-align: center;\n    max-width: 100%;\n    margin-bottom: 60px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-194 {\n    color: var(--black);\n    text-align: center;\n    font-size: 56px;\n    font-weight: 700;\n    line-height: 1.1\n}\n\n.body-4 {\n    color: var(--black);\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.4\n}\n\n.features-grid-3 {\n    grid-column-gap: 30px;\n    grid-row-gap: 60px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr\n}\n\n.feature-block-4 {\n    background-color: var(--white-smoke);\n    text-align: center;\n    border-radius: 16px;\n    padding: 30px\n}\n\n.feature-illustration {\n    background-color: var(--white);\n    border-radius: 12px;\n    margin-bottom: 40px\n}\n\n.section-36 {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-492 {\n    flex-wrap: wrap;\n    justify-content: center;\n    width: 80%;\n    margin-top: 24px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.div-block-494 {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-495 {\n    width: 100%;\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.div-block-496 {\n    margin-top: 16px\n}\n\n.heading-197 {\n    font-size: 32px;\n    line-height: 1.4em\n}\n\n.div-block-497 {\n    margin-bottom: 40px\n}\n\n.link-38,\n.link-39,\n.text-span-195 {\n    color: var(--pabloo-green);\n    /* text-decoration: none */\n}\n\n.div-block-498 {\n    align-items: center;\n    margin-top: 16px;\n    display: flex\n}\n\n.image-170 {\n    height: 80px;\n    margin-right: 16px\n}\n\n.div-block-499 {\n    margin-top: 16px\n}\n\n.image-171 {\n    height: 80px\n}\n\n.image-172 {\n    height: 72px\n}\n\n.container-1283 {\n    max-width: 1120px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 30px;\n    padding-right: 30px\n}\n\n.section-title-2 {\n    text-align: center;\n    max-width: 100%;\n    margin-bottom: 60px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-198 {\n    color: #fff;\n    font-size: 56px;\n    font-weight: 700;\n    line-height: 1.4\n}\n\n.body-5 {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.features-grid-4 {\n    grid-column-gap: 30px;\n    grid-row-gap: 60px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr\n}\n\n.feature-block-5 {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr\n}\n\n.feature-block-2-text-wrap {\n    text-align: left\n}\n\n.columns-7 {\n    width: 100%\n}\n\n.heading-200 {\n    text-align: left\n}\n\n.heading-200.line-height-auto {\n    line-height: 1.1em\n}\n\n.paragraph-114 {\n    text-align: left\n}\n\n.column-75 {\n    padding-right: 8%\n}\n\n.div-block-500 {\n    margin-top: 20%\n}\n\n.collection-item-3 {\n    border-right: 1px rgba(0, 0, 0, .21)\n}\n\n.button-33 {\n    border-radius: 12px;\n    padding: 12px 16px\n}\n\n.image-173 {\n    object-fit: fill\n}\n\n.text-span-196,\n.text-span-197 {\n    font-size: 24px\n}\n\n.text-span-198 {\n    color: var(--pabloo-green)\n}\n\n.div-block-502 {\n    padding: 32px 1px\n}\n\n.div-block-503 {\n    grid-column-gap: 6px;\n    display: flex\n}\n\n.button-34 {\n    border-radius: 12px;\n    padding: 12px 16px\n}\n\n.empty-state-8 {\n    background-color: var(--white)\n}\n\n.text-span-199,\n.text-span-200 {\n    color: var(--pabloo-green)\n}\n\n.checkbox-label-3 {\n    font-size: 16px;\n    line-height: 16px\n}\n\n.checkbox-2 {\n    margin-top: 8px\n}\n\n.heading-201 {\n    text-align: center;\n    font-size: 48px;\n    line-height: 1.2em\n}\n\n.text-span-201 {\n    color: var(--pabloo-green)\n}\n\n.form-4 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 60% 40%;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    width: 100%;\n    padding: 16px 0;\n    display: grid\n}\n\n.div-block-508 {\n    background-color: var(--white)\n}\n\n.submit-button-4 {\n    background-color: #000;\n    font-size: 16px;\n    line-height: 20px\n}\n\n.text-field-8 {\n    margin-bottom: 0;\n    font-size: 16px;\n    line-height: 32px\n}\n\n.form-block-2 {\n    width: 100%\n}\n\n.heading-203 {\n    text-align: center;\n    margin-top: 48px;\n    margin-left: auto;\n    margin-right: auto;\n    line-height: 1.2em\n}\n\n.heading-204 {\n    color: var(--white);\n    margin-bottom: 32px;\n    font-size: 40px;\n    line-height: 1.2em\n}\n\n.bold-text-21,\n.bold-text-22 {\n    color: var(--black)\n}\n\n.link-40 {\n    display: flex\n}\n\n.link-40.w--current {\n    grid-column-gap: 4px;\n    display: block\n}\n\n.text-span-204 {\n    color: var(--pabloo-green);\n    background-color: rgba(245, 205, 225, .3);\n    border-radius: 12px;\n    margin-left: 2px;\n    padding: 4px 8px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px\n}\n\n.empty-state-9 {\n    background-color: var(--white)\n}\n\n.div-block-511 {\n    justify-content: center;\n    width: 100%;\n    margin-top: 32px;\n    display: flex\n}\n\n.div-block-513 {\n    margin-top: 24px;\n    margin-bottom: 24px\n}\n\n.div-block-514 {\n    width: 100%;\n    max-width: 820px;\n    margin-bottom: -160px\n}\n\n.section-37 {\n    background-color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f1703c61110085d41bc77b_Mask%20Group.png);\n    background-position: 100%;\n    background-repeat: no-repeat;\n    background-size: cover\n}\n\n.heading-205 {\n    color: var(--white);\n    width: 100%;\n    font-size: 48px;\n    line-height: 1.2em\n}\n\n.text-span-205 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 11\", sans-serif\n}\n\n.div-block-515 {\n    width: 100%\n}\n\n.div-block-516 {\n    grid-column-gap: 32px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    margin-top: 32px;\n    padding-top: 64px;\n    padding-bottom: 64px;\n    display: grid\n}\n\n.div-block-517 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--white);\n    border-radius: 16px;\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    padding: 20px;\n    display: grid\n}\n\n.paragraph-117 {\n    color: #000;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.paragraph-117.sub {\n    color: #64748b;\n    font-size: 18px;\n    font-weight: 500\n}\n\n.div-block-518 {\n    grid-column-gap: 40px;\n    grid-row-gap: 16px;\n    border-radius: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.75fr .75fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 16px;\n    display: grid\n}\n\n.div-block-519 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid\n}\n\n.text-block-231 {\n    color: var(--white);\n    font-size: 16px;\n    line-height: 1.2em\n}\n\n.text-block-232 {\n    color: var(--white);\n    margin-bottom: 16px;\n    font-family: P22, sans-serif;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.text-span-206 {\n    font-size: 18px;\n    line-height: 18px\n}\n\n.div-block-520,\n.div-block-521 {\n    border-left: 1px solid rgba(255, 255, 255, .24);\n    padding: 24px\n}\n\n.image-175 {\n    min-width: auto;\n    height: 150px\n}\n\n.image-176 {\n    height: 160px\n}\n\n.div-block-522 {\n    align-items: center;\n    display: flex\n}\n\n.div-block-523 {\n    padding: 24px\n}\n\n.div-block-524 {\n    background-color: var(--pabloo-green);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61f1745d5c7aaa6516e4bce8_Group%20216.png);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.heading-206 {\n    color: var(--white)\n}\n\n.div-block-525 {\n    background-color: var(--pabloo-green);\n    border: 1px #000;\n    border-radius: 120px;\n    width: auto;\n    margin-bottom: 24px;\n    padding: 4px 12px\n}\n\n.text-block-233 {\n    color: var(--white);\n    font-size: 16px;\n    font-weight: 500\n}\n\n.text-block-234 {\n    color: var(--white);\n    margin-top: 24px;\n    font-size: 20px\n}\n\n.section-38 {\n    background-color: #fff\n}\n\n.div-block-527 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 32px;\n    display: grid\n}\n\n.div-block-528 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-235 {\n    font-weight: 500\n}\n\n.div-block-529 {\n    display: none\n}\n\n.list-16 {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    margin-top: 8px;\n    padding-left: 0;\n    display: block\n}\n\n.heading-208 {\n    color: var(--black);\n    text-align: center;\n    margin-top: 8px;\n    margin-bottom: 8px\n}\n\n.paragraph-118 {\n    color: var(--light-slate-grey);\n    text-align: center;\n    margin-bottom: 24px;\n    font-size: 14px;\n    line-height: 1.1em\n}\n\n.collection-list-wrapper-6 {\n    margin-top: 56px\n}\n\n.mt-md.center {\n    text-align: center\n}\n\n.mt-md.center.text-sm {\n    color: var(--black);\n    text-align: left;\n    font-size: 18px;\n    line-height: 1.4em\n}\n\n.column-76 {\n    padding: 4%\n}\n\n.sign-up-pointer {\n    background-color: transparent;\n    border: 1px #000;\n    border-radius: 120px;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 0;\n    margin-bottom: 6px;\n    margin-right: 4px;\n    padding: 4px;\n    display: flex\n}\n\n.sign-up-pointer.last {\n    border: 1px #000;\n    border-radius: 120px;\n    margin-right: 0\n}\n\n.sign-up-pointer-text {\n    color: var(--black-2);\n    font-size: 18px;\n    font-weight: 400\n}\n\n.div-block-531 {\n    padding-top: 4%;\n    padding-bottom: 4%\n}\n\n.div-block-531.flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-left: 2.4%;\n    padding-right: 2.4%;\n    display: flex\n}\n\n.div-block-532 {\n    z-index: 1;\n    background-color: var(--white);\n    border-radius: 12px;\n    margin-bottom: 40px;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    position: relative;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, .1)\n}\n\n.div-block-533 {\n    border-radius: 0;\n    padding: 12px 24px\n}\n\n.image-177 {\n    height: 24px;\n    margin-right: 6px\n}\n\n.div-block-535 {\n    display: flex\n}\n\n.div-block-536 {\n    width: 50%;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-537 {\n    width: 50%;\n    padding-left: 8%\n}\n\n.image-178 {\n    height: 64px\n}\n\n.heading-209 {\n    color: var(--white);\n    font-weight: 500\n}\n\n.div-block-538 {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.text-block-241 {\n    color: #fff;\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.button-35 {\n    background-color: var(--pabloo-green);\n    border-radius: 0;\n    padding: 12px 32px\n}\n\n.div-block-539 {\n    padding-top: 16px;\n    padding-bottom: 16px\n}\n\n.paragraph-119 {\n    color: var(--white);\n    font-weight: 300\n}\n\n.section-39 {\n    background-color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64ad366f8751c560ba096ef9_second-fold-bg.svg);\n    background-position: 0 0;\n    background-repeat: repeat-x;\n    background-size: 75%\n}\n\n.div-block-540 {\n    margin-top: 0;\n    padding-top: 40px;\n    padding-bottom: 120px\n}\n\n.heading-210 {\n    text-align: center;\n    text-transform: none;\n    font-family: Satoshi, sans-serif;\n    font-size: 64px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.div-block-541 {\n    background-image: linear-gradient(152deg, #cd3a8f 47%, var(--slate-blue));\n    -webkit-text-fill-color: transparent;\n    -webkit-background-clip: text;\n    background-clip: text;\n    justify-content: center;\n    display: flex\n}\n\n.div-block-542 {\n    margin-top: 40px\n}\n\n.paragraph-120 {\n    text-align: center;\n    font-size: 24px;\n    line-height: 2em\n}\n\n.section-40 {\n    padding-top: 120px;\n    padding-bottom: 120px;\n    position: relative\n}\n\n.heading-211 {\n    color: #fff;\n    text-align: center;\n    font-size: 48px;\n    font-weight: 500;\n    line-height: 1.1em\n}\n\n.div-block-543 {\n    grid-column-gap: 40px;\n    grid-row-gap: 56px;\n    flex-wrap: nowrap;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    grid-auto-flow: row;\n    align-content: space-between;\n    justify-content: center;\n    align-items: stretch;\n    justify-items: stretch;\n    margin-top: 120px;\n    display: grid\n}\n\n.div-block-544 {\n    background-color: var(--pabloo-green);\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.div-block-544.yellow {\n    background-color: var(--goldenrod)\n}\n\n.div-block-544.orange {\n    background-color: #ff8a50\n}\n\n.div-block-544.green {\n    background-color: #1dd1a1\n}\n\n.div-block-544.gray {\n    background-color: #0984e3\n}\n\n.div-block-544.red {\n    background-color: #f43f5e\n}\n\n.div-block-544.amber {\n    background-color: #f59e0b\n}\n\n.image-180 {\n    margin-top: -56px;\n    margin-bottom: -.5px\n}\n\n.div-block-545 {\n    background-color: var(--white);\n    padding: 16px\n}\n\n.text-block-242 {\n    text-align: center;\n    font-weight: 700\n}\n\n.text-block-243 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.section-41 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64ad5cb8d78f2eee58e3326e_agenda-section-bg.svg);\n    background-position: 0 0;\n    background-repeat: repeat-x;\n    background-size: 75%;\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.heading-212 {\n    color: #fff;\n    text-align: center;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 1.1em\n}\n\n.text-block-244 {\n    color: #fff;\n    text-align: center;\n    margin-top: 16px;\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.section-42 {\n    background-color: #2c2e35;\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-546 {\n    display: flex\n}\n\n.div-block-547 {\n    width: 50%;\n    padding-top: 32px;\n    padding-bottom: 32px\n}\n\n.div-block-548 {\n    justify-content: center;\n    align-items: center;\n    width: 40%;\n    padding-left: 40px;\n    padding-right: 40px;\n    display: flex\n}\n\n.heading-213 {\n    color: #fff;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.paragraph-121 {\n    color: #fff\n}\n\n.div-block-549 {\n    padding-top: 16px;\n    padding-bottom: 16px\n}\n\n.div-block-550 {\n    border-bottom: 6px solid var(--goldenrod);\n    margin-bottom: 16px;\n    display: inline-block\n}\n\n.div-block-551 {\n    border-bottom: 6px solid var(--goldenrod);\n    margin-top: 16px;\n    display: inline-block\n}\n\n.text-block-245 {\n    color: #fff;\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.div-block-552 {\n    background-color: rgba(247, 247, 245, .11);\n    background-image: linear-gradient(214deg, #464646, #2c2e35 59%);\n    border: 2px solid #414141;\n    border-radius: 16px;\n    flex-flow: column wrap;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n    display: flex;\n    box-shadow: 16px 0 24px rgba(0, 0, 0, .12)\n}\n\n.section-43 {\n    background-color: var(--black-2);\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.heading-214 {\n    text-align: center;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.section-44 {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-554 {\n    padding-left: 4%;\n    padding-right: 4%;\n    display: flex\n}\n\n.div-block-555 {\n    width: 50%\n}\n\n.div-block-556 {\n    align-self: center;\n    width: 50%;\n    padding-left: 32px\n}\n\n.div-block-557 {\n    margin-top: 16px\n}\n\n.div-block-558 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-wrap: wrap;\n    align-items: center;\n    display: flex\n}\n\n.text-block-248 {\n    color: #fff\n}\n\n.div-block-559 {\n    background-color: var(--pabloo-green);\n    padding: 4px 8px\n}\n\n.section-45 {\n    background-color: var(--black-2);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64ad366f8751c560ba096ef9_second-fold-bg.svg);\n    background-repeat: repeat-x;\n    background-size: 75%;\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.heading-215 {\n    text-align: center;\n    font-size: 48px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.paragraph-122 {\n    text-align: center\n}\n\n.div-block-560 {\n    margin-top: 64px\n}\n\n.text-block-249 {\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.div-block-561 {\n    grid-column-gap: 56px;\n    grid-row-gap: 32px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 16px;\n    display: flex\n}\n\n.image-182 {\n    height: 32px\n}\n\n.image-183 {\n    height: 30px;\n    margin-bottom: -9px\n}\n\n.image-184 {\n    height: 42px;\n    margin-bottom: -16px\n}\n\n.section-46 {\n    background-color: var(--slate-blue);\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.heading-216 {\n    color: var(--white);\n    font-size: 52px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.button-36 {\n    background-color: var(--pabloo-green);\n    border-radius: 12px;\n    padding: 16px 24px\n}\n\n.columns-8 {\n    align-items: center;\n    display: flex\n}\n\n.div-block-563 {\n    margin-top: 24px\n}\n\n.div-block-564 {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-565 {\n    grid-column-gap: 32px;\n    grid-row-gap: 8px;\n    flex-flow: column wrap;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.image-185 {\n    height: 240px\n}\n\n.div-block-566 {\n    margin-top: 0;\n    margin-bottom: 0\n}\n\n.div-block-567 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--goldenrod);\n    background-image: linear-gradient(345deg, #5a4df6 38%, var(--pabloo-green));\n    border-radius: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 5%;\n    padding: 12px;\n    display: grid;\n    position: relative\n}\n\n.text-block-250 {\n    color: var(--white);\n    margin-left: 4px;\n    font-size: 20px;\n    font-weight: 400\n}\n\n.button-37 {\n    background-color: var(--black);\n    color: var(--white);\n    border-radius: 12px;\n    padding: 12px 32px;\n    font-weight: 500;\n    transition: all .3s cubic-bezier(.42, 0, .515, 1.013)\n}\n\n.button-37:hover {\n    background-color: var(--pabloo-green)\n}\n\n.optimize-hero {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62f2968d9aa17f2f1003b12c_ezgif.com-gif-maker%20\\(1\\).webp);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover\n}\n\n.text-block-251 {\n    color: #fff\n}\n\n.text-block-251.text-align-center {\n    text-align: left\n}\n\n.heading-218 {\n    color: var(--white);\n    text-align: left;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 44px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.div-block-570 {\n    margin-top: 56px\n}\n\n.div-block-571 {\n    grid-column-gap: 0px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: .25fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 10px;\n    display: grid\n}\n\n.div-block-572 {\n    background-color: var(--black);\n    border-radius: 12px;\n    display: flex\n}\n\n.div-block-573 {\n    background-color: var(--goldenrod);\n    border-radius: 100%;\n    align-self: center;\n    width: 16px;\n    height: 16px;\n    margin-left: -8px\n}\n\n.div-block-573.gray {\n    background-color: var(--light-slate-grey)\n}\n\n.div-block-573.blue {\n    background-color: #50b0ff\n}\n\n.div-block-574 {\n    background-color: transparent;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    justify-content: center;\n    align-items: center;\n    padding: 24px 8px;\n    display: flex\n}\n\n.div-block-575 {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    flex-wrap: wrap;\n    align-items: center;\n    width: 100%;\n    padding-left: 24px;\n    padding-right: 24px;\n    display: flex\n}\n\n.text-block-252 {\n    color: var(--white)\n}\n\n.image-186 {\n    height: 50px\n}\n\n.div-block-576 {\n    flex: 1\n}\n\n.text-block-253,\n.text-block-254,\n.text-block-255,\n.text-block-256,\n.text-block-257,\n.text-block-258,\n.text-block-260 {\n    color: var(--white)\n}\n\n.div-block-577 {\n    height: 120px\n}\n\n.div-block-578 {\n    background-color: var(--white)\n}\n\n.div-block-579 {\n    height: 120px\n}\n\n.div-block-580 {\n    background-color: #7566ff;\n    padding-top: 40px;\n    padding-bottom: 120px\n}\n\n.text-block-261 {\n    text-align: center;\n    font-size: 24px;\n    line-height: 1.6em\n}\n\n.div-block-581 {\n    margin-top: 12px\n}\n\n.paragraph-124 {\n    color: var(--white);\n    text-align: center;\n    margin-top: 16px;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.6em\n}\n\n.bold-text-23 {\n    color: var(--white)\n}\n\n.div-block-583 {\n    background-color: var(--white-smoke);\n    height: 64px\n}\n\n.div-block-584 {\n    background-color: var(--white-smoke);\n    padding-bottom: 120px\n}\n\n.div-block-585 {\n    justify-content: center;\n    margin-top: 32px;\n    display: flex\n}\n\n.button-39 {\n    background-color: var(--pabloo-green);\n    border-radius: 12px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 16px 40px;\n    font-size: 20px;\n    font-weight: 400\n}\n\n.text-span-209 {\n    color: var(--pabloo-green)\n}\n\n.heading-219 {\n    font-size: 48px;\n    line-height: 1.2em\n}\n\n.div-block-586 {\n    margin-bottom: 40px\n}\n\n.text-block-263 {\n    margin-top: 16px;\n    font-size: 18px;\n    line-height: 1.4em\n}\n\n.div-block-587 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-587.hide {\n    display: none\n}\n\n.text-block-264 {\n    color: var(--pabloo-green);\n    text-align: left;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.section-48 {\n    background-color: var(--white);\n    padding-top: 100px;\n    padding-bottom: 40px\n}\n\n.text-block-265 {\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.pabloo-offering-pointer {\n    background-color: rgba(245, 205, 225, .28);\n    border-radius: 4px;\n    padding: 8px\n}\n\n.vendr-offering-pointer {\n    background-color: #f3f7ff;\n    border-radius: 4px;\n    padding: 8px\n}\n\n.section-49 {\n    background-color: var(--black);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/61e91732e354a8764f6fdb08_Group%2023%20\\(2\\).svg);\n    background-position: 0 0;\n    background-repeat: no-repeat;\n    background-size: cover;\n    margin-top: 76px;\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.heading-220 {\n    color: var(--white);\n    line-height: 1.2em\n}\n\n.text-block-266 {\n    color: var(--white);\n    margin-top: 16px\n}\n\n.div-block-589 {\n    margin-bottom: 40px\n}\n\n.div-block-590 {\n    grid-column-gap: 24px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-267 {\n    color: #fff;\n    text-transform: none;\n    font-weight: 400\n}\n\n.text-block-268 {\n    color: #fff;\n    font-weight: 400;\n    line-height: 1.2em\n}\n\n.div-block-591,\n.div-block-592,\n.div-block-593 {\n    border-bottom: 1px solid rgba(255, 255, 255, .5);\n    padding: 4px\n}\n\n.div-block-594 {\n    align-items: center;\n    padding: 4px;\n    display: flex\n}\n\n.text-span-210 {\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.text-block-269,\n.text-block-270 {\n    color: var(--white);\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.heading-221 {\n    margin-top: 0;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 30px\n}\n\n.heading-222 {\n    letter-spacing: -.5px;\n    font-size: 3rem;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.section-50 {\n    background-color: var(--white);\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.div-block-595 {\n    grid-column-gap: 48px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .75fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    display: grid\n}\n\n.section-51 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64d06f7e9279d16dce484b36_64a7e7a6656a76b25ff7b627_62f295f65cac0a38a49e99e4_ezgif.com-gif-maker.webp.png);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-top: 48px;\n    padding-bottom: 120px\n}\n\n.div-block-596 {\n    padding-right: 40px\n}\n\n.heading-223 {\n    text-align: center\n}\n\n.text-block-271 {\n    text-align: center;\n    margin-top: 16px\n}\n\n.div-block-597 {\n    margin-bottom: 40px\n}\n\n.div-block-598 {\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    display: flex\n}\n\n.empty-state-10,\n.empty-state-11 {\n    background-color: var(--white)\n}\n\n.div-block-599,\n.youtube-2 {\n    margin-left: auto;\n    margin-right: auto\n}\n\n.section-52 {\n    background-color: var(--white);\n    padding-top: 20px;\n    padding-bottom: 120px\n}\n\n.div-block-600 {\n    margin-top: 24px\n}\n\n.div-block-601 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 32px;\n    display: grid\n}\n\n.div-block-602 {\n    grid-column-gap: 0px;\n    grid-row-gap: 16px;\n    background-color: transparent;\n    grid-template-rows: auto;\n    grid-template-columns: 93% 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 12px;\n    display: grid\n}\n\n.div-block-603 {\n    background-color: var(--pabloo-green);\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    height: 16px\n}\n\n.div-block-604 {\n    background-color: var(--white-smoke);\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n    height: 16px\n}\n\n.div-block-605 {\n    grid-column-gap: 0px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 87% 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 12px;\n    display: grid\n}\n\n.div-block-605.xx {\n    grid-template-columns: 83% 1fr\n}\n\n.div-block-606 {\n    background-color: rgba(0, 0, 0, .24);\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n    height: 16px\n}\n\n.div-block-607 {\n    margin-top: 24px\n}\n\n.section-53 {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.div-block-608 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 40px;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    display: grid\n}\n\n.text-block-272 {\n    font-size: 16px;\n    line-height: 1em\n}\n\n.div-block-609 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 40px;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    display: grid\n}\n\n.text-block-273 {\n    font-size: 16px;\n    line-height: 1em\n}\n\n.div-block-610 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 40px;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    display: grid\n}\n\n.text-block-274 {\n    font-size: 16px;\n    line-height: 1em\n}\n\n.div-block-611 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 40px;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    display: grid\n}\n\n.text-block-275 {\n    font-size: 16px;\n    line-height: 1em\n}\n\n.div-block-612 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 40px;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    display: grid\n}\n\n.text-block-276 {\n    font-size: 16px;\n    line-height: 1em\n}\n\n.div-block-613 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 40px;\n    grid-auto-columns: 1fr;\n    align-items: end;\n    display: grid\n}\n\n.text-block-277 {\n    font-size: 16px;\n    line-height: 1em\n}\n\n.section-54 {\n    background-color: var(--slate-blue);\n    padding-top: 100px;\n    padding-bottom: 120px\n}\n\n.heading-224,\n.text-block-278 {\n    color: var(--white);\n    text-align: center\n}\n\n.div-block-614 {\n    margin-top: 24px\n}\n\n.div-block-615 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 32px;\n    display: grid\n}\n\n.bold-text-24 {\n    color: var(--white);\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.text-block-279 {\n    color: var(--white);\n    font-size: 14px;\n    line-height: 1.4em\n}\n\n.div-block-616 {\n    background-color: #6363ff;\n    border-radius: 12px;\n    padding: 24px 16px\n}\n\n.heading-226 {\n    margin-top: 8px;\n    margin-bottom: 20px\n}\n\n.text-span-213 {\n    font-size: 48px\n}\n\n.text-block-280 {\n    color: rgba(255, 255, 255, .74);\n    font-size: 14px;\n    line-height: 1.2em\n}\n\n.section-55 {\n    background-color: var(--black);\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.heading-227 {\n    color: var(--white);\n    text-align: center;\n    line-height: 1.2em\n}\n\n.text-span-214 {\n    color: var(--pabloo-green)\n}\n\n.text-block-281 {\n    color: var(--white);\n    text-align: center;\n    margin-top: 16px;\n    font-size: 20px\n}\n\n.div-block-617 {\n    margin-top: 32px;\n    padding-top: 24px;\n    padding-bottom: 24px\n}\n\n.div-block-618 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-619 {\n    border: 2px none var(--light-pink);\n    background-color: #1c1c1c;\n    border-radius: 12px;\n    padding: 20px\n}\n\n.heading-228 {\n    color: var(--white);\n    margin-top: 0;\n    font-size: 23px;\n    line-height: 1.2em\n}\n\n.paragraph-125,\n.paragraph-126,\n.paragraph-127 {\n    color: rgba(255, 255, 255, .8);\n    font-size: 18px;\n    font-weight: 300;\n    line-height: 1.4em\n}\n\n.paragraph-128 {\n    color: var(--white);\n    text-align: center;\n    font-size: 24px;\n    font-weight: 500\n}\n\n.div-block-620 {\n    margin-top: 24px\n}\n\n.text-span-215 {\n    color: var(--pabloo-green);\n    font-weight: 700\n}\n\n.div-block-621 {\n    background-color: var(--pabloo-green);\n    border-top: 1px rgba(255, 255, 255, .4);\n    border-radius: 12px;\n    margin-top: 0;\n    padding: 32px 24px 32px 32px\n}\n\n.heading-229 {\n    color: var(--white);\n    text-align: center;\n    font-size: 56px;\n    line-height: 1.2em\n}\n\n.div-block-622 {\n    justify-content: center;\n    margin-top: 40px;\n    display: flex\n}\n\n.button-40 {\n    background-color: var(--black);\n    border-radius: 8px;\n    padding: 16px 32px;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.section-56 {\n    background-color: var(--pabloo-green);\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.link-41 {\n    color: var(--pabloo-green)\n}\n\n.link-42 {\n    color: var(--pabloo-green);\n    font-weight: 500\n}\n\n.div-block-623,\n.div-block-624,\n.div-block-625 {\n    border-radius: 12px;\n    padding: 0;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, .1)\n}\n\n.heading-230,\n.heading-231,\n.heading-232 {\n    color: var(--white);\n    text-transform: capitalize;\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.div-block-626 {\n    background-color: var(--pabloo-green);\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    padding: 16px 24px\n}\n\n.div-block-627 {\n    padding: 16px 24px 24px\n}\n\n.div-block-628 {\n    background-color: var(--pabloo-green);\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    padding: 16px 24px\n}\n\n.div-block-629 {\n    padding: 16px 24px 24px\n}\n\n.div-block-630 {\n    background-color: var(--pabloo-green);\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    padding: 16px 24px\n}\n\n.div-block-631 {\n    padding: 16px 24px 24px\n}\n\n.text-span-216,\n.text-span-217 {\n    color: var(--pabloo-green)\n}\n\n.div-block-632 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-632.hide {\n    display: none\n}\n\n.div-block-633 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 16px;\n    display: grid\n}\n\n.div-block-634,\n.div-block-635 {\n    border: 2px solid #000;\n    border-radius: 16px;\n    padding: 16px\n}\n\n.heading-233 {\n    margin-top: 12px;\n    margin-left: 24px\n}\n\n.heading-234 {\n    color: var(--pabloo-green);\n    margin-top: 12px;\n    margin-left: 24px\n}\n\n.paragraph-129 {\n    margin-bottom: 24px\n}\n\n.div-block-636 {\n    margin-top: 16px;\n    margin-bottom: 16px\n}\n\n.button-41 {\n    background-color: var(--pabloo-green);\n    text-align: center;\n    border-radius: 8px;\n    width: 100%;\n    padding: 12px 16px;\n    font-weight: 500\n}\n\n.button-42 {\n    background-color: var(--black);\n    text-align: center;\n    border-radius: 8px;\n    width: 100%;\n    padding: 12px 16px;\n    font-weight: 500\n}\n\n.div-block-637 {\n    grid-column-gap: 6px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 20px 1fr;\n    grid-auto-columns: 1fr;\n    margin-bottom: 8px;\n    display: grid\n}\n\n.text-block-282 {\n    font-size: 16px;\n    line-height: 1.2em\n}\n\n.image-187 {\n    width: 100%;\n    height: auto\n}\n\n.heading-235 {\n    font-size: 36px;\n    line-height: 1.2em\n}\n\n.div-block-638 {\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-top: 32px;\n    display: flex\n}\n\n.image-188 {\n    height: 200px\n}\n\n.heading-236 {\n    text-align: center;\n    width: 100%\n}\n\n.div-block-639 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    border: 1px solid rgba(0, 0, 0, .1);\n    border-radius: 12px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.75fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 12px;\n    display: grid\n}\n\n.div-block-639.hide {\n    display: none\n}\n\n.image-189 {\n    object-fit: cover;\n    object-position: 50% 50%;\n    border-top-right-radius: 11px;\n    border-bottom-right-radius: 11px;\n    height: 100%\n}\n\n.div-block-640 {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 12px;\n    display: flex\n}\n\n.div-block-641 {\n    margin-top: 16px\n}\n\n.button-43 {\n    background-color: var(--pabloo-green);\n    border-radius: 8px;\n    font-size: 16px\n}\n\n.heading-237 {\n    font-size: 20px;\n    line-height: 1.2em\n}\n\n.text-span-218 {\n    color: var(--pabloo-green)\n}\n\n.heading-238 {\n    color: #121212;\n    text-align: center;\n    margin-top: 0\n}\n\n.heading-238.white {\n    color: var(--white)\n}\n\n.div-block-642 {\n    border: 1px solid rgba(0, 0, 0, .1);\n    border-radius: 12px;\n    margin-top: 12px;\n    padding: 12px;\n    display: none\n}\n\n.div-block-642.glass {\n    background-color: rgba(255, 255, 255, .08);\n    border-width: 1px;\n    border-color: rgba(255, 255, 255, .13);\n    display: none\n}\n\n.button-44 {\n    background-color: var(--pabloo-green);\n    text-align: center;\n    border-radius: 8px;\n    width: 100%\n}\n\n.div-block-643 {\n    grid-column-gap: 4px;\n    grid-row-gap: 4px;\n    flex-wrap: wrap;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    padding-left: 16px;\n    padding-right: 16px;\n    display: grid\n}\n\n.image-190 {\n    height: 18px\n}\n\n.image-191,\n.image-192,\n.image-193,\n.image-194 {\n    height: 20px\n}\n\n.div-block-644 {\n    border: 1px solid rgba(0, 0, 0, .1);\n    border-radius: 12px;\n    margin-top: 48px;\n    padding: 12px;\n    position: relative\n}\n\n.div-block-645 {\n    width: 25%;\n    position: absolute;\n    top: -32px;\n    left: 37.5%\n}\n\n.image-195 {\n    width: 100%;\n    height: auto\n}\n\n.div-block-646 {\n    margin-top: 40px;\n    font-size: 18px\n}\n\n.text-block-283 {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.div-block-647 {\n    margin-top: 16px\n}\n\n.paragraph-130 {\n    color: var(--white);\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.4em\n}\n\n.div-block-648 {\n    padding-right: 24px\n}\n\n.div-block-649 {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 0;\n    display: none\n}\n\n.lottie-animation {\n    width: auto;\n    height: 48px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.html-embed-26,\n.html-embed-27 {\n    opacity: .64\n}\n\n.image-196 {\n    height: 48px\n}\n\n.div-block-650 {\n    border: 4px solid #77f;\n    border-radius: 22px;\n    margin-left: 0;\n    display: flex\n}\n\n.webinar-cta {\n    background-color: var(--white);\n    color: var(--black);\n    border: 3px solid #9a9afd;\n    border-radius: 12px;\n    padding: 12px 24px;\n    font-size: 18px;\n    font-weight: 700\n}\n\n.webinar-cta.pink-border {\n    border-color: #f358a5\n}\n\n.webinar-cta.pink-border.pink-text {\n    color: var(--pabloo-green)\n}\n\n.div-block-651 {\n    border: 4px solid #77f;\n    border-radius: 22px\n}\n\n.button-45 {\n    background-color: var(--pabloo-green);\n    border: 3px solid #e571ab;\n    border-radius: 12px;\n    padding: 12px 24px;\n    font-weight: 700\n}\n\n.container-1285 {\n    background-color: #6060f7;\n    border-radius: 20px;\n    max-width: 1040px;\n    padding-top: 64px;\n    padding-bottom: 64px\n}\n\n.container-1286 {\n    max-width: 1040px;\n    padding-left: 50px;\n    padding-right: 50px\n}\n\n.text-span-219 {\n    color: var(--slate-blue)\n}\n\n.button-46 {\n    background-color: var(--pabloo-green);\n    border-radius: 12px;\n    padding: 12px 32px;\n    font-weight: 500\n}\n\n.div-block-652 {\n    grid-column-gap: 12px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 28px 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid\n}\n\n.div-block-652.mt-sm {\n    margin-top: 12px\n}\n\n.text-span-220 {\n    color: var(--pabloo-green)\n}\n\n.div-block-653 {\n    justify-content: flex-end;\n    align-items: center;\n    margin-top: 16px;\n    display: flex\n}\n\n.div-block-656 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64d491cbb29dae8ffa766f7b_Background%20\\(1\\).jpg);\n    background-position: 100% 100%;\n    background-size: cover;\n    border-radius: 10px;\n    align-self: center;\n    width: 600px;\n    display: flex\n}\n\n.image-197 {\n    padding: 20px\n}\n\n.div-block-657 {\n    width: 30%\n}\n\n.div-block-658 {\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n    width: 70%;\n    display: flex\n}\n\n.heading-239 {\n    color: var(--white);\n    font-size: 26px\n}\n\n.div-block-659 {\n    position: absolute;\n    top: 64px;\n    right: -32px\n}\n\n.image-198 {\n    height: 120px\n}\n\n.div-block-660 {\n    margin-top: 32px;\n    position: static;\n    top: auto;\n    bottom: -136px;\n    left: -80px;\n    right: auto\n}\n\n.image-199 {\n    height: 200px\n}\n\n.div-block-661 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: start;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto;\n    display: grid\n}\n\n.image-200 {\n    height: 24px\n}\n\n.text-block-285 {\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1em\n}\n\n.image-201 {\n    height: 24px\n}\n\n.div-block-662 {\n    justify-content: center;\n    margin-top: 24px;\n    display: flex\n}\n\n.text-span-221 {\n    color: var(--pabloo-green)\n}\n\n.lottie-animation-2 {\n    height: 48px;\n    display: block\n}\n\n.div-block-663 {\n    display: none\n}\n\n.div-block-664 {\n    justify-content: center;\n    margin-top: 32px;\n    display: flex\n}\n\n.image-202 {\n    width: auto;\n    height: 200px\n}\n\n.banner-cta-blog {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/64d491cbb29dae8ffa766f7b_Background%20\\(1\\).jpg);\n    background-position: 50% 100%;\n    background-size: 500px;\n    border-radius: 10px;\n    justify-content: space-between;\n    align-self: center;\n    width: 500px;\n    padding: 20px;\n    display: flex\n}\n\n.image-203 {\n    width: 120px\n}\n\n.heading-240 {\n    color: #fff\n}\n\n.div-block-665 {\n    flex-direction: column;\n    align-items: center;\n    width: 70%;\n    display: flex\n}\n\n.link-button-copy2 {\n    background-color: var(--white);\n    border: 2px #505144;\n    border-radius: 10px;\n    flex-direction: row;\n    justify-content: flex-end;\n    align-items: center;\n    width: 210px;\n    margin: 10px 0 0;\n    padding: 2px;\n    display: flex;\n    position: relative;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0\n}\n\n.text-block-4 {\n    justify-content: flex-start;\n    align-self: center;\n    align-items: center;\n    margin: auto 50px auto 0;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 100%;\n    text-decoration: none;\n    display: flex;\n    position: absolute\n}\n\n.div-block-7 {\n    background-color: var(--black);\n    border: 1px red;\n    border-radius: 10px;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n    align-items: center;\n    width: 40px;\n    min-width: auto;\n    margin-left: 0;\n    padding: 5px 10px;\n    display: flex;\n    position: static\n}\n\n.text-block-286 {\n    color: var(--white);\n    padding-right: 46px;\n    font-weight: 500\n}\n\n.image-204 {\n    width: 20px\n}\n\n.section-57 {\n    background-color: #d53987;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.section-58 {\n    padding-top: 120px\n}\n\n.text-block-288 {\n    color: #fff;\n    font-weight: 500\n}\n\n.section-59 {\n    padding-top: 80px;\n    padding-bottom: 120px\n}\n\n.div-block-669 {\n    display: flex;\n    position: relative;\n    overflow: visible\n}\n\n.div-block-670 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-671 {\n    margin-left: 0%;\n    margin-right: 0%;\n    padding: 12px\n}\n\n.heading-241 {\n    font-size: 3rem;\n    font-weight: 500;\n    line-height: 1.3em\n}\n\n.div-block-672 {\n    background-color: rgba(255, 255, 255, .24);\n    border: 6px solid rgba(255, 255, 255, .2);\n    border-radius: 12px;\n    padding: 12px\n}\n\n.div-block-673 {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .75fr;\n    grid-auto-columns: 1fr;\n    justify-content: flex-start;\n    align-items: center;\n    display: grid\n}\n\n.heading-242 {\n    color: #fff;\n    margin-bottom: 24px;\n    font-size: 2.4rem;\n    line-height: 1.2em\n}\n\n.div-block-674 {\n    z-index: 2;\n    width: 72%;\n    position: absolute;\n    top: auto;\n    bottom: -20%;\n    left: auto;\n    right: -35%\n}\n\n.image-210 {\n    filter: grayscale(29%)sepia(43%);\n    border-radius: 8px;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, .12)\n}\n\n.case-study-hero-sub-heading {\n    color: var(--black);\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.8em\n}\n\n.rich-text-block-28 {\n    font-size: 20px;\n    line-height: 1.8em\n}\n\n.div-block-677 {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.case-study-hero-heading-2 {\n    font-size: 3rem;\n    line-height: 1.2em\n}\n\n.div-block-679 {\n    margin-top: 8px\n}\n\n.text-block-290 {\n    color: #fff;\n    text-transform: uppercase;\n    font-size: .8rem;\n    font-weight: 300;\n    line-height: 1.3em\n}\n\n.section-60 {\n    background-color: #000;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.paragraph-133 {\n    color: var(--black);\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.case-study-hero-heading-container {\n    margin-top: 24px\n}\n\n.case-study-hero-container {\n    width: 60%\n}\n\n.case-study-hero-logo {\n    height: 48px\n}\n\n.div-block-681 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 60%;\n    display: grid\n}\n\n.div-block-682 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: .25fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-bottom: 40px;\n    display: grid\n}\n\n.paragraph-134 {\n    color: #fff;\n    font-size: 20px;\n    line-height: 1.8em\n}\n\n.case-study-hero-metrics-container {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: repeat(auto-fit, minmax(0, auto)) minmax(0, auto) minmax(0, auto);\n    grid-auto-columns: 1fr;\n    grid-auto-flow: row;\n    justify-items: stretch;\n    margin-top: 24px;\n    display: grid\n}\n\n.text-block-293 {\n    text-transform: uppercase;\n    font-size: .8rem;\n    line-height: 1.3em\n}\n\n.case-study-hero-section {\n    background-image: linear-gradient(147deg, #fff, #fff 57%, #f5cde1);\n    justify-content: flex-end;\n    padding-top: 160px;\n    padding-bottom: 80px;\n    font-size: 18px;\n    line-height: 28px;\n    display: flex;\n    overflow: hidden\n}\n\n.div-block-683 {\n    margin-top: 24px\n}\n\n.div-block-686 {\n    background-color: var(--white-smoke);\n    outline-offset: 0px;\n    border: 1px solid rgba(31, 31, 31, .06);\n    border-radius: 8px;\n    outline: 3px #000;\n    margin-bottom: 48px;\n    padding: 32px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, .12)\n}\n\n.image-212 {\n    height: 42px\n}\n\n.navigation-link-10 {\n    color: #000;\n    letter-spacing: -.01em;\n    white-space: nowrap;\n    cursor: pointer;\n    background-color: transparent;\n    border-radius: 50px;\n    padding: 12px 24px;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    text-decoration: none;\n    transition: all .35s\n}\n\n.navigation-link-10:hover {\n    color: #d53987;\n    background-color: #fff\n}\n\n.navigation-link-10.w--current {\n    color: #d53987\n}\n\n.text-block-294 {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px\n}\n\n.text-span-222,\n.text-span-224 {\n    color: var(--pabloo-green)\n}\n\n.section-61 {\n    background-color: var(--white-smoke);\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.div-block-687 {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto auto;\n    grid-template-columns: .5fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-295 {\n    margin-top: 16px\n}\n\n.image-213 {\n    border: 2px solid #000;\n    border-radius: 4px\n}\n\n.section-62 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.heading-244 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-family: Satoshi, sans-serif;\n    font-size: 40px;\n    line-height: 1.4em\n}\n\n.div-block-689 {\n    grid-column-gap: 40px;\n    grid-row-gap: 56px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 64px;\n    display: grid\n}\n\n.div-block-690 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-296 {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 700\n}\n\n.div-block-691 {\n    justify-content: center;\n    display: flex\n}\n\n.section-63 {\n    background-color: var(--black-2);\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.heading-246 {\n    color: var(--white);\n    text-align: center;\n    font-size: 40px;\n    line-height: 1.4em\n}\n\n.div-block-692 {\n    margin-top: 64px\n}\n\n.div-block-693 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    margin-bottom: 24px;\n    display: grid\n}\n\n.text-block-297 {\n    color: var(--white);\n    font-weight: 700;\n    line-height: 20px\n}\n\n.paragraph-136,\n.paragraph-137,\n.paragraph-138,\n.paragraph-139 {\n    color: var(--white)\n}\n\n.text-span-225 {\n    color: var(--black)\n}\n\n.image-214 {\n    height: 48px\n}\n\n.div-block-694 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: transparent;\n    border-radius: 40px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: start;\n    margin-top: 32px;\n    padding: 4px 20px 4px 0;\n    display: grid\n}\n\n.text-block-298 {\n    color: var(--white);\n    text-align: center;\n    font-size: 20px;\n    font-weight: 400\n}\n\n.div-block-695 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: #1f1f1f;\n    border: 1px solid #2e2e2e;\n    border-radius: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid\n}\n\n.image-215,\n.image-216 {\n    height: 48px\n}\n\n.div-block-696 {\n    border-left: 1px solid #2e2e2e\n}\n\n.div-block-697 {\n    margin-top: 24px\n}\n\n.div-block-698 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr auto;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-700 {\n    border-bottom: 1px solid #5a5a5a;\n    width: 56px;\n    height: 1px;\n    margin-top: 4px;\n    display: none\n}\n\n.div-block-701 {\n    border-bottom: 1px solid rgba(255, 255, 255, .24);\n    justify-content: center;\n    width: 72%;\n    margin-top: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 16px;\n    display: flex\n}\n\n.image-217,\n.image-218 {\n    height: 56px\n}\n\n.updated-page-wrapper {\n    max-width: 100vw;\n    color: var(--dark-violet);\n    margin-top: 0;\n    font-family: Inter, sans-serif;\n    position: relative\n}\n\n.updated-page-wrapper.optimize {\n    color: var(--white)\n}\n\n.reference-hero-section {\n    background-color: var(--white-smoke);\n    border-radius: 10px;\n    width: 100%\n}\n\n.reference-hero-wrapper {\n    text-align: center;\n    flex-direction: column;\n    width: 100%;\n    padding-top: 120px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.reference-center-wrapper {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 620px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.reference-top-block {\n    grid-column-gap: 16px;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.reference-block {\n    grid-row-gap: 60px;\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.colors-grid {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.reference-wrapper {\n    grid-row-gap: 100px;\n    flex-direction: column;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.reference-bottom-block {\n    width: 100%\n}\n\n.buttons-grid {\n    grid-column-gap: 16px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    justify-items: start;\n    width: 100%;\n    display: grid\n}\n\n.color-box {\n    background-color: #145aff;\n    border-radius: 12px;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: flex-start;\n    width: 100%;\n    height: 150px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    font-weight: 500;\n    display: flex;\n    position: relative\n}\n\n.color-box._5 {\n    background-color: var(--soft-pink);\n    color: #fff;\n    margin-top: 0\n}\n\n.color-box._4 {\n    background-color: var(--dark-violet);\n    color: #031447;\n    margin-top: 0\n}\n\n.color-box._1 {\n    background-color: var(--pabloo-green);\n    color: #fff\n}\n\n.color-box._3 {\n    background-color: var(--magenta);\n    color: #fff\n}\n\n.color-box._2 {\n    background-color: var(--white);\n    background-image: none;\n    border: 1px solid rgba(0, 0, 0, .3)\n}\n\n.color-box._6 {\n    background-color: var(--darker-violet);\n    color: #fff;\n    margin-top: 0\n}\n\n.reference-text {\n    opacity: .6;\n    flex: none;\n    font-size: 16px\n}\n\n.sg-icon-contain {\n    background-color: #dfd3ff;\n    border-radius: 8px;\n    flex-direction: column;\n    flex: none;\n    justify-content: center;\n    align-items: center;\n    width: 56px;\n    height: 56px;\n    display: flex\n}\n\n.sg-icon-contain.yellow {\n    background-color: #fff964\n}\n\n.sg-icon-contain.salmon {\n    background-color: #ffb199\n}\n\n.typography-item-description {\n    margin-bottom: 16px\n}\n\n.reference-section {\n    width: 100%\n}\n\n.typography-grid {\n    grid-column-gap: 16px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.sg-icon {\n    object-fit: contain;\n    width: 32px;\n    height: 32px\n}\n\n.heading-64px {\n    letter-spacing: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 64px;\n    font-weight: 800;\n    line-height: 112.5%\n}\n\n.heading-64px.hero-home-heading {\n    display: inline\n}\n\n.heading-64px.hero-home-heading.sales {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    transform: perspective(2000px)\n}\n\n.heading-64px.hero-home-heading.zapier,\n.heading-64px.hero-home-heading.snow {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    position: absolute;\n    transform: perspective(2000px)\n}\n\n.heading-64px.hero-home-heading.top {\n    max-width: 515.278px\n}\n\n.heading-64px.hero-home-heading.bottom {\n    z-index: 2;\n    transition: all .2s;\n    position: relative\n}\n\n.heading-64px.hero-home-heading.mail,\n.heading-64px.hero-home-heading.inter,\n.heading-64px.hero-home-heading.adobe,\n.heading-64px.hero-home-heading.jira,\n.heading-64px.hero-home-heading.hubspot,\n.heading-64px.hero-home-heading.zendesk {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    position: absolute;\n    transform: perspective(2000px)\n}\n\n.heading-64px.text-align-center {\n    color: var(--black-2);\n    text-align: center;\n    margin-top: 15px;\n    font-size: 52px\n}\n\n.heading-64px.text-align-center.integra {\n    font-size: 46px\n}\n\n.heading-64px.text-align-center.integra.new {\n    text-align: left\n}\n\n.heading-64px.blogs-hero-heading {\n    text-align: center\n}\n\n.heading-64px.resource-hero-heading {\n    color: var(--white);\n    text-align: left\n}\n\n.heading-64px.saas-hero-heading,\n.heading-64px.cloud-hero-heading {\n    margin-bottom: 4px\n}\n\n.heading-64px.skewed {\n    transform: rotate(-11deg)\n}\n\n.heading-64px.skewed.text-color-pink {\n    color: var(--pabloo-green-2);\n    margin-top: -16px;\n    margin-left: 12px;\n    margin-right: 12px\n}\n\n.heading-90px {\n    letter-spacing: -3.6px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 90px;\n    font-weight: 700;\n    line-height: 124.444%\n}\n\n.heading-56px {\n    letter-spacing: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 56px;\n    font-weight: 800;\n    line-height: 118.519%\n}\n\n.heading-56px.integrations-heading {\n    margin-bottom: 16px\n}\n\n.heading-56px.integrations-heading._40px-bottom-margin {\n    margin-bottom: 40px\n}\n\n.heading-56px.spend-heading {\n    text-align: center;\n    max-width: 800px\n}\n\n.heading-48px {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 48px;\n    font-weight: 800;\n    line-height: 116.667%\n}\n\n.heading-48px.stack-heading {\n    color: var(--white);\n    text-align: center;\n    max-width: 800px;\n    margin-bottom: 40px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-48px.blogs-heading {\n    text-align: center;\n    max-width: 728px\n}\n\n.heading-48px.ctas-heading {\n    color: var(--white);\n    max-width: 580px;\n    margin-bottom: 8px\n}\n\n.heading-48px.ctas-heading._16px-bottom-margin {\n    margin-bottom: 16px\n}\n\n.heading-48px.blog-post-title {\n    color: var(--dark-violet)\n}\n\n.heading-48px.blog-post-title.cms {\n    color: #5b002c\n}\n\n.heading-48px.setup-heading {\n    color: var(--white);\n    text-align: center;\n    max-width: 800px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-48px.points-heading {\n    color: var(--white);\n    max-width: 534px;\n    margin-bottom: 24px\n}\n\n.heading-40px {\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 40px;\n    font-weight: 800;\n    line-height: 120%\n}\n\n.heading-40px.tribe-heading {\n    max-width: 800px;\n    padding-right: 0\n}\n\n.heading-40px.calculator-text-contain-heading {\n    max-width: 459px;\n    line-height: 110%\n}\n\n.heading-40px.spend-block-heading {\n    font-family: Inter, sans-serif;\n    font-weight: 600\n}\n\n.navigation-bar {\n    z-index: 1000;\n    background-color: var(--transparent);\n    margin-top: 0;\n    position: fixed;\n    top: 0;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.navigation-bar.xt {\n    display: none\n}\n\n.navbar-container {\n    z-index: 2;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    display: flex;\n    position: relative\n}\n\n.navbar-container.optimize {\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 32px;\n    padding-bottom: 32px\n}\n\n.navigation-menu {\n    margin-left: 20px;\n    margin-right: auto;\n    position: static\n}\n\n.navigation-menu.new {\n    flex: 0 auto;\n    margin-left: auto;\n    margin-right: 20px\n}\n\n.navigation-menu.new.optimize {\n    flex: 0 auto;\n    order: 0;\n    justify-content: flex-start;\n    align-items: center;\n    margin-left: 0;\n    margin-right: 0;\n    display: block\n}\n\n.nav-links-contain {\n    grid-column-gap: 12px;\n    grid-row-gap: 32px;\n    align-items: center;\n    display: flex\n}\n\n.nav-links-contain.new,\n.nav-links-contain.new.adpage,\n.nav-links-contain.new.adpage.optimize {\n    justify-content: center;\n    align-items: center\n}\n\n.navigation-link {\n    color: var(--dark-violet);\n    font-weight: 500;\n    line-height: 118.75%;\n    transition: color .3s ease-in-out\n}\n\n.navigation-link:hover {\n    color: rgb(21 128 61)\n}\n\n.navigation-link.w--current {\n    color: rgb(21 128 61)\n}\n\n.navigation-link.white {\n    color: var(--white)\n}\n\n.navigation-link.white:hover {\n    color: var(--light-pink)\n}\n\n.navigation-link.new {\n    padding-left: 15px;\n    padding-right: 15px\n}\n\n.navigation-link.new.optimize-community {\n    color: var(--white)\n}\n\n.navbar-dropdown {\n    background-color: rgba(255, 255, 255, 0);\n    border-radius: 40px;\n    font-size: 16px;\n    line-height: 118.75%;\n    position: static\n}\n\n.navbar-dropdown-toggle {\n    grid-column-gap: 8px;\n    align-items: center;\n    padding: 20px 0;\n    display: flex;\n    position: static\n}\n\n.dropdown-lists {\n    background-color: #fff\n}\n\n.dropdown-lists.w--open {\n    background-color: rgba(255, 255, 255, 0);\n    width: 104%;\n    padding-top: 40px;\n    top: 82px;\n    bottom: auto;\n    left: -2%;\n    right: auto\n}\n\n.dropdown-lists.resources.w--open {\n    left: -400px\n}\n\n.dropdown-links-contain {\n    background-color: #fff;\n    border-radius: 10px;\n    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)\n}\n\n.dropdown-links-contain.w--open {\n    border-radius: 10px;\n    box-shadow: 0 80px 100px rgba(28, 28, 31, .1)\n}\n\n.dropdown-links-contain.product {\n    width: 100%;\n    max-width: 1312px;\n    padding: 32px;\n    position: relative\n}\n\n.dropdown-links-contain.solutions {\n    width: 321px;\n    padding: 12px\n}\n\n.dropdown-links-contain.resources {\n    width: 782px;\n    padding: 12px\n}\n\n.dropdown-link {\n    color: var(--dark-violet);\n    transition: color .3s ease-in-out\n}\n\n.dropdown-link:hover {\n    color: var(--pabloo-green)\n}\n\n.dropdown-link.w--current,\n.dropdown-link.w--current:hover {\n    color: #ff5757\n}\n\n.dropdown-arrow-embed {\n    width: 12px;\n    height: 19px\n}\n\n.dropdown-arrow-embed.mobile {\n    display: none\n}\n\n.logo-contain {\n    grid-column-gap: 5.95px;\n    grid-row-gap: 5.95px;\n    align-items: flex-end;\n    height: 36px;\n    display: flex\n}\n\n.logo-contain.footer-logo {\n    grid-column-gap: 9px;\n    grid-row-gap: 9px;\n    height: 60px\n}\n\n.logo-bars-contain {\n    flex: none;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: flex-end;\n    height: 31.72px;\n    margin-bottom: auto;\n    display: flex;\n    overflow: hidden\n}\n\n.logo-bars-contain.footer-bars {\n    height: 55.54px\n}\n\n.logo-image {\n    max-width: 125px\n}\n\n.logo-image.footer-logo {\n    width: 209px;\n    max-width: 209px\n}\n\n.logo-bar {\n    width: 11px\n}\n\n.logo-bar.second {\n    margin-left: -1px\n}\n\n.logo-bar.second.footer-bar {\n    width: 19px;\n    margin-left: -1.5px\n}\n\n.logo-bar.third {\n    margin-left: -1px\n}\n\n.logo-bar.third.footer-bar {\n    width: 19px;\n    margin-left: -1.5px\n}\n\n.logo-bar.first.footer-bar {\n    width: 19px\n}\n\n.navigation-button-contain {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    align-items: center;\n    display: flex\n}\n\n.navigation-button-contain.out-menu {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px\n}\n\n.navigation-button-contain.in-menu {\n    display: none\n}\n\n.hero-home-section {\n    background-color: var(--soft-pink);\n    padding-top: 0;\n    overflow: hidden;\n}\n\n@media (max-width: 768px) {\n    .hero-home-section {\n        background-color: var(--soft-pink);\n        padding-top: 0;\n        overflow: hidden;\n        margin-top: -30px;\n    }\n}\n\n.hero-home-section.padding-bottom-xl {\n    overflow: hidden\n}\n\n.hero-home-section.padding-bottom-xl.abstract-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba19fb45f87422d52b2f2_Group%202085663950.svg);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: 100%\n}\n\n.hero-home-wrapper {\n    z-index: 2;\n    aspect-ratio: 16/9;\n    color: var(--darker-violet);\n    flex-flow: row;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: -110px;\n    margin-bottom: -140px;\n    padding-top: 213px;\n    padding-bottom: 118px;\n    display: flex;\n    position: relative\n}\n\n.hero-home-wrapper.new {\n    padding-top: 220px;\n    padding-bottom: 140px\n}\n\n.hero-home-wrapper.new.ads {\n    padding-top: 180px\n}\n\n.transparent-arrow-button {\n    color: var(--dark-violet);\n    letter-spacing: -.16px;\n    border: 2px solid rgba(36, 2, 19, .4);\n    border-radius: 10px;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 32px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 122.222%;\n    text-decoration: none;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.transparent-arrow-button._16px {\n    padding: 18px 24px;\n    font-size: 16px;\n    line-height: 118.75%\n}\n\n.transparent-arrow-button._16px.navigation {\n    padding-left: 36px;\n    padding-right: 36px\n}\n\n.transparent-arrow-button._16px.navigation.optimize-community {\n    border-color: rgba(110, 110, 110, .5)\n}\n\n.transparent-arrow-button.integra {\n    color: var(--white);\n    -webkit-text-fill-color: inherit;\n    background-color: transparent;\n    background-clip: border-box;\n    border-width: 2px;\n    justify-content: center;\n    align-items: center\n}\n\n.transparent-arrow-button.product {\n    background-color: #fff;\n    align-self: flex-start;\n    padding-top: 10px;\n    padding-bottom: 10px\n}\n\n.transparent-arrow-button.product:hover {\n    border-color: var(--pabloo-green);\n    background-color: var(--pabloo-green);\n    color: var(--white)\n}\n\n.button-panel {\n    background-color: rgba(36, 2, 19, .15);\n    border-radius: 0;\n    width: 0%\n}\n\n.button-panel.white {\n    background-color: rgba(255, 255, 255, .1)\n}\n\n.button-text {\n    z-index: 2;\n    color: var(--white);\n    -webkit-text-stroke-color: var(--dark-violet);\n    font-weight: 700\n}\n\n.button-text.integra {\n    color: var(--white);\n    -webkit-text-stroke-color: var(--dark-violet)\n}\n\n.button-text.savings {\n    color: var(--white)\n}\n\n.button-text.trans,\n.button-text.nav {\n    color: var(--dark-violet)\n}\n\n.button-text.nav.optimize-comm {\n    color: #fff\n}\n\n.button-panels-contain {\n    z-index: 1;\n    color: var(--white);\n    border-radius: 0;\n    flex-direction: row;\n    flex: 0 auto;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: space-around;\n    width: 100%;\n    display: flex;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.button-text-wrapper {\n    z-index: 2;\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    align-items: center;\n    display: flex;\n    position: relative\n}\n\n.button-text-wrapper.optimize-community {\n    justify-content: center;\n    align-items: flex-end\n}\n\n.button-arrow-embed {\n    width: 6px;\n    height: 19px\n}\n\n.button-arrow-embed._18px {\n    color: var(--white);\n    -webkit-text-stroke-color: var(--white);\n    width: 10px;\n    height: 19px\n}\n\n.button-arrow-embed:hover {\n    color: var(--pabloo-green);\n    -webkit-text-stroke-color: var(--pabloo-green);\n}\n\n\n.button-arrow-embed._18px.trans {\n    color: var(--dark-violet)\n}\n\n.button-arrow-embed.resource {\n    margin-top: 2px\n}\n\n.button-arrow-embed.downward {\n    width: 18px\n}\n\n.button-arrow-embed._16px,\n.button-arrow-embed._14px {\n    width: 7px;\n    height: 24px\n}\n\n.button-arrow-embed.trans.optimize {\n    width: auto;\n    height: auto\n}\n\n.hero-home-text-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 51%;\n    max-width: 560px;\n    /* padding-right: 22px; */\n    display: flex\n}\n\n.hero-home-text-wrapper.new {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    max-width: none\n}\n\n.pink-heading-span {\n    color: var(--pabloo-green)\n}\n\n.paragraph-18px {\n    font-size: 18px;\n    line-height: 156%\n}\n\n.paragraph-18px.hero-home-paragraph {\n    color: var(--darker-violet);\n    margin-bottom: 24px;\n    padding-right: 41px\n}\n\n.paragraph-18px.hero-home-paragraph.new {\n    text-align: center;\n    width: 80%;\n    margin-top: 25px;\n    font-size: 22px\n}\n\n.paragraph-18px.hero-home-paragraph.new.x {\n    font-size: 17px\n}\n\n.paragraph-18px.integrations-paragraph {\n    margin-bottom: 40px\n}\n\n.paragraph-18px.stack-block-paragraph {\n    color: var(--white)\n}\n\n.paragraph-18px.blog-post-summary._8px-bottom-margn {\n    margin-bottom: 8px\n}\n\n.paragraph-18px.ctas-paragraph {\n    color: var(--white);\n    max-width: 600px;\n    margin-bottom: 32px\n}\n\n.paragraph-18px.tribe-tab-paragraph {\n    color: var(--dark-violet);\n    font-weight: 400\n}\n\n.paragraph-18px.spend-block-paragraph {\n    font-weight: 400\n}\n\n.paragraph-18px.spend-block-paragraph.new {\n    font-weight: 400;\n    display: block\n}\n\n.paragraph-18px.reviewer-position {\n    opacity: .8;\n    font-weight: 500\n}\n\n.paragraph-18px.calculator-toggle-text {\n    font-weight: 700\n}\n\n.paragraph-18px.resource-post-description {\n    color: #240213\n}\n\n.paragraph-18px.saas-hero-paragraph {\n    max-width: 636px;\n    margin-bottom: 24px\n}\n\n.paragraph-18px.cloud-hero-paragraph {\n    max-width: 527px;\n    margin-bottom: 24px\n}\n\n.paragraph-18px.navigation-header-link-text {\n    font-family: Satoshi, sans-serif;\n    font-weight: 700\n}\n\n.paragraph-18px.points-check-list-text {\n    color: var(--white)\n}\n\n.pink-arrow-button {\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    letter-spacing: -.18px;\n    border-radius: 10px;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 32px;\n    font-weight: 600;\n    line-height: 122.222%;\n    text-decoration: none;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.pink-arrow-button.ebook {\n    width: 60%\n}\n\n.pink-arrow-button.ads {\n    margin-top: 19px\n}\n\n.pink-arrow-button.new {\n    padding-left: 88px;\n    padding-right: 84px\n}\n\n.stats-section {\n    width: 100%;\n    margin-top: 103px;\n    padding-top: 0\n}\n\n.stats-wrapper {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    padding-top: 17px;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.stats-grid {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 90%;\n    max-width: 1188px;\n    margin-top: 60px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.stats-block {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    border-radius: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    height: 100%;\n    padding: 28px 28px 20px;\n    display: flex\n}\n\n.stats-block.first {\n    background-image: linear-gradient(135deg, #fff4dc, #f0deb5);\n    padding-bottom: 28px\n}\n\n.stats-block.second {\n    background-image: linear-gradient(135deg, #ddfbf7, #ace7df)\n}\n\n.stats-block.third {\n    background-image: linear-gradient(135deg, #fbeded, #e6c5c6)\n}\n\n.stats-bottom-block {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.heading-24px {\n    font-size: 24px;\n    line-height: 133.333%\n}\n\n.heading-24px.stats-text {\n    margin-bottom: 4px;\n    font-weight: 500\n}\n\n.heading-24px.type-card-subheading {\n    font-weight: 600\n}\n\n.heading-24px.stack-block-heading {\n    margin-right: auto;\n    font-weight: 600\n}\n\n.heading-24px.blog-post-title {\n    font-weight: 600\n}\n\n.heading-24px.blog-post-title.resource-feature {\n    color: var(--white);\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 700\n}\n\n.heading-24px.footer-logo-subtext {\n    font-weight: 500\n}\n\n.heading-24px.tribe-link-heading {\n    color: var(--dark-violet)\n}\n\n.heading-24px.review-text {\n    letter-spacing: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 800\n}\n\n.heading-24px.resource-tab-heading {\n    font-weight: 600\n}\n\n.heading-24px.setup-card-text {\n    max-width: 230px;\n    font-size: 20px\n}\n\n.heading-24px.navigation-header-heading {\n    font-family: Satoshi, sans-serif\n}\n\n.stats-icon-contain {\n    background-color: rgba(36, 2, 19, .08);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 48px;\n    height: 48px;\n    display: flex\n}\n\n.stats-icon-embed {\n    width: 24px;\n    height: 24px\n}\n\n.stats-gradient-block {\n    background-image: linear-gradient(135deg, rgba(6, 19, 27, .1), rgba(6, 19, 27, .04));\n    border-radius: 16px;\n    padding: 2px\n}\n\n.stats-gradient-block.second {\n    background-color: var(--transparent);\n    background-image: linear-gradient(135deg, rgba(19, 86, 101, .1), rgba(19, 86, 101, .2))\n}\n\n.stats-gradient-block.third {\n    background-image: linear-gradient(135deg, rgba(72, 33, 53, .08), rgba(72, 33, 53, .16))\n}\n\n.seo-page-hero {\n    background-color: #fdf2ea;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/65280657811f4e02dda60f95_Background.png);\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding: 8rem 40px 80px\n}\n\n.div-block-702 {\n    padding-top: 16px;\n    padding-bottom: 24px;\n    display: block\n}\n\n.html-embed-28 {\n    text-align: left;\n    font-family: P22 Mackinacpro, sans-serif\n}\n\n.paragraph-140 {\n    text-align: center;\n    font-family: Satoshi, sans-serif;\n    font-weight: 400\n}\n\n.div-block-703 {\n    padding: 24px 10%\n}\n\n.logos-main-wrapper {\n    background-color: var(--transparent);\n    width: 100%;\n    margin-bottom: 40px;\n    position: relative\n}\n\n.splide {\n    position: relative\n}\n\n.splide__track {\n    display: flex;\n    position: relative\n}\n\n.splide__list {\n    flex: none;\n    display: flex;\n    position: relative\n}\n\n.logo-image-contain {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 214px;\n    height: 40px;\n    display: flex;\n    position: relative\n}\n\n.logo-tain-image {\n    z-index: 1;\n    opacity: 1;\n    object-fit: contain;\n    flex: 0 auto;\n    height: 100%;\n    position: relative\n}\n\n.logo-tain-image.puuffco {\n    opacity: .72\n}\n\n.logo-colour-overlay {\n    z-index: 2;\n    background-color: var(--white);\n    mix-blend-mode: color;\n    display: block;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.logo-colour-overlay.new {\n    background-color: var(--soft-pink)\n}\n\n.type-cards-section {\n    background-color: #18020d;\n    width: 100%;\n    overflow: hidden\n}\n\n.type-cards-wrapper {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529beaffd19962a33ef44ed_Type%20Bg.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.type-cards-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.type-card-block {\n    border-radius: 20px;\n    width: 100%;\n    padding-top: 36px;\n    padding-bottom: 36px;\n    overflow: hidden\n}\n\n.type-card-block.first {\n    background-color: var(--transparent);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529bf430cb2a8e1a63b75a1_Type%20Card%20Bg.svg), linear-gradient(135deg, #fff4dc, #f1dfb8);\n    background-position: 50% 100%, 0 0;\n    background-size: cover, auto;\n    padding-bottom: 45px;\n    padding-left: 0;\n    padding-right: 0\n}\n\n.type-card-block.second {\n    background-color: var(--transparent);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529bf430cb2a8e1a63b75a1_Type%20Card%20Bg.svg), linear-gradient(135deg, #fbedee, #e7c7c8);\n    background-position: 50% 100%, 0 0;\n    background-size: cover, auto;\n    padding-bottom: 50px;\n    padding-left: 0;\n    padding-right: 0\n}\n\n.type-card-top-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    padding-left: 36px;\n    padding-right: 36px;\n    display: flex\n}\n\n.type-card-heading-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    align-items: center;\n    margin-bottom: 16px;\n    display: flex\n}\n\n.type-card-icon-contain {\n    background-image: linear-gradient(135deg, #fffefc, #fffaf0);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    display: flex\n}\n\n.type-card-icon-embed {\n    width: 36px;\n    height: 36px\n}\n\n.heading-28px {\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 128.571%;\n\n    font-family: P22 Mackinacpro, sans-serif;\n}\n\n.heading-28px.type-card-heading {\n    max-width: 483px;\n    margin-bottom: 20px\n}\n\n.heading-28px.ctas-subheading {\n    color: #f7e8c7;\n    margin-bottom: 20px\n}\n\n.section-64 {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.div-block-704 {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 2.5fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-705 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.paragraph-141 {\n    margin-top: 16px;\n    font-family: Satoshi, sans-serif;\n    font-size: 18px;\n    font-weight: 300;\n    line-height: 1.6em\n}\n\n.heading-248 {\n    font-family: P22 Mackinacpro, sans-serif\n}\n\n.div-block-706 {\n    border-radius: 8px;\n    padding: 12px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, .14)\n}\n\n.image-219 {\n    object-fit: contain;\n    border-radius: 8px;\n    width: 80px;\n    height: 80px\n}\n\n.div-block-707 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/652927f9e4171f39a0535818_Rectangle%2034624776.png);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: auto 100%;\n    margin-top: 40px;\n    padding: 48px\n}\n\n.div-block-708 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: .25fr 1fr;\n    grid-auto-columns: 1fr;\n    padding: 16px 32px;\n    display: grid\n}\n\n.text-block-300 {\n    margin-top: 8px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 56px;\n    font-weight: 700;\n    line-height: 56px\n}\n\n.div-block-709 {\n    justify-content: center;\n    align-items: center;\n    padding: 32px 16px;\n    display: flex\n}\n\n.heading-249 {\n    margin-top: 8px;\n    margin-bottom: 4px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 32px;\n    line-height: 1.2em\n}\n\n.paragraph-142 {\n    color: #7a8391;\n    font-family: Satoshi, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 1.6em\n}\n\n.div-block-710 {\n    background-color: #fff;\n    border-radius: 10px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, .1)\n}\n\n.div-block-711 {\n    border-top: 1px solid rgba(0, 0, 0, .4);\n    padding: 16px 32px 32px\n}\n\n.div-block-712 {\n    grid-column-gap: 4px;\n    grid-row-gap: 4px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-712.n-1 {\n    margin-top: 16px\n}\n\n.div-block-713 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 2.75fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-714 {\n    background-color: #eee;\n    border-radius: 8px;\n    width: 100%;\n    display: flex\n}\n\n.div-block-715 {\n    background-color: #280015;\n    border-top-left-radius: 8px;\n    border-bottom-left-radius: 8px;\n    width: 50%;\n    height: 10px\n}\n\n.div-block-716 {\n    grid-column-gap: 4px;\n    grid-row-gap: 4px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-716.n-1 {\n    margin-top: 24px\n}\n\n.text-block-301 {\n    color: rgba(51, 65, 85, .65);\n    text-transform: uppercase;\n    font-family: Inter, sans-serif;\n    font-size: 16px;\n    font-weight: 600\n}\n\n.div-block-717 {\n    grid-column-gap: 2px;\n    grid-row-gap: 2px;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-717.new {\n    display: flex\n}\n\n.text-block-302 {\n    color: var(--pabloo-green);\n    flex: 0 auto;\n    font-weight: 500\n}\n\n.div-block-718 {\n    display: flex\n}\n\n.link-n-1 {\n    margin-left: 8px\n}\n\n.div-block-719 {\n    border-left: 1px solid #f4dfe0;\n    padding-top: 32px;\n    padding-left: 40px\n}\n\n.section-65 {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-720 {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    grid-template-rows: auto;\n    grid-template-columns: .75fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-721 {\n    background-image: linear-gradient(#fff4dc, #f0deb5);\n    border: 1px solid #fdf1d6;\n    border-radius: 16px;\n    padding: 40px 32px 40px 40px\n}\n\n.link-block-36 {\n    align-items: center;\n    margin-top: 20px;\n    display: flex\n}\n\n.html-embed-29 {\n    margin-left: 8px\n}\n\n.text-block-303 {\n    line-height: 18px;\n    /* text-decoration: none */\n}\n\n.div-block-722 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid\n}\n\n.collection-list-7 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.heading-250 {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-size: 22px\n}\n\n.div-block-724 {\n    margin-top: 20px\n}\n\n.div-block-725 {\n    border-radius: 10px;\n    padding: 16px;\n    box-shadow: 3px 0 16px rgba(0, 0, 0, .12)\n}\n\n.paragraph-143 {\n    font-size: 16px;\n    line-height: 23px\n}\n\n.image-220 {\n    height: 36px\n}\n\n.div-block-726 {\n    padding-top: 8px\n}\n\n.section-66 {\n    background-color: var(--dark-violet);\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.div-block-727 {\n    grid-column-gap: 56px;\n    grid-row-gap: 56px;\n    grid-template-rows: auto;\n    grid-template-columns: 1.5fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.heading-251 {\n    color: var(--white);\n    font-family: P22 Mackinacpro, sans-serif\n}\n\n.paragraph-144 {\n    color: var(--white);\n    margin-top: 20px\n}\n\n.div-block-728 {\n    background-color: #fff;\n    border-radius: 10px;\n    padding: 16px 20px\n}\n\n.arrow-text-link {\n    grid-column-gap: 8px;\n    grid-row-gap: 4px;\n    color: var(--dark-violet);\n    cursor: pointer;\n    flex-direction: column;\n    align-items: flex-end;\n    font-weight: 600;\n    line-height: 155.556%;\n    display: flex;\n    overflow: hidden\n}\n\n.arrow-text-link.white {\n    color: var(--white)\n}\n\n.arrow-text-link.white.hide {\n    display: none\n}\n\n.arrow-text-link.resource {\n    grid-column-gap: 2px;\n    grid-row-gap: 2px;\n    color: var(--pabloo-green);\n    font-size: 14px\n}\n\n.arrow-text-link.pink {\n    color: var(--pabloo-green)\n}\n\n.arrow-text-link._14px {\n    font-size: 14px\n}\n\n.arrow-text-link.menu {\n    color: var(--pabloo-green)\n}\n\n.arrow-text-link.cream {\n    color: var(--cream)\n}\n\n.arrow-text-link-top-contain {\n    grid-column-gap: 8px;\n    align-items: center;\n    display: flex\n}\n\n.arrow-wrapper {\n    height: 24px;\n    overflow: hidden\n}\n\n.text-link-underline {\n    background-color: var(--dark-violet);\n    width: 100%;\n    height: 2px\n}\n\n.text-link-underline.pink {\n    background-color: var(--pabloo-green)\n}\n\n.text-link-underline.white {\n    background-color: var(--white)\n}\n\n.text-link-underline.cream {\n    background-color: var(--cream)\n}\n\n.type-cards-train-container {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex-direction: column;\n    margin-top: 28px;\n    margin-bottom: 42px;\n    display: flex\n}\n\n.type-cards-train-container.vertical {\n    margin-bottom: 58px;\n    padding-left: 34px;\n    padding-right: 34px\n}\n\n.type-cards-train-wrapper {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-direction: row;\n    display: flex\n}\n\n.type-cards-train-wrapper.vertical {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex-direction: column\n}\n\n.type-cards-train-card {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex: none;\n    align-items: center;\n    display: flex\n}\n\n.type-card-checkmark {\n    color: #5e4146;\n    flex: none;\n    width: 20px;\n    height: 20px\n}\n\n.type-card-images-grid {\n    align-items: end;\n    width: 90%;\n    max-width: 563px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.type-card-grid-image {\n    width: 100%\n}\n\n.type-card-grid-image.shadow {\n    box-shadow: 0 9px 77px rgba(36, 2, 19, .08)\n}\n\n.type-card-image-contain {\n    width: 90%;\n    max-width: 520px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.integrations-section {\n    width: 100%;\n    overflow: hidden\n}\n\n.integrations-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1240px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 140px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.integrations-wrapper.cloud {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.integrations-text-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 45%;\n    max-width: 514px;\n    display: flex\n}\n\n.integrations-image-contain {\n    width: 50%;\n    max-width: 613px\n}\n\n.calculator-section {\n    background-color: var(--soft-pink);\n    position: relative;\n    overflow: hidden\n}\n\n.calculator-container {\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1240px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.calculator-container.confined {\n    width: 94%;\n    max-width: 100%\n}\n\n.calculator-left {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 48%;\n    max-width: 651px;\n    display: flex\n}\n\n.calc-arrow-image {\n    flex: none;\n    width: 100%;\n    max-width: 306px;\n    display: none;\n    position: absolute;\n    top: auto;\n    bottom: auto;\n    left: auto;\n    right: -22%\n}\n\n.stack-section {\n    background-color: var(--dark-violet);\n    width: 100%;\n    overflow: hidden\n}\n\n.stack-wrapper {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.stack-wrapper-contain {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529cb39722f7ce55df781c6_Stack%20Bg.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.stack-span {\n    color: #f7e8c7\n}\n\n.stack-tabs-menu {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    justify-content: center;\n    align-items: flex-end;\n    margin-bottom: 60px;\n    display: flex\n}\n\n.stack-tab-link {\n    background-color: var(--transparent);\n    color: #f7e8c7;\n    min-width: 230px;\n    padding: 0\n}\n\n.stack-tab-link.w--current {\n    background-color: var(--transparent)\n}\n\n.stack-tab-link-wrapper {\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.stack-tab-link-header {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 16px;\n    display: flex\n}\n\n.stack-tab-link-header:hover {\n    color: none;\n}\n\n.stack-tab-link-icon {\n    width: 28px;\n    height: 28px\n}\n\n.stack-tab-link-progress-bar-contain {\n    background-color: rgba(246, 244, 241, .2);\n    border-radius: 80px;\n    width: 100%;\n    height: 8px;\n    position: relative\n}\n\n.paragraph-20px {\n    font-size: 20px;\n    line-height: 140%\n}\n\n.paragraph-20px.stack-tab-link-text {\n    /* color: var(--white) */\n}\n\n.paragraph-20px.stack-tab-link-text:hover {\n    color: var(--pabloo-green)\n}\n\n.paragraph-20px.footer-column-subheading {\n    opacity: .5;\n    letter-spacing: .4px;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n    font-weight: 600\n}\n\n.paragraph-20px.footer-link {\n    font-weight: 500\n}\n\n.paragraph-20px.footer-link.dark {\n    color: #ccc\n}\n\n.paragraph-20px.reviewer-name {\n    font-weight: 600\n}\n\n.paragraph-20px.author-name {\n    font-weight: 700\n}\n\n.paragraph-20px.author-position {\n    opacity: .6;\n    font-weight: 500\n}\n\n.paragraph-20px.resource-post-heading {\n    color: #240213;\n    letter-spacing: 0\n}\n\n.paragraph-20px.blog-tag-radio-button-label {\n    text-transform: capitalize;\n    margin-bottom: 10px;\n    padding-left: 30px;\n    padding-right: 30px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500\n}\n\n.paragraph-20px.navigation-block-heading {\n    font-weight: 600\n}\n\n.stack-tab-info-contain {\n    width: 100%\n}\n\n.stack-blocks-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto\n}\n\n.stack-block {\n    border-radius: 16px;\n    width: 100%;\n    padding: 32px 32px 29px\n}\n\n.stack-block.a-first {\n    background-color: rgba(255, 255, 255, .2);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529d3e06af926707aa8b658_Stack%20Bg%201.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover\n}\n\n.stack-block.a-second {\n    background-color: var(--pabloo-green);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529d3e06af926707aa8b658_Stack%20Bg%201.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover\n}\n\n.stack-block.d-first {\n    background-color: rgba(255, 255, 255, .2);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529d3e06af926707aa8b658_Stack%20Bg%201.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    padding-left: 19px;\n    padding-right: 22px\n}\n\n.stack-block-top-wrapper {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.stack-block-top-wrapper.before-d {\n    padding-left: 13px;\n    padding-right: 10px\n}\n\n.stack-block-header {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    color: var(--white);\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.stack-block-icon {\n    width: 32px;\n    height: 32px\n}\n\n.stack-block-image-contain {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.stack-block-image-contain.a-first {\n    max-width: 556px;\n    margin-top: 34px;\n    padding-bottom: 3px\n}\n\n.stack-block-image-contain.a-second {\n    max-width: 556px;\n    margin-top: 32px;\n    padding-bottom: 1px\n}\n\n.stack-block-image-contain.b-first {\n    max-width: 537px;\n    margin-top: 109px;\n    padding-bottom: 39px\n}\n\n.stack-block-image-contain.c-first {\n    max-width: 530px;\n    margin-top: 67px;\n    padding-bottom: 13px\n}\n\n.stack-block-image-contain.c-second {\n    max-width: 511px;\n    margin-top: 67px;\n    padding-bottom: 34px\n}\n\n.stack-block-image-contain.b-second {\n    max-width: 493px;\n    margin-top: 39px;\n    padding-bottom: 13px\n}\n\n.stack-block-image-contain.d-second {\n    max-width: 552px;\n    margin-top: 74px;\n    padding-bottom: 11px\n}\n\n.stack-block-image-contain.d-first {\n    max-width: 579px;\n    margin-top: 27px;\n    padding-bottom: 37px\n}\n\n.stack-block-image {\n    width: 100%\n}\n\n.stack-block-image.shadow {\n    box-shadow: 0 14px 73px rgba(0, 0, 0, .05)\n}\n\n.stack-tabs {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.stack-tab-progress-bar {\n    background-color: var(--white);\n    border-radius: 80px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.blogs-section {\n    width: 100%;\n    overflow: hidden\n}\n\n.blogs-wrapper {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    flex-direction: column;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 140px;\n    display: flex\n}\n\n.blogs-container {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.blogs-container.new {\n    display: block\n}\n\n.blogs-collection-list-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: block\n}\n\n.blogs-collection-list {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.blogs-collection-list.grid {\n    grid-column-gap: 36px;\n    grid-row-gap: 36px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.blogs-collection-list._3-column-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 60px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.blogs-collection-list.blog-page {\n    grid-template-columns: 1fr\n}\n\n.blogs-collection-item {\n    width: 100%\n}\n\n.blog-post-wrapper {\n    grid-column-gap: 28px;\n    grid-row-gap: 28px;\n    color: var(--dark-violet);\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.blog-post-wrapper.featured {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    background-color: #fff;\n    border-radius: 20px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    box-shadow: 0 20px 100px rgba(36, 2, 19, .08)\n}\n\n.blog-post-wrapper._16px-gap,\n.blog-post-wrapper.resource-hero {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px\n}\n\n.blog-post-wrapper.load-list {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    border-radius: 10px;\n    transition: all .3s cubic-bezier(.445, .05, .55, .95)\n}\n\n.blog-post-wrapper.load-list:hover {\n    color: #b33071;\n    transform: translateY(-10px)\n}\n\n.blog-post-image-wrapper {\n    border-radius: 16px;\n    width: 100%;\n    height: 400px;\n    overflow: hidden\n}\n\n.blog-post-image-wrapper.featured {\n    height: 400px;\n    margin-top: 0\n}\n\n.blog-post-image-wrapper.featured.blog-page {\n    width: 53%\n}\n\n.blog-post-image-wrapper.featured.cms {\n    width: 45%;\n    max-width: 580px;\n    height: 420px\n}\n\n.blog-post-image-wrapper.featured.resources-hero {\n    height: 365px\n}\n\n.blog-post-image-wrapper._300px {\n    height: 300px\n}\n\n.blog-post-info-wrapper {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-bottom: 41px;\n    display: flex\n}\n\n.blog-post-info-wrapper.featured {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    width: 43%\n}\n\n.blog-post-info-wrapper.cms {\n    width: 50%;\n    max-width: 620px\n}\n\n.blog-post-info-wrapper.resource-hero {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px\n}\n\n.paragraph-16px {\n    font-size: 16px;\n    line-height: 125%\n}\n\n.paragraph-16px.blog-category-text {\n    color: var(--pabloo-green);\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    background-color: rgba(213, 57, 135, .12);\n    border-radius: 8px;\n    margin-bottom: 4px;\n    padding: 6px 16px;\n    font-weight: 600\n}\n\n.paragraph-16px.blog-category-text.no-bottom-margin {\n    margin-bottom: 0\n}\n\n.paragraph-16px.blog-category-text.only-text {\n    background-color: rgba(213, 57, 135, 0);\n    border-radius: 0;\n    margin-bottom: 0;\n    padding: 0\n}\n\n.paragraph-16px.blog-category-text.date {\n    color: #5b002c;\n    background-color: rgba(213, 57, 135, 0);\n    border-radius: 0;\n    margin-bottom: 0;\n    padding: 0\n}\n\n.paragraph-16px.navigation-header-text {\n    font-weight: 500\n}\n\n.paragraph-16px.dropdown-link {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 0\n}\n\n.paragraph-16px.dropdown-link.highlight {\n    color: var(--pabloo-green);\n    font-weight: 500\n}\n\n.paragraph-16px.dropdown-link.highlight:hover {\n    color: var(--darker-violet)\n}\n\n.paragraph-16px.pink-subheading {\n    color: var(--pabloo-green);\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    font-weight: 600\n}\n\n.paragraph-16px.copyright-paragraph {\n    text-align: center\n}\n\n.paragraph-16px.privacy-link {\n    color: var(--black);\n    text-decoration: none\n}\n\n.paragraph-16px.privacy-link.dark {\n    color: #ccc\n}\n\n.paragraph-16px.dropdown-block-link-text {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 0\n}\n\n.paragraph-16px.dropdown-block-link-text.highlight {\n    color: var(--pabloo-green);\n    font-weight: 500\n}\n\n.paragraph-16px.dropdown-block-link-text.highlight:hover {\n    color: var(--darker-violet)\n}\n\n.paragraph-16px.navigation-subheading {\n    letter-spacing: 1.2px;\n    text-transform: none;\n    font-weight: 600\n}\n\n.paragraph-16px.navigation-block-description {\n    color: var(--dark-violet);\n    margin-bottom: 12px;\n    line-height: 150%\n}\n\n.paragraph-16px.dropdown-block-link-description {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 0;\n    font-family: Satoshi, sans-serif;\n    font-weight: 400\n}\n\n.paragraph-16px.dropdown-block-link-description.highlight {\n    color: var(--pabloo-green);\n    font-weight: 500\n}\n\n.paragraph-16px.dropdown-block-link-description.highlight:hover {\n    color: var(--darker-violet)\n}\n\n.paragraph-16px.dropdown-block-link-heading {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 0;\n    font-weight: 600;\n    line-height: 100%\n}\n\n.paragraph-16px.dropdown-block-link-heading.highlight {\n    color: var(--pabloo-green);\n    font-weight: 500\n}\n\n.paragraph-16px.dropdown-block-link-heading.highlight:hover {\n    color: var(--darker-violet)\n}\n\n.heading-32px {\n    letter-spacing: 0;\n    font-size: 32px;\n    font-weight: 600;\n    line-height: 118.75%\n}\n\n.heading-32px.blog-sticky-heading {\n    margin-top: 24px;\n    margin-bottom: 24px;\n    font-weight: 700\n}\n\n.heading-32px.review-text {\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 800;\n    line-height: 125%\n}\n\n.blog-post-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n    display: inline-block\n}\n\n.blog-post-image.featured {\n    object-position: 0% 50%\n}\n\n.empty-states {\n    color: var(--pabloo-green);\n    text-align: center;\n    background-color: rgba(213, 57, 135, .08);\n    border-radius: 8px;\n    padding: 14px;\n    font-weight: 500\n}\n\n.empty-states.hidden {\n    display: none\n}\n\n.solutions-overview-sec {\n    background-color: var(--darker-violet);\n    width: 100%;\n    overflow: hidden\n}\n\n.ctas-wrapper {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529ed3e13ed5242e06f6cc0_CTA%20Bg.svg);\n    background-position: 0 0;\n    background-size: auto;\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.ctas-container {\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 84px;\n    padding-bottom: 95px;\n    display: flex\n}\n\n.ctas-text-wrapper {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 52%;\n    max-width: 607px;\n    display: flex\n}\n\n.ctas-text-wrapper._50 {\n    width: 50%\n}\n\n.ctas-button-contain {\n    grid-column-gap: 18px;\n    grid-row-gap: 18px;\n    flex-wrap: wrap;\n    display: flex\n}\n\n.transparent-white-arrow-button {\n    color: var(--white);\n    letter-spacing: -.16px;\n    border: 2px solid rgba(255, 255, 255, .32);\n    border-radius: 10px;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 32px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 122.222%;\n    text-decoration: none;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.transparent-white-arrow-button._16px {\n    padding: 22px 28px;\n    font-size: 16px;\n    line-height: 118.75%\n}\n\n.footer-section {\n    background-color: #fff;\n    width: 100%;\n    overflow: hidden\n}\n\n.footer-section.new.dark {\n    background-color: transparent\n}\n\n.footer-wrapper {\n    grid-column-gap: 50px;\n    grid-row-gap: 50px;\n    flex-direction: column;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 80px;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.footer-wrapper.new {\n    padding-bottom: 40px\n}\n\n.footer-top-container {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.footer-logo-header {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.brand-logos-contain {\n    background-image: linear-gradient(135deg, rgba(6, 19, 27, .05), rgba(6, 19, 27, .1));\n    border-radius: 100px;\n    padding: 2px\n}\n\n.brand-logos-wrapper {\n    background-image: linear-gradient(135deg, #fff, #fbfbfb);\n    border-radius: 100px;\n    width: 100%;\n    padding: 15px 16px 15px 19px\n}\n\n.brand-logo.first {\n    width: 73px;\n    margin-right: 14px\n}\n\n.brand-logo.second {\n    width: 77px;\n    margin-right: 21px\n}\n\n.brand-logo.third {\n    width: 80px\n}\n\n.footer-divider {\n    background-color: var(--dark-violet);\n    opacity: .12;\n    width: 100%;\n    height: 1px;\n    /* margin-bottom: 30px */\n}\n\n@media screen and (max-width:767px) {\n    .footer-divider {\n        background-color: var(--dark-violet);\n        opacity: .12;\n        width: 100%;\n        height: 1px;\n        margin-bottom: 30px\n    }\n}\n\n\n.footer-divider.socials.dark {\n    background-color: var(--white)\n}\n\n.footer-links-wrapper {\n    grid-column-gap: 50px;\n    grid-row-gap: 50px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .5fr .75fr .75fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: space-between;\n    width: 100%;\n    display: grid\n}\n\n.footer-links-column {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    display: flex\n}\n\n.footer-links-column.first {\n    max-width: 180px\n}\n\n.footer-links-column.second {\n    max-width: 106px\n}\n\n.footer-links-column.third {\n    max-width: 127px\n}\n\n.footer-links-column.fourth {\n    max-width: 148px\n}\n\n.footer-links-column.fifth {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-flow: column;\n    flex: none;\n    align-items: flex-start;\n    max-width: 240px\n}\n\n.footer-links-column.fifth.new {\n    flex-flow: wrap;\n    justify-content: center;\n    align-items: flex-start\n}\n\n.footer-link-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    color: var(--dark-violet);\n    flex: 0 auto;\n    align-items: center;\n    transition: color .3s ease-in-out;\n    display: flex\n}\n\n.footer-link-wrapper:hover {\n    color: rgb(21 128 61)\n}\n\n.footer-link-wrapper.help {\n    display: none\n}\n\n.footer-link-wrapper.dark {\n    color: #ccc\n}\n\n.footer-link-icon {\n    width: 24px;\n    height: 24px\n}\n\n.tribe-section {\n    width: 100%;\n    overflow: hidden\n}\n\n.tribe-wrapper {\n    flex-direction: column;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 20px;\n    display: flex\n}\n\n.tribe-wrapper.about {\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.tribe-tabs {\n    flex-direction: row-reverse;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.tribe-tabs-content {\n    width: 50%;\n    max-width: 696px;\n    margin-right: auto;\n    overflow: visible\n}\n\n.tribe-tabs-menu {\n    flex-direction: column;\n    width: 40%;\n    max-width: 464px;\n    display: flex\n}\n\n.tribe-tabs-menu.about {\n    width: 55%;\n    max-width: 564px\n}\n\n.tribe-tab-link {\n    background-color: rgba(255, 255, 255, 0);\n    padding: 0\n}\n\n.tribe-tab-link.w--current {\n    background-color: rgba(255, 255, 255, 0)\n}\n\n.tribe-tab-link-info-wrapper {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    width: 100%;\n    display: flex\n}\n\n.tribe-progress-bar-contain {\n    background-color: #f4dfe0;\n    border-radius: 20px;\n    flex: none;\n    width: 4px\n}\n\n.tribe-tab-content-wrapper {\n    padding-top: 2px;\n    padding-bottom: 2px\n}\n\n.tribe-tab-headings-contain {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    display: flex\n}\n\n.tribe-tab-icon-contain {\n    background-image: linear-gradient(135deg, rgba(72, 33, 53, .1), rgba(72, 33, 53, .15));\n    border-radius: 50%;\n    width: 60px;\n    height: 60px;\n    padding: 1px\n}\n\n.tribe-tab-icon-wrapper {\n    color: var(--dark-violet);\n    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.tribe-tab-icon-embed {\n    width: 36px;\n    height: 36px\n}\n\n.tribe-tab-progress-bar {\n    background-color: var(--dark-violet);\n    border-radius: 20px;\n    width: 100%;\n    height: 0%\n}\n\n.tribe-tab-image-contain {\n    width: 100%;\n    padding-top: 57px;\n    padding-bottom: 57px;\n    display: flex;\n    position: relative\n}\n\n.tribe-tab-background-gradient-contain {\n    z-index: 1;\n    background-image: linear-gradient(rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));\n    border-radius: 16px;\n    width: 60%;\n    padding: 1px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.tribe-tab-background-gradient {\n    /*background-image: linear-gradient(135deg, #fbeded, #FEC45B);*/\n    border-radius: 16px;\n    width: 100%;\n    height: 100%\n}\n\n.ctas-image-wrapper {\n    width: 42%;\n    max-width: 440px;\n    position: relative\n}\n\n.ctas-image {\n    width: 100%\n}\n\n.ctas-image.first {\n    z-index: 1;\n    position: relative\n}\n\n.ctas-image.second {\n    z-index: 2;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.ctas-image.third {\n    z-index: 3;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.ctas-image.fourth {\n    z-index: 4;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.spend-section {\n    width: 100%\n}\n\n.spend-wrapper {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 140px 40px;\n    display: flex\n}\n\n.calculator-right {\n    width: 47%\n}\n\n.calculator-right.new {\n    width: 100%\n}\n\n.calculator-wrapper {\n    text-align: center;\n    background-image: linear-gradient(90deg, rgba(8, 9, 10, .9), #08090a);\n    border-radius: 16px;\n    flex-direction: column;\n    align-items: center;\n    padding: 36px 20px;\n    display: flex\n}\n\n.calculator-heading {\n    color: var(--white);\n    width: 100%;\n    max-width: 459px;\n    margin-bottom: 80px;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 133.33%\n}\n\n.calculator {\n    width: 100%\n}\n\n.calculator-input-wrap {\n    width: 85%;\n    max-width: 503px;\n    margin-bottom: 60px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.calculator-input-embed {\n    width: 100%\n}\n\n.calculator-selector-wrap {\n    z-index: 3;\n    width: 1px;\n    height: 1px;\n    transition: all .1s;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    right: 0%;\n    transform: translateY(-50%)\n}\n\n.calculator-selector-button {\n    background-color: #f7e8c7;\n    border: 2px solid rgba(116, 47, 47, .2);\n    border-radius: 40px;\n    justify-content: space-between;\n    align-items: center;\n    width: 82px;\n    height: 32px;\n    padding: 7px;\n    display: flex;\n    position: absolute;\n    transform: translate(-50%, -50%)\n}\n\n.calculator-selector-value-wrapper {\n    color: var(--white);\n    background-color: #434241;\n    border-radius: 50px;\n    width: 120px;\n    padding: 5px 14px;\n    font-weight: 600;\n    line-height: 111.11%;\n    /* transition: all .2s cubic-bezier(.645, .045, .355, 1); */\n    /* display: block; */\n    position: absolute;\n    top: 16px;\n    left: 50%;\n    transform: translate(-50%, -210%)\n}\n\n.calculator-track {\n    z-index: 1;\n    background-color: rgba(229, 224, 216, .2);\n    border: 1px solid rgba(185, 180, 172, .4);\n    border-radius: 60px;\n    width: 100%;\n    height: 12px;\n    position: absolute;\n    top: 50%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    transform: translateY(-50%)\n}\n\n.calculator-progress-bar {\n    z-index: 2;\n    background-color: #f7e8c7;\n    border-radius: 16px;\n    width: 50%;\n    height: 12px;\n    transition: all .1s;\n    position: absolute;\n    top: 50%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    transform: translateY(-50%)\n}\n\n.calculator-selector-icons {\n    width: 16px;\n    height: 16px\n}\n\n.calculator-content {\n    grid-column-gap: 40px;\n    grid-row-gap: 20px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-end;\n    display: flex\n}\n\n.calculator-content-sub-heading {\n    color: var(--white);\n    margin-bottom: 14px;\n    font-weight: 500;\n    line-height: 133.33%\n}\n\n.calculator-content-text {\n    color: var(--white);\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 125%\n}\n\n.calculator-content-text-wrap {\n    background-color: rgba(250, 242, 235, .16);\n    border-radius: 10px;\n    padding: 10px 23px\n}\n\n.spend-block-icon-embed {\n    width: 28px;\n    height: 28px\n}\n\n.indicator-arrow {\n    opacity: .4;\n    width: 16px;\n    height: 24px\n}\n\n.spend-image {\n    width: 100%\n}\n\n.spend-image.e {\n    width: 75%;\n    max-width: 507px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.spend-image.c {\n    border-radius: 10px;\n    width: 70%;\n    max-width: 435px;\n    margin-top: -140px;\n    margin-left: auto;\n    margin-right: 0;\n    box-shadow: 0 -20px 80px rgba(0, 0, 0, .1)\n}\n\n.spend-image.d {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.spend-image.b {\n    margin-top: 22px\n}\n\n.spend-block-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    flex: none;\n    width: 100%;\n    display: flex\n}\n\n.spend-block-wrapper.c,\n.spend-block-wrapper.a {\n    justify-content: flex-end;\n    min-height: 311px\n}\n\n.spend-block-wrapper.a.new {\n    color: var(--black);\n    width: 360px;\n    display: flex;\n    position: absolute;\n    top: 150%\n}\n\n.spend-block-wrapper.a.new._1 {\n    background-color: var(--transparent);\n    display: flex;\n    bottom: auto;\n    left: auto;\n    overflow: hidden;\n    margin-top: -70px\n}\n\n.spend-block-wrapper.a.new._2 {\n    background-color: var(--transparent);\n    background-image: none;\n    display: none;\n    bottom: auto;\n    left: auto;\n    overflow: hidden;\n    margin-top: -50px\n}\n\n.spend-block-wrapper.a.new._3 {\n    box-sizing: border-box;\n    object-fit: fill;\n    flex: none;\n    justify-content: center;\n    align-items: flex-start;\n    margin-left: 0;\n    display: none;\n    position: absolute;\n    bottom: auto;\n    left: auto;\n    right: auto;\n    overflow: hidden;\n    margin-top: -30px\n}\n\n.spend-block-wrapper.b {\n    justify-content: flex-end;\n    min-height: 311px\n}\n\n.spend-sticky-wrapper {\n    width: 100%;\n    height: 60vh;\n    position: static\n}\n\n.spend-texts-blocks-wrapper {\n    flex-direction: column;\n    align-items: flex-end;\n    width: 100%;\n    display: flex;\n    position: relative\n}\n\n.spend-text-container {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    background-image: linear-gradient(135deg, #fff4dc, #f0deb5);\n    border-radius: 16px;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 100%;\n    padding: 40px;\n    display: flex\n}\n\n.sticky-indicator-text-wrapper {\n    grid-column-gap: 10px;\n    grid-row-gap: 16px;\n    flex-wrap: wrap;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.spend-image-wrapper {\n    width: 100%;\n    position: relative\n}\n\n.spend-image-wrapper.second {\n    opacity: 0;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0 0 0 16px;\n    display: flex;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.spend-image-wrapper.first {\n    opacity: 1;\n    flex-direction: column;\n    padding: 60px 65px 60px 76px;\n    display: flex\n}\n\n.spend-image-wrapper.third {\n    opacity: 0;\n    border-top-right-radius: 16px;\n    border-bottom-right-radius: 16px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0 0 0 16px;\n    display: flex;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.spend-block-icon-contain {\n    background-color: rgba(36, 2, 19, .1);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    display: flex\n}\n\n.spend-text-blocks-contain {\n    flex-direction: row;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 407px;\n    height: 311px;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.spend-images-grid {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .5fr;\n    width: 100%\n}\n\n.spend-images-gradient-border {\n    background-image: linear-gradient(135deg, rgba(6, 19, 27, .06), rgba(6, 19, 27, .04));\n    border-top-right-radius: 16px;\n    border-bottom-right-radius: 16px;\n    width: 60%;\n    max-width: 780px;\n    padding: 2px;\n    position: relative;\n    left: -16px\n}\n\n.paragraph-22px {\n    font-size: 22px;\n    line-height: 127.273%\n}\n\n.paragraph-22px.sticky-indicator-text {\n    letter-spacing: -.22px;\n    font-weight: 500\n}\n\n.spend-image-container {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/654d5326762335b932e9059c_Spend%20Bkg.svg), linear-gradient(135deg, #fdf8ec, #f9f2e1);\n    background-position: 50%, 0 0;\n    background-repeat: no-repeat, repeat;\n    background-size: cover, auto;\n    border-top-right-radius: 16px;\n    border-bottom-right-radius: 16px;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    position: relative\n}\n\n.spend-text-gradient-border {\n    z-index: 2;\n    background-image: linear-gradient(rgba(6, 19, 27, .04), rgba(6, 19, 27, .1));\n    border-radius: 16px;\n    width: 40%;\n    max-width: 500px;\n    padding: 2px;\n    display: flex;\n    position: relative\n}\n\n.spend-sticky-block {\n    justify-content: center;\n    width: 100%;\n    padding-left: 16px;\n    display: flex;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 140px\n}\n\n.heading-252 {\n    color: var(--white);\n    margin-bottom: 24px;\n    font-size: 32px;\n    font-weight: 400;\n    line-height: 109%\n}\n\n.heading-252.new {\n    color: var(--black-2);\n    font-size: 24px;\n    line-height: 1.4\n}\n\n.heading-253 {\n    text-transform: uppercase;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px\n}\n\n.heading-254 {\n    font-size: 24px;\n    line-height: 30px\n}\n\n.heading-255 {\n    color: var(--goldenrod);\n    text-transform: uppercase;\n    margin-left: 20px;\n    margin-right: 20px;\n    font-size: 18px;\n    line-height: 28px\n}\n\n.heading-255.pink {\n    color: var(--pabloo-green)\n}\n\n.heading-256 {\n    color: var(--pabloo-green);\n    font-size: 28px;\n    line-height: 28px\n}\n\n.reviews-section {\n    width: 100%;\n    overflow: hidden\n}\n\n.reviews-main-wrapper {\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch;\n    width: 100%;\n    padding-top: 60px;\n    padding-bottom: 60px;\n    display: flex\n}\n\n.reviews-main-wrapper.new {\n    padding-top: 140px\n}\n\n.reviews-slider {\n    background-color: rgba(255, 255, 255, 0);\n    width: 90%;\n    max-width: 1138px;\n    height: auto;\n    display: none;\n    position: relative\n}\n\n.reviews-slider-mask {\n    width: 100%;\n    overflow: visible\n}\n\n.review-slide-nav {\n    position: absolute;\n    top: auto;\n    bottom: -102px;\n    left: 0%;\n    right: 0%\n}\n\n.reviews-slide-wrapper {\n    justify-content: space-between;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.reviews-slide-image-contain {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 35%;\n    max-width: 358px;\n    display: flex\n}\n\n.reviews-slide-image {\n    object-fit: cover;\n    object-position: 0% 50%;\n    border-radius: 16px;\n    width: 100%;\n    height: 100%\n}\n\n.reviews-slide-text-gradient-wrapper {\n    background-image: linear-gradient(135deg, rgba(6, 19, 27, .04), rgba(6, 19, 27, .08));\n    border-radius: 26px;\n    width: 63%;\n    padding: 2px\n}\n\n.review-slide-text-wrapper {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    background-image: linear-gradient(135deg, #fff4dc, #f7e7c6);\n    border-radius: 26px;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    padding: 40px 40px 22px;\n    display: flex\n}\n\n.reviewer-block {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-top: auto;\n    display: flex\n}\n\n.reviewer-info-block {\n    grid-column-gap: 5px;\n    grid-row-gap: 5px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.review-company-logo {\n    object-fit: contain;\n    width: auto;\n    height: 36px\n}\n\n.review-company-logo._32px {\n    height: 32px\n}\n\n.review-company-logo._29px {\n    height: 29px\n}\n\n.review-company-logo._31px {\n    height: 31px\n}\n\n.review-company-logo._44px {\n    height: 44px\n}\n\n.slider-arrow {\n    color: var(--dark-violet);\n    background-color: #fff;\n    border: 1px solid rgba(36, 2, 19, .15);\n    border-radius: 8px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 40px;\n    transition: all .4s ease-in-out;\n    display: flex\n}\n\n.slider-arrow:hover {\n    background-color: var(--dark-violet);\n    color: var(--white)\n}\n\n.slider-arrow.right {\n    top: auto;\n    bottom: -101px;\n    left: auto;\n    right: 30%\n}\n\n.slider-arrow.right.events {\n    top: -101px;\n    bottom: auto;\n    right: 0\n}\n\n.slider-arrow.right.events:hover {\n    background-color: var(--pabloo-green-2)\n}\n\n.slider-arrow.left {\n    top: auto;\n    bottom: -101px;\n    left: 30%;\n    right: auto\n}\n\n.slider-arrow.left.events {\n    justify-content: flex-start;\n    align-items: center;\n    top: -101px;\n    bottom: auto;\n    left: auto;\n    right: 80px\n}\n\n.slider-arrow.left.events:hover {\n    background-color: var(--pabloo-green-2)\n}\n\n.review-slide-arrow-icon-embed {\n    width: 12px;\n    height: 40px;\n    position: relative\n}\n\n.review-slide-arrow-icon-embed.right {\n    top: 2px;\n    transform: rotate(180deg)\n}\n\n.home-hero-heading-contain {\n    flex-direction: column\n}\n\n.logos-white-gradient {\n    z-index: 2;\n    background-image: linear-gradient(90deg, #fff, rgba(255, 255, 255, 0));\n    width: 200px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.logos-white-gradient.right {\n    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff);\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.logos-white-gradient.right.new {\n    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), var(--soft-pink))\n}\n\n.logos-white-gradient.new {\n    background-image: linear-gradient(90deg, var(--soft-pink), rgba(255, 255, 255, 0))\n}\n\n.reviews-slide {\n    width: 100%;\n    height: 100%;\n    margin-right: 60px\n}\n\n.calculator-tabs-menu {\n    display: none\n}\n\n.calculator-toggle-buttons-contain {\n    background-color: var(--white);\n    border-radius: 10px;\n    flex: none;\n    padding: 6px;\n    position: relative\n}\n\n.calculator-toggle-button-wrapper {\n    z-index: 2;\n    border-radius: 10px;\n    padding: 13px 26px;\n    position: relative\n}\n\n.calculator-toggle-button-wrapper.saas {\n    color: var(--white)\n}\n\n.calculator-toggle-background-div {\n    z-index: 1;\n    background-color: var(--dark-violet);\n    border-radius: 10px;\n    width: 46%;\n    position: absolute;\n    top: 6px;\n    bottom: 6px;\n    left: 6px;\n    right: auto\n}\n\n.calculator-left-flex-wrap {\n    grid-column-gap: 70px;\n    grid-row-gap: 70px;\n    justify-content: space-between;\n    align-items: center;\n    display: flex;\n    position: relative\n}\n\n.flip-heading-contain {\n    z-index: 1;\n    flex-direction: column;\n    display: flex;\n    position: relative\n}\n\n.hamburger-wrapper {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.burger-line {\n    background-color: var(--dark-violet);\n    border-radius: 2px;\n    width: 18px;\n    height: 2px;\n    margin-top: 2px;\n    margin-bottom: 2px\n}\n\n.stack-block-heading-contain {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    align-items: center;\n    display: flex\n}\n\n.hero-bottom-heading-contain {\n    display: flex\n}\n\n.hero-wrapper-contain {\n    width: 100%;\n    max-width: 1440px;\n    margin-bottom: 0;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.hero-wrapper-contain.apps-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/657aa3e5262099fe2d4a28c8_Background.svg);\n    background-position: 50%;\n    background-repeat: no-repeat;\n    background-size: cover\n}\n\n.hero-bkg {\n    z-index: 1;\n    object-fit: fill;\n    object-position: 50% 0%;\n    background-color: rgba(255, 255, 255, 0);\n    width: 100%;\n    height: 85%;\n    max-height: 700px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.hero-bkg.blog {\n    height: 100%;\n    max-height: none\n}\n\n.hero-bkg.blog-cms {\n    max-height: 540px\n}\n\n.hero-bkg.hub {\n    max-height: 621px\n}\n\n.hero-bkg.saas {\n    max-height: 769px;\n    bottom: 10%\n}\n\n.hero-bkg.cloud {\n    height: 90%;\n    max-height: 561px\n}\n\n.home-hero-images-container {\n    width: 50%;\n    max-width: 700px;\n    margin-right: -10%;\n    position: relative\n}\n\n.hero-workflow-image {\n    width: 100%\n}\n\n.hero-before-images-contain {\n    width: 48%;\n    max-width: 320px;\n    position: absolute;\n    top: 13%;\n    bottom: auto;\n    left: auto;\n    right: 10%\n}\n\n.before-hero-image-sales {\n    width: 100%\n}\n\n.before-hero-image-zapier,\n.before-hero-image-snow {\n    width: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.hero-after-images-contain {\n    width: 48%;\n    max-width: 320px;\n    position: absolute;\n    top: auto;\n    bottom: -3%;\n    left: auto;\n    right: 10%\n}\n\n.hero-person-images-contain {\n    width: 38%;\n    max-width: 280px;\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: 0%;\n    right: auto\n}\n\n.hero-person-image-sales {\n    width: 100%\n}\n\n.hero-person-image-mail,\n.hero-person-image-jira {\n    width: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.hero-bubbles-block-wrapper {\n    width: 100%;\n    max-width: 160px;\n    display: flex;\n    position: absolute;\n    top: auto;\n    bottom: 5%;\n    left: 8%;\n    right: auto;\n    overflow: hidden\n}\n\n.hero-bubbles-block {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex: none;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.hero-bubbles-block-contain {\n    flex-direction: column;\n    flex: none;\n    width: 960px;\n    display: flex;\n    overflow: hidden\n}\n\n.hero-bubble-image {\n    width: 100%;\n    max-width: 60px;\n    height: 60px\n}\n\n.after-hero-image-sales {\n    width: 100%\n}\n\n.after-hero-image-zapier,\n.after-hero-image-snow {\n    width: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.div-block-729 {\n    margin-top: 20px\n}\n\n.text-block-304 {\n    opacity: .5;\n    color: var(--white-smoke);\n    text-align: left;\n    font-size: 14px;\n    line-height: 22px\n}\n\n.calc-anchor {\n    position: absolute;\n    top: -91px;\n    bottom: auto;\n    left: 0%;\n    right: auto\n}\n\n.navigation-background-div {\n    z-index: 1;\n    opacity: 0;\n    background-color: #fff;\n    border-radius: 12px;\n    width: 94%;\n    max-width: 1312px;\n    margin: 10px auto;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)\n}\n\n.navigation-background-div.dark {\n    background-color: #18020d\n}\n\n.navigation-links-grid {\n    grid-column-gap: 32px;\n    grid-row-gap: 0px;\n    object-fit: fill;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n    display: flex\n}\n\n.navigation-links-grid.solutions {\n    flex-direction: column\n}\n\n.navigation-links-grid.resources {\n    grid-column-gap: 12px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .75fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.navigation-links-column {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-direction: column;\n    grid-template-rows: auto 1fr;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-items: flex-start;\n    display: flex\n}\n\n.navigation-header-link-contain {\n    align-items: center;\n    display: flex\n}\n\n.navigation-header-link {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    color: var(--dark-violet);\n    align-items: center;\n    transition: color .3s ease-in-out;\n    display: flex\n}\n\n.navigation-header-link:hover {\n    color: var(--pabloo-green)\n}\n\n.dropdown-link-arrow-embed {\n    color: var(--pabloo-green);\n    width: 16px;\n    height: 16px\n}\n\n.navbar-dropdown-text {\n    font-weight: 500\n}\n\n.dropdown-links-container-column {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.dropdown-links-container-column.solutions,\n.dropdown-links-container-column.resources {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px\n}\n\n.dropdown-highlight-span {\n    color: var(--pabloo-green);\n    background-color: rgba(245, 205, 225, .3);\n    border-radius: 12px;\n    margin-left: 2px;\n    padding: 4px 10px;\n    font-weight: 500\n}\n\n.navigation-block-link {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    color: var(--dark-violet);\n    border-radius: 8px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 100%;\n    text-decoration: none;\n    transition: all .3s;\n    display: flex\n}\n\n.navigation-block-link:hover {\n    color: var(--pabloo-green)\n}\n\n.paragraph-14px {\n    color: var(--dark-violet);\n    font-size: 14px;\n    line-height: 142.857%\n}\n\n.paragraph-14px.navigation-block-link-description._4px-bottom-margin {\n    margin-bottom: 4px\n}\n\n.dropdown-resources-column {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    width: 100%;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    padding-left: 12px;\n    display: flex\n}\n\n.resource-dropdown-wrapper {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    border-radius: 10px;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    transition: color .3s ease-in-out;\n    display: flex\n}\n\n.resource-dropdown-wrapper:hover {\n    color: var(--pabloo-green)\n}\n\n.resource-dropdown-image-contain {\n    background-color: rgba(213, 57, 135, .1);\n    border-radius: 10px;\n    width: 100%;\n    height: 227px;\n    padding: 27px 37px;\n    display: flex\n}\n\n.resource-dropdown-image {\n    object-fit: cover;\n    border-radius: 13px;\n    width: 100%\n}\n\n.resource-dropdown-info-block {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    display: flex\n}\n\n.integrations-lottie {\n    width: 100%\n}\n\n.integrations-lottie.integra {\n    text-align: left;\n    object-fit: contain;\n    flex: 0 auto;\n    width: 100%\n}\n\n.spend-anchor.first {\n    position: absolute;\n    top: 0%;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.spend-anchor.second {\n    position: absolute;\n    top: 40%;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.spend-anchor.third {\n    position: absolute;\n    top: 70%;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.linear-bkg-menu-button {\n    color: #000;\n    background-image: linear-gradient(rgba(121, 121, 122, .08), rgba(121, 121, 122, .2));\n    border-radius: 100px;\n    padding: 2px;\n    font-weight: 600;\n    line-height: 150%;\n    text-decoration: none;\n    display: none\n}\n\n.dropdown-links-divider {\n    display: none\n}\n\n.navigation-inner-wrapper {\n    margin-right: auto;\n    position: static\n}\n\n.navigation-inner-wrapper.white.new {\n    margin-right: 0\n}\n\n.tribe-image-wrapper {\n    z-index: 2;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    display: flex;\n    position: relative;\n    left: 4%\n}\n\n.tribe-tab-lottie {\n    z-index: 2;\n    border-radius: 12px;\n    width: 100%;\n    position: relative\n}\n\n.tribe-tab-lottie-shadow {\n    z-index: 1;\n    border-radius: 12px;\n    width: 100%;\n    height: 98%;\n    margin: auto;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    box-shadow: 0 19px 74px rgba(0, 0, 0, .08)\n}\n\n.hero-platform-wrapper {\n    z-index: 2;\n    width: 90%;\n    max-width: 1280px;\n    min-height: 200px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 160px 8% 42px;\n    position: relative\n}\n\n.hero-platform-wrapper.padding-bottom-md {\n    padding-bottom: 80px\n}\n\n.hero-platform-wrapper.integra {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-flow: row;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: flex-end;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 2%;\n    padding-right: 2%;\n    display: flex\n}\n\n.hero-platform-heading-wrapper {\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-top: 0;\n    display: block\n}\n\n.hero-platform-heading-wrapper.display-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    display: flex\n}\n\n.hero-platform-heading-wrapper.display-flex.include-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/654b723207dd65fd8b2c88f0_Group%202087326002.svg);\n    background-position: 58% 40%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    max-width: 900px;\n    margin-top: 32px\n}\n\n.text-span-226 {\n    color: var(--pabloo-green-2)\n}\n\n.hero-platform-subheading {\n    margin-top: 48px\n}\n\n.hero-platform-subheading-text {\n    text-align: center;\n    flex-flow: row;\n    justify-content: flex-start;\n    align-items: center;\n    font-family: Satoshi, sans-serif;\n    font-size: 20px;\n    font-weight: 500;\n    display: block\n}\n.hero-platform-subheading-text-case {\n    flex-flow: row;\n    justify-content: flex-start;\n    align-items: center;\n    font-family: Satoshi, sans-serif;\n    font-size: 20px;\n    font-weight: 500;\n    display: block;\n    margin-bottom: 10px;\n}\n\n.hero-platform-subheading-text.integra.new {\n    text-align: left\n}\n\n.hero-platform-cta-wrapper {\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: flex-start;\n    margin-top: 48px;\n    display: flex\n}\n\n.hero-platform-cta-wrapper.integra.new {\n    justify-content: flex-start;\n    align-items: center\n}\n\n.hero-button-cta {\n    text-align: center;\n    background-color: #c73a88;\n    border-radius: 10px;\n    padding: 16px 32px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500\n}\n\n.div-block-731 {\n    text-align: left;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin-top: 16px;\n    display: flex\n}\n\n.text-block-305 {\n    flex: 1;\n    justify-content: center;\n    align-items: flex-start;\n    font-family: Satoshi, sans-serif;\n    display: flex\n}\n\n.hero-platform-image {\n    object-fit: fill;\n    flex-direction: row;\n    justify-content: center;\n    align-items: stretch;\n    margin-top: 40px;\n    display: flex;\n    position: relative\n}\n\n.hero-platform-image.integra {\n    justify-content: flex-end;\n    align-items: stretch;\n    width: 100%;\n    margin-top: 0\n}\n\n.hero-spotlight-image {\n    z-index: 0;\n    border-radius: 16px;\n    width: 72%;\n    margin-bottom: 0;\n    margin-left: auto;\n    margin-right: auto;\n    position: static;\n    box-shadow: 0 8px 40px rgba(0, 0, 0, .1)\n}\n\n.hero-spotlight-image.border-radius-reset {\n    border-radius: 0 0 8px 8px\n}\n\n.hero-spotlight-image.border-radius-reset.no-shadow {\n    box-shadow: none;\n    width: 90%\n}\n\n.blogs-hero-wrapper {\n    z-index: 2;\n    color: var(--darker-violet);\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 190px;\n    padding-bottom: 400px;\n    display: flex;\n    position: relative\n}\n\n.blogs-hero-wrapper.cms {\n    flex-direction: row;\n    justify-content: space-between;\n    padding-top: 160px;\n    padding-bottom: 80px\n}\n\n.blogs-hero-header {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 938px;\n    display: flex\n}\n\n.subscription-form {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    justify-content: center;\n    display: flex\n}\n\n.subscription-form-block {\n    width: 100%;\n    max-width: 643px;\n    margin-bottom: 0\n}\n\n.form-email-text-field {\n    color: var(--darker-violet);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6539910146c0d6a12aef43e7_Form%20Email.svg);\n    background-position: 5%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    border: 1px #000;\n    border-radius: 10px;\n    width: 64.9%;\n    max-width: 420px;\n    height: auto;\n    margin-bottom: 0;\n    padding: 18px 20px 18px 60px;\n    font-size: 18px;\n    line-height: 156%\n}\n\n.form-email-text-field::placeholder {\n    color: rgba(32, 0, 16, .5)\n}\n\n.form-email-text-field._100 {\n    width: 100%\n}\n\n.form-email-text-field.resource-hero {\n    width: 55.7%;\n    max-width: 320px\n}\n\n.absolute-submit-button {\n    z-index: 4;\n    background-color: rgba(255, 255, 255, 0);\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.success-state {\n    background-color: var(--white);\n    color: var(--pabloo-green);\n    border-radius: 4px;\n    font-weight: 600\n}\n\n.error-state {\n    background-color: #f3adad;\n    border-radius: 4px;\n    font-weight: 600\n}\n\n.featured-block-contain {\n    z-index: 2;\n    width: 90%;\n    max-width: 1300px;\n    margin-top: -320px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.featured-block-contain.resources {\n    width: 45%;\n    max-width: 520px;\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 0\n}\n\n.blogs-tabs-section {\n    width: 100%\n}\n\n.blog-tabs-wrapper {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 60px;\n    padding-bottom: 50px\n}\n\n.blogs-tab-link {\n    color: var(--dark-violet);\n    background-color: rgba(255, 255, 255, 0);\n    width: 100%;\n    min-width: 165px;\n    max-width: 165px;\n    padding: 0;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 140%\n}\n\n.blogs-tab-link.w--current {\n    background-color: rgba(255, 255, 255, 0)\n}\n\n.blog-tabs-info-wrapper {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.ctas-form-wrapper {\n    background-image: linear-gradient(135deg, #fbeded, #e5c4c5);\n    border-radius: 20px;\n    width: 100%;\n    max-width: 560px;\n    padding: 40px\n}\n\n.cta-form-block {\n    flex-direction: column;\n    justify-content: center;\n    min-height: 518px;\n    margin-bottom: 0;\n    display: flex\n}\n\n.cta-form-block.hide {\n    display: none\n}\n\n.form-fields-contain {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.form-field-label {\n    margin-bottom: 0\n}\n\n.white-form-field {\n    background-color: var(--white);\n    border: 1px solid rgba(36, 2, 19, .14);\n    border-radius: 10px;\n    height: auto;\n    margin-bottom: 0;\n    padding: 12px 20px;\n    font-size: 20px;\n    line-height: 120%\n}\n\n.white-form-field:focus {\n    border-color: rgba(36, 2, 19, .24)\n}\n\n.ctas-form {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    display: flex\n}\n\n.ctas-form._16px-gap {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px\n}\n\n.form-fields-grid {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    grid-template-rows: auto;\n    width: 100%\n}\n\n.form-select-field {\n    background-color: var(--white);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6539dba54436eb9715b8bff9_Select%20Field%20Arrow.svg);\n    background-position: 94%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    border: 1px solid rgba(36, 2, 19, .14);\n    border-radius: 10px;\n    height: auto;\n    margin-bottom: 0;\n    padding: 12px 20px;\n    font-size: 20px;\n    line-height: 120%\n}\n\n.form-select-field:focus {\n    border-color: rgba(36, 2, 19, .24)\n}\n\n.ctas-form-gradient-wrapper {\n    background-image: linear-gradient(135deg, rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));\n    border-radius: 20px;\n    width: 45%;\n    max-width: 560px;\n    padding: 1px\n}\n\n.div-block-732 {\n    background-color: #fff;\n    width: 100%;\n    height: 180px;\n    margin-top: -227px;\n    padding-top: 0\n}\n\n.features-section {\n    padding-top: 56px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.blogs-hero-section {\n    background-color: var(--soft-pink);\n    overflow: hidden\n}\n\n.old-sections {\n    display: none\n}\n\n.blog-category-text-contain {\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    color: var(--pabloo-green);\n    letter-spacing: 1.2px;\n    background-color: rgba(213, 57, 135, .12);\n    border-radius: 16px;\n    align-items: center;\n    padding: 6px 12px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 125%;\n    display: flex\n}\n\n.blog-category-text-contain.date {\n    color: #5b002c;\n    background-color: rgba(213, 57, 135, 0)\n}\n\n.blog-category-icon {\n    width: 20px;\n    height: 21px\n}\n\n.blog-tags-contain {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    display: flex\n}\n\n.blog-info-section {\n    width: 100%\n}\n\n.blog-cms-info-wrapper {\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 90%;\n    max-width: 1240px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-bottom: 140px;\n    display: flex\n}\n\n.blog-cms-left-contain {\n    width: 60%;\n    max-width: 760px\n}\n\n.block-rich-text {\n    width: 100%\n}\n\n.block-rich-text h1 {\n    margin-bottom: 28px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 800;\n    line-height: 112.5%\n}\n\n.block-rich-text h2 {\n    margin-bottom: 28px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 56px;\n    font-weight: 800;\n    line-height: 118.51%\n}\n\n.block-rich-text h3 {\n    margin-top: 0;\n    margin-bottom: 28px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 48px;\n    font-weight: 800;\n    line-height: 116.66%\n}\n\n.block-rich-text h4 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 40px;\n    font-weight: 800;\n    line-height: 120%\n}\n\n.block-rich-text h5 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 32px;\n    font-weight: 800;\n    line-height: 118.75%\n}\n\n.block-rich-text h6 {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 128.57%\n}\n\n.block-rich-text p,\n.block-rich-text ul,\n.block-rich-text ol {\n    margin-bottom: 30px;\n    line-height: 156%\n}\n\n.block-rich-text li {\n    margin-bottom: 8px\n}\n\n.block-rich-text blockquote {\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b0274f5f5c39f63cee643_RT%20Quote.svg);\n    background-position: 40px 40px;\n    background-repeat: no-repeat;\n    background-size: 48px 40px;\n    border-left-style: none;\n    border-radius: 12px;\n    margin-bottom: 30px;\n    padding: 108px 40px 40px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 32px;\n    font-weight: 800;\n    line-height: 125%\n}\n\n.block-rich-text figure {\n    margin-bottom: 28px\n}\n\n.block-rich-text figcaption {\n    opacity: .8;\n    margin-top: 16px;\n    font-weight: 500;\n    line-height: 100%\n}\n\n.block-rich-text a {\n    color: var(--pabloo-green);\n    /* text-decoration: none; */\n    transition: color .3s ease-in-out\n}\n\n.block-rich-text a:hover {\n    color: var(--dark-violet)\n}\n\n.block-rich-text strong {\n    font-weight: 800\n}\n\n.features-wrapper {\n    width: 90%;\n    max-width: 1280px;\n    margin-top: 83px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.feature-wrap {\n    grid-column-gap: 72px;\n    grid-row-gap: 72px;\n    flex-wrap: wrap;\n    align-content: stretch;\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.feature-image-wrapper {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 55%;\n    padding-top: 40px;\n    padding-left: 40px\n}\n\n.feature-image-wrapper.right {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    background-position: 100%;\n    padding-top: 40px;\n    padding-left: 0;\n    padding-right: 40px\n}\n\n.feature-image-wrapper.right.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    justify-content: flex-end;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.feature-image-wrapper.right.green-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);\n    flex: 1;\n    width: 50%;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper.right.green-bg.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper.right.yellow-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    padding-bottom: 1px;\n    padding-right: 38px\n}\n\n.feature-image-wrapper.right.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-right: 0\n}\n\n.feature-image-wrapper.right.green-bg-copy {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    width: 50%;\n    min-height: auto;\n    padding-top: 3px;\n    padding-bottom: 32px;\n    padding-right: 0\n}\n\n.feature-image-wrapper.right.green-bg-copy.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper.left {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)\n}\n\n.feature-image-wrapper.left.green-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    flex-direction: column;\n    flex: 1;\n    justify-content: flex-end;\n    align-items: flex-start;\n    height: 500px;\n    padding-top: 6px;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.feature-image-wrapper.left.green-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper.left.yellow-bg {\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex-direction: column;\n    flex: 1;\n    justify-content: flex-start;\n    align-items: center;\n    height: 550px;\n    padding-bottom: 32px;\n    display: flex\n}\n\n.feature-image-wrapper.left.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper.left.yellow-bg.padding-left-reset {\n    padding-left: 0\n}\n\n.feature-image-wrapper.left.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    flex-direction: column;\n    flex: 1;\n    justify-content: center;\n    align-self: center;\n    align-items: flex-start;\n    height: 500px;\n    padding-top: 2px;\n    padding-bottom: 32px;\n    display: flex\n}\n\n.feature-image-wrapper.left.pink-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-content-wrap {\n    width: 36.7%\n}\n\n.feature-content-header {\n    color: var(--dark-violet)\n}\n\n.feature-content-heading-wrapper {\n    margin-top: 24px\n}\n\n.feature-content-heading-text {\n    color: var(--black-2);\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 32px;\n    line-height: 1.4em\n}\n\n.feature-content-body {\n    margin-top: 36px\n}\n\n.feature-content-body-text {\n    font-family: Satoshi, sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 1.6em\n}\n\n.verical-seperator---100 {\n    height: 100px\n}\n\n.text-span-227,\n.text-span-228,\n.text-span-229,\n.text-span-230,\n.text-span-231 {\n    color: var(--pabloo-green-2)\n}\n\n.hero-design-element {\n    position: absolute;\n    top: 68%;\n    bottom: auto\n}\n\n.hero-design-element.right {\n    top: 32%;\n    right: 0\n}\n\n.hero-design-element.left {\n    top: auto;\n    bottom: 0%;\n    left: 0\n}\n\n.hero-design-element.center {\n    top: 2%;\n    left: -10%\n}\n\n.text-span-232,\n.text-span-233,\n.text-span-234,\n.text-span-235 {\n    color: var(--pabloo-green-2)\n}\n\n.blog-cms-sticky-contain {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    width: 35%;\n    max-width: 400px;\n    display: flex;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 120px\n}\n\n.subscribe-form-gradient-wrapper {\n    background-image: linear-gradient(135deg, rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));\n    border-radius: 20px;\n    width: 100%;\n    padding: 1px\n}\n\n.subscribe-form-main-wrapper {\n    background-color: #faf2eb;\n    border-radius: 20px;\n    width: 100%;\n    padding: 40px\n}\n\n.blog-sticky-icon-contain {\n    background-image: linear-gradient(135deg, #f8e7e8, #e8cacb);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 80px;\n    height: 80px;\n    display: flex\n}\n\n.html-embed-30 {\n    width: 44px;\n    height: 44px\n}\n\n.author-block {\n    grid-column-gap: 60px;\n    grid-row-gap: 40px;\n    border-top: 1px solid rgba(18, 0, 9, .12);\n    flex-wrap: wrap;\n    width: 100%;\n    margin-top: 20px;\n    padding-top: 30px;\n    display: flex\n}\n\n.author-container {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    align-items: center;\n    display: flex\n}\n\n.author-headings-contain {\n    grid-column-gap: 1px;\n    grid-row-gap: 1px;\n    flex-direction: column;\n    display: flex\n}\n\n.author-image {\n    border-radius: 50%;\n    width: 60px;\n    height: 60px\n}\n\n.related-blogs-section {\n    width: 100%\n}\n\n.related-blogs-wrapper {\n    grid-column-gap: 58px;\n    grid-row-gap: 58px;\n    flex-direction: column;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.related-header {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.fs-cc-prefs3_overlay {\n    z-index: -1;\n    background-color: rgba(0, 0, 0, .8);\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.fs-cc-prefs3_header {\n    background-color: #2730d4;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 2rem;\n    display: flex\n}\n\n.fs-cc-manager3_text {\n    opacity: .84;\n    color: var(--slate-blue);\n    margin-left: .625rem;\n    font-size: 16px;\n    font-weight: 700;\n    display: inline-block\n}\n\n.fs-cc-banner3_component {\n    z-index: 998;\n    background-color: #fff;\n    border-radius: 1rem;\n    margin: 2rem;\n    padding: 1.6rem 2rem;\n    display: none;\n    position: fixed;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: auto;\n    box-shadow: 7px 7px 12px rgba(0, 0, 0, .1)\n}\n\n.fs-cc-banner3_text {\n    color: var(--pabloo-green);\n    font-size: 1.2rem;\n    font-weight: 400\n}\n\n.fs-cc-prefs3_button {\n    color: #fff;\n    text-align: center;\n    background-color: #129657;\n    border: 2px solid #129657;\n    border-radius: 999rem;\n    padding: .875rem 2rem;\n    font-size: 1rem\n}\n\n.fs-cc-prefs3_button.fs-cc-button-alt {\n    color: #7e7e7e;\n    background-color: #fff;\n    border-color: #a8a8a8;\n    margin-right: .75rem\n}\n\n.fs-cc-prefs3_submit {\n    color: #fff;\n    text-align: center;\n    background-color: #4b53eb;\n    border-radius: 999rem;\n    margin-left: .75rem;\n    padding: .875rem 2rem;\n    font-size: 1rem\n}\n\n.fs-cc-prefs3_checkbox-field {\n    align-items: center;\n    margin-bottom: 0;\n    display: flex\n}\n\n.fs-cc-prefs3_label {\n    color: #4b53eb;\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1.4\n}\n\n.fs-cc-banner3_paragraph {\n    color: #000;\n    margin-top: .75rem;\n    margin-bottom: 0;\n    font-size: 16px\n}\n\n.fs-cc-prefs3_checkbox {\n    border-radius: 999rem;\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0;\n    margin-right: .75rem\n}\n\n.fs-cc-prefs3_checkbox.w--redirected-checked {\n    background-color: #129657;\n    background-size: 16px;\n    border-color: #129657\n}\n\n.fs-cc-prefs3_checkbox.w--redirected-focus {\n    box-shadow: 0 0 3px 1px #129657\n}\n\n.fs-cc-prefs3_content {\n    padding: 2rem\n}\n\n.fs-cc-prefs3_close {\n    background-color: #fff;\n    border-radius: 999rem;\n    padding: .75rem;\n    position: absolute;\n    top: 2rem;\n    bottom: auto;\n    left: auto;\n    right: 2rem\n}\n\n.fs-cc-prefs3_checkbox-label {\n    display: none\n}\n\n.set-all-components-to-display-none-and-use-this-div-to-create-a-symbol {\n    display: block\n}\n\n.fs-cc-prefs3_icon {\n    color: #fff;\n    width: 2rem;\n    height: 2rem;\n    margin-right: .75rem\n}\n\n.fs-cc-prefs3_component {\n    z-index: 1040;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh;\n    padding: 2rem;\n    display: none;\n    position: fixed\n}\n\n.fs-cc-banner3_button-icon {\n    width: 1rem;\n    margin-right: .625rem\n}\n\n.fs-cc-manager3_icon {\n    color: #4b53eb;\n    width: 1rem;\n    height: 1.5rem;\n    display: inline-block\n}\n\n.fs-cc-banner3_button {\n    color: #fff;\n    background-color: #129657;\n    border-radius: 12px;\n    padding: .875rem 2rem;\n    font-size: 1.125rem;\n    text-decoration: none\n}\n\n.fs-cc-banner3_button.fs-cc-button-alt {\n    background-color: #df6966;\n    border-radius: 12px;\n    margin-right: .75rem\n}\n\n.fs-cc-prefs3_form {\n    position: relative\n}\n\n.fs-cc-prefs3_title {\n    color: #fff;\n    font-size: 1.5rem;\n    line-height: 1.3\n}\n\n.fs-cc-banner3_block {\n    margin-right: 2rem\n}\n\n.fs-cc-prefs3_buttons-wrapper {\n    background-color: #f2f3ff;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: stretch;\n    padding: 1.5rem 2rem;\n    display: flex\n}\n\n.fs-cc-prefs3_toggle-wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.fs-cc-prefs3_line {\n    background-color: #e9e9e9;\n    flex: 1;\n    height: 1px;\n    margin-left: 1.5rem;\n    margin-right: 1.5rem\n}\n\n.fs-cc-banner3_text-link {\n    color: #4b53eb;\n    border-bottom: 2px solid #4b53eb;\n    font-weight: 400;\n    text-decoration: none\n}\n\n.fs-cc-manager3_component {\n    z-index: 999;\n    background-color: #fff;\n    border-radius: 999rem;\n    align-items: center;\n    display: none;\n    position: fixed;\n    top: auto;\n    bottom: 2rem;\n    left: 2rem;\n    right: auto;\n    box-shadow: 7px 7px 12px rgba(0, 0, 0, .1)\n}\n\n.fs-cc-banner3_container {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.fs-cc-banner3_buttons-wrapper {\n    flex: none\n}\n\n.fs-cc-preferences3_close-icon {\n    color: #4b53eb;\n    width: 1.5rem;\n    height: 1.5rem\n}\n\n.fs-cc-prefs3_form-wrapper {\n    background-color: #fff;\n    border-radius: .75rem;\n    max-width: 45rem;\n    margin-bottom: 0;\n    overflow: hidden\n}\n\n.fs-cc-manager3-link {\n    justify-content: center;\n    align-items: center;\n    padding: .5rem 1rem;\n    text-decoration: none;\n    display: flex\n}\n\n.fs-cc-prefs3_option {\n    padding-top: .75rem;\n    padding-bottom: .75rem\n}\n\n.fs-cc-banner3_button-text {\n    display: inline-block\n}\n\n.resources-hero-section {\n    background-color: #18020d;\n    overflow: hidden\n}\n\n.navigation-bar-dark {\n    z-index: 1000;\n    background-color: var(--transparent);\n    position: fixed;\n    top: auto;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.navbar-dropdown-toggle-white {\n    grid-column-gap: 8px;\n    color: var(--white);\n    align-items: center;\n    padding: 20px 0;\n    display: flex;\n    position: static\n}\n\n.transparent-arrow-button-white {\n    color: var(--white);\n    letter-spacing: -.16px;\n    border: 2px solid rgba(255, 255, 255, .4);\n    border-radius: 10px;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 32px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 122.222%;\n    text-decoration: none;\n    display: flex;\n    position: relative;\n    overflow: hidden\n}\n\n.transparent-arrow-button-white._16px {\n    padding: 18px 24px;\n    font-size: 16px;\n    line-height: 118.75%\n}\n\n.transparent-arrow-button-white._16px.navigation {\n    padding-left: 14px;\n    padding-right: 14px\n}\n\n.resources-hero-wrapper {\n    z-index: 2;\n    color: var(--darker-violet);\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 160px;\n    padding-bottom: 60px;\n    display: flex;\n    position: relative\n}\n\n.resource-left-header {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: column;\n    align-items: center;\n    width: 50%;\n    max-width: 547px;\n    display: flex\n}\n\n.resource-hero-span {\n    color: #f7e8c7\n}\n\n.resource-tabs-section {\n    width: 100%\n}\n\n.resource-tabs-wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 120px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.resource-tab-info-wrapper {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: column;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    width: 78.2813%;\n    max-width: 1002px\n}\n\n.resource-tab-flex-wrapper {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    flex-direction: column;\n    width: 100%;\n    display: block\n}\n\n.resource-tab-header {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 32px;\n    display: flex\n}\n\n.resource-tab-heading-contain {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    align-items: center;\n    display: flex\n}\n\n.resource-tab-icon-embed {\n    color: var(--pabloo-green);\n    width: 36px;\n    height: 36px\n}\n\n.resource-collection-contain {\n    width: 100%;\n    padding-bottom: 40px;\n    overflow: hidden\n}\n\n.resource-collection-list-wrapper {\n    width: 100%\n}\n\n.resource-collection-list {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    display: grid\n}\n\n.resource-collection-item {\n    width: 100%\n}\n\n.resource-post-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.resource-post-image-wrapper {\n    border: 2px solid var(--soft-pink);\n    border-radius: 14px;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    height: 260px;\n    display: flex;\n    overflow: hidden\n}\n\n.resource-post-image {\n    object-fit: cover;\n    object-position: 50% 50%;\n    width: 100%;\n    height: 100%\n}\n\n.resource-post-image.ebook {\n    object-position: 10% 50%;\n    display: inline-block\n}\n\n.resource-post-image.events {\n    object-position: 0% 50%\n}\n\n.resource-collection-divider {\n    opacity: .25;\n    background-color: #0e1328;\n    width: 100%;\n    height: 1px;\n    margin-top: 40px\n}\n\n.text-span-236,\n.text-span-237,\n.text-span-238 {\n    color: var(--pabloo-green-2)\n}\n\n.section-67 {\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.container {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.container.product {\n    max-width: 940px\n}\n\n.div-block-733 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    padding-left: 4%;\n    padding-right: 4%;\n    display: grid\n}\n\n.div-block-734 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-306 {\n    font-size: 40px;\n    font-weight: 600;\n    line-height: 1.2em\n}\n\n.paragraph-145 {\n    margin-top: 16px;\n    font-family: Satoshi, sans-serif;\n    font-size: 20px;\n    font-weight: 400\n}\n\n.text-span-239,\n.text-span-240,\n.text-span-241,\n.text-span-242,\n.text-span-243,\n.text-span-244,\n.text-span-245 {\n    color: var(--pabloo-green-2)\n}\n\n.image-221 {\n    border-bottom-right-radius: 10px;\n    border-bottom-left-radius: 10px;\n    box-shadow: -4px 2px 24px rgba(0, 0, 0, .12)\n}\n\n.text-span-246 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-735 {\n    width: 60%\n}\n\n.div-block-736 {\n    justify-content: center;\n    width: 57%;\n    display: flex\n}\n\n.text-span-247 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-737 {\n    background-color: #faf2eb;\n    height: 100%;\n    min-height: 100%;\n    padding-top: 180px;\n    padding-bottom: 100px;\n    /* margin-bottom: 200px */\n}\n\n.div-block-738 {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.demo-sub-heading {\n    width: 90%;\n    margin-top: 32px;\n}\n\n@media (max-width: 768px) {\n    .demo-sub-heading {\n        width: 100%;\n        margin-top: 32px;\n    }\n}\n\n.div-block-740 {\n    margin-top: 35px;\n    display: flex\n\n}\n\n.demo-pointer-icon {\n    width: 32px;\n    height: 32px\n}\n\n.demo-pointer-wrapper {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    align-items: center\n}\n\n.div-block-741 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-741.social {\n    grid-template-columns: 1fr\n}\n\n.div-block-742 {\n    z-index: 1;\n    background-color: #fff;\n    border-radius: 4px;\n    padding: 24px;\n    position: relative;\n    box-shadow: -3px 3px 8px rgba(0, 0, 0, .12)\n}\n\n.demo-g2-badges-holder {\n    margin-top: 32px\n}\n\n.column-79 {\n    padding-left: 0%;\n    padding-right: 6%\n}\n\n.demo-form-wrapper {\n    margin-top: 0;\n    padding-left: 6%;\n    padding-right: 10%;\n    position: relative\n}\n\n.demo-form-wrapper.social {\n    flex: 1;\n    padding-left: 0%\n}\n\n.book-demo-form-graphic-1 {\n    z-index: 0;\n    aspect-ratio: auto;\n    max-width: none;\n    height: 640px;\n    min-height: auto;\n    position: absolute;\n    top: -68px;\n    bottom: auto;\n    left: -40%;\n    right: auto\n}\n\n.book-demo-form-graphic-1.social {\n    left: 0%\n}\n\n.image-222 {\n    height: 480px;\n    position: absolute;\n    top: auto;\n    bottom: -88px;\n    left: auto;\n    right: -10%\n}\n\n.image-222.social {\n    right: 0%\n}\n\n.html-embed-31 {\n    width: 100%\n}\n\n.text-span-248,\n.text-span-249,\n.text-span-250,\n.text-span-251 {\n    color: var(--pabloo-green-2)\n}\n\n.navbar-dropdown-white {\n    background-color: rgba(255, 255, 255, 0);\n    border-radius: 40px;\n    font-size: 16px;\n    line-height: 118.75%;\n    position: static\n}\n\n.container-fluid {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.flex-split {\n    padding-top: 160px;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.optimize-hero-content-container {\n    width: 60%;\n    padding-left: 24px;\n    padding-right: 64px\n}\n\n.optimize-hero-logo {\n    height: 120px\n}\n\n.div-block-743 {\n    margin-top: 16px\n}\n\n.div-block-744 {\n    justify-content: flex-start;\n    display: flex\n}\n\n.div-block-745 {\n    justify-content: center;\n    align-items: center;\n    width: 50%;\n    padding-left: 40px;\n    padding-right: 40px;\n    display: flex\n}\n\n.div-block-746 {\n    margin-top: 24px\n}\n\n.div-block-747 {\n    border-bottom: 1px solid #5a5a5a;\n    width: 56px;\n    height: 1px;\n    margin-top: 4px\n}\n\n.blog-tabs-header {\n    margin-bottom: 40px\n}\n\n.blogs-tabs-form {\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.blog-tag-radio-button-wrap {\n    text-align: center;\n    flex-direction: column-reverse;\n    align-items: center;\n    margin-bottom: 0;\n    padding-left: 0;\n    display: flex\n}\n\n.blog-tag-radio-button {\n    border-width: 2.5px;\n    border-color: rgba(36, 2, 19, .2);\n    border-radius: 4px;\n    width: 100%;\n    height: 0;\n    margin-top: 0;\n    margin-left: 0\n}\n\n.blog-tag-radio-button.w--redirected-checked {\n    border-width: 2.5px;\n    border-color: #240213;\n    width: 100%;\n    height: 0\n}\n\n.blog-tag-radio-button.w--redirected-focus {\n    box-shadow: none;\n    flex: 0 auto;\n    width: 100%;\n    height: 4px\n}\n\n.blog-tabs-seach-input {\n    border: 1px #000;\n    height: auto;\n    margin-bottom: 0;\n    font-size: 18px;\n    line-height: 155.56%\n}\n\n.blog-tabs-seach-input:focus {\n    border-style: none\n}\n\n.blog-tabs-search-wrapper {\n    border: 1px solid rgba(36, 2, 19, .1);\n    border-radius: 10px;\n    width: 100%;\n    max-width: 333px;\n    padding: 10px 20px 10px 48px;\n    display: flex;\n    position: relative\n}\n\n.blog-search-icon {\n    opacity: .5;\n    width: 28px;\n    height: 28px;\n    position: absolute;\n    top: 50%;\n    bottom: 0%;\n    left: 20px;\n    right: auto;\n    transform: translateY(-50%)\n}\n\n.blog-tag-radio-buttons-contain {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    display: flex\n}\n\n.blog-tabs-pagination {\n    margin-top: 80px\n}\n\n.load-more-button {\n    background-color: var(--transparent);\n    border-style: none;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    font-size: 18px;\n    line-height: 156%;\n    display: flex\n}\n\n.resource-tabs-filters {\n    width: 19%;\n    max-width: 238px;\n    padding-top: 10px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 120px\n}\n\n.resources-search-wrapper {\n    display: flex;\n    position: relative\n}\n\n.resources-search-icon {\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 50%;\n    bottom: 0%;\n    left: auto;\n    right: 12px;\n    transform: translateY(-50%)\n}\n\n.resources-search-input {\n    background-color: rgba(14, 19, 40, .04);\n    border: 1px #000;\n    border-radius: 4px;\n    height: auto;\n    margin-bottom: 0;\n    padding: 10px 12px;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 150%\n}\n\n.resources-radio-button-wrap {\n    border-radius: 4px;\n    margin-bottom: 0;\n    padding: 0;\n    line-height: 156%;\n    overflow: hidden\n}\n\n.resources-radio-button {\n    margin-left: 0;\n    display: none\n}\n\n.radio-button-label {\n    width: 100%;\n    margin-bottom: 0;\n    padding: 8px 16px;\n    font-weight: 500\n}\n\n.resource-tab-form-separator {\n    background-color: rgba(14, 19, 40, .25);\n    width: 100%;\n    height: 2px;\n    margin-top: 16px;\n    margin-bottom: 16px\n}\n\n.resource-name {\n    display: none\n}\n\n.resources-tab-flex-contain {\n    transition: all .6s cubic-bezier(.645, .045, .355, 1);\n    overflow: hidden\n}\n\n.text-span-252,\n.text-span-253,\n.text-span-254 {\n    color: var(--pabloo-green-2)\n}\n\n.procurement-team-section {\n    padding-top: 85px;\n    padding-bottom: 120px\n}\n\n.procurement-team-container {\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.procurement-team-wrapper {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.procurement-team-header {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.section-heading {\n    text-align: left;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 40px;\n    line-height: 1.2em\n}\n\n.section-heading.text-center {\n    text-align: center\n}\n\n.text-span-255 {\n    color: var(--pabloo-green-2)\n}\n\n.procurement-team-cards-grid {\n    grid-column-gap: 64px;\n    grid-row-gap: 64px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 100px;\n    display: grid\n}\n\n.procurement-team-member-image-wrapper {\n    display: flex\n}\n\n.procurement-team-member-image-wrapper.new {\n    justify-content: center;\n    align-items: center\n}\n\n.procurement-team-member-image {\n    height: auto\n}\n\n.procurement-team-member-credentials-wrapper {\n    margin-top: 24px\n}\n\n.procurement-team-member-credentials-wrapper.new {\n    width: 100%\n}\n\n.procurement-team-member-name {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 600\n}\n\n.procurement-team-member-designation {\n    text-align: center;\n    font-weight: 400\n}\n\n.procurement-team-member-description {\n    margin-top: 24px\n}\n\n.paragraph-146 {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.6em\n}\n\n.text-span-256,\n.text-span-257,\n.text-span-258,\n.text-span-259,\n.text-span-260,\n.text-span-261,\n.text-span-262,\n.text-span-263,\n.text-span-264 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-749 {\n    width: 50%;\n    max-width: 700px\n}\n\n.intgrations-tabs-section {\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.integrations-container {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.integrations-tabs-wrap {\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    display: block\n}\n\n.text-span-265 {\n    color: var(--pabloo-green-2)\n}\n\n.integrations-tabs-body {\n    width: 100%;\n    display: flex\n}\n\n.tab-link-tab-1 {\n    background-color: #fff;\n    width: 100%\n}\n\n.tab-link-tab-1.w--current {\n    color: var(--white);\n    background-color: #d53987;\n    border-radius: 6px\n}\n\n.tab-link-tab-2 {\n    background-color: #fdfdfd;\n    width: 100%;\n    margin-top: 8px\n}\n\n.tab-link-tab-2.w--current {\n    color: var(--white);\n    background-color: #d53987;\n    border-radius: 6px\n}\n\n.tab-link-tab-3 {\n    background-color: #fff;\n    border-radius: 6px;\n    width: 100%;\n    margin-top: 8px\n}\n\n.tab-link-tab-3.w--current {\n    color: var(--white);\n    background-color: #c73b88\n}\n\n.integrations-tabs-menu {\n    width: 30%;\n    margin-top: 32px\n}\n\n.tab-pane-tab-1,\n.tab-pane-tab-2,\n.tab-pane-tab-3 {\n    width: 100%\n}\n\n.tabs-content-3 {\n    -webkit-text-fill-color: inherit;\n    background-clip: border-box;\n    width: 64%;\n    margin-top: -90px;\n    margin-left: 0%;\n    padding: 2% 2% 4% 4%\n}\n\n.div-block-750 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-751 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    border: 1.5px solid #cbd5e1;\n    border-radius: 12px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    padding: 20px 20px 20px 16px;\n    transition: all .2s;\n    display: grid;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, .08)\n}\n\n.div-block-751:hover {\n    box-shadow: 2px 8px 20px rgba(0, 0, 0, .24)\n}\n\n.div-block-752 {\n    padding: 10px\n}\n\n.image-223 {\n    border-radius: 10px;\n    height: 100px\n}\n\n.paragraph-147 {\n    font-size: 14px;\n    line-height: 1.6em\n}\n\n.text-block-307 {\n    margin-bottom: 16px;\n    line-height: 1.2em\n}\n\n.tab-link-tab-4 {\n    background-color: var(--white);\n    width: 100%;\n    margin-top: 8px\n}\n\n.tab-link-tab-4.w--current {\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    border-radius: 6px\n}\n\n.text-span-266 {\n    color: var(--pabloo-green-2)\n}\n\n.saas-hero-container {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: relative\n}\n\n.saas-hero-section {\n    background-color: var(--soft-pink);\n    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 90%, #fff 90%, #fff)\n}\n\n.saas-hero-text-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 794px;\n    margin-top: 54px;\n    display: flex\n}\n\n.saas-hero-wrapper {\n    z-index: 2;\n    color: var(--darker-violet);\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 140px;\n    display: flex;\n    position: relative\n}\n\n.saas-hero-image-wrapper {\n    z-index: 2;\n    width: 90%;\n    max-width: 1076px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-bottom: 20px;\n    position: relative\n}\n\n.saas-hero-main-image {\n    border-radius: 10px;\n    width: 100%;\n    box-shadow: 0 36px 178px rgba(36, 2, 19, .08)\n}\n\n.saas-hero-absolute-image {\n    border-radius: 9px;\n    width: 100%;\n    max-width: 240px;\n    position: absolute;\n    top: auto;\n    bottom: -5%;\n    left: -5%;\n    right: auto;\n    box-shadow: 0 20px 100px rgba(36, 2, 19, .1)\n}\n\n.saas-hero-absolute-image.second {\n    max-width: 300px;\n    top: 28%;\n    bottom: auto;\n    left: auto;\n    right: -4%\n}\n\n.stats-section-contain {\n    padding-top: 45px;\n    padding-bottom: 40px\n}\n\n.stats-section-contain.cloud {\n    padding-top: 19px\n}\n\n.flex-section {\n    width: 100%\n}\n\n.flex-container {\n    grid-column-gap: 140px;\n    grid-row-gap: 140px;\n    flex-direction: column;\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 140px;\n    padding-bottom: 140px;\n    display: flex\n}\n\n.flex-container._140px-bottom-margin {\n    padding-top: 0;\n    padding-bottom: 140px\n}\n\n.flex-container._115px-bottom-margin {\n    padding-bottom: 115px\n}\n\n.flex-block-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.flex-block-wrapper.vertical {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    flex-direction: column;\n    padding-top: 80px\n}\n\n.flex-text-block {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 40%;\n    max-width: 473px;\n    display: flex\n}\n\n.flex-text-block._524px {\n    max-width: 524px\n}\n\n.flex-text-block._580px {\n    width: 50%;\n    max-width: 580px\n}\n\n.flex-text-block._580px.new {\n    justify-content: flex-start;\n    align-items: flex-start;\n    max-width: 600px;\n    margin-bottom: 45px\n}\n\n.flex-text-block._550px {\n    width: 45%;\n    max-width: 550px\n}\n\n.flex-text-block._440px {\n    max-width: 440px\n}\n\n.flex-text-block.vertical-cloud {\n    text-align: center;\n    align-items: center;\n    width: 100%;\n    max-width: 600px\n}\n\n.flex-image-block {\n    width: 50%;\n    max-width: 676px;\n    padding-top: 57px;\n    padding-bottom: 57px;\n    display: flex;\n    position: relative\n}\n\n.flex-image-block.lottie {\n    width: 55%;\n    left: 5%\n}\n\n.flex-image-block.cloud-1 {\n    max-width: 660px;\n    padding-top: 52px;\n    padding-bottom: 37px\n}\n\n.flex-image-block.vertical-cloud {\n    width: 100%;\n    max-width: 1080px;\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.flex-block-icon-embed {\n    width: 28px;\n    height: 28px\n}\n\n.flex-block-icon-contain {\n    background-image: linear-gradient(135deg, rgba(72, 33, 53, .1), rgba(72, 33, 53, .15));\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    padding: 1px\n}\n\n.flex-block-icon-contain._4px-bottom-margin {\n    margin-bottom: 4px\n}\n\n.flex-block-icon-contain.blue {\n    background-image: linear-gradient(135deg, rgba(19, 86, 101, .12), rgba(19, 86, 101, .19))\n}\n\n.flex-block-icon-wrapper {\n    color: var(--dark-violet);\n    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.flex-block-icon-wrapper.blue {\n    background-image: linear-gradient(135deg, #d6f8f3, #b3eae2)\n}\n\n.flex-block-points-contain {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    display: flex\n}\n\n.flex-block-points-contain._495px {\n    max-width: 495px\n}\n\n.flex-block-point-wrapper {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    display: flex\n}\n\n.flex-block-point-icon-embed {\n    flex: none;\n    width: 20px;\n    height: 20px;\n    margin-top: 4px\n}\n\n.flex-block-point-icon-embed.pink {\n    color: var(--pabloo-green)\n}\n\n.bold-text-span {\n    font-weight: 700\n}\n\n.flex-block-background-gradient-contain {\n    z-index: 1;\n    background-image: linear-gradient(rgba(72, 33, 53, .08), rgba(72, 33, 53, .16));\n    border-radius: 16px;\n    width: 60%;\n    padding: 1px;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: auto\n}\n\n.flex-block-background-gradient-contain.blue {\n    background-image: linear-gradient(rgba(19, 86, 101, .1), rgba(19, 86, 101, .2))\n}\n\n.flex-block-background-gradient-contain.blue.right {\n    top: 0%;\n    bottom: 0%;\n    left: auto;\n    right: 0%\n}\n\n.flex-block-background-gradient {\n    background-image: linear-gradient(135deg, #fbeded, #e5c4c5);\n    border-radius: 16px;\n    width: 100%;\n    height: 100%\n}\n\n.flex-block-background-gradient.blue {\n    background-image: linear-gradient(135deg, #ddfbf7, #ace6de)\n}\n\n.flex-block-image-wrapper {\n    z-index: 2;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    display: flex;\n    position: relative;\n    left: 4%\n}\n\n.flex-block-image-wrapper.right {\n    text-align: left;\n    left: auto;\n    right: 4%\n}\n\n.flex-block-image {\n    border-radius: 12px 12px 0 0;\n    width: 100%;\n    box-shadow: 0 19px 74px rgba(0, 0, 0, .08)\n}\n\n.flex-block-image.cloud-1 {\n    border-radius: 14px;\n    width: 75%;\n    max-width: 500px;\n    margin-left: -10%;\n    box-shadow: 0 20px 100px rgba(36, 2, 19, .1)\n}\n\n.flex-block-image.cloud-2 {\n    border-radius: 14px;\n    width: 75%;\n    max-width: 500px;\n    margin-top: -40px;\n    margin-left: auto;\n    box-shadow: 0 -16px 100px rgba(36, 2, 19, .08), 0 20px 110px rgba(0, 0, 0, .05)\n}\n\n.flex-block-image.vertical-cloud {\n    box-shadow: 0 1px 195px rgba(36, 2, 19, .08)\n}\n\n.flex-block-image.cloud-3 {\n    box-shadow: 0 19px 93px rgba(36, 2, 19, .05)\n}\n\n.flex-pink-section {\n    background-color: var(--soft-pink);\n    width: 100%\n}\n\n.flex-block-abs-image {\n    border-radius: 13px;\n    width: 100%;\n    max-width: 240px;\n    position: absolute;\n    top: auto;\n    bottom: -8%;\n    left: auto;\n    right: 8%;\n    box-shadow: 0 -16px 100px rgba(0, 0, 0, .05), 0 9px 68px rgba(36, 2, 19, .08)\n}\n\n.flex-block-abs-image.fourth {\n    max-width: 301px;\n    top: auto;\n    bottom: -12%;\n    left: 12%;\n    right: auto;\n    box-shadow: 0 9px 68px rgba(36, 2, 19, .08)\n}\n\n.solution-callout-section {\n    background-color: var(--soft-pink);\n    width: 100%;\n    overflow: hidden\n}\n\n.solution-callout-wrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 85%;\n    max-width: 1160px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    position: relative\n}\n\n.solution-callout-text-wrapper {\n    grid-column-gap: 32px;\n    grid-row-gap: 32px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 45%;\n    max-width: 501px;\n    padding-top: 60px;\n    padding-bottom: 60px;\n    display: flex\n}\n\n.solution-callout-text-wrapper.cloud {\n    width: 46%;\n    max-width: 490px\n}\n\n.solution-callout-images-contain {\n    z-index: 1;\n    grid-column-gap: 21px;\n    grid-row-gap: 21px;\n    flex-direction: column;\n    width: 50%;\n    max-width: 608px;\n    display: flex;\n    position: absolute;\n    top: -10%;\n    bottom: auto;\n    left: auto;\n    right: -5%;\n    transform: rotate(-20deg)\n}\n\n.solution-callout-images-contain.cloud {\n    max-width: 700px\n}\n\n.solution-callout-image-row {\n    grid-column-gap: 22px;\n    grid-row-gap: 22px;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.solution-callout-image-row.cloud-second {\n    grid-column-gap: 27px;\n    grid-row-gap: 27px;\n    margin-left: 15%\n}\n\n.solution-callout-image {\n    border-radius: 10px;\n    width: 100%;\n    box-shadow: 0 15px 80px rgba(0, 0, 0, .05)\n}\n\n.solution-callout-image.first {\n    width: 58%;\n    max-width: 361px\n}\n\n.solution-callout-image.second {\n    width: 40%;\n    max-width: 227px\n}\n\n.solution-callout-image.third {\n    max-width: 395px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.solution-callout-image.cloud-first {\n    box-shadow: none;\n    width: 46%;\n    max-width: 292px\n}\n\n.solution-callout-image.cloud-second {\n    width: 55%;\n    max-width: 332px;\n    box-shadow: 0 -22px 138px rgba(0, 0, 0, .05), 0 12px 94px rgba(36, 2, 19, .08)\n}\n\n.solution-callout-image.cloud-third {\n    width: 55%;\n    max-width: 303px;\n    box-shadow: 0 -20px 108px rgba(0, 0, 0, .05)\n}\n\n.solution-callout-image.cloud-fourth {\n    width: 50%;\n    max-width: 280px;\n    margin-bottom: auto;\n    box-shadow: 0 -20px 108px rgba(0, 0, 0, .05)\n}\n\n.setup-section {\n    background-color: var(--dark-violet);\n    width: 100%\n}\n\n.setup-wrapper {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    flex-direction: column;\n    align-items: center;\n    width: 90%;\n    max-width: 1203px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.setup-span {\n    color: #f7e8c7\n}\n\n.setup-cards-grid {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%;\n    max-width: 1203px;\n    display: flex\n}\n\n.setup-card-wrapper {\n    grid-column-gap: 1px;\n    grid-row-gap: 1px;\n    width: 100%;\n    display: flex\n}\n\n.setup-card-number-contain {\n    grid-column-gap: 2px;\n    grid-row-gap: 2px;\n    flex-direction: column;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    width: 90px;\n    display: flex\n}\n\n.setup-card-number-image {\n    object-fit: cover;\n    border-radius: 12px;\n    width: 100%;\n    height: 100%\n}\n\n.setup-card-text-contain {\n    background-color: var(--soft-pink);\n    border-radius: 12px;\n    align-items: center;\n    width: 100%;\n    padding: 28px 20px;\n    display: flex\n}\n\n.cta-cream-span {\n    color: var(--cream)\n}\n\n.flex-lottie {\n    width: 100%\n}\n\n.cloud-hero-container {\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.cloud-hero-section {\n    background-color: var(--soft-pink);\n    overflow: hidden\n}\n\n.cloud-hero-wrapper {\n    z-index: 2;\n    color: var(--darker-violet);\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 154px;\n    padding-bottom: 134px;\n    display: flex;\n    position: relative\n}\n\n.cloud-hero-text-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 53%;\n    max-width: 624px;\n    display: flex\n}\n\n.cloud-hero-span {\n    color: var(--pabloo-green)\n}\n\n.cloud-hero-image-wrapper {\n    width: 45%;\n    max-width: 600px;\n    display: flex;\n    position: relative\n}\n\n.cloud-hero-image {\n    width: 100%;\n    max-width: 490px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.cloud-hero-absolute-image {\n    border-radius: 8px;\n    width: 100%;\n    max-width: 180px;\n    position: absolute;\n    top: 30%;\n    bottom: auto;\n    left: -10%;\n    right: auto;\n    box-shadow: 0 12px 60px rgba(0, 0, 0, .05)\n}\n\n.cloud-hero-absolute-image.second {\n    max-width: 300px;\n    top: auto;\n    bottom: -10%;\n    left: -7%;\n    right: auto;\n    box-shadow: 0 13px 66px rgba(0, 0, 0, .05)\n}\n\n.cloud-hero-absolute-image.third {\n    max-width: 197px;\n    top: 30%;\n    bottom: auto;\n    left: auto;\n    right: -10%;\n    box-shadow: 0 13px 66px rgba(0, 0, 0, .05)\n}\n\n.cloud-hero-absolute-image.fourth {\n    border-radius: 20px;\n    max-width: 180px;\n    top: auto;\n    bottom: -22%;\n    left: auto;\n    right: -6%;\n    box-shadow: 0 13px 66px rgba(0, 0, 0, .05)\n}\n\n.flex-text-header {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    align-items: center;\n    display: flex\n}\n\n.cloud-absolute-image {\n    border-radius: 8px;\n    width: 100%;\n    max-width: 252px;\n    position: absolute;\n    top: 38%;\n    bottom: auto;\n    left: -5%;\n    right: auto;\n    box-shadow: 0 13px 70px rgba(0, 0, 0, .05)\n}\n\n.cloud-absolute-image.second {\n    max-width: 210px;\n    top: auto;\n    bottom: 20%;\n    left: auto;\n    right: -5%\n}\n\n.text-span-269 {\n    color: #dfd5d1\n}\n\n.sub-heading-title {\n    color: var(--dark-violet);\n    text-align: center;\n    margin-top: 0\n}\n\n.subheading-title-wrap {\n    justify-content: center;\n    display: flex\n}\n\n.html-embed-32 {\n    margin-top: 2px;\n    margin-left: 6px\n}\n\n.div-block-753 {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 100px;\n    display: flex\n}\n\n.heading-257 {\n    text-align: center;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 32px\n}\n\n.text-span-270,\n.text-span-271,\n.text-span-272,\n.text-span-273 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-754 {\n    transition: opacity .2s\n}\n\n.spend-absolute-image {\n    border-radius: 8px;\n    width: 100%;\n    max-width: 250px;\n    position: absolute;\n    top: 29%;\n    bottom: auto;\n    left: 5%;\n    right: auto;\n    box-shadow: 0 32px 133px rgba(36, 2, 19, .1)\n}\n\n.spend-absolute-image.a {\n    width: 40%;\n    left: 8%\n}\n\n.spend-absolute-image.b {\n    width: 40%;\n    max-width: 266px;\n    top: auto;\n    bottom: 20%;\n    left: auto;\n    right: 5%\n}\n\n.heading-258 {\n    text-align: center;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 56px\n}\n\n.paragraph-148 {\n    font-size: 14px;\n    line-height: 20px\n}\n\n.text-block-308 {\n    color: #fff;\n    font-size: 16px;\n    line-height: 18px\n}\n\n.pricing-table-column-category-header {\n    background-color: #fcf6e8;\n    justify-content: center;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    display: flex\n}\n\n.pricing-plan-card {\n    background-image: linear-gradient(#fff4dc, #f0deb5 62%);\n    border: 1px solid #d7d5d2;\n    border-radius: 8px;\n    padding: 32px\n}\n\n.pricing-plan-card.saas-growth {\n    background-image: linear-gradient(#fef2f2, #f5cde1 62%);\n    margin-left: 12px\n}\n\n.pricing-plan-card.saas-pro {\n    margin-left: 0;\n    margin-right: 12px\n}\n\n.toggle-dot {\n    background-color: #fff;\n    border-radius: 50%;\n    width: 24px;\n    height: 24px\n}\n\n.text-block-211 {\n    font-size: 14px;\n    font-weight: 700\n}\n\n.pricing-menu-tabs {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    max-width: 100%;\n    margin-left: 100px;\n    margin-right: 100px;\n    display: grid\n}\n\n.text-block-309 {\n    text-align: center;\n    align-self: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 24px\n}\n\n.text-block-209 {\n    color: #828aa5;\n    font-size: 14px;\n    line-height: 1em\n}\n\n.div-block-755 {\n    margin-top: 24px\n}\n\n.pricing-duration-toggle {\n    justify-content: flex-end;\n    align-items: center;\n    max-width: 100%;\n    margin-bottom: 48px;\n    margin-left: 100px;\n    margin-right: 100px;\n    display: none\n}\n\n.div-block-756 {\n    align-items: flex-end;\n    margin-top: 24px;\n    margin-bottom: 10px;\n    display: flex\n}\n\n.div-block-440 {\n    padding-top: 8px;\n    padding-bottom: 8px\n}\n\n.div-block-427 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto 1fr;\n    grid-auto-columns: 1fr;\n    align-self: auto;\n    align-items: center;\n    display: grid\n}\n\n.heading-259 {\n    font-size: 24px\n}\n\n.div-block-424 {\n    max-width: 100%;\n    margin-left: 100px;\n    margin-right: 100px;\n    padding-left: 100px;\n    padding-right: 100px\n}\n\n.section-68 {\n    background-color: #faf2eb;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6597aa2642f1fe5180df02ff_Frame%202087326089.svg);\n    background-position: 0 0;\n    background-size: cover;\n    padding-top: 200px\n}\n\n.section-68.new {\n    padding-top: 140px;\n    padding-bottom: 100px\n}\n\n.pricing-table-column-status {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.pricing-table-column-status.gray-bg {\n    background-color: #f7f7f5\n}\n\n.button-27 {\n    text-align: center;\n    background-color: #d53987;\n    border-radius: 8px;\n    width: 100%;\n    padding-left: 12px;\n    padding-right: 12px;\n    font-size: 16px\n}\n\n.tab-link-pabloo-for-cloud {\n    color: #828aa5;\n    background-color: #fff;\n    border-bottom: 2px solid #9ca3af\n}\n\n.tab-link-pabloo-for-cloud.w--current {\n    color: #d53987;\n    background-color: #fff;\n    border-bottom: 2px solid #d53987\n}\n\n.text-block-310 {\n    font-weight: 700\n}\n\n.text-block-210 {\n    text-transform: none;\n    margin-left: 8px;\n    font-family: \"P22mackinacpro 26\", sans-serif;\n    line-height: 18px\n}\n\n.heading-158 {\n    margin-bottom: -8px;\n    margin-left: 4px;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    line-height: 52px\n}\n\n.div-block-425 {\n    max-width: 100%;\n    margin-top: 100px;\n    margin-left: 0;\n    margin-right: 0\n}\n\n.toggle-contain {\n    background-color: #ea9cc3;\n    border-radius: 50px;\n    width: 70px;\n    height: 34px;\n    padding-top: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n    position: relative\n}\n\n.div-block-757 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-205 {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.div-block-426 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template: \".\" \".\" /1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    max-width: 100%;\n    margin-left: 100px;\n    margin-right: 100px;\n    display: grid\n}\n\n.text-block-212 {\n    font-weight: 700\n}\n\n.pricing-table-row-section-header {\n    background-color: #faf2eb;\n    width: 100%;\n    margin-top: 80px;\n    padding: 24px 20px\n}\n\n.paragraph-149 {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 24px\n}\n\n.text-block-206 {\n    text-align: center;\n    font-size: 20px;\n    font-weight: 500\n}\n\n.pricing-table-column-text {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    padding-left: 16px;\n    display: flex\n}\n\n.pricing-table-column-text.gray-bg {\n    background-color: #f7f7f5\n}\n\n.div-block-429 {\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.tab-pane-pabloo-for-saas {\n    padding-top: 60px;\n    padding-bottom: 0\n}\n\n.div-block-431 {\n    margin-top: 24px\n}\n\n.text-span-274 {\n    color: #d53987;\n    font-family: \"P22mackinacpro 12\", sans-serif\n}\n\n.div-block-433 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 16px;\n    display: grid\n}\n\n.tab-link-pabloo-for-saas {\n    color: #828aa5;\n    background-color: #fff;\n    border-bottom: 2px solid #9ca3af\n}\n\n.tab-link-pabloo-for-saas.w--current {\n    color: #d53987;\n    background-color: #fff;\n    border-bottom: 2px solid #d53887\n}\n\n.text-block-214 {\n    color: #514f6d;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.text-block-208 {\n    color: #666;\n    font-weight: 700\n}\n\n.pricing-tier-metric-wrap {\n    margin-top: 24px;\n    margin-bottom: 0\n}\n\n.text-block-312 {\n    font-family: Inter, sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.div-block-758 {\n    background-color: #fff;\n    border: 1px solid #d7d5d2;\n    border-radius: 8px;\n    margin-top: 8px;\n    padding: 12px 16px\n}\n\n.text-block-313 {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.flex-block-lottie {\n    border-radius: 12px 12px 0 0;\n    width: 100%;\n    box-shadow: 0 19px 74px rgba(0, 0, 0, .08)\n}\n\n.flex-block-lottie.animate-from-right {\n    z-index: 2;\n    box-shadow: none;\n    position: relative\n}\n\n.type-card-lottie {\n    z-index: 2;\n    width: 100%;\n    position: relative\n}\n\n.subscribe-block {\n    width: 100%\n}\n\n.before-hero-image-mail,\n.after-hero-image-mail,\n.before-hero-image-inter,\n.after-hero-image-inter,\n.before-hero-image-adobe,\n.after-hero-image-adobe,\n.before-hero-image-jira,\n.after-hero-image-jira,\n.before-hero-image-hubspot,\n.after-hero-image-hubspot,\n.before-hero-image-zendesk,\n.after-hero-image-zendesk {\n    width: 100%;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.div-block-759 {\n    background-color: #08090a;\n    max-width: 100%;\n    margin-top: 64px;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 100px\n}\n\n.heading-260 {\n    color: #f7e8c7;\n    text-align: center;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 48px;\n    line-height: 56px\n}\n\n.heading-261 {\n    color: var(--white);\n    text-align: center;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 48px;\n    line-height: 56px\n}\n\n.div-block-760 {\n    margin-bottom: 64px\n}\n\n.tabs {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-content: start;\n    justify-content: space-between;\n    align-items: start;\n    justify-items: stretch;\n    width: 100%;\n    display: grid\n}\n\n.tabs-menu-4 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: start;\n    width: 100%;\n    display: grid\n}\n\n.tabs-content-4 {\n    background-color: #faf2eb;\n    background-image: linear-gradient(127deg, #fff4dc, #f0deb5);\n    border: 1.5px solid #f7f1d0;\n    border-radius: 16px;\n    flex: 0 auto;\n    width: 100%;\n    padding: 40px 32px\n}\n\n.tab-link-tab-1-2 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    color: var(--white);\n    background-color: #282d32;\n    border-radius: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    padding: 20px 32px;\n    display: grid\n}\n\n.tab-link-tab-1-2.w--current {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    border-radius: 20px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    padding: 20px 32px;\n    display: flex\n}\n\n.text-block-314 {\n    margin-left: 0;\n    font-size: 18px;\n    line-height: 1em\n}\n\n.html-embed-33 {\n    margin-bottom: -6px\n}\n\n.div-block-761 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-762 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-315 {\n    font-family: Inter, sans-serif;\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 36px\n}\n\n.div-block-763 {\n    display: flex\n}\n\n.text-block-316 {\n    font-family: \"P22mackinacpro 26\", sans-serif;\n    font-size: 14px\n}\n\n.text-block-317 {\n    margin-left: 2px;\n    margin-right: 2px;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 48px;\n    line-height: 40px\n}\n\n.div-block-764 {\n    margin-top: 24px\n}\n\n.text-block-318 {\n    font-size: 14px;\n    line-height: 20px\n}\n\n.div-block-765 {\n    margin-top: 16px;\n    font-size: 16px;\n    line-height: 20px\n}\n\n.div-block-766 {\n    margin-top: 24px\n}\n\n.button-47 {\n    background-color: var(--pabloo-green);\n    text-align: center;\n    border-radius: 10px;\n    width: 100%\n}\n\n.tab-link-tab-2-2 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    color: var(--white);\n    background-color: #282d32;\n    border-radius: 20px;\n    align-items: center;\n    padding: 20px 32px;\n    display: flex\n}\n\n.tab-link-tab-2-2.w--current {\n    background-color: #df4391\n}\n\n.text-block-319 {\n    line-height: 1em\n}\n\n.div-block-767 {\n    background-color: #faf2eb;\n    border-radius: 20px;\n    margin-top: 0;\n    margin-bottom: 0%\n}\n\n.div-block-767.set {\n    margin-bottom: 0%\n}\n\n.tab-pane-pabloo-for-cloud {\n    padding-top: 60px;\n    padding-bottom: 80px\n}\n\n.div-block-769 {\n    max-width: 100%;\n    margin-left: 100px;\n    margin-right: 100px;\n    padding-left: 24%;\n    padding-right: 24%\n}\n\n.div-block-770 {\n    margin-top: 20px\n}\n\n.div-block-771 {\n    max-width: 100%;\n    padding: 80px 100px\n}\n\n.select-field-3 {\n    background-color: var(--white);\n    color: var(--black);\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    margin-top: 8px;\n    font-family: Inter, sans-serif;\n    font-weight: 500\n}\n\n.subscription-form-embed {\n    width: 100%;\n    margin-bottom: 0\n}\n\n.subscription-form-embed.resource {\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.sticky-progress-bar-contain {\n    background-color: rgba(36, 2, 19, .2);\n    border-radius: 8px;\n    width: 100%;\n    height: 4px;\n    position: absolute;\n    top: auto;\n    bottom: -20px;\n    left: 0%;\n    right: 0%\n}\n\n.sticky-blocks-progress-wrapper {\n    width: 100%;\n    max-width: 407px;\n    position: relative\n}\n\n.sticky-progress-bar {\n    background-color: #240213;\n    border-radius: 8px;\n    width: 100%;\n    height: 100%\n}\n\n.share-links-contain {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    justify-content: center;\n    width: 100%;\n    display: flex\n}\n\n.share-link-icon-contain {\n    background-image: linear-gradient(135deg, rgba(72, 33, 53, .1), rgba(72, 33, 53, .15));\n    border-radius: 12px;\n    width: 48px;\n    height: 48px;\n    padding: 1px\n}\n\n.share-link-icon-wrapper {\n    color: var(--dark-violet);\n    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);\n    border-radius: 12px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.share-link-icon-embed {\n    width: 28px;\n    height: 28px\n}\n\n.share-link-icon-embed.check {\n    position: absolute;\n    top: auto;\n    bottom: -100%;\n    left: 0%;\n    right: 0%\n}\n\n.share-embed-contain {\n    position: relative;\n    overflow: hidden\n}\n\n.section-69 {\n    background-color: #08090a;\n    padding: 120px 100px\n}\n\n.text-span-275 {\n    color: var(--pabloo-green-2)\n}\n\n.html-embed-34 {\n    margin-left: 4px\n}\n\n.div-block-774 {\n    padding-top: 100px\n}\n\n.div-block-775 {\n    display: flex\n}\n\n.badge-image {\n    width: 45%;\n    max-width: 104px\n}\n\n.badge-image.new {\n    margin-left: 0;\n    margin-right: auto\n}\n\n.footer-bottom-wrapper {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.footer-socials-contain {\n    grid-column-gap: 28px;\n    grid-row-gap: 28px;\n    align-items: center;\n    display: flex\n}\n\n.footer-socials-wrapper {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    align-items: center;\n    display: flex\n}\n\n.social-link-wrapper {\n    color: var(--darker-violet);\n    border: 1px solid #bdbdbd;\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 56px;\n    height: 56px;\n    transition: all .3s ease-in-out;\n    display: flex\n}\n\n.social-link-wrapper:hover {\n    background-color: var(--soft-pink);\n    color: var(--pabloo-green-2)\n}\n\n.footer-end-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    display: flex\n}\n\n.privacy-links-contain {\n    grid-column-gap: 36px;\n    grid-row-gap: 36px;\n    align-items: center;\n    display: flex\n}\n\n.navigation-flex-wrapper {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    justify-content: space-between;\n    width: 100%;\n    display: flex\n}\n\n.navigation-left-flex-wrapper {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    width: 67%;\n    max-width: 752px;\n    display: flex\n}\n\n.navigation-left-flex-wrapper.product {\n    width: 75%;\n    max-width: 842px\n}\n\n.navigation-header {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding-right: 24px;\n    display: flex\n}\n\n.navigation-header.no-padding {\n    padding-right: 0\n}\n\n.navigation-divider {\n    background-color: var(--pabloo-green);\n    opacity: .2;\n    width: 100%;\n    height: 1px\n}\n\n.navigation-block-wrapper {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 100%;\n    display: flex\n}\n\n.navigation-block-container {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    width: 100%;\n    display: flex\n}\n\n.navigation-block-container._50 {\n    width: 50%\n}\n\n.navigation-block-container._40 {\n    width: 40%\n}\n\n.navigation-block-container._60 {\n    width: 75%\n}\n\n.navigation-block-links-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 100%\n}\n\n.navigation-block-links-grid._2-column,\n.navigation-block-links-grid.resources {\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr\n}\n\n.navigation-block-links-grid._1-column {\n    grid-template-columns: 1fr\n}\n\n.navigation-block-link-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    color: var(--dark-violet);\n    align-items: center;\n    font-weight: 500;\n    transition: color .3s ease-in-out;\n    display: flex\n}\n\n.navigation-block-link-wrapper:hover {\n    color: var(--pabloo-green)\n}\n\n.navigation-block-link-wrapper.resource {\n    align-items: flex-start\n}\n\n.navigation-icon-contain {\n    background-image: none;\n    border-radius: 50%;\n    flex: none;\n    width: 40px;\n    height: 40px;\n    padding: 1px\n}\n\n.navigation-icon-contain.new {\n    background-image: none\n}\n\n.navigation-icon-wrapper {\n    color: var(--dark-violet);\n    background-image: linear-gradient(135deg, #f8e7e7, #e9cacb);\n    border-radius: 50%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.navigation-icon-wrapper.new {\n    background-image: none\n}\n\n.navigation-icon-embed {\n    width: 24px;\n    height: 24px\n}\n\n.navigation-vertical-divider {\n    background-color: var(--pabloo-green);\n    opacity: .2;\n    width: 1px\n}\n\n.navigation-right-flex-wrapper {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    flex-direction: column;\n    width: 30%;\n    display: flex\n}\n\n.navigation-right-flex-wrapper.product {\n    width: 25%;\n    max-width: 348px\n}\n\n.dropdown-image-contain {\n    background-color: rgba(250, 242, 235, .6);\n    border-radius: 12px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.dropdown-image {\n    width: 90%;\n    max-width: 287px\n}\n\n.dropdown-chevron {\n    width: 100%;\n    max-width: 20px;\n    position: absolute;\n    top: -12px;\n    bottom: auto;\n    left: 21%;\n    right: auto\n}\n\n.dropdown-chevron.solution {\n    left: 30%\n}\n\n.dropdown-chevron.resources {\n    left: 45%\n}\n\n.navigation-flex-grid {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n    width: 100%;\n    display: flex\n}\n\n.dropdown-block-image {\n    width: 100%;\n    margin-bottom: 12px\n}\n\n.dropdown-link-headings-contain {\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    flex-direction: column;\n    align-items: flex-start;\n    display: flex\n}\n\n.nav-mobile-contain {\n    grid-column-gap: 12px;\n    grid-row-gap: 32px;\n    align-items: center;\n    display: none\n}\n\n.product-dropdown-wrapper {\n    display: none\n}\n\n.navigation-flex-block {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    width: 100%;\n    display: flex\n}\n\n.dropdown-links-wrapper {\n    width: 100%\n}\n\n.mobile-links-divider,\n.solutions-dropdown-wrapper,\n.resources-dropdown-wrapper {\n    display: none\n}\n\n.ncf-filter-item-container {\n    grid-column-gap: 32px;\n    grid-row-gap: 48px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.ncf-filter-content-item {\n    border-radius: 10px;\n    padding: 32px;\n    box-shadow: 0 20px 100px rgba(40, 0, 18, .08)\n}\n\n.page-indicator-wrapper {\n    justify-content: center;\n    align-items: center;\n    display: flex\n}\n\n.page-indicator-wrapper.ncf-filter-page-indicator {\n    margin-top: 10px\n}\n\n._24px-icon {\n    flex: none;\n    width: 24px;\n    height: 24px;\n    margin-top: 0;\n    display: inline-block\n}\n\n.indicator {\n    margin-top: auto;\n    margin-bottom: auto;\n    display: inline\n}\n\n.ncf-filter-control-search {\n    outline-offset: 0px;\n    border: 1px #000;\n    border-radius: 8px;\n    outline: 3px #d9d9d9;\n    width: 100%;\n    height: 56px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 7%;\n    font-size: 16px;\n    box-shadow: 0 20px 40px rgba(0, 0, 0, .05)\n}\n\n.description-container-ncf {\n    background-color: #f2ff8d;\n    margin-top: 40px;\n    margin-bottom: 8px\n}\n\n.ncf-filter-reset.ncf-filter-target.ncf-filter-no {\n    opacity: 0\n}\n\n.ncf-filter-categorie-chip {\n    border: 1px solid rgba(40, 0, 21, .1);\n    border-radius: 120px;\n    padding: 8px 12px;\n    font-size: 16px;\n    line-height: 24px\n}\n\n.ncf-filter-categorie-chip.ncf-selected {\n    color: var(--white);\n    background-color: #000;\n    border-color: rgba(0, 0, 0, .1)\n}\n\n.description-header {\n    font-family: Inconsolata, monospace\n}\n\n.div-block-776 {\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 2rem;\n    padding-bottom: 2rem\n}\n\n.heading-262 {\n    text-align: center;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    line-height: 4.8rem\n}\n\n.text-span-276 {\n    color: var(--pabloo-green-2)\n}\n\n.integrations-search-field-wrapper {\n    width: 56%;\n    margin-top: -126px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative\n}\n\n.html-embed-35 {\n    position: absolute;\n    top: 28%;\n    bottom: auto;\n    left: 2%;\n    right: auto\n}\n\n.apps-filter-tags-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    display: flex\n}\n\n.apps-filters-wrapper {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 100%;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    margin-top: 40px;\n    display: grid\n}\n\n.slide-nav-7 {\n    display: none\n}\n\n.slider-19 {\n    background-color: rgba(255, 255, 255, 0);\n    align-items: center;\n    width: auto;\n    height: auto;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 50px;\n    padding-right: 50px;\n    display: block\n}\n\n.slide-21 {\n    width: auto;\n    height: auto;\n    margin-right: 8px;\n    padding-bottom: 0;\n    padding-right: 0\n}\n\n.slide-22 {\n    width: auto;\n    height: auto;\n    margin-left: 8px;\n    padding-bottom: 0;\n    padding-right: 0\n}\n\n.left-arrow-9 {\n    background-color: #eee;\n    border-radius: 100%;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n    display: block\n}\n\n.right-arrow-10 {\n    background-color: #eee;\n    border-radius: 100%;\n    width: 40px;\n    height: 40px\n}\n\n.html-embed-36 {\n    align-self: center;\n    margin-top: -1px\n}\n\n.app-listing-card {\n    position: relative\n}\n\n.app-listing-flo-score {\n    position: absolute;\n    top: -38px;\n    right: -12px\n}\n\n.div-block-777 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    font-family: \"P22mackinacpro 26\", sans-serif;\n    font-size: 28px;\n    line-height: 32px;\n    display: grid\n}\n\n.image-225 {\n    width: auto;\n    height: 48px\n}\n\n.paragraph-150 {\n    font-size: 16px;\n    line-height: 24px\n}\n\n.div-block-778 {\n    margin-top: 20px\n}\n\n.div-block-779 {\n    border-top: 1px solid rgba(222, 222, 222, .3);\n    margin-top: 40px;\n    padding-top: 80px\n}\n\n.link-block-37 {\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    border: 1px solid #280015;\n    border-radius: 8px;\n    justify-content: flex-end;\n    align-items: center;\n    width: auto;\n    padding: 8px 40px;\n    display: flex\n}\n\n.html-embed-37 {\n    margin-bottom: -6px\n}\n\n.div-block-780 {\n    margin-left: 48px;\n    display: none\n}\n\n.points-section {\n    background-color: #014737;\n    position: relative;\n    overflow: hidden\n}\n\n.points-text-contain {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 51%;\n    max-width: 630px;\n    display: flex\n}\n\n.points-image-contain {\n    grid-column-gap: 14px;\n    grid-row-gap: 14px;\n    flex-direction: column;\n    width: 46%;\n    max-width: 602px;\n    display: flex\n}\n\n.points-bg-contain {\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.points-bg-image {\n    width: 126%;\n    max-width: 126%;\n    height: 115%;\n    position: absolute;\n    top: -7.5%;\n    bottom: 0%;\n    left: -5%;\n    right: 0%\n}\n\n.points-heading-span {\n    color: var(--cream)\n}\n\n.points-checklist-grid {\n    grid-column-gap: 24px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-bottom: 40px;\n    display: grid\n}\n\n.points-checklist-row {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: flex-start;\n    display: flex\n}\n\n.html-embed-38 {\n    flex: none;\n    width: 20px;\n    height: 20px;\n    margin-top: 4px\n}\n\n.points-images-top-flex {\n    justify-content: space-between;\n    display: flex\n}\n\n.points-image {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.points-image-wrapper {\n    border-radius: 10.64px;\n    overflow: hidden;\n    box-shadow: 11px -11px 97px rgba(36, 2, 19, .12)\n}\n\n.points-image-wrapper.a {\n    width: 54.9834%;\n    max-width: 331px\n}\n\n.points-image-wrapper.b {\n    width: 42.3588%;\n    max-width: 255px\n}\n\n.points-image-wrapper.c {\n    width: 100%;\n    max-width: 602px\n}\n\n.text-span-277 {\n    color: var(--pabloo-green-2)\n}\n\n.empty-state-12 {\n    background-color: #fff\n}\n\n.image-226 {\n    height: 140px\n}\n\n.section-70 {\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    padding-top: 24px;\n    padding-bottom: 120px\n}\n\n.image-227 {\n    height: 24px\n}\n\n.heading-263 {\n    margin-top: 0;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 30px\n}\n\n.features-wrapper-2 {\n    border: 1px solid #e4e4e4;\n    border-radius: 8px;\n    justify-content: space-around;\n    align-items: center;\n    margin-top: 24px;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex\n}\n\n.competitor-landing-hero-form-2 {\n    background-color: #fff;\n    border-left: 12px #5050ff;\n    border-radius: 8px;\n    flex-wrap: wrap;\n    justify-content: center;\n    padding: 24px;\n    font-family: Inter, sans-serif;\n    display: block;\n    box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n}\n\n.html-embed-39 {\n    margin-left: auto;\n    margin-right: auto;\n    display: block\n}\n\n.div-block-781 {\n    grid-column-gap: 48px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .7fr;\n    grid-auto-columns: 1fr;\n    align-items: start;\n    display: grid\n}\n\n.text-block-320 {\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1em\n}\n\n.div-block-782 {\n    justify-content: flex-start;\n    align-items: center;\n    width: auto;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.text-block-321 {\n    color: #d53987;\n    text-align: left;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px\n}\n\n.div-block-783 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: auto auto 1fr;\n    grid-auto-columns: 1fr;\n    justify-items: start;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto;\n    display: grid\n}\n\n.features-title {\n    margin-bottom: 8px;\n    font-size: 40px;\n    font-weight: 600;\n    line-height: 48px\n}\n\n.div-block-784 {\n    background-color: #f5cde1;\n    border-radius: 4px;\n    justify-content: center;\n    width: 100%;\n    margin-top: 16px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 4px 8px 8px;\n    display: flex\n}\n\n.features-block {\n    text-align: center;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.div-block-785 {\n    padding-right: 40px\n}\n\n.div-block-786 {\n    grid-column-gap: 12px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 28px 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid\n}\n\n.div-block-786.mt-sm {\n    margin-top: 12px\n}\n\n.heading-264 {\n    letter-spacing: -.5px;\n    margin-top: 24px;\n    font-size: 2.3rem;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.text-span-278 {\n    color: #d53987\n}\n\n.image-228 {\n    height: 24px\n}\n\n.div-block-787 {\n    justify-content: center;\n    margin-top: 24px;\n    display: flex\n}\n\n.features-title-small {\n    font-size: 24px;\n    line-height: 32px\n}\n\n.div-block-788 {\n    font-family: Inter, sans-serif\n}\n\n.sysf-collapse-text {\n    opacity: 0;\n    color: var(--systemflow-lite--neutral--80);\n    padding-top: 0;\n    padding-bottom: 12px;\n    padding-left: 32px;\n    display: none\n}\n\n.sysf-collapse-text.sysf-borderless {\n    padding-left: 12px\n}\n\n.material-icons.sysf-icon-left {\n    margin-top: 2px;\n    margin-right: 4px\n}\n\n.material-icons.sysf-icon-left.sysf-icon-collapse {\n    color: var(--systemflow-lite--neutral--80);\n    margin-top: 0;\n    margin-right: 0\n}\n\n.sysf-collapse-title {\n    flex: 1;\n    margin-left: 12px;\n    font-weight: 500;\n    display: inline-block\n}\n\n.sysf-collapse-trigger {\n    align-items: center;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    display: flex\n}\n\n.sysf-collapse-item-2 {\n    cursor: pointer;\n    padding-left: 16px;\n    padding-right: 16px\n}\n\n.sysf-collapse {\n    border-radius: 6px;\n    overflow: hidden\n}\n\n.sysf-collapse.sysf-borderless {\n    background-color: var(--systemflow-lite--neutral--10);\n    border-style: none;\n    padding: 24px\n}\n\n.sysf-collapse-wrapper {\n    max-width: 640px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.sysf-heading {\n    color: var(--systemflow-lite--neutral--100)\n}\n\n.sysf-heading.sysf-l {\n    letter-spacing: -.021em;\n    margin-top: 0;\n    margin-bottom: 1.25rem;\n    font-size: 2.25rem;\n    font-weight: 600;\n    line-height: 1.25\n}\n\n.sysf-tagline {\n    background-color: var(--white-smoke);\n    color: var(--pabloo-green);\n    letter-spacing: -.006em;\n    text-transform: uppercase;\n    border-radius: 6px;\n    margin-bottom: 3.05rem;\n    padding: 8px 67px;\n    font-size: 16px;\n    font-weight: 800;\n    line-height: 28px;\n    display: inline-block;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, .2)\n}\n\n.sysf-section-title {\n    width: 50%;\n    margin-bottom: 48px\n}\n\n.sysf-section-title.sysf-centered {\n    text-align: center;\n    text-align: center;\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.sysf-wrapper-m {\n    padding-top: 64px;\n    padding-bottom: 64px\n}\n\n.sysf-container {\n    max-width: 1248px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.sysf-c-b-neutral-20 {\n    background-color: var(--systemflow-lite--neutral--20)\n}\n\n.sysf-body-text {\n    color: var(--systemflow-lite--neutral--80);\n    margin-top: 0\n}\n\n.sysf-body-text.sysf-m {\n    letter-spacing: -.011em\n}\n\n.sysf-s-m-b-0 {\n    margin-bottom: 0\n}\n\n.sysf-faq-question {\n    margin-bottom: 8px;\n    font-weight: 600\n}\n\n.sysf-faq-item-wrapper {\n    margin-bottom: 24px\n}\n\n.sysf-faq-item-wrapper.sysf-box {\n    background-color: var(--systemflow-lite--neutral--20);\n    border-radius: 6px;\n    height: 100%;\n    margin-bottom: 24px;\n    padding: 24px\n}\n\n.sysf-faq-item-wrapper.sysf-box.sysf-last {\n    margin-bottom: 0\n}\n\n.sysf-column {\n    width: 50%;\n    padding-left: 12px;\n    padding-right: 12px\n}\n\n.sysf-row {\n    flex-direction: row;\n    align-items: stretch;\n    margin-left: -12px;\n    margin-right: -12px;\n    display: flex\n}\n\n.brix---heading-h3-size {\n    margin-top: 0;\n    margin-bottom: 2px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.2em\n}\n\n.brix---color-neutral-800 {\n    color: var(--elements-webflow-library--neutral--800)\n}\n\n.brix---color-accent-1 {\n    color: var(--pabloo-green)\n}\n\n.brix---display-2 {\n    font-size: 40px;\n    font-weight: 700;\n    line-height: 1.2em\n}\n\n.brix---mg-bottom-12px {\n    margin-bottom: 4px\n}\n\n.brix---text-center {\n    text-align: center\n}\n\n.brix---stat-card-4-cols---04 {\n    border-style: solid;\n    border-width: 1px 0 0 1px;\n    border-color: var(--elements-webflow-library--neutral--300);\n    border-bottom-right-radius: 24px;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    margin-left: -1px;\n    padding: 44px 20px;\n    display: flex\n}\n\n.brix---stat-card-4-cols---03 {\n    border-style: solid;\n    border-width: 1px 1px 0 0;\n    border-color: var(--elements-webflow-library--neutral--300);\n    border-bottom-left-radius: 24px;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 44px 20px;\n    display: flex\n}\n\n.brix---stat-card-4-cols---02 {\n    border: 1px solid var(--elements-webflow-library--neutral--300);\n    border-top-right-radius: 24px;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    margin-bottom: -1px;\n    margin-left: -1px;\n    padding: 12px;\n    display: flex\n}\n\n.brix---stat-card-4-cols---01 {\n    border: 1px solid var(--elements-webflow-library--neutral--300);\n    border-top-left-radius: 24px;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    margin-bottom: -1px;\n    margin-right: -1px;\n    padding: 12px;\n    display: flex\n}\n\n.brix---grid-2-stats-v4 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    margin-top: 24px;\n    display: grid\n}\n\n.brix---card {\n    border: 1px solid var(--elements-webflow-library--neutral--300);\n    background-color: var(--elements-webflow-library--neutral--100);\n    box-shadow: 0 2px 7px 0 var(--elements-webflow-library--general--shadow-01);\n    border-radius: 24px\n}\n\n.brix---heading-h2-size {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 50px\n}\n\n.brix---text-center-tablet {\n    text-align: left\n}\n\n.brix---grid-stats-v4 {\n    grid-column-gap: 70px;\n    grid-row-gap: 28px;\n    grid-template-rows: auto;\n    grid-template-columns: .4fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    display: grid\n}\n\n.brix---container-default {\n    max-width: 1218px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.brix---section {\n    color: var(--elements-webflow-library--neutral--100);\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.brix---image-width-100 {\n    width: 100%\n}\n\n.brix---border-radius-24px {\n    z-index: -1;\n    border-radius: 24px;\n    overflow: hidden;\n    transform: translate(0)\n}\n\n.brix---link-icon-right {\n    margin-left: 6px\n}\n\n.brix---text-200-bold {\n    color: var(--pabloo-green);\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    line-height: 20px\n}\n\n.brix---color-accent-2 {\n    color: var(--elements-webflow-library--accent--primary-1)\n}\n\n.brix---link-wrapper {\n    color: var(--systemflow-lite--neutral--80);\n    align-items: center;\n    font-size: 18px;\n    line-height: 20px;\n    text-decoration: none;\n    transition: color .3s;\n    display: flex\n}\n\n.brix---link-wrapper:hover {\n    color: var(--elements-webflow-library--accent--primary-1)\n}\n\n.brix---color-neutral-600 {\n    color: var(--elements-webflow-library--neutral--600)\n}\n\n.brix---paragraph-default {\n    margin-bottom: 0;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;\n    font-size: 18px;\n    line-height: 30px\n}\n\n.brix---mg-bottom-24px {\n    margin-bottom: 24px\n}\n\n.brix---heading-h3-size-2 {\n    margin-top: 0;\n    margin-bottom: 12px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Noto Sans, Ubuntu, Cantarell, Helvetica Neue, Oxygen, Fira Sans, Droid Sans, sans-serif;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 34px\n}\n\n.brix---color-neutral-801 {\n    color: var(--elements-webflow-library--neutral--800)\n}\n\n.brix---mg-bottom-8px {\n    margin-bottom: 8px\n}\n\n.brix---mg-bottom-48px {\n    color: var(--black);\n    margin-bottom: 0\n}\n\n.brix---card-link-content-left-fw {\n    border: 1px solid var(--elements-webflow-library--neutral--300);\n    background-color: var(--elements-webflow-library--neutral--100);\n    box-shadow: 0 2px 7px 0 var(--elements-webflow-library--general--shadow-01);\n    transform-style: preserve-3d;\n    border-radius: 24px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 48px 32px 32px;\n    text-decoration: none;\n    transition: transform .3s, color .3s;\n    display: flex\n}\n\n.brix---card-link-content-left-fw:hover {\n    transform: scale3d(.94, .94, 1.01)\n}\n\n.brix---grid-3-columns---1-col-mb {\n    grid-column-gap: 28px;\n    grid-row-gap: 28px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 40px;\n    display: grid\n}\n\n.brix---inner-container-600px---center {\n    max-width: 80%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.bold-text-26 {\n    font-size: 34px;\n    line-height: 1.3em\n}\n\n.div-block-789 {\n    margin-top: 0\n}\n\n.div-block-790 {\n    width: 100%\n}\n\n.text-block-322 {\n    text-transform: capitalize;\n    margin-top: 10px;\n    font-size: 21px;\n    font-weight: 900\n}\n\n.text-block-323 {\n    font-size: 16px;\n    line-height: 1.2\n}\n\n.button-new {\n    background-color: var(--pabloo-green);\n    border-radius: 9px;\n    margin-left: 0;\n    margin-right: auto;\n    padding: 16px 40px;\n    font-size: 20px;\n    font-weight: 600\n}\n\n.button-48 {\n    background-color: var(--pabloo-green);\n    border-radius: 8px;\n    padding: 3px 30px;\n    font-weight: 600\n}\n\n.youtube-3 {\n    margin-top: 34px\n}\n\n.image-229 {\n    z-index: 2;\n    position: static\n}\n\n.image-230 {\n    text-align: left;\n    height: 400px\n}\n\n.new-product-heading-4 {\n    color: var(--pabloo-green-2);\n    letter-spacing: -.5px;\n    margin-bottom: 16px;\n    font-family: Satoshi, sans-serif;\n    font-size: 44px;\n    line-height: 48px\n}\n\n.new-product-heading-4.max-width-400px {\n    max-width: 440px\n}\n\n.div-block-791 {\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    justify-content: flex-start;\n    display: flex\n}\n\n.image-231 {\n    height: 400px\n}\n\n.image-232 {\n    height: 500px\n}\n\n.image-233 {\n    text-align: right;\n    height: 400px\n}\n\n.image-234 {\n    height: 500px\n}\n\n.image-235 {\n    height: 400px\n}\n\n.image-236 {\n    height: 500px\n}\n\n.text-block-324 {\n    color: var(--pabloo-green-2);\n    text-align: center;\n    text-transform: uppercase;\n    font-size: 16px;\n    font-weight: 600\n}\n\n.hero-platform-wrapper-solutions {\n    z-index: 2;\n    width: 90%;\n    max-width: 1280px;\n    min-height: 200px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 120px 8% 0;\n    position: relative\n}\n\n.hero-platform-wrapper-solutions.padding-bottom-md {\n    padding-bottom: 80px\n}\n\n.image-237 {\n    object-fit: contain;\n    height: 100%\n}\n\n.heading-64px-copy {\n    letter-spacing: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 64px;\n    font-weight: 800;\n    line-height: 112.5%\n}\n\n.heading-64px-copy.hero-home-heading {\n    display: inline\n}\n\n.heading-64px-copy.hero-home-heading.sales {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    transform: perspective(2000px)\n}\n\n.heading-64px-copy.hero-home-heading.zapier,\n.heading-64px-copy.hero-home-heading.snow {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    position: absolute;\n    transform: perspective(2000px)\n}\n\n.heading-64px-copy.hero-home-heading.top {\n    max-width: 515.278px\n}\n\n.heading-64px-copy.hero-home-heading.bottom {\n    z-index: 2;\n    transition: all .2s;\n    position: relative\n}\n\n.heading-64px-copy.hero-home-heading.mail,\n.heading-64px-copy.hero-home-heading.inter,\n.heading-64px-copy.hero-home-heading.adobe,\n.heading-64px-copy.hero-home-heading.jira,\n.heading-64px-copy.hero-home-heading.hubspot,\n.heading-64px-copy.hero-home-heading.zendesk {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    position: absolute;\n    transform: perspective(2000px)\n}\n\n.heading-64px-copy.text-align-center {\n    text-align: center;\n    margin-top: 15px;\n    padding-left: 69px;\n    padding-right: 69px;\n    font-size: 32px\n}\n\n.heading-64px-copy.text-align-center.ebook {\n    color: #7e7d7d;\n    font-family: Satoshi, sans-serif;\n    font-size: 20px\n}\n\n.heading-64px-copy.text-align-center.events {\n    text-transform: uppercase;\n    font-family: Satoshi, sans-serif;\n    font-size: 20px\n}\n\n.heading-64px-copy.blogs-hero-heading {\n    text-align: center\n}\n\n.heading-64px-copy.resource-hero-heading {\n    color: var(--white);\n    text-align: left\n}\n\n.heading-64px-copy.saas-hero-heading,\n.heading-64px-copy.cloud-hero-heading {\n    margin-bottom: 4px\n}\n\n.heading-64px-copy.skewed {\n    transform: rotate(-11deg)\n}\n\n.heading-64px-copy.skewed.text-color-pink {\n    color: var(--pabloo-green-2);\n    margin-top: -16px;\n    margin-left: 12px;\n    margin-right: 12px\n}\n\n.heading-64px-new {\n    letter-spacing: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 64px;\n    font-weight: 800;\n    line-height: 112.5%\n}\n\n.heading-64px-new.hero-home-heading {\n    display: inline\n}\n\n.heading-64px-new.hero-home-heading.sales {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    transform: perspective(2000px)\n}\n\n.heading-64px-new.hero-home-heading.zapier,\n.heading-64px-new.hero-home-heading.snow {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    position: absolute;\n    transform: perspective(2000px)\n}\n\n.heading-64px-new.hero-home-heading.top {\n    max-width: 515.278px\n}\n\n.heading-64px-new.hero-home-heading.bottom {\n    z-index: 2;\n    transition: all .2s;\n    position: relative\n}\n\n.heading-64px-new.hero-home-heading.mail,\n.heading-64px-new.hero-home-heading.inter,\n.heading-64px-new.hero-home-heading.adobe,\n.heading-64px-new.hero-home-heading.jira,\n.heading-64px-new.hero-home-heading.hubspot,\n.heading-64px-new.hero-home-heading.zendesk {\n    background-color: var(--soft-pink);\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    perspective: 2000px;\n    position: absolute;\n    transform: perspective(2000px)\n}\n\n.heading-64px-new.text-align-center {\n    text-align: center;\n    flex-direction: column;\n    margin-top: 15px;\n    padding-left: 69px;\n    padding-right: 69px;\n    font-size: 32px;\n    line-height: 1.4;\n    display: flex\n}\n\n.heading-64px-new.blogs-hero-heading {\n    text-align: center\n}\n\n.heading-64px-new.resource-hero-heading {\n    color: var(--white);\n    text-align: left\n}\n\n.heading-64px-new.saas-hero-heading,\n.heading-64px-new.cloud-hero-heading {\n    margin-bottom: 4px\n}\n\n.heading-64px-new.skewed {\n    transform: rotate(-11deg)\n}\n\n.heading-64px-new.skewed.text-color-pink {\n    color: var(--pabloo-green-2);\n    margin-top: -16px;\n    margin-left: 12px;\n    margin-right: 12px\n}\n\n.image-238 {\n    object-fit: fill;\n    height: auto;\n    position: relative\n}\n\n.feature-image-wrapper-copy.right.green-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);\n    flex: 1;\n    width: 50%;\n    height: 550px;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy.left.yellow-bg {\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-image-wrapper-copy.left.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-content-heading-text-copy {\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 28px;\n    line-height: 1.4em\n}\n\n.image-240 {\n    max-width: 90%;\n    height: auto\n}\n\n.ctas-container-copy {\n    grid-column-gap: 40px;\n    grid-row-gap: 40px;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 84px;\n    padding-bottom: 95px;\n    display: flex\n}\n\n.ctas-text-wrapper-copy {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 50%;\n    max-width: 607px;\n    display: flex\n}\n\n.ctas-text-wrapper-copy._50 {\n    width: 50%\n}\n\n.heading-48px-copy.ctas-heading {\n    color: var(--white);\n    letter-spacing: 0;\n    max-width: 580px;\n    margin-bottom: 8px;\n    padding-bottom: 11px;\n    font-size: 28px;\n    line-height: 1.4\n}\n\n.paragraph-18px-copy.ctas-paragraph {\n    color: var(--white);\n    max-width: 600px;\n    margin-top: 12px;\n    margin-bottom: 32px;\n    line-height: 1.2;\n}\n\n.paragraph-18px-copy.ctas-paragraph.center-this {\n    color: var(--white);\n    max-width: 600px;\n    margin-top: 12px;\n    margin-bottom: 32px;\n    line-height: 1.2;\n    /* text-align: center; */\n}\n\n.ctas-button-contain-copy {\n    grid-column-gap: 18px;\n    grid-row-gap: 18px;\n    flex-wrap: wrap;\n    display: flex\n}\n\n.heading-48px-copy {\n    margin-top: 0;\n    margin-bottom: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 48px;\n    font-weight: 800;\n    line-height: 116.667%\n}\n\n.heading-48px-copy.stack-heading {\n    color: var(--white);\n    text-align: center;\n    max-width: 800px;\n    margin-bottom: 40px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-48px-copy.blogs-heading {\n    text-align: center;\n    max-width: 728px\n}\n\n.heading-48px-copy.ctas-heading {\n    color: var(--white);\n    max-width: 580px;\n    margin-bottom: 8px\n}\n\n.heading-48px-copy.ctas-heading._16px-bottom-margin {\n    margin-bottom: 16px\n}\n\n.heading-48px-copy.blog-post-title {\n    color: var(--dark-violet)\n}\n\n.heading-48px-copy.blog-post-title.cms {\n    color: #5b002c\n}\n\n.heading-48px-copy.setup-heading {\n    color: var(--white);\n    text-align: center;\n    max-width: 800px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.heading-48px-copy.points-heading {\n    color: var(--white);\n    max-width: 534px;\n    margin-bottom: 24px\n}\n\n.heading-28px-copy.ctas-subheading {\n    color: #f7e8c7;\n    margin-bottom: 20px\n}\n\n.paragraph-18px-copy {\n    font-size: 18px;\n    line-height: 156%\n}\n\n.paragraph-18px-copy.hero-home-paragraph {\n    color: var(--darker-violet);\n    margin-bottom: 24px\n}\n\n.paragraph-18px-copy.integrations-paragraph {\n    margin-bottom: 40px\n}\n\n.paragraph-18px-copy.stack-block-paragraph {\n    color: var(--white)\n}\n\n.paragraph-18px-copy.blog-post-summary._8px-bottom-margn {\n    margin-bottom: 8px\n}\n\n.paragraph-18px-copy.ctas-paragraph {\n    color: var(--white);\n    align-self: center;\n    max-width: 600px;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-left: 0;\n    font-size: 16px\n}\n\n.paragraph-18px-copy.tribe-tab-paragraph {\n    color: var(--dark-violet)\n}\n\n.paragraph-18px-copy.reviewer-position {\n    opacity: .8;\n    font-weight: 500\n}\n\n.paragraph-18px-copy.calculator-toggle-text {\n    font-weight: 700\n}\n\n.paragraph-18px-copy.resource-post-description {\n    color: #240213\n}\n\n.paragraph-18px-copy.saas-hero-paragraph {\n    max-width: 636px;\n    margin-bottom: 24px\n}\n\n.paragraph-18px-copy.cloud-hero-paragraph {\n    max-width: 527px;\n    margin-bottom: 24px\n}\n\n.paragraph-18px-copy.navigation-header-link-text {\n    font-family: Satoshi, sans-serif;\n    font-weight: 700\n}\n\n.paragraph-18px-copy.points-check-list-text {\n    color: var(--white)\n}\n\n.div-block-792 {\n    display: flex\n}\n\n.text-span-279 {\n    color: #a9e5dd\n}\n\n.heading-28px-copy {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 128.571%\n}\n\n.heading-28px-copy.type-card-heading {\n    max-width: 483px;\n    margin-bottom: 20px\n}\n\n.heading-28px-copy.ctas-subheading {\n    color: #f7e8c7;\n    margin-bottom: 11px;\n    font-size: 25px\n}\n\n.div-block-793 {\n    flex-direction: row;\n    flex: 0 auto;\n    order: 0;\n    justify-content: flex-start;\n    align-self: flex-start;\n    align-items: stretch;\n    display: flex\n}\n\n.image-242 {\n    margin-right: 4px\n}\n\n.heading-28px-copy-copy {\n    font-size: 28px;\n    font-weight: 600;\n    line-height: 128.571%\n}\n\n.heading-28px-copy-copy.type-card-heading {\n    max-width: 483px;\n    margin-bottom: 20px\n}\n\n.heading-28px-copy-copy.ctas-subheading {\n    color: #f7e8c7;\n    margin-top: 15px;\n    margin-bottom: 3px;\n    font-size: 18px;\n    font-weight: 400\n}\n\n.spend-analyse-footer {\n    padding: 56px\n}\n\n.image-243 {\n    margin-top: 7px\n}\n\n.ctas-text-wrapper-copy-copy {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 40%;\n    max-width: 607px;\n    display: flex\n}\n\n.ctas-text-wrapper-copy-copy._50 {\n    width: 50%\n}\n\n.ctas-text-wrapper-copy-copy-copy {\n    flex-direction: column;\n    align-items: flex-start;\n    width: 50%;\n    max-width: 607px;\n    display: flex\n}\n\n.ctas-text-wrapper-copy-copy-copy._50 {\n    width: 50%\n}\n\n.feature-image-wrapper-copy-copy {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 55%;\n    padding-top: 40px;\n    padding-left: 40px\n}\n\n.feature-image-wrapper-copy-copy.right {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    background-position: 100%;\n    padding-top: 40px;\n    padding-left: 0;\n    padding-right: 40px\n}\n\n.feature-image-wrapper-copy-copy.right.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    justify-content: flex-end;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.feature-image-wrapper-copy-copy.right.green-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);\n    flex: 1;\n    width: 50%;\n    height: 550px;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy-copy.right.green-bg.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy-copy.right.yellow-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    padding-bottom: 1px;\n    padding-right: 38px\n}\n\n.feature-image-wrapper-copy-copy.right.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy-copy.right.green-bg-copy {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    width: 50%;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy-copy.right.green-bg-copy.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy-copy.left {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)\n}\n\n.feature-image-wrapper-copy-copy.left.green-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy-copy.left.green-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy-copy.left.yellow-bg {\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-image-wrapper-copy-copy.left.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy-copy.left.yellow-bg.padding-left-reset {\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy-copy.left.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-image-wrapper-copy-copy.left.pink-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-content-wrap-copy {\n    width: 40%\n}\n\n.feature-image-wrapper-copy.left.yellow-bg {\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    height: auto;\n    padding-bottom: 32px\n}\n\n.image-245 {\n    max-width: 90%\n}\n\n.text-block-325 {\n    text-align: center;\n    flex: 0 auto;\n    margin-top: 11px;\n    font-size: 16px\n}\n\n.div-block-794 {\n    flex-direction: column;\n    flex: 0 auto;\n    justify-content: flex-start;\n    display: flex\n}\n\n.stats-wrapper-copy {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 0;\n    padding-top: 0;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.stats-section-copy {\n    width: 100%;\n    margin-top: 102px\n}\n\n.stats-wrapper-new {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 0;\n    padding-top: 0;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.stats-wrapper-new.ebook {\n    margin-top: 25px\n}\n\n.stats-wrapper-new.x {\n    padding-bottom: 40px\n}\n\n.stats-section-copy {\n    width: 100%;\n    display: block;\n    overflow: hidden\n}\n\n.stats-wrapper-copy {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    padding-top: 0;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.stats-section-copy {\n    width: 100%;\n    margin-top: 26px;\n    overflow: hidden\n}\n\n.hero-platform-cta-wrapper-copy {\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-top: 48px;\n    display: flex\n}\n\n.feature-image-wrapper-copy {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 55%;\n    padding-top: 40px;\n    padding-left: 40px\n}\n\n.feature-image-wrapper-copy.right {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    background-position: 100%;\n    padding-top: 40px;\n    padding-left: 0;\n    padding-right: 40px\n}\n\n.feature-image-wrapper-copy.right.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    justify-content: flex-end;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.feature-image-wrapper-copy.right.green-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);\n    flex: 1;\n    width: 50%;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy.right.green-bg.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy.right.yellow-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    padding-bottom: 1px;\n    padding-right: 38px\n}\n\n.feature-image-wrapper-copy.right.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy.right.green-bg-copy {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    width: 50%;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy.right.green-bg-copy.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy.left {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)\n}\n\n.feature-image-wrapper-copy.left.green-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy.left.green-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy.left.yellow-bg {\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex-direction: column;\n    flex: 1;\n    justify-content: flex-start;\n    align-items: center;\n    height: 550px;\n    padding-bottom: 32px;\n    display: flex\n}\n\n.feature-image-wrapper-copy.left.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy.left.yellow-bg.padding-left-reset {\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy.left.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    flex: 1;\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-image-wrapper-copy.left.pink-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.div-block-732-copy {\n    background-color: #fff;\n    width: 100%;\n    height: 180px;\n    margin-top: -227px;\n    padding-top: 0\n}\n\n.div-block-795 {\n    flex: 0 auto\n}\n\n.text-block-326 {\n    text-align: center;\n    margin-top: 20px\n}\n\n.hero-button-cta-copy {\n    text-align: center;\n    text-align: center;\n    background-color: #c73a88;\n    border-radius: 10px;\n    padding: 16px 50px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500\n}\n\n.div-block-796 {\n    flex-direction: column;\n    display: flex\n}\n\n.text-block-327 {\n    text-align: center;\n    margin-top: 20px;\n    font-size: 16px\n}\n\n.text-span-280,\n.text-span-281,\n.text-span-282 {\n    color: var(--pabloo-green-2)\n}\n\n.feature-image-wrapper-copy-copy-copy {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    background-position: 0%;\n    background-repeat: no-repeat;\n    background-size: contain;\n    width: 55%;\n    padding-top: 40px;\n    padding-left: 40px\n}\n\n.feature-image-wrapper-copy-copy-copy.right {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    background-position: 100%;\n    padding-top: 40px;\n    padding-left: 0;\n    padding-right: 40px\n}\n\n.feature-image-wrapper-copy-copy-copy.right.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    justify-content: flex-end;\n    padding-bottom: 40px;\n    display: flex\n}\n\n.feature-image-wrapper-copy-copy-copy.right.green-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653ba2d2f8b5205c6d78e9bf_Rectangle%2034624684%20\\(2\\).svg);\n    flex: 1;\n    width: 50%;\n    height: 500px;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy-copy-copy.right.green-bg.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy-copy-copy.right.yellow-bg {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    padding-bottom: 1px;\n    padding-right: 38px\n}\n\n.feature-image-wrapper-copy-copy-copy.right.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy-copy-copy.right.green-bg-copy {\n    text-align: right;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    flex: 1;\n    width: 50%;\n    min-height: auto;\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy-copy-copy.right.green-bg-copy.padding-right-reset {\n    padding-right: 0\n}\n\n.feature-image-wrapper-copy-copy-copy.left {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg)\n}\n\n.feature-image-wrapper-copy-copy-copy.left.green-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b45eb2d5e3e4b6b0e8e7f_Rectangle%2034624684.svg);\n    padding-bottom: 40px\n}\n\n.feature-image-wrapper-copy-copy-copy.left.green-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy-copy-copy.left.yellow-bg {\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-image-wrapper-copy-copy-copy.left.yellow-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy-copy-copy.left.yellow-bg.padding-left-reset {\n    padding-left: 0\n}\n\n.feature-image-wrapper-copy-copy-copy.left.pink-bg {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b49b018ac409314bb03ce_Rectangle%2034624776.svg);\n    height: 500px;\n    padding-bottom: 32px\n}\n\n.feature-image-wrapper-copy-copy-copy.left.pink-bg.padding-reset {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 0\n}\n\n.text-span-283,\n.text-span-284 {\n    color: var(--pabloo-green-2)\n}\n\n.logos-main-wrapper-copy {\n    width: 100%;\n    position: relative\n}\n\n.splide-copy {\n    position: relative\n}\n\n.splide__track-copy {\n    display: flex;\n    position: relative\n}\n\n.logo-colour-overlay-copy {\n    z-index: 2;\n    background-color: var(--dark-violet);\n    mix-blend-mode: color;\n    display: block;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.splide__list-copy {\n    flex: none;\n    display: flex;\n    position: relative\n}\n\n.image-212-copy {\n    height: 42px\n}\n\n.image-212-copy-copy {\n    object-fit: contain;\n    height: 36px\n}\n\n.hero-heading-copy {\n    text-align: center\n}\n\n.hero-heading-copy.competitor-landing-usp-highlight-heading {\n    color: var(--white)\n}\n\n.home-value-heading-copy {\n    color: #fff;\n    margin-bottom: 20px\n}\n\n.new-navigation-background-div {\n    z-index: 1;\n    opacity: 0;\n    background-color: #fff;\n    width: 100%;\n    max-width: 100%;\n    margin: 0;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)\n}\n\n.new-navigation-background-div.dark {\n    background-color: var(--black-2)\n}\n\n.div-block-20-copy {\n    margin-top: 0%;\n    padding: 0% 8px 32%;\n    position: relative\n}\n\n.div-block-21-copy {\n    background-color: #fff;\n    border-radius: 8px;\n    padding: 48px;\n    position: static;\n    box-shadow: 1px 1px 24px rgba(0, 0, 0, .1)\n}\n\n.div-block-21-copy.registration-form-block {\n    -webkit-backdrop-filter: blur(8px);\n    backdrop-filter: blur(8px);\n    outline-offset: 0px;\n    background-color: #f0f0f0;\n    border: 12px solid rgba(213, 57, 135, .16);\n    outline: 3px #000;\n    margin-top: 30px;\n    margin-bottom: 0;\n    padding: 11px 20px 16px;\n    box-shadow: 3px 3px 24px rgba(0, 0, 0, .1)\n}\n\n.navigation-background-div-black {\n    z-index: 1;\n    opacity: 0;\n    background-color: #fff;\n    border-radius: 12px;\n    width: 94%;\n    max-width: 1312px;\n    margin: 10px auto;\n    position: absolute;\n    top: 0%;\n    bottom: 0%;\n    left: 0%;\n    right: 0%;\n    box-shadow: 0 20px 80px rgba(8, 9, 10, .1)\n}\n\n.navigation-background-div-black.dark {\n    background-color: #18020d;\n    border-radius: 0;\n    width: 100%;\n    max-width: 100%;\n    margin-top: 0;\n    margin-bottom: 0\n}\n\n.html-embed-40 {\n    color: var(--pabloo-green-2);\n    font-weight: 600\n}\n\n.text-span-285 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-286,\n.text-span-287,\n.text-span-288,\n.text-span-289 {\n    color: var(--black)\n}\n\n.text-span-290 {\n    color: var(--pabloo-green)\n}\n\n.hero-button-cta-slack {\n    text-align: center;\n    background-color: #c73a88;\n    border-radius: 10px;\n    padding: 16px 32px;\n    font-family: Satoshi, sans-serif;\n    font-weight: 500\n}\n\n.text-block-328 {\n    color: var(--pabloo-green-2);\n    text-align: center;\n    font-weight: 600\n}\n\n.features-section-copy {\n    padding-top: 0;\n    padding-bottom: 120px;\n    display: flex\n}\n\n.features-wrapper-copy {\n    width: 90%;\n    max-width: 1280px;\n    margin-top: 83px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.image-231-copy {\n    height: 500px\n}\n\n.fast-track-approval-hero-section-copy {\n    background-color: var(--white-smoke);\n    margin-bottom: 240px;\n    position: relative\n}\n\n.wrapper-1280px-copy {\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-bottom: 100px;\n    display: flex;\n    position: relative\n}\n\n.wrapper-1280px-copy.popup-div {\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.wrapper-1280px-copy.solution-wrapper {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.split-wrapper {\n    flex-direction: column;\n    align-items: stretch;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.finance-wrapper {\n    flex-direction: column;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.together-blue-flex {\n    max-width: 1200px\n}\n\n.wrapper-1280px-copy.discover-product-hero-flex {\n    flex-direction: column;\n    padding-top: 88px;\n    padding-bottom: 0\n}\n\n.wrapper-1280px-copy.discover-purchase-flex {\n    padding-top: 120px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px-copy.discover-tools-flex {\n    max-width: 1260px;\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.procurement-black-flex {\n    flex-direction: column;\n    align-items: stretch;\n    padding-top: 140px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px-copy.case-study-hero-flex {\n    padding-top: 64px;\n    padding-bottom: 64px\n}\n\n.wrapper-1280px-copy.case-study-flex {\n    justify-content: center\n}\n\n.wrapper-1280px-copy.track-approval-flex {\n    max-width: 1260px\n}\n\n.wrapper-1280px-copy.multi-channel-approval-flex {\n    max-width: 1200px;\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.wrapper-1280px-copy.workflow-approval-flex {\n    align-items: center;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.fast-track-approval-hero-flex {\n    z-index: 1;\n    flex-direction: column;\n    padding-top: 88px;\n    padding-bottom: 0\n}\n\n.wrapper-1280px-copy.document-one-place-flex {\n    padding-top: 120px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px-copy.best-deals-flex {\n    padding-top: 80px;\n    padding-bottom: 80px\n}\n\n.wrapper-1280px-copy.assisted-tools-flex {\n    padding-top: 70px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.assisted-purchasing-flex {\n    flex-direction: column;\n    padding-top: 88px;\n    padding-bottom: 0\n}\n\n.wrapper-1280px-copy.actionable-insight-flex {\n    padding-top: 120px;\n    padding-bottom: 120px\n}\n\n.wrapper-1280px-copy.contract-renewals-flex {\n    max-width: 1200px;\n    padding-top: 120px;\n    padding-bottom: 140px\n}\n\n.wrapper-1280px-copy.slack-steps-width-limiter {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 40px;\n    padding-bottom: 40px\n}\n\n.wrapper-1280px-copy.custo {\n    flex-wrap: wrap;\n    justify-content: center\n}\n\n.wrapper-1280px-copy.wrap {\n    flex-wrap: wrap\n}\n\n.wrapper-1280px-copy.custom {\n    padding-top: 40px;\n    padding-bottom: 80px\n}\n\n.wrapper-1280px-copy.pt-xs {\n    padding-top: 24px\n}\n\n.wrapper-1280px-copy.points-container {\n    z-index: 3\n}\n\n.fast-track-hero-wrapper-copy {\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 780px;\n    margin-top: 119px;\n    margin-bottom: 80px;\n    display: flex\n}\n\n.div-block-797 {\n    display: block;\n    position: relative\n}\n\n.navbar-logo-center-container {\n    z-index: 5;\n    background-color: transparent;\n    width: 1030px;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 20px\n}\n\n.navbar-logo-center-container.shadow-three {\n    width: 100%;\n    max-width: 1140px\n}\n\n.container-1290 {\n    width: 100%;\n    max-width: 940px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.navbar-wrapper-three {\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    position: relative\n}\n\n.navbar-brand-three {\n    z-index: 5;\n    position: absolute\n}\n\n.nav-menu-wrapper-three {\n    width: 100%\n}\n\n.nav-menu-three {\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0;\n    display: flex\n}\n\n.nav-menu-block {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 0;\n    display: flex\n}\n\n.nav-link-6 {\n    color: #1a1b1f;\n    letter-spacing: .25px;\n    margin-left: 5px;\n    margin-right: 5px;\n    padding: 5px 10px;\n    font-size: 14px;\n    line-height: 20px;\n    text-decoration: none\n}\n\n.nav-link-6:hover {\n    color: rgba(26, 27, 31, .75)\n}\n\n.nav-link-6:focus-visible {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 4px;\n    outline: 2px solid #0050bd\n}\n\n.nav-link-6[data-wf-focus-visible] {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 4px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown {\n    margin-left: 5px;\n    margin-right: 5px\n}\n\n.nav-dropdown-toggle {\n    letter-spacing: .25px;\n    padding: 5px 30px 5px 10px;\n    font-size: 14px;\n    line-height: 20px\n}\n\n.nav-dropdown-toggle:hover {\n    color: rgba(26, 27, 31, .75)\n}\n\n.nav-dropdown-toggle:focus-visible {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-toggle[data-wf-focus-visible] {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-icon {\n    margin-right: 10px\n}\n\n.nav-dropdown-list {\n    background-color: #fff;\n    border-radius: 12px\n}\n\n.nav-dropdown-list.w--open {\n    padding-top: 10px;\n    padding-bottom: 10px\n}\n\n.nav-dropdown-link {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    font-size: 14px\n}\n\n.nav-dropdown-link:focus-visible {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-link[data-wf-focus-visible] {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-link-accent {\n    color: #1a1b1f;\n    letter-spacing: .25px;\n    margin-left: 5px;\n    margin-right: 20px;\n    padding: 5px 10px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n    text-decoration: none\n}\n\n.nav-link-accent:hover {\n    color: rgba(26, 27, 31, .75)\n}\n\n.button-primary {\n    color: #fff;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    background-color: #1a1b1f;\n    padding: 12px 25px;\n    font-size: 12px;\n    line-height: 20px;\n    transition: all .2s\n}\n\n.button-primary:hover {\n    color: #fff;\n    background-color: #32343a\n}\n\n.button-primary:active {\n    background-color: #43464d\n}\n\n.hello-bar-link {\n    color: var(--white);\n    font-size: 16px;\n    font-weight: 700\n}\n\n.new-hello-bar {\n    z-index: 7;\n    background-color: var(--pabloo-green);\n    text-align: center;\n    width: 100%;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    position: fixed\n}\n\n.text-span-291 {\n    font-weight: 900\n}\n\n.hello-navigation-bar {\n    z-index: 20;\n    background-color: var(--transparent);\n    /* margin-top: 48px; */\n    position: fixed;\n    top: 0;\n    bottom: auto;\n    left: 0%;\n    right: 0%\n}\n\n.hello-navbar-container {\n    z-index: 2;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 100vw;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    display: flex;\n    position: relative\n}\n\n.stats-section-copy-copy {\n    width: 100%;\n    margin-top: 0\n}\n\n.stats-wrapper-copy-copy {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    padding-top: 0;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.heading-90px-copy {\n    letter-spacing: -3.6px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 90px;\n    font-weight: 700;\n    line-height: 124.444%\n}\n\n.heading-24px-copy {\n    font-size: 24px;\n    line-height: 133.333%\n}\n\n.heading-24px-copy.stats-text {\n    margin-bottom: 4px;\n    font-weight: 500\n}\n\n.heading-24px-copy.type-card-subheading {\n    font-weight: 600\n}\n\n.heading-24px-copy.stack-block-heading {\n    margin-right: auto;\n    font-weight: 600\n}\n\n.heading-24px-copy.blog-post-title {\n    font-weight: 600\n}\n\n.heading-24px-copy.blog-post-title.resource-feature {\n    color: var(--white);\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 700\n}\n\n.heading-24px-copy.footer-logo-subtext {\n    font-weight: 500\n}\n\n.heading-24px-copy.tribe-link-heading {\n    color: var(--dark-violet)\n}\n\n.heading-24px-copy.review-text {\n    letter-spacing: 0;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 800\n}\n\n.heading-24px-copy.resource-tab-heading {\n    font-weight: 600\n}\n\n.heading-24px-copy.setup-card-text {\n    max-width: 230px;\n    font-size: 20px\n}\n\n.heading-24px-copy.navigation-header-heading {\n    font-family: Satoshi, sans-serif\n}\n\n.heading-24px-copy.stats-text-copy {\n    margin-bottom: 4px;\n    font-weight: 500;\n    line-height: 100%\n}\n\n.pitch-section-copy {\n    background-color: var(--white);\n    margin-top: 4px;\n    margin-bottom: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: block;\n    overflow: visible\n}\n\n.bold-text-30-copy {\n    letter-spacing: 0;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    font-size: 30px;\n    line-height: 100%;\n    display: block\n}\n\n.bold-text-31 {\n    white-space: normal;\n    font-size: 18px\n}\n\n.bold-text-31-copy {\n    white-space: normal;\n    font-size: 18px;\n    font-weight: 500\n}\n\n.stats-section-copy-copy {\n    width: 100%;\n    margin-top: 79px;\n    overflow: hidden\n}\n\n.wrapper-1300px-copy {\n    z-index: 2;\n    background-color: transparent;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 40px 34px;\n    display: flex;\n    position: relative\n}\n\n.home-hero-heading-copy {\n    font-size: 46px;\n    line-height: 1.2em\n}\n\n.home-hero-heading-copy.smaller {\n    font-size: 48px\n}\n\n.image-246 {\n    height: 32px\n}\n\n.cta-section-copy {\n    background-color: var(--pabloo-green);\n    padding-top: 0;\n    padding-bottom: 0\n}\n\n.div-block-798 {\n    height: 100px\n}\n\n.stats-grid-copy {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    width: 90%;\n    max-width: 1188px;\n    margin-top: 0;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.solutions-overview-sec-copy {\n    background-color: var(--darker-violet);\n    width: 100%;\n    display: none;\n    overflow: hidden\n}\n\n.hero-bkg-copy {\n    z-index: 0;\n    object-fit: fill;\n    object-position: 50% 0%;\n    background-color: rgba(255, 255, 255, 0);\n    flex: 1;\n    width: 100%;\n    height: 85%;\n    max-height: 900px;\n    display: block;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.home-split-section-copy {\n    background-color: var(--soft-pink);\n    padding-top: 90px;\n    padding-bottom: 0\n}\n\n.home-split-section-copy.light-grey-bg {\n    background-color: var(--white-smoke)\n}\n\n.home-split-section-copy.bottom-0 {\n    padding-bottom: 0\n}\n\n.home-split-section-copy._50-50 {\n    padding-top: 0;\n    padding-bottom: 50px\n}\n\n.wrapper-1300px-copy-copy {\n    z-index: 2;\n    background-color: transparent;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 71px 34px 40px;\n    display: flex;\n    position: relative\n}\n\n.wrapper-1300px-copy-copy.home-hero-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex\n}\n\n.wrapper-1300px-copy-copy.featured-on-wrapper {\n    width: 100%;\n    padding-top: 40px;\n    padding-bottom: 24px\n}\n\n.wrapper-1300px-copy-copy.center {\n    justify-content: center\n}\n\n.wrapper-1300px-copy-copy.mt-negative {\n    margin-top: -32px\n}\n\n.wrapper-1300px-copy-copy.p0 {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.wrapper-1300px-copy-copy.p-top-reset {\n    padding-top: 0\n}\n\n.wrapper-1300px-copy-copy._40-0 {\n    padding-bottom: 0\n}\n\n.wrapper-1300px-copy-copy._0-40 {\n    padding-top: 0\n}\n\n.image-247 {\n    text-align: left;\n    object-fit: contain;\n    height: 100%;\n    display: block\n}\n\n.hero-platform-image-slack {\n    text-align: left;\n    width: 100%;\n    height: 100%;\n    margin-top: 48px;\n    display: flex\n}\n\n.div-block-799 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 45px;\n    display: grid\n}\n\n.hero-button-cta-slack-copy {\n    text-align: center;\n    background-color: #c73a88;\n    border-radius: 10px;\n    padding: 16px 90px;\n    font-family: Inter, sans-serif;\n    font-weight: 600\n}\n\n.paragraph-152 {\n    text-align: left;\n    /* padding-right: 82px */\n}\n\n.paragraph-152.social {\n    text-align: left;\n    width: 100%\n}\n\n.blog-collection-item-copy.margin.custo {\n    border: 10px none var(--goldenrod);\n    background-color: var(--white);\n    border-radius: 0;\n    margin-bottom: 12px\n}\n\n.collection-list-8 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    flex: 0 auto;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: stretch;\n    padding-left: 24px;\n    padding-right: 24px;\n    display: grid\n}\n\n.collection-list-wrapper-7 {\n    flex-direction: column;\n    flex: 1;\n    order: 0;\n    justify-content: flex-start;\n    align-self: auto;\n    align-items: flex-start;\n    max-width: 1080px;\n    display: flex\n}\n\n.blog-hero-heading-copy {\n    color: var(--black);\n    letter-spacing: normal;\n    align-self: center;\n    max-width: 800px;\n    margin: 15px auto 20px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 52px\n}\n\n.text-span-292 {\n    color: var(--pabloo-green)\n}\n\n.hero-bkg-copy {\n    z-index: 1;\n    object-fit: fill;\n    object-position: 50% 0%;\n    background-color: rgba(255, 255, 255, 0);\n    width: 100%;\n    height: 85%;\n    max-height: 700px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.hero-bkg-copy.blog {\n    height: 100%;\n    max-height: none\n}\n\n.hero-bkg-copy.blog-cms {\n    max-height: 540px\n}\n\n.hero-bkg-copy.hub {\n    max-height: 621px\n}\n\n.hero-bkg-copy.saas {\n    max-height: 769px;\n    bottom: 10%\n}\n\n.hero-bkg-copy.cloud {\n    height: 90%;\n    max-height: 561px\n}\n\n.hero-bkg-copy-copy {\n    z-index: 0;\n    opacity: .41;\n    object-fit: fill;\n    object-position: 50% 0%;\n    background-color: rgba(255, 255, 255, 0);\n    width: 100%;\n    height: 85%;\n    max-height: 700px;\n    position: absolute;\n    top: auto;\n    bottom: 0%;\n    left: 0%;\n    right: 0%\n}\n\n.hero-bkg-copy-copy.blog {\n    height: 100%;\n    max-height: none\n}\n\n.hero-bkg-copy-copy.blog-cms {\n    max-height: 540px\n}\n\n.hero-bkg-copy-copy.hub {\n    max-height: 621px\n}\n\n.hero-bkg-copy-copy.saas {\n    max-height: 769px;\n    bottom: 10%\n}\n\n.hero-bkg-copy-copy.cloud {\n    height: 90%;\n    max-height: 561px\n}\n\n.blog-collection-item-copy {\n    background-color: var(--white);\n    border-radius: 10px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 520px;\n    padding: 24px 24px 38px;\n    display: flex;\n    box-shadow: 0 10px 80px rgba(0, 0, 0, .05)\n}\n\n.blog-collection-item-copy:hover {\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .1)\n}\n\n.blog-collection-item-copy.margin {\n    max-width: 440px;\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-right: 12px\n}\n\n.blog-collection-item-copy.margin.custo {\n    border: 10px none var(--goldenrod);\n    background-color: var(--white);\n    border-radius: 0;\n    max-width: 540px;\n    margin-bottom: 12px\n}\n\n.blog-collection-item-copy.margin.custo._1 {\n    margin-top: 0;\n    padding-top: 24px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.blog-collection-item-copy.margin.custo._2 {\n    background-image: none;\n    margin-left: 0;\n    margin-right: 12px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.blog-collection-item-copy.margin.mt-16 {\n    border-radius: 0;\n    margin-top: 0\n}\n\n.blog-collection-item-copy.limit-width {\n    max-width: 440px;\n    margin-left: 12px\n}\n\n.blog-collection-item-copy.limit-width.custo {\n    border: 10px none var(--goldenrod);\n    border-radius: 0\n}\n\n.blog-collection-item-copy.limit-width.custo.m-t-16 {\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 12px\n}\n\n.blog-collection-item-copy-copy.margin.custo {\n    border: 10px none var(--goldenrod);\n    background-color: var(--white);\n    border-radius: 0;\n    max-width: 540px;\n    margin-bottom: 12px\n}\n\n.blog-collection-item-copy-copy {\n    background-color: var(--white);\n    border-radius: 10px;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    max-width: 520px;\n    padding: 24px 24px 38px;\n    display: flex;\n    box-shadow: 0 10px 80px rgba(0, 0, 0, .05)\n}\n\n.blog-collection-item-copy-copy:hover {\n    box-shadow: 0 10px 40px rgba(0, 0, 0, .1)\n}\n\n.blog-collection-item-copy-copy.margin {\n    max-width: 440px;\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-right: 12px\n}\n\n.blog-collection-item-copy-copy.margin.custo {\n    border: 10px none var(--goldenrod);\n    background-color: var(--white);\n    border-radius: 0;\n    margin-bottom: 12px\n}\n\n.blog-collection-item-copy-copy.margin.custo._1 {\n    margin-top: 0;\n    padding-top: 24px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.blog-collection-item-copy-copy.margin.custo._2 {\n    background-image: none;\n    margin-left: 0;\n    margin-right: 12px;\n    padding-left: 24px;\n    padding-right: 24px\n}\n\n.blog-collection-item-copy-copy.margin.mt-16 {\n    border-radius: 0;\n    margin-top: 0\n}\n\n.blog-collection-item-copy-copy.limit-width {\n    max-width: 440px;\n    margin-left: 12px\n}\n\n.blog-collection-item-copy-copy.limit-width.custo {\n    border: 10px none var(--goldenrod);\n    border-radius: 0\n}\n\n.blog-collection-item-copy-copy.limit-width.custo.m-t-16 {\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 12px\n}\n\n.div-block-800 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-329 {\n    font-size: 32px\n}\n\n.text-block-330 {\n    text-align: center;\n    flex: 1;\n    margin-top: 69px;\n    margin-bottom: 46px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 36px;\n    font-weight: 700\n}\n\n.text-span-293 {\n    color: var(--pabloo-green-2)\n}\n\n.cms-blog-block-section-copy {\n    padding-bottom: 140px\n}\n\n.cms-blog-block-section-copy.templates-block {\n    margin-top: -176px\n}\n\n.bold-text-32 {\n    font-family: \"P22mackinacpro 12\", sans-serif\n}\n\n.blog-card-image-copy {\n    object-fit: cover;\n    width: 100%;\n    height: 100%\n}\n\n.blog-card-image-copy.custo {\n    object-fit: contain;\n    transform-style: preserve-3d\n}\n\n.blog-card-image-copy.custo:hover {\n    object-fit: contain;\n    transform: scale3d(1.1, 1.1, 1.1)\n}\n\n.about-hero-wrapper-copy {\n    background-color: var(--slate-blue);\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    margin-bottom: 90px;\n    padding-top: 120px;\n    padding-bottom: 0;\n    position: relative\n}\n\n.wrapper-1300px-copy {\n    z-index: 2;\n    background-color: transparent;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 2px 34px 40px;\n    display: flex;\n    position: relative\n}\n\n.wrapper-1300px-copy.home-hero-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex\n}\n\n.wrapper-1300px-copy.featured-on-wrapper {\n    width: 100%;\n    padding-top: 40px;\n    padding-bottom: 24px\n}\n\n.wrapper-1300px-copy.center {\n    justify-content: center\n}\n\n.wrapper-1300px-copy.mt-negative {\n    margin-top: -32px\n}\n\n.wrapper-1300px-copy.p0 {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.wrapper-1300px-copy.p-top-reset {\n    padding-top: 0\n}\n\n.wrapper-1300px-copy._40-0 {\n    padding-bottom: 0\n}\n\n.wrapper-1300px-copy._0-40 {\n    padding-top: 0\n}\n\n.new-about-1300px-header {\n    z-index: 2;\n    background-color: transparent;\n    border-radius: 16px;\n    flex-wrap: wrap;\n    width: 90%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 2px 34px 40px;\n    display: flex;\n    position: relative\n}\n\n.new-about-1300px-header.home-hero-flex {\n    flex-wrap: wrap;\n    justify-content: center;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex\n}\n\n.new-about-1300px-header.featured-on-wrapper {\n    width: 100%;\n    padding-top: 40px;\n    padding-bottom: 24px\n}\n\n.new-about-1300px-header.center {\n    justify-content: center\n}\n\n.new-about-1300px-header.mt-negative {\n    margin-top: -32px\n}\n\n.new-about-1300px-header.p0 {\n    padding-left: 0;\n    padding-right: 0\n}\n\n.new-about-1300px-header.p-top-reset {\n    padding-top: 0\n}\n\n.new-about-1300px-header._40-0 {\n    padding-bottom: 0\n}\n\n.new-about-1300px-header._0-40 {\n    padding-top: 0\n}\n\n.new-about-hero-wrapper {\n    background-color: var(--soft-pink);\n    background-image: none;\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: auto;\n    background-attachment: scroll;\n    margin-bottom: 90px;\n    padding-top: 176px;\n    padding-bottom: 79px;\n    position: relative\n}\n\n.text-span-294 {\n    color: var(--black);\n    font-size: 28px;\n    font-weight: 600\n}\n\n.xs-text {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 56px;\n    font-weight: 800\n}\n\n.about-heading-x {\n    color: var(--black-2);\n    margin-bottom: 20px;\n    font-size: 65px;\n    line-height: 110%\n}\n\n.about-heading-x.white {\n    color: var(--white)\n}\n\n.about-hero-text-wrap-copy {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.stats-section-copy-copy,\n.stats-about {\n    width: 100%;\n    overflow: hidden\n}\n\n.stats-wrapper-copy-copy,\n.stats-xx {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 0;\n    padding-top: 0;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.text-block-331 {\n    color: var(--pabloo-green-2);\n    text-align: left;\n    align-self: flex-start;\n    margin-left: 0;\n    font-size: 28px;\n    font-weight: 700;\n    display: none\n}\n\n.text-block-332 {\n    text-align: left;\n    padding-top: 35px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 46px;\n    line-height: 1.2\n}\n\n.text-block-332.intra {\n    text-align: center;\n    margin-bottom: 32px;\n    padding-right: 34px;\n    font-size: 46px\n}\n\n.text-span-295 {\n    color: var(--pabloo-green)\n}\n\n.div-block-801 {\n    border: 2px solid #cbd5e1;\n    border-radius: 10px;\n    width: 100%;\n    padding: 24px;\n    display: flex;\n    box-shadow: 0 0 2px rgba(0, 0, 0, .2)\n}\n\n.div-block-801:hover {\n    box-shadow: 0 8px 15px -7px rgba(0, 0, 0, .2)\n}\n\n.div-block-801.integra {\n    border-color: #d3d3d3\n}\n\n.div-block-802 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.image-248 {\n    border: 2px solid #cbd5e1;\n    border-radius: 10px;\n    height: 80px;\n    margin-right: 23px\n}\n\n.image-248._2-0 {\n    box-shadow: none;\n    border-width: 0\n}\n\n.div-block-803 {\n    line-height: 1.1\n}\n\n.text-block-333 {\n    text-align: left;\n    font-weight: 700\n}\n\n.div-block-804 {\n    flex-flow: column;\n    flex: 0 auto;\n    align-self: center;\n    display: flex\n}\n\n.div-block-805 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    padding-top: 0;\n    padding-bottom: 28px;\n    display: grid\n}\n\n.div-block-805.integra {\n    grid-template-columns: 1fr 1fr;\n    margin-top: 39px\n}\n\n.text-block-334,\n.text-block-335,\n.text-block-336 {\n    text-align: left\n}\n\n.tribe-section---about {\n    width: 100%;\n    padding-top: 50px;\n    padding-bottom: 50px;\n    overflow: hidden\n}\n\n.tribe-tab-image-contain-copy {\n    width: 100%;\n    padding-top: 57px;\n    padding-bottom: 57px;\n    display: none;\n    position: relative\n}\n\n.text-span-296 {\n    color: var(--pabloo-green-2)\n}\n\n.text-block-337 {\n    margin-top: 26px;\n    font-size: 16px\n}\n\n.div-block-806 {\n    height: 100px\n}\n\n.solutions-overview-sec-copy,\n.about-x-platform {\n    background-color: var(--darker-violet);\n    width: 100%;\n    overflow: hidden\n}\n\n.ctas-wrapper-copy {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529ed3e13ed5242e06f6cc0_CTA%20Bg.svg);\n    background-position: 0 0;\n    background-size: auto;\n    width: 100%;\n    max-width: 1440px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.about-x-platform-wrapper {\n    background-color: var(--dark-violet);\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6529ed3e13ed5242e06f6cc0_CTA%20Bg.svg);\n    background-position: 0 0;\n    background-size: auto;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.about-x-platform-wrapper.new {\n    margin-bottom: 73px\n}\n\n.ctas-container-copy {\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 84px;\n    padding-bottom: 95px;\n    display: flex\n}\n\n.about-x-platform-container {\n    flex-flow: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 90%;\n    max-width: 1280px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 180px;\n    padding-bottom: 160px;\n    display: flex\n}\n\n.text-block-338 {\n    color: var(--white);\n    text-align: center;\n    flex: 1;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 46px;\n    font-weight: 500;\n    line-height: 1.3\n}\n\n.text-span-297 {\n    color: var(--white)\n}\n\n.about-x-cards {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    margin-top: 66px;\n    display: grid\n}\n\n.about-x-cards.new {\n    flex-flow: wrap;\n    justify-content: center;\n    align-items: center;\n    justify-items: center;\n    display: flex\n}\n\n.about-x-card {\n    background-image: linear-gradient(150deg, #fdf0f1, #e3c0c1 77%);\n    border-radius: 15px;\n    margin-top: 0;\n    padding: 40px 29px\n}\n\n.about-x-card._1 {\n    background-image: linear-gradient(150deg, #d3fbf6, #a9e5dd 77%)\n}\n\n.about-x-card._3 {\n    background-image: linear-gradient(150deg, #fff4dc, #f0deb5 77%)\n}\n\n.about-x-card.new {\n    flex-flow: column;\n    flex: 0 auto;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 30%;\n    height: 250px;\n    display: flex\n}\n\n.text-block-339 {\n    text-transform: uppercase;\n    padding-bottom: 20px;\n    font-family: Satoshi, sans-serif;\n    font-size: 50px;\n    font-weight: 900;\n    line-height: 1.1\n}\n\n.text-block-339.new {\n    padding-bottom: 0;\n    font-size: 25px\n}\n\n.text-block-340 {\n    margin-top: 28px;\n    font-family: Satoshi, sans-serif;\n    font-size: 18px;\n    font-weight: 900;\n    line-height: 1.2\n}\n\n.text-block-340.new {\n    font-size: 22px\n}\n\n.text-block-341 {\n    text-align: left;\n    margin-top: 17px;\n    font-family: Satoshi, sans-serif;\n    font-size: 15px;\n    line-height: 1.3\n}\n\n.text-block-341.new {\n    font-weight: 500\n}\n\n.text-span-298,\n.text-span-299 {\n    color: var(--pabloo-green)\n}\n\n.div-block-807 {\n    flex-flow: column;\n    display: flex\n}\n\n.integra.x {\n    padding-top: 44px\n}\n\n.text-block-342 {\n    text-align: left\n}\n\n.text-block-342.intra {\n    margin-top: 10px;\n    font-size: 16px;\n    line-height: 1.2\n}\n\n.text-block-343 {\n    border: 2px solid var(--light-slate-grey);\n    text-align: left;\n    border-radius: 3px;\n    width: 90%;\n    margin-top: 0;\n    margin-bottom: 10px;\n    padding: 11px 21px;\n    font-weight: 900\n}\n\n.text-block-343:hover {\n    border-width: 2px;\n    border-color: var(--white-smoke);\n    background-color: var(--pabloo-green);\n    color: var(--white)\n}\n\n.text-block-343:active {\n    color: var(--dark-violet);\n    border-width: 2px\n}\n\n.div-block-808 {\n    flex-flow: column;\n    margin-top: 44px;\n    display: flex\n}\n\n.div-block-809 {\n    display: flex\n}\n\n.integra-btn {\n    margin-bottom: 13px\n}\n\n.tabs-menu-5 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    flex-flow: column;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr;\n    grid-auto-columns: 1fr;\n    align-content: start;\n    width: 90%;\n    margin: 34px 0 34px 5px;\n    display: grid\n}\n\n.tab-link-all,\n.tab-link-finance,\n.tab-link-sso,\n.tab-link-hrms {\n    margin-right: 21px\n}\n\n.integra-tab {\n    background-color: #fff;\n    border: 2px solid #d3d3d3;\n    border-radius: 10px;\n    width: 90%;\n    margin-top: 4px;\n    margin-bottom: 4px;\n    padding-top: 13px;\n    padding-bottom: 13px;\n    font-weight: 700\n}\n\n.integra-tab.w--current {\n    border-color: var(--pabloo-green);\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    width: 90%;\n    padding-top: 13px;\n    padding-bottom: 13px;\n    font-weight: 700\n}\n\n.integra-text {\n    font-weight: 700\n}\n\n.tabs-2 {\n    max-width: 1300px;\n    display: flex\n}\n\n.div-block-810 {\n    margin-top: 81px;\n    display: flex\n}\n\n.div-block-811 {\n    flex: 1\n}\n\n.div-block-812 {\n    width: 100%\n}\n\n.text-block-344 {\n    text-align: center;\n    flex-flow: row;\n    justify-content: center;\n    align-items: center;\n    width: 80%;\n    margin-bottom: 50px;\n    margin-left: auto;\n    margin-right: auto;\n    font-family: Inter, sans-serif;\n    display: flex\n}\n\n.pricing-block {\n    background-image: linear-gradient(283deg, rgba(77, 184, 129, .32), #f4fbf9);\n    border-radius: 13px;\n    padding: 27px 46px 46px;\n    display: block\n}\n\n.div-block-814 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    display: flex\n}\n\n.text-block-345 {\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 64px\n}\n\n.text-block-346 {\n    padding-right: 7px;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 30px;\n    font-weight: 500;\n    line-height: 64px\n}\n\n.text-block-347 {\n    margin-bottom: 21px;\n    font-size: 14px;\n    line-height: 1.3\n}\n\n.pricing-cards {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 40px;\n    display: grid\n}\n\n.pricing-card {\n    background-color: var(--white);\n    border-radius: 10px;\n    flex-flow: column;\n    height: 170px;\n    padding: 22px;\n    display: flex;\n    box-shadow: 0 2px 20px -8px rgba(0, 0, 0, .2)\n}\n\n.text-block-348 {\n    clear: none;\n    background-color: #0cc531;\n    border-radius: 6px;\n    flex-flow: row;\n    flex: 0 auto;\n    justify-content: flex-start;\n    align-self: flex-start;\n    align-items: stretch;\n    padding-left: 16px;\n    padding-right: 16px;\n    font-family: Satoshi, sans-serif;\n    font-size: 16px;\n    font-weight: 700;\n    display: flex;\n    position: static\n}\n\n.text-block-349 {\n    margin-top: 10px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-weight: 700\n}\n\n.text-block-350 {\n    font-size: 14px\n}\n\n.text-block-351 {\n    text-transform: uppercase;\n    font-weight: 700\n}\n\n.text-block-352 {\n    margin-top: 30px;\n    margin-bottom: 12px;\n    font-weight: 600\n}\n\n.container-offerings {\n    flex-flow: wrap;\n    display: flex\n}\n\n.div-block-816 {\n    background-color: var(--white);\n    border-radius: 4px;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 10px;\n    margin-right: 15px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-right: 18px;\n    display: flex;\n    box-shadow: 0 1px 11px -5px rgba(0, 0, 0, .2)\n}\n\n.text-block-353 {\n    color: var(--light-slate-grey);\n    flex: 1;\n    padding-left: 14px;\n    font-size: 13px;\n    font-weight: 500\n}\n\n.html-embed-41 {\n    padding-left: 10px\n}\n\n.html-embed-42 {\n    flex: 0 auto\n}\n\n.faq-section-x {\n    background-color: var(--dark-violet);\n    padding-top: 100px;\n    padding-bottom: 100px;\n    display: block\n}\n\n.faq-section-x.demo {\n    background-color: var(--white)\n}\n\n.faq-item-x {\n    background-color: var(--white);\n    border-radius: 20px;\n    margin-bottom: 20px;\n    padding: 24px 30px\n}\n\n.faq-item-x.demo {\n    background-color: var(--white-smoke);\n    box-shadow: 0 2px 3px rgba(0, 0, 0, .2)\n}\n\n.faq-question-trigger {\n    text-align: center;\n    cursor: pointer;\n    flex-flow: row;\n    align-content: center;\n    align-items: center;\n    margin-bottom: 9px;\n    padding-top: 0;\n    padding-bottom: 0;\n    display: flex\n}\n\n.sysf-custom-code-embeds {\n    display: none\n}\n\n.faq-drop-icon {\n    order: 0;\n    align-self: auto;\n    max-width: none;\n    height: 10px;\n    margin-right: 0;\n    padding-right: 0\n}\n\n.heading-265 {\n    text-align: left;\n    flex: 1;\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-right: 15px;\n    font-size: 22px;\n    line-height: 1.2\n}\n\n.faq-answer {\n    overflow: hidden\n}\n\n.paragraph-153 {\n    text-align: left;\n    margin-bottom: 15px;\n    padding-top: 16px;\n    padding-bottom: 16px;\n    padding-right: 12px;\n    font-size: 16px\n}\n\n.div-block-817 {\n    flex: 0 auto;\n    align-self: center;\n    padding: 6px;\n    font-size: 22px;\n    line-height: 1.2\n}\n\n.text-block-354 {\n    color: var(--white);\n    text-align: center;\n    margin-bottom: 60px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 42px;\n    line-height: 64px\n}\n\n.text-block-354.new {\n    color: var(--black-2)\n}\n\n.text-span-300 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-818 {\n    flex-flow: row;\n    display: flex\n}\n\n.text-block-355 {\n    color: var(--black-2);\n    flex: 1;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 42px;\n    line-height: 1.3\n}\n\n.button-49 {\n    align-self: center;\n    padding-left: 91px;\n    padding-right: 91px\n}\n\n.text-span-301 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-819 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 50px;\n    display: grid\n}\n\n.div-block-820 {\n    border-radius: 14px;\n    padding: 28px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, .2)\n}\n\n.heading-266 {\n    font-family: P22 Mackinacpro, sans-serif\n}\n\n.paragraph-154 {\n    margin-top: 0;\n    padding-top: 8px;\n    font-size: 16px;\n    line-height: 1.3\n}\n\n.section-71 {\n    display: block\n}\n\n.div-block-821 {\n    margin-bottom: 0\n}\n\n.section-72 {\n    float: none;\n    clear: both;\n    text-align: left;\n    width: 100%;\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 100px;\n    padding-left: 44px;\n    padding-right: 44px\n}\n\n.section-72.what-is-in {\n    padding-top: 45px;\n    padding-left: 44px;\n    padding-right: 44px\n}\n\n.section-72.why-read {\n    grid-column-gap: 22px;\n    grid-row-gap: 22px;\n    flex-flow: column;\n    padding-top: 0;\n    padding-bottom: 100px;\n    display: flex\n}\n\n.section-72.events {\n    padding-top: 100px\n}\n\n.section-72.testimonial {\n    padding-top: 100px;\n    padding-bottom: 100px\n}\n\n.section-72.expectation {\n    padding-top: 60px;\n    padding-bottom: 100px\n}\n\n.section-72.location {\n    padding: 0\n}\n\n.section-72.about-eve {\n    padding-top: 250px\n}\n\n.section-72.webinar {\n    padding-top: 44px;\n    padding-bottom: 44px\n}\n\n.section-72.webinar-about {\n    padding-top: 60px;\n    padding-bottom: 60px\n}\n\n.section-72.about-partners {\n    padding-top: 10px;\n    padding-bottom: 40px\n}\n\n.section-72.optimize {\n    height: 100%;\n    padding-top: 128px;\n    padding-bottom: 200px;\n    font-size: 16px;\n    font-weight: 400\n}\n\n.section-72.optimizef2 {\n    padding-top: 0;\n    padding-left: 0\n}\n\n.section-72.about {\n    padding-top: 0\n}\n\n.section-72.ads {\n    padding-top: 90px;\n    padding-bottom: 100px\n}\n\n.div-block-822 {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    flex-flow: row;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    width: 100%;\n    padding-left: 0;\n    padding-right: 0;\n    display: grid\n}\n\n.div-block-822.ebook {\n    background-color: var(--white);\n    display: flex\n}\n\n.div-block-823 {\n    background-color: var(--white);\n    object-fit: cover;\n    border-radius: 0;\n    flex-flow: column;\n    display: flex\n}\n\n.image-249 {\n    object-fit: cover;\n    background-color: #fff;\n    border-radius: 0 35px 35px 0;\n    flex: 0 auto;\n    align-self: auto;\n    height: 100%;\n    max-height: 100%;\n    display: block\n}\n\n.div-block-824 {\n    background-color: var(--soft-pink);\n    color: var(--black-2);\n    border-top-left-radius: 35px;\n    border-bottom-left-radius: 35px;\n    flex-flow: column;\n    justify-content: center;\n    align-items: flex-start;\n    height: 100%;\n    padding: 60px 41px 49px 81px;\n    display: flex\n}\n\n.div-block-824.ebook {\n    display: flex\n}\n\n.div-block-824.what {\n    background-color: var(--white)\n}\n\n.text-block-356 {\n    font-family: P22 Mackinacpro, sans-serif;\n    font-weight: 500\n}\n\n.text-block-357 {\n    margin-top: 0;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 50px;\n    font-weight: 700;\n    line-height: 1\n}\n\n.text-block-357.events {\n    font-size: 42px\n}\n\n.text-span-302 {\n    color: var(--pabloo-green)\n}\n\n.div-block-825 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 20px;\n    display: grid\n}\n\n.div-block-826 {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    display: flex\n}\n\n.image-250 {\n    width: 40px;\n    padding-right: 11px\n}\n\n.text-block-358 {\n    text-align: left;\n    margin-top: 33px;\n    margin-bottom: 81px;\n    line-height: 1.5\n}\n\n.div-block-827 {\n    z-index: 2;\n    background-color: var(--transparent);\n    justify-content: center;\n    align-items: center;\n    margin-top: -82px;\n    padding: 0 44px 44px;\n    display: flex;\n    position: static\n}\n\n.div-block-827.webniars {\n    margin-top: -170px\n}\n\n.div-block-828 {\n    background-color: var(--white);\n    border-radius: 14px;\n    flex: 0 auto;\n    align-self: auto;\n    width: 80%;\n    padding: 44px;\n    box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .2)\n}\n\n.text-block-359 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 52px;\n    font-weight: 700;\n    line-height: 1\n}\n\n.text-block-359.events {\n    font-size: 42px\n}\n\n.div-block-829 {\n    grid-column-gap: 19px;\n    grid-row-gap: 19px;\n    background-color: #f8f8f8;\n    border-radius: 20px;\n    width: 100%;\n    padding: 50px;\n    display: flex\n}\n\n.div-block-829.why {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/660fa460db21ea9df7c42d15_Group%202085664163.svg);\n    background-position: 0 0;\n    background-repeat: repeat;\n    background-size: cover;\n    background-attachment: scroll;\n    margin-top: 88px\n}\n\n.div-block-830 {\n    width: 40%\n}\n\n.div-block-830.why {\n    align-self: flex-start\n}\n\n.text-block-360 {\n    font-family: Inter, sans-serif;\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 1.2\n}\n\n.text-block-360.why {\n    color: var(--black-2);\n    width: 90%\n}\n\n.text-span-303 {\n    color: var(--pabloo-green-2)\n}\n\n.image-251 {\n    align-self: flex-start;\n    width: 40px;\n    height: 40px\n}\n\n.div-block-831 {\n    grid-column-gap: 17px;\n    grid-row-gap: 17px;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 11px;\n    display: flex\n}\n\n.div-block-832 {\n    flex: 1\n}\n\n.section-73 {\n    max-width: 1300px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-left: 44px;\n    padding-right: 44px\n}\n\n.text-block-361 {\n    text-align: center;\n    font-family: Inter, sans-serif;\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 1.2\n}\n\n.div-block-833 {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n    margin-bottom: 0;\n    display: flex\n}\n\n.div-block-834 {\n    background-color: #fef0f6;\n    border-radius: 25px;\n    padding: 22px 27px\n}\n\n.div-block-834._1 {\n    align-self: stretch\n}\n\n.div-block-834._2 {\n    background-color: #fff4d4;\n    background-image: none;\n    align-self: stretch\n}\n\n.div-block-834._3 {\n    background-color: #f0fef6;\n    flex: 0 auto;\n    align-self: stretch;\n    margin-top: 0\n}\n\n.text-block-362 {\n    text-align: center\n}\n\n.text-span-304 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-305 {\n    color: var(--pabloo-green)\n}\n\n.div-block-835 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/660fabd5aed4381a048727b1_Group%202085664155.svg);\n    background-position: 0 0;\n    background-size: cover;\n    border-radius: 20px;\n    padding: 70px;\n    display: flex\n}\n\n.text-block-363 {\n    color: var(--black-2);\n    font-size: 42px;\n    font-weight: 700\n}\n\n.div-block-836 {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    flex-flow: column;\n    width: 65%;\n    display: flex\n}\n\n.text-block-364 {\n    border-left: 4px solid var(--pabloo-green);\n    padding-left: 15px;\n    font-weight: 700\n}\n\n.text-block-365 {\n    width: 90%;\n    line-height: 1.5\n}\n\n.div-block-837 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 27px;\n    display: grid\n}\n\n.text-span-307 {\n    color: var(--pabloo-green)\n}\n\n.text-block-366 {\n    align-self: center\n}\n\n.div-block-840 {\n    flex-flow: row;\n    flex: 0 auto;\n    justify-content: flex-start;\n    align-self: auto;\n    align-items: flex-start;\n    display: block\n}\n\n.div-block-840.events {\n    padding-top: 12px;\n    padding-bottom: 12px\n}\n\n.text-block-370 {\n    font-family: \"P22mackinacpro 16\", sans-serif\n}\n\n.text-block-371 {\n    padding-top: 7px\n}\n\n.div-block-841 {\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    flex-flow: column;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    display: flex\n}\n\n.div-block-842 {\n    display: flex\n}\n\n.text-block-372 {\n    align-self: center;\n    padding-left: 10px\n}\n\n.div-block-843 {\n    margin-top: 0;\n    margin-bottom: 82px\n}\n\n.partners {\n    border-right: 0px solid var(--light-slate-grey);\n    padding-left: 9px;\n    padding-right: 9px\n}\n\n.partners.partner-logos {\n    object-fit: fill;\n    border: 0 solid #000;\n    margin-bottom: 3px;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 6px;\n    padding-right: 6px\n}\n\n.partners.partner-logos.pabloo {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    border-left-width: 0;\n    flex-flow: row;\n    flex: 1;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-top: 10px;\n    margin-left: 0;\n    display: grid\n}\n\n.partners._3 {\n    border-right-style: none;\n    border-right-width: 0\n}\n\n.div-block-845 {\n    grid-column-gap: 9px;\n    grid-row-gap: 9px;\n    flex-flow: wrap;\n    flex: 1;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-top: 5px;\n    display: flex\n}\n\n.image-253 {\n    object-fit: contain;\n    align-self: center;\n    height: 25px\n}\n\n.image-253.pabloo {\n    object-fit: fill;\n    position: absolute;\n    left: 10%\n}\n\n.image-254,\n.image-255 {\n    object-fit: contain;\n    height: 25px\n}\n\n.image-256,\n.image-257 {\n    height: 25px\n}\n\n.image-258 {\n    height: auto\n}\n\n.slick-slider {\n    grid-column-gap: 20px;\n    grid-row-gap: 20px;\n    flex-flow: row;\n    justify-content: space-around;\n    align-items: stretch;\n    display: flex\n}\n\n.slick-slider.cms-slider {\n    margin-top: 46px;\n    display: none\n}\n\n.testimonialx {\n    object-fit: fill;\n    background-color: #f0f0f0;\n    border-radius: 14px;\n    flex: none;\n    align-self: auto;\n    width: 49%;\n    margin-right: 20px;\n    padding: 40px 30px 40px 50px;\n    position: static\n}\n\n.text-block-374 {\n    margin-top: 20px;\n    margin-bottom: 20px\n}\n\n.testimonial-new-logo {\n    object-fit: fill;\n    height: 50px\n}\n\n.div-block-848 {\n    object-fit: none;\n    height: 50px\n}\n\n.text-block-375 {\n    color: var(--pabloo-green-2);\n    flex: 0 auto;\n    order: 0;\n    justify-content: center;\n    align-self: stretch;\n    align-items: flex-end;\n    margin-bottom: 0;\n    font-weight: 700;\n    display: block;\n    position: static\n}\n\n.div-block-849 {\n    grid-column-gap: 13px;\n    grid-row-gap: 13px;\n    justify-content: flex-end;\n    margin-bottom: 15px;\n    display: none\n}\n\n.testimonial-left-slider {\n    display: inline-block\n}\n\n.slide-nav-8 {\n    display: none\n}\n\n.slider-20 {\n    background-color: var(--white);\n    display: block\n}\n\n.mask-9 {\n    padding-left: 3px;\n    padding-right: 3px;\n    overflow: hidden\n}\n\n.text-block-376 {\n    margin-bottom: 65px;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 36px\n}\n\n.text-block-377 {\n    color: var(--black);\n    text-align: center;\n    margin-bottom: 0;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 42px\n}\n\n.text-block-377.new {\n    color: var(--white);\n    font-size: 42px\n}\n\n.text-block-377.pink {\n    color: var(--pabloo-green)\n}\n\n.text-span-308 {\n    color: var(--pabloo-green-2)\n}\n\n.text-block-378 {\n    text-align: center;\n    align-self: center;\n    width: 70%;\n    font-size: 16px\n}\n\n.div-block-850 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    background-color: #f7e0cb;\n    border-radius: 30px;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-top: 98px;\n    padding: 0;\n    display: flex\n}\n\n.div-block-850.partner {\n    grid-column-gap: 31px;\n    grid-row-gap: 31px;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 68px;\n    padding: 68px\n}\n\n.events-expectations-section {\n    background-image: radial-gradient(circle at 100% 100%, #e3c0c1, #fdf0f1);\n    border-radius: 20px;\n    flex-flow: row;\n    width: 100%;\n    padding: 3px;\n    display: flex\n}\n\n.event-exectations-tab {\n    flex-flow: column;\n    align-self: center;\n    width: 50%;\n    margin-top: 71px;\n    padding: 32px 28px 32px 40px;\n    display: flex\n}\n\n.event-expectation {\n    object-fit: cover;\n    border-radius: 20px;\n    width: 100%;\n    height: auto\n}\n\n.event-expectations-content {\n    flex: 1;\n    order: 0;\n    justify-content: flex-end;\n    align-self: auto;\n    align-items: center;\n    padding: 28px;\n    display: flex\n}\n\n.agenda-tab {\n    background-color: var(--transparent);\n    margin-top: 10px;\n    margin-bottom: 0;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    display: flex\n}\n\n.agenda-tab.w--current {\n    background-color: #eed6d6;\n    background-image: linear-gradient(154deg, #e3c0c1, #fdf0f1);\n    border-radius: 12px;\n    flex: 0 auto;\n    margin-bottom: 0;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 20px;\n    display: flex\n}\n\n.agenda-header {\n    align-self: center;\n    font-weight: 700\n}\n\n.image-259 {\n    object-fit: contain;\n    align-self: flex-start;\n    width: 50px;\n    margin-right: 20px\n}\n\n.tab-pane-tab-1-2 {\n    flex: 1\n}\n\n.agenda-description {\n    width: 70%;\n    margin-top: 5px;\n    font-size: 14px;\n    line-height: 1.4;\n    display: none\n}\n\n.agenda {\n    align-self: center\n}\n\n.text-block-379 {\n    z-index: 1;\n    align-self: flex-start;\n    margin-top: 58px;\n    margin-bottom: 0;\n    padding-left: 51px;\n    font-size: 26px;\n    font-weight: 700;\n    line-height: 1.2;\n    display: flex;\n    position: absolute;\n    left: auto\n}\n\n.tab-pane-tab-2-2,\n.tab-pane-tab-3-2 {\n    flex: 1\n}\n\n.text-block-380 {\n    color: var(--white);\n    text-align: center;\n    font-size: 40px;\n    font-weight: 700\n}\n\n.div-block-851 {\n    background-color: var(--dark-violet);\n    flex: 1;\n    padding-top: 105px;\n    padding-bottom: 105px\n}\n\n.paragraph-155 {\n    color: var(--pabloo-green-2);\n    text-align: center;\n    font-weight: 700\n}\n\n.definitions {\n    color: var(--pabloo-green-2);\n    text-align: center\n}\n\n.paragraph-156,\n.paragraph-157 {\n    color: var(--pabloo-green);\n    text-align: center\n}\n\n.paragraph-158,\n.paragraph-159,\n.paragraph-160,\n.paragraph-161,\n.paragraph-162,\n.paragraph-163 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-weight: 700\n}\n\n.paragraph-164 {\n    color: var(--pabloo-green);\n    text-align: center\n}\n\n.paragraph-165,\n.paragraph-166,\n.paragraph-167,\n.paragraph-168 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-weight: 700\n}\n\n.rich-text-block-30 {\n    text-align: justify;\n    flex: 0 auto;\n    margin-top: 44px\n}\n\n.image-260 {\n    flex: 1\n}\n\n.div-put {\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    display: flex\n}\n\n.inner-testimonial {\n    object-fit: cover;\n    flex-flow: column;\n    flex: 1;\n    justify-content: flex-start;\n    align-self: stretch;\n    align-items: flex-start;\n    width: 100%;\n    max-width: 100%;\n    height: 100%;\n    display: flex\n}\n\n.slider-container {\n    margin-top: 43px;\n    overflow: visible\n}\n\n.slider-track {\n    display: flex\n}\n\n.sysf-button-text {\n    font-weight: 500;\n    display: inline-block\n}\n\n.material-icons-2.sysf-icon-left {\n    margin-top: 2px;\n    margin-right: 4px\n}\n\n.sysf-text-icon-wrapper {\n    align-items: center;\n    display: flex\n}\n\n.sysf-link-with-icon {\n    text-decoration: none;\n    display: inline-block\n}\n\n.sysf-link-with-icon:hover {\n    color: var(--systemflow-lite--primary--70)\n}\n\n.sysf-link-with-icon:active {\n    color: var(--systemflow-lite--primary--80)\n}\n\n.sysf-link-with-icon:focus {\n    box-shadow: 0 0 0 2px var(--systemflow-lite--neutral--10), 0 0 0 5px var(--systemflow-lite--primary--60);\n    color: var(--systemflow-lite--primary--70)\n}\n\n.slider-button-right {\n    margin-left: 18px\n}\n\n.div-block-852 {\n    object-fit: cover;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6620cd07ce745a152a79ecad_Group%202085664001.png);\n    background-position: 0 0;\n    background-size: auto;\n    flex-flow: column;\n    display: block\n}\n\n.div-block-853 {\n    grid-column-gap: 26px;\n    grid-row-gap: 26px;\n    object-fit: fill;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6620edcbff94c4d9a8cb405b_Group%202085664001.png);\n    background-position: 0 0;\n    background-size: auto;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: center;\n    height: 600px;\n    padding: 82px;\n    display: flex\n}\n\n.text-block-381 {\n    border: 2px solid var(--pabloo-green);\n    color: var(--white);\n    text-align: center;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: center;\n    width: 150px;\n    padding: 6px 30px;\n    line-height: 1.2;\n    display: flex\n}\n\n.div-block-854 {\n    grid-column-gap: 14px;\n    grid-row-gap: 14px;\n    flex: 0 auto;\n    justify-content: flex-start;\n    align-self: center;\n    align-items: flex-start;\n    line-height: 1;\n    display: flex\n}\n\n.text-span-309 {\n    color: var(--pabloo-green)\n}\n\n.button-50 {\n    background-color: var(--white);\n    color: var(--black);\n    border-radius: 9px;\n    align-self: center;\n    padding: 15px 53px;\n    font-weight: 600;\n    line-height: 1.2\n}\n\n.button-50.pink {\n    background-color: var(--pabloo-green);\n    color: var(--white);\n    align-self: center;\n    padding-top: 15px;\n    padding-bottom: 15px\n}\n\n.button-50.partner {\n    color: var(--white);\n    background-color: #f45900\n}\n\n.div-block-855 {\n    grid-column-gap: 25px;\n    grid-row-gap: 25px;\n    margin-top: 15px;\n    display: flex\n}\n\n.privacy-link {\n    color: var(--pabloo-green);\n    text-decoration: none\n}\n\n.div-block-856 {\n    grid-column-gap: 25px;\n    grid-row-gap: 25px;\n    flex-flow: column;\n    display: flex\n}\n\n.div-block-857 {\n    background-color: var(--white);\n    border-radius: 40px;\n    width: 80%;\n    height: 600px;\n    margin-top: 40px;\n    margin-bottom: -230px\n}\n\n.html-embed-43 {\n    border-radius: 40px;\n    display: block\n}\n\n.sysf-button-text-2 {\n    font-weight: 500;\n    display: inline-block\n}\n\n.sysf-button {\n    background-color: var(--systemflow-lite--primary--60);\n    color: var(--systemflow-lite--neutral--10);\n    text-align: center;\n    align-items: center;\n    text-decoration: none;\n    transition: background-color .25s;\n    position: relative\n}\n\n.sysf-button:hover {\n    background-color: var(--systemflow-lite--primary--50)\n}\n\n.sysf-button:active {\n    background-color: var(--systemflow-lite--primary--70)\n}\n\n.sysf-button:focus {\n    box-shadow: 0 0 0 2px var(--systemflow-lite--neutral--10), 0 0 0 5px var(--systemflow-lite--primary--60)\n}\n\n.sysf-button.sysf-medium {\n    border-radius: 6px;\n    padding: 8px 12px\n}\n\n.sysf-button.sysf-medium:hover {\n    background-color: var(--systemflow-lite--primary--70)\n}\n\n.sysf-button.sysf-medium:active {\n    background-color: var(--systemflow-lite--primary--80)\n}\n\n.sysf-button.sysf-medium:focus {\n    background-color: var(--systemflow-lite--primary--70)\n}\n\n.about-pabloo-events {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: center;\n    margin-top: 92px;\n    display: flex\n}\n\n.about-pabloo-events.webinar {\n    grid-column-gap: 33px;\n    grid-row-gap: 33px;\n    margin-top: 60px\n}\n\n.text-block-382 {\n    color: var(--pabloo-green);\n    font-weight: 700\n}\n\n.div-block-858 {\n    grid-column-gap: 10px;\n    grid-row-gap: 10px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: flex-start;\n    display: grid\n}\n\n.logx-spend {\n    height: 50px\n}\n\n.div-block-859 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    background-color: rgba(247, 224, 203, 0);\n    border: 1px solid rgba(247, 170, 46, 0);\n    border-radius: 20px;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 0;\n    display: flex\n}\n\n.text-block-383 {\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 30px;\n    font-weight: 700\n}\n\n.text-block-384 {\n    color: #f45900;\n    font-family: P22 Mackinacpro, sans-serif;\n    font-size: 30px;\n    font-weight: 700\n}\n\n.text-block-385 {\n    text-align: center;\n    flex-flow: row;\n    width: 80%;\n    display: block\n}\n\n.collection-list-wrapper-8 {\n    flex-flow: wrap;\n    flex: 1;\n    margin-top: 10px;\n    display: flex\n}\n\n.div-block-860 {\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-top: 10px;\n    display: flex\n}\n\n.your-grid-container {\n    clear: none;\n    grid-column-gap: 4px;\n    grid-row-gap: 4px;\n    border-right: 0 solid #000;\n    border-radius: 0;\n    flex-flow: row;\n    flex: 1;\n    order: 0;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    grid-auto-flow: row;\n    align-items: center;\n    justify-items: start;\n    display: flex;\n    position: relative\n}\n\n.bold-text-33 {\n    color: var(--pabloo-green-2)\n}\n\n.features-wrapper-new {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    grid-auto-flow: row;\n    display: grid\n}\n\n.features-wrapper-new.yellow {\n    grid-column-gap: 0px;\n    grid-row-gap: 0px;\n    margin-top: 75px;\n    padding-left: 0\n}\n\n.feature-block-item {\n    display: block\n}\n\n.feature-block-item.yellow1 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628ac5bc34fcf44ab7feff5_yellow-bg.svg);\n    background-position: 0%;\n    background-repeat: repeat-y;\n    background-size: contain;\n    background-attachment: scroll;\n    justify-content: flex-start;\n    align-items: center;\n    height: 100%;\n    padding: 10%;\n    display: flex\n}\n\n.feature-block-item.yellow1.green1 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628cde57b512b59aa792c52_green-bg.svg);\n    background-position: 100%\n}\n\n.feature-block-item.yellow1.green1.yellow-right {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628ac5bc34fcf44ab7feff5_yellow-bg.svg)\n}\n\n.feature-block-item.yellow1.pink1 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628d4132a2e79bd87db2a0f_Rectangle%2034624776.svg)\n}\n\n.feature-block-item.yellow1.pink1.greenleft {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6628cde57b512b59aa792c52_green-bg.svg)\n}\n\n.feature-block-item.yellow2 {\n    grid-column-gap: 25px;\n    grid-row-gap: 25px;\n    flex-flow: column;\n    justify-content: center;\n    align-items: flex-start;\n    padding: 10% 10% 10% 5%;\n    display: flex\n}\n\n.feature-block-image {\n    object-fit: fill;\n    display: inline-block\n}\n\n.feature-block-image._2-0 {\n    box-shadow: none\n}\n\n.feature-block-content-logo {\n    height: 60px\n}\n\n.feature-text-header {\n    text-align: left;\n    align-self: stretch;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 32px;\n    font-weight: 700;\n    line-height: 1.3\n}\n\n.text-span-310 {\n    color: var(--pabloo-green)\n}\n\n.text-block-386 {\n    line-height: 1.4\n}\n\n.text-span-311,\n.text-span-312,\n.text-span-313,\n.text-span-314,\n.text-span-315,\n.text-span-316,\n.text-span-317 {\n    color: var(--pabloo-green)\n}\n\n.image-261 {\n    height: 150px;\n    position: absolute;\n    top: 2894.8px;\n    left: auto;\n    right: 29%;\n    box-shadow: 0 0 20px -9px rgba(0, 0, 0, .2)\n}\n\n.text-span-318,\n.text-span-319,\n.text-span-320,\n.text-span-321,\n.text-span-322,\n.text-span-323,\n.text-span-324,\n.text-span-325,\n.text-span-326,\n.text-span-327,\n.text-span-328,\n.text-span-329,\n.text-span-330,\n.text-span-331,\n.text-span-332,\n.text-span-333 {\n    color: var(--pabloo-green)\n}\n\n.link-43 {\n    color: var(--pabloo-green);\n    text-decoration: none\n}\n\n.paragraph-169 {\n    color: var(--pabloo-green);\n    text-align: center;\n    font-weight: 700\n}\n\n.text-span-334,\n.text-span-335 {\n    color: var(--pabloo-green)\n}\n\n.text-span-336 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-337 {\n    color: var(--pabloo-green)\n}\n\n.text-span-338 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-345,\n.text-span-346 {\n    color: var(--pabloo-green)\n}\n\n.text-span-347 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-348,\n.text-span-349,\n.text-span-350,\n.text-span-351,\n.text-span-352,\n.text-span-353,\n.text-span-354,\n.text-span-355 {\n    color: var(--pabloo-green)\n}\n\n.html-embed-44 {\n    display: block\n}\n\n.div-block-861 {\n    grid-column-gap: 24px;\n    grid-row-gap: 24px;\n    height: 100%;\n    display: flex\n}\n\n.div-block-862 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    text-align: left;\n    object-fit: cover;\n    background-image: linear-gradient(135deg, #fbeded, #FEC45B);\n    border-radius: 20px;\n    flex-flow: row;\n    flex: 0 auto;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-self: stretch;\n    align-items: center;\n    width: 30%;\n    max-height: 500px;\n    margin-bottom: 0;\n    padding-top: 2%;\n    padding-left: 0;\n    padding-right: 0;\n    display: flex;\n    overflow: visible\n}\n\n.div-block-863 {\n    grid-column-gap: 31px;\n    grid-row-gap: 31px;\n    background-image: linear-gradient(#f7e7c6, #fff4dc);\n    border-radius: 20px;\n    flex-flow: column;\n    width: 70%;\n    padding: 48px;\n    display: flex\n}\n\n.tabs-3 {\n    width: 90%;\n    max-width: 1300px;\n    display: block\n}\n\n.tabs-menu-6 {\n    grid-column-gap: 11px;\n    grid-row-gap: 11px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: stretch;\n    margin-top: 50px;\n    display: grid\n}\n\n.text-block-387 {\n    font-size: 25px;\n    font-weight: 400\n}\n\n.text-span-356 {\n    font-weight: 700\n}\n\n.text-span-357 {\n    color: var(--pabloo-green);\n    font-weight: 700\n}\n\n.image-262 {\n    object-fit: fill;\n    flex: 0 auto;\n    align-self: flex-end;\n    width: 260px;\n    margin-bottom: 0;\n    display: block\n}\n\n.image-262._2-0 {\n    align-self: center\n}\n\n.testimonial_tab_1 {\n    border-bottom: 5px solid var(--white-smoke);\n    background-color: #fff\n}\n\n.testimonial_tab_1.w--current {\n    border-bottom: 5px solid var(--pabloo-green);\n    background-color: rgba(200, 200, 200, 0)\n}\n\n.div-block-864 {\n    justify-content: center;\n    align-items: flex-start;\n    height: 40px;\n    display: flex\n}\n\n.text-block-388 {\n    text-align: justify;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 1.4\n}\n\n.text-span-358,\n.text-span-359 {\n    color: var(--pabloo-green);\n    font-weight: 800\n}\n\n.dropdown-2 {\n    width: 100%\n}\n\n.logos-quote-block {\n    border-bottom: 1px solid #e4ebf3;\n    padding: 60px 30px;\n    position: relative\n}\n\n.container-1292 {\n    width: 100%;\n    max-width: 940px;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.clients-wrapper-two {\n    justify-content: space-between;\n    align-items: center;\n    max-width: 820px;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex\n}\n\n.clients-card {\n    background-color: #f5f7fa;\n    flex-direction: column;\n    align-items: flex-start;\n    width: 50%;\n    padding: 24px;\n    display: flex\n}\n\n.clients-quote {\n    margin-bottom: 24px;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32px\n}\n\n.clients-info {\n    align-items: center;\n    font-size: 14px;\n    line-height: 20px;\n    display: flex\n}\n\n.clients-info-image {\n    object-fit: cover;\n    width: 50px;\n    height: 50px;\n    margin-right: 24px\n}\n\n.clients-grid {\n    grid-column-gap: 50px;\n    grid-row-gap: 50px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    justify-items: center;\n    display: grid\n}\n\n.image-263 {\n    object-fit: contain;\n    height: 50px\n}\n\n.text-span-360,\n.text-span-361,\n.text-span-362,\n.text-span-363,\n.text-span-364 {\n    color: var(--pabloo-green);\n    font-weight: 800\n}\n\n.slider-21,\n.slider-22 {\n    display: none\n}\n\n.text-span-365 {\n    font-weight: 800\n}\n\n.bold-text-34 {\n    font-weight: 500\n}\n\n.bold-text-35 {\n    font-weight: 900\n}\n\n.text-span-366,\n.text-span-367,\n.text-span-368,\n.text-span-369 {\n    color: var(--pabloo-green)\n}\n\n.div-block-865 {\n    display: flex\n}\n\n.tabs-4 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4f2ab2fe33ac69859f70_Group%202087326245news.png);\n    background-position: 0 0;\n    background-size: 100% 580px;\n    width: 100%;\n    height: 580px;\n    display: flex\n}\n\n.tabs-menu-7 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4bbc17ed885772b7ec8f_Bgx.png);\n    background-position: 0 0;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 20px;\n    flex: 0 auto;\n    width: 40%;\n    padding: 13px;\n    display: flex\n}\n\n.tabs-content-5 {\n    width: 60%\n}\n\n.tab-link-tab-1-3 {\n    background-color: var(--transparent);\n    height: 100px;\n    padding-right: 10px;\n    display: flex\n}\n\n.tab-link-tab-1-3.w--current {\n    background-color: var(--transparent);\n    color: var(--black);\n    flex: 0 auto;\n    height: 100px;\n    padding-right: 10px;\n    font-weight: 700;\n    display: flex\n}\n\n.tab-link-tab-2-3 {\n    background-color: var(--transparent);\n    color: var(--light-slate-grey);\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n    padding-left: 10px;\n    padding-right: 10px;\n    display: flex\n}\n\n.tab-link-tab-2-3.w--current {\n    background-color: var(--transparent);\n    font-weight: 700\n}\n\n.tab-link-tab-3-2 {\n    background-color: var(--transparent);\n    color: var(--black);\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    height: 100px;\n    padding-left: 10px;\n    display: flex\n}\n\n.tab-link-tab-3-2.w--current {\n    background-color: var(--transparent);\n    justify-content: center;\n    align-items: flex-end;\n    font-weight: 700\n}\n\n.div-block-867 {\n    color: var(--black);\n    flex: 0 auto;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.text-block-389 {\n    color: var(--black);\n    padding-right: 10px;\n    font-size: 22px\n}\n\n.div-block-868 {\n    flex-flow: column;\n    justify-content: center;\n    align-items: center;\n    height: 580px;\n    padding: 44px;\n    display: flex\n}\n\n.image-264 {\n    display: inline-block\n}\n\n.div-block-869 {\n    height: 100px\n}\n\n.div-block-869.new {\n    height: 50px\n}\n\n.body-6 {\n    font-family: P22, sans-serif\n}\n\n.collection-list-wrapper-9 {\n    margin-bottom: 30px\n}\n\n.text-block-390 {\n    font-size: 30px\n}\n\n.text-block-391 {\n    text-align: center;\n    margin-top: 30px;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 90px;\n    line-height: 1\n}\n\n.text-span-370 {\n    color: var(--pabloo-green)\n}\n\n.image-265,\n.image-266 {\n    height: 32px\n}\n\n.popup-modal-new {\n    z-index: 29;\n    background-color: rgba(0, 0, 0, .33);\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    display: none;\n    position: fixed;\n    top: 0;\n    overflow: hidden;\n    transform: translate(0)\n}\n\n.code-embed {\n    margin-top: 21px\n}\n\n.div-block-870 {\n    object-fit: contain;\n    width: 45%\n}\n\n.text-block-392 {\n    text-align: center\n}\n\n.bold-text-36 {\n    white-space: normal;\n    font-size: 30px;\n    line-height: 1\n}\n\n.div-block-871 {\n    background-color: #fdeddf;\n    background-image: linear-gradient(100deg, #fdeddf, #e8c5a7);\n    border-radius: 28px;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 97px;\n    padding: 50px 30px 39px;\n    display: flex\n}\n\n.text-block-393 {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: 700\n}\n\n.text-span-371 {\n    color: var(--pabloo-green)\n}\n\n.div-block-872 {\n    grid-column-gap: 6px;\n    grid-row-gap: 6px;\n    border: 2px solid #ffacd6;\n    border-radius: 20px;\n    justify-content: center;\n    align-items: flex-start;\n    width: 35%;\n    padding: 4px;\n    display: flex\n}\n\n.div-block-872.new {\n    width: 60%\n}\n\n.div-block-873 {\n    height: 100%;\n    display: flex\n}\n\n.div-block-874 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    justify-content: center;\n    align-items: flex-start;\n    margin-top: 30px;\n    display: flex\n}\n\n.text-block-394 {\n    color: var(--pabloo-green-2);\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 40px;\n    font-weight: 500;\n    line-height: 1.2\n}\n\n.text-block-395 {\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 40px\n}\n\n.div-block-875 {\n    justify-content: center;\n    align-items: flex-start;\n    font-family: Satoshi, sans-serif;\n    font-size: 22px;\n    font-weight: 500;\n    display: flex\n}\n\n.div-block-876 {\n    margin-top: 30px\n}\n\n.text-block-396 {\n    padding-right: 10px;\n    font-weight: 700\n}\n\n.div-block-877 {\n    grid-column-gap: 8px;\n    grid-row-gap: 8px;\n    flex: 0 auto;\n    display: flex\n}\n\n.div-block-878 {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    justify-content: center;\n    align-items: center;\n    margin-top: 0;\n    display: flex\n}\n\n.image-267 {\n    flex: 0 auto;\n    align-self: flex-start\n}\n\n.text-block-397 {\n    align-self: flex-start;\n    font-weight: 500\n}\n\n.div-block-879 {\n    grid-column-gap: 12px;\n    grid-row-gap: 12px;\n    flex-flow: column;\n    display: flex\n}\n\n.div-block-880 {\n    grid-column-gap: 15px;\n    grid-row-gap: 15px;\n    flex-flow: wrap;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: flex-start;\n    margin-top: 30px;\n    margin-bottom: 110px;\n    display: flex\n}\n\n.div-block-881 {\n    justify-content: center;\n    align-items: flex-start;\n    display: flex\n}\n\n.div-block-881.new {\n    width: 60%\n}\n\n.text-span-372 {\n    color: var(--pabloo-green)\n}\n\n.text-block-398 {\n    text-align: center;\n    justify-content: center;\n    align-items: flex-start;\n    width: 100%;\n    margin-top: 0;\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 1.2;\n    display: block\n}\n\n.text-block-398.pink {\n    color: var(--pabloo-green)\n}\n\n.div-block-882 {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: center;\n    display: flex\n}\n\n.text-span-373 {\n    color: var(--pabloo-green-2)\n}\n\n.div-block-883 {\n    grid-column-gap: 26px;\n    grid-row-gap: 26px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    height: auto;\n    margin-top: 20px;\n    display: grid\n}\n\n.text-block-399 {\n    flex: 0 auto;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 1.2\n}\n\n.div-block-884 {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    border: 3px solid #e9e7e7;\n    border-radius: 20px;\n    flex-flow: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 39px;\n    display: flex\n}\n\n.div-block-884:hover {\n    border-width: 0;\n    box-shadow: 1px 4px 9px rgba(0, 0, 0, .2)\n}\n\n.div-block-885 {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex\n}\n\n.text-block-400 {\n    text-align: left;\n    flex: 1\n}\n\n.text-block-401,\n.text-block-402 {\n    flex: 1\n}\n\n.button-51 {\n    padding-left: 60px\n}\n\n.button-52 {\n    background-color: var(--pabloo-green);\n    border-radius: 10px;\n    padding-left: 60px;\n    padding-right: 60px;\n    font-weight: 600\n}\n\n.text-span-374 {\n    color: var(--black)\n}\n\n.text-block-403 {\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 40px;\n    line-height: 1.2\n}\n\n.image-268 {\n    vertical-align: baseline;\n    height: 25px\n}\n\n.optimize-body {\n    -webkit-text-stroke-color: var(--white);\n    background-color: #0f1010\n}\n\n.div-block-887 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    margin-top: 69px;\n    padding-top: 2px;\n    display: grid\n}\n\n.image-269 {\n    height: 30px\n}\n\n.text-block-404,\n.text-block-405 {\n    font-size: 60px;\n    line-height: 1.2\n}\n\n.text-block-406 {\n    color: var(--white);\n    font-size: 60px;\n    line-height: 1.2\n}\n\n.text-block-407 {\n    color: var(--white);\n    font-family: Poppins, sans-serif;\n    font-size: 60px;\n    font-weight: 400;\n    line-height: 1.2\n}\n\n.div-block-888 {\n    width: 90%\n}\n\n.div-block-888.fold-2 {\n    padding-left: 47px\n}\n\n.text-span-375 {\n    color: #fff\n}\n\n.div-block-889 {\n    grid-column-gap: 30px;\n    grid-row-gap: 30px;\n    flex-flow: column;\n    justify-content: center;\n    align-items: flex-start;\n    padding-left: 72px;\n    display: flex\n}\n\n.text-block-408 {\n    color: #ccc;\n    text-transform: uppercase;\n    font-size: 18px\n}\n\n.div-block-890 {\n    background-color: rgba(47, 46, 46, .46);\n    border: 1px solid rgba(204, 204, 204, .2);\n    border-radius: 40px;\n    padding: 14px 30px\n}\n\n.image-270 {\n    height: 70px\n}\n\n.image-270.fold-2 {\n    height: 60px\n}\n\n.div-block-891 {\n    background-color: rgba(255, 255, 255, .04);\n    border: 2px solid rgba(86, 86, 86, .34);\n    border-radius: 20px;\n    justify-content: center;\n    align-items: flex-start;\n    width: 80%;\n    padding: 55px;\n    font-weight: 400;\n    line-height: 1.2;\n    display: block\n}\n\n.div-block-892 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664c80bcba5c5a09b4793611_Group%2024%20c.svg);\n    background-position: 50%;\n    background-repeat: repeat;\n    background-size: cover;\n    background-attachment: scroll\n}\n\n.div-block-892.fold-2 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664b1bf1d46e76a7588efa35_Shotfinal2.svg);\n    margin-left: auto;\n    margin-right: auto\n}\n\n.div-block-892.fold3 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664c331fcce04b8fbf79e758_Frame%2049fold3.svg);\n    background-position: 100% 100%;\n    background-repeat: no-repeat;\n    background-size: auto;\n    padding-bottom: 110px\n}\n\n.div-block-892.fold3.fold4 {\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664c26a5770e98317577f1a1_Shotfold3.svg);\n    background-size: cover;\n    border-bottom-right-radius: 50px;\n    border-bottom-left-radius: 50px\n}\n\n.code-embed-2 {\n    color: rgba(255, 255, 255, .8);\n    font-family: Inter, sans-serif;\n    font-size: 12px;\n    font-weight: 400\n}\n\n.div-block-893 {\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex\n}\n\n.link-block-38 {\n    border: 2px solid rgba(99, 99, 99, .59);\n    border-radius: 8px;\n    padding: 9px 24px\n}\n\n.div-block-894 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: .75fr 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: grid\n}\n\n.div-block-895 {\n    background-color: transparent;\n    background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/664a357bf8ff2dd87fcae846_Group%2011.svg);\n    background-position: 0 0;\n    background-size: cover;\n    justify-content: flex-end;\n    align-items: flex-start;\n    width: 100%;\n    padding-top: 40px;\n    padding-bottom: 40px;\n    padding-right: 40px;\n    display: flex\n}\n\n.image-271 {\n    width: 80%;\n    margin-bottom: 0\n}\n\n.text-block-410 {\n    color: #ccc;\n    margin-top: 40px;\n    margin-bottom: 40px\n}\n\n.button-53 {\n    background-color: var(--pabloo-green);\n    border-radius: 11px;\n    padding-left: 49px;\n    padding-right: 49px;\n    font-size: 16px\n}\n\n.div-block-896 {\n    justify-content: flex-start;\n    align-items: center;\n    height: 100%;\n    display: flex\n}\n\n.text-block-411 {\n    font-family: Poppins, sans-serif;\n    font-size: 60px\n}\n\n.text-block-412 {\n    flex: 1;\n    width: 50%;\n    padding-left: 24px;\n    font-family: Poppins, sans-serif;\n    font-size: 60px;\n    line-height: 1.2\n}\n\n.div-block-897 {\n    margin-top: -202px;\n    display: flex\n}\n\n.image-272 {\n    z-index: 1;\n    box-sizing: border-box;\n    flex: 0 auto;\n    order: 0;\n    width: 200px;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 220px;\n    overflow: visible\n}\n\n.div-block-898 {\n    grid-column-gap: 73px;\n    grid-row-gap: 73px;\n    flex-flow: column;\n    grid-template-rows: auto;\n    grid-template-columns: minmax(200px, .25fr) 1fr;\n    grid-auto-columns: 1fr;\n    justify-content: center;\n    align-items: flex-start;\n    display: flex\n}\n\n.text-block-413 {\n    font-size: 22px;\n    font-weight: 700\n}\n\n.text-block-414 {\n    box-sizing: content-box;\n    color: #ccc\n}\n\n.div-block-899 {\n    grid-column-gap: 19px;\n    grid-row-gap: 19px;\n    flex-flow: column;\n    flex: 0 auto;\n    justify-content: flex-start;\n    align-items: flex-start;\n    margin-top: 10px;\n    margin-bottom: 0;\n    padding-bottom: 34px;\n    display: flex\n}\n\n.div-block-899.onex {\n    grid-column-gap: 13px;\n    grid-row-gap: 13px\n}\n\n.div-block-899.two {\n    margin-top: 21px;\n    padding-top: 0\n}\n\n.div-block-899.three {\n    margin-top: 24px\n}\n\n.div-block-899.four {\n    margin-top: 10px\n}\n\n.div-block-900 {\n    grid-column-gap: 37px;\n    grid-row-gap: 37px;\n    margin-top: 86px;\n    display: flex\n}\n\n.image-273 {\n    width: 60px\n}\n\n.image-274 {\n    align-self: flex-start\n}\n\n.div-block-901 {\n    justify-content: flex-end;\n    align-items: flex-start;\n    display: flex;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 160px;\n    overflow: visible\n}\n\n.div-block-902 {\n    grid-column-gap: 60px;\n    grid-row-gap: 60px;\n    flex-flow: column;\n    width: 65%;\n    margin-top: 65px;\n    padding-left: 0;\n    padding-right: 37px;\n    display: flex\n}\n\n.text-block-415 {\n    font-family: Poppins, sans-serif;\n    font-size: 60px\n}\n\n.text-block-416 {\n    width: 60%\n}\n\n.div-block-903 {\n    grid-column-gap: 61px;\n    grid-row-gap: 61px;\n    flex-flow: column;\n    padding-left: 52px;\n    padding-right: 52px;\n    display: flex\n}\n\n.text-block-417 {\n    color: #ccc;\n    text-align: justify\n}\n\n.text-block-418 {\n    font-size: 22px\n}\n\n.div-block-904 {\n    background-color: rgba(255, 255, 255, .49);\n    width: 100%;\n    height: 1px;\n    margin-bottom: 20px\n}\n\n.div-block-905 {\n    grid-column-gap: 29px;\n    grid-row-gap: 29px;\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    display: flex\n}\n\n.navbar-logo-left.optimize {\n    z-index: 10;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100px;\n    display: flex;\n    position: fixed\n}\n\n.navbar-logo-left-container {\n    z-index: 5;\n    background-color: transparent;\n    width: 1030px;\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 15px 20px\n}\n\n.navbar-logo-left-container.shadow-three {\n    width: 100%;\n    max-width: 1140px;\n    margin-bottom: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-top: 20px;\n    padding-bottom: 20px\n}\n\n.container-1293 {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto\n}\n\n.navbar-wrapper {\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    display: flex\n}\n\n.navbar-brand {\n    flex: 0 auto\n}\n\n.nav-menu-wrapper {\n    flex: 1;\n    padding-left: 153px\n}\n\n.nav-menu-two {\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0;\n    margin-left: 0;\n    display: flex\n}\n\n.nav-link-7 {\n    color: #ccc;\n    letter-spacing: .25px;\n    margin-left: 5px;\n    margin-right: 5px;\n    padding: 5px 10px;\n    font-size: 14px;\n    line-height: 20px;\n    text-decoration: none\n}\n\n.nav-link-7:hover {\n    color: var(--white);\n    font-weight: 400\n}\n\n.nav-link-7:focus-visible {\n    outline-offset: 0px;\n    color: var(--white);\n    border-radius: 4px;\n    outline: 2px solid #0050bd\n}\n\n.nav-link-7[data-wf-focus-visible] {\n    outline-offset: 0px;\n    color: var(--white);\n    border-radius: 4px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-2 {\n    margin-left: 5px;\n    margin-right: 5px\n}\n\n.nav-dropdown-toggle-2 {\n    letter-spacing: .25px;\n    padding: 5px 30px 5px 10px;\n    font-size: 14px;\n    line-height: 20px\n}\n\n.nav-dropdown-toggle-2:hover {\n    color: rgba(26, 27, 31, .75)\n}\n\n.nav-dropdown-toggle-2:focus-visible {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-toggle-2[data-wf-focus-visible] {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-icon-2 {\n    margin-right: 10px\n}\n\n.nav-dropdown-list-2 {\n    background-color: #fff;\n    border-radius: 12px\n}\n\n.nav-dropdown-list-2.w--open {\n    padding-top: 10px;\n    padding-bottom: 10px\n}\n\n.nav-dropdown-link-2 {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    font-size: 14px\n}\n\n.nav-dropdown-link-2:focus-visible {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-dropdown-link-2[data-wf-focus-visible] {\n    outline-offset: 0px;\n    color: #0050bd;\n    border-radius: 5px;\n    outline: 2px solid #0050bd\n}\n\n.nav-divider {\n    background-color: #e4ebf3;\n    width: 1px;\n    height: 22px;\n    margin-left: 15px;\n    margin-right: 15px\n}\n\n.nav-link-accent-2 {\n    color: #1a1b1f;\n    letter-spacing: .25px;\n    margin-left: 5px;\n    margin-right: 20px;\n    padding: 5px 10px;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n    text-decoration: none\n}\n\n.nav-link-accent-2:hover {\n    color: rgba(26, 27, 31, .75)\n}\n\n.mobile-margin-top-11 {\n    padding-left: 0\n}\n\n.button-primary-2 {\n    color: #fff;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    background-color: #1a1b1f;\n    border: 1px solid #ccc;\n    border-radius: 12px;\n    padding: 12px 61px;\n    font-size: 12px;\n    line-height: 20px;\n    transition: all .2s\n}\n\n.button-primary-2:hover {\n    color: #fff;\n    background-color: #32343a\n}\n\n.button-primary-2:active {\n    background-color: #43464d\n}\n\n.button-primary-2.w--current {\n    border-color: rgba(204, 204, 204, .37)\n}\n\n.list-item-12 {\n    flex: 0 auto;\n    list-style-type: none\n}\n\n.div-block-906 {\n    display: none\n}\n\n.text-span-376 {\n    color: var(--pabloo-green);\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 56px;\n    font-style: normal\n}\n\n.div-block-907 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-content: start;\n    justify-content: start;\n    align-items: center;\n    display: grid\n}\n\n.text-block-419 {\n    margin-top: 0;\n    font-size: 24px;\n    line-height: 1.7\n}\n\n.text-block-420 {\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 50px;\n    display: none\n}\n\n.text-span-377 {\n    color: var(--pabloo-green-2)\n}\n\n.text-block-421 {\n    color: var(--white)\n}\n\n.text-block-422 {\n    color: var(--white);\n    text-align: center;\n    width: 75%;\n    font-weight: 400\n}\n\n.text-span-378 {\n    color: var(--pabloo-green);\n    font-weight: 700\n}\n\n.text-span-379 {\n    font-weight: 700\n}\n\n.div-block-908 {\n    grid-column-gap: 52px;\n    grid-row-gap: 52px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    align-items: center;\n    justify-items: center;\n    padding-left: 0;\n    padding-right: 0;\n    display: grid\n}\n\n.div-block-909 {\n    object-fit: contain;\n    flex-flow: row;\n    justify-content: center;\n    align-items: center;\n    width: 70%;\n    height: 50px;\n    display: flex\n}\n\n.text-block-423 {\n    text-align: center;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 34px\n}\n\n.div-block-910 {\n    grid-column-gap: 80px;\n    grid-row-gap: 80px;\n    flex-flow: column;\n    max-width: 1300px;\n    margin-bottom: 56px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 33px;\n    padding-left: 100px;\n    padding-right: 100px;\n    display: flex\n}\n\n.text-span-380 {\n    color: var(--pabloo-green-2)\n}\n\n.image-278 {\n    object-fit: contain;\n    flex: 0 auto;\n    width: 100%;\n    height: auto;\n    display: block\n}\n\n.text-span-381 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-382 {\n    color: var(--pabloo-green)\n}\n\n.text-block-424 {\n    color: var(--white);\n    text-align: center;\n    width: 85%;\n    margin-top: 40px\n}\n\n.div-block-911 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.text-block-425 {\n    font-family: \"P22mackinacpro 16\", sans-serif;\n    font-size: 32px;\n    font-weight: 500;\n    line-height: 1.5\n}\n\n.div-block-912 {\n    flex-flow: column;\n    justify-content: flex-start;\n    align-items: center;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    display: flex\n}\n\n.text-block-426 {\n    color: var(--elements-webflow-library--neutral--600);\n    margin-top: 10px;\n    margin-bottom: 10px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n    font-weight: 600;\n    line-height: 1.2\n}\n\n.div-block-913 {\n    flex-flow: column;\n    padding-top: 0;\n    padding-bottom: 13px;\n    display: flex\n}\n\n.image-279 {\n    height: 50px;\n    margin-top: auto;\n    margin-bottom: auto;\n    padding-top: 10px;\n    padding-bottom: 10px\n}\n\n.div-block-914 {\n    grid-column-gap: 16px;\n    grid-row-gap: 16px;\n    grid-template-rows: auto;\n    grid-template-columns: 1fr .5fr .5fr;\n    grid-auto-columns: 1fr;\n    display: grid\n}\n\n.div-block-914.x1 {\n    background-color: var(--white-smoke);\n    border-radius: 10px\n}\n\n.div-block-914.main {\n    padding-top: 35px;\n    padding-bottom: 35px\n}\n\n.div-block-915 {\n    border: 3px solid var(--pabloo-green);\n    border-radius: 20px;\n    width: 350px;\n    height: 730px;\n    margin-top: -705px;\n    margin-left: 45%;\n    position: absolute\n}\n\n.div-block-916 {\n    max-width: 1300px\n}\n\n.text-block-427 {\n    text-align: center;\n    margin-bottom: 0;\n    font-family: \"P22mackinacpro 12\", sans-serif;\n    font-size: 38px;\n    font-weight: 700;\n    line-height: 1.2\n}\n\n.text-span-383 {\n    color: var(--pabloo-green-2)\n}\n\n.text-span-384 {\n    border-left: 0 solid #5a5a5a;\n    padding-left: 0\n}\n\n@media screen and (min-width:1280px) {\n    .home-hero-section {\n        margin-top: 0\n    }\n\n    .wrapper-1300px {\n        justify-content: flex-start\n    }\n\n    .wrapper-1300px.center-align {\n        justify-content: center\n    }\n\n    .wrapper-1300px.for-about {\n        margin-right: 0\n    }\n\n    .logo-container.as-featured-on-logo-container {\n        align-items: center;\n        display: flex\n    }\n\n    .logo-container.as-featured-on-logo-container.et-container {\n        align-items: center;\n        width: 17%;\n        display: flex\n    }\n\n    .logo-container.as-featured-on-logo-container.cnbc-logo-container {\n        width: 8%\n    }\n\n    .home-pointer-split-content-wrapper {\n        width: 50%\n    }\n\n    .pricing-head-container {\n        margin-bottom: 24px\n    }\n\n    .pricing-hero-table {\n        background-color: #fff;\n        border-radius: 20px;\n        margin-top: 80px;\n        box-shadow: 7px 4px 24px rgba(0, 0, 0, .11)\n    }\n\n    .pricing-table-left {\n        border-radius: 20px\n    }\n\n    .pricing-table-right {\n        border-top-right-radius: 20px;\n        border-bottom-right-radius: 20px\n    }\n\n    .wrapper-1280px.split-wrapper.split-3 {\n        padding-bottom: 140px\n    }\n\n    .wrapper-1280px.finance-wrapper {\n        flex-direction: column;\n        align-items: stretch;\n        padding-top: 120px;\n        padding-bottom: 120px\n    }\n\n    .wrapper-1280px.pt-sm {\n        padding-top: 40px\n    }\n\n    .about-hero-text-contain {\n        max-width: 1000px\n    }\n\n    .persona-split-text-container.split-3 {\n        max-width: 560px\n    }\n\n    .persona-split-side-image.split-2 {\n        top: 31%;\n        right: -7%\n    }\n\n    .persona-finance-section {\n        background-color: var(--black)\n    }\n\n    .finance-head-wrap {\n        text-align: center;\n        max-width: 720px;\n        margin-bottom: 80px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .finance-heading {\n        color: var(--white);\n        line-height: 108%\n    }\n\n    .finance-grid {\n        grid-column-gap: 40px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr 1fr;\n        grid-auto-columns: 1fr;\n        display: grid\n    }\n\n    .finance-grid-item {\n        color: var(--white);\n        text-align: center;\n        flex-direction: column;\n        align-items: center;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 140%;\n        display: flex\n    }\n\n    .finanve-item-icon-block {\n        flex: none;\n        width: 48px;\n        height: 48px;\n        margin-bottom: 24px\n    }\n\n    .finance-icon {\n        width: 100%;\n        height: 100%\n    }\n\n    .multi-channel-background.top-right {\n        right: -15%\n    }\n\n    .case-study-hero-logo-item._2.no-bg {\n        background-color: transparent;\n        background-image: none\n    }\n\n    .assisted-hero-p-icon {\n        left: 15%\n    }\n\n    .assisted-hero-gmail-icon {\n        left: 50%\n    }\n\n    .hero-head-container {\n        margin-top: 50px\n    }\n\n    .div-block-2 {\n        width: 100%\n    }\n\n    .text-block-11.roundtable-text.pill-text {\n        font-weight: 700\n    }\n\n    .div-block-27 {\n        top: auto;\n        right: -20px\n    }\n\n    .div-block-39 {\n        margin-top: 0;\n        padding-right: 0\n    }\n\n    .div-block-53 {\n        top: auto;\n        bottom: 64px\n    }\n\n    .text-span-11,\n    .heading-9 {\n        color: var(--black)\n    }\n\n    .heading-10 {\n        color: var(--pabloo-green)\n    }\n\n    .paragraph-3 {\n        color: var(--black)\n    }\n\n    .div-block-61.pink {\n        display: none\n    }\n\n    .div-block-61.white {\n        background-color: var(--white)\n    }\n\n    .button-2 {\n        background-color: var(--pabloo-green);\n        color: var(--white)\n    }\n\n    .heading-11 {\n        color: var(--black)\n    }\n\n    .text-span-12 {\n        color: var(--pabloo-green)\n    }\n\n    .html-embed-4 {\n        margin-bottom: 0\n    }\n\n    .authors-wrapper {\n        margin-top: 0\n    }\n\n    .company-logo-2.dan.lg {\n        height: 160px\n    }\n\n    .container-13 {\n        background-position: 100% 100%;\n        background-size: 50%\n    }\n\n    .header-section-3 {\n        padding-top: 120px\n    }\n\n    .header-section-3.with-bg {\n        background-color: var(--white)\n    }\n\n    .image-cover.not-in-mobile {\n        object-fit: cover\n    }\n\n    .modal-section {\n        display: none\n    }\n\n    .modal-content {\n        padding-top: 24px;\n        padding-bottom: 24px\n    }\n\n    .modal-image-large {\n        height: 100%\n    }\n\n    .div-block-169 {\n        display: block\n    }\n\n    .header-slider-product {\n        min-height: 590px\n    }\n\n    .header-featured-wrap.contact {\n        position: relative\n    }\n\n    .sticky-wrapper {\n        height: 100%;\n        padding-bottom: 40px\n    }\n\n    .sec-bk {\n        padding-bottom: 0\n    }\n\n    .sec-bk.p-b-32 {\n        padding-bottom: 32vh\n    }\n\n    .sec-bk.p-b-32.xx {\n        height: auto;\n        padding-bottom: 0\n    }\n\n    .sub-header-img.contact-us {\n        border-radius: 8px;\n        padding-bottom: 24px;\n        top: 16%\n    }\n\n    .columns-6 {\n        padding-bottom: 80px;\n        display: flex\n    }\n\n    .column-71 {\n        height: auto\n    }\n\n    .f-paragraph-large-2 {\n        margin-top: 24px\n    }\n\n    .jobs-board-form {\n        margin-top: 16px\n    }\n\n    .faq-paragraph-2 {\n        color: var(--white-smoke)\n    }\n\n    .image-57,\n    .image-58,\n    .image-59 {\n        border-radius: 8px\n    }\n\n    .faq-heading-3 {\n        color: var(--white)\n    }\n\n    .faq-section-3 {\n        background-color: var(--slate-blue)\n    }\n\n    .faq-subheading,\n    .faq-title-3,\n    .bold-text-15 {\n        color: var(--white)\n    }\n\n    .success-message-5 {\n        background-color: var(--pabloo-green);\n        border-radius: 8px\n    }\n\n    .text-block-137 {\n        color: var(--white);\n        font-weight: 500\n    }\n\n    .text-block-138 {\n        text-align: center;\n        margin-bottom: 8px;\n        font-size: 14px\n    }\n\n    .link-24 {\n        color: var(--pabloo-green)\n    }\n\n    .header-section-6 {\n        padding-top: 120px\n    }\n\n    .b-navigation-base-2 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .navigation-grid-3 {\n        grid-column-gap: 24px\n    }\n\n    .nav-list {\n        font-size: 15px\n    }\n\n    .b-navigation-link-icon-2:hover {\n        color: #d53987\n    }\n\n    .navigation-list-2.w--open {\n        width: 60%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .navigation-list-2.product.w--open,\n    .navigation-list-2.resources.w--open {\n        width: 120%\n    }\n\n    .navigation-list-2.product.w--open {\n        width: 110%\n    }\n\n    .b-navigation-link-icon-3:hover {\n        color: #d53987\n    }\n\n    .navigation-dropdown-base-3 {\n        box-shadow: 2px 24px 140px -48px rgba(57, 59, 106, .16)\n    }\n\n    .b-navigation-link-icon-4:hover {\n        color: #d53987\n    }\n\n    .text-block-201 {\n        font-size: 15px\n    }\n\n    .b-navigation-link-icon-5:hover {\n        color: #d53987\n    }\n\n    .image-158 {\n        width: 100%\n    }\n\n    .div-block-671 {\n        margin-left: 0%;\n        margin-right: 0%\n    }\n\n    .navigation-bar {\n        top: 0\n    }\n\n    .navigation-menu {\n        margin-left: 40px\n    }\n\n    .nav-links-contain {\n        grid-column-gap: 20px\n    }\n\n    .dropdown-lists.w--open {\n        top: 72px\n    }\n\n    .navigation-button-contain.out-menu {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .hero-home-wrapper.new {\n        padding-top: 220px\n    }\n\n    .transparent-arrow-button._16px.navigation {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .paragraph-18px.hero-home-paragraph.new {\n        width: 80%\n    }\n\n    .stats-wrapper {\n        padding-top: 0\n    }\n\n    .heading-24px.setup-card-text {\n        font-size: 22px\n    }\n\n    .collection-list-7 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .footer-links-wrapper {\n        grid-template-columns: .75fr .5fr .75fr .75fr 1fr\n    }\n\n    .indicator-arrow {\n        margin-right: 0\n    }\n\n    .spend-block-wrapper.a.new {\n        object-fit: contain;\n        width: 360px;\n        margin-top: 40px;\n        display: flex;\n        position: absolute;\n        top: 150%;\n        bottom: auto;\n        left: 40px;\n        right: 40px\n    }\n\n    .spend-block-wrapper.a.new._1 {\n        display: none;\n        left: 40px\n    }\n\n    .spend-block-wrapper.a.new._2 {\n        object-fit: fill;\n        flex-flow: column;\n        flex: none;\n        justify-content: center;\n        align-items: flex-start;\n        margin-left: 0;\n        padding-left: 0%;\n        display: none;\n        left: -70%;\n        right: auto\n    }\n\n    .spend-block-wrapper.a.new._3 {\n        flex-flow: column;\n        flex: none;\n        justify-content: center;\n        align-items: flex-start;\n        margin-left: 0;\n        display: none;\n        /* left: auto */\n    }\n\n    .spend-text-container {\n        padding-bottom: 60px\n    }\n\n    .reviews-slide-text-gradient-wrapper {\n        width: 67%\n    }\n\n    .hero-bkg {\n        height: 85%\n    }\n\n    .home-hero-images-container {\n        width: 55%;\n        margin-right: -9%\n    }\n\n    .hero-bubbles-block-wrapper {\n        bottom: 6%;\n        left: 10.5%\n    }\n\n    .navigation-links-grid {\n        grid-column-gap: 24px\n    }\n\n    .navigation-block-link:hover {\n        color: #d53987\n    }\n\n    .hero-platform-heading-wrapper.display-flex.include-bg {\n        max-width: 900px;\n        padding-left: 53px\n    }\n\n    .hero-platform-image.integra {\n        object-fit: contain\n    }\n\n    .hero-spotlight-image {\n        width: 80%\n    }\n\n    .form-email-text-field.resource-hero {\n        width: 67%\n    }\n\n    .div-block-732 {\n        margin-top: -240px\n    }\n\n    .features-section {\n        display: flex\n    }\n\n    .features-wrapper {\n        margin-top: 67px\n    }\n\n    .feature-image-wrapper.left.green-bg {\n        flex-direction: column;\n        flex: 1;\n        justify-content: flex-end;\n        align-items: flex-start\n    }\n\n    .feature-image-wrapper.left.pink-bg {\n        height: 550px\n    }\n\n    .hero-design-element {\n        top: 64%\n    }\n\n    .hero-design-element.right {\n        top: 25%\n    }\n\n    .hero-design-element.left {\n        top: auto;\n        bottom: 24%\n    }\n\n    .hero-design-element.center {\n        left: -12%\n    }\n\n    .blog-cms-sticky-contain {\n        top: 140px\n    }\n\n    .transparent-arrow-button-white._16px.navigation {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .div-block-737 {\n        padding-bottom: 38px\n    }\n\n    .flex-image-block.lottie {\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .flex-block-abs-image.fourth {\n        bottom: -10%\n    }\n\n    .cloud-hero-absolute-image {\n        top: 38%\n    }\n\n    .cloud-hero-absolute-image.third {\n        top: 34%\n    }\n\n    .cloud-hero-absolute-image.fourth {\n        right: -5%\n    }\n\n    .cloud-absolute-image {\n        top: 38%\n    }\n\n    .cloud-absolute-image.second {\n        right: -7%\n    }\n\n    .div-block-424 {\n        max-width: 100%;\n        margin-left: 100px;\n        margin-right: 100px\n    }\n\n    .section-68 {\n        background-color: #faf2eb;\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/6597aa2642f1fe5180df02ff_Frame%202087326089.svg);\n        background-position: 0%;\n        background-repeat: no-repeat;\n        background-size: auto\n    }\n\n    .div-block-425 {\n        max-width: 100%;\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .html-embed-33 {\n        margin-bottom: -6px\n    }\n\n    .tab-pane-pabloo-for-cloud {\n        padding-bottom: 80px\n    }\n\n    .navigation-block-links-grid.resources {\n        grid-column-gap: 60px\n    }\n\n    .nav-mobile-contain {\n        grid-column-gap: 20px\n    }\n\n    .features-wrapper-2 {\n        justify-content: space-around\n    }\n\n    .html-embed-39 {\n        margin-bottom: 0\n    }\n\n    .heading-264 {\n        font-size: 2.3rem\n    }\n\n    .sysf-tagline {\n        padding-top: 12px;\n        font-size: 17px;\n        font-weight: 800\n    }\n\n    .brix---heading-h3-size {\n        font-size: 14px;\n        font-weight: 500\n    }\n\n    .brix---color-accent-1 {\n        color: var(--pabloo-green)\n    }\n\n    .brix---display-2 {\n        color: var(--black-2);\n        font-size: 40px\n    }\n\n    .brix---stat-card-4-cols---01 {\n        color: var(--black)\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg,\n    .feature-image-wrapper-copy.left.pink-bg,\n    .feature-image-wrapper-copy.left.pink-bg {\n        height: 550px\n    }\n\n    .stats-wrapper-copy,\n    .stats-wrapper-new,\n    .stats-wrapper-copy {\n        padding-top: 0\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        height: 550px\n    }\n\n    .div-block-732-copy {\n        margin-top: -240px\n    }\n\n    .new-navigation-background-div {\n        max-width: 100%\n    }\n\n    .html-embed-40 {\n        color: var(--pabloo-green-2);\n        font-weight: 600\n    }\n\n    .features-section-copy {\n        display: flex\n    }\n\n    .features-wrapper-copy {\n        margin-top: 67px\n    }\n\n    .wrapper-1280px-copy.split-wrapper.split-3 {\n        padding-bottom: 140px\n    }\n\n    .wrapper-1280px-copy.finance-wrapper {\n        flex-direction: column;\n        align-items: stretch;\n        padding-top: 120px;\n        padding-bottom: 120px\n    }\n\n    .wrapper-1280px-copy.pt-sm {\n        padding-top: 40px\n    }\n\n    .hello-navigation-bar {\n        top: 0\n    }\n\n    .heading-24px-copy.setup-card-text {\n        font-size: 22px\n    }\n\n    .wrapper-1300px-copy-copy {\n        justify-content: flex-start\n    }\n\n    .wrapper-1300px-copy-copy.center-align {\n        justify-content: center\n    }\n\n    .hero-bkg-copy,\n    .hero-bkg-copy-copy {\n        height: 85%\n    }\n\n    .cms-blog-block-section-copy.templates-block {\n        margin-top: -180px\n    }\n\n    .wrapper-1300px-copy {\n        justify-content: flex-start\n    }\n\n    .wrapper-1300px-copy.center-align {\n        justify-content: center\n    }\n\n    .new-about-1300px-header {\n        justify-content: flex-start\n    }\n\n    .new-about-1300px-header.center-align {\n        justify-content: center\n    }\n\n    .new-about-hero-wrapper {\n        background-image: none;\n        background-position: 0 0;\n        background-repeat: repeat;\n        background-size: auto;\n        background-attachment: scroll\n    }\n\n    .stats-wrapper-copy-copy,\n    .stats-xx {\n        padding-top: 0\n    }\n\n    .text-block-332 {\n        padding-right: 23px\n    }\n\n    .section-72,\n    .section-72.what-is-in {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .section-72.events,\n    .section-72.testimonial {\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .section-72.location {\n        max-width: none;\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .section-72.optimize {\n        background-size: auto\n    }\n\n    .section-72.ads {\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .div-block-822 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .text-block-357.events {\n        font-size: 52px\n    }\n\n    .text-block-358 {\n        margin-bottom: 103px\n    }\n\n    .div-block-827 {\n        margin-top: -101px\n    }\n\n    .text-block-359.events {\n        font-size: 52px\n    }\n\n    .div-block-841 {\n        flex-flow: column\n    }\n\n    .partners.partner-logos {\n        height: 25px;\n        margin-bottom: 10px;\n        display: flex\n    }\n\n    .div-block-845 {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px\n    }\n\n    .image-260 {\n        flex: 0 auto;\n        align-self: center;\n        margin-top: 0;\n        padding-top: 10px\n    }\n\n    .div-block-853 {\n        background-size: cover\n    }\n\n    .div-block-860 {\n        margin-top: 10px\n    }\n\n    .feature-text-header {\n        align-self: stretch\n    }\n\n    .text-span-339,\n    .text-span-340,\n    .text-span-341,\n    .text-span-342,\n    .text-span-343,\n    .text-span-344 {\n        color: var(--pabloo-green-2)\n    }\n\n    .div-block-865 {\n        display: block\n    }\n\n    .div-block-866 {\n        width: 30px\n    }\n\n    .tabs-4 {\n        background-color: var(--soft-pink);\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4f2ab2fe33ac69859f70_Group%202087326245news.png);\n        background-position: 0 0;\n        background-repeat: repeat-x;\n        background-size: 100% 580px;\n        border-radius: 20px;\n        flex-flow: row;\n        flex: 0 auto;\n        width: 100%;\n        display: flex\n    }\n\n    .tabs-menu-7 {\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/663b4bbc17ed885772b7ec8f_Bgx.png);\n        background-position: 50%;\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-attachment: scroll;\n        border-radius: 20px;\n        width: 40%;\n        height: 580px;\n        padding: 13px;\n        display: flex\n    }\n\n    .tabs-content-5 {\n        width: 60%\n    }\n\n    .tab-link-tab-1-3 {\n        flex: 1\n    }\n\n    .tab-link-tab-1-3.w--current {\n        background-color: var(--transparent);\n        flex-flow: column;\n        flex: 0 auto;\n        justify-content: center;\n        align-items: center;\n        height: 100px;\n        padding-right: 10px;\n        display: flex\n    }\n\n    .tab-link-tab-2-3 {\n        background-color: var(--transparent);\n        flex: 0 auto;\n        justify-content: center;\n        align-items: flex-end;\n        height: 100px;\n        padding-left: 10px;\n        padding-right: 10px;\n        display: flex\n    }\n\n    .tab-link-tab-2-3.w--current {\n        justify-content: center;\n        align-items: flex-end;\n        margin-left: auto\n    }\n\n    .tab-link-tab-3-2 {\n        background-color: var(--transparent);\n        flex: 0 auto;\n        justify-content: center;\n        align-items: center;\n        height: 100px;\n        padding-left: 10px;\n        display: flex\n    }\n\n    .div-block-867 {\n        justify-content: center;\n        align-items: center;\n        display: flex\n    }\n\n    .text-block-389 {\n        padding-right: 10px;\n        font-size: 22px\n    }\n\n    .div-block-868 {\n        box-sizing: border-box;\n        object-fit: cover;\n        flex-flow: column;\n        justify-content: center;\n        align-items: center;\n        height: 580px;\n        padding: 34px;\n        display: flex\n    }\n\n    .image-264 {\n        flex: 0 auto;\n        display: block;\n        overflow: visible\n    }\n\n    .text-block-391 {\n        font-size: 90px\n    }\n\n    .div-block-892 {\n        background-position: 50%\n    }\n\n    .image-271 {\n        width: 70%\n    }\n}\n\n@media screen and (min-width:1440px) {\n    .wrapper-1300px {\n        left: auto\n    }\n\n    .wrapper-1300px.featured-on-wrapper {\n        max-width: 100%\n    }\n\n    .wrapper-1300px.for-about {\n        margin-right: 0\n    }\n\n    .wrapper-1300px.for-integra {\n        max-width: 1300px\n    }\n\n    .navigation-left {\n        width: 22%\n    }\n\n    .navigation-container {\n        max-width: 100%\n    }\n\n    .nav-link {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .nav01.sticky {\n        z-index: 99\n    }\n\n    .home-hero-content-wrapper {\n        width: 60%;\n        max-width: 63%\n    }\n\n    .home-hero-heading-wrapper,\n    .home-hero-para-wrapper {\n        max-width: 88%\n    }\n\n    .primary-button.white-button.book-button {\n        font-size: 16px\n    }\n\n    .cards-section.vertical-padding-large {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .cards-section.vertical-padding-large.integra {\n        padding-left: 70px;\n        padding-right: 42px\n    }\n\n    .logo-wrapper-grid.as-featured-on-logos-wrapper-grid {\n        max-width: 90%\n    }\n\n    .logo-container.as-featured-on-logo-container {\n        align-items: center;\n        width: 15%;\n        height: 48px;\n        display: flex\n    }\n\n    .logo-container.as-featured-on-logo-container.et-container {\n        width: 18%;\n        height: 60px\n    }\n\n    .logo-container.as-featured-on-logo-container.cnbc-logo-container {\n        width: 8%;\n        height: 48px\n    }\n\n    .logo-container.as-featured-on-logo-container.forbes-logo-container {\n        height: 42px\n    }\n\n    .company-logo.publication-logo.forbes-logo {\n        height: 64%\n    }\n\n    .company-logo.publication-logo.ent-logo {\n        height: 72%\n    }\n\n    .split-section-content-container {\n        width: 40%\n    }\n\n    .split-image-2 {\n        right: 33%\n    }\n\n    .pitch-section {\n        padding-top: 89px;\n        padding-bottom: 89px\n    }\n\n    .pitch-head-wrapper {\n        margin-bottom: -1px\n    }\n\n    .pitch-heading {\n        margin-top: 43px;\n        margin-bottom: 43px;\n        font-size: 38px\n    }\n\n    .pitch-card-content-wrapper.persona {\n        max-width: 350px\n    }\n\n    .pitch-card-para.persona {\n        margin-bottom: 20px\n    }\n\n    .white-alter-span.white {\n        font-size: 64px\n    }\n\n    .pricing-hero-section {\n        background-position: 50% 0;\n        background-size: cover\n    }\n\n    .blog-main-image-wrapper {\n        max-width: none\n    }\n\n    .home-value-bg-image-wrap {\n        max-width: 790px\n    }\n\n    .about-hero-text-contain {\n        max-width: 1000px\n    }\n\n    .member-image._1.member-image-webinar,\n    .member-image._2.member-image-webinar {\n        max-height: 240px\n    }\n\n    .member-name.volopay-member-name {\n        margin-bottom: 10px\n    }\n\n    .persona-split-text-container.split-3 {\n        width: 43%\n    }\n\n    .persona-split-text-container.procurement-2-text {\n        width: 42%\n    }\n\n    .persona-split-side-image {\n        right: -9%\n    }\n\n    .persona-split-side-image.split-2 {\n        top: 31%;\n        right: -11%\n    }\n\n    .persona-split-side-image.split-3 {\n        right: -6%\n    }\n\n    .persona-text-link {\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d1ffb97d792f833449_Vector%20\\(9\\).svg), url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);\n        background-position: 85%, 85%;\n        background-repeat: no-repeat, no-repeat;\n        background-size: auto, auto;\n        padding-top: 5px;\n        padding-bottom: 5px;\n        padding-right: 40px;\n        font-weight: 700;\n        line-height: 156%;\n        transition: color .3s, background-position .34s\n    }\n\n    .persona-text-link:hover {\n        color: var(--pabloo-green);\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/624d28d02cc0295477122da8_Vector%20\\(10\\).svg);\n        background-position: 95%;\n        background-repeat: no-repeat;\n        background-size: auto\n    }\n\n    .procurement-section-1-image {\n        position: absolute\n    }\n\n    .procurement-section-1-image._1 {\n        border-radius: 10px\n    }\n\n    .procurement-section-1-image._2 {\n        border-radius: 10px;\n        margin-top: auto;\n        margin-bottom: auto;\n        top: 0%;\n        bottom: 0%;\n        right: auto\n    }\n\n    .procurement-section-1-image._3 {\n        border-radius: 10px;\n        top: auto;\n        left: auto\n    }\n\n    .procurement-section-2-image {\n        right: -10%\n    }\n\n    .dropdown-toggle {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .discover-product-hero-heading {\n        line-height: 72px\n    }\n\n    .new-product-hero-image {\n        box-shadow: -14px 14px 0 0 var(--slate-blue)\n    }\n\n    .tools-hero-image {\n        box-shadow: -14px 14px 0 0 var(--pabloo-green)\n    }\n\n    .track-approval-hero-image {\n        box-shadow: none\n    }\n\n    .multi-channel-background.bottom-left {\n        left: -15%\n    }\n\n    .fast-track-hero-circle-wrapper.left {\n        left: 5%\n    }\n\n    .fast-track-hero-circle-wrapper.right {\n        right: 5%\n    }\n\n    .fast-track-hero-user-element._1,\n    .fast-track-hero-user-element._4 {\n        left: 40%\n    }\n\n    .footer-top-wrapper {\n        padding-top: 32px;\n        padding-bottom: 20px\n    }\n\n    .split-section-form-wrapper {\n        padding-left: 32px;\n        padding-right: 32px\n    }\n\n    .form-field-wrapper {\n        flex-wrap: wrap\n    }\n\n    .assisted-tools-image-container {\n        width: 48%;\n        max-width: none\n    }\n\n    .assisted-hero-image-wrapper {\n        box-shadow: none;\n        max-width: 95%\n    }\n\n    .assisted-hero-office-icon {\n        left: 20%\n    }\n\n    .assisted-hero-p-icon {\n        left: 30%\n    }\n\n    .assisted-hero-droupbox-icon {\n        right: 30px\n    }\n\n    .assisted-hero-z-icon {\n        right: 25%\n    }\n\n    .assisted-hero-gmail-icon {\n        left: 40%\n    }\n\n    .investor-logo.investor-logo-rt-demo-custo-styles {\n        width: 33%\n    }\n\n    .insights-hero-image-4 {\n        width: 30%\n    }\n\n    .contract-hero-item-wrap.left {\n        left: 40px\n    }\n\n    .contract-hero-item-wrap.right {\n        right: 40px\n    }\n\n    .thank-you-section {\n        align-items: center;\n        height: 64vh\n    }\n\n    .home-hero-text-wrapper {\n        margin-top: 96px\n    }\n\n    .hello-bar {\n        padding-top: 10px;\n        padding-bottom: 10px;\n        position: -webkit-sticky;\n        position: sticky\n    }\n\n    .div-block-2 {\n        width: 80%\n    }\n\n    .text-block-8 {\n        text-align: center\n    }\n\n    .div-block-12 {\n        display: block\n    }\n\n    .body-2 {\n        background-color: #fff;\n        transition: all .4s\n    }\n\n    .div-block-19 {\n        margin-top: 0\n    }\n\n    .div-block-19.p-r-40 {\n        padding-right: 40px\n    }\n\n    .div-block-20 {\n        padding: 16% 8px 20%\n    }\n\n    .container-4 {\n        background-size: 40%\n    }\n\n    .container-4.custo {\n        max-width: 1040px\n    }\n\n    .div-block-23 {\n        align-items: center;\n        padding: 16px 24px;\n        display: flex\n    }\n\n    .div-block-23.alt-badge {\n        border-radius: 120px\n    }\n\n    .text-block-10,\n    .text-block-10.primary-badge-text {\n        line-height: 18px\n    }\n\n    .text-block-11 {\n        color: var(--black)\n    }\n\n    .text-block-11.roundtable-text.pill-text {\n        font-weight: 700\n    }\n\n    .div-block-24 {\n        margin-top: 16px\n    }\n\n    .div-block-24.panel-shadow {\n        margin-top: 0\n    }\n\n    .div-block-27 {\n        z-index: -1;\n        top: auto;\n        bottom: 16px\n    }\n\n    .div-block-28 {\n        min-height: auto\n    }\n\n    .div-block-29 {\n        background-color: var(--white);\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        padding-bottom: 80px\n    }\n\n    .bestsuited-webinarblock {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .button {\n        transition: background-color .275s ease-in-out\n    }\n\n    .button:hover {\n        background-color: var(--black)\n    }\n\n    .button.round:hover {\n        background-color: var(--pabloo-green)\n    }\n\n    .div-block-35 {\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62adcf5682ada2a467982e5d_topics-bg.svg)\n    }\n\n    .div-block-38 {\n        background-color: transparent;\n        background-image: none;\n        border-bottom-right-radius: 0;\n        padding-top: 80px;\n        padding-bottom: 80px;\n        padding-left: 0%\n    }\n\n    .cta-button-roundtable {\n        transition: background-color .275s ease-in-out\n    }\n\n    .cta-button-roundtable:hover {\n        background-color: var(--black-2);\n        color: var(--white)\n    }\n\n    .cta-button-roundtable.cta-button-roundtable-pink {\n        background-color: var(--pabloo-green);\n        color: var(--white);\n        border-radius: 12px;\n        box-shadow: 1px 1px 16px rgba(0, 0, 0, .1)\n    }\n\n    .cta-button-roundtable.cta-button-roundtable-pink:hover {\n        background-color: var(--black-2)\n    }\n\n    .div-block-39 {\n        justify-content: flex-start;\n        margin-top: 48px;\n        padding-right: 0\n    }\n\n    .div-block-40 {\n        background-color: var(--white)\n    }\n\n    .container-5 {\n        padding-bottom: 80px;\n        padding-left: 0;\n        line-height: 25px\n    }\n\n    .div-block-41 {\n        margin-top: 0;\n        padding-left: 8%\n    }\n\n    .div-block-42 {\n        margin-top: 24px\n    }\n\n    .div-block-45 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto;\n        grid-template-columns: auto 1fr;\n        grid-auto-columns: 1fr;\n        align-items: center;\n        display: grid\n    }\n\n    .text-block-20 {\n        color: #fff\n    }\n\n    .text-block-21 {\n        color: var(--black-2)\n    }\n\n    .image-7 {\n        width: 100%;\n        max-width: none;\n        height: auto;\n        position: static\n    }\n\n    .column-2 {\n        padding-top: 56px\n    }\n\n    .text-block-22 {\n        color: var(--black)\n    }\n\n    .column-5 {\n        background-position: 50% 12%\n    }\n\n    .div-block-50 {\n        border-radius: 120px\n    }\n\n    .column-6 {\n        padding-top: 4%\n    }\n\n    .div-block-53 {\n        display: none\n    }\n\n    .container-6 {\n        max-width: 1040px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .container-6.m-w-72 {\n        max-width: 80%\n    }\n\n    .div-block-60 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        padding-left: 24px;\n        display: none\n    }\n\n    .text-span-11 {\n        font-family: Satoshi, sans-serif;\n        font-style: normal;\n        font-weight: 700\n    }\n\n    .heading-9 {\n        margin-bottom: 16px;\n        font-size: 28px;\n        font-weight: 500\n    }\n\n    .heading-10 {\n        color: var(--black);\n        font-size: 32px;\n        line-height: 40px\n    }\n\n    .paragraph-3 {\n        margin-top: 20px;\n        font-size: 19px\n    }\n\n    .div-block-61 {\n        padding-top: 120px;\n        padding-bottom: 120px\n    }\n\n    .div-block-61.pink {\n        display: none\n    }\n\n    .div-block-61.white {\n        padding-top: 80px;\n        display: block\n    }\n\n    .columns-4 {\n        padding-top: 16px;\n        padding-bottom: 40px\n    }\n\n    .button-2 {\n        background-color: var(--pabloo-green);\n        color: var(--white);\n        border-radius: 2px;\n        margin-top: 24px;\n        margin-left: 0;\n        padding: 22px 32px;\n        font-size: 20px;\n        font-weight: 700\n    }\n\n    .image-14 {\n        line-height: 28px\n    }\n\n    .heading-11 {\n        font-family: Satoshi, sans-serif\n    }\n\n    .column-8 {\n        justify-content: center\n    }\n\n    .div-block-62 {\n        padding-left: 0\n    }\n\n    .container-7 {\n        max-width: 1040px\n    }\n\n    .div-block-63 {\n        padding-right: 4%\n    }\n\n    .container-9 {\n        max-width: 85%\n    }\n\n    .div-block-98.pb-md.pt-sm.flex {\n        background-size: cover\n    }\n\n    .div-block-100 {\n        background-color: var(--black)\n    }\n\n    .div-block-101 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n        grid-auto-columns: 1fr;\n        display: flex\n    }\n\n    .div-block-102 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr;\n        grid-auto-columns: 1fr;\n        display: grid\n    }\n\n    .div-block-103 {\n        display: flex\n    }\n\n    .container-13 {\n        background-position: 100% 100%;\n        background-size: 50%\n    }\n\n    .container-13.remove-bg {\n        min-height: auto\n    }\n\n    .features-container {\n        margin-top: 42px;\n        margin-left: auto;\n        padding-left: 60px\n    }\n\n    .image-cover.not-in-mobile {\n        object-fit: cover\n    }\n\n    .div-block-144 {\n        padding-left: 24%;\n        padding-right: 24%\n    }\n\n    .section-large-2.blackbg {\n        background-position: 112% 115%, 0 0\n    }\n\n    .modal-section {\n        display: none\n    }\n\n    .grid-four-column {\n        grid-template-columns: 1fr 1fr 1fr 1fr\n    }\n\n    .image-40,\n    .client-logo {\n        filter: grayscale()\n    }\n\n    .client-logo.mind-tickle-logo-resize {\n        height: 28px\n    }\n\n    .header-slider-product {\n        min-height: 600px\n    }\n\n    .sticky-wrapper {\n        height: 100%\n    }\n\n    .sec-bk {\n        padding-bottom: 14vh\n    }\n\n    .sec-bk.p-b-32.xx {\n        height: auto;\n        padding-bottom: 0\n    }\n\n    .div-block-194 {\n        width: 100%;\n        max-width: 1280px;\n        margin-left: auto;\n        margin-right: auto;\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .div-block-199 {\n        align-items: center\n    }\n\n    .image-47.m-l-8 {\n        width: auto;\n        height: 80px\n    }\n\n    .div-block-200 {\n        padding-left: 5%;\n        padding-right: 5%\n    }\n\n    .image-60 {\n        border-radius: 8px\n    }\n\n    .header-section-6 {\n        min-height: 72vh;\n        padding-top: 40px\n    }\n\n    .member-position {\n        line-height: 1.1\n    }\n\n    .tab-button-content {\n        border-bottom-style: none;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .tab-button.w--current {\n        background-color: rgba(80, 80, 255, .06)\n    }\n\n    .dropdown-toggle-3,\n    .nav-link-5 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .blog-book-demo-box {\n        max-width: 290px\n    }\n\n    .b-navigation-base-2 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .navigation-grid-3 {\n        height: auto;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .wrapper-1300px-3 {\n        left: auto\n    }\n\n    .navigation-list-2.w--open {\n        width: 56%;\n        left: 0%\n    }\n\n    .navigation-list-2.solutions {\n        width: 60%;\n        min-width: auto;\n        left: 0%\n    }\n\n    .navigation-list-2.product {\n        width: 120%;\n        left: auto\n    }\n\n    .navigation-list-2.resources {\n        width: 120%;\n        min-width: auto\n    }\n\n    .div-block-371 {\n        align-items: center\n    }\n\n    .image-111.m-l-8 {\n        width: auto;\n        height: 80px\n    }\n\n    .navigation-menu-6 {\n        position: relative\n    }\n\n    .div-block-430 {\n        min-height: 320px\n    }\n\n    .html-embed-25 {\n        width: 100%;\n        height: 100%\n    }\n\n    .image-155,\n    .image-156 {\n        width: 100%\n    }\n\n    .div-block-475 {\n        width: 52%\n    }\n\n    .image-158 {\n        width: 80%\n    }\n\n    .text-span-204 {\n        margin-left: 2px\n    }\n\n    .column-76 {\n        padding-bottom: 0%;\n        padding-left: 8%;\n        padding-right: 8%\n    }\n\n    .div-block-671 {\n        margin-left: 0%;\n        margin-right: 0%\n    }\n\n    .navigation-bar {\n        top: 0\n    }\n\n    .nav-links-contain {\n        grid-column-gap: 32px\n    }\n\n    .dropdown-lists.w--open {\n        left: -1.5%\n    }\n\n    .paragraph-18px.hero-home-paragraph.new {\n        width: 80%\n    }\n\n    .pink-arrow-button.ebook {\n        width: 60%\n    }\n\n    .stats-wrapper {\n        padding-top: 0\n    }\n\n    .heading-24px.setup-card-text {\n        font-size: 24px\n    }\n\n    .footer-links-wrapper {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px\n    }\n\n    .calculator-content {\n        grid-column-gap: 24px\n    }\n\n    .spend-image.c {\n        box-shadow: 0 -20px 80px rgba(0, 0, 0, .1)\n    }\n\n    .spend-image.b {\n        position: relative\n    }\n\n    .sticky-indicator-text-wrapper {\n        grid-column-gap: 16px\n    }\n\n    .home-hero-images-container {\n        width: 55%;\n        margin-right: -7%\n    }\n\n    .hero-bubbles-block-wrapper {\n        left: 16%\n    }\n\n    .navigation-links-grid {\n        height: auto;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .dropdown-highlight-span {\n        margin-left: 2px\n    }\n\n    .tribe-image-wrapper {\n        left: 8%\n    }\n\n    .hero-platform-wrapper.integra {\n        padding-left: 8%;\n        padding-right: 8%\n    }\n\n    .hero-platform-heading-wrapper.display-flex.include-bg {\n        justify-content: center;\n        align-items: flex-end;\n        max-width: 900px;\n        padding-left: 155px\n    }\n\n    .div-block-732 {\n        margin-top: -259px\n    }\n\n    .features-section {\n        display: flex\n    }\n\n    .old-sections {\n        display: block\n    }\n\n    .features-wrapper {\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        margin-top: 87px;\n        display: flex\n    }\n\n    .feature-image-wrapper.left.pink-bg {\n        height: 550px\n    }\n\n    .hero-design-element {\n        top: 52%\n    }\n\n    .hero-design-element.right {\n        top: 24%\n    }\n\n    .hero-design-element.left {\n        bottom: 16%\n    }\n\n    .div-block-737 {\n        align-items: center;\n        min-height: auto;\n        padding-bottom: 60px;\n        display: flex\n    }\n\n    .div-block-737.new {\n        min-height: auto;\n        padding-bottom: 7%\n    }\n\n    .flex-block-image-wrapper {\n        left: 6%\n    }\n\n    .flex-block-image-wrapper.right {\n        right: 6%\n    }\n\n    .flex-block-image.cloud-1,\n    .flex-block-image.cloud-2 {\n        width: 70%\n    }\n\n    .cloud-hero-image-wrapper {\n        width: 45%\n    }\n\n    .cloud-hero-absolute-image {\n        top: 40%\n    }\n\n    .cloud-hero-absolute-image.fourth {\n        right: -4%\n    }\n\n    .cloud-absolute-image {\n        top: 40%\n    }\n\n    .cloud-absolute-image.second {\n        right: -12%\n    }\n\n    .spend-absolute-image.a {\n        left: 6%\n    }\n\n    .section-68,\n    .tab-pane-pabloo-for-saas {\n        padding-bottom: 0\n    }\n\n    .div-block-769 {\n        max-width: 1280%;\n        padding-left: 24%;\n        padding-right: 24%\n    }\n\n    .navigation-block-links-grid.resources {\n        grid-column-gap: 80px\n    }\n\n    .nav-mobile-contain {\n        grid-column-gap: 32px\n    }\n\n    .points-checklist-grid {\n        grid-template-columns: .9fr 1fr\n    }\n\n    .text-block-321 {\n        text-align: center\n    }\n\n    .div-block-784 {\n        display: block\n    }\n\n    .sysf-tagline {\n        font-size: 18px;\n        font-weight: 800\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        height: 550px;\n        padding-left: 3px\n    }\n\n    .stats-wrapper-new {\n        margin-top: 0;\n        padding-top: 0\n    }\n\n    .stats-wrapper-copy {\n        padding-top: 0\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        height: 550px\n    }\n\n    .div-block-732-copy {\n        margin-top: -259px\n    }\n\n    .new-navigation-background-div {\n        max-width: 100%\n    }\n\n    .div-block-20-copy {\n        padding: 16% 8px 20%\n    }\n\n    .features-section-copy {\n        display: flex\n    }\n\n    .features-wrapper-copy {\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        margin-top: 87px;\n        display: flex\n    }\n\n    .hello-navigation-bar {\n        top: 0\n    }\n\n    .wrapper-1300px-copy {\n        padding-top: 0;\n        padding-bottom: 0;\n        left: auto\n    }\n\n    .stats-wrapper-copy-copy {\n        padding-top: 0\n    }\n\n    .heading-90px-copy.stats-block-heading-copy {\n        letter-spacing: 0;\n        font-size: 24px\n    }\n\n    .bold-text-30 {\n        font-size: 30px\n    }\n\n    .heading-24px-copy.setup-card-text,\n    .heading-24px-copy.stats-text-copy {\n        font-size: 24px\n    }\n\n    .pitch-section-copy {\n        padding-top: 0;\n        padding-bottom: 0;\n        display: block\n    }\n\n    .bold-text-30-copy {\n        font-size: 30px\n    }\n\n    .wrapper-1300px-copy {\n        justify-content: center;\n        align-items: center;\n        left: auto\n    }\n\n    .wrapper-1300px-copy-copy {\n        left: auto\n    }\n\n    .wrapper-1300px-copy-copy.featured-on-wrapper {\n        max-width: 100%\n    }\n\n    .paragraph-152 {\n        /* padding-right: 79px */\n    }\n\n    .blog-hero-heading-copy {\n        margin-top: 42px\n    }\n\n    .text-block-330 {\n        flex: 1;\n        justify-content: center;\n        align-self: auto;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .blog-card-image-copy.custo:hover {\n        transform: none\n    }\n\n    .wrapper-1300px-copy {\n        left: auto\n    }\n\n    .wrapper-1300px-copy.featured-on-wrapper {\n        max-width: 100%\n    }\n\n    .new-about-1300px-header {\n        left: auto\n    }\n\n    .new-about-1300px-header.featured-on-wrapper {\n        max-width: 100%\n    }\n\n    .new-about-hero-wrapper {\n        background-image: none\n    }\n\n    .xs-text,\n    .about-heading-x {\n        font-size: 64px\n    }\n\n    .stats-about {\n        margin-top: 220px\n    }\n\n    .stats-wrapper-copy-copy,\n    .stats-xx {\n        margin-top: 0;\n        padding-top: 0\n    }\n\n    .text-block-331 {\n        align-self: flex-start\n    }\n\n    .text-block-332 {\n        padding-bottom: 0;\n        padding-right: 24px\n    }\n\n    .tabs-menu-5 {\n        align-items: center;\n        justify-items: start\n    }\n\n    .heading-265 {\n        font-size: 22px\n    }\n\n    .section-72,\n    .section-72.what-is-in {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .section-72.about-eve {\n        padding-top: 290px\n    }\n\n    .section-72.optimize {\n        background-size: cover\n    }\n\n    .div-block-822 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .image-249 {\n        object-fit: cover;\n        display: inline-block\n    }\n\n    .div-block-827 {\n        margin-top: -119px\n    }\n\n    .div-block-829.why {\n        background-position: 0 100%;\n        background-repeat: repeat;\n        background-attachment: scroll;\n        margin-top: 100px\n    }\n\n    .div-block-832.why {\n        margin-top: 6px\n    }\n\n    .div-block-833 {\n        justify-content: center;\n        align-items: center;\n        display: flex\n    }\n\n    .div-block-835 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/660fabd5aed4381a048727b1_Group%202085664155.svg);\n        background-position: 0 0;\n        background-size: cover;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        padding: 104px;\n        display: flex\n    }\n\n    .text-block-363 {\n        font-size: 42px;\n        font-weight: 700\n    }\n\n    .text-span-306 {\n        color: var(--pabloo-green-2)\n    }\n\n    .div-block-836 {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px;\n        flex-flow: column;\n        width: 60%;\n        display: flex\n    }\n\n    .text-block-364 {\n        border-left: 4px solid var(--pabloo-green);\n        padding-left: 15px\n    }\n\n    .text-block-365 {\n        width: 90%\n    }\n\n    .div-block-837 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        margin-top: 26px;\n        display: grid\n    }\n\n    .image-252 {\n        object-fit: fill\n    }\n\n    .div-block-838 {\n        align-self: flex-start\n    }\n\n    .div-block-842 {\n        padding-right: 12px\n    }\n\n    .div-block-857 {\n        width: 70%\n    }\n\n    .collection-list-wrapper-8 {\n        margin-top: 10px\n    }\n\n    .feature-text-header {\n        align-self: stretch\n    }\n\n    .div-block-862 {\n        padding-top: 2%\n    }\n\n    .text-block-391 {\n        font-size: 90px\n    }\n\n    .div-block-888.fold-2 {\n        width: 75%\n    }\n\n    .div-block-892 {\n        background-position: 50%;\n        background-size: cover\n    }\n\n    .image-271 {\n        width: 70%\n    }\n}\n\n@media screen and (min-width:1920px) {\n    .wrapper-1300px.for-about {\n        margin-right: 0\n    }\n\n    .wrapper-1300px.for-integra {\n        max-width: 1300px\n    }\n\n    .navigation-container {\n        max-width: 100%\n    }\n\n    .nav01 {\n        max-width: none\n    }\n\n    .primary-button.white-button.book-button {\n        font-size: 20px\n    }\n\n    .cards-section.vertical-padding-large {\n        justify-content: center;\n        align-items: center;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .company-logo {\n        height: 100%\n    }\n\n    .company-logo.uc-logo {\n        height: 120%\n    }\n\n    .home-slider-section.cs {\n        height: 100vh\n    }\n\n    .blog-main-image-wrapper {\n        max-width: 1600px\n    }\n\n    .home-value-bg-image-wrap {\n        width: 90%;\n        max-width: 920px\n    }\n\n    .career-section {\n        display: none\n    }\n\n    .fast-track-hero-circle-wrapper.left {\n        left: 15%\n    }\n\n    .fast-track-hero-circle-wrapper.right {\n        right: 15%\n    }\n\n    .contract-hero-item-wrap.left {\n        left: 220px\n    }\n\n    .contract-hero-item-wrap.right {\n        right: 220px\n    }\n\n    .container-4.custo {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .text-block-11.roundtable-text.pill-text {\n        font-weight: 700\n    }\n\n    .div-block-27 {\n        top: 154px;\n        right: -61px\n    }\n\n    .div-block-29 {\n        background-position: 0 0;\n        background-size: auto 45%;\n        padding-left: 50px;\n        padding-right: 50px\n    }\n\n    .div-block-36 {\n        margin-top: 0\n    }\n\n    .div-block-38 {\n        background-image: none;\n        padding-left: 50px;\n        padding-right: 50px\n    }\n\n    .div-block-39 {\n        justify-content: flex-start;\n        margin-top: 0;\n        padding-right: 0\n    }\n\n    .container-6 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .container-7 {\n        max-width: 1040px\n    }\n\n    .div-block-64 {\n        justify-content: flex-start\n    }\n\n    .header-grid-3 {\n        align-items: center\n    }\n\n    .container-13 {\n        align-self: center;\n        min-height: 50vh;\n        position: relative\n    }\n\n    .container-13.remove-bg {\n        min-height: auto\n    }\n\n    .header-section-3.with-bg {\n        min-height: 70vh\n    }\n\n    .features-container {\n        direction: rtl;\n        text-align: left;\n        object-fit: fill;\n        margin-left: auto;\n        display: inline-block\n    }\n\n    .team-heading {\n        direction: ltr;\n        letter-spacing: 0;\n        object-fit: contain;\n        order: 0;\n        align-self: flex-start\n    }\n\n    .feature-section-2.new {\n        display: flex\n    }\n\n    .features-heading-wrap {\n        flex-flow: row;\n        order: -1\n    }\n\n    .features-heading-wrap._2-0 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: flex-start\n    }\n\n    .div-block-144 {\n        padding-left: 32%;\n        padding-right: 32%\n    }\n\n    .section-large-2.blackbg {\n        background-position: 108% 115%, 0 0\n    }\n\n    .modal-section {\n        display: flex\n    }\n\n    .sticky-wrapper {\n        height: 100%\n    }\n\n    .header-section-6 {\n        min-height: auto\n    }\n\n    .image-67 {\n        height: 42px\n    }\n\n    .empty-state-3 {\n        padding-left: 50px;\n        padding-right: 50px\n    }\n\n    .blog-book-demo-box {\n        max-width: 320px\n    }\n\n    .section-26 {\n        background-size: cover\n    }\n\n    .div-block-502 {\n        padding-left: 50px;\n        padding-right: 50px\n    }\n\n    .div-block-674 {\n        width: 100%;\n        top: 20%;\n        right: -64%\n    }\n\n    .case-study-hero-sub-heading {\n        font-size: 18px\n    }\n\n    .rich-text-block-28 {\n        font-size: 20px\n    }\n\n    .heading-64px.text-align-center {\n        font-size: 52px\n    }\n\n    .navigation-bar {\n        top: 0\n    }\n\n    .hero-home-wrapper {\n        padding-top: 185px\n    }\n\n    .hero-home-wrapper.new.ads {\n        padding-top: 220px;\n        padding-bottom: 180px\n    }\n\n    .paragraph-18px.hero-home-paragraph.new {\n        width: 85%\n    }\n\n    .stats-wrapper {\n        padding-top: 0\n    }\n\n    .paragraph-16px.navigation-subheading {\n        text-transform: none\n    }\n\n    .spend-section.new,\n    .spend-wrapper {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .hero-platform-heading-wrapper.display-flex.include-bg {\n        max-width: 950px;\n        padding-left: 81px\n    }\n\n    .div-block-732 {\n        margin-top: -260px\n    }\n\n    .features-section {\n        display: flex\n    }\n\n    .old-sections {\n        display: block\n    }\n\n    .features-wrapper {\n        flex-flow: column;\n        align-content: flex-start;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .feature-wrap {\n        flex-direction: row;\n        justify-content: flex-start;\n        align-items: center;\n        margin-top: 50px;\n        display: flex;\n        position: static\n    }\n\n    .feature-image-wrapper.right.pink-bg,\n    .feature-image-wrapper.right.green-bg,\n    .feature-image-wrapper.right.green-bg-copy {\n        order: -1\n    }\n\n    .feature-image-wrapper.left.green-bg {\n        flex-direction: column;\n        flex: 1;\n        order: 1;\n        justify-content: flex-start;\n        align-items: center\n    }\n\n    .feature-image-wrapper.left.green-bg.padding-reset {\n        order: 1\n    }\n\n    .feature-image-wrapper.left.yellow-bg {\n        object-fit: fill;\n        flex-direction: column;\n        flex: 1;\n        order: 1;\n        align-self: center;\n        align-items: center;\n        height: 550px;\n        display: block\n    }\n\n    .feature-image-wrapper.left.pink-bg {\n        flex: 1;\n        order: 1\n    }\n\n    .hero-design-element {\n        top: 40%\n    }\n\n    .hero-design-element.right {\n        top: 16%\n    }\n\n    .hero-design-element.left {\n        bottom: 50%\n    }\n\n    .div-block-737 {\n        align-items: center;\n        min-height: auto;\n        display: flex\n    }\n\n    .div-block-737.new {\n        padding-bottom: 4%\n    }\n\n    .pricing-menu-tabs,\n    .pricing-duration-toggle,\n    .div-block-424 {\n        max-width: 1280px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .section-68 {\n        padding-bottom: 0\n    }\n\n    .div-block-426 {\n        max-width: 1280px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .tab-pane-pabloo-for-saas {\n        padding-bottom: 0\n    }\n\n    .div-block-760,\n    .div-block-767,\n    .div-block-768 {\n        max-width: 1280px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .tab-pane-pabloo-for-cloud {\n        padding-bottom: 80px\n    }\n\n    .div-block-769 {\n        max-width: 1280px;\n        margin-left: auto;\n        margin-right: auto;\n        padding-left: 22%;\n        padding-right: 22%\n    }\n\n    .section-69 {\n        background-color: #08090a\n    }\n\n    .sysf-tagline {\n        font-size: 18px\n    }\n\n    .heading-64px-copy.text-align-center,\n    .heading-64px-new.text-align-center {\n        font-size: 32px\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        object-fit: fill;\n        flex: 1;\n        order: 1;\n        width: 50%;\n        height: 550px;\n        display: block\n    }\n\n    .image-244 {\n        overflow-wrap: normal\n    }\n\n    .feature-image-wrapper-copy-copy.right.green-bg {\n        order: -1\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        order: 1\n    }\n\n    .stats-wrapper-copy,\n    .stats-wrapper-new,\n    .stats-wrapper-copy {\n        padding-top: 0\n    }\n\n    .feature-image-wrapper-copy.right.green-bg {\n        order: -1\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        object-fit: fill;\n        flex-direction: column;\n        flex: 1;\n        order: 1;\n        align-self: center;\n        align-items: center;\n        height: 550px;\n        display: block\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        flex: 1;\n        order: 1\n    }\n\n    .div-block-732-copy {\n        margin-top: -260px\n    }\n\n    .div-block-795 {\n        flex-direction: column;\n        display: flex\n    }\n\n    .text-block-326 {\n        text-align: center;\n        margin-top: 19px;\n        font-size: 18px\n    }\n\n    .hero-button-cta-copy {\n        padding-left: 50px;\n        padding-right: 50px\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.green-bg {\n        order: -1\n    }\n\n    .new-navigation-background-div {\n        max-width: 100%\n    }\n\n    .features-section-copy {\n        display: flex\n    }\n\n    .features-wrapper-copy {\n        flex-flow: column;\n        align-content: flex-start;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .hello-navigation-bar {\n        top: 0\n    }\n\n    .new-about-hero-wrapper {\n        background-image: none;\n        background-attachment: scroll\n    }\n\n    .stats-wrapper-copy-copy,\n    .stats-xx {\n        padding-top: 0\n    }\n\n    .text-block-331 {\n        text-align: left;\n        margin-left: 0;\n        text-decoration: none\n    }\n\n    .about-x-platform-wrapper.new {\n        background-image: none\n    }\n\n    .faq-item-x.demo {\n        padding: 38px\n    }\n\n    .section-72 {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .section-72.about-eve {\n        padding-top: 335px\n    }\n\n    .section-72.optimize {\n        background-size: auto\n    }\n\n    .div-block-829 {\n        background-color: #f8f8f8;\n        border-radius: 20px;\n        padding-left: 60px\n    }\n\n    .div-block-829.why {\n        background-position: 0 100%;\n        background-attachment: scroll\n    }\n\n    .section-73 {\n        max-width: 1300px\n    }\n\n    .div-block-835 {\n        margin-bottom: 47px\n    }\n\n    .div-block-841 {\n        grid-column-gap: 10px;\n        grid-row-gap: 10px\n    }\n\n    .testimonialx {\n        width: 49%\n    }\n\n    .text-block-377,\n    .text-block-377.new {\n        font-size: 52px\n    }\n\n    .tab-pane-tab-2-2,\n    .tab-pane-tab-3-2 {\n        flex: 1\n    }\n\n    .image-260 {\n        flex: 0 auto;\n        align-self: auto\n    }\n\n    .div-block-857 {\n        width: 50%\n    }\n\n    .feature-block-item.yellow2,\n    .feature-block-item.yellow2.green2 {\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .feature-block-content-logo {\n        flex: 0 auto;\n        order: 0;\n        align-self: flex-end\n    }\n\n    .feature-text-header {\n        text-align: left;\n        flex-flow: column;\n        flex: 0 auto;\n        order: 0;\n        align-self: stretch;\n        margin-left: 0;\n        padding-left: 0;\n        display: block;\n        position: static\n    }\n\n    .div-block-862 {\n        width: 25%;\n        padding-top: 2%\n    }\n\n    .div-block-863 {\n        width: 75%\n    }\n\n    .tabs-menu-6 {\n        width: 100%\n    }\n\n    .text-block-391 {\n        font-size: 90px\n    }\n\n    .text-block-407 {\n        font-size: 70px\n    }\n\n    .div-block-888.fold-2 {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px;\n        flex-flow: column;\n        justify-content: center;\n        align-items: flex-start;\n        width: 80%;\n        display: flex\n    }\n\n    .image-270.fold-2 {\n        height: 70px\n    }\n\n    .div-block-892 {\n        background-position: 50%;\n        background-size: cover\n    }\n\n    .div-block-892.fold-2 {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .div-block-892.fold3 {\n        background-position: 100% 100%;\n        background-repeat: no-repeat;\n        background-size: auto;\n        margin-bottom: 0;\n        padding-bottom: 148px\n    }\n\n    .div-block-892.fold3.fold4 {\n        background-position: 50%;\n        background-size: cover\n    }\n\n    .div-block-894 {\n        justify-content: flex-start;\n        align-items: flex-start\n    }\n\n    .div-block-895 {\n        justify-content: flex-end;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .image-271 {\n        vertical-align: baseline;\n        width: 55%;\n        margin-top: 30px;\n        margin-right: 30px\n    }\n\n    .text-block-409 {\n        width: 60%;\n        font-size: 24px\n    }\n\n    .text-block-410 {\n        color: #ccc;\n        margin-top: 60px;\n        margin-bottom: 60px;\n        font-size: 26px;\n        font-weight: 400;\n        line-height: 1.2\n    }\n\n    .button-53 {\n        border-radius: 12px;\n        padding-left: 50px;\n        padding-right: 50px\n    }\n\n    .div-block-896 {\n        justify-content: flex-start;\n        align-items: center;\n        height: 100%;\n        padding-left: 53px;\n        padding-right: 58px;\n        display: flex\n    }\n\n    .text-block-413 {\n        padding-left: 8px\n    }\n\n    .text-block-414 {\n        padding-left: 9px\n    }\n\n    .div-block-901 {\n        overflow: hidden\n    }\n\n    .div-block-904 {\n        background-color: rgba(255, 255, 255, .38);\n        height: 1px\n    }\n}\n\n@media screen and (max-width:991px) {\n    h1 {\n        font-size: 60px\n    }\n\n    .wrapper-1300px {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .wrapper-1300px.home-hero-flex {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column;\n        align-items: center\n    }\n\n    .wrapper-1300px.for-about {\n        grid-template-columns: 1fr\n    }\n\n    .nav-menu {\n        background-color: #fff;\n        height: auto;\n        padding-bottom: 20px;\n        padding-left: 4px;\n        box-shadow: 0 100px 100px rgba(0, 0, 0, .1)\n    }\n\n    .navigation-right {\n        flex: 0 auto;\n        order: 0;\n        display: block;\n        position: absolute;\n        top: 0%;\n        bottom: auto;\n        left: auto;\n        right: 0%\n    }\n\n    .navigation-right.tab-visibility {\n        flex-direction: column;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .nav-link-register.hide {\n        display: none\n    }\n\n    .navigation-left {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .navigation-container {\n        justify-content: flex-start;\n        min-height: auto;\n        padding-left: 20px;\n        padding-right: 20px;\n        position: relative\n    }\n\n    .brand {\n        margin-right: 10px;\n        padding: 0\n    }\n\n    .nav-link {\n        color: var(--black)\n    }\n\n    .menu-button {\n        color: #3f0a3d;\n        border: 1px solid rgba(0, 0, 0, .1);\n        border-radius: 100%\n    }\n\n    .menu-button.w--open {\n        border-color: var(--pabloo-green);\n        background-color: var(--pabloo-green)\n    }\n\n    .home-hero-content-wrapper {\n        width: 100%\n    }\n\n    .home-hero-heading {\n        font-size: 44px;\n        line-height: 48px\n    }\n\n    .primary-button {\n        padding: 20px\n    }\n\n    .primary-button.popup-form-button {\n        padding-top: 16px;\n        padding-bottom: 16px\n    }\n\n    .hollow-button {\n        padding: 20px\n    }\n\n    .hollow-button.white-hollow-button:hover {\n        color: var(--pabloo-green)\n    }\n\n    .hero-image-wrapper {\n        width: 80%;\n        max-width: none;\n        margin-top: 5%;\n        margin-left: 0;\n        margin-right: auto\n    }\n\n    .cards-section.vertical-padding-large {\n        flex-flow: column;\n        margin-left: 37px;\n        margin-right: 37px\n    }\n\n    .logo-wrapper-grid {\n        flex-wrap: wrap;\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n        justify-content: center;\n        display: flex\n    }\n\n    .logo-container {\n        width: 17%;\n        margin-bottom: 30px;\n        margin-left: 20px;\n        margin-right: 20px\n    }\n\n    .home-value-wrapper {\n        flex-direction: column-reverse;\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .home-value-content-wrapper {\n        width: 100%;\n        margin-top: 20px\n    }\n\n    .home-value-image-container {\n        width: 100%;\n        max-width: 560px;\n        height: auto;\n        margin-top: 0\n    }\n\n    .value-image-wrapper-1,\n    .value-image-wrapper-2,\n    .value-image-wrapper-3 {\n        display: none\n    }\n\n    .split-section-wrapper {\n        flex-direction: column;\n        align-items: center\n    }\n\n    .split-section-wrapper.reverse {\n        flex-direction: column-reverse;\n        align-items: center\n    }\n\n    .split-section-content-container {\n        width: 100%;\n        margin-top: 40px;\n        margin-bottom: 10px\n    }\n\n    .split-section-content-container.split-2 {\n        width: 100%;\n        max-width: 520px\n    }\n\n    .split-section-content-container.max-width-520px {\n        max-width: 600px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .split-section-heading.max-width-520px {\n        max-width: none\n    }\n\n    .split-pointer-text {\n        max-width: 540px\n    }\n\n    .blue-button {\n        padding: 20px\n    }\n\n    .split-image-wrapper {\n        width: 100%;\n        max-width: 620px;\n        margin-top: 40px\n    }\n\n    .split-image-wrapper-2 {\n        width: 100%;\n        height: 450px;\n        margin-bottom: 5%;\n        margin-right: 0%\n    }\n\n    .split-image-wrapper-2.split-image-wrapper-3 {\n        height: 500px\n    }\n\n    .work-head-wrapper.slack-steps-header-wrapper {\n        margin-bottom: 32px\n    }\n\n    .home-work-slide-wrapper.slack-steps-wrapper {\n        flex-wrap: wrap\n    }\n\n    .work-slide-container.slack-step-container {\n        margin-top: 8px;\n        margin-bottom: 8px\n    }\n\n    .review-slide {\n        padding-bottom: 103px\n    }\n\n    .review-slider-text {\n        font-size: 20px\n    }\n\n    .home-pointers-split-wrapper {\n        flex-direction: column;\n        align-items: center\n    }\n\n    .home-pointers-image-wrapper {\n        width: 80%;\n        margin-bottom: 5%;\n        margin-right: 0%\n    }\n\n    .home-pointer-split-content-wrapper {\n        width: 100%\n    }\n\n    .pitch-heading {\n        margin-bottom: 56px\n    }\n\n    .pitch-illustration-wrapper {\n        flex-direction: row;\n        justify-content: center\n    }\n\n    .pitch-brach-wrapper {\n        width: 8%;\n        margin-right: 20px;\n        transform: rotate(0)\n    }\n\n    .pitch-brach-wrapper.persona {\n        width: 8%;\n        max-width: 60.0469px;\n        margin-right: 0\n    }\n\n    .brach-image {\n        display: none\n    }\n\n    .brach-image.branch-image-vertical {\n        object-fit: contain;\n        width: 100%;\n        display: inline-block\n    }\n\n    .branch-card-wrapper {\n        flex-flow: column wrap;\n        grid-template-rows: auto auto auto auto;\n        grid-template-columns: 1fr;\n        width: auto\n    }\n\n    .branch-card-wrapper.branch-persona {\n        z-index: 10;\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr;\n        position: relative\n    }\n\n    .branch-card-wrapper.three-columns {\n        grid-template-columns: 1fr\n    }\n\n    .pitch-main-card.bottom-block.mobile {\n        display: block\n    }\n\n    .pitch-main-card.bottom-block.bottom {\n        display: none\n    }\n\n    .pitch-card-content-wrapper.persona {\n        max-width: 300px\n    }\n\n    .pitch-card-content-wrapper.persona.full {\n        max-width: 100%\n    }\n\n    .home-support-section {\n        background-position: 70%\n    }\n\n    .cta-section {\n        background-position: 50% 0\n    }\n\n    .cta-split-wrapper {\n        flex-direction: column-reverse;\n        align-items: center;\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .cta-split-content-wrapper {\n        width: 100%;\n        margin-top: 6%;\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .cta-split-content-wrapper.persona {\n        width: 100%;\n        padding-top: 0\n    }\n\n    .white-alter-span.white {\n        font-size: 52px\n    }\n\n    .cta-image-wrapper {\n        width: 100%\n    }\n\n    .copyright-text,\n    .footer-down-link {\n        font-size: 16px\n    }\n\n    .pricing-heading {\n        font-size: 44px\n    }\n\n    .auto-slider-arrow-left {\n        bottom: 10%;\n        right: 20%\n    }\n\n    .auto-slider-arrow-right {\n        bottom: 10%\n    }\n\n    .contact-hero-wrapper {\n        flex-direction: column;\n        margin-top: 138px\n    }\n\n    .contact-hero-text-wrapper {\n        width: 100%\n    }\n\n    .blog-hero-heading {\n        font-size: 55px;\n        line-height: 54px\n    }\n\n    .wrapper-1080px {\n        width: 75%\n    }\n\n    .blog-feature-block {\n        grid-column-gap: 20px\n    }\n\n    .blog-feature-block.guide {\n        grid-template-columns: 1fr\n    }\n\n    .blog-feature-image-container {\n        flex-direction: column;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .blog-feature-image {\n        text-align: center;\n        object-fit: contain;\n        width: 50%\n    }\n\n    .blog-feature-heading {\n        font-size: 25px\n    }\n\n    .blog-feature-para {\n        font-size: 18px\n    }\n\n    .blog-collection-list {\n        grid-column-gap: 20px\n    }\n\n    .home-value-bg-image-wrap {\n        width: 100%;\n        max-width: none;\n        height: 530px;\n        display: none;\n        top: auto;\n        bottom: 0%;\n        left: 0%;\n        right: 0%\n    }\n\n    .home-value-bg-image {\n        object-fit: contain\n    }\n\n    .home-slider-image-1,\n    .home-slider-image-2 {\n        width: 40%\n    }\n\n    .value-image-wrapper-4 {\n        display: block\n    }\n\n    .pricing-hero-table {\n        flex-direction: column\n    }\n\n    .pricing-table-left,\n    .pricing-table-right {\n        width: 100%\n    }\n\n    .black-button {\n        padding: 20px\n    }\n\n    .wrapper-1280px {\n        flex-direction: column;\n        max-width: 600px\n    }\n\n    .wrapper-1280px.popup-div {\n        max-width: 1000px;\n        padding-top: 100px\n    }\n\n    .wrapper-1280px.discover-new-product-flex {\n        flex-direction: column-reverse;\n        padding-top: 50px\n    }\n\n    .wrapper-1280px.discover-purchase-flex {\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px.case-study-hero-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px.track-approval-flex {\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px.workflow-approval-flex {\n        flex-direction: column;\n        padding-top: 30px\n    }\n\n    .wrapper-1280px.document-one-place-flex {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px.assisted-tools-flex,\n    .wrapper-1280px.actionable-insight-flex,\n    .wrapper-1280px.contract-renewals-flex {\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px.points-container {\n        max-width: 660px\n    }\n\n    .html-embed-calendly {\n        width: 100%\n    }\n\n    .popup-close {\n        margin-right: 0;\n        top: 40px;\n        right: 0%\n    }\n\n    .home-work-heading-2.slack-steps-heading {\n        color: var(--black)\n    }\n\n    .blog-feature-item {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        grid-template-columns: 1fr;\n        align-items: stretch\n    }\n\n    .popup-container {\n        width: 80%\n    }\n\n    .popup-heading {\n        font-size: 40px\n    }\n\n    .popup-split-block.block-down {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .about-head-container {\n        margin-top: 62px\n    }\n\n    .about-hero-text-contain {\n        width: 90%\n    }\n\n    .team-grid {\n        grid-column-gap: 58px;\n        grid-row-gap: 58px;\n        flex-wrap: wrap;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        justify-content: center;\n        display: grid\n    }\n\n    .team-grid.speakers-grid-webinar {\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .team-member-wrap {\n        flex: 33%\n    }\n\n    .member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller.pb-0 {\n        max-width: 200px;\n        max-height: 200px\n    }\n\n    .career-wrapper {\n        flex-direction: column\n    }\n\n    .career-left-wrap {\n        width: 100%;\n        margin-bottom: 60px;\n        position: static\n    }\n\n    .career-right-wrap {\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .about-slide {\n        margin-right: 40px\n    }\n\n    .background-image {\n        opacity: .6;\n        max-width: none\n    }\n\n    .persona-hero-card {\n        flex-direction: column;\n        height: auto;\n        padding: 60px 50px\n    }\n\n    .persona-hero-card-image {\n        border-radius: 8px;\n        flex: none;\n        width: 100%;\n        height: auto;\n        overflow: hidden\n    }\n\n    .persona-hero-card-text {\n        width: 100%;\n        margin-bottom: 40px;\n        margin-left: 0;\n        margin-right: 0%\n    }\n\n    .persona-card-text {\n        margin-top: 10px\n    }\n\n    .solution-text-container {\n        width: 100%;\n        margin-bottom: 40px;\n        margin-right: 0%\n    }\n\n    .persona-solution-pointers-wrap {\n        width: 100%;\n        max-width: 560px\n    }\n\n    .persona-split-section-heading {\n        font-size: 40px\n    }\n\n    .split-container.split-top-padding-0,\n    .split-container.split-inverse {\n        flex-direction: column-reverse\n    }\n\n    .persona-split-text-container {\n        width: 100%;\n        max-width: none;\n        margin-top: 60px;\n        margin-right: 0%\n    }\n\n    .persona-split-text-container.procurement-2-text {\n        width: 100%;\n        margin-left: 0%\n    }\n\n    .persona-split-text-container.it {\n        width: 100%\n    }\n\n    .persona-split-text {\n        font-size: 42px\n    }\n\n    .persona-split-para {\n        max-width: none\n    }\n\n    .persona-split-image-container {\n        width: 90%;\n        margin-right: 0\n    }\n\n    .finance-heading {\n        font-size: 44px\n    }\n\n    .finance-grid {\n        grid-template-columns: 1fr\n    }\n\n    .finance-grid-item {\n        max-width: 340px;\n        font-size: 18px\n    }\n\n    .dropdown-list.w--open {\n        margin-top: 0;\n        padding-top: 0;\n        position: relative;\n        left: 0\n    }\n\n    .persona-dropdown-wrap {\n        box-shadow: none;\n        width: auto;\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .persona-dropdown-wrap.product {\n        width: auto\n    }\n\n    .persona-dropdown-link {\n        max-width: 350px\n    }\n\n    .persona-triangle {\n        display: none\n    }\n\n    .dropdown {\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .together-image-container {\n        width: 100%;\n        margin-bottom: 60px\n    }\n\n    .together-text-container {\n        width: 100%\n    }\n\n    .together-blue-heading {\n        font-size: 50px;\n        line-height: 100%\n    }\n\n    .together-blue-paragraph-18px {\n        line-height: 150%\n    }\n\n    .discover-product-hero-bg {\n        height: 85%\n    }\n\n    .discover-product-hero-heading {\n        line-height: 100%\n    }\n\n    .discover-hero-paragraph {\n        line-height: 150%\n    }\n\n    .discover-hero-pointer {\n        line-height: 160%\n    }\n\n    .discover-hero-pink-text {\n        line-height: 150%\n    }\n\n    .discover-hero-circle-image {\n        width: 40%\n    }\n\n    .discover-hero-circle-image.left,\n    .discover-hero-circle-image.right {\n        bottom: 15%\n    }\n\n    .new-product-text-container {\n        width: 100%\n    }\n\n    .new-product-image-container {\n        width: 100%;\n        margin-bottom: 80px\n    }\n\n    .new-product-heading-44px {\n        line-height: 100%\n    }\n\n    .new-product-paragraph-18px {\n        line-height: 150%\n    }\n\n    .purchase-text-container {\n        width: 100%\n    }\n\n    .purchase-image-container {\n        width: 100%;\n        margin-bottom: 80px\n    }\n\n    .tools-text-container,\n    .tools-text-container.max-width-500px {\n        width: 100%\n    }\n\n    .tools-image-container {\n        width: 100%;\n        max-width: 550px;\n        margin-bottom: 80px\n    }\n\n    .procurement-upper-container {\n        flex-direction: column;\n        align-items: center\n    }\n\n    .procurement-paragraph-18px {\n        line-height: 150%\n    }\n\n    .procurement-heading-wrapper {\n        width: 100%;\n        margin-bottom: 60px;\n        margin-right: 0%\n    }\n\n    .procurement-grid {\n        grid-column-gap: 30px;\n        grid-row-gap: 40px;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .procurement-item {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .procurement-heading-24px {\n        margin-bottom: 4px;\n        line-height: 150%\n    }\n\n    .procurement-item-text-18px {\n        line-height: 150%\n    }\n\n    .case-study-hero-text-container {\n        width: 100%\n    }\n\n    .case-study-hero-image-container {\n        width: 90vw;\n        margin-top: 60px\n    }\n    .case-study-hero-image {\n        width: 90vw;\n        height: 90vw;\n        width: 500px;\n        object-fit: cover;\n        object-position: \"center\",\n\n    }\n\n    .case-study-hero-heading {\n        font-size: 50px;\n        line-height: 100%\n    }\n\n    .case-study-hero-pink-text {\n        line-height: 140%\n    }\n\n    .case-study-grid {\n        grid-template-columns: 1fr;\n        justify-items: center\n    }\n\n    .case-study-item-wrapper {\n        padding: 20px 20px 24px\n    }\n\n    .case-study-item-pink-tag {\n        line-height: 140%\n    }\n\n    .case-study-item-heading {\n        line-height: 120%\n    }\n\n    .case-study-item-para-small {\n        line-height: 140%\n    }\n\n    .track-approval-text-container {\n        width: 100%;\n        margin-top: 60px\n    }\n\n    .track-appoval-image-container {\n        width: 100%\n    }\n\n    .track-approval-item-absolute {\n        right: -5%\n    }\n\n    .multi-channel-image-container {\n        width: 100%\n    }\n\n    .multi-channel-text-container {\n        width: 100%;\n        margin-top: 100px\n    }\n\n    .workflow-approval-text-wrapper {\n        width: 100%;\n        margin-bottom: 60px;\n        position: relative;\n        top: 0\n    }\n\n    .workflow-approval-image-wrapper {\n        width: 100%\n    }\n\n    .fast-track-approval-h1-heading {\n        line-height: 100%\n    }\n\n    .fast-track-hero-image-wrapper.track-usage {\n        width: 70%;\n        margin-bottom: -60px\n    }\n\n    .fast-track-hero-circle-wrapper.left,\n    .fast-track-hero-circle-wrapper.right {\n        width: 40%\n    }\n\n    .fast-track-hero-user-element {\n        width: 18%\n    }\n\n    .fast-track-hero-user-element._1 {\n        left: 20%\n    }\n\n    .fast-track-hero-user-element._2 {\n        bottom: 15%;\n        left: 5%\n    }\n\n    .fast-track-hero-user-element._3 {\n        top: 0%;\n        right: 10%\n    }\n\n    .fast-track-hero-user-element._5 {\n        bottom: 5%\n    }\n\n    .dropdown-grid {\n        grid-column-gap: 40px\n    }\n\n    .footer-top-wrapper {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .footer-grid {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        width: 100%;\n        max-width: none;\n        padding-top: 0\n    }\n\n    .footer-left-contain {\n        flex-direction: row;\n        justify-content: space-between;\n        width: 100%;\n        margin-bottom: 60px\n    }\n\n    .split-section-form-wrapper {\n        padding: 10px\n    }\n\n    .review-slide-2 {\n        padding-bottom: 103px\n    }\n\n    .doc-one-place-text-container,\n    .doc-one-place-image-container {\n        width: 100%\n    }\n\n    .best-deals-text-container {\n        width: 100%;\n        margin-top: 80px\n    }\n\n    .assisted-tools-text-container {\n        width: 100%;\n        margin-top: 60px\n    }\n\n    .assisted-tools-image-container {\n        width: 100%\n    }\n\n    .assisted-purchasing-hero-wrapper {\n        margin-top: 41px\n    }\n\n    .assisted-purchasing-hero-wrapper.insights {\n        margin-top: 84px;\n        margin-bottom: 60px\n    }\n\n    .assisted-hero-item-wrapper.left {\n        justify-content: flex-start;\n        width: 380px;\n        bottom: 220px\n    }\n\n    .assisted-hero-item-wrapper.right {\n        justify-content: flex-end;\n        width: 380px;\n        bottom: 220px\n    }\n\n    .assisted-hero-office-icon {\n        width: 15%;\n        top: 0%;\n        left: 5%\n    }\n\n    .assisted-hero-bird-icon {\n        width: 15%;\n        left: 3%\n    }\n\n    .assisted-hero-p-icon {\n        width: 15%;\n        left: 10%\n    }\n\n    .assisted-hero-droupbox-icon {\n        width: 18%\n    }\n\n    .assisted-hero-z-icon {\n        width: 15%;\n        right: 5%\n    }\n\n    .assisted-hero-gmail-icon {\n        width: 15%;\n        top: 35%;\n        left: 70%\n    }\n\n    .actionable-insight-text-wrap {\n        width: 100%;\n        margin-top: 80px\n    }\n\n    .actionable-insight-image-wrap {\n        width: 100%;\n        max-width: 550px\n    }\n\n    .insight-hero-section.track-usage {\n        margin-bottom: 180px\n    }\n\n    .investor-logo.investor-logo-rt-demo-custo-styles {\n        width: 24%\n    }\n\n    .press-card-image-wrapper {\n        height: 400px\n    }\n\n    .insights-hero-image-3 {\n        width: 30%\n    }\n\n    .contract-renewal-image-wrap,\n    .contract-document-image-wrap {\n        width: 100%\n    }\n\n    .contract-hero-item-wrap.left {\n        bottom: 2%;\n        left: 0\n    }\n\n    .contract-hero-item-wrap.right {\n        bottom: 2%;\n        right: 0\n    }\n\n    .contract-hero-logo-item._2 {\n        bottom: 15%;\n        left: 10%\n    }\n\n    .contract-hero-logo-item._1 {\n        top: -20px;\n        left: 10px\n    }\n\n    .contract-hero-logo-item._4 {\n        right: 10%\n    }\n\n    .contract-hero-logo-item._5 {\n        right: 80px\n    }\n\n    .contract-hero-logo-item._6 {\n        bottom: 15%\n    }\n\n    .hero-subheading {\n        line-height: 150%\n    }\n\n    .hero-head-container {\n        width: 100%\n    }\n\n    .hero-heading {\n        line-height: 100%\n    }\n\n    .home-hero-image-wrapper {\n        width: 100%\n    }\n\n    .usp-icon {\n        width: 24px\n    }\n\n    .column {\n        margin-top: 4%\n    }\n\n    .paragraph-2 {\n        font-size: 14px;\n        line-height: 20px\n    }\n\n    .div-block {\n        margin-top: 0%\n    }\n\n    .heading-2 {\n        font-size: 32px;\n        line-height: 40px\n    }\n\n    .heading {\n        font-size: 40px\n    }\n\n    .div-block-2 {\n        max-width: 520px;\n        padding-bottom: 24px\n    }\n\n    .container-3 {\n        max-width: 80%;\n        margin-top: 0%\n    }\n\n    .div-block-10 {\n        margin-top: 0%\n    }\n\n    .grid-2 {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .text-block-6 {\n        font-size: 20px;\n        line-height: 36px\n    }\n\n    .text-block-6.social {\n        width: 100%\n    }\n\n    .div-block-18 {\n        padding-top: 0%\n    }\n\n    .heading-5 {\n        font-size: 48px;\n        line-height: 56px\n    }\n\n    .div-block-19 {\n        font-size: 18px\n    }\n\n    .div-block-20 {\n        margin-top: 40px;\n        padding-top: 0%;\n        padding-bottom: 4%\n    }\n\n    .container-4 {\n        max-width: 100%\n    }\n\n    .div-block-23.alt-badge {\n        align-items: center;\n        margin-left: 8px;\n        padding: 0 16px;\n        display: flex\n    }\n\n    .text-block-10 {\n        font-size: 16px;\n        line-height: 16px\n    }\n\n    .text-block-11 {\n        color: var(--black)\n    }\n\n    .div-block-24 {\n        margin-top: 32px\n    }\n\n    .div-block-25 {\n        margin-top: 8px\n    }\n\n    .div-block-27 {\n        top: -64px;\n        right: 0\n    }\n\n    .div-block-28 {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .div-block-29 {\n        background-color: var(--white);\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        min-height: auto;\n        padding-top: 0;\n        padding-bottom: 56px\n    }\n\n    .bestsuited-webinarblock {\n        min-height: auto;\n        padding-top: 56px;\n        padding-bottom: 56px\n    }\n\n    .div-block-33 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        justify-content: space-around;\n        display: grid\n    }\n\n    .grid-3.m-l-24 {\n        width: 100%;\n        margin-left: 0\n    }\n\n    .div-block-35 {\n        min-height: auto;\n        margin-top: 0;\n        padding-top: 0;\n        padding-bottom: 56px\n    }\n\n    .div-block-36 {\n        background-size: cover;\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .div-block-36.pink {\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .div-block-38 {\n        background-color: transparent;\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        border-bottom-right-radius: 64px;\n        padding: 50px\n    }\n\n    .div-block-39 {\n        justify-content: flex-start;\n        margin-top: 0;\n        padding-right: 0\n    }\n\n    .div-block-40 {\n        height: auto;\n        margin-top: 0;\n        padding-top: 56px;\n        padding-bottom: 56px\n    }\n\n    .container-5 {\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .div-block-41 {\n        margin-top: 24px\n    }\n\n    .image-7 {\n        position: static\n    }\n\n    .text-block-22 {\n        color: var(--black)\n    }\n\n    .columns-2 {\n        flex-direction: column-reverse;\n        justify-content: flex-start;\n        align-items: stretch;\n        display: flex\n    }\n\n    .column-6 {\n        padding-top: 0%;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .div-block-52 {\n        top: -12%\n    }\n\n    .image-11,\n    .image-12 {\n        display: none\n    }\n\n    .ebook-hero-points-short {\n        align-items: flex-end\n    }\n\n    .div-block-61.white.p-t-40 {\n        padding-top: 20px\n    }\n\n    .columns-4 {\n        display: block\n    }\n\n    .div-block-65 {\n        display: none\n    }\n\n    .button-6 {\n        display: inline-block\n    }\n\n    .auto-slider-arrow-left-2 {\n        bottom: 10%;\n        right: 20%\n    }\n\n    .review-slider-text-2 {\n        font-size: 20px\n    }\n\n    .header-grid {\n        grid-template-columns: 1fr\n    }\n\n    .header-content {\n        flex-direction: column;\n        display: flex\n    }\n\n    .feature-grid-large {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .authors-wrapper {\n        flex-wrap: wrap;\n        width: 100%\n    }\n\n    .company-logo-2 {\n        margin: 15px\n    }\n\n    .header-grid-3 {\n        grid-template-columns: 1fr\n    }\n\n    .header-section-3 {\n        padding-top: 60px\n    }\n\n    .line-break {\n        display: none\n    }\n\n    .process-title-wrap {\n        max-width: 600px;\n        margin-bottom: 100px\n    }\n\n    .process-grid {\n        grid-column-gap: 32px;\n        grid-row-gap: 60px;\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        grid-template-columns: 1fr;\n        max-width: 450px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .features-wrap {\n        flex-direction: column-reverse;\n        justify-content: flex-end;\n        align-items: stretch\n    }\n\n    .features-grid {\n        grid-column-gap: 24px;\n        max-width: 100%;\n        margin-right: 0\n    }\n\n    .features-heading-wrap {\n        max-width: 600px;\n        margin-bottom: 60px\n    }\n\n    .integration {\n        min-width: 210px\n    }\n\n    .bloom-image-effect-2 {\n        min-width: 100%\n    }\n\n    .image-cover.not-in-mobile {\n        object-fit: contain\n    }\n\n    .div-block-126 {\n        width: 88%\n    }\n\n    .cta-image-2 {\n        opacity: .5\n    }\n\n    .grid-two-column-2 {\n        grid-template-columns: 1fr\n    }\n\n    .heading-wrapper {\n        margin-top: 36px\n    }\n\n    .grid-three-column {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .testimoial-container {\n        flex-direction: column-reverse;\n        flex: 0 auto;\n        align-items: center;\n        margin-top: 100px;\n        margin-bottom: 140px;\n        margin-right: 0%\n    }\n\n    .d-128-3d-card-wrapper {\n        margin-bottom: 60px\n    }\n\n    .grid-cta {\n        grid-template-columns: 1fr\n    }\n\n    .testimonial-section-2 {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .flex-wrapper-centre-3.margin-bottom-48.custo {\n        max-width: 100%\n    }\n\n    .grid-four-column {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .grid-team-slider {\n        grid-template-columns: 1fr\n    }\n\n    .title-wrapper-regular.custo {\n        margin-left: 0\n    }\n\n    .testimonial-content-wrapper {\n        min-height: 340px;\n        padding-top: 0\n    }\n\n    .div-block-169 {\n        width: 30%\n    }\n\n    .image-43,\n    .image-44 {\n        max-width: 30%\n    }\n\n    .navigation-wrapper {\n        align-items: center;\n        width: auto;\n        display: flex\n    }\n\n    .navigation-3 {\n        position: relative\n    }\n\n    .navigation-avatar-wrapper {\n        margin-right: 14px\n    }\n\n    .logo-link-large {\n        margin-right: 0\n    }\n\n    .menu-button-5 {\n        color: #393b6a;\n        border: 1px solid #f3f5fb;\n        border-radius: 8px;\n        padding: 12px\n    }\n\n    .menu-button-5.w--open {\n        background-color: #160042;\n        border-color: #fff\n    }\n\n    .navigation-menu-2 {\n        color: #393b6a;\n        background-color: #fff;\n        border-radius: 8px;\n        padding: 12px;\n        position: absolute\n    }\n\n    .navigation-menu-2.w--open {\n        background-color: #282556;\n        border-color: #fff\n    }\n\n    .feature-grid-2 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .process-title-wrap-2 {\n        max-width: 600px;\n        margin-bottom: 100px\n    }\n\n    .process-grid-2 {\n        grid-column-gap: 32px;\n        grid-row-gap: 60px;\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        grid-template-columns: 1fr;\n        max-width: 450px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .process-section-2 {\n        padding-top: 37px;\n        padding-bottom: 37px\n    }\n\n    .header-featured-wrap.contact {\n        width: 100%;\n        padding-right: 0;\n        position: static;\n        top: auto\n    }\n\n    .sticky-wrapper {\n        height: auto\n    }\n\n    .contact-us-wrapper {\n        flex-direction: column;\n        height: auto\n    }\n\n    .sec-bk {\n        padding-bottom: 16vh\n    }\n\n    .sec-bk.p-b-32.xx {\n        height: auto;\n        padding-bottom: 10vh\n    }\n\n    .social-media-icons {\n        display: none\n    }\n\n    .big-container {\n        width: auto;\n        padding-left: 0\n    }\n\n    .sub-header-img.contact-us {\n        width: 100%;\n        height: auto;\n        position: relative;\n        top: 0\n    }\n\n    .sub-header-img.contact-us.hide-desktop {\n        display: block\n    }\n\n    .process-graphic {\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .process-block-2 {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .column-72 {\n        display: none\n    }\n\n    .shows-archive {\n        grid-column-gap: 40px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr;\n        grid-auto-columns: 1fr;\n        justify-content: space-between;\n        align-items: stretch;\n        display: grid\n    }\n\n    .intro {\n        padding-top: 113px;\n        padding-bottom: 113px\n    }\n\n    .side-pattern {\n        left: -20%\n    }\n\n    .grid-feature-wrapper {\n        grid-template-columns: 1fr\n    }\n\n    .grid-features {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .faq-grid-3 {\n        grid-column-gap: 60px\n    }\n\n    .content-grid-2 {\n        grid-column-gap: 62px;\n        grid-row-gap: 62px\n    }\n\n    .feature-grid-4,\n    .a-testimonial-slider-grid {\n        grid-template-columns: 1fr\n    }\n\n    .content-grid-3 {\n        grid-template-columns: 1fr;\n        justify-items: center\n    }\n\n    .header-grid-5 {\n        grid-template-columns: 1fr\n    }\n\n    .header-section-6 {\n        padding-top: 60px\n    }\n\n    .image-67 {\n        height: 42px\n    }\n\n    .grid,\n    .step-grid {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .home-section,\n    .slider-section {\n        padding-top: 90px\n    }\n\n    .slider-title {\n        width: 90%;\n        max-width: 1300px\n    }\n\n    .tab-button-desc-wrapper {\n        overflow: hidden\n    }\n\n    .b-navigation-title-block {\n        display: none\n    }\n\n    .navigation-dropdown {\n        width: 100%\n    }\n\n    .navigation-link-block {\n        padding: 24px\n    }\n\n    .navigation-list.w--open {\n        border-bottom: 4px solid #1a1a1a;\n        height: 420px;\n        position: static;\n        overflow: visible\n    }\n\n    .navigation-link-3 {\n        width: 100%\n    }\n\n    .navigation-grid-2 {\n        grid-template-columns: 1fr\n    }\n\n    .navigation-dropdown-base {\n        box-shadow: none\n    }\n\n    .b-navigation-base {\n        padding: 0\n    }\n\n    .tab-mobile-img {\n        margin-top: 16px;\n        display: block\n    }\n\n    .tabs-menu-3 {\n        width: 100%;\n        margin-bottom: 48px;\n        margin-right: 0%\n    }\n\n    .navigation-toggle-3 {\n        justify-content: flex-start;\n        width: 100%\n    }\n\n    .navigation-toggle-3.w--open {\n        color: #160042;\n        background-color: #f7f9fd;\n        width: 100%\n    }\n\n    .tabs-content-2 {\n        width: 100%;\n        display: none\n    }\n\n    .tab-component {\n        flex-direction: column\n    }\n\n    .div-block-320 {\n        justify-content: flex-start;\n        align-items: center;\n        margin-left: 0\n    }\n\n    .div-block-320.new {\n        justify-content: center;\n        align-items: center;\n        margin-left: auto\n    }\n\n    .nav-link-register-2.hide {\n        display: none\n    }\n\n    .persona-dropdown-wrap-2 {\n        box-shadow: none;\n        width: auto;\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .persona-dropdown-wrap-2.product {\n        width: auto\n    }\n\n    .menu-button-7 {\n        color: #3f0a3d;\n        border: 1px solid rgba(0, 0, 0, .1);\n        border-radius: 100%\n    }\n\n    .menu-button-7.w--open {\n        background-color: #d53987;\n        border-color: #d53987\n    }\n\n    .nav-link-5 {\n        color: #000\n    }\n\n    .div-block-333 {\n        margin-left: 0%;\n        margin-right: 0%\n    }\n\n    .b-navigation-base-2 {\n        padding: 0\n    }\n\n    .split-image-wrapper-3 {\n        width: 100%;\n        max-width: 620px;\n        margin-top: 40px\n    }\n\n    .navigation-toggle-4 {\n        justify-content: flex-start;\n        width: 100%\n    }\n\n    .navigation-toggle-4.w--open {\n        color: #160042;\n        background-color: #f7f9fd;\n        width: 100%\n    }\n\n    .navigation-grid-3 {\n        grid-template-columns: 1fr\n    }\n\n    .auto-slider-arrow-left-3 {\n        bottom: 10%;\n        right: 20%\n    }\n\n    .wrapper-1300px-3 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .hover-block__text {\n        width: 80%\n    }\n\n    .review-slide-3 {\n        padding-bottom: 103px\n    }\n\n    .navigation-list-2.w--open {\n        border-bottom: 4px solid #1a1a1a;\n        height: 420px;\n        position: static;\n        overflow: visible\n    }\n\n    .hollow-button-3 {\n        padding: 20px\n    }\n\n    .review-slider-text-4 {\n        font-size: 20px\n    }\n\n    .home-slider-image-4 {\n        width: 40%\n    }\n\n    .navigation-dropdown-base-3 {\n        box-shadow: none\n    }\n\n    .navigation-6 {\n        position: relative\n    }\n\n    .menu-button-10 {\n        color: #393b6a;\n        border: 1px solid #f3f5fb;\n        border-radius: 8px;\n        padding: 12px\n    }\n\n    .menu-button-10.w--open {\n        background-color: #160042;\n        border-color: #fff\n    }\n\n    .navigation-menu-6 {\n        color: #393b6a;\n        background-color: #fff;\n        border-radius: 8px;\n        padding: 12px;\n        position: absolute\n    }\n\n    .navigation-menu-6.w--open {\n        background-color: #282556;\n        border-color: #fff\n    }\n\n    .navigation-link-6 {\n        width: 100%\n    }\n\n    .hollow-button-4 {\n        padding: 20px\n    }\n\n    .home-slider-image-5,\n    .home-slider-image-6 {\n        width: 40%\n    }\n\n    .div-block-478 {\n        grid-template-columns: 1fr\n    }\n\n    .image-158 {\n        width: 64%;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .features-grid-3 {\n        grid-row-gap: 30px;\n        grid-template-columns: 1fr\n    }\n\n    .features-grid-4 {\n        grid-row-gap: 30px;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .div-block-501 {\n        justify-content: center;\n        display: flex\n    }\n\n    .div-block-502 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .paragraph-117.sub {\n        font-size: 14px\n    }\n\n    .div-block-598 {\n        justify-content: space-between\n    }\n\n    .webinar-cta.pink-border.pink-text {\n        margin-top: 22px\n    }\n\n    .container-1285 {\n        padding-left: 31px;\n        padding-right: 31px\n    }\n\n    .banner-cta-blog {\n        width: 400px\n    }\n\n    .image-203 {\n        width: 100px\n    }\n\n    .div-block-665 {\n        flex-direction: column\n    }\n\n    .link-button-copy2 {\n        border-style: none;\n        align-self: center;\n        width: 210px;\n        margin-bottom: 40px;\n        margin-left: 0;\n        margin-right: 0;\n        padding-left: 2px;\n        left: 0\n    }\n\n    .div-block-666 {\n        align-self: center\n    }\n\n    .case-study-hero-heading-2 {\n        font-size: 50px;\n        line-height: 100%\n    }\n\n    .navigation-link-10 {\n        width: 100%\n    }\n\n\n    .colors-grid {\n        grid-template-columns: 1fr 1fr 1fr 1fr\n    }\n\n    .heading-64px {\n        font-size: 56px\n    }\n\n    .heading-64px.hero-home-heading {\n        font-size: 64px\n    }\n\n    .heading-64px.hero-home-heading.top {\n        display: block\n    }\n\n    .heading-64px.text-align-center.integra {\n        font-size: 28px\n    }\n\n    .heading-90px {\n        font-size: 72px\n    }\n\n    .heading-56px {\n        font-size: 46px\n    }\n\n    .heading-48px {\n        font-size: 42px\n    }\n\n    .heading-40px {\n        font-size: 36px\n    }\n\n    .navigation-bar {\n        top: 0\n    }\n\n    .navbar-container {\n        position: static\n    }\n\n    .navigation-menu {\n        background-color: var(--transparent);\n        width: 100%;\n        margin-left: auto;\n        margin-right: auto;\n        position: absolute;\n        overflow: visible\n    }\n\n    .navigation-menu.new {\n        margin-right: auto\n    }\n\n    .navigation-menu.new.optimize {\n        background-color: rgba(255, 255, 255, 0)\n    }\n\n    .nav-links-contain {\n        grid-row-gap: 0px;\n        background-color: var(--soft-pink);\n        border-bottom-right-radius: 20px;\n        border-bottom-left-radius: 20px;\n        flex-direction: column;\n        align-items: flex-start;\n        width: 90%;\n        height: 100%;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 0px 16px 24px;\n        position: relative;\n        overflow: visible;\n        box-shadow: 0px 46px 29px 25px rgba(8, 9, 10, .1),0px 100px 27px -3px rgba(8, 9, 10, .1);\n    }\n\n    .nav-links-contain.new.adpage {\n        background-color: var(--soft-pink);\n        width: 100%;\n        height: auto;\n        margin-right: 0;\n        box-shadow: 0 12px 20px -8px rgba(0, 0, 0, .2)\n    }\n\n    .navigation-link {\n        margin-left: 0;\n        font-family: Satoshi, sans-serif;\n        /*font-size: 18px*/\n    }\n\n    .navigation-link.login {\n        display: none\n    }\n\n    .navigation-link.white {\n        color: var(--black)\n    }\n\n    .navbar-dropdown {\n        width: 100%;\n        margin-left: 0\n    }\n\n    .navbar-dropdown-toggle {\n        justify-content: space-between;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .dropdown-lists {\n        display: none\n    }\n\n    .dropdown-lists.w--open {\n        box-shadow: none;\n        border-radius: 0;\n        padding-top: 0;\n        display: none;\n        position: static;\n        left: 0\n    }\n\n    .dropdown-links-contain {\n        box-shadow: none;\n        border-radius: 0\n    }\n\n    .dropdown-links-contain.w--open {\n        box-shadow: none;\n        border-left: 1px solid rgba(28, 28, 31, .1);\n        border-radius: 0\n    }\n\n    .dropdown-links-contain.product {\n        background-color: rgba(255, 255, 255, 0);\n        width: auto;\n        padding-top: 0;\n        padding-left: 0;\n        padding-right: 0;\n        display: flex\n    }\n\n    .dropdown-links-contain.solutions {\n        background-color: rgba(255, 255, 255, 0);\n        width: auto;\n        padding: 0 0 24px\n    }\n\n    .dropdown-links-contain.resources {\n        background-color: var(--transparent);\n        width: auto;\n        padding: 0\n    }\n\n    .dropdown-arrow-embed {\n        width: 16px;\n        height: 16px\n    }\n\n    .dropdown-arrow-embed.mobile {\n        width: 14px;\n        height: 24px;\n        display: block\n    }\n\n    .dropdown-arrow-embed.desktop {\n        display: none\n    }\n\n    .navigation-button-contain {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        margin-left: auto;\n        margin-right: 16px\n    }\n\n    .navigation-button-contain.in-menu {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        flex-direction: column;\n        width: 100%;\n        margin-top: 0px;\n        margin-left: 0;\n        margin-right: 0;\n        display: flex\n    }\n\n    .navigation-button-contain.in-menu.bottom {\n        margin-top: auto;\n        padding-top: 24px\n    }\n\n    .navigation-button-contain.in-menu.bottom.new {\n        padding-top: 10px\n    }\n\n    .hero-home-wrapper {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column;\n        align-items: center;\n        display: flex\n    }\n\n    .hero-home-wrapper.new {\n        padding-top: 180px\n    }\n\n    .transparent-arrow-button._16px.navigation {\n        padding-top: 16px;\n        padding-bottom: 16px\n    }\n\n    .transparent-arrow-button._16px.navigation.login {\n        width: 100%\n    }\n\n    .button-arrow-embed.menu {\n        width: 14px;\n        height: 16px\n    }\n\n    .hero-home-text-wrapper {\n        width: 100%;\n        margin-top: 44px;\n        padding-right: 0\n    }\n\n    .hero-home-text-wrapper.new {\n        justify-content: space-between;\n        align-items: center\n    }\n\n    .paragraph-18px.hero-home-paragraph {\n        padding-right: 0\n    }\n\n    .paragraph-18px.hero-home-paragraph.new {\n        width: 90%\n    }\n\n    .paragraph-18px.navbar-dropdown-text {\n        font-family: Satoshi, sans-serif\n    }\n\n    .paragraph-18px.callout-link-heading {\n        color: var(--dark-violet);\n        font-family: Satoshi, sans-serif;\n        font-weight: 700\n    }\n\n    .pink-arrow-button._16px {\n        font-size: 16px\n    }\n\n    .pink-arrow-button._16px.navigation,\n    .pink-arrow-button.ebook {\n        width: 100%\n    }\n\n    .stats-section {\n        padding-top: 44px\n    }\n\n    .stats-wrapper {\n        margin-top: 24px;\n        padding-top: 25px\n    }\n\n    .stats-grid {\n        grid-template-columns: 1fr 1fr;\n        margin-top: 35px\n    }\n\n    .heading-24px {\n        font-size: 22px\n    }\n\n    .logo-tain-image {\n        box-sizing: border-box\n    }\n\n    .type-cards-grid {\n        grid-template-columns: 1fr;\n        max-width: 640px\n    }\n\n    .heading-28px {\n        font-size: 24px\n    }\n\n    .collection-list-7 {\n        grid-template-columns: 1fr\n    }\n\n    .arrow-text-link.menu {\n        font-family: Satoshi, sans-serif;\n        font-weight: 700\n    }\n\n    .integrations-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column-reverse;\n        padding-top: 120px\n    }\n\n    .integrations-wrapper.saas {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        flex-direction: column\n    }\n\n    .integrations-wrapper.cloud {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px;\n        flex-direction: column\n    }\n\n    .integrations-text-wrapper,\n    .integrations-image-contain {\n        width: 100%\n    }\n\n    .calculator-container {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .calculator-left {\n        text-align: center;\n        align-items: center;\n        width: 100%\n    }\n\n    .calc-arrow-image {\n        display: none\n    }\n\n    .stack-tab-link {\n        min-width: 180px\n    }\n\n    .stack-tab-link-header {\n        padding-left: 12px;\n        padding-right: 12px\n    }\n\n    .paragraph-20px.stack-tab-link-text {\n        font-size: 18px\n    }\n\n    .stack-blocks-grid {\n        grid-template-columns: 1fr\n    }\n\n    .stack-block-image-contain.a-first {\n        max-width: 600px\n    }\n\n    .blogs-wrapper {\n        padding-bottom: 120px\n    }\n\n    .blogs-collection-list {\n        grid-template-columns: 1fr\n    }\n\n    .blogs-collection-list._3-column-grid {\n        grid-row-gap: 40px;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .blog-post-wrapper.featured {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        flex-direction: column-reverse\n    }\n\n    .blog-post-wrapper.load-list:hover {\n        padding: 0\n    }\n\n    .blog-post-image-wrapper.featured.blog-page,\n    .blog-post-image-wrapper.featured.cms {\n        width: 100%;\n        height: 360px\n    }\n\n    .blog-post-image-wrapper.featured.resources-hero {\n        height: 300px\n    }\n\n    .blog-post-info-wrapper.featured,\n    .blog-post-info-wrapper.cms {\n        width: 100%\n    }\n\n    .paragraph-16px.dropdown-block-link-text {\n        text-align: left\n    }\n\n    .paragraph-16px.dropdown-block-link-text.auto {\n        margin-left: auto\n    }\n\n    .paragraph-16px.navigation-subheading.mobile {\n        text-align: left;\n        letter-spacing: normal;\n        text-transform: none;\n        padding-top: 18px;\n        padding-bottom: 18px;\n        font-size: 18px;\n        font-weight: 500\n    }\n\n    .paragraph-16px.dropdown-block-link-description {\n        text-align: left;\n        font-family: Inter, sans-serif;\n        font-size: 14px\n    }\n\n    .paragraph-16px.dropdown-block-link-heading {\n        font-weight: 500\n    }\n\n    .heading-32px {\n        font-size: 28px\n    }\n\n    .ctas-container {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column\n    }\n\n    .ctas-text-wrapper,\n    .ctas-text-wrapper._50 {\n        width: 100%\n    }\n\n    .brand-logo.first {\n        width: 60px;\n        margin-right: 10px\n    }\n\n    .brand-logo.second {\n        width: 64px;\n        margin-right: 10px\n    }\n\n    .brand-logo.third {\n        width: 70px\n    }\n\n    .footer-divider.socials {\n        display: none\n    }\n\n    .footer-links-wrapper {\n        grid-template-columns: 1fr 1fr 1fr\n    }\n\n    .footer-links-column.fifth.new {\n        flex-flow: wrap;\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .tribe-tabs {\n        flex-direction: column-reverse\n    }\n\n    .tribe-tabs-content {\n        width: 100%;\n        max-width: 600px;\n        margin-bottom: 60px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .tribe-tabs-menu,\n    .tribe-tabs-menu.about {\n        width: 100%\n    }\n\n    .ctas-image-wrapper {\n        width: 100%;\n        max-width: 320px\n    }\n\n    .spend-wrapper {\n        padding-top: 120px;\n        padding-bottom: 120px\n    }\n\n    .calculator-right {\n        width: 100%;\n        max-width: 640px\n    }\n\n    .spend-block-wrapper {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px\n    }\n\n    .spend-block-wrapper.c,\n    .spend-block-wrapper.a {\n        min-height: 260px\n    }\n\n    .spend-block-wrapper.a.new._1 {\n        flex: none;\n        justify-content: flex-start;\n        align-items: flex-start;\n        width: 550px;\n        min-height: auto;\n        padding-left: 0%;\n        display: none;\n        top: 180%\n    }\n\n    .spend-block-wrapper.a.new._2 {\n        width: 550px;\n        min-height: auto;\n        display: none;\n        top: 200%;\n        left: -90%\n    }\n\n    .spend-block-wrapper.a.new._3 {\n        width: 550px;\n        min-height: auto;\n        display: none;\n        top: 100%;\n        left: -125%\n    }\n\n    .spend-block-wrapper.b {\n        min-height: 260px\n    }\n\n    .spend-text-container {\n        padding: 30px 30px 40px\n    }\n\n    .spend-image-wrapper.second {\n        border-radius: 16px;\n        padding-left: 0\n    }\n\n    .spend-image-wrapper.first {\n        border-top-left-radius: 16px;\n        border-top-right-radius: 16px;\n        padding-top: 40px;\n        padding-bottom: 40px;\n        padding-left: 40px\n    }\n\n    .spend-image-wrapper.third {\n        border-radius: 16px;\n        padding-left: 0\n    }\n\n    .spend-text-blocks-contain {\n        height: 260px\n    }\n\n    .spend-images-gradient-border {\n        border-radius: 0 0 16px 16px;\n        width: 100%;\n        margin-top: -16px;\n        left: 0;\n        overflow: hidden\n    }\n\n    .paragraph-22px {\n        font-size: 20px\n    }\n\n    .spend-image-container {\n        border-radius: 16px;\n        padding-top: 16px\n    }\n\n    .spend-text-gradient-border {\n        width: 100%;\n        max-width: none;\n        top: 0\n    }\n\n    .spend-sticky-block {\n        flex-direction: column;\n        max-width: 600px;\n        margin-left: auto;\n        margin-right: auto;\n        padding-left: 0;\n        top: 100px\n    }\n\n    .heading-252.new {\n        font-size: 20px\n    }\n\n    .reviews-slide-wrapper {\n        flex-direction: column-reverse;\n        justify-content: flex-end;\n        align-items: center;\n        max-width: 500px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .reviews-slide-image-contain {\n        width: 100%;\n        max-width: none\n    }\n\n    .reviews-slide-text-gradient-wrapper {\n        width: 100%\n    }\n\n    .review-slide-text-wrapper {\n        padding-top: 34px;\n        padding-left: 34px;\n        padding-right: 34px\n    }\n\n    .slider-arrow.right {\n        right: 16%\n    }\n\n    .slider-arrow.left {\n        left: 16%\n    }\n\n    .slider-arrow.left.events {\n        left: auto\n    }\n\n    .logos-white-gradient {\n        width: 140px\n    }\n\n    .navigation-menu-button {\n        border: 2px solid rgba(22 163 74);\n        border-radius: 10px;\n        flex-direction: column;\n        justify-content: space-between;\n        padding: 16px;\n        display: flex\n    }\n\n    .navigation-menu-button.w--open {\n        background-color: rgba(36, 2, 19, .1)\n    }\n\n    .navigation-menu-button.white {\n        border-color: rgba(255, 255, 255, .4)\n    }\n\n    .navigation-menu-button.white.w--open {\n        background-color: rgba(255, 255, 255, .1)\n    }\n\n    .burger-line.a.white,\n    .burger-line.b.white,\n    .burger-line.c.white {\n        background-color: var(--white)\n    }\n\n    .hero-bkg {\n        height: 60%;\n        max-height: none\n    }\n\n    .hero-bkg.blog-cms,\n    .hero-bkg.hub {\n        max-height: none\n    }\n\n    .home-hero-images-container {\n        width: 100%\n    }\n\n    .hero-bubbles-block-wrapper {\n        bottom: 6%;\n        left: 15%\n    }\n\n    .calc-anchor {\n        top: -87px\n    }\n\n    .navigation-background-div {\n        display: none\n    }\n\n    .navigation-links-grid {\n        grid-column-gap: 32px;\n        grid-row-gap: 24px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        display: grid\n    }\n\n    .navigation-links-grid.resources {\n        flex-direction: column-reverse;\n        grid-template-columns: 1fr;\n        display: flex\n    }\n\n    .dropdown-link-arrow-embed.mobile {\n        height: 24px\n    }\n\n    .navbar-dropdown-text {\n        font-family: Satoshi, sans-serif;\n        font-size: 18px\n    }\n\n    .dropdown-highlight-span {\n        background-color: rgba(213, 57, 135, .1)\n    }\n\n    .navigation-block-link {\n        padding-left: 0\n    }\n\n    .dropdown-resources-column {\n        flex-direction: row;\n        padding-top: 24px;\n        padding-bottom: 24px;\n        padding-left: 0\n    }\n\n    .resource-dropdown-image-contain {\n        height: auto;\n        padding: 16px\n    }\n\n    .integrations-lottie.integra {\n        width: 100%\n    }\n\n    .spend-anchor.third {\n        top: 60%\n    }\n\n    .linear-bkg-menu-button {\n        z-index: 3;\n        display: block;\n        position: relative\n    }\n\n    .dropdown-links-divider {\n        background-color: rgba(213, 57, 135, .1);\n        width: 100%;\n        height: 1px;\n        padding-bottom: 0;\n        padding-right: 0;\n        display: block\n    }\n\n    .navigation-inner-wrapper {\n        background-color: none;\n        width: 100%;\n        height: 76vh;\n        margin-left: 0;\n        margin-right: 0;\n        padding-top: 0px;\n        /* padding-bottom: 10px; */\n        position: static;\n        overflow: visible;\n    }\n\n    .navigation-inner-wrapper.white {\n        background-color: none\n    }\n\n    .navigation-inner-wrapper.white.new {\n        background-color: rgba(133, 131, 130, .68);\n        height: 100vh;\n        margin-left: 0;\n        margin-right: 0;\n        padding: 0 17px 40px\n    }\n\n    .navigation-inner-wrapper.white.new.optimize {\n        display: block;\n        overflow: visible\n    }\n\n    .hero-platform-heading-wrapper {\n        margin-top: 0\n    }\n\n    .hero-platform-subheading.integra {\n        margin-top: 21px\n    }\n\n    .hero-platform-subheading-text.integra {\n        font-size: 16px\n    }\n\n    .hero-platform-cta-wrapper.integra {\n        margin-top: 19px\n    }\n\n    .blogs-hero-wrapper {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 160px;\n        display: flex\n    }\n\n    .blogs-hero-wrapper.cms {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column\n    }\n\n    .featured-block-contain {\n        max-width: 700px\n    }\n\n    .featured-block-contain.resources {\n        width: 100%\n    }\n\n    .blog-tabs-wrapper {\n        padding-top: 120px\n    }\n\n    .blogs-tab-link {\n        width: auto;\n        min-width: 100px;\n        max-width: 150px;\n        font-size: 18px\n    }\n\n    .blog-tabs-info-wrapper {\n        max-width: 800px\n    }\n\n    .ctas-form-gradient-wrapper {\n        width: 100%\n    }\n\n    .blog-cms-info-wrapper {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column;\n        align-items: center;\n        padding-bottom: 120px\n    }\n\n    .blog-cms-left-contain {\n        width: 100%\n    }\n\n    .block-rich-text h1 {\n        font-size: 56px\n    }\n\n    .block-rich-text h2 {\n        font-size: 46px\n    }\n\n    .block-rich-text h3 {\n        font-size: 42px\n    }\n\n    .block-rich-text h4 {\n        font-size: 36px\n    }\n\n    .block-rich-text h5 {\n        font-size: 28px\n    }\n\n    .block-rich-text h6 {\n        font-size: 24px\n    }\n\n    .block-rich-text blockquote {\n        background-size: 40px;\n        padding-top: 100px;\n        font-size: 28px\n    }\n\n    .feature-wrap {\n        grid-column-gap: 10px;\n        grid-row-gap: 10px\n    }\n\n    .feature-image-wrapper.right.pink-bg {\n        flex: 1\n    }\n\n    .feature-image-wrapper.right.green-bg,\n    .feature-image-wrapper.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper.left.green-bg {\n        flex: 1;\n        height: 350px\n    }\n\n    .feature-image-wrapper.left.yellow-bg {\n        flex-direction: column;\n        flex: 1;\n        justify-content: center;\n        align-items: center;\n        width: 50%;\n        height: 300px;\n        padding-top: 0;\n        padding-bottom: 0;\n        padding-left: 0\n    }\n\n    .feature-image-wrapper.left.pink-bg {\n        flex: 1;\n        height: 300px\n    }\n\n    .feature-content-wrap {\n        width: 50%\n    }\n\n    .feature-content-header {\n        padding-left: 10px\n    }\n\n    .feature-content-heading-text {\n        font-size: 25px\n    }\n\n    .feature-content-body-text {\n        font-size: 16px;\n        line-height: 1.2\n    }\n\n    .blog-cms-sticky-contain,\n    .subscribe-form-gradient-wrapper {\n        width: 100%\n    }\n\n    .related-blogs-wrapper {\n        max-width: 800px\n    }\n\n    .navigation-bar-dark {\n        top: 0\n    }\n\n    .navbar-dropdown-toggle-white {\n        color: var(--black);\n        justify-content: space-between;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .transparent-arrow-button-white._16px.navigation {\n        padding-top: 16px;\n        padding-bottom: 16px\n    }\n\n    .resources-hero-wrapper {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column;\n        align-items: center;\n        padding-top: 160px;\n        display: flex\n    }\n\n    .resource-left-header {\n        width: 100%\n    }\n\n    .resource-tabs-wrapper {\n        grid-column-gap: 50px;\n        grid-row-gap: 50px;\n        flex-direction: column;\n        align-items: center;\n        max-width: 800px;\n        padding-top: 120px\n    }\n\n    .resource-tab-info-wrapper {\n        width: 100%\n    }\n\n    .resource-tab-icon-embed {\n        width: 32px;\n        height: 32px\n    }\n\n    .resource-collection-list {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .resource-post-image-wrapper {\n        height: 280px\n    }\n\n    .div-block-737 {\n        padding-top: 140px\n    }\n\n    .div-block-740.social {\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .book-demo-form-graphic-1.social,\n    .image-222.social {\n        display: none\n    }\n\n    .text-span-251 {\n        text-align: left\n    }\n\n    .navbar-dropdown-white {\n        width: 100%;\n        margin-left: 0\n    }\n\n    .blogs-tabs-form {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        flex-direction: column-reverse;\n        align-items: center\n    }\n\n    .blog-tag-radio-buttons-contain {\n        flex-wrap: wrap\n    }\n\n    .resource-tabs-filters {\n        width: 100%;\n        max-width: none;\n        position: static\n    }\n\n    .resource-tab-form {\n        flex-direction: column;\n        align-items: center;\n        display: flex\n    }\n\n    .resources-radio-button-contain {\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        display: flex\n    }\n\n    .resource-tab-form-separator {\n        max-width: 400px\n    }\n\n    .procurement-team-cards-grid {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .procurement-team-member-card {\n        margin-bottom: 40px\n    }\n\n    .paragraph-146 {\n        font-size: 16px\n    }\n\n    .saas-hero-text-wrapper {\n        max-width: 600px\n    }\n\n    .saas-hero-wrapper {\n        flex-direction: column;\n        align-items: center;\n        display: flex\n    }\n\n    .saas-hero-absolute-image {\n        width: 40%\n    }\n\n    .stats-section-contain {\n        padding-top: 40px\n    }\n\n    .flex-container._140px-bottom-margin {\n        grid-column-gap: 120px;\n        grid-row-gap: 120px;\n        padding-bottom: 120px\n    }\n\n    .flex-container._115px-bottom-margin {\n        grid-column-gap: 120px;\n        grid-row-gap: 120px;\n        padding-top: 120px\n    }\n\n    .flex-block-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column\n    }\n\n    .flex-block-wrapper.reverse {\n        flex-direction: column-reverse\n    }\n\n    .flex-block-wrapper.lottie {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px;\n        padding-top: 100px\n    }\n\n    .flex-text-block,\n    .flex-text-block._580px,\n    .flex-text-block._550px,\n    .flex-text-block.vertical-cloud,\n    .flex-image-block {\n        width: 100%\n    }\n\n    .flex-image-block.lottie {\n        width: 100%;\n        padding-top: 0;\n        padding-bottom: 0;\n        left: 0%\n    }\n\n    .flex-block-abs-image {\n        width: 40%\n    }\n\n    .solution-callout-wrapper {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        flex-direction: column;\n        max-width: 600px\n    }\n\n    .solution-callout-text-wrapper,\n    .solution-callout-text-wrapper.cloud {\n        width: 100%\n    }\n\n    .solution-callout-images-contain {\n        width: 100%;\n        max-width: 500px;\n        margin-left: -10%;\n        position: static;\n        top: auto;\n        bottom: -6%;\n        left: auto;\n        right: auto\n    }\n\n    .solution-callout-images-contain.cloud {\n        width: 100%;\n        max-width: 500px;\n        margin-bottom: -20%;\n        margin-left: -10%;\n        position: static\n    }\n\n    .solution-callout-images-contain.saas {\n        margin-bottom: -20%;\n        margin-left: 0%\n    }\n\n    .setup-cards-grid {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        flex-direction: column;\n        max-width: 340px\n    }\n\n    .cloud-hero-wrapper {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column;\n        align-items: center;\n        display: flex\n    }\n\n    .cloud-hero-text-wrapper {\n        width: 100%;\n        max-width: 540px\n    }\n\n    .cloud-hero-image-wrapper {\n        width: 100%\n    }\n\n    .cloud-hero-absolute-image {\n        width: 40%\n    }\n\n    .cloud-hero-absolute-image.second {\n        width: 45%\n    }\n\n    .cloud-absolute-image {\n        width: 30%\n    }\n\n    .cloud-absolute-image.second {\n        width: 26%\n    }\n\n    .tabs {\n        grid-template-columns: 1fr\n    }\n\n    .footer-socials-contain {\n        justify-content: center\n    }\n\n    .footer-end-wrapper {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        flex-direction: column\n    }\n\n    .navigation-block-link-wrapper {\n        grid-column-gap: 14px;\n        grid-row-gap: 14px;\n        padding-top: 18px;\n        padding-bottom: 18px\n    }\n\n    .navigation-icon-embed {\n        flex: none\n    }\n\n    .navigation-icon-embed._32px {\n        width: 32px;\n        height: 32px\n    }\n\n    .nav-mobile-contain {\n        grid-row-gap: 0px;\n        background-color: var(--soft-pink);\n        border-radius: 10px;\n        flex-direction: column;\n        align-items: flex-start;\n        width: 90%;\n        margin-left: auto;\n        margin-right: auto;\n        padding: 4px 16px 24px;\n        display: flex;\n        position: relative\n    }\n\n    .product-dropdown-wrapper {\n        z-index: 1300;\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        background-color: #faf2eb;\n        flex-direction: column;\n        width: 100%;\n        margin-left: 100%;\n        padding-top: 24px;\n        display: flex;\n        position: absolute;\n        top: 0%;\n        bottom: 0%;\n        left: 0%;\n        right: 0%;\n        overflow: auto\n    }\n\n    .dropdown-mobile-link-contain {\n        grid-column-gap: 18px;\n        grid-row-gap: 18px;\n        flex-direction: column;\n        align-items: flex-start;\n        padding-left: 16px;\n        padding-right: 16px;\n        display: flex\n    }\n\n    .dropdown-mobile-link-contain.bottom {\n        margin-top: auto;\n        padding-bottom: 16px\n    }\n\n    .dropdown-mobile-link-contain.solutions {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px\n    }\n\n    .dropdown-mobile-link-contain.resources {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px;\n        margin-top: -18px\n    }\n\n    .dropdown-callout-link-wrapper {\n        background-color: rgba(213, 57, 135, .1);\n        border-radius: 12px;\n        justify-content: space-between;\n        align-items: center;\n        padding: 16px;\n        display: flex\n    }\n\n    .callout-header {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        align-items: center;\n        display: flex\n    }\n\n    .mobile-dropdown {\n        width: 100%\n    }\n\n    .mobile-dropdown-toggle {\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        padding: 0;\n        display: flex\n    }\n\n    .mobile-dropdown-list {\n        position: static;\n        overflow: hidden\n    }\n\n    .mobile-dropdown-list.w--open {\n        background-color: rgba(255, 255, 255, 0);\n        position: static\n    }\n\n    .mobile-dropdown-links-contain {\n        flex-direction: column;\n        padding-top: 18px;\n        display: flex\n    }\n\n    .mobile-links-divider {\n        background-color: var(--pabloo-green);\n        opacity: .1;\n        width: 100%;\n        height: 1px;\n        padding-bottom: 0;\n        padding-right: 0;\n        display: block\n    }\n\n    .solutions-dropdown-wrapper,\n    .resources-dropdown-wrapper {\n        z-index: 1300;\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        background-color: #faf2eb;\n        flex-direction: column;\n        width: 100%;\n        margin-left: 100%;\n        padding-top: 24px;\n        display: flex;\n        position: absolute;\n        top: 0%;\n        bottom: 0%;\n        left: 0%;\n        right: 0%;\n        overflow: auto\n    }\n\n    .ncf-filter-item-container {\n        grid-template-columns: 1fr 1fr\n    }\n\n    ._24px-icon {\n        flex: none\n    }\n\n    .points-text-contain {\n        width: 50%;\n        max-width: 660px;\n        margin-bottom: 50px\n    }\n\n    .points-image-contain {\n        width: 100%\n    }\n\n    .points-bg-contain {\n        top: 0%\n    }\n\n    .points-bg-image {\n        height: 100%\n    }\n\n    .section-70 {\n        padding-bottom: 38px;\n        padding-left: 25px;\n        padding-right: 25px\n    }\n\n    .features-wrapper-2 {\n        justify-content: space-between\n    }\n\n    .sysf-collapse-text {\n        display: none\n    }\n\n    .material-icons.sysf-icon-left.sysf-icon-collapse {\n        margin-top: 1px\n    }\n\n    .sysf-section-title {\n        width: 100%;\n        margin-bottom: 32px\n    }\n\n    .sysf-section-title.sysf-centered {\n        width: 75%\n    }\n\n    .sysf-container {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .sysf-faq-question {\n        line-height: 1.5\n    }\n\n    .sysf-faq-item-wrapper.sysf-box,\n    .sysf-faq-item-wrapper.sysf-box.sysf-last {\n        margin-bottom: 16px\n    }\n\n    .sysf-column {\n        width: 100%\n    }\n\n    .sysf-row {\n        flex-direction: column\n    }\n\n    .brix---heading-h3-size {\n        font-size: 22px;\n        line-height: 32px\n    }\n\n    .brix---display-2 {\n        font-size: 58px;\n        line-height: 70px\n    }\n\n    .brix---heading-h2-size {\n        font-size: 30px;\n        line-height: 46px\n    }\n\n    .brix---text-center-tablet {\n        text-align: center\n    }\n\n    .brix---grid-stats-v4 {\n        grid-template-columns: 1fr\n    }\n\n    .brix---section {\n        padding-top: 33px;\n        padding-bottom: 118px\n    }\n\n    .brix---heading-h3-size-2 {\n        font-size: 22px;\n        line-height: 32px\n    }\n\n    .brix---mg-bottom-48px {\n        margin-bottom: 0\n    }\n\n    .brix---grid-3-columns---1-col-mb {\n        grid-template-columns: 1fr\n    }\n\n    .bold-text-26 {\n        font-size: 27px\n    }\n\n    .button-48 {\n        text-align: center;\n        padding-left: 13px;\n        padding-right: 13px\n    }\n\n    .image-230 {\n        height: 250px\n    }\n\n    .new-product-heading-4 {\n        line-height: 100%\n    }\n\n    .image-231 {\n        height: 350px\n    }\n\n    .image-232,\n    .image-233,\n    .image-234 {\n        height: 340px\n    }\n\n    .image-236 {\n        height: 300px\n    }\n\n    .hero-platform-wrapper-solutions {\n        padding-top: 125px\n    }\n\n    .heading-64px-copy {\n        font-size: 56px\n    }\n\n    .heading-64px-copy.hero-home-heading {\n        font-size: 64px\n    }\n\n    .heading-64px-copy.hero-home-heading.top {\n        display: block\n    }\n\n    .heading-64px-new {\n        font-size: 56px\n    }\n\n    .heading-64px-new.hero-home-heading {\n        font-size: 64px\n    }\n\n    .heading-64px-new.hero-home-heading.top {\n        display: block\n    }\n\n    .image-238 {\n        flex: 0 auto;\n        order: 0;\n        align-self: auto;\n        padding-top: 42px\n    }\n\n    .feature-image-wrapper-copy.right.green-bg {\n        flex: 1;\n        width: 50%;\n        height: 350px\n    }\n\n    .feature-image-wrapper-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        flex-direction: column;\n        flex: 1;\n        justify-content: flex-end;\n        align-items: center;\n        width: 50%;\n        height: 350px;\n        padding-top: 0;\n        padding-bottom: 0;\n        padding-left: 0;\n        display: flex\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        flex: 1\n    }\n\n    .feature-content-heading-text-copy {\n        font-size: 22px\n    }\n\n    .image-239 {\n        object-fit: fill\n    }\n\n    .image-240 {\n        max-width: 100%\n    }\n\n    .image-241 {\n        height: 50px\n    }\n\n    .ctas-text-wrapper-copy,\n    .ctas-text-wrapper-copy._50,\n    .ctas-text-wrapper-copy,\n    .ctas-text-wrapper-copy._50 {\n        width: 100%\n    }\n\n    .heading-48px-copy {\n        font-size: 42px\n    }\n\n    .paragraph-18px-copy.navbar-dropdown-text {\n        font-family: Satoshi, sans-serif\n    }\n\n    .paragraph-18px-copy.callout-link-heading {\n        color: var(--dark-violet);\n        font-family: Satoshi, sans-serif;\n        font-weight: 700\n    }\n\n    .heading-28px-copy,\n    .heading-28px-copy-copy {\n        font-size: 24px\n    }\n\n    .ctas-text-wrapper-copy-copy,\n    .ctas-text-wrapper-copy-copy._50,\n    .ctas-text-wrapper-copy-copy-copy,\n    .ctas-text-wrapper-copy-copy-copy._50 {\n        width: 100%\n    }\n\n    .feature-image-wrapper-copy-copy.right.green-bg {\n        flex: 1;\n        width: 50%;\n        height: 350px\n    }\n\n    .feature-image-wrapper-copy-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy-copy.left.green-bg {\n        flex: 1\n    }\n\n    .feature-image-wrapper-copy-copy.left.yellow-bg {\n        flex-direction: column;\n        flex: 1;\n        justify-content: flex-end;\n        align-items: center;\n        width: 50%;\n        height: 350px;\n        padding-top: 0;\n        padding-bottom: 0;\n        padding-left: 0;\n        display: flex\n    }\n\n    .feature-image-wrapper-copy-copy.left.pink-bg {\n        flex: 1\n    }\n\n    .feature-content-wrap-copy {\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy.right.green-bg,\n    .feature-image-wrapper-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        flex: 1;\n        width: 50%;\n        padding-top: 0;\n        padding-bottom: 0;\n        padding-left: 0\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        flex: 1;\n        height: 350px;\n        padding-left: 12px\n    }\n\n    .image-245 {\n        max-width: 100%\n    }\n\n    .feature-image-wrapper-copy.right.green-bg,\n    .feature-image-wrapper-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy.right.green-bg,\n    .feature-image-wrapper-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .stats-wrapper-copy,\n    .stats-wrapper-new,\n    .stats-wrapper-copy {\n        margin-top: 24px;\n        padding-top: 25px\n    }\n\n    .stats-section-copy {\n        margin-top: 19px\n    }\n\n    .feature-image-wrapper-copy.right.green-bg,\n    .feature-image-wrapper-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy.left.green-bg {\n        flex: 1\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        flex-direction: column;\n        flex: 1;\n        justify-content: center;\n        align-items: center;\n        width: 50%;\n        padding-top: 0;\n        padding-bottom: 0;\n        padding-left: 0\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        flex: 1;\n        height: 350px\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.green-bg {\n        flex: 1;\n        width: 50%;\n        height: 350px;\n        padding-right: 0\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.green-bg-copy {\n        flex: 1;\n        width: 50%\n    }\n\n    .feature-image-wrapper-copy-copy-copy.left.green-bg {\n        flex: 1\n    }\n\n    .feature-image-wrapper-copy-copy-copy.left.yellow-bg {\n        flex-direction: column;\n        flex: 1;\n        justify-content: flex-end;\n        align-items: center;\n        width: 50%;\n        height: 350px;\n        padding-top: 0;\n        padding-bottom: 0;\n        padding-left: 0;\n        display: flex\n    }\n\n    .feature-image-wrapper-copy-copy-copy.left.pink-bg {\n        flex: 1\n    }\n\n    .hero-heading-copy {\n        line-height: 100%\n    }\n\n    .new-navigation-background-div {\n        display: none;\n        overflow: visible\n    }\n\n    .container-1289 {\n        max-width: 100%;\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .div-block-20-copy {\n        margin-top: 40px;\n        padding-top: 0%;\n        padding-bottom: 4%\n    }\n\n    .navigation-background-div-black {\n        display: none\n    }\n\n    .features-wrapper-copy {\n        margin-top: 6px\n    }\n\n    .image-231-copy {\n        height: 350px\n    }\n\n    .wrapper-1280px-copy {\n        flex-direction: column;\n        max-width: 600px\n    }\n\n    .wrapper-1280px-copy.popup-div {\n        max-width: 1000px;\n        padding-top: 100px\n    }\n\n    .wrapper-1280px-copy.discover-new-product-flex {\n        flex-direction: column-reverse;\n        padding-top: 50px\n    }\n\n    .wrapper-1280px-copy.discover-purchase-flex {\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px-copy.case-study-hero-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px-copy.track-approval-flex {\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px-copy.workflow-approval-flex {\n        flex-direction: column;\n        padding-top: 30px\n    }\n\n    .wrapper-1280px-copy.document-one-place-flex {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px-copy.assisted-tools-flex,\n    .wrapper-1280px-copy.actionable-insight-flex,\n    .wrapper-1280px-copy.contract-renewals-flex {\n        flex-direction: column-reverse\n    }\n\n    .wrapper-1280px-copy.points-container {\n        max-width: 660px\n    }\n\n    .container-1290 {\n        max-width: 728px\n    }\n\n    .navbar-wrapper-three {\n        justify-content: space-between\n    }\n\n    .navbar-brand-three {\n        position: relative\n    }\n\n    .nav-menu-wrapper-three {\n        background-color: transparent;\n        top: 70px\n    }\n\n    .nav-menu-three {\n        background-color: #fff;\n        border-radius: 50px;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        align-items: center;\n        margin-top: 10px;\n        padding: 20px;\n        display: flex;\n        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)\n    }\n\n    .nav-link-6 {\n        padding-left: 5px;\n        padding-right: 5px\n    }\n\n    .nav-dropdown-list.shadow-three.w--open {\n        position: absolute\n    }\n\n    .menu-button-11 {\n        padding: 12px\n    }\n\n    .menu-button-11.w--open {\n        color: #fff;\n        background-color: #a6b1bf\n    }\n\n    .hello-bar-link {\n        color: var(--white);\n        text-align: center;\n        font-weight: 500\n    }\n\n    .new-hello-bar {\n        background-color: var(--pabloo-green);\n        text-align: center;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        display: block\n    }\n\n    .hello-navbar-container {\n        position: static\n    }\n\n    .heading-90px-copy {\n        font-size: 72px\n    }\n\n    .heading-24px-copy {\n        font-size: 22px\n    }\n\n    .home-hero-heading-copy {\n        font-size: 40px;\n        line-height: 48px\n    }\n\n    .cta-section-copy {\n        background-position: 50% 0\n    }\n\n    .stats-grid-copy {\n        grid-template-columns: 1fr 1fr;\n        margin-top: 35px\n    }\n\n    .hero-bkg-copy.blog-cms,\n    .hero-bkg-copy.hub {\n        max-height: none\n    }\n\n    .wrapper-1300px-copy-copy {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .wrapper-1300px-copy-copy.home-hero-flex {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column;\n        align-items: center\n    }\n\n    .image-247 {\n        height: 90%\n    }\n\n    .div-block-799 {\n        grid-template-columns: 1fr\n    }\n\n    .blog-hero-heading-copy {\n        font-size: 55px;\n        line-height: 54px\n    }\n\n    .hero-bkg-copy {\n        height: 60%;\n        max-height: none\n    }\n\n    .hero-bkg-copy.blog-cms,\n    .hero-bkg-copy.hub {\n        max-height: none\n    }\n\n    .hero-bkg-copy-copy {\n        height: 60%;\n        max-height: none\n    }\n\n    .hero-bkg-copy-copy.blog-cms,\n    .hero-bkg-copy-copy.hub {\n        max-height: none\n    }\n\n    .text-block-330 {\n        margin-top: 39px\n    }\n\n    .cms-blog-block-section-copy.templates-block {\n        padding-bottom: 139px\n    }\n\n    .wrapper-1300px-copy {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .wrapper-1300px-copy.home-hero-flex {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column;\n        align-items: center\n    }\n\n    .new-about-1300px-header {\n        margin-top: 27px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .new-about-1300px-header.home-hero-flex {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        flex-direction: column;\n        align-items: center\n    }\n\n    .new-about-hero-wrapper {\n        background-image: none;\n        background-position: 0 0;\n        background-repeat: repeat;\n        background-size: auto;\n        background-attachment: scroll;\n        padding-bottom: 20px\n    }\n\n    .text-span-294 {\n        font-size: 25px\n    }\n\n    .xs-text {\n        font-size: 52px\n    }\n\n    .about-heading-x {\n        font-size: 44px\n    }\n\n    .stats-wrapper-copy-copy,\n    .stats-xx {\n        margin-top: 24px;\n        padding-top: 25px\n    }\n\n    .text-block-332,\n    .text-block-332.intra {\n        font-size: 38px\n    }\n\n    .div-block-801.integra {\n        padding: 19px\n    }\n\n    .text-block-333 {\n        flex: 0 auto;\n        order: 0;\n        font-size: 16px\n    }\n\n    .tribe-section---about {\n        padding-top: 60px\n    }\n\n    .ctas-container-copy,\n    .about-x-platform-container {\n        grid-column-gap: 80px;\n        grid-row-gap: 80px;\n        flex-direction: column\n    }\n\n    .text-block-338 {\n        font-size: 38px\n    }\n\n    .about-x-cards {\n        margin-top: 3px\n    }\n\n    .about-x-card.new {\n        width: 100%\n    }\n\n    .text-block-342.intra {\n        font-size: 14px\n    }\n\n    .tabs-menu-5 {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px;\n        flex-flow: row;\n        flex: 0 auto;\n        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n        width: 100%;\n        margin-left: 0\n    }\n\n    .integra-tab {\n        width: 100%\n    }\n\n    .integra-tab.w--current {\n        border-color: var(--pabloo-green);\n        width: 100%\n    }\n\n    .integra-text,\n    .integra-text-block {\n        text-align: center\n    }\n\n    .tabs-2,\n    .div-block-810 {\n        flex-flow: column\n    }\n\n    .div-block-811 {\n        margin-top: 44px\n    }\n\n    .heading-265 {\n        font-size: 18px\n    }\n\n    .text-block-355 {\n        font-size: 32px\n    }\n\n    .div-block-819 {\n        grid-template-columns: 1fr 1fr 1fr\n    }\n\n    .paragraph-154 {\n        display: block\n    }\n\n    .section-72.ebooks,\n    .section-72.events {\n        background-color: var(--soft-pink)\n    }\n\n    .section-72.testimonial {\n        padding-top: 86px\n    }\n\n    .section-72.block3 {\n        padding-top: 91px\n    }\n\n    .div-block-822 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-823 {\n        display: flex\n    }\n\n    .image-249 {\n        object-fit: cover;\n        border-top-right-radius: 0;\n        border-bottom-left-radius: 35px;\n        align-self: center;\n        width: 100%;\n        height: 400px;\n        display: none\n    }\n\n    .div-block-824 {\n        border-top-right-radius: 35px;\n        border-bottom-right-radius: 35px;\n        border-bottom-left-radius: 35px;\n        padding-left: 70px\n    }\n\n    .text-block-357 {\n        text-align: center\n    }\n\n    .text-block-358 {\n        text-align: justify;\n        margin-bottom: 99px\n    }\n\n    .div-block-828 {\n        width: 100%\n    }\n\n    .text-block-359.events {\n        text-align: center\n    }\n\n    .div-block-830.why {\n        width: 35%\n    }\n\n    .text-block-363 {\n        line-height: 1\n    }\n\n    .text-block-365 {\n        font-size: 16px;\n        line-height: 1.3\n    }\n\n    .div-block-840 {\n        align-self: center\n    }\n\n    .text-block-370,\n    .text-block-371 {\n        text-align: center\n    }\n\n    .div-block-842 {\n        text-align: center;\n        align-self: center\n    }\n\n    .div-block-843 {\n        margin-bottom: 84px\n    }\n\n    .div-block-845 {\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .text-block-373 {\n        text-align: center\n    }\n\n    .testimonialx {\n        width: 100%\n    }\n\n    .div-block-850.partner {\n        margin-bottom: 66px\n    }\n\n    .events-expectations-section {\n        flex-flow: column\n    }\n\n    .event-exectations-tab {\n        width: 100%\n    }\n\n    .rich-text-block-30 {\n        text-align: justify;\n        margin-top: 9px\n    }\n\n    .div-block-857 {\n        width: 100%\n    }\n\n    .sysf-button.sysf-medium {\n        font-size: 16px\n    }\n\n    .about-pabloo-events {\n        margin-top: 41px;\n        margin-bottom: 28px\n    }\n\n    .div-block-860 {\n        justify-content: flex-start;\n        align-items: flex-start\n    }\n\n    .your-grid-container {\n        justify-content: center;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .features-wrapper-new.yellow {\n        grid-template-columns: 1fr\n    }\n\n    .feature-block-item.yellow2 {\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .div-block-861 {\n        flex-flow: column\n    }\n\n    .div-block-862 {\n        align-self: center;\n        width: 40%;\n        padding-top: 30px;\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .div-block-863 {\n        width: 100%;\n        padding: 60px\n    }\n\n    .text-block-387 {\n        text-align: center;\n        font-size: 25px\n    }\n\n    .image-262 {\n        width: 300px\n    }\n\n    .text-block-388 {\n        text-align: justify;\n        font-size: 18px\n    }\n\n    .container-1292 {\n        max-width: 728px\n    }\n\n    .tabs-4 {\n        background-size: cover;\n        flex-flow: column;\n        height: auto\n    }\n\n    .tabs-menu-7 {\n        width: 100%;\n        height: 360px\n    }\n\n    .tabs-content-5 {\n        width: 100%\n    }\n\n    .div-block-868 {\n        height: 580px\n    }\n\n    .text-block-391 {\n        text-align: center;\n        font-size: 64px\n    }\n\n    .div-block-872 {\n        width: 60%\n    }\n\n    .div-block-880 {\n        flex-flow: row\n    }\n\n    .div-block-881.new {\n        width: 80%\n    }\n\n    .div-block-883 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-887 {\n        grid-column-gap: 68px;\n        grid-row-gap: 68px;\n        flex-flow: column;\n        grid-template-columns: 1fr;\n        justify-content: center;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .text-block-407,\n    .div-block-888 {\n        width: 100%\n    }\n\n    .div-block-888.fold-2 {\n        margin-bottom: 50px;\n        padding-left: 0\n    }\n\n    .div-block-889 {\n        width: 100%\n    }\n\n    .div-block-892.fold-2 {\n        margin-bottom: 0\n    }\n\n    .div-block-893 {\n        justify-content: center;\n        align-items: flex-start;\n        width: 100%\n    }\n\n    .div-block-894 {\n        flex-flow: column;\n        grid-template-columns: .75fr;\n        align-content: stretch;\n        justify-content: start;\n        align-items: start;\n        justify-items: center;\n        width: 100%;\n        padding-left: 0;\n        padding-right: 0;\n        display: flex\n    }\n\n    .div-block-895 {\n        display: none\n    }\n\n    .button-53 {\n        padding: 12px 71px;\n        font-size: 20px\n    }\n\n    .div-block-896 {\n        width: 100%;\n        padding: 99px 72px 67px\n    }\n\n    .div-block-897 {\n        margin-top: 9px\n    }\n\n    .div-block-901 {\n        display: none\n    }\n\n    .div-block-902 {\n        grid-column-gap: 19px;\n        grid-row-gap: 19px;\n        width: 100%;\n        padding-right: 0\n    }\n\n    .text-block-415 {\n        text-align: center;\n        line-height: 1.4\n    }\n\n    .text-block-417 {\n        text-align: center\n    }\n\n    .div-block-905 {\n        justify-content: flex-start;\n        align-items: flex-start\n    }\n\n    .container-1293 {\n        max-width: 728px\n    }\n\n    .nav-menu-wrapper {\n        background-color: transparent;\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .nav-menu-two {\n        background-color: var(--black-2);\n        border: 1px solid rgba(204, 204, 204, .13);\n        border-radius: 19px;\n        flex-wrap: wrap;\n        justify-content: space-around;\n        align-items: center;\n        margin-top: 24px;\n        padding: 20px;\n        display: flex;\n        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)\n    }\n\n    .nav-link-7 {\n        padding-left: 5px;\n        padding-right: 5px\n    }\n\n    .nav-dropdown-list-2.shadow-three.w--open {\n        position: absolute\n    }\n\n    .menu-button-12 {\n        flex: 0 auto;\n        padding: 0\n    }\n\n    .menu-button-12:active {\n        padding: 0\n    }\n\n    .menu-button-12.w--open {\n        color: #fff;\n        background-color: rgba(166, 177, 191, 0);\n        padding: 0\n    }\n\n    .image-275 {\n        width: 35px;\n        margin-right: 20px\n    }\n\n    .image-276 {\n        width: 100%;\n        margin-bottom: 0;\n        padding-bottom: 0\n    }\n\n    .div-block-906 {\n        flex-flow: row;\n        justify-content: flex-end;\n        align-items: center;\n        width: 100%;\n        display: none\n    }\n\n    .image-277 {\n        padding-left: 20px\n    }\n\n    .text-span-376 {\n        font-size: 52px\n    }\n\n    .div-block-907 {\n        grid-template-columns: 1fr;\n        grid-auto-flow: column\n    }\n\n    .text-block-419 {\n        margin-top: 35px;\n        margin-bottom: 67px\n    }\n\n    .div-block-908 {\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr 1fr;\n        align-items: center;\n        justify-items: center;\n        margin-left: 0;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-909 {\n        justify-content: center;\n        align-items: center\n    }\n\n    .text-block-423 {\n        line-height: 1.3\n    }\n\n    .text-block-424 {\n        margin-top: 1px\n    }\n\n    .text-block-425 {\n        font-size: 25px\n    }\n\n    .text-block-426 {\n        font-size: 16px\n    }\n\n    .text-block-427 {\n        font-size: 25px\n    }\n\n    .text-block-428,\n    .text-block-429,\n    .text-block-430 {\n        font-size: 14px;\n        line-height: 1.2\n    }\n}\n\n@media screen and (max-width:767px) {\n    h1 {\n        font-size: 50px\n    }\n\n    h2 {\n        font-size: 40px;\n        line-height: 50px\n    }\n\n    .home-hero-section {\n        margin-top: 60px\n    }\n\n    .wrapper-1300px {\n        padding-top: 8px\n    }\n\n    .wrapper-1300px.for-integra {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .navigation-right {\n        display: none\n    }\n\n    .navigation-right.show {\n        display: block\n    }\n\n    .navigation-left {\n        justify-content: space-between;\n        width: 100%\n    }\n\n    .home-hero-heading {\n        font-size: 40px;\n        line-height: 42px\n    }\n\n    .button-wrapper.home-hero-btn-wrapper {\n        justify-content: center;\n        width: 100%\n    }\n\n    .primary-button {\n        font-size: 16px\n    }\n\n    .primary-button.white-alter-button {\n        text-align: center;\n        width: 100%\n    }\n\n    .primary-button.popup-form-button {\n        width: 100%\n    }\n\n    .hollow-button {\n        font-size: 16px\n    }\n\n    .home-hero-stat-grid {\n        flex-wrap: wrap;\n        display: flex\n    }\n\n    .home-hero-stat-block {\n        padding-left: 10px\n    }\n\n    .home-hero-stat-number {\n        font-size: 38px\n    }\n\n    .hero-image-wrapper {\n        width: 90%;\n        margin-top: 10%\n    }\n\n    .cards-section.vertical-padding-large {\n        margin-left: 31px;\n        margin-right: 31px\n    }\n\n    .logo-container {\n        width: 20%;\n        margin-bottom: 40px;\n        margin-left: 20px;\n        margin-right: 20px\n    }\n\n    .home-value-content-wrapper {\n        margin-top: 0\n    }\n\n    .home-value-heading {\n        margin-bottom: 25px\n    }\n\n    .split-section-content-container.first {\n        margin-top: 80px\n    }\n\n    .split-image-wrapper._50 {\n        width: 100%\n    }\n\n    .split-image-2 {\n        max-width: 300px;\n        max-height: 160px;\n        top: 70%;\n        right: 2%\n    }\n\n    .work-slide-container {\n        padding: 20px\n    }\n\n    .work-slide-number-container {\n        width: 50px;\n        height: 50px\n    }\n\n    .work-slider-text-wrapper {\n        font-size: 22px\n    }\n\n    .review-heading {\n        font-size: 40px\n    }\n\n    .review-slider {\n        height: auto;\n        display: flex\n    }\n\n    .review-slider.width-100 {\n        width: 100%\n    }\n\n    .mask-not-visible {\n        height: auto\n    }\n\n    .review-slide {\n        height: 100%;\n        padding-top: 60px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .review-slider-text {\n        font-size: 18px\n    }\n\n    .pitch-heading {\n        margin-bottom: 60px;\n        font-size: 36px;\n        line-height: 109%\n    }\n\n    .pitch-illustration-head {\n        width: 100px\n    }\n\n    .pitch-brach-wrapper {\n        width: 15%\n    }\n\n    .pitch-brach-wrapper.persona {\n        width: 15%;\n        max-width: 63.0938px\n    }\n\n    .branch-card-wrapper {\n        flex: 0 auto\n    }\n\n    .branch-card-wrapper.three-columns {\n        grid-template-columns: 1fr\n    }\n\n    .pitch-main-card.bottom-block.mobile {\n        display: none\n    }\n\n    .pitch-main-card.bottom-block.bottom {\n        display: block\n    }\n\n    .home-support-section {\n        background-position: 75%\n    }\n\n    .support-content-wrapper {\n        width: 90%\n    }\n\n    .faq-wrapper {\n        grid-template-columns: 1fr\n    }\n\n    .white-alter-span.white {\n        font-size: 45px\n    }\n\n    .footer-logo-container {\n        margin-right: 0\n    }\n\n    .footer-logo-container.w--current {\n        flex: none;\n        margin-right: 0\n    }\n\n    .footer-down-container {\n        flex-flow: column-reverse wrap;\n        justify-content: center;\n        max-width: 480px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .copyright-text {\n        text-align: center;\n        margin-top: 20px;\n        margin-bottom: 0\n    }\n\n    .footer-down-link.first {\n        margin-left: 0\n    }\n\n    .pricing-heading {\n        letter-spacing: 0\n    }\n\n    .auto-slider-arrow-left {\n        bottom: 6%;\n        right: 25%\n    }\n\n    .auto-slider-arrow-right {\n        bottom: 6%\n    }\n\n    .contact-hero-wrapper {\n        margin-top: 160px\n    }\n\n    .blog-hero-section {\n        padding-bottom: 280px\n    }\n\n    .blog-hero-heading {\n        font-size: 40px;\n        line-height: 40px\n    }\n\n    .blog-hero-para {\n        font-size: 18px\n    }\n\n    .blog-form {\n        flex-direction: column\n    }\n\n    .blog-form-field {\n        text-align: center;\n        height: 60px;\n        margin-bottom: 20px;\n        margin-right: 0\n    }\n\n    .blog-form-field::placeholder {\n        font-size: 18px\n    }\n\n    .subscribe-button {\n        height: 60px;\n        font-size: 18px\n    }\n\n    .wrapper-1080px.blog-wrapper {\n        flex-direction: column\n    }\n\n    .blog-feature-block {\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr\n    }\n\n    .blog-filter-tab {\n        align-items: flex-end\n    }\n\n    .blog-tab {\n        margin-right: 0\n    }\n\n    .blog-tab.w--current {\n        font-size: 18px\n    }\n\n    .blog-collection-list {\n        grid-template-columns: 1fr\n    }\n\n    .blog-main-image-wrapper {\n        height: auto\n    }\n\n    .blog-rich-text a {\n        transition: color .2s\n    }\n\n    .blog-rich-text a:hover {\n        color: var(--slate-blue)\n    }\n\n    .pricing-hero-table.new {\n        grid-template-columns: 1fr\n    }\n\n    .black-button {\n        font-size: 16px\n    }\n\n    .wrapper-1280px.discover-new-product-flex {\n        padding-top: 0\n    }\n\n    .wrapper-1280px.discover-purchase-flex,\n    .wrapper-1280px.discover-tools-flex,\n    .wrapper-1280px.procurement-black-flex,\n    .wrapper-1280px.contract-renewals-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .popup-close {\n        right: 0%\n    }\n\n    .work-slide-2 {\n        max-width: none;\n        max-height: 250px;\n        margin-right: 40px\n    }\n\n    .bold-head {\n        margin-bottom: 10px\n    }\n\n    .blog-featured-heading {\n        font-size: 26px\n    }\n\n    .blog-featured-para {\n        font-size: 18px\n    }\n\n    .popup-container {\n        width: 90%;\n        padding: 30px\n    }\n\n    .popup-heading {\n        font-size: 32px;\n        line-height: 38px\n    }\n\n    .popup-text-field::placeholder {\n        font-size: 18px\n    }\n\n    .popup-split-block {\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr;\n        margin-bottom: 20px\n    }\n\n    .about-hero-paragraph {\n        font-size: 15px\n    }\n\n    .team-grid {\n        grid-template-columns: 1fr;\n        max-width: 388px;\n        margin-left: auto;\n        margin-right: auto\n    }\n\n    .career-paragraph {\n        font-size: 22px\n    }\n\n    .about-slide {\n        max-width: none;\n        max-height: none;\n        margin-right: 40px\n    }\n\n    .background-image {\n        opacity: .4\n    }\n\n    .persona-hero-card {\n        padding: 30px\n    }\n\n    .paragraph-18px-copy.ctas-paragraph.center-this {\n        color: var(--white);\n        max-width: 600px;\n        margin-top: 12px;\n        margin-bottom: 32px;\n        line-height: 1.2;\n        text-align: center;\n    }\n\n    .persona-card-text {\n        margin-top: 0;\n        font-size: 40px\n    }\n\n    .persona-head-para {\n        font-size: 18px\n    }\n\n    .persona-split-text {\n        font-size: 40px\n    }\n\n    .persona-split-image-container.procurement-section-3-image {\n        width: 100%\n    }\n\n    .finance-heading {\n        font-size: 40px\n    }\n\n    .persona-block-image {\n        margin-bottom: 20px\n    }\n\n    .together-blue-heading {\n        font-size: 40px\n    }\n\n    .together-blue-paragraph-18px {\n        font-size: 16px\n    }\n\n    .discover-product-hero-section {\n        padding-bottom: 100px\n    }\n\n    .discover-product-hero-heading {\n        margin-bottom: 16px\n    }\n\n    .discover-hero-paragraph {\n        margin-bottom: 30px;\n        font-size: 18px\n    }\n\n    .discover-hero-pointer,\n    .discover-hero-pink-text {\n        font-size: 16px\n    }\n\n    .discover-hero-pink-text-wrapper {\n        margin-bottom: 18px\n    }\n\n    .new-product-heading-44px {\n        font-size: 40px\n    }\n\n    .new-product-paragraph-18px,\n    .procurement-paragraph-18px {\n        font-size: 16px\n    }\n\n    .procurement-grid {\n        grid-template-columns: 1fr;\n        justify-items: center\n    }\n\n    .procurement-heading-24px {\n        font-size: 22px\n    }\n\n    .procurement-item-text-18px {\n        font-size: 16px\n    }\n\n    .case-study-hero-heading {\n        font-size: 45px\n    }\n\n    .track-appoval-image-container,\n    .multi-channel-image-container {\n        width: 90%\n    }\n\n    .fast-track-approval-h1-heading {\n        margin-bottom: 15px;\n        font-size: 45px\n    }\n\n    .dropdown-grid {\n        grid-template-columns: 1fr\n    }\n\n    .footer-grid {\n        grid-row-gap: 60px;\n        flex-direction: column;\n        display: flex\n    }\n\n    .split-section-form-wrapper {\n        padding: 30px\n    }\n\n    .review-slide-2 {\n        height: 100%;\n        padding-top: 60px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .assisted-purchasing-hero-wrapper.insights {\n        margin-top: 47px\n    }\n\n    .assisted-hero-item-wrapper.left,\n    .assisted-hero-item-wrapper.right {\n        width: 300px\n    }\n\n    .actionable-insight-text-wrap {\n        max-width: 500px\n    }\n\n    .investor-logo.investor-logo-rt-demo-custo-styles {\n        width: 26%\n    }\n\n    .insights-hero-image-3 {\n        margin-bottom: 90px\n    }\n\n    .insights-hero-image-4 {\n        margin-bottom: 70px\n    }\n\n    .contract-hero-item-wrap.left,\n    .contract-hero-item-wrap.right {\n        bottom: 1%\n    }\n\n    .contract-hero-logo-item._1 {\n        top: 0\n    }\n\n    .contract-hero-logo-item._5 {\n        right: 30%\n    }\n\n    .hello-bar {\n        flex-direction: column;\n        align-items: center\n    }\n\n    .div-block-18 {\n        padding-top: 0%\n    }\n\n    .div-block-20 {\n        margin-top: 24px;\n        padding-top: 10%;\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .div-block-21.registration-form-block {\n        padding-left: 16px;\n        padding-right: 15px\n    }\n\n    .container-4 {\n        max-width: 100%\n    }\n\n    .div-block-23.alt-badge {\n        margin-top: 0;\n        margin-left: 16px\n    }\n\n    .text-block-11 {\n        color: var(--black)\n    }\n\n    .div-block-24,\n    .div-block-25 {\n        margin-top: 16px\n    }\n\n    .div-block-27 {\n        top: 0;\n        right: 0\n    }\n\n    .div-block-28 {\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .div-block-29 {\n        background-color: var(--white);\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        min-height: auto\n    }\n\n    .bestsuited-webinarblock {\n        min-height: auto;\n        padding-top: 56px;\n        padding-bottom: 56px\n    }\n\n    .div-block-33 {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px;\n        flex-wrap: wrap;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        grid-auto-flow: row;\n        display: grid\n    }\n\n    .grid-3 {\n        padding-bottom: 16px;\n        padding-left: 16px\n    }\n\n    .grid-3.m-l-24 {\n        width: 100%;\n        margin-left: 0\n    }\n\n    .button.bigger {\n        height: 54px\n    }\n\n    .div-block-35 {\n        min-height: auto;\n        padding-top: 1px;\n        padding-bottom: 4px\n    }\n\n    .div-block-36 {\n        padding-top: 56px;\n        padding-bottom: 56px\n    }\n\n    .text-block-18 {\n        font-size: 24px;\n        line-height: 28px\n    }\n\n    .div-block-38 {\n        background-color: transparent;\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        padding: 24px 30px\n    }\n\n    .div-block-39 {\n        justify-content: center;\n        margin-top: 0;\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .div-block-40 {\n        height: auto\n    }\n\n    .container-5 {\n        max-width: 90%;\n        padding-top: 56px;\n        padding-bottom: 56px\n    }\n\n    .div-block-41 {\n        justify-content: flex-start;\n        margin-top: 24px\n    }\n\n    .div-block-42 {\n        justify-content: center;\n        display: flex\n    }\n\n    .image-7 {\n        position: static\n    }\n\n    .text-block-22 {\n        color: var(--black)\n    }\n\n    .columns-2 {\n        flex-direction: column-reverse;\n        display: flex\n    }\n\n    .div-block-49 {\n        display: flex\n    }\n\n    .column-6 {\n        padding-top: 0%\n    }\n\n    .image-11,\n    .image-12 {\n        display: none\n    }\n\n    .div-block-61.white.p-t-40 {\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .columns-4 {\n        display: block\n    }\n\n    .column-8 {\n        justify-content: flex-start;\n        padding-left: 0\n    }\n\n    .div-block-63 {\n        width: 100%;\n        padding-top: 24px\n    }\n\n    .div-block-65 {\n        display: none\n    }\n\n    .section {\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .auto-slider-arrow-left-2 {\n        bottom: 6%;\n        right: 25%\n    }\n\n    .review-slider-text-2 {\n        font-size: 18px\n    }\n\n    .h1-heading {\n        font-size: 72px\n    }\n\n    .header-grid {\n        grid-template-columns: 1fr\n    }\n\n    .company-logo-2 {\n        margin-left: 15px;\n        margin-right: 15px\n    }\n\n    .header-section-3 {\n        padding-bottom: 100px\n    }\n\n    .process-heading {\n        font-size: 50px\n    }\n\n    .process-grid {\n        grid-template-columns: 1fr\n    }\n\n    .features-container {\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .feature-section-2 {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .features-grid {\n        grid-row-gap: 24px;\n        grid-template-columns: 1fr\n    }\n\n    .features-heading-wrap {\n        margin-bottom: 60px\n    }\n\n    .section-regular {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .cta-block {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .header-feature-3 {\n        margin-top: 32px\n    }\n\n    .image-cover.not-in-mobile {\n        display: none\n    }\n\n    .image-cover.mobile-only {\n        object-fit: contain;\n        display: block\n    }\n\n    .header-placeholder-top {\n        height: 490px\n    }\n\n    .section-large {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .cta-image-2 {\n        display: none\n    }\n\n    .section-cta {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .cta-heading {\n        font-size: 50px;\n        line-height: 60px\n    }\n\n    .button-cta-primary {\n        width: 100%\n    }\n\n    .content-grid {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px\n    }\n\n    .h3-heading-2 {\n        font-size: 40px\n    }\n\n    .grid-two-column-2 {\n        grid-template-columns: 1fr\n    }\n\n    .section-large-2 {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .grid-three-column {\n        grid-template-columns: 1fr\n    }\n\n    .testimoial-container {\n        margin-top: 100px;\n        padding-bottom: 100px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .ck-modal__content-w {\n        padding-bottom: 1.5rem;\n        padding-left: 1.5rem;\n        padding-right: 1.5rem\n    }\n\n    .ck-modal__exit-btn {\n        margin-right: 1.25rem\n    }\n\n    .ck-modal__exit-btn.is--sticky {\n        top: -1rem\n    }\n\n    .ck-modal__btns-w {\n        padding: 1.5rem\n    }\n\n    .ck-modal__btns-w.in-pref-manger {\n        margin: 1.5rem -1.5rem -2rem;\n        padding-top: 1.25rem;\n        position: -webkit-sticky;\n        position: sticky;\n        bottom: 0\n    }\n\n    .ck-preference__scroll-w {\n        padding-top: 2rem\n    }\n\n    .ck-form {\n        padding-top: .75rem\n    }\n\n    .ck-preference__icon {\n        margin-right: 0\n    }\n\n    .ck-preference-txt {\n        display: none\n    }\n\n    .modal-section {\n        justify-content: flex-start;\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .modal-container {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 40px 20px\n    }\n\n    .modal-content {\n        width: 100%;\n        margin-bottom: 45px\n    }\n\n    .modal-image-large {\n        margin-bottom: 20px;\n        margin-right: 0\n    }\n\n    .modal-image-large.blue-bg {\n        object-fit: cover;\n        height: 300px\n    }\n\n    .section-small {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .grid-team-slider {\n        grid-template-columns: 1fr\n    }\n\n    .h3-heading-3 {\n        font-size: 36px;\n        line-height: 52px\n    }\n\n    .header-large-white {\n        font-size: 48px\n    }\n\n    .header-section-small {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .process-heading-2 {\n        font-size: 50px\n    }\n\n    .process-grid-2 {\n        grid-template-columns: 1fr\n    }\n\n    .m-t-40.p-v-40.bg-change {\n        padding-top: 26px\n    }\n\n    .header-featured-wrap {\n        width: 70%;\n        top: 100px\n    }\n\n    .process-step {\n        margin-right: 20px\n    }\n\n    .process-title-wrap-3 {\n        margin-bottom: 60px\n    }\n\n    .intro {\n        padding-left: 55px;\n        padding-right: 55px\n    }\n\n    .section-regular-2 {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .pricing-icon {\n        color: #1a1a1a\n    }\n\n    .heading-content-2 {\n        font-size: 48px\n    }\n\n    .price-custom-icon {\n        color: #1a1a1a\n    }\n\n    .banner-2 {\n        background-image: none;\n        background-position: 0 0;\n        background-repeat: repeat;\n        background-size: auto\n    }\n\n    .banner-wrap {\n        flex-direction: column;\n        align-items: flex-start;\n        width: 100%\n    }\n\n    .link-block-9 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        flex-wrap: nowrap;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr auto;\n        grid-auto-columns: 1fr;\n        justify-items: stretch;\n        padding-left: 12px;\n        padding-right: 12px;\n        display: grid\n    }\n\n    .side-pattern {\n        left: -35%\n    }\n\n    .faq-question-wrap {\n        padding-left: 32px;\n        padding-right: 32px\n    }\n\n    .f-h1-heading {\n        margin-top: 0;\n        font-size: 48px\n    }\n\n    .f-section-large-3 {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .feature-card-04 {\n        border-bottom: 1px dashed #e5e5e5\n    }\n\n    .feature-card-5 {\n        border-bottom: 1px dashed #e5e5e5;\n        border-right-style: none\n    }\n\n    .grid-features {\n        grid-template-columns: 1fr\n    }\n\n    .feature-card-01 {\n        border-right-style: none\n    }\n\n    .section-feature {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .faq-grid-3 {\n        grid-row-gap: 40px;\n        grid-template-columns: 1fr\n    }\n\n    .content-grid-2 {\n        grid-template-columns: 1fr\n    }\n\n    .feature-block-header {\n        padding-left: 40px\n    }\n\n    .a-testimonial-slider-grid {\n        grid-template-columns: 1fr\n    }\n\n    .a-section-regular-2 {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .content-section-5 {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .content-heading {\n        font-size: 40px;\n        line-height: 50px\n    }\n\n    .content-grid-3 {\n        grid-row-gap: 60px\n    }\n\n    .section-large-3 {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .header-section-6 {\n        padding-bottom: 100px\n    }\n\n    .section-large-4,\n    .section-regular-4 {\n        padding-top: 72px;\n        padding-bottom: 72px\n    }\n\n    .image-67 {\n        height: 37px\n    }\n\n    .grid {\n        grid-template-columns: 1fr\n    }\n\n    .step-grid {\n        grid-template-rows: auto;\n        grid-template-columns: 1fr\n    }\n\n    .slider-section {\n        padding-top: 100px\n    }\n\n    .lp-para {\n        font-size: 18px\n    }\n\n    .lp-logo-section {\n        padding-top: 60px;\n        padding-bottom: 60px\n    }\n\n    .logo-video {\n        grid-row-gap: 32px;\n        flex-direction: column;\n        margin-top: 60px;\n        display: flex\n    }\n\n    .lp-win-section {\n        padding-top: 60px;\n        padding-bottom: 60px\n    }\n\n    .win-content {\n        grid-row-gap: 32px;\n        flex-direction: column;\n        margin-top: 60px\n    }\n\n    .win-item-wrapper {\n        grid-row-gap: 24px\n    }\n\n    .lp-slider-flex {\n        grid-row-gap: 24px;\n        flex-direction: column;\n        display: flex\n    }\n\n    .vender-alternate-head {\n        grid-column-gap: 12px;\n        margin-bottom: 12px\n    }\n\n    .lp-image-wrapper,\n    .lp-image-wrapper._50 {\n        width: 100%\n    }\n\n    .lp-highlighter {\n        border-width: 2px;\n        margin-top: 20px\n    }\n\n    .b-navigation-large-grid,\n    .navigation-grid-2,\n    .b-navigation-small-grid {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-320 {\n        justify-content: center;\n        align-items: center\n    }\n\n    .image-76 {\n        flex: 0 auto;\n        height: 100px\n    }\n\n    .close-wrapper {\n        width: 24px;\n        height: 24px;\n        top: 1rem;\n        right: 1rem\n    }\n\n    .blog-book-demo-box {\n        align-self: center\n    }\n\n    .ssms-button-wrapper {\n        grid-row-gap: 24px;\n        flex-direction: column\n    }\n\n    .image-87 {\n        width: 100%\n    }\n\n    .ssms-2-grid {\n        grid-template-columns: 1fr\n    }\n\n    .ssms-grid-item {\n        max-width: 100%;\n        font-size: 18px\n    }\n\n    .ssms-h3 {\n        font-size: 26px\n    }\n\n    .ssms-sec-3-grid {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .ssms-sec-3-grid-item {\n        padding: 20px;\n        font-size: 18px\n    }\n\n    .ssms-step-text {\n        padding: 8px 20px;\n        font-size: 26px\n    }\n\n    .ssms-3-h3 {\n        font-size: 26px\n    }\n\n    .b-navigation-large-grid-2,\n    .navigation-grid-3 {\n        grid-template-columns: 1fr\n    }\n\n    .auto-slider-arrow-left-3 {\n        bottom: 6%;\n        right: 25%\n    }\n\n    .hover-block__text {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        max-width: none;\n        min-height: 44%;\n        padding: 20px;\n        display: flex;\n        position: absolute;\n        top: auto;\n        bottom: 0%;\n        left: 0;\n        right: 0;\n        transform: none\n    }\n\n    .review-slide-3 {\n        height: 100%;\n        padding-top: 60px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .mask-not-visible-2 {\n        height: auto\n    }\n\n    .hollow-button-3 {\n        font-size: 16px\n    }\n\n    .review-slider-text-4 {\n        font-size: 18px\n    }\n\n    .hollow-button-4 {\n        font-size: 16px\n    }\n\n    .persona-head-para-2 {\n        font-size: 18px\n    }\n\n    .max-save-compoennt {\n        padding-top: 64px;\n        padding-bottom: 64px\n    }\n\n    .max-sav-heading {\n        font-size: 32px;\n        line-height: 44px\n    }\n\n    .max-save-para {\n        font-size: 16px;\n        line-height: 24px\n    }\n\n    .div-block-456 {\n        grid-row-gap: 16px;\n        margin-top: 48px\n    }\n\n    .text-block-215 {\n        font-size: 17px\n    }\n\n    .div-block-457 {\n        grid-column-gap: 30px;\n        grid-row-gap: 18px;\n        margin-top: 16px;\n        margin-bottom: 40px;\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .text-block-218 {\n        font-size: 16px\n    }\n\n    .text-block-219 {\n        font-size: 36px\n    }\n\n    .hide-in-mobile {\n        display: none\n    }\n\n    .div-block-502 {\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .section-48 {\n        padding-top: 67px;\n        padding-left: 17px;\n        padding-right: 17px\n    }\n\n    .div-block-590 {\n        grid-column-gap: 6px\n    }\n\n    .div-block-598 {\n        padding-left: 21px;\n        padding-right: 21px\n    }\n\n    .section-52 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .section-55 {\n        padding-bottom: 72px\n    }\n\n    .div-block-618 {\n        grid-template-columns: 1fr;\n        padding-left: 18px;\n        padding-right: 18px\n    }\n\n    .heading-229 {\n        font-size: 32px\n    }\n\n    .container-1286 {\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .banner-cta-blog {\n        align-self: center\n    }\n\n    .link-button-copy2 {\n        left: 8px\n    }\n\n    .case-study-hero-heading-2 {\n        font-size: 45px\n    }\n\n    .reference-hero-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .reference-center-wrapper {\n        width: 90%\n    }\n\n    .colors-grid {\n        grid-template-columns: 1fr 1fr 1fr\n    }\n\n    .reference-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .buttons-grid {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .heading-64px {\n        font-size: 48px\n    }\n\n    .heading-64px.hero-home-heading {\n        font-size: 46px\n    }\n\n    .heading-64px.text-align-center {\n        font-size: 45px\n    }\n\n    .heading-90px {\n        font-size: 60px;\n        line-height: 120%\n    }\n\n    .heading-56px {\n        font-size: 42px\n    }\n\n    .heading-56px.integrations-heading._40px-bottom-margin {\n        margin-bottom: 30px\n    }\n\n    .heading-48px {\n        font-size: 38px\n    }\n\n    .heading-40px {\n        font-size: 32px\n    }\n\n    .navigation-bar {\n        top: 0\n    }\n\n    .navbar-container {\n        padding-top: 12px;\n        padding-bottom: 12px\n    }\n\n    .navigation-link {\n        /*font-size: 16px*/\n    }\n\n    .navbar-logo {\n        padding-left: 0\n    }\n\n    .logo-image.footer-logo {\n        width: 160px\n    }\n\n    .logo-bar.second.footer-bar,\n    .logo-bar.third.footer-bar,\n    .logo-bar.first.footer-bar {\n        width: 14px\n    }\n\n    .navigation-button-contain.out-menu {\n        margin-right: 12px;\n        display: none\n    }\n\n    .hero-home-wrapper {\n        padding-top: 120px;\n        padding-bottom: 100px;\n        margin-top: -120px;\n        margin-bottom: -140px;\n    }\n\n    .hero-home-wrapper.new {\n        padding-top: 140px\n    }\n\n    .transparent-arrow-button {\n        padding-left: 24px;\n        padding-right: 24px;\n    }\n\n    .hero-home-text-wrapper {\n        max-width: 460px\n    }\n\n    .hero-home-text-wrapper.new {\n        width: 100%\n    }\n\n    .paragraph-18px {\n        font-size: 16px\n    }\n\n    .paragraph-18px.hero-home-paragraph.new {\n        font-size: 22px\n    }\n\n    .paragraph-18px.integrations-paragraph {\n        margin-bottom: 30px;\n        text-align: center;\n\n    }\n\n    .paragraph-18px.saas-hero-paragraph,\n    .paragraph-18px.cloud-hero-paragraph {\n        margin-bottom: 16px\n    }\n\n    .pink-arrow-button {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .stats-section {\n        margin-top: 0\n    }\n\n    .stats-wrapper {\n        margin-top: 11px\n    }\n\n    .stats-grid {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        grid-template-columns: 1fr;\n        max-width: 360px\n    }\n\n    .heading-24px {\n        font-size: 20px\n    }\n\n    .heading-24px.review-text {\n        font-size: 18px\n    }\n\n    .logo-image-contain {\n        height: 30px\n    }\n\n    .type-cards-grid {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .type-card-block.first,\n    .type-card-block.second {\n        padding-top: 30px;\n        padding-bottom: 30px\n    }\n\n    .type-card-top-wrapper {\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .type-card-icon-contain {\n        width: 50px;\n        height: 50px\n    }\n\n    .heading-28px {\n        font-size: 22px\n    }\n\n    .div-block-704 {\n        grid-template-columns: 2.5fr\n    }\n\n    .div-block-720 {\n        grid-template-columns: 1fr;\n        padding-left: 11px;\n        padding-right: 11px\n    }\n\n    .collection-list-7 {\n        grid-template-columns: 1fr\n    }\n\n    .type-cards-train-container.vertical {\n        margin-top: 20px;\n        margin-bottom: 40px;\n        padding-left: 30px;\n        padding-right: 30px\n    }\n\n    .integrations-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .integrations-wrapper.saas {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        padding-bottom: 80px\n    }\n\n    .calculator-container {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px\n    }\n\n    .stack-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .stack-tabs-menu {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .stack-tab-link {\n        text-align: center;\n        min-width: 100px;\n        display: flex\n    }\n\n    .stack-tab-link-wrapper {\n        margin-top: auto\n    }\n\n    .stack-tab-link-header {\n        padding-top: 6px;\n        padding-bottom: 6px\n    }\n\n    .stack-tab-link-icon {\n        display: none\n    }\n\n    .stack-tab-link-progress-bar-contain {\n        height: 6px\n    }\n\n    .paragraph-20px {\n        font-size: 18px\n    }\n\n    .paragraph-20px.stack-tab-link-text {\n        font-size: 16px\n    }\n\n    .paragraph-20px.blog-tag-radio-button-label {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .stack-blocks-grid {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px;\n        grid-template-columns: 1fr\n    }\n\n    .stack-block.a-first,\n    .stack-block.a-second,\n    .stack-block.d-first {\n        padding: 28px\n    }\n\n    .stack-block-image-contain.a-first {\n        margin-top: 40px\n    }\n\n    .stack-block-image-contain.b-first,\n    .stack-block-image-contain.c-first,\n    .stack-block-image-contain.c-second,\n    .stack-block-image-contain.b-second,\n    .stack-block-image-contain.d-second,\n    .stack-block-image-contain.d-first {\n        margin-top: 40px;\n        padding-bottom: 0\n    }\n\n    .blogs-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .blogs-container {\n        grid-template-columns: 1fr;\n        max-width: 500px\n    }\n\n    .blogs-collection-list._3-column-grid {\n        grid-template-columns: 1fr\n    }\n\n    .blog-post-image-wrapper.featured,\n    .blog-post-image-wrapper.featured.blog-page,\n    .blog-post-image-wrapper.featured.cms {\n        height: 300px\n    }\n\n    .blog-post-image-wrapper.featured.resources-hero {\n        height: 260px\n    }\n\n    .blog-post-image-wrapper._300px {\n        height: 240px\n    }\n\n    .paragraph-16px.blog-category-text {\n        margin-bottom: 0;\n        padding-left: 12px;\n        padding-right: 12px;\n        font-size: 14px\n    }\n\n    .paragraph-16px.copyright-paragraph {\n        font-size: 14px\n    }\n\n    .heading-32px {\n        font-size: 26px\n    }\n\n    .ctas-container {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        padding-top: 80px\n    }\n\n    .transparent-white-arrow-button {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .footer-wrapper {\n        padding-top: 60px\n    }\n\n    .footer-top-container {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .brand-logos-wrapper {\n        padding: 12px 14px\n    }\n\n    .brand-logo.third {\n        width: 67px\n    }\n\n    .footer-links-column.fifth.new {\n        justify-content: center;\n        align-items: center\n    }\n\n    .footer-link-icon {\n        width: 20px;\n        height: 20px\n    }\n\n    .tribe-tab-link-info-wrapper {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px\n    }\n\n    .tribe-tab-image-contain {\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .spend-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .spend-image.c {\n        margin-top: -80px\n    }\n\n    .spend-block-wrapper {\n        grid-column-gap: 10px;\n        grid-row-gap: 10px\n    }\n\n    .spend-block-wrapper.c,\n    .spend-block-wrapper.a {\n        min-height: 220px\n    }\n\n    .spend-block-wrapper.a.new._1,\n    .spend-block-wrapper.a.new._2,\n    .spend-block-wrapper.a.new._3 {\n        width: 360px;\n        display: none\n    }\n\n    .spend-block-wrapper.b {\n        min-height: 220px\n    }\n\n    .spend-sticky-wrapper {\n        height: 60vh\n    }\n\n    .spend-text-container {\n        padding-top: 20px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .sticky-indicator-text-wrapper {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .spend-image-wrapper.first {\n        padding: 30px 20px\n    }\n\n    .spend-image-wrapper.third {\n        padding-left: 0\n    }\n\n    .spend-block-icon-contain {\n        width: 40px;\n        height: 40px\n    }\n\n    .spend-text-blocks-contain {\n        height: 220px\n    }\n\n    .spend-images-grid {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .paragraph-22px {\n        font-size: 18px\n    }\n\n    .paragraph-22px.sticky-indicator-text {\n        font-size: 16px\n    }\n\n    .spend-sticky-block {\n        top: 80px\n    }\n\n    .heading-252.new {\n        font-size: 19px\n    }\n\n    .reviews-main-wrapper {\n        padding-top: 100px\n    }\n\n    .reviews-slider {\n        max-width: 358px\n    }\n\n    .reviews-slide-wrapper {\n        flex-direction: column-reverse\n    }\n\n    .reviews-slide-image-contain,\n    .reviews-slide-text-gradient-wrapper {\n        width: 100%\n    }\n\n    .review-slide-text-wrapper {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        padding: 20px 40px 20px 20px\n    }\n\n    .reviewer-block {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .reviewer-info-block {\n        grid-column-gap: 3px;\n        grid-row-gap: 3px\n    }\n\n    .review-company-logo {\n        height: 30px\n    }\n\n    .review-company-logo._32px {\n        height: 28px\n    }\n\n    .review-company-logo._29px {\n        height: 24px\n    }\n\n    .review-company-logo._44px {\n        height: 36px\n    }\n\n    .slider-arrow {\n        border-width: 3px;\n        flex-flow: row;\n        justify-content: flex-start;\n        align-items: center;\n        margin-top: 100px;\n        margin-left: 20px;\n        margin-right: 20px;\n        display: flex\n    }\n\n    .slider-arrow.right {\n        right: -10%\n    }\n\n    .slider-arrow.right.events {\n        top: -160px;\n        right: 30%\n    }\n\n    .slider-arrow.left {\n        left: -10%\n    }\n\n    .slider-arrow.left.events {\n        justify-content: center;\n        align-items: flex-start;\n        top: -160px;\n        left: 30%\n    }\n\n    .slider-arrow.testimonials {\n        border-width: 0;\n        border-color: var(--light-pink);\n        -webkit-text-stroke-color: var(--pabloo-green);\n        margin-left: auto;\n        margin-right: auto;\n        box-shadow: 0 2px 20px -1px rgba(0, 0, 0, .2), 0 2px 5px rgba(0, 0, 0, .2)\n    }\n\n    .slider-arrow.testimonials:hover {\n        background-color: var(--pabloo-green)\n    }\n\n    .slider-arrow.testimonials.left {\n        margin: 21px 0 0;\n        padding-top: 0;\n        top: auto;\n        bottom: 0;\n        left: 35%;\n        overflow: visible\n    }\n\n    .slider-arrow.testimonials.right {\n        margin: 20px 0 0;\n        top: auto;\n        bottom: 0;\n        left: auto;\n        right: 35%\n    }\n\n    .review-slide-arrow-icon-embed {\n        flex: 1;\n    }\n\n    .review-slide-arrow-icon-embed.right {\n        justify-content: center;\n        align-self: center;\n        align-items: center;\n        display: flex;\n        margin-right: -3px;\n        margin-bottom: 5px;\n    }\n\n    .review-slide-arrow-icon-embed.left {\n        justify-content: center;\n        align-self: center;\n        align-items: center;\n        display: flex;\n        margin-left: -3px;\n    }\n\n    .logos-white-gradient {\n        width: 40px\n    }\n\n    .reviews-slide {\n        object-fit: fill;\n        margin-right: 40px\n    }\n\n    .home-hero-images-container {\n        max-width: 580px;\n        margin-right: -5%\n    }\n\n    .hero-bubbles-block-wrapper {\n        width: 100%;\n        max-width: 150px;\n        bottom: 6%;\n        left: 14%\n    }\n\n    .hero-bubbles-block-contain {\n        width: auto\n    }\n\n    .hero-bubble-image {\n        width: 100px;\n        max-width: 50px;\n        height: 50px\n    }\n\n    .calc-anchor {\n        top: -70px\n    }\n\n    .navigation-links-grid {\n        grid-template-columns: 1fr\n    }\n\n    .navbar-dropdown-text {\n        font-size: 16px\n    }\n\n    .dropdown-resources-column {\n        flex-direction: column\n    }\n\n    .resource-dropdown-image-contain {\n        width: 30%;\n        height: 140px\n    }\n\n    .resource-dropdown-info-block {\n        width: 70%\n    }\n\n    .spend-anchor.second {\n        top: 35%\n    }\n\n    .spend-anchor.third {\n        top: 55%\n    }\n\n    .footer-logo-link {\n        padding-left: 0\n    }\n\n    .hero-platform-wrapper.integra {\n        flex-flow: wrap\n    }\n\n    .hero-platform-heading-wrapper.display-flex.include-bg {\n        margin-top: 10px\n    }\n\n    .hero-platform-cta-wrapper.integra {\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .blogs-hero-wrapper {\n        padding-top: 120px\n    }\n\n    .blogs-hero-wrapper.cms {\n        padding-top: 140px\n    }\n\n    .subscription-form {\n        flex-direction: column\n    }\n\n    .form-email-text-field,\n    .form-email-text-field.resource-hero {\n        width: 100%;\n        max-width: none\n    }\n\n    .blogs-tab-link {\n        min-width: 80px;\n        font-size: 16px\n    }\n\n    .blog-tabs-info-wrapper {\n        max-width: 500px\n    }\n\n    .ctas-form-wrapper {\n        padding: 30px 24px\n    }\n\n    .form-fields-contain._4px-margin {\n        margin-bottom: 4px\n    }\n\n    .white-form-field {\n        padding-left: 16px;\n        padding-right: 16px;\n        font-size: 18px\n    }\n\n    .ctas-form {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .form-select-field {\n        background-position: 95%;\n        padding-left: 16px;\n        font-size: 18px\n    }\n\n    .div-block-732 {\n        height: 100px;\n        margin-top: -142px\n    }\n\n    .blog-cms-info-wrapper {\n        padding-bottom: 100px\n    }\n\n    .block-rich-text h1 {\n        font-size: 48px\n    }\n\n    .block-rich-text h2 {\n        font-size: 42px\n    }\n\n    .block-rich-text h3 {\n        font-size: 38px\n    }\n\n    .block-rich-text h4 {\n        font-size: 32px\n    }\n\n    .block-rich-text h5 {\n        font-size: 26px\n    }\n\n    .block-rich-text h6 {\n        font-size: 22px\n    }\n\n    .block-rich-text p {\n        margin-bottom: 24px;\n        font-size: 16px\n    }\n\n    .block-rich-text ul,\n    .block-rich-text ol {\n        margin-bottom: 28px\n    }\n\n    .block-rich-text li {\n        margin-bottom: 4px;\n        font-size: 16px\n    }\n\n    .block-rich-text blockquote {\n        background-position: 30px 30px;\n        background-size: 34px;\n        padding: 80px 30px 30px;\n        font-size: 24px\n    }\n\n    .feature-wrap {\n        flex-direction: row;\n        justify-content: center;\n        align-items: center\n    }\n\n    .feature-image-wrapper.right.green-bg {\n        padding-right: 2px\n    }\n\n    .feature-image-wrapper.left.pink-bg {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 0;\n        padding-left: 0;\n        display: flex\n    }\n\n    .feature-content-heading-text {\n        font-size: 22px\n    }\n\n    .feature-content-body-text {\n        font-size: 14px\n    }\n\n    .subscribe-form-main-wrapper {\n        padding: 30px 24px\n    }\n\n    .author-block {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .author-container {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .related-blogs-wrapper {\n        max-width: 500px;\n        padding-bottom: 100px\n    }\n\n    .related-header {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        flex-wrap: wrap\n    }\n\n    .fs-cc-prefs3_submit {\n        margin-left: 0\n    }\n\n    .fs-cc-prefs3_buttons-wrapper {\n        flex-direction: column\n    }\n\n    .fs-cc-banner3_container {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .fs-cc-banner3_buttons-wrapper {\n        margin-top: 1rem\n    }\n\n    .fs-cc-prefs3_buttons-block {\n        margin-bottom: 1rem\n    }\n\n    .transparent-arrow-button-white {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .resources-hero-wrapper {\n        padding-top: 120px\n    }\n\n    .resource-tabs-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .resource-tab-heading-contain {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .resource-tab-icon-embed {\n        width: 28px;\n        height: 28px\n    }\n\n    .resource-collection-list {\n        grid-column-gap: 20px;\n        grid-row-gap: 40px\n    }\n\n    .resource-post-image-wrapper {\n        height: 240px\n    }\n\n    .div-block-733 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .book-demo-form-graphic-1,\n    .image-222 {\n        display: none\n    }\n\n    .blog-tabs-seach-input {\n        padding-left: 6px;\n        font-size: 16px\n    }\n\n    .blog-tabs-search-wrapper {\n        padding-top: 6px;\n        padding-bottom: 6px;\n        padding-left: 40px\n    }\n\n    .blog-search-icon {\n        width: 24px;\n        height: 24px;\n        left: 12px\n    }\n\n    .blog-tag-radio-buttons-contain {\n        justify-content: center;\n        align-items: center\n    }\n\n    .load-more-button,\n    .resources-radio-button-wrap {\n        font-size: 16px\n    }\n\n    .resource-tab-form-separator {\n        max-width: 300px\n    }\n\n    .procurement-team-cards-grid {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .procurement-team-member-card {\n        margin: 8px\n    }\n\n    .paragraph-146 {\n        font-size: 16px\n    }\n\n    .saas-hero-container {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px\n    }\n\n    .saas-hero-text-wrapper {\n        margin-top: 70px\n    }\n\n    .saas-hero-wrapper {\n        padding-top: 120px\n    }\n\n    .saas-hero-absolute-image.second {\n        border-radius: 4px;\n        width: 45%\n    }\n\n    .stats-section-contain {\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .flex-image-block {\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .flex-image-block.cloud-1 {\n        padding-top: 40px\n    }\n\n    .flex-block-abs-image.fourth {\n        border-radius: 8px\n    }\n\n    .solution-callout-wrapper {\n        flex-direction: column\n    }\n\n    .solution-callout-text-wrapper.cloud {\n        grid-column-gap: 26px;\n        grid-row-gap: 26px\n    }\n\n    .solution-callout-text-wrapper.saas {\n        grid-column-gap: 26px;\n        grid-row-gap: 26px;\n        padding-bottom: 40px\n    }\n\n    .solution-callout-images-contain {\n        width: 100%;\n        max-width: 500px\n    }\n\n    .solution-callout-images-contain.saas {\n        margin-left: 10%;\n        position: static\n    }\n\n    .setup-cards-grid {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .cloud-hero-wrapper {\n        padding-top: 120px\n    }\n\n    .cloud-hero-absolute-image {\n        width: 30%;\n        left: -2%\n    }\n\n    .cloud-hero-absolute-image.second {\n        left: -4%\n    }\n\n    .cloud-hero-absolute-image.third {\n        right: -4%\n    }\n\n    .cloud-hero-absolute-image.fourth {\n        border-radius: 12px;\n        right: -4%\n    }\n\n    .heading-258 {\n        display: block\n    }\n\n    .div-block-424 {\n        padding-left: 1px;\n        padding-right: 1px\n    }\n\n    .sticky-progress-bar-contain {\n        height: 3px\n    }\n\n    .badge-image {\n        max-width: 90px\n    }\n\n    .badge-image.new {\n        margin-right: auto\n    }\n\n    .footer-socials-wrapper {\n        flex-wrap: wrap;\n        justify-content: center\n    }\n\n    .social-link-wrapper {\n        width: 48px;\n        height: 48px\n    }\n\n    .privacy-links-contain {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px;\n        flex-wrap: wrap;\n        justify-content: center\n    }\n\n    .navigation-icon-embed._32px {\n        width: 24px;\n        height: 24px\n    }\n\n    .ncf-filter-item-container {\n        grid-template-columns: 1fr\n    }\n\n    .points-checklist-grid {\n        grid-column-gap: 10px;\n        grid-row-gap: 12px\n    }\n\n    .features-wrapper-2 {\n        flex-wrap: wrap;\n        margin-bottom: -40px\n    }\n\n    .competitor-landing-hero-form-2 {\n        margin-top: 50px\n    }\n\n    .div-block-781 {\n        grid-template-columns: 1fr\n    }\n\n    .features-block {\n        width: 50%;\n        margin-bottom: 40px\n    }\n\n    .sysf-heading.sysf-l {\n        font-size: 1.7rem\n    }\n\n    .sysf-section-title,\n    .sysf-section-title.sysf-centered,\n    .sysf-section-title.sysf-centered {\n        width: 100%\n    }\n\n    .sysf-container {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .sysf-faq-item-wrapper,\n    .sysf-faq-item-wrapper.sysf-box {\n        margin-bottom: 16px\n    }\n\n    .brix---display-2 {\n        font-size: 48px;\n        line-height: 56px\n    }\n\n    .brix---stat-card-4-cols---04 {\n        border-top-width: 0;\n        border-left-width: 0;\n        border-right-width: 0\n    }\n\n    .brix---stat-card-4-cols---03 {\n        border-width: 0 0 1px;\n        border-bottom-left-radius: 0\n    }\n\n    .brix---stat-card-4-cols---02 {\n        border-top-width: 0;\n        border-left-width: 0;\n        border-right-width: 0\n    }\n\n    .brix---stat-card-4-cols---01 {\n        border-top-width: 0;\n        border-left-width: 0;\n        border-right-width: 0;\n        border-radius: 0\n    }\n\n    .brix---grid-2-stats-v4 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .brix---heading-h2-size {\n        font-size: 28px;\n        line-height: 40px\n    }\n\n    .brix---grid-stats-v4 {\n        grid-template-columns: 1fr\n    }\n\n    .brix---section {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .brix---link-icon-right {\n        width: 20px;\n        margin-left: 8px\n    }\n\n    .brix---text-200-bold {\n        font-size: 16px;\n        line-height: 18px\n    }\n\n    .brix---mg-bottom-48px {\n        margin-bottom: 0\n    }\n\n    .brix---card-link-content-left-fw {\n        align-items: stretch\n    }\n\n    .brix---grid-3-columns---1-col-mb {\n        grid-template-columns: 1fr\n    }\n\n    .bold-text-26 {\n        font-size: 32px\n    }\n\n    .button-new {\n        text-align: center;\n        width: 100%\n    }\n\n    .button-48 {\n        text-align: center;\n        padding-top: 13px;\n        padding-bottom: 13px;\n        font-size: 13px;\n        line-height: 1.1\n    }\n\n    .container-1287 {\n        padding-left: 31px;\n        padding-right: 31px\n    }\n\n    .image-230 {\n        height: 220px\n    }\n\n    .new-product-heading-4 {\n        font-size: 40px\n    }\n\n    .image-231,\n    .image-232 {\n        height: 270px\n    }\n\n    .hero-platform-wrapper-solutions {\n        padding-top: 120px\n    }\n\n    .heading-64px-copy {\n        font-size: 48px\n    }\n\n    .heading-64px-copy.hero-home-heading {\n        font-size: 46px\n    }\n\n    .heading-64px-copy.text-align-center {\n        padding-left: 33px;\n        padding-right: 33px;\n        font-size: 27px\n    }\n\n    .heading-64px-new {\n        font-size: 48px\n    }\n\n    .heading-64px-new.hero-home-heading {\n        font-size: 46px\n    }\n\n    .heading-64px-new.text-align-center {\n        padding-left: 26px;\n        padding-right: 26px;\n        font-size: 27px\n    }\n\n    .image-238 {\n        flex: 1;\n        align-self: center\n    }\n\n    .feature-image-wrapper-copy.right.green-bg {\n        object-fit: fill;\n        flex-direction: row;\n        flex: 1;\n        justify-content: center;\n        align-self: auto;\n        align-items: center;\n        padding-bottom: 0;\n        padding-right: 0;\n        display: flex\n    }\n\n    .image-239 {\n        object-fit: contain\n    }\n\n    .paragraph-18px-copy.saas-hero-paragraph,\n    .paragraph-18px-copy.cloud-hero-paragraph {\n        margin-bottom: 16px\n    }\n\n    .heading-48px-copy {\n        font-size: 38px\n    }\n\n    .paragraph-18px-copy {\n        font-size: 16px\n    }\n\n    .paragraph-18px-copy.integrations-paragraph {\n        margin-bottom: 30px\n    }\n\n    .paragraph-18px-copy.saas-hero-paragraph,\n    .paragraph-18px-copy.cloud-hero-paragraph {\n        margin-bottom: 16px\n    }\n\n    .heading-28px-copy {\n        font-size: 22px\n    }\n\n    .div-block-793 {\n        margin-bottom: 5px\n    }\n\n    .heading-28px-copy-copy {\n        font-size: 22px\n    }\n\n    .feature-image-wrapper-copy-copy.right.green-bg {\n        object-fit: fill;\n        flex-direction: row;\n        flex: 1;\n        justify-content: center;\n        align-self: auto;\n        align-items: center;\n        padding-bottom: 0;\n        padding-right: 0;\n        display: flex\n    }\n\n    .stats-wrapper-new {\n        margin-top: 11px\n    }\n\n    .stats-wrapper-copy {\n        margin-top: 11px\n    }\n\n    .stats-section-copy {\n        margin-top: 0\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 0;\n        padding-left: 0;\n        display: flex\n    }\n\n    .div-block-732-copy {\n        height: 100px;\n        margin-top: -142px\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.green-bg {\n        object-fit: fill;\n        flex-direction: row;\n        flex: 1;\n        justify-content: center;\n        align-self: auto;\n        align-items: center;\n        padding-bottom: 0;\n        padding-right: 0;\n        display: flex\n    }\n\n    .home-value-heading-copy {\n        margin-bottom: 25px\n    }\n\n    .container-1289 {\n        padding-left: 4px;\n        padding-right: 4px\n    }\n\n    .div-block-20-copy {\n        margin-top: 24px;\n        padding-top: 10%;\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .div-block-21-copy.registration-form-block {\n        padding-left: 16px;\n        padding-right: 15px\n    }\n\n    .image-231-copy {\n        height: 270px\n    }\n\n    .wrapper-1280px-copy.discover-new-product-flex {\n        padding-top: 0\n    }\n\n    .wrapper-1280px-copy.discover-purchase-flex,\n    .wrapper-1280px-copy.discover-tools-flex,\n    .wrapper-1280px-copy.procurement-black-flex,\n    .wrapper-1280px-copy.contract-renewals-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .navbar-brand-three {\n        padding-left: 0\n    }\n\n    .nav-menu-three {\n        border-radius: 20px;\n        flex-direction: column;\n        padding-bottom: 30px\n    }\n\n    .nav-menu-block {\n        flex-direction: column\n    }\n\n    .nav-link-6 {\n        padding-top: 10px;\n        padding-bottom: 10px;\n        display: inline-block\n    }\n\n    .nav-dropdown {\n        flex-direction: column;\n        align-items: center;\n        display: flex\n    }\n\n    .nav-dropdown-toggle {\n        padding-top: 10px;\n        padding-bottom: 10px\n    }\n\n    .nav-dropdown-list.shadow-three {\n        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)\n    }\n\n    .nav-dropdown-list.shadow-three.w--open {\n        position: relative\n    }\n\n    .nav-dropdown-list.shadow-three.mobile-shadow-hide {\n        box-shadow: none\n    }\n\n    .nav-link-accent {\n        margin-right: 5px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        display: inline-block\n    }\n\n    .mobile-margin-top-10 {\n        margin-top: 10px\n    }\n\n    .hello-bar-link {\n        font-size: 12px\n    }\n\n    .new-hello-bar {\n        padding-left: 26px;\n        padding-right: 26px\n    }\n\n    .hello-navigation-bar {\n        margin-top: -5px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n\n    .hello-navbar-container {\n        padding-top: 10px;\n        padding-bottom: 5px\n    }\n\n    .heading-90px-copy {\n        font-size: 60px;\n        line-height: 120%\n    }\n\n    .heading-24px-copy {\n        font-size: 20px\n    }\n\n    .heading-24px-copy.review-text {\n        font-size: 18px\n    }\n\n    .home-hero-heading-copy {\n        font-size: 36px;\n        line-height: 42px\n    }\n\n    .wrapper-1300px-copy,\n    .wrapper-1300px-copy-copy {\n        padding-top: 8px\n    }\n\n    .stats-grid-copy {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        grid-template-columns: 1fr;\n        max-width: 360px\n    }\n\n    .wrapper-1300px-copy,\n    .wrapper-1300px-copy-copy {\n        padding-top: 8px\n    }\n\n    .paragraph-152 {\n        text-align: center;\n        /* margin-left: 10px */\n    }\n\n    .collection-list-8 {\n        grid-template-columns: 1fr\n    }\n\n    .blog-hero-heading-copy {\n        font-size: 40px;\n        line-height: 40px\n    }\n\n    .text-block-330 {\n        margin-bottom: 29px\n    }\n\n    .cms-blog-block-section-copy.templates-block {\n        margin-top: -176px\n    }\n\n    .wrapper-1300px-copy {\n        padding-top: 8px\n    }\n\n    .new-about-1300px-header {\n        margin-top: 0;\n        padding-top: 0\n    }\n\n    .new-about-hero-wrapper {\n        padding-bottom: 10px\n    }\n\n    .xs-text {\n        font-size: 45px\n    }\n\n    .about-heading-x {\n        letter-spacing: 0;\n        width: 100%;\n        padding-left: 62px;\n        padding-right: 62px;\n        font-size: 40px\n    }\n\n    .about-hero-text-wrap-copy {\n        font-size: 16px\n    }\n\n    .stats-section-copy-copy,\n    .stats-about {\n        margin-top: 0\n    }\n\n    .stats-wrapper-copy-copy,\n    .stats-xx {\n        margin-top: 11px\n    }\n\n    .div-block-801.integra {\n        width: 90%\n    }\n\n    .div-block-805,\n    .div-block-805.integra {\n        grid-template-columns: 1fr\n    }\n\n    .tribe-tab-image-contain-copy {\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .ctas-container-copy,\n    .about-x-platform-container {\n        grid-column-gap: 60px;\n        grid-row-gap: 25px;\n        padding-top: 80px\n    }\n\n    .about-x-cards {\n        grid-template-columns: 1fr;\n        width: 70%\n    }\n\n    .about-x-cards.new {\n        width: 90%\n    }\n\n    .tabs-menu-5 {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px;\n        object-fit: fill;\n        grid-template-columns: 1fr\n    }\n\n    .integra-tab,\n    .integra-tab.w--current {\n        width: 90%\n    }\n\n    .pricing-block {\n        margin-right: 20px\n    }\n\n    .text-block-345,\n    .text-block-346 {\n        font-size: 22px\n    }\n\n    .pricing-cards {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-815 {\n        width: 100%;\n        padding: 12px 25px\n    }\n\n    .container-1291 {\n        margin-left: 15px;\n        margin-right: 15px\n    }\n\n    .faq-wrapper-x {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .paragraph-153 {\n        padding-top: 11px\n    }\n\n    .div-block-818 {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        flex-flow: column\n    }\n\n    .div-block-819 {\n        grid-template-columns: 1fr\n    }\n\n    .section-72 {\n        padding-left: 28px;\n        padding-right: 28px\n    }\n\n    .section-72.what-is-in {\n        padding-left: 29px;\n        padding-right: 29px\n    }\n\n    .section-72.events {\n        background-color: var(--soft-pink);\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .section-72.testimonial {\n        padding-top: 62px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .section-72.expectation {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .section-72.webx {\n        background-color: var(--soft-pink)\n    }\n\n    .section-72.optimize {\n        padding-bottom: 136px\n    }\n\n    .section-72.block3 {\n        margin-top: 0;\n        padding-top: 73px\n    }\n\n    .div-block-824 {\n        padding-left: 49px\n    }\n\n    .text-block-357 {\n        font-size: 38px;\n        line-height: 1.1\n    }\n\n    .text-block-358 {\n        text-align: justify\n    }\n\n    .div-block-827 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-828 {\n        width: 100%;\n        padding: 25px\n    }\n\n    .text-block-359 {\n        text-align: center;\n        font-size: 38px;\n        line-height: 1.1\n    }\n\n    .div-block-829 {\n        flex-flow: column;\n        padding-left: 28px;\n        padding-right: 28px\n    }\n\n    .div-block-829.why {\n        padding-top: 62px;\n        padding-left: 28px;\n        padding-right: 28px\n    }\n\n    .div-block-830 {\n        width: 100%\n    }\n\n    .div-block-830.why {\n        width: 70%;\n        padding-left: 31px\n    }\n\n    .text-block-360 {\n        font-size: 32px\n    }\n\n    .div-block-832.why {\n        margin-top: 17px\n    }\n\n    .text-block-361 {\n        font-size: 32px\n    }\n\n    .div-block-833 {\n        flex-flow: column\n    }\n\n    .div-block-835 {\n        border-top-left-radius: 10px;\n        border-top-right-radius: 30px;\n        flex-flow: column;\n        padding: 55px 45px\n    }\n\n    .div-block-836 {\n        width: 100%\n    }\n\n    .div-block-838 {\n        margin-top: 43px\n    }\n\n    .text-block-366,\n    .text-block-367,\n    .text-block-368,\n    .text-block-369 {\n        font-size: 16px\n    }\n\n    .div-block-841 {\n        flex-flow: column;\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .text-block-372 {\n        flex: 0 auto;\n        font-size: 16px\n    }\n\n    .div-block-843 {\n        margin-bottom: 86px\n    }\n\n    .partners.partner-logos {\n        border-left-width: 0\n    }\n\n    .div-block-845 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center\n    }\n\n    .testimonialx {\n        padding-left: 40px\n    }\n\n    .slider-20 {\n        margin-top: 1px\n    }\n\n    .text-block-376 {\n        text-align: center;\n        margin-bottom: 89px\n    }\n\n    .text-block-377 {\n        line-height: 1\n    }\n\n    .text-block-378 {\n        width: 90%\n    }\n\n    .event-expectation {\n        height: 300px\n    }\n\n    .text-block-380 {\n        font-size: 34px\n    }\n\n    .div-block-851 {\n        padding-top: 69px;\n        padding-bottom: 69px\n    }\n\n    .rich-text-block-30 {\n        margin-top: 0\n    }\n\n    .div-block-853 {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .div-block-854 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center;\n        line-height: .5\n    }\n\n    .text-span-309 {\n        line-height: 0\n    }\n\n    .div-block-855 {\n        flex-flow: column\n    }\n\n    .div-block-857 {\n        flex: 0 auto;\n        margin-left: 0\n    }\n\n    .about-pabloo-events {\n        margin-top: 183px\n    }\n\n    .div-block-858 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .text-block-385 {\n        width: 100%\n    }\n\n    .feature-block-item.yellow1 {\n        padding-right: 5%\n    }\n\n    .feature-block-content-logo {\n        align-self: auto;\n        height: 60px\n    }\n\n    .feature-text-header {\n        font-size: 26px\n    }\n\n    .text-block-386 {\n        font-size: 16px\n    }\n\n    .div-block-861 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .div-block-861.slider {\n        padding-left: 10px;\n        padding-right: 10px;\n        display: flex\n    }\n\n    .div-block-862 {\n        width: 300px;\n        height: 300px;\n        /*padding-top: 20px*/\n    }\n\n    .div-block-863 {\n        flex: 0 auto;\n        width: 100%;\n        margin-top: 20px;\n        margin-bottom: 20px\n    }\n\n    .tabs-3 {\n        display: none\n    }\n\n    .tabs-menu-6 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .text-block-387 {\n        font-size: 22px\n    }\n\n    .image-262 {\n        object-fit: fill\n    }\n\n    .text-block-388 {\n        text-align: center;\n        font-size: 16px\n    }\n\n    .logos-quote-block {\n        padding: 60px 15px\n    }\n\n    .clients-wrapper-two {\n        flex-direction: column\n    }\n\n    .clients-card {\n        width: 100%;\n        margin-bottom: 30px\n    }\n\n    .clients-grid {\n        grid-column-gap: 40px;\n        grid-template-columns: 1fr 1fr 1fr;\n        margin-top: 15px\n    }\n\n    .slider-21 {\n        flex-flow: column;\n        display: block\n    }\n\n    .slide-23 {\n        background-color: var(--white);\n        object-fit: fill;\n        height: 100%;\n        margin-bottom: -3px;\n        padding-bottom: 0;\n        position: static\n    }\n\n    .mask-10 {\n        height: auto;\n        margin-left: 10px;\n        margin-right: 10px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .slider-22 {\n        background-color: var(--white);\n        flex-flow: column;\n        flex: 0 auto;\n        order: 0;\n        justify-content: center;\n        align-self: auto;\n        align-items: flex-start;\n        width: 100%;\n        height: auto;\n        padding-left: 40px;\n        padding-right: 40px;\n        display: block;\n        position: relative\n    }\n\n    .icon-2,\n    .icon-3 {\n        margin-top: 100px\n    }\n\n    .slide-nav-9 {\n        display: none\n    }\n\n    .tabs-menu-7,\n    .tabs-content-5 {\n        height: 400px\n    }\n\n    .text-block-389 {\n        font-size: 16px\n    }\n\n    .div-block-868 {\n        height: 400px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .text-block-391 {\n        font-size: 60px\n    }\n\n    .div-block-870 {\n        object-fit: none;\n        width: 100%;\n        height: 300px;\n        margin-top: 60px;\n        margin-bottom: 25px;\n        display: none\n    }\n\n    .div-block-871 {\n        background-color: var(--soft-pink);\n        background-image: none\n    }\n\n    .div-block-872 {\n        width: 80%\n    }\n\n    .div-block-874 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .text-block-394 {\n        text-align: center;\n        flex: 0 auto\n    }\n\n    .div-block-880 {\n        flex-flow: wrap\n    }\n\n    .div-block-881.new {\n        width: 100%\n    }\n\n    .text-block-398 {\n        width: 80%\n    }\n\n    .div-block-886 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .text-block-407 {\n        text-align: center;\n        margin-bottom: 15px\n    }\n\n    .div-block-888 {\n        flex-flow: column;\n        justify-content: center;\n        align-items: center;\n        display: flex\n    }\n\n    .div-block-889 {\n        justify-content: center;\n        align-items: center;\n        padding-left: 0\n    }\n\n    .image-270 {\n        text-align: center\n    }\n\n    .div-block-891 {\n        width: 90%\n    }\n\n    .div-block-892.fold3 {\n        padding-bottom: 50px\n    }\n\n    .div-block-892.fold3.fold4 {\n        border-bottom-right-radius: 30px;\n        border-bottom-left-radius: 30px;\n        margin-bottom: 15px;\n        padding-bottom: 82px\n    }\n\n    .text-block-410 {\n        text-align: center\n    }\n\n    .button-53 {\n        text-align: left;\n        justify-content: flex-start;\n        align-self: center;\n        align-items: flex-start;\n        display: block\n    }\n\n    .text-block-412 {\n        text-align: center;\n        font-size: 50px\n    }\n\n    .div-block-898 {\n        grid-column-gap: 36px;\n        grid-row-gap: 36px;\n        justify-content: center;\n        align-items: center\n    }\n\n    .text-block-414 {\n        text-align: center\n    }\n\n    .div-block-899,\n    .div-block-899.two,\n    .div-block-899.three {\n        justify-content: flex-start;\n        align-items: center\n    }\n\n    .image-274 {\n        display: none\n    }\n\n    .div-block-902 {\n        grid-column-gap: 27px;\n        grid-row-gap: 27px;\n        padding-right: 0\n    }\n\n    .text-block-415 {\n        text-align: center;\n        font-size: 50px\n    }\n\n    .div-block-903 {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .text-block-417 {\n        text-align: center\n    }\n\n    .text-block-418 {\n        line-height: 1.4\n    }\n\n    .navbar-logo-left-container {\n        max-width: 100%\n    }\n\n    .navbar-brand {\n        padding-left: 0\n    }\n\n    .nav-menu-two {\n        border-radius: 20px;\n        flex-direction: column;\n        padding-bottom: 30px\n    }\n\n    .nav-link-7 {\n        padding-top: 10px;\n        padding-bottom: 10px;\n        display: inline-block\n    }\n\n    .nav-dropdown-2 {\n        flex-direction: column;\n        align-items: center;\n        display: flex\n    }\n\n    .nav-dropdown-toggle-2 {\n        padding-top: 10px;\n        padding-bottom: 10px\n    }\n\n    .nav-dropdown-list-2.shadow-three {\n        box-shadow: 0 8px 50px rgba(0, 0, 0, .05)\n    }\n\n    .nav-dropdown-list-2.shadow-three.w--open {\n        position: relative\n    }\n\n    .nav-dropdown-list-2.shadow-three.mobile-shadow-hide {\n        box-shadow: none\n    }\n\n    .nav-divider {\n        width: 200px;\n        max-width: 100%;\n        height: 1px;\n        margin-top: 10px;\n        margin-bottom: 10px\n    }\n\n    .nav-link-accent-2 {\n        margin-right: 5px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n        display: inline-block\n    }\n\n    .mobile-margin-top-11 {\n        margin-top: 10px\n    }\n\n    .text-span-376 {\n        font-size: 45px\n    }\n\n    .div-block-908 {\n        align-items: center;\n        justify-items: start\n    }\n\n    .div-block-909 {\n        width: 100%\n    }\n\n    .div-block-910 {\n        padding-left: 60px;\n        padding-right: 60px\n    }\n\n    .text-block-425 {\n        font-size: 22px\n    }\n\n    .text-block-426 {\n        font-size: 14px\n    }\n\n    .text-block-427 {\n        text-align: left\n    }\n}\n\n@media screen and (max-width:479px) {\n    h2 {\n        line-height: 42px\n    }\n\n    .page-wrapper {\n        aspect-ratio: auto;\n        padding-left: 0;\n        padding-right: 0;\n        overflow: scroll\n    }\n\n    .page-wrapper.fix-overflow {\n        overflow: visible\n    }\n\n    .main-wrapper {\n        background-color: var(--white);\n        -webkit-backdrop-filter: none;\n        backdrop-filter: none;\n        margin-top: 0\n    }\n\n    .home-hero-section {\n        margin-top: 0;\n        margin-bottom: 0\n    }\n\n    .wrapper-1300px {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .wrapper-1300px.adjust-padding {\n        padding-top: 16px\n    }\n\n    .wrapper-1300px.privacy {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .large-link-2 {\n        justify-content: flex-end;\n        margin-left: 8px;\n        padding: 16px 6px;\n        font-size: 14px;\n        display: none\n    }\n\n    .large-link-2.show {\n        justify-content: center;\n        margin-left: 0;\n        padding-left: 8px;\n        padding-right: 8px;\n        display: flex\n    }\n\n    .nav-menu {\n        height: auto;\n        padding-bottom: 0;\n        padding-left: 0;\n        overflow: visible\n    }\n\n    .navigation-right {\n        justify-content: space-between;\n        margin-right: 8px;\n        padding-right: 0;\n        display: flex\n    }\n\n    .navigation-right.tab-visibility {\n        flex-direction: column;\n        display: none\n    }\n\n    .nav-link-register.hide {\n        display: block\n    }\n\n    .navigation-left {\n        justify-content: flex-start;\n        height: auto;\n        margin-left: 8px;\n        padding-left: 0;\n        padding-right: 0;\n        display: flex\n    }\n\n    .navigation-left.custo {\n        width: auto;\n        padding-left: 8px;\n        padding-right: 8px;\n        display: block\n    }\n\n    .navigation-container {\n        flex-direction: row;\n        align-items: center;\n        height: auto;\n        min-height: auto;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .navigation-container.custo {\n        padding-top: 8px;\n        padding-bottom: 8px;\n        padding-right: 0\n    }\n\n    .logo {\n        width: auto;\n        height: 24px;\n        max-height: 24px\n    }\n\n    .logo.competitor-landing-nav-logo {\n        width: auto;\n        height: 20px\n    }\n\n    .nav-button-text {\n        margin-right: 0;\n        font-size: 16px\n    }\n\n    .brand.w--current {\n        margin-right: 0\n    }\n\n    .nav-link {\n        display: block\n    }\n\n    .nav-link.sp {\n        background-color: var(--pabloo-green);\n        color: var(--white)\n    }\n\n    .nav01 {\n        height: 70px\n    }\n\n    .nav01.sticky {\n        padding-top: 16px;\n        padding-bottom: 16px\n    }\n\n    .menu-button {\n        background-color: var(--white);\n        border-style: none;\n        border-radius: 0% 6px 6px 0%;\n        padding: 8px 6px;\n        box-shadow: 0 0 8px rgba(0, 0, 0, .1)\n    }\n\n    .home-hero-heading {\n        line-height: 1.4em\n    }\n\n    .home-hero-para {\n        line-height: 1.6em\n    }\n\n    .button-wrapper.home-hero-btn-wrapper {\n        flex-flow: column wrap;\n        align-items: stretch;\n        width: 100%\n    }\n\n    .primary-button {\n        text-align: center\n    }\n\n    .home-hero-stat-grid {\n        flex-wrap: wrap;\n        grid-template-columns: 1fr 1fr;\n        justify-content: flex-start;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .home-hero-stat-grid.pricing-stat {\n        flex-flow: wrap;\n        justify-content: flex-start;\n        align-items: flex-start\n    }\n\n    .home-hero-stat-grid.pricing-stat.pricing-center {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr 1fr;\n        grid-auto-columns: 1fr;\n        margin-top: 32px;\n        padding-left: 0;\n        padding-right: 8px;\n        display: grid\n    }\n\n    .home-hero-stat-grid.demo-stat-grid {\n        align-items: flex-start;\n        display: none\n    }\n\n    .home-hero-stat-grid.competitor-landing-page-hero-stat-grid {\n        justify-content: flex-start\n    }\n\n    .home-hero-stat-item {\n        align-items: flex-start;\n        width: 100%;\n        margin-bottom: 10px\n    }\n\n    .home-hero-stat-item.competitor-landing-page-hero-stat-item {\n        width: 100%\n    }\n\n    .hero-stat-block-square {\n        line-height: 20px\n    }\n\n    .hero-stat-block-square.demo-stat-block-square {\n        height: 12px\n    }\n\n    .home-hero-stat-block {\n        grid-column-gap: 20px;\n        flex-flow: wrap;\n        justify-content: center;\n        align-self: center;\n        align-items: center;\n        width: 100%\n    }\n\n    .home-hero-stat-number {\n        text-align: center;\n        width: 100%;\n        line-height: 48px\n    }\n\n    .home-hero-stat-number.white-text {\n        margin-bottom: 0;\n        margin-right: 10px;\n        line-height: 45px\n    }\n\n    .home-hero-stat-number.demo-stat-number {\n        margin-bottom: 2px;\n        font-size: 28px;\n        line-height: 28px\n    }\n\n    .home-hero-stat-number.competitor-landing-usps-stat-number {\n        text-align: center\n    }\n\n    .home-hero-stat-text {\n        text-align: left;\n        order: 0;\n        line-height: 20px\n    }\n\n    .home-hero-stat-text.demo-hero-stat-text {\n        text-align: left;\n        font-size: 12px;\n        line-height: 16px\n    }\n\n    .hero-image-wrapper {\n        width: 90%\n    }\n\n    .cards-section {\n        margin-bottom: 0;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .cards-section.vertical-padding-large {\n        margin-left: 21px;\n        margin-right: 21px;\n        padding-bottom: 64px\n    }\n\n    .logo-wrapper-grid {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr 1fr;\n        grid-auto-columns: 1fr;\n        justify-content: center;\n        display: grid\n    }\n\n    .logo-wrapper-grid.investors {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-flow: row;\n        justify-items: stretch;\n        margin-bottom: 60px\n    }\n\n    .logo-container {\n        width: auto;\n        margin-bottom: 0;\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .company-logo {\n        height: 100%\n    }\n\n    .company-logo.accel-logo.fix {\n        height: 40px\n    }\n\n    .home-value-wrapper {\n        padding: 100px 8px\n    }\n\n    .home-value-content-wrapper {\n        margin-top: 0\n    }\n\n    .home-value-heading {\n        font-size: 32px;\n        line-height: 38px\n    }\n\n    .value-image-wrapper-3 {\n        width: 250px\n    }\n\n    .home-split-section {\n        padding-top: 0;\n        padding-bottom: 60px\n    }\n\n    .home-split-section.light-grey-bg {\n        padding: 60px 8px\n    }\n\n    .split-section-wrapper.wrapper-logo {\n        margin-top: 187px\n    }\n\n    .split-section-wrapper.reverse {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .split-section-content-container,\n    .split-section-content-container.first {\n        margin-top: 0\n    }\n\n    .split-section-content-container.first.spaced-top {\n        margin-top: 48px\n    }\n\n    .split-section-heading {\n        letter-spacing: 0;\n        font-size: 32px;\n        line-height: 38px\n    }\n\n    .split-section-heading.max-width-560px,\n    .split-section-heading.max-width-520px {\n        line-height: 38px\n    }\n\n    .split-section-heading.max-width-560px {\n        font-size: 28px;\n        line-height: 150%\n    }\n\n    .blue-button {\n        font-size: 16px\n    }\n\n    .split-image-wrapper {\n        margin-top: 16px;\n        margin-bottom: 24px\n    }\n\n    .split-image-2 {\n        max-width: 200px\n    }\n\n    .split-image-wrapper-2.split-image-wrapper-3,\n    .split-image-wrapper-2.h-auto {\n        height: auto\n    }\n\n    .home-work-wrapper.slack-steps-wrapper {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .slide-nave-hide {\n        position: static;\n        top: auto;\n        bottom: -8%;\n        left: 0%;\n        right: 0%\n    }\n\n    .mask-visible {\n        width: 90%\n    }\n\n    .mask-visible._480px {\n        width: 95%;\n        max-width: none\n    }\n\n    .review-section {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .review-head-wrapper {\n        margin-bottom: 40px\n    }\n\n    .review-heading {\n        letter-spacing: 0;\n        font-size: 24px;\n        line-height: 32px\n    }\n\n    .review-slider-wrapper {\n        width: 100%\n    }\n\n    .review-slider {\n        flex-wrap: wrap;\n        width: 100%;\n        max-width: 100%;\n        height: auto\n    }\n\n    .review-slide {\n        width: 100%;\n        height: auto;\n        padding: 32px 0 0\n    }\n\n    .review-slider-container {\n        padding-bottom: 0;\n        padding-left: 24px\n    }\n\n    .review-slider-container.home {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .review-company-image-container {\n        height: 24px;\n        display: block\n    }\n\n    .review-company-image-container.airmeet-logo-wrapper {\n        height: 24px\n    }\n\n    .review-slider-content-wrapper {\n        min-height: auto;\n        margin-bottom: 32px\n    }\n\n    .review-slider-text {\n        font-weight: 400\n    }\n\n    .review-slider-author-wrapper {\n        flex-direction: row;\n        align-items: flex-start\n    }\n\n    .review-author-info-wrapper {\n        grid-column-gap: 4px;\n        grid-row-gap: 4px;\n        grid-template-columns: auto;\n        align-items: start;\n        margin-top: 0;\n        margin-bottom: 16px;\n        margin-left: 8px\n    }\n\n    .review-author-job-post {\n        font-size: 12px;\n        line-height: 16px\n    }\n\n    .home-pointers-section {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .home-pointers-image-wrapper {\n        width: 100%\n    }\n\n    .home-pointer-split-content-wrapper {\n        margin-top: 40px\n    }\n\n    .pitch-section {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .pitch-heading {\n        letter-spacing: 0;\n        padding-left: 18px;\n        padding-right: 18px;\n        font-size: 26px;\n        line-height: 109%\n    }\n\n    .pitch-illustration-wrapper {\n        flex-direction: column;\n        align-items: center;\n        width: 100%\n    }\n\n    .pitch-illustration-head {\n        width: 160px;\n        margin-bottom: 40px\n    }\n\n    .pitch-brach-wrapper {\n        display: none\n    }\n\n    .branch-card-wrapper {\n        align-self: auto;\n        width: 100%\n    }\n\n    .branch-card-wrapper.three-columns {\n        grid-template-columns: 1fr\n    }\n\n    .pitch-card-head {\n        font-size: 20px\n    }\n\n    .pitch-card-para.persona {\n        font-size: 16px\n    }\n\n    .home-support-section {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .support-content-wrapper {\n        width: 100%\n    }\n\n    .faq-container {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .faq-question {\n        font-size: 18px\n    }\n\n    .faq-answer {\n        font-size: 17px\n    }\n\n    .cta-split-wrapper {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .cta-split-wrapper.competitor-cta-section {\n        padding: 40px 16px\n    }\n\n    .cta-split-wrapper.align-center {\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .cta-split-content-wrapper.width-sm {\n        width: 100%\n    }\n\n    .cta-split-heading {\n        line-height: 38px\n    }\n\n    .white-alter-span {\n        display: inline\n    }\n\n    .white-alter-span.white {\n        font-size: 32px\n    }\n\n    .cta-image-wrapper,\n    .cta-image-wrapper.flex.width-md {\n        width: 100%\n    }\n\n    .footer {\n        padding-bottom: 40px;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .copyright-text {\n        flex: 0 auto\n    }\n\n    .copyright-text.competitor-landing {\n        font-size: 14px\n    }\n\n    .footer-down-link {\n        margin-left: 10px;\n        margin-right: 10px\n    }\n\n    .footer-down-link.first.competitor-landing {\n        font-size: 14px\n    }\n\n    .footer-down-link.last {\n        margin-right: 0\n    }\n\n    .footer-down-link.last.competitor-landing {\n        margin-left: 0;\n        font-size: 14px\n    }\n\n    .footer-down-link-wrapper.competitor-landing-footer-down-link-wrapper {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto auto;\n        grid-template-columns: 1fr 1fr;\n        grid-auto-columns: 1fr;\n        display: grid\n    }\n\n    .home-slider-section-heading {\n        letter-spacing: 0;\n        font-size: 32px;\n        line-height: 38px\n    }\n\n    .pricing-heading {\n        font-size: 37px;\n        line-height: 150%\n    }\n\n    .auto-slider-arrow-left {\n        display: none;\n        bottom: 10%;\n        left: auto;\n        right: 80px\n    }\n\n    .auto-slider-arrow-right {\n        display: none;\n        bottom: 10%;\n        left: auto;\n        right: 32px\n    }\n\n    .auto-slider-arrow-right.home.show {\n        position: static;\n        bottom: 0;\n        right: 0\n    }\n\n    .contact-hero-section {\n        margin-top: 0\n    }\n\n    .contact-hero-wrapper {\n        margin-top: 175px\n    }\n\n    .contact-hero-heading {\n        font-size: 40px;\n        line-height: 48px\n    }\n\n    .contact-field-wrapper {\n        grid-row-gap: 20px;\n        grid-template-columns: 1fr\n    }\n\n    .contact-field-block {\n        margin-right: 0\n    }\n\n    .contact-form-select {\n        margin-left: -4px;\n        padding-left: 0;\n        display: flex\n    }\n\n    .contact-message {\n        margin-bottom: 0\n    }\n\n    .email-span {\n        font-size: 25px;\n        display: block\n    }\n\n    .blog-hero-heading {\n        max-width: none;\n        font-size: 36px;\n        line-height: 38px\n    }\n\n    .blog-feature-section {\n        top: -289px\n    }\n\n    .blog-feature-wrapper {\n        padding: 16px\n    }\n\n    .blog-feature-wrapper.custo {\n        border-width: 6px;\n        padding: 8px\n    }\n\n    .wrapper-1080px,\n    .wrapper-1080px.blog-wrapper {\n        width: 90%\n    }\n\n    .blog-feature-block {\n        grid-row-gap: 23px;\n        grid-template-rows: auto auto\n    }\n\n    .blog-feature-block.guide {\n        grid-template-columns: 1fr\n    }\n\n    .blog-feature-image-container {\n        height: 180px\n    }\n\n    .blog-feature-image {\n        height: 100%\n    }\n\n    .blog-feature-content-wrapper {\n        padding-left: 11px;\n        padding-right: 11px\n    }\n\n    .blog-feature-info-top {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 12px\n    }\n\n    .blog-feature-info-top.spread,\n    .blog-tag-text {\n        font-size: 13px\n    }\n\n    .blog-date {\n        font-size: 13px;\n        line-height: 22px\n    }\n\n    .divider-circle {\n        display: none\n    }\n\n    .blog-feature-heading {\n        font-size: 18px;\n        line-height: 1.3\n    }\n\n    .blog-feature-para {\n        margin-top: 16px;\n        margin-bottom: 18px;\n        font-size: 12px;\n        line-height: 1.5\n    }\n\n    .blog-feature-author-block {\n        margin-top: 30px\n    }\n\n    .blog-feature-author-block.blog-collection {\n        margin-bottom: 40px\n    }\n\n    .cms-blog-block-section {\n        padding-bottom: 140px\n    }\n\n    .blog-filter-tab {\n        flex-flow: column wrap;\n        align-items: center\n    }\n\n    .blog-tab {\n        justify-content: center;\n        width: 100%;\n        margin-left: 0;\n        display: flex\n    }\n\n    .blog-collection-item {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .blog-collection-item.margin.custo {\n        border-width: 6px;\n        margin-right: 0;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .blog-collection-item.limit-width.custo {\n        border-width: 6px;\n        margin-top: 16px;\n        margin-left: 0;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .blog-card-image-container {\n        height: 180px\n    }\n\n    .blog-card-heading {\n        margin-bottom: 8px;\n        font-size: 20px;\n        line-height: 1.2\n    }\n\n    .blog-card-para {\n        font-size: 16px;\n        line-height: 22px\n    }\n\n    .blog-card-para.custo {\n        margin-top: 10px;\n        font-size: 14px\n    }\n\n    .blog-collection-hero-section {\n        padding-top: 48px\n    }\n\n    .blog-collection-heading {\n        font-size: 48px\n    }\n\n    .blog-collection-para {\n        font-size: 18px\n    }\n\n    .blog-main-image-wrapper {\n        margin-bottom: 24px\n    }\n\n    .blog-rich-text-section {\n        flex-wrap: wrap;\n        height: 100%;\n        padding-bottom: 0;\n        display: flex;\n        position: relative;\n        overflow: visible\n    }\n\n    .more-blog-section {\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .more-blog-head {\n        margin-bottom: 24px\n    }\n\n    .blog-contact-container {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .blog-designer-wrapper {\n        width: 100%;\n        margin-left: 0\n    }\n\n    .home-slider-image-1,\n    .home-slider-image-2 {\n        width: 50%\n    }\n\n    .pricing-hero-table {\n        grid-template-columns: 1fr\n    }\n\n    .pricing-table-left,\n    .pricing-table-right {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .price-point {\n        font-size: 18px;\n        line-height: 25px\n    }\n\n    .html-embed-2 {\n        margin-top: 28px;\n        margin-bottom: 21px\n    }\n\n    .wrapper-1280px {\n        flex-direction: column;\n        justify-content: space-between;\n        width: 90%\n    }\n\n    .wrapper-1280px.solution-wrapper,\n    .wrapper-1280px.split-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px.finance-wrapper {\n        padding-top: 80px\n    }\n\n    .wrapper-1280px.case-study-hero-flex {\n        padding-top: 60px;\n        padding-bottom: 50px\n    }\n\n    .wrapper-1280px.case-study-flex {\n        padding-top: 50px;\n        padding-bottom: 50px\n    }\n\n    .wrapper-1280px.fast-track-approval-hero-flex {\n        padding-top: 60px\n    }\n\n    .wrapper-1280px.document-one-place-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px.assisted-tools-flex {\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px.assisted-purchasing-flex {\n        margin-top: 0;\n        padding-top: 60px\n    }\n\n    .wrapper-1280px.actionable-insight-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px.custo {\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .wrapper-1280px.points-container {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .popup-close {\n        width: 40px;\n        height: 40px;\n        top: 50px;\n        right: 0%\n    }\n\n    .home-work-section-slider,\n    .home-work-section-slider.competitor-landing-page-how-it-works-slider {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .privacy-content-wrapper {\n        flex-direction: row;\n        flex: 0 auto;\n        justify-content: flex-start;\n        align-items: center;\n        width: 100%\n    }\n\n    .privacy-rich-text h2 {\n        font-size: 36px\n    }\n\n    .privacy-rich-text p {\n        font-size: 16px;\n        line-height: 150%\n    }\n\n    .privacy-rich-text h4 {\n        font-size: 17px\n    }\n\n    .blog-featured-heading {\n        font-size: 24px\n    }\n\n    .blog-featured-para {\n        font-size: 16px;\n        line-height: 24px\n    }\n\n    .popup-container {\n        width: 100%;\n        padding: 22px\n    }\n\n    .popup-heading {\n        font-size: 24px;\n        line-height: 26px\n    }\n\n    .popup-text-field::placeholder {\n        font-size: 16px\n    }\n\n    ._16-px {\n        flex-wrap: wrap-reverse;\n        display: flex\n    }\n\n    .about-hero-paragraph {\n        font-size: 13px\n    }\n\n    .about-hero-point-wrap {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .about-point-icon {\n        margin-bottom: 10px;\n        margin-right: 0\n    }\n\n    .about-hero-wrapper {\n        background-position: 0%, 100%\n    }\n\n    .about-team-heading {\n        letter-spacing: 0;\n        font-size: 32px\n    }\n\n    .team-grid.speakers-grid-webinar {\n        grid-template-columns: 1fr;\n        justify-content: flex-start;\n        max-width: 100%;\n        display: flex\n    }\n\n    .team-grid.speakers-grid-webinar.volopay-speakers {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .member-image._1.member-image-webinar.volopay-speaker-image,\n    .member-image._2.member-image-webinar.volopay-speaker-image {\n        max-height: 120px\n    }\n\n    .member-image._2.member-image-webinar.saas-cfo-webinar.no-shadow.smaller.pb-0 {\n        object-fit: contain\n    }\n\n    .member-name.volopay-member-name {\n        font-size: 16px\n    }\n\n    .member-company {\n        font-size: 12px\n    }\n\n    .career-wrapper {\n        padding-top: 100px\n    }\n\n    .career-block {\n        padding-left: 24px;\n        padding-right: 24px\n    }\n\n    .career-paragraph {\n        font-size: 20px\n    }\n\n    .career-heading {\n        letter-spacing: 0;\n        font-size: 32px\n    }\n\n    .about-slide {\n        max-height: none;\n        margin-right: 20px\n    }\n\n    .about-slider-contain {\n        padding: 0\n    }\n\n    .about-slider {\n        width: 100%\n    }\n\n    .left-arrow-about,\n    .right-arrow-about {\n        bottom: -26%\n    }\n\n    .about-subheading {\n        font-size: 22px;\n        line-height: 120%\n    }\n\n    .about-slide-text {\n        font-size: 16px\n    }\n\n    .persona-hero-card {\n        width: 90%;\n        padding: 20px\n    }\n\n    .persona-card-text {\n        margin-top: 0;\n        font-size: 28px\n    }\n\n    .persona-head-para {\n        font-size: 16px\n    }\n\n    .persona-head-para.it {\n        font-size: 18px;\n        line-height: 150%\n    }\n\n    .persona-hero-button-wrap.margin-top-120 {\n        margin-top: 64px\n    }\n\n    .persona-solution-para,\n    .solution-pointer-wrap {\n        font-size: 16px\n    }\n\n    .persona-split-section-head {\n        margin-bottom: 60px\n    }\n\n    .persona-split-section-heading {\n        font-size: 32px\n    }\n\n    .persona-split-text-container {\n        margin-top: 60px\n    }\n\n    .persona-split-text {\n        font-size: 32px\n    }\n\n    .persona-split-para {\n        font-size: 16px\n    }\n\n    .persona-split-image-container.procurement-section-3-image {\n        width: 100%\n    }\n\n    .finance-head-wrap {\n        margin-bottom: 40px\n    }\n\n    .finance-heading {\n        font-size: 32px\n    }\n\n    .finance-grid-item {\n        font-size: 16px\n    }\n\n    .persona-block-image {\n        margin-bottom: 10px\n    }\n\n    .dropdown-list.w--open {\n        object-fit: fill;\n        overflow: visible\n    }\n\n    .persona-dropdown-wrap {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .persona-dropdown-wrap.product-drop-down {\n        width: 100%;\n        padding-left: 0;\n        padding-right: 0;\n        overflow: visible\n    }\n\n    .persona-dropdown-wrap.resources {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .persona-dropdown-link,\n    .persona-dropdown-link.dropdown-link-no-border {\n        padding-top: 12px;\n        padding-bottom: 12px\n    }\n\n    .persona-dropdown-icon {\n        width: 32px;\n        height: 32px\n    }\n\n    .persona-dropdown-title {\n        margin-bottom: 4px;\n        font-size: 16px\n    }\n\n    .persona-dropdown-description {\n        font-size: 12px\n    }\n\n    .dropdown-toggle.w--open {\n        background-color: var(--light-pink)\n    }\n\n    .together-blue-heading {\n        font-size: 35px\n    }\n\n    .discover-product-hero-section {\n        padding-bottom: 80px\n    }\n\n    .discover-product-hero-section.custo {\n        padding-bottom: 40px\n    }\n\n    .discover-product-hero-heading {\n        font-size: 40px\n    }\n\n    .discover-hero-paragraph {\n        font-size: 16px\n    }\n\n    .discover-hero-pink-line {\n        width: 30px\n    }\n\n    .discover-hero-pink-text {\n        margin-left: 10px;\n        margin-right: 10px;\n        font-size: 14px\n    }\n\n    .discover-new-product-section.discover-new-product-slack {\n        margin-top: 32px\n    }\n\n    .new-product-heading-44px {\n        font-size: 32px\n    }\n\n    .new-product-paragraph-18px {\n        line-height: 160%\n    }\n\n    .new-product-hero-image {\n        box-shadow: -8px 8px 0 0 var(--slate-blue);\n        border-radius: 4px\n    }\n\n    .tools-image-container {\n        margin-bottom: 60px\n    }\n\n    .tools-image-container.resize-width {\n        width: 100%\n    }\n\n    .tools-hero-image {\n        box-shadow: -8px 8px 0 0 var(--pabloo-green);\n        border-radius: 4px\n    }\n\n    .procurement-item {\n        padding: 30px 15px\n    }\n\n    .button-container {\n        flex-wrap: wrap;\n        justify-content: center\n    }\n\n    .case-study-hero-heading {\n        font-size: 35px\n    }\n\n    .case-study-button-rapper {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-top: 30px;\n    }\n\n    .read-stories-button {\n        margin-bottom: 10px\n    }\n\n    .case-study-hero-pink-text {\n        font-size: 16px\n    }\n\n    .case-study-item-wrapper {\n        padding: 12px 12px 16px\n    }\n\n    .case-study-item-text-wrapper {\n        margin-top: 16px\n    }\n\n    .case-study-item-pink-tag {\n        margin-bottom: 8px;\n        font-size: 14px\n    }\n\n    .case-study-item-heading {\n        font-size: 22px\n    }\n\n    .case-study-item-para-small {\n        font-size: 16px\n    }\n\n    .track-appoval-image-container,\n    .track-appoval-image-container._w-md {\n        width: 100%\n    }\n\n    .track-approval-hero-image {\n        box-shadow: -7px 7px 0 0 var(--slate-blue)\n    }\n\n    .track-approval-hero-image.hide-shadow {\n        box-shadow: none\n    }\n\n    .track-approval-item-absolute {\n        width: 70%;\n        right: -2%\n    }\n\n    .multi-channel-image-container {\n        width: 95%\n    }\n\n    .multi-channel-item-wrapper {\n        box-shadow: -7px 7px 0 0 var(--pabloo-green)\n    }\n\n    .multi-channel-item-wrapper.middle {\n        margin-top: 30px;\n        margin-bottom: 30px\n    }\n\n    .workflow-approval-text-wrapper {\n        margin-top: 50px\n    }\n\n    .fast-track-approval-hero-section {\n        margin-bottom: 140px\n    }\n\n    .fast-track-approval-h1-heading {\n        margin-bottom: 10px;\n        font-size: 35px\n    }\n\n    .fast-track-hero-image-wrapper {\n        margin-bottom: -50px\n    }\n\n    .fast-track-hero-image-wrapper.track-usage {\n        width: 90%\n    }\n\n    .fast-track-hero-image-wrapper.resize {\n        max-width: 96%\n    }\n\n    .fast-track-hero-circle.left,\n    .fast-track-hero-circle.right {\n        width: 100%\n    }\n\n    .fast-track-hero-user-element {\n        width: 30%\n    }\n\n    .fast-track-hero-user-element._4 {\n        top: 25%\n    }\n\n    .fast-track-hero-user-element.track-usage-2 {\n        bottom: 5%;\n        left: 20%\n    }\n\n    .case-study-hero-logo-item._2 {\n        right: -5%\n    }\n\n    .footer-top-wrapper {\n        padding-top: 16px;\n        padding-bottom: 16px\n    }\n\n    .footer-top-wrapper.competitor-footer {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .footer-grid {\n        flex-flow: wrap\n    }\n\n    .footer-left-contain {\n        grid-row-gap: 50px;\n        flex-direction: column\n    }\n\n    .footer-links {\n        font-size: 16px\n    }\n\n    .mobile-only {\n        display: block\n    }\n\n    .split-section-form-wrapper {\n        padding: 0\n    }\n\n    .form-holder {\n        padding: 10px\n    }\n\n    .assisted-purchasing-hero-wrapper {\n        margin-bottom: 60px\n    }\n\n    .assisted-purchasing-hero-wrapper.insights {\n        margin-top: 19px\n    }\n\n    .assisted-hero-section {\n        padding-bottom: 100px\n    }\n\n    .assisted-hero-item-wrapper.left,\n    .assisted-hero-item-wrapper.right {\n        width: 200px;\n        bottom: 150px\n    }\n\n    .actionable-insight-text-wrap {\n        margin-top: 60px\n    }\n\n    .actionable-insight-image-wrap.resize-width {\n        width: 100%\n    }\n\n    .insight-hero-section {\n        margin-bottom: 120px\n    }\n\n    .insight-hero-section.track-usage {\n        margin-bottom: 160px\n    }\n\n    .investor-logo,\n    .investor-logo.investor-logo-rt-demo-custo-styles,\n    .investor-logo.investor-logo-rt-demo-custo-styles.rt-logo.fix {\n        width: 100%\n    }\n\n    .press-card-image-wrapper {\n        box-shadow: none;\n        height: auto\n    }\n\n    .text-color-white {\n        text-align: center;\n        font-size: 12px;\n        line-height: 24px\n    }\n\n    .news-logos {\n        width: 100%\n    }\n\n    .insights-hero-image {\n        width: 90%;\n        padding-bottom: 70px\n    }\n\n    .insights-hero-image-1 {\n        width: 70%\n    }\n\n    .insights-hero-image-4 {\n        margin-bottom: 140px\n    }\n\n    .insights-visualize-image {\n        box-shadow: -8px 8px 0 0 var(--pabloo-green)\n    }\n\n    .contract-hero-image-wrap {\n        margin-bottom: -60px\n    }\n\n    .contract-hero-section {\n        margin-bottom: 140px\n    }\n\n    .hero-subheading {\n        font-size: 16px\n    }\n\n    .hero-head-container.competitor-landing-usp-highlight-section {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .hero-heading {\n        font-size: 36px\n    }\n\n    .hero-heading-wrapper {\n        margin-bottom: 20px\n    }\n\n    .home-hero-image-blue-shadow {\n        box-shadow: 7px 7px 0 0 var(--slate-blue);\n        border-radius: 6px\n    }\n\n    .home-hero-text-wrapper {\n        margin-top: 40px\n    }\n\n    .hello-bar {\n        flex-flow: wrap;\n        padding-left: 8px;\n        padding-right: 8px;\n        position: -webkit-sticky;\n        position: sticky;\n        top: auto\n    }\n\n    .column {\n        flex-wrap: wrap\n    }\n\n    .div-block {\n        margin-top: 4%;\n        padding-left: 0\n    }\n\n    .heading {\n        margin-bottom: 8px;\n        font-size: 28px;\n        line-height: 1.2\n    }\n\n    .heading.center {\n        text-align: center;\n        /* margin-left: 5px */\n    }\n\n    .div-block-2 {\n        width: 100%;\n        padding-bottom: 12px;\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .container-3 {\n        max-width: 100%\n    }\n\n    .container-3.margin-top-0 {\n        max-width: 96%\n    }\n\n    .div-block-9 {\n        padding-bottom: 0\n    }\n\n    .div-block-10 {\n        padding-left: 4px\n    }\n\n    .grid-2 {\n        align-items: center;\n        margin-top: 4px\n    }\n\n    .text-block-6 {\n        font-size: 18px;\n        line-height: 28px\n    }\n\n    .div-block-13 {\n        margin-top: 8px;\n        margin-bottom: 16px\n    }\n\n    .div-block-14 {\n        margin-top: 8px\n    }\n\n    .div-block-15 {\n        flex-wrap: wrap\n    }\n\n    .div-block-15.m-t-20 {\n        margin-top: 20px\n    }\n\n    .div-block-15.m-t-20.m-b-40 {\n        margin-bottom: 40px\n    }\n\n    .text-block-9 {\n        font-size: 12px\n    }\n\n    .div-block-17 {\n        margin-top: 0;\n        padding: 2px 6px\n    }\n\n    .body-2 {\n        object-fit: fill;\n        overflow: visible\n    }\n\n    .heading-5 {\n        font-size: 48px;\n        line-height: 56px\n    }\n\n    .heading-5.custo {\n        font-size: 37px;\n        line-height: 1.2em\n    }\n\n    .div-block-19 {\n        margin-top: 16px\n    }\n\n    .div-block-20 {\n        width: 100%;\n        padding: 32px 8px\n    }\n\n    .div-block-21 {\n        padding: 24px 16px\n    }\n\n    .div-block-21.registration-form-block {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .container-4 {\n        background-color: var(--white);\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        max-width: 100%\n    }\n\n    .container-4.custo {\n        max-width: 90%\n    }\n\n    .div-block-22 {\n        flex-flow: column wrap;\n        align-items: flex-start\n    }\n\n    .div-block-23.alt-badge {\n        margin-top: 16px;\n        margin-left: 0;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .text-block-11 {\n        color: var(--white);\n        font-size: 16px\n    }\n\n    .text-block-11.roundtable-text {\n        font-size: 16px\n    }\n\n    .div-block-24 {\n        color: #fff;\n        margin-top: 16px;\n        padding-top: 2px;\n        padding-bottom: 2px\n    }\n\n    .div-block-24.panel-shadow {\n        margin-right: 0;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .div-block-25.panel-shadow {\n        grid-column-gap: 4px;\n        grid-row-gap: 4px;\n        align-items: center;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .div-block-25.panel-shadow.custo {\n        padding-top: 2px;\n        padding-bottom: 2px\n    }\n\n    .div-block-27 {\n        top: -24px;\n        bottom: auto;\n        right: 0\n    }\n\n    .div-block-28 {\n        padding: 0\n    }\n\n    .div-block-29 {\n        background-color: var(--white);\n        border: 4px red;\n        min-height: auto;\n        padding-top: 24px;\n        padding-bottom: 24px\n    }\n\n    .bestsuited-webinarblock {\n        min-height: auto;\n        padding: 40px 8px;\n        display: block\n    }\n\n    .bestsuited-webinarblock.hide {\n        display: none\n    }\n\n    .heading-7 {\n        font-size: 28px;\n        line-height: 1.2em\n    }\n\n    .div-block-33 {\n        grid-row-gap: 24px;\n        flex-wrap: wrap;\n        grid-template-columns: 1fr;\n        align-content: stretch;\n        justify-content: flex-start;\n        align-items: flex-start;\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .grid-3 {\n        padding-top: 16px\n    }\n\n    .grid-3.m-l-24 {\n        width: 100%;\n        margin-top: 0;\n        margin-left: 0;\n        padding-top: 16px\n    }\n\n    .text-block-14 {\n        font-size: 38px\n    }\n\n    .div-block-34 {\n        margin-top: 56px;\n        padding-left: 12px;\n        padding-right: 12px\n    }\n\n    .button {\n        border-radius: 8px;\n        width: 100%;\n        height: 56px;\n        font-size: 16px\n    }\n\n    .div-block-35 {\n        background-color: var(--white);\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/62b1a53121d721625b5654cd_pattern-bg.png);\n        background-repeat: no-repeat;\n        background-size: cover;\n        min-height: auto;\n        margin-top: 40px;\n        padding: 24px 0;\n        display: block\n    }\n\n    .div-block-36 {\n        background-color: transparent;\n        background-image: none;\n        padding-top: 8px;\n        padding-bottom: 32px\n    }\n\n    .div-block-36.why-attend-block {\n        display: none\n    }\n\n    .heading-8 {\n        text-align: center;\n        margin-bottom: 21px;\n        font-size: 24px;\n        line-height: 30px\n    }\n\n    .grid-4 {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px;\n        margin-bottom: 16px\n    }\n\n    .text-block-18 {\n        font-size: 16px;\n        line-height: 20px\n    }\n\n    .div-block-37 {\n        font-size: 18px\n    }\n\n    .div-block-38 {\n        background-color: transparent;\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        border-bottom-right-radius: 32px;\n        padding: 24px 16px\n    }\n\n    .cta-button-roundtable {\n        border-radius: 8px;\n        width: 100%;\n        height: 56px;\n        font-size: 16px\n    }\n\n    .cta-button-roundtable.cta-button-roundtable-pink {\n        border-radius: 8px\n    }\n\n    .div-block-39 {\n        margin-top: 0;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-40 {\n        height: auto;\n        padding-top: 16px;\n        padding-bottom: 16px;\n        display: block\n    }\n\n    .container-5 {\n        max-width: 100%;\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .div-block-41 {\n        margin-top: 24px\n    }\n\n    .div-block-42 {\n        justify-content: center;\n        display: flex\n    }\n\n    .div-block-45 {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px;\n        margin-bottom: 16px\n    }\n\n    .text-block-21 {\n        font-size: 18px\n    }\n\n    .image-7 {\n        width: 100%;\n        position: static\n    }\n\n    .text-block-22 {\n        color: var(--black);\n        font-size: 15px\n    }\n\n    .columns-2 {\n        flex-direction: column-reverse;\n        display: flex\n    }\n\n    .column-5 {\n        background-image: none;\n        padding-left: 0;\n        padding-right: 0;\n        display: block\n    }\n\n    .column-6 {\n        padding-top: 0%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .text-span-7 {\n        color: var(--white);\n        -webkit-text-stroke-color: var(--white)\n    }\n\n    .div-block-52 {\n        display: none;\n        top: -28%;\n        right: auto\n    }\n\n    .image-9 {\n        display: block\n    }\n\n    .image-9.hide {\n        display: none\n    }\n\n    .image-10 {\n        display: block\n    }\n\n    .div-block-57 {\n        flex-wrap: wrap\n    }\n\n    .hero-points-rt {\n        background-color: rgba(255, 255, 255, .19);\n        margin-top: 8px\n    }\n\n    .rt-hero-text {\n        color: var(--black);\n        font-size: 18px;\n        line-height: 30px\n    }\n\n    .ebook-hero-points-short {\n        justify-content: flex-start\n    }\n\n    .container-6 {\n        max-width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .div-block-60 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .heading-9 {\n        font-size: 20px\n    }\n\n    .heading-10,\n    .heading-10.text-white {\n        font-size: 24px\n    }\n\n    .paragraph-3 {\n        font-size: 18px;\n        font-weight: 400;\n        line-height: 1.4em\n    }\n\n    .div-block-61.white {\n        padding-top: 48px;\n        padding-bottom: 48px;\n        display: block\n    }\n\n    .div-block-61.white.m-t-40 {\n        margin-top: 0;\n        padding-top: 0\n    }\n\n    .div-block-61.white.p-t-40 {\n        padding-left: 15px;\n        padding-right: 15px\n    }\n\n    .columns-4 {\n        display: block\n    }\n\n    .button-2 {\n        margin-left: 0;\n        padding-left: 28px;\n        padding-right: 28px\n    }\n\n    .button-2.rt-footer-cta {\n        border-radius: 8px;\n        margin-left: 0\n    }\n\n    .heading-11 {\n        font-size: 24px;\n        line-height: 1.2em\n    }\n\n    .column-8 {\n        flex-wrap: nowrap;\n        flex: 0 auto;\n        display: block\n    }\n\n    .column-9 {\n        flex-wrap: wrap;\n        flex: 0 auto;\n        padding-left: 0;\n        padding-right: 0;\n        display: block\n    }\n\n    .container-7 {\n        max-width: 100%\n    }\n\n    .div-block-63 {\n        padding-top: 8px\n    }\n\n    .div-block-65 {\n        display: none\n    }\n\n    .body-3 {\n        overflow: visible\n    }\n\n    .home-hero-logos-wrap {\n        flex-wrap: wrap;\n        align-items: center;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .home-hero-logo-container {\n        margin-top: 0;\n        margin-right: 8px;\n        padding-top: 4px;\n        padding-bottom: 4px;\n        padding-left: 10px\n    }\n\n    .home-hero-logo-container.gs {\n        margin-top: 0\n    }\n\n    .div-block-66.margin-reset {\n        margin-right: 0\n    }\n\n    .div-block-67 {\n        width: 20px;\n        height: 20px;\n        margin-right: 8px\n    }\n\n    .div-block-67.gs {\n        width: 16px;\n        height: 16px\n    }\n\n    .image-15 {\n        max-width: 100%\n    }\n\n    .link-block {\n        width: 100%\n    }\n\n    .button-3 {\n        width: 100%;\n        margin-top: 24px;\n        margin-left: 0\n    }\n\n    .section {\n        grid-template-columns: 1fr;\n        padding-left: 5px;\n        padding-right: 5px\n    }\n\n    .section-2 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-70 {\n        justify-content: flex-start\n    }\n\n    .goldman-sachs {\n        height: 32px\n    }\n\n    .goldman-sachs.accel {\n        height: 20px\n    }\n\n    .paragraph-12 {\n        color: rgba(0, 0, 0, .68);\n        width: 100%;\n        font-size: 16px\n    }\n\n    .div-block-97 {\n        position: fixed;\n        left: 0%\n    }\n\n    .div-block-97.hide {\n        display: none\n    }\n\n    .div-block-98.pb-md {\n        -webkit-backdrop-filter: none;\n        backdrop-filter: none\n    }\n\n    .div-block-98.pb-md.pt-sm.flex {\n        background-image: none;\n        background-position: 0 0;\n        background-repeat: repeat;\n        background-size: auto\n    }\n\n    .blog-subscription-container {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .heading-36 {\n        font-size: 36px\n    }\n\n    .landing-nav.competitor-landing-nav {\n        padding-bottom: 0\n    }\n\n    .div-block-102 {\n        justify-items: center;\n        width: 100%\n    }\n\n    .div-block-102.child {\n        margin-left: 0\n    }\n\n    .div-block-104 {\n        grid-column-gap: 32px;\n        grid-row-gap: 32px;\n        padding: 12px 8px\n    }\n\n    .div-block-105 {\n        grid-template-columns: 1fr\n    }\n\n    .paragraph-14,\n    .heading-40 {\n        text-align: center\n    }\n\n    .div-block-109 {\n        grid-template-columns: 1fr\n    }\n\n    .image-24 {\n        margin-top: 32px\n    }\n\n    .list-item-9 {\n        margin-top: 24px;\n        margin-bottom: 48px;\n        font-size: 18px\n    }\n\n    .list-item-10 {\n        margin-bottom: 48px;\n        font-size: 18px\n    }\n\n    .list-item-11 {\n        font-size: 18px\n    }\n\n    .div-block-111 {\n        grid-template-columns: 1fr\n    }\n\n    .section-6 {\n        background-color: var(--white-smoke)\n    }\n\n    .div-block-112 {\n        grid-template-columns: 1fr\n    }\n\n    .competitor-landing-hero-grid {\n        grid-column-gap: 32px;\n        grid-row-gap: 32px;\n        grid-template-columns: 1fr;\n        padding: 8px 8px 40px\n    }\n\n    .competitor-landing-hero-content {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px\n    }\n\n    .competitor-landing-hero-form.minimal-fields {\n        background-color: var(--pabloo-green)\n    }\n\n    .competitor-landing-hero-section {\n        padding-top: 0\n    }\n\n    .heading-44 {\n        font-size: 40px;\n        line-height: 56px\n    }\n\n    .paragraph-20 {\n        font-size: 18px;\n        line-height: 1.4em\n    }\n\n    .button-6 {\n        padding: 8px;\n        font-family: Satoshi, sans-serif;\n        font-size: 12px;\n        font-weight: 500\n    }\n\n    .button-6.w--current {\n        padding: 8px 12px;\n        font-size: 14px\n    }\n\n    .button-6.competitor-ladning-nav-cta,\n    .button-6.competitor-ladning-nav-cta.w--current {\n        padding-left: 16px;\n        padding-right: 16px;\n        font-size: 16px\n    }\n\n    .div-block-115 {\n        background-image: radial-gradient(circle farthest-corner at 50% 100%, var(--pabloo-green), var(--black)53%);\n        grid-template-columns: auto\n    }\n\n    .div-block-116 {\n        display: none\n    }\n\n    .div-block-118 {\n        width: 80px;\n        display: block\n    }\n\n    .image-26 {\n        border-radius: 0% 0% 0% 8px\n    }\n\n    .text-block-48 {\n        display: none\n    }\n\n    .auto-slider-arrow-left-2 {\n        display: none;\n        bottom: 10%;\n        left: auto;\n        right: 80px\n    }\n\n    .review-slider-text-2 {\n        font-weight: 400\n    }\n\n    .text-block-49 {\n        display: none\n    }\n\n    .div-block-119 {\n        background-image: radial-gradient(circle farthest-corner at 0% 100%, #d53987, var(--white)32%);\n        grid-template-columns: auto\n    }\n\n    .div-block-120 {\n        padding-bottom: 40px\n    }\n\n    .html-embed-5 {\n        margin-bottom: 0\n    }\n\n    .image-28 {\n        height: 28px\n    }\n\n    .h1-heading {\n        font-size: 64px\n    }\n\n    .header-section {\n        height: auto;\n        padding-bottom: 60px\n    }\n\n    .h3-heading {\n        font-size: 36px;\n        line-height: 44px\n    }\n\n    .feature-grid-large {\n        grid-template-columns: 1fr\n    }\n\n    .authors-wrapper {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr;\n        grid-auto-columns: 1fr;\n        justify-content: flex-start;\n        margin-top: 0;\n        display: grid\n    }\n\n    .company-logo-2 {\n        margin-top: 8px;\n        margin-bottom: 8px\n    }\n\n    .company-logo-2._1.nivas {\n        height: 140px\n    }\n\n    .company-logo-2.dan {\n        height: 140px;\n        margin-left: 0\n    }\n\n    .company-logo-2.dan.lg {\n        height: 200px\n    }\n\n    .ebook-points-heading {\n        text-align: left;\n        font-size: 16px;\n        line-height: 26px\n    }\n\n    .ebook-points-heading.custo {\n        text-align: left;\n        font-size: 18px\n    }\n\n    .image-wrapper.darl-mode {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .image-wrapper.darl-mode.custo {\n        margin-left: 0\n    }\n\n    .trusted-text {\n        text-align: center\n    }\n\n    .hero-heading-2 {\n        text-align: left;\n        letter-spacing: 0;\n        text-transform: capitalize;\n        font-size: 2em;\n        line-height: 1.2em\n    }\n\n    .hero-heading-2.custo {\n        text-align: left;\n        font-size: 34px\n    }\n\n    .header-grid-3 {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px\n    }\n\n    .div-block-123 {\n        text-align: center;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        display: flex\n    }\n\n    .header-section-3 {\n        margin-top: 0;\n        padding-top: 23px;\n        padding-bottom: 60px\n    }\n\n    .header-section-3.with-bg {\n        background-image: url(https://d3e54v103j8qbb.cloudfront.net/img/background-image.svg);\n        background-repeat: no-repeat;\n        background-size: 0%\n    }\n\n    .process-heading {\n        font-size: 32px\n    }\n\n    .shape.hide {\n        max-width: 50%;\n        display: block\n    }\n\n    .number-large.medium {\n        position: absolute;\n        top: -8px\n    }\n\n    .process-grid {\n        grid-template-columns: 1fr\n    }\n\n    .process-section {\n        padding-bottom: 40px\n    }\n\n    .feature-card {\n        padding-top: 40px\n    }\n\n    .features-container {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .team-heading {\n        font-size: 32px\n    }\n\n    .features-paragraph {\n        font-size: 16px;\n        font-weight: 300\n    }\n\n    .features-button {\n        justify-content: center;\n        margin-left: auto;\n        margin-right: auto;\n        font-size: 15px;\n        font-weight: 500\n    }\n\n    .features-button.ab {\n        justify-content: flex-start\n    }\n\n    .section-regular.middle-band {\n        background-position: 50% 100%;\n        background-size: contain;\n        background-attachment: scroll\n    }\n\n    .section-regular.partner-section {\n        padding-left: 4px;\n        padding-right: 4px\n    }\n\n    .form-wrapper-2 {\n        flex-direction: column\n    }\n\n    .integration {\n        min-width: 130px;\n        min-height: 120px;\n        padding: 16px\n    }\n\n    .integration-logo {\n        width: 70px\n    }\n\n    .cta-block {\n        padding: 32px 16px\n    }\n\n    .bloom-image-effect-2 {\n        display: none\n    }\n\n    .bold-text,\n    .bold-text-2 {\n        font-size: 60px\n    }\n\n    .heading-62 {\n        font-size: 32px\n    }\n\n    .image-cover {\n        object-fit: cover;\n        object-position: 50% 50%\n    }\n\n    .image-cover.not-in-mobile {\n        display: none\n    }\n\n    .image-cover.mobile-only {\n        object-fit: contain;\n        display: block\n    }\n\n    .header-placeholder-top {\n        height: 390px\n    }\n\n    .div-block-126 {\n        width: 98%;\n        margin-top: 50%;\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .heading-63 {\n        font-size: 20px;\n        line-height: 26px\n    }\n\n    .paragraph-33 {\n        font-size: 14px;\n        line-height: 18px\n    }\n\n    .text-block-60 {\n        font-size: 12px\n    }\n\n    .white-button {\n        text-align: center;\n        width: 100%\n    }\n\n    .div-block-144 {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .text-block-65 {\n        font-size: 14px\n    }\n\n    .div-block-145 {\n        border-radius: 0;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .submit-button {\n        width: 100%\n    }\n\n    .div-block-146,\n    .div-block-148 {\n        grid-template-columns: 1fr\n    }\n\n    .cta-image-2 {\n        opacity: .16;\n        width: 100%;\n        display: block\n    }\n\n    .cta-button-wrapper {\n        grid-row-gap: 14px;\n        flex-direction: column;\n        align-items: stretch\n    }\n\n    .section-cta.hide {\n        padding-left: 2%;\n        padding-right: 2%\n    }\n\n    .cta-heading {\n        font-size: 32px;\n        line-height: 42px\n    }\n\n    .button-cta-secondary {\n        border-color: var(--white);\n        background-color: var(--white)\n    }\n\n    .div-block-152 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-153.margin-top-reset.no-border {\n        grid-template-columns: .5fr 1fr;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .avatar-name {\n        text-align: left\n    }\n\n    .div-block-159 {\n        flex-wrap: wrap\n    }\n\n    .heading-71 {\n        text-align: left\n    }\n\n    .content-grid {\n        grid-template-columns: 1fr\n    }\n\n    .section-large-2.blackbg {\n        background-image: none;\n        background-position: 0 0;\n        background-repeat: repeat;\n        background-size: auto\n    }\n\n    .testimoial-container {\n        flex-direction: column;\n        align-items: center;\n        margin-top: 100px;\n        margin-right: 0;\n        padding-bottom: 100px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .d-128-3d-card-wrapper {\n        width: 300px;\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .ck-button-w {\n        padding-left: 1.25em;\n        padding-right: 1.25em\n    }\n\n    .ck-modal__content-w.is--small {\n        padding-bottom: 1.25rem;\n        padding-left: 1.25rem;\n        padding-right: 1.25rem\n    }\n\n    .ck-cookie-w {\n        max-width: 100%;\n        top: auto;\n        bottom: 0%;\n        left: 0%;\n        right: 0%\n    }\n\n    .ck-modal__exit-btn {\n        margin-top: 1rem;\n        margin-right: 1rem\n    }\n\n    .ck-modal__btns-w.is--small {\n        padding: 1.25rem\n    }\n\n    .ck-modal {\n        max-width: 100%;\n        display: none\n    }\n\n    .ck-preference-w {\n        align-items: flex-end\n    }\n\n    .ck-preference__scroll-w {\n        max-width: 100%;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .ck-prefmanager-w {\n        left: 1rem\n    }\n\n    .modal-section {\n        z-index: 9;\n        display: none\n    }\n\n    .modal-paragraph {\n        margin-bottom: 24px;\n        font-size: 16px;\n        line-height: 24px\n    }\n\n    .modal-container {\n        border-radius: 0;\n        grid-template-columns: 1fr;\n        padding: 48px 12px 12px\n    }\n\n    .modal-content {\n        flex-wrap: wrap;\n        justify-content: center;\n        width: 100%;\n        padding-right: 0;\n        display: flex\n    }\n\n    .modal-content.hide {\n        display: none\n    }\n\n    .modal-heading {\n        font-size: 24px;\n        line-height: 32px\n    }\n\n    .modal-image-large {\n        object-fit: contain;\n        border-radius: 0;\n        width: 100%;\n        max-height: 200px;\n        margin-bottom: 0\n    }\n\n    .modal-image-large.blue-bg {\n        width: 100%\n    }\n\n    .modal-buttons-wrap {\n        text-align: center;\n        flex-direction: column;\n        align-items: stretch\n    }\n\n    .section-11 {\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .heading-77 {\n        font-size: 40px;\n        line-height: 52px\n    }\n\n    .testimonial-title-wrapper {\n        padding-left: 4%;\n        padding-right: 5%\n    }\n\n    .testimonial-section-2 {\n        padding: 80px 0% 0\n    }\n\n    .div-block-164 {\n        padding-left: 1%;\n        padding-right: 1%\n    }\n\n    .section-small {\n        padding-left: 2%;\n        padding-right: 2%\n    }\n\n    .h6-heading {\n        font-size: 30px;\n        line-height: 1.3\n    }\n\n    .grid-four-column {\n        grid-template-columns: 1fr\n    }\n\n    .logo-block {\n        min-height: 60px;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .client-logo {\n        height: 26px\n    }\n\n    .client-logo.mind-tickle-logo-resize {\n        height: 20px\n    }\n\n    .client-logo.curefit-logo-resize {\n        height: 40px\n    }\n\n    .client-logo.m-t-8 {\n        height: 24px\n    }\n\n    .title-wrapper-regular {\n        text-align: center\n    }\n\n    .back-button,\n    .next-button-2 {\n        display: none\n    }\n\n    .section-testimonial {\n        overflow: hidden\n    }\n\n    .container-16 {\n        max-width: 100%\n    }\n\n    .h6-heading-2 {\n        font-size: 22px;\n        line-height: 32px\n    }\n\n    .span-primary {\n        color: var(--pabloo-green)\n    }\n\n    .div-block-168 {\n        position: relative\n    }\n\n    .div-block-169 {\n        background-color: var(--light-pink);\n        width: 100%;\n        height: 84%;\n        position: absolute;\n        bottom: 0\n    }\n\n    .image-43,\n    .image-44,\n    .div-block-170 {\n        position: relative\n    }\n\n    .navigation-avatar-wrapper {\n        display: none\n    }\n\n    .header-slide-image {\n        object-fit: cover;\n        border-radius: 16px;\n        min-height: auto\n    }\n\n    .header-slider-product {\n        border-radius: 0;\n        height: 210px;\n        min-height: 180px\n    }\n\n    .header-slide-wrapper {\n        height: 100%;\n        padding-top: 0;\n        padding-bottom: 0\n    }\n\n    .feature-section-3 {\n        padding-bottom: 60px\n    }\n\n    .feature-grid-2 {\n        grid-template-columns: 1fr\n    }\n\n    .link-block-5 {\n        height: 100%\n    }\n\n    .link-block-5.header-slider-product {\n        min-height: auto\n    }\n\n    .div-block-171.hide {\n        display: none\n    }\n\n    .process-heading-2 {\n        font-size: 44px\n    }\n\n    .process-heading-2.m-b-8 {\n        font-size: 1.8em\n    }\n\n    .process-grid-2 {\n        grid-column-gap: 64px;\n        grid-row-gap: 64px;\n        grid-template-columns: 1fr\n    }\n\n    .sub-heading-text {\n        width: auto;\n        font-size: 3rem;\n        line-height: 3rem\n    }\n\n    .header-featured-wrap {\n        width: 100%;\n        top: 50%;\n        transform: translateY(-50%)\n    }\n\n    .header-featured-wrap.contact {\n        padding-right: 0;\n        display: block\n    }\n\n    .sticky-wrapper {\n        height: auto;\n        position: relative\n    }\n\n    .contact-us-wrapper {\n        position: static\n    }\n\n    .big-container {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .sub-header-img.contact-us {\n        padding-left: 10px;\n        padding-right: 10px;\n        position: static\n    }\n\n    .process-graphic {\n        max-width: 100%\n    }\n\n    .process-step {\n        margin-bottom: 20px;\n        margin-right: 0\n    }\n\n    .line-break-2 {\n        max-width: 100%\n    }\n\n    .process-main-block {\n        flex-direction: column\n    }\n\n    .process-section-3 {\n        overflow: visible\n    }\n\n    .process-line {\n        display: none\n    }\n\n    .columns-6 {\n        display: block\n    }\n\n    .column-71 {\n        object-fit: fill;\n        position: static\n    }\n\n    .column-72 {\n        position: static\n    }\n\n    .slide-detail {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .text-span-95 {\n        font-size: 16px;\n        line-height: 26px\n    }\n\n    .heading-83,\n    .heading-84 {\n        text-align: left;\n        font-size: 16px\n    }\n\n    .text-block-83,\n    .text-block-84 {\n        text-align: left;\n        font-size: 14px\n    }\n\n    .div-block-186 {\n        margin-left: 0\n    }\n\n    .div-block-186.m-l-0 {\n        margin-right: 0\n    }\n\n    .image-46 {\n        height: 24px\n    }\n\n    .div-block-187 {\n        padding-top: 8px;\n        padding-bottom: 8px;\n        padding-right: 0\n    }\n\n    .text-block-86 {\n        text-align: left;\n        font-size: 24px;\n        font-style: normal\n    }\n\n    .div-block-191 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        flex-wrap: wrap;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr;\n        grid-auto-columns: 1fr;\n        justify-content: flex-end;\n        justify-items: start;\n        display: flex\n    }\n\n    .div-block-192 {\n        justify-content: flex-start;\n        margin-top: 16px\n    }\n\n    .div-block-194 {\n        grid-template-columns: 1fr\n    }\n\n    .intro {\n        max-width: 90%;\n        padding-bottom: 54px;\n        padding-left: 35px;\n        padding-right: 37px\n    }\n\n    .intro.feature-3 {\n        padding-top: 56px;\n        padding-left: 21px;\n        padding-right: 21px\n    }\n\n    .heading-88 {\n        margin-top: 15px;\n        padding-right: 26px\n    }\n\n    .heading-88.mob {\n        padding-right: 106px\n    }\n\n    .column-73,\n    .column-74 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .heading-89 {\n        font-size: 16px\n    }\n\n    .section-regular-2 {\n        padding-top: 48px\n    }\n\n    .pricing-image {\n        max-width: 40%\n    }\n\n    .heading-content-2 {\n        font-size: 38px\n    }\n\n    .slider-4 {\n        min-height: auto\n    }\n\n    .left-arrow-3,\n    .right-arrow-3 {\n        display: none\n    }\n\n    .banner-wrap {\n        text-align: left\n    }\n\n    .text-block-103,\n    .text-block-104 {\n        font-size: 13px\n    }\n\n    .text-block-105,\n    .text-block-106 {\n        font-size: 12px\n    }\n\n    .text-block-107,\n    .text-block-108 {\n        font-size: 13px\n    }\n\n    .heading-95 {\n        font-size: 22px\n    }\n\n    .text-span-127 {\n        color: var(--pabloo-green)\n    }\n\n    .f-header-form-row {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .feature-card-04,\n    .feature-card-5,\n    .feature-card-6,\n    .feature-card-01 {\n        text-align: center;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        display: flex\n    }\n\n    .heading-large {\n        font-size: 48px\n    }\n\n    .feature-block-header {\n        padding-left: 20px\n    }\n\n    .feature-title-2 {\n        font-size: 1.4em;\n        line-height: 1.2em\n    }\n\n    .feature-number {\n        margin-right: 20px;\n        font-size: 1.2em;\n        line-height: 1em\n    }\n\n    .feature-header-2 {\n        font-size: 34px;\n        line-height: 44px\n    }\n\n    .feature-pink-block {\n        width: 100%\n    }\n\n    .collection-list-3 {\n        grid-column-gap: 4px;\n        grid-row-gap: 4px;\n        flex-wrap: nowrap;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr 1fr 1fr;\n        grid-auto-columns: 1fr;\n        align-items: center;\n        width: 100%;\n        display: flex\n    }\n\n    .paragraph-50 {\n        text-align: left;\n        margin-bottom: 24px;\n        font-size: 16px;\n        font-weight: 300;\n        line-height: 1.4em\n    }\n\n    .header-grid-5 {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px\n    }\n\n    .image-wrapper-3.darl-mode {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .image-wrapper-3.darl-mode.custo {\n        margin-left: 0\n    }\n\n    .features-button-2 {\n        justify-content: center;\n        align-self: center;\n        margin-left: auto;\n        margin-right: auto;\n        font-size: 15px;\n        font-weight: 500\n    }\n\n    .ebook-points-heading-2 {\n        text-align: left;\n        font-size: 16px;\n        line-height: 26px\n    }\n\n    .ebook-points-heading-2.custo {\n        text-align: left;\n        font-size: 18px\n    }\n\n    .hero-heading-4 {\n        text-align: left;\n        font-size: 40px;\n        line-height: 50px\n    }\n\n    .hero-heading-4.custo {\n        text-align: left;\n        font-size: 44px\n    }\n\n    .header-section-6 {\n        padding-bottom: 60px\n    }\n\n    .main-wrapper-2 {\n        -webkit-backdrop-filter: blur(5px)blur(120px);\n        backdrop-filter: blur(5px)blur(120px);\n        background-color: #fff\n    }\n\n    .rich-text-block-20 {\n        font-size: 18px;\n        line-height: 1.6em\n    }\n\n    .heading-104 {\n        font-size: 32px;\n        line-height: 1.2em\n    }\n\n    .collection-list-4 {\n        grid-template-columns: auto auto\n    }\n\n    .image-67 {\n        height: 32px\n    }\n\n    .div-block-263 {\n        font-size: 16px\n    }\n\n    .text-block-158 {\n        color: var(--white)\n    }\n\n    .text-block-159 {\n        color: var(--black)\n    }\n\n    .rich-text-block-22 {\n        text-align: left\n    }\n\n    .lp-text-style {\n        font-size: 16px\n    }\n\n    .logo-item {\n        max-width: 120px\n    }\n\n    .win-item-wrapper {\n        align-self: stretch;\n        max-width: 100%\n    }\n\n    .lp-image-wrapper {\n        align-self: stretch\n    }\n\n    .navigation-link-block {\n        padding-left: 14px;\n        padding-right: 14px\n    }\n\n    .navigation-cta {\n        padding: 24px\n    }\n\n    .footer-3 {\n        padding-bottom: 40px;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .footer-links-2 {\n        font-size: 16px\n    }\n\n    .div-block-320 {\n        flex-wrap: wrap;\n        justify-content: center\n    }\n\n    .image-76 {\n        height: 70px\n    }\n\n    .div-block-321 {\n        width: 100%;\n        margin-top: 24px\n    }\n\n    .large-link-3 {\n        justify-content: flex-end;\n        margin-left: 8px;\n        padding: 16px 6px;\n        font-size: 14px;\n        display: none\n    }\n\n    .nav-link-register-2.hide {\n        display: block\n    }\n\n    .text-block-184 {\n        font-size: 12px\n    }\n\n    .persona-dropdown-wrap-2 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .persona-dropdown-wrap-2.product-drop-down {\n        width: 100%;\n        padding-left: 0;\n        padding-right: 0;\n        overflow: visible\n    }\n\n    .persona-dropdown-wrap-2.resources {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .menu-button-7 {\n        background-color: #fff;\n        border-style: none;\n        border-radius: 0% 6px 6px 0%;\n        padding: 8px 6px;\n        box-shadow: 0 0 8px rgba(0, 0, 0, .1)\n    }\n\n    .dropdown-toggle-3.w--open {\n        background-color: #f5cde1\n    }\n\n    .nav-link-5 {\n        display: block\n    }\n\n    .nav-link-5.sp {\n        color: #fff;\n        background-color: #d53987\n    }\n\n    .div-block-332 {\n        justify-content: center;\n        align-self: center;\n        width: auto\n    }\n\n    .heading-122 {\n        font-size: 32px;\n        line-height: 36px\n    }\n\n    .div-block-333 {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-columns: 1fr;\n        margin-top: 40px;\n        margin-left: 0%;\n        margin-right: 0%\n    }\n\n    .div-block-334,\n    .div-block-334.border-gradient {\n        border-top-style: none\n    }\n\n    .image-82,\n    .image-83,\n    .image-84,\n    .image-85 {\n        margin-top: 0\n    }\n\n    .blog-book-demo-block {\n        display: none\n    }\n\n    .wrapper-block {\n        padding-right: 0\n    }\n\n    .split-image-wrapper-3 {\n        margin-top: 16px;\n        margin-bottom: 0\n    }\n\n    .review-slider-author-wrapper-2 {\n        flex-direction: row;\n        align-items: center;\n        width: 100%\n    }\n\n    .top-tag-text-2 {\n        margin-left: 10px;\n        margin-right: 10px;\n        font-size: 16px\n    }\n\n    .auto-slider-arrow-left-3 {\n        display: none;\n        bottom: 10%;\n        left: auto;\n        right: 80px\n    }\n\n    .auto-slider-arrow-left-3.show {\n        flex: 0 auto;\n        order: 0;\n        position: static;\n        bottom: 0;\n        right: 64px\n    }\n\n    .wrapper-1300px-3 {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .hover-block__text {\n        background-color: #fff;\n        margin-top: 55%;\n        padding-top: 35px;\n        padding-bottom: 35px;\n        position: relative;\n        top: 0%;\n        bottom: auto;\n        left: 0;\n        right: 0;\n        transform: none\n    }\n\n    .page-subheading {\n        font-size: 18px\n    }\n\n    .review-slide-3 {\n        height: auto;\n        max-height: none;\n        padding: 0\n    }\n\n    .navigation-list-2.solutions.w--open,\n    .navigation-list-2.resources.w--open {\n        width: 100%\n    }\n\n    .mask-not-visible-2 {\n        height: 100%\n    }\n\n    .page-heading {\n        font-size: 40px;\n        line-height: 48px\n    }\n\n    .div-block-367 {\n        grid-template-columns: auto;\n        margin-top: 24px\n    }\n\n    .div-block-369 {\n        margin-left: 4px;\n        margin-right: 4px;\n        padding: 12px\n    }\n\n    .heading-141 {\n        font-size: 32px;\n        line-height: 150%\n    }\n\n    .review-author-job-post-3 {\n        font-size: 12px;\n        line-height: 16px\n    }\n\n    .review-slider-container-3 {\n        padding-bottom: 0;\n        padding-left: 24px\n    }\n\n    .review-slider-container-3.home {\n        padding-top: 0;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .review-slider-text-4 {\n        font-size: 14px;\n        font-weight: 400\n    }\n\n    .heading-145 {\n        font-size: 32px\n    }\n\n    .about-hero-wrapper-3 {\n        background-position: 0%, 100%\n    }\n\n    .about-hero-wrapper-3.white-bg.margin-top-40.transparent-bg {\n        margin-bottom: 24px\n    }\n\n    .home-slider-image-4 {\n        width: 50%\n    }\n\n    .heading-148 {\n        font-size: 32px;\n        line-height: 150%\n    }\n\n    .paragraph-93 {\n        font-size: 16px;\n        line-height: 24px\n    }\n\n    .review-company-image-container-3 {\n        height: 24px;\n        display: block\n    }\n\n    .review-company-image-container-3.airmeet-logo-wrapper {\n        height: 24px\n    }\n\n    .footer-links-4 {\n        font-size: 16px\n    }\n\n    .div-block-391.margin-top-reset.no-border {\n        grid-column-gap: 4px;\n        grid-template-columns: auto;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .heading-151 {\n        font-size: 16px\n    }\n\n    .menu-button-10.w--open {\n        background-color: var(--pabloo-green)\n    }\n\n    .review-slider-content-wrapper-4 {\n        min-height: auto;\n        margin-top: 8px;\n        margin-bottom: 16px\n    }\n\n    .div-block-396 {\n        background-image: radial-gradient(circle at 0 100%, #d53987, #fff 32%);\n        grid-template-columns: auto\n    }\n\n    .div-block-396.border {\n        grid-template-columns: 1fr;\n        padding-top: 0;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .heading-152 {\n        font-size: 28px\n    }\n\n    .div-block-397 {\n        width: 72px;\n        display: block\n    }\n\n    .image-123 {\n        border-radius: 0% 0% 0% 8px\n    }\n\n    .div-block-398 {\n        display: none\n    }\n\n    .heading-155 {\n        font-size: 32px\n    }\n\n    .div-block-399 {\n        padding-top: 24px\n    }\n\n    .div-block-399.integrations-section-container {\n        margin-top: 0\n    }\n\n    .div-block-404 {\n        grid-template-columns: auto;\n        margin-top: 24px\n    }\n\n    .heading-160 {\n        font-size: 32px;\n        line-height: 150%\n    }\n\n    .home-slider-image-5 {\n        width: 50%\n    }\n\n    .persona-head-para-2 {\n        font-size: 16px\n    }\n\n    .persona-head-para-2.it {\n        font-size: 18px;\n        line-height: 150%\n    }\n\n    .persona-head-para-2.it.black {\n        font-size: 18px;\n        font-weight: 400\n    }\n\n    .heading-130 {\n        margin-bottom: 0;\n        font-size: 32px;\n        line-height: 150%\n    }\n\n    .div-block-436 {\n        width: 100%\n    }\n\n    .home-slider-image-6 {\n        width: 50%\n    }\n\n    .heading-177 {\n        font-size: 18px\n    }\n\n    .div-block-445 {\n        border-left-style: none;\n        width: 100%\n    }\n\n    .paragraph-108 {\n        font-size: 14px\n    }\n\n    .rich-text-block-23 {\n        text-align: left;\n        font-size: 16px;\n        line-height: 1.6\n    }\n\n    .heading-180 {\n        font-size: 40px\n    }\n\n    .collection-list-wrapper-5 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .collection-list-5 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-466 {\n        border-radius: 0;\n        grid-template-columns: 1fr\n    }\n\n    .div-block-469 {\n        padding: 16px\n    }\n\n    .collection-list-6 {\n        grid-template-columns: 1fr\n    }\n\n    .paragraph-111 {\n        font-size: 18px;\n        line-height: 1.6\n    }\n\n    .div-block-471 {\n        border-left-style: none;\n        padding-left: 0\n    }\n\n    .div-block-473 {\n        width: 120px;\n        display: block\n    }\n\n    .section-34 {\n        padding-left: 2%;\n        padding-right: 2%\n    }\n\n    .div-block-478 {\n        grid-template-columns: 1fr\n    }\n\n    .text-span-188 {\n        font-size: 24px\n    }\n\n    .heading-185,\n    .heading-186,\n    .heading-187 {\n        font-size: 34px\n    }\n\n    .heading-189 {\n        font-size: 24px;\n        line-height: 1.2em\n    }\n\n    .text-block-228 {\n        margin-left: 6px\n    }\n\n    .heading-191,\n    .text-block-229 {\n        line-height: 1.6em\n    }\n\n    .heading-193 {\n        font-size: 36px;\n        line-height: 1.6em\n    }\n\n    .div-block-491 {\n        width: 100%;\n        max-width: none;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .container-1282 {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .heading-194 {\n        font-size: 36px;\n        line-height: 1.6\n    }\n\n    .section-36 {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .container-1283 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .heading-198 {\n        font-size: 40px\n    }\n\n    .features-grid-4 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-502 {\n        padding-left: 9px;\n        padding-right: 9px\n    }\n\n    .form-4 {\n        grid-template-columns: 1fr\n    }\n\n    .section-37 {\n        background-size: cover\n    }\n\n    .div-block-516 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-518 {\n        grid-template-columns: auto\n    }\n\n    .div-block-519 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-529 {\n        background-color: var(--black);\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/643657e7caba8c4227a33de6_ads-banner.svg);\n        background-position: 0 0;\n        background-repeat: no-repeat;\n        background-size: cover;\n        align-self: flex-end;\n        width: 100%;\n        height: auto;\n        padding-bottom: 12px;\n        padding-left: 12px;\n        padding-right: 12px;\n        display: flex;\n        position: -webkit-sticky;\n        position: sticky;\n        bottom: 0\n    }\n\n    .heading-207 {\n        color: var(--white);\n        text-align: center;\n        font-size: 20px\n    }\n\n    .list-16 {\n        justify-content: flex-start\n    }\n\n    .collection-list-wrapper-6,\n    .collection-item-4 {\n        width: 100%\n    }\n\n    .mt-md.center.text-sm {\n        font-size: 16px\n    }\n\n    .column-76 {\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .column-77 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-535 {\n        flex-wrap: wrap\n    }\n\n    .div-block-536 {\n        width: 100%;\n        padding: 40px 16px 64px\n    }\n\n    .div-block-537 {\n        display: none\n    }\n\n    .image-178 {\n        height: 48px\n    }\n\n    .div-block-540 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .heading-210 {\n        font-size: 38px;\n        line-height: 1.1em\n    }\n\n    .paragraph-120 {\n        font-size: 18px\n    }\n\n    .section-40 {\n        padding: 80px 16px\n    }\n\n    .div-block-543 {\n        grid-row-gap: 80px;\n        grid-template-columns: 1fr\n    }\n\n    .section-41 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .section-42 {\n        padding: 64px 8px\n    }\n\n    .div-block-546 {\n        flex-wrap: wrap\n    }\n\n    .div-block-547 {\n        width: 100%\n    }\n\n    .div-block-548 {\n        width: 100%;\n        margin-top: 32px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-552 {\n        height: 100%;\n        padding: 20px 12px\n    }\n\n    .section-43 {\n        padding: 56px 8px\n    }\n\n    .section-44 {\n        padding: 80px 16px\n    }\n\n    .div-block-554 {\n        flex-wrap: wrap\n    }\n\n    .div-block-555 {\n        width: 100%\n    }\n\n    .div-block-556 {\n        width: 100%;\n        margin-top: 32px;\n        padding-left: 0\n    }\n\n    .section-45 {\n        padding: 0\n    }\n\n    .div-block-561 {\n        flex-wrap: wrap\n    }\n\n    .section-46 {\n        padding: 64px 16px\n    }\n\n    .heading-216 {\n        font-size: 40px\n    }\n\n    .columns-8 {\n        display: block\n    }\n\n    .div-block-562 {\n        margin-top: 32px\n    }\n\n    .div-block-564 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .image-185 {\n        width: 100%;\n        height: auto\n    }\n\n    .div-block-567 {\n        grid-column-gap: 4px;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .text-block-250 {\n        font-size: 16px\n    }\n\n    .button-37 {\n        padding-left: 16px;\n        padding-right: 16px;\n        font-size: 14px\n    }\n\n    .text-block-251 {\n        text-align: center;\n        font-size: 16px\n    }\n\n    .text-block-251.text-align-center {\n        text-align: center\n    }\n\n    .heading-218 {\n        text-align: center;\n        font-size: 40px\n    }\n\n    .div-block-571 {\n        grid-template-columns: .5fr 1fr\n    }\n\n    .div-block-574 {\n        padding: 8px 0\n    }\n\n    .div-block-575 {\n        grid-column-gap: 2px;\n        grid-row-gap: 12px;\n        grid-template-rows: auto;\n        grid-template-columns: 1fr auto auto;\n        grid-auto-columns: 1fr;\n        padding: 8px 4px 8px 8px;\n        display: grid\n    }\n\n    .text-block-252 {\n        font-size: 16px;\n        line-height: 1.6em\n    }\n\n    .image-186 {\n        height: 40px;\n        font-size: 18px\n    }\n\n    .text-block-253,\n    .text-block-254,\n    .text-block-255,\n    .text-block-256,\n    .text-block-257,\n    .text-block-258,\n    .text-block-260 {\n        font-size: 16px\n    }\n\n    .div-block-577 {\n        height: 40px\n    }\n\n    .div-block-579 {\n        height: 30px\n    }\n\n    .div-block-580 {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .text-block-261 {\n        font-size: 20px\n    }\n\n    .div-block-581 {\n        margin-top: 24px\n    }\n\n    .div-block-583 {\n        height: 20px\n    }\n\n    .div-block-584 {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .heading-219 {\n        font-size: 32px\n    }\n\n    .section-48 {\n        padding-top: 12%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .section-49 {\n        padding: 24% 8px 10%\n    }\n\n    .heading-220 {\n        font-size: 32px\n    }\n\n    .div-block-590 {\n        grid-column-gap: 8px\n    }\n\n    .text-block-268,\n    .text-span-210,\n    .text-block-269,\n    .text-block-270 {\n        font-size: 16px\n    }\n\n    .heading-221 {\n        font-size: 20px\n    }\n\n    .heading-222 {\n        font-size: 40px\n    }\n\n    .section-50 {\n        padding: 8% 8px\n    }\n\n    .div-block-595 {\n        grid-template-columns: 1fr\n    }\n\n    .section-51 {\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        padding: 4% 8px 8%\n    }\n\n    .div-block-596 {\n        padding-right: 0\n    }\n\n    .heading-223 {\n        font-size: 32px;\n        line-height: 1.2em\n    }\n\n    .div-block-598 {\n        padding-left: 8px;\n        padding-right: 8px;\n        position: relative\n    }\n\n    .section-52 {\n        padding: 8% 8px 40px\n    }\n\n    .div-block-601 {\n        grid-template-columns: 1fr\n    }\n\n    .section-54 {\n        padding: 32px 8px\n    }\n\n    .heading-224 {\n        font-size: 32px;\n        line-height: 1.2em\n    }\n\n    .div-block-615 {\n        grid-template-columns: 1fr\n    }\n\n    .section-55 {\n        padding: 48px 8px 32px\n    }\n\n    .heading-227 {\n        font-size: 32px\n    }\n\n    .text-block-281 {\n        color: var(--white)\n    }\n\n    .div-block-618 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-621 {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .heading-229 {\n        font-size: 32px\n    }\n\n    .link-41 {\n        color: var(--pabloo-green)\n    }\n\n    .div-block-632 {\n        grid-template-columns: 1fr\n    }\n\n    .heading-235 {\n        font-size: 32px\n    }\n\n    .image-188 {\n        width: 100%;\n        height: auto\n    }\n\n    .container-1286 {\n        padding-left: 22px;\n        padding-right: 22px\n    }\n\n    .image-202 {\n        height: auto\n    }\n\n    .banner-cta-blog {\n        width: 300px\n    }\n\n    .heading-240 {\n        text-align: center;\n        margin-top: 0;\n        font-size: 20px\n    }\n\n    .div-block-665 {\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: stretch;\n        margin-left: 8px\n    }\n\n    .link-button-copy2 {\n        width: 180px;\n        margin-bottom: 0\n    }\n\n    .text-block-4 {\n        font-size: 16px;\n        line-height: 100%\n    }\n\n    .text-block-286 {\n        font-size: 16px\n    }\n\n    .section-59 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .div-block-669 {\n        flex-wrap: wrap\n    }\n\n    .image-207 {\n        object-fit: cover;\n        height: 120px\n    }\n\n    .heading-241 {\n        font-size: 2.25rem\n    }\n\n    .div-block-673 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-674 {\n        width: 100%;\n        margin-top: 24px;\n        margin-bottom: 0;\n        display: block;\n        position: relative;\n        top: auto;\n        bottom: -80px;\n        right: auto\n    }\n\n    .div-block-675 {\n        padding-left: 12px;\n        padding-right: 12px\n    }\n\n    .case-study-hero-sub-heading {\n        margin-top: 20px;\n        font-size: 14px\n    }\n\n    .rich-text-block-28 {\n        font-size: 1rem;\n        line-height: 1.75em\n    }\n\n    .case-study-hero-heading-2 {\n        font-size: 2.5rem;\n        line-height: 1.1em\n    }\n\n    .section-60 {\n        padding-top: 120px;\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .paragraph-133 {\n        font-size: 1.5rem;\n        font-weight: 700;\n        line-height: 1.4em\n    }\n\n    .case-study-hero-container {\n        width: 100%\n    }\n\n    .div-block-681 {\n        grid-template-columns: 1fr 1fr;\n        width: 100%\n    }\n\n    .div-block-682 {\n        grid-template-columns: 1fr\n    }\n\n    .case-study-hero-metrics-container {\n        grid-template-columns: auto\n    }\n\n    .case-study-hero-section {\n        padding: 80px 16px 32px;\n        overflow: visible\n    }\n\n    .image-212 {\n        width: auto;\n        height: auto;\n        min-height: auto;\n        max-height: 36px\n    }\n\n    .bold-text-25 {\n        font-size: .9em;\n        line-height: 1.2em\n    }\n\n    .rich-text-block-29 {\n        font-size: 16px;\n        font-weight: 300;\n        line-height: 1.8em\n    }\n\n    .section-61 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .div-block-687 {\n        grid-template-columns: 1fr\n    }\n\n    .section-62 {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .div-block-689 {\n        grid-template-columns: 1fr\n    }\n\n    .section-63 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .div-block-694 {\n        justify-items: center;\n        padding-right: 0\n    }\n\n    .text-block-298 {\n        font-size: 14px;\n        line-height: 1.2em\n    }\n\n    .div-block-698 {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .div-block-700 {\n        width: 56px;\n        display: block\n    }\n\n    .div-block-701 {\n        width: 100%\n    }\n\n    .image-217,\n    .image-218 {\n        height: 40px\n    }\n\n\n    .reference-hero-wrapper {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .colors-grid {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .buttons-grid {\n        grid-template-columns: 1fr\n    }\n\n    .heading-64px {\n        font-size: 42px\n    }\n\n    .heading-64px.hero-home-heading {\n        font-size: 36px\n    }\n\n    .heading-64px.hero-home-heading.top {\n        max-width: 400px\n    }\n\n    .heading-64px.hero-home-heading.bottom {\n        flex: 0 auto\n    }\n\n    .heading-64px.hero-home-heading.zendesk {\n        width: 152.828px\n    }\n\n    .heading-64px.text-align-center {\n        margin-bottom: 16px;\n        font-size: 26px\n    }\n\n    .heading-64px.text-align-center.include-bg-element {\n        margin-top: 0\n    }\n\n    .heading-64px.blogs-hero-heading,\n    .heading-64px.resource-hero-heading {\n        font-size: 38px\n    }\n\n    .heading-90px {\n        font-size: 48px\n    }\n\n    .heading-56px {\n        font-size: 36px\n    }\n\n    .heading-56px.integrations-heading._40px-bottom-margin {\n        margin-bottom: 24px\n    }\n\n    .heading-48px {\n        font-size: 32px\n    }\n\n    .heading-48px.stack-heading {\n        margin-bottom: 30px\n    }\n\n    .heading-40px {\n        font-size: 28px\n    }\n\n    .heading-40px.spend-block-heading {\n        font-size: 24px\n    }\n\n    .navigation-bar {\n        margin-top: 0;\n        top: 0\n    }\n\n    .navigation-link {\n        width: 100%;\n        margin-right: auto\n    }\n\n    .logo-contain {\n        grid-column-gap: 4px;\n        grid-row-gap: 4px\n    }\n\n    .logo-image {\n        max-width: 130px;\n    }\n\n    .logo-bar.second,\n    .logo-bar.third,\n    .logo-bar.first {\n        width: 10px\n    }\n\n    .navigation-button-contain.out-menu {\n        margin-right: 6px\n    }\n\n    .navigation-button-contain.in-menu {\n        grid-column-gap: 10px;\n        grid-row-gap: 10px\n    }\n\n    .hero-home-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px\n    }\n\n    .hero-home-wrapper.new,\n    .hero-home-wrapper.new.ads {\n        padding-top: 100px\n    }\n\n    .transparent-arrow-button {\n        padding: 18px 20px;\n        font-size: 17px\n    }\n\n    .hero-home-text-wrapper {\n        max-width: 383px;\n        padding-top: 0\n    }\n\n    .hero-home-text-wrapper.new {\n        margin-top: 94px\n    }\n\n    .paragraph-18px.hero-home-paragraph {\n        margin-bottom: 10px\n    }\n\n    .paragraph-18px.hero-home-paragraph.new {\n        font-size: 18px\n    }\n\n    .paragraph-18px.integrations-paragraph {\n        margin-bottom: 30px\n    }\n\n    .paragraph-18px.spend-block-paragraph,\n    .paragraph-18px.reviewer-position {\n        font-size: 14px\n    }\n\n    .paragraph-18px.saas-hero-paragraph,\n    .paragraph-18px.cloud-hero-paragraph {\n        margin-bottom: 10px\n    }\n\n    .pink-arrow-button {\n        padding: 18px 20px;\n        font-size: 17px\n    }\n\n    .pink-arrow-button.new {\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .stats-section {\n        padding-top: 2px\n    }\n\n    .stats-wrapper {\n        margin-top: 15px;\n        padding-top: 39px;\n        padding-bottom: 80px\n    }\n\n    .stats-grid {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .stats-block {\n        padding-top: 20px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .heading-24px.stats-text {\n        margin-bottom: 0\n    }\n\n    .heading-24px.review-text {\n        font-size: 17px\n    }\n\n    .heading-24px.setup-card-text {\n        font-size: 18px\n    }\n\n    .seo-page-hero {\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        padding: 32px 16px 40px\n    }\n\n    .seo-page-hero.new {\n        padding-top: 151px\n    }\n\n    .html-embed-28 {\n        font-size: 18px\n    }\n\n    .paragraph-140 {\n        font-size: 16px\n    }\n\n    .div-block-703 {\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .type-cards-grid {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .type-card-block.first,\n    .type-card-block.second {\n        padding-top: 24px\n    }\n\n    .type-card-top-wrapper {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .type-card-heading-wrapper {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px\n    }\n\n    .type-card-icon-contain {\n        width: 46px;\n        height: 46px\n    }\n\n    .type-card-icon-embed {\n        width: 30px;\n        height: 30px\n    }\n\n    .heading-28px {\n        font-size: 20px\n    }\n\n    .div-block-704 {\n        grid-template-columns: 1fr;\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .div-block-705 {\n        grid-template-columns: 1fr\n    }\n\n    .heading-248 {\n        text-align: left\n    }\n\n    .div-block-707 {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .div-block-708 {\n        grid-template-columns: 1fr;\n        align-items: center;\n        justify-items: center\n    }\n\n    .heading-249,\n    .paragraph-142 {\n        text-align: center\n    }\n\n    .section-65 {\n        padding: 40px 16px\n    }\n\n    .div-block-720 {\n        grid-template-columns: 1fr;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-721 {\n        padding-bottom: 40px\n    }\n\n    .collection-list-7 {\n        grid-template-columns: 1fr\n    }\n\n    .section-66 {\n        padding: 80px 16px\n    }\n\n    .div-block-727 {\n        grid-template-columns: 1fr\n    }\n\n    .arrow-text-link {\n        font-size: 17px\n    }\n\n    .arrow-text-link-top-contain {\n        align-items: flex-end\n    }\n\n    .text-link-underline.hide-on-portrait {\n        display: none\n    }\n\n    .type-cards-train-container.vertical {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .type-cards-train-card {\n        align-items: flex-start\n    }\n\n    .type-card-checkmark {\n        margin-top: 3px\n    }\n\n    .integrations-wrapper {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        padding-top: 80px;\n        padding-bottom: 60px\n    }\n\n    .integrations-wrapper.saas,\n    .integrations-wrapper.cloud {\n        padding-bottom: 60px\n    }\n\n    .calculator-left {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .stack-wrapper {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .stack-tabs-menu {\n        grid-column-gap: 4px;\n        grid-row-gap: 4px;\n        margin-bottom: 40px\n    }\n\n    .stack-tab-link {\n        min-width: 70px\n    }\n\n    .stack-tab-link-progress-bar-contain {\n        height: 4px\n    }\n\n    .paragraph-20px.stack-tab-link-text {\n        font-size: 14px\n    }\n\n    .paragraph-20px.footer-column-subheading,\n    .paragraph-20px.footer-link,\n    .paragraph-20px.reviewer-name,\n    .paragraph-20px.form-field-label {\n        font-size: 16px\n    }\n\n    .paragraph-20px.blog-tag-radio-button-label {\n        padding-left: 16px;\n        padding-right: 16px\n    }\n\n    .stack-blocks-grid {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .stack-block.a-first,\n    .stack-block.a-second,\n    .stack-block.d-first {\n        padding: 20px\n    }\n\n    .stack-block-header {\n        grid-column-gap: 10px;\n        grid-row-gap: 10px;\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .stack-block-image-contain.a-first,\n    .stack-block-image-contain.a-second,\n    .stack-block-image-contain.b-first,\n    .stack-block-image-contain.c-first,\n    .stack-block-image-contain.c-second,\n    .stack-block-image-contain.b-second,\n    .stack-block-image-contain.d-second,\n    .stack-block-image-contain.d-first {\n        margin-top: 30px\n    }\n\n    .blogs-wrapper {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .blog-post-wrapper._16px-gap,\n    .blog-post-wrapper.load-list {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px\n    }\n\n    .blog-post-image-wrapper.featured {\n        height: 225px\n    }\n\n    .blog-post-image-wrapper.featured.blog-page {\n        height: 260px\n    }\n\n    .blog-post-image-wrapper.featured.cms,\n    .blog-post-image-wrapper.featured.resources-hero {\n        height: 240px\n    }\n\n    .blog-post-image-wrapper._300px {\n        height: 225px\n    }\n\n    .blog-post-info-wrapper {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .heading-32px {\n        font-size: 24px\n    }\n\n    .blog-post-image.featured {\n        object-fit: cover;\n        height: 80%\n    }\n\n    .transparent-white-arrow-button {\n        padding: 18px 20px;\n        font-size: 17px\n    }\n\n    .footer-wrapper {\n        grid-column-gap: 40px;\n        grid-row-gap: 10px;\n        padding-top: 40px\n    }\n\n    .footer-top-container {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .brand-logos-contain.new {\n        align-self: center;\n        width: 100%\n    }\n\n    .brand-logos-wrapper {\n        padding: 10px\n    }\n\n    .brand-logos-wrapper.new {\n        justify-content: center;\n        align-items: center;\n        display: flex\n    }\n\n    .brand-logo.first {\n        width: 54px;\n        margin-right: 2px\n    }\n\n    .brand-logo.second {\n        width: 54px;\n        margin-right: 6px\n    }\n\n    .brand-logo.third {\n        width: 58px\n    }\n\n    .footer-links-wrapper {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .footer-links-wrapper.new {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .footer-links-column.fifth {\n        max-width: none;\n        padding-top: 20px\n    }\n\n    .footer-links-column.fifth.new {\n        grid-column-gap: 0px;\n        grid-row-gap: 0px;\n        flex-flow: wrap;\n        align-content: stretch;\n        justify-content: center;\n        align-items: center;\n        padding-top: 39px;\n        display: flex\n    }\n\n    .tribe-wrapper {\n        margin-top: -20px\n    }\n\n    .tribe-tab-link-info-wrapper {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .tribe-tab-image-contain {\n        padding-top: 30px;\n        padding-bottom: 30px\n    }\n\n    .spend-wrapper {\n        padding: 80px 10px\n    }\n\n    .calculator-wrapper {\n        padding: 30px 16px\n    }\n\n    .spend-block-icon-embed {\n        width: 24px;\n        height: 24px\n    }\n\n    .spend-image.c {\n        margin-top: -40px\n    }\n\n    .spend-block-wrapper {\n        grid-column-gap: 10px;\n        grid-row-gap: 10px\n    }\n\n    .spend-block-wrapper.a.new._1 {\n        width: 240px;\n        display: none\n    }\n\n    .spend-block-wrapper.a.new._2 {\n        width: 260px;\n        display: none;\n        left: -110%\n    }\n\n    .spend-block-wrapper.a.new._3 {\n        width: 260px;\n        margin-top: 20px;\n        display: none;\n        /* left: -150% */\n    }\n\n    .spend-block-wrapper.b {\n        min-height: 190px\n    }\n\n    .spend-sticky-wrapper {\n        height: 50vh\n    }\n\n    .spend-text-container {\n        padding-top: 14px;\n        padding-left: 14px;\n        padding-right: 14px\n    }\n\n    .sticky-indicator-text-wrapper {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .spend-image-wrapper.first {\n        padding: 20px 16px\n    }\n\n    .spend-images-grid {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .heading-252 {\n        padding-left: 11px;\n        padding-right: 11px;\n        line-height: 1.1\n    }\n\n    .heading-252.new {\n        text-align: center;\n        font-size: 19px\n    }\n\n    .reviews-main-wrapper {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .review-slide-nav {\n        display: none\n    }\n\n    .review-slide-text-wrapper {\n        grid-column-gap: 24px;\n        grid-row-gap: 24px;\n        padding: 16px\n    }\n\n    .reviewer-block {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px;\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .reviewer-info-block {\n        grid-column-gap: 2px;\n        grid-row-gap: 2px\n    }\n\n    .review-company-logo {\n        height: 30px\n    }\n\n    .review-company-logo._32px {\n        height: 24px\n    }\n\n    .review-company-logo._29px {\n        height: 20px\n    }\n\n    .review-company-logo._31px {\n        height: 26px\n    }\n\n    .review-company-logo._44px {\n        height: 28px\n    }\n\n    .slider-arrow.right {\n        bottom: -60px;\n        right: 0%\n    }\n\n    .slider-arrow.right.events {\n        left: auto;\n        right: 20px\n    }\n\n    .slider-arrow.left {\n        bottom: -60px;\n        left: 0%\n    }\n\n    .slider-arrow.left.events {\n        left: 20px;\n        right: auto\n    }\n\n    .slider-arrow.testimonials.left {\n        clear: none;\n        object-fit: fill;\n        justify-content: flex-start;\n        align-items: center;\n        margin-top: 20px;\n        margin-left: 0;\n        margin-right: 0;\n        display: flex;\n        position: absolute;\n        top: auto;\n        bottom: auto;\n        left: 25%;\n        right: 0%;\n        overflow: visible\n    }\n\n    .slider-arrow.testimonials.right {\n        margin-top: 20px;\n        position: absolute;\n        top: auto;\n        bottom: auto;\n        right: 25%\n    }\n\n    .review-slide-arrow-icon-embed {\n        flex: 1;\n        display: block;\n        position: relative\n    }\n\n    .home-hero-heading-contain {\n        flex: 0 auto;\n        order: -1;\n        padding-right: 0\n    }\n\n    .logos-white-gradient {\n        width: 20px\n    }\n\n    .navigation-menu-button {\n        padding: 14px\n    }\n\n    .hero-wrapper-contain {\n        margin-top: 50px;\n        /* padding-top: 37px */\n    }\n\n    .home-hero-images-container {\n        max-width: 400px\n    }\n\n    .hero-bubbles-block-wrapper {\n        max-width: 120px;\n        left: 12%\n    }\n\n    .hero-bubbles-block {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px\n    }\n\n    .hero-bubble-image {\n        width: 100%;\n        max-width: 40px;\n        height: auto\n    }\n\n    .dropdown-resources-column {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        padding-top: 10px\n    }\n\n    .resource-dropdown-wrapper {\n        flex-direction: column;\n        align-items: flex-start\n    }\n\n    .resource-dropdown-image-contain,\n    .resource-dropdown-info-block {\n        width: 100%\n    }\n\n    .integrations-lottie {\n        min-width: 100%\n    }\n\n    .navigation-inner-wrapper.white.new {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .tribe-tab-lottie-shadow {\n        height: 96%\n    }\n\n    .hero-platform-wrapper {\n        width: 100%;\n        padding-left: 12px;\n        padding-right: 12px\n    }\n\n    .hero-platform-heading-wrapper.display-flex.include-bg {\n        background-image: none;\n        background-position: 0 0;\n        background-repeat: repeat;\n        background-size: auto\n    }\n\n    .hero-platform-heading-wrapper.integra {\n        padding-left: 33px;\n        padding-right: 33px\n    }\n\n    .hero-platform-subheading-text {\n        padding: 16px 30px;\n        font-size: 19px;\n        margin-top: -25px;\n        margin-bottom: 10px\n    }\n\n    .hero-platform-subheading-text-case {\n        flex-flow: row;\n        justify-content: flex-start;\n        align-items: center;\n        font-family: Satoshi, sans-serif;\n        font-size: 20px;\n        font-weight: 500;\n        display: block;\n        padding: 16px 30px;\n        margin-top: 15px;\n        margin-bottom: 10px\n    }\n\n    .hero-platform-cta-wrapper.integra {\n        justify-content: center;\n        align-items: flex-start\n    }\n\n    .hero-platform-image {\n        margin-top: 24px\n    }\n\n    .hero-spotlight-image {\n        width: 100%\n    }\n\n    .blogs-hero-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px\n    }\n\n    .blogs-hero-wrapper.cms {\n        padding-top: 120px\n    }\n\n    .form-email-text-field {\n        background-size: 24px;\n        padding-left: 46px;\n        font-size: 16px\n    }\n\n    .blog-tabs-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .ctas-form-wrapper {\n        padding: 24px 16px\n    }\n\n    .form-fields-contain {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .white-form-field {\n        font-size: 16px\n    }\n\n    .ctas-form {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .form-fields-grid {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px;\n        grid-template-columns: 1fr\n    }\n\n    .form-select-field {\n        font-size: 16px\n    }\n\n    .features-section {\n        padding-bottom: 80px\n    }\n\n    .blog-category-text-contain {\n        grid-column-gap: 8px;\n        grid-row-gap: 8px\n    }\n\n    .blog-cms-info-wrapper {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .block-rich-text h1 {\n        font-size: 42px\n    }\n\n    .block-rich-text h2 {\n        font-size: 36px\n    }\n\n    .block-rich-text h3 {\n        font-size: 32px\n    }\n\n    .block-rich-text h4 {\n        font-size: 28px\n    }\n\n    .block-rich-text h5 {\n        font-size: 24px\n    }\n\n    .block-rich-text h6 {\n        font-size: 20px\n    }\n\n    .block-rich-text ul,\n    .block-rich-text ol {\n        margin-bottom: 24px\n    }\n\n    .block-rich-text li {\n        margin-bottom: 2px\n    }\n\n    .block-rich-text blockquote {\n        background-position: 20px 20px;\n        background-size: 30px;\n        padding: 68px 20px 20px;\n        font-size: 20px\n    }\n\n    .feature-wrap {\n        flex-direction: row;\n        justify-content: center;\n        align-items: center\n    }\n\n    .feature-image-wrapper.right.pink-bg {\n        order: -1;\n        width: 100%;\n        padding-right: 16px\n    }\n\n    .feature-image-wrapper.right.green-bg {\n        text-align: center;\n        order: -1;\n        width: 100%\n    }\n\n    .feature-image-wrapper.right.yellow-bg {\n        text-align: center;\n        flex: 1\n    }\n\n    .feature-image-wrapper.right.green-bg-copy {\n        text-align: center;\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n        order: -1;\n        width: 100%\n    }\n\n    .feature-image-wrapper.left.green-bg {\n        text-align: center;\n        width: 100%;\n        padding-left: 16px\n    }\n\n    .feature-image-wrapper.left.yellow-bg {\n        text-align: center;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        padding-bottom: 16px;\n        padding-left: 16px\n    }\n\n    .feature-image-wrapper.left.pink-bg {\n        text-align: center;\n        width: 100%\n    }\n\n    .feature-content-wrap {\n        width: 100%\n    }\n\n    .feature-content-header {\n        text-align: left\n    }\n\n    .feature-content-icon-wrapper {\n        text-align: left;\n        align-items: center;\n        display: block\n    }\n\n    .hero-design-element.right,\n    .hero-design-element.left {\n        display: none\n    }\n\n    .subscribe-form-main-wrapper {\n        padding: 24px 16px\n    }\n\n    .fs-cc-prefs3_button.fs-cc-button-alt {\n        margin-bottom: .25rem;\n        margin-right: 0\n    }\n\n    .fs-cc-prefs3_label {\n        font-size: .75rem\n    }\n\n    .fs-cc-prefs3_icon {\n        width: 1.5rem;\n        height: 1.5rem\n    }\n\n    .fs-cc-banner3_button {\n        text-align: center\n    }\n\n    .fs-cc-banner3_button.fs-cc-button-alt {\n        margin-bottom: .5rem;\n        margin-right: 0\n    }\n\n    .fs-cc-prefs3_title {\n        font-size: 1.125rem\n    }\n\n    .fs-cc-banner3_block {\n        text-align: center;\n        margin-right: 0\n    }\n\n    .fs-cc-prefs3_line {\n        min-width: .75rem;\n        margin-left: .75rem;\n        margin-right: .75rem;\n        display: none\n    }\n\n    .fs-cc-banner3_buttons-wrapper {\n        flex-direction: column;\n        width: 100%;\n        display: flex\n    }\n\n    .fs-cc-prefs3_form-wrapper {\n        width: 100%\n    }\n\n    .fs-cc-prefs3_buttons-block {\n        flex-direction: column;\n        display: flex\n    }\n\n    .fs-cc-prefs3_option {\n        padding-top: .5rem;\n        padding-bottom: .5rem\n    }\n\n    .transparent-arrow-button-white {\n        padding: 18px 20px;\n        font-size: 17px\n    }\n\n    .resources-hero-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px\n    }\n\n    .resource-tabs-wrapper {\n        max-width: 420px;\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .resource-tab-header {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        flex-flow: wrap;\n        align-items: center\n    }\n\n    .resource-collection-list {\n        grid-template-columns: 1fr\n    }\n\n    .resource-post-image-wrapper {\n        height: 200px\n    }\n\n    .div-block-733 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-735,\n    .div-block-736 {\n        width: 100%\n    }\n\n    .div-block-737 {\n        padding-top: 120px\n    }\n\n    .div-block-741 {\n        grid-template-columns: 1fr\n    }\n\n    .demo-form-wrapper {\n        margin-top: 24px;\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .book-demo-form-graphic-1,\n    .image-222 {\n        display: none\n    }\n\n    .flex-split {\n        flex-wrap: wrap;\n        justify-content: center;\n        padding-top: 64px;\n        padding-bottom: 64px\n    }\n\n    .optimize-hero-content-container {\n        width: 100%;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .optimize-hero-logo {\n        height: 80px\n    }\n\n    .div-block-744 {\n        justify-content: center\n    }\n\n    .blog-tag-radio-buttons-contain {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .resource-tab-form-separator {\n        max-width: 250px\n    }\n\n    .section-heading.text-center {\n        font-size: 32px\n    }\n\n    .procurement-team-cards-grid {\n        grid-template-columns: 1fr;\n        margin-top: 80px\n    }\n\n    .procurement-team-member-card {\n        margin-top: 21px\n    }\n\n    .procurement-team-member-image {\n        height: 300px\n    }\n\n    .div-block-749 {\n        width: 100%\n    }\n\n    .integrations-tabs-wrap {\n        width: 100%;\n        padding-left: 12px;\n        padding-right: 12px\n    }\n\n    .integrations-tabs-body {\n        flex-wrap: wrap\n    }\n\n    .integrations-tabs-menu {\n        width: 100%\n    }\n\n    .tabs-content-3 {\n        width: 100%;\n        margin-top: 24px;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .div-block-750 {\n        padding-left: 0;\n        padding-right: 0;\n        display: block\n    }\n\n    .div-block-751 {\n        grid-template-columns: auto;\n        margin-bottom: 32px\n    }\n\n    .saas-hero-text-wrapper {\n        margin-top: 65px\n    }\n\n    .saas-hero-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px\n    }\n\n    .flex-container._140px-bottom-margin {\n        grid-column-gap: 100px;\n        grid-row-gap: 100px;\n        padding-bottom: 100px\n    }\n\n    .flex-container._115px-bottom-margin {\n        grid-column-gap: 100px;\n        grid-row-gap: 100px;\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .flex-block-wrapper {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px\n    }\n\n    .flex-block-wrapper.lottie {\n        padding-top: 80px\n    }\n\n    .flex-block-wrapper.vertical {\n        grid-column-gap: 40px;\n        grid-row-gap: 40px;\n        padding-top: 60px\n    }\n\n    .flex-text-block {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .flex-image-block,\n    .flex-image-block.cloud-1 {\n        padding-top: 30px;\n        padding-bottom: 30px\n    }\n\n    .solution-callout-text-wrapper.cloud,\n    .solution-callout-text-wrapper.saas {\n        grid-column-gap: 20px;\n        grid-row-gap: 20px;\n        padding-bottom: 30px\n    }\n\n    .solution-callout-images-contain.cloud,\n    .solution-callout-images-contain.saas,\n    .solution-callout-image-row {\n        grid-column-gap: 12px;\n        grid-row-gap: 12px\n    }\n\n    .solution-callout-image-row.cloud-second {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .setup-card-text-contain {\n        padding: 20px 16px\n    }\n\n    .cloud-hero-wrapper {\n        grid-column-gap: 60px;\n        grid-row-gap: 60px;\n        padding-bottom: 120px\n    }\n\n    .heading-258 {\n        font-size: 32px;\n        line-height: 1.2em\n    }\n\n    .pricing-table-column-category-header {\n        width: 32%;\n        margin-left: 0\n    }\n\n    .pricing-plan-card.saas-growth {\n        margin-left: 0\n    }\n\n    .pricing-plan-card.saas-pro {\n        width: 100%;\n        margin-bottom: 24px;\n        margin-right: 0\n    }\n\n    .pricing-menu-tabs,\n    .pricing-duration-toggle {\n        margin-left: 0;\n        margin-right: 0\n    }\n\n    .div-block-440 {\n        display: none\n    }\n\n    .div-block-424 {\n        margin-top: 82px;\n        margin-left: 0;\n        margin-right: 0;\n        padding-left: 29px;\n        padding-right: 29px\n    }\n\n    .section-68 {\n        padding-top: 99px\n    }\n\n    .toggle-contain {\n        margin-left: 15px;\n        margin-right: 15px\n    }\n\n    .div-block-426 {\n        flex-wrap: wrap;\n        grid-template-columns: auto 1fr 1fr;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n        display: flex\n    }\n\n    .div-block-759 {\n        padding: 31px 15px\n    }\n\n    .heading-260,\n    .heading-261 {\n        font-size: 24px;\n        line-height: 1.2\n    }\n\n    .div-block-761 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-769 {\n        margin-left: 0;\n        margin-right: 0;\n        padding-left: 0%;\n        padding-right: 0%\n    }\n\n    .image-224,\n    .div-block-773 {\n        display: none\n    }\n\n    .badge-image.new {\n        flex: 0 auto;\n        max-width: 90px;\n        margin-right: 0\n    }\n\n    .points-checklist-grid {\n        grid-template-columns: 1fr;\n        margin-bottom: 30px\n    }\n\n    .points-image-wrapper {\n        border-radius: 6px\n    }\n\n    .image-226 {\n        height: 100px\n    }\n\n    .section-70 {\n        background-image: none;\n        background-repeat: repeat;\n        background-size: auto;\n        padding: 4% 8px 8%\n    }\n\n    .heading-263 {\n        font-size: 14px\n    }\n\n    .div-block-781 {\n        grid-template-columns: 1fr\n    }\n\n    .div-block-782 {\n        flex-wrap: wrap;\n        justify-content: center\n    }\n\n    .div-block-785 {\n        padding-right: 0\n    }\n\n    .heading-264 {\n        margin-top: 5px;\n        font-size: 40px;\n        line-height: .7\n    }\n\n    .material-icons.sysf-icon-left.sysf-icon-collapse {\n        margin-top: 4px\n    }\n\n    .sysf-collapse-title {\n        line-height: 1.5\n    }\n\n    .sysf-collapse-trigger {\n        align-items: flex-start\n    }\n\n    .sysf-collapse.sysf-borderless {\n        padding: 16px\n    }\n\n    .sysf-heading.sysf-l {\n        font-size: 16px;\n        font-weight: 700\n    }\n\n    .sysf-tagline {\n        padding-left: 28px;\n        padding-right: 28px;\n        font-size: 14px\n    }\n\n    .sysf-body-text.sysf-m.sysf-s-m-b-0 {\n        font-size: 14px\n    }\n\n    .brix---heading-h3-size {\n        margin-bottom: 10px;\n        font-size: 20px;\n        line-height: 30px\n    }\n\n    .brix---display-2 {\n        font-size: 38px;\n        line-height: 48px\n    }\n\n    .brix---heading-h2-size {\n        font-size: 24px;\n        line-height: 34px\n    }\n\n    .brix---container-default {\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .brix---section {\n        padding-top: 49px\n    }\n\n    .brix---link-icon-right {\n        width: 18px\n    }\n\n    .brix---text-200-bold {\n        font-size: 15px;\n        line-height: 16px\n    }\n\n    .brix---paragraph-default {\n        margin-top: 28px;\n        font-size: 17px;\n        line-height: 28px\n    }\n\n    .brix---mg-bottom-24px {\n        margin-bottom: 16px\n    }\n\n    .brix---heading-h3-size-2 {\n        margin-bottom: 10px;\n        font-size: 20px;\n        line-height: 30px\n    }\n\n    .brix---mg-bottom-8px {\n        margin-bottom: 6px\n    }\n\n    .brix---mg-bottom-48px {\n        margin-bottom: 32px\n    }\n\n    .brix---card-link-content-left-fw {\n        padding: 24px\n    }\n\n    .brix---grid-3-columns---1-col-mb {\n        grid-template-columns: 1fr\n    }\n\n    .bold-text-26 {\n        font-size: 19px;\n        line-height: .3\n    }\n\n    .column-80 {\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .button-new {\n        margin-top: 13px;\n        padding-top: 7px;\n        padding-bottom: 7px;\n        font-size: 14px\n    }\n\n    .button-48 {\n        padding-left: 12px;\n        padding-right: 12px;\n        font-size: 10px\n    }\n\n    .paragraph-151 {\n        margin-top: 15px;\n        font-size: 12px;\n        line-height: 1\n    }\n\n    .container-1288 {\n        padding-left: 5px;\n        padding-right: 5px\n    }\n\n    .bold-text-27,\n    .bold-text-28,\n    .bold-text-29 {\n        font-size: 16px\n    }\n\n    .image-230 {\n        text-align: center;\n        height: 240px\n    }\n\n    .new-product-heading-4 {\n        font-size: 32px\n    }\n\n    .image-231 {\n        text-align: center;\n        height: 320px\n    }\n\n    .image-232 {\n        height: 300px\n    }\n\n    .image-233 {\n        text-align: center\n    }\n\n    .hero-platform-wrapper-solutions {\n        width: 100%;\n        padding-top: 121px;\n        padding-left: 12px;\n        padding-right: 12px\n    }\n\n    .heading-64px-copy {\n        font-size: 42px\n    }\n\n    .heading-64px-copy.hero-home-heading {\n        font-size: 36px\n    }\n\n    .heading-64px-copy.hero-home-heading.top {\n        max-width: 400px\n    }\n\n    .heading-64px-copy.hero-home-heading.zendesk {\n        width: 152.828px\n    }\n\n    .heading-64px-copy.text-align-center {\n        margin-bottom: 16px;\n        font-size: 24px\n    }\n\n    .heading-64px-copy.text-align-center.include-bg-element {\n        margin-top: 0\n    }\n\n    .heading-64px-copy.blogs-hero-heading,\n    .heading-64px-copy.resource-hero-heading {\n        font-size: 38px\n    }\n\n    .heading-64px-new {\n        font-size: 42px\n    }\n\n    .heading-64px-new.hero-home-heading {\n        font-size: 36px\n    }\n\n    .heading-64px-new.hero-home-heading.top {\n        max-width: 400px\n    }\n\n    .heading-64px-new.hero-home-heading.zendesk {\n        width: 152.828px\n    }\n\n    .heading-64px-new.text-align-center {\n        margin-bottom: 16px;\n        padding-left: 13px;\n        padding-right: 13px;\n        font-size: 25px\n    }\n\n    .heading-64px-new.text-align-center.include-bg-element {\n        margin-top: 0\n    }\n\n    .heading-64px-new.blogs-hero-heading,\n    .heading-64px-new.resource-hero-heading {\n        font-size: 38px\n    }\n\n    .image-238 {\n        object-fit: contain;\n        flex: 1;\n        align-self: center\n    }\n\n    .feature-image-wrapper-copy.right.green-bg {\n        text-align: center;\n        flex-flow: column;\n        flex: 1;\n        order: -1;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        padding-bottom: 0\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        text-align: center;\n        flex-direction: row;\n        justify-content: center;\n        align-items: flex-end;\n        width: 100%;\n        height: 350px;\n        padding-bottom: 0;\n        padding-left: 0\n    }\n\n    .image-240 {\n        align-self: center\n    }\n\n    .paragraph-18px-copy.spend-block-paragraph,\n    .paragraph-18px-copy.reviewer-position {\n        font-size: 14px\n    }\n\n    .paragraph-18px-copy.saas-hero-paragraph,\n    .paragraph-18px-copy.cloud-hero-paragraph {\n        margin-bottom: 10px\n    }\n\n    .heading-48px-copy {\n        font-size: 32px\n    }\n\n    .heading-48px-copy.stack-heading {\n        margin-bottom: 30px\n    }\n\n    .paragraph-18px-copy.hero-home-paragraph {\n        margin-bottom: 10px\n    }\n\n    .paragraph-18px-copy.integrations-paragraph {\n        margin-bottom: 30px\n    }\n\n    .paragraph-18px-copy.spend-block-paragraph,\n    .paragraph-18px-copy.reviewer-position {\n        font-size: 14px\n    }\n\n    .paragraph-18px-copy.saas-hero-paragraph,\n    .paragraph-18px-copy.cloud-hero-paragraph {\n        margin-bottom: 10px\n    }\n\n    .heading-28px-copy {\n        font-size: 20px\n    }\n\n    .div-block-793 {\n        margin-bottom: 11px\n    }\n\n    .heading-28px-copy-copy {\n        font-size: 20px\n    }\n\n    .spend-analyse-footer {\n        padding-bottom: 80px\n    }\n\n    .feature-image-wrapper-copy-copy.right.pink-bg {\n        order: -1;\n        width: 100%;\n        padding-right: 16px\n    }\n\n    .feature-image-wrapper-copy-copy.right.green-bg {\n        text-align: center;\n        flex-flow: column;\n        flex: 1;\n        order: -1;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        padding-bottom: 0\n    }\n\n    .feature-image-wrapper-copy-copy.right.yellow-bg {\n        text-align: center;\n        flex: 1\n    }\n\n    .feature-image-wrapper-copy-copy.right.green-bg-copy {\n        text-align: center;\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n        order: -1;\n        width: 100%\n    }\n\n    .feature-image-wrapper-copy-copy.left.green-bg {\n        text-align: center;\n        width: 100%;\n        padding-left: 16px\n    }\n\n    .feature-image-wrapper-copy-copy.left.yellow-bg {\n        text-align: center;\n        flex-direction: row;\n        justify-content: center;\n        align-items: flex-end;\n        width: 100%;\n        height: 350px;\n        padding-bottom: 0;\n        padding-left: 0\n    }\n\n    .feature-image-wrapper-copy-copy.left.pink-bg {\n        text-align: center;\n        width: 100%\n    }\n\n    .feature-content-wrap-copy {\n        width: 100%\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        text-align: center;\n        width: 100%;\n        padding-bottom: 16px;\n        padding-left: 16px\n    }\n\n    .stats-wrapper-copy,\n    .stats-wrapper-new,\n    .stats-wrapper-copy {\n        margin-top: -5px;\n        padding-top: 39px;\n        padding-bottom: 50px\n    }\n\n    .feature-image-wrapper-copy.right.pink-bg {\n        order: -1;\n        width: 100%;\n        padding-right: 16px\n    }\n\n    .feature-image-wrapper-copy.right.green-bg {\n        text-align: center;\n        order: -1;\n        width: 100%\n    }\n\n    .feature-image-wrapper-copy.right.yellow-bg {\n        text-align: center;\n        flex: 1\n    }\n\n    .feature-image-wrapper-copy.right.green-bg-copy {\n        text-align: center;\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n        order: -1;\n        width: 100%\n    }\n\n    .feature-image-wrapper-copy.left.green-bg {\n        text-align: center;\n        width: 100%;\n        padding-left: 16px\n    }\n\n    .feature-image-wrapper-copy.left.yellow-bg {\n        text-align: center;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        padding-bottom: 16px;\n        padding-left: 16px\n    }\n\n    .feature-image-wrapper-copy.left.pink-bg {\n        text-align: center;\n        width: 100%\n    }\n\n    .hero-button-cta-copy {\n        padding-left: 18px;\n        padding-right: 18px\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.pink-bg {\n        order: -1;\n        width: 100%;\n        padding-right: 16px\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.green-bg {\n        text-align: center;\n        flex-flow: column;\n        flex: 1;\n        order: -1;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        padding-bottom: 0\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.yellow-bg {\n        text-align: center;\n        flex: 1\n    }\n\n    .feature-image-wrapper-copy-copy-copy.right.green-bg-copy {\n        text-align: center;\n        background-image: url(https://assets-global.website-files.com/61e8ec6584cc457e5ccb9501/653b4a4678ea8a087f270378_Rectangle%2034624684%20\\(1\\).svg);\n        order: -1;\n        width: 100%\n    }\n\n    .feature-image-wrapper-copy-copy-copy.left.green-bg {\n        text-align: center;\n        width: 100%;\n        padding-left: 16px\n    }\n\n    .feature-image-wrapper-copy-copy-copy.left.yellow-bg {\n        text-align: center;\n        flex-direction: row;\n        justify-content: center;\n        align-items: flex-end;\n        width: 100%;\n        height: 350px;\n        padding-bottom: 0;\n        padding-left: 0\n    }\n\n    .feature-image-wrapper-copy-copy-copy.left.pink-bg {\n        text-align: center;\n        width: 100%\n    }\n\n    .image-212-copy,\n    .image-212-copy-copy {\n        width: auto;\n        height: auto;\n        min-height: auto;\n        max-height: 36px\n    }\n\n    .hero-heading-copy {\n        margin-top: 47px;\n        font-size: 36px\n    }\n\n    .home-value-heading-copy {\n        margin-top: 35px;\n        font-size: 32px;\n        line-height: 38px\n    }\n\n    .div-block-20-copy {\n        width: 100%;\n        padding: 32px 8px\n    }\n\n    .div-block-21-copy {\n        padding: 24px 16px\n    }\n\n    .div-block-21-copy.registration-form-block {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .features-section-copy {\n        padding-bottom: 80px\n    }\n\n    .image-231-copy {\n        text-align: center;\n        height: 320px\n    }\n\n    .fast-track-approval-hero-section-copy {\n        margin-bottom: 140px\n    }\n\n    .wrapper-1280px-copy {\n        flex-direction: column;\n        justify-content: space-between;\n        width: 90%\n    }\n\n    .wrapper-1280px-copy.solution-wrapper,\n    .wrapper-1280px-copy.split-wrapper {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px-copy.finance-wrapper {\n        padding-top: 80px\n    }\n\n    .wrapper-1280px-copy.case-study-hero-flex {\n        padding-top: 60px;\n        padding-bottom: 50px\n    }\n\n    .wrapper-1280px-copy.case-study-flex {\n        padding-top: 50px;\n        padding-bottom: 50px\n    }\n\n    .wrapper-1280px-copy.fast-track-approval-hero-flex {\n        padding-top: 60px\n    }\n\n    .wrapper-1280px-copy.document-one-place-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px-copy.assisted-tools-flex {\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px-copy.assisted-purchasing-flex {\n        margin-top: 0;\n        padding-top: 60px\n    }\n\n    .wrapper-1280px-copy.actionable-insight-flex {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .wrapper-1280px-copy.custo {\n        padding-top: 40px;\n        padding-bottom: 40px\n    }\n\n    .wrapper-1280px-copy.points-container {\n        padding-top: 80px;\n        padding-bottom: 80px\n    }\n\n    .container-1290 {\n        max-width: none\n    }\n\n    .nav-menu-three {\n        flex-direction: column\n    }\n\n    .hello-bar-link {\n        font-size: 12px\n    }\n\n    .new-hello-bar {\n        padding-left: 38px;\n        padding-right: 38px;\n        overflow: visible\n    }\n\n    .heading-90px-copy {\n        font-size: 48px\n    }\n\n    .heading-24px-copy.stats-text {\n        margin-bottom: 0\n    }\n\n    .heading-24px-copy.review-text {\n        font-size: 17px\n    }\n\n    .heading-24px-copy.setup-card-text {\n        font-size: 18px\n    }\n\n    .heading-24px-copy.stats-text-copy {\n        margin-bottom: 0\n    }\n\n    .pitch-section-copy {\n        padding-top: 100px;\n        padding-bottom: 100px\n    }\n\n    .home-hero-heading-copy {\n        font-size: 32px;\n        line-height: 1.4em\n    }\n\n    .image-246 {\n        height: 20px\n    }\n\n    .stats-grid-copy {\n        grid-column-gap: 16px;\n        grid-row-gap: 16px\n    }\n\n    .home-split-section-copy {\n        padding-top: 0;\n        padding-bottom: 60px\n    }\n\n    .home-split-section-copy.light-grey-bg {\n        padding: 60px 8px\n    }\n\n    .wrapper-1300px-copy-copy {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .wrapper-1300px-copy-copy.adjust-padding {\n        padding-top: 16px\n    }\n\n    .image-247 {\n        height: 100%\n    }\n\n    .collection-list-8 {\n        padding-left: 9px;\n        padding-right: 9px\n    }\n\n    .blog-hero-heading-copy {\n        max-width: none;\n        padding-left: 14px;\n        padding-right: 14px;\n        font-size: 26px;\n        line-height: 38px\n    }\n\n    .blog-collection-item-copy {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .blog-collection-item-copy.margin.custo {\n        border-width: 6px;\n        margin-right: 0;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .blog-collection-item-copy.limit-width.custo {\n        border-width: 6px;\n        margin-top: 16px;\n        margin-left: 0;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .blog-collection-item-copy-copy.margin.custo {\n        border-width: 6px;\n        margin-right: 0;\n        padding: 20px\n    }\n\n    .blog-collection-item-copy-copy {\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .blog-collection-item-copy-copy.margin.custo {\n        border-width: 6px;\n        margin-right: 0;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .blog-collection-item-copy-copy.limit-width.custo {\n        border-width: 6px;\n        margin-top: 16px;\n        margin-left: 0;\n        padding-top: 20px;\n        padding-bottom: 20px\n    }\n\n    .text-block-330 {\n        margin-top: 46px;\n        margin-bottom: 35px;\n        padding-left: 10px;\n        padding-right: 10px;\n        font-size: 24px;\n        line-height: 1.3\n    }\n\n    .cms-blog-block-section-copy {\n        padding-bottom: 140px\n    }\n\n    .cms-blog-block-section-copy.templates-block {\n        margin-top: -301px\n    }\n\n    .about-hero-wrapper-copy {\n        background-position: 0%, 100%\n    }\n\n    .wrapper-1300px-copy {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .wrapper-1300px-copy.adjust-padding {\n        padding-top: 16px\n    }\n\n    .new-about-1300px-header {\n        width: 100%;\n        padding-left: 8px;\n        padding-right: 8px\n    }\n\n    .new-about-1300px-header.adjust-padding {\n        padding-top: 16px\n    }\n\n    .new-about-hero-wrapper {\n        background-position: 0%, 100%\n    }\n\n    .text-span-294 {\n        padding-left: 9px;\n        padding-right: 9px;\n        font-size: 18px;\n        line-height: 1.1\n    }\n\n    .xs-text {\n        font-size: 32px\n    }\n\n    .about-heading-x {\n        padding-left: 10px;\n        padding-right: 10px;\n        font-size: 32px;\n        line-height: 1.2\n    }\n\n    .stats-wrapper-copy-copy,\n    .stats-xx {\n        margin-top: 15px;\n        padding-top: 39px;\n        padding-bottom: 80px\n    }\n\n    .text-block-332 {\n        font-size: 32px\n    }\n\n    .text-block-332.intra,\n    .text-span-295 {\n        text-align: center\n    }\n\n    .tribe-tab-image-contain-copy {\n        padding-top: 30px;\n        padding-bottom: 30px\n    }\n\n    .about-x-cards,\n    .about-x-cards.new {\n        width: 95%\n    }\n\n    .text-block-344 {\n        font-size: 16px;\n        line-height: 1.2\n    }\n\n    .pricing-block {\n        width: 100%;\n        margin-right: 0;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .div-block-814 {\n        margin-bottom: 20px\n    }\n\n    .text-block-345,\n    .text-block-346 {\n        font-size: 19px;\n        line-height: 1.2\n    }\n\n    .pricing-cards {\n        margin-right: 0\n    }\n\n    .pricing-card {\n        width: 100%\n    }\n\n    .container-1291 {\n        margin-left: 5px;\n        margin-right: 5px\n    }\n\n    .faq-item-x.demo {\n        padding-top: 44px;\n        padding-bottom: 44px\n    }\n\n    .heading-265 {\n        font-size: 16px;\n        line-height: 1.3\n    }\n\n    .faq-answer {\n        padding-top: 2px\n    }\n\n    .paragraph-153 {\n        text-align: left;\n        font-size: 14px\n    }\n\n    .section-72 {\n        background-color: rgba(250, 242, 235, 0);\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .section-72.what-is-in {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .section-72.ebooks,\n    .section-72.events {\n        background-color: var(--soft-pink)\n    }\n\n    .section-72.testimonial {\n        padding-top: 70px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .section-72.expectation {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .section-72.optimize {\n        padding-top: 93px\n    }\n\n    .section-72.block3 {\n        padding-top: 0\n    }\n\n    .div-block-823 {\n        display: none\n    }\n\n    .image-249 {\n        height: 300px\n    }\n\n    .div-block-824 {\n        border-bottom-right-radius: 35px;\n        border-bottom-left-radius: 35px;\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 100px;\n        padding-left: 35px;\n        padding-right: 35px\n    }\n\n    .text-block-357,\n    .text-block-357.events {\n        text-align: center;\n        font-size: 32px\n    }\n\n    .text-block-358 {\n        text-align: justify;\n        margin-bottom: 23px;\n        font-size: 14px\n    }\n\n    .div-block-827 {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .text-block-359,\n    .text-block-359.events {\n        text-align: center;\n        font-size: 32px\n    }\n\n    .div-block-829.why {\n        padding-left: 14px;\n        padding-right: 14px\n    }\n\n    .div-block-830.why {\n        width: 100%\n    }\n\n    .text-block-360 {\n        font-size: 28px\n    }\n\n    .text-block-360.why {\n        padding-left: 11px;\n        padding-right: 11px\n    }\n\n    .text-block-361,\n    .text-block-363 {\n        font-size: 28px\n    }\n\n    .div-block-838 {\n        align-self: center\n    }\n\n    .div-block-839 {\n        padding-left: 13px;\n        padding-right: 13px\n    }\n\n    .text-block-370,\n    .text-block-371 {\n        text-align: center;\n        font-size: 16px\n    }\n\n    .div-block-841 {\n        justify-content: center;\n        align-items: center\n    }\n\n    .div-block-843 {\n        margin-bottom: 65px\n    }\n\n    .partners {\n        border-right-width: 0;\n        align-self: center;\n        padding-left: 0\n    }\n\n    .partners.partner-logos {\n        border-left: 0px solid var(--light-slate-grey);\n        border-right-width: 0;\n        align-self: center\n    }\n\n    .div-block-845 {\n        grid-column-gap: 9px;\n        grid-row-gap: 9px;\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center\n    }\n\n    .image-253 {\n        height: 20px\n    }\n\n    .text-block-373 {\n        text-align: center;\n        font-size: 16px\n    }\n\n    .image-256 {\n        line-height: 1.2\n    }\n\n    .testimonialx {\n        padding-top: 30px;\n        padding-left: 30px\n    }\n\n    .testimonial-new-logo {\n        height: 40px\n    }\n\n    .text-block-375 {\n        margin-bottom: 0\n    }\n\n    .text-block-376 {\n        text-align: center;\n        margin-bottom: 98px;\n        line-height: 1.2\n    }\n\n    .text-block-377 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center;\n        display: flex\n    }\n\n    .div-block-850.partner {\n        margin-top: 47px;\n        padding-left: 20px;\n        padding-right: 20px\n    }\n\n    .event-exectations-tab {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .text-block-379 {\n        justify-content: center;\n        align-items: flex-start;\n        padding-left: 40%\n    }\n\n    .text-block-380 {\n        padding-left: 30px;\n        padding-right: 30px;\n        font-size: 32px;\n        line-height: 1.2\n    }\n\n    .rich-text-block-30 {\n        text-align: left;\n        flex: 0 auto;\n        order: 0;\n        align-self: auto;\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n        padding-left: 21px;\n        padding-right: 21px\n    }\n\n    .div-block-853 {\n        padding-left: 10px;\n        padding-right: 10px\n    }\n\n    .div-block-857 {\n        height: 400px\n    }\n\n    .sysf-button.sysf-medium {\n        align-self: stretch\n    }\n\n    .text-block-382 {\n        font-size: 14px\n    }\n\n    .div-block-858 {\n        grid-template-columns: 1fr 1fr\n    }\n\n    .div-block-859 {\n        flex-flow: column;\n        justify-content: flex-start;\n        align-items: center\n    }\n\n    .text-block-385 {\n        text-align: center\n    }\n\n    .your-grid-container {\n        flex-flow: column;\n        grid-template-columns: 1fr;\n        align-items: center;\n        justify-items: center\n    }\n\n    .feature-block-item.yellow1 {\n        background-repeat: repeat-y;\n        padding: 10% 5%\n    }\n\n    .feature-block-item.yellow2 {\n        grid-column-gap: 25px;\n        grid-row-gap: 25px\n    }\n\n    .feature-block-content-logo {\n        height: 60px\n    }\n\n    .feature-text-header {\n        font-size: 22px\n    }\n\n    .text-block-386 {\n        font-size: 14px\n    }\n\n    .div-block-861.slider {\n        margin-bottom: 0;\n        overflow: hidden\n    }\n\n    .div-block-862 {\n        width: auto;\n        max-width: none;\n        height: auto;\n        /*height: 300px;*/\n        /*padding-top: 20px*/\n    }\n\n    .div-block-863 {\n        width: 100%;\n        margin-bottom: 20px;\n        padding: 40px 30px;\n        overflow: hidden\n    }\n\n    .tabs-menu-6 {\n        flex-flow: column;\n        grid-template-columns: 1fr;\n        justify-content: space-between;\n        align-items: center\n    }\n\n    .image-262 {\n        object-fit: fill;\n        width: 260px;\n        overflow: visible\n    }\n\n    .text-block-388 {\n        text-align: center\n    }\n\n    .container-1292 {\n        max-width: none\n    }\n\n    .clients-quote {\n        font-size: 20px;\n        line-height: 28px\n    }\n\n    .clients-info-image {\n        margin-right: 16px\n    }\n\n    .clients-grid {\n        grid-column-gap: 20px;\n        grid-row-gap: 40px;\n        grid-template-columns: 1fr 1fr\n    }\n\n    .slide-23 {\n        object-fit: contain;\n        margin-right: 5px\n    }\n\n    .slider-22 {\n        padding-left: 10px;\n        padding-right: 10px;\n        position: relative\n    }\n\n    .tabs-menu-7 {\n        flex-flow: row;\n        justify-content: flex-start;\n        align-items: flex-start;\n        height: 380px\n    }\n\n    .tabs-content-5 {\n        height: 300px\n    }\n\n    .tab-link-tab-1-3 {\n        height: auto;\n        padding-left: 10px\n    }\n\n    .tab-link-tab-1-3.w--current {\n        justify-content: flex-start;\n        align-items: center;\n        height: auto;\n        padding-left: 10px\n    }\n\n    .tab-link-tab-2-3 {\n        height: auto;\n        padding-left: 0;\n        padding-right: 0\n    }\n\n    .tab-link-tab-3-2 {\n        height: auto\n    }\n\n    .text-block-389 {\n        font-size: 14px\n    }\n\n    .div-block-868 {\n        height: 300px\n    }\n\n    .text-block-391 {\n        text-align: center;\n        font-size: 40px\n    }\n\n    .div-block-870 {\n        height: 200px;\n        margin-top: 20px;\n        margin-bottom: 20px\n    }\n\n    .div-block-872 {\n        width: 100%\n    }\n\n    .div-block-872.new {\n        width: 90%;\n        padding-top: 8px;\n        padding-bottom: 8px\n    }\n\n    .div-block-875 {\n        grid-column-gap: 9px;\n        grid-row-gap: 9px;\n        flex-flow: column\n    }\n\n    .div-block-878 {\n        margin-top: 25px;\n        margin-bottom: 18px\n    }\n\n    .text-block-397 {\n        font-size: 16px\n    }\n\n    .text-block-398 {\n        width: 90%;\n        font-size: 24px\n    }\n\n    .div-block-884 {\n        padding-left: 35px;\n        padding-right: 35px\n    }\n\n    .text-block-407 {\n        margin-bottom: 5px;\n        font-size: 40px\n    }\n\n    .text-block-408 {\n        font-size: 16px\n    }\n\n    .image-270 {\n        height: 45px\n    }\n\n    .image-270.fold-2 {\n        height: 40px\n    }\n\n    .div-block-891 {\n        padding-left: 11px;\n        padding-right: 11px\n    }\n\n    .div-block-892.fold3.fold4 {\n        border-bottom-right-radius: 20px;\n        border-bottom-left-radius: 20px\n    }\n\n    .button-53 {\n        text-align: center;\n        padding-left: 30px;\n        padding-right: 34px;\n        font-size: 16px\n    }\n\n    .div-block-896 {\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .text-block-412 {\n        padding-left: 0;\n        font-size: 30px\n    }\n\n    .div-block-897 {\n        width: 100%;\n        margin-top: 0;\n        padding-top: 54px\n    }\n\n    .div-block-902 {\n        grid-column-gap: 29px;\n        grid-row-gap: 29px;\n        padding-right: 0\n    }\n\n    .text-block-415 {\n        font-size: 32px;\n        line-height: 1.2\n    }\n\n    .text-block-417 {\n        text-align: center;\n        font-size: 16px\n    }\n\n    .text-block-418 {\n        font-size: 16px\n    }\n\n    .div-block-905 {\n        justify-content: flex-start;\n        align-items: flex-start\n    }\n\n    .container-1293 {\n        max-width: none\n    }\n\n    .nav-menu-two {\n        flex-direction: column\n    }\n\n    .menu-button-12,\n    .menu-button-12:active {\n        padding-right: 0\n    }\n\n    .image-277 {\n        padding-left: 0\n    }\n\n    .text-span-376 {\n        font-size: 32px\n    }\n\n    .text-block-419 {\n        text-align: justify;\n        font-size: 18px\n    }\n\n    .text-block-422 {\n        width: 90%\n    }\n\n    .div-block-908 {\n        grid-column-gap: 30px;\n        grid-row-gap: 30px\n    }\n\n    .div-block-910 {\n        padding-left: 40px;\n        padding-right: 40px\n    }\n\n    .text-block-425 {\n        font-size: 16px\n    }\n\n    .text-block-426 {\n        font-size: 12px\n    }\n\n    .text-block-427 {\n        font-size: 16px\n    }\n\n    .text-block-430 {\n        font-size: 10px\n    }\n}\n\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc747-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc790-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc791-93cb7710 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc792-93cb7710 {\n    grid-area: span 1/span 2/span 1/span 2\n}\n\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc793-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc84d-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc858-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc86c-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc877-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc88b-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc896-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc8aa-93cb7710,\n#w-node-aabc552b-ce2d-0f4b-87e4-4703a07bc8b5-93cb7710,\n#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9cc97-cee9cc82,\n#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9cc9d-cee9cc82,\n#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccac-cee9cc82,\n#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccbb-cee9cc82 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: auto\n}\n\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b54-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b58-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b5c-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b60-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b64-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b68-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b6c-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b70-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b74-e3ba9b4c,\n#w-node-_24139d18-8e79-5ec2-9466-4056e3ba9b78-e3ba9b4c,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c0f-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c15-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c1b-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c21-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c27-ebcc7be3,\n#w-node-bb90c496-c575-1494-3005-6bcdf8e82a17-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c32-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c3a-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7c4b-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cb2-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cbb-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cc4-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7ccd-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cd6-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cdf-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7ceb-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cec-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7cee-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d2b-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d35-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d3a-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d43-ebcc7be3,\n#w-node-_71804d9f-56d6-3e28-5ac2-6231ebcc7d4e-ebcc7be3,\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f009-3251eff9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f010-3251eff9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f011-3251eff9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f012-3251eff9,\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f013-3251eff9,\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f014-3251eff9,\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f015-3251eff9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f016-3251eff9,\n#w-node-dbc2e5b9-0fb3-fa78-27f3-f94d3251f017-3251eff9,\n#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a9296e-f64fae89,\n#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a92977-f64fae89,\n#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a92986-f64fae89,\n#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a92995-f64fae89,\n#w-node-_6d4519ec-5cef-0417-fde8-18e1d1a929ac-f64fae89,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba50-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba56-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba5c-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba62-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba68-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba73-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba7b-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134eba8c-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebaf3-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebafc-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb05-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb0e-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb17-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb23-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb24-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb26-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb63-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb6d-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb72-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb7b-074bcbbe,\n#w-node-_623e8343-de28-bcf3-6173-0032134ebb86-074bcbbe,\n#w-node-_4d46cc23-8ec1-3981-be6a-a103125fbe80-93cb7738,\n#w-node-_89cd2751-9b34-2040-9f21-4a7cc8f42a90-93cb7738,\n#w-node-b6ea5126-82cc-9c4c-845a-b3ac63d6f8c8-93cb7738,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80ce-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80d4-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80da-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80e0-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80e6-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80f1-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d80f9-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d810a-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8173-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d817c-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8185-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d818e-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8197-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81a3-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81a4-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81a6-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81e3-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81ed-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81f2-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d81fb-eb80e708,\n#w-node-ea88cbe6-b6a7-a9bd-3099-28f1012d8206-eb80e708,\n#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7739,\n#w-node-ad2baa79-e05c-3254-6679-d28f7b6620b6-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ad2baa79-e05c-3254-6679-d28f7b6620bc-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e938e4-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e938ea-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-_807a9b0f-1427-d35d-746f-e6219c1b7a1e-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_807a9b0f-1427-d35d-746f-e6219c1b7a24-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e938f8-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93900-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93911-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93917-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e93925-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_8fa83183-ebfd-dce6-65f4-4a3850e9392b-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-_7a0adbe3-9234-ae81-b72f-8b8f1baf7065-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7a0adbe3-9234-ae81-b72f-8b8f1baf706b-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-ba8fc776-c335-adf3-3775-c9e333014c4f-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ba8fc776-c335-adf3-3775-c9e333014c55-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb53890ed-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb53890f3-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389107-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb538910d-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb538911e-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389124-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389138-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389140-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb538914e-50e938d3 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ec55cdd0-747b-0aca-7bb3-f1deb5389154-50e938d3 {\n    justify-self: auto\n}\n\n#w-node-d862036f-348e-95b1-d411-9d2c13184902-93cb773c,\n#w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c409-93cb773c,\n#w-node-_01b5676c-0c15-b261-4ad0-393603f95b9d-93cb773c {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_89e33cb6-1014-442c-9dc8-61847d5443c4-7d5443b9,\n#w-node-_89e33cb6-1014-442c-9dc8-61847d5443cf-7d5443b9,\n#w-node-_89e33cb6-1014-442c-9dc8-61847d5443da-7d5443b9,\n#w-node-_89e33cb6-1014-442c-9dc8-61847d5443e5-7d5443b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_715b4270-6d1c-2ced-4a71-388d64049471-93cb773e,\n#w-node-_3eb03c01-305f-629a-cfc8-eab54b8bd47b-93cb773e {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_2caa981a-1245-8dde-0467-aa5c2e271ab6-93cb773e,\n#w-node-_87009e58-eb0d-089a-8953-434470df64e4-93cb773e,\n#w-node-_2f307556-891f-bdaf-0872-21266377a3f2-93cb773e,\n#w-node-_4c92dfac-3403-9d50-d207-d6bc2b20a7b4-93cb773e,\n#w-node-_4c92dfac-3403-9d50-d207-d6bc2b20a7b5-93cb773e,\n#w-node-_4c92dfac-3403-9d50-d207-d6bc2b20a7b7-93cb773e,\n#w-node-b32ab332-5753-8f6b-532d-f38d1558a8ce-93cb773e,\n#w-node-b32ab332-5753-8f6b-532d-f38d1558a8cf-93cb773e,\n#w-node-b32ab332-5753-8f6b-532d-f38d1558a8d1-93cb773e,\n#w-node-d25799f6-7178-8313-ed07-6b3027a55c07-93cb773e,\n#w-node-d25799f6-7178-8313-ed07-6b3027a55c08-93cb773e,\n#w-node-d25799f6-7178-8313-ed07-6b3027a55c0a-93cb773e,\n#w-node-cc09c278-2d84-4b68-e023-f85d3deb23df-93cb773e,\n#w-node-cc09c278-2d84-4b68-e023-f85d3deb23e0-93cb773e,\n#w-node-cc09c278-2d84-4b68-e023-f85d3deb23e2-93cb773e,\n#w-node-a77735db-1cfb-6d8d-bb24-f08f06dab9f9-93cb773e,\n#w-node-a77735db-1cfb-6d8d-bb24-f08f06dab9fa-93cb773e,\n#w-node-a77735db-1cfb-6d8d-bb24-f08f06dab9fc-93cb773e,\n#w-node-_7011b672-cb26-acc2-a652-4e8490d3b62e-93cb773e,\n#w-node-_1d5d3793-a225-fd5d-bfdd-8c37bd765b9b-93cb773e,\n#w-node-_056e026c-8303-e237-7c96-bf7aaad99942-93cb773e,\n#w-node-_9c2831d2-277b-57c9-aab2-99f6da57f9d6-93cb773e,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7742,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7742,\n#w-node-_4741a5ad-ecb8-45fd-b97a-63442878d5a8-93cb7742,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7742,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7742,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7742,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7742,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7742,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7742,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7742,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7742,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7742,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7742,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7742,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7742,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7742,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7742,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7742,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7742,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7742,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7742 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7742 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7742 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7742 {\n    align-self: auto\n}\n\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ee1-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ee7-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668eed-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ef3-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ef9-2b668eb5,\n#w-node-_6fef27fb-c1a3-2d06-748d-88a0eb1b42fd-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f04-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f0c-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f1d-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f84-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f8d-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f96-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668f9f-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fa8-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fb1-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fbd-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fbe-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668fc0-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b668ffd-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b669007-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b66900c-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b669015-2b668eb5,\n#w-node-b5b5c87e-96d1-ed72-0d99-0c032b669020-2b668eb5,\n#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7767,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74754d-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74754f-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747553-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747555-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74755b-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d74755d-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747561-93cb7768,\n#w-node-cb9eac57-6c2e-1b49-a5ec-768f4d747563-93cb7768 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d1a-93cb777d,\n#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d21-93cb777d,\n#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d28-93cb777d {\n    justify-self: start\n}\n\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441c7-93cb777d,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441c9-93cb777d,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441cd-93cb777d,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441cf-93cb777d,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027c-93cb777d,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027e-93cb777d,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0276-93cb777d,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0278-93cb777d {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d1a-93cb777e,\n#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d21-93cb777e,\n#w-node-_68c09e73-88fa-dbc5-7929-0039292e0d28-93cb777e {\n    justify-self: start\n}\n\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441c7-93cb777e,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441c9-93cb777e,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441cd-93cb777e,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441cf-93cb777e,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027c-93cb777e,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027e-93cb777e,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0276-93cb777e,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0278-93cb777e {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb507-93cb777e {\n    grid-area: 2/3/3/4\n}\n\n#w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb509-93cb777e {\n    grid-area: 1/6/2/7\n}\n\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f5d-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f64-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f6b-93cb7781 {\n    justify-self: start\n}\n\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f83-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f85-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f89-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f8b-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f91-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f93-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f97-93cb7781,\n#w-node-_004f5ffd-4e87-3312-5474-6201acf36f99-93cb7781,\n#w-node-ef91da35-ecaa-722e-9ce4-bb73d611f68c-93cb7783,\n#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4ad-93cb7785 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4ae-93cb7785 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4b8-93cb7785 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_63b3c934-a152-1e34-cb68-ff70bf98f4b9-93cb7785 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6a78-c7ab6a6d {\n    justify-self: auto\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6a8a-c7ab6a6d {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6a93-c7ab6a6d {\n    justify-self: auto\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6aa2-c7ab6a6d {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6aaa-c7ab6a6d {\n    justify-self: auto\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6abc-c7ab6a6d {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6ac5-c7ab6a6d {\n    justify-self: auto\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6ad4-c7ab6a6d {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6adc-c7ab6a6d {\n    justify-self: auto\n}\n\n#w-node-e5e4b497-77c0-c5cc-3ab7-b575c7ab6aee-c7ab6a6d,\n#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d093-93cb77b5,\n#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d094-93cb77b5,\n#w-node-_173a66da-ce82-391d-b1bb-616b52906002-93cb77b5,\n#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d095-93cb77b5,\n#w-node-_0a62dcb4-d73b-bed3-322a-370e6f98d098-93cb77b5,\n#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1162-93cb77b5,\n#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1163-93cb77b5,\n#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1164-93cb77b5,\n#w-node-_82b4614c-589a-4db6-744b-e1a6c80a1167-93cb77b5,\n#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85bc-93cb77b5,\n#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85bd-93cb77b5,\n#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85be-93cb77b5,\n#w-node-_89bd8a48-10b8-583d-41bc-a6c6993d85c1-93cb77b5,\n#w-node-_656a7e81-99fa-7551-bcf3-1ce7d65152b0-93cb77b5,\n#w-node-_9faa675f-6c11-6b9d-f734-a4dce26246df-93cb77b5,\n#w-node-bb9b15ad-1503-97f7-7b5e-d4b02332802a-93cb77b5,\n#w-node-e587e106-802b-2556-d74a-ec206db554a5-93cb77b5,\n#w-node-fb07354c-3001-0cd3-a6ed-12c47c3602d5-93cb77b5,\n#w-node-e36009ac-1019-2bb2-f4ac-30d9ec069657-7ffd0210,\n#w-node-_1dadb9fe-2716-4601-cb13-bcc5abe02a2e-7ffd0210,\n#w-node-_72100bcb-af0e-6fec-fb8a-026a9d9ff525-7ffd0210,\n#w-node-_7c4ceb90-8b97-9a97-62c3-1e1fd8d08f8f-7ffd0210,\n#w-node-bdaea790-1339-2737-6da2-26c4d7d5caa0-7ffd0210,\n#w-node-_41358288-42c7-6637-1f48-e5c10aee1e1d-7ffd0210,\n#w-node-_41358288-42c7-6637-1f48-e5c10aee1e23-7ffd0210,\n#w-node-fd8ae82b-b2bd-d5db-b405-7aa3cf5388b6-7ffd0210,\n#w-node-_8010d6a4-3129-3481-4ecd-e9b1998d3760-7ffd0210,\n#w-node-b05c4180-8284-4d67-95be-60429ebd1be0-7ffd0210,\n#w-node-_8a4f3811-4024-3314-89f5-0df7d8b16f41-7ffd0210,\n#w-node-_2c6ff113-7933-5b7d-da7f-ef94e9273b20-7ffd0210,\n#w-node-_11a4e2eb-60d9-1575-e3cf-df436cce5ade-7ffd0210,\n#w-node-c8d24d95-0015-7003-5821-cf099944a0e3-7ffd0210,\n#w-node-_40c3cd2e-5e65-ca1a-f414-fa6673b7c52f-7ffd0210,\n#w-node-_40c3cd2e-5e65-ca1a-f414-fa6673b7c530-7ffd0210,\n#w-node-_40c3cd2e-5e65-ca1a-f414-fa6673b7c532-7ffd0210,\n#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab40-7ffd0210,\n#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab52-7ffd0210,\n#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab4c-7ffd0210,\n#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab5d-7ffd0210,\n#w-node-ab5180b7-77a6-ce0b-b112-b7fa3901ab65-7ffd0210,\n#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb77b6,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb77b6,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb77b6,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb77b6,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb77b6,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb77b6,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb77b6,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb77b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb77b6 {\n    align-self: auto\n}\n\n#w-node-_05fbec55-15d5-bc10-882a-1b7b0e76a32e-93cb77b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb77b7 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb77b7,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb77b7,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb77b7,\n#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb77b7,\n#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb77b7,\n#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb77b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb77ba {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb77ba,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb77ba,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb77ba,\n#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb77ba,\n#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb77ba,\n#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb77ba,\n#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a05-3d1729f0,\n#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a0e-3d1729f0,\n#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a1d-3d1729f0,\n#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a2c-3d1729f0,\n#w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a43-3d1729f0,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade208-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade20d-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade212-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade217-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade21c-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade223-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade22a-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade234-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade236-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade238-93cb77c1,\n#w-node-_0b4162c0-2d42-0e8a-54db-73bdd6ade2ad-93cb77c1 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-bc52e2fc-ca3c-6bdb-456b-b0ea36b12fcd-93cb77c5 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_77e61512-b93e-4a57-37ef-af13341d0e17-93cb77c5 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-bc52e2fc-ca3c-6bdb-456b-b0ea36b12fdb-93cb77c5 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-bc52e2fc-ca3c-6bdb-456b-b0ea36b12fde-93cb77c5 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286a-93cb77c5 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto\n}\n\n#w-node-ffd203e1-5d43-182d-4ab2-9c0c6e5340c8-93cb77c5 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286b-93cb77c5,\n#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286d-93cb77c5 {\n    align-self: center\n}\n\n#w-node-_0f5e4374-1bb0-73cd-1a25-0b3848b3286e-93cb77c5,\n#w-node-_32e39d14-5354-1527-7a58-f64d595cf77b-93cb77c5 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_9286401d-042d-36a3-288e-3545ffeb5510-93cb77c5 {\n    justify-self: center\n}\n\n#w-node-_3a15f428-faa7-1bad-165a-b317a22f014e-93cb77dd {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd77f5-93cb77dd {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start;\n    justify-self: center\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd77f6-93cb77dd {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd77fe-93cb77dd {\n    grid-area: span 1/span 2/span 1/span 2\n}\n\n#w-node-aa0513c7-4063-1380-347c-1a244a4c3ce2-93cb77dd,\n#w-node-ff5cfcca-aec9-fdce-4621-e1ab4ae15728-93cb77dd,\n#w-node-_5e6bb53a-fe25-f8a7-5b59-e9739f100201-93cb77dd {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7832-93cb77dd {\n    align-self: center\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7838-93cb77dd {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd784b-93cb77dd {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd785f-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7861-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7865-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7867-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd786b-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd786d-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7871-93cb77dd,\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd7873-93cb77dd {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ae71e5d7-d5f2-8f6f-cd5f-d66551dd788f-93cb77dd {\n    align-self: center\n}\n\n#w-node-c3872391-191b-f9ec-8d33-d740c07e2c73-93cb77fc,\n#w-node-c4c37850-5df6-a06e-9a39-f93f6d779d0f-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-d26efc9b-757f-6b02-d6d9-6ed47e6eb92b-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-_32738114-c87c-8350-29fe-5f8a97eca111-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_802fb8c7-6066-06bc-5774-9463292fba4a-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-b094e1d1-5991-5a05-e7ca-30e4a066e338-93cb77fc {\n    grid-area: span 1/span 2/span 1/span 2\n}\n\n#w-node-fa50ae89-2e56-e30c-dfea-4fa302f9ba75-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-eb3769ea-b13f-fff9-bfef-b81b424a2795-93cb77fc,\n#w-node-_22aa8215-645d-8e69-b038-a4001bbae991-93cb77fc,\n#w-node-_75aac411-2920-ccf7-0d44-6e114ccdee16-93cb77fc,\n#w-node-ed6cc8ce-5095-b7b4-f967-da593ca5b131-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-d8c8aed4-c702-a892-5ef5-a80782608868-93cb77fc,\n#w-node-e1a04ad3-df9a-0616-2538-a136fe9fc409-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-dda2d83a-0a05-41b8-3fe9-c8496f1287e2-93cb77fc,\n#w-node-_0cd7d884-fd59-fcaa-4999-0c8a95dc5202-93cb77fc,\n#w-node-_0cd7d884-fd59-fcaa-4999-0c8a95dc5203-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_5e650026-33a0-c81b-3ad8-f16c1968ad7f-93cb77fc,\n#w-node-_5e650026-33a0-c81b-3ad8-f16c1968ad80-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-_928d7c5e-645b-dd23-d5ca-8f6ad755bb68-93cb77fc,\n#w-node-_8cb573d7-b398-db84-6bda-6126252523c2-93cb77fc,\n#w-node-_8cb573d7-b398-db84-6bda-6126252523c3-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_8cb573d7-b398-db84-6bda-6126252523c5-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-d712d870-48f3-cf51-9dda-cd4a91a33de0-93cb77fc,\n#w-node-d712d870-48f3-cf51-9dda-cd4a91a33de1-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-d712d870-48f3-cf51-9dda-cd4a91a33de3-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-_601fefd5-b92c-3718-9bb5-c58bd3011545-93cb77fc,\n#w-node-e900174c-7926-d1e0-4b07-c216f0467bb0-93cb77fc,\n#w-node-b4463ed5-d4f4-9309-dc25-74a1819c06c4-93cb77fc,\n#w-node-_84832811-aea4-468c-0a31-c1ffb33de1a1-93cb77fc,\n#w-node-_84832811-aea4-468c-0a31-c1ffb33de1a3-93cb77fc,\n#w-node-cfd18d1a-ff7c-aa6e-6f8f-ec1f8bf0bab8-93cb77fc,\n#w-node-cfd18d1a-ff7c-aa6e-6f8f-ec1f8bf0baba-93cb77fc,\n#w-node-_6007e4c0-0719-3424-4a87-6e7270f91bb8-93cb77fc,\n#w-node-_6007e4c0-0719-3424-4a87-6e7270f91bba-93cb77fc,\n#w-node-_9c5784aa-2414-9b3c-9e1a-b96118fd83be-93cb77fc,\n#w-node-_65ea0360-0527-323d-7d00-34dc27af33f4-93cb77fc,\n#w-node-_4aebaf31-8d59-123d-3bec-67879ca0b5d8-93cb77fc,\n#w-node-_9c5784aa-2414-9b3c-9e1a-b96118fd83c0-93cb77fc,\n#w-node-_1a33091b-740e-95ec-8fdd-2343ead28a91-93cb77fc,\n#w-node-c081d2ef-0598-03f1-0b18-0f2273e4ea25-93cb77fc,\n#w-node-_37768e56-2de7-90c4-a7d8-01b14a6d4129-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_60a26e9f-da0c-3420-ba3a-a8fd1e4e9c5a-93cb77fc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: stretch\n}\n\n#w-node-_0e139a5f-0e3f-c435-536e-9a1f6c4c1873-93cb77fc,\n#w-node-_8995b6d8-e3d1-221d-a1da-3af1e0cc9d9d-93cb77fc,\n#w-node-_8995b6d8-e3d1-221d-a1da-3af1e0cc9d9e-93cb77fc,\n#w-node-b2c11cd4-ceff-cf45-531d-32078b44c444-93cb77fc,\n#w-node-_2c829d5d-b45f-a93d-4fa8-ca36db8e84a5-93cb77fc,\n#w-node-befe73de-ec83-6b07-0c6d-dc06b93d865f-93cb77fc,\n#w-node-befe73de-ec83-6b07-0c6d-dc06b93d8665-93cb77fc,\n#w-node-befe73de-ec83-6b07-0c6d-dc06b93d8674-93cb77fc,\n#w-node-befe73de-ec83-6b07-0c6d-dc06b93d8683-93cb77fc,\n#w-node-befe73de-ec83-6b07-0c6d-dc06b93d869a-93cb77fc,\n#w-node-d6b9c541-8c70-bfd3-ecae-1f0c4152ec4d-93cb77fe,\n#w-node-_477dd745-7085-6a73-b282-eb4d23ba5f38-93cb77fe,\n#w-node-c27ba869-f8a9-52c2-1578-2be42dbcb792-93cb77fe,\n#w-node-e1237b2f-43e4-2e61-e1fe-51a5ba19bcca-93cb77fe,\n#w-node-_56c6e15a-b17a-82b7-43fd-ea46b34e063b-93cb77fe {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_40c40156-7608-9b9b-a686-c13f62607cd4-93cb77fe {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_8531ac38-9b0a-fe14-d3d1-a4b75553ece6-93cb77fe {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7912e588-f92f-47e0-eaaa-0df83b37e29c-93cb77fe,\n#w-node-f71a274f-2bdb-72c1-39db-ceecb8ee3062-93cb77fe,\n#w-node-_973acb1a-eb73-a8bd-583e-0ced71960216-93cb77fe,\n#w-node-c6e89ad7-21ad-9f36-089c-f222892b9c70-93cb77fe {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_8890d250-4bd7-2564-bc1c-b3a4c136114a-93cb77fe,\n#w-node-_57a1245e-9c7f-7935-1108-3cd27ec15b56-93cb77fe,\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fa5-93cb77fe,\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fa8-93cb77fe,\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fab-93cb77fe,\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fb0-93cb77fe,\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fb3-93cb77fe,\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fb6-93cb77fe {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3fee-93cb77fe {\n    align-self: center\n}\n\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf3ff4-93cb77fe {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_73eff977-97ce-45b5-d9a8-e77525bf4041-93cb77fe {\n    align-self: auto\n}\n\n#w-node-_922125af-6840-213d-87af-bf463177b709-3177b6fb,\n#w-node-_922125af-6840-213d-87af-bf463177b70b-3177b6fb,\n#w-node-_922125af-6840-213d-87af-bf463177b70e-3177b6fb,\n#w-node-_922125af-6840-213d-87af-bf463177b713-3177b6fb,\n#w-node-_922125af-6840-213d-87af-bf463177b715-3177b6fb,\n#w-node-_922125af-6840-213d-87af-bf463177b718-3177b6fb,\n#w-node-_63daa8ea-c7b7-bc64-b503-1ec9ab8e0aaf-93cb7800,\n#w-node-_91b11cf7-0722-728d-d871-db0dd442e6af-93cb7800,\n#w-node-f28035e4-e0d5-157f-379e-3a1f22d0c8f9-93cb7800,\n#w-node-cb5c13a8-46f5-b5f3-3589-55bbb31c0563-93cb7800,\n#w-node-cb5c13a8-46f5-b5f3-3589-55bbb31c0564-93cb7800,\n#w-node-cb5c13a8-46f5-b5f3-3589-55bbb31c0566-93cb7800,\n#w-node-e5325195-7bdc-aa2f-2af4-51298d208f32-93cb7800,\n#w-node-e5325195-7bdc-aa2f-2af4-51298d208f33-93cb7800,\n#w-node-e5325195-7bdc-aa2f-2af4-51298d208f35-93cb7800 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b0c1b0f7-ed8e-ea97-04b6-e67ede012b0c-93cb7800,\n#w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabff-93cb7800,\n#w-node-bad18347-b3e3-3b17-d808-7320f8eab480-93cb7800,\n#w-node-_7128d008-abfe-92cd-ad02-a2227f76f343-93cb7800,\n#w-node-_8ea22c76-2344-1281-9838-1dc5c6e1102e-93cb7800 {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_57564854-16dd-e5fb-f917-45da6f9ecb75-93cb7803,\n#w-node-_09a77a8f-79e2-ac4e-7b09-293ee6307ff1-93cb7806,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7806,\n#w-node-_67576e80-e279-2a6c-ca5f-1f0789972fdb-93cb7806,\n#w-node-_67576e80-e279-2a6c-ca5f-1f0789972fdc-93cb7806,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7806,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7806,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7806,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7806,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7806,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7806,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7806,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7806,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7806,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7806,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7806,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7806,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7806,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7806,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7806,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7806 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7806 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7806 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7806 {\n    align-self: auto\n}\n\n#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb7808,\n#w-node-f1973054-052b-d1ae-a328-bda759153908-93cb7808,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7808,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7808,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7808,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7808,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7808,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb7808,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb7808 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7808 {\n    align-self: auto\n}\n\n#w-node-_05fbec55-15d5-bc10-882a-1b7b0e76a32e-93cb7808,\n#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b64-93cb780a,\n#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2cff-93cb780a,\n#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d03-93cb780a,\n#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d07-93cb780a {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb780a {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-a839737e-82a4-2aa4-6b9e-4100f463cb59-93cb780a,\n#w-node-_7126b630-96ac-1ddc-5357-1ec527c56260-93cb780a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8c9d-93cb780a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8ca4-93cb780a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cab-93cb780a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cb2-93cb780a,\n#w-node-_41c593f6-40ad-beb2-1029-27d05d7c755b-93cb780c {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_36d2a246-cb39-7c89-6d4f-0332607907af-93cb780d,\n#w-node-_77bb34f1-1340-c927-6fb8-6482a7f19145-93cb780d,\n#w-node-_90f6eeec-2560-e528-eaba-6048ad0318ec-93cb780d {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff62-2349ff59,\n#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff63-2349ff59,\n#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff69-2349ff59,\n#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff6a-2349ff59,\n#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff70-2349ff59,\n#w-node-c535969a-c3a6-3dca-7e6e-a4b72349ff71-2349ff59,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b37b-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b37c-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b37d-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b381-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b383-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b384-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b388-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b38a-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b38b-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b38f-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b391-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b392-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b393-93cb7816,\n#w-node-f53807d9-5415-d802-8ee3-3f0f9268b397-93cb7816,\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792c9-93cb7817 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792cf-93cb7817 {\n    justify-self: auto\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792dd-93cb7817 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792e5-93cb7817 {\n    justify-self: auto\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792f6-93cb7817 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd4097792fc-93cb7817 {\n    justify-self: auto\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd40977930a-93cb7817 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7ed293b0-81eb-4e7c-5192-2dd409779310-93cb7817 {\n    justify-self: auto\n}\n\n#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7817,\n#w-node-_996af45e-970d-59a6-a44f-82f0a0ac2cc9-93cb7818,\n#w-node-_996af45e-970d-59a6-a44f-82f0a0ac2cca-93cb7818,\n#w-node-_996af45e-970d-59a6-a44f-82f0a0ac2ccc-93cb7818,\n#w-node-_7e16f63c-5ed2-4d9d-25ac-c90fddd9146c-93cb7818,\n#w-node-_7e16f63c-5ed2-4d9d-25ac-c90fddd9146d-93cb7818,\n#w-node-_7e16f63c-5ed2-4d9d-25ac-c90fddd9146f-93cb7818,\n#w-node-_86d587e6-c4c8-d18b-09c1-7be813a8e852-93cb7818,\n#w-node-_03f14b75-481d-2c4e-648b-cf0a96446e44-93cb7818,\n#w-node-db34f1c3-fba8-f364-baa4-9e75089133c8-93cb7818,\n#w-node-_143d5d15-62e0-62e8-a75f-32a51bcb9aaf-93cb7818,\n#w-node-_9d3812e0-761c-6f06-88cf-216937bcf774-93cb7818,\n#w-node-bfdc67dd-5a87-1afd-2d4e-684dfa5402a6-93cb7818,\n#w-node-c6887bc3-10da-efab-2a13-109e28c49635-93cb7818,\n#w-node-_33b6bea5-b01c-aa70-7b04-af4cdea6743b-93cb7818 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b2f1b523-1902-9c9c-593d-7a6b76f6921a-93cb7818 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_005b9bb7-84bb-7440-fb4f-4cb02969d2cb-93cb7818 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_4ba668e6-ca36-cc5b-7bf7-f42be58e064b-93cb7819,\n#w-node-_5d57aa1a-c76b-efa2-b432-d6a8ca24d810-93cb7819 {\n    align-self: center\n}\n\n#w-node-_44e7aad6-436d-7ea4-4dbf-ff175da8cde7-93cb7819 {\n    justify-self: auto\n}\n\n#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc90-93cb781a,\n#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc97-93cb781a,\n#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc9e-93cb781a {\n    justify-self: start\n}\n\n#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ed7-f5a10ed1,\n#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ed9-f5a10ed1 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ee0-f5a10ed1,\n#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ee9-f5a10ed1 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_417c0c29-5c1a-c85a-4c7b-a83bf5a10ef0-f5a10ed1 {\n    align-self: center\n}\n\n#w-node-_1a9ad16a-cf91-4631-ccd5-84cc1676b57c-93cb781e,\n#w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb74-93cb781e,\n#w-node-f7bf232d-31e6-0823-e8a7-3e7f893b7fd1-93cb781e {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_161cdf43-05f8-fdf0-849c-063676e55aa9-93cb7820 {\n    align-self: center\n}\n\n#w-node-_2ac091be-85d0-7c06-96a1-31598ef01eb4-93cb7820 {\n    align-self: center;\n    justify-self: end\n}\n\n#w-node-_2499bd8b-1252-89c3-cd1f-f4fb98e84b54-93cb7822,\n#w-node-_5796f4fb-1441-34a4-b19e-1c6039930f40-93cb7822,\n#w-node-b3c0d1f4-3808-4fd1-907f-71852c76a8bc-93cb7822 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_4b928710-15ce-ac8e-c296-40b33744a978-93cb7822 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_9ee16af2-0bb9-b76f-8c7e-f558b9ed0a1a-93cb7822 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_0575697a-9b75-fad4-6c53-c532393abfa4-93cb7822 {\n    align-self: center\n}\n\n#w-node-_0575697a-9b75-fad4-6c53-c532393abfaa-93cb7822 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_78883919-c1ff-44cf-3589-2a7f6bdb8902-93cb7822,\n#w-node-_78883919-c1ff-44cf-3589-2a7f6bdb8905-93cb7822,\n#w-node-_73653ffa-6a3b-4891-1245-d9f50281db6c-93cb7822,\n#w-node-_507e9163-ce1c-6370-08ce-bd76d88aae4b-93cb7822,\n#w-node-ef91da35-ecaa-722e-9ce4-bb73d611f68c-93cb7823 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eac3-93cb7829 {\n    justify-self: auto\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3ead5-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eade-93cb7829 {\n    justify-self: auto\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eaed-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eaf5-93cb7829 {\n    justify-self: auto\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb07-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb10-93cb7829 {\n    justify-self: auto\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb1f-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb27-93cb7829 {\n    justify-self: auto\n}\n\n#w-node-_49be8501-dc91-5ea3-354f-dfdda3b3eb39-93cb7829,\n#w-node-e52efb07-d0cb-5618-f327-8e3339121aef-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e52efb07-d0cb-5618-f327-8e3339121af0-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-e52efb07-d0cb-5618-f327-8e3339121afa-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e52efb07-d0cb-5618-f327-8e3339121afb-93cb7829 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_41c593f6-40ad-beb2-1029-27d05d7c755b-93cb782a,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb782d,\n#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd7-93cb782d,\n#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd8-93cb782d,\n#w-node-_557e393f-9a6f-aaaa-4071-60d5a79e36e0-93cb782d,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb782d,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb782d,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb782d,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb782d,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb782d,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb782d,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb782d,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb782d,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb782d,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb782d,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb782d,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb782d,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb782d,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb782d {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb782d {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb782d {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb782d {\n    align-self: auto\n}\n\n#w-node-_462e1e2a-849d-3f32-13ee-d12453635faa-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_3200fcf8-0ac5-5498-78b8-a688afd4f1a4-93cb782f,\n#w-node-_5552f219-48f8-213a-66df-3993c0984fac-93cb782f,\n#w-node-_86f7ec23-2bc7-2459-0b38-4c7befc0e7f4-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dd1cced9-d551-0916-d0f4-dd81de3f56f9-93cb782f,\n#w-node-_4a30385e-8417-5a46-85dd-b1b82088b09a-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-de1d40b8-fc4c-bb1a-d594-c0c63d8693a9-93cb782f {\n    align-self: center\n}\n\n#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa1-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_9ee9eced-632f-a0e3-dd17-b47293f1c82a-93cb782f,\n#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa5-93cb782f,\n#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa6-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa7-93cb782f,\n#w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa9-93cb782f,\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b1f-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b26-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b27-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b28-93cb782f,\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b29-93cb782f,\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b2a-93cb782f,\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b2b-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b2c-93cb782f,\n#w-node-_54466388-3219-79f5-198b-6bc377bb0b2d-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_62873f6e-3cca-a01b-a37f-551094e3f5ae-93cb782f,\n#w-node-_394d02d1-0b95-78da-1e6e-2a245dadd403-93cb782f,\n#w-node-_9bdd82a4-cb00-5ee5-13f5-6e1934c3dfcf-93cb782f,\n#w-node-_2d4b391e-3c79-a86b-8abb-ccd89266c9cb-93cb782f,\n#w-node-_3d5707c5-22d9-ee3b-f35b-b9cc144ffdc7-93cb782f,\n#w-node-daf2dd60-1227-818d-9c5b-cc776f5e1577-93cb782f,\n#w-node-_0696de55-24d9-390c-f2f5-7d9afbf5ae13-93cb782f,\n#w-node-_4da5e53b-2fa8-513b-122b-7f28b22a5b79-93cb782f,\n#w-node-_5bff9624-f73d-9a3b-6d33-a10cce5d076c-93cb782f,\n#w-node-_464f8b3b-eab6-3b79-066f-da768c2dfec1-93cb782f,\n#w-node-_36ef1cad-f49c-6f20-45e7-ed0358555a5c-93cb782f,\n#w-node-_32d97587-1883-9700-2b7c-5073aa0995f9-93cb782f,\n#w-node-bf8805d9-3766-00a8-dee9-75b794d57a85-93cb782f {\n    order: 0;\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: auto\n}\n\n#w-node-afe74a8d-ff0f-a571-e6ac-946ecf487b86-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_0e89972e-fe99-2763-f487-af7a9b2fd0a1-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_2b53cf1e-d42d-782c-bcc7-2b15b4900f72-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_3470d107-f7bc-af98-2932-25ecdc7e4829-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_3470d107-f7bc-af98-2932-25ecdc7e482c-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_6c9cd9c6-54db-5a3c-8577-81a6c1100999-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_6c9cd9c6-54db-5a3c-8577-81a6c110099c-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_3d3769d0-21b7-a05a-9d83-9cdf4fa900fd-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_3d3769d0-21b7-a05a-9d83-9cdf4fa90100-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_2824f613-def0-706b-0c8e-9b1873735f34-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_2824f613-def0-706b-0c8e-9b1873735f37-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_5442f912-9b20-315f-39b5-62abe2c08797-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_5442f912-9b20-315f-39b5-62abe2c0879a-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_5e84255a-ecbc-6211-cf65-298c524d8b1e-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_5e84255a-ecbc-6211-cf65-298c524d8b21-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-fd97b084-77f1-2dc5-79bc-fb7d5e917a47-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-fd97b084-77f1-2dc5-79bc-fb7d5e917a4a-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_04dd575b-ab05-2294-a4d2-e6bba348df96-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_04dd575b-ab05-2294-a4d2-e6bba348df99-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_01166d48-6c36-3bce-e709-d5fed40c1b27-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_01166d48-6c36-3bce-e709-d5fed40c1b2a-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_1fc5f98d-b4ac-e466-f22a-680e25bfee18-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_1fc5f98d-b4ac-e466-f22a-680e25bfee1b-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-a9c9e552-f957-bef9-a63a-d2492ba65273-93cb782f {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-a9c9e552-f957-bef9-a63a-d2492ba65276-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123b7-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123be-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123bf-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c0-93cb782f,\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c1-93cb782f,\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c2-93cb782f,\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c3-93cb782f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c4-93cb782f,\n#w-node-_66862598-b3c9-84e3-cf9e-81100b7123c5-93cb782f,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7831,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7831,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7831,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7831,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7831,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7831,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7831,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7831,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7831,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7831,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7831,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7831,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7831,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7831,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7831,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7831,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7831,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7831,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7831,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7831 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7831 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7831 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7831 {\n    align-self: auto\n}\n\n#w-node-fd1a957a-533a-8824-006b-7313a5dccedb-93cb7832,\n#w-node-b431b86b-f2f0-708d-f867-ce24ea365c7d-93cb7832,\n#w-node-_0fab30e8-69c7-8a91-ac45-f4adb0d1bb7a-93cb7832 {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63281-93cb7834 {\n    grid-area: 1/1/2/2;\n    align-self: start;\n    justify-self: auto\n}\n\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63282-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63286-93cb7834 {\n    align-self: center;\n    justify-self: stretch\n}\n\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328a-93cb7834 {\n    grid-area: 1/2/3/3;\n    justify-self: auto\n}\n\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328d-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328e-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328f-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63291-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd63293-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632a6-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632a7-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632a8-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632aa-93cb7834,\n#w-node-_41fdb07b-387c-bef8-9004-83ed2dd632ac-93cb7834,\n#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b40b-93cb7835,\n#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b42e-93cb7835,\n#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b44f-93cb7835,\n#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b471-93cb7835,\n#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b494-93cb7835,\n#w-node-b0f1dd6c-93a7-9e15-e3b4-9a7362c7b4b5-93cb7835,\n#w-node-_96d1a9e5-f77d-e9a8-35ac-758eca638e96-93cb7837,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb783f,\n#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd7-93cb783f,\n#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd8-93cb783f,\n#w-node-_557e393f-9a6f-aaaa-4071-60d5a79e36e0-93cb783f,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb783f,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb783f,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb783f,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb783f,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb783f,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb783f,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb783f,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb783f,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb783f,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb783f,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb783f,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb783f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb783f {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb783f {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb783f {\n    align-self: auto\n}\n\n#w-node-_8f080c5f-5d43-e1fe-8f50-fbd438ba3900-93cb7840,\n#w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61b8-93cb7840,\n#w-node-_76f22f68-56ac-162e-498a-f1ddff7de17d-93cb7840,\n#w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662ff-93cb7840 {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7842,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7842,\n#w-node-_4741a5ad-ecb8-45fd-b97a-63442878d5a8-93cb7842,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7842,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7842,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7842,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7842,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7842,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7842,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7842,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7842,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7842,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7842,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7842,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7842,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7842,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7842,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7842,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7842,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7842,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7842 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7842 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7842 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7842 {\n    align-self: auto\n}\n\n#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb7843 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626bc6-93cb7843,\n#w-node-c9d841c6-b7de-201c-736b-087712626bcf-93cb7843,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7844,\n#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd7-93cb7844,\n#w-node-_95012409-b8f7-408d-fcb6-2649b18bffd8-93cb7844,\n#w-node-_557e393f-9a6f-aaaa-4071-60d5a79e36e0-93cb7844,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7844,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7844,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7844,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7844,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7844,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7844,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7844,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7844,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7844,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7844,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7844,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7844 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7844 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7844 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7844 {\n    align-self: auto\n}\n\n#w-node-_9ee16af2-0bb9-b76f-8c7e-f558b9ed0a1a-93cb7846 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_83436a2a-6983-27b5-d6cf-44eadd3347ab-93cb7846 {\n    align-self: center\n}\n\n#w-node-_481a6ed2-1fcc-7792-07b9-f00d54825df1-93cb7847,\n#w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b42-93cb7847,\n#w-node-e03e9185-11ce-791a-e264-dee25008c53a-93cb7847 {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-c98c598c-9f00-d846-20b8-d56cae0b9346-93cb7848,\n#w-node-c98c598c-9f00-d846-20b8-d56cae0b934d-93cb7848,\n#w-node-c98c598c-9f00-d846-20b8-d56cae0b9354-93cb7848 {\n    justify-self: start\n}\n\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5f4-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5f7-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5f9-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5fb-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5fd-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef5ff-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef601-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef603-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef605-93cb7848,\n#w-node-_39bbd0e1-8adc-76c5-0a02-a9c5291ef607-93cb7848 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e16d4a35-bc24-7b09-aaa3-513b15e74c78-93cb7848 {\n    align-self: center\n}\n\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa84e-cd55d8f4 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa855-cd55d8f4 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa856-cd55d8f4 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa857-cd55d8f4,\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa858-cd55d8f4,\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa859-cd55d8f4,\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa85a-cd55d8f4 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa85b-cd55d8f4,\n#w-node-b903a5bf-be01-33d5-c2cb-eaa5c99aa85c-cd55d8f4 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_15fdf71c-7871-73bb-c76a-9ea042992150-93cb784b {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9aae-93cb784b,\n#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9ab5-93cb784b,\n#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9abc-93cb784b {\n    justify-self: center\n}\n\n#w-node-_1dc8c3fe-dd74-ce3e-e0f4-63fafd190397-93cb784d {\n    grid-area: 1/1/2/1\n}\n\n#w-node-_1075d511-de9d-eb09-87fa-3cb611b3370e-93cb784d {\n    grid-area: span 1/span 3/span 1/span 3\n}\n\n#w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d {\n    grid-area: 1/2/2/2\n}\n\n#w-node-_78dbd686-4557-31f7-c2e8-0ddfac9f126c-93cb784d {\n    grid-area: 1/3/2/3\n}\n\n#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf5e-93cb7871 {\n    grid-area: 1/1/2/1\n}\n\n#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf67-93cb7871 {\n    grid-area: span 1/span 3/span 1/span 3\n}\n\n#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {\n    grid-area: 1/2/2/2\n}\n\n#w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf71-93cb7871 {\n    grid-area: 1/3/2/3\n}\n\n#w-node-bed9c8b8-f8d4-ab01-02e4-f685ec0a4b49-93cb7871,\n#w-node-d9fcb6be-7c6f-bc6e-54d7-10c5b59ba63f-93cb7871,\n#w-node-_773ed52a-f3d2-9fd1-9a87-6ae5ff8daf39-93cb7871 {\n    grid-area: span 1/span 2/span 1/span 2\n}\n\n#w-node-_37c07466-bdad-ed4c-9614-29f684d1b263-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_4e888680-b006-3265-a75e-b37fbfd004cf-93cb7871,\n#w-node-_0ce76b96-a607-9f7f-c880-2d30c33ee79f-93cb7871 {\n    grid-area: span 1/span 2/span 1/span 2\n}\n\n#w-node-f3dce5f1-8822-db7d-fbe3-36f747433a68-93cb7871,\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4da-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4e0-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4f4-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b4fa-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b50b-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b511-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b525-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b52d-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b53b-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b541-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b555-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b55b-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b572-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b578-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b58c-93cb7871 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b592-93cb7871 {\n    justify-self: auto\n}\n\n#w-node-_305d023b-1e0d-9a15-92ef-5f4a9f23b5aa-93cb7871 {\n    align-self: center\n}\n\n#w-node-_81d4c42b-0c38-e283-5db6-e4245108afb9-93cb7871 {\n    grid-area: span 2/span 1/span 2/span 1\n}\n\n#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb7872,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7872,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7872,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7872,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7872,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7872,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7872,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7872,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7872,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7872,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7872,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7872,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7872,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7872,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7872 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7872 {\n    align-self: auto\n}\n\n#w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7872 {\n    grid-area: 2/3/3/4\n}\n\n#w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7872 {\n    grid-area: 1/6/2/7\n}\n\n#w-node-_15fdf71c-7871-73bb-c76a-9ea042992150-93cb7874 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9aae-93cb7874,\n#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9ab5-93cb7874,\n#w-node-_872a351a-9535-30ca-69b1-cf4f1d1c9abc-93cb7874 {\n    justify-self: center\n}\n\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7875,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7875,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7875,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7875,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7875,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7875,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7875,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7875,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7875,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7875,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7875,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7875,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7875,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7875,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7875,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7875,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7875,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7875,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7875,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7875 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7875 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7875 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7875 {\n    align-self: auto\n}\n\n#w-node-f394acbb-f5b9-0318-761f-7dda684b278e-93cb7877 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-c9d841c6-b7de-201c-736b-087712626b9e-93cb7877,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba0-93cb7877,\n#w-node-c9d841c6-b7de-201c-736b-087712626ba2-93cb7877,\n#w-node-c9d841c6-b7de-201c-736b-087712626bab-93cb7877,\n#w-node-c9d841c6-b7de-201c-736b-087712626bb4-93cb7877,\n#w-node-c9d841c6-b7de-201c-736b-087712626bbd-93cb7877,\n#w-node-_09a77a8f-79e2-ac4e-7b09-293ee6307ff1-93cb7878,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a32-93cb7878,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3b-93cb7878,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a3c-93cb7878,\n#w-node-_2dc634a1-8670-5149-82f6-caa2e9d33a49-93cb7878,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7878,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7878,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7878,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7878,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7878,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7878,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7878,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7878,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7878,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7878,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7878,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7878,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adbe-93cb7878,\n#w-node-_41f0576c-1b13-26aa-77d5-d8402b93adc0-93cb7878 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe6f-93cb7878 {\n    align-self: center\n}\n\n#w-node-a18286d5-be2d-f9dd-5ebb-0343b6defe79-93cb7878 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7878 {\n    align-self: auto\n}\n\n#w-node-c95191df-6078-39a7-ee16-e4adc7852441-93cb7879,\n#w-node-_95091db4-c91c-2e2a-527d-4a498db5df0a-93cb7879,\n#w-node-c95191df-6078-39a7-ee16-e4adc785244b-93cb7879,\n#w-node-_3daa264e-af02-c78c-6ebb-274206f68d37-93cb7879,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb7879,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb7879,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb7879,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb7879,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb7879,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb7879,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb7879,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb7879,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb7879,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb7879,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb7879,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb7879,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243d-93cb7879,\n#w-node-_703e22aa-35c0-4aac-285d-d84a46e0243f-93cb7879 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb7879 {\n    align-self: auto\n}\n\n#w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7879 {\n    grid-area: 2/3/3/4\n}\n\n#w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7879 {\n    grid-area: 1/6/2/7\n}\n\n#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b64-93cb787a,\n#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2cff-93cb787a,\n#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d03-93cb787a,\n#w-node-f90d36d3-8002-bdaf-151e-9af38a2a2d07-93cb787a {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb787a {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: end\n}\n\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8c9d-93cb787a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8ca4-93cb787a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cab-93cb787a,\n#w-node-bae3f87e-33ab-77b7-6b9b-daf6077d8cb2-93cb787a,\n#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb787d,\n#w-node-fdf54a5d-6dc2-b882-f2be-fafdce531879-93cb787f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-fdf54a5d-6dc2-b882-f2be-fafdce53187a-93cb787f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-fdf54a5d-6dc2-b882-f2be-fafdce531884-93cb787f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-fdf54a5d-6dc2-b882-f2be-fafdce531885-93cb787f {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-93cb7883,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441c7-93cb7887,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441c9-93cb7887,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027c-93cb7887,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e027e-93cb7887,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0276-93cb7887,\n#w-node-b3f0c15b-967d-8dd1-b90c-44a64c8e0278-93cb7887,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441cd-93cb7887,\n#w-node-_6485294b-ab01-ed67-2584-5f9d485441cf-93cb7887,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4b-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4c-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4d-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df4f-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df50-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df51-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df53-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df54-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df55-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df57-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df58-1379df41,\n#w-node-c7b51183-7ceb-4ed8-b826-e86b1379df59-1379df41,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a80-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a82-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a85-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a89-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a8b-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a8e-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a92-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a94-65364a74,\n#w-node-_45cb4c88-9168-9674-7648-d21565364a97-65364a74,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086bb-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086c1-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086c7-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086cd-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086d3-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086de-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086e6-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7086f7-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee70875e-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708767-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708770-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708779-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708782-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee70878b-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708797-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee708798-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee70879a-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087d7-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087e1-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087e6-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087ef-ee70868e,\n#w-node-c4711ce7-5e7b-9fea-ed90-f465ee7087fa-ee70868e,\n#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb78b5,\n#w-node-f1973054-052b-d1ae-a328-bda759153908-93cb78b5,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb78b5,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb78b5,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb78b5,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb78b5,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb78b5,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb78b5,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb78b5 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb78b5 {\n    align-self: auto\n}\n\n#w-node-_05fbec55-15d5-bc10-882a-1b7b0e76a32e-93cb78b5,\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d4a-93cb78b6,\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d4c-93cb78b6,\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d50-93cb78b6,\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d52-93cb78b6,\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d56-93cb78b6,\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d58-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d5c-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-c29a9e59-cab5-f9d6-e0bf-7d13e2583d5e-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d284-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d286-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d297-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d29a-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d29d-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2a0-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2a3-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2a8-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ac-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2b0-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2b5-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2b9-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2bd-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2c2-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2c6-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ca-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2cf-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2dc-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e2-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e3-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e4-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e6-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e7-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2e8-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ea-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2eb-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ec-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ee-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ef-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f0-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f2-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f3-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f4-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f6-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f7-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2f8-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fa-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fb-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fc-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2fe-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d2ff-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d300-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d302-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d303-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d304-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d306-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d307-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d308-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_9c788f07-d9fc-c3fb-0337-cb0c284f6041-93cb78b6,\n#w-node-_9c788f07-d9fc-c3fb-0337-cb0c284f6042-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_9c788f07-d9fc-c3fb-0337-cb0c284f6043-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d30d-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d313-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d314-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d315-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d317-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d318-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d319-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31b-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31c-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31d-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d31f-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d320-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d321-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d323-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d324-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d325-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d327-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d328-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d329-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32b-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32c-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32d-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d32f-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d330-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d331-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d333-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d334-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d335-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ab8c2b69-154a-9e08-cad7-e1ad71f71beb-93cb78b6,\n#w-node-ab8c2b69-154a-9e08-cad7-e1ad71f71bec-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-ab8c2b69-154a-9e08-cad7-e1ad71f71bed-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_30a30e84-4eab-213e-9723-71471c610305-93cb78b6,\n#w-node-_30a30e84-4eab-213e-9723-71471c610306-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_30a30e84-4eab-213e-9723-71471c610307-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d33c-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d33f-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d342-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d345-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d348-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d34b-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d34e-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d351-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d354-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d357-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d35a-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d35d-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d360-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d363-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d366-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d369-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d36c-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d36f-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d37c-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d382-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d386-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d387-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d388-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d38b-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d38f-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d390-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d391-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d393-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d399-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d39d-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d39e-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d39f-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a2-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a6-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a7-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3a8-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3aa-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b0-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b4-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b5-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b6-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3b9-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3bb-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3bd-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3be-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3bf-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3df-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3eb-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d3f7-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d40e-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d413-93cb78b6,\n#w-node-_21ce9186-8f7a-4d3d-9c49-5c4a7640d418-93cb78b6 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_8475e6c8-39db-3a19-c868-b0f5e971523a-e9715238,\n#w-node-_8475e6c8-39db-3a19-c868-b0f5e971523b-e9715238 {\n    align-self: center\n}\n\n#w-node-_8475e6c8-39db-3a19-c868-b0f5e971523c-e9715238 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb325-93cb78b7,\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb327-93cb78b7,\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb32b-93cb78b7,\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb32d-93cb78b7,\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb331-93cb78b7,\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb333-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb337-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-_683897d9-f8fa-ae9a-371b-01cf90ffb339-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a64-93cb78b7,\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a65-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a66-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad1-93cb78b7,\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad2-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad3-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b6-93cb78b7,\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b7-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b8-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f7-93cb78b7,\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f8-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f9-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce0-93cb78b7,\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce1-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce2-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8191-93cb78b7,\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8192-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8193-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73955-93cb78b7,\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73956-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73957-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_12aca550-6cf7-7049-82bf-0e8acd3f0ad9-93cb78b7,\n#w-node-_12aca550-6cf7-7049-82bf-0e8acd3f0ada-93cb78b7 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_12aca550-6cf7-7049-82bf-0e8acd3f0adb-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78b7,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78b7,\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a594-93cb78b8,\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a596-93cb78b8,\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a59a-93cb78b8,\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a59c-93cb78b8,\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a0-93cb78b8,\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a2-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a6-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-_70a9c6fe-fb1d-497c-8000-6daa8726a5a8-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65883f-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658841-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658863-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658866-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658869-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65886c-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65886f-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658874-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658878-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65887c-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658881-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658885-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658889-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65888e-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658892-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658896-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65889b-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588a8-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ae-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588af-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b0-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b6-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b7-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588b8-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ba-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588bb-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588bc-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ce-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588cf-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d0-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d2-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d3-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588d4-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_2f7ea246-e8c2-43a7-18c5-1f5254695811-93cb78b8,\n#w-node-_2f7ea246-e8c2-43a7-18c5-1f5254695812-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_2f7ea246-e8c2-43a7-18c5-1f5254695813-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588dd-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588e3-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588e4-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588e5-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588eb-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ec-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ed-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ef-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588f0-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588f1-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6588ff-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658900-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658901-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658903-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658904-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658905-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_962a133b-0258-976a-44b9-2ceae20dfa66-93cb78b8,\n#w-node-_962a133b-0258-976a-44b9-2ceae20dfa67-93cb78b8 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_962a133b-0258-976a-44b9-2ceae20dfa68-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658914-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658917-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65891a-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65891d-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658920-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658923-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658926-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658929-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65892c-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65892f-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658932-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658935-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658938-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65893b-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65893e-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658941-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658944-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658947-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658954-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65895a-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65895e-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65895f-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658960-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658963-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658967-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658968-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658969-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65896b-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658971-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658975-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658976-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658977-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65897a-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65897e-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65897f-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658980-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658982-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658988-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65898c-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65898d-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f65898e-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658991-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658993-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658995-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658996-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f658997-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589a6-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589b2-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589be-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589d5-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589da-93cb78b8,\n#w-node-_506f084e-7d79-6faa-e4a0-6dd87f6589df-93cb78b8,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a64-93cb78b9,\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a65-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a66-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad1-93cb78b9,\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad2-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad3-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b6-93cb78b9,\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b7-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b8-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f7-93cb78b9,\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f8-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f9-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce0-93cb78b9,\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce1-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce2-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8191-93cb78b9,\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8192-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8193-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73955-93cb78b9,\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73956-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73957-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-f139e468-f3cc-b550-c8a9-1de40b14318d-93cb78b9,\n#w-node-f139e468-f3cc-b550-c8a9-1de40b14318e-93cb78b9 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-f139e468-f3cc-b550-c8a9-1de40b14318f-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78b9,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78b9,\n#w-node-b385e230-e21c-0748-6ce3-931872347272-93cb78ba,\n#w-node-b385e230-e21c-0748-6ce3-931872347274-93cb78ba,\n#w-node-b385e230-e21c-0748-6ce3-931872347278-93cb78ba,\n#w-node-b385e230-e21c-0748-6ce3-93187234727a-93cb78ba,\n#w-node-b385e230-e21c-0748-6ce3-93187234727e-93cb78ba,\n#w-node-b385e230-e21c-0748-6ce3-931872347280-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b385e230-e21c-0748-6ce3-931872347284-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-b385e230-e21c-0748-6ce3-931872347286-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdae4-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdae6-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdaf6-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdaf9-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdafc-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdaff-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb02-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb07-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb0b-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb0f-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb14-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb18-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb1c-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb21-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb25-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb29-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb2e-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb3a-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb40-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb41-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb42-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb44-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb45-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb46-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb48-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb49-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4a-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4c-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4d-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb4e-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb50-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb51-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb52-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb54-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb55-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb56-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb58-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb59-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5a-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_370dedee-316c-4be9-49c2-89861a32b8b0-93cb78ba,\n#w-node-_370dedee-316c-4be9-49c2-89861a32b8b1-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_370dedee-316c-4be9-49c2-89861a32b8b2-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5c-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5d-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb5e-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ee4d4f42-97e9-7e3a-eab0-1c117325c278-93cb78ba,\n#w-node-ee4d4f42-97e9-7e3a-eab0-1c117325c279-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-ee4d4f42-97e9-7e3a-eab0-1c117325c27a-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb63-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb69-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6a-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6b-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6d-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6e-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb6f-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb71-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb72-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb73-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb75-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb76-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb77-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb7d-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb7e-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb7f-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb81-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb82-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb83-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb85-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb86-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb87-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-db001b84-f4b1-ad0c-99c6-e8cb56067042-93cb78ba,\n#w-node-db001b84-f4b1-ad0c-99c6-e8cb56067043-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-db001b84-f4b1-ad0c-99c6-e8cb56067044-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-df7e24ca-197c-5c1d-7d23-7b10530caa28-93cb78ba,\n#w-node-df7e24ca-197c-5c1d-7d23-7b10530caa29-93cb78ba {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-df7e24ca-197c-5c1d-7d23-7b10530caa2a-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb8e-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb91-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb94-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb97-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb9a-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdb9d-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba0-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba3-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba6-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdba9-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbac-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbaf-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbb2-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbb5-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbb8-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbbb-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbbe-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbc1-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbce-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbd4-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbd8-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbd9-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbda-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbdd-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe1-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe2-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe3-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbe5-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbeb-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbef-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf0-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf1-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf4-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf8-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbf9-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbfa-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdbfc-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc02-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc06-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc07-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc08-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc0b-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc0d-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc0f-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc10-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc11-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc2d-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc39-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc45-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc5c-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc61-93cb78ba,\n#w-node-b8e47130-ff41-8710-80a0-4da2bc5cdc66-93cb78ba,\n#w-node-b7843a38-8800-5dce-e230-aa37d1f45b58-93cb78bc,\n#w-node-_4ae47232-fe84-b81d-ec86-6ef0a9a05741-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-b7843a38-8800-5dce-e230-aa37d1f45b60-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-_247107bd-ea7e-f150-8aab-5e83264224c2-93cb78bc,\n#w-node-_0710f280-2de1-6112-1c8a-3a8c42df3dd5-93cb78bc,\n#w-node-f3ed03bf-0076-a5b2-c842-4244e1bc4f0b-93cb78bc,\n#w-node-_8870acee-c89d-ea76-5824-db449952b297-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_5d8806f5-21bf-378f-bf6f-05c90c6677a9-93cb78bc,\n#w-node-ff86c5c4-dd1d-0d60-826d-fedd7202a63d-93cb78bc,\n#w-node-_80858616-7b6b-599c-e202-a7b601bfce51-93cb78bc,\n#w-node-c70fbda4-b5d3-b387-a67b-777788e6d745-93cb78bc,\n#w-node-c557f283-e16e-25d8-3b90-2de4ff048945-93cb78bc,\n#w-node-_9938b4e5-31d2-1c93-138d-bae4bc269111-93cb78bc,\n#w-node-_29c117df-af6c-3305-f610-d2c036ddb7c4-93cb78bc,\n#w-node-_95160acb-683b-9387-1985-2cd71e40aeb5-93cb78bc,\n#w-node-bd2c90a3-3449-cd68-9ce5-a364ea69e078-93cb78bc,\n#w-node-_4fcb369a-6251-e873-6667-b7606c289ad8-93cb78bc,\n#w-node-_277c8042-d460-4cfa-a115-ba668ba2a14a-93cb78bc,\n#w-node-_76746d7c-2b97-095c-54e0-bbf14503bbdd-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_5070e47b-833d-0883-324a-f424cecfb905-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-fbc1a123-a2b3-ebc6-adcd-6b93255a19b6-93cb78bc,\n#w-node-_8ddce519-2261-9d1e-3eec-a671cf28b9bf-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-f4c80b7f-9c49-67e7-34af-c9f2b362ef29-93cb78bc,\n#w-node-efc1cc14-56a8-05d8-f6a1-bf99658d6d05-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-efc1cc14-56a8-05d8-f6a1-bf99658d6d06-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-efc1cc14-56a8-05d8-f6a1-bf99658d6d07-93cb78bc,\n#w-node-_422fb230-2d36-045c-b853-0f8089d82e62-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_422fb230-2d36-045c-b853-0f8089d82e63-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_422fb230-2d36-045c-b853-0f8089d82e64-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_22d8bcb9-b51f-eaf0-a315-9656f3a41d4a-93cb78bc,\n#w-node-_22d8bcb9-b51f-eaf0-a315-9656f3a41d4b-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_22d8bcb9-b51f-eaf0-a315-9656f3a41d4c-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-bada1742-743b-7fff-4387-a5508857c704-93cb78bc,\n#w-node-bada1742-743b-7fff-4387-a5508857c705-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-bada1742-743b-7fff-4387-a5508857c706-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-ed787b6d-1248-22d0-9ad4-06210883ecb9-93cb78bc,\n#w-node-ed787b6d-1248-22d0-9ad4-06210883ecba-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-ed787b6d-1248-22d0-9ad4-06210883ecbb-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-d0bb2a30-4ba7-6a21-54b9-d9c8c842599f-93cb78bc,\n#w-node-d0bb2a30-4ba7-6a21-54b9-d9c8c84259a0-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-d0bb2a30-4ba7-6a21-54b9-d9c8c84259a1-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_1190ae00-6e66-4235-8e95-18807d06cde2-93cb78bc,\n#w-node-_1190ae00-6e66-4235-8e95-18807d06cde3-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_1190ae00-6e66-4235-8e95-18807d06cde4-93cb78bc,\n#w-node-beb30fc9-0059-c6b1-8ec9-b3284a75f41d-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d3-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d4-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d5-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d7-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d8-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38d9-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38db-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38dc-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38dd-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38df-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e0-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e1-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e3-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e4-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e5-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e7-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e8-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38e9-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38eb-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38ec-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38ed-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38ef-93cb78bc,\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38f0-93cb78bc {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-dc8d2af6-cb15-6e07-ef0a-94230e6d38f1-93cb78bc,\n#w-node-_9b94c343-de9a-9f9f-6748-38765931e14c-93cb78bc,\n#w-node-_34db14ca-c4bc-39b2-8564-17e325a376a7-93cb78bc,\n#w-node-_5bf3ab00-42aa-b93c-08a1-a1fbb4fcc9a2-93cb78bc,\n#w-node-e88aaeb4-76ef-92dc-136a-9c75180c1026-93cb78bc,\n#w-node-_6f631e88-9f85-5145-e1e6-48c0215e450b-93cb78bc,\n#w-node-bcc2b0c3-a89e-7b50-6a2e-d1eac0ddcd37-93cb78bc,\n#w-node-_56469230-0be4-65e8-dade-8eb2e4d19f96-93cb78bc,\n#w-node-ee8e0457-bdd1-61c6-2506-90e91ce6c0d9-93cb78bc,\n#w-node-_1dc87aa8-dc11-693b-a78d-8cf287d3d098-93cb78bc,\n#w-node-_001b5ef1-6555-efb9-a5b1-2ef6292c022b-93cb78bc,\n#w-node-_80741575-7979-8032-b539-3c65c770d3fe-93cb78bc,\n#w-node-a4cbe887-b45f-57ca-9427-33d9ee636751-93cb78bc,\n#w-node-_753d7c15-e45b-0263-7c4e-c9bdc827e246-93cb78bc,\n#w-node-_48c2a45d-8050-4c9a-9e5e-b7b30c1b96b7-93cb78bc,\n#w-node-_88318a72-bb06-1bed-13c7-a358263bd9fc-93cb78bc,\n#w-node-_8a37ae3f-78be-543c-f8f8-7732a0d67e14-93cb78bc,\n#w-node-_68709c64-fc28-3f96-d6f6-300f310b66a3-93cb78bc,\n#w-node-a32f74f7-cbac-2fdc-750a-2ad4049532bc-93cb78bc,\n#w-node-ca5e02d1-c2a4-1e74-9e4a-7e1536660834-93cb78bc,\n#w-node-e60dd6c9-6c87-5cb7-0032-909bdd5b5548-93cb78bc,\n#w-node-_3bc4b485-30b3-9c77-9dd4-daff85074425-93cb78bc,\n#w-node-_7172ba28-4768-784c-4e73-269c4a4258e9-93cb78bc,\n#w-node-a954e68b-9ec7-bd59-76be-bdc986833218-93cb78bc,\n#w-node-_06ad1068-ce3c-99c6-a065-ac3be19415b0-93cb78bc,\n#w-node-_8fb350b8-2f59-46fe-6880-a4cd7cdb52f5-93cb78bc,\n#w-node-_8fb350b8-2f59-46fe-6880-a4cd7cdb52f6-93cb78bc,\n#w-node-c732a22a-a7f5-84fe-9d9e-4cf56d7f911c-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062ccd-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062cd3-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062cd6-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062cd7-93cb78bc,\n#w-node-_49fe0344-c4d1-3650-0707-45c05c88cdf5-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062cd9-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062cdc-93cb78bc,\n#w-node-bbed632f-2fe9-adb2-739f-822d14062cdd-93cb78bc,\n#w-node-e99fe387-b8d6-56b3-e2a4-44af11da6bba-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddaf5-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddafb-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddafe-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddaff-93cb78bc,\n#w-node-_0e3191a1-a370-2bce-26a4-004ee9fcb811-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddb01-93cb78bc,\n#w-node-_86986f42-4836-4c9e-8d95-af16c8fe7858-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddb04-93cb78bc,\n#w-node-d6c12f43-51df-dd3d-5e6f-fe2baf4ddb05-93cb78bc,\n#w-node-f19d1ce7-44bc-a6e3-f9ba-671da4eec333-93cb78bc,\n#w-node-_2ba78627-dd6b-248c-9b00-4caa17872f8c-93cb78bc,\n#w-node-_5f584a56-6eb9-2bdd-a3e0-350274e5f538-93cb78bc,\n#w-node-_086669d1-492a-ef77-a73a-b56985608bbf-93cb78bc,\n#w-node-_40eb5e87-5586-0a6f-3570-323485032148-93cb78bc,\n#w-node-_50dd7425-4bfd-f928-f542-058d4cc341f8-93cb78bc,\n#w-node-_7a8efeeb-f54d-d2cf-1ec7-cad5cc661932-93cb78bc,\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1cd-93cb78bf,\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1cf-93cb78bf,\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1d3-93cb78bf,\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1d5-93cb78bf,\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1d9-93cb78bf,\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1db-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1df-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-d5e35d94-8eba-106a-d387-d721f782b1e1-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274608-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274609-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460a-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460d-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27460e-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78bf {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78bf,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78bf,\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d645a-93cb78c0,\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d645c-93cb78c0,\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6460-93cb78c0,\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6462-93cb78c0,\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6466-93cb78c0,\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d6468-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d646c-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-d90ca9c5-4154-0bea-5a45-16baab7d646e-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274539-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27453b-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274557-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455a-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27455d-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274560-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274563-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274568-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27456c-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274570-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274575-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274579-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27457d-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274582-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274586-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458a-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27458f-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a1-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a7-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a8-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745a9-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ab-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ac-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ad-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745af-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b0-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: start\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b1-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b3-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b4-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b5-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b7-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b8-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745b9-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bb-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bc-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bd-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745bf-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c0-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c1-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c3-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c4-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c5-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c7-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c8-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745c9-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d7-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d8-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745d9-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a64-93cb78c0,\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a65-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-aa00aef3-a684-e63a-c715-f34ea3657a66-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad1-93cb78c0,\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad2-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_090fc494-de17-f3d1-1a26-867af8f48ad3-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b6-93cb78c0,\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b7-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_5fe28457-e3aa-979e-af75-d9779d3e48b8-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745de-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e4-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e5-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e6-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e8-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745e9-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ea-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ec-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ed-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745ee-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f0-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f1-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f2-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f7-93cb78c0,\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f8-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_6c1dd9e3-1f26-93a0-1e84-6acf6869d0f9-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce0-93cb78c0,\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce1-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_0c50aa3b-ac9b-46ea-970b-2b05b32dcce2-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8191-93cb78c0,\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8192-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-e320397f-4f1b-99fc-42d3-0b4afacf8193-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73955-93cb78c0,\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73956-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-_9b4797a4-5237-c5f0-1a6f-79ba42d73957-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f4-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f5-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2745f6-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274600-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274601-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274602-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274604-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274605-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274606-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274610-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274611-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274612-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-f139e468-f3cc-b550-c8a9-1de40b14318d-93cb78c0,\n#w-node-f139e468-f3cc-b550-c8a9-1de40b14318e-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-f139e468-f3cc-b550-c8a9-1de40b14318f-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274619-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461c-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27461f-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274622-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274625-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274628-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462b-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27462e-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274631-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274634-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274637-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463a-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27463d-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274640-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274643-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274646-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274649-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27464c-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274659-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27465f-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274663-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274664-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274665-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274668-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466c-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466d-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27466e-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274670-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274676-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467a-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467b-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467c-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27467f-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274683-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274684-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274685-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274687-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27468d-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274691-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274692-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274693-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274696-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf274698-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469a-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469b-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf27469c-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746ab-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746b7-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746c3-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746da-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746df-93cb78c0,\n#w-node-c5239bd4-3b59-a15c-0f74-c35bbf2746e4-93cb78c0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3e6-93cb78e9 {\n    align-self: center;\n    justify-self: center\n}\n\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3f2-93cb78e9,\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3f5-93cb78e9,\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e3f7-93cb78e9,\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e403-93cb78e9,\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e40f-93cb78e9,\n#w-node-_46e8387b-cd2d-f3a2-20ff-08c423b8e41c-93cb78e9,\n#w-node-_3deb8624-686e-65dd-c431-d20a4a0d702b-93cb78ec,\n#w-node-e8413fa3-2c14-0318-3f47-800a00971205-93cb78ec {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c20425a6-2326-4d4c-8b3b-f0cbe553034b-93cb7909,\n#w-node-_23766549-02ab-9520-0510-6850153dfa6b-93cb7909,\n#w-node-_94c7a407-ac95-9054-83ec-f8485a2bb894-93cb7909,\n#w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793c7-93cb7909,\n#w-node-_283026b3-5294-dee5-3d5a-4352e93cc0d3-93cb7909 {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-f1973054-052b-d1ae-a328-bda7591538fe-93cb790a,\n#w-node-_61e41015-1507-d45c-6189-48f5370afa39-93cb790a,\n#w-node-eda86f13-9e2e-5cb1-0955-adbe8cda26b4-93cb790a,\n#w-node-c578f11d-da2e-6ac7-8e4f-b8a9acb657c0-93cb790a,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085a-93cb790a,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f4085d-93cb790a,\n#w-node-_16bac122-62d5-4ae5-2321-539bf7f40860-93cb790a,\n#w-node-_1bb4c74f-569d-d4e4-aaf7-5ffc079925b8-93cb790a,\n#w-node-_81440cd4-8bf6-395c-84ed-f4d14ec95ebf-93cb790a,\n#w-node-_10ad6a87-c1bd-5211-ef01-29c2bc1e7e3a-93cb790a,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814814-93cb790a,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814816-93cb790a {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481a-93cb790a {\n    grid-area: span 1/span 1/span 1/span 1;\n    align-self: center\n}\n\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c81481c-93cb790a,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814820-93cb790a,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814822-93cb790a,\n#w-node-_15b99ec8-0277-810a-61ae-d60174f26cf5-93cb790a,\n#w-node-_15b99ec8-0277-810a-61ae-d60174f26cf7-93cb790a,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814826-93cb790a,\n#w-node-fc038d3d-1dfb-37d5-d6ee-ec680c814828-93cb790a {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f3-93cb790a {\n    align-self: auto\n}\n\n#w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb790a {\n    grid-area: 2/3/3/4\n}\n\n#w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb790a {\n    grid-area: 1/6/2/7\n}\n\n#w-node-c8a0ed9a-079c-e85c-e684-42e4dfe5e13c-93cb790f,\n#w-node-c8a0ed9a-079c-e85c-e684-42e4dfe5e140-93cb790f {\n    align-self: auto\n}\n\n#w-node-_058047f0-d9c2-4ec8-f4b3-063d874f13e7-93cb7923,\n#w-node-_9118a212-9442-628d-ac5e-6da2ee54cda9-93cb7923,\n#w-node-_06d05749-8911-70e8-b36d-954d89430ab7-93cb7923,\n#w-node-_6e693b13-83bc-712c-839a-f2e50d8a4afc-93cb7924,\n#w-node-_98297c28-e473-00ed-b583-8c52be085aad-93cb7924,\n#w-node-d1833798-6b2f-fa9b-2099-c04947765649-93cb7924 {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc90-93cb7926,\n#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc97-93cb7926,\n#w-node-e0cbc0be-00fd-98f5-b10d-4da23452dc9e-93cb7926 {\n    justify-self: center\n}\n\n#w-node-dc76907a-f8e2-c218-e3c1-24a1cf800667-93cb7926,\n#w-node-dc76907a-f8e2-c218-e3c1-24a1cf800669-93cb7926,\n#w-node-dc76907a-f8e2-c218-e3c1-24a1cf80066f-93cb7926,\n#w-node-_32082f67-c36e-9e61-9cc0-0c92ae54d935-93cb7926,\n#w-node-_960c03db-0819-8e0d-88ea-bab860117e0d-93cb7926,\n#w-node-_8901cafc-90ec-6686-6166-2f9c3cd72f67-93cb7926,\n#w-node-_8901cafc-90ec-6686-6166-2f9c3cd72f68-93cb7926,\n#w-node-f8c96113-f23f-2c06-265d-cc7a6f1315ce-93cb7926,\n#w-node-f8c96113-f23f-2c06-265d-cc7a6f1315cf-93cb7926 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6f3189e8-a31e-17ec-e872-f40da31437cb-8676de95 {\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-_339c5877-5ff7-32e3-7e05-334be1c8c17e-8676de95 {\n    align-self: center\n}\n\n#w-node-b9e4e460-f87c-7e25-eb78-1c9629344a2c-8676de95,\n#w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb744e-8676de95,\n#w-node-_824071e6-0194-461f-12d0-08eb4cf1c6c4-8676de95,\n#w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d124-8676de95,\n#w-node-_59911d5d-48ab-6fca-f96d-fd4652474e12-8676de95,\n#w-node-a3b4ce1c-50b1-5fa5-1462-df981ec6e574-1adf4b3b,\n#w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d4b-1adf4b3b,\n#w-node-bb0cd039-e522-80e3-0a35-b1a518695189-1adf4b3b,\n#w-node-eff55037-24c4-870b-155a-a9728acbb7e3-ac2ff666,\n#w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f039f-ac2ff666,\n#w-node-e47ab1f6-152e-159a-b9a6-e38ea9b45f92-ac2ff666,\n#w-node-e9401e50-06e1-0862-cc4e-029899dc72cc-c64f9a6b,\n#w-node-_09ac2a08-b917-4337-bd8f-050cee23acf2-c64f9a6b,\n#w-node-_162aae03-c586-ae88-6ad4-531388f54214-c64f9a6b {\n    align-self: auto;\n    justify-self: auto\n}\n\n#w-node-_819a1707-791c-b7da-200a-5b1c138b7708-952caff1,\n#w-node-c1ddc278-5523-7778-97d0-329436819f82-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f83-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f84-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f85-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f86-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f87-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f88-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f89-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f8a-27d2a40c,\n#w-node-c1ddc278-5523-7778-97d0-329436819f8b-27d2a40c {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-c64d297c-7f60-b05a-22aa-1b0a3ac39485-3ac3946f {\n    grid-area: 1/1/2/2\n}\n\n#w-node-_798f30d4-70ab-03fa-cdde-6710fcae902b-fcae901f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-f9661c9f-41e0-1500-2752-16794f57f181-077d536b {\n    align-self: center;\n    justify-self: auto\n}\n\n#w-node-ff29dc34-7dc7-788a-0eee-79a242f86988-077d536b {\n    justify-self: auto\n}\n\n#w-node-_65b26a55-76d8-c122-4a51-7ba062cf4d2a-077d536b {\n    justify-self: end\n}\n\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5df6-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5df8-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5dfc-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5dfe-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e02-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e04-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e08-e1586dd0,\n#w-node-_5e3c4744-f8c0-e48b-a36b-a6d66cea5e0a-e1586dd0 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_4e9fc0c4-34d6-0e39-fb29-e29d5a662dc3-2d3663e1 {\n    align-self: stretch;\n    justify-self: auto\n}\n\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62ce2-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62ce4-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62ce8-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cea-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf0-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf2-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf6-41739e32,\n#w-node-da7ae3c7-8de6-80e2-f99c-9ca83bc62cf8-41739e32,\n#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f6e-38aa0f2b,\n#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f78-38aa0f2b,\n#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f7d-38aa0f2b,\n#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f8b-38aa0f2b,\n#w-node-eafb8ee2-246e-779a-f539-8b9c38aa0f96-38aa0f2b,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a33-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a35-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a39-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a3b-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a3f-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a41-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a45-fe2f2a10,\n#w-node-_27bc17ab-a5a4-7fb6-875a-65b5fe2f2a47-fe2f2a10 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_6c5b7f4c-42b3-6447-10f0-26cb1463137a-1db4e30c {\n    align-self: stretch;\n    justify-self: auto\n}\n\n#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a08-f31fda6f,\n#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a0e-f31fda6f,\n#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a1d-f31fda6f,\n#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a2c-f31fda6f {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a43-f31fda6f {\n    grid-area: span 1/span 1/span 1/span 1;\n    justify-self: auto\n}\n\n#w-node-_7585a360-7847-67ba-0978-b8320fb22440-e9d43c82,\n#w-node-_2aaf64a3-1135-b40a-19f6-8221da49343d-e9d43c82 {\n    grid-area: 1/1/2/2\n}\n\n#w-node-_8cce25ef-775e-6687-e6f6-59689e610d26-6fe592a5,\n#w-node-e2c822fa-b8d5-5acc-f476-11980cbc88c6-6fe592a5 {\n    grid-area: span 1/span 1/span 1/span 1\n}\n\n#w-node-_7771d834-f93a-d303-7b97-685f736546a7-6fe592a5 {\n    align-self: center;\n    justify-self: start\n}\n\n#w-node-f5fef4f6-53bb-e3dc-28ab-68424dab6395-6fe592a5,\n#w-node-_1d09d740-c52f-5379-5c77-c9d314ebadbd-6fe592a5,\n#w-node-_5841ebaa-c8ab-1bd5-74ae-64556d84782f-6fe592a5,\n#w-node-ce2c2b4b-69cc-5d72-1832-78c732b3bc79-6fe592a5,\n#w-node-fb905444-be2f-bac8-b7a6-80cd86ea722f-6fe592a5,\n#w-node-fb905444-be2f-bac8-b7a6-80cd86ea7230-6fe592a5,\n#w-node-f6604f73-3c58-e8fe-ca82-892f82db4030-6fe592a5,\n#w-node-f6604f73-3c58-e8fe-ca82-892f82db4031-6fe592a5,\n#w-node-_61975f25-6d86-9949-f10c-b21da6ee5588-6fe592a5,\n#w-node-_61975f25-6d86-9949-f10c-b21da6ee5589-6fe592a5,\n#w-node-cd0d853b-2f0b-18dd-b0d3-bedefb1f7c95-6fe592a5,\n#w-node-cd0d853b-2f0b-18dd-b0d3-bedefb1f7c94-6fe592a5,\n#w-node-e3416bc3-31eb-c64a-8da7-8fe8ff61e686-6fe592a5,\n#w-node-e3416bc3-31eb-c64a-8da7-8fe8ff61e687-6fe592a5,\n#w-node-ea8ae60d-decd-9c1f-1eea-f7d0dcec360b-6fe592a5,\n#w-node-ea8ae60d-decd-9c1f-1eea-f7d0dcec360a-6fe592a5,\n#w-node-_0b3e8a7e-6358-5c0d-34b5-81c3bcaccdd1-6fe592a5,\n#w-node-_0b3e8a7e-6358-5c0d-34b5-81c3bcaccdd2-6fe592a5 {\n    align-self: center;\n    justify-self: center\n}\n\n@media screen and (min-width:1920px) {\n    #w-node-d862036f-348e-95b1-d411-9d2c13184902-93cb773c {\n        order: 9999\n    }\n\n    #w-node-d862036f-348e-95b1-d411-9d2c13184904-93cb773c,\n    #w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c400-93cb773c {\n        justify-self: start\n    }\n\n    #w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c409-93cb773c {\n        order: -9999\n    }\n\n    #w-node-_01b5676c-0c15-b261-4ad0-393603f95b9d-93cb773c {\n        order: 9999\n    }\n\n    #w-node-_01b5676c-0c15-b261-4ad0-393603f95b9f-93cb773c {\n        justify-self: start\n    }\n\n    #w-node-_477dd745-7085-6a73-b282-eb4d23ba5f2f-93cb77fe {\n        grid-area: span 1/span 1/span 1/span 1\n    }\n\n    #w-node-b0c1b0f7-ed8e-ea97-04b6-e67ede012b0c-93cb7800 {\n        order: 9999\n    }\n\n    #w-node-b0c1b0f7-ed8e-ea97-04b6-e67ede012b0e-93cb7800,\n    #w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabf6-93cb7800 {\n        justify-self: start\n    }\n\n    #w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabff-93cb7800 {\n        order: -9999\n    }\n\n    #w-node-bad18347-b3e3-3b17-d808-7320f8eab480-93cb7800 {\n        order: 9999\n    }\n\n    #w-node-bad18347-b3e3-3b17-d808-7320f8eab482-93cb7800,\n    #w-node-_7128d008-abfe-92cd-ad02-a2227f76f33a-93cb7800 {\n        justify-self: start\n    }\n\n    #w-node-_7128d008-abfe-92cd-ad02-a2227f76f343-93cb7800 {\n        order: -9999\n    }\n\n    #w-node-_8ea22c76-2344-1281-9838-1dc5c6e1102e-93cb7800 {\n        order: 9999\n    }\n\n    #w-node-_8ea22c76-2344-1281-9838-1dc5c6e11030-93cb7800 {\n        justify-self: start\n    }\n\n    #w-node-_36d2a246-cb39-7c89-6d4f-0332607907af-93cb780d {\n        order: 9999\n    }\n\n    #w-node-_36d2a246-cb39-7c89-6d4f-0332607907b1-93cb780d,\n    #w-node-_77bb34f1-1340-c927-6fb8-6482a7f1913c-93cb780d {\n        justify-self: start\n    }\n\n    #w-node-_77bb34f1-1340-c927-6fb8-6482a7f19145-93cb780d {\n        order: -9999\n    }\n\n    #w-node-_90f6eeec-2560-e528-eaba-6048ad0318ec-93cb780d {\n        order: 9999\n    }\n\n    #w-node-_90f6eeec-2560-e528-eaba-6048ad0318ee-93cb780d {\n        justify-self: start\n    }\n\n    #w-node-_4ba668e6-ca36-cc5b-7bf7-f42be58e064b-93cb7819,\n    #w-node-_5d57aa1a-c76b-efa2-b432-d6a8ca24d810-93cb7819 {\n        align-self: center\n    }\n\n    #w-node-_1a9ad16a-cf91-4631-ccd5-84cc1676b57c-93cb781e {\n        order: 9999\n    }\n\n    #w-node-_1a9ad16a-cf91-4631-ccd5-84cc1676b57e-93cb781e,\n    #w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb6b-93cb781e {\n        justify-self: start\n    }\n\n    #w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb74-93cb781e {\n        order: -9999\n    }\n\n    #w-node-f7bf232d-31e6-0823-e8a7-3e7f893b7fd1-93cb781e {\n        order: 9999\n    }\n\n    #w-node-f7bf232d-31e6-0823-e8a7-3e7f893b7fd3-93cb781e {\n        justify-self: start\n    }\n\n    #w-node-fd1a957a-533a-8824-006b-7313a5dccedb-93cb7832 {\n        order: 9999\n    }\n\n    #w-node-fd1a957a-533a-8824-006b-7313a5dccedd-93cb7832,\n    #w-node-b431b86b-f2f0-708d-f867-ce24ea365c74-93cb7832 {\n        justify-self: start\n    }\n\n    #w-node-b431b86b-f2f0-708d-f867-ce24ea365c7d-93cb7832 {\n        order: -9999\n    }\n\n    #w-node-_0fab30e8-69c7-8a91-ac45-f4adb0d1bb7a-93cb7832 {\n        order: 9999\n    }\n\n    #w-node-_0fab30e8-69c7-8a91-ac45-f4adb0d1bb7c-93cb7832 {\n        justify-self: start\n    }\n\n    #w-node-_8f080c5f-5d43-e1fe-8f50-fbd438ba3900-93cb7840 {\n        order: 9999\n    }\n\n    #w-node-_8f080c5f-5d43-e1fe-8f50-fbd438ba3902-93cb7840,\n    #w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61af-93cb7840 {\n        justify-self: start\n    }\n\n    #w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61b8-93cb7840 {\n        order: -9999\n    }\n\n    #w-node-_76f22f68-56ac-162e-498a-f1ddff7de17d-93cb7840 {\n        order: 9999\n    }\n\n    #w-node-_76f22f68-56ac-162e-498a-f1ddff7de17f-93cb7840,\n    #w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662f6-93cb7840 {\n        justify-self: start\n    }\n\n    #w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662ff-93cb7840 {\n        order: -9999\n    }\n\n    #w-node-_481a6ed2-1fcc-7792-07b9-f00d54825df1-93cb7847 {\n        order: 9999\n    }\n\n    #w-node-_481a6ed2-1fcc-7792-07b9-f00d54825df3-93cb7847,\n    #w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b39-93cb7847 {\n        justify-self: start\n    }\n\n    #w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b42-93cb7847 {\n        order: -9999\n    }\n\n    #w-node-e03e9185-11ce-791a-e264-dee25008c53a-93cb7847 {\n        order: 9999\n    }\n\n    #w-node-e03e9185-11ce-791a-e264-dee25008c53c-93cb7847 {\n        justify-self: start\n    }\n\n    #w-node-c20425a6-2326-4d4c-8b3b-f0cbe553034b-93cb7909 {\n        order: 9999\n    }\n\n    #w-node-c20425a6-2326-4d4c-8b3b-f0cbe553034d-93cb7909,\n    #w-node-_23766549-02ab-9520-0510-6850153dfa62-93cb7909 {\n        justify-self: start\n    }\n\n    #w-node-_23766549-02ab-9520-0510-6850153dfa6b-93cb7909 {\n        order: -9999\n    }\n\n    #w-node-_94c7a407-ac95-9054-83ec-f8485a2bb894-93cb7909 {\n        order: 9999\n    }\n\n    #w-node-_94c7a407-ac95-9054-83ec-f8485a2bb896-93cb7909,\n    #w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793be-93cb7909 {\n        justify-self: start\n    }\n\n    #w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793c7-93cb7909 {\n        order: -9999\n    }\n\n    #w-node-_283026b3-5294-dee5-3d5a-4352e93cc0d3-93cb7909 {\n        order: 9999\n    }\n\n    #w-node-_283026b3-5294-dee5-3d5a-4352e93cc0d5-93cb7909 {\n        justify-self: start\n    }\n\n    #w-node-_058047f0-d9c2-4ec8-f4b3-063d874f13e7-93cb7923 {\n        order: 9999\n    }\n\n    #w-node-_058047f0-d9c2-4ec8-f4b3-063d874f13e9-93cb7923,\n    #w-node-_9118a212-9442-628d-ac5e-6da2ee54cda0-93cb7923 {\n        justify-self: start\n    }\n\n    #w-node-_9118a212-9442-628d-ac5e-6da2ee54cda9-93cb7923 {\n        order: -9999\n    }\n\n    #w-node-_06d05749-8911-70e8-b36d-954d89430ab7-93cb7923 {\n        order: 9999\n    }\n\n    #w-node-_06d05749-8911-70e8-b36d-954d89430ab9-93cb7923 {\n        justify-self: start\n    }\n\n    #w-node-_6e693b13-83bc-712c-839a-f2e50d8a4afc-93cb7924 {\n        order: 9999\n    }\n\n    #w-node-_6e693b13-83bc-712c-839a-f2e50d8a4afe-93cb7924,\n    #w-node-_98297c28-e473-00ed-b583-8c52be085aa4-93cb7924 {\n        justify-self: start\n    }\n\n    #w-node-_98297c28-e473-00ed-b583-8c52be085aad-93cb7924 {\n        order: -9999\n    }\n\n    #w-node-d1833798-6b2f-fa9b-2099-c04947765649-93cb7924 {\n        order: 9999\n    }\n\n    #w-node-d1833798-6b2f-fa9b-2099-c0494776564b-93cb7924 {\n        justify-self: start\n    }\n\n    #w-node-b9e4e460-f87c-7e25-eb78-1c9629344a2c-8676de95 {\n        order: 9999\n    }\n\n    #w-node-b9e4e460-f87c-7e25-eb78-1c9629344a2e-8676de95,\n    #w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb7445-8676de95 {\n        justify-self: start\n    }\n\n    #w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb744e-8676de95 {\n        order: -9999\n    }\n\n    #w-node-_824071e6-0194-461f-12d0-08eb4cf1c6c4-8676de95 {\n        order: 9999\n    }\n\n    #w-node-_824071e6-0194-461f-12d0-08eb4cf1c6c6-8676de95,\n    #w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d11b-8676de95 {\n        justify-self: start\n    }\n\n    #w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d124-8676de95 {\n        order: -9999\n    }\n\n    #w-node-_59911d5d-48ab-6fca-f96d-fd4652474e12-8676de95 {\n        order: 9999\n    }\n\n    #w-node-_59911d5d-48ab-6fca-f96d-fd4652474e14-8676de95 {\n        justify-self: start\n    }\n\n    #w-node-a3b4ce1c-50b1-5fa5-1462-df981ec6e574-1adf4b3b {\n        order: 9999\n    }\n\n    #w-node-a3b4ce1c-50b1-5fa5-1462-df981ec6e576-1adf4b3b,\n    #w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d42-1adf4b3b {\n        justify-self: start\n    }\n\n    #w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d4b-1adf4b3b {\n        order: -9999\n    }\n\n    #w-node-bb0cd039-e522-80e3-0a35-b1a518695189-1adf4b3b {\n        order: 9999\n    }\n\n    #w-node-bb0cd039-e522-80e3-0a35-b1a51869518b-1adf4b3b {\n        justify-self: start\n    }\n\n    #w-node-eff55037-24c4-870b-155a-a9728acbb7e3-ac2ff666 {\n        order: 9999\n    }\n\n    #w-node-eff55037-24c4-870b-155a-a9728acbb7e5-ac2ff666,\n    #w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f0396-ac2ff666 {\n        justify-self: start\n    }\n\n    #w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f039f-ac2ff666 {\n        order: -9999\n    }\n\n    #w-node-e47ab1f6-152e-159a-b9a6-e38ea9b45f92-ac2ff666 {\n        order: 9999\n    }\n\n    #w-node-e47ab1f6-152e-159a-b9a6-e38ea9b45f94-ac2ff666 {\n        justify-self: start\n    }\n\n    #w-node-e9401e50-06e1-0862-cc4e-029899dc72cc-c64f9a6b {\n        order: 9999\n    }\n\n    #w-node-e9401e50-06e1-0862-cc4e-029899dc72ce-c64f9a6b,\n    #w-node-_09ac2a08-b917-4337-bd8f-050cee23ace9-c64f9a6b {\n        justify-self: start\n    }\n\n    #w-node-_09ac2a08-b917-4337-bd8f-050cee23acf2-c64f9a6b {\n        order: -9999\n    }\n\n    #w-node-_162aae03-c586-ae88-6ad4-531388f54214-c64f9a6b {\n        order: 9999\n    }\n\n    #w-node-_162aae03-c586-ae88-6ad4-531388f54216-c64f9a6b {\n        justify-self: start\n    }\n\n    #w-node-_55933a29-ee0c-5f05-a0c1-f345d2370167-f31fda6f {\n        justify-self: auto\n    }\n}\n\n@media screen and (min-width:1440px) {\n\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7742,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7742,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7742,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7742,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7742,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7742,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7742,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7742,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb77b6,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb77b6,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb77b6,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb77b6,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb77b6,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb77b6,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb77b6,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb77b6,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401a-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401b-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401c-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf401d-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf4047-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf4048-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf4049-93cb77fe,\n    #w-node-_73eff977-97ce-45b5-d9a8-e77525bf404a-93cb77fe,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7806,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7806,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7806,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7806,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7806,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7806,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7806,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7806,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7808,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7808,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7808,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7808,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7808,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7808,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7808,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7808,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb782d,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb782d,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb782d,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb782d,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb782d,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb782d,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb782d,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb782d,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7831,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7831,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7831,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7831,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7831,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7831,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7831,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7831,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb783f,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb783f,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb783f,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb783f,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb783f,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb783f,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb783f,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb783f,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7842,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7842,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7842,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7842,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7842,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7842,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7842,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7842,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7844,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7844,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7844,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7844,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7844,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7844,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7844,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7844,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7872,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7872,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7872,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7872,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7872,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7872,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7872,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7872,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7875,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7875,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7875,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7875,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7875,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7875,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7875,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7875,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7878,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7878,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7878,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7878,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7878,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7878,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7878,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7878,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb7879,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb7879,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb7879,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb7879,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb7879,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb7879,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb7879,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb7879,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb78b5,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb78b5,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb78b5,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb78b5,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb78b5,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb78b5,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb78b5,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb78b5,\n    #w-node-_25bbf697-f85d-3877-6432-bca0e6a388ec-93cb790a,\n    #w-node-_8ebf7023-1ca2-9ff9-802a-876f1d41257c-93cb790a,\n    #w-node-_0eacf595-794e-f4b3-de0e-23e5642a93d3-93cb790a,\n    #w-node-e13027a7-8404-ba0a-35f9-1b92de5529c2-93cb790a,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82f9-93cb790a,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fa-93cb790a,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fb-93cb790a,\n    #w-node-_014f9eed-dcc5-57f0-5c3e-3a601b6f82fc-93cb790a {\n        grid-area: span 1/span 1/span 1/span 1\n    }\n\n    #w-node-_4de89373-2018-f68d-53f7-7019f91df458-2d3663e1 {\n        justify-self: auto\n    }\n}\n\n@media screen and (min-width:1280px) {\n\n    #w-node-_3d3434d1-a202-57b4-e574-4c533e78a595-93cb7812,\n    #w-node-_1fbe0be4-1ea3-4a63-4199-fb712b11a9b0-93cb7812,\n    #w-node-a6d88170-cf40-dcec-fad2-5a893540766d-93cb7812,\n    #w-node-_3d3434d1-a202-57b4-e574-4c533e78a595-93cb7813,\n    #w-node-_1fbe0be4-1ea3-4a63-4199-fb712b11a9b0-93cb7813,\n    #w-node-a6d88170-cf40-dcec-fad2-5a893540766d-93cb7813,\n    #w-node-_3d3434d1-a202-57b4-e574-4c533e78a595-93cb7814,\n    #w-node-_1fbe0be4-1ea3-4a63-4199-fb712b11a9b0-93cb7814,\n    #w-node-a6d88170-cf40-dcec-fad2-5a893540766d-93cb7814 {\n        grid-area: span 1/span 1/span 1/span 1\n    }\n\n    #w-node-b7843a38-8800-5dce-e230-aa37d1f45b60-93cb78bc {\n        justify-self: center\n    }\n\n    #w-node-_247107bd-ea7e-f150-8aab-5e83264224b7-93cb78bc {\n        justify-self: auto\n    }\n}\n\n@media screen and (max-width:991px) {\n    #w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82 {\n        grid-area: span 1/span 2/span 1/span 2\n    }\n\n    #w-node-_5aad8a25-47ec-c84c-18fd-58b7e593c400-93cb773c {\n        order: 9999\n    }\n\n    #w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb507-93cb777e,\n    #w-node-_4ce35af5-58fc-280d-1d86-db98b4cbb509-93cb777e {\n        grid-area: span 1/span 1/span 1/span 1\n    }\n\n    #w-node-_15b69947-88f3-92e8-a7ba-fdff3d172a43-3d1729f0,\n    #w-node-befe73de-ec83-6b07-0c6d-dc06b93d869a-93cb77fc {\n        grid-area: span 1/span 2/span 1/span 2\n    }\n\n    #w-node-_14d6b874-d78a-32ff-e041-b9cdde0fabf6-93cb7800,\n    #w-node-_7128d008-abfe-92cd-ad02-a2227f76f33a-93cb7800 {\n        order: 9999\n    }\n\n    #w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb780a {\n        justify-self: center\n    }\n\n    #w-node-_77bb34f1-1340-c927-6fb8-6482a7f1913c-93cb780d {\n        order: 9999\n    }\n\n    #w-node-_4ba668e6-ca36-cc5b-7bf7-f42be58e0649-93cb7819,\n    #w-node-e4be6bd5-d7bc-15af-5134-0ec3fbe1d4e0-93cb7819 {\n        justify-self: center\n    }\n\n    #w-node-_9f8e4df4-c5c8-eb8a-e0f8-90c29f96bb6b-93cb781e,\n    #w-node-b431b86b-f2f0-708d-f867-ce24ea365c74-93cb7832 {\n        order: 9999\n    }\n\n    #w-node-_41fdb07b-387c-bef8-9004-83ed2dd6328a-93cb7834 {\n        grid-area: 2/1/4/2\n    }\n\n    #w-node-cb255365-ae57-3c38-c8e0-aaf3d85b61af-93cb7840,\n    #w-node-_6e7dc935-bae0-d3ce-14f2-f6c3866662f6-93cb7840,\n    #w-node-_771ce08b-f8b3-41a9-4fd0-211330a10b39-93cb7847 {\n        order: 9999\n    }\n\n    #w-node-_1dc8c3fe-dd74-ce3e-e0f4-63fafd190397-93cb784d {\n        grid-area: 2/3/2/2\n    }\n\n    #w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d {\n        grid-column-start: 1\n    }\n\n    #w-node-_78dbd686-4557-31f7-c2e8-0ddfac9f126c-93cb784d {\n        grid-area: 1/1/2/3\n    }\n\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf5e-93cb7871 {\n        grid-area: 2/3/2/2\n    }\n\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {\n        grid-column-start: 1\n    }\n\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf71-93cb7871 {\n        grid-area: 1/1/2/3\n    }\n\n    #w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7872,\n    #w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7872,\n    #w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb7879,\n    #w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb7879 {\n        grid-area: span 1/span 1/span 1/span 1\n    }\n\n    #w-node-_6474ffe6-2042-9657-3eb0-d8030abf5b85-93cb787a,\n    #w-node-e8413fa3-2c14-0318-3f47-800a00971205-93cb78ec {\n        justify-self: center\n    }\n\n    #w-node-_23766549-02ab-9520-0510-6850153dfa62-93cb7909,\n    #w-node-_38ad42f6-5013-9bb8-4f2d-bbc848b793be-93cb7909 {\n        order: 9999\n    }\n\n    #w-node-_63073c53-3564-740c-5325-6dd50186ae95-93cb790a,\n    #w-node-_63073c53-3564-740c-5325-6dd50186ae97-93cb790a {\n        grid-area: span 1/span 1/span 1/span 1\n    }\n\n    #w-node-_9118a212-9442-628d-ac5e-6da2ee54cda0-93cb7923,\n    #w-node-_98297c28-e473-00ed-b583-8c52be085aa4-93cb7924 {\n        order: 9999\n    }\n\n    #w-node-_339c5877-5ff7-32e3-7e05-334be1c8c17e-8676de95 {\n        justify-self: center\n    }\n\n    #w-node-_7d1e7f34-cc7b-7fd8-fc3e-79c9d7bb7445-8676de95,\n    #w-node-_96efbb25-48d7-f50c-b8f5-f1d62e45d11b-8676de95,\n    #w-node-_619362a8-3b53-e8ec-d9b8-d0d2d4a62d42-1adf4b3b,\n    #w-node-_34002620-b85d-fcdb-dcf4-3c55dc0f0396-ac2ff666,\n    #w-node-_09ac2a08-b917-4337-bd8f-050cee23ace9-c64f9a6b {\n        order: 9999\n    }\n\n    #w-node-f9661c9f-41e0-1500-2752-16794f57f181-077d536b {\n        align-self: center;\n        justify-self: auto\n    }\n\n    #w-node-_4de89373-2018-f68d-53f7-7019f91df458-2d3663e1 {\n        align-self: auto;\n        justify-self: auto\n    }\n\n    #w-node-_55933a29-ee0c-5f05-a0c1-f345d2370167-f31fda6f {\n        order: -9999\n    }\n\n    #w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a43-f31fda6f {\n        grid-area: span 1/span 2/span 1/span 2\n    }\n}\n\n@media screen and (max-width:767px) {\n    #w-node-b094e1d1-5991-5a05-e7ca-30e4a066e338-93cb77fc {\n        grid-column: span 1/span 1\n    }\n\n    #w-node-_1dc8c3fe-dd74-ce3e-e0f4-63fafd190397-93cb784d,\n    #w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d {\n        grid-row-start: 1;\n        grid-column-end: 3\n    }\n\n    #w-node-_78dbd686-4557-31f7-c2e8-0ddfac9f126c-93cb784d {\n        grid-area: 2/1/3/3\n    }\n\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf5e-93cb7871,\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {\n        grid-row-start: 1;\n        grid-column-end: 3\n    }\n\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf71-93cb7871 {\n        grid-area: 2/1/3/3\n    }\n\n    #w-node-_7f17079a-8881-0259-1eb8-c98eba1bae74-077d536b,\n    #w-node-_7f17079a-8881-0259-1eb8-c98eba1bae77-077d536b,\n    #w-node-_7f17079a-8881-0259-1eb8-c98eba1bae7a-077d536b,\n    #w-node-_2fa56ef2-738d-6ffc-950c-ebc00e1113f4-077d536b,\n    #w-node-_7cac7751-8645-8ec9-1db8-59c30615d0e7-077d536b,\n    #w-node-ffeb09cf-7ce9-9d9a-2bf8-f1c820068890-077d536b,\n    #w-node-_2ebbf7b3-e23c-2cba-d121-8b963a7c0f54-077d536b,\n    #w-node-df5960e5-9864-5112-4eeb-e6e31e4b7329-077d536b,\n    #w-node-_49d8deef-379f-633a-53a2-6063464b03d4-077d536b,\n    #w-node-_37a86e95-42f8-fa49-4c8d-e97556a84cf8-077d536b {\n        justify-self: center\n    }\n}\n\n@media screen and (max-width:479px) {\n    #w-node-_04f7ff85-bbba-0256-7cd8-9945cee9ccd2-cee9cc82 {\n        align-self: auto;\n        justify-self: center\n    }\n\n    #w-node-d26efc9b-757f-6b02-d6d9-6ed47e6eb92b-93cb77fc,\n    #w-node-_802fb8c7-6066-06bc-5774-9463292fba4a-93cb77fc {\n        justify-self: start\n    }\n\n    #w-node-befe73de-ec83-6b07-0c6d-dc06b93d869a-93cb77fc {\n        justify-self: auto\n    }\n\n    #w-node-_507e9163-ce1c-6370-08ce-bd76d88aae4b-93cb7822 {\n        justify-self: start\n    }\n\n    #w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa1-93cb782f,\n    #w-node-_96e7ec6f-12a1-f290-cef1-ec064fa7bfa6-93cb782f {\n        justify-self: center\n    }\n\n    #w-node-c9d841c6-b7de-201c-736b-087712626bc6-93cb7843 {\n        order: 9999\n    }\n\n    #w-node-_89365686-0e60-b5d9-afbe-98207cd79db3-93cb784d,\n    #w-node-_4f89a255-b6bf-ca6e-d307-23aa9cb6bf68-93cb7871 {\n        grid-area: 1/1/2/3\n    }\n\n    #w-node-e6a4efba-cebc-888a-a28d-c6d3864c4a43-f31fda6f {\n        align-self: auto;\n        justify-self: center\n    }\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c995ca5562a0a11b7_Satoshi-Black.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907b88df927eb6f0c609_Satoshi-Black.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a1ac7fc52b1f10764_Satoshi-Black.otf') format('opentype');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907cf0a732e6f6dd7265_Satoshi-Italic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907e5f5fbe0c50b486cc_Satoshi-VariableItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c49ffdcdf9e844e52_Satoshi-Italic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907efddb2a5b0b0255b5_Satoshi-VariableItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22ae354a81e1a6e8ecc_Satoshi-Italic.otf') format('opentype');\n    font-weight: 400;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907cfa78fa2fb5884cf6_Satoshi-Light.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d2e5dae3050d6a4ae_Satoshi-Light.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22ac9ea3efa94b78d44_Satoshi-Light.otf') format('opentype');\n    font-weight: 300;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c5f5fbe79fdb486ca_Satoshi-BlackItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c79ce670bb3daca1f_Satoshi-BlackItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a2d0e9cb218d07d89_Satoshi-BlackItalic.otf') format('opentype');\n    font-weight: 900;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c8b23630aa8712f5d_Satoshi-LightItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c8b236328bf712f5c_Satoshi-LightItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a3876e63fcbfb937f_Satoshi-LightItalic.otf') format('opentype');\n    font-weight: 300;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c79ce674833daca20_Satoshi-BoldItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c71fd1d0dee132f10_Satoshi-BoldItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22bf0a95ae6eff15b5b_Satoshi-BoldItalic.otf') format('opentype');\n    font-weight: 700;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d878edabc5d3c7838_Satoshi-MediumItalic.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907dfa78fa96ec884cf9_Satoshi-MediumItalic.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22aba66e21bdb211459_Satoshi-MediumItalic.otf') format('opentype');\n    font-weight: 500;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d75cb9f97e8db6959_Satoshi-Medium.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d32fac368c3c13cf8_Satoshi-Medium.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a85a3b14f4b2f3611_Satoshi-Medium.otf') format('opentype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907efd39a16665eda62e_Satoshi-Regular.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907d58147e595393cf46_Satoshi-Regular.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22abaa2d4db334fee73_Satoshi-Regular.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi variable';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907e5f5fbe3310b486cb_Satoshi-Variable.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907e58147eedff93cf47_Satoshi-Variable.woff') format('woff');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f291ee6c79af50128e0553_P22MackinacProExtraBold-Italic-webfont.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f291ee484223715c7c50ec_P22MackinacProExtraBold-Italic-webfont.woff') format('woff');\n    font-weight: 700;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2927d8a120352353fc784_P22MackinacProBold-Italic-webfont.woff2') format('woff2'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2927d82066d2c47850b77_P22MackinacProBold-Italic-webfont.woff') format('woff');\n    font-weight: 800;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Satoshi';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61f2907c995ca5f15f0a11b8_Satoshi-Bold.woff') format('woff'), url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f22a6f5b56f080b08210_Satoshi-Bold.otf') format('opentype');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e972f7c60601a5bab5d_Inter-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e977e8a69256e1d62ae_Inter-ExtraBold.ttf') format('truetype');\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e97950eb103499beb6f_Inter-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e9863de511c95f1bbc2_Inter-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e97ad2d5a4b94a6fcfa_Inter-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Inter';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/65272e97ca731b7fff17b0d9_Inter-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 17';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24de8be94a6ac5b3f24_P22MackinacPro-ExBoldItalic_17.otf') format('opentype');\n    font-weight: 700;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro book 25';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24d43ba4a85944175b6_P22MackinacPro-Book_25.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 11';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24d6f5b56ba58b08224_P22MackinacPro-BoldItalic_11.otf') format('opentype');\n    font-weight: 700;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 16';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24dd07b6d1b36f34fe4_P22MackinacPro-Bold_16.otf') format('opentype');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 15';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24dbaa2d491134fef5c_P22MackinacPro-BookItalic_15.otf') format('opentype');\n    font-weight: 400;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 12';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24d54165576d732ed25_P22MackinacPro-ExtraBold_12.otf') format('opentype');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 26';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24db36f02da2a37019a_P22MackinacPro-Medium_26.otf') format('opentype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22mackinacpro 18';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/61e8f24e4fad261e4d6fc10e_P22MackinacPro-MedItalic_18.otf') format('opentype');\n    font-weight: 400;\n    font-style: italic;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22 Mackinacpro';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e81643fb931e8e5f21_P22MackinacPro-Book_25.otf') format('opentype');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22 Mackinacpro';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e804aea9dd57ef7dbd_P22MackinacPro-Medium_26.otf') format('opentype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22 Mackinacpro';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e82f7c60601a502a93_P22MackinacPro-Bold_16.otf') format('opentype');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'P22 Mackinacpro';\n    src: url('https://uploads-ssl.webflow.com/61e8ec6584cc457e5ccb9501/652724e722c77e92a41be9e6_P22MackinacPro-ExtraBold_12.otf') format('opentype');\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
